// Quote Dashboard — main inline script, extracted from
// sections/rep-quote-dashboard.liquid to keep that section under Shopify's
// 256 KB hard limit. Load order is preserved by including this file via
// <script src=...> right after dashboard-handshake.js in the section.
(function() {
  'use strict';

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — 50ms haptic tap on every
     button, mobile only. This file is loaded by rep-quote-dashboard.liquid and
     nothing else, so a document-level listener is already DD-scoped.

     CAPTURE phase is load-bearing, not a style choice: this file alone calls
     e.stopPropagation() in 46 handlers (the + New toggle, the actions cog, the
     status dropdown, the collapse router...). A bubble-phase listener on
     document would never hear those clicks — so the buttons a rep taps most
     would be exactly the ones that didn't buzz. Capture runs before the
     target's own handler, so nothing can swallow it.

     `click`, not `pointerdown`: pointerdown fires the moment a gesture STARTS
     on an element, so flicking the deal list from a spot that happens to be a
     button would buzz without ever activating it. click only fires on a real
     activation, at the cost of firing on release rather than on press.

     Gated on the 769px media query (the DD's own mobile breakpoint), NOT on
     touch support — Ryan's desktop is a touchscreen and reports touch events +
     a coarse pointer, so a touch gate would be lying about intent. Read at
     click time, so rotating in/out of the breakpoint is handled for free.

     ⚠ iOS: navigator.vibrate is effectively Android-only. Safari has never
     shipped the Vibration API on iPhone or iPad, and there is no equivalent
     available to a web page. On iOS this feature is correct but silent — the
     guard below simply returns. That's a platform gap, not something to fix
     here. */
  (function initButtonHaptics() {
    if (!window.navigator || typeof navigator.vibrate !== 'function') return;
    var mq = window.matchMedia && window.matchMedia('(max-width: 769px)');
    if (!mq) return;
    document.addEventListener('click', function(e) {
      if (!mq.matches) return;
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      /* `tr[data-ref]` is the deal card (Ryan 2026-07-15). One selector covers
         all three tabs: offline/online set it in dashboard-quote-row.js, and
         prospecting sets the same attribute in _buildProspectRowPair.
         It does NOT over-fire into an expanded deal: the detail panel is a
         SEPARATE sibling <tr> carrying data-detail-ref, not data-ref — so
         tapping an input or reading the Deal Feed inside an open card stays
         silent, and only the card header itself buzzes.
         Nor does it double-buzz on a button inside a card: closest() returns
         the NEAREST match walking up from the tap, which is the button, so each
         tap resolves to exactly one element. */
      var hit = t.closest('button, [role="button"], tr[data-ref]');
      // Don't buzz for a press that does nothing. (A <tr> has no .disabled —
      // undefined is falsy, so cards fall through both guards.)
      if (!hit || hit.disabled || hit.getAttribute('aria-disabled') === 'true') return;
      // Wrapped: some browsers throw if the gesture requirement isn't met.
      try { navigator.vibrate(50); } catch (_) {}
    }, true);
  })();

  function whenReady(cb) {
    if (window.RepPortal) return cb();
    var t = setInterval(function() {
      if (window.RepPortal) { clearInterval(t); cb(); }
    }, 50);
  }

  whenReady(function() {
    var API = window.RepPortal.API;
    var Auth = window.RepPortal.Auth;

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22, B.1.b hotfix) — Collapse-
       state stores hoisted ABOVE the module init blocks. These were declared
       around L213 — vars are hoisted (name exists) but values are undefined
       until that line executes. dashboard-order-cards.js captured the values
       at init time (= undefined) → applyCollapseState threw "Cannot read
       properties of undefined" on every detail-row render. forEach aborted
       after the first throw, leaving only row 1's main <tr> visible.

       ⚠️ A REPEATED `var` IS A NO-OP; A REPEATED `var x = {}` IS NOT. The declaration is ignored,
       but the initialiser runs and rebinds the variable — which is how the collapse state came to
       live in two objects at once until 2026-08-29. If these two are ever re-emitted further down
       the file, re-emit them WITHOUT an initialiser. */
    var collapsedSections = {};       // ref -> Set of section IDs
    var sectionsAutoCollapsedRef = {}; // ref -> bool (admin auto-collapse run?)
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-31) — ref -> { sectionId: true } for cards the
       rep has toggled BY HAND. Auto-collapse re-evaluates on every render now (a card can finish
       mid-session), so it needs to know which cards it must never touch again. Absence of a
       `collapsedSections` entry cannot carry that: it means "expanded", which is also the state
       of a card nobody has touched. ⛔ Declared ONCE and passed BY REFERENCE — re-declaring it
       with `= {}` anywhere below rebinds it after the card module captured the old object, which
       is the exact bug the note at ~L786 exists to record. */
    var manuallyToggledSections = {};

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21, Phase A.2 refactor) —
       Init the lead-actions module (extracted to dashboard-lead-actions.js).
       Function declarations like esc / formatDate / fetchQuotes are hoisted
       in this IIFE, so they resolve here even though their declarations
       sit further down. allQuotes is a var (hoisted but undefined until
       assigned around line 91) — wrap it in a getter closure so the
       extracted functions always see the current value. */
    if (window.RQD && window.RQD.initLeadActions) {
      window.RQD.initLeadActions({
        esc: esc,
        formatDate: formatDate,
        formatFollowUpDate: formatFollowUpDate,
        daysFromNowYmd: daysFromNowYmd,
        snapYmdToWeekday: snapYmdToWeekday,
        fetchQuotes: fetchQuotes,
        _qstHasContactActivity: _qstHasContactActivity,
        getAllQuotes: function() { return allQuotes; },
        handleBuildQuoteFromLead: handleBuildQuoteFromLead,
        API: API,
        Auth: Auth,
      });
    }

    /* Phase A.3 init — + New modals (dashboard-lead-create.js). */
    if (window.RQD && window.RQD.initLeadCreate) {
      window.RQD.initLeadCreate({
        daysFromNowYmd: daysFromNowYmd,
        snapYmdToWeekday: snapYmdToWeekday,
        API: API,
        Auth: Auth,
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-25) — setter into this IIFE's
           pendingStatusChange (read by the modal-footer Confirm dispatcher). The
           + New openers reassign it; a value-injection wouldn't propagate back. */
        setPendingStatusChange: function(v) { pendingStatusChange = v; },
      });
    }

    /* Phase A.4 init — Deal Feed note-entry handlers (dashboard-deal-feed.js).
       Ryan 2026-05-22 hotfix — formatFollowUpRemaining + _followUpDayCount +
       refreshProgressBar added. All function declarations (safe to pass by
       reference per the init-deps hoisting trap memo). */
    if (window.RQD && window.RQD.initDealFeed) {
      window.RQD.initDealFeed({
        esc: esc,
        formatNoteDate: formatNoteDate,
        formatFollowUpDate: formatFollowUpDate,
        daysFromNowYmd: daysFromNowYmd,
        fetchQuotes: fetchQuotes,
        getAllQuotes: function() { return allQuotes; },
        armFollowUp: armFollowUp,
        clearFollowUp: clearFollowUp,
        _syncSaveEnabled: _syncSaveEnabled,
        formatFollowUpRemaining: formatFollowUpRemaining,
        _followUpDayCount: _followUpDayCount,
        refreshProgressBar: refreshProgressBar,
        /* CUSTOM_FOLLOWUPFIX_BY_CLAUDE (AIOPS 1e26be1d9a86) — the surgical entries redraw, so a
           follow-up correction folded onto an existing entry can be shown without a third copy of
           the entry renderer (there are already two, and they drift). */
        repaintEntriesFor: _repaintEntriesFor,
        API: API,
        Auth: Auth,
      });
    }

    /* Phase B.1.a init — Shipping/Freight cards (dashboard-shipping-cards.js).
       isAdmin is a closure-mutating var (assigned after Auth resolves at
       main.js:301), so pass it via a getter so the module always sees the
       current value rather than the false at boot. sectionTitleHtml is now
       a delegation stub (Phase B.1.b moved the implementation to
       dashboard-order-cards.js); the stub function reference is passed
       through unchanged — the call still resolves to RQD.sectionTitleHtml. */
    if (window.RQD && window.RQD.initShippingCards) {
      window.RQD.initShippingCards({
        esc: esc,
        money: money,
        formatDate: formatDate,
        sectionTitleHtml: sectionTitleHtml,
        isFreightBalanced: isFreightBalanced,
        isPostShipInvoiceVendor: isPostShipInvoiceVendor,
        getIsAdmin: function() { return isAdmin; },
      });
    }

    /* Phase B.2.a init — Sold To / Ship To / Bill To customer columns
       (dashboard-customer-columns.js). All deps are function declarations
       in main.js, safe to pass directly per the init-deps-var-hoisting-trap
       memo. detailRow declared at ~L9850 (well after this init block) but
       function decls are fully hoisted so the reference resolves. */
    if (window.RQD && window.RQD.initCustomerColumns) {
      window.RQD.initCustomerColumns({
        esc: esc,
        formatDate: formatDate,
        detailRow: detailRow,
        fmtPhone: fmtPhone,
        isResidentialOrg: isResidentialOrg,
      });
    }

    /* Phase B.2.b init — Lead detail card (dashboard-lead-detail.js).
       Renders the qIsLead branch of buildDetailHtml. isAdmin is the
       closure var that mutates after Auth.getSession() resolves
       (~L91) — pass as getter so the sample-tracking admin block
       sees the current value, not the init-time value. */
    if (window.RQD && window.RQD.initLeadDetail) {
      window.RQD.initLeadDetail({
        esc: esc,
        formatDate: formatDate,
        fmtPhone: fmtPhone,
        getIsAdmin: function() { return isAdmin; },
      });
    }

    /* Phase B.2.c init — AR/AP card (dashboard-ar-ap-card.js).
       B.2.c.i: buildArApTopHalf(q) — Invoice row + Payments parent +
       Payment child rows. B.2.c.ii: buildArApCloseout(q) — Taxes
       Remitted + Installer Paid toggles. getIsAdmin closure-getter:
       Void-invoice link admin gate. buildToggle is a function
       declaration in main, safe to pass by reference. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — replacement claim card.
       getIsAdmin is a CLOSURE-GETTER, not a bare reference: isAdmin is a var that
       only becomes true after Auth.getSession() resolves, so passing it by value
       here would hide the whole card from anyone authenticated after boot. */
    /* CUSTOM_PAYMENTCHECK_BY_CLAUDE (ONYX e27ee0c84a87) - the payment check card + chip; isAdmin by getter
       for the same reason as the claim card below. */
    if (window.RQD && window.RQD.initPaymentCheck) {
      window.RQD.initPaymentCheck({ getIsAdmin: function() { return isAdmin; } });
    }
    if (window.RQD && window.RQD.initClaimCard) {
      window.RQD.initClaimCard({
        esc: esc,
        money: money,
        formatDate: formatDate,
        getIsAdmin: function() { return isAdmin; },
      });
    }
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — claim paperwork panel. Same
       closure-getter contract as the claim card above, and for the same reason. */
    if (window.RQD && window.RQD.initClaimDocs) {
      window.RQD.initClaimDocs({
        esc: esc,
        money: money,
        formatDate: formatDate,
        getIsAdmin: function() { return isAdmin; },
      });
    }
    if (window.RQD && window.RQD.initArApCard) {
      window.RQD.initArApCard({
        esc: esc,
        formatDate: formatDate,
        money: money,
        isResidentialOrg: isResidentialOrg,
        buildToggle: buildToggle,
        getIsAdmin: function() { return isAdmin; },
      });
    }

    /* Phase B.2.d init — Sample Tracking + Commission cards
       (dashboard-sample-commission.js). Three render functions:
       buildSampleTrackingCard, buildCommissionCard (offline),
       buildCommissionCodeAttribution (online discount-code path).
       capitalize lives at ~L14960 but function decls are fully
       hoisted. currentSource is a `var` that mutates on source-
       picker click — pass as getter so Code Attribution's editable/
       read-only branch sees the current value. */
    if (window.RQD && window.RQD.initSampleCommission) {
      window.RQD.initSampleCommission({
        esc: esc,
        formatDate: formatDate,
        money: money,
        detailRow: detailRow,
        capitalize: capitalize,
        getIsAdmin: function() { return isAdmin; },
        getCurrentSource: function() { return currentSource; },
      });
    }

    /* Phase B.3.a init — Detail panel shell residual
       (dashboard-detail-shell.js). Four sibling pieces: mobile actions
       row, linked-child banner, balance chain banner, Financials
       default-branch card. All deps are function declarations in main
       (some declared after buildDetailHtml at L8345+ but fully hoisted).
       getIsAdmin closure-getter is used by the mobile-actions admin
       gates + balance-chain action buttons + Financials Full-margin
       toggle render. */
    if (window.RQD && window.RQD.initDetailShell) {
      window.RQD.initDetailShell({
        esc: esc,
        money: money,
        detailRow: detailRow,
        costRow: costRow,
        freightCostScrollRow: freightCostScrollRow,
        _qstHasContactActivity: _qstHasContactActivity,
        /* CUSTOM_REVIEWS_BY_CLAUDE (Ryan 2026-09-09) — mobile cog parity for the review-ask entry. */
        buildReviewAskMenuItem: buildReviewAskMenuItem,
        buildRequestLogisticsButtons: buildRequestLogisticsButtons,
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08) — see the initQuoteRow note */
        buildLinkExternalButton: buildLinkExternalButton,
        buildLinkOpenDealButton: buildLinkOpenDealButton,
        getIsAdmin: function() { return isAdmin; },
      });
    }

    /* Phase B.2.e init — Activity / Notes log card
       (dashboard-activity-card.js). Biggest extraction — ~775 LOC
       moved out. collapsedSections passed BY REFERENCE (shared
       mutable store with click-toggle handler ~L1985 + prospect
       detail ~L17097). Date/follow-up formatters all live at
       ~L14550+ in main but are function decls (fully hoisted).
       getIsAdmin gates the entry-edit/delete button render path. */
    if (window.RQD && window.RQD.initActivityCard) {
      window.RQD.initActivityCard({
        esc: esc,
        formatNoteDate: formatNoteDate,
        formatFollowUpDate: formatFollowUpDate,
        formatFollowUpRemaining: formatFollowUpRemaining,
        formatDate: formatDate,
        _followUpDayCount: _followUpDayCount,
        daysFromNowYmd: daysFromNowYmd,
        collapsedSections: collapsedSections,
        getIsAdmin: function() { return isAdmin; },
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — the pending-automation block needs a
           quiet refetch after Stop, so the block's disappearance and the feed entry recording
           who stopped it arrive together rather than a page-load apart. Same dependency
           dashboard-deal-feed.js already takes, and by reference for the same reason. */
        fetchQuotes: fetchQuotes,
      });
    }

    /* Phase B.1.b init — Order/Balance cards + collapse helpers
       (dashboard-order-cards.js). collapsedSections + sectionsAutoCollapsed-
       Ref passed by object reference — shared mutable stores that main.js
       also writes to (click-toggle handler at ~L1985, activity-card read at
       ~L8480, prospect detail at ~L17097). vendorNamesMatch +
       buildOnlineFlowSteps + isFreightBalanced still in main.js. */
    if (window.RQD && window.RQD.initOrderCards) {
      window.RQD.initOrderCards({
        esc: esc,
        money: money,
        getIsAdmin: function() { return isAdmin; },
        buildOnlineFlowSteps: buildOnlineFlowSteps,
        isFreightBalanced: isFreightBalanced,
        vendorNamesMatch: vendorNamesMatch,
        collapsedSections: collapsedSections,
        sectionsAutoCollapsedRef: sectionsAutoCollapsedRef,
        manuallyToggledSections: manuallyToggledSections,
      });
    }

    /* CUSTOM_DDFREIGHTCARD_BY_CLAUDE (Ryan 2026-08-29) — the Freight Quote / Installation Quote
       cards (dashboard-freight-cards.js).
       ⚠️ getIsAdmin and getAllQuotes are GETTERS, not values: `isAdmin` is false until Auth
       resolves and `allQuotes` is REPLACED wholesale by every fetchQuotes, so a captured reference
       would leave the module reading a dead array and hiding the cards from everybody.
       rerenderDetail comes from DashboardHandshake, resolved at call time because these modules are
       `defer`-loaded in document order and main boots last. */
    if (window.RQD && window.RQD.initFreightCards) {
      window.RQD.initFreightCards({
        esc: esc,
        money: money,
        formatDate: formatDate,
        sectionTitleHtml: sectionTitleHtml,
        getIsAdmin: function() { return isAdmin; },
        API: API,
        getAllQuotes: function() { return allQuotes; },
        vendorNamesMatch: vendorNamesMatch,
        notePendingPatch: notePendingPatch,
        refreshProgressBar: refreshProgressBar,
        buildToggle: buildToggle,
        fetchQuotesQuiet: function() { fetchQuotes({ quiet: true }); },
        rerenderDetail: function(detailEl, q) {
          if (window.DashboardHandshake && window.DashboardHandshake.rerenderDetail) {
            window.DashboardHandshake.rerenderDetail(detailEl, q);
          } else if (detailEl && q) {
            detailEl.innerHTML = buildDetailHtml(q);
            applyCollapseState(detailEl, q);
          }
        },
      });
    }

    /* Phase B.3.b SURGICAL init — Quote row (dashboard-quote-row.js).
       Extracted from renderTable's inner buildQuoteRow (~386 LOC). All
       function declarations resolve via the same hoisting rule as the
       Phase B.2.x modules. isAdmin + currentSource via closure-getter:
       isAdmin mutates after Auth.getSession() resolves (~L301);
       currentSource mutates on source-picker click. The row renderer
       reads both on every render so the getters must always see
       current values. */
    if (window.RQD && window.RQD.initQuoteRow) {
      window.RQD.initQuoteRow({
        esc: esc,
        isResidentialOrg: isResidentialOrg,
        formatDate: formatDate,
        money: money,
        capitalize: capitalize,
        buildProgressBar: buildProgressBar,
        _qstHasContactActivity: _qstHasContactActivity,
        buildRequestLogisticsButtons: buildRequestLogisticsButtons,
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08) — the two link builders both cog
           menus call from EVERY lifecycle branch. Function declarations in main, safe to pass
           by reference per the init-deps-var-hoisting-trap memo. */
        buildLinkExternalButton: buildLinkExternalButton,
        buildLinkOpenDealButton: buildLinkOpenDealButton,
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM²) — shared with the detail-panel
           tint so the LINKED pill and the purple panel can never disagree again. */
        hasExternalOrderLink: hasExternalOrderLink,
        getIsAdmin: function() { return isAdmin; },
        getCurrentSource: function() { return currentSource; },
        /* CUSTOM_REVIEWS_BY_CLAUDE (Ryan 2026-09-09) — the review-ask cog entry (function
           declaration in main, safe by reference). */
        buildReviewAskMenuItem: buildReviewAskMenuItem,
      });
    }

    /* Phase C.1 init — Shipping/Tracking detail card
       (dashboard-shipping-tracking-card.js). Extracted from buildDetailHtml's
       admin-side Shipping/Tracking block (~484 LOC). All 6 function deps are
       function declarations in main (some defined further down — fully
       hoisted). carriers = ONLINE_CARRIERS passed once at init (other
       handlers in main use it directly, so it stays here). No closure-
       getters needed — isAdmin is folded into the per-call effectiveAdmin
       opt; currentSource is not consulted in the card. */
    if (window.RQD && window.RQD.initShippingTrackingCard) {
      window.RQD.initShippingTrackingCard({
        esc: esc,
        formatDate: formatDate,
        money: money,
        vendorNamesMatch: vendorNamesMatch,
        isPostShipInvoiceVendor: isPostShipInvoiceVendor,
        vendorIsShipped: vendorIsShipped,
        vendorEarlyStampVeto: vendorEarlyStampVeto, // CUSTOM_EARLYSTAMP_BY_CLAUDE (AIOPS fb2ebf0cafb8) - the row caption reads the same veto
        sectionTitleHtml: sectionTitleHtml,
        carriers: ONLINE_CARRIERS,
      });
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Source-picker
       auth-race rescue. The .rqd-source-picker (Offline / Online / All /
       Prospecting dropdown) is built synchronously below by a block that
       reads Auth.getSession() at script-execute time. On a fresh page
       load after re-login, the session can be empty at that moment
       (auth hydrates asynchronously) — _isAdminSel resolves to false,
       the picker is never created, and the rep is left without the
       source toggle.

       Listener fires on rep-portal:authenticated. After a 1.5s grace
       (lets the bootstrap finish), if the rep should see the picker
       (admin or CFA) but it isn't in the DOM, do a one-time reload so
       the synchronous block re-runs with auth ready. sessionStorage
       guard prevents reload loops if the second attempt also fails. */
    window.addEventListener('rep-portal:authenticated', function _onAuthRescue() {
      setTimeout(function() {
        try {
          var sess = window.RepPortal && window.RepPortal.Auth && window.RepPortal.Auth.getSession();
          if (!sess) return;
          var canSeePicker = (sess.admin === true) || sess.role === 'admin' || sess.role === 'cfa';
          if (!canSeePicker) return;
          if (document.querySelector('.rqd-source-picker')) return;
          if (sessionStorage.getItem('rqd-picker-reload-guard')) return;
          sessionStorage.setItem('rqd-picker-reload-guard', '1');
          window.removeEventListener('rep-portal:authenticated', _onAuthRescue);
          window.location.reload();
        } catch (e) {}
      }, 1500);
    });
    // Clear the guard whenever the picker IS present (page bootstrapped
    // successfully) so a FUTURE auth race in a different session can still
    // trigger the rescue reload.
    setTimeout(function() {
      try {
        if (document.querySelector('.rqd-source-picker')) {
          sessionStorage.removeItem('rqd-picker-reload-guard');
        }
      } catch (e) {}
    }, 2500);

    var currentStatus = 'all';
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-29) — MONEY MOVES filter active
       flag. Mutually exclusive with the status dropdown + freight-pending. */
    var moneyMovesActive = false;
    var currentPage = 1;
    var currentSort = 'date_desc';
    var currentSearch = '';
    var currentDateFrom = '';
    var currentDateTo = '';
    // Date preset is the source of truth for rolling ranges (year/quarter/
    // month/week). currentDateFrom/To are the resolved dates re-derived from
    // the preset on every load — pushing them to the URL freezes them at the
    // moment they were resolved (e.g. yesterday's "today"), which then masks
    // any orders placed today on the next visit. We persist the preset name
    // and recompute dates from `new Date()` instead.
    var currentPreset = 'year';
    // Admin master-view source toggle (default 'offline' matches the original
    // dashboard scope — rep-quote-driven rfq draft orders).
    // CUSTOM_RFQPORTAL_BY_CLAUDE — Persist last-selected tab across refreshes
    // so a refresh on Online/All keeps the rep on that tab. Validated against
    // the known set to avoid a corrupt localStorage value silently breaking.
    var currentSource = 'offline';
    try {
      var _savedSource = localStorage.getItem('rqd-source');
      if (_savedSource === 'offline' || _savedSource === 'online' || _savedSource === 'all') {
        currentSource = _savedSource;
      }
    } catch (e) {}
    // currentIncludePaidOnline removed 2026-05-07 — toggle was unclear and
    // rarely useful; All-tab now includes paid-online offline quotes by
    // default (worker simplified to not gate on this flag).
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — show-cancelled toggle (admin online/all) */
    var currentIncludeCancelled = false;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — Online Deals default view: stop at the
       EARLIEST still-open deal. Everything from that point forward stays (open deals with
       settled ones interleaved, chronology intact); everything older than it drops out.
       Default ON — the whole point is that the working set is what you land on. */
    var currentHideOlderCompleted = true;
    try {
      if (localStorage.getItem('rqd_hide_older_completed') === '0') currentHideOlderCompleted = false;
    } catch (_) { /* private mode — the default stands */ }
    var _olderCompletedHidden = 0;
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    var searchTimer = null;
    var allQuotes = [];

    /* CUSTOM_OPTIMISTIC_BY_CLAUDE (Ryan 2026-08-27) — writes that must survive the next refetch.

       THE BUG THIS EXISTS FOR. Ryan: *"I type it into the text field input box and click the small
       save button … the box then empties and goes back to looking like nothing was typed in or
       saved. It's not until I hard refresh that I see my dollar amount was added and saved
       correctly."* Intermittently, which is the tell.

       ⛔ THE SAVE WAS ALWAYS CORRECT. saveCost patches the row it holds and re-renders — instantly
       and right. What undoes it is `fetchQuotes`, which REPLACES `allQuotes` wholesale from the
       server response, so the patched object is discarded and the repaint draws whatever the server
       just said. The 2-minute quiet poll is usually what fires it; the tab-return fetch does too.

       ⚠️ AND BYPASSING THE SERVER CACHE DOES NOT FIX IT. The quiet path already appends `__nc=1`.
       The staleness is one layer lower: KV is eventually consistent, so a read issued moments after
       the write legitimately returns the old value. There is no cache flag that makes a distributed
       write instant, which is why this is an overlay rather than a freshness tweak.

       HOW IT CLEARS — the part that matters most. A patch is dropped the moment the server's own
       response carries the value (`settled`), so this never fights real data, and it expires after
       PENDING_TTL_MS regardless. ⛔ An overlay with no expiry is a LATCH: a write that genuinely
       failed would keep re-appearing on every render and read as saved forever, which is a worse
       bug than the one being fixed. */
    var _pendingPatches = {};
    var PENDING_PATCH_TTL_MS = 120000;   // two poll cycles; a write that has not landed by then is a failure, not a lag
    function notePendingPatch(key, ref, apply, settled) {
      _pendingPatches[key] = { ref: ref, at: Date.now(), apply: apply, settled: settled };
    }
    /* CUSTOM_CARDWRITESTICK_BY_CLAUDE (Ryan 2026-10-09, SHOP-2128) - ⛔ A WRITE FROM THE FULFILLMENT CARD STICKS.
       "No Balance" on SHOP-2128 looked undone for minutes: the click saved, but only the ROW ON SCREEN was patched.
       The RAM and sessionStorage copies of the board still held the old row, so the next refetch that painted from
       them (or a server read a few seconds behind the write) put the PO rows back behind the balance gate.
       This patches EVERY cached copy of the row (window.RQD.patchCachedQuoteRow, the supplier-pay settle's own
       helper) and registers the same mutation as a pending patch, so a stale response is overlaid until the
       server's own row agrees (`settled`) or two poll cycles pass. */
    function stickCardWrite(key, ref, mutate, settled) {
      var patched = false;
      try { if (window.RQD && window.RQD.patchCachedQuoteRow) patched = window.RQD.patchCachedQuoteRow(ref, mutate); } catch (_) {}
      if (!patched) {
        var q0 = allQuotes.find(function (x) { return x && x.reference === ref; });
        if (q0) { try { mutate(q0); } catch (_) {} }
      }
      notePendingPatch(key, ref, mutate, settled);
    }
    /* The alternate source's own shipment entry inside a shared bucket, or null. */
    function bucketSupplierEntry(q, bucketId, supplier) {
      if (!q || !Array.isArray(q.shippingBuckets) || !supplier) return null;
      var b = q.shippingBuckets.find(function (x) { return x && x.id === bucketId; });
      if (!b || !Array.isArray(b.suppliers)) return null;
      return b.suppliers.find(function (e) { return e && e.vendor === supplier; }) || null;
    }
    /* END CUSTOM_CARDWRITESTICK_BY_CLAUDE */
    function applyPendingPatches(quotes) {
      var keys = Object.keys(_pendingPatches);
      if (!keys.length || !Array.isArray(quotes)) return;
      var now = Date.now();
      keys.forEach(function (k) {
        var p = _pendingPatches[k];
        if (!p || (now - p.at) > PENDING_PATCH_TTL_MS) { delete _pendingPatches[k]; return; }
        var q = quotes.find(function (x) { return x && x.reference === p.ref; });
        if (!q) return;                       // row not in this view; keep the patch for when it is
        try {
          if (p.settled(q)) { delete _pendingPatches[k]; return; }   // the server agrees — stand down
          p.apply(q);
        } catch (_) { delete _pendingPatches[k]; }
      });
    }
    /* END CUSTOM_OPTIMISTIC_BY_CLAUDE */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Post-ship freight invoice vendors.
       The Freight Balance card on the Quote Dashboard exists for one scenario:
       vendor bills freight AFTER the order ships, so admin has to capture
       the freight $ post-ship to close out P&L. For every other vendor
       (cost-included, broker-quoted up front, etc.) the card produces
       false action items once the order is fulfilled.
       Canonical names — sub-brands (Normatec, Hypervolt, Hypersphere,
       Venom, Vyper) all roll up to "Hyperice" via canonicalVendor() on
       the worker side, so one entry covers the whole family. */
    var POST_SHIP_INVOICE_VENDORS = (function () {
      var s = new Set();
      s.add('Hyperice');
      return s;
    })();
    function isPostShipInvoiceVendor(name) {
      if (!name) return false;
      return POST_SHIP_INVOICE_VENDORS.has(String(name).trim());
    }
    /* CUSTOM_PRODUCTRULES_BY_CLAUDE (Session 7, Ryan 2026-10-10) - the list above is a stored setting now, edited on
       Product Rules ("Invoices after shipment") and served by GET /rule-settings with ECORE's West states. The list
       above is its default until the answer lands; a failed read keeps it. The handshake picks up the West states
       (window.RepRuleSettings, read again when it loads after this). */
    try {
      API.get('/rule-settings').then(function (rs) {
        if (!rs || !Array.isArray(rs.postShipInvoiceVendors)) return;
        window.RepRuleSettings = rs;
        POST_SHIP_INVOICE_VENDORS.clear();
        rs.postShipInvoiceVendors.forEach(function (v) { if (v) POST_SHIP_INVOICE_VENDORS.add(String(v).trim()); });
        if (window.DashboardHandshake && window.DashboardHandshake.setEcoreWestStates) window.DashboardHandshake.setEcoreWestStates(rs.ecoreWestStates);
      }).catch(function () { /* the default lists stand */ });
    } catch (_) { /* the default lists stand */ }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    // CUSTOM_RFQPORTAL_BY_CLAUDE — Client-side filter toggled by the
    // "⚠ Freight Pending" stat card. When true, renderTable receives only
    // orders with at least one parcel-rate bucket awaiting an actual
    // freight cost. Cleared by clicking any existing status pill or
    // clicking the freight-pending card a second time.
    var freightPendingOnly = false;
    var isAdmin = false;
    var expandedRef = null;
    var expandedGroup = null;

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Vendor workflow map
       (vendor-name-lowercase → workflow string from Vendor Guide). Fetched
       once on boot via /vendor-workflows (proxies vendor-worker via service
       binding). Used to branch the purchase action menu: vendors flagged
       'web-order' skip the Generate PO / Mark Purchased dropdown and route
       straight to the Mark Purchased popover. Empty map until fetched —
       behavior degrades gracefully (admin still sees the standard menu). */
    var vendorWorkflowMap = {};
    /* CUSTOM_VENDORFROM_BY_CLAUDE (Ryan 2026-08-13) — vendors whose POs go out from Abby by
       default rather than from Ryan. Ryan: *"make it so that the default from when emails like
       PO's go out to Legend is always Abby."*

       A named list rather than an inline `=== 'Legend Fitness'`, so adding the next vendor is one
       line here instead of an archaeology exercise. Matched with vendorNamesMatch, so the entry
       survives the "Legend" / "Legend Fitness" drift that already exists between the Shopify
       product vendor and the Vendor Guide's canonical name — an exact-string check would fail on
       whichever of the two this PO happened to be created under.

       ⚠️ If this list ever grows past a handful, it belongs on the vendor PROFILE in the Vendor
       Guide (beside contact/bcc/shippingModel) rather than in the theme, so Ryan can set it
       himself without a deploy. Not built that way today because one vendor does not justify a
       worker field plus a Guide UI. */
    var PO_FROM_ABBY_VENDORS = ['Legend Fitness'];

    /* CUSTOM_VENDORFROM_BY_CLAUDE (Ryan 2026-08-26) — the rule now lives on the vendor's PO
       Profile, which is where this function's own comment said it belonged. PO_FROM_ABBY_VENDORS
       above survives as a FALLBACK rather than being deleted: the map behind getVendorPoFrom comes
       from a fire-and-forget boot fetch that is allowed to fail, and a failed fetch must not
       quietly send a Legend PO from Ryan. Once every Abby vendor carries poFrom, the list is dead
       weight and can go — check the profiles before deleting it, not this comment. */
    /* CUSTOM_VENDORFROM_BY_CLAUDE (Ryan 2026-08-27) — RENAMED from `_poDefaultFromFor`, and it now
       takes a ref, for two reasons that arrived together.

       ⛔ IT IS NOT ONLY ABOUT POs. Ryan set TKO to Abby, opened the freight request on RW-1339-A
       and got Ryan's mailbox: *"I basically want the PO SENDS FROM to include freight requests and
       weight/dims requests too."* The vendor field always meant "which of our mailboxes talks to
       this supplier" — it was simply only ever consulted by the PO composer. The Vendor Guide
       label is now "Emails Send From" to match.

       ⛔ AND IT HAS TO ASK THE SUPPLIER THE ROW RESOLVES TO. A white-label row is named for US, so
       `getVendorPoFrom('Blue Sky Fitness Supply')` answers for nobody and the rule silently
       reverts to the rep's habit. Same trap as the freight predicate on 2026-08-26 — any question
       keyed on a Purchasing row's vendor string needs `resolvedVendorFor` first. The ref is the
       argument that makes that possible; callers that genuinely have no deal pass ''. */
    function defaultFromMailboxFor(ref, vendor) {
      if (!vendor) return '';
      var _q = ref ? allQuotes.find(function (x) { return x && x.reference === ref; }) : null;
      var _supplier = resolvedVendorFor(_q, vendor) || vendor;
      var fromProfile = getVendorPoFrom(_supplier);
      if (fromProfile) return fromProfile;
      for (var i = 0; i < PO_FROM_ABBY_VENDORS.length; i++) {
        if (vendorNamesMatch(_supplier, PO_FROM_ABBY_VENDORS[i])) return 'ABBY';
      }
      return '';   // no rule → the rep's saved default decides, as before
    }

    function getVendorWorkflow(vendor) {
      if (!vendor) return '';
      /* CUSTOM_VENDORFROM_BY_CLAUDE (Ryan 2026-08-27) — same short-form miss as getVendorPoFrom
         below, and the same fix. A row named "TKO" was reading NO workflow at all, so this
         vendor's Freight → PO / web-order setting reached nothing either. See _vendorMapLookup. */
      return _vendorMapLookup(vendorWorkflowMap, vendor) || '';
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — Quote Alias map (quote name -> [supplier,...]),
       filled from the same boot fetch as the workflow map above.

       A vendor row's name comes off the Shopify line item, and for white-labelled goods that name
       is OURS — "Blue Sky Fitness Supply" — not the supplier's. A Quote Alias on the supplier's PO
       Profile claims that name. One claimant and the whole chain resolves silently; two or more
       and the row has to ask which supplier fills it, so the candidate names ARE the dropdown.

       Returns [] for an ordinary vendor, which is what keeps every non-white-label row untouched. */
    var vendorAliasMap = {};
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — which mailbox each vendor's POs go out from,
       set per vendor on the Vendor Guide PO Profile. Same boot fetch as the two maps around it. */
    var vendorPoFromMap = {};
    /* CUSTOM_WSFREIGHT_BY_CLAUDE (Ryan 2026-08-27) — each vendor's PO short code, same boot fetch.
       Used to tell "the supplier is carrying this" from "a third party is" when the Workstation's
       free-text carrier field holds a code ("CPT") rather than a name. */
    var vendorShortCodeMap = {};
    var vendorAlternates = []; // CUSTOM_ALTSOURCE_BY_CLAUDE - [{name, alternateFor, shortCode}] off /vendor-workflows
    var vendorOrdersThrough = {}; // CUSTOM_ORDERSTHROUGH_BY_CLAUDE - { 'maxxus saunas': 'Golden Designs' } off /vendor-workflows
    function getVendorShortCode(vendor) {
      if (!vendor) return '';
      return _vendorMapLookup(vendorShortCodeMap, vendor) || '';
    }
    /* CUSTOM_VENDORFROM_BY_CLAUDE (Ryan 2026-08-27) — ⛔ A PURCHASING ROW IS NAMED BY THE SHOPIFY
       LINE, WHICH IS OFTEN THE SHORT FORM. RW-1339-A's row says "TKO"; the Guide record is
       "TKO Strength" (slug `tko-strength`), and these maps are keyed on the name and the slug. An
       exact lookup therefore misses, returns '', and every vendor-level rule quietly reverts to a
       default — which is why Ryan set TKO to Abby, opened the freight request, and got ryan@.

       ⚠️ IT ALSO EXPLAINS WHY LEGEND NEVER BROKE. `PO_FROM_ABBY_VENDORS` compares with
       `vendorNamesMatch`, which IS fuzzy, so the "dead weight" fallback list has been masking this
       for every vendor on it since the rule moved onto the profile. Do NOT delete that list on the
       strength of "every Abby vendor carries poFrom now" — it was covering a real bug.

       ⛔ EXACT FIRST, THEN A UNIQUE FUZZY MATCH, THEN NOTHING. Two vendors matching one short form
       ("X Fitness" and "X Athletic" against a row named "X") is unanswerable, and picking the first
       is a guess about which supplier a PO is addressed from. Returning '' there leaves today's
       behaviour — the rep's saved default — which is the safe answer. */
    function _vendorMapLookup(map, vendor) {
      if (!map || !vendor) return undefined;
      var key = String(vendor).toLowerCase().trim();
      if (Object.prototype.hasOwnProperty.call(map, key)) return map[key];
      var hits = Object.keys(map).filter(function (k) { return vendorNamesMatch(vendor, k); });
      return hits.length === 1 ? map[hits[0]] : undefined;
    }
    function getVendorPoFrom(vendor) {
      if (!vendor) return '';
      var v = _vendorMapLookup(vendorPoFromMap, vendor);
      return (v === 'ABBY' || v === 'REP') ? v : '';
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    function getVendorAliasCandidates(vendor) {
      if (!vendor) return [];
      var hit = vendorAliasMap[String(vendor).toLowerCase().trim()];
      return Array.isArray(hit) ? hit : [];
    }

    /* The workflow of the supplier a ROW resolves to, which is not always the workflow of the
       row's name. A shared quote alias has no workflow of its own — two suppliers can answer to it
       and buy differently — so the deal's stored pick decides. Falls straight through to
       getVendorWorkflow for every ordinary vendor. */
    /* WHICH SUPPLIER does this row actually mean? For an ordinary vendor, itself. For a
       white-label row the name came off the quote line and is OURS ("Blue Sky Fitness Supply"),
       so every vendor-level question about that row — its workflow, and therefore whether it
       owes a freight ask — has to be asked of the supplier it resolves to.

       ⛔ ONE claimant resolves from the alias map; TWO OR MORE resolve only from the admin's
       stored pick, because the Guide deliberately refuses to guess and /vendor-workflows leaves a
       shared alias out of the workflow map entirely. Asking `getVendorWorkflow(rowName)` there
       returns '' — not "no workflow", but "unknowable from the name alone". RW-1339-A is exactly
       that shape: "Blue Sky Fitness Supply" claimed by both Ferus Prime and CPTurf, pointed at
       Ferus Prime on the row, and the freight step stayed invisible because the predicate was
       asking about a name that answers for nobody. */
    function resolvedVendorFor(q, vendor) {
      var cands = getVendorAliasCandidates(vendor);
      if (cands.length === 1) return cands[0];
      if (cands.length > 1) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-27) — the admin's explicit pick first, then
           what the PRODUCTS on the row say. An Alias Keyword on a supplier's PO Profile
           ("dumbbell", "grip plate") resolves a row named "Blue Sky Fitness Supply" to Ferus Prime
           without anybody choosing, because the quote already answered the question.

           ⛔ ORDER MATTERS AND THE HUMAN IS FIRST. A stored poVendor is somebody having decided;
           a keyword is an inference. Letting the inference win would silently overrule a
           deliberate correction the next time a keyword was edited.

           ⛔ THIS ONLY READS. The answer is fetched by the Purchasing card (the one surface that
           knows a row is on screen) and cached; the fetch is never kicked from here, because this
           predicate also feeds the progress bar and the To-Do strip, which run over every deal on
           the board. A read that could start a request per vendor per deal is a stampede. */
        var _picked = ((q && q.ordering && q.ordering[vendor]) || {}).poVendor;
        if (_picked) return _picked;
        var _auto = getAliasAuto(q && q.reference, vendor);
        if (_auto && _auto.vendor) return _auto.vendor;
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        return vendor;
      }
      return vendor;
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-27) — answers to "which supplier do the products on
       this shared-alias row name?", keyed ref||vendor.

       ⛔ THE ANSWER COMES FROM THE WORKER, NOT FROM A MATCHER IN HERE, and that is deliberate.
       This file boots with the alias map and the keyword map, so running the match locally looks
       free — but the dashboard cannot see the products reliably (freightLineItemsFor(q) is empty
       until Order Contents lazily fetches them), and generate-po has to resolve the same question
       server-side anyway because a browser does not get to say where a PO goes. A second copy of
       the rule would be free to disagree with the one that spends the money. See
       /alias-auto-vendor in the worker's po-routes.js.

       Values: undefined = never asked; 'pending' = in flight; an object = the answer, including
       the negative ones (reason 'none' / 'conflict'), which are cached exactly as hard as the
       positive ones so a row that genuinely cannot be resolved asks once and then stops. */
    var aliasAutoCache = {};
    function _aliasAutoKey(ref, vendor) { return String(ref || '') + '||' + String(vendor || ''); }
    function getAliasAuto(ref, vendor) {
      if (!ref || !vendor) return null;
      var hit = aliasAutoCache[_aliasAutoKey(ref, vendor)];
      return (hit && hit !== 'pending') ? hit : null;
    }
    /* Fire once per row per session. Re-renders the deal's open detail panel on arrival — the
       card was drawn before the answer existed, so the picker it drew is now the wrong control. */
    function requestAliasAuto(ref, vendor) {
      if (!ref || !vendor) return;
      var key = _aliasAutoKey(ref, vendor);
      if (aliasAutoCache[key] !== undefined) return;
      aliasAutoCache[key] = 'pending';
      API.get('/alias-auto-vendor?ref=' + encodeURIComponent(ref) + '&vendor=' + encodeURIComponent(vendor))
        .then(function (data) {
          aliasAutoCache[key] = (data && typeof data === 'object') ? data : { vendor: null, reason: 'none' };
          /* Only repaint when there is something new to show. A 'none' answer leaves the picker
             exactly as it already is, and repainting would throw away a selection the admin may
             have started making while the request was in flight. */
          if (!aliasAutoCache[key].vendor) return;
          var el = document.getElementById('rqd-detail-' + ref);
          if (!el || el.dataset.detailBuilt !== '1') return;
          var qq = allQuotes.find(function (x) { return x && x.reference === ref; });
          if (!qq) return;
          el.innerHTML = buildDetailHtml(qq);
          try { applyCollapseState(el, qq); } catch (_) {}
        })
        .catch(function () {
          /* ⛔ Cache the FAILURE too. Left undefined, every re-render of the card would fire
             another request at a worker that is already failing. The picker stays, which is the
             correct resting state — the admin can always answer it by hand. */
          aliasAutoCache[key] = { vendor: null, reason: 'error' };
        });
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    function getRowVendorWorkflow(ref, vendor) {
      var _q = allQuotes.find(function (x) { return x.reference === ref; });
      return getVendorWorkflow(resolvedVendorFor(_q, vendor));
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_DDFREIGHTCARD_BY_CLAUDE (Ryan 2026-08-29) — ⛔ THE SECOND `= {}` LIVED HERE AND IT
       SPLIT THE COLLAPSE STATE IN TWO.

       `collapsedSections` / `sectionsAutoCollapsedRef` are declared at the top of this IIFE (~L81)
       and passed BY REFERENCE into RQD.initOrderCards (~L316). This block re-declared them in the
       SAME scope with a fresh `= {}`. A repeated `var` is a no-op for the declaration — which is
       what the note at the top of the file says, and it is right about that — but **the initialiser
       still runs**, so this line rebound the variable to a NEW object minutes after the card module
       had captured the old one.

       From here down, main's collapse click handler mutated object B while
       dashboard-order-cards.js seeded and read object A. Expanding a card wrote to B; the next
       re-render read A, still holding `collapsed: true`, and folded it straight back up.

       ⚠️ LATENT SINCE THE SPLIT, AND INVISIBLE UNTIL NOW, because shouldAutoCollapse returns false
       for nearly every section — A almost never held a `true` to go stale. The Freight/Installation
       cards are the first whose rule collapses BY DEFAULT, so they read a stale `true` on every
       re-render and re-collapsed on each checkbox and each ? click. New code exposing an old bug,
       not a new one.

       The declarations at ~L81 are the survivors; their comment carries the description. */

    // ── Carrier URL memory (online orders, custom/Other carriers) ──
    // localStorage-backed dictionary { carrierName: urlTemplate } so a custom
    // carrier the rep entered before auto-fills its tracking-URL field next
    // time. Stored as a template — when the rep saves with a tracking # that
    // appears in the URL, the # is swapped for `{TRACKING}` so re-expansion
    // against a fresh tracking # produces a working link. If the tracking #
    // isn't in the URL (rep used a generic landing page), we store as-is.
    var CARRIER_URL_LS_KEY = 'rqd-carrier-urls';
    function loadCarrierUrlMemory() {
      try {
        var raw = localStorage.getItem(CARRIER_URL_LS_KEY);
        return raw ? (JSON.parse(raw) || {}) : {};
      } catch (_) { return {}; }
    }
    function saveCarrierUrlMemory(dict) {
      try { localStorage.setItem(CARRIER_URL_LS_KEY, JSON.stringify(dict || {})); } catch (_) {}
    }
    function buildUrlTemplate(url, tracking) {
      if (!url) return '';
      if (!tracking) return url;
      var idx = url.indexOf(tracking);
      if (idx === -1) return url;
      return url.slice(0, idx) + '{TRACKING}' + url.slice(idx + tracking.length);
    }
    function expandUrlTemplate(template, tracking) {
      if (!template) return '';
      return template.replace('{TRACKING}', tracking || '');
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Memory layer used to
       skip known carriers (URL field was only shown for custom carriers).
       Now that admin can override URLs for ANY carrier (FedEx Freight
       migrating to a new tracking site is the catalyst), memory works
       for known carriers too — so the override URL persists per-carrier-
       name instead of being retyped on every shipment. Carriers are
       still keyed by name, so "FedEx Freight Priority" and "FedEx Ground"
       remain separately remembered. */
    function rememberCarrierUrl(carrier, url, tracking) {
      if (!carrier || !url) return;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-01) - remember DELIBERATE overrides
         only. A URL we generated ourselves needs no memory (the map rebuilds it on
         demand), and remembering one is what poisoned this store: a 10-digit PRO was
         auto-detected as "DHL Express", which auto-filled a dhl.com URL; the rep
         corrected the carrier to FedEx Freight; the save then stamped the DHL link
         into memory UNDER the key "FedEx Freight" -- so every later FedEx Freight
         shipment recalled dhl.com, on a fresh row, with nothing on screen to
         explain it. Only a URL the rep typed themselves is worth remembering. */
      if (isGeneratedTrackingUrl(url, tracking)) return;
      var dict = loadCarrierUrlMemory();
      dict[carrier] = buildUrlTemplate(url, tracking);
      saveCarrierUrlMemory(dict);
    }
    function recallCarrierUrl(carrier, tracking) {
      if (!carrier) return '';
      var dict = loadCarrierUrlMemory();
      var template = dict[carrier];
      if (!template) return '';
      var expanded = expandUrlTemplate(template, tracking);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-01) - self-heal entries stored before
         the guard in rememberCarrierUrl existed. This memory is localStorage, so a
         poisoned entry lives on in the browser that made it and no deploy clears it.
         A remembered template that expands to one of OUR generated deep links was
         never a deliberate override -- it is one carrier's link captured under
         another carrier's name. Drop it on sight; the map rebuilds the right link
         for whatever carrier is actually on the row. */
      if (isGeneratedTrackingUrl(expanded, tracking)) {
        delete dict[carrier];
        saveCarrierUrlMemory(dict);
        return '';
      }
      return expanded;
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // ── Online-order carrier list ──
    // US-relevant carriers from Shopify's published carrier list (parcel,
    // LTL freight, cross-border). Used by the Shipping card's custom
    // autocomplete dropdown — declared once here so both the render path
    // (buildDetailHtml) and the autocomplete event handlers filter against
    // the same source. Browser <datalist> would be simpler but its popup
    // can't be height-constrained — a 50-entry list overflows the viewport.
    var ONLINE_CARRIERS = [
      // Parcel / express
      'Amazon Logistics', 'DHL eCommerce', 'DHL Express',
      'FedEx Ground', 'FedEx Home Delivery', 'FedEx Priority Overnight', 'FedEx Standard Overnight', 'FedEx 2Day', 'FedEx Express Saver', 'FedEx International',
      'UPS Ground', 'UPS Next Day Air', 'UPS 2nd Day Air', 'UPS 3 Day Select', 'UPS Worldwide Express',
      'USPS Priority', 'USPS Priority Express', 'USPS First Class', 'USPS Ground Advantage', 'USPS Media Mail', 'USPS International',
      'OnTrac', 'Lasership', 'LSO', 'TForce Final Mile', 'GLS US', 'Newgistics',
      'APC Postal Logistics', 'Doordash', 'Eagle', 'FSC', 'Globegistics', 'ICS Courier',
      'OSM Worldwide', 'SFC Logistics', 'Spee-Dee Delivery', 'UDS',
      // LTL freight
      // NB: not every entry here is on Shopify's list — 'Daylight Transport'
      // (added 2026-07-29) is a carrier WE deep-link ourselves via the worker's
      // src/lib/tracking-urls.js. That's fine: the worker passes our own
      // trackingInfo.url to Shopify, so the customer's link works either way.
      // Adding a carrier here without a tracking-urls.js entry is what forces
      // the rep to hand-paste a URL.
      'ABF Freight', 'ArcBest', 'Averitt Express', 'Daylight Transport', 'Estes Express', 'FedEx Freight', 'FedEx Freight Priority',
      'Forward Air', 'Holland', 'Old Dominion', 'Pilot Freight Services', 'R+L Carriers',
      'Roadrunner Transportation', 'SAIA', 'TForce Freight', 'Ward Transport & Logistics', 'XPO Logistics', 'YRC Freight',
      // Cross-border
      'Canada Post', 'Canpar', 'Purolator',
    ];

    // Cross-file deps for assets/dashboard-handshake.js (extracted to keep
    // this section under Shopify's 256 KB limit). Function declarations
    // are hoisted so they're already callable here.
    window.RPDash = {
      get allQuotes() { return allQuotes; },
      API: API,
      buildDetailHtml: function (q) { return buildDetailHtml(q); },
      refreshProgressBar: function (ref) { return refreshProgressBar(ref); },
      /* ============================================
         CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-19) — the board reacts to a send IMMEDIATELY.
         ============================================
         Ryan: *"how come when I send an email in the DD, the bell in the TO DO column isn't
         immediately removed once I click send? And it always takes a few minutes and/or a
         refresh for the email to show up in the Deal Feed?"*

         Two causes, both now fixed on the worker: the cadence arm ran in a `waitUntil` (after
         the response), and the email only reached the deal when the five-minute outlook-sync
         cron swept Sent Items. `/outlook-send` and `/outlook-reply` now do both before
         answering, and report what they did.

         This is the client half. ⛔ IT IS AN OPTIMISTIC PATCH, NOT THE SOURCE OF TRUTH — the
         same shape as the 2026-07-23 instant-🔔-clear on note save: mirror the server's answer
         onto the local row, repaint just that cell, then let a quiet refetch reconcile. The
         refetch alone is not enough (it re-pulls and re-renders the WHOLE board, ~3-4s), and
         KV is eventually consistent, so a refetch that lands too early can read the pre-send
         record and paint the bell straight back on.
         ============================================ */
      onEmailSent: function (ref, resp) {
        try {
          if (!ref) return;
          var q = allQuotes.find(function (x) { return x && x.reference === ref; });
          var cadence = resp && resp.cadence;
          if (q && cadence) {
            /* A LEAD-stage arm puts the deal ON HOLD server-side, and that is what removes the
               bell; a QUOTE-stage arm sets a countdown instead. Mirror whichever happened. */
            if (cadence.stage === 'lead' && cadence.isOnHold) {
              q.isOnHold = true;
              q.holdUntil = cadence.holdUntil;
              q.status = 'on_hold';
              delete q.wokenFromHold; delete q.wokeAt;
            } else if (cadence.stage === 'quote' && cadence.followUp) {
              q.followUp = cadence.followUp;
            }
          }
          /* The email itself, onto the local feed, so an OPEN Activity card shows it without a
             round-trip. Guarded against double-insert: the quiet refetch below may already have
             landed if KV was fast. */
          if (q && resp && resp.noteEntry && resp.noteEntry.id) {
            if (!Array.isArray(q.noteEntries)) q.noteEntries = [];
            var seen = q.noteEntries.some(function (e) { return e && e.id === resp.noteEntry.id; });
            if (!seen) {
              q.noteEntries.unshift(resp.noteEntry);
              q.notesUpdatedAt = resp.noteEntry.ts;
            }
          }
          refreshProgressBar(ref);
          /* Repaint an OPEN detail panel in place so the new entry appears on the Activity card
             without collapsing the row the rep is working in. */
          try {
            var _row = document.querySelector('tr.rqd-detail-row[data-ref="' + String(ref).replace(/"/g, '\\"') + '"] .rqd-detail-cell');
            if (_row && q) _row.innerHTML = buildDetailHtml(q);
          } catch (_) { /* the quiet refetch below is the backstop */ }
          fetchQuotes({ quiet: true });
        } catch (_) { /* never let a repaint break a send that already succeeded */ }
      },
      vendorNamesMatch: function (a, b) { return vendorNamesMatch(a, b); },
      /* CUSTOM_ORDERSTHROUGH_BY_CLAUDE (Ryan 2026-11-02) - the Vendor Guide's "Order through" map, and a line's
         vendor folded through it (Maxxus Saunas -> Golden Designs), for the freight ask and the dims button. */
      vendorFolds: function () { return vendorOrdersThrough; },
      foldVendor: function (v) { var k = String(v || '').replace(/\s+/g, ' ').trim().toLowerCase(); return (vendorOrdersThrough && vendorOrdersThrough[k]) || String(v || '').trim(); },
      esc: function (s) { return esc(s); },
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Exposed for the
         Mark-as-Fulfilled success handler in dashboard-handshake.js.
         Online rows skip doTrackingSave (Shopify-fulfill flow handles
         persistence), so without this the carrier→URL memory would
         never get populated on online shipments. */
      rememberCarrierUrl: function (carrier, url, tracking) { return rememberCarrierUrl(carrier, url, tracking); },
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Exposed for dashboard-handshake.js so
      // post-save innerHTML re-renders can re-attach collapse handlers.
      // Without this call, any card header click after a freight-cost
      // save was a dead element + cards stayed permanently expanded.
      applyCollapseState: function (detailEl, q) { return applyCollapseState(detailEl, q); },
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Vendor workflow lookup
         exposed so dashboard-po-lens.js (separate IIFE) can render the
         per-vendor purchase button label as "Mark Web Purchased" instead of
         "-- Select --" when the vendor is flagged 'web-order' in the Vendor
         Guide. Returns '' when vendor isn't known (degrades gracefully). */
      getVendorWorkflow: function (vendor) { return getVendorWorkflow(vendor); },
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — same reason as getVendorWorkflow above:
         dashboard-po-lens.js is a separate IIFE and needs the alias candidates to decide whether
         a vendor row must ask which supplier fills it. */
      getVendorAliasCandidates: function (vendor) { return getVendorAliasCandidates(vendor); },
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — the freight-handshake predicate, so the
         Purchasing card asks the SAME question the progress bar and the To-Do strip ask. It used
         to re-derive its own answer inline, which is how the two drifted apart before (see the
         2026-08-17 note on vendorNeedsFreightHandshake). */
      vendorNeedsFreightHandshake: function (q, vendor) { return vendorNeedsFreightHandshake(q, vendor); },
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-27) — the Purchasing card is the only surface
         that knows a shared-alias row is on screen, so it is the only one that asks. Reading is
         separate from asking on purpose: resolvedVendorFor reads on every deal on the board. */
      getAliasAuto: function (ref, vendor) { return getAliasAuto(ref, vendor); },
      requestAliasAuto: function (ref, vendor) { return requestAliasAuto(ref, vendor); },
      // CUSTOM_OPTIMISTIC_BY_CLAUDE (Ryan 2026-08-27) — see _pendingPatches above.
      notePendingPatch: function (key, ref, apply, settled) { return notePendingPatch(key, ref, apply, settled); },
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-27) — the supplier a row actually means, for the
         surfaces that LABEL that row: the Purchasing card and the Tracking card both used to print
         the quote name, so a white-label row read "Blue Sky Fitness Supply" on a screen whose whole
         job is telling you who to chase.

         ⛔ A LABEL, NEVER A KEY. Every stored thing about the row — lifecycle.ordering[],
         freightQuotes, palletFeeKey, the PO record, the progress tracker, the Deal Feed — stays
         keyed on the name off the quote line. This is a VIEW of the row, not a rename of it; the
         moment a data-vendor attribute is built from this, state starts landing under a second
         name and the row splits in two. */
      resolvedVendorFor: function (q, vendor) { return resolvedVendorFor(q, vendor); },
      /* CUSTOM_VENDORFROM_BY_CLAUDE (Ryan 2026-08-27) — which of our mailboxes talks to this
         supplier ('REP' | 'ABBY' | '' for no rule). Exposed so the freight/dims composer in
         dashboard-freight-modal.js applies the SAME rule the PO composer does, from the same
         function — two copies of "who is this from" is how Legend's PO started going out as Ryan
         once already. */
      defaultFromMailboxFor: function (ref, vendor) { return defaultFromMailboxFor(ref, vendor); },
      // CUSTOM_WSFREIGHT_BY_CLAUDE (Ryan 2026-08-27) — see vendorShortCodeMap.
      getVendorShortCode: function (vendor) { return getVendorShortCode(vendor); },
      /* END CUSTOM_DEALDASHBOARD_BY_CLAUDE */
    };

    // DOM refs
    var statsEl = document.getElementById('rqd-stats');
    var loader = document.getElementById('rqd-loader');
    var tbody = document.getElementById('rqd-tbody');
    var tableEl = document.getElementById('rqd-table');
    var tableWrap = document.getElementById('rqd-table-wrap');
    var emptyEl = document.getElementById('rqd-empty');
    var prevBtn = document.getElementById('rqd-prev');
    var nextBtn = document.getElementById('rqd-next');
    var pageInfo = document.getElementById('rqd-page-info');
    var repFilter = document.getElementById('rqd-rep-filter');
    var modalBackdrop = document.getElementById('rqd-modal-backdrop');
    var modalEl = document.getElementById('rqd-modal');
    var modalTitle = document.getElementById('rqd-modal-title');
    var modalSub = document.getElementById('rqd-modal-sub');
    var modalBody = document.getElementById('rqd-modal-body');
    var modalCancel = document.getElementById('rqd-modal-cancel');
    var modalConfirm = document.getElementById('rqd-modal-confirm');

    // Wait for auth
    var checkAuth = setInterval(function() {
      var session = Auth.getSession();
      if (session) {
        clearInterval(checkAuth);
        isAdmin = session.admin === true;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-29) — Non-admins land on
           MONEY MOVES by default (their "act now" queue). Admins keep 'All'.
           An explicit ?status= URL wins for everyone (readUrlState already ran
           synchronously on load, before this async auth callback). */
        try {
          if (!isAdmin && !new URLSearchParams(window.location.search).get('status')) {
            moneyMovesActive = true;
            currentStatus = 'moneymoves';
            var _mmbDefault = document.getElementById('rqd-moneymoves-btn');
            if (_mmbDefault) _mmbDefault.classList.add('rqd-moneymoves--active');
            document.querySelectorAll('.rqd-pill[data-status]').forEach(function(p) { p.classList.remove('rqd-pill--active'); });
          }
        } catch (_) { /* non-fatal: falls back to 'all' */ }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        var userRole = session.role || 'rep';  // 'rep' | 'cfa' | 'admin'
        var isCfa = userRole === 'cfa';
        if (isCfa) {
          document.getElementById('rqd-table-wrap').classList.add('rqd-cfa-view');
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Deal Prospecting
           tab visibility. Show the source-toggle bar + the Deal Prospecting
           button for CFAs and admins. For CFAs, default the source to
           'prospecting' on first load (they don't see the other tabs as
           usable anyway). Admins keep their default of 'offline' but can
           toggle into prospecting and pick a CFA filter. */
        var _dpBtn = document.querySelector('.rqd-source-btn--prospecting');
        if (_dpBtn && (isCfa || isAdmin)) {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Prospecting
             button is no longer a visible tab — the new #rqd-source-select
             dropdown owns the visible UI. Skip the .style.display = ''
             reveal that lived here previously; the hidden button stays
             in the DOM so the select's change handler can synth-click
             it through the original source-change pipeline. */
          if (isCfa && !isAdmin) {
            // No source-toggle bar reveal for CFAs either — the dropdown
            // is in the .rqd-controls row and handles visibility itself.
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — CFAs get ONLY the
               Prospecting tab (starting rule; may be relaxed per-CFA later).
               Force it on every load regardless of any stored rqd-source, so a
               previously-selected Offline can't strand them on a now-pruned tab. */
            currentSource = 'prospecting';
            _dpBtn.classList.add('rqd-source-btn--active');
            document.querySelectorAll('.rqd-source-btn:not(.rqd-source-btn--prospecting)').forEach(function(b) {
              b.classList.remove('rqd-source-btn--active');
            });
          }
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        if (isAdmin) {
          document.getElementById('rqd-table-wrap').classList.add('rqd-admin-view');
          repFilter.style.display = '';
          // Reveal the master Offline / Online / All source toggle (it's
          // hidden by default in the markup so non-admins never see it).
          var srcToggleEl = document.getElementById('rqd-source-toggle');
          if (srcToggleEl) srcToggleEl.style.display = '';
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Reports & Analytics
             section removed from the Deal Dashboard. New reports home is being
             built on the portal hub. initReportsToggle() call removed; the
             function definition stays in this file as harvestable code. */
          // Populate rep filter dropdown, then fetch (deferred so saved filter applies before first load)
          API.get('/rep-list').then(function(data) {
            var reps = data.reps || data || [];
            reps.forEach(function(r) {
              var opt = document.createElement('option');
              opt.value = r.initials || r.code;
              opt.textContent = r.name || r.fullName || r.code;
              /* CUSTOM_RFQPORTAL_BY_CLAUDE — Stash online-access on the option
                 so the change handler can detect when admin picks a rep who
                 only has Offline access while the Online tab is active, and
                 auto-flip to Offline. r.admin (boolean) or r.role === 'admin'
                 are the two signals for "can see Online" — match the
                 srcToggleEl admin-only gating elsewhere. */
              var _canOnline = !!(r && (r.admin === true || r.role === 'admin'));
              opt.dataset.canOnline = _canOnline ? '1' : '0';
              /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Stash CFA
                 role on the option so the change handler can auto-flip
                 admin to the Prospecting tab when a CFA is picked. CFAs
                 only have access to that tab — landing admin elsewhere
                 would show an empty list. Mirrors the canOnline pattern. */
              opt.dataset.isCfa = (r && r.role === 'cfa') ? '1' : '0';
              /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
              repFilter.appendChild(opt);
            });
            /* CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — collect every portal user's
               email for the Abby send-modal autocomplete datalist. */
            if (typeof abbyEmailList !== 'undefined' && abbyEmailList) {
              reps.forEach(function (r) { if (r && r.email) abbyEmailList.push(String(r.email)); });
            }
            var urlRep = new URLSearchParams(window.location.search).get('rep');
            var saved = urlRep;
            if (!saved) { try { saved = localStorage.getItem('rqd-rep-filter'); } catch(e) {} }
            if (saved) repFilter.value = saved;
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — If the persisted source was 'online',
               apply the same rep-snap the click handler does (force RW, remember
               prior value for restoration on Offline/All toggle). */
            if (currentSource === 'online') {
              if (repFilterBeforeOnline === null) repFilterBeforeOnline = repFilter.value;
              var _hasRWBoot = Array.prototype.some.call(repFilter.options, function(o) { return o.value === 'RW'; });
              if (_hasRWBoot) repFilter.value = 'RW';
            }
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          }).catch(function() {}).then(function() { fetchQuotes(); });
        } else {
          fetchQuotes();
        }
        /* Bound once on boot, before any fetch resolves — the button must be live even if the
           first assembly is slow or fails, since a failed load is exactly when someone reaches
           for Refresh. */
        _bindRefreshButton();
        _renderFreshness();
        /* CUSTOM_DDFEEDSTUCK_BY_CLAUDE — a 'Loading activity...' nobody is feeding becomes an
           error with a Retry rather than a permanent spinner. Cheap: it returns immediately
           unless a pending element is actually on the page. */
        if (_stuckHistoryTimer) clearInterval(_stuckHistoryTimer);
        _stuckHistoryTimer = setInterval(_watchStuckHistory, 4000);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Fetch vendor workflow
           map once on boot. Fire-and-forget; the openPurchaseActionMenu
           handler reads vendorWorkflowMap lazily, so a slow vendor-worker
           response just means the first click sees the default menu — still
           usable. Cached for the session. */
        API.get('/vendor-workflows').then(function (data) {
          if (data && data.workflows && typeof data.workflows === 'object') {
            vendorWorkflowMap = data.workflows;
          }
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — Quote Alias candidates ride along in
             the same response. Same fire-and-forget contract: an empty map just means white-label
             rows render as ordinary rows until the fetch lands. */
          if (data && data.aliases && typeof data.aliases === 'object') {
            vendorAliasMap = data.aliases;
          }
          // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — per-vendor PO sender, same contract.
          if (data && data.poFrom && typeof data.poFrom === 'object') {
            vendorPoFromMap = data.poFrom;
          }
          // CUSTOM_WSFREIGHT_BY_CLAUDE (Ryan 2026-08-27) — short codes, same contract.
          if (data && data.shortCodes && typeof data.shortCodes === 'object') {
            vendorShortCodeMap = data.shortCodes;
          }
          // CUSTOM_ALTSOURCE_BY_CLAUDE (Ryan 2026-10-07) - suppliers that buy for a brand ("Buys for").
          if (data && Array.isArray(data.alternates)) vendorAlternates = data.alternates;
          // CUSTOM_ORDERSTHROUGH_BY_CLAUDE (Ryan 2026-11-02) - brand -> parent supplier ("Order through"), same contract.
          if (data && data.ordersThrough && typeof data.ordersThrough === 'object') vendorOrdersThrough = data.ordersThrough;
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        }).catch(function () { /* non-fatal: dashboard falls back to default menu */ });
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      }
    }, 100);

    // ── Event Handlers ──

    // Status filter pills
    document.getElementById('rqd-filters').addEventListener('click', function(e) {
      // Status pills are irrelevant on the Online Orders tab — every online
      // order is paid + sold, so Pending / New Leads / Quoted / Lost don't
      // apply. Block clicks while in online-only mode.
      if (currentSource === 'online') return;
      var pill = e.target.closest('.rqd-pill');
      if (!pill || pill.id === 'rqd-new-toggle') return; // Skip the "+ New" dropdown toggle
      if (!pill.dataset.status) return;
      document.querySelectorAll('.rqd-pill[data-status]').forEach(function(p) { p.classList.remove('rqd-pill--active'); });
      pill.classList.add('rqd-pill--active');
      currentStatus = pill.dataset.status;
      currentPage = 1;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-29) — Picking a status pill
         exits MONEY MOVES, syncs the dropdown trigger label/count, and closes
         the popover. */
      _deactivateMoneyMoves();
      _syncStatusTrigger();
      var _sMenu = document.getElementById('rqd-status-menu');
      if (_sMenu) _sMenu.style.display = 'none';
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Clear the freight-pending sub-filter
      // when any status pill is clicked. Mutually-exclusive UX: status pills
      // and the ⚠ Freight Pending pill are two ways to scope the table,
      // can't be active at the same time.
      if (freightPendingOnly) {
        freightPendingOnly = false;
        var _fpPill = document.getElementById('rqd-freight-pending-pill');
        if (_fpPill) _fpPill.classList.remove('rqd-source-btn--active');
      }
      fetchQuotes();
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-29) — Status dropdown + MONEY
       MOVES. The 11 status pills now live inside #rqd-status-menu (a popover);
       the trigger #rqd-status-toggle mirrors the active pill's label + count.
       MONEY MOVES is a free-standing button mapping to the server status
       'moneymoves' (every deal showing a 🔔), mutually exclusive with the
       dropdown + freight-pending. */
    function _syncStatusTrigger() {
      var labelEl = document.getElementById('rqd-status-toggle-label');
      var countEl = document.getElementById('rqd-status-toggle-count');
      if (!labelEl) return;
      var menu = document.getElementById('rqd-status-menu');
      var active = menu && menu.querySelector('.rqd-pill--active[data-status]');
      if (active && !moneyMovesActive) {
        labelEl.textContent = ((active.firstChild && active.firstChild.textContent) || active.dataset.status || 'All').trim();
        var c = active.querySelector('.rqd-pill__count');
        if (countEl) countEl.textContent = c ? c.textContent : '';
      } else {
        // MONEY MOVES active (or nothing selected) — trigger reads neutral.
        labelEl.textContent = 'All';
        if (countEl) countEl.textContent = '';
      }
    }
    function _deactivateMoneyMoves() {
      moneyMovesActive = false;
      var b = document.getElementById('rqd-moneymoves-btn');
      if (b) b.classList.remove('rqd-moneymoves--active');
    }
    window.__toggleStatusMenu = function(e) {
      if (e) e.stopPropagation();
      var menu = document.getElementById('rqd-status-menu');
      if (!menu) return;
      if (currentSource === 'online') return; // status filters n/a on Online
      menu.style.display = (menu.style.display === 'block') ? 'none' : 'block';
    };
    // Close the status dropdown on outside click.
    document.addEventListener('click', function(e) {
      var menu = document.getElementById('rqd-status-menu');
      if (!menu || menu.style.display !== 'block') return;
      if (e.target.closest('#rqd-statusdd')) return;
      menu.style.display = 'none';
    });
    // MONEY MOVES free-standing filter button.
    var _mmBtn = document.getElementById('rqd-moneymoves-btn');
    if (_mmBtn) {
      _mmBtn.addEventListener('click', function() {
        if (currentSource === 'online') return;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — second click on an already-
           active Money Moves toggles it OFF and reverts to All deals (the exact
           inverse of activate, mirroring a click on the default "All" status pill). */
        if (moneyMovesActive) {
          _deactivateMoneyMoves();
          currentStatus = 'all';
          document.querySelectorAll('.rqd-pill[data-status]').forEach(function(p) {
            p.classList.toggle('rqd-pill--active', p.dataset.status === 'all');
          });
          currentPage = 1;
          _syncStatusTrigger();
          var _smOff = document.getElementById('rqd-status-menu');
          if (_smOff) _smOff.style.display = 'none';
          fetchQuotes();
          return;
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        moneyMovesActive = true;
        _mmBtn.classList.add('rqd-moneymoves--active');
        // Clear status pills' active state (mutually-exclusive scope).
        document.querySelectorAll('.rqd-pill[data-status]').forEach(function(p) { p.classList.remove('rqd-pill--active'); });
        currentStatus = 'moneymoves';
        // Clear the freight-pending sub-filter (also mutually exclusive).
        if (freightPendingOnly) {
          freightPendingOnly = false;
          var _fpPill = document.getElementById('rqd-freight-pending-pill');
          if (_fpPill) _fpPill.classList.remove('rqd-source-btn--active');
        }
        currentPage = 1;
        _syncStatusTrigger();
        var _sm2 = document.getElementById('rqd-status-menu');
        if (_sm2) _sm2.style.display = 'none';
        fetchQuotes();
      });
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Toggle the disabled visual state on the filter row whenever the
    // source switches. Online-only view greys out the status pills + the
    // "+ New" button since neither applies to organic Shopify orders.
    function syncFilterDisabledState() {
      var filtersEl = document.getElementById('rqd-filters');
      if (!filtersEl) return;
      filtersEl.classList.toggle('rqd-filters--disabled', currentSource === 'online');
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Deal-type dropdown
       (replaces the tab-button row visually). The hidden buttons in
       #rqd-source-toggle still carry the source-change logic via the
       click handler below; this select synth-clicks them. Visibility +
       option pruning happens here based on role. */
    var srcSelect = document.getElementById('rqd-source-select');
    function _syncSrcSelectValue() {
      if (!srcSelect) return;
      // Bail if currentSource isn't one of the listed options (e.g. transient
      // 'freight-pending' sub-filter); leave the select on its prior value.
      var matched = Array.prototype.some.call(srcSelect.options, function(o){ return o.value === currentSource; });
      if (matched) srcSelect.value = currentSource;
    }
    if (srcSelect) {
      var _sess = window.RepPortal && window.RepPortal.Auth && window.RepPortal.Auth.getSession();
      var _isAdminSel = !!(_sess && (_sess.admin === true || _sess.role === 'admin'));
      var _isCfaSel = !!(_sess && _sess.role === 'cfa');
      // Prune options the user can't access. data-show-for values:
      //   'cfa-or-admin' → Prospecting (CFAs + admin)
      //   'admin'        → Online / All (admin only)
      //   (unset)        → everyone (Offline default)
      Array.prototype.slice.call(srcSelect.options).forEach(function(opt){
        var gate = opt.dataset.showFor || '';
        var ok = !gate
          || (gate === 'admin' && _isAdminSel)
          || (gate === 'cfa-or-admin' && (_isAdminSel || _isCfaSel));
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — a CFA who isn't also an
           admin sees ONLY Prospecting: prune the ungated Offline + admin-gated
           Online options so the dropdown offers just the one tab. Starting rule —
           relax per-CFA here if some CFAs later need Offline access. */
        if (_isCfaSel && !_isAdminSel) ok = (opt.value === 'prospecting');
        if (!ok) opt.parentNode.removeChild(opt);
      });
      _syncSrcSelectValue();
      srcSelect.addEventListener('change', function(){
        var btn = document.querySelector('#rqd-source-toggle .rqd-source-btn[data-source="' + srcSelect.value + '"]');
        if (btn) btn.click();
      });
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Build a custom
         dropdown alongside the native <select>. <option> elements can
         only render text + emoji glyphs (not SVG / images), so the
         actual Shopify brand mark — same one shown in the REF column
         of Online Deals rows — needed a custom dropdown to live next
         to the "Online Deals" option. The native select stays mounted
         (display:none) as the source-of-truth value holder so the
         existing change-handler chain keeps firing through the same
         path; the custom picker just reads/writes select.value and
         dispatches a change event. */
      if (_isAdminSel || _isCfaSel) {
        // Same Shopify SVG used in the REF column (`refShopifyLogo`,
        // see ~line 5434). Inline so the picker is self-contained.
        var SHOPIFY_ICON_SVG =
          '<svg class="rqd-source-picker__icon" width="20" height="22" viewBox="0 0 23 26" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path fill="#95BF47" d="M19.486 4.667c-.012-.092-.087-.142-.15-.142-.062 0-1.345-.025-1.345-.025s-1.07-1.038-1.183-1.149c-.112-.111-.337-.077-.424-.052-.013.004-.23.071-.591.183-.358-1.027-.987-1.97-2.094-1.97-.03 0-.062.001-.094.003C13.291 1.097 12.91.95 12.578.95c-2.55 0-3.768 3.179-4.151 4.795-.991.306-1.696.524-1.785.553-.553.173-.572.19-.644.711-.054.394-1.5 11.541-1.5 11.541l11.262 2.108L21.69 19.34s-2.193-14.583-2.204-14.673z"/>' +
          '<path fill="#5E8E3E" d="M19.337 4.525c-.062 0-1.345-.025-1.345-.025s-1.07-1.038-1.183-1.149a.262.262 0 0 0-.149-.07v18.95l5.027-1.083s-2.193-14.583-2.204-14.673c-.012-.092-.087-.142-.15-.142z"/>' +
          '<path fill="#FFFFFF" d="M13.482 8.247l-.652 1.927c-.385-.205-.836-.327-1.342-.327-1.082 0-1.143.677-1.143.847 0 .929 2.422 1.286 2.422 3.461 0 1.711-1.085 2.812-2.546 2.812-1.751 0-2.647-1.092-2.647-1.092l.469-1.553s.921.79 1.7.79c.508 0 .714-.4.714-.694 0-1.211-1.987-1.265-1.987-3.255 0-1.674 1.205-3.295 3.633-3.295.937.001 1.379.32 1.379.32z"/>' +
          '</svg>';
        function _optHtmlForValue(v, label) {
          var icon = (v === 'online') ? SHOPIFY_ICON_SVG : '';
          var labelHtml = '<span class="rqd-source-picker__label">' + label.replace(/[<>&"]/g, function(c){
            return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c];
          }) + '</span>';
          return icon + labelHtml;
        }
        var _availOptions = Array.prototype.slice.call(srcSelect.options).map(function(o){
          return { value: o.value, label: o.textContent.trim() };
        });
        var _picker = document.createElement('div');
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — a user with access to
           exactly one tab (a CFA sees only Prospecting after the pruning above)
           gets a dropdown that can only ever pick what's already selected. Tag it
           so CSS can drop it on mobile, where the space actually costs something.
           Kept on desktop: there it reads as a heading telling you which tab
           you're on, and the row has room for it. */
        var _isSingleTab = _availOptions.length <= 1;
        _picker.className = 'rqd-source-picker' + (_isSingleTab ? ' rqd-source-picker--single' : '');
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — mirror the flag onto the
           native select. On mobile the select becomes the visible control (see the
           CSS swap), so it needs the same "only one tab — show nothing" rule the
           picker has. */
        if (_isSingleTab) srcSelect.classList.add('rqd-controls__select--single');
        _picker.innerHTML =
          '<button type="button" class="rqd-source-picker__trigger" aria-haspopup="listbox" aria-expanded="false">' +
            '<span class="rqd-source-picker__trigger-content"></span>' +
            '<span class="rqd-source-picker__chevron" aria-hidden="true">▾</span>' +
          '</button>' +
          '<div class="rqd-source-picker__menu" role="listbox" hidden>' +
            _availOptions.map(function(o){
              return '<button type="button" class="rqd-source-picker__option" role="option" data-value="' + o.value.replace(/"/g, '&quot;') + '">' +
                _optHtmlForValue(o.value, o.label) +
              '</button>';
            }).join('') +
          '</div>';
        srcSelect.parentNode.insertBefore(_picker, srcSelect.nextSibling);
        /* Hide native select — the custom picker is the visible UI on desktop.
           CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15): on mobile the CSS flips
           this back (display:block !important, which is why this stays an inline
           style rather than a class) so tapping the control opens the OS-native
           picker — the same behaviour as the Name and Date selects, which are
           plain <select>s. The custom picker only exists to render the Shopify
           SVG beside "Online Deals", which an <option> cannot do; that's a
           desktop nicety not worth a bespoke menu on a phone. The 250ms value
           poller below keeps the picker's label in lockstep, so a pick made via
           the native select on mobile is reflected if the viewport widens. */
        srcSelect.style.display = 'none';

        var _trigger = _picker.querySelector('.rqd-source-picker__trigger');
        var _triggerContent = _picker.querySelector('.rqd-source-picker__trigger-content');
        var _menu = _picker.querySelector('.rqd-source-picker__menu');
        function _syncPickerTrigger() {
          var cur = _availOptions.find(function(o){ return o.value === srcSelect.value; }) || _availOptions[0];
          if (cur) _triggerContent.innerHTML = _optHtmlForValue(cur.value, cur.label);
          _picker.querySelectorAll('.rqd-source-picker__option').forEach(function(b){
            b.classList.toggle('rqd-source-picker__option--active', b.dataset.value === srcSelect.value);
          });
        }
        _trigger.addEventListener('click', function(e){
          e.stopPropagation();
          var willOpen = _menu.hidden;
          _menu.hidden = !willOpen;
          _trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
        _menu.addEventListener('click', function(e){
          var btn = e.target.closest('.rqd-source-picker__option');
          if (!btn) return;
          srcSelect.value = btn.dataset.value;
          srcSelect.dispatchEvent(new Event('change', { bubbles: true }));
          _syncPickerTrigger();
          _menu.hidden = true;
          _trigger.setAttribute('aria-expanded', 'false');
        });
        document.addEventListener('click', function(e){
          if (!_picker.contains(e.target)) {
            _menu.hidden = true;
            _trigger.setAttribute('aria-expanded', 'false');
          }
        });
        // Watch for external value changes (e.g. _syncSrcSelectValue
        // running after a freight-pending sub-filter toggles back to
        // a known source) and keep the trigger label in lockstep.
        var _lastSelVal = srcSelect.value;
        setInterval(function(){
          if (srcSelect.value !== _lastSelVal) {
            _lastSelVal = srcSelect.value;
            _syncPickerTrigger();
          }
        }, 250);
        _syncPickerTrigger();
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Master source toggle (Offline / Online / All) — admin only.
    var srcToggle = document.getElementById('rqd-source-toggle');
    // Holds the rep filter value before we force it to RW for the Online
    // tab — restored when the user toggles back off Online. Skipped if
    // already null so re-toggling Online → All → Online doesn't lose
    // the original "true" pre-Online value.
    var repFilterBeforeOnline = null;
    if (srcToggle) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Apply persisted source on init. The
         markup ships with the Offline button active; if the user last had a
         different tab open, flip the active class to match currentSource so
         the UI and state agree before the first fetchQuotes. The Online-tab
         rep-snap is handled later in the /rep-list async callback (rep
         options aren't populated yet at this point). */
      if (currentSource !== 'offline') {
        srcToggle.querySelectorAll('.rqd-source-btn').forEach(function(b) {
          b.classList.toggle('rqd-source-btn--active', b.dataset.source === currentSource);
        });
        var cancelledElInit = document.getElementById('rqd-source-cancelled');
        if (cancelledElInit) cancelledElInit.style.display = (currentSource === 'offline' || currentSource === 'prospecting') ? 'none' : '';
        syncFilterDisabledState();
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      srcToggle.addEventListener('click', function(e) {
        var btn = e.target.closest('.rqd-source-btn');
        if (!btn) return;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Freight Pending pill lives inside
           the source-toggle row but is a client-side sub-filter, NOT a
           source change. Toggle freightPendingOnly + refresh in place
           instead of mutating currentSource (which would clobber
           Offline/Online/All scoping). */
        if (btn.dataset.source === 'freight-pending') {
          freightPendingOnly = !freightPendingOnly;
          btn.classList.toggle('rqd-source-btn--active', freightPendingOnly);
          // Clear status pills' active state when entering freight-pending
          // mode so the active scope is unambiguous.
          if (freightPendingOnly) {
            document.querySelectorAll('.rqd-pill[data-status]').forEach(function (p) {
              p.classList.toggle('rqd-pill--active', p.dataset.status === 'all');
            });
            currentStatus = 'all';
          }
          currentPage = 1;
          fetchQuotes();
          return;
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        srcToggle.querySelectorAll('.rqd-source-btn').forEach(function(b) { b.classList.remove('rqd-source-btn--active'); });
        btn.classList.add('rqd-source-btn--active');
        var prevSource = currentSource;
        currentSource = btn.dataset.source;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17; updated 2026-07-11) — Tear down the
           prospect filter bar when leaving the prospecting tab and reset to the default
           All Active view (view='all' + the 3 active stages) so a re-entry always starts
           there, never stranded on the 🔔 Follow Up view or a prior stage selection. */
        if (prevSource === 'prospecting' && currentSource !== 'prospecting') {
          currentProspectView = 'all';
          currentProspectStages = PROSPECT_ACTIVE_STAGES.slice();
          if (typeof _syncProspectFilters === 'function') _syncProspectFilters();
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        // CUSTOM_RFQPORTAL_BY_CLAUDE — Clear the freight-pending sub-filter
        // when admin switches Offline / Online / All — those are
        // mutually-exclusive scopes from the freight-pending sub-filter.
        if (freightPendingOnly) {
          freightPendingOnly = false;
          var _fpPill = document.getElementById('rqd-freight-pending-pill');
          if (_fpPill) _fpPill.classList.remove('rqd-source-btn--active');
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-02) — Online Deals can't
           be scoped by the status dropdown / Money Moves (both controls grey
           out on this view). A status filter carried over from another tab —
           e.g. Money Moves — keeps applying server-side, silently filtering
           every online order to zero ("No deals found matching your filters")
           while the Money Moves button stays lit but un-clickable (its handler
           early-returns on Online). Snap the status scope back to 'All' when
           entering Online so the table populates. */
        if (currentSource === 'online') {
          if (moneyMovesActive) _deactivateMoneyMoves();
          currentStatus = 'all';
          document.querySelectorAll('.rqd-pill[data-status]').forEach(function (p) {
            p.classList.toggle('rqd-pill--active', p.dataset.status === 'all');
          });
          if (typeof _syncStatusTrigger === 'function') _syncStatusTrigger();
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        try { localStorage.setItem('rqd-source', currentSource); } catch (e) {}
        if (typeof _syncSrcSelectValue === 'function') _syncSrcSelectValue();
        currentPage = 1;
        // Online Orders auto-snap the rep dropdown to RW — Ryan is the
        // de-facto handler for online orders (only admins can see them at
        // all per the worker's permission gate, and no rep tag attaches
        // to Shopify customer orders, so any other rep selection is
        // misleading). Restore the prior rep filter when leaving Online.
        // Bypass localStorage on both legs so the user's persisted "true"
        // filter preference isn't overwritten by the temporary force.
        if (currentSource === 'online' && prevSource !== 'online') {
          if (repFilterBeforeOnline === null) repFilterBeforeOnline = repFilter.value;
          // Only force if RW is actually an option on this dropdown
          // (defensive — some envs may not seed it). Falls back silently.
          var hasRW = Array.prototype.some.call(repFilter.options, function(o) { return o.value === 'RW'; });
          if (hasRW) repFilter.value = 'RW';
        } else if (currentSource !== 'online' && prevSource === 'online') {
          if (repFilterBeforeOnline !== null) {
            repFilter.value = repFilterBeforeOnline;
            repFilterBeforeOnline = null;
          }
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — show-cancelled toggle visibility */
        var cancelledEl = document.getElementById('rqd-source-cancelled');
        if (cancelledEl) cancelledEl.style.display = (currentSource === 'offline' || currentSource === 'prospecting') ? 'none' : '';
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — the open-deal trim is Online-only, so
        // its toggle follows the source picker. Called here as well as after render because a
        // source switch has to hide/show it before the fetch resolves.
        syncOlderCompletedToggle();
        syncFilterDisabledState();
        fetchQuotes();
      });
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — show-cancelled checkbox handler */
      var includeCancelledCb = document.getElementById('rqd-include-cancelled');
      if (includeCancelledCb) {
        includeCancelledCb.addEventListener('change', function() {
          currentIncludeCancelled = !!this.checked;
          currentPage = 1;
          fetchQuotes();
        });
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — older-completed toggle. Checked = show
         the full window; unchecked (the default) = stop at the earliest still-open deal. The
         cut is purely a view over rows already in hand, so this re-renders rather than
         re-fetching. Persisted so the default holds across reloads. */
      var showOlderCb = document.getElementById('rqd-show-older-completed');
      if (showOlderCb) {
        showOlderCb.checked = !currentHideOlderCompleted;
        showOlderCb.addEventListener('change', function () {
          currentHideOlderCompleted = !this.checked;
          try { localStorage.setItem('rqd_hide_older_completed', currentHideOlderCompleted ? '1' : '0'); } catch (_) {}
          fetchQuotes();
        });
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }

    // Search — debounced input + a small × clear button. Wrap toggles
    // `has-value` to show/hide the button without per-keystroke layout
    // shift. Clear button uses mousedown so the click fires before the
    // input loses focus on blur (avoids losing focus in some browsers).
    var searchInput = document.getElementById('rqd-search');
    var searchClearBtn = document.getElementById('rqd-search-clear');
    var searchWrap = searchInput && searchInput.parentElement;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Shorter search
       placeholder on mobile. The verbose desktop "Search by reference,
       customer, email, phone, ZIP, address..." overflowed the input on
       narrow viewports. Plain "Search" reads cleanly and the rep
       discovers the searchable fields via typing. */
    if (searchInput && window.matchMedia && window.matchMedia('(max-width: 760px)').matches) {
      searchInput.placeholder = 'Search';
    }
    function syncSearchClearBtn() {
      if (!searchWrap) return;
      searchWrap.classList.toggle('has-value', !!searchInput.value);
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Search-driven rep-filter snap.
       Admins start each search with an open catchment (All Reps) so the
       query can hit orders belonging to any rep they have visibility on.
       When the search clears, the prior rep selection resumes. No write
       to localStorage — the snap is ephemeral. Non-admins (no dropdown
       shown) are untouched. Defensive restore: if anything else moved
       the dropdown while search was active (source tab toggle, manual
       change), skip the restore so we don't yank them off a deliberate
       choice. */
    var repFilterBeforeSearch = null;
    function maybeSnapRepForSearch(hasQuery) {
      if (!repFilter || repFilter.style.display === 'none') return;
      if (hasQuery) {
        if (repFilterBeforeSearch === null && repFilter.value !== '') {
          repFilterBeforeSearch = repFilter.value;
          repFilter.value = '';
        }
      } else if (repFilterBeforeSearch !== null) {
        if (repFilter.value === '') repFilter.value = repFilterBeforeSearch;
        repFilterBeforeSearch = null;
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_DDSEARCH_BY_CLAUDE (Ryan 2026-10-07) — INSTANT SEARCH, THEN THE FULL ANSWER.
       ────────────────────────────────────────────────────────────────────────────────────────
       Reps asked to find a contact by phone number "quick". Phone search already worked — the
       server matched it — but every search blanked the table, showed the spinner and waited on a
       round trip (a 6s rebuild when the rep's cached board had lapsed). Now each keystroke filters
       the rows ALREADY on screen at once, and the server search runs quietly behind it to fill in
       matches from page 2+, other status pills and (for admins) the other tab.

       ⛔ `_ddSearchMatch` IS A COPY OF THE WORKER'S `matchesQuoteSearch` (quote-dashboard.js).
       Edit both or tests/dd-search-parity.test.mjs goes red — that is the point: the instant rows
       and the server's rows must agree about what a match is, or rows flash in and out.

       ⚠️ The pool is the last NON-search load of the CURRENT view (tab / status / rep / dates)
       plus every row a background search has returned since; a pool from another view is never
       used (`_ddSearchViewKey`), because filtering the old tab's rows would show deals that are
       not on the tab the rep is looking at. */
    function _ddSearchMatch(q, term) {
      if (!term) return true;
      var fields = [
        q.reference,
        q.customer,
        q.customerEmail,
        q.customerCompany,
        q.customerStreet,
        q.customerStreet2,
        q.city,
        q.state,
        q.zip,
        q.location
      ];
      if (q.shipTo) {
        fields.push(q.shipTo.name, q.shipTo.company, q.shipTo.street, q.shipTo.street2,
          q.shipTo.city, q.shipTo.state, q.shipTo.zip, q.shipTo.email);
      }
      if (q.billTo) {
        fields.push(q.billTo.name, q.billTo.company, q.billTo.street, q.billTo.street2,
          q.billTo.city, q.billTo.state, q.billTo.zip, q.billTo.email);
      }
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        if (f && String(f).toLowerCase().indexOf(term) !== -1) return true;
      }
      var termDigits = term.replace(/\D/g, '');
      if (termDigits.length === 11 && termDigits.charAt(0) === '1') termDigits = termDigits.slice(1);
      if (termDigits.length >= 3) {
        var phones = [q.customerPhone, q.shipTo && q.shipTo.phone, q.billTo && q.billTo.phone];
        for (var p = 0; p < phones.length; p++) {
          if (!phones[p]) continue;
          var pd = String(phones[p]).replace(/\D/g, '');
          if (pd && pd.indexOf(termDigits) !== -1) return true;
        }
      }
      /* CUSTOM_DDSEARCH_BY_CLAUDE (Ryan 2026-10-14) — find a deal by its total; same rule as the
         worker ("1425523", "$14,255.23", "14,255.23", "14255" all find $14,255.23). */
      var money = /^\$?([\d,]+)(?:\.(\d{0,2}))?$/.exec(term);
      var total = parseFloat(q.total) || 0;
      if (money && total > 0) {
        var cents = Math.round(total * 100);
        var typed = money[1].replace(/,/g, '');
        if (money[2] === undefined) {
          if (typed.length >= 3 && String(cents).indexOf(typed) === 0) return true;
        } else if (Number(typed) === Math.floor(cents / 100) && ('0' + (cents % 100)).slice(-2).indexOf(money[2]) === 0) {
          return true;
        }
      }
      return false;
    }
    var _ddSearchPool = null;     // { key, rows } — the last non-search load of a view
    var _ddSearchExtras = {};     // ref -> row, returned by background searches on this view
    var _ddSearchViewKey = '';    // the view (minus search + page) currently on screen
    var _ddSearchEmptyText = (emptyEl && emptyEl.textContent || '').trim() || 'No deals found matching your filters.';
    /* Keyed on the TAB (source + cancelled) only. A search snaps an admin's rep filter to All
       Reps and ignores the status pill server-side, so a pool loaded under one rep or one pill is
       still a true subset of what the search covers; keying on the whole URL threw the pool away
       the moment the first background search ran (Ryan 2026-10-07: "804" found JW-1308-A,
       "8048" lost him). */
    function _ddViewKeyOf(params) {
      var s = String(params || '');
      var src = (s.match(/[?&]source=([^&]*)/) || [])[1] || '';
      return src + (/[?&]includeCancelled=1/.test(s) ? '|c' : '');
    }
    function _ddResetSearchExtras() { _ddSearchExtras = {}; }
    /* A match on ANY row of a revision chain / linked group / replacement keeps the whole group,
       so a matching child never renders without its parent (renderTable groups whatever it is
       handed, and a lone child would be drawn as a parent of its own). */
    function _ddSearchGroupKeys(q) {
      var keys = [];
      var parsed = parseBaseRef(q.reference);
      keys.push(q.linkGroupId || (parsed ? parsed.base : q.reference));
      if (q.isReplacement && q.replacementParentRef) {
        var pp = parseBaseRef(q.replacementParentRef);
        keys.push(pp ? pp.base : q.replacementParentRef);
      }
      return keys;
    }
    function _ddInstantFilter(val) {
      var term = String(val || '').toLowerCase().trim();
      if (!term) return;
      var rows = [];
      var seen = {};
      if (_ddSearchPool && _ddSearchPool.key === _ddSearchViewKey) {
        _ddSearchPool.rows.forEach(function (q) { if (q && q.reference && !seen[q.reference]) { seen[q.reference] = 1; rows.push(q); } });
      }
      Object.keys(_ddSearchExtras).forEach(function (r) { if (!seen[r]) { seen[r] = 1; rows.push(_ddSearchExtras[r]); } });
      var hitKeys = {};
      rows.forEach(function (q) {
        if (_ddSearchMatch(q, term)) _ddSearchGroupKeys(q).forEach(function (k) { hitKeys[k] = 1; });
      });
      var subset = rows.filter(function (q) {
        return _ddSearchGroupKeys(q).some(function (k) { return hitKeys[k]; });
      });
      subset = freightPendingOnly ? subset : applyOpenDealCut(subset);
      loader.style.display = 'none';
      emptyEl.textContent = 'Searching all deals…';
      renderTable(subset, { stream: subset.length > 30 });
      restoreExpandedRow();
      var _deals = {};
      subset.forEach(function (q) { if (!q.isReplacement || currentStatus === 'replacement') _deals[_ddSearchGroupKeys(q)[0]] = 1; });
      var shown = Object.keys(_deals).length;
      pageInfo.textContent = (shown ? shown + ' on screen' : 'None on screen') + ' · searching all deals…';
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      document.getElementById('rqd-pagination').style.display = '';
    }
    /* Warm the rep's cached board when the search box is focused, so the background search
       re-slices a cached board instead of paying the full rebuild. A plain view load refreshes
       the worker's board cache (180s); skipped when the board was fetched within the last 2 min. */
    var _ddSearchWarmAt = 0;
    searchInput.addEventListener('focus', function () {
      if (currentSource === 'prospecting') return;
      var now = Date.now();
      if (now - _ddSearchWarmAt < 120000 || !_lastParams) return;
      _ddSearchWarmAt = now;
      /* Warm the board the SEARCH will read: an admin's search snaps to All Reps, which is a
         different worker board from the one-rep view on screen. No __nc — a warm board answers
         from cache in well under a second; a cold one is built now, while the rep is typing. */
      var p = _lastParams.replace(/&search=[^&]*/, '&search=');
      if (repFilter && repFilter.style.display !== 'none') p = p.replace(/&rep=[^&]*/, '');
      try { API.get('/rep-quotes' + p).catch(function () { /* best-effort */ }); } catch (_) {}
    });
    searchInput.addEventListener('input', function() {
      var val = this.value;
      syncSearchClearBtn();
      clearTimeout(searchTimer);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — Prospecting search is client-side
         (/cfa-prospects returns the whole list); re-render in place, no network round-trip. */
      if (currentSource !== 'prospecting' && val.trim()) {
        try { _ddInstantFilter(val); } catch (e) { console.warn('instant search failed', e); }
      }
      searchTimer = setTimeout(function() {
        maybeSnapRepForSearch(!!val);
        currentSearch = val;
        currentPage = 1;
        if (currentSource === 'prospecting') { _renderProspectView(); return; }
        if (!val.trim()) { _ddResetSearchExtras(); fetchQuotes(); return; }
        fetchQuotes({ searchBg: true });
      }, 300);
    });
    if (searchClearBtn) {
      searchClearBtn.addEventListener('mousedown', function(e) {
        e.preventDefault(); // keep input focus
      });
      searchClearBtn.addEventListener('click', function() {
        searchInput.value = '';
        searchInput.focus();
        syncSearchClearBtn();
        clearTimeout(searchTimer);
        maybeSnapRepForSearch(false);
        currentSearch = '';
        currentPage = 1;
        _ddResetSearchExtras();
        fetchQuotes();
      });
    }
    // Esc on the input also clears (matches native search-input UX).
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && this.value) {
        this.value = '';
        syncSearchClearBtn();
        clearTimeout(searchTimer);
        maybeSnapRepForSearch(false);
        currentSearch = '';
        currentPage = 1;
        _ddResetSearchExtras();
        fetchQuotes();
      }
    });
    // Initial sync — covers the case where the page restored a search
    // term from URL state on load.
    syncSearchClearBtn();

    // Brand-list tooltip — singleton element appended to body so the
    // REF cell's overflow:hidden (needed for ellipsis-truncating long
    // refs) doesn't clip it. Position-fixed + JS-driven coordinates
    // means the tooltip can render anywhere on screen, escaping the
    // table/cell bounds entirely. Single shared element across all
    // rows since at most one row is hovered at a time.
    var brandsTip = document.createElement('div');
    brandsTip.className = 'rqd-brands-tooltip';
    brandsTip.setAttribute('role', 'tooltip');
    document.body.appendChild(brandsTip);
    var brandsTipShowTimer = null;
    var brandsTipHideTimer = null;
    function hideBrandsTip() {
      clearTimeout(brandsTipShowTimer);
      clearTimeout(brandsTipHideTimer);
      brandsTip.classList.remove('rqd-brands-tooltip--visible');
      brandsTip._activeCell = null;
    }
    // Defer hide briefly so the cursor can travel from the REF cell into
    // the tooltip itself without the tooltip vanishing mid-transit. The
    // sample-tracking popover gets away without this because it's a
    // direct child of the trigger (CSS :hover bubbles); the brand
    // tooltip lives on <body> (escapes the REF cell's overflow:hidden)
    // so the JS has to bridge the gap.
    function scheduleHideBrandsTip() {
      clearTimeout(brandsTipHideTimer);
      brandsTipHideTimer = setTimeout(hideBrandsTip, 150);
    }
    function cancelHideBrandsTip() {
      clearTimeout(brandsTipHideTimer);
    }
    // Render the popover body — same anatomy as the sample tracking
    // popover: label line + selectable detail. For a single vendor we
    // show "Brand · {name}"; for multiple we show "Brands (N)" + bullet
    // list. user-select:text on the body lets reps highlight + Ctrl+C.
    function renderBrandsTipContent(brands) {
      if (!brands.length) return '';
      var html = '';
      if (brands.length === 1) {
        html += '<div class="rqd-brands-tooltip__label">Brand</div>';
        html += '<div class="rqd-brands-tooltip__list">' + esc(brands[0]) + '</div>';
      } else {
        html += '<div class="rqd-brands-tooltip__label">Brands · ' + brands.length + '</div>';
        html += '<ul class="rqd-brands-tooltip__list">';
        brands.forEach(function (b) {
          html += '<li>' + esc(b) + '</li>';
        });
        html += '</ul>';
      }
      return html;
    }
    function positionBrandsTip(cellEl) {
      // Dark-mode class — the tooltip lives on <body> (outside the
      // .rep-quote-portal-wrap.rep-quote-dark scope) so ancestor
      // selectors don't reach it. Sync the class explicitly on each
      // show so theme toggles take effect on the next hover.
      var darkOn = !!document.querySelector('.rep-quote-portal-wrap.rep-quote-dark');
      brandsTip.classList.toggle('rqd-brands-tooltip--dark', darkOn);
      // Read the cell rect on each show so it tracks scrolling /
      // sticky-header offsets. measureFirst trick: render off-screen
      // to get the tooltip's natural width, then snap to the cell.
      brandsTip.style.left = '-9999px';
      brandsTip.style.top = '0';
      brandsTip.classList.add('rqd-brands-tooltip--visible');
      var tipRect = brandsTip.getBoundingClientRect();
      var cellRect = cellEl.getBoundingClientRect();
      // Default: below the cell, left-aligned with the REF text — same
      // direction as the sample tracking popover.
      var left = cellRect.left + 8;
      var top = cellRect.bottom + 6;
      // If below would clip past the viewport, render above the cell.
      if (top + tipRect.height > window.innerHeight - 8) {
        top = cellRect.top - tipRect.height - 6;
      }
      if (top < 4) top = 4;
      // Keep within viewport horizontally.
      if (left + tipRect.width > window.innerWidth - 8) {
        left = window.innerWidth - tipRect.width - 8;
      }
      if (left < 8) left = 8;
      brandsTip.style.left = left + 'px';
      brandsTip.style.top = top + 'px';
    }
    document.addEventListener('mouseover', function (e) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Skip the
         REF-cell brands tooltip entirely on touch devices. iOS/Android
         fire `mouseover` on tap, so the dropdown was surfacing every
         time a rep tapped a REF on mobile. Ryan doesn't want this
         behaviour on touch — the brand list is still accessible from
         the row's detail panel. */
      if (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
      // Hovering INSIDE the tooltip itself — keep it open. The cursor
      // is on its way to select text or just resting on the surface.
      if (brandsTip.contains(e.target)) { cancelHideBrandsTip(); return; }
      var cell = e.target && e.target.closest && e.target.closest('.rqd-col-ref[data-brands-tooltip]');
      if (!cell) return;
      var raw = cell.getAttribute('data-brand-list') || '';
      var brands = raw ? raw.split('|').filter(Boolean) : [];
      if (!brands.length) {
        // Legacy fallback — render the flat-text tooltip if no brand-list
        // attribute is present (shouldn't happen after the row rebuild,
        // but defensive against half-rendered states).
        var text = cell.getAttribute('data-brands-tooltip') || '';
        if (!text) return;
        if (cell === brandsTip._activeCell) { cancelHideBrandsTip(); return; }
        brandsTip._activeCell = cell;
        brandsTip.textContent = text;
        clearTimeout(brandsTipShowTimer);
        brandsTipShowTimer = setTimeout(function () { positionBrandsTip(cell); }, 150);
        return;
      }
      if (cell === brandsTip._activeCell) { cancelHideBrandsTip(); return; }
      brandsTip._activeCell = cell;
      brandsTip.innerHTML = renderBrandsTipContent(brands);
      cancelHideBrandsTip();
      clearTimeout(brandsTipShowTimer);
      brandsTipShowTimer = setTimeout(function () { positionBrandsTip(cell); }, 150);
    });
    document.addEventListener('mouseout', function (e) {
      // Leaving the tooltip — schedule a hide unless the cursor enters
      // back into the REF cell or stays within the tooltip.
      if (brandsTip.contains(e.target)) {
        if (e.relatedTarget && brandsTip.contains(e.relatedTarget)) return;
        if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.rqd-col-ref[data-brands-tooltip]')) return;
        scheduleHideBrandsTip();
        return;
      }
      var cell = e.target && e.target.closest && e.target.closest('.rqd-col-ref[data-brands-tooltip]');
      if (!cell) return;
      // Only hide when leaving the cell entirely. Don't hide if the
      // cursor is moving into the tooltip itself.
      if (e.relatedTarget && cell.contains(e.relatedTarget)) return;
      if (e.relatedTarget && brandsTip.contains(e.relatedTarget)) return;
      scheduleHideBrandsTip();
    });
    // Hide on scroll so the tooltip doesn't drift away from its anchor.
    window.addEventListener('scroll', hideBrandsTip, true);

    // ── Sample tracking popover (body-level, same pattern as brands)
    // The 📦 pill in the To Do column carries the tracking data as
    // data-attributes; this single popover element reads them on hover
    // and renders the link + saved date. Lives on <body> to escape the
    // table-scroll wrapper's overflow-x:auto (which would otherwise
    // both clip the popover's right edge AND contribute to a phantom
    // horizontal scroll on the table).
    var sampleTip = document.createElement('div');
    sampleTip.className = 'rqd-sample-tip';
    sampleTip.setAttribute('role', 'tooltip');
    document.body.appendChild(sampleTip);
    var sampleTipShowTimer = null;
    var sampleTipHideTimer = null;
    function hideSampleTip() {
      clearTimeout(sampleTipShowTimer);
      clearTimeout(sampleTipHideTimer);
      sampleTip.classList.remove('rqd-sample-tip--visible');
      /* Give the pill its native `title` back — see the note where it is stripped.
         ⚠️ Restored off `_activeCell` rather than by re-querying: the board re-renders often
         enough that the pill we stripped may no longer be the pill under the cursor, and a
         query would hand the title to the wrong one (or to none, stranding it permanently
         title-less). The element reference is the only thing that stays true across a
         re-render — and if it HAS been replaced wholesale, the new node was built with its
         title already on it, so nothing is owed. */
      var prev = sampleTip._activeCell;
      if (prev && prev._rqdTitle != null) {
        prev.setAttribute('title', prev._rqdTitle);
        prev._rqdTitle = null;
      }
      sampleTip._activeCell = null;
    }
    function scheduleHideSampleTip() {
      clearTimeout(sampleTipHideTimer);
      sampleTipHideTimer = setTimeout(hideSampleTip, 150);
    }
    function cancelHideSampleTip() {
      clearTimeout(sampleTipHideTimer);
    }
    function renderSampleTipContent(url, label, saved, state, tone, list) {
      var html = '';
      /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-20) — a pill carrying more than one box renders a
         row per box: "on mouseover, it needs to clearly denote both tracking numbers". */
      var boxes = null;
      if (list) { try { boxes = JSON.parse(list); } catch (_) { boxes = null; } }
      /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: a box that names WHO it went to
         prints that name where "Shipment N" goes, so two people read differently from two boxes. */
      if (Array.isArray(boxes) && (boxes.length > 1 || boxes.some(function (b) { return b && b.who; }))) {
        boxes.forEach(function (b) {
          if (!b) return;
          html += '<div class="rqd-sample-tip__box">'
            + '<div class="rqd-sample-tip__seq">' + (b.who ? esc(String(b.who)) : 'Shipment ' + esc(String(b.seq || ''))) + '</div>'
            + (b.state ? '<div class="rqd-sample-tip__state' + (b.tone ? ' rqd-sample-tip__state--' + esc(String(b.tone)) : '') + '">' + esc(String(b.state)) + '</div>' : '')
            + (b.url
                ? '<a class="rqd-sample-tip__link" href="' + esc(String(b.url)) + '" target="_blank" rel="noopener">' + esc(String(b.label || '')) + '</a>'
                : '<span class="rqd-sample-tip__link">' + esc(String(b.label || '')) + '</span>')
            + (b.saved ? '<div class="rqd-sample-tip__footer"><span class="rqd-sample-tip__date">Saved ' + esc(String(b.saved)) + '</span>'
                + (b.url ? '<button type="button" class="rqd-sample-tip__copy" data-copy-url="' + esc(String(b.url)) + '" title="Copy tracking URL to clipboard">Copy</button>' : '') + '</div>' : '')
            + '</div>';
        });
        return html;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — ⛔ DID THE BOX LAND? IT SAYS SO HERE NOW.
         ─────────────────────────────────────────────────────────────────────────────────────
         This popover listed carrier, number, link and saved-date — everything about the
         SHIPMENT and nothing about its OUTCOME. The delivery state existed, but only inside
         the pill's native `title` attribute, which meant hovering the badge opened this
         styled popover AND, a second later, the browser's own tooltip bubble on top of it
         saying something different. Two tooltips from one hover, and the one carrying
         "Delivered · 8/7" was the one you could not read without waiting for it.

         The sentence leads, because it is the answer to the question a rep hovered to ask. */
      if (state) {
        html += '<div class="rqd-sample-tip__state' + (tone ? ' rqd-sample-tip__state--' + tone : '') + '">'
              + esc(state) + '</div>';
      }
      if (url) {
        html += '<a class="rqd-sample-tip__link" href="' + esc(url) + '" target="_blank" rel="noopener">' + esc(label) + '</a>';
      } else {
        html += '<span class="rqd-sample-tip__link">' + esc(label) + '</span>';
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Footer row: saved date on the left,
         Copy button on the right. Copy button shows only when there's an
         actual URL to copy (no URL = label-only popover for unknown
         carriers, nothing useful to copy). */
      var footer = '';
      if (saved) footer += '<span class="rqd-sample-tip__date">Saved ' + esc(saved) + '</span>';
      if (url) footer += '<button type="button" class="rqd-sample-tip__copy" data-copy-url="' + esc(url) + '" title="Copy tracking URL to clipboard">Copy</button>';
      if (footer) html += '<div class="rqd-sample-tip__footer">' + footer + '</div>';
      return html;
    }
    function positionSampleTip(cellEl) {
      var darkOn = !!document.querySelector('.rep-quote-portal-wrap.rep-quote-dark');
      sampleTip.classList.toggle('rqd-sample-tip--dark', darkOn);
      // Variant flows from the icon's data-variant so the popover hyperlink
      // colour matches the 📦 pill colour: quote=blue, lead=orange,
      // on-hold=purple, anything else stays forest-green (sample-row default).
      var variant = cellEl.getAttribute('data-variant') || '';
      sampleTip.classList.toggle('rqd-sample-tip--quote', variant === 'quote');
      sampleTip.classList.toggle('rqd-sample-tip--lead', variant === 'lead');
      sampleTip.classList.toggle('rqd-sample-tip--on-hold', variant === 'on-hold');
      sampleTip.style.left = '-9999px';
      sampleTip.style.top = '0';
      sampleTip.classList.add('rqd-sample-tip--visible');
      var tipRect = sampleTip.getBoundingClientRect();
      var cellRect = cellEl.getBoundingClientRect();
      // Default: below the icon, left-aligned (same direction as the brand tooltip).
      var left = cellRect.left;
      var top = cellRect.bottom + 6;
      // Flip up if it would clip past the viewport bottom.
      if (top + tipRect.height > window.innerHeight - 8) {
        top = cellRect.top - tipRect.height - 6;
      }
      if (top < 4) top = 4;
      // Keep within viewport horizontally.
      if (left + tipRect.width > window.innerWidth - 8) {
        left = window.innerWidth - tipRect.width - 8;
      }
      if (left < 8) left = 8;
      sampleTip.style.left = left + 'px';
      sampleTip.style.top = top + 'px';
    }
    document.addEventListener('mouseover', function (e) {
      // Hovering INSIDE the popover — keep open while the cursor may
      // be heading to the link to click or to select the tracking text.
      if (sampleTip.contains(e.target)) { cancelHideSampleTip(); return; }
      var pill = e.target && e.target.closest && e.target.closest('.rqd-sample-shipped, .rqd-sample-tag[data-track-label]');
      if (!pill) return;
      var url = pill.getAttribute('data-track-url') || '';
      var label = pill.getAttribute('data-track-label') || '';
      var saved = pill.getAttribute('data-track-saved') || '';
      var state = pill.getAttribute('data-track-state') || '';
      var tone = pill.getAttribute('data-track-tone') || '';
      var list = pill.getAttribute('data-track-list') || ''; // CUSTOM_SAMPLES2ND_BY_CLAUDE
      if (!label) return;
      if (pill === sampleTip._activeCell) { cancelHideSampleTip(); return; }
      sampleTip._activeCell = pill;
      /* ⛔ PARK THE NATIVE `title` WHILE THE POPOVER IS UP — do not delete it.
         An element cannot suppress its own browser tooltip except by not having one, so the
         two bubbles fought on every hover. But `title` is not dead weight: this popover is
         bound to `mouseover` ONLY, and the pill carries `tabindex="0"` — so a rep who reaches
         it by keyboard gets the native tooltip and nothing else. Removing the attribute
         outright would take the state away from exactly the person with no other way to see
         it. Stash it, strip it, put it back in hideSampleTip(). */
      if (pill.hasAttribute('title')) {
        pill._rqdTitle = pill.getAttribute('title');
        pill.removeAttribute('title');
      }
      sampleTip.innerHTML = renderSampleTipContent(url, label, saved, state, tone, list);
      cancelHideSampleTip();
      clearTimeout(sampleTipShowTimer);
      // 80ms delay (shorter than the brand tooltip's 150ms) — sample
      // tracking is a high-frequency hover target so it should feel
      // snappier.
      sampleTipShowTimer = setTimeout(function () { positionSampleTip(pill); }, 80);
    });
    document.addEventListener('mouseout', function (e) {
      if (sampleTip.contains(e.target)) {
        if (e.relatedTarget && sampleTip.contains(e.relatedTarget)) return;
        if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.rqd-sample-shipped, .rqd-sample-tag[data-track-label]')) return;
        scheduleHideSampleTip();
        return;
      }
      var pill = e.target && e.target.closest && e.target.closest('.rqd-sample-shipped, .rqd-sample-tag[data-track-label]');
      if (!pill) return;
      if (e.relatedTarget && pill.contains(e.relatedTarget)) return;
      if (e.relatedTarget && sampleTip.contains(e.relatedTarget)) return;
      scheduleHideSampleTip();
    });
    window.addEventListener('scroll', hideSampleTip, true);

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Generic body-level
       tooltip for emoji indicators (🔔, ⏰, etc.). Mirrors the sample-
       tip pattern: body-level fixed-position div, JS positioning so the
       table's overflow-x:auto wrapper doesn't clip it, status-colored
       border variants matching the row's palette.
       Triggers: any element with `.rqd-tip-trigger` class. Reads
       `data-tip` for text content, `data-tip-variant` for status class
       (awaiting / quoted / pending / hold / sample / lost / sold / etc.).
       Currently applied to: RESUMED bell, expired-followup bell. Native
       title= still used for non-emoji affordances (cog menus, buttons). */
    var genericTip = document.createElement('div');
    genericTip.className = 'rqd-tip';
    genericTip.setAttribute('role', 'tooltip');
    document.body.appendChild(genericTip);
    var genericTipShowTimer = null;
    var genericTipHideTimer = null;
    function hideGenericTip() {
      clearTimeout(genericTipShowTimer);
      clearTimeout(genericTipHideTimer);
      genericTip.classList.remove('rqd-tip--visible');
      genericTip._activeTrigger = null;
    }
    function scheduleHideGenericTip() {
      clearTimeout(genericTipHideTimer);
      genericTipHideTimer = setTimeout(hideGenericTip, 150);
    }
    function positionGenericTip(triggerEl) {
      var darkOn = !!document.querySelector('.rep-quote-portal-wrap.rep-quote-dark');
      genericTip.classList.toggle('rqd-tip--dark', darkOn);
      // Variant class: drives the border-color accent so the tip
      // matches the row's status palette. Wipe prior variants first.
      ['awaiting', 'quoted', 'pending', 'hold', 'sample', 'lost', 'sold', 'dead', 'resumed'].forEach(function(v) {
        genericTip.classList.remove('rqd-tip--' + v);
      });
      var variant = triggerEl.getAttribute('data-tip-variant') || '';
      if (variant) genericTip.classList.add('rqd-tip--' + variant);
      genericTip.style.left = '-9999px';
      genericTip.style.top = '0';
      genericTip.classList.add('rqd-tip--visible');
      var tipRect = genericTip.getBoundingClientRect();
      var triggerRect = triggerEl.getBoundingClientRect();
      var left = triggerRect.left;
      var top = triggerRect.bottom + 6;
      if (top + tipRect.height > window.innerHeight - 8) {
        top = triggerRect.top - tipRect.height - 6;
      }
      if (top < 4) top = 4;
      if (left + tipRect.width > window.innerWidth - 8) {
        left = window.innerWidth - tipRect.width - 8;
      }
      if (left < 8) left = 8;
      genericTip.style.left = left + 'px';
      genericTip.style.top = top + 'px';
    }
    document.addEventListener('mouseover', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('.rqd-tip-trigger');
      if (!trigger) return;
      var text = trigger.getAttribute('data-tip') || '';
      if (!text) return;
      if (trigger === genericTip._activeTrigger) {
        clearTimeout(genericTipHideTimer);
        return;
      }
      genericTip._activeTrigger = trigger;
      genericTip.textContent = text;
      clearTimeout(genericTipHideTimer);
      clearTimeout(genericTipShowTimer);
      genericTipShowTimer = setTimeout(function () { positionGenericTip(trigger); }, 80);
    });
    document.addEventListener('mouseout', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('.rqd-tip-trigger');
      if (!trigger) return;
      if (e.relatedTarget && trigger.contains(e.relatedTarget)) return;
      scheduleHideGenericTip();
    });
    window.addEventListener('scroll', hideGenericTip, true);

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Copy button click handler. Event
       delegation on the popover element (content is innerHTML'd on each
       hover so a handler bound directly to the button would get wiped).
       Reads the URL from data-copy-url, writes to clipboard, and flashes
       a "Copied!" confirmation for 1.5s before reverting. Uses navigator
       .clipboard.writeText when available, falls back to a temp textarea
       + execCommand('copy') for older browsers / non-https contexts. */
    sampleTip.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.rqd-sample-tip__copy');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var url = btn.getAttribute('data-copy-url') || '';
      if (!url) return;
      function flash(ok) {
        var origText = btn.textContent;
        btn.textContent = ok ? 'Copied!' : 'Failed';
        btn.classList.toggle('rqd-sample-tip__copy--copied', !!ok);
        btn.classList.toggle('rqd-sample-tip__copy--failed', !ok);
        setTimeout(function () {
          btn.textContent = origText;
          btn.classList.remove('rqd-sample-tip__copy--copied');
          btn.classList.remove('rqd-sample-tip__copy--failed');
        }, 1500);
      }
      function fallback() {
        try {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          var ok = document.execCommand('copy');
          document.body.removeChild(ta);
          flash(ok);
        } catch (_) { flash(false); }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { flash(true); }, fallback);
      } else {
        fallback();
      }
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Rep filter (admin)
    repFilter.addEventListener('change', function() {
      try { localStorage.setItem('rqd-rep-filter', repFilter.value); } catch(e) {}
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — A manual rep pick during an active
         search-driven override becomes the new "real" choice; drop the
         pre-search snapshot so clearing the search doesn't restore an
         older selection. */
      repFilterBeforeSearch = null;
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Auto-flip to
         Prospecting tab when admin picks a CFA. CFAs only have access
         to that tab (per the rep-only / cfa-only role gating at boot),
         so filtering for a CFA from any other tab would always show an
         empty list. Snap to Prospecting so admin lands directly in
         that CFA's workspace. Runs BEFORE the canOnline check so
         picking a CFA from the Online tab still lands on Prospecting
         (CFAs are inherently non-online too). */
      var _optPick = repFilter.options[repFilter.selectedIndex];
      var _isCfaPick = !!(_optPick && _optPick.value && _optPick.dataset.isCfa === '1');
      if (_isCfaPick && currentSource !== 'prospecting') {
        currentSource = 'prospecting';
        try { localStorage.setItem('rqd-source', currentSource); } catch (e) {}
        if (typeof _syncSrcSelectValue === 'function') _syncSrcSelectValue();
        var _srcToggleCfa = document.getElementById('rqd-source-toggle');
        if (_srcToggleCfa) {
          _srcToggleCfa.querySelectorAll('.rqd-source-btn').forEach(function (b) {
            b.classList.toggle('rqd-source-btn--active', b.dataset.source === 'prospecting');
          });
        }
        if (typeof syncFilterDisabledState === 'function') syncFilterDisabledState();
        var _cancelledElCfa = document.getElementById('rqd-source-cancelled');
        if (_cancelledElCfa) _cancelledElCfa.style.display = 'none';
        // Release the Online-tab rep-snapshot so a future Online toggle
        // doesn't try to restore the CFA's value.
        repFilterBeforeOnline = null;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Auto-flip to Offline tab when the
         newly-selected rep can't see Online orders. The Online tab is
         admin-only (per the worker permission gate AND the srcToggleEl
         admin-only reveal), so filtering for a non-admin rep on the
         Online tab would always show an empty list. Snap to Offline
         immediately so admin sees that rep's actual quotes. The "All
         Reps" option (value='') is treated as online-capable so we
         don't yank admin off the Online tab on a clear. */
      if (currentSource === 'online') {
        var _opt = repFilter.options[repFilter.selectedIndex];
        var _canOnline = !_opt || _opt.value === '' || _opt.dataset.canOnline !== '0';
        if (!_canOnline) {
          // Persist source change + flip UI to Offline tab. Mirrors the
          // srcToggle click handler's path but skipped the snapshot logic
          // since the user is the one initiating via rep selection.
          currentSource = 'offline';
          try { localStorage.setItem('rqd-source', currentSource); } catch (e) {}
          if (typeof _syncSrcSelectValue === 'function') _syncSrcSelectValue();
          var _srcToggle = document.getElementById('rqd-source-toggle');
          if (_srcToggle) {
            _srcToggle.querySelectorAll('.rqd-source-btn').forEach(function (b) {
              b.classList.toggle('rqd-source-btn--active', b.dataset.source === 'offline');
            });
          }
          if (typeof syncFilterDisabledState === 'function') syncFilterDisabledState();
          var _cancelledEl = document.getElementById('rqd-source-cancelled');
          if (_cancelledEl) _cancelledEl.style.display = 'none';
          // Release the Online-tab rep-snapshot so a future Online toggle
          // doesn't try to restore an out-of-date filter value.
          repFilterBeforeOnline = null;
        }
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      currentPage = 1;
      fetchQuotes();
    });

    // Date range dropdown
    var datePreset = document.getElementById('rqd-date-preset');
    var dateFromInput = document.getElementById('rqd-date-from');
    var dateToInput = document.getElementById('rqd-date-to');
    var dateSep = document.getElementById('rqd-date-sep');

    // Format a date range for the dropdown's Custom option label, e.g.
    // "Custom: Jan 15 – May 6" or "Custom: Jan 15, 2025 – May 6, 2026" if
    // the years differ. Single-day ranges read "Custom: May 6".
    function formatDateRangeLabel(fromStr, toStr) {
      var f = parseYMD(fromStr);
      var t = parseYMD(toStr);
      if (!f) return 'Custom Range';
      var SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      function lbl(d, includeYear) {
        return SHORT[d.getMonth()] + ' ' + d.getDate() + (includeYear ? ', ' + d.getFullYear() : '');
      }
      if (!t || sameDay(f, t)) {
        return 'Custom: ' + lbl(f, true);
      }
      var sameYear = f.getFullYear() === t.getFullYear();
      var thisYear = new Date().getFullYear();
      var hideYears = sameYear && f.getFullYear() === thisYear;
      return 'Custom: ' + lbl(f, !hideYears) + ' – ' + lbl(t, !hideYears || !sameYear);
    }
    // Sync the dropdown's "Custom Range" option label so the pill itself
    // shows the active dates — no need for inline date inputs underneath.
    // Also toggles the small ✎ edit button next to the dropdown so the rep
    // can re-open the modal without fighting native-select event quirks
    // (re-selecting the same option doesn't fire change).
    function syncCustomPillLabel() {
      if (!datePreset) return;
      var customOpt = datePreset.querySelector('option[value="custom"]');
      var editBtn = document.getElementById('rqd-edit-dates');
      var isCustomActive = currentPreset === 'custom' && !!currentDateFrom;
      if (customOpt) {
        customOpt.textContent = isCustomActive
          ? formatDateRangeLabel(currentDateFrom, currentDateTo)
          : 'Custom Range';
      }
      if (editBtn) {
        editBtn.style.display = isCustomActive ? 'inline-flex' : 'none';
      }
    }

    function applyDateRange(range, skipFetch) {
      var now = new Date();
      var from = '', to = '';
      var showCustom = false;

      currentPreset = range;

      if (range === 'today') {
        // Single-day range — useful when the CFA wants to focus on the
        // prospects/leads created or touched today only (Ryan 2026-05-17).
        from = toDateStr(now); to = toDateStr(now);
      } else if (range === 'week') {
        // Sun-start week (Sunday → today)
        var day = now.getDay();
        var start = new Date(now); start.setDate(now.getDate() - day);
        from = toDateStr(start); to = toDateStr(now);
      } else if (range === 'month') {
        from = now.getFullYear() + '-' + pad2(now.getMonth() + 1) + '-01'; to = toDateStr(now);
      } else if (range === 'quarter') {
        var qMonth = Math.floor(now.getMonth() / 3) * 3;
        from = now.getFullYear() + '-' + pad2(qMonth + 1) + '-01'; to = toDateStr(now);
      } else if (range === 'year') {
        from = now.getFullYear() + '-01-01'; to = toDateStr(now);
      } else if (range === 'lastyear') {
        from = (now.getFullYear() - 1) + '-01-01'; to = (now.getFullYear() - 1) + '-12-31';
      } else if (range === 'lastquarter') {
        // Previous full quarter. Wraps to Q4 of last year when now is in Q1.
        var thisQ = Math.floor(now.getMonth() / 3); // 0..3
        var lqYear = now.getFullYear();
        var lqStartMonth = (thisQ - 1) * 3;
        if (thisQ === 0) { lqYear -= 1; lqStartMonth = 9; }
        var lqEnd = new Date(lqYear, lqStartMonth + 3, 0); // day 0 of next month = last day of quarter
        from = lqYear + '-' + pad2(lqStartMonth + 1) + '-01';
        to = toDateStr(lqEnd);
      } else if (range === 'lastmonth') {
        // Previous full calendar month
        var lmYear = now.getFullYear();
        var lmMonth = now.getMonth() - 1;
        if (lmMonth < 0) { lmMonth = 11; lmYear -= 1; }
        var lmEnd = new Date(lmYear, lmMonth + 1, 0); // last day of that month
        from = lmYear + '-' + pad2(lmMonth + 1) + '-01';
        to = toDateStr(lmEnd);
      } else if (range === 'lastweek') {
        // Previous full Sun-Sat week (matches existing 'week' Sun-start convention)
        var lwDay = now.getDay();
        var lwEnd = new Date(now); lwEnd.setDate(now.getDate() - lwDay - 1); // Saturday before this Sunday
        var lwStart = new Date(lwEnd); lwStart.setDate(lwEnd.getDate() - 6); // 6 days before that Saturday = Sunday
        from = toDateStr(lwStart); to = toDateStr(lwEnd);
      } else if (range === 'last30' || range === 'last90' || range === 'last180') {
        /* CUSTOM_DATERANGES_BY_CLAUDE (Ryan 2026-10-10): the Marketing Ops rolling windows, today
           included (last30 = today and the 29 days before it), the same arithmetic as rep-paid-ads.js. */
        var rollDays = range === 'last30' ? 30 : (range === 'last90' ? 90 : 180);
        var rollStart = new Date(now); rollStart.setDate(now.getDate() - (rollDays - 1));
        from = toDateStr(rollStart); to = toDateStr(now);
      } else if (range === 'custom') {
        // Open the calendar-range modal instead of revealing inline inputs.
        // The modal pre-fills with the current from/to (if any) and applies
        // them only on Confirm.
        if (typeof openDateRangeModal === 'function') {
          openDateRangeModal();
          return;
        }
        showCustom = true;
        from = currentDateFrom; to = currentDateTo;
      }
      // 'all' leaves from/to empty

      // Custom-range inline inputs are no longer shown — the dates live on
      // the dropdown pill itself ("Custom: Jan 15 – May 6") with a small ✎
      // edit button for re-opening the modal. Keep the underlying input
      // values in sync as a hidden state holder so older code paths that
      // read .value continue to work.
      var customDatesDiv = document.getElementById('rqd-custom-dates');
      if (customDatesDiv) customDatesDiv.style.display = 'none';

      currentDateFrom = from;
      currentDateTo = to;
      dateFromInput.value = from;
      dateToInput.value = to;
      syncCustomPillLabel();
      if (!skipFetch) {
        currentPage = 1;
        fetchQuotes();
      }
    }

    datePreset.addEventListener('change', function() { applyDateRange(this.value); });

    // Edit button — re-opens the calendar modal pre-filled with the current
    // custom range. Bypasses the native-select "same value won't fire change"
    // limitation when the rep wants to adjust an already-active custom range.
    var editDatesBtn = document.getElementById('rqd-edit-dates');
    if (editDatesBtn) {
      editDatesBtn.addEventListener('click', function() {
        if (typeof openDateRangeModal === 'function') openDateRangeModal();
      });
    }
    // Manually editing a date in the custom-range inputs implicitly switches
    // to 'custom' so the URL persists exact dates (and the next reload doesn't
    // overwrite them with the rolling preset's recomputed range).
    dateFromInput.addEventListener('change', function() {
      currentDateFrom = this.value;
      currentPreset = 'custom';
      if (datePreset) datePreset.value = 'custom';
      currentPage = 1;
      fetchQuotes();
    });
    dateToInput.addEventListener('change', function() {
      currentDateTo = this.value;
      currentPreset = 'custom';
      if (datePreset) datePreset.value = 'custom';
      currentPage = 1;
      fetchQuotes();
    });

    // Default to "This Year" on initial load (set vars only, fetchQuotes called by auth handler)
    if (!currentDateFrom && !currentDateTo) {
      var now = new Date();
      currentDateFrom = now.getFullYear() + '-01-01';
      currentDateTo = toDateStr(now);
    }

    // ── Custom Date Range Modal ──
    // Self-contained overlay (own backdrop, own DOM) — independent of the
    // shared modalEl machinery so its lifecycle doesn't tangle with lead /
    // pending / status modals. Two month grids side-by-side, click-to-pick
    // start, click-again to pick end (auto-swaps if before start). Hover
    // previews range. Apply commits to currentDateFrom/To + fetches.
    var prevPresetBeforeCustom = currentPreset;
    function parseYMD(s) {
      if (!s) return null;
      var m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!m) return null;
      return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
    }
    function sameDay(a, b) {
      return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }
    function inRange(d, lo, hi) {
      if (!d || !lo || !hi) return false;
      var t = d.getTime(), a = lo.getTime(), b = hi.getTime();
      if (a > b) { var x = a; a = b; b = x; }
      return t >= a && t <= b;
    }
    var MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var DOW_LABELS = ['S','M','T','W','T','F','S'];

    window.openDateRangeModal = function openDateRangeModal() {
      // Snapshot the dropdown state so Cancel can restore it.
      prevPresetBeforeCustom = currentPreset === 'custom' ? prevPresetBeforeCustom : currentPreset;

      // Drop any existing instance
      var existing = document.getElementById('rqd-daterange-modal');
      if (existing) existing.remove();

      var start = parseYMD(currentDateFrom);
      var end = parseYMD(currentDateTo);
      var hover = null;
      // View anchors — left calendar shows viewYear/viewMonth, right shows next.
      // Default: anchor at end-date's month so the most-relevant range is visible.
      var anchor = end || start || new Date();
      var viewYear = anchor.getFullYear();
      var viewMonth = anchor.getMonth() - 1; // left = prev of anchor; right = anchor's month
      if (viewMonth < 0) { viewMonth = 11; viewYear -= 1; }
      var today = new Date(); today.setHours(0,0,0,0);

      var overlay = document.createElement('div');
      overlay.id = 'rqd-daterange-modal';
      overlay.className = 'rqd-daterange-backdrop';
      overlay.innerHTML = ''
        + '<div class="rqd-daterange-modal" role="dialog" aria-label="Select date range">'
        +   '<div class="rqd-daterange-modal__header">'
        +     '<div class="rqd-daterange-modal__title">Custom Date Range</div>'
        +     '<div class="rqd-daterange-modal__summary" id="rqd-dr-summary"></div>'
        +   '</div>'
        +   '<div class="rqd-daterange-modal__body">'
        +     '<button type="button" class="rqd-daterange-nav rqd-daterange-nav--prev" data-dr-nav="-1" aria-label="Previous month">&#9664;</button>'
        +     '<div class="rqd-daterange-cal" id="rqd-dr-cal-left"></div>'
        +     '<div class="rqd-daterange-cal" id="rqd-dr-cal-right"></div>'
        +     '<button type="button" class="rqd-daterange-nav rqd-daterange-nav--next" data-dr-nav="1" aria-label="Next month">&#9654;</button>'
        +   '</div>'
        +   '<div class="rqd-daterange-modal__footer">'
        +     '<button type="button" class="rqd-pill" id="rqd-dr-cancel">Cancel</button>'
        +     '<button type="button" class="rqd-pill rqd-pill--active" id="rqd-dr-apply">Apply</button>'
        +   '</div>'
        + '</div>';
      // Append into the portal wrap so the --rq-* CSS custom properties
      // (background, text, border) inherit. document.body is outside the
      // var scope and the modal would render transparent in dark mode.
      var portalWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
      portalWrap.appendChild(overlay);

      function fmt(d) {
        if (!d) return '—';
        return MONTH_NAMES[d.getMonth()].slice(0,3) + ' ' + d.getDate() + ', ' + d.getFullYear();
      }
      function refreshSummary() {
        var s = document.getElementById('rqd-dr-summary');
        if (!s) return;
        if (!start && !end) s.textContent = 'Click a day to start';
        else if (start && !end) s.textContent = fmt(start) + ' → click an end date';
        else s.textContent = fmt(start) + '  →  ' + fmt(end);
      }
      function buildMonth(yy, mm) {
        // Returns HTML for one month grid. mm is 0..11.
        var first = new Date(yy, mm, 1);
        var lastDay = new Date(yy, mm + 1, 0).getDate();
        var startDow = first.getDay();
        // 6 weeks × 7 days = 42 cells. Leading cells are previous-month
        // spillover (rendered dimmed); trailing cells are next-month.
        var cells = '';
        for (var i = 0; i < 42; i++) {
          var dayNum = i - startDow + 1;
          var cellDate = new Date(yy, mm, dayNum);
          var inMonth = dayNum >= 1 && dayNum <= lastDay;
          var disabled = cellDate > today;
          var classes = ['rqd-daterange-day'];
          if (!inMonth) classes.push('rqd-daterange-day--out');
          if (disabled) classes.push('rqd-daterange-day--disabled');
          if (sameDay(cellDate, today)) classes.push('rqd-daterange-day--today');
          if (sameDay(cellDate, start)) classes.push('rqd-daterange-day--start');
          if (sameDay(cellDate, end)) classes.push('rqd-daterange-day--end');
          var rangeHi = end ? inRange(cellDate, start, end) : (start && hover ? inRange(cellDate, start, hover) : false);
          if (rangeHi) classes.push('rqd-daterange-day--in-range');
          var iso = toDateStr(cellDate);
          cells += '<button type="button" class="' + classes.join(' ') + '" data-dr-date="' + iso + '"' + (disabled ? ' disabled' : '') + '>' + cellDate.getDate() + '</button>';
        }
        var hdr = '<div class="rqd-daterange-cal__title">' + MONTH_NAMES[mm] + ' ' + yy + '</div>';
        var dows = '<div class="rqd-daterange-cal__dow">' + DOW_LABELS.map(function(d){return '<span>'+d+'</span>';}).join('') + '</div>';
        var grid = '<div class="rqd-daterange-cal__grid">' + cells + '</div>';
        return hdr + dows + grid;
      }
      function refreshCalendars() {
        var leftMonth = viewMonth, leftYear = viewYear;
        var rightMonth = leftMonth + 1, rightYear = leftYear;
        if (rightMonth > 11) { rightMonth = 0; rightYear += 1; }
        document.getElementById('rqd-dr-cal-left').innerHTML = buildMonth(leftYear, leftMonth);
        document.getElementById('rqd-dr-cal-right').innerHTML = buildMonth(rightYear, rightMonth);
      }
      refreshCalendars();
      refreshSummary();

      // Day click — pick start, then end. After both set, next click resets to new start.
      overlay.addEventListener('click', function(e) {
        var dayBtn = e.target.closest('.rqd-daterange-day');
        if (dayBtn && !dayBtn.disabled) {
          var d = parseYMD(dayBtn.dataset.drDate);
          if (!d) return;
          if (!start || (start && end)) {
            start = d; end = null; hover = null;
          } else {
            // start set, no end — set end (auto-swap if before start)
            if (d.getTime() < start.getTime()) {
              end = start; start = d;
            } else {
              end = d;
            }
          }
          refreshCalendars();
          refreshSummary();
          return;
        }
        var navBtn = e.target.closest('[data-dr-nav]');
        if (navBtn) {
          var delta = parseInt(navBtn.dataset.drNav, 10);
          viewMonth += delta;
          while (viewMonth < 0) { viewMonth += 12; viewYear -= 1; }
          while (viewMonth > 11) { viewMonth -= 12; viewYear += 1; }
          refreshCalendars();
          return;
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
        if (e.target.id === 'rqd-dr-cancel' || window.RepPortal.dismissedOnBackdrop(e, overlay)) {
          // Cancel: close + revert dropdown to previous preset
          overlay.remove();
          if (datePreset) datePreset.value = prevPresetBeforeCustom || 'year';
          currentPreset = prevPresetBeforeCustom || 'year';
          // Re-apply the previous preset so currentDateFrom/To match the dropdown
          if (currentPreset !== 'custom') applyDateRange(currentPreset, true);
          return;
        }
        if (e.target.id === 'rqd-dr-apply') {
          if (!start) { return; } // no-op until at least a start is picked
          var finalEnd = end || start; // single-day selection treated as start = end
          currentDateFrom = toDateStr(start);
          currentDateTo = toDateStr(finalEnd);
          currentPreset = 'custom';
          if (datePreset) datePreset.value = 'custom';
          if (dateFromInput) dateFromInput.value = currentDateFrom;
          if (dateToInput) dateToInput.value = currentDateTo;
          // Inline custom-dates div stays hidden — the pill label + edit
          // button surface the active range now.
          var customDatesDiv = document.getElementById('rqd-custom-dates');
          if (customDatesDiv) customDatesDiv.style.display = 'none';
          syncCustomPillLabel();
          overlay.remove();
          currentPage = 1;
          fetchQuotes();
          return;
        }
      });

      // Hover preview — only when a start is picked but no end yet
      overlay.addEventListener('mouseover', function(e) {
        var dayBtn = e.target.closest('.rqd-daterange-day');
        if (!dayBtn || dayBtn.disabled) return;
        if (!start || end) return;
        var d = parseYMD(dayBtn.dataset.drDate);
        if (!d || sameDay(d, hover)) return;
        hover = d;
        refreshCalendars();
      });
      overlay.addEventListener('mouseleave', function() {
        if (hover) { hover = null; refreshCalendars(); }
      });

      // Keyboard shortcuts — ←/→ shift the focused day by ±1, ↑/↓ by ±7,
      // Enter applies, Esc cancels. Cursor lives on `start` (no end yet) or
      // on `end` (range complete) and we shift it; behavior mirrors picking
      // dates with the mouse.
      var keyCursor = null; // tracks the date currently being moved
      function shiftCursor(deltaDays) {
        var base = keyCursor || end || start || new Date();
        var next = new Date(base.getFullYear(), base.getMonth(), base.getDate() + deltaDays);
        if (next > today) return; // clamp to today
        keyCursor = next;
        // If only a start is picked, shift the end-preview via hover
        if (start && !end) {
          hover = next;
        } else if (!start) {
          start = next;
        } else {
          // Both set — moving collapses the range to a new start at the cursor
          start = next; end = null; hover = null;
        }
        // Bring the focused month into view if cursor moved out of either calendar.
        var rightMonth = viewMonth + 1, rightYear = viewYear;
        if (rightMonth > 11) { rightMonth = 0; rightYear += 1; }
        var leftFirst = new Date(viewYear, viewMonth, 1);
        var rightLast = new Date(rightYear, rightMonth + 1, 0);
        if (next < leftFirst) {
          viewMonth -= 1;
          if (viewMonth < 0) { viewMonth = 11; viewYear -= 1; }
        } else if (next > rightLast) {
          viewMonth += 1;
          if (viewMonth > 11) { viewMonth = 0; viewYear += 1; }
        }
        refreshCalendars();
        refreshSummary();
      }
      function onKey(ev) {
        if (!document.getElementById('rqd-daterange-modal')) {
          document.removeEventListener('keydown', onKey);
          return;
        }
        if (ev.key === 'Escape') {
          ev.stopPropagation();
          document.getElementById('rqd-dr-cancel')?.click();
          document.removeEventListener('keydown', onKey);
          return;
        }
        if (ev.key === 'ArrowLeft')  { ev.preventDefault(); shiftCursor(-1); return; }
        if (ev.key === 'ArrowRight') { ev.preventDefault(); shiftCursor(1);  return; }
        if (ev.key === 'ArrowUp')    { ev.preventDefault(); shiftCursor(-7); return; }
        if (ev.key === 'ArrowDown')  { ev.preventDefault(); shiftCursor(7);  return; }
        if (ev.key === 'Enter') {
          ev.preventDefault();
          // Treat hover as the end if a start is picked but end isn't
          if (start && !end && hover) end = hover;
          document.getElementById('rqd-dr-apply')?.click();
        }
      }
      document.addEventListener('keydown', onKey);
    };

    // Pagination
    prevBtn.addEventListener('click', function() { if (currentPage > 1) { currentPage--; fetchQuotes(); } });
    nextBtn.addEventListener('click', function() { currentPage++; fetchQuotes(); });

    /* CUSTOM_FREIGHTPROMISE_BY_CLAUDE (Ryan 2026-10-23) - the 30-day truck's card opens on hover (and on keyboard focus);
       the click handler below stays for touch screens. */
    function _openHoldFrom(e) {
      var t = e.target && e.target.closest && e.target.closest('.rqd-logistics-icon--hold');
      if (t) openFreightHoldPopover(t, t.getAttribute('data-ref'));
    }
    tbody.addEventListener('mouseover', _openHoldFrom);
    tbody.addEventListener('focusin', _openHoldFrom);

    // Table row clicks (expand/collapse + status badge clicks)
    tbody.addEventListener('click', function(e) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Sample tracking pill + popover.
         Clicks on the 📦 emoji, the ⓘ badge, or the tracking-number link
         inside the hover popover must NOT also toggle the row's
         expand/collapse state. Default click behavior is preserved
         (the <a> still opens the tracking page); we just halt
         propagation to the row-expand handler below. */
      if (e.target.closest('.rqd-sample-shipped')) {
        e.stopPropagation();
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_FREIGHTPROMISE_BY_CLAUDE (Ryan 2026-10-23) - the 30-day truck opens its own card, never the row. */
      var holdTruck = e.target.closest('.rqd-logistics-icon--hold');
      if (holdTruck) {
        e.stopPropagation();
        e.preventDefault();
        openFreightHoldPopover(holdTruck, holdTruck.getAttribute('data-ref'));
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Admin-only date
         override pencil in the date column. Pre-empt the row-expand
         handler and open the date-edit popover anchored to the button. */
      var dateEditBtn = e.target.closest('.rqd-date-edit-btn');
      if (dateEditBtn) {
        e.stopPropagation();
        e.preventDefault();
        openDateOverridePopover(dateEditBtn);
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — In-row "Link to Parent" pill (renders
         inside the To Do cell on draft-sourced unlinked online orders).
         Catch the click here BEFORE the row-expand handler fires, otherwise
         the row toggles open instead of opening the link modal. */
      var inRowLinkBtn = e.target.closest('.rqd-flow-link-prompt');
      if (inRowLinkBtn) {
        e.stopPropagation();
        e.preventDefault();
        handleLinkBalanceFromDraft(inRowLinkBtn);
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-11) — ⭐ review-decision
         star (centered in the To Do cell, or the muted skipped-state star
         in the icons slot). Opens the send/skip menu; must not also toggle
         the row open. */
      var reviewStarBtn = e.target.closest('.rqd-review-star-decide');
      if (reviewStarBtn) {
        e.stopPropagation();
        e.preventDefault();
        openReviewDecisionMenu(reviewStarBtn);
        /* CUSTOM_REVIEWS_BY_CLAUDE (Ryan 2026-09-09) — opened from the row's cog menu: the
           popover is positioned off the entry while it is still visible, THEN the cog menu
           folds away so the two never stack. */
        if (reviewStarBtn.closest('.rqd-actions-menu')) {
          document.querySelectorAll('.rqd-actions-menu--open').forEach(function (m) { m.classList.remove('rqd-actions-menu--open'); });
          if (typeof closeMobileModal === 'function') closeMobileModal();
        }
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Balance Chain banner Edit + Unlink
         buttons live in the detail panel, NOT in an actions-menu element.
         Catch them here BEFORE the actions-menu gate further down so the
         click actually fires the handler instead of toggling row expand. */
      var editBalanceTopBtn = e.target.closest('.rqd-edit-balance-btn');
      if (editBalanceTopBtn) {
        e.stopPropagation();
        e.preventDefault();
        handleEditBalanceOrder(editBalanceTopBtn);
        return;
      }
      var unlinkBalanceTopBtn = e.target.closest('.rqd-unlink-balance-btn');
      if (unlinkBalanceTopBtn) {
        e.stopPropagation();
        e.preventDefault();
        handleUnlinkBalanceOrder(unlinkBalanceTopBtn);
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Substitution toggle button. Lives in
         the Balance Chain panel, not the actions menu. */
      var substituteBalanceTopBtn = e.target.closest('.rqd-balance-substitute-btn');
      if (substituteBalanceTopBtn) {
        e.stopPropagation();
        e.preventDefault();
        handleBalanceSubstitute(substituteBalanceTopBtn);
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Jump-to-parent link in the linked-
         child detail banner + Financials stub. SHOP-XXXX-style refs are
         online orders; everything else is offline. Auto-switch the source
         tab if needed, then expand the parent row after the fetch lands. */
      var jumpToParentLink = e.target.closest('[data-jump-to-parent]');
      if (jumpToParentLink) {
        e.preventDefault();
        e.stopPropagation();
        var _parentRef = jumpToParentLink.getAttribute('data-jump-to-parent');
        if (!_parentRef) return;
        var _parentIsOnline = /^SHOP-/i.test(_parentRef);
        var _targetSource = _parentIsOnline ? 'online' : 'offline';
        function _focusParent() {
          var _parentRow = tbody.querySelector('tr[data-ref="' + _parentRef + '"]');
          if (!_parentRow) return;
          _parentRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (!_parentRow.classList.contains('rqd-row--expanded')) {
            toggleDetail(_parentRef);
          }
        }
        if (currentSource !== _targetSource) {
          // Switch source tab, re-fetch, then focus the parent once the row exists.
          var _srcBtn = srcToggle && srcToggle.querySelector('.rqd-source-btn[data-source="' + _targetSource + '"]');
          if (_srcBtn) {
            srcToggle.querySelectorAll('.rqd-source-btn').forEach(function (b) { b.classList.remove('rqd-source-btn--active'); });
            _srcBtn.classList.add('rqd-source-btn--active');
            currentSource = _targetSource;
            try { localStorage.setItem('rqd-source', currentSource); } catch (_) {}
            // Listen for the next render completion via a one-shot setTimeout
            // polling — fetchQuotes resolves the DOM asynchronously, so we
            // re-query for the parent row every 100ms up to 5s.
            fetchQuotes();
            var _tries = 0;
            var _poll = setInterval(function () {
              _tries++;
              if (tbody.querySelector('tr[data-ref="' + _parentRef + '"]')) {
                clearInterval(_poll);
                _focusParent();
              } else if (_tries > 50) {
                clearInterval(_poll);
              }
            }, 100);
          }
        } else {
          _focusParent();
        }
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      // Status badge click -> open modal
      var statusBadge = e.target.closest('.rqd-status');
      if (statusBadge) {
        e.stopPropagation();
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Deal Prospecting
           rows surface stage pills (COLD/ENGAGED/QUALIFIED/HANDOFF/WON/LOST)
           that have nothing to do with the QUOTED→SOLD/LOST lifecycle modal.
           Stage transitions on prospects flow through the Discovery card /
           Handoff button / Archive button. Suppress the rep-side modal here
           before the role + lifecycle gates below. */
        if (currentSource === 'prospecting') return;
        var sess = window.RepPortal && window.RepPortal.Auth.getSession();
        if (sess && sess.role === 'cfa') return; // CFAs can't change status
        var ref = statusBadge.dataset.ref;
        var q = allQuotes.find(function(x) { return x.reference === ref; });
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Stale early-out
           removed: was "Pending can't be manually changed", which was
           true when the only pill-click destination was the SOLD/LOST
           lifecycle modal. Now pending routes to the lead-actions
           chooser below (Create Quote / Delete Pending) and clicks
           must reach that branch. */
        // Online orders can't be manually re-statused — they're definitionally
        // sold (real Shopify checkouts) and only flip via cancel/refund inside
        // Shopify Admin. Don't open the lifecycle modal.
        if (q && q.source === 'online') return;
        // Lead rows route to Mark Dead / Resurrect / Promote Sample instead
        // of the SOLD/LOST lifecycle modal (which assumes the quote has
        // reached the QUOTED stage).
        //   DEAD → Resurrect (always available).
        //   SAMPLE → Promote to Lead (always available; Mark Dead lives in
        //     the cog menu since pill-click should default to the optimistic
        //     action — promote — not the destructive one).
        //   NEW + 72h+ → Mark Dead.
        //   NEW + <72h → no-op with hours-remaining toast.
        // Lead-state row routing:
        //   - Dead / Sample / On Hold → always the lead-actions chooser
        //     (Resurrect / Wake / Promote / Hold / Mark Dead).
        //   - NEW LEAD that's still fresh (no items, no PDF) → lead-actions
        //     chooser (Create Quote / Hold / Mark Dead).
        //   - NEW LEAD that has progressed — items in the quote (q.total > 0,
        //     the "..." pill) OR PDF downloaded (canonical QUOTED) — route
        //     to the standard lifecycle modal instead. Server-side status
        //     stays 'new_lead' until PDF, but the rep's mental model is
        //     "this is a quote now, let me mark it Sold / Lost / Quoted",
        //     not "create / hold / kill this lead."
        var _hasQuoteItems = (parseFloat(q && q.total) || 0) > 0;
        var _pdfDone = !!(q && (q.pdfDownloaded || q.chainPdfDownloaded));
        var _isStillFreshLead = q && (q.isLead || q.status === 'new_lead' || q.status === 'submitted' || q.status === 'under_review')
          && !_hasQuoteItems && !_pdfDone;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — PENDING rows now
           route to the lead-actions chooser (like DEAD / SAMPLE / ON HOLD
           / fresh NEW LEAD) instead of the SOLD/LOST lifecycle modal.
           Pending rows haven't reached the QUOTED stage yet — opening
           a "SOLD or LOST?" modal doesn't apply. The chooser surfaces
           the right options for this state: Create Quote (primary) +
           Delete. */
        if (q && (q.isDeadLead || q.status === 'dead_lead' || q.isSample || q.status === 'sample' || q.isOnHold || q.status === 'on_hold' || q.isPending || q.status === 'pending' || _isStillFreshLead)) {
          openLeadActionsModal(q);
          return;
        }
        if (q) openStatusModal(q);
        return;
      }

      // Actions menu trigger -> toggle menu, don't toggle row
      var menuTrigger = e.target.closest('.rqd-actions-trigger');
      if (menuTrigger) {
        e.stopPropagation();
        var menuRef = menuTrigger.dataset.menuRef;
        var row = menuTrigger.closest('tr');
        var menu = row ? row.querySelector('.rqd-actions-menu[data-menu-for="' + menuRef + '"]') : menuTrigger.parentElement.querySelector('.rqd-actions-menu[data-menu-for="' + menuRef + '"]');
        // Close all other menus first
        document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) {
          if (m !== menu) m.classList.remove('rqd-actions-menu--open');
        });
        closeMobileModal();
        if (menu) {
          var willOpen = !menu.classList.contains('rqd-actions-menu--open');
          menu.classList.toggle('rqd-actions-menu--open');
          if (willOpen) {
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — collapse the deal's link-*
               buttons into one "🔗 Link…" chooser (once per rendered menu) before sizing. */
            collapseLinkButtons(menu);
            positionActionsMenu(menu, menuTrigger);
          } else closeMobileModal();
        }
        return;
      }
      // Action menu item -> don't toggle row
      if (e.target.closest('.rqd-actions-menu')) {
        var buildLeadBtnMenu = e.target.closest('.rqd-build-quote-from-lead-btn');
        if (buildLeadBtnMenu) { handleBuildQuoteFromLead(buildLeadBtnMenu); return; }
        var reassignBtn = e.target.closest('.rqd-reassign-btn');
        if (reassignBtn) { handleReassign(reassignBtn); return; }
        var deleteBtn = e.target.closest('.rqd-delete-pending-btn');
        if (deleteBtn) { handleDeletePending(deleteBtn); return; }
        var deleteQuoteBtn = e.target.closest('.rqd-delete-quote-btn');
        if (deleteQuoteBtn) { handleDeleteQuote(deleteQuoteBtn); return; }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-10) — Duplicate to New Deal */
        var dupQuoteBtn = e.target.closest('.rqd-duplicate-quote-btn');
        if (dupQuoteBtn) { handleDuplicateQuote(dupQuoteBtn); return; }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — Create Replacement Order */
        var createReplBtn = e.target.closest('.rqd-create-replacement-btn');
        if (createReplBtn) { handleCreateReplacement(createReplBtn); return; }
        var linkExtBtn = e.target.closest('.rqd-link-external-btn');
        if (linkExtBtn) { handleLinkExternal(linkExtBtn); return; }
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08) — order-side twin of the above */
        var linkOpenDealBtn = e.target.closest('.rqd-link-open-deal-btn');
        if (linkOpenDealBtn) { handleLinkOpenDeal(linkOpenDealBtn); return; }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — "Link to inquiry" route */
        var linkInqBtn = e.target.closest('.rqd-link-inquiry-btn');
        if (linkInqBtn) { handleLinkInquiry(linkInqBtn); return; }
        var unlinkExtBtn = e.target.closest('.rqd-unlink-external-btn');
        if (unlinkExtBtn) { handleUnlinkExternal(unlinkExtBtn); return; }
        var cancelLinkedOrderBtn = e.target.closest('.rqd-cancel-linked-order-btn');
        if (cancelLinkedOrderBtn) { handleCancelLinkedOrder(cancelLinkedOrderBtn); return; }
        var pdfBtn = e.target.closest('.rqd-download-pdf-btn');
        if (pdfBtn) { handleDownloadPdf(pdfBtn); return; }
        var revSigBtn = e.target.closest('.rqd-reverse-signature-btn'); // CUSTOM_SIGNEDUNPAID_BY_CLAUDE (card 0a13de9f8439)
        if (revSigBtn) { handleReverseSignature(revSigBtn); return; }
        var payLinkBtn = e.target.closest('.rqd-copy-pay-link-btn'); // CUSTOM_ONLINESIGN_BY_CLAUDE (Ryan 2026-10-26)
        if (payLinkBtn) { handleCopyPayLink(payLinkBtn); return; }
        var genInvBtn = e.target.closest('.rqd-generate-invoice-btn');
        if (genInvBtn) { handleGenerateInvoice(genInvBtn); return; }
        var reqLogBtn = e.target.closest('.rqd-request-logistics-btn');
        if (reqLogBtn) { handleRequestLogistics(reqLogBtn); return; }
        var cancelFreightBtn = e.target.closest('.rqd-cancel-freight-btn');
        if (cancelFreightBtn) { handleFreightCancel(cancelFreightBtn); return; }
        var cancelInstallBtn = e.target.closest('.rqd-cancel-install-btn'); // CUSTOM_REQUESTCANCEL_BY_CLAUDE (Ryan 2026-10-13)
        if (cancelInstallBtn) { handleInstallCancel(cancelInstallBtn); return; }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Shopify cancel + refund handlers */
        var cancelOnlineBtn = e.target.closest('.rqd-cancel-online-btn');
        if (cancelOnlineBtn) { handleCancelOnlineOrder(cancelOnlineBtn); return; }
        var cancelOrderBtn = e.target.closest('.rqd-cancel-order-btn');
        if (cancelOrderBtn) { handleCancelOrder(cancelOrderBtn); return; }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Balance order link / edit / unlink */
        var linkBalanceBtn = e.target.closest('.rqd-link-balance-btn');
        if (linkBalanceBtn) { handleLinkBalanceOrder(linkBalanceBtn); return; }
        var editBalanceBtn = e.target.closest('.rqd-edit-balance-btn');
        if (editBalanceBtn) { handleEditBalanceOrder(editBalanceBtn); return; }
        var unlinkBalanceBtn = e.target.closest('.rqd-unlink-balance-btn');
        if (unlinkBalanceBtn) { handleUnlinkBalanceOrder(unlinkBalanceBtn); return; }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — Deal grouping ("Same Deal" link) */
        var linkDealBtn = e.target.closest('.rqd-link-deal-btn');
        if (linkDealBtn) { handleLinkDeal(linkDealBtn); return; }
        var ungroupDealBtn = e.target.closest('.rqd-ungroup-deal-btn');
        if (ungroupDealBtn) { handleUngroupDeal(ungroupDealBtn); return; }
        var setPrimaryDealBtn = e.target.closest('.rqd-set-primary-deal-btn');
        if (setPrimaryDealBtn) { handleSetPrimaryDeal(setPrimaryDealBtn); return; }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Mark Dead / Resurrect / Promote / Hold / Wake */
        var markDeadBtnMenu = e.target.closest('.rqd-mark-dead-btn');
        if (markDeadBtnMenu) { handleMarkLeadDead(markDeadBtnMenu); return; }
        var resurrectBtnMenu = e.target.closest('.rqd-resurrect-lead-btn');
        if (resurrectBtnMenu) { handleResurrectLead(resurrectBtnMenu); return; }
        var promoteSampleMenu = e.target.closest('.rqd-promote-sample-btn');
        if (promoteSampleMenu) { handlePromoteSample(promoteSampleMenu); return; }
        var holdLeadMenu = e.target.closest('.rqd-hold-lead-btn');
        if (holdLeadMenu) { handleHoldLead(holdLeadMenu); return; }
        var editHoldMenu = e.target.closest('.rqd-edit-hold-btn');
        if (editHoldMenu) { handleHoldLead(editHoldMenu); return; }
        var wakeLeadMenu = e.target.closest('.rqd-wake-lead-btn');
        if (wakeLeadMenu) { handleWakeLead(wakeLeadMenu); return; }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        return;
      }

      // Version badge click -> toggle revision sub-rows
      var vBadge = e.target.closest('.rqd-version-badge');
      if (vBadge) {
        e.stopPropagation();
        var groupKey = vBadge.dataset.revisionGroup;
        var isOpen = vBadge.classList.contains('rqd-version-badge--open');
        // Helper: clear group border classes from all rows
        function clearGroupBorder(gk) {
          var parentRow = tbody.querySelector('.rqd-version-badge[data-revision-group="' + gk + '"]');
          if (parentRow) parentRow = parentRow.closest('tr');
          if (parentRow) parentRow.classList.remove('rqd-group-open', 'rqd-group-top');
          tbody.querySelectorAll('tr[data-revision-group="' + gk + '"]').forEach(function(r) {
            r.classList.remove('rqd-group-open', 'rqd-group-bottom');
          });
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-08) — One-chain-open accordion
           REMOVED: opening a revision group no longer collapses the others, so
           multiple groups (auto-opened on bells, or manually) can stay open at once. */
        vBadge.classList.toggle('rqd-version-badge--open', !isOpen);
        var childRows = tbody.querySelectorAll('tr[data-revision-group="' + groupKey + '"]');
        childRows.forEach(function(r) {
          r.classList.toggle('rqd-revision-row--hidden', isOpen);
        });
        // Toggle group border
        var parentRow = vBadge.closest('tr');
        if (!isOpen) {
          parentRow.classList.add('rqd-group-open', 'rqd-group-top');
          childRows.forEach(function(r) { r.classList.add('rqd-group-open'); });
          // Mark last child row for bottom border
          if (childRows.length > 0) childRows[childRows.length - 1].classList.add('rqd-group-bottom');
        } else {
          clearGroupBorder(groupKey);
        }
        expandedGroup = isOpen ? null : groupKey;
        return;
      }

      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — Claim paperwork launcher.
         ⛔ CHECKED BEFORE THE CLAIM-SAVE HANDLER BELOW, and it has to be. The launcher
         wears `.rqd-claim-save` on purpose — that class is tinted across ~38 per-status
         selector groups in dashboard.css and a parallel class would have to re-state every
         one of them. But the handler below matches on that class, finds no `.rqd-claim-card`
         around the button, and returns: the click would be swallowed in silence and the
         panel would simply never open. Matching the more specific attribute first is the
         fix; all logic lives in dashboard-claim-invoice.js. The modal delegates its OWN
         clicks (it mounts on <body>, outside this table), so this only ever sees the card. */
      /* CUSTOM_PAYMENTCHECK_BY_CLAUDE (ONYX e27ee0c84a87) - Release / Refund / re-hold on the payment check card. */
      var phBtn = e.target.closest('[data-payhold-action]');
      if (phBtn && isAdmin) {
        if (phBtn.disabled) { e.preventDefault(); return; }
        handlePaymentHoldClick(phBtn);
        return;
      }
      var cdBtn = e.target.closest('[data-claimdoc-action]');
      if (cdBtn && isAdmin) {
        if (cdBtn.disabled) { e.preventDefault(); return; }
        if (window.RQD && window.RQD.claimDocs) window.RQD.claimDocs.handle(cdBtn);
        return;
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — save the recovery claim on a
         replacement order. Admin-only here AND on the worker (handlePostQuoteLifecycle
         handles `claim` in its own rep.admin branch, deliberately outside the `allowed`
         field list any deal-owning rep can write). */
      var claimSaveBtn = e.target.closest('.rqd-claim-save');
      if (claimSaveBtn && isAdmin) { handleClaimSave(claimSaveBtn); return; }

      // Payment add/remove/fill buttons
      var paymentAddBtn = e.target.closest('.rqd-payment-add');
      if (paymentAddBtn && isAdmin) {
        if (paymentAddBtn.disabled) return;  // grayed out when fully paid
        handlePaymentAdd(paymentAddBtn);
        return;
      }
      var paymentRemoveBtn = e.target.closest('.rqd-payment-remove');
      if (paymentRemoveBtn && isAdmin) { handlePaymentRemove(paymentRemoveBtn); return; }
      // Click on empty payment amount input → auto-fill remaining balance + reveal date
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Don't auto-save on click. Previous behavior
         saved the payment row the instant the rep clicked into an empty amount
         field — feedback-free + accident-prone if they meant to type a
         different amount. Now: click pre-fills + reveals the date, the input
         stays focused, and the rep edits if needed. Save fires on blur via
         the focusout handler below (~line 2061), giving the rep a clean
         "click to fill → click out to commit" rhythm. */
      var paymentAmtInput = e.target.closest('.rqd-payment-amount');
      if (paymentAmtInput && !paymentAmtInput.value && paymentAmtInput.dataset.remaining) {
        var rem = parseFloat(paymentAmtInput.dataset.remaining);
        if (rem > 0) {
          paymentAmtInput.value = money(rem);
          var pmtRow = paymentAmtInput.closest('.rqd-payment-row');
          if (pmtRow) {
            // Reveal date picker (default to today).
            var dateInput = pmtRow.querySelector('.rqd-payment-date');
            if (dateInput) { dateInput.style.display = ''; if (!dateInput.value) dateInput.value = todayStr(); }
          }
        }
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      // Collapsible workflow card header — click on a section title inside
      // a .rqd-detail__arap--collapsible toggles the card open/closed. Inner
      // buttons / inputs shouldn't trigger a collapse, so bail if the click
      // landed on an interactive child rather than the bare title (or its
      // chevron, which has pointer-events:none anyway).
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — ⛔ ONLY THE CARD'S OWN HEADER TOGGLES IT.
         Ryan: *"you should only be able to collapse/expand it by clicking the top-most header on
         the card… there's a bug on this card which allows you to click on the JOB INFORMATION or
         the SHIPMENT TRACKING [headings] to expand/collapse."* Those are `--sub` section titles
         that sit as direct children of the same `.rqd-detail__arap` (the Samples card carries
         four), and this selector matched every one of them. The `--sub` modifier is exactly the
         marker the collapse CSS already keys on, so it is the marker here too. */
      var collapseTitle = e.target.closest('.rqd-detail__arap--collapsible > .rqd-detail__section-title:not(.rqd-detail__section-title--sub)');
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — When a card is
         COLLAPSED, the entire card body (not just the title bar above
         the dividing line) is a click target for re-expansion. Title
         clickability covers expanded → collapsed already; this branch
         covers collapsed → expanded for clicks that land in the empty
         padding below the title. Hidden interactive children (max-
         height: 0 + overflow: hidden) don't receive clicks, so no
         conflict with chips/inputs while collapsed. */
      if (!collapseTitle) {
        var _collapsedCard = e.target.closest('.rqd-detail__arap--collapsed');
        if (_collapsedCard) collapseTitle = _collapsedCard.querySelector(':scope > .rqd-detail__section-title');
      }
      if (collapseTitle) {
        var card = collapseTitle.parentElement;
        var _isCardCollapsed = card.classList.contains('rqd-detail__arap--collapsed');
        // For EXPANDED cards, gate on interactive children so chips /
        // inputs / textarea clicks don't accidentally collapse. For
        // COLLAPSED cards, any click anywhere in the card body counts
        // as an expand request — children are hidden and don't receive
        // events anyway, so the guard isn't needed.
        if (!_isCardCollapsed && e.target !== collapseTitle && !e.target.classList.contains('rqd-arap__chevron') && e.target.closest('button, input, select, textarea, a, label')) return;
        e.stopPropagation();
        var sectionId = card.dataset.section;
        var detailContainer = card.closest('[id^="rqd-detail-"]');
        var ref = detailContainer ? detailContainer.id.replace(/^rqd-detail-/, '') : null;
        if (!ref || !sectionId) return;
        if (!collapsedSections[ref]) collapsedSections[ref] = {};
        /* The rep has now stated a preference for this card; auto-collapse must never override
           it again, in either direction. */
        if (!manuallyToggledSections[ref]) manuallyToggledSections[ref] = {};
        manuallyToggledSections[ref][sectionId] = true;
        var nowCollapsed = card.classList.toggle('rqd-detail__arap--collapsed');
        if (nowCollapsed) collapsedSections[ref][sectionId] = true;
        else delete collapsedSections[ref][sectionId];
        // Spin the chevron 360° on toggle; swap glyph at the midpoint so the
        // symbol visibly flips during the spin.
        var chevron = collapseTitle.querySelector('.rqd-arap__chevron');
        if (chevron) {
          chevron.classList.remove('rqd-arap__chevron--spin');
          // Force a reflow so re-adding the class restarts the animation.
          // eslint-disable-next-line no-unused-expressions
          void chevron.offsetWidth;
          chevron.classList.add('rqd-arap__chevron--spin');
          setTimeout(function() {
            chevron.textContent = nowCollapsed ? '+' : '−';
          }, 200);
          setTimeout(function() {
            chevron.classList.remove('rqd-arap__chevron--spin');
          }, 420);
        }
        return;
      }

      // Toggle/checkbox/tracking/install/invoice/payment in detail -> don't toggle row
      if (e.target.closest('.rqd-toggle') || e.target.closest('.rqd-vendors__check') || e.target.closest('.rqd-vendor-tracking') || e.target.closest('.rqd-install-form') || e.target.closest('.rqd-install-add') || e.target.closest('.rqd-invoice') || e.target.closest('.rqd-payment-row') || e.target.closest('.rqd-payment-add')) return;

      // Row click -> expand/collapse detail
      var row = e.target.closest('tr[data-ref]');
      if (!row) return;
      var ref2 = row.dataset.ref;
      toggleDetail(ref2);
    });

    // Detail panel clicks (AR/AP toggles, vendor ordering)
    /* ⚠️ async (Ryan 2026-08-27, Phase 2) so the Unlink-asset branch below can await its in-DOM
       confirm. Every await in this dispatcher must stay inside a branch that returns straight
       after it — the listener's return value is discarded, but code placed AFTER an await would
       run a microtask late, and e.preventDefault()/stopPropagation() would then be too late. */
    tbody.addEventListener('click', async function(e) {
      var vendorCheck = e.target.closest('.rqd-vendors__check');
      if (!vendorCheck) {
        var parentToggle = e.target.closest('.rqd-toggle');
        if (parentToggle) vendorCheck = parentToggle.querySelector('.rqd-vendors__check');
      }
      if (vendorCheck && isAdmin) {
        handleVendorOrderClick(vendorCheck);
        return;
      }
      /* CUSTOM_ROLLMATH_BY_CLAUDE (ONYX 4d660f6996ea, Ryan 2026-09-30) — "Adjust to 805" on the roll
         sub-row opens Adjust Order with that line's New quantity already set to the saved roll total.
         ⛔ CHECKED BEFORE the roll-lengths cell below: the button sits inside a cell that carries
         .rqd-roll-lengths-btn, and that branch would open the length editor on the same click. */
      var raBtn = e.target.closest('.rqd-roll-adjust-btn');
      if (raBtn && isAdmin) {
        e.preventDefault(); e.stopPropagation();
        var _raRef = raBtn.dataset.ref;
        var _raQ = allQuotes.find(function (x) { return x && x.reference === _raRef; });
        if (window.RQD && window.RQD.adjustOrder && window.RQD.adjustOrder.open) {
          window.RQD.adjustOrder.open(_raRef, _raQ, null, { prefill: { lineItemId: raBtn.dataset.line, toQty: parseInt(raBtn.dataset.to, 10) } });
        }
        return;
      }
      // ── Roll lengths step (admin only) — Fulfillment card ──
      var rlBtn = e.target.closest('.rqd-roll-lengths-btn');
      if (rlBtn && isAdmin) { handleLogRollLengths(rlBtn); return; }
      // ── Purchase Order actions (admin only) ──
      var poBtn = e.target.closest('[data-po-action]');
      if (poBtn && isAdmin) {
        if (poBtn.disabled) { e.preventDefault(); return; }
        var action = poBtn.dataset.poAction;
        var ref = poBtn.dataset.ref || '';
        var vendor = poBtn.dataset.vendor || '';
        var poNumber = poBtn.dataset.po || '';
        // Optional bucket key — set by Generate PO buttons inside the
        // Freight Balance card's bucket panels. Worker uses it to filter
        // line items by shipping bucket + suffix the PO number.
        var bucket = poBtn.dataset.bucket || null;
        if (action === 'generate' || action === 'regen') handlePoGenerate(ref, vendor, action === 'regen', bucket, poBtn);
        else if (action === 'view') handlePoView(poNumber);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — view-pdf opens the sent PDF in a
           new tab without going through the modal. Used by the View PO
           button on already-sent POs. */
        else if (action === 'view-pdf') handlePoViewPdf(poNumber);
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        else if (action === 'email') handlePoEmail(poNumber, poBtn);
        // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — record a PO sent outside the portal
        else if (action === 'mark-sent') handlePoMarkSent(poNumber, ref, vendor, poBtn);
        else if (action === 'void') handlePoVoid(poNumber);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Purchase-action
           dropdown. The "-- Select -- ▾" button opens a menu with two
           equal options: Generate PO + Mark Purchased (no PO). Generate
           PO routes to the existing handler; Mark Purchased opens the
           popover. Edit re-opens the popover prefilled for an existing
           direct-purchase entry. */
        else if (action === 'purchase-action-menu') openPurchaseActionMenu(poBtn, ref, vendor, bucket);
        else if (action === 'mark-purchased-open') openMarkPurchasedPopover(poBtn, ref, vendor, null);
        else if (action === 'mark-purchased-edit') {
          var _vq = allQuotes.find(function (x) { return x.reference === ref; });
          var _existing = (_vq && _vq.ordering && _vq.ordering[vendor]) || null;
          openMarkPurchasedPopover(poBtn, ref, vendor, _existing);
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        return;
      }
      // ── Freight Balance actions (admin only, online Flow A orders) ──
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-07-21) — Adjust Order actions.
         Distinct data-adjust-action namespace so it never collides with the
         freight switch below; all logic lives in dashboard-adjust-order.js. */
      var aoBtn = e.target.closest('[data-adjust-action]');
      if (aoBtn && isAdmin) {
        if (aoBtn.disabled) { e.preventDefault(); return; }
        if (window.RQD && window.RQD.adjustOrder) window.RQD.adjustOrder.handle(aoBtn);
        return;
      }

      var fbBtn = e.target.closest('[data-fb-action]');
      if (fbBtn && isAdmin) {
        if (fbBtn.disabled) { e.preventDefault(); return; }
        var fbAction = fbBtn.dataset.fbAction;
        var fbRef = fbBtn.dataset.ref || '';
        var fbVendor = fbBtn.dataset.vendor || '';
        // Optional bucket key — set on bucket-scoped request buttons so
        // the email writes per-bucket request state on the worker.
        var fbBucket = fbBtn.dataset.bucket || null;
        if (fbAction === 'request-dims') handleFreightBalanceRequestDims(fbBtn, fbRef, fbVendor, fbBucket);
        else if (fbAction === 'add-pallet-row') handleFreightBalanceAddPalletRow(fbBtn);
        else if (fbAction === 'remove-pallet-row') handleFreightBalanceRemovePalletRow(fbBtn);
        else if (fbAction === 'save-pallets') handleFreightBalanceSavePallets(fbBtn, fbRef);
        // CUSTOM_FBCOSTSAVE_BY_CLAUDE (Ryan 2026-08-13) — the Fulfillment card's freight cost
        // now commits only from its own floppy button, never on blur.
        else if (fbAction === 'save-bucket-cost') saveBucketCost(fbBtn);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Cancel pallet
           entry: bail without saving. In-place close (no full refresh)
           so the row stays expanded + scroll position holds:
           - Per-vendor form (lives inside .rqd-vendor-dims-block):
             find the closest local q copy, re-render just that row's
             detail panel (mirrors applyVendorDimsPatch's pattern), which
             reverts the inline state to either the Log dims link or
             saved-summary chip based on q.ordering[vendor].freightDims.
           - Legacy global form (online Flow A path inside
             .rqd-fulfillment-dims-block or .rqd-fb-pallet-form on FB
             card): fall through to fetchQuotes() since those flows have
             surrounding state we don't want to drift from a local stub. */
        else if (fbAction === 'cancel-pallet-entry') {
          var _cancelForm = fbBtn.closest('.rqd-fb-pallet-form');
          /* CUSTOM_DIMSDISCLOSURE_BY_CLAUDE (Ryan 2026-08-28) — ⛔ CANCEL IS THE EXACT REVERSE OF
             "Log dims", NOTHING MORE. Ryan: *"instead of those buttons smoothly disappearing
             leaving me looking at a screen that was the same thing prior to clicking the 'Log dims'
             button, it collapses the entire deal and loads me at the top of the page."*

             The online form had no branch here, so it fell through to fetchQuotes() — a full board
             reload, which throws away the expanded panel and the scroll position. Opening the form
             only filled this block; closing it only has to empty it. The collapsed row above is
             untouched in the DOM the whole time, so there is nothing to rebuild and nothing to
             scroll back to. */
          var _cancelBucketBlock = _cancelForm && _cancelForm.closest('.rqd-bucket-dims-block');
          if (_cancelBucketBlock) { _cancelBucketBlock.innerHTML = ''; return; }
          var _cancelVendorBlock = _cancelForm && _cancelForm.closest('.rqd-vendor-dims-block');
          if (_cancelVendorBlock) {
            var _cancelRef = _cancelVendorBlock.dataset.ref || '';
            var _cancelVendor = _cancelVendorBlock.dataset.vendor || '';
            var _cq = allQuotes.find(function (x) { return x.reference === _cancelRef; });
            var _cDetail = document.getElementById('rqd-detail-' + _cancelRef);
            if (_cq && _cDetail) {
              _cDetail.innerHTML = buildDetailHtml(_cq);
              applyCollapseState(_cDetail, _cq);
            } else {
              // Defensive — local state missing, fall back.
              fetchQuotes();
            }
          } else {
            fetchQuotes();
          }
        }
        else if (fbAction === 'edit-dims' && fbBtn.dataset.supplier) handleBucketDimsOpen(fbBtn, fbRef); // CUSTOM_ALTSHIP_BY_CLAUDE
        else if (fbAction === 'edit-dims') handleFreightBalanceEditDims(fbBtn, fbRef);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Fulfillment-card
           Edit Dims action. Mirrors edit-dims but scoped to the
           offline-sold Fulfillment card's standalone dims-block — swaps
           the saved-display toggle inline for the entry form without
           touching the FB card's multi-row structure. */
        else if (fbAction === 'edit-fulfillment-dims') handleFulfillmentEditDims(fbBtn, fbRef);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Per-vendor dims
           actions. add/edit swap the vendor's .rqd-vendor-dims-block for
           the pallet form (with vendor context); remove clears + reverts. */
        else if (fbAction === 'add-vendor-dims') handleVendorDimsOpen(fbBtn, fbRef, fbVendor, null);
        // CUSTOM_DIMSDISCLOSURE_BY_CLAUDE (Ryan 2026-08-28) — the online bucket row's Log dims.
        else if (fbAction === 'open-bucket-dims') handleBucketDimsOpen(fbBtn, fbRef);
        else if (fbAction === 'edit-vendor-dims') {
          var _vq = allQuotes.find(function (x) { return x.reference === fbRef; });
          var _existing = _vq && _vq.ordering && _vq.ordering[fbVendor] && _vq.ordering[fbVendor].freightDims;
          handleVendorDimsOpen(fbBtn, fbRef, fbVendor, _existing);
        }
        else if (fbAction === 'remove-vendor-dims') handleVendorDimsRemove(fbBtn, fbRef, fbVendor);
        else if (fbAction === 'generate-invoice') handleFreightBalanceGenerate(fbBtn, fbRef);
        else if (fbAction === 'edit-cost') handleFreightBalanceEditCost(fbBtn, fbRef);
        else if (fbAction === 'save-edited-cost') handleFreightBalanceSaveEditedCost(fbBtn, fbRef);
        else if (fbAction === 'send-email') handleFreightBalanceSendEmailRecovery(fbBtn, fbRef);
        else if (fbAction === 'mark-paid') handleFreightBalanceMarkPaid(fbBtn, fbRef);
        else if (fbAction === 'bypass-set') handleFreightBalanceBypassSet(fbBtn, fbRef);
        /* CUSTOM_ONLINEWILLCALL_BY_CLAUDE (ONYX 39db36f688e9 + 96dc64a31604) - the customer collects the order. */
        else if (fbAction === 'willcall-set') handleWillCallSet(fbBtn, fbRef);
        else if (fbAction === 'willcall-undo') handleWillCallUndo(fbBtn, fbRef);
        else if (fbAction === 'willcall-refund') handleWillCallRefund(fbBtn, fbRef);
        else if (fbAction === 'bypass-clear') handleFreightBalanceBypassClear(fbBtn, fbRef);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-16) — Weight/dims N/A skip +
           undo, for shipments the supplier sent on their own carrier. */
        else if (fbAction === 'dims-na') handleFreightBalanceDimsNa(fbBtn, fbRef);
        else if (fbAction === 'dims-na-clear') handleFreightBalanceDimsNaClear(fbBtn, fbRef);
        else if (fbAction === 'expand-broker-quote') {
          // Toggle row 3's collapsed state — reveals the cost/markup/charge
          // inputs + the Invoice + Email button. Pure UI; no save.
          var wrap = fbBtn.closest('.rqd-fb-row3');
          if (wrap) wrap.classList.remove('rqd-fb-row3--collapsed');
        }
        return;
      }
      // ── Freight quote handshake (online Flow B orders) ──
      // 'cancel' is rep-allowed (own quotes) — wipes pending requests only.
      // 'reset' is admin-only — force-wipes already-quoted entries (lossy).
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — per-order freight-mode
         override (switch a freight-in-product vendor to our own carrier, edit our
         cost, or revert). Admin-only; checked before the generic toggle/invoice
         handlers since these buttons live inside .rqd-toggle / .rqd-invoice. */
      var fovBtn = e.target.closest('[data-freight-override-action]');
      if (fovBtn) {
        if (!isAdmin) return;
        var fovAction = fovBtn.dataset.freightOverrideAction;
        var fovRef = fovBtn.dataset.ref || '';
        var fovVendor = fovBtn.dataset.vendor || '';
        if (fovAction === 'switch') {
          openFreightOverridePopover(fovBtn, fovRef, fovVendor, { isSwitch: true, currentCost: '' });
        } else if (fovAction === 'switch-vendor') {
          /* CUSTOM_THEIRCARRIER_BY_CLAUDE (Ryan 2026-09-06) — "Their carrier" on a brokered row.
             No popover: there is no cost of ours to take, only a decision to record. */
          handleFreightOverrideSwitchVendor(fovRef, fovVendor);
        } else if (fovAction === 'edit-cost') {
          openFreightOverridePopover(fovBtn, fovRef, fovVendor, { isSwitch: false, currentCost: _freightOverrideCostFor(fovRef, fovVendor) });
        } else if (fovAction === 'save-cost') {
          /* CUSTOM_FOVCOSTROW_BY_CLAUDE (Ryan 2026-09-01) — the inline floppy on an our-carrier
             row whose cost is still unset. Same write as the popover's Save, minus the popover. */
          handleFreightOverrideCostSave(fovBtn, fovRef, fovVendor);
        } else if (fovAction === 'revert') {
          handleFreightOverrideRevert(fovRef, fovVendor, fovBtn.dataset.fovMode || 'our-carrier');
        }
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — the pallet / packaging fee ✎ on the
         Financials card. Admin-only and checked here, alongside the freight override, because
         both pencils live inside rows the generic handlers below would otherwise claim. */
      var pfBtn = e.target.closest('[data-pallet-fee-action]');
      if (pfBtn) {
        if (!isAdmin) return;
        var pfRef = pfBtn.dataset.ref || '';
        var pfVendor = pfBtn.dataset.vendor || '';
        var pfBucket = pfBtn.dataset.bucket || '';
        var pfQ = (typeof allQuotes !== 'undefined' && allQuotes)
          ? allQuotes.find(function (x) { return x && x.reference === pfRef; })
          : null;
        var pfKey = pfBucket ? (pfVendor + '::' + pfBucket) : pfVendor;
        var pfRec = (pfQ && pfQ.palletFees && (pfQ.palletFees[pfKey] || pfQ.palletFees[pfVendor])) || null;
        openPalletFeePopover(pfBtn, pfRef, pfVendor, {
          bucket: pfBucket,
          currentCount: pfBtn.dataset.count || (pfRec && pfRec.count != null ? pfRec.count : ''),
          rate: pfRec && pfRec.rate,
        });
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_DDFREIGHTCARD_BY_CLAUDE (Ryan 2026-08-29) — the Freight Quote / Installation Quote
         cards own their own actions.
         ⚠️ ABOVE the [data-freight-action] branch below, not merged into it: those two cards reuse
         `data-freight-action="skip"` / `"unskip"` verbatim so one handler serves both surfaces, and
         the new controls carry `data-fqc-action` instead. Checking the new attribute first keeps
         the shared ones falling through to the existing handler rather than being intercepted.
         Admin-gated here at the ROUTER, the house rule — a rep's click on an admin control is a
         silent no-op rather than a 403. */
      var fqcBtn = e.target.closest('[data-fqc-action]');
      if (fqcBtn && isAdmin && window.RQD && window.RQD.handleFreightCardAction) {
        if (window.RQD.handleFreightCardAction(e.target)) return;
      }
      var fqBtn = e.target.closest('[data-freight-action]');
      if (fqBtn) {
        var fqAction = fqBtn.dataset.freightAction;
        var fqRef = fqBtn.dataset.ref || '';
        var fqVendor = fqBtn.dataset.vendor || '';
        // Admin gate applies only to actions that mutate already-saved state.
        var requiresAdmin = fqAction === 'reset' || fqAction === 'edit-cost';
        if (requiresAdmin && !isAdmin) return;
        // CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — both mutate saved state: admin only.
        if (fqAction === 'skip' || fqAction === 'unskip') {
          if (!isAdmin) return;
          handleFreightSkip(fqRef, fqVendor, fqAction === 'unskip');
        } else if (fqAction === 'request-quote') {
          var fqBucket = fqBtn.dataset.bucket || null;
          handleFreightRequestStub(fqRef, fqVendor, fqBucket);
        } else if (fqAction === 'save-cost') {
          handleFreightCostSave(fqRef, fqVendor, fqBtn);
        } else if (fqAction === 'edit-cost') {
          handleFreightCostEdit(fqRef, fqVendor);
        } else if (fqAction === 'cancel') {
          handleFreightReset(fqRef, fqVendor, 'cancel');
        } else if (fqAction === 'reset') {
          handleFreightReset(fqRef, fqVendor, 'reset');
        }
        return;
      }
      // Click on the cost input itself shouldn't bubble to the row toggle.
      if (e.target.closest('.rqd-freight-cost-input')) return;
      // Invoice buttons must be checked BEFORE toggle (they live inside the toggle div)
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Void invoice action. Checked before
         the generic .rqd-invoice__generate handler so the Void button's
         click doesn't fall through to "generate". Mirrors the PO void
         pattern: admin only, confirm prompt, POST /void-invoice. */
      var invoiceVoidBtn = e.target.closest('[data-invoice-action="void"]');
      if (invoiceVoidBtn && isAdmin) {
        handleInvoiceVoid(invoiceVoidBtn);
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Skip anchors (e.g., the Preview
         link on a generated invoice — uses .rqd-invoice__generate to
         pick up the green ghost-outline treatment, but should navigate
         to the PDF, NOT re-fire the Generate handler with its due-date
         prompt). Only <button> elements bound to this class actually
         trigger generate. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — "Send Invoice" (sold-but-unpaid) shares the
         .rqd-invoice__generate class, so match its data-invoice-mode="send" BEFORE the generic
         generate handler and route to the Abby composer flow. */
      var invoiceSendComposeBtn = e.target.closest('button.rqd-invoice__generate[data-invoice-mode="send"]');
      if (invoiceSendComposeBtn && isAdmin) {
        handleInvoiceSendCompose(invoiceSendComposeBtn);
        return;
      }
      /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE (Ryan 2026-08-31) — "Send Paid Invoice": the way back for a
         PAID invoice that was prepared and then not sent (notify unticked, or the composer closed).
         ⛔ A SEPARATE MODE, NOT "send". handleInvoiceSendCompose builds the DUE email — the
         due-date preStep and "Please find your invoice attached" — which is the wrong letter to
         send someone who has already paid in full. Exact-match attribute selectors mean "send"
         above cannot catch "send-paid"; both must sit above the generic .rqd-invoice__generate
         handler, which they share a class with. */
      var invoicePaidSendBtn = e.target.closest('button.rqd-invoice__generate[data-invoice-mode="send-paid"]');
      if (invoicePaidSendBtn && isAdmin) {
        openPaidInvoiceCompose(invoicePaidSendBtn.dataset.ref);
        return;
      }
      var invoiceGenBtn = e.target.closest('button.rqd-invoice__generate');
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      if (invoiceGenBtn && isAdmin) {
        handleInvoiceGenerate(invoiceGenBtn);
        return;
      }
      var invoiceSendBtn = e.target.closest('.rqd-invoice__send');
      if (invoiceSendBtn && isAdmin) {
        handleInvoiceSend(invoiceSendBtn);
        return;
      }
      /* CUSTOM_RELEASENOW_BY_CLAUDE (Ryan 2026-08-29) — "⏳ Scheduled" clicked, on any of the four
         rows that can hold a vendor email. One handler, because they all render the same pill from
         RQD.scheduledReleaseBtnHtml.

         ⛔ THIS MUST STAY ABOVE THE `.rqd-invoice__link` BAIL-OUT DIRECTLY BELOW, and that is the
         whole reason it moved here. The pill wears `.rqd-invoice__link` to inherit the shared
         140x28 button look, so the "let the link navigate naturally" guard matched it first and
         returned — swallowing every click in total silence. Ryan clicked it on SHOP-1999 and then
         on SHOP-1996: no dialog, no error, no email, and the job still sitting in KV afterwards.

         ⚠️ A SILENT `return` IS THE WORST PLACE TO LAND, because nothing distinguishes it from a
         handler that ran and decided to do nothing. The lesson generalises: any NEW button that
         borrows `.rqd-invoice__link` for its styling is inert until it is dispatched above line
         ~3264, and it will fail without a single console message. */
      /* CUSTOM_FREIGHTABORT_BY_CLAUDE (AIOPS e653a9fd28de, Ryan 2026-09-04) — "cancel" beside the
         ⏳ pill: un-send a held freight / dims ask. Dispatched here, above the `.rqd-invoice__link`
         bail-out, for the reason the release pill's note gives. */
      var cancelHeldBtn = e.target.closest('[data-cancel-email]');
      if (cancelHeldBtn) {
        if (isAdmin) {
          try {
            var _cancP = handleCancelScheduledEmail(cancelHeldBtn);
            if (_cancP && typeof _cancP.catch === 'function') {
              _cancP.catch(function (err) { rqdAlert('Could not cancel it: ' + ((err && err.message) || 'unknown error')); });
            }
          } catch (err) {
            rqdAlert('Could not cancel it: ' + ((err && err.message) || 'unknown error'));
          }
        }
        return;
      }
      var releaseBtn = e.target.closest('[data-release-email]');
      if (releaseBtn) {
        /* ⛔ A THROW HERE USED TO LOOK EXACTLY LIKE A DEAD BUTTON. The dispatcher is `async`, so
           anything this rejects with is an unhandled rejection the user never sees — the same
           indistinguishable-from-nothing symptom as the swallowed click above, from a different
           cause. Surfaced rather than logged: "nothing happened" is not an acceptable answer for a
           control that sends mail. */
        if (isAdmin) {
          /* ⚠️ BOTH HALVES, because the handler is `async`: a synchronous throw needs the catch
             block, and a REJECTED PROMISE (rqdConfirm failing, say) escapes it entirely and would
             be just as invisible. */
          try {
            var _relP = handleReleaseScheduledEmail(releaseBtn);
            if (_relP && typeof _relP.catch === 'function') {
              _relP.catch(function (err) {
                rqdAlert('Could not release it: ' + ((err && err.message) || 'unknown error'));
              });
            }
          } catch (err) {
            rqdAlert('Could not release it: ' + ((err && err.message) || 'unknown error'));
          }
        }
        return;
      }
      /* CUSTOM_SAVEDEADBUTTON_BY_CLAUDE (Ryan 2026-09-11) - ONLY AN ANCHOR NAVIGATES.
         This guard's own comment says "let the link navigate naturally", and that is true of an
         <a>. But `.rqd-invoice__link` is ALSO the shared status-coloured button style, worn by
         ~20 <button>s purely for its looks - and on 2026-09-06 the sample cards' Save became one
         of them. From that day this bare `return` swallowed the click before the save branches
         ~670 lines below could ever see it, inside THIS SAME listener, so Save did nothing and
         printed nothing: no handler ran, so there was no error to log.
         Buttons elsewhere kept working only because their handlers live in OTHER click listeners,
         which a return here cannot reach. The two that did not are both here: the lead-side
         `.rqd-sample-tracking__save` and the quote-side `.rqd-quote-sample-tracking__save`.
         Scoping this to `a.` restores them and changes nothing else - the only <a> carrying the
         class is the invoice generate link, which still returns and still navigates. */
      var invoiceLink = e.target.closest('a.rqd-invoice__link');
      if (invoiceLink) return; // let the link navigate naturally
      var invoiceStatus = e.target.closest('.rqd-invoice__status') || e.target.closest('.rqd-invoice__meta');
      if (invoiceStatus) return; // don't toggle when clicking invoice meta text
      // Paid inline fields — don't trigger toggle when interacting with selects/inputs
      if (e.target.closest('.rqd-paid-fields')) return;

      var toggle = e.target.closest('.rqd-toggle');
      if (toggle && isAdmin) {
        // Only toggle when clicking the checkbox or label text, not the entire row
        var clickedCheck = e.target.closest('.rqd-toggle__check');
        var clickedLabel = e.target.tagName === 'SPAN' && !e.target.classList.contains('rqd-toggle__date') && !e.target.classList.contains('rqd-toggle__partial-badge');
        if (clickedCheck || clickedLabel) {
          handleToggleClick(toggle);
        }
        return;
      }
      var finEdit = e.target.closest('.rqd-fin-editable');
      if (finEdit && isAdmin) {
        handleFinancialEdit(finEdit);
        return;
      }
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Freight Cost ✎ wayfinder: not an
      // inline editor; just scrolls + focuses the per-bucket input below.
      var freightScroll = e.target.closest('.rqd-fin-freight-scroll');
      if (freightScroll && isAdmin) {
        jumpToFreightBalance(freightScroll.dataset.ref);
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var lineCostEdit = e.target.closest('.rqd-line-cost-edit');
      if (lineCostEdit && isAdmin) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Bundle parent
           Cost cell is read-only (computed sum of components below). */
        if (lineCostEdit.classList.contains('rqd-line-cost-edit--bundle-sum')) return;
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        handleLineCostEdit(lineCostEdit);
        return;
      }
      var lineQtyEdit = e.target.closest('.rqd-line-qty-edit');
      if (lineQtyEdit && isAdmin) {
        handleLineQtyEdit(lineQtyEdit);
        return;
      }
      var lineSkuEdit = e.target.closest('.rqd-line-sku-edit');
      if (lineSkuEdit && isAdmin) {
        handleLineSkuEdit(lineSkuEdit);
        return;
      }
      // CUSTOM_LINETITLE_BY_CLAUDE — the item-name pencil, same pattern as SKU.
      var lineTitleEdit = e.target.closest('.rqd-line-title-edit');
      if (lineTitleEdit && isAdmin) {
        handleLineTitleEdit(lineTitleEdit);
        return;
      }
      // CUSTOM_LEGENDWS_BY_CLAUDE — Legend weight-stack upgrade: which stacks it applies to.
      var lineStackEdit = e.target.closest('.rqd-line-stack-edit');
      if (lineStackEdit && isAdmin) {
        handleLineStackEdit(lineStackEdit);
        return;
      }
      // CUSTOM_LEGENDSPEC_BY_CLAUDE — Legend build spec: rewrite the rows the PO prints.
      var lineSpecEdit = e.target.closest('.rqd-line-legend-spec-edit');
      if (lineSpecEdit && isAdmin) {
        handleLineLegendSpecEdit(lineSpecEdit);
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Per-line flags popover. The `+`
         button opens a small popover with NEW + Freight Quoted toggles;
         each checkbox change persists immediately via its own endpoint
         (/line-new-flag and /line-freight-quoted-flag). Same source-of-
         truth on the worker side as the prior single-button flow — just
         a more discoverable affordance for the new freight-quoted path. */
      var lineFlagsToggle = e.target.closest('[data-line-flags-toggle]');
      if (lineFlagsToggle && isAdmin) {
        handleLineFlagsToggle(lineFlagsToggle);
        return;
      }
      /* NOTE: the checkbox change is NOT delegated here. The popover lives
         on document.body (outside this `tbody` listener), so its inputs are
         handled by a `change` listener bound directly on the popover in
         handleLineFlagsToggle. Delegating from tbody here never fired. */
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Log pallet dims
         click delegation retired. Pallet dims entry now lives inline
         inside the Fulfillment card via renderFreightBalancePalletForm,
         which saves through the existing data-fb-action="save-pallets"
         delegation — no separate modal needed. */
      var balanceFreightEdit = e.target.closest('.rqd-balance-rec__freight-edit');
      if (balanceFreightEdit && isAdmin) {
        handleBalanceFreightEdit(balanceFreightEdit);
        return;
      }
      // CUSTOM_RFQPORTAL_BY_CLAUDE — one-click auto-reconcile / undo on the card
      var balanceAutoBtn = e.target.closest('.rqd-balance-rec__auto-btn');
      if (balanceAutoBtn && isAdmin) { handleBalanceAutoReconcile(balanceAutoBtn); return; }
      var balanceUndoBtn = e.target.closest('.rqd-balance-rec__undo-btn');
      if (balanceUndoBtn && isAdmin) { handleBalanceAutoReconcileUndo(balanceUndoBtn); return; }
      /* CUSTOM_FBCOSTSAVE_BY_CLAUDE (Ryan 2026-08-13) — stop a click on the freight-cost INPUT
         from toggling the row it sits in.

         ⚠️ Guards the input, NOT its wrapper. The wrapper now also contains the Save button, and
         a wrapper-wide `return` here would swallow that click — the [data-fb-action] dispatcher
         above happens to run first, but relying on the ordering of two guards in one listener is
         exactly how a button silently stops working later. */
      var bucketCostField = e.target.closest('.rqd-fb__bucket-cost-input');
      if (bucketCostField) {
        e.stopPropagation();
        return;
      }
      var bucketActionBtn = e.target.closest('[data-bucket-action]');
      if (bucketActionBtn && isAdmin) {
        var bktAction = bucketActionBtn.dataset.bucketAction;
        var bktRef = bucketActionBtn.dataset.ref || '';
        var bktId = bucketActionBtn.dataset.bucket || '';
        if (bktAction === 'open-settings') {
          handleBucketSettingsToggle(bucketActionBtn, bktRef, bktId);
          return;
        }
        if (bktAction === 'combine') {
          handleBucketMode(bktRef, 'combined');
          return;
        }
        if (bktAction === 'split') {
          handleBucketMode(bktRef, 'auto-split');
          return;
        }
        // 'change-kind' and 'rename' fire on change/blur, not click —
        // change/input handlers below catch them.
      }
      var noteSaveBtn = e.target.closest('.rqd-pending-note-save');
      if (noteSaveBtn) {
        handlePendingNoteSave(noteSaveBtn);
        return;
      }
      var leadNoteSaveBtn = e.target.closest('.rqd-lead-note-save');
      if (leadNoteSaveBtn) {
        handleLeadNoteSave(leadNoteSaveBtn);
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Notes card v3
         click router. Type chips are now MUTUALLY EXCLUSIVE — only one
         active at a time. Clicking any chip deactivates all others +
         activates the clicked one. Click the active chip again to
         deactivate it; Note auto-reactivates as the implicit fallback
         (no entry can be untyped — Note is the default). The previous
         multi-select model + Meeting/Drop-In conflict rule are subsumed
         by the universal mutual-exclusion behavior. */
      var noteChip = e.target.closest('.rqd-notes-log__chip');
      /* Gate on dataset.noteType so the chip handler ignores the
         "✉ Email" action button (which shares the chip class for
         visual + status-scoped styling but is functionally an action,
         not a toggle). The new-email-btn handler downstream catches it. */
      if (noteChip && noteChip.closest('.rqd-notes-log__types') && noteChip.dataset.noteType) {
        var chipsRow = noteChip.parentElement;
        var card = noteChip.closest('.rqd-notes-log');
        var ta = card && card.querySelector('.rqd-notes-log__input');
        var clickedType = noteChip.dataset.noteType;
        var wasActive = noteChip.classList.contains('rqd-notes-log__chip--active');
        var nowActive;
        if (clickedType === 'note') {
          // Note always activates exclusively (deactivates all others)
          chipsRow.querySelectorAll('.rqd-notes-log__chip').forEach(function(c) {
            var isNote = c.dataset.noteType === 'note';
            c.classList.toggle('rqd-notes-log__chip--active', isNote);
            c.setAttribute('aria-pressed', isNote ? 'true' : 'false');
          });
          nowActive = ['note'];
        } else if (wasActive) {
          // Clicked an already-active non-Note chip → deactivate it +
          // auto-activate Note as the fallback default.
          chipsRow.querySelectorAll('.rqd-notes-log__chip').forEach(function(c) {
            var isNote = c.dataset.noteType === 'note';
            c.classList.toggle('rqd-notes-log__chip--active', isNote);
            c.setAttribute('aria-pressed', isNote ? 'true' : 'false');
          });
          nowActive = ['note'];
        } else {
          // Clicked an inactive non-Note chip → activate it + deactivate
          // all others (including Note + any other previously-active chip).
          chipsRow.querySelectorAll('.rqd-notes-log__chip').forEach(function(c) {
            var isClicked = c === noteChip;
            c.classList.toggle('rqd-notes-log__chip--active', isClicked);
            c.setAttribute('aria-pressed', isClicked ? 'true' : 'false');
          });
          nowActive = [clickedType];
        }
        applySmartPrefill(card, nowActive);
        /* Ryan 2026-05-29: Call "Focus mode" — while Call is active, collapse the
           other type chips (CSS via .is-calling on the types stack) so Call
           slides to the top and the outcome buttons stack beneath it. Clear any
           picked outcome when Call is toggled off. */
        var _callOn = nowActive.indexOf('call') !== -1;
        chipsRow.classList.toggle('is-calling', _callOn);
        // Reset the outcome decision-tree to step 1 whenever Call toggles on/off.
        _ocReset(card);
        clearFollowUp(card); // reset any armed follow-up — the outcome pick re-arms it
        if (!_callOn) _ocClearPrefill(card.querySelector('.rqd-notes-log__input'));
        /* Ryan 2026-05-21: chip toggle changes whether the save gate applies
           (only Call/Email trigger the follow-up requirement now), so re-
           sync the Save button enable state on every chip click. */
        _syncSaveEnabled(card);
        if (ta) ta.focus();
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-29) — Call-outcome DECISION TREE.
         Call → Inbound | Outbound → (Connected | No answer) → (Left VM | Didn't
         leave VM). Non-terminal nodes reveal the next step; terminal nodes set
         finalOutcome (inbound|connected|no-answer) which drives the cadence +
         save gate. "Left VM" and "Didn't leave VM" each prefill the note
         (rep can overwrite). Helpers (_ocReset etc.) live near applySmartPrefill. */
      var ocGo = e.target.closest('.rqd-notes-log__calloutcome-chip[data-oc-go]');
      if (ocGo) {
        var ocCard = ocGo.closest('.rqd-notes-log');
        var oc = ocCard && ocCard.querySelector('.rqd-notes-log__calloutcome');
        if (oc) {
          var node = ocGo.dataset.ocGo;
          if (node === 'outbound') {
            delete oc.dataset.finalOutcome; _ocSetCrumbs(oc, ['Outbound']); _ocShowStep(oc, 'outbound');
          } else if (node === 'no-answer') {
            delete oc.dataset.finalOutcome; _ocSetCrumbs(oc, ['No answer']); _ocShowStep(oc, 'no-answer');
          } else {
            /* Crumb is a single short label — each leaf already implies its path
               (e.g. "Didn't leave VM" only happens via Outbound → No answer), so
               the full chain was needless and overflowed the column. */
            var _outcome, _crumbs;
            if (node === 'inbound') { _outcome = 'inbound'; _crumbs = ['Inbound']; }
            else if (node === 'connected') { _outcome = 'connected'; _crumbs = ['Connected']; }
            else if (node === 'left-vm') { _outcome = 'no-answer'; _crumbs = ['Left VM']; }
            else { _outcome = 'no-answer'; _crumbs = ['Didn’t leave VM']; }
            oc.dataset.finalOutcome = _outcome;
            if (node === 'left-vm') oc.dataset.callVm = 'left';
            else if (node === 'no-vm') oc.dataset.callVm = 'none';
            else delete oc.dataset.callVm;
            oc.dataset.ocStage = 'done';
            /* CUSTOM_CALLDETAIL_BY_CLAUDE (Ryan 2026-09-20) — reaching ANY leaf is a fresh pick,
               so drop a reason left over from an earlier trip through the tree before the note is
               prefilled below (passing false keeps this from writing the note twice). */
            _ocClearDetail(oc, null, false);
            /* The no-VM leaf is the one terminal node that keeps a step on screen — its optional
               "why" chips. Every other leaf still collapses to the crumb alone. */
            _ocShowStep(oc, node === 'no-vm' ? 'no-vm-detail' : '__done__');
            _ocSetCrumbs(oc, _crumbs);
            var _ta = ocCard.querySelector('.rqd-notes-log__input');
            if (node === 'left-vm') _ocPrefillNote(_ta, 'Left a voicemail.');
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-07) — "Didn't leave VM"
               now prefills its own note (symmetric with "Left VM"); was clearing. */
            else if (node === 'no-vm') _ocPrefillNote(_ta, _ocNoVmNote(oc));
            /* Every call outcome arms a follow-up (mandatory next step — Ryan
               2026-05-29). No answer = chase → advance to the current rung;
               Connected/Inbound = contact (counter resets server-side) → default
               the next step to the first rung. Rep can adjust the date. */
            var _ocBtn = ocCard.querySelector('.rqd-notes-log__submit');
            var _ocRef = _ocBtn && _ocBtn.dataset.ref;
            var _ocQ = (typeof allQuotes !== 'undefined') ? allQuotes.find(function (x) { return x.reference === _ocRef; }) : null;
            var _ocQuoteStage = !!(_ocQ && (_ocQ.lifecycleStatus === 'quoted' || _ocQ.lifecycleStatus === 'sold' || _ocQ.lifecycleStatus === 'lost' || _ocQ.chainQuoted || _ocQ.pdfDownloaded || _ocQ.chainPdfDownloaded));
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-07) — Sample requests
               use a +7d-first ladder so logging that first call lands the
               follow-up at +7d (samples ship/deliver in ~4-5 days; chasing
               sooner is premature). Matches the +7d preset default baked
               into the composer for samples (dashboard-activity-card.js). */
            var _ocIsSample = !!(_ocQ && (_ocQ.isSample || _ocQ.status === 'sample'));
            /* CFA prospects (cfaCode): cold prospect ladder [3,7,7,14,14,30,45], or flat-7 once they've replied. */
            var _ocIsProspect = !!(_ocQ && _ocQ.cfaCode);
            var _ocLadder = _ocIsProspect ? [3, 7, 7, 14, 14, 30, 45, 45]
                          : (_ocQuoteStage || _ocIsSample) ? [7, 7, 7, 10, 10, 10] : [3, 5, 7, 14, 14, 30];
            var _ocIdx = (_outcome === 'no-answer') ? ((_ocQ && ((_ocQ.consecutiveUnanswered) || (_ocQ.followUp && _ocQ.followUp.consecutiveUnanswered))) || 0) : 0;
            var _ocDays = (_ocIsProspect && _ocQ && _ocQ.prospectRepliedAt) ? 7 : _ocLadder[Math.min(_ocIdx, _ocLadder.length - 1)];
            armFollowUp(ocCard, daysFromNowYmd(_ocDays), _ocDays);
          }
          _syncSaveEnabled(ocCard);
        }
        return;
      }
      /* CUSTOM_CALLDETAIL_BY_CLAUDE (Ryan 2026-09-20) — the optional "why there was no voicemail"
         chips. ONE at a time: a second chip swaps, the active chip clicked again clears back to no
         reason. They never touch callOutcome, callVm or the armed follow-up — those were all set
         by the leaf that revealed them, so the cadence, the sequence-stop and the call-wait park
         behave exactly as they did before this existed. */
      var ocDetail = e.target.closest('.rqd-notes-log__oc-detail-chip[data-oc-detail]');
      if (ocDetail) {
        var dCard = ocDetail.closest('.rqd-notes-log');
        var dOc = dCard && dCard.querySelector('.rqd-notes-log__calloutcome');
        if (dOc) {
          var _wasDetail = dOc.dataset.callDetail === ocDetail.dataset.ocDetail;
          _ocClearDetail(dOc, null, false);
          if (!_wasDetail) {
            dOc.dataset.callDetail = ocDetail.dataset.ocDetail;
            ocDetail.classList.add('rqd-notes-log__chip--active');
            ocDetail.setAttribute('aria-pressed', 'true');
          }
          /* ⚠️ _ocPrefillNote declines when the rep has typed over the prefill. That is the right
             answer here: their sentence survives and the reason still rides along in callDetail,
             so the structured half is never lost to a hand-written note. */
          _ocPrefillNote(dCard.querySelector('.rqd-notes-log__input'), _ocNoVmNote(dOc));
          _syncSaveEnabled(dCard); // Save was already live; the note text just changed under it
        }
        return;
      }
      var ocRestart = e.target.closest('.rqd-notes-log__oc-restart');
      if (ocRestart) {
        var rCard = ocRestart.closest('.rqd-notes-log');
        if (rCard) { _ocReset(rCard); clearFollowUp(rCard); _ocClearPrefill(rCard.querySelector('.rqd-notes-log__input')); _syncSaveEnabled(rCard); }
        return;
      }
      var noteSubmit = e.target.closest('.rqd-notes-log__submit');
      if (noteSubmit) {
        handleNoteEntryAdd(noteSubmit);
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-16) — "Save & Mark Lost/Dead". */
      var noteCloseOut = e.target.closest('.rqd-notes-log__closeout');
      if (noteCloseOut) {
        handleNoteCloseOut(noteCloseOut);
        return;
      }
      /* Ryan 2026-05-22: "📨 New Email" button on the activity card →
         opens the compose modal (fresh email, not a reply). To-prefill
         comes from the deal's customer email; subject auto-prefilled
         with the deal ref. */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-29) — reply-vs-new on the ✉ pill.
         The QW's Send Quote has asked this since 2026-05-30 (workstation-save.js
         showSendModeChooser); the DD opened a fresh email every time, which is why replying to a
         customer meant leaving the board. Ryan's shape: a drop-down off the pill, and *"unless
         there's no existing thread to the customer, in which case it'll just default to starting
         a fresh new email."*

         ⛔ BOTH BRANCHES LIVE IN ONE BLOCK ON PURPOSE. They share three helpers, and this is the
         body of a delegated click listener — declaring them here keeps them in the one scope both
         paths can see, with no reliance on where the enclosing function happens to end. */
      var emailModeItem = e.target.closest('.rqd-notes-log__email-menu .rqd-fqc__menu-item');
      var newEmailBtn = emailModeItem ? null : e.target.closest('.rqd-notes-log__new-email-btn');
      if (emailModeItem || newEmailBtn) {
        var _emWrap = (emailModeItem || newEmailBtn).closest('.rqd-fqc__menu-wrap');
        var _emBtn = newEmailBtn || (_emWrap && _emWrap.querySelector('.rqd-notes-log__new-email-btn'));
        var _emMenu = _emWrap && _emWrap.querySelector('.rqd-notes-log__email-menu');
        /* CUSTOM_COMPOSEDRAFT_BY_CLAUDE — this deal's email is already minimized: open it, never a second one. */
        if (newEmailBtn && window.RQD && window.RQD.restoreMinimizedCompose && window.RQD.restoreMinimizedCompose(newEmailBtn.dataset.ref)) return;
        /* One cache per ref on RQD rather than a module var — the pill fetches the thread, the
           menu item spends it, and they are two separate clicks through this same listener. */
        window.RQD = window.RQD || {};
        var _emThreads = window.RQD.__dealEmailThreads = window.RQD.__dealEmailThreads || {};

        function _emGroups(list) {
          return (window.RQD && typeof window.RQD.groupEmailThreads === 'function')
            ? window.RQD.groupEmailThreads(list)
            : (list.length ? [{ top: list[0], emails: list, label: '' }] : []);
        }
        /* One item per thread when there is a choice to make (newest first, so the top item is
           the default); the original single item when there is not. Rebuilt on every open —
           the activity card repaints the static markup, so nothing here can go stale. */
        function _emFillMenu(list) {
          if (!_emMenu) return;
          var grp = _emGroups(list);
          var anySib = list.some(function (m) { return m && m.sibling; });
          var items = _emMenu.querySelectorAll('[data-email-mode="reply"]');
          for (var ii = 0; ii < items.length; ii++) items[ii].remove();
          var newItem = _emMenu.querySelector('[data-email-mode="new"]');
          var rows = (grp.length > 1 || anySib) ? grp.slice(0, 8) : [null];
          rows.forEach(function (t, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'rqd-fqc__menu-item';
            b.dataset.emailMode = 'reply';
            b.dataset.threadIdx = String(i);
            b.textContent = t ? ('↳ ' + t.label) : '↳ Reply on existing thread';
            if (t) b.title = 'Reply all on: ' + t.label;
            _emMenu.insertBefore(b, newItem);
          });
        }
        function _emCloseMenu() {
          if (_emMenu) _emMenu.hidden = true;
          if (_emBtn) _emBtn.setAttribute('aria-expanded', 'false');
        }
        function _emOpen(mode, threadIdx) {
          var ref = (_emBtn && _emBtn.dataset.ref) || '';
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (AIOPS c811b43f9288, Ryan 2026-09-28) — the list now spans the
             customer's other deals, so it is grouped into threads and the menu item names one. */
          var _grp = _emGroups(_emThreads[ref] || []);
          var _t = _grp[threadIdx || 0] || _grp[0];
          var emails = _t ? _t.emails : [];
          var top = emails[0];
          if (mode !== 'reply' || !top) return _emOpenNew();
          /* Mirrors the QW's reply fork (workstation-save.js openReply): open on REPLY-ALL as the
             send would address it, with `replyAll` built server-side by /deal-email-thread — it
             needs the system-mailbox list out of KV to subtract our own addresses and force the
             customer into To. Never rebuild that audience here. */
          var otherParty = '';
          for (var ei = 0; ei < emails.length; ei++) {
            if (emails[ei] && emails[ei].direction === 'inbound') {
              otherParty = emails[ei].fromName || emails[ei].from || ''; break;
            }
          }
          if (!otherParty) otherParty = (_emBtn && _emBtn.dataset.to) || '';
          var _ra = top.replyAll || null;
          if (!window.RQD.openComposeModal) return;
          window.RQD.openComposeModal({
            ref: ref,
            persistMinimized: true,   // CUSTOM_COMPOSEDRAFT_BY_CLAUDE
            prefillTo: (_ra && _ra.to && _ra.to.length) ? _ra.to.join(', ') : ((_emBtn && _emBtn.dataset.to) || ''),
            prefillCc: (_ra && Array.isArray(_ra.cc)) ? _ra.cc.slice() : [],
            replyToMessageId: top.messageId,
            prefillSubject: top.subject || '',
            /* A reply rides the owner's own thread, so the sender is locked — the same rule the
               QW's reply fork has always used. The NEW fork below keeps the admin's choice. */
            fromOptions: ['REP'],
            showBusinessHours: true,
            businessHoursDefault: false,
            replyThread: emails,
            replyContext: { subject: top.subject || '', withWhom: otherParty, count: emails.length },
            fetchQuotes: _emFetch,
          });
        }
        function _emOpenNew() {
          if (!window.RQD.openComposeModal) return;
          window.RQD.openComposeModal({
            ref: (_emBtn && _emBtn.dataset.ref) || '',
            persistMinimized: true,   // CUSTOM_COMPOSEDRAFT_BY_CLAUDE
            prefillTo: (_emBtn && _emBtn.dataset.to) || '',
            // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — From: selector. 'customer-email'
            // remembers (per rep) whether this email type sends from you or Abby/orders@.
            emailType: 'customer-email',
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — ⛔ THIS BUTTON IS THE REP WRITING TO
               THEIR CUSTOMER, AND FOR A REP THAT IS NOT A CHOICE. Ryan: *"rep emails when they
               click the 'Email' button in the DD or QW will always be from them. admins default
               to from them, but they can choose."*

               So the role decides whether there is a dropdown at all — one option renders as a
               locked From row — and `forceFrom` decides what it opens on. ⚠️ forceFrom does two
               things the plain default cannot (see openComposeModal): it BEATS the saved
               per-type preference, so an admin who once picked Abby here still opens on
               themselves, and switching does NOT write a new default, so choosing Abby on one
               email stays a one-off. That is exactly "default to from them, but they can
               choose". The remembered-preference behaviour from 2026-06-15 is deliberately
               retired for this type; it is still live for PO / freight / shipping.

               ⚠️ Client-side rule, like every admin gate in the theme — `isAdmin` is
               `session.admin === true` (never `role`, which reads 'rep' for real admins). The
               send endpoint still honours whatever mailbox it is told, the same as it does for
               POs, so this shapes what a rep is OFFERED rather than what the API permits. */
            forceFrom: 'REP',
            fromOptions: isAdmin ? ['REP', 'ABBY'] : ['REP'],
            /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-08-20) — the ⏱ clock on the toolbar.
               ⛔ DEFAULT UNCHECKED HERE, unlike every other composer that has this control.
               Those are all Abby/system emails composed on somebody's behalf at an arbitrary
               moment, where holding to business hours is obviously right. This is a rep TYPING
               RIGHT NOW and pressing Send because they mean now — defaulting to a hold would
               mean the first person to email a customer at 8pm finds out the next morning.
               Ticking it is the deliberate act. */
            showBusinessHours: true,
            businessHoursDefault: false,
            fetchQuotes: _emFetch,
          });
        }

        // ── dispatch ────────────────────────────────────────────────────────────────────────
        if (emailModeItem) {          // a choice was made in the menu
          _emCloseMenu();
          _emOpen(emailModeItem.dataset.emailMode, parseInt(emailModeItem.dataset.threadIdx, 10) || 0);
          return;
        }
        if (_emMenu && !_emMenu.hidden) { _emCloseMenu(); return; }   // second click closes it

        var _emRef = _emBtn.dataset.ref || '';
        /* ⚠️ GUARD THE IN-FLIGHT LOOKUP ON THE ELEMENT, not on a flag the next re-render drops.
           The pill sits inside the activity card, which repaints on any note or quiet refresh —
           a double click while the fetch is out would otherwise open two composers. */
        if (_emBtn.dataset.emBusy === '1') return;
        _emBtn.dataset.emBusy = '1';

        var _emDone = function (emails) {
          delete _emBtn.dataset.emBusy;
          _emThreads[_emRef] = emails;
          /* No thread → no choice worth making. Straight to a fresh email, exactly as this
             button behaved before today. */
          if (!emails.length || !_emMenu) { _emOpenNew(); return; }
          _emFillMenu(emails);
          _emMenu.hidden = false;
          _emBtn.setAttribute('aria-expanded', 'true');
        };
        /* ⛔ A FAILED LOOKUP MUST NOT COST THE REP THE EMAIL. If /deal-email-thread is down or
           the deal is one this rep does not own (it 403s on ownership), fall through to the
           fresh-email composer rather than surfacing an error on a button whose whole job is to
           open a composer. Degrades to precisely the old behaviour. */
        if (_emThreads[_emRef]) { _emDone(_emThreads[_emRef]); }
        else {
          API.get('/deal-email-thread?siblings=1&search=1&ref=' + encodeURIComponent(_emRef))   // + the customer's other deals (AIOPS c811b43f9288); search=1 pulls the customer's Outlook mail when the deal has none (RW-1509-A)
            .then(function (t) { _emDone((t && Array.isArray(t.emails)) ? t.emails : []); })
            .catch(function () { delete _emBtn.dataset.emBusy; _emOpenNew(); });
        }
        return;
      }
      var noteDelete = e.target.closest('.rqd-notes-log__entry-delete');
      if (noteDelete) {
        handleNoteEntryDelete(noteDelete);
        return;
      }
      var noteEditBtn = e.target.closest('.rqd-notes-log__entry-edit-btn');
      if (noteEditBtn) {
        enterNoteEditMode(noteEditBtn);
        return;
      }
      var noteEditSave = e.target.closest('.rqd-notes-log__entry-edit-save');
      if (noteEditSave) {
        handleNoteEntryEdit(noteEditSave);
        return;
      }
      var noteEditCancel = e.target.closest('.rqd-notes-log__entry-edit-cancel');
      if (noteEditCancel) {
        exitNoteEditMode(noteEditCancel.closest('.rqd-notes-log__entry'));
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Mobile-only:
         tap the timestamp on an activity entry to open a popover with
         Edit / Delete actions. The ✎ + ✕ icons are CSS-hidden on
         mobile (no room + too easy to mis-tap), but the underlying
         buttons still exist in the DOM with their data-ref +
         data-entry-id, so the popover just delegates to the same
         handlers (enterNoteEditMode / handleNoteEntryDelete) the
         desktop icons use. If the entry has no mutate buttons (user
         lacks edit/delete permission for this entry), the timestamp
         tap is a no-op. */
      var entryWhen = e.target.closest('.rqd-notes-log__entry-when');
      if (entryWhen && window.matchMedia && window.matchMedia('(max-width: 760px)').matches) {
        var _entryEl = entryWhen.closest('.rqd-notes-log__entry');
        var _editBtn = _entryEl && _entryEl.querySelector('.rqd-notes-log__entry-edit-btn');
        var _delBtn = _entryEl && _entryEl.querySelector('.rqd-notes-log__entry-delete');
        if (_editBtn || _delBtn) {
          showEntryMutatePopover(entryWhen, _editBtn, _delBtn);
          return;
        }
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Follow-up cluster
         handlers. Preset buttons toggle: click an inactive preset →
         arm at that date; click the already-active preset → clear the
         follow-up entirely. No separate Clear button — the rep clears
         either by re-clicking the active preset or by deleting the
         text in the custom date input. */
      var followPick = e.target.closest('.rqd-notes-log__followup-pick');
      if (followPick) {
        var days = parseInt(followPick.dataset.days, 10);
        if (!isFinite(days)) return;
        var pickCard = followPick.closest('.rqd-notes-log');
        if (followPick.classList.contains('rqd-notes-log__followup-pick--active')) {
          clearFollowUp(pickCard);
        } else {
          armFollowUp(pickCard, daysFromNowYmd(days), days);
        }
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — Clicking a SOLD deal's reminder
         opens a confirm popup to clear it. Checked BEFORE the follow-up-badge handler so
         a sold row's follow-up routes to the clear-confirm modal (not the Activity card).
         Active-deal follow-ups carry no data-sold-fu-clear → unchanged. */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (AIOPS d6c1b2c5907a, Ryan 2026-09-16) — the hover ✕.
         ⛔ CHECKED BEFORE THE BADGE IT SITS INSIDE, or the click bubbles to the branch below and
         the confirm box opens on top of the clear that already happened.
         ⛔ AND IT CLEARS WITHOUT ASKING. Ryan chose that on 2026-09-16 over keeping the confirm:
         the ✕ is a 15px target you had to aim at and it appears only on hover, so the mis-click
         the 2026-07-03 confirm was defending against is not the same risk here. Clicking the BELL
         still confirms — that is the large, easy-to-hit surface, and it keeps its guard.
         ⛔ NO NOTE, NO CALL, NO EMAIL. `/follow-up-clear` removes `wm.followUp` and writes no
         activity; inventing one is the exact thing the card was filed to stop. */
      var soldFuDismiss = e.target.closest('[data-sold-fu-dismiss]');
      if (soldFuDismiss) {
        e.stopPropagation();
        e.preventDefault();
        var _sfdRef = soldFuDismiss.getAttribute('data-ref');
        if (!_sfdRef) return;
        soldFuDismiss.disabled = true;
        (async function () {
          try {
            await API.post('/follow-up-clear', { ref: _sfdRef });
            var _sfdQ = allQuotes.find(function (x) { return x.reference === _sfdRef; });
            /* Patched locally and the cell re-rendered, the same pair the confirm path does — the
               next board poll is up to fifteen seconds away and a bell that survives the click
               reads as a click that did not register. */
            if (_sfdQ) { _sfdQ.followUp = null; refreshProgressBar(_sfdRef); }
          } catch (err) {
            /* Said out loud and the ✕ handed back. A silent failure here leaves the reminder on
               screen with no explanation, which is indistinguishable from the button not working. */
            soldFuDismiss.disabled = false;
            rqdAlert('Could not clear the reminder: ' + ((err && err.message) || 'error'));
          }
        })();
        return;
      }
      var soldFuClear = e.target.closest('[data-sold-fu-clear]');
      if (soldFuClear) {
        e.stopPropagation();
        var _sfcRef = soldFuClear.getAttribute('data-ref');
        var _sfcQ = _sfcRef && allQuotes.find(function(x) { return x.reference === _sfcRef; });
        if (_sfcQ) openClearReminderModal(_sfcQ);
        return;
      }
      var followBadge = e.target.closest('.rqd-followup-countdown');
      if (followBadge) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — BOTH the bell (expired)
           and the countdown (not yet expired) now just open the row's Activity
           card so the rep can log a follow-through (which advances the cadence).
           A follow-up is NEVER manually cleared — it only clears when the deal
           goes terminal (SOLD/LOST). The old non-expired branch popped a
           confirm-then-clear, which left active deals with no bell AND no
           countdown — exactly the silent-drop we don't want. */
        handleFollowUpBellOpen(followBadge);
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Phase 2.5 lead → quote handoff button.
      // Body-level (inside detail panel, not actions menu) so the rep gets a
      // prominent CTA when they expand a NEW LEAD row.
      var buildLeadBtn = e.target.closest('.rqd-build-quote-from-lead-btn');
      if (buildLeadBtn) {
        handleBuildQuoteFromLead(buildLeadBtn);
        return;
      }
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Mark Dead / Resurrect lead handlers.
      // Mark Dead is gated server-side to leads ≥72h old; UI hides the
      // option before then but a stale-tab race could send the request, so
      // we surface the worker's 425 Too Early response with a friendly toast.
      var markDeadBtn = e.target.closest('.rqd-mark-dead-btn');
      if (markDeadBtn) {
        handleMarkLeadDead(markDeadBtn);
        return;
      }
      var resurrectBtn = e.target.closest('.rqd-resurrect-lead-btn');
      if (resurrectBtn) {
        handleResurrectLead(resurrectBtn);
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Manual link button
         on the LINKED FILES section. Opens the design picker; selection
         POSTs /quote-link-design + quiet-refreshes the row. */
      var linkFileBtn = e.target.closest('.rqd-linked-file__add');
      if (linkFileBtn) {
        var _lfRef = linkFileBtn.dataset.ref;
        if (_lfRef) openLinkFloorPlanPicker(_lfRef);
        return;
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Unlink Asset button.
         Single linked file → confirm + unlink. Multiple → open the picker
         in unlink-mode where each linked file shows a remove action. */
      var unlinkFileBtn = e.target.closest('.rqd-linked-file__unlink');
      if (unlinkFileBtn) {
        var _ulRef = unlinkFileBtn.dataset.ref;
        if (_ulRef && typeof allQuotes !== 'undefined') {
          var _ulQ = allQuotes.find(function(x) { return x && x.reference === _ulRef; });
          if (_ulQ && Array.isArray(_ulQ.linkedFiles) && _ulQ.linkedFiles.length > 0) {
            if (_ulQ.linkedFiles.length === 1) {
              var _ulFile = _ulQ.linkedFiles[0];
              var _ulName = _ulFile.name || _ulFile.designRef || 'this asset';
              if (await rqdConfirm('Unlink "' + _ulName + '" from ' + _ulRef + '?', { title: 'Unlink asset', confirmLabel: 'Unlink', danger: true })) {
                window.RepPortal.API.post('/quote-unlink-design', {
                  ref: _ulRef,
                  designId: _ulFile.designId || _ulFile.designRef,
                }).then(function() { fetchQuotes({ quiet: true }); })
                  .catch(function(err) { rqdAlert('Unlink failed: ' + (err && err.message ? err.message : 'unknown error')); });
              }
            } else {
              openUnlinkAssetPicker(_ulRef, _ulQ.linkedFiles);
            }
          }
        }
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Deal-feed pagination.
         Reveal the hidden "older entries" block on click. Toggle the
         button label so a second click can collapse it back. */
      var showMoreBtn = e.target.closest('.rqd-notes-log__show-more');
      if (showMoreBtn) {
        var hiddenBlock = showMoreBtn.nextElementSibling;
        if (hiddenBlock && hiddenBlock.classList.contains('rqd-notes-log__hidden-entries')) {
          var isHidden = hiddenBlock.hasAttribute('hidden');
          if (isHidden) {
            hiddenBlock.removeAttribute('hidden');
            showMoreBtn.textContent = 'Hide older entries';
          } else {
            hiddenBlock.setAttribute('hidden', '');
            // Restore the original "Show N older entries" label
            var hiddenCount = hiddenBlock.children.length;
            showMoreBtn.textContent = 'Show ' + hiddenCount + ' older ' + (hiddenCount === 1 ? 'entry' : 'entries');
          }
          return;
        }
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Email entry expand.
         Click anywhere on the email card → modal with the full body.
         The entry itself is now the click target (role=button) — no
         inner __open wrapper since that prevented natural sibling-row
         indentation. Ignore clicks on inner anchor tags so future
         inline-link rendering doesn't open the modal. */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-29) — a HELD email opens its own modal.
         ⛔ CHECKED BEFORE the sent-email branch below, and it has to be: that branch's finder
         requires `n.emailMeta`, which a held entry does not have, so a held row would fall through
         it and silently do nothing — a control that looks clickable and is not. */
      var heldCard = e.target.closest('.rqd-email-entry--held');
      if (heldCard && !e.target.closest('a, button')) {
        var _heldKey = heldCard.dataset.heldKey;
        var _heldRef = '';
        var _heldEntry = null;
        if (typeof allQuotes !== 'undefined') {
          for (var _hi = 0; _hi < allQuotes.length; _hi++) {
            var _hq = allQuotes[_hi];
            if (!_hq || !Array.isArray(_hq.noteEntries)) continue;
            var _hh = _hq.noteEntries.find(function (n) {
              return n && n.heldMeta && n.heldMeta.key === _heldKey;
            });
            if (_hh) { _heldEntry = _hh; _heldRef = _hq.reference || ''; break; }
          }
        }
        if (_heldKey && window.RQD && window.RQD.openHeldEmailModal) {
          /* ⛔ INVALIDATE THE SWR CACHE, THEN REFETCH. This passed plain `fetchQuotes`, which
             serves the RAM/sessionStorage entry for the current view first (6h TTL) and only
             revalidates behind the scenes — so after re-sending or deleting a held email the feed
             repainted from a payload assembled BEFORE the change. Ryan saw the superseded Monday
             row still claiming to be pending while the composer correctly said Sunday, and the
             backend was right the whole time.
             ⚠️ This is the same trap the 2026-08-26 note above `_swrInvalidateQuotes` describes
             for a newly created pending deal, arriving from a different direction: that comment
             says to clear when the SET of rows changes and not when a row's contents do, because
             contents normally get patched in place. A held email is the exception — it rewrites
             `noteEntries`, and nothing patches the feed, so the cached copy is simply wrong until
             it is refetched. */
          window.RQD.openHeldEmailModal(_heldKey, _heldEntry, _heldRef, { fetchQuotes: _emFetch });
        }
        return;
      }
      var emailCard = e.target.closest('.rqd-email-entry');
      /* CUSTOM_DEALFEED_BY_CLAUDE (AIOPS c812ade34056, Ryan 2026-09-10) — A DRAG THAT ENDS HERE IS
         A SELECTION, NOT A CLICK. Email cards are whole-card click targets sitting in the middle
         of the feed; now that the feed is selectable, releasing the mouse on one at the end of a
         drag across several notes would open it. If the user has actually selected something,
         this is not a click. An empty selection behaves exactly as before. */
      var _selLen = 0;
      try { _selLen = String(window.getSelection() || '').length; } catch (_) { _selLen = 0; }
      if (emailCard && !_selLen && !e.target.closest('a, button')) {
        var _emEntryId = emailCard.dataset.entryId;
        var _emRef = emailCard.closest('tr')?.previousElementSibling?.dataset?.ref;
        // Find the entry on the quote — walk allQuotes for the rep's deals.
        if (typeof allQuotes !== 'undefined') {
          for (var _qi = 0; _qi < allQuotes.length; _qi++) {
            var _q = allQuotes[_qi];
            if (!_q || !Array.isArray(_q.noteEntries)) continue;
            var _hit = _q.noteEntries.find(function(n) { return n && n.id === _emEntryId && n.emailMeta; });
            if (_hit) {
              openEmailModal(_hit, _q);
              break;
            }
          }
        }
        return;
      }
      var promoteSampleBtn = e.target.closest('.rqd-promote-sample-btn');
      if (promoteSampleBtn) {
        handlePromoteSample(promoteSampleBtn);
        return;
      }
      var holdLeadBtn = e.target.closest('.rqd-hold-lead-btn');
      if (holdLeadBtn) {
        handleHoldLead(holdLeadBtn);
        return;
      }
      var editHoldBtn = e.target.closest('.rqd-edit-hold-btn');
      if (editHoldBtn) {
        handleHoldLead(editHoldBtn);
        return;
      }
      var wakeLeadBtn = e.target.closest('.rqd-wake-lead-btn');
      if (wakeLeadBtn) {
        handleWakeLead(wakeLeadBtn);
        return;
      }
      var sampleTrackingSaveBtn = e.target.closest('.rqd-sample-tracking__save');
      if (sampleTrackingSaveBtn) {
        handleSampleTrackingSave(sampleTrackingSaveBtn);
        return;
      }
      // Quote-level sample tracking — admin records a sample shipment
      // attached to a regular ECORE-quoted order (not a sample-request
      // lead). Distinct save handler hits /quote-sample-tracking-save.
      // (Collapse/expand of the surrounding card is handled by the
      // generic .rqd-detail__arap--collapsible system at line ~1211 —
      // we don't need a separate toggle here.)
      var quoteSampleSaveBtn = e.target.closest('.rqd-quote-sample-tracking__save');
      if (quoteSampleSaveBtn) {
        handleQuoteSampleTrackingSave(quoteSampleSaveBtn);
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var installSaveBtn = e.target.closest('.rqd-install-form__save');
      if (installSaveBtn) {
        handleInstallSave(installSaveBtn);
        return;
      }
      var installAddBtn = e.target.closest('.rqd-install-add');
      if (installAddBtn && isAdmin) {
        handleInstallAdd(installAddBtn);
        return;
      }
    });

    // Info card tab switching
    tbody.addEventListener('click', function(e) {
      var tab = e.target.closest('.rqd-info-tab');
      if (!tab) return;
      e.stopPropagation();
      var card = tab.closest('.rqd-detail__card');
      if (!card) return;
      card.querySelectorAll('.rqd-info-tab').forEach(function(t) { t.classList.remove('rqd-info-tab--active'); });
      card.querySelectorAll('.rqd-info-pane').forEach(function(p) { p.classList.remove('rqd-info-pane--active'); });
      tab.classList.add('rqd-info-tab--active');
      var pane = card.querySelector('[data-pane="' + tab.dataset.tab + '"]');
      if (pane) pane.classList.add('rqd-info-pane--active');
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — persist the choice so the
         next re-render reopens THIS tab. Without it the selection was DOM-only and
         every quiet render (2-min poll, and the visibilitychange refetch when the
         rep tabs back from a carrier site mid-copy) reset the card to Sold To —
         which is how a ship-to copy could silently continue off the wrong pane. */
      if (window.RQD && RQD.rememberInfoTab) RQD.rememberInfoTab(tab.dataset.infoRef, tab.dataset.infoPane);
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — pencil-edit affordance on the Sold To
       card for pre-quote leads (NEW LEAD / SAMPLE / ON HOLD / DEAD).
       Stops propagation so the click doesn't toggle the detail row open/closed,
       looks up the row's q from allQuotes, and hands off to __openEditCustomer. */
    tbody.addEventListener('click', function(e) {
      var btn = e.target.closest('.rqd-edit-sold-pencil');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var ref = btn.getAttribute('data-edit-sold-ref');
      if (!ref || !Array.isArray(allQuotes)) return;
      var q = allQuotes.find(function(x) { return x.reference === ref; });
      if (!q) return;
      /* CUSTOM_SHIPTOPENCIL_BY_CLAUDE (Ryan 2026-10-02, RW-1339-A) — the pencil edits the tab that is
         OPEN. It always opened Sold To, so Ryan, on the Ship To tab of a sold deal, re-addressed the
         customer instead of the second shipment. Bill To has no editor yet; it falls to Sold To. */
      var _card = btn.closest('.rqd-detail__card');
      var _active = _card ? _card.querySelector('.rqd-info-tab--active') : null;
      var _pane = _active ? _active.getAttribute('data-info-pane') : 'sold';
      if (_pane === 'ship' && typeof window.__openEditShipTo === 'function') { window.__openEditShipTo(q); return; }
      if (typeof window.__openEditCustomer === 'function') window.__openEditCustomer(q);
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-23) — online-order ship-to pencil.
       Same standalone delegation as the offline pencil above (the cog-menu click
       block doesn't see customer-card clicks). Stops propagation so it doesn't
       toggle the row, then routes by the open tab via handleOnlineShipPencil. */
    tbody.addEventListener('click', function(e) {
      var btn = e.target.closest('.rqd-edit-online-ship-pencil');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      handleOnlineShipPencil(btn);
    });
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — Financials-card pencil →
       edit deal terms (QW Terms & Options) without opening the Workstation. */
    tbody.addEventListener('click', function(e) {
      var btn = e.target.closest('.rqd-edit-terms-pencil');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var ref = btn.getAttribute('data-edit-terms-ref');
      if (!ref || !Array.isArray(allQuotes)) return;
      var q = allQuotes.find(function(x) { return x.reference === ref; });
      if (!q) return;
      if (typeof window.__openEditTerms === 'function') window.__openEditTerms(q);
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Red × button on Shipping tracking row — clears the shipment + unchecks
    // the vendor box. Wired before the change/input listeners so the click
    // doesn't get re-interpreted as a field edit.
    tbody.addEventListener('click', function(e) {
      var btn = e.target.closest('.rqd-vendor-tracking__remove');
      if (!btn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      handleVendorShipmentClear(btn);
    });

    /* CUSTOM_MULTISHIP_BY_CLAUDE (AIOPS `17a342129a10`, SHOP-1999) — "+ Add shipment" under an online vendor row:
       a LATER shipment from the same vendor, beside the first (never by clearing it). */
    tbody.addEventListener('click', function(e) {
      var sb = e.target.closest('[data-ship-action]');
      if (!sb || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      handleLaterShipmentAction(sb);
    });
    // "Send to Customer" button on online-order Shipping rows. Calls
    // /shopify-fulfillment-create which (a) creates a real Shopify
    // fulfillment, (b) emails the customer Shopify's shipped notification,
    // (c) logs tracking on the order's customer-facing page.
    tbody.addEventListener('click', function(e) {
      var syncBtn = e.target.closest('.rqd-vendor-tracking__sync');
      if (!syncBtn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      handleShopifyFulfillmentSync(syncBtn);
    });

    /* ============================================================================
       CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-31) — Delay / Backorder / DISCONTINUED
       card: the mode switch, the per-item replacement picker, and the outcome line.
       ============================================================================ */

    /* The picks live in the DOM as chips rather than in a JS store, for the same reason
       the ETA does: buildDetailHtml re-renders this panel on a great many unrelated
       events, and a store keyed by ref would survive that render while the inputs
       beside it reset, leaving the card showing one thing and sending another. */
    function _dnSubsOf(line) {
      return Array.prototype.slice.call(line.querySelectorAll('.rqd-delay-notice__chip'))
        .map(function (c) { return { t: c.dataset.t || '', u: c.dataset.u || '', vt: c.dataset.vt || '' }; })
        .filter(function (s) { return s.t && s.u; });
    }

    /* Show/hide the ETA vs. the replacement pickers, and say in words which of the four
       discontinued emails is about to go out.

       ⛔ THE BRANCH CONDITIONS ARE MIRRORED IN THE WORKER (discontinuedOutcomeLabel in
       quote-routes.js), on purpose and not by accident. The worker's copy is what gets
       written into the Deal Feed as the record of a refund we promised, so it cannot be
       a string this browser handed it. Change the matrix and you change BOTH. */
    function _dnSync(card) {
      if (!card) return;
      var disc = card.dataset.mode === 'discontinued';
      var etaEl = card.querySelector('.rqd-delay-notice__eta');
      if (etaEl) etaEl.hidden = disc;
      var lines = Array.prototype.slice.call(card.querySelectorAll('.rqd-delay-notice__line'));
      var checked = 0, subCount = 0;
      lines.forEach(function (ln) {
        var cb = ln.querySelector('.rqd-delay-notice__cb');
        var on = !!(cb && cb.checked);
        if (on) checked++;
        var subs = ln.querySelector('.rqd-delay-notice__subs');
        if (subs) subs.hidden = !(disc && on);
        if (disc && on) subCount += _dnSubsOf(ln).length;
      });
      var out = card.querySelector('.rqd-delay-notice__outcome');
      if (!out) return;
      out.hidden = !disc;
      if (!disc) return;
      if (!checked) { out.textContent = 'Select the discontinued item(s).'; return; }
      var whole = checked >= lines.length;
      if (whole && !subCount) {
        out.textContent = 'Whole order. The email will say we’re cancelling the order and refunding in full, back on their card within 2-3 business days.';
      } else if (whole) {
        out.textContent = 'Whole order. The email will offer the replacement(s). If they pass, we cancel the order and refund in full.';
      } else if (!subCount) {
        out.textContent = 'Part of the order. The email will ask whether to ship the rest and refund the discontinued part, or cancel the whole order.';
      } else {
        out.textContent = 'Part of the order. The email will offer the replacement(s). If they pass, it asks whether to ship the rest or cancel the whole order.';
      }
    }

    /* Replacement search runs against the composer's product mention index, NOT
       /product-search. The index is published-products-only, already cached for the
       page, and carries the storefront URL — so every suggestion the rep can pick is
       one a customer can actually open. /product-search would happily offer an
       unpublished variant and there would be no link to give it. */
    function _dnSearchReplacements(input) {
      var box = input.parentNode ? input.parentNode.querySelector('.rqd-delay-notice__subhits') : null;
      if (!box) return;
      var term = String(input.value || '').trim().toLowerCase();
      if (term.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
      var loader = (window.RQD && window.RQD.loadMentionIndex) ? window.RQD.loadMentionIndex() : Promise.resolve([]);
      loader.then(function (index) {
        // The rep kept typing while the first fetch was in flight: that keystroke owns the box now.
        if (String(input.value || '').trim().toLowerCase() !== term) return;
        var words = term.split(/\s+/).filter(Boolean);
        /* Every word must appear in the product's OWN title or vendor, plus a SKU rung.
           The index carries no description, so word matching here is already precise
           (the noise Adjust Order's search had to filter out came from Shopify reading
           descriptions) — but a rep who knows the model number types the model number,
           and that never appears in the title. */
        var hits = (index || []).filter(function (p) {
          var hay = (String(p.t || '') + ' ' + String(p.v || '')).toLowerCase();
          for (var i = 0; i < words.length; i++) if (hay.indexOf(words[i]) === -1) {
            return Array.isArray(p.s) && p.s.some(function (s) { return String(s || '').toLowerCase().indexOf(term) !== -1; });
          }
          return true;
        }).slice(0, 8);
        box.hidden = false;
        if (!hits.length) { box.innerHTML = '<div class="rqd-delay-notice__nohit">No published product matches.</div>'; return; }
        box.innerHTML = hits.map(function (p) {
          /* `vc` is the variant count. ⚠️ A MISSING vc means "this catalog entry predates the
             field", not "one variant" — read as 1 it would silently stop offering colours for
             every product cached before the next rebuild. Absent is unknown, and unknown asks. */
          var _vc = (p.vc === undefined || p.vc === null) ? '' : String(p.vc);
          return '<button type="button" class="rqd-delay-notice__hit" data-t="' + esc(p.t || '') + '" data-u="' + esc(p.u || '') + '"'
            + ' data-h="' + esc(p.h || '') + '" data-vc="' + esc(_vc) + '">'
            + esc(p.t || '')
            + (p.v ? '<span class="rqd-delay-notice__hitv"> &middot; ' + esc(p.v) + '</span>' : '')
            + (_vc && Number(_vc) > 1 ? '<span class="rqd-delay-notice__hitv"> &middot; ' + esc(_vc) + ' options</span>' : '')
            + '</button>';
        }).join('');
      });
    }

    /* Add a picked replacement as a chip. `vt` is the variant, kept in its own attribute so the
       worker can append it AFTER the house rule strips a title's " - " tail — pre-composed as
       "Mat (Black)" the strip would eat the colour, which on this email is the entire point. */
    function _dnAddChip(line, title, url, vt) {
      var chips = line.querySelector('.rqd-delay-notice__chips');
      if (!chips || !url) return;
      var existing = Array.prototype.slice.call(chips.querySelectorAll('.rqd-delay-notice__chip'));
      if (existing.length >= 3) { rqdAlert('Three replacement suggestions is the most one item should carry.'); return; }
      if (existing.some(function (c) { return c.dataset.u === url; })) return;
      /* Chip shows the FULL catalog title plus the variant, because "- Gray" is often the only
         thing telling two rows apart and the colour is what the rep is choosing between. The
         email shortens the title at the house rule's usual place; the href is exact either way. */
      var shown = title + (vt ? ' (' + vt + ')' : '');
      chips.insertAdjacentHTML('beforeend',
        '<span class="rqd-delay-notice__chip" data-t="' + esc(title) + '" data-u="' + esc(url) + '" data-vt="' + esc(vt || '') + '">'
        + esc(shown)
        + '<button type="button" class="rqd-delay-notice__chiprm" title="Remove" aria-label="Remove">&times;</button></span>');
      _dnSync(line.closest('.rqd-delay-notice'));
    }

    /* Second step of the picker: which variant? Fetched on demand for the ONE product the rep
       chose, rather than shipping every product's variants in the mention index that every
       composer downloads.

       ⛔ ONLY WHAT A CUSTOMER CAN BUY. `available === false` variants are filtered out, and on
       this card that is not a nicety: the variant being replaced is usually a variant of this
       very product, and offering the discontinued colour back as its own replacement is the one
       wrong answer the list could give.

       ⚠️ A failed lookup falls back to the PRODUCT-level chip rather than losing the pick. The
       rep chose a replacement; a flaky round trip should cost them the variant, not the choice. */
    function _dnLoadVariants(hit, line) {
      var box = line.querySelector('.rqd-delay-notice__subhits');
      var handle = hit.dataset.h || '';
      var baseT = hit.dataset.t || '';
      var baseU = hit.dataset.u || '';
      function _fallback() {
        if (box) { box.hidden = true; box.innerHTML = ''; }
        var inp = line.querySelector('.rqd-delay-notice__subq');
        if (inp) inp.value = '';
        _dnAddChip(line, baseT, baseU, '');
      }
      if (!box || !handle || !baseU) { _fallback(); return; }
      box.hidden = false;
      box.innerHTML = '<div class="rqd-delay-notice__nohit">Loading options…</div>';
      API.get('/product-by-handle?handle=' + encodeURIComponent(handle)).then(function (d) {
        var p = (d && d.product) || null;
        var vs = (p && Array.isArray(p.variants)) ? p.variants : [];
        var avail = vs.filter(function (v) {
          return v && v.available !== false && String(v.title || '') && String(v.title) !== 'Default Title';
        });
        if (!avail.length) { _fallback(); return; }
        box.innerHTML = '<div class="rqd-delay-notice__nohit">Which one?</div>'
          + avail.map(function (v) {
              // GID -> the numeric id Shopify's ?variant= deep link expects.
              var vid = String(v.id || '').split('/').pop();
              var u = /^[0-9]+$/.test(vid) ? (baseU.replace(/\/$/, '') + '?variant=' + vid) : baseU;
              return '<button type="button" class="rqd-delay-notice__hit" data-final="1"'
                + ' data-t="' + esc(baseT) + '" data-vt="' + esc(v.title || '') + '" data-u="' + esc(u) + '">'
                + esc(v.title || '')
                + (v.sku ? '<span class="rqd-delay-notice__hitv"> &middot; ' + esc(v.sku) + '</span>' : '')
                + '</button>';
            }).join('');
      }).catch(function () { _fallback(); });
    }

    // Mode switch + item checkboxes both change what the card is asking for.
    tbody.addEventListener('change', function (e) {
      var el = e.target;
      if (!isAdmin || !el) return;
      var card = el.closest ? el.closest('.rqd-delay-notice') : null;
      if (!card) return;
      if (el.classList.contains('rqd-delay-notice__moderadio')) {
        card.dataset.mode = el.value === 'discontinued' ? 'discontinued' : 'delay';
        _dnSync(card);
      } else if (el.classList.contains('rqd-delay-notice__cb')) {
        _dnSync(card);
      }
    });

    tbody.addEventListener('input', function (e) {
      if (!isAdmin || !e.target || !e.target.classList) return;
      if (!e.target.classList.contains('rqd-delay-notice__subq')) return;
      _dnSearchReplacements(e.target);
    });

    // Pick a replacement, or drop one already picked.
    tbody.addEventListener('click', function (e) {
      if (!isAdmin || !e.target || !e.target.closest) return;
      /* Close any hit list the rep clicked away from. Runs BEFORE the pick below and
         deliberately skips the list that owns this click, so selecting a row still
         works. `click` and not `focusout`: focusout fires before the button's click
         lands, so hiding there would swallow the pick. */
      Array.prototype.forEach.call(document.querySelectorAll('.rqd-delay-notice__subhits:not([hidden])'), function (box) {
        if (box.contains(e.target)) return;
        var wrap = box.parentNode;
        if (wrap && wrap.contains(e.target)) return;   // the input that owns it
        box.hidden = true;
        box.innerHTML = '';
      });
      var rm = e.target.closest('.rqd-delay-notice__chiprm');
      if (rm) {
        e.preventDefault();
        e.stopPropagation();
        var chip = rm.closest('.rqd-delay-notice__chip');
        var cardR = rm.closest('.rqd-delay-notice');
        if (chip && chip.parentNode) chip.parentNode.removeChild(chip);
        _dnSync(cardR);
        return;
      }
      var hit = e.target.closest('.rqd-delay-notice__hit');
      if (!hit) return;
      e.preventDefault();
      e.stopPropagation();
      var line = hit.closest('.rqd-delay-notice__line');
      if (!line) return;
      /* ⛔ A PRODUCT IS NOT ALWAYS THE ANSWER. Ryan's first real case: the vendor discontinued
         the Perform Better hanging mat in BLUE and still makes it in black, so the replacement
         is the same product, a different variant. Picking the product alone would link the
         customer to a page defaulted to whichever variant Shopify lists first, which may well
         be the one that no longer exists. So a multi-variant hit drills in before it becomes a
         chip; a single-variant one is already unambiguous and skips the step. */
      var _vcRaw = hit.dataset.vc;
      var _vc = (_vcRaw === '' || _vcRaw === undefined) ? null : parseInt(_vcRaw, 10);
      if (hit.dataset.final !== '1' && _vc !== 1 && (hit.dataset.h || '')) {
        _dnLoadVariants(hit, line);
        return;
      }
      var box0 = line.querySelector('.rqd-delay-notice__subhits');
      if (box0) { box0.hidden = true; box0.innerHTML = ''; }
      var input0 = line.querySelector('.rqd-delay-notice__subq');
      if (input0) input0.value = '';
      _dnAddChip(line, hit.dataset.t || '', hit.dataset.u || '', hit.dataset.vt || '');
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-13) — "Build & Review Email" on
       the Delay/Backorder Notice card (online orders). Gathers the checked
       item(s) + ETA, then opens the shared compose modal (Abby/orders@).
       (Ryan 2026-08-31) — in DISCONTINUED mode it gathers the replacement picks and
       the lines that still ship instead of an ETA, and resolves a storefront URL for
       each line first. */
    tbody.addEventListener('click', function(e) {
      var dBtn = e.target.closest('.rqd-delay-notify');
      if (!dBtn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      var ref = dBtn.dataset.ref;
      var q = allQuotes.find(function(x){ return x.reference === ref; });
      if (!q) return;
      var card = dBtn.closest('.rqd-delay-notice');
      if (!card) return;
      var isDisc = card.dataset.mode === 'discontinued';
      var lines = Array.prototype.slice.call(card.querySelectorAll('.rqd-delay-notice__line'));
      var checkedBoxes = Array.prototype.slice.call(card.querySelectorAll('.rqd-delay-notice__cb:checked'));
      var selected = checkedBoxes.map(function(cb){ return cb.value; });
      var brands = checkedBoxes.map(function(cb){ return cb.dataset.brand || ''; }).filter(Boolean);
      var qtys = checkedBoxes.map(function(cb){ return parseInt(cb.dataset.qty, 10) || 1; });
      var eta = String((card.querySelector('.rqd-delay-notice__eta') || {}).value || '').trim();
      if (!selected.length) { rqdAlert(isDisc ? 'Select at least one discontinued item.' : 'Select at least one delayed / backordered item.'); return; }
      if (!isDisc && !eta) { rqdAlert('Enter an estimated ship time (a date, or "week of …").'); return; }
      if (!q.customerEmail) { rqdAlert('No customer email on file for this order.'); return; }
      /* ⛔ COUNTED OFF THE RENDERED LINES, which is what the rep ticked against. This
         number is the whole-order test on the worker: get it from a different list than
         the checkboxes came from and a 1-of-3 selection can read as a full cancellation. */
      var orderItemCount = lines.length;
      if (!isDisc) {
        openDelayNoticeModal({ ref: ref, customerEmail: q.customerEmail, customerName: q.customer || '', items: selected, brands: brands, qtys: qtys, eta: eta, orderItemCount: orderItemCount });
        return;
      }
      var loader = (window.RQD && window.RQD.loadMentionIndex) ? window.RQD.loadMentionIndex() : Promise.resolve([]);
      loader.then(function (index) {
        /* Handle → SKU → exact title, the same ladder the quote PDF and the email
           templates use (RQDTpl.linkForLine). A discontinued product usually resolves
           to nothing by now, and empty is the right answer: the name renders unlinked
           rather than pointing a customer at a 404. */
        function _url(cb) {
          if (!(window.RQDTpl && window.RQDTpl.linkForLine)) return '';
          return window.RQDTpl.linkForLine({ handle: cb.dataset.handle || '', sku: cb.dataset.sku || '', title: cb.value || '' }, index || []) || '';
        }
        var urls = [], subs = [], keepItems = [], variantTitles = [];
        lines.forEach(function (ln) {
          var cb = ln.querySelector('.rqd-delay-notice__cb');
          if (!cb) return;
          var vt = cb.dataset.variant || '';
          if (cb.checked) { urls.push(_url(cb)); subs.push(_dnSubsOf(ln)); variantTitles.push(vt); }
          else keepItems.push({ t: cb.value || '', u: _url(cb), vt: vt });
        });
        openDelayNoticeModal({
          ref: ref, customerEmail: q.customerEmail, customerName: q.customer || '',
          customerPhone: q.customerPhone || '', // CUSTOM_DISCDRIP_BY_CLAUDE — for Abby's call reminder to Ryan
          items: selected, brands: brands, qtys: qtys, eta: '', orderItemCount: orderItemCount,
          noticeType: 'discontinued', urls: urls, subs: subs, keepItems: keepItems,
          variantTitles: variantTitles,
        });
      });
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — "Notify Customer" button on PURE OFFLINE
       Shipping rows. No Shopify order to fulfill, so this opens the notify
       pop-up which fires Abby's customer shipping email (CCs the rep) via
       /notify-customer-shipping. Tracking is read from the already-saved
       q.ordering[vendor]; items from the lazy-loaded offline order contents. */
    /* ⚠️ async (Phase 2): the no-tracking confirm below is a Promise now. preventDefault and
       stopPropagation both run BEFORE the first await, and the awaited branch returns. */
    tbody.addEventListener('click', async function(e) {
      var nBtn = e.target.closest('.rqd-vendor-notify');
      if (!nBtn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      if (nBtn.disabled) return;
      var ref = nBtn.dataset.ref;
      var vendor = nBtn.dataset.vendor;
      var isResend = nBtn.dataset.resend === '1';
      var q = allQuotes.find(function(x){ return x.reference === ref; });
      if (!q) return;
      var ord = (q.ordering && q.ordering[vendor]) || {};
      var item = nBtn.closest('.rqd-vendor-item');
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — the notify button is
         always rendered now (like online's Mark-as-Fulfilled), so guard the
         click: require tracking to be entered first. Checks the saved ordering
         AND the live input (covers a number typed but not yet auto-saved). */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-30) - read the SHIPPING tracking row
         explicitly. The Installation Quote card reuses .rqd-vendor-tracking__input for its date
         field (buildDetailHtml), so an unqualified lookup inside the vendor item could pick that
         one up; :not(.rqd-install-form) is how doTrackingSave's callers already tell them apart. */
      var _trkRow = item ? item.querySelector('.rqd-vendor-tracking:not(.rqd-install-form)') : null;
      function _liveVal(sel) {
        var el = _trkRow ? _trkRow.querySelector(sel) : null;
        return (el && !el.disabled && el.offsetParent !== null) ? (el.value || '').trim() : '';
      }
      var _liveTrk = _trkRow ? ((_trkRow.querySelector('.rqd-vendor-tracking__input') || {}).value || '') : '';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — combined "Mark Fulfilled"
         button. No tracking entered → mark the vendor fulfilled WITHOUT tracking
         + no email (customer pickup / unavailable): confirm, POST, re-render.
         Tracking present → fall through to the normal notify-customer modal. */
      if (!(ord.tracking || ord.trackingNumber || _liveTrk.trim())) {
        if (!(await rqdConfirm('Use this for shipments the customer picked up or where tracking is unavailable. No email is sent to the customer. You can Undo this afterward.', { title: 'Mark "' + vendor + '" fulfilled without a tracking number?', confirmLabel: 'Mark fulfilled' }))) return;
        nBtn.disabled = true;
        nBtn.textContent = 'Saving…';
        /* Posts to /notify-customer-shipping (noTracking mode) — the worker sets
           the shippedNoTracking marker AND, if this offline deal was paid via
           the Shopify link, silently marks the linked Shopify order fulfilled
           (no Shopify email). orderName = the linked Shopify order (if any). */
        API.post('/notify-customer-shipping', { ref: ref, vendor: vendor, noTracking: true, orderName: q.linkedOnlineOrderName || '' }).then(function () {
          if (!q.ordering) q.ordering = {};
          var _ex = q.ordering[vendor] || {};
          q.ordering[vendor] = Object.assign({}, _ex, {
            ordered: true,
            date: _ex.date || todayStr(),
            shipped: true,
            shippedNoTracking: true,
            shipDate: _ex.shipDate || todayStr(),
          });
          var detailEl = document.getElementById('rqd-detail-' + ref);
          if (detailEl) detailEl.innerHTML = buildDetailHtml(q);
          refreshProgressBar(ref);
        }).catch(function (err) {
          nBtn.disabled = false;
          nBtn.textContent = 'Mark Fulfilled';
          rqdAlert('Could not mark fulfilled: ' + (err && err.message ? err.message : 'unknown error'));
        });
        return;
      }
      var rawItems = (Array.isArray(q.offlineLineItems) && q.offlineLineItems.length > 0)
        ? q.offlineLineItems
        : ((window.__orderContentsCache && window.__orderContentsCache[ref]) || []);
      var items = rawItems.map(function(li){
        return {
          title: li.title || '',
          qty: parseInt(li.quantity, 10) || parseInt(li.qty, 10) || 0,
          sku: li.sku || '',
          handle: li.handle || '',
        };
      }).filter(function(it){ return it.title; });
      var status = item ? item.querySelector('.rqd-vendor-tracking__status') : null;
      if (window.DashboardHandshake && window.DashboardHandshake.openNotifyCustomerModal) {
        window.DashboardHandshake.openNotifyCustomerModal({
          ref: ref,
          vendor: vendor,
          orderName: ref,
          // Linked Shopify order (set when this offline deal was paid via the
          // Shopify hosted link). The modal forwards it to /notify-customer-
          // shipping as orderName so the worker silently marks that real order
          // fulfilled (no Shopify email) alongside Abby's email.
          shopifyOrderName: q.linkedOnlineOrderName || '',
          /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-30) - THE COMPOSER OPENED BEFORE THE
             ROW HAD SAVED, AND THE PREVIEW CAME BACK "No tracking number on this vendor yet".

             The row auto-saves on a 400ms focusout debounce (scheduleTrackingSave). Clicking
             Notify Customer IS that focusout, so this handler runs while the save is still
             pending and `ord` is one edit stale - reliably so, if the rep typed the tracking
             number last, which is the normal order. The guard above already reads the live
             input to decide the button even opens the composer; the ctx it builds now agrees
             with it, and the worker takes these values over its KV copy. */
          trackingNumber: _liveVal('.rqd-vendor-tracking__input') || ord.tracking || ord.trackingNumber || '',
          carrier: _liveVal('.rqd-vendor-tracking__carrier') || _liveVal('.rqd-vendor-tracking__carrier-other') || ord.carrier || '',
          trackingUrl: _liveVal('.rqd-vendor-tracking__url') || ord.trackingUrl || '',
          trackingType: (function () {
            // Mirrors doTrackingSave: "Other" means the free-text box holds the real label.
            var t = _liveVal('.rqd-vendor-tracking__type');
            if (t === 'Other') return _liveVal('.rqd-vendor-tracking__type-other') || 'Other';
            return t || ord.trackingType || '';
          })(),
          items: items,
          alreadyNotified: isResend,
          btn: nBtn,
          status: status,
        });
      }
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — Undo the no-tracking
       fulfillment: clear the marker so the row re-opens for tracking entry.
       Leaves `ordered` as-is (only the shipping marker is reverted). */
    tbody.addEventListener('click', function (e) {
      var unBtn = e.target.closest('.rqd-vendor-notrack-undo');
      if (!unBtn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      if (unBtn.disabled) return;
      var ref = unBtn.dataset.ref;
      var vendor = unBtn.dataset.vendor;
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) return;
      var ordering = Object.assign({}, q.ordering || {});
      var existing = Object.assign({}, ordering[vendor] || {});
      delete existing.shippedNoTracking;
      existing.shipped = false;
      ordering[vendor] = existing;
      unBtn.disabled = true;
      unBtn.textContent = '…';
      API.post('/quote-lifecycle', { ref: ref, ordering: ordering }).then(function () {
        q.ordering = ordering;
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl) detailEl.innerHTML = buildDetailHtml(q);
        refreshProgressBar(ref);
      }).catch(function (err) {
        unBtn.disabled = false;
        unBtn.textContent = 'Undo';
        rqdAlert('Could not undo: ' + (err && err.message ? err.message : 'unknown error'));
      });
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — Undo a Mark-as-Fulfilled (online orders).
       Cancels the Shopify fulfillment + clears the portal's persisted shipping state via
       /shopify-fulfillment-cancel, then optimistically reverts local state so the row re-opens
       for tracking entry. Works for both bucket-mode (data-bucket) and vendor-mode rows. The
       customer is NOT notified of the cancellation. */
    /* ⚠️ async (Phase 2): the undo confirm below is a Promise now. preventDefault and
       stopPropagation both run BEFORE the first await, and the awaited branch returns. */
    tbody.addEventListener('click', async function (e) {
      var ufBtn = e.target.closest('.rqd-vendor-undo-fulfill');
      if (!ufBtn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      if (ufBtn.disabled) return;
      var ref = ufBtn.dataset.ref;
      var vendor = ufBtn.dataset.vendor || '';
      var bucketId = ufBtn.dataset.bucket || '';
      var orderName = ufBtn.dataset.orderName || ref;
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) return;
      if (!(await rqdConfirm('This cancels the fulfillment in Shopify (the tracking is removed from the customer\'s order) and re-opens the tracking fields so you can redo it. The customer is NOT notified of the cancellation.', { title: 'Undo this fulfillment?', confirmLabel: 'Undo the fulfillment', cancelLabel: 'Leave it fulfilled', danger: true }))) return;
      ufBtn.disabled = true;
      ufBtn.textContent = '…';
      var payload = { ref: ref, orderName: orderName, vendor: vendor };
      if (bucketId) payload.bucketId = bucketId;
      /* CUSTOM_TRACKINGCLEAR_BY_CLAUDE (AIOPS `5982e62242c1`, Ryan 2026-09-22) — a VENDOR row's Undo
         goes through POST /deal-tracking-clear, which cancels the fulfillment AND clears the number
         off the record, so "re-open the tracking fields so you can redo it" is true of the record
         and not only of the inputs (the old route left the number in place, and the next stamp of
         a different number answered 409). A BUCKET row keeps /shopify-fulfillment-cancel: buckets
         hold their shipping under `shippingBuckets[id].shipping`, which that route clears. */
      var _undoCall = bucketId
        ? API.post('/shopify-fulfillment-cancel', payload)
        : API.post('/deal-tracking-clear', { ref: ref, vendor: vendor, reason: 'undo on the Deal Dashboard' });
      _undoCall.then(function () {
        // Optimistic local revert so the row updates without waiting for a re-fetch.
        if (bucketId && Array.isArray(q.shippingBuckets)) {
          for (var i = 0; i < q.shippingBuckets.length; i++) {
            if (q.shippingBuckets[i] && q.shippingBuckets[i].id === bucketId) { q.shippingBuckets[i].shipping = null; break; }
          }
        } else if (vendor && q.ordering && q.ordering[vendor]) {
          q.ordering[vendor].shipped = false;
          delete q.ordering[vendor].shopifyFulfillmentId;
          delete q.ordering[vendor].shipDate;
          /* CUSTOM_TRACKINGCLEAR_BY_CLAUDE — the clear route also dropped the number; mirror it locally. */
          ['carrier', 'tracking', 'trackingNumbers', 'trackingType', 'trackingUrl', 'shippedNoTracking'].forEach(function (k) { delete q.ordering[vendor][k]; });
        }
        q.onlineHasTracking = false;
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl) detailEl.innerHTML = buildDetailHtml(q);
        refreshProgressBar(ref);
      }).catch(function (err) {
        ufBtn.disabled = false;
        ufBtn.textContent = 'Undo';
        rqdAlert('Could not undo the fulfillment: ' + (err && err.message ? err.message : 'unknown error'));
      });
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — Commission card date-popover
       triggers: "-- Select --" (unpaid) and "Edit" (paid) open the date popup to
       log / change the commission payment date in one Save. */
    tbody.addEventListener('click', function (e) {
      var cpBtn = e.target.closest('.rqd-commission-select, .rqd-commission-edit');
      if (!cpBtn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      if (cpBtn.disabled) return;
      var ref = cpBtn.dataset.ref;
      var field = cpBtn.dataset.field;
      var dateField = cpBtn.dataset.dateField;
      var label = cpBtn.dataset.label || 'Commission';
      var isEdit = cpBtn.classList.contains('rqd-commission-edit');
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      var existingIso = (q && q[dateField]) ? new Date(q[dateField]).toISOString().slice(0, 10) : '';
      openCommissionPaidPopover(cpBtn, ref, field, dateField, label, isEdit, existingIso);
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-19) — THE SAMPLES LADDER'S OFF SWITCH,
       on the deal it belongs to.
       ─────────────────────────────────────────────────────────────────────────────
       Once a sample box is scanned delivered, this deal mails the customer by itself at
       08:05 MT, four times over three weeks. Ryan: *"an unattended customer email needs an
       off switch before the crons go on. Put it in the portal, not a curl."*

       ⛔ STOPPING IS NOT DELETING THE QUEUED JOB. The delivery sweep re-arms on its next
       scan and the backfill re-arms on demand, so a deletion comes back on its own. The
       worker writes a record every arming path is refused by; Resume lifts it and queues
       NOTHING, so lifting a stop can never itself be the thing that mails somebody.

       ⚠️ Hydrated by a MutationObserver rather than from each render site: the detail card
       is rebuilt from at least four places in this file and one in dashboard-order-cards,
       and a status line wired to only some of them is worse than none — it would read
       "stopped" on a deal that is live. The button works with no status at all. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — Abby's automatic "your samples are on the
       way" notice, painted off the same status response as the ladder below it.

       ⛔ "QUEUED" AND "WILL SEND" ARE DIFFERENT FACTS, and the row must say the second one. A job
       can sit in the queue while the global switch is off, and the drain will refuse it — so a
       row that reported the job alone would promise a send that never comes. That is the exact
       defect PM²⁷ fixed on the ladder row a day earlier; `sends` is the worker's own answer, not
       a re-derivation here.

       ⚠️ (Until 2026-09-06) Stop stayed live with nothing queued, deliberately — same rule as the
       ladder: stopping a deal with no job refuses the arm the NEXT tracking write would make.
       ⛔ REVERSED BY RYAN: *"there's a 'Stop' button which is visible even if none are queued yet
       -- the button can be removed if none are queued."* Stop now shows only while a notice job
       exists (queued, or queued-but-switched-off); the markup renders it hidden so it does not
       flash before the status lands. The pre-emptive tombstone is still reachable from the
       ladder row, which keeps its Stop. */
    function _noticePaint(box, data) {
      if (!box || !box.classList.contains('rqd-sample-ladder--notice')) return;
      var stateEl = box.querySelector('.rqd-sample-ladder__state');
      var stopBtn = box.querySelector('.rqd-sample-notice__stop');
      var resumeBtn = box.querySelector('.rqd-sample-notice__resume');
      if (!stateEl) return;
      var n = (data && data.autoNotify) || {};
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — ⛔ THIS ROW READS `noticeAudience`, NOT
         `audience`. The gate split into two channels: `audience` is the rep-mailbox one (the
         follow-up ladder below, still admin-only) and `noticeAudience` is Abby's "on the way"
         notice, which now runs for everyone. They were one field until today, and leaving this
         row on the old one would print "Not automated for JW" over a notice that had already
         gone out — the row would be reporting the LADDER's refusal to answer a question about
         itself. ⚠️ No `|| data.audience` fallback: a stale worker that returns only the old
         field must make this row fall through to the real state below, never inherit a verdict
         that belongs to the other sender. */
      var aud = (data && data.noticeAudience) || null;
      box.classList.remove('rqd-sample-ladder--queued', 'rqd-sample-ladder--closed');
      box.classList.toggle('rqd-sample-ladder--stopped', !!n.stopped);

      /* ⛔ AND WHEN IT IS REFUSED, THE ROW STILL HAS TO SAY SO. Since the split this is the
         narrow case rather than the common one — the notice is open, so it only lands when
         somebody has narrowed the notice channel from the portal, or when the deal resolves to
         nobody who could be Cc'd. ⚠️ Checked before the switch and the job, because it is the
         reason that outranks both — and the sentence is the WORKER'S, so it cannot drift from
         the rule that actually refuses the send. */
      if (aud && aud.allowed === false) {
        box.classList.add('rqd-sample-ladder--closed');
        stateEl.textContent = 'Not automated for ' + (aud.ownerCode || 'this rep');
        stateEl.title = aud.why || 'Automatic customer emails are limited to admin-owned deals for now.';
        if (stopBtn) stopBtn.hidden = true;
        if (resumeBtn) resumeBtn.hidden = true;
        return;
      }

      if (n.stopped) {
        stateEl.textContent = 'Stopped'
          + (n.stopped.by ? ' by ' + n.stopped.by : '')
          + (n.stopped.at ? ' ' + (formatDate(n.stopped.at) || '') : '');
        stateEl.title = n.stopped.cancelledJob
          ? 'Cancelled the notice queued for ' + n.stopped.cancelledJob.sendAfter
          : 'Nothing was queued at the time; future arms are refused.';
        if (stopBtn) stopBtn.hidden = true;
        if (resumeBtn) resumeBtn.hidden = false;
        return;
      }
      if (resumeBtn) resumeBtn.hidden = true;
      /* Stop only when there is something to stop (Ryan 2026-09-06). */
      if (stopBtn) stopBtn.hidden = !n.job;

      if (!n.enabled) {
        /* ⚠️ OFF GLOBALLY IS NOT OFF HERE. Saying "Off" alone would read as a per-deal setting
           somebody could fix on this card; it is a switch elsewhere, and the row says which. */
        box.classList.add('rqd-sample-ladder--closed');
        stateEl.textContent = n.job ? 'Queued — automatic notices are switched off' : 'Automatic notices are switched off';
        stateEl.title = 'Nothing sends while the global switch is off. An admin turns it on in the samples ops page; anything queued resumes rather than being discarded.';
        return;
      }
      /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: the buyer's notice waits until
         both boxes have a number. The drain stamps `waitingFor:'pair'` on the job while it waits. */
      if (n.job && n.job.waitingFor === 'pair') {
        box.classList.add('rqd-sample-ladder--queued');
        stateEl.textContent = 'Waiting for the second recipient\'s tracking';
        stateEl.title = 'Abby emails the buyer once both boxes have a tracking number. If the second one has not landed 24 hours after the first, Ryan is emailed to chase it. Stop cancels the notice.';
        return;
      }
      if (n.job && n.sends) {
        var when = n.job.sendAfter ? (formatDate(n.job.sendAfter) || n.job.sendAfter) : '';
        box.classList.add('rqd-sample-ladder--queued');
        stateEl.textContent = 'Abby emails the customer' + (when ? ' ' + when : '') + (n.job.overdue ? ' (due now)' : '');
        stateEl.title = 'Armed ' + (n.job.armedAt || '?') + '. Sends inside the 6am–6pm MT window; Stop cancels it.';
        return;
      }
      /* ⚠️ "Not queued" is NOT "off" — the next tracking write arms one. Which is why Stop is
         available here, and why leaving off the "yet" would read as an off switch already thrown. */
      stateEl.textContent = 'None queued yet';
      stateEl.title = 'The next tracking number saved on this deal arms one, unless this is stopped.';
    }

    function _ladderPaint(box, data) {
      /* The notice row is rendered immediately above this one and shares the fetch. */
      _noticePaint(box.previousElementSibling, data);
      var stateEl = box.querySelector('.rqd-sample-ladder__state');
      var stopBtn = box.querySelector('.rqd-sample-ladder__stop');
      var resumeBtn = box.querySelector('.rqd-sample-ladder__resume');
      if (!stateEl) return;
      var stopped = data && data.stopped;
      var job = data && data.queuedJob;
      box.classList.toggle('rqd-sample-ladder--stopped', !!stopped);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — presentational only, no behaviour.
         "Samples 2 of 4 — sends Aug 27" and "None queued yet" are both data-state="ready"
         and not stopped, so CSS had no way to tell an armed email from an empty queue and
         rendered both in the same grey italic. These classes are the only signal it needs.
         ⚠️ CLEARED FIRST, then re-added by whichever branch below applies. This function
         repaints an element that is already on screen (Stop/Resume both re-hydrate it), so a
         class left over from the previous verdict would stack on top of the new one — a deal
         that goes from queued to closed would carry both and the later rule would silently
         decide the colour. */
      box.classList.remove('rqd-sample-ladder--queued', 'rqd-sample-ladder--closed');
      if (stopped) {
        stateEl.textContent = 'Stopped'
          + (stopped.by ? ' by ' + stopped.by : '')
          + (stopped.at ? ' ' + (formatDate(stopped.at) || '') : '');
        stateEl.title = stopped.cancelledJob
          ? 'Cancelled ' + stopped.cancelledJob.id + ', which was due ' + stopped.cancelledJob.sendAfter
          : 'Nothing was queued at the time; future arms are refused.';
        if (stopBtn) stopBtn.hidden = true;
        if (resumeBtn) resumeBtn.hidden = false;
      } else if (job) {
        var due = job.sendAfter ? (formatDate(job.sendAfter) || job.sendAfter) : '';
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — ⛔ A QUEUED JOB IS NOT A PROMISE TO SEND.
           The row used to print the job's date and stop there, so a deal whose customer had
           already replied read "sends Aug 27" until the cron cancelled it ON Aug 27 — the one
           morning that knowing is useless. The status endpoint now runs the same gate the cron
           runs, and `verdict` is its answer for THIS rung.

           ⚠️ The wording is the gate's own sentence, not a paraphrase. It already writes for a
           human ("They replied a little bit ago, so this ladder is closed."), and re-wording it
           here would be a second voice describing one decision — which drifts the first time the
           gate's copy changes.

           ⛔ `verdict` MAY BE NULL, and null means "could not check", NOT "will send". The
           endpoint returns null when its read failed, so this falls through to the plain date —
           the same thing the card said before this existed. Never turn a failed check into a
           confident claim in either direction. */
        var _v = data && data.verdict;
        if (_v && _v.cancel) {
          box.classList.add('rqd-sample-ladder--closed');
          stateEl.textContent = job.rungLabel + ' — ' + (_v.reason || 'this ladder is closed.');
          stateEl.title = 'The next cron run will cancel this instead of sending it'
            + (due ? ' (it was queued for ' + due + ')' : '') + '.';
        } else if (_v && !_v.ok && _v.reason) {
          /* Queued but not yet clear to go — e.g. the box has not landed. Still scheduled, so it
             keeps the queued styling; the reason just explains what it is waiting on. */
          box.classList.add('rqd-sample-ladder--queued');
          stateEl.textContent = job.rungLabel + (due ? ' — sends ' + due : '');
          stateEl.title = _v.reason;
        } else {
          box.classList.add('rqd-sample-ladder--queued');
          stateEl.textContent = job.rungLabel + (due ? ' — sends ' + due : '')
            + (job.overdue ? ' (due now)' : '');
          stateEl.title = 'Armed ' + (job.armedAt || '?') + (job.reason ? ' (' + job.reason + ')' : '');
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — ⛔ NOTHING LEFT TO STOP.
           Ryan: *"now that it's stopped, should the 'STOP' button disappear?"* Yes — once the gate
           has closed the ladder there is no pending send for Stop to cancel, and offering it beside
           "this ladder is closed" invites the question "stop what?". A CANCEL retires the whole
           ladder (see drainSampleFollowUps), so there is no future arm for a stop record to refuse
           either — the button would write a record that changes nothing.
           ⚠️ HIDDEN, NOT DISABLED, and it comes BACK on its own if it needs to. This function
           re-runs on every expand, so if the verdict ever stops saying cancel — a reply unlinked
           from the deal, a gate rule changed — the next paint falls through to the queued branch
           and Stop reappears. The control tracks the state instead of being switched off once. */
        if (stopBtn) stopBtn.hidden = !!(_v && _v.cancel);
        if (resumeBtn) resumeBtn.hidden = true;
      } else if (data && data.audience && data.audience.allowed === false) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — same shape as the notice row above.
           ⛔ Without this a rep's deal reads "None queued yet", which promises an arm that the
           gate will refuse every morning for the next few weeks. Stop is hidden too: there is
           nothing to stop, and offering it would invite "stop what?".

           ⚠️ THIS ONE KEEPS `audience` AND THAT IS CORRECT (2026-08-25). This ladder sends from
           the DEAL OWNER'S OWN MAILBOX, which is the sender Ryan is still holding back from
           reps, so it reads the rep-mailbox channel. The row above reads `noticeAudience`. The
           two are no longer the same answer: on a rep's deal the notice sends and this does not,
           which is the whole point of the split — do not "tidy" them back onto one field. */
        box.classList.add('rqd-sample-ladder--closed');
        stateEl.textContent = 'Not automated for ' + (data.audience.ownerCode || 'this rep');
        stateEl.title = data.audience.why || 'Automatic customer emails are limited to admin-owned deals for now.';
        if (stopBtn) stopBtn.hidden = true;
        if (resumeBtn) resumeBtn.hidden = true;
      } else {
        /* ⚠️ "None queued" is NOT "off". The next delivery scan arms one — which is exactly
           why Stop stays available here, and why saying "none" without saying "yet" would
           read as an off switch that is already thrown. */
        stateEl.textContent = 'None queued yet';
        stateEl.title = 'The next delivery scan will arm one unless this is stopped.';
        if (stopBtn) stopBtn.hidden = false;
        if (resumeBtn) resumeBtn.hidden = true;
      }
    }

    function _ladderHydrate(box) {
      if (!box || box.dataset.state !== 'pending') return;
      box.dataset.state = 'loading';
      API.get('/admin/samples-ladder?status=1&ref=' + encodeURIComponent(box.dataset.ref || ''))
        .then(function (data) { box.dataset.state = 'ready'; _ladderPaint(box, data); })
        .catch(function (err) {
          /* ⛔ An empty state and a failed load must not look the same. Say which. */
          box.dataset.state = 'error';
          var stateEl = box.querySelector('.rqd-sample-ladder__state');
          if (stateEl) {
            stateEl.textContent = 'Status unavailable';
            stateEl.title = (err && err.message) || 'Could not read the follow-up queue.';
          }
          /* ⛔ The notice row rides the same fetch, so it fails with it. Leaving it on its
             loading ellipsis would read as "still checking" for ever. */
          var _nb = box.previousElementSibling;
          if (_nb && _nb.classList.contains('rqd-sample-ladder--notice')) {
            _nb.dataset.state = 'error';
            var _ns = _nb.querySelector('.rqd-sample-ladder__state');
            if (_ns) {
              _ns.textContent = 'Status unavailable';
              _ns.title = (err && err.message) || 'Could not read the notice queue.';
            }
          }
        });
    }

    function _ladderScan(root) {
      if (!isAdmin) return;
      var boxes = (root || document).querySelectorAll('.rqd-sample-ladder[data-state="pending"]');
      for (var i = 0; i < boxes.length; i++) _ladderHydrate(boxes[i]);
    }

    /* ⛔ ATTACHED UNCONDITIONALLY, GATED INSIDE. `isAdmin` is a var that flips true only
       after Auth.getSession() resolves, well after this line runs — the same hoisting trap
       the lead-detail module takes a getIsAdmin closure for. Reading it HERE would decide
       "not an admin" at boot and never look again, so the observer would never attach for
       the one person who can see the control. Every sibling handler in this file gets away
       with a bare `isAdmin` because it reads it at CLICK time; an attach cannot. */
    if (window.MutationObserver) {
      var _ladderQueued = false;
      new MutationObserver(function () {
        if (_ladderQueued) return;
        _ladderQueued = true;
        // Coalesce a whole-board re-render into one scan.
        setTimeout(function () { _ladderQueued = false; _ladderScan(tbody); }, 0);
      }).observe(tbody, { childList: true, subtree: true });
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — the notice's own Stop/Resume. Separate
       handler because it posts a different action and confirms a different sentence; sharing one
       would mean a branch on class name inside every step of the other. Re-hydrates through the
       LADDER box, since that is the element the fetch belongs to. */
    tbody.addEventListener('click', async function (e) {
      var nb = e.target.closest('.rqd-sample-notice__stop, .rqd-sample-notice__resume');
      if (!nb || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      if (nb.disabled) return;
      var nBox = nb.closest('.rqd-sample-ladder--notice');
      var nRef = nb.dataset.ref;
      var nStopping = nb.classList.contains('rqd-sample-notice__stop');
      if (nStopping && !(await rqdConfirm('Re-saving the tracking number will not switch it back on. You can Resume from here, and the Notify Customer button still works.', { title: 'Stop Abby emailing ' + nRef + ' about their samples?', confirmLabel: 'Stop the notice', cancelLabel: 'Leave it on', danger: true }))) return;
      var nPrior = nb.textContent;
      nb.disabled = true;
      nb.textContent = nStopping ? 'Stopping…' : 'Resuming…';
      try {
        await API.post('/admin/samples-ladder', { ref: nRef, action: nStopping ? 'notify-stop' : 'notify-resume' });
        // Re-read rather than guessing — the answer says what was actually cancelled.
        var sib = nBox && nBox.nextElementSibling;
        if (sib && sib.classList.contains('rqd-sample-ladder')) { sib.dataset.state = 'pending'; _ladderHydrate(sib); }
      } catch (err) {
        rqdAlert((err && err.message) || 'Could not update the automatic customer notice.');
      } finally {
        nb.disabled = false;
        nb.textContent = nPrior;
      }
    });

    tbody.addEventListener('click', async function (e) {
      var btn = e.target.closest('.rqd-sample-ladder__stop, .rqd-sample-ladder__resume');
      if (!btn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      var box = btn.closest('.rqd-sample-ladder');
      var ref = btn.dataset.ref;
      var stopping = btn.classList.contains('rqd-sample-ladder__stop');
      if (stopping && !(await rqdConfirm('Nothing further will be sent to this customer by the ladder, and a later delivery scan cannot switch it back on. You can Resume from here.', { title: 'Stop the samples follow-up emails for ' + ref + '?', confirmLabel: 'Stop the ladder', cancelLabel: 'Leave it running', danger: true }))) return;

      var prior = btn.textContent;
      btn.disabled = true;
      btn.textContent = stopping ? 'Stopping…' : 'Resuming…';
      try {
        await API.post('/admin/samples-ladder', { ref: ref, action: stopping ? 'stop' : 'resume' });
        // Re-read rather than guessing: the answer includes what was actually cancelled.
        if (box) { box.dataset.state = 'pending'; _ladderHydrate(box); }
      } catch (err) {
        rqdAlert((err && err.message) || 'Could not update the follow-up ladder.');
      } finally {
        btn.disabled = false;
        btn.textContent = prior;
      }
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — CLICK THE TEXT TO EDIT IT.
       ─────────────────────────────────────────────────────────────────────────
       The Shipment Tracking card rests as a label/value summary and keeps its three inputs
       hidden behind `.rqd-sample-tracking--summary`. This is the whole of the swap: clicking a
       value reveals the row and drops the caret in the field you actually clicked, so "fix the
       tracking number" is one click, not a click plus a hunt.

       ⛔ NOTHING HERE TOUCHES THE SAVE PATH. `handleSampleTrackingSave` still reads the same
       three inputs off the same wrapper; it neither knows nor cares that they were off-screen a
       moment ago. */
    var _ST_FIELD_SEL = {
      carrier: '.rqd-sample-tracking__carrier',
      number: '.rqd-sample-tracking__number',
      url: '.rqd-sample-tracking__url'
    };
    function _stEnterEdit(wrap, field) {
      if (!wrap || wrap.classList.contains('rqd-sample-tracking--editing')) return;
      /* Snapshot for Cancel. ⚠️ Taken from the INPUTS, not from the record on `allQuotes` — a
         previous edit that was cancelled, or a value the rep typed and abandoned, lives in the
         input and nowhere else, so the record is not what "back to how it was" means here. */
      wrap._stSnapshot = {};
      Object.keys(_ST_FIELD_SEL).forEach(function (k) {
        var el = wrap.querySelector(_ST_FIELD_SEL[k]);
        wrap._stSnapshot[k] = el ? el.value : '';
      });
      wrap.classList.add('rqd-sample-tracking--editing');
      var target = wrap.querySelector(_ST_FIELD_SEL[field] || _ST_FIELD_SEL.carrier);
      if (target) {
        target.focus();
        // Caret to the end rather than selecting all — these get corrected, not retyped.
        try { target.setSelectionRange(target.value.length, target.value.length); } catch (_) {}
      }
    }
    function _stExitEdit(wrap) {
      if (!wrap) return;
      wrap.classList.remove('rqd-sample-tracking--editing');
      wrap._stSnapshot = null;
    }
    tbody.addEventListener('click', function (e) {
      // The ↗ opens the tracking page; it must never be read as "edit this".
      if (e.target.closest && e.target.closest('.rqd-sample-tracking__open')) return;
      var cancel = e.target.closest && e.target.closest('.rqd-sample-tracking__cancel');
      if (cancel) {
        var cWrap = cancel.closest('.rqd-sample-tracking');
        if (cWrap && cWrap._stSnapshot) {
          Object.keys(_ST_FIELD_SEL).forEach(function (k) {
            var el = cWrap.querySelector(_ST_FIELD_SEL[k]);
            if (el) el.value = cWrap._stSnapshot[k];
          });
        }
        _stExitEdit(cWrap);
        return;
      }
      var cell = e.target.closest && e.target.closest('.rqd-sample-tracking__v');
      if (!cell || !isAdmin) return;
      _stEnterEdit(cell.closest('.rqd-sample-tracking'), cell.dataset.field);
    });
    /* The cells carry role="button" + tabindex="0", so they have to answer the keyboard the way a
       button does or they are a focus stop that does nothing. */
    tbody.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var cell = e.target.closest && e.target.closest('.rqd-sample-tracking__v');
      if (!cell || !isAdmin) return;
      e.preventDefault();
      _stEnterEdit(cell.closest('.rqd-sample-tracking'), cell.dataset.field);
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — "Notify Customer" on the
       sample-tracking row (both the lead-side .rqd-sample-tracking__save form
       in dashboard-lead-detail.js and the quote-side .rqd-quote-sample-tracking
       form in dashboard-sample-commission.js). Reads tracking + customer + rep
       from q, opens openSampleNotifyModal — paste samples-dept note → Abby
       extracts → review/edit → Send Test / Send (CCs the rep). */
    tbody.addEventListener('click', async function (e) {
      /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-20) — fold a joined online sample request into the
         sibling deal that already has this customer's box (POST /sample-fold, admin). */
      var sfBtn = e.target.closest('.rqd-sample-fold');
      if (sfBtn && isAdmin) {
        e.stopPropagation();
        var _sfRef = sfBtn.dataset.ref || '';
        var _sfInto = sfBtn.dataset.into || '';
        if (!_sfRef || !_sfInto) return;
        if (!(await rqdConfirm('Move the samples on ' + _sfRef + ' onto ' + _sfInto + ' as its next request?\n\nThe list, the request and the tracking then live on ' + _sfInto + '; this card reads through to it. If ' + _sfInto + '\'s box has already gone out, ' + _sfRef + ' goes ON HOLD for 7 days, the same as it would have when the box shipped. Nothing is emailed.',
          { title: 'Fold into ' + _sfInto, confirmLabel: 'Fold', cancelLabel: 'Keep separate' }))) return;
        sfBtn.disabled = true;
        try {
          var _sfRes = await API.post('/sample-fold', { ref: _sfRef, into: _sfInto });
          if (!(_sfRes && _sfRes.success)) throw new Error((_sfRes && _sfRes.error) || 'Could not fold');
          try { fetchQuotes({ quiet: true }); } catch (_) { }
        } catch (err) {
          sfBtn.disabled = false;
          rqdAlert('Could not fold: ' + (err && err.message ? err.message : 'unknown error'), { title: 'Not folded' });
        }
        return;
      }
      var snBtn = e.target.closest('.rqd-sample-notify');
      if (!snBtn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      if (snBtn.disabled) return;
      var ref = snBtn.dataset.ref;
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) return;

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — Auto-save on EVERY Notify
         click (idempotent re-save is fine). The point: clicking Notify Customer
         always commits the live tracking values, regardless of whether the rep
         then sends or cancels the modal. Save button stays for the "record
         tracking, no notify" case. Only skip the save when the form has no
         tracking number at all (blank form — nothing to save, and we don't
         auto-clear; clearing requires the explicit Save which has its own
         confirm). */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — ⛔ NOTIFY SITS OUTSIDE THE WRAPPER NOW, ON
         BOTH CARDS. It is the right half of `.rqd-sample-band--tracking`; the tracking block is the
         left half. `closest()` therefore finds nothing, which used to make `isQuoteSide` false and
         skip the save-before-notify silently. Resolve the block through the band first (one band,
         one block — immune to two cards carrying the same origin ref), then by data-ref. */
      var form = snBtn.closest('.rqd-sample-tracking');
      if (!form) {
        var _band = snBtn.closest('.rqd-sample-band');
        form = (_band && _band.querySelector('.rqd-sample-tracking:not([data-lane="2"])'))
          || document.querySelector('.rqd-sample-tracking[data-ref="' + (window.CSS && CSS.escape ? CSS.escape(ref) : ref) + '"]:not([data-lane="2"])'); // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — never the second recipient's widget
      }
      /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: while their box has no number
         the automatic notice is waiting for it; a manual Notify asks before sending the buyer one number. */
      if (window.RQD && typeof RQD.samplePairWaiting === 'function' && RQD.samplePairWaiting(q)) {
        if (!(await rqdConfirm('The second recipient\'s box has no tracking number yet. Abby\'s automatic notice waits until both numbers are in and sends them together.\n\nSend the buyer their own tracking number now, without the second one?',
          { title: 'Waiting on the 2nd box', confirmLabel: 'Send the buyer\'s number only', cancelLabel: 'Keep waiting' }))) return;
      }
      /* Same owner signal the Save button uses — the two controls must not disagree about
         which record a deal's tracking lives on. */
      var isQuoteSide = !!(form && ((form.dataset.owner || '') === 'wm'
        || (!form.dataset.owner && form.classList.contains('rqd-quote-sample-tracking'))));
      var liveCarrier = '', liveNumber = '', liveUrl = '';
      if (form) {
        liveCarrier = String(((form.querySelector('.rqd-sample-tracking__carrier') || {}).value || '')).trim();
        liveNumber = String(((form.querySelector('.rqd-sample-tracking__number') || {}).value || '')).trim();
        liveUrl = String(((form.querySelector('.rqd-sample-tracking__url') || {}).value || '')).trim();
      }
      if (liveNumber) {
        var origText = snBtn.textContent;
        snBtn.disabled = true;
        snBtn.textContent = 'Saving…';
        try {
          var saveEndpoint = isQuoteSide ? '/quote-sample-tracking-save' : '/sample-tracking-save';
          await API.post(saveEndpoint, {
            ref: ref,
            trackingNumber: liveNumber,
            carrier: liveCarrier,
            trackingUrl: liveUrl,
          });
          var newRec = { carrier: liveCarrier, number: liveNumber, url: liveUrl };
          if (isQuoteSide) q.quoteSampleTracking = newRec;
          else q.sampleTracking = newRec;
          if (window.RQD && typeof RQD.mirrorSampleFields === 'function') RQD.mirrorSampleFields(q.reference);
        } catch (err) {
          snBtn.disabled = false;
          snBtn.textContent = origText;
          rqdAlert('Could not save tracking before notifying: ' + (err && err.message ? err.message : 'unknown error'));
          return;
        }
        snBtn.disabled = false;
        snBtn.textContent = origText;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      // Tracking lives on whichever surface recorded it (sample-request lead
      // → q.sampleTracking; sample on an ECORE quote → q.quoteSampleTracking).
      // Both are optional — the email reads cleanly with or without a number.
      var trackRec = (q.sampleTracking && q.sampleTracking.number ? q.sampleTracking : null)
        || (q.quoteSampleTracking && q.quoteSampleTracking.number ? q.quoteSampleTracking : null)
        || {};
      var customerName = q.customer && q.customer !== 'Unknown' ? q.customer : '';
      if (!customerName && q.shippingAddress) {
        customerName = ((q.shippingAddress.firstName || '') + ' ' + (q.shippingAddress.lastName || '')).trim();
      }
      var repFullName = q.repName || '';
      var repFirstName = repFullName.split(/\s+/)[0] || '';
      if (window.DashboardHandshake && window.DashboardHandshake.openSampleNotifyModal) {
        window.DashboardHandshake.openSampleNotifyModal({
          ref: ref,
          customerEmail: q.customerEmail || '',
          customerName: customerName,
          sampleShipTo: q.sampleShipTo || null, // CUSTOM_SAMPLECONTACT_BY_CLAUDE (Ryan 2026-09-23) — the modal re-addresses to the card's email when it has one
          pair: (window.RQD && typeof RQD.samplePairFor === 'function') ? RQD.samplePairFor(q) : null, // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — the second set's number, for the buyer's email
          repFirstName: repFirstName,
          repEmail: q.repEmail || '',
          tracking: {
            number: trackRec.number || liveNumber || '',
            carrier: trackRec.carrier || liveCarrier || '',
            url: trackRec.url || trackRec.trackingUrl || liveUrl || '',
          },
          btn: snBtn,
        });
      }
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* ============================================
       REQUEST SAMPLES — ask ECORE to ship the box
       CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-19)
       ============================================
       Ryan's flow: the sample lead lands, the rep CALLS to confirm the list and the address,
       and then admin clicks this. So the button is the step after that conversation.

       Three beats: ask where it goes → let the worker build the email → open the composer on
       it. The email is built server-side (/sample-request-compose) rather than here, so it is
       assembled from the deal as it stands rather than from a dashboard row that may have
       been sitting open for an hour.

       ⛔ THE ADDRESS QUESTION COMES FIRST, AND IT IS NOT A SETTING. Ryan: *"there may be SOME
       occasions (rare) where someone wants samples sent elsewhere."* A one-off address is used
       for this email and stored on the request; it never touches the deal's Ship To, because
       the deal's Ship To is where the actual order goes and a swatch decision must not move a
       pallet months later. */
    tbody.addEventListener('click', async function (e) {
      var srBtn = e.target.closest('.rqd-sample-request');
      if (!srBtn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      if (srBtn.disabled) return;

      var ref = srBtn.dataset.ref;
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) return;
      /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: the block's own Request builds a
         SEPARATE work order (`recipient: 2` on compose and send; its own Project Name, its own address),
         never the "request more" reply on the buyer's thread. */
      var _srLane2 = srBtn.dataset.lane === '2';

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — ⛔ NO ADDRESS DIALOG ANY MORE. Ryan: *"Then
         when 'Request' is clicked, we no longer need the pop-up asking about the shipping address
         the shipment is going to."* The Shipping Address section on the Samples card is where the
         destination is read and, with the pencil, changed for this box only (POST /sample-ship-to);
         the worker's `shipBlockOf` reads that block above the deal's own addresses and compose
         refuses a deal with no address anywhere. The 08-27 three-option chooser and its one-line
         prompt (which once shipped a request with an empty ZIP) are gone with it. */
      var origText = srBtn.textContent;
      srBtn.disabled = true;
      srBtn.textContent = 'Building…';
      /* Ryan 2026-09-06: a Job Information or Shipping Address save may still be in flight — the
         Request click is what blurred the field — so wait for it before the worker reads the
         record, or the email is built from the value before the edit ("170 sq ft" on a deal just
         set to 210). */
      if (window.RQD && typeof RQD.awaitSampleSaves === 'function') { try { await RQD.awaitSampleSaves(ref); } catch (_) { /* compose reads the record either way */ } }
      var pv;
      try {
        pv = _srLane2 ? await API.post('/sample-request-compose', { ref: ref, recipient: 2 }) : await API.post('/sample-request-compose', { ref: ref });
        if (!pv || !pv.success) throw new Error((pv && pv.error) || 'Could not build the email');
      } catch (err) {
        srBtn.disabled = false;
        srBtn.textContent = origText;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — a 409 is the worker refusing an
           unready request (no list, no project type, no footage): its message already names the
           gaps in the card's own words, so it is shown as-is rather than behind "could not
           build". The card's gate should have caught it first; this is the boundary. */
        if (err && err.status === 409) { rqdAlert(err.message, { title: 'Not ready to send' }); return; }
        rqdAlert('Could not build the sample request: ' + (err && err.message ? err.message : 'unknown error'));
        return;
      }
      srBtn.disabled = false;
      srBtn.textContent = origText;

      /* What the deal never captured, said BEFORE the composer opens rather than after the
         email has gone. Since 2026-09-06 only the ADDRESS reaches here — the list and the project
         details are refused upstream with a 409 — and it does not block, because the one-off
         address path is how it gets fixed. */
      if (pv.missing && pv.missing.length) {
        if (!(await rqdConfirm('  ' + pv.missing.join('\n  ') + '\n\nOpen the email anyway?',
          { title: 'Heads up before this opens', confirmLabel: 'Open the email' }))) return;
      }
      /* CUSTOM_SAMPLESMORE_BY_CLAUDE (AIOPS bf531a5e001d, 2026-09-08) — "send another" is a further
         request on the SAME job: the worker re-composes it as a reply on the original ask (the
         added samples listed, the first email quoted underneath) and the send threads on it. The
         first-request path above this block is untouched; only the already-requested branch
         changed, and the composer opens exactly as before. */
      var _srMore = null;
      if (pv.alreadyRequested && _srLane2) {
        /* CUSTOM_SAMPLES2ND_BY_CLAUDE — no "request more" for the second recipient in v1: a second click
           re-sends the same work order, after a confirm. */
        if (!(await rqdConfirm('A sample request has already gone out for the second recipient on ' + ref + '.\n\nSend it to the samples desk again?',
          { title: 'Already requested', confirmLabel: 'Request again', cancelLabel: 'Do not send', danger: true }))) return;
      } else if (pv.alreadyRequested) {
        /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-20) — the draft first, the question second: when
           the list carries samples no ask has named, the button already said "Request more" and the
           composer opens straight onto the reply. Only a re-ship of the SAME list still asks. */
        try {
          _srMore = await API.post('/sample-request-compose', { ref: ref, additional: true });
          if (!_srMore || !_srMore.success) throw new Error((_srMore && _srMore.error) || 'Could not build the follow-up request');
        } catch (err) {
          rqdAlert('Could not build the follow-up request: ' + (err && err.message ? err.message : 'unknown error'));
          return;
        }
        if (!(_srMore.newCount > 0)) {
          if (!(await rqdConfirm('A sample request has already gone out for ' + ref + ' and nothing new is on the list.\n\nAsk the samples desk for another set of the same samples? It goes as a reply on the original request.',
            { title: 'Already requested', confirmLabel: 'Request again', cancelLabel: 'Do not send', danger: true }))) return;
        }
        pv = _srMore;
      }
      /* The reply chrome — the original request thread in the composer, and the rep's choice to
         thread or not — only when there is a message to reply on. Model: the deal feed's Reply. */
      var _srReply = (_srMore && _srMore.replyTo && _srMore.replyTo.messageId) ? {
        replyToMessageId: _srMore.replyTo.messageId,
        replyThread: Array.isArray(_srMore.thread) ? _srMore.thread : [],
        replyContext: _srMore.replyContext || { subject: pv.subject || '', withWhom: 'ECORE samples desk', count: (Array.isArray(_srMore.thread) ? _srMore.thread.length : 0) },
        canReply: true,
        replyUnavailable: _srMore.threadUnavailable || '',
      } : {};

      window.RQD.openComposeModal(Object.assign({
        ref: ref,
        prefillTo: pv.to,
        prefillSubject: pv.subject,
        prefillBody: pv.html,
        /* Abby is the sender and there is no choice to offer — this is her mailbox writing to
           a supplier she already corresponds with. */
        forceFrom: 'ABBY',
        fromOptions: ['ABBY'],
        /* No rep cadence: a follow-up timer belongs to the customer conversation, not to a
           work order we sent a supplier. */
        suppressFollowUp: true,
        followUpDefaultNa: true,
        /* CUSTOM_SENDWINDOW_BY_CLAUDE — ⛔ UNTICKED BY DEFAULT NOW (Ryan 2026-08-29). It was
           ticked on Ryan's earlier "default setting of send within business hours should be
           checked", which was said about the family as a whole before the vendor half of it
           existed. This is Abby writing a WORK ORDER TO A SUPPLIER, and the 2am argument does not
           apply to a supplier's orders@ queue — holding it only delays the answer we are waiting
           on. Customer-directed composers (Send Invoice) keep the tick. */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — ⛔ TICKED BY DEFAULT AGAIN, and the window
           is different now. Ryan: *"the checkbox should be checked automatically for samples too."*
           The 08-29 argument for unticking it (a supplier's queue does not care about 2am) gave way
           once the window became 6am–8pm with a random minute after the open — a request held at
           10pm now leaves at, say, 6:23am rather than at 2am, and the desk reads it in the same
           morning either way. */
        showBusinessHours: true,
        businessHoursDefault: true,
        enterFrom: 'right',
        sendOverride: function (args) {
          var payload = {
            ref: ref,
            subject: args.subject,
            bodyHtml: args.bodyHtml,
            businessHoursOnly: args.businessHoursOnly === true,
            includesSignature: false,
          };
          if (_srLane2) payload.recipient = 2; // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient
          /* CUSTOM_SAMPLESMORE_BY_CLAUDE — the follow-up request carries the thread it replies on.
             CUSTOM_SAMPLES2ND_BY_CLAUDE — and only when the rep left "reply on this thread" ticked:
             the composer reports the choice as `sendMode`, and this override honours it the way
             /order-adjust/email does. The greeting the draft showed rides along for a held send. */
          if (_srMore && _srMore.additional) {
            payload.additional = true;
            if (args.sendMode !== 'new' && _srMore.replyTo && _srMore.replyTo.messageId) payload.replyToMessageId = _srMore.replyTo.messageId;
            if (_srMore.greetingFirst) payload.greetingFirst = _srMore.greetingFirst;
          }
          if (args.isTest) {
            payload.test = true;
            /* ⚠️ Read inline, NOT via _repSessionEmail() — that helper looks module-scope but
               is declared INSIDE the PO composer function, so calling it from here throws a
               silent ReferenceError and the click does nothing. Same trap the *e* helper set
               in this file on 2026-08-19. */
            var _sessEmail = '';
            try { var _raw = sessionStorage.getItem('rep_portal_session'); _sessEmail = _raw ? ((JSON.parse(_raw) || {}).email || '').trim() : ''; } catch (_) { _sessEmail = ''; }
            payload.testRecipient = _sessEmail || (args.to || [])[0] || '';
            if (!payload.testRecipient) return Promise.reject(new Error('No address for the test — re-login so your session email is set.'));
          }
          return API.post('/sample-request-send', payload).then(function (res) {
            if (!(res && res.success)) throw new Error((res && res.error) || 'Send failed');
            if (!args.isTest && _srLane2) {
              /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: the block in memory learns
                 the stamp and re-renders (chip, "Sent", the tracking widget appears); the buyer's request
                 state below is untouched. */
              var _b2 = (q.sampleSecondary && typeof q.sampleSecondary === 'object') ? q.sampleSecondary : {};
              var _keep = (_b2.status === 'shipped' || _b2.status === 'delivered') ? _b2.status : 'requested';
              /* Ryan 2026-09-24: a parked send (`res.scheduled`) is recorded as scheduled, not sent - the
                 block then reads "⌛ Scheduled" and the ✓, not "Sent" with a stamp nobody has. */
              q.sampleSecondary = Object.assign({}, _b2, { requested: true, status: _keep,
                sampleRequest: Object.assign({}, _b2.sampleRequest || {}, (res && res.scheduled)
                  ? { scheduledFor: res.sendAfter || new Date().toISOString(), by: 'you', status: 'scheduled' }
                  : { sentAt: new Date().toISOString(), by: 'you', status: 'awaiting-tracking' }) });
              if (window.RQD && typeof RQD.mirrorSampleFields === 'function') RQD.mirrorSampleFields(ref);
              if (window.RQD && typeof RQD.rerenderSampleSecondary === 'function') RQD.rerenderSampleSecondary(ref);
              try { fetchQuotes({ quiet: true }); } catch (_) { /* the 2-minute poll is the backstop */ }
              return res;
            }
            if (!args.isTest) {
              /* Repaint so the button reads "Requested ✓" without a full reload. The quiet
                 refetch owns the real state; this is the optimistic half. */
              /* CUSTOM_SAMPLESMORE_BY_CLAUDE — a follow-up request keeps the FIRST request's stamp (the
                 card's "Requested on" is the first ask); only the first send writes it. */
              /* Ryan 2026-09-24: outside the send window the worker answers `{scheduled: true, sendAfter}` -
                 record THAT (`scheduledFor`, no `sentAt`), so the card ghosts as "⌛ Scheduled" and a quiet
                 refetch cannot flip it back to a live "Request". It used to stamp `sentAt: now` regardless. */
              var _srScheduled = !!(res && res.scheduled);
              q.sampleRequest = (_srMore && _srMore.additional && q.sampleRequest && q.sampleRequest.sentAt)
                ? Object.assign({}, q.sampleRequest, { lastRequestedAt: new Date().toISOString(), expectingMore: true, status: 'awaiting-tracking' })
                : _srScheduled
                ? { scheduledFor: (res && res.sendAfter) || new Date().toISOString(), projectName: ref, status: 'scheduled' }
                : { sentAt: new Date().toISOString(), projectName: ref, status: 'awaiting-tracking' };
              /* The quote-side card reads `quoteSampleRequest`; an origin row that is not a lead
                 row (JW-1273-A, status quoted) would otherwise never read "Requested" until the
                 refetch. Both fields, then the in-memory cascade for any revision inheriting it. */
              q.quoteSampleRequest = q.sampleRequest;
              /* CUSTOM_SAMPLES2ND_BY_CLAUDE — the further ask is on the record now: nothing on the
                 list is new any more, and the tracking card lists the ask under "More requested". */
              if (_srMore && _srMore.additional) {
                var _addl = Array.isArray(q.sampleRequest.additional) ? q.sampleRequest.additional.slice() : [];
                _addl.push({ sentAt: new Date().toISOString(), by: 'you', items: Array.isArray(_srMore.added) ? _srMore.added.slice() : [] });
                q.sampleRequest = Object.assign({}, q.sampleRequest, { additional: _addl });
                q.quoteSampleRequest = q.sampleRequest;
                if (Object.prototype.hasOwnProperty.call(q, 'sampleNewCount')) q.sampleNewCount = 0;
                if (Object.prototype.hasOwnProperty.call(q, 'quoteSampleNewCount')) q.quoteSampleNewCount = 0;
                var _tags = Array.isArray(q.sampleItemTags) ? q.sampleItemTags : (Array.isArray(q.quoteSampleItemTags) ? q.quoteSampleItemTags : null);
                if (_tags) {
                  var _reqNo = (Number(q.sampleRequestCount || q.quoteSampleRequestCount) || 1) + 1;
                  (Array.isArray(_srMore.added) ? _srMore.added : []).forEach(function (t) {
                    var k = String(t).trim().toLowerCase();
                    var hit = _tags.find(function (x) { return x && String(x.name).trim().toLowerCase() === k; });
                    if (hit) { hit.requestNo = _reqNo; hit.state = 'requested'; hit.requestedAt = new Date().toISOString(); }
                    else _tags.push({ name: String(t).trim(), requestNo: _reqNo, requestedAt: new Date().toISOString(), box: null, state: 'requested' });
                  });
                }
              }
              if (window.RQD && typeof RQD.mirrorSampleFields === 'function') RQD.mirrorSampleFields(ref);
              /* Ryan 2026-09-06: the button reads "Sent" in the outline look the moment the send
                 lands, on whichever card is open — no wait for the quiet refetch. */
              document.querySelectorAll('.rqd-sample-request[data-ref="' + (window.CSS && CSS.escape ? CSS.escape(ref) : ref) + '"]:not([data-lane="2"])').forEach(function (b) { // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — the buyer's button only
                b.textContent = _srScheduled ? '⌛ Scheduled' : 'Sent';
                b.classList.add('rqd-sample-request--sent');
                b.classList.toggle('rqd-sample-request--scheduled', _srScheduled);
                b.classList.remove('rqd-sample-request--more'); // CUSTOM_SAMPLES2ND_BY_CLAUDE
                b.title = _srScheduled
                  ? 'Scheduled for the next send window. Click again only to replace the queued email.'
                  : 'Already requested. Click again only if they lost it or the list has changed — the composer will ask you to confirm.';
              });
              document.querySelectorAll('.rqd-sample-adjust[data-ref="' + (window.CSS && CSS.escape ? CSS.escape(ref) : ref) + '"]:not([data-lane="2"])').forEach(function (b) {
                b.classList.add('rqd-sample-adjust--sent');
              });
              /* CUSTOM_SAMPLES2ND_BY_CLAUDE — the second recipient's Request was gated on this send. */
              if (window.RQD && typeof RQD.refreshSampleSecondGate === 'function') RQD.refreshSampleSecondGate(ref);
              try { fetchQuotes({ quiet: true }); } catch (_) { /* the 2-minute poll is the backstop */ }
            }
            return res;
          });
        },
      }, _srReply)); // CUSTOM_SAMPLES2ND_BY_CLAUDE — the reply chrome, when there is a thread
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Custom Costs inline in Financials card.
       Actions: add-trigger (toggle form), cancel-new, save-new, delete.
       Find the form by walking up to the nearest detail panel + scoped
       querySelector — there's at most one expanded form per panel at a
       time. */
    /* ⚠️ async (Phase 2): the delete branch below awaits an in-DOM confirm. preventDefault and
       stopPropagation both run BEFORE the first await, and the awaited branch returns. */
    tbody.addEventListener('click', async function (e) {
      var ccBtn = e.target.closest('[data-cc-action]');
      if (!ccBtn || !isAdmin) return;
      e.preventDefault();
      e.stopPropagation();
      var action = ccBtn.getAttribute('data-cc-action');
      var ref = ccBtn.getAttribute('data-ref');
      var detail = ccBtn.closest('[id^="rqd-detail-"]');
      if (action === 'add-trigger') {
        if (!detail) return;
        var triggerRow = detail.querySelector('.rqd-cc-add-trigger-row[data-ref="' + ref + '"]');
        var form = detail.querySelector('.rqd-cc-add-form[data-ref="' + ref + '"]');
        if (triggerRow) triggerRow.style.display = 'none';
        if (form) {
          form.style.display = '';
          var labelInput = form.querySelector('.rqd-cc-new-label');
          if (labelInput) setTimeout(function () { labelInput.focus(); }, 0);
        }
        return;
      }
      if (action === 'cancel-new') {
        if (!detail) return;
        var triggerRow2 = detail.querySelector('.rqd-cc-add-trigger-row[data-ref="' + ref + '"]');
        var form2 = detail.querySelector('.rqd-cc-add-form[data-ref="' + ref + '"]');
        if (form2) {
          form2.style.display = 'none';
          // Clear inputs so the next open starts fresh
          var l = form2.querySelector('.rqd-cc-new-label'); if (l) l.value = '';
          var a = form2.querySelector('.rqd-cc-new-amount'); if (a) a.value = '';
          var cb = form2.querySelector('.rqd-cc-new-addpo-cb'); if (cb) cb.checked = true;
        }
        if (triggerRow2) triggerRow2.style.display = '';
        return;
      }
      if (action === 'save-new') {
        if (!detail) return;
        var form3 = detail.querySelector('.rqd-cc-add-form[data-ref="' + ref + '"]');
        if (!form3) return;
        var labelEl = form3.querySelector('.rqd-cc-new-label');
        var amountEl = form3.querySelector('.rqd-cc-new-amount');
        var vendorEl = form3.querySelector('.rqd-cc-new-vendor');
        var addPoEl = form3.querySelector('.rqd-cc-new-addpo-cb');
        var label = (labelEl && labelEl.value || '').trim();
        var amount = parseFloat(amountEl && amountEl.value);
        if (!label || isNaN(amount) || amount < 0) {
          rqdAlert('Enter a label and a non-negative amount.');
          if (labelEl && !label) labelEl.focus();
          else if (amountEl) amountEl.focus();
          return;
        }
        ccBtn.disabled = true;
        var origText = ccBtn.textContent; ccBtn.textContent = 'Saving…';
        API.post('/custom-cost-upsert', {
          ref: ref,
          cost: {
            label: label,
            amount: amount,
            vendorTag: (vendorEl && vendorEl.value) || '',
            addToPo: !!(addPoEl && addPoEl.checked),
          },
        }).then(function () { fetchQuotes(); })
          .catch(function (err) {
            rqdAlert('Save failed: ' + (err.message || 'unknown'));
            ccBtn.disabled = false; ccBtn.textContent = origText;
          });
        return;
      }
      if (action === 'delete') {
        var costId = ccBtn.getAttribute('data-cc-id');
        if (!(await rqdConfirm('It comes off this deal\'s costs and off any PO it was set to appear on.', { title: 'Remove this custom cost?', confirmLabel: 'Remove', danger: true }))) return;
        ccBtn.disabled = true;
        API.post('/custom-cost-delete', { ref: ref, costId: costId })
          .then(function () { fetchQuotes(); })
          .catch(function (err) {
            rqdAlert('Delete failed: ' + (err.message || 'unknown'));
            ccBtn.disabled = false;
          });
        return;
      }
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // ── Carrier autocomplete (online orders) ──
    // Custom dropdown with controlled height — replaces the browser-native
    // <datalist> popup, which can't be height-constrained and overflowed the
    // viewport on a 50-entry list. Renders a filtered list of ONLINE_CARRIERS
    // beneath the input as the rep types; mousedown on an option fires the
    // input's `change` event so the existing save flow picks it up unchanged.
    // Position the carrier autocomplete menu in viewport coordinates. The
    // menu is position:fixed so it escapes any ancestor stacking context
    // (detail panel, portal-content, footer). Opens DOWNWARD by default to
    // match native <select> behavior — flips UPWARD only when there isn't
    // enough room below the input for the full menu (auto-flip mirrors the
    // OS's native dropdown placement logic).
    function positionCarrierAcMenu(menu, input) {
      if (!menu || !input) return;
      var rect = input.getBoundingClientRect();
      var menuMaxHeight = 220; // matches .rqd-carrier-ac__menu max-height
      var spaceBelow = window.innerHeight - rect.bottom;
      var spaceAbove = rect.top;
      var openUp = spaceBelow < menuMaxHeight + 8 && spaceAbove > spaceBelow;
      menu.style.left = rect.left + 'px';
      menu.style.width = Math.max(rect.width, 215) + 'px';
      if (openUp) {
        menu.style.top = 'auto';
        menu.style.bottom = (window.innerHeight - rect.top + 2) + 'px';
      } else {
        menu.style.bottom = 'auto';
        menu.style.top = (rect.bottom + 2) + 'px';
      }
    }

    // Close any open carrier autocomplete menu — fired on page scroll/resize
    // so the menu doesn't stay pinned to the old viewport coords while the
    // row scrolls underneath it.
    function closeAllCarrierAcMenus() {
      var open = document.querySelectorAll('.rqd-carrier-ac__menu--open');
      for (var i = 0; i < open.length; i++) {
        open[i].classList.remove('rqd-carrier-ac__menu--open');
      }
    }
    window.addEventListener('scroll', function (e) {
      // Skip when the scroll fired INSIDE the menu (overflow-y:auto fires
      // scroll events on the menu div itself when the rep wheels through
      // 50 carriers) — closing on inner scroll defeats the whole purpose of
      // having a scrollable list. e.target is the document on page scroll,
      // the menu div on internal scroll.
      var t = e.target;
      if (t && t.nodeType === 1 && t.closest && t.closest('.rqd-carrier-ac__menu')) return;
      closeAllCarrierAcMenus();
    }, true);
    window.addEventListener('resize', closeAllCarrierAcMenus);

    /* CUSTOM_CARRIERSEARCH_BY_CLAUDE (AIOPS `e176f0c6fe3a`, Ryan 2026-09-14) — ⛔ THE CARRIER WAS
       ALREADY IN THE LIST; THE SEARCH COULD NOT FIND IT.
       ────────────────────────────────────────────────────────────────────────
       Ryan went to stamp tracking on RW-1167-B, typed "R&L Carriers", got nothing and free-typed
       it. `ONLINE_CARRIERS` has carried `R+L Carriers` all along — the company's own spelling,
       and the one Shopify recognises. The match was `name.toLowerCase().indexOf(query)`, so one
       character of punctuation hid the row.

       ⛔ SO "ADD R&L CARRIERS" WOULD HAVE MADE IT WORSE. A second option spelled with the
       ampersand is two rows for one carrier, and that spelling is NOT on Shopify's list —
       picking it flips the URL field visible and drops the auto-built customer link, which is
       the exact thing being ON this list buys you. Worse, the worker normalises `r&l` straight
       back to `R+L Carriers` (shopify-fulfillment.js), so the new row would have displayed one
       name and stored another. The NAMES stay canonical; the SEARCH learns the other spellings.

       ⚠️ TWO HALVES, BECAUSE THERE ARE TWO KINDS OF MISS:
         · `_carrierFold` is the general one — `&`, `+` and the word "and" are one token, and
           spacing/punctuation is dropped. That fixes the whole class in one line: R&L/R+L, and
           "Ward Transport and Logistics" vs "Ward Transport & Logistics".
         · `CARRIER_SEARCH_ALIASES` is for ABBREVIATIONS, which no fold can reach. ⚠️ Every
           entry is lifted from a spelling the house ALREADY accepts downstream — the `match`
           predicates in the worker's lib/tracking-urls.js and normalizeCarrierForShopify() —
           not invented here. Those two files are the record of what reps actually type.

       ⚠️ SEARCH-ONLY, AND THAT IS THE WHOLE SAFETY ARGUMENT. Nothing below is ever displayed or
       stored: the option still renders `matches[i]` and still carries the canonical name in
       `data-carrier-value`, so the saved value, the Shopify push and the customer link are
       byte-for-byte what they were. An alias can only ever make an existing row FINDABLE.

       ⚠️ The "Other — Use 'X'" sentinel still works: folding makes matching looser, never
       stricter, so a genuinely unknown carrier still matches nothing and still offers Other. */
    function _carrierFold(str) {
      return String(str || '').toLowerCase()
        .replace(/\band\b/g, '&')
        .replace(/\+/g, '&')
        .replace(/[^a-z0-9&]+/g, '');
    }
    var CARRIER_SEARCH_ALIASES = {
      'R+L Carriers': ['rl carriers'],                        // tracking-urls.js: c.includes('rl carriers')
      'Old Dominion': ['odfl'],                               // tracking-urls.js + normalizeCarrierForShopify
      'Daylight Transport': ['dylt'],                         // tracking-urls.js: c.includes('dylt')
      'Roadrunner Transportation': ['rrts'],                  // tracking-urls.js: c.includes('rrts')
      'Ward Transport & Logistics': ['ward trucking', 'wardtlc'], // tracking-urls.js: /\bwards?\b/ + wardtlc
      'YRC Freight': ['yellow freight'],                      // normalizeCarrierForShopify
    };
    function _carrierMatches(name, typed) {
      var q = _carrierFold(typed);
      if (!q) return true;
      if (_carrierFold(name).indexOf(q) !== -1) return true;
      var aliases = CARRIER_SEARCH_ALIASES[name];
      if (!aliases) return false;
      for (var ai = 0; ai < aliases.length; ai++) {
        if (_carrierFold(aliases[ai]).indexOf(q) !== -1) return true;
      }
      return false;
    }

    function renderCarrierAcMenu(menu, query) {
      var typed = (query || '').trim();
      var qs = typed.toLowerCase();
      var matches = qs
        ? ONLINE_CARRIERS.filter(function (c) { return _carrierMatches(c, typed); })
        : ONLINE_CARRIERS.slice();
      var out = '';
      // No matches + the rep typed something → surface a single "Other" option
      // whose data-carrier-value is the typed text. Clicking it commits the
      // typed value as the carrier (not the literal word "Other"); the URL
      // input flips visible because the carrier isn't on Shopify's recognized
      // list.
      if (matches.length === 0 && typed) {
        out = '<div class="rqd-carrier-ac__option rqd-carrier-ac__option--other" role="option" data-carrier-value="' + esc(typed) + '">'
          + '<span class="rqd-carrier-ac__other-tag">Other</span>'
          + '<span class="rqd-carrier-ac__other-text">Use "' + esc(typed) + '"</span>'
          + '</div>';
      } else if (matches.length === 0) {
        out = '<div class="rqd-carrier-ac__option rqd-carrier-ac__option--empty">Type to search carriers</div>';
      } else {
        for (var i = 0; i < matches.length; i++) {
          out += '<div class="rqd-carrier-ac__option" role="option" data-carrier-value="' + esc(matches[i]) + '">' + esc(matches[i]) + '</div>';
        }
      }
      menu.innerHTML = out;
    }

    tbody.addEventListener('focusin', function (e) {
      var input = e.target.closest('.rqd-vendor-tracking__carrier');
      if (!input || input.tagName !== 'INPUT') return;
      var ac = input.closest('.rqd-carrier-ac');
      if (!ac) return;
      var menu = ac.querySelector('.rqd-carrier-ac__menu');
      if (!menu) return;
      renderCarrierAcMenu(menu, input.value);
      menu.classList.add('rqd-carrier-ac__menu--open');
      positionCarrierAcMenu(menu, input);
    });

    // Freight Balance cost/markup/charge cross-fill. Three inputs:
    //   cost × (1 + markup%/100) = charge
    // Edit cost or markup → charge recomputes. Edit charge → markup
    // recomputes (pinning cost). Pure UI; no save until "Invoice + Email".
    tbody.addEventListener('input', function (e) {
      var costEl = e.target.closest('.rqd-fb-cost-input');
      var markupEl = e.target.closest('.rqd-fb-markup-input');
      var chargeEl = e.target.closest('.rqd-fb-charge-input');
      if (!costEl && !markupEl && !chargeEl) return;
      var card = e.target.closest('.rqd-fb');
      if (!card) return;
      var ref = e.target.dataset.ref || '';
      var cost = parseFloat(card.querySelector('.rqd-fb-cost-input[data-ref="' + ref + '"]')?.value);
      var markup = parseFloat(card.querySelector('.rqd-fb-markup-input[data-ref="' + ref + '"]')?.value);
      var charge = parseFloat(card.querySelector('.rqd-fb-charge-input[data-ref="' + ref + '"]')?.value);
      if (chargeEl) {
        // Admin typed in charge → derive markup from cost + charge (pin cost)
        if (!isNaN(cost) && cost > 0 && !isNaN(charge) && charge > 0) {
          var newMarkup = Math.round(((charge / cost) - 1) * 1000) / 10;
          var mEl = card.querySelector('.rqd-fb-markup-input[data-ref="' + ref + '"]');
          if (mEl) mEl.value = newMarkup;
        }
      } else {
        // Cost or markup changed → derive charge
        if (!isNaN(cost) && cost > 0 && !isNaN(markup)) {
          var newCharge = Math.round(cost * (1 + markup / 100) * 100) / 100;
          var cEl = card.querySelector('.rqd-fb-charge-input[data-ref="' + ref + '"]');
          if (cEl) cEl.value = newCharge.toFixed(2);
        }
      }
    });

    tbody.addEventListener('input', function (e) {
      var input = e.target.closest('.rqd-vendor-tracking__carrier');
      if (!input || input.tagName !== 'INPUT') return;
      var ac = input.closest('.rqd-carrier-ac');
      if (!ac) return;
      var menu = ac.querySelector('.rqd-carrier-ac__menu');
      if (!menu) return;
      renderCarrierAcMenu(menu, input.value);
      menu.classList.add('rqd-carrier-ac__menu--open');
      positionCarrierAcMenu(menu, input);
    });

    // mousedown (not click) so the value lands BEFORE the input's blur fires
    // — preventDefault keeps focus on the input until we've set the value
    // and dispatched change. The blanket preventDefault on ANY mousedown
    // inside the menu also covers scrollbar drags / empty-space clicks: the
    // browser would otherwise shift focus to the menu or scrollbar element,
    // fire focusout on the input, and close the menu mid-interaction.
    tbody.addEventListener('mousedown', function (e) {
      if (e.target.closest('.rqd-carrier-ac__menu')) {
        e.preventDefault();
      }
      var opt = e.target.closest('.rqd-carrier-ac__option[data-carrier-value]');
      if (!opt) return;
      var ac = opt.closest('.rqd-carrier-ac');
      if (!ac) return;
      var input = ac.querySelector('.rqd-vendor-tracking__carrier');
      var menu = ac.querySelector('.rqd-carrier-ac__menu');
      if (input) {
        input.value = opt.dataset.carrierValue;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (menu) menu.classList.remove('rqd-carrier-ac__menu--open');
      if (input) input.blur();
    });

    tbody.addEventListener('focusout', function (e) {
      // Bucket settings popover — rename input saves on blur.
      var bucketRenameInput = e.target.closest('.rqd-fb__bucket-popover-label-input');
      if (bucketRenameInput) {
        var brRef = bucketRenameInput.dataset.ref || '';
        var brId = bucketRenameInput.dataset.bucket || '';
        var newLabel = (bucketRenameInput.value || '').trim();
        if (brRef && brId) {
          API.post('/shipping-bucket-set', { ref: brRef, bucketId: brId, label: newLabel })
            .then(function () { fetchQuotes(); })
            .catch(function (err) { rqdAlert('Failed to save bucket label: ' + (err && err.message ? err.message : 'unknown error')); });
        }
      }
      var input = e.target.closest('.rqd-vendor-tracking__carrier');
      if (!input || input.tagName !== 'INPUT') return;
      var ac = input.closest('.rqd-carrier-ac');
      if (!ac) return;
      // Delay close so a click on a menu option is processed first (mousedown
      // → blur → click order; we close on the trailing tick to avoid eating
      // the option selection).
      setTimeout(function () {
        var menu = ac.querySelector('.rqd-carrier-ac__menu');
        if (menu && !ac.contains(document.activeElement)) {
          menu.classList.remove('rqd-carrier-ac__menu--open');
        }
      }, 120);
    });

    // Online-row carrier change → toggle the tracking-URL input's visibility
    // and pre-fill it from carrier-URL memory. URL is only relevant for
    // custom carriers (Shopify auto-builds the link for known ones from the
    // tracking #). Fires on every value change — datalist click, free-typed
    // commit, or "Other — Use 'X'" pick.
    // Editable toggle date — used by Taxes Remitted, Rep Commission, Referral
    // Commission, CFA Commission. Picking a date on an UNDONE toggle also
    // flips the toggle to done with that date (so the rep can set the date
    // directly without first checking the box). Picking on a done toggle
    // just updates the date. Clearing the date does NOT untoggle — the rep
    // can manually un-flip via the checkbox.
    tbody.addEventListener('change', async function (e) {
      var dateInput = e.target.closest('.rqd-toggle__date-input');
      if (!dateInput) return;
      var ref = dateInput.dataset.ref;
      var dateField = dateInput.dataset.field;
      var toggleField = dateInput.dataset.toggleField;
      var newDate = dateInput.value || null;
      if (!ref || !dateField) return;
      var toggleEl = dateInput.closest('.rqd-toggle');
      var wasUndone = toggleEl && !toggleEl.classList.contains('rqd-toggle--done');
      var payload = { ref: ref };
      payload[dateField] = newDate;
      // Flip done when picking a date on an undone toggle.
      if (wasUndone && newDate && toggleField) {
        payload[toggleField] = true;
      }
      // Optimistic UI — flip the green/done classes immediately so the rep
      // sees instant feedback. We revert on save failure below.
      var prevFilled = dateInput.classList.contains('rqd-toggle__date-input--filled');
      var prevDone = toggleEl && toggleEl.classList.contains('rqd-toggle--done');
      var prevCheck = toggleEl ? (toggleEl.querySelector('.rqd-toggle__check') || {}).innerHTML : '';
      dateInput.classList.toggle('rqd-toggle__date-input--filled', !!newDate);
      if (toggleEl && wasUndone && newDate) {
        toggleEl.classList.add('rqd-toggle--done');
        var checkEl = toggleEl.querySelector('.rqd-toggle__check');
        if (checkEl) checkEl.innerHTML = '&#10003;';
      }
      try {
        await API.post('/quote-lifecycle', payload);
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        if (q) {
          q[dateField] = newDate;
          if (wasUndone && newDate && toggleField) q[toggleField] = true;
        }
        if (toggleEl && wasUndone && newDate && typeof refreshProgressBar === 'function') {
          refreshProgressBar(ref);
        }
      } catch (err) {
        console.error('Failed to save toggle date:', err);
        // Revert optimistic UI on failure.
        dateInput.classList.toggle('rqd-toggle__date-input--filled', prevFilled);
        if (toggleEl) {
          toggleEl.classList.toggle('rqd-toggle--done', !!prevDone);
          var checkBack = toggleEl.querySelector('.rqd-toggle__check');
          if (checkBack) checkBack.innerHTML = prevCheck || '';
        }
      }
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Phase 3.5 Phase 1.5:
       leadSource dropdown on code-attributed online orders' Commission card.
       Posts to /quote-lifecycle which (with status='sold' present on the
       lifecycle record) triggers commission compute via the
       lifecycle.financials fallback path. Quick refresh so admin sees
       the recomputed Commission value + the ⚠ badge clear without a
       manual reload. */
    tbody.addEventListener('change', async function (e) {
      var sel = e.target.closest('.rqd-attr-leadsource');
      if (!sel) return;
      var ref = sel.dataset.ref;
      var newLeadSource = sel.value;
      if (!ref) return;
      sel.disabled = true;
      var prev = sel.dataset.prevValue || '';
      try {
        await API.post('/quote-lifecycle', { ref: ref, leadSource: newLeadSource || null });
        sel.dataset.prevValue = newLeadSource;
        // Update local q so the next detail re-render reflects the new state
        // without a network refetch.
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        if (q) {
          q.leadSource = newLeadSource || null;
          q.needsLeadSourceSetup = !!(q.attribution && q.attribution.method === 'discount-code' && !newLeadSource);
        }
        sel.style.outline = '2px solid var(--rq-success, #22c55e)';
        setTimeout(function () { sel.style.outline = ''; sel.disabled = false; }, 1200);
        // Pull a fresh /rep-quotes load so commission card + badge update.
        if (typeof fetchQuotes === 'function') fetchQuotes();
      } catch (err) {
        console.error('Failed to save leadSource:', err);
        sel.value = prev;
        sel.style.outline = '2px solid var(--rq-error, #ef4444)';
        setTimeout(function () { sel.style.outline = ''; sel.disabled = false; }, 2000);
      }
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — Quote Alias supplier picker on a Purchasing
       row. A quote name claimed by two suppliers cannot be resolved by the Vendor Guide, so the
       admin answers it here and the answer is stored on the deal — the PO, the freight request and
       the vendor email all read it back. Re-renders the detail panel from the response rather than
       refetching: the gate on Generate PO and the freight buttons has to lift in the same beat as
       the pick, and a full /rep-quotes round trip reads as a dead click. */
    /* CUSTOM_DDFREIGHTCARD_BY_CLAUDE (Ryan 2026-08-29) — the Freight / Installation cards' selects
       and tickboxes. Admin-gated at the delegate, like every other mutation route on this table. */
    tbody.addEventListener('change', function (e) {
      if (!isAdmin) return;
      if (window.RQD && window.RQD.handleFreightCardChange) {
        window.RQD.handleFreightCardChange(e.target);
      }
    });
    /* Live recompute of the charged figure as the cost or markup is typed. Deliberately `input`,
       not `change`: `change` fires on blur, which is far too late for "the output should react as I
       delete characters". Purely local arithmetic — no request, no re-render, nothing saved until
       the floppy — so running it on every keystroke is free. */
    tbody.addEventListener('input', function (e) {
      if (!isAdmin) return;
      if (window.RQD && window.RQD.handleFreightCardInput) {
        window.RQD.handleFreightCardInput(e.target);
      }
    });
    /* Auto-save a Freight/Installation breakdown row once focus leaves it. `focusin`/`focusout`
       rather than `focus`/`blur` because only the former bubble, so one delegate on the table
       serves every expanded deal. relatedTarget is what distinguishes "moved to the next field in
       this row" from "done with this row". */
    tbody.addEventListener('focusin', function (e) {
      if (!isAdmin) return;
      if (window.RQD && window.RQD.handleFreightCardFocusIn) {
        window.RQD.handleFreightCardFocusIn(e.target);
      }
    });
    tbody.addEventListener('focusout', function (e) {
      if (!isAdmin) return;
      if (window.RQD && window.RQD.handleFreightCardFocusOut) {
        window.RQD.handleFreightCardFocusOut(e.target, e.relatedTarget);
      }
    });

    tbody.addEventListener('change', async function (e) {
      var pick = e.target.closest('.rqd-po-vendor-pick');
      if (!pick) return;
      var pRef = pick.getAttribute('data-ref');
      var pVendor = pick.getAttribute('data-vendor');
      if (!pRef || !pVendor) return;
      pick.disabled = true;
      try {
        var resp = await API.post('/vendor-po-target', {
          ref: pRef, vendor: pVendor, poVendor: pick.value || ''
        });
        var pq = allQuotes.find(function (x) { return x.reference === pRef; });
        if (pq) {
          pq.ordering = pq.ordering || {};
          pq.ordering[pVendor] = (resp && resp.ordering) || {};
          var pDetail = document.getElementById('rqd-detail-' + pRef);
          if (pDetail) {
            pDetail.innerHTML = buildDetailHtml(pq);
            applyCollapseState(pDetail, pq);
          }
        }
      } catch (err) {
        // Re-enable rather than re-render: the select still holds what was picked, so the admin
        // can read the reason and try again without hunting for the row.
        pick.disabled = false;
        rqdAlert((err && err.message) ? err.message : 'Could not save the supplier for this row.');
      }
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    tbody.addEventListener('change', function (e) {
      var input = e.target.closest('.rqd-vendor-tracking__carrier');
      if (!input || input.tagName !== 'INPUT') return;
      var row = input.closest('.rqd-vendor-tracking');
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — carrier→URL recall now
         runs for OFFLINE rows too (was online-only). The urlInput existence
         check below is the real gate — offline rows now render the URL field,
         so picking a previously-used carrier auto-fills its remembered URL. */
      if (!row) return;
      var carrierVal = (input.value || '').trim();
      var urlInput = row.querySelector('.rqd-vendor-tracking__url');
      if (!urlInput) return;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — URL field is always
         visible now; carrier change no longer toggles visibility. Keep
         the memory-recall auto-fill so reps don't re-type previously-
         used URLs for the same carrier+tracking-# pair. Recall fires
         for any carrier (not just custom) since admin may want a
         memory-stored override for a recognized carrier too (e.g.
         FedEx Freight migrating to a new tracking site). */
      /* Ryan 2026-09-01: recall is no longer the only thing a carrier change may do
         to the URL, and "the box is empty" is no longer the only time it may act --
         a box still holding the PREVIOUS carrier's generated link is the case that
         put a dhl.com URL on a FedEx Freight shipment. syncAutofilledTrackingUrl
         runs the whole decision (deep-link map, then remembered override). */
      syncAutofilledTrackingUrl(row);
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    });

    // (Online order tracking-URL input is always visible now — there's no
    // "Other" sentinel since the carrier picker is a free-typed autocomplete.
    // Reps fill the URL whenever their typed carrier isn't on Shopify's
    // recognized list; the worker enforces this server-side.)

    // Show/hide "Other" text inputs + auto-save on dropdown change
    tbody.addEventListener('change', function(e) {
      /* Request-kind select fires on change. One listener serves BOTH surfaces —
         the ⚙ popover's picker and the on-row dropdown (CUSTOM_RFQPORTAL_BY_CLAUDE,
         Ryan 2026-07-23) — matched on the shared data-bucket-action rather than
         either one's class. */
      var bucketKindSel = e.target.closest('select[data-bucket-action="change-kind"]');
      if (bucketKindSel) {
        var bktRef = bucketKindSel.dataset.ref || '';
        var bktId = bucketKindSel.dataset.bucket || '';
        var newKind = bucketKindSel.value || '';
        saveBucketRequestKind(bktRef, bktId, newKind, bucketKindSel.dataset.supplier || ''); // supplier: CUSTOM_ALTSHIP_BY_CLAUDE
        return;
      }
      // Full margin toggle on the Financials card. Persists in localStorage
      // and re-renders every open detail panel so the change is visible
      // across all expanded rows immediately.
      var finToggle = e.target.closest('[data-fin-toggle="full-margin"]');
      if (finToggle) {
        try {
          if (finToggle.checked) localStorage.setItem('dashboard_fin_full_margin', 'true');
          else localStorage.removeItem('dashboard_fin_full_margin');
        } catch (_) {}
        // Re-render every open detail panel currently in the DOM.
        document.querySelectorAll('[id^="rqd-detail-"]').forEach(function (el) {
          var ref = el.id.replace(/^rqd-detail-/, '');
          var q = allQuotes.find(function (x) { return x.reference === ref; });
          if (q) { el.innerHTML = buildDetailHtml(q); applyCollapseState(el, q); }
        });
        return;
      }
      var carrierSel = e.target.closest('.rqd-vendor-tracking__carrier');
      if (carrierSel) {
        var otherInput = carrierSel.parentElement.querySelector('.rqd-vendor-tracking__carrier-other');
        if (otherInput) otherInput.style.display = carrierSel.value === 'Other' ? '' : 'none';
      }
      var typeSel = e.target.closest('.rqd-vendor-tracking__type');
      if (typeSel) {
        var otherInput = typeSel.parentElement.querySelector('.rqd-vendor-tracking__type-other');
        if (otherInput) otherInput.style.display = typeSel.value === 'Other' ? '' : 'none';
      }
      // Auto-save on any tracking field change
      var row = e.target.closest('.rqd-vendor-tracking');
      if (row) {
        // If this is an install form, auto-save install instead
        if (row.classList.contains('rqd-install-form')) {
          handleInstallSave(e.target);
        } else {
          updateTrackingRemoveVisibility(row);  // immediate × toggle
          scheduleTrackingSave(row);
        }
      }
      // Payment row progressive reveal + save only when complete
      var pmtMethodSel = e.target.closest('.rqd-payment-method');
      if (pmtMethodSel) {
        var pmtRow = pmtMethodSel.closest('.rqd-payment-row');
        if (pmtRow) {
          // Show amount input when method is selected
          var amtInput = pmtRow.querySelector('.rqd-payment-amount');
          if (amtInput && pmtMethodSel.value) {
            amtInput.style.display = '';
            amtInput.focus();
          }
          maybeAutoSavePaymentRow(pmtRow);
        }
      }
      var pmtDateInput = e.target.closest('.rqd-payment-date');
      if (pmtDateInput) {
        var pmtRow = pmtDateInput.closest('.rqd-payment-row');
        if (pmtRow) maybeAutoSavePaymentRow(pmtRow);
      }
      /* CUSTOM_ABBY_BY_CLAUDE (Ryan 2026-07-23) — Expected ship date on the AR/AP
         Payments card. Saving it is what schedules Abby's balance-request email to
         the customer (10 days prior) and cancels her weekly nudges to Ryan. */
      var esdInput = e.target.closest('.rqd-expected-ship-date');
      if (esdInput) saveExpectedShipDate(esdInput);
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (AIOPS 1c5409fdb018 + fc5b7ad0298d, 2026-09-02) */
      /* CUSTOM_READYBY_BY_CLAUDE (AIOPS adefb81882f0, 2026-09-11) - the window input saves the same
         way the date does; leaving it out of this list is how it would look editable and never store. */
      /* CUSTOM_READYBY_BY_CLAUDE (AIOPS b641360cdb02, 2026-09-16) — `.rqd-vendor-eta-date2` is the
         second half of a window and belongs in this list for the same reason the label input did:
         an input that looks editable and never stores is worse than one that is not there. */
      /* CUSTOM_CUSTWINDOW_BY_CLAUDE (Ryan 2026-10-02) — the Customer window row borrows the
         vendor-eta date-box classes for its look, so it is claimed HERE, before the vendor-eta
         match below could send its dates to saveVendorEta as a supplier called "". */
      var cwInput = e.target.closest('.rqd-cust-window-row input');
      if (cwInput) {
        cwInput.classList.toggle('rqd-vendor-eta-date--empty', !cwInput.value);
        var _cwWrap = cwInput.closest('.rqd-eta-datewrap');
        if (_cwWrap) _cwWrap.classList.toggle('rqd-eta-datewrap--empty', !cwInput.value);
        saveCustomerWindow(cwInput.closest('.rqd-cust-window-row'));
      }
      var veInput = e.target.closest('.rqd-vendor-eta-date, .rqd-vendor-eta-date2, .rqd-vendor-eta-note, .rqd-vendor-eta-label');
      if (cwInput) veInput = null; // CUSTOM_CUSTWINDOW_BY_CLAUDE - handled above, never a supplier's row
      /* CUSTOM_READYBYUI_BY_CLAUDE (Ryan 2026-09-19) — keep the "Start"/"End" placeholder state in
         step with the value. The class is what hides the browser's mm/dd/yyyy and draws the word
         instead (dashboard.css), so a stale one would leave a real date hidden behind "Start".
         ⚠️ BEFORE the save, not after: the save is async and a failed round trip must not leave the
         box lying about what is typed in it. */
      if (veInput && veInput.classList.contains('rqd-vendor-eta-date')) {
        veInput.classList.toggle('rqd-vendor-eta-date--empty', !veInput.value);
        /* ⛔ THE WRAPPER CARRIES THE STATE THE WORD IS DRAWN FROM. The input's own class still
           dims the native mm/dd/yyyy, but "Start"/"End" is a span reached by DESCENT from the
           wrapper — keeping only the input in step would leave the word showing over a date
           somebody just typed. */
        var _veWrap = veInput.closest('.rqd-eta-datewrap');
        if (_veWrap) _veWrap.classList.toggle('rqd-eta-datewrap--empty', !veInput.value);
      }
      if (veInput) saveVendorEta(veInput.closest('.rqd-vendor-eta-row'));
      /* CUSTOM_DDCARDCOUNT_BY_CLAUDE (Ryan 2026-09-26) — a DATED row ghosts every box, the unused End box
         too (the render's `--answered`). The Start box decides: a firm date, or a window's first day.
         After the save call on purpose: the look is synchronous either way, and
         tests/vendor-ready-row-ui-tests.mjs reads the save call within a fixed window of this block. */
      if (veInput) {
        var _veRow = veInput.closest('.rqd-vendor-eta-row');
        var _veStartEl = _veRow && _veRow.querySelector('.rqd-vendor-eta-date:not(.rqd-vendor-eta-date2)');
        if (_veRow) _veRow.classList.toggle('rqd-vendor-eta-row--answered', !!(_veStartEl && _veStartEl.value));
      }
    });

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (AIOPS 1c5409fdb018 + fc5b7ad0298d, 2026-09-02)
       Save the vendor's own ready-date. Deliberately a SIBLING of saveExpectedShipDate rather
       than a branch inside it: that one schedules a customer balance email and this one triggers
       nothing, and a shared function is how those two behaviours end up one `if` apart.

       ⛔ `asOf` IS STAMPED HERE, NOT TYPED. The date is read off a vendor-portal screenshot, so
       "as of" is simply when you looked — today. Asking for it as a third input would get it left
       blank, and a vendor date with no as-of cannot be aged, which is the whole point of the
       second suggestion. An API caller (Elon, transcribing an older screenshot) can still send an
       explicit asOf; the worker takes what it is given. */
    async function saveVendorEta(row) {
      if (!row) return;
      var ref = row.dataset.ref;
      /* ⛔ The vendor is on the ROW, and it is what makes this a patch rather than a clobber: the
         worker merges this one entry into the deal's per-vendor map and leaves the others alone. */
      var vendor = row.dataset.vendor || '';
      var dateEl = row.querySelector('.rqd-vendor-eta-date');
      var noteEl = row.querySelector('.rqd-vendor-eta-note');
      /* CUSTOM_READYBY_BY_CLAUDE (AIOPS adefb81882f0, Ryan 2026-09-11) — the supplier's own words,
         for when they did not give a date. RW-1339-A: FerusPrime answered "early October". */
      var labelEl = row.querySelector('.rqd-vendor-eta-label');
      /* CUSTOM_READYBY_BY_CLAUDE (AIOPS b641360cdb02, Ryan 2026-09-16) — the second half of a
         window. Empty means the first box is a firm date, which is every row that existed before
         this shipped. */
      var date2El = row.querySelector('.rqd-vendor-eta-date2');
      var indicator = row.querySelector('.rqd-vendor-eta-saved');
      var val = (dateEl && dateEl.value) || '';
      var val2 = (date2El && date2El.value) || '';
      var label = (labelEl && labelEl.value || '').trim();
      /* CUSTOM_READYBYUI_BY_CLAUDE (Ryan 2026-09-19) — ⛔ NO INPUT MEANS KEEP WHAT IS STORED, NOT
         CLEAR IT. The note field was removed from the row (Ryan: "get rid of the note field"), and
         `noteEl && noteEl.value || ''` evaluates to '' when the element is gone — which the worker
         then writes back as `null`, because lib/vendor-ready-by.js REBUILDS the whole entry rather
         than patching the fields it was handed. So simply deleting the input would have silently
         deleted the stored note on the first save of every row: RW-1317-C's ECORE entry carries
         one from AIOPS reading the supplier portal's ship date, and nothing could reconstruct it.
         ⚠️ The fallback is the LOADED record, not a second fetch — the same `allQuotes` entry this
         function already patches thirty lines down, so there is no new round trip and no new
         source of truth. An input that still exists (an older cached asset mid-deploy) still wins,
         which is what makes this safe to ship while both versions are in the wild. */
      var note;
      if (noteEl) {
        note = (noteEl.value || '').trim();
      } else {
        var _qNote = allQuotes.find(function (x) { return x.reference === ref; });
        var _veNote = _qNote && _qNote.vendorEta && _qNote.vendorEta[vendor];
        note = ((_veNote && _veNote.note) || '').trim();
      }
      /* ⛔ SAID HERE, BEFORE THE ROUND TRIP. The worker refuses `end` before `start` with a 400 and
         the catch below would surface it as "Not saved" with no clue which box was wrong. A rep
         half-way through typing the pair backwards deserves the sentence, not the refusal. */
      if (val && val2 && val2 < val) {
        if (indicator) indicator.textContent = 'Not saved';
        rqdAlert('The second date is before the first. A window runs from the earlier date to the later one.');
        return;
      }
      if (!val && val2) {
        if (indicator) indicator.textContent = 'Not saved';
        rqdAlert('A window needs both dates. Fill in the first one, or clear the second and the row records the supplier’s words instead.');
        return;
      }
      if (indicator) indicator.textContent = 'Saving...';
      try {
        /* Clearing the DATE clears the whole field — a note about a date that no longer exists is
           a sentence with nothing to attach to. Sent as null, which is what the worker's validator
           expects for a clear. */
        /* Always names the vendor, even when clearing: an empty date on a named vendor removes
           THAT entry and leaves the deal's other suppliers untouched. */
        /* ⛔ A TYPED DATE OUTRANKS THE WORDS. Both inputs can be filled; if somebody pinned a firm
           date the supplier has committed to, that is the better answer and the label becomes
           decoration. The worker reads `date` first for exactly this reason. */
        var _answered = !!(val || label);
        /* CUSTOM_READYBY_BY_CLAUDE (AIOPS b641360cdb02, Ryan 2026-09-16) — A WINDOW IS SENT AS
           `{start, end}` AND NEVER ALONGSIDE `date`. The worker's normaliseReadyBy reads `date`
           FIRST and stops, so a payload carrying both would silently store the pair as a firm date
           on the start day — the opposite of what the rep typed, and unreported.
           ⚠️ The label rides along with a window rather than being dropped: "the 6th to the 13th,
           they said the week of the 6th" is two facts and both are worth keeping. */
        var _isWindow = !!(val && val2 && val2 !== val);
        var payload = {
          vendor: vendor,
          date: _isWindow ? null : (val || null),
          start: _isWindow ? val : null,
          end: _isWindow ? val2 : null,
          label: ((_isWindow || !val) && label) || null,
          asOf: _answered ? new Date().toISOString().slice(0, 10) : null,
          note: (_answered && note) || null,
          source: 'portal',
        };
        await API.post('/quote-lifecycle', { ref: ref, vendorEta: payload });
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        /* ⚠ Patch the local MAP, never replace it. This row knows its own vendor and nothing about
           the others, so assigning the payload wholesale is how a second supplier's date vanishes
           from the screen while still being stored. */
        if (q) {
          var _m = (q.vendorEta && typeof q.vendorEta === 'object') ? Object.assign({}, q.vendorEta) : {};
          /* ⚠️ The local patch cannot PARSE the label — that is the worker's job — so a window
             saved here shows its words until the next load fills in the dates. Storing a guessed
             window client-side would be a second parser, and the one that drifts. */
          /* CUSTOM_READYBY_BY_CLAUDE (2026-09-16) — a typed window is the one shape this CAN patch
             faithfully without a parser: the rep gave us both ends, so `start`, `end` and the
             `date` the worker derives from them are all known here. `precision` is deliberately
             absent — that is a word the worker reads out of a LABEL, and guessing one client-side
             would put "early Oct" on a window nobody described that way. */
          if (_isWindow) _m[vendor] = { kind: 'range', date: val2, start: val, end: val2, label: label || null, asOf: payload.asOf, note: payload.note };
          else if (val) _m[vendor] = { kind: 'firm', date: val, label: null, asOf: payload.asOf, note: payload.note };
          else if (label) _m[vendor] = { kind: 'range', date: null, label: label, asOf: payload.asOf, note: payload.note };
          else delete _m[vendor];
          q.vendorEta = Object.keys(_m).length ? _m : null;
        }
        row.classList.toggle('rqd-vendor-eta-row--set', _answered);
        if (indicator) {
          indicator.textContent = _answered ? 'Saved' : 'Cleared';
          setTimeout(function () { if (indicator) indicator.textContent = ''; }, 2500);
        }
      } catch (err) {
        /* Said out loud. A silent failure here leaves a date on screen that is not stored, and the
           next person to open the card would see it vanish with no explanation. */
        if (indicator) indicator.textContent = 'Not saved';
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-15) — was a native alert(). NOT awaited,
           and that is the documented rule rather than an oversight: this is the last statement in
           the block, so nothing runs underneath the notice and fire-and-forget is exactly
           equivalent to the blocking dialog it replaces. See the note on rqdAlert. */
        rqdAlert('Could not save the vendor ready date: ' + ((err && err.message) || 'unknown error'));
      }
    }

    /* CUSTOM_CUSTWINDOW_BY_CLAUDE (Ryan 2026-10-02, RW-1380-B) — save the customer's DELIVERY window.
       Both boxes go up together on every change (the worker stores the pair as one value, so a
       one-box patch would need a merge rule for nothing). Both empty = cleared. Triggers nothing
       but one Deal Feed line; the worker refuses a reversed pair, said here first in plain words. */
    async function saveCustomerWindow(row) {
      if (!row) return;
      var ref = row.dataset.ref;
      var eEl = row.querySelector('.rqd-cust-window-earliest');
      var lEl = row.querySelector('.rqd-cust-window-latest');
      var indicator = row.querySelector('.rqd-cust-window-saved');
      var earliest = (eEl && eEl.value) || '';
      var latest = (lEl && lEl.value) || '';
      if (earliest && latest && latest < earliest) {
        if (indicator) indicator.textContent = 'Not saved';
        rqdAlert('Latest is before Earliest. The window runs from the first day the customer can take delivery to the last.');
        return;
      }
      if (indicator) indicator.textContent = 'Saving...';
      var payload = (earliest || latest) ? { earliest: earliest || null, latest: latest || null } : null;
      /* CUSTOM_SUPPWINDOW_BY_CLAUDE (Ryan 2026-10-09) - a supplier's row (data-vendor) saves THAT supplier's window;
         both empty removes it and the order's window applies again. */
      var vendor = row.dataset.windowVendor || '';
      try {
        await API.post('/quote-lifecycle', { ref: ref, customerWindow: vendor ? { vendor: vendor, earliest: earliest || null, latest: latest || null } : payload });
        /* CUSTOM_WINDOWSTICK_BY_CLAUDE (Ryan 2026-10-09, SHOP-2128) - the date showed, then the card repainted blank 3s
           later from an older board copy, and a hard refresh read the server's cached copy. Now: every cached copy is
           patched and the change is held over a stale repaint until the server agrees (the No Balance rule), and a
           quiet forced refetch refreshes the server's 3-minute copy (the worker answers only after the summary is
           rebuilt, so that refetch reads the new window). */
        var _q0 = allQuotes.find(function (x) { return x.reference === ref; }); // CUSTOM_QUOTEDWINDOW_BY_CLAUDE - the worker keeps the note on a dates-only save; so does the cached copy
        var _keptNote = (!vendor && _q0 && _q0.customerWindow && _q0.customerWindow.note) || null;
        var _stamp = payload ? { earliest: payload.earliest, latest: payload.latest, note: vendor ? null : _keptNote, at: new Date().toISOString() } : null;
        var _sameDates = function (a, b) { return (a ? (a.earliest || '') + '|' + (a.latest || '') : '') === (b ? (b.earliest || '') + '|' + (b.latest || '') : ''); };
        stickCardWrite('cust-window:' + ref + ':' + vendor, ref, function (x) {
          if (vendor) {
            x.customerWindows = Object.assign({}, x.customerWindows || {});
            if (_stamp) x.customerWindows[vendor] = _stamp; else delete x.customerWindows[vendor];
          } else {
            x.customerWindow = _stamp;
          }
        }, function (x) {
          var cur = vendor ? ((x && x.customerWindows) || {})[vendor] : (x && x.customerWindow);
          return _sameDates(cur || null, _stamp);
        });
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        try { fetchQuotes({ quiet: true, force: true }); } catch (_) {}
        var set = !!payload;
        /* CUSTOM_WINDOWGHOST_BY_CLAUDE (Ryan 2026-10-09) - one save can change every window row on the card (a supplier
           filling in its own window fades the order row once all have one; clearing it shows the order's dates again),
           so every window row in this card is redrawn from the updated deal. */
        var _box = row.parentElement;
        if (q && _box && window.RQD && typeof window.RQD.renderCustomerWindowRow === 'function') {
          Array.prototype.slice.call(_box.querySelectorAll('.rqd-cust-window-row')).forEach(function (r) {
            var tmp = document.createElement('div');
            tmp.innerHTML = window.RQD.renderCustomerWindowRow(q, r.dataset.shipped === '1', r.dataset.windowVendor || '');
            var fresh = tmp.firstElementChild;
            if (fresh) { r.parentNode.replaceChild(fresh, r); if (r === row) { row = fresh; indicator = fresh.querySelector('.rqd-cust-window-saved'); } }
          });
        }
        if (indicator) {
          indicator.textContent = set ? 'Saved' : 'Cleared';
          setTimeout(function () { if (indicator) indicator.textContent = ''; }, 2500);
        }
      } catch (err) {
        if (indicator) indicator.textContent = 'Not saved';
        rqdAlert('Could not save the customer window: ' + ((err && err.message) || 'unknown error'));
      }
    }
    /* END CUSTOM_CUSTWINDOW_BY_CLAUDE */

    async function saveExpectedShipDate(input) {
      var row = input.closest('.rqd-expected-ship-row');
      if (!row) return;
      var ref = row.dataset.ref;
      var indicator = row.querySelector('.rqd-expected-ship-saved');
      var val = input.value || '';
      if (indicator) indicator.textContent = 'Saving...';
      try {
        await API.post('/quote-lifecycle', { ref: ref, expectedShipDate: val });
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        if (q) q.expectedShipDate = val || null;
        if (indicator) {
          indicator.textContent = val ? 'Saved' : 'Cleared';
          setTimeout(function () { if (indicator) indicator.textContent = ''; }, 2500);
        }
        // Reflect the completed state without a full re-render (which would
        // collapse the card the admin is working in). Parent-row chrome:
        // .rqd-payment-check fill + tick, same as the Payments row above it.
        var check = row.querySelector('.rqd-payment-check');
        if (check) {
          check.classList.toggle('rqd-payment-check--full', !!val);
          var fill = check.querySelector('.rqd-payment-check__fill');
          if (fill) fill.style.height = val ? '100%' : '0%';
          var icon = check.querySelector('.rqd-payment-check__icon');
          if (val && !icon) {
            icon = document.createElement('span');
            icon.className = 'rqd-payment-check__icon';
            icon.innerHTML = '&#10003;';
            check.appendChild(icon);
          } else if (!val && icon) {
            icon.remove();
          }
        }
        // Filled → the input goes ghost, same as a completed payment row. Toggled
        // here because this handler updates in place rather than re-rendering.
        row.classList.toggle('rqd-expected-ship-row--set', !!val);
        var hint = row.parentNode && row.parentNode.querySelector('.rqd-expected-ship-hint');
        // 10 days mirrors BALANCE_LEAD_DAYS in the rfq-worker; keep the two in
        // step with the same string in dashboard-ar-ap-card.js.
        if (hint && val) hint.textContent = 'Balance request queues 10 days prior';
      } catch (err) {
        if (indicator) indicator.textContent = 'Failed';
        rqdAlert('Could not save the expected ship date: ' + (err && err.message ? err.message : 'unknown error'));
      }
    }

    // Tracking-number → carrier auto-detect. Mirrors how Shopify's fulfillment
    // form pre-fills the carrier from the typed number. Pattern order
    // matters — most-distinctive prefix matches run first, then falls
    // through to length-based heuristics. The 12-digit / 15-digit FedEx
    // patterns are the same defaults Shopify uses (FedEx Express / FedEx
    // Ground respectively); occasional false-positive on a regional USPS
    // or carrier-specific number is the trade-off for matching Shopify's
    // behavior. The rep can always overwrite the autofill manually.
    function detectCarrierFromTracking(raw) {
      var s = (raw || '').replace(/\s+/g, '').toUpperCase();
      if (!s) return '';
      // 1. Letter-prefixed (most distinctive — no length collisions)
      if (/^1Z[0-9A-Z]{16}$/.test(s)) return 'UPS';                  // UPS standard
      if (/^TBA\d{12,}$/.test(s)) return 'Amazon Logistics';
      if (/^[A-Z]{2}\d{9}US$/.test(s)) return 'USPS';                // International
      if (/^D10\d{12}$/.test(s) || /^C\d{14}$/.test(s)) return 'OnTrac';
      // 2. Digit-only with strong prefix
      if (/^9612\d{18}$/.test(s)) return 'FedEx';                    // SmartPost (more specific than 22-digit USPS)
      if (/^9[2-5]\d{20}$/.test(s)) return 'USPS';                   // 22-digit Priority/Express
      // 3. Length-based fallback (matches Shopify's defaults)
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-01) - the 10-digit case used to
         return 'DHL Express'. It is genuinely ambiguous: a DHL Express AWB and a
         FedEx Freight PRO are BOTH 10 digits, and Blue Sky ships FedEx Freight
         constantly while DHL Express is ~never. Guessing wrong here is not a
         harmless default -- the guessed carrier name auto-fills the row, gets
         normalized for Shopify, and reaches the customer email. So we guess
         nothing and let the rep pick; every other length below is unambiguous. */
      if (/^\d{12}$/.test(s)) return 'FedEx';                        // FedEx Express 12-digit
      if (/^\d{15}$/.test(s)) return 'FedEx';                        // FedEx Ground 15-digit
      if (/^\d{20}$/.test(s)) return 'FedEx';                        // FedEx 96-prefix (older 20-digit)
      return '';
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — client-side carrier tracking
       deep-link builder, so the Tracking URL field auto-fills when a known carrier
       is detected/entered (the rep sees + can edit the link instead of a blank box).
       MUST stay in sync with the worker's canonical map: rfq-worker
       src/lib/tracking-urls.js. When adding/fixing a carrier ("better tracking link
       for X"), update BOTH this and that file. `verified` carriers confirmed to deep-
       link; others are best-guess until tested. */
    function buildTrackingUrlClient(carrier, trackingNumber) {
      var c = String(carrier || '').toLowerCase().trim();
      var n = String(trackingNumber || '').trim();
      if (!c || !n) return '';
      var t = encodeURIComponent(n);
      // Parcel (FedEx unified tracking also resolves FedEx Freight PROs).
      if (c.indexOf('fedex') !== -1) return 'https://www.fedex.com/fedextrack/?tracknumbers=' + t;            // verified
      if (c === 'ups' || c.indexOf('ups ') === 0) return 'https://www.ups.com/track?tracknum=' + t;           // verified
      if (c === 'usps' || c.indexOf('usps ') === 0) return 'https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum=' + t; // verified
      if (c.indexOf('dhl') !== -1) return 'https://www.dhl.com/us-en/home/tracking.html?tracking-id=' + t;    // UNVERIFIED
      if (c.indexOf('ontrac') !== -1) return 'https://www.ontrac.com/tracking?number=' + t;                   // UNVERIFIED
      // LTL freight (track by PRO #) — UNVERIFIED best-guess; paste-test before relying.
      if (c.indexOf('abf') !== -1 || c.indexOf('arcbest') !== -1) return 'https://arcb.com/tools/tracking.html#/' + t;
      if (c.indexOf('estes') !== -1) return 'https://www.estes-express.com/myestes/tracking/shipments?type=PRO&query=' + t;
      if (c.indexOf('old dominion') !== -1 || c === 'odfl') return 'https://www.odfl.com/Trace/standardResult.faces?pro=' + t;
      if (c.indexOf('r+l') !== -1 || c.indexOf('r&l') !== -1 || c.indexOf('rl carriers') !== -1) return 'https://www2.rlcarriers.com/freight/shipping/shipment-tracing?pro=' + t + '&docType=PRO';
      if (c.indexOf('saia') !== -1) return 'https://www.saiasecure.com/tracing/n_manifest.asp?link=y&pro=' + t;
      if (c.indexOf('roadrunner') !== -1 || c.indexOf('rrts') !== -1) return 'https://tools.rrts.com/LTLTrack/?searchValues=' + t;
      if (c.indexOf('tforce') !== -1) return 'https://www.tforcefreight.com/ltl/apps/Tracking?proNumbers=' + t;
      if (c.indexOf('xpo') !== -1) return 'https://ext-web.ltl-xpo.com/public-app/shipments?referenceNumber=' + t;
      return '';
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-01) - "is this URL one WE built?"
       The auto-fill used to mark its own work with a data-autofilled attribute,
       which is the right idea but dies at every re-render: the URL comes back
       from the save as a plain value, so a generated link that survived one
       round-trip could never be corrected again. This asks the question about
       the VALUE instead, so the answer survives re-render, reload and recall.

       Two tests, because a generated URL outlives the number it was built with
       (recalled from memory before the rep types one, re-rendered from a save):
         a. exact match against the link we would build for this number, and
         b. shape match -- same prefix/suffix around the number slot, any number
            or none. A hand-pasted URL in that exact shape is byte-identical to
            what we would build anyway, so claiming it costs nothing.
       A URL failing BOTH is the rep's own, and we never touch it. */
    function isGeneratedTrackingUrl(url, trackingNumber) {
      var u = String(url || '').trim();
      if (!u) return false;
      var num = String(trackingNumber || '').trim();
      // One probe per branch of buildTrackingUrlClient above. Adding a carrier
      // there means adding its key here, or its links stop being recognized as
      // ours and go stale on screen.
      var probes = ['fedex', 'ups', 'usps', 'dhl', 'ontrac', 'abf', 'estes',
                    'old dominion', 'r+l', 'saia', 'roadrunner', 'tforce', 'xpo'];
      for (var i = 0; i < probes.length; i++) {
        if (num && buildTrackingUrlClient(probes[i], num) === u) return true;
        var shape = buildTrackingUrlClient(probes[i], 'TRACKINGSENTINEL');
        if (!shape) continue;
        var parts = shape.split('TRACKINGSENTINEL');
        if (parts.length !== 2) continue;
        if (u.length < parts[0].length + parts[1].length) continue;
        if (u.indexOf(parts[0]) === 0 &&
            u.slice(u.length - parts[1].length) === parts[1]) return true;
      }
      return false;
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-01) - the single owner of the
       auto-filled Tracking URL. Every input that can change what the right URL
       is -- the carrier AND the number -- calls this; before, only the number
       did, so correcting a wrongly-detected carrier left the WRONG carrier's
       link sitting in the box, and that link is what shipped to the customer.

       Precedence: our own deep-link map first, remembered override second (the
       override now only exists for carriers the map has no link for -- see
       rememberCarrierUrl). Leaves anything the rep typed themselves alone. */
    function syncAutofilledTrackingUrl(row) {
      if (!row) return;
      var urlEl = row.querySelector('.rqd-vendor-tracking__url');
      if (!urlEl || urlEl.disabled) return;
      var carrierEl = row.querySelector('.rqd-vendor-tracking__carrier');
      var numEl = row.querySelector('.rqd-vendor-tracking__input');
      var carrier = carrierEl ? (carrierEl.value || '').trim() : '';
      var num = numEl ? (numEl.value || '').trim() : '';
      var current = (urlEl.value || '').trim();
      var ours = urlEl.getAttribute('data-autofilled') === '1' ||
                 !current ||
                 isGeneratedTrackingUrl(current, num);
      if (!ours) return;
      var next = buildTrackingUrlClient(carrier, num) || recallCarrierUrl(carrier, num) || '';
      if (next === current) {
        if (next) urlEl.setAttribute('data-autofilled', '1');
        return;
      }
      urlEl.value = next;
      if (next) urlEl.setAttribute('data-autofilled', '1');
      else urlEl.removeAttribute('data-autofilled');
      // Synthetic (isTrusted false) on purpose -- the listener below treats a
      // TRUSTED input on this field as the rep taking the URL over.
      urlEl.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // Sample tracking number → carrier auto-detect. Mirrors the vendor-
    // tracking auto-detect: when admin pastes/types a tracking number into
    // the sample tracking row, sniff the format (UPS 1Z…, FedEx 12-digit,
    // USPS 22-digit, etc.) and pre-fill the carrier IF it's empty (never
    // overwrite a manual pick).
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — LINKED FILES card
       name-marquee on hover. When the name is truncated by ellipsis,
       hovering animates the inner span leftward inside the outer
       viewport so the cut-off text scrolls into view. Outer
       .rqd-linked-file__name has overflow:hidden, inner __name-text is
       inline-block sized to actual content — translating the inner
       reveals the hidden portion. Delegated handlers (mouseover/
       mouseout) since mouseenter doesn't bubble through event delegation. */
    /* Ryan 2026-05-21: same marquee pattern for email-entry subjects.
       Long subjects on emails get the viewport/scroller treatment so
       reps can read past the ellipsis on hover. */
    tbody.addEventListener('mouseover', function(e) {
      var sCard = e.target.closest && e.target.closest('.rqd-email-entry');
      if (!sCard) return;
      var wrap = sCard.querySelector('.rqd-email-entry__subject-wrap');
      var textEl2 = sCard.querySelector('.rqd-email-entry__subject-text');
      if (!wrap || !textEl2) return;
      wrap.setAttribute('data-marquee', '1');
      void textEl2.offsetWidth;
      var overflow2 = textEl2.scrollWidth - wrap.clientWidth;
      if (overflow2 <= 2) { wrap.removeAttribute('data-marquee'); return; }
      textEl2.style.transitionDuration = Math.max(2, overflow2 / 30) + 's';
      textEl2.style.transform = 'translateX(-' + overflow2 + 'px)';
    });
    tbody.addEventListener('mouseout', function(e) {
      var sCard = e.target.closest && e.target.closest('.rqd-email-entry');
      if (!sCard) return;
      var related = e.relatedTarget;
      if (related && sCard.contains(related)) return;
      var wrap = sCard.querySelector('.rqd-email-entry__subject-wrap');
      var textEl2 = sCard.querySelector('.rqd-email-entry__subject-text');
      if (!wrap || !textEl2) return;
      textEl2.style.transitionDuration = '0.4s';
      textEl2.style.transform = 'translateX(0)';
      setTimeout(function() { wrap.removeAttribute('data-marquee'); }, 420);
    });

    tbody.addEventListener('mouseover', function(e) {
      var card = e.target.closest && e.target.closest('.rqd-linked-file');
      if (!card) return;
      var nameEl = card.querySelector('.rqd-linked-file__name');
      var textEl = card.querySelector('.rqd-linked-file__name-text');
      if (!nameEl || !textEl) return;
      // Flag the outer FIRST so the CSS hover rule swaps ellipsis → clip
      // and lets the inner break out of max-width:100% — needed before
      // measuring true scrollWidth (otherwise the inner is clamped and
      // overflow always reads 0).
      nameEl.setAttribute('data-marquee', '1');
      // Force layout flush so the un-clamped width is measurable.
      void textEl.offsetWidth;
      var overflow = textEl.scrollWidth - nameEl.clientWidth;
      if (overflow <= 2) {
        nameEl.removeAttribute('data-marquee');
        return;
      }
      // Duration scales with overflow distance (~30px/sec).
      textEl.style.transitionDuration = Math.max(2, overflow / 30) + 's';
      textEl.style.transform = 'translateX(-' + overflow + 'px)';
    });
    tbody.addEventListener('mouseout', function(e) {
      var card = e.target.closest && e.target.closest('.rqd-linked-file');
      if (!card) return;
      // Ignore movement within the same card (mouseout fires on every
      // child boundary).
      var related = e.relatedTarget;
      if (related && card.contains(related)) return;
      var nameEl = card.querySelector('.rqd-linked-file__name');
      var textEl = card.querySelector('.rqd-linked-file__name-text');
      if (!nameEl || !textEl) return;
      // Faster reset glide-back.
      textEl.style.transitionDuration = '0.4s';
      textEl.style.transform = 'translateX(0)';
      // Restore ellipsis after the slide-back completes so there's no
      // visual flash from clip→ellipsis happening mid-animation.
      setTimeout(function() { nameEl.removeAttribute('data-marquee'); }, 420);
    });

    tbody.addEventListener('input', function(e) {
      var sampleNumberInput = e.target.closest('.rqd-sample-tracking__number');
      if (!sampleNumberInput) return;
      var sampleRow = sampleNumberInput.closest('.rqd-sample-tracking');
      if (!sampleRow) return;
      var carrierEl = sampleRow.querySelector('.rqd-sample-tracking__carrier');
      if (!carrierEl || carrierEl.value.trim()) return;
      var detected = detectCarrierFromTracking(sampleNumberInput.value);
      if (detected) {
        carrierEl.value = detected;
        carrierEl.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    /* CUSTOM_SAMPLEURL_BY_CLAUDE (AIOPS 517090ebde9c, Ryan 2026-09-11)
       ============================================
       ⛔ IS THIS SAMPLE URL ONE OF OURS?
       ============================================
       The twin of `isGeneratedTrackingUrl` for the SAMPLE card, and it needs to exist because
       the two cards do not build the same link. `buildTrackingUrlClient` writes FedEx as
       `?tracknumbers=`; `sampleTrackingUrl` writes it as `?trknbr=`. Both are real FedEx
       tracking URLs, so neither is wrong — but asking the vendor question about a sample URL
       answers "the rep typed this" about a link we generated ourselves, and the field then
       freezes: change the carrier and the OLD carrier's link stays on screen, which is the
       failure `syncAutofilledTrackingUrl` was written to stop next door.
       ⚠️ It still defers to the vendor test at the end, so a URL in EITHER shape is recognised
       as ours — a rep who pasted the vendor-shaped FedEx link is not punished for it. */
    function isGeneratedSampleTrackingUrl(url, trackingNumber) {
      var u = String(url || '').trim();
      if (!u) return false;
      var num = String(trackingNumber || '').trim();
      // One probe per branch of sampleTrackingUrl above. Adding a carrier there
      // means adding its key here, or its links stop being recognised as ours.
      var probes = ['fedex', 'ups', 'usps', 'dhl'];
      for (var i = 0; i < probes.length; i++) {
        if (num && sampleTrackingUrl(probes[i], num) === u) return true;
        var shape = sampleTrackingUrl(probes[i], 'TRACKINGSENTINEL');
        if (!shape) continue;
        var parts = shape.split('TRACKINGSENTINEL');
        if (parts.length !== 2) continue;
        if (u.length < parts[0].length + parts[1].length) continue;
        if (u.indexOf(parts[0]) === 0 &&
            u.slice(u.length - parts[1].length) === parts[1]) return true;
      }
      /* A vendor-shaped link on a sample row is still ours. */
      return isGeneratedTrackingUrl(u, num);
    }

    /* CUSTOM_SAMPLEURL_BY_CLAUDE (AIOPS 517090ebde9c, Ryan 2026-09-11)
       ============================================
       ⛔ THE SINGLE OWNER OF THE SAMPLE CARD'S AUTO-FILLED TRACKING URL.
       ============================================
       What this replaces listened for `change` ON THE CARRIER ONLY, and refused to write unless
       the URL box was completely empty. Three things followed, and together they are the
       regression Ryan reported on RW-1350-A — *"the tracking URL used to auto-fill … after
       samples-tracking work ~1 week ago it no longer does"*:

         1. THE COMMON PATH NEVER FIRED. Typing a tracking number auto-detects the carrier and
            fills it in — the listener above does that — and it announces the change with a
            synthetic `input` event. This listener wanted `change`, so the whole detect-then-fill
            path, which is how a rep actually uses the card, filled a carrier and no URL.
         2. THE NUMBER DID NOT COUNT AS A CHANGE. Pick the carrier first, type the number second
            — the normal order — and nothing re-ran, so the URL stayed as whatever a carrier with
            no number could produce: a generic landing page, or nothing at all.
         3. A CORRECTED CARRIER LEFT THE WRONG LINK. `if (urlEl.value.trim()) return` meant the
            first link written was the last, so fixing a wrongly-detected carrier left the old
            carrier's URL in the box — and that box is what reaches the customer.

       ⛔ SO IT MIRRORS `syncAutofilledTrackingUrl`, DELIBERATELY, rather than inventing a second
       set of rules for the same job: every input that can change what the right URL is calls
       this, and it only ever overwrites a link WE generated. A URL the rep typed themselves
       fails `isGeneratedSampleTrackingUrl`, so it is left exactly alone.
       ⚠️ `data-autofilled` is the same marker the vendor row uses, and the trusted-input
       listener below is what hands the field back to a rep the moment they edit it. */
    function syncAutofilledSampleTrackingUrl(sampleRow) {
      if (!sampleRow) return;
      var urlEl = sampleRow.querySelector('.rqd-sample-tracking__url');
      if (!urlEl || urlEl.disabled) return;
      var carrierEl = sampleRow.querySelector('.rqd-sample-tracking__carrier');
      var numEl = sampleRow.querySelector('.rqd-sample-tracking__number');
      var carrier = carrierEl ? (carrierEl.value || '').trim() : '';
      var num = numEl ? (numEl.value || '').trim() : '';
      var current = (urlEl.value || '').trim();
      var ours = urlEl.getAttribute('data-autofilled') === '1' ||
                 !current ||
                 isGeneratedSampleTrackingUrl(current, num);
      if (!ours) return;
      /* The same heal-aware picker the render path uses, so admin starts with a deep link
         instead of a stale generic URL inherited from corrupted memory. */
      var next = bestSampleTrackingUrl('', carrier, num) || '';
      if (next === current) {
        if (next) urlEl.setAttribute('data-autofilled', '1');
        return;
      }
      urlEl.value = next;
      if (next) urlEl.setAttribute('data-autofilled', '1');
      else urlEl.removeAttribute('data-autofilled');
      // Synthetic (isTrusted false) on purpose - the listener below treats a
      // TRUSTED input on this field as the rep taking the URL over.
      urlEl.dispatchEvent(new Event('input', { bubbles: true }));
    }

    /* Both events, because the two ways a carrier arrives announce themselves differently: the
       auto-detect above dispatches `input`, and the carrier autocomplete's own pick fires
       `change`. Listening for one of them is exactly how this broke. */
    tbody.addEventListener('input', function(e) {
      var el = e.target.closest('.rqd-sample-tracking__number, .rqd-sample-tracking__carrier');
      if (!el) return;
      syncAutofilledSampleTrackingUrl(el.closest('.rqd-sample-tracking'));
    });
    tbody.addEventListener('change', function(e) {
      var el = e.target.closest('.rqd-sample-tracking__number, .rqd-sample-tracking__carrier');
      if (!el) return;
      syncAutofilledSampleTrackingUrl(el.closest('.rqd-sample-tracking'));
    });

    /* ⛔ THE REP TAKING THE FIELD OVER. Without this, a URL we auto-filled keeps its
       `data-autofilled` marker, so the rep's own edit would read as ours and be overwritten the
       next time they touched the carrier or the number. A TRUSTED input is a person typing;
       the synthetic one `syncAutofilledSampleTrackingUrl` dispatches is not, and must not
       hand the field away. */
    tbody.addEventListener('input', function(e) {
      var u = e.target.closest('.rqd-sample-tracking__url');
      if (!u || !e.isTrusted) return;
      u.removeAttribute('data-autofilled');
    });

    // Live currency formatting on payment amount inputs — commas while typing, full format on blur
    tbody.addEventListener('input', function(e) {
      // Show/hide the red × on the Shipping tracking row as soon as the rep
      // types the first character (don't wait for the 400ms save debounce).
      var trackingTextInput = e.target.closest('.rqd-vendor-tracking__input, .rqd-vendor-tracking__carrier, .rqd-vendor-tracking__carrier-other, .rqd-vendor-tracking__type-other, .rqd-vendor-tracking__url');
      if (trackingTextInput) {
        var trackingRow = trackingTextInput.closest('.rqd-vendor-tracking');
        if (trackingRow && !trackingRow.classList.contains('rqd-install-form')) {
          updateTrackingRemoveVisibility(trackingRow);
          // Tracking number → carrier auto-detect. Only fires when the input
          // event is on the tracking-number field AND the carrier field is
          // currently empty (so we never overwrite a rep's manual pick). The
          // existing focusout listener picks up the populated carrier and
          // saves both fields together.
          if (trackingTextInput.classList.contains('rqd-vendor-tracking__input')) {
            var carrierEl = trackingRow.querySelector('.rqd-vendor-tracking__carrier');
            var _carrierWasEmpty = carrierEl && !carrierEl.disabled && !carrierEl.value.trim();
            var detected = detectCarrierFromTracking(trackingTextInput.value);
            if (_carrierWasEmpty && detected) {
              carrierEl.value = detected;
              // Trigger a synthetic input event so the autocomplete menu /
              // URL-visibility / save-debounce path observes the new value
              // instead of treating it as a stale field.
              carrierEl.dispatchEvent(new Event('input', { bubbles: true }));
            }
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Auto-set Type
               to "Tracking #" when a parcel carrier is detected. Every
               carrier detectCarrierFromTracking can recognize (USPS, UPS,
               FedEx, DHL Express, OnTrac, Amazon Logistics) is a parcel
               carrier — they all use tracking numbers, never PRO/BOL/
               Shipment IDs. The non-parcel options ('PRO #', 'BOL #',
               etc.) only apply to LTL/freight carriers which the
               detector doesn't try to identify. Only fires when the
               Type select is currently empty so a manual pick is never
               overwritten. */
            if (detected) {
              var typeEl = trackingRow.querySelector('.rqd-vendor-tracking__type');
              if (typeEl && !typeEl.disabled && !typeEl.value.trim()) {
                typeEl.value = 'Tracking #';
                typeEl.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — auto-fill the Tracking URL
               field with the carrier deep-link as the number is typed, so the rep can
               eyeball / paste-test the link before sending (was blank for known carriers,
               which relied on the server to build it at send time).
               Ryan 2026-09-01: the decision moved into syncAutofilledTrackingUrl. This
               was its ONLY caller, which is exactly why fixing a wrong carrier could not
               fix the URL the wrong carrier had already written. */
            syncAutofilledTrackingUrl(trackingRow);
          }
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-01) — the carrier field drives the
             URL too. The autocomplete commits a pick by dispatching `input` on the
             carrier field, which never reached the URL logic before. */
          if (trackingTextInput.classList.contains('rqd-vendor-tracking__carrier')) {
            syncAutofilledTrackingUrl(trackingRow);
          }
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — a REAL edit of the URL field
             (trusted event, not our synthetic dispatch) means the rep took it over;
             stop auto-overwriting it as they keep typing the number. */
          if (trackingTextInput.classList.contains('rqd-vendor-tracking__url') && e.isTrusted) {
            trackingTextInput.removeAttribute('data-autofilled');
          }
        }
      }

      if (!e.target.closest('.rqd-payment-amount')) return;
      var input = e.target;
      var cursorPos = input.selectionStart;
      var prevLen = input.value.length;
      var raw = input.value.replace(/[^0-9.]/g, '');
      // Prevent multiple decimals
      var parts = raw.split('.');
      if (parts.length > 2) raw = parts[0] + '.' + parts.slice(1).join('');
      // Format: $ + commas on whole part, preserve decimal as-is (don't force .00)
      var wholePart = raw.split('.')[0] || '';
      var decPart = raw.includes('.') ? '.' + raw.split('.')[1] : '';
      var formatted = '$' + wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + decPart;
      input.value = formatted;
      // Adjust cursor for added/removed characters
      var newLen = formatted.length;
      var diff = newLen - prevLen;
      input.setSelectionRange(cursorPos + diff, cursorPos + diff);
    });

    // Auto-save tracking on text input blur
    tbody.addEventListener('focusout', function(e) {
      if (e.target.closest('.rqd-vendor-tracking__input') ||
          e.target.closest('.rqd-vendor-tracking__carrier') ||
          e.target.closest('.rqd-vendor-tracking__carrier-other') ||
          e.target.closest('.rqd-vendor-tracking__type-other') ||
          e.target.closest('.rqd-vendor-tracking__url')) {
        var row = e.target.closest('.rqd-vendor-tracking');
        if (row && !row.classList.contains('rqd-install-form')) {
          scheduleTrackingSave(row);
        } else if (row && row.classList.contains('rqd-install-form')) {
          handleInstallSave(e.target);
        }
      }
      // Payment amount blur — show date picker + check if ready to save
      if (e.target.closest('.rqd-payment-amount')) {
        var pmtRow = e.target.closest('.rqd-payment-row');
        if (pmtRow) {
          var amtVal = parseMoneyInput(e.target.value);
          if (amtVal > 0) {
            var dateInput = pmtRow.querySelector('.rqd-payment-date');
            if (dateInput) {
              dateInput.style.display = '';
              if (!dateInput.value) dateInput.value = todayStr(); // default to today
            }
          }
          maybeAutoSavePaymentRow(pmtRow);
        }
      }
      /* CUSTOM_FBCOSTSAVE_BY_CLAUDE (Ryan 2026-08-13) — the blur auto-save is GONE.
         Ryan: *"it's not clear if you need to press enter, click outside the box, just sit there
         and wait."* Committing on focusout gave the rep no moment where they knew the number was
         in, and it fired on every incidental click-away — including one mid-typing. The floppy
         button beside the input is now the only commit. */
    });

    /* CUSTOM_FBCOSTSAVE_BY_CLAUDE (Ryan 2026-08-13) — Keydown for bucket cost input.
       Enter presses the Save button rather than blurring, so the keyboard path and the mouse path
       run the exact same handler (a second save path is how the two drift). Escape restores the
       last-saved value and does NOT save. */
    tbody.addEventListener('keydown', function (e) {
      var inp = e.target.closest && e.target.closest('.rqd-fb__bucket-cost-input');
      if (!inp) return;
      if (e.key === 'Enter') {
        e.preventDefault();
        var wrap = inp.closest('.rqd-freight-cost-wrap');
        var saveBtn = wrap && wrap.querySelector('.rqd-freight-cost-save');
        if (saveBtn) saveBtn.click();
      } else if (e.key === 'Escape') {
        inp.value = inp.dataset.lastSaved || '';
        inp.blur();
      }
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Notes card v2:
       Enter is NO LONGER a submit shortcut. Save is the only path —
       gives reps a deliberate moment to confirm the note + follow-up
       choices before committing. The textarea uses default newline-on-
       Enter behavior. Auto-grow on input is preserved. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16, narrowed 2026-05-21) —
       Selective Save-button enable gate. Button is enabled IFF:
         1. Textarea has trimmed text (worker requires text), AND
         2. EITHER the row is closed (DEAD/SOLD/LOST/cancelled — no
            follow-up requirement), OR the active chip types are all
            non-asking (note/meeting/drop-in only — see Ryan 2026-05-21
            narrowing: calls + emails are outbound asks waiting on
            response, so they need a timer; observations don't), OR
            the row already has a follow-up set (q.followUp.dueAt /
            q.holdUntil), OR the rep has armed a new follow-up in the
            cluster (cluster.dataset.armedDate).
       Quieter UX than alert-on-submit — the rep SEES when Save is
       blocked. Called from textarea input, armFollowUp / clearFollowUp,
       AND chip-toggle handlers (Ryan 2026-05-21 added the chip sync so
       toggling Call/Email on a no-follow-up row instantly disables
       Save). Server has the matching gate. */
    function _syncSaveEnabled(card) {
      if (!card) return;
      var btn = card.querySelector('.rqd-notes-log__submit');
      if (!btn) return;
      var input = card.querySelector('.rqd-notes-log__input');
      var hasText = !!(input && input.value.trim());
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-16) — the "Save & Mark Lost/Dead"
         button only needs the note (it becomes the close-out reason) and bypasses
         the follow-up gate, so enable it purely on text presence. */
      var _coBtn = card.querySelector('.rqd-notes-log__closeout');
      if (_coBtn) _coBtn.disabled = !hasText;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-08) — Allow a FOLLOW-UP-ONLY save
         (no note typed) when the armed date DIFFERS from the deal's current follow-up,
         so a rep can quickly re-date a ticking follow-up without writing a note. The
         save handler auto-stamps a one-line audit note in that case. */
      if (!hasText) {
        var _fuClus = card.querySelector('.rqd-notes-log__followup');
        var _fuUser = _fuClus && _fuClus.dataset.userArmed === '1';
        var _fuArmed = _fuClus && _fuClus.dataset.armedDate;
        var _fuRef = btn.dataset.ref;
        var _fuQ = (typeof allQuotes !== 'undefined') ? allQuotes.find(function(x){ return x.reference === _fuRef; }) : null;
        var _fuCur = _fuQ ? String((_fuQ.followUp && _fuQ.followUp.dueAt) || _fuQ.holdUntil || '').slice(0, 10) : '';
        btn.disabled = !(_fuUser && _fuArmed && _fuArmed !== _fuCur);
        return;
      }
      var ref = btn.dataset.ref;
      var q = (typeof allQuotes !== 'undefined') ? allQuotes.find(function(x) { return x.reference === ref; }) : null;
      if (!q) { btn.disabled = false; return; }
      var isClosed = !!(q.isDeadLead || q.status === 'dead_lead'
        || q.lifecycleStatus === 'sold' || q.lifecycleStatus === 'lost'
        || q.cancelled);
      if (isClosed) { btn.disabled = false; return; }
      // Selective gate: only Call/Email types require a follow-up. If the
      // active chips are note-only / meeting / drop-in, allow save.
      var activeChips = card.querySelectorAll('.rqd-notes-log__types .rqd-notes-log__chip--active');
      var _needsFu = false, _callActive = false;
      for (var i = 0; i < activeChips.length; i++) {
        var t = activeChips[i].dataset.noteType;
        if (t === 'call') { _callActive = true; _needsFu = true; }
        else if (t === 'email') { _needsFu = true; }
      }
      /* Ryan 2026-05-29: a Call must have an outcome picked; Connected/Inbound
         (contact) needs no follow-up, No answer (chase) still does. Gated on the
         outcome selector existing so the prospect/quick composers are unaffected. */
      var _ocSel = card.querySelector('.rqd-notes-log__calloutcome');
      if (_callActive && _ocSel) {
        var _fin = _ocSel.dataset.finalOutcome;
        if (!_fin) { btn.disabled = true; return; }   // mid-tree — outcome not chosen yet
        // Ryan 2026-05-29: ALL call outcomes require a follow-up — fall through
        // to the _needsFu check below (Connected/Inbound auto-arm a default, so
        // it's satisfied unless the rep clears the date).
      }
      if (!_needsFu) { btn.disabled = false; return; }
      var hasExistingFu = !!((q.followUp && q.followUp.dueAt) || q.holdUntil);
      if (hasExistingFu) { btn.disabled = false; return; }
      var cluster = card.querySelector('.rqd-notes-log__followup');
      var armedDate = cluster && cluster.dataset.armedDate;
      btn.disabled = !armedDate;
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-16) — Composer "Save & Mark Lost/Dead".
       Logs the final activity (closeOut:true bypasses the follow-up gate), then flips
       the deal to LOST (quoted) via /quote-lifecycle or DEAD (lead) via /lead-mark-dead
       — reusing those canonical endpoints so their validation + side-effects (lead-dead
       eligibility gate, active-leads counter, transition feed entry) stay intact. The
       note text doubles as the lost/dead reason. */
    async function handleNoteCloseOut(btn) {
      var ref = btn.dataset.ref;
      if (!ref) return;
      var mode = btn.dataset.closeoutMode === 'lost' ? 'lost' : 'dead';
      var word = mode === 'lost' ? 'Lost' : 'Dead';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — a prospect closes out via
         /cfa-prospect-archive (sets prospectStage='lost'), not /quote-lifecycle. The
         typed note becomes the archive reason — "note + mark LOST in one go". */
      var _coRec = (allQuotes || []).find(function(x) { return x && (x.reference === ref || x.ref === ref); });
      var _coIsProspect = !!(_coRec && _coRec.cfaCode && _coRec.prospectStage);
      var card = btn.closest('.rqd-notes-log');
      if (!card) return;
      var input = card.querySelector('.rqd-notes-log__input');
      var text = input ? (input.value || '').trim() : '';
      if (!text) { if (input) input.focus(); return; }
      if (!(await rqdConfirm('This logs your note and closes the deal out. Your note becomes the ' + word.toLowerCase() + ' reason.', { title: 'Mark ' + ref + ' ' + word + '?', confirmLabel: 'Mark ' + word, cancelLabel: 'Keep it open', danger: true }))) return;
      // Mirror the Save handler's chip-type + call-outcome collection.
      var activeTypes = [];
      card.querySelectorAll('.rqd-notes-log__types .rqd-notes-log__chip--active').forEach(function(c) {
        if (c.dataset.noteType) activeTypes.push(c.dataset.noteType);
      });
      if (activeTypes.length === 0) activeTypes.push('note');
      var notePayload = { ref: ref, types: activeTypes, text: text, closeOut: true };
      if (activeTypes.indexOf('call') !== -1) {
        var _ocSel = card.querySelector('.rqd-notes-log__calloutcome');
        if (_ocSel && _ocSel.dataset.finalOutcome) {
          notePayload.callOutcome = _ocSel.dataset.finalOutcome;
          if (_ocSel.dataset.callVm) notePayload.callVm = _ocSel.dataset.callVm;
        }
      }
      btn.disabled = true;
      btn.textContent = 'Saving…';
      if (input) input.disabled = true;
      var _coDone = false;
      try {
        // 1) Log the final activity (no follow-up — closeOut bypasses the gate).
        await API.post('/note-entry-add', notePayload);
        // 2) Close out via the canonical endpoint for the deal's stage.
        if (_coIsProspect) {
          await API.post('/cfa-prospect-archive', { ref: ref, reason: text });
        } else if (mode === 'lost') {
          await API.post('/quote-lifecycle', { ref: ref, status: 'lost', lostReason: text });
        } else {
          await API.post('/lead-mark-dead', { ref: ref, reason: text });
        }
        _coDone = true;
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-11) — this path used to end at
           `await fetchQuotes({quiet:true})` and nothing else, which left the button on
           "Saving…" and the row unchanged until a manual refresh. THREE causes, all fixed
           here:

           1. The note was never cleared out of the textarea. hasUnsavedTyping() (see the
              LAST-MOMENT gate in fetchQuotes) returns true while ANY portal textarea holds
              text, and that gate SKIPS the whole quiet render — so the repaint that was
              meant to flip the pill and drop the 🔔 silently never ran. The plain Save path
              works precisely because it empties the box before it refetches. Clear first.
           2. No optimistic patch. The status modal got one 2026-07-23 (markStatusPillClosed
              + refreshProgressBar); the composer close-out — same transition, same row —
              never did, so even a render that DID land was seconds of board-fetch away.
           3. No `finally`. The success path relied on the re-render replacing the whole
              card to take "Saving…" off screen with it; when the render was skipped, the
              label had nothing to restore it. A stuck-forever button must never depend on
              a repaint landing. */
        if (input) {
          input.value = '';
          /* CUSTOM_COMPOSERHEIGHT_BY_CLAUDE (Ryan 2026-09-20) — `''`, not `'auto'`; the third and
             last copy of this reset (the others are in dashboard-deal-feed.js's post-save block
             and the `input` listener below). The field is `height: 100%` of the composer's grid
             row, so an inline height of ANY kind — `auto` included — takes it off that and sizes
             it by its own content instead. */
          input.style.height = '';
          delete input.dataset.prefilled;
          // Empty box → the sibling Save button must go back to disabled too.
          _syncSaveEnabled(card);
        }
        if (_coRec) {
          // Closing out clears any pending follow-up server-side — mirror it so the
          // To-Do bell / hold countdown drops on this repaint, not the next fetch.
          _coRec.followUp = null;
          _coRec.holdUntil = null;
          _coRec.isOnHold = false;
          if (_coIsProspect) {
            _coRec.prospectStage = 'lost';
            _coRec.archiveReason = text;
            _coRec.archivedAt = new Date().toISOString();
          } else if (mode === 'lost') {
            _coRec.lifecycleStatus = 'lost';
            _coRec.lostReason = text;
            if (!_coRec.dateLost) _coRec.dateLost = todayStr();
          } else {
            _coRec.isDeadLead = true;
            _coRec.status = 'dead_lead';
          }
        }
        if (_coIsProspect) {
          // Prospect table has its own render path (stage filters + BANT/countdown cell).
          _syncProspectFilters();
          _renderProspectView();
        } else {
          markStatusPillClosed(ref, mode);
          if (typeof refreshProgressBar === 'function') refreshProgressBar(ref);
        }
        // Background reconcile (detail panel, filter counts, the just-logged entry).
        // Deliberately NOT awaited: the board fetch runs `&__nc=1` and has been measured
        // at 12s+, and nothing the rep sees is waiting on it any more.
        fetchQuotes({ quiet: true });
      } catch (err) {
        rqdAlert('Could not mark the deal ' + word + ': ' + (err && err.message ? err.message : 'Unknown error') + '\n\n(Your note may have been logged; the status was not changed.)');
      } finally {
        if (input) input.disabled = false;
        btn.textContent = 'Save & Mark ' + word;
        // Success → composer is empty and the deal is closed, so leave it disabled
        // (the re-render drops the button entirely). Failure → the rep's text is
        // still there to retry with.
        btn.disabled = _coDone;
      }
    }
    tbody.addEventListener('input', function (e) {
      var inp = e.target.closest && e.target.closest('.rqd-notes-log__input');
      if (inp) {
        /* CUSTOM_COMPOSERHEIGHT_BY_CLAUDE (Ryan 2026-09-20) — ⛔ THIS HANDLER NO LONGER WRITES A
           HEIGHT, and removing that write is the whole fix. Ryan: *"as soon as you click one of
           the main buttons ... the box shrinks and gets shorter. It just snaps shorter for no
           reason."*

           It used to auto-grow the field — `style.height = 'auto'`, then
           `min(scrollHeight, 200)`. That made sense for a textarea sized by its own content and
           has been wrong since this composer became a GRID: `.rqd-notes-log__input` is
           `height: 100%` inside a stretched grid row, so at rest it is exactly as tall as the
           row. An inline height overrides `height: 100%`, and the inline value is capped at 200
           while the row is 204 — so the field could only ever SHRINK, never grow. Clicking Note,
           Text, Meeting, Email, Drop-In, Follow-up or Win fires a programmatic prefill/clear,
           which dispatches `input`, which ran this and took 24px off the box every time.

           ⚠️ Measured, not reasoned: `tools/composer-height/measure.mjs` renders the real card
           against the real stylesheet in Chromium — 204 at rest, 180 after one click, 204 with
           this write gone. Re-run it if any of these numbers are ever in doubt.
           ⚠️ The field still scrolls past the row (`overflow-y: auto`, `max-height: 280px`), so
           nothing is lost by not growing it. ⛔ And do NOT "restore" auto-grow with a bigger
           `maxH`: any inline height at all defeats `height: 100%`, which is what sizes it.
           ⚠️ The hold-modal textarea shares this class but is appended to `.rep-quote-portal-wrap`,
           outside this `tbody`, so it never reached this handler either way. */
        var _card = inp.closest('.rqd-notes-log');
        _syncSaveEnabled(_card);
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Custom date input
         on the inline follow-up cluster. Arms the follow-up at the
         picked date; the active-preset highlight de-syncs if the
         custom date doesn't match a preset. */
      var customDate = e.target.closest && e.target.closest('.rqd-notes-log__followup-custom');
      if (customDate) {
        var card = customDate.closest('.rqd-notes-log');
        if (customDate.value) armFollowUp(card, customDate.value);
        else clearFollowUp(card);
      }
    });

    /* Follow-Up helpers + render utilities. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Weekend-skip rule
       refined to "snap to NEAREST weekday" (was: snap forward to next
       Monday on both Sat and Sun). New rule: Saturday → Friday (-1 day,
       pull forward in calendar), Sunday → Monday (+1 day, push back).
       Same rule applies to the inline +Nd presets AND to the hold-date
       modal's date picker — one consistent behavior everywhere a wake
       date is computed. Holidays still NOT handled (rep can manually
       reschedule). */
    function snapWeekendToWeekday(d) {
      var dow = d.getDay();
      if (dow === 6) d.setDate(d.getDate() - 1); // Sat → Fri (pull forward)
      else if (dow === 0) d.setDate(d.getDate() + 1); // Sun → Mon (push back)
      return d;
    }
    function daysFromNowYmd(n) {
      var d = new Date();
      d.setDate(d.getDate() + n);
      snapWeekendToWeekday(d);
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Snap any YYYY-MM-DD
       string to the nearest weekday using the same rule. Used by the
       hold-date modal Apply handler so rep-picked dates that land on a
       weekend get pulled to the adjacent business day before submit. */
    function snapYmdToWeekday(ymd) {
      if (!ymd) return ymd;
      var parts = String(ymd).split('-');
      if (parts.length !== 3) return ymd;
      var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      if (isNaN(d.getTime())) return ymd;
      snapWeekendToWeekday(d);
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }
    function formatFollowUpDate(ymd) {
      if (!ymd) return '';
      var parts = String(ymd).split('-');
      if (parts.length !== 3) return ymd;
      var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      if (isNaN(d.getTime())) return ymd;
      var now = new Date(); now.setHours(0, 0, 0, 0);
      var t = new Date(d); t.setHours(0, 0, 0, 0);
      var diff = Math.round((t - now) / 86400000);
      if (diff === 0) return 'Today';
      if (diff === 1) return 'Tomorrow';
      if (diff === -1) return 'Yesterday';
      if (diff > 1 && diff <= 7) {
        return d.toLocaleDateString('en-US', { weekday: 'short' }) + ' ' + d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      }
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Arm the inline
       follow-up cluster at the given YYYY-MM-DD. Highlights the matching
       preset (if any) + syncs the custom date input + surfaces the armed
       date in the header. Idempotent — calling multiple times with
       different dates re-arms cleanly. Clearing is rep-driven: re-click
       the active preset, or delete the text in the custom date input
       (handled by the input handler below). */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Save button label
       swapper. On lead-state rows, the button reads "Put on Hold" when a
       follow-up is armed (saving auto-holds server-side) and "Save"
       otherwise. data-holdable + the two label data attrs are baked at
       render time so we can flip without a full re-render. */
    function _syncSaveButtonLabel(card, isArmed) {
      if (!card) return;
      var btn = card.querySelector('.rqd-notes-log__submit');
      if (!btn || btn.dataset.holdable !== '1') return;
      var label = isArmed ? (btn.dataset.holdLabel || 'Put on Hold') : (btn.dataset.saveLabel || 'Save');
      // Don't clobber the transient "Saving..." label mid-flight.
      if (btn.disabled) return;
      btn.textContent = label;
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — armFollowUp now
       accepts an optional `days` arg. Why: weekend-snap can make
       multiple presets resolve to the same date (e.g., on Sat, +1d
       snaps Sun → Mon AND +2d resolves directly to Mon — both preset
       buttons share Monday as their wake date). Previously both
       highlighted as "active" on click. Now: if the rep explicitly
       clicked a preset (days passed), only THAT preset highlights.
       If days is omitted (custom date input, initial render fallback),
       the lowest-N matching preset wins so at most ONE pill is ever
       lit at a time. */
    function armFollowUp(card, ymd, days) {
      if (!card || !ymd) return;
      var cluster = card.querySelector('.rqd-notes-log__followup');
      if (!cluster) return;
      cluster.dataset.armedDate = ymd;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-08) — Mark that the rep
         actively armed/changed this follow-up (vs the silent default pre-arm
         baked into the cluster HTML). Gates the follow-up-only save in
         _syncSaveEnabled + handleNoteEntryAdd so the pre-armed default never
         falsely enables Save. */
      cluster.dataset.userArmed = '1';
      var picks = cluster.querySelectorAll('.rqd-notes-log__followup-pick');
      var explicitDays = (days !== undefined && days !== null) ? parseInt(days, 10) : NaN;
      /* Ryan 2026-05-29: if the armed interval has no preset button (e.g. the
         lead short shelf [1-5] but the call cadence armed +7/+14/+30), inject
         one so the rep always sees the armed value as a highlighted pick. */
      if (isFinite(explicitDays)) {
        var _hasPreset = false;
        picks.forEach(function (b) { if (parseInt(b.dataset.days, 10) === explicitDays) _hasPreset = true; });
        if (!_hasPreset) {
          var _pw = cluster.querySelector('.rqd-notes-log__followup-presets');
          if (_pw) {
            var _nb = document.createElement('button');
            _nb.type = 'button';
            _nb.className = 'rqd-notes-log__followup-pick';
            _nb.dataset.days = explicitDays;
            _nb.title = 'In ' + explicitDays + ' days';
            _nb.textContent = '+' + explicitDays + 'd';
            _pw.appendChild(_nb);
            picks = cluster.querySelectorAll('.rqd-notes-log__followup-pick');
          }
        }
      }
      var lowestMatchingDays = NaN;
      if (!isFinite(explicitDays)) {
        picks.forEach(function(b) {
          var d = parseInt(b.dataset.days, 10);
          if (!isNaN(d) && daysFromNowYmd(d) === ymd) {
            if (!isFinite(lowestMatchingDays) || d < lowestMatchingDays) lowestMatchingDays = d;
          }
        });
      }
      picks.forEach(function(b) {
        var d = parseInt(b.dataset.days, 10);
        var match = isFinite(explicitDays) ? (d === explicitDays) : (isFinite(lowestMatchingDays) && d === lowestMatchingDays);
        b.classList.toggle('rqd-notes-log__followup-pick--active', match);
      });
      var dateEl = cluster.querySelector('.rqd-notes-log__followup-armed-date');
      if (dateEl) {
        dateEl.textContent = '— ' + formatFollowUpDate(ymd);
        dateEl.removeAttribute('hidden');
      }
      var customInp = cluster.querySelector('.rqd-notes-log__followup-custom');
      if (customInp && customInp.value !== ymd) customInp.value = ymd;
      /* Toggle the wrapper's --has-value class so the mobile mm/dd/yyyy
         placeholder overlay hides once a date is armed. */
      var _customWrap = customInp && customInp.closest('.rqd-notes-log__followup-custom-wrap');
      if (_customWrap) _customWrap.classList.add('rqd-notes-log__followup-custom-wrap--has-value');
      _syncSaveButtonLabel(card, true);
      /* Ryan 2026-05-16: arming a date may flip the universal follow-up
         gate from blocking → allowing on the Save button (if the only
         missing requirement was the follow-up). Re-sync. */
      _syncSaveEnabled(card);
    }
    function clearFollowUp(card) {
      if (!card) return;
      var cluster = card.querySelector('.rqd-notes-log__followup');
      if (!cluster) return;
      delete cluster.dataset.armedDate;
      cluster.querySelectorAll('.rqd-notes-log__followup-pick--active').forEach(function(b) {
        b.classList.remove('rqd-notes-log__followup-pick--active');
      });
      var dateEl = cluster.querySelector('.rqd-notes-log__followup-armed-date');
      if (dateEl) {
        dateEl.textContent = '';
        dateEl.setAttribute('hidden', '');
      }
      var customInp = cluster.querySelector('.rqd-notes-log__followup-custom');
      if (customInp) customInp.value = '';
      /* Re-show the mobile mm/dd/yyyy placeholder overlay once the date
         is cleared. */
      var _customWrap = customInp && customInp.closest('.rqd-notes-log__followup-custom-wrap');
      if (_customWrap) _customWrap.classList.remove('rqd-notes-log__followup-custom-wrap--has-value');
      _syncSaveButtonLabel(card, false);
      /* Ryan 2026-05-16: clearing the date may flip the universal
         follow-up gate from allowing → blocking on the Save button. */
      _syncSaveEnabled(card);
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — Confirm popup to clear a SOLD deal's
       post-sale reminder. Reuses the deal-status modal shell (#rqd-modal) so it matches
       the QUOTED→SOLD changer. The actual /follow-up-clear + row re-render run in the
       shared modalConfirm handler, gated on pendingReminderClear. */
    function openClearReminderModal(q) {
      if (!q) return;
      pendingStatusChange = null;
      pendingReminderClear = q.reference;
      modalTitle.textContent = 'Clear reminder: ' + q.reference;
      var _fd = (q.followUp && q.followUp.dueAt) ? formatFollowUpDate(q.followUp.dueAt) : '';
      modalSub.textContent = _fd ? ('Follow-up due ' + _fd) : 'Follow-up reminder';
      modalBody.innerHTML = '<p style="margin:4px 0 0;font-size:13px;line-height:1.5;">'
        + 'Clear this follow-up reminder? The deal stays <strong>sold</strong> — this just '
        + 'removes the countdown/bell. No new reminder is set.</p>';
      modalConfirm.textContent = 'Clear reminder';
      modalConfirm.style.display = '';
      modalBackdrop.classList.add('rqd-modal-backdrop--open');
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Smart prefill, v2.
       Re-derives on every chip toggle so deselecting a chip can clear or
       re-shape the prefill text. Won't clobber user-typed content: if
       the textarea differs from the previously-prefilled string, leave
       it alone. data-prefilled tracks what we last wrote so we can tell
       "rep edited" from "rep didn't touch." Covers the existing pairs +
       new Drop-In combos. */
    function applySmartPrefill(card, activeTypes) {
      if (!card) return;
      var ta = card.querySelector('.rqd-notes-log__input');
      if (!ta) return;
      var prevPrefill = ta.dataset.prefilled || '';
      var curVal = ta.value || '';
      // If rep typed something custom, don't replace.
      if (curVal && curVal !== prevPrefill) return;
      var hasCall = activeTypes.indexOf('call') !== -1;
      var hasEmail = activeTypes.indexOf('email') !== -1;
      var hasMeeting = activeTypes.indexOf('meeting') !== -1;
      var hasDropin = activeTypes.indexOf('dropin') !== -1;
      var suggestion = '';
      if (hasCall && hasEmail && !hasMeeting && !hasDropin) {
        suggestion = 'Left VM, followed up via email.';
      } else if (hasCall && hasMeeting && !hasEmail && !hasDropin) {
        suggestion = 'Called to confirm meeting.';
      } else if (hasEmail && hasMeeting && !hasCall && !hasDropin) {
        suggestion = 'Emailed to confirm meeting.';
      } else if (hasCall && hasDropin && !hasEmail && !hasMeeting) {
        suggestion = 'Called first, then stopped by in person.';
      } else if (hasEmail && hasDropin && !hasCall && !hasMeeting) {
        suggestion = 'Emailed, then dropped in.';
      }
      ta.value = suggestion;
      ta.dataset.prefilled = suggestion;
      // Trigger auto-grow recalc.
      ta.dispatchEvent(new Event('input', { bubbles: true }));
    }
    /* END applySmartPrefill */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-29) — Call-outcome decision-tree
       helpers. The tree lives in .rqd-notes-log__calloutcome (in the left type
       column). data-oc-stage tracks position; data-finalOutcome holds the leaf
       (inbound|connected|no-answer). _ocReset returns to step 1. */
    function _ocShowStep(oc, name) {
      if (!oc) return;
      oc.querySelectorAll('.rqd-notes-log__oc-step').forEach(function (s) {
        s.hidden = (s.dataset.ocStep !== name);
      });
    }
    function _ocSetCrumbs(oc, parts) {
      if (!oc) return;
      var c = oc.querySelector('.rqd-notes-log__oc-crumbs');
      if (!c) return;
      if (!parts || !parts.length) {
        c.innerHTML = '<span class="rqd-notes-log__oc-crumb-label">Outcome</span>';
        return;
      }
      var html = '';
      for (var i = 0; i < parts.length; i++) {
        if (i) html += '<span class="rqd-notes-log__oc-sep">›</span>';
        html += '<span class="rqd-notes-log__oc-crumb">' + parts[i] + '</span>';
      }
      html += '<button type="button" class="rqd-notes-log__oc-restart" title="Start over">↺</button>';
      c.innerHTML = html;
    }
    function _ocReset(card) {
      var oc = card && card.querySelector('.rqd-notes-log__calloutcome');
      if (!oc) return;
      oc.dataset.ocStage = 'root';
      delete oc.dataset.finalOutcome;
      delete oc.dataset.callVm;
      _ocClearDetail(oc, null, false); // CUSTOM_CALLDETAIL_BY_CLAUDE — the caller clears the note
      _ocShowStep(oc, 'root');
      _ocSetCrumbs(oc, []);
    }
    /* CUSTOM_CALLDETAIL_BY_CLAUDE (Ryan 2026-09-20) — the optional reason a no-answer call got no
       voicemail. `_OC_NO_VM_NOTE` is the sentence that leaf has prefilled since 2026-06-07; a
       picked reason extends it rather than replacing it, so the note reads the same and says more.
       The reason strings themselves live in RQD.CALL_DETAILS (dashboard-deal-feed.js) with the
       chip labels and the feed wording — one place, so the three cannot drift. */
    var _OC_NO_VM_NOTE = 'Did not leave a voicemail.';
    function _ocNoVmNote(oc) {
      var d = (oc && oc.dataset.callDetail && window.RQD && typeof window.RQD.callDetailBy === 'function')
        ? window.RQD.callDetailBy(oc.dataset.callDetail) : null;
      return d ? _OC_NO_VM_NOTE + ' ' + d.sentence : _OC_NO_VM_NOTE;
    }
    /* Clears the pick AND the chips' pressed state. `repaintNote` is false wherever the caller is
       about to write the note itself — passing true here as well would run the prefill twice and,
       worse, set data-prefilled to an intermediate string the caller then fails to match. */
    function _ocClearDetail(oc, ta, repaintNote) {
      if (!oc) return;
      delete oc.dataset.callDetail;
      oc.querySelectorAll('.rqd-notes-log__oc-detail-chip').forEach(function (c) {
        c.classList.remove('rqd-notes-log__chip--active');
        c.setAttribute('aria-pressed', 'false');
      });
      if (repaintNote) _ocPrefillNote(ta, _ocNoVmNote(oc));
    }
    function _ocPrefillNote(ta, text) {
      if (!ta) return;
      var cur = ta.value || '', prev = ta.dataset.prefilled || '';
      if (cur && cur !== prev) return; // rep typed custom text — keep it
      ta.value = text;
      ta.dataset.prefilled = text;
      ta.dispatchEvent(new Event('input', { bubbles: true }));
    }
    function _ocClearPrefill(ta) {
      if (!ta) return;
      var cur = ta.value || '', prev = ta.dataset.prefilled || '';
      if (cur && cur === prev) {
        ta.value = '';
        delete ta.dataset.prefilled;
        ta.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Click the ⏰ badge in
       the To-Do column to clear an existing committed follow-up on a
       quote-state row. Confirms then POSTs /follow-up-clear, removes
       the badge optimistically, restores on error. Lead-state rows
       use the existing Wake Now affordance instead. */
    async function handleFollowUpBadgeClear(badgeEl) {
      var ref = badgeEl.dataset.ref;
      if (!ref) return;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — QUOTED rows must
         always carry a follow-up (auto-armed +5d at PDF download; no
         row should exist without a future tipping point). Refuse the
         clear; force the rep to use the Activity composer's date
         picker / preset shelf to RESCHEDULE instead of zeroing it.
         Detection via row class — .rqd-row--quoted covers both
         lifecycleStatus === 'quoted' and the in-progress '...' rows
         that share the quoted statusClass. */
      var _row = badgeEl.closest('tr');
      if (_row && _row.classList.contains('rqd-row--quoted')) {
        rqdAlert('QUOTED deals always need a follow-up timer. Open the Activity card and pick a new date to reschedule.');
        return;
      }
      if (!(await rqdConfirm('Nothing will chase this deal until a new date is set.', { title: 'Clear the follow-up reminder for ' + ref + '?', confirmLabel: 'Clear it', cancelLabel: 'Keep the reminder', danger: true }))) return;
      // Stash the parent cell + sibling reference for restore-on-error.
      var parent = badgeEl.parentElement;
      var prevSibling = badgeEl.previousElementSibling;
      badgeEl.remove();
      try {
        await API.post('/follow-up-clear', { ref: ref });
        var q = allQuotes.find(function(x) { return x.reference === ref; });
        if (q) q.followUp = null;
        if (typeof refreshProgressBar === 'function') refreshProgressBar(ref);
      } catch (err) {
        // Restore on failure
        if (parent) {
          if (prevSibling && prevSibling.parentElement === parent) {
            prevSibling.insertAdjacentElement('afterend', badgeEl);
          } else {
            parent.appendChild(badgeEl);
          }
        }
        rqdAlert('Clear failed: ' + (err && err.message ? err.message : 'Unknown error'));
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-11) — ⭐ review-decision menu.
       Click the star (pending centered star OR muted skipped star) → small
       anchored popover with the two choices. "Send" POSTs /review-decision
       {decision:'send'} → worker creates the request with email_delay_days=0
       so Abby's next 10am cron emails the customer. "Don't send" records the
       skip (reversible — the muted star re-opens this menu). The two explicit
       buttons ARE the confirm step; no extra dialog. */
    var _reviewMenuEl = null;
    function closeReviewDecisionMenu() {
      if (_reviewMenuEl) {
        _reviewMenuEl.remove();
        _reviewMenuEl = null;
        document.removeEventListener('click', _reviewMenuDocClose, true);
      }
    }
    function _reviewMenuDocClose(e) {
      if (_reviewMenuEl && !_reviewMenuEl.contains(e.target) && !e.target.closest('.rqd-review-star-decide')) {
        closeReviewDecisionMenu();
      }
    }
    function openReviewDecisionMenu(starEl) {
      // Re-click while open = toggle closed.
      if (_reviewMenuEl && _reviewMenuEl.dataset.ref === starEl.dataset.ref) { closeReviewDecisionMenu(); return; }
      closeReviewDecisionMenu();
      var ref = starEl.dataset.ref;
      if (!ref) return;
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      /* CUSTOM_REVIEWS_BY_CLAUDE (Ryan 2026-09-09) — the popover reads the same summary the cog
         entry does, so the buttons it offers match what POST /review-decision will accept:
         Send from pending / skipped, Skip from pending / queued (a queued ask can still be pulled
         back before Abby's window). A legacy row with no summary keeps the old two buttons. */
      var _sum = (q && typeof reviewAskSummary === 'function') ? reviewAskSummary(q) : null;
      var sendOpen = _sum ? _sum.sendOpen : true;
      var skipOpen = _sum ? _sum.skipOpen : (q && q.reviewStatus !== 'skipped');
      var custName = (q && q.customer) ? q.customer : 'the customer';
      var menu = document.createElement('div');
      menu.className = 'rqd-review-menu';
      menu.dataset.ref = ref;
      menu.innerHTML =
        '<div class="rqd-review-menu__title">&#11088; Review request &mdash; ' + esc(ref) + '</div>' +
        (_sum ? '<div class="rqd-review-menu__hint rqd-review-menu__state">' + esc(_sum.text) + (_sum.sub ? ' &middot; ' + esc(_sum.sub) : '') + '</div>' : '') +
        (sendOpen ? '<button type="button" class="rqd-review-menu__btn rqd-review-menu__btn--send" data-decision="send">&#9993; Send review request</button>' : '') +
        (skipOpen ? '<button type="button" class="rqd-review-menu__btn rqd-review-menu__btn--skip" data-decision="skip">Don&#8217;t send</button>' : '') +
        (!sendOpen && !skipOpen ? '<div class="rqd-review-menu__hint">Nothing left to decide on this deal.</div>' : '') +
        (sendOpen ? '<div class="rqd-review-menu__hint">Send = Abby emails ' + esc(custName) + ' at the next 10am send window.</div>' : '');
      // Append inside the portal wrap (not body) so the --rq-* theme vars
      // resolve in dark mode; position:fixed makes the DOM home irrelevant
      // for layout. Falls back to body if the wrap isn't found.
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(menu);
      // Viewport rect — same pattern as the date-override popover. Clamp
      // inside the viewport's right edge.
      var r = starEl.getBoundingClientRect();
      menu.style.top = (r.bottom + 6) + 'px';
      menu.style.left = Math.max(8, Math.min(
        r.left + r.width / 2 - menu.offsetWidth / 2,
        window.innerWidth - menu.offsetWidth - 8
      )) + 'px';
      _reviewMenuEl = menu;
      menu.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var btn = ev.target.closest('.rqd-review-menu__btn');
        if (!btn || btn.disabled) return;
        submitReviewDecision(ref, btn.dataset.decision, btn);
      });
      // Defer the outside-click closer so the opening click doesn't
      // immediately dismiss the menu.
      setTimeout(function () { document.addEventListener('click', _reviewMenuDocClose, true); }, 0);
    }
    async function submitReviewDecision(ref, decision, btn) {
      var origLabel = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = decision === 'send' ? 'Queuing…' : 'Saving…';
      try {
        var res = await API.post('/review-decision', { ref: ref, decision: decision });
        closeReviewDecisionMenu();
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        if (q) {
          q.reviewStatus = (res && res.reviewStatus) || (decision === 'send' ? 'requested' : 'skipped');
          q.reviewDecision = { state: q.reviewStatus === 'requested' ? 'sent' : q.reviewStatus, at: new Date().toISOString() };
          /* CUSTOM_REVIEWS_BY_CLAUDE (Ryan 2026-09-09) — mirror the durable stamp the worker just
             wrote so the cog entry reads right until the next full refresh. */
          q.reviewAsk = { state: q.reviewStatus === 'requested' ? 'sent-by-owner' : q.reviewStatus, at: q.reviewDecision.at, by: String((((window.RepPortal && window.RepPortal.Auth && window.RepPortal.Auth.getSession()) || {}).repCode) || '').toUpperCase() || undefined, reason: (res && res.message) || undefined };
          refreshReviewAskMenuItems(q);
        }
        if (typeof refreshProgressBar === 'function') refreshProgressBar(ref);
        if (res && res.reviewStatus === 'suppressed') {
          rqdAlert('Not sent — ' + (res.message || 'this customer was recently asked or already reviewed.'));
        }
      } catch (err) {
        btn.disabled = false;
        btn.innerHTML = origLabel;
        rqdAlert('Failed: ' + (err && err.message ? err.message : 'Unknown error'));
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Bell click handler.
       When a follow-up expires the badge swaps to 🔔; clicking it opens
       the row's Activity card so the rep can log what they did. Expands
       the detail panel if collapsed, then polls briefly for the Activity
       card element + scrolls it into view. Mirrors the existing
       expand-then-scroll pattern used by other row-expand affordances
       (see ~L8523 for the comment style). */
    function handleFollowUpBellOpen(badgeEl) {
      var ref = badgeEl.dataset.ref;
      if (!ref) return;
      var detailEl = document.querySelector('.rqd-detail-row[data-detail-ref="' + ref + '"] .rqd-detail');
      if (!detailEl) {
        // Fallback: try toggleDetail which expands by ref directly.
        try { toggleDetail(ref); } catch (_) {}
      } else if (!detailEl.classList.contains('rqd-detail--open')) {
        try { toggleDetail(ref); } catch (_) {}
      }
      // Poll briefly for the Activity card. The card may already exist
      // (row was open) or may need a beat after toggleDetail wires up
      // detail HTML. Bail after ~1s.
      var _tries = 0;
      var _poll = setInterval(function() {
        _tries++;
        var actCard = document.querySelector('.rqd-notes-log[data-ref="' + ref + '"]');
        if (actCard) {
          clearInterval(_poll);
          actCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Brief visual ack — flash the card border so the rep's eye
          // lands on it. Reuses --awaiting accent for the flash.
          actCard.classList.add('rqd-notes-log--bell-focus');
          setTimeout(function() {
            actCard.classList.remove('rqd-notes-log--bell-focus');
          }, 1400);
        } else if (_tries > 20) {
          clearInterval(_poll);
        }
      }, 50);
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_FBCOSTSAVE_BY_CLAUDE (Ryan 2026-08-13) — save the bucket freight cost from the
       floppy button, and land it WITHOUT a board re-fetch.

       Ryan: *"when it does save, it takes forever… don't have it refresh the page and scroll you
       to the top. save right then and there without any weird visual stuff going on."* The old
       version chained `fetchQuotes({quiet:true})` onto the POST — a full board fetch (12s+ on a
       loaded board) before anything on screen acknowledged the save.

       This mirrors the Purchasing card's handshake saveCost(): POST, patch the local record from
       the response, re-render THAT panel, refresh its progress bar. rerenderDetail restores scroll
       itself, so nothing jumps. The response carries the saved bucket, so the patch is the
       server's own value, not a guess about what it did.

       A quiet reconcile still fires, UNAWAITED, because the freight-balanced gate, the Generate-PO
       gate and the Financials freight figure are all derived server-side from more than this one
       field. Re-deriving them here would put a second copy of that logic in the browser — the
       thing that makes two surfaces disagree. Unawaited means correctness catches up without the
       rep waiting on it. */
    function saveBucketCost(btn) {
      var ref = btn.dataset.ref;
      var bucketId = btn.dataset.bucket;
      var wrap = btn.closest('.rqd-freight-cost-wrap');
      var inp = wrap && wrap.querySelector('.rqd-fb__bucket-cost-input');
      if (!inp || !ref || !bucketId) return;
      /* CUSTOM_ALTSHIP_BY_CLAUDE (Ryan 2026-10-09) - an alternate source's block saves ITS shipment's cost. */
      var supplier = btn.dataset.supplier || inp.dataset.supplier || '';

      var rawLastSaved0 = (inp.dataset.lastSaved || '').trim();
      var hasSaved0 = rawLastSaved0 !== '';
      var raw0 = (inp.value || '').replace(/[$,\s]/g, '');
      var newVal0 = parseFloat(raw0);
      if (isNaN(newVal0) || newVal0 < 0) { inp.focus(); inp.select && inp.select(); return; }
      inp.value = newVal0.toFixed(2);
      inp.dataset.lastSaved = inp.value;

      /* Icon-sized button (28px) — swapping the SVG for "Saving..." would overflow it, so it
         disables and takes the shared pulse class, exactly as the Purchasing card's does. */
      btn.disabled = true;
      btn.classList.add('rqd-invoice__link--loading');

      var _costBody = { ref: ref, bucketId: bucketId, freightCost: newVal0 };
      if (supplier) _costBody.vendor = supplier;
      API.post('/shipping-bucket-set', _costBody)
        .then(function (resp) {
          var q = allQuotes.find(function (x) { return x.reference === ref; });
          /* CUSTOM_CARDWRITESTICK_BY_CLAUDE - patched on every cached copy and held until the server's row agrees. */
          var _saved = supplier
            ? (resp && resp.supplier && resp.supplier.freightCost != null ? resp.supplier.freightCost : null)
            : (resp && resp.bucket ? resp.bucket.freightCost : null);
          if (resp && (resp.bucket || resp.supplier)) {
            stickCardWrite('bucket-cost:' + ref + ':' + bucketId + ':' + (supplier || ''), ref, function (x) {
              if (!x || !Array.isArray(x.shippingBuckets)) return;
              var b = x.shippingBuckets.find(function (bb) { return bb && bb.id === bucketId; });
              if (!b) return;
              var target = supplier ? bucketSupplierEntry(x, bucketId, supplier) : b;
              if (!target) return;
              target.freightCost = _saved == null ? 0 : _saved;
              target.freightCostSet = _saved != null;
              if (!supplier) {
                b.parcelRatePending = (resp.bucket && resp.bucket.parcelRatePending) || null;
                // The brand's entry in a shared bucket mirrors the bucket.
                var brandEntry = Array.isArray(b.suppliers) ? b.suppliers.find(function (e) { return e && e.isBrand; }) : null;
                if (brandEntry) { brandEntry.freightCost = target.freightCost; brandEntry.freightCostSet = target.freightCostSet; }
              }
            }, function (x) {
              var b = x && Array.isArray(x.shippingBuckets) ? x.shippingBuckets.find(function (bb) { return bb && bb.id === bucketId; }) : null;
              var target = supplier ? bucketSupplierEntry(x, bucketId, supplier) : b;
              return !!target && (parseFloat(target.freightCost) || 0) === (parseFloat(_saved) || 0) && !!target.freightCostSet === (_saved != null);
            });
          }
          if (q) {
            var detailEl = document.getElementById('rqd-detail-' + ref);
            if (detailEl && window.DashboardHandshake && window.DashboardHandshake.rerenderDetail) {
              window.DashboardHandshake.rerenderDetail(detailEl, q);
            }
            refreshProgressBar(ref);
          }
          // Unawaited on purpose — see the header. Nothing below waits on it.
          fetchQuotes({ quiet: true });
        })
        .catch(function (err) {
          inp.value = hasSaved0 ? rawLastSaved0 : '';
          inp.dataset.lastSaved = rawLastSaved0;
          btn.disabled = false;
          btn.classList.remove('rqd-invoice__link--loading');
          rqdAlert('Failed to save bucket freight cost: ' + (err && err.message ? err.message : 'unknown error'));
        });
    }
    /* END CUSTOM_FBCOSTSAVE_BY_CLAUDE */

    /* CUSTOM_FBCOSTSAVE_BY_CLAUDE (Ryan 2026-08-13) — saveBucketCostInput removed. It was
       the blur/Enter auto-save, and its whole tail was `.then(fetchQuotes)` — a full board
       re-fetch before the screen acknowledged anything. Replaced by saveBucketCost(btn),
       driven by the floppy button and patching the panel in place. */
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Column header sorting — server-side (re-fetches with sort param)
    var columnSortKey = 'date';
    var columnSortDir = 'desc';
    document.querySelector('.rqd-table thead').addEventListener('click', function(e) {
      var th = e.target.closest('th[data-sort]');
      if (!th) return;
      var key = th.dataset.sort;
      if (columnSortKey === key) {
        columnSortDir = columnSortDir === 'asc' ? 'desc' : 'asc';
      } else {
        columnSortKey = key;
        // Default direction per column: dates and to-do counts feel right descending first
        // (newest / most-remaining at top), strings feel right ascending first (A→Z).
        columnSortDir = (key === 'date' || key === 'todo') ? 'desc' : 'asc';
      }
      // Map column key to API sort param
      currentSort = columnSortKey + '_' + columnSortDir;
      currentPage = 1;
      updateSortArrows();
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — Prospecting sort is client-side
         (/cfa-prospects doesn't sort); re-render in place instead of re-fetching. */
      if (currentSource === 'prospecting') { _renderProspectView(); return; }
      fetchQuotes();
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — clickable prospect stat tiles: click a
       tile to filter the list to that stage. The Closed tile → 'won' is the ONLY way to reach
       WON prospects (the stage pills intentionally omit won). */
    if (statsEl) {
      var _prospectStatFilter = function(tile) {
        if (!tile || currentSource !== 'prospecting') return;
        currentProspectStages = [tile.dataset.prospectStatFilter];
        currentProspectView = 'all';
        _syncProspectFilters();
        _renderProspectView();
      };
      statsEl.addEventListener('click', function(ev) {
        _prospectStatFilter(ev.target.closest('[data-prospect-stat-filter]'));
      });
      statsEl.addEventListener('keydown', function(ev) {
        if (ev.key !== 'Enter' && ev.key !== ' ') return;
        var tile = ev.target.closest('[data-prospect-stat-filter]');
        if (tile) { ev.preventDefault(); _prospectStatFilter(tile); }
      });
    }

    function updateSortArrows() {
      document.querySelectorAll('.rqd-table th[data-sort]').forEach(function(th) {
        var existing = th.querySelector('.rqd-sort-arrow');
        if (existing) existing.remove();
        if (th.dataset.sort === columnSortKey) {
          var arrow = document.createElement('span');
          arrow.className = 'rqd-sort-arrow rqd-sort-arrow--active';
          arrow.textContent = columnSortDir === 'asc' ? ' \u25B2' : ' \u25BC';
          th.appendChild(arrow);
        }
      });
    }

    // Close action menus on outside click
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.rqd-actions')) {
        closeMobileModal();
        document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) {
          m.classList.remove('rqd-actions-menu--open');
        });
      }
      // Close bucket settings popovers on outside-click.
      if (!e.target.closest('.rqd-fb__bucket-popover')
          && !e.target.closest('.rqd-fb__bucket-settings-btn')) {
        document.querySelectorAll('.rqd-fb__bucket-popover').forEach(function (p) {
          p.setAttribute('hidden', '');
        });
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Close per-line flags popover on
         outside-click. The popover is rendered transiently (created on +
         click, removed on close) so we delete the node rather than
         hiding it. */
      if (!e.target.closest('.rqd-online-items__flags-popover')
          && !e.target.closest('.rqd-online-items__flags-btn')) {
        document.querySelectorAll('.rqd-online-items__flags-popover').forEach(function (p) { p.remove(); });
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    });

    var _mobileBackdrop = null;
    var _mobileMenuOrigParent = null;
    var _mobileMenuEl = null;
    function isMobileView() { return window.innerWidth <= 769; }
    function closeMobileModal() {
      if (_mobileBackdrop) _mobileBackdrop.classList.remove('rqd-actions-backdrop--open');
      if (_mobileMenuEl && _mobileMenuOrigParent) {
        _mobileMenuEl.classList.remove('rqd-actions-menu--mobile-modal');
        _mobileMenuOrigParent.appendChild(_mobileMenuEl);
        _mobileMenuEl = null; _mobileMenuOrigParent = null;
      }
    }
    function openMobileModal(menu) {
      if (!_mobileBackdrop) {
        _mobileBackdrop = document.createElement('div');
        _mobileBackdrop.className = 'rqd-actions-backdrop';
        var portalWrap = document.querySelector('.rep-quote-portal-wrap');
        (portalWrap || document.body).appendChild(_mobileBackdrop);
        _mobileBackdrop.addEventListener('click', function(ev) {
          if (ev.target === _mobileBackdrop) {
            closeMobileModal();
            document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) {
              m.classList.remove('rqd-actions-menu--open');
            });
          }
        });
      }
      _mobileMenuOrigParent = menu.parentElement;
      _mobileMenuEl = menu;
      _mobileBackdrop.appendChild(menu);
      _mobileBackdrop.classList.add('rqd-actions-backdrop--open');
      menu.classList.add('rqd-actions-menu--mobile-modal');
      menu.style.left = ''; menu.style.top = ''; menu.style.right = ''; menu.style.bottom = '';
      menu.style.visibility = '';
    }

    var _activeMenu = null;
    var _activeTrigger = null;
    function positionActionsMenu(menu, trigger) {
      if (isMobileView()) { openMobileModal(menu); return; }
      _activeMenu = menu;
      _activeTrigger = trigger;
      var rect = trigger.getBoundingClientRect();
      // Neutralize any CSS right/bottom overrides so inline left/top fully control placement
      menu.style.right = 'auto';
      menu.style.bottom = 'auto';
      menu.style.visibility = 'hidden';
      menu.style.left = '0px';
      menu.style.top = '0px';
      var menuW = menu.offsetWidth;
      var menuH = menu.offsetHeight;
      var vw = window.innerWidth, vh = window.innerHeight;
      var left = Math.round(rect.right - menuW);
      if (left < 8) left = 8;
      if (left + menuW > vw - 8) left = vw - menuW - 8;
      var top = Math.round(rect.bottom + 4);
      if (top + menuH > vh - 8) top = Math.round(rect.top - menuH - 4);
      if (top < 8) top = 8;
      menu.style.left = left + 'px';
      menu.style.top = top + 'px';
      menu.style.visibility = '';
    }

    // Reposition (or close if trigger scrolled off-screen) on scroll/resize
    var _repositionActiveMenu = function() {
      if (!_activeMenu || !_activeMenu.classList.contains('rqd-actions-menu--open')) {
        _activeMenu = null; _activeTrigger = null;
        return;
      }
      // If trigger was detached from DOM, close
      if (!_activeTrigger || !document.body.contains(_activeTrigger)) {
        _activeMenu.classList.remove('rqd-actions-menu--open');
        _activeMenu = null; _activeTrigger = null;
        return;
      }
      var rect = _activeTrigger.getBoundingClientRect();
      // If trigger is fully off-screen, close the menu
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        _activeMenu.classList.remove('rqd-actions-menu--open');
        _activeMenu = null; _activeTrigger = null;
        return;
      }
      positionActionsMenu(_activeMenu, _activeTrigger);
    };
    window.addEventListener('scroll', _repositionActiveMenu, true);
    window.addEventListener('resize', _repositionActiveMenu);

    // Modal cancel
    modalCancel.addEventListener('click', closeModal);
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Click-outside-to-
       close removed. The previous behavior wiped the form when the rep
       was selecting text inside an input and released the mouse outside
       the modal — a click-and-drag selection that ended on the backdrop
       fired backdrop's mouseup → closeModal → lost work. Only the
       Cancel button closes now. */

    // ── Fetch ──

    // Read URL state on load
    function readUrlState() {
      var p = new URLSearchParams(window.location.search);
      if (p.get('status')) { currentStatus = p.get('status'); document.querySelectorAll('.rqd-pill').forEach(function(b) { b.classList.toggle('rqd-pill--active', b.dataset.status === currentStatus); });
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-29) — deep-link to MONEY
           MOVES (?status=moneymoves): no pill matches, so light the button. */
        if (currentStatus === 'moneymoves') { moneyMovesActive = true; var _mmbU = document.getElementById('rqd-moneymoves-btn'); if (_mmbU) _mmbU.classList.add('rqd-moneymoves--active'); }
      }
      if (p.get('page')) currentPage = parseInt(p.get('page')) || 1;
      if (p.get('sort')) currentSort = p.get('sort');
      if (p.get('search')) {
        currentSearch = p.get('search');
        var _restoredSearchInput = document.getElementById('rqd-search');
        _restoredSearchInput.value = currentSearch;
        // Sync the × clear button visibility so the restored value
        // shows it on first paint (before any input event fires).
        if (_restoredSearchInput.parentElement) _restoredSearchInput.parentElement.classList.add('has-value');
      }
      if (p.get('rep') && repFilter) repFilter.value = p.get('rep');

      // Date preset trumps frozen dateFrom/dateTo. For rolling presets
      // (year/quarter/month/week) we recompute against today so the upper
      // bound includes any orders placed since the URL was last written.
      // For 'custom' we restore the explicit dates from the URL. URLs
      // without a preset param fall through to the default ("This Year")
      // — bare dateFrom/dateTo from older URLs are intentionally ignored
      // so they don't lock today's orders out of the view.
      var urlPreset = p.get('preset');
      if (urlPreset) {
        if (datePreset) datePreset.value = urlPreset;
        if (urlPreset === 'custom') {
          currentPreset = 'custom';
          if (p.get('dateFrom')) { currentDateFrom = p.get('dateFrom'); document.getElementById('rqd-date-from').value = currentDateFrom; }
          if (p.get('dateTo')) { currentDateTo = p.get('dateTo'); document.getElementById('rqd-date-to').value = currentDateTo; }
          // Inline range inputs stay hidden — surface dates on the pill + ✎ edit button.
          var customDatesDiv = document.getElementById('rqd-custom-dates');
          if (customDatesDiv) customDatesDiv.style.display = 'none';
          syncCustomPillLabel();
        } else {
          applyDateRange(urlPreset, true);
        }
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — show-cancelled URL state */
      if (p.get('showCancelled') === '1') {
        currentIncludeCancelled = true;
        var includeCancelledCbInit = document.getElementById('rqd-include-cancelled');
        if (includeCancelledCbInit) includeCancelledCbInit.checked = true;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }
    readUrlState();

    function pushUrlState() {
      var p = new URLSearchParams();
      if (currentStatus !== 'all') p.set('status', currentStatus);
      if (currentPage > 1) p.set('page', currentPage);
      if (currentSort !== 'date_desc') p.set('sort', currentSort);
      if (currentSearch) p.set('search', currentSearch);
      if (repFilter && repFilter.value) p.set('rep', repFilter.value);
      // Persist the preset name (not the resolved dates) for rolling presets
      // so the next reload recomputes against today. Custom keeps the dates.
      if (currentPreset && currentPreset !== 'year') p.set('preset', currentPreset);
      if (currentPreset === 'custom') {
        if (currentDateFrom) p.set('dateFrom', currentDateFrom);
        if (currentDateTo) p.set('dateTo', currentDateTo);
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — persist show-cancelled in URL */
      if (currentIncludeCancelled) p.set('showCancelled', '1');
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var qs = p.toString();
      var newUrl = window.location.pathname + (qs ? '?' + qs : '');
      if (window.history.replaceState) window.history.replaceState(null, '', newUrl);
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — request-generation guard.
       Every non-inject fetch bumps _fetchGen and captures it; a background SWR
       revalidate or an in-flight network response only repaints if it's still the
       latest. Without this, a revalidate (or slow fetch) from the PREVIOUS tab/rep
       repainted OVER the view you just switched to → the "click twice" bug. */
    var _fetchGen = 0;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-20) — QUIET-render generation.
       _fetchGen above guards the NETWORK repaint but is only assigned on
       non-inject fetches (:5488), so it can't arbitrate between overlapping
       QUIET renders. Several can be in flight at once (2-min poll + SWR
       revalidate + tab-return fetch), and each carried its own frozen copy of
       window.scrollY, so each one independently dragged the rep back to a
       position from up to 25s earlier.

       Measured live 2026-07-20 with console instrumentation — the same frozen
       value re-applied four times across a minute, from four different
       invocations:
         t=43977   scrollTo target=1568.800048828125  (rep was at 2901)
         t=78198   scrollTo target=1568.800048828125
         t=101090  scrollTo target=1568.800048828125  (rep was at 892 → yanked DOWN)
         t=105197  scrollTo target=1568.800048828125
       and a burst of three restores 100ms apart: 2316 → 1569 → 1358 → 1126.

       Every quiet invocation now takes a ticket here; only the newest may
       render or touch scroll. Superseded ones bail out silently. */
    var _quietGen = 0;
    var _prefetchTimer = null;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — in-memory SWR cache. sessionStorage
       has a ~5MB quota and a single big /rep-quotes payload (a busy rep, or all-reps)
       overflows it, so setItem threw and that view NEVER cached — every rep/tab switch
       (even A→B→A) hit the 3-6s worker. This RAM cache has no practical size limit and is
       the primary layer; sessionStorage stays as a best-effort secondary (survives reload).
       Capped + oldest-evicted so it can't grow unbounded across a long session. */
    var _memQuotes = {};
    var _MEM_QUOTES_MAX = 16;
    function _memQuotesGet(key) {
      var e = _memQuotes[key];
      if (e && e.at && (Date.now() - e.at < 21600000) && e.data) return e.data;
      return null;
    }
    /* The entry's write time, for the freshness label. Same 6h TTL rule as _memQuotesGet so the
       two cannot disagree about whether an entry counts. */
    function _memQuotesAt(key) {
      var e = _memQuotes[key];
      return (e && e.at && (Date.now() - e.at < 21600000) && e.data) ? e.at : 0;
    }
    function _memQuotesSet(key, data) {
      _memQuotes[key] = { at: Date.now(), data: data };
      var keys = Object.keys(_memQuotes);
      if (keys.length > _MEM_QUOTES_MAX) {
        keys.sort(function (a, b) { return (_memQuotes[a].at || 0) - (_memQuotes[b].at || 0); });
        delete _memQuotes[keys[0]];
      }
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — throw the SWR cache away.

       ⛔ NOTHING CLEARED IT, AND THAT IS WHY A NEW PENDING NEEDED A MANUAL REFRESH.
       Ryan: *"When I create a pending deal in the DD, I need to do a refresh for me to see it
       appear."* The create posts, succeeds, and calls fetchQuotes() — but fetchQuotes serves the
       RAM/sessionStorage entry for this exact view first (6h TTL, written seconds earlier when the
       board loaded) and only revalidates in the background. So the first paint is a list assembled
       before the deal existed, and the row can only arrive on a repaint that is itself gated by
       `hasUnsavedTyping()` and by the rep still being on the same view.

       ⛔ THE FRESHNESS RULE EXISTED AND WAS NEVER ASKED. `rqd_mutated_at` is stamped by every
       `API.post` (custom-rep-portal.js) precisely so a post-mutation load bypasses the stale
       assembly — but it is read inside `if (!data)`, the branch that runs ONLY when the client
       cache MISSED. On this path the cache HITS, so the flag never gets a vote. A rule that is
       right but unreachable reads exactly like no rule at all.

       ⚠️ CALL THIS WHEN THE SET OF ROWS CHANGES, NOT WHEN A ROW'S CONTENTS DO. A status flip, a
       note, a follow-up — those patch the row in place (`markStatusPillClosed`, `refreshProgressBar`)
       and feel instant already, so blanket-clearing on every POST would trade a 25s server-cached
       assembly for a cold one after each note save and make the common path slower to fix the rare
       one. Creating, deleting or converting a deal is different: there is no row to patch, so the
       cached list is simply wrong until it is refetched. */
    function _swrInvalidateQuotes() {
      _memQuotes = {};          // the RAM layer, which only this page has
      /* The sessionStorage layer is shared with every other portal page (the Workstation can
         mint a pending and send the rep here), so its sweep lives on RepPortal — one owner of
         the `rqd-swr:` prefix. Guarded because dashboard-main.js is loaded on pages that have
         not booted the portal shell. */
      try {
        if (window.RepPortal && window.RepPortal.API && window.RepPortal.API.invalidateDealList) {
          window.RepPortal.API.invalidateDealList();
        }
      } catch (_) { /* RAM clear above already covers this page's own next fetch */ }
    }

    /* ⛔ THE BOARD'S SWR CACHE HAS TO GO BEFORE THE REFETCH, OR A HELD EMAIL LEAVES NO TRACE.
       Ryan sent a first quote on RW-1309-A with the clock ticked and saw *"NOTHING for this
       email in the deal feed"* — while KV had both the queued job and its feed entry, written
       correctly. Plain `fetchQuotes` serves the RAM/sessionStorage entry for the current view
       (6h TTL) and revalidates behind the scenes, so the repaint used a payload assembled
       BEFORE the send. `sessionStorage` also survives a reload, so refreshing does not help.
       ⚠️ Scoped to this composer rather than every API.post on purpose: the 2026-08-26 note
       above `_swrInvalidateQuotes` rejected blanket clearing because it would trade a warm
       25s assembly for a cold one after every note save. A customer email is the opposite
       case — rare, and it writes a feed entry that nothing patches in place. */
    function _emFetch(o) {
      try { _swrInvalidateQuotes(); } catch (_) { /* RAM clear is best-effort */ }
      /* ⛔ force:true, OR THE SERVER HANDS BACK ITS OWN STALE COPY. There are TWO caches, and
         clearing the client one only proved the point: /rep-quotes is cached server-side for
         180s, and `force` is what appends `__nc=1` to bypass it — the same flag the Refresh
         button passes. Without it the browser dutifully re-asks and gets the assembly from
         before the send, so a held email is invisible even after clearing sessionStorage and
         reloading, which is exactly what Ryan saw on RW-1309-A: the entry was correct in KV,
         correct in the record, and absent from the response.
         ⚠️ quiet AND force together — the two are independent. force decides FRESHNESS, quiet
         decides whether the board visibly reloads and throws the rep back to the top. */
      return fetchQuotes(Object.assign({ quiet: true }, o, { force: true }));
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — warm the SIBLING source tab into
       the SWR cache after a user load, so switching Offline<->Online is instant (served
       from cache + a quiet background revalidate) instead of sitting on the 3-6s worker
       spinner. Best-effort: it mirrors the params the source-switch would produce; a
       mismatch just means no cache hit (it never breaks anything). Skips if already warm. */
    function _prefetchSibling() {
      try {
        if (currentSource !== 'offline' && currentSource !== 'online') return;
        var sib = currentSource === 'offline' ? 'online' : 'offline';
        var p = '?status=' + encodeURIComponent(sib === 'online' ? 'all' : currentStatus) +
          '&page=1' +
          '&sort=' + encodeURIComponent(currentSort) +
          '&search=' + encodeURIComponent(currentSearch) +
          '&source=' + encodeURIComponent(sib) +
          (currentIncludeCancelled ? '&includeCancelled=1' : '');
        var repVal;
        if (sib === 'online') {
          var hasRW = repFilter && Array.prototype.some.call(repFilter.options, function (o) { return o.value === 'RW'; });
          repVal = hasRW ? 'RW' : (repFilter ? repFilter.value : '');
        } else {
          repVal = (repFilterBeforeOnline !== null && repFilterBeforeOnline !== undefined) ? repFilterBeforeOnline : (repFilter ? repFilter.value : '');
        }
        if (repVal) p += '&rep=' + encodeURIComponent(repVal);
        if (currentDateFrom) p += '&dateFrom=' + encodeURIComponent(currentDateFrom);
        if (currentDateTo) p += '&dateTo=' + encodeURIComponent(currentDateTo);
        var key = 'rqd-swr:' + p;
        if (_memQuotesGet(key)) return; // already warm (RAM)
        /* CUSTOM_DDKEEPPLACE_BY_CLAUDE - the saved copy (IndexedDB) is checked and written through the one owner. */
        Promise.resolve(API.dealListGet(key)).then(function (hit) {
          if (hit && hit.data) return;
          return API.get('/rep-quotes' + p).then(function (fresh) {
            _memQuotesSet(key, fresh);
            API.cacheDealList(key, JSON.stringify({ at: Date.now(), data: _slimForCache(fresh) }));
          });
        }).catch(function () { /* best-effort */ });
      } catch (_) { /* best-effort */ }
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21 / 2026-05-27; hoisted to shared
       scope 2026-07-11) — true when the rep has unsubmitted work anywhere in the
       portal: any textarea with content (a half-typed note/call log), OR focus in
       an input/select/textarea (composer, tracking card, fulfillment card, etc.).
       ANY background re-render — the 2-min poll, the tab-return fetch, AND the SWR
       revalidate repaint — must skip while this is true so it can't rebuild the
       row's HTML out from under the rep and wipe their unsaved input (the note that
       vanished + snapped-to-top a few seconds after a fresh rep-switch load). */
    function hasUnsavedTyping() {
      var portalWrap = document.querySelector('.rep-quote-portal-wrap');
      if (!portalWrap) return false;
      var areas = portalWrap.querySelectorAll('textarea');
      for (var i = 0; i < areas.length; i++) {
        if (!areas[i].value || areas[i].value.trim().length === 0) continue;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-19) — ONLY A TEXTAREA THE REP CAN SEE COUNTS.
           The "+ New" modals inject their own textareas into #rqd-modal-body, and closeModal()
           only removes a CSS class — the box and its text stay in the DOM, inside this wrap,
           forever. So one Phone Lead with anything typed into Message/Notes used to make this
           return true for the rest of the page's life: the Refresh button accused the rep of
           unsaved text with nothing on screen to explain it, and every background repaint
           (SWR revalidate, 2-min poll, tab-return, the last-moment render gate) was silently
           skipped — which is what hid the rep's own brand-new lead until they forced a refresh.
           A textarea nobody can see is not one anybody is typing into. getClientRects() is the
           test rather than offsetParent, because the modal backdrop is position:fixed (for which
           offsetParent is null even while visible) and is hidden with display:none, for which
           getClientRects() is reliably empty. */
        if (areas[i].getClientRects().length === 0) continue;
        return true;
      }
      var ae = document.activeElement;
      /* CUSTOM_DDSEARCH_BY_CLAUDE (Ryan 2026-10-07) — THE SEARCH BOX IS NOT UNSAVED WORK. Treating
         focus there as typing skipped the 2-minute poll for as long as the cursor sat in it, so the
         worker's 180s board cache lapsed and the next search paid the full ~6s rebuild; it also
         refused to paint the background search's own answer. A repaint never touches the box. */
      if (ae && ae.id === 'rqd-search') return false;
      if (ae && portalWrap.contains(ae)) {
        var tag = ae.tagName;
        if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') return true;
      }
      return false;
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-28 PM14) — REFRESH, AND SAYING HOW OLD THIS IS.
       ────────────────────────────────────────────────────────────────────────────────────────
       ⛔ A BROWSER RELOAD CANNOT GET FRESH DATA, WHICH IS WHY THIS EXISTS. F5 sends a plain
       /rep-quotes, that hits the 180s server cache, and the rep sees the same bytes again — so
       "I refreshed and it is still wrong" was unanswerable. The only paths that bypassed the
       cache were the 2-minute background poll and the rep's own saves. This is the first one a
       human can press.

       ⛔ AND IT MATTERS MORE ONCE AI AGENTS WRITE TO DEALS. The post-mutation bypass keys off
       `rqd_mutated_at` in localStorage, stamped by OUR OWN posts — an agent (or another rep)
       changing a deal cannot mark this browser dirty, so nothing here knows it happened. The
       2-minute poll was the only corrective. Ryan 2026-08-28: "humans need to be able to refresh
       on-demand to see the latest."

       ⚠️ THE LABEL IS THE HALF THAT DOES THE WORK. A button alone leaves people guessing whether
       they need it; "as of 2:47pm" tells them. It reports when the PAINTED bytes were fetched, so
       a cache hit reads its true age rather than the moment it was drawn.

       ⚠️ Refresh is an explicit act, so unlike the quiet paths it is NOT silently skipped while
       someone is typing — it warns first, because the rebuild would destroy an open composer's
       unsaved text (the reason hasUnsavedTyping() guards the poll and the revalidate). */
    var _lastParams = '';   // CUSTOM_DDFEEDSTUCK_BY_CLAUDE - the params behind the painted view
    var _lastDataAt = 0;
    var _freshTimer = null;
    /* CUSTOM_DDREFRESH_BY_CLAUDE (Ryan 2026-09-15, suggestion c045754566fe) — ONE PAINTER FOR THE
       PILL, BECAUSE THREE THINGS WERE WRITING TO IT.
       ────────────────────────────────────────────────────────────────────────────────────────
       Ryan: *"clicking Refresh often feels like nothing happened... the label can stay stuck on
       Refresh 20min even after click / hard refresh, then later it snaps to Refresh now with no
       tie to the click."* All three halves of that are real, and none of them is the spinner:

       ⛔ 1. THE BACKGROUND REVALIDATE WAS INVISIBLE. After F5 the board paints instantly from the
       sessionStorage SWR entry, so the age it reports is the ENTRY's age — a truthful "20m" — and
       the `&__nc=1` revalidate that will correct it runs silently for the 12s it takes. Nothing on
       screen said work was happening, and when the repaint landed the label jumped to "now" for
       no visible reason. That is the "snaps with no tie to the click" report exactly. So a
       background revalidate now lights the same pill the click does.

       ⛔ 2. PROSPECTING NEVER STAMPED ITS FRESHNESS AT ALL. `fetchQuotes` returns early for
       `currentSource === 'prospecting'`, forty lines above the `_lastDataAt` stamp — and the
       Refresh pill is deliberately relocated INTO the prospect bar (see _syncProspectFilters), so
       it is sitting right there, pressable, reporting the age of the last DEAL-BOARD load and
       climbing. Press it as often as you like: the number never resets. Literally a label stuck
       on "20m" after a click.

       ⛔ 3. A FAILED LOAD LEFT A CONFIDENT AGE. The catch wrote a message into the empty state and
       never touched the pill, so a board that failed to load still advertised "now".

       The fix is one painter. `_renderFreshness` owns the age span, the spin class and the title;
       everything else sets a flag and calls it. ⚠️ A CLICK OUTRANKS EVERYTHING — while
       `_clickBusy` is set the seconds counter owns the text and the painter touches only the
       tooltip, so a fetch resolving mid-click cannot blank the counter for a second and make the
       button look like it died. And the spin class is now DERIVED rather than set by hand: no
       path can leave it spinning, whatever happens to the code that started it. */
    var _clickBusy = false;   // a human pressed Refresh and is watching the seconds counter
    var _bgBusy = 0;          // search-box background fetches in flight
    var _bgRevalGen = 0;      // _fetchGen of the SWR revalidate in flight; spins the pill only while it is still the view on screen
    var _loadFailed = false;  // the last loud load threw — the age on screen is not to be trusted
    /* Self-contained toast (no CSS dependency), so a failed refresh says so somewhere other than
       an empty state the rep may have scrolled past. Mirrors _dupToast further down; kept local
       rather than shared because this scope cannot see that one. */
    function _refreshToast(msg) {
      try {
        var t = document.createElement('div');
        t.className = 'rqd-refresh-toast';
        t.textContent = msg;
        t.setAttribute('style', 'position:fixed;left:50%;bottom:32px;transform:translateX(-50%);z-index:100000;background:#b42318;color:#fff;padding:12px 18px;border-radius:10px;box-shadow:0 8px 30px rgba(0,0,0,.35);font-size:14px;font-weight:600;max-width:90vw;text-align:center;');
        document.body.appendChild(t);
        setTimeout(function () { t.style.transition = 'opacity .4s'; t.style.opacity = '0'; }, 5200);
        setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 5700);
      } catch (_) { /* toast is cosmetic */ }
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-29) — RELATIVE ONLY, NEVER A CLOCK TIME.
       The previous ladder fell back to "2:47pm" past an hour, which was fine beside the button
       and is wrong ON it: ⛔ "Refresh (2:47pm)" reads as a SCHEDULE — refresh AT 2:47 — not as
       the age of the data. A control's label describes what it does, so any absolute time sitting
       in one gets read as an instruction. The exact timestamp is still available, in `title`,
       where it reads as description rather than command.
       Compact by design: this shares a pill with an icon and a word, so 'now' / '8m' / '3h' /
       '2d' rather than '8 min ago'. */
    function _freshLabel(ms) {
      if (!ms) return '';
      var age = Math.max(0, Date.now() - ms);
      if (age < 45000) return 'now';
      var m = Math.round(age / 60000);
      if (m < 60) return m + 'm';
      /* ⚠️ FLOOR above the minute rung, ROUND below it. Rounding hours would call 90 minutes
         "2h" — overstating an age by half an hour to save a character. Flooring the minutes
         instead would call 46 seconds "0m", which is worse than either. Different rungs, and
         the boundary is where 'now' stops. */
      var h = Math.floor(m / 60);
      if (h < 24) return h + 'h';
      return Math.floor(h / 24) + 'd';
    }
    function _renderFreshness() {
      var el = document.getElementById('rqd-freshness');
      var btn = document.getElementById('rqd-refresh');
      /* The three states this pill can be in, in precedence order. A click outranks a
         background check, and a background check outranks a failure we have already reported
         once, because the check is the thing that will clear it. */
      var _bgLive = _bgBusy > 0 || (_bgRevalGen !== 0 && _bgRevalGen === _fetchGen);
      var busy = _clickBusy ? 'click' : (_bgLive ? 'bg' : (_loadFailed ? 'failed' : 'idle'));
      /* ⛔ THE SPIN CLASS IS DERIVED, NEVER SET BY HAND. The click handler used to add and
         remove it itself, which made every early return in its path a chance to strand the icon
         spinning. It is a function of the flags now, recomputed on every repaint. */
      if (btn) {
        if (busy === 'click' || busy === 'bg') btn.classList.add('rqd-refresh--spinning');
        else btn.classList.remove('rqd-refresh--spinning');
        /* The tooltip is where the precise time lives, and it names the ACTION too — the
           button's own title used to say "Fetch the latest data now" and that must not be lost
           to a bare timestamp. */
        btn.title =
          busy === 'click' ? 'Refreshing the board...' :
          /* ⚠️ The age has to survive the check. 'checking' replaces it in the pill (there is no
             room for both), so the tooltip is the only place left that can answer "how old is
             what I am looking at while you check" — and that is the question the pill exists for. */
          busy === 'bg' ? ('Checking for newer data... (showing data from '
            + (_lastDataAt ? new Date(_lastDataAt).toLocaleString() : 'this session') + ')') :
          busy === 'failed' ? 'The last load did not come back — click to try again' :
          (_lastDataAt
            ? ('Data fetched ' + new Date(_lastDataAt).toLocaleString() + ' — click to fetch the latest now')
            : 'Fetch the latest data now');
      }
      if (!el) return;
      /* Writes only this span, so the icon and the word beside it are untouched. The middot is a
         CSS ::before on the span, so an empty age collapses the separator with it.
         ⚠️ SILENT WHILE A CLICK IS IN FLIGHT. The seconds counter owns this text then, and a
         mid-fetch re-label would blank it for a second — the exact "did it stop?" flicker this
         card is about. The tooltip above still updates: nothing else writes that.
         ⚠️ 'checking' and 'failed' are wider than '20m' and the pill will step. The width note
         on .rqd-refresh__age is about an IDLE pill re-labelling itself every 30s; a state change
         is the one time a width change carries information rather than being a twitch. */
      if (busy !== 'click') {
        el.textContent =
          busy === 'bg' ? 'checking' :
          busy === 'failed' ? 'failed' :
          (_lastDataAt ? _freshLabel(_lastDataAt) : '');
        if (busy === 'failed') el.classList.add('rqd-refresh__age--failed');
        else el.classList.remove('rqd-refresh__age--failed');
      }
      /* Re-label on a timer so "just now" ages into "3 min ago" on a board nobody is touching —
         a stamp frozen at load time is worse than none, because it reads as current. */
      if (_freshTimer) clearTimeout(_freshTimer);
      _freshTimer = setTimeout(_renderFreshness, 30000);
    }
    /* CUSTOM_DDFEEDSTUCK_BY_CLAUDE (AIOPS 847f234e793b, Ryan 2026-09-14) — "LOADING ACTIVITY..."
       THAT NEVER LOADS.
       ────────────────────────────────────────────────────────────────────────────────────────
       Ryan: *"expanding a deal sometimes shows Loading activity... and it never loads. Refresh /
       re-expand does not always recover."*

       ⛔ IT IS NOT A SPINNER WAITING ON A FETCH. The Activity card starts no request; it prints
       whatever `noteEntries` the board handed it, and when the row was painted from the
       sessionStorage copy there is no array at all — `_slimForCache` strips it, because the email
       bodies are 86% of a deal and the board would not fit in the 5 MB origin budget otherwise.
       The row carries `_historyPending` instead, the card says "Loading activity...", and it is
       waiting for SOMEBODY ELSE'S repaint.

       ⛔ AND THAT REPAINT IS GATED ON `hasUnsavedTyping()`. Expanding a deal is the very act that
       puts a note composer on screen: click into it and the quiet repaint is skipped, the 2-minute
       poll is skipped too, and the history never lands. Meanwhile the FULL payload is sitting in
       `_memQuotes` unread — only the sessionStorage copy is slimmed, never the RAM one. So in the
       common case nothing needs fetching at all; it needs delivering.

       ⛔ SECOND WAY IN, and the reason a watchdog exists as well: the revalidate can have finished
       (or failed) BEFORE the row was expanded, so nothing is in flight and no repaint is coming.
       Re-expanding cannot help — it re-renders from the same stripped row.

       TWO MECHANISMS, deliberately separate:
         _repaintEntriesFor(ref)   push the history into an open row without touching the composer
         _watchStuckHistory()      turn a spinner nobody is feeding into an error with a Retry */

    /* Merge a fresh payload's `noteEntries` into the rows we already hold. Returns the refs that
       actually gained history, so a caller only repaints what changed. ⚠️ HISTORY ONLY — this must
       not become a general row merge. Everything else on the row is the repaint's business, and
       patching fields behind the typing guard's back is how the guard stops meaning anything. */
    function _mergeHistoryFrom(fresh) {
      var gained = [];
      try {
        var rows = (fresh && Array.isArray(fresh.quotes)) ? fresh.quotes : [];
        if (!rows.length || typeof allQuotes === 'undefined' || !Array.isArray(allQuotes)) return gained;
        var byRef = {};
        for (var i = 0; i < rows.length; i++) {
          if (rows[i] && rows[i].reference && Array.isArray(rows[i].noteEntries)) byRef[rows[i].reference] = rows[i];
        }
        for (var j = 0; j < allQuotes.length; j++) {
          var mine = allQuotes[j];
          if (!mine || !mine.reference) continue;
          /* Only a row that is MISSING its history. A row that already has an array is either live
             or has been patched optimistically, and the optimistic copy is the newer truth.
             CUSTOM_FEEDFIRST_BY_CLAUDE — EXCEPT a row filled by the one-deal fetch below
             (`_historyPartial`): that is the deal's own feed without the cascaded sibling lines,
             and the board's copy is the complete one. */
          if (Array.isArray(mine.noteEntries) && !mine._historyPartial) continue;
          var theirs = byRef[mine.reference];
          if (!theirs) continue;
          mine.noteEntries = theirs.noteEntries;
          delete mine._historyPending;
          delete mine._historyPartial;
          gained.push(mine.reference);
        }
      } catch (_e) { /* best-effort: the next full repaint is the backstop */ }
      return gained;
    }

    /* Re-render ONLY `.rqd-notes-log__entries` for one open row, built offscreen.
       ⚠️ The composer lives in a SIBLING subtree (`.rqd-notes-log__composer`), so swapping the
       entries list cannot touch an unsaved note — which is what makes this safe to run at the
       exact moment the full repaint is being refused. Same move the Discovery save already makes
       (~L25860); this is that trick, generalised and given the deal-side opts. */
    /* CUSTOM_FEEDVIEW_BY_CLAUDE (Ryan 2026-10-10) — published so the Deal Feed's Rep view /
       Everything switch (dashboard-feed-view.js) can redraw open feeds on the click. It was only
       handed to dashboard-deal-feed.js's init, so the switch saved the choice and redrew nothing
       until the page was reloaded. */
    window.RQD = window.RQD || {};
    window.RQD.repaintEntriesFor = _repaintEntriesFor;
    /* CUSTOM_FEEDFIRST_BY_CLAUDE (Ryan 2026-10-10) — AN OPENED CARD FETCHES ITS OWN FEED.
       A row painted from the saved copy has no history, and its card waited on the WHOLE board
       (~200 deals with their histories) before it could draw anything. Ryan: the feed is one of the
       slowest things on an expand, and the Rep view entries are what a rep needs first. So the card
       asks GET /deal-feed-entries for that ONE deal, draws it at once, and keeps it; reopening the
       card is then instant. The board's copy replaces it when it lands (`_historyPartial`, read by
       `_mergeHistoryFrom` above, and a full repaint replaces the row outright). One request per
       deal at a time; once it settles, a card whose history was stripped again can ask again. */
    var _historyFetches = {};
    function _rowFor(ref) {
      for (var i = 0; i < allQuotes.length; i++) { if (allQuotes[i] && allQuotes[i].reference === ref) return allQuotes[i]; }
      return null;
    }
    function _fetchHistoryFor(ref) {
      if (!ref || _historyFetches[ref]) return;
      var q = _rowFor(ref);
      if (!q || Array.isArray(q.noteEntries)) return;
      _historyFetches[ref] = API.get('/deal-feed-entries?ref=' + encodeURIComponent(ref)).then(function (res) {
        /* The guard only stops a SECOND request while one is in flight: a later repaint from the
           saved copy can strip the history again, and that open must be able to ask again. */
        delete _historyFetches[ref];
        var row = _rowFor(ref);
        /* The board may have won the race: its copy is the complete one, leave it. */
        if (!row || Array.isArray(row.noteEntries)) return;
        if (!res || !Array.isArray(res.noteEntries)) return;
        row.noteEntries = res.noteEntries;
        row._historyPartial = true;
        delete row._historyPending;
        _repaintEntriesFor(ref);
      }).catch(function () { delete _historyFetches[ref]; });
    }
    window.RQD.fetchHistoryFor = _fetchHistoryFor;
    function _repaintEntriesFor(ref) {
      try {
        if (!ref || !window.RQD || !window.RQD.buildActivityCard) return false;
        var detail = document.getElementById('rqd-detail-' + ref);
        if (!detail) return false;                       // row is not open; nothing to repaint
        var entriesEl = detail.querySelector('.rqd-notes-log__entries');
        if (!entriesEl) return false;
        /* ⛔ NEVER OVER AN OPEN INLINE EDIT. An ✎ edit form lives INSIDE the entries list, so this
           swap would wipe it — the one case where the subtree is not safely disposable. */
        if (document.activeElement && entriesEl.contains(document.activeElement)) return false;
        var q = null;
        for (var i = 0; i < allQuotes.length; i++) { if (allQuotes[i] && allQuotes[i].reference === ref) { q = allQuotes[i]; break; } }
        if (!q) return false;
        var tmp = document.createElement('div');
        tmp.innerHTML = window.RQD.buildActivityCard(q, {});
        var fresh = tmp.querySelector('.rqd-notes-log__entries');
        if (!fresh) return false;
        entriesEl.replaceWith(fresh);
        /* The count badge is part of the same claim and would otherwise keep saying (0). */
        var title = detail.querySelector('.rqd-notes-log .rqd-detail__section-title');
        if (title) {
          var countEl = title.querySelector('.rqd-notes-log__count');
          var n = (q.noteEntries || []).length;
          if (countEl) countEl.textContent = ' (' + n + ')';
        }
        return true;
      } catch (_e) { return false; }
    }

    /* The watchdog. A "Loading activity..." older than the threshold is one nobody is feeding:
       either the revalidate finished before this row was expanded, or it failed.

       ⛔ IT TRIES THE CHEAP ANSWER FIRST. The fresh payload is usually already in `_memQuotes` for
       the current view, so the fix is a merge and a repaint, not a request. Only when RAM has
       nothing does it say so and offer a Retry — a spinner that has given up must SAY it has given
       up, which is the whole of this card's ask 3. */
    var _stuckHistoryTimer = null;
    var _STUCK_HISTORY_MS = 12000;   // the `__nc=1` board assembly was measured at 12.3s
    function _watchStuckHistory() {
      try {
        var pending = document.querySelectorAll('[data-history-pending]');
        if (!pending.length) return;
        var now = Date.now();
        for (var i = 0; i < pending.length; i++) {
          var el = pending[i];
          var ref = el.getAttribute('data-history-pending');
          var since = parseInt(el.getAttribute('data-since') || '0', 10);
          if (ref) _fetchHistoryFor(ref); // CUSTOM_FEEDFIRST_BY_CLAUDE — a card nobody asked for yet
          if (!ref || !since || (now - since) < _STUCK_HISTORY_MS) continue;
          /* Cheap answer: is it already in RAM for the view we are on? */
          var hit = _memQuotesGet('rqd-swr:' + _lastParams);
          if (hit && _mergeHistoryFrom(hit).indexOf(ref) !== -1 && _repaintEntriesFor(ref)) continue;
          if (el.getAttribute('data-gave-up') === '1') continue;
          el.setAttribute('data-gave-up', '1');
          el.innerHTML = 'Could not load this deal\'s history. '
            + '<button type="button" class="rqd-notes-log__retry" data-history-retry="' + ref + '">Retry</button>';
        }
      } catch (_e) { /* cosmetic */ }
    }
    /* One document-level listener rather than one per row: the entries list is replaced wholesale
       by every repaint, so a handler bound to the button would not survive its own fix. */
    document.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest('[data-history-retry]');
      if (!btn) return;
      var ref = btn.getAttribute('data-history-retry');
      var host = btn.closest('[data-history-pending]');
      if (host) { host.textContent = 'Loading activity…'; host.setAttribute('data-since', String(Date.now())); host.removeAttribute('data-gave-up'); }
      /* force:true bypasses BOTH caches; quiet:true keeps the board from collapsing under the rep.
         The repaint may still be refused for typing - which is fine, because the merge below runs
         off the same fresh payload and does not need the repaint. */
      Promise.resolve(fetchQuotes({ quiet: true, force: true }))
        .catch(function () { /* fetchQuotes reports its own failure */ })
        .then(function () { _repaintEntriesFor(ref); setTimeout(_watchStuckHistory, 200); });
    });

    function _bindRefreshButton() {
      var btn = document.getElementById('rqd-refresh');
      if (!btn) return;
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-15) — ⛔ ASYNC BECAUSE THE GUARD IS, and
         the guard has to be: a native confirm() lives in browser chrome where nothing driving this
         page can see or answer it. Everything after the await is ordinary DOM work — no
         preventDefault, no event-object read — so moving it into a microtask changes nothing.
         ⚠️ `danger` on a REFRESH looks odd until you read what it guards: the rep's unsaved note
         or half-written email. Danger focuses nothing, so Enter cannot discard their typing by
         reflex, which is the whole reason this prompt exists. It only appears when there IS
         unsaved text, so the deliberate click is not a cost anybody pays routinely. */
      btn.addEventListener('click', async function () {
        if (btn.disabled) return;
        if (hasUnsavedTyping() && !(await rqdConfirm(
              'You have unsaved text in an open note or email. Refreshing will discard it.',
              { title: 'Discard unsaved text?', confirmLabel: 'Refresh anyway', danger: true }))) return;
        /* Busy state lives on the control, and it is restored in a finally so a failed fetch
           cannot leave the board looking permanently mid-refresh. */
        btn.disabled = true;
        /* The class itself is _renderFreshness's job now (see the flags block above it): setting
           the flag and asking for a repaint is the only move here, so there is exactly one place
           that can leave the icon spinning, and it cannot. */
        _clickBusy = true;
        _renderFreshness();
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-11) — ⛔ THE PROGRESS SIGNAL MUST NOT BE AN
           ANIMATION. Ryan: *"there's no visualization to let me know it's doing anything... I need
           this, so I know it's working or not. Especially since it can take 30-60 seconds."* The
           spinner and the loader were already here and already deployed — but the spinner is a
           CSS animation, and `@media (prefers-reduced-motion: reduce)` in dashboard.css turns it
           into a static half-opacity glyph, while "Loading quotes..." is a fixed string. Both are
           indistinguishable from a hung page for a minute.
           ⛔ SO THE SIGNAL IS A COUNTER IN TEXT: it advances every second whether or not this
           machine renders animations, and a number that is still climbing is the only thing that
           answers "is it working". Restored on settle; `_renderFreshness` puts the age pill back. */
        var _t0 = Date.now();
        var _lbl = btn.querySelector('.rqd-refresh__label');
        var _age = btn.querySelector('.rqd-refresh__age');
        var _loadTxt = document.querySelector('#rqd-loader p');
        /* ⛔ RESTORE TO THE CONSTANT, NOT TO WHAT WAS THERE. Both of these are fixed strings in
           the markup, and reading them back off the DOM meant that if any path ever left
           "Refreshing" or "Still refreshing... 41s" on screen, the NEXT click would capture that
           as the resting state and keep it forever. A stuck label that heals itself on the next
           click beats one that latches. */
        var _lblWas = 'Refresh';
        var _loadWas = 'Loading quotes...';
        var _gaveUp = false;
        var _secs = function () { return Math.round((Date.now() - _t0) / 1000); };
        var _tick = function () {
          var s = _secs();
          if (_lbl) _lbl.textContent = 'Refreshing';
          if (_age) _age.textContent = s + 's';
          if (!_loadTxt) return;
          /* ⚠️ The wording escalates so a long wait reads as a long wait rather than as a stall.
             A normal board is 3-4s; `__nc=1` (which Refresh always sends) has been measured at
             12.3s; 30-60s is a big board, not a fault. */
          _loadTxt.textContent = s < 20
            ? 'Refreshing the board... ' + s + 's'
            : (s < 45
              ? 'Still refreshing... ' + s + 's (a large board can take up to a minute)'
              : 'Still refreshing... ' + s + 's - this is longer than usual, but it has not failed.');
        };
        _tick();
        var _iv = setInterval(_tick, 1000);
        var _restore = function () {
          try { clearInterval(_iv); } catch (_e) {}
          try { clearTimeout(_giveUp); } catch (_e) {}
          if (_lbl) _lbl.textContent = _lblWas;
          if (_loadTxt) _loadTxt.textContent = _loadWas;
          btn.disabled = false;
          /* Clearing the flag and repainting is the whole restore: _renderFreshness drops the spin
             class and writes either the true age or 'failed', whichever fetchQuotes just decided. */
          _clickBusy = false;
          _renderFreshness();
        };
        /* ⛔ AND IT HAS TO BE ABLE TO GIVE UP. `RepAPI._request` has no AbortController and no
           timer, so a hung request spins this button until the browser's own network timeout —
           which is minutes, with the control disabled the whole time. Rather than plumb an abort
           through the shared fetch layer (which every screen in the portal uses), the button hands
           itself back after 2 minutes and SAYS SO. The request is left running: `fetchQuotes`
           already guards against a stale response repainting a newer view via `_fetchGen`, so a
           late arrival is discarded, not merged. */
        var _giveUp = setTimeout(function () {
          _gaveUp = true;
          try {
            /* ⚠️ Looked up here rather than closed over: `loader` / `emptyEl` are locals of
               fetchQuotes' own scope, not this one. */
            var _ld = document.getElementById('rqd-loader');
            var _mt = document.getElementById('rqd-empty');
            if (_ld) _ld.style.display = 'none';
            /* ⛔ NO EARLY RETURN IN HERE. `_restore()` below is what hands the button back; a
               `return` past it on a missing element would leave the control disabled for good,
               which is the very failure this timer exists to prevent. */
            if (_mt) {
              _mt.style.display = 'block';
              _mt.textContent = 'This refresh has not come back after ' + _secs()
                + ' seconds. It may still be running - check your connection, then press Refresh to try again.';
            }
          } catch (_e) {}
          /* ⚠️ The pill must say so too, or the board reads "· 3m" under an empty state that says
             the refresh never came back. Self-correcting: the request was left running, and if it
             does land, fetchQuotes clears the flag and stamps the real age. */
          _loadFailed = true;
          _restore();
        }, 120000);
        Promise.resolve(fetchQuotes({ force: true }))
          .catch(function () { /* fetchQuotes already reports its own failure */ })
          .then(function () { if (!_gaveUp) _restore(); });
      });
    }
    /* CUSTOM_DDSLIMSCOPE_BY_CLAUDE (Ryan 2026-09-15) — ⛔ HOISTED OUT OF THE BLOCK IT WAS
       DECLARED IN, WHICH THREW ON EVERY NETWORK FETCH.
       ──────────────────────────────────────────────────────────────────────────────────────
       Ryan: *"the error msg I keep seeing: Could not refresh the board: _slimForCache is not
       defined."*

       It was declared INSIDE `} else if (!_quiet) {` and called from TWO places: once inside
       that block (the SWR revalidate, fine) and once in the `if (!data)` branch BELOW it,
       which is outside. A function declaration in a block is block-scoped in strict mode, so
       the second call was a ReferenceError - every time.

       ⛔ WHICH MEANS IT THREW ON EVERY FETCH THAT REACHED THE NETWORK:
         • every QUIET fetch (the 2-minute poll, every save's refetch) - `_quiet` is true, so
           the block never runs and the function is never even declared;
         • every LOUD fetch that missed the cache - including EVERY REFRESH CLICK, because
           `force` deliberately skips the cache layer.
       The board only ever looked healthy because a cache HIT sets `data` and skips the branch
       entirely. The throw lands after the bytes have arrived and before renderTable, so the
       rows were fetched and then thrown away.

       ⚠️ IT WAS INVISIBLE UNTIL THE PILL LEARNED TO SAY SO. fetchQuotes catches its own
       throw, and before 2026-09-15 a loud failure only wrote into the empty state - which on a
       long board is scrolled off screen. The toast and the red "failed" age are what surfaced
       a bug that had been swallowing the Refresh button.

       ⚠️ OUTER SCOPE, NOT JUST THE TOP OF fetchQuotes: it is pure (payload in, payload out,
       no closure over anything) so it has no business being re-declared per call, and at this
       level neither caller can be outside it. */
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-03) — ⛔ THE STORED COPY LEAVES THE EMAIL
       HISTORY BEHIND, because it did not fit and so NOTHING was being stored.

       sessionStorage is ONE ~5 MB budget for the whole origin. Measured on the live board:
       Ryan's `status=all` view is 5,649 KB and JW's is 10,760 KB, so neither could ever be
       cached even with every other view evicted — every reload of the view reps live in started
       cold and refetched the lot. The August payload diet had left 202 KB of margin; the board
       has since outgrown it, which is precisely what cacheDealList's warning was left there to
       say.

       ⛔ `noteEntries` IS 81% OF A DEAL ON THE WIRE (~29 KB each, 200 to a page) AND THE LIST
       RENDERS NONE OF IT. It is read by the Activity card, one deal at a time, when a row is
       opened. So the cache keeps what the board paints and drops what it does not — the
       history is one already-in-flight request away, and the RAM cache still holds it whole for
       the rest of the tab's life.

       ⚠️ IT IS MARKED, NOT SILENTLY MISSING. `_historyPending` is what stops the Activity card
       announcing "No activity yet" on a deal with fifteen emails on it — an absent array and an
       empty one mean opposite things, and only the flag can tell them apart. Set on the ROW,
       not the envelope, because that is what the card is handed. */
    /* CUSTOM_DDKEEPPLACE_BY_CLAUDE (Ryan 2026-10-22) - helpers for the quiet repaint's "do not disturb" rule.
       _ddRepIsBusy: the rep clicked, pressed a key, scrolled or wheeled in the last DD_QUIET_IDLE_MS, has text
       selected, or has a menu open on the board (anything `aria-expanded="true"` inside it). Pointer movement alone
       does not count: resting a hand on the mouse must not starve the board of fresh data. */
    var DD_QUIET_IDLE_MS = 2000;
    var DD_QUIET_HOLD_MAX_MS = 60000;
    var _ddLastInputAt = 0;
    ['pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'].forEach(function (ev) {
      try { window.addEventListener(ev, function () { _ddLastInputAt = Date.now(); }, { passive: true, capture: true }); } catch (_) {}
    });
    function _ddRepIsBusy() {
      if (Date.now() - _ddLastInputAt < DD_QUIET_IDLE_MS) return true;
      try { var sel = window.getSelection && window.getSelection(); if (sel && String(sel).trim()) return true; } catch (_) {}
      try {
        var root = document.querySelector('.rep-quote-portal-wrap') || document.body;
        var open = root.querySelectorAll('[aria-expanded="true"]');
        for (var i = 0; i < open.length; i++) if (open[i].offsetParent !== null) return true;   // a visible open menu
      } catch (_) {}
      return false;
    }
    function _ddCaptureAnchor() {
      try {
        if (!tbody) return null;
        var els = tbody.querySelectorAll('tr[data-ref], .rqd-detail[id^="rqd-detail-"]');
        for (var i = 0; i < els.length; i++) {
          var r = els[i].getBoundingClientRect();
          if (r.height > 0 && r.bottom > 0) {
            var isRow = els[i].tagName === 'TR';
            return { kind: isRow ? 'row' : 'detail', ref: isRow ? els[i].getAttribute('data-ref') : els[i].id, offset: r.top };
          }
        }
      } catch (_) {}
      return null;
    }
    function _ddRestoreAnchor(a) {
      if (!a || !a.ref || !tbody) return false;
      try {
        var el = a.kind === 'row'
          ? tbody.querySelector('tr[data-ref="' + (window.CSS && CSS.escape ? CSS.escape(a.ref) : a.ref) + '"]')
          : document.getElementById(a.ref);
        if (!el) return false;
        var r = el.getBoundingClientRect();
        if (!(r.height > 0)) return false;
        var delta = r.top - a.offset;
        if (Math.abs(delta) >= 1) window.scrollTo(0, window.scrollY + delta);
        return true;
      } catch (_) { return false; }
    }
    /* END CUSTOM_DDKEEPPLACE_BY_CLAUDE */
    function _slimForCache(payload) {
      if (!payload || !Array.isArray(payload.quotes)) return payload;
      return Object.assign({}, payload, {
        quotes: payload.quotes.map(function (q) {
          if (!q || q.noteEntries === undefined) return q;
          var out = Object.assign({}, q);
          /* ⛔ CARRY THE ONE FACT THE LIST ITSELF DERIVES FROM THE HISTORY. The unread-email
             envelope and its count live in the To Do column — the very thing this cache exists
             to paint — and they are computed by walking `noteEntries`. Dropping the array
             without this would blank the envelope on a cache paint: not a false claim, but a
             row that quietly reads "nothing unread" on a deal with unread mail, for as long as
             the refresh takes. A number is a handful of bytes against ~23 KB of history.
             ⚠️ Live data always wins: the reader below prefers a real `noteEntries` array and
             only falls back to this when the array is absent. */
          out._unreadCached = (Array.isArray(q.noteEntries) ? q.noteEntries : []).filter(function (e) {
            return e && e.type === 'email' && e.emailMeta
              && e.emailMeta.direction === 'inbound'
              && e.emailMeta.isRead === false;
          }).length;
          delete out.noteEntries;
          out._historyPending = true;
          return out;
        }),
      });
    }

    /* CUSTOM_DDREFRESHBLANK_BY_CLAUDE (Ryan 2026-10-22: "the board hit 21 seconds, the timer then stopped, and the display was
       blank") - A QUIET RELOAD NEVER CUTS OFF ONE THE REP IS WAITING ON. fetchQuotes drops a response when a newer fetch has
       started (`_gen !== _fetchGen`), which is right for a newer VIEW (tab, filter, page) and wrong for a background reload: the
       2-minute poll, a reload after a save or a wake landed inside a 20-30 s Refresh, bumped the generation, and the Refresh's
       answer was thrown away with the table already hidden. So while a foreground (non-quiet) load is in flight, a plain quiet
       reload is HELD and runs once when it finishes (a save made mid-refresh still shows). The search box's own fetch, an
       _inject repaint and any foreground load are untouched. */
    var _fgInFlight = 0;
    var _quietHeld = null;
    async function fetchQuotes(opts) {
      opts = opts || {};
      var _plainQuiet = !!opts.quiet && !opts.searchBg && !opts._inject;
      if (_plainQuiet && _fgInFlight > 0) { _quietHeld = opts; return; }
      var _fg = !opts.quiet && !opts.searchBg && !opts._inject;
      if (_fg) _fgInFlight++;
      try {
        return await _fetchQuotesCore(opts);
      } finally {
        if (_fg) {
          _fgInFlight--;
          if (_fgInFlight === 0 && _quietHeld) {
            var _h = _quietHeld; _quietHeld = null;
            setTimeout(function () { fetchQuotes(_h); }, 0);
          }
        }
      }
    }
    async function _fetchQuotesCore(opts) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — opts.quiet=true skips
         the loader flash + table-hide + expandedRef wipe + scroll jump so a
         background re-render (e.g. after auto-hold on a note save) doesn't
         visually collapse the row the rep was working in or fling them back
         to the top of the page. Default behavior (tab switch, pagination,
         search) is unchanged. */
      opts = opts || {};
      /* CUSTOM_DDSEARCH_BY_CLAUDE (Ryan 2026-10-07) — `searchBg`: the search box's own fetch.
         It renders like a quiet refresh (no spinner, no blank table — the instant filter is
         already on screen) but it is NOT a revalidate: it sends no `__nc`, so the worker answers
         from its cached board instead of rebuilding it. `_reqSearch` is what this fetch searched
         for; a result for a term the rep has since changed is never painted. */
      var _searchBg = !!opts.searchBg;
      var _quiet = !!opts.quiet || _searchBg;
      var _reqSearch = currentSearch;
      var _sbBusy = false;
      if (_searchBg) { _sbBusy = true; _bgBusy++; _renderFreshness(); }
      var _qSavedScrollY = _quiet ? window.scrollY : 0;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-20) — see _quietGen above.
         Ticket for this quiet render, plus a LIVE scroll snapshot.

         The snapshot used to freeze here, at the top of an async function that
         can run for 25+ seconds (the `&__nc=1` revalidate bypasses the server
         cache and was measured at 12.3s), and was then applied in the finally.
         Anything the rep did in between was undone. Now it TRACKS the rep until
         the moment we actually write to the DOM, so the restore can only ever
         return them to where they genuinely are — which makes it a no-op in the
         common case, and a real correction only when our own rebuild moved them. */
      var _myQuietGen = _quiet ? ++_quietGen : 0;
      var _qTrackScroll = null;
      if (_quiet) {
        _qTrackScroll = function () { _qSavedScrollY = window.scrollY; };
        try { window.addEventListener('scroll', _qTrackScroll, { passive: true }); } catch (_e) {
          try { window.addEventListener('scroll', _qTrackScroll, true); } catch (_e2) {}
        }
      }
      function _qStopTracking() {
        if (!_qTrackScroll) return;
        try { window.removeEventListener('scroll', _qTrackScroll, { passive: true }); } catch (_e) {}
        try { window.removeEventListener('scroll', _qTrackScroll, true); } catch (_e) {}
        try { window.removeEventListener('scroll', _qTrackScroll); } catch (_e) {}
        _qTrackScroll = null;
      }
      // True once a newer quiet render has superseded this one.
      function _qSuperseded() { return _quiet && _myQuietGen !== _quietGen; }
      /* Invariant: we only move the rep if we moved the DOM. Set true just
         before renderTable; the finally refuses to touch scroll unless it is. */
      var _qDidRender = false;
      if (!_quiet) {
        loader.style.display = 'block';
        tableWrap.style.display = 'none';
        emptyEl.style.display = 'none';
        document.getElementById('rqd-pagination').style.display = 'none';
      }
      pushUrlState();
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — expose currentSource to CSS so the Online
         tab can hide the Status column + widen Org/Customer/Location. */
      if (tableEl) tableEl.dataset.source = currentSource;
      // Phase 1.33 — Tab switches blow away the prior tab's table so any
      // expanded row no longer exists. Reset the dim flag + expandedRef
      // so the new tab doesn't open with every row stuck at 55% opacity
      // because the old "has-expanded" class never got cleared.
      // (Quiet mode preserves expandedRef so restoreExpandedRow re-opens
      // the row that was open before the save.)
      if (!_quiet) {
        expandedRef = null;
        if (tableEl) tableEl.classList.remove('rqd-table--has-expanded');
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Deal Prospecting branch.
         CFA-owned leads (lead:{ref} with cfaCode set) live in their own
         dashboard view that swaps the entire table + stats header. Fetch
         path, render path, and stats compute are all distinct from the
         quote-side flow. */
      if (currentSource === 'prospecting') {
        /* CUSTOM_DDTWOLOADERS_BY_CLAUDE (Ryan 2026-10-15) — this branch returns before the board's
           `++_fetchGen`, so picking a CFA left a deal-board revalidate still counted as "the view
           on screen": the pill kept spinning for it, and its landing would trigger a repaint. */
        if (!opts._inject) { ++_fetchGen; _renderFreshness(); }
        // Clear any stale rep-side panels left over from the previous source.
        if (alertsEl) alertsEl.innerHTML = '';
        try {
          var dpParams = '';
          var dpRepVal = repFilter && repFilter.value;
          if (dpRepVal) dpParams = '?cfa=' + encodeURIComponent(dpRepVal);
          var dpData = await API.get('/cfa-prospects' + dpParams);
          allQuotes = dpData.prospects || [];
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Prospect records
             carry `ref` (lead record convention); the rest of the dashboard
             code (row click → expand, refresh helpers, detail re-render)
             looks up via `x.reference`. Stamp an alias so all those paths
             work without per-call branching. */
          allQuotes.forEach(function(p) { if (p && !p.reference) p.reference = p.ref; });
          renderProspectStats(dpData.stats || {});
          _syncProspectFilters();
          /* CUSTOM_DDREFRESH_BY_CLAUDE (Ryan 2026-09-15, suggestion c045754566fe) — ⛔ STAMP IT
             HERE, BECAUSE THIS BRANCH RETURNS BEFORE THE STAMP. The `_lastDataAt` write lives
             ~250 lines below, past this early return, so Prospecting has never updated the
             freshness pill in its life: it showed the age of the last DEAL-BOARD load and kept
             climbing. And _syncProspectFilters deliberately MOVES the Refresh pill into the
             prospect bar, so it is sitting right there, pressable, lying. Pressing it refetched
             correctly and changed the number by nothing, which is exactly Ryan's "label stuck on
             Refresh 20min even after click". A prospect fetch is always a live request (no SWR
             layer on /cfa-prospects), so the paint is as fresh as now. */
          _lastDataAt = Date.now();
          _loadFailed = false;
          _renderFreshness();
          loader.style.display = 'none';
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — one render path for
             both prospect views (All Active flat list / Follow Up due-only);
             also owns the table/empty-state visibility. */
          _renderProspectView();  // sets the table, empty-state, AND the footer count
          /* /cfa-prospects returns the whole list in one shot, so Prev/Next stay disabled;
             the footer count text is owned by _renderProspectView now. */
          prevBtn.disabled = true;
          nextBtn.disabled = true;
          document.getElementById('rqd-pagination').style.display = '';
        } catch (err) {
          loader.style.display = 'none';
          emptyEl.style.display = 'block';
          emptyEl.textContent = 'Failed to load prospects: ' + (err && err.message ? err.message : 'unknown error');
          /* Same contract as the deal board's catch below: the pill stops claiming an age it does
             not have, and the failure is said out loud rather than only in the table area. */
          _loadFailed = true;
          _renderFreshness();
          _refreshToast('Could not load prospects: ' + (err && err.message ? err.message : 'the request failed'));
        }
        // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-20) — this return predates the
        // try/finally below, so the scroll tracker installed at the top of the
        // function would leak here (one listener per prospecting fetch, forever).
        _qStopTracking();
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      try {
        var params = '?status=' + encodeURIComponent(currentStatus) +
          '&page=' + currentPage +
          '&sort=' + encodeURIComponent(currentSort) +
          '&search=' + encodeURIComponent(currentSearch) +
          '&source=' + encodeURIComponent(currentSource) +
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — show cancelled */
          (currentIncludeCancelled ? '&includeCancelled=1' : '');
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

        var repVal = repFilter.value;
        if (repVal) params += '&rep=' + encodeURIComponent(repVal);
        if (currentDateFrom) params += '&dateFrom=' + encodeURIComponent(currentDateFrom);
        if (currentDateTo) params += '&dateTo=' + encodeURIComponent(currentDateTo);

        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-11) — stale-while-
           revalidate. The worker needs 3-4s to assemble /rep-quotes
           (Shopify queries + hundreds of KV reads), so every page load sat
           on the spinner. Now: the last successful response for the SAME
           params (tab/page/filters) renders instantly from sessionStorage,
           while the real fetch runs in the background and re-renders
           through the existing quiet path (scroll + expanded row
           preserved) when it lands — usually a few seconds of staleness
           at most. Cache writes are quota-guarded (a too-big payload just
           skips SWR for that view); entries die with the tab session and
           are ignored after 6h. opts._inject carries the fresh payload on
           the revalidate hop so we don't fetch twice. */
        // This fetch's generation. _inject repaints inherit the generation of the
        // revalidate that already passed the staleness check, so they don't bump it.
        var _gen;
        /* CUSTOM_DDTWOLOADERS_BY_CLAUDE (Ryan 2026-10-15) — repaint the pill the moment the view
           changes, so a revalidate that belonged to the view just left stops spinning it now,
           not when it happens to land (see _bgRevalGen). */
        if (!opts._inject) { _gen = ++_fetchGen; _renderFreshness(); }
        var _swrKey = 'rqd-swr:' + params;
        /* CUSTOM_DDFEEDSTUCK_BY_CLAUDE — the watchdog needs to know which cache entry belongs to
           what is currently on screen; it has no other way back to these params. */
        _lastParams = params;
        /* CUSTOM_DDSEARCH_BY_CLAUDE — a different view (tab, pill, rep, dates) starts a new pool. */
        var _ddKeyNow = _ddViewKeyOf(params);
        if (_ddKeyNow !== _ddSearchViewKey) { _ddSearchViewKey = _ddKeyNow; _ddResetSearchExtras(); }
        var data = null;
        /* When the bytes we are about to paint were actually fetched. A cache hit is as old as the
           ENTRY; only a network response is "now". Drives the "as of HH:MM" label, which is the
           thing that tells a rep whether pressing Refresh is worth it. */
        var _dataAsOf = 0;
        if (opts._inject) {
          data = opts._inject;
          _dataAsOf = Date.now();          // an _inject is the revalidate's fresh payload
        } else if (!_quiet) {
          // In-memory cache first (no quota), then sessionStorage (reload-survivable).
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-28 PM14) — opts.force (the Refresh button)
             skips this layer entirely. A cache hit here paints instantly and only revalidates in
             the BACKGROUND, which is the opposite of what someone pressing Refresh is asking for:
             they want to look at fresh data now, not in a moment. */

          var _cached = opts.force ? null : _memQuotesGet(_swrKey);
          if (_cached) _dataAsOf = _memQuotesAt(_swrKey);
          /* CUSTOM_DDREFRESHSTALE_BY_CLAUDE (Ryan 2026-10-01, RW-1469-A) — ⛔ force SKIPS THIS LAYER
             TOO. It used to skip only the RAM copy above and then fall straight into this read, so
             Refresh painted the tab's sessionStorage copy, which is the OLDER of the two: a new lead
             stayed missing through Refresh and F5 alike until sessionStorage.clear(). */
          if (!_cached && !opts.force) {
            /* CUSTOM_DDKEEPPLACE_BY_CLAUDE (Ryan 2026-10-22) - the saved copy is in IndexedDB now (RepPortal.API.dealListGet,
               which still falls back to a sessionStorage copy): the offline board outgrew sessionStorage's ~5 MB, so every
               return from the Workstation started cold. The read is async, so a newer fetch may have started meanwhile. */
            try {
              var _swrHit = await API.dealListGet(_swrKey);
              if (_swrHit && _swrHit.data) {
                _cached = _swrHit.data;
                _dataAsOf = _swrHit.at;   // as old as the ENTRY, not as old as this paint
              }
            } catch (_) { /* corrupt cache entry — fall through to network */ }
            if (_gen !== _fetchGen) return;
          }
          if (_cached) {
            data = _cached;
            /* CUSTOM_DDREFRESH_BY_CLAUDE (Ryan 2026-09-15, suggestion c045754566fe) — ⛔ SAY THAT
               THIS IS HAPPENING. This is the half of the complaint that was never a spinner bug.
               After F5 the board paints INSTANTLY off the sessionStorage entry, so the pill
               truthfully reports that entry's age — "20m" — and this revalidate then runs silently
               for the 12.3s it takes. Nothing on screen said work was in progress, and when the
               repaint landed the number jumped to "now" out of nowhere. Ryan: *"the label can stay
               stuck on Refresh 20min even after hard refresh... later it snaps to Refresh now with
               no tie to the click."* Both sentences describe this block.
               ⚠️ THE BOARD IS NOT HIDDEN AND THE BUTTON IS NOT DISABLED. This is a check, not a
               reload: the rep is looking at real data and may click Refresh over the top of it.
               Only the pill changes, to 'checking' with the icon turning.
               ⚠️ A COUNTER, not a boolean — two revalidates for the same view can overlap (a tab
               switch back and forth), and the first to land must not declare the second finished. */
            /* CUSTOM_DDTWOLOADERS_BY_CLAUDE (Ryan 2026-10-15) — keyed to THIS view's generation,
               not a shared counter. Was `_bgBusy++`: switch reps while this check ran and the
               next view's full-screen loader came up with the pill still turning for the board
               just left — two loaders at once, one of them for a view no longer on screen. The
               request still runs to the end (it warms the cache for that view); it just stops
               claiming the pill once another fetch has superseded it. */
            _bgRevalGen = _gen;
            _renderFreshness();
            var _bgSettled = false;
            var _bgDone = function () {
              if (_bgSettled) return;   // .then and .catch are both wired; only one may count
              _bgSettled = true;
              if (_bgRevalGen === _gen) _bgRevalGen = 0;
              _renderFreshness();
            };
            API.get('/rep-quotes' + params + '&__nc=1').then(function(fresh) {
              _memQuotesSet(_swrKey, fresh);
              /* Evicts older rqd-swr views and retries rather than silently losing the write —
                 see RepPortal.API.cacheDealList. */
              API.cacheDealList(_swrKey, JSON.stringify({ at: Date.now(), data: _slimForCache(fresh) }));
              // Only repaint if the user is STILL on this exact view. A revalidate
              // from a prior tab/rep must refresh the cache silently, never clobber
              // the view that was switched to in the meantime.
              /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — AND never repaint out
                 from under a rep who's mid-typing a note/call/edit: the quiet
                 re-render rebuilds the row + detail panel, wiping the open activity
                 composer's unsaved text and resetting scroll. The fresh payload is
                 already cached just above, so skipping the repaint loses nothing —
                 the rep's next action (e.g. saving the note) repaints with it. This
                 mirrors the 2-min poll + tab-return guards the SWR path never had. */
              /* ⛔ 'checking' ENDS WHEN THE BYTES ARE ON SCREEN, NOT WHEN THEY ARRIVE. Clearing the
                 flag here would repaint the pill with the OLD age for the moment the repaint takes
                 - checking -> 20m -> now - which is a worse version of the flicker this card is
                 about. So the repaint owns the settle; the skip path settles immediately, because
                 in that case the stale age IS the honest answer and there is nothing coming. */
              if (_gen === _fetchGen && !hasUnsavedTyping()) {
                Promise.resolve(fetchQuotes({ quiet: true, _inject: fresh }))
                  .catch(function () { /* the inject repaint reports its own failure */ })
                  .then(_bgDone);
              } else {
                /* CUSTOM_DDFEEDSTUCK_BY_CLAUDE (AIOPS 847f234e793b, Ryan 2026-09-14) — ⛔ THE
                   REPAINT IS REFUSED, BUT THE HISTORY STILL HAS TO ARRIVE. This is the branch that
                   produced "Loading activity... forever": the rep is typing (which expanding a deal
                   invites), so the rebuild is correctly skipped to protect their note - and the
                   fresh `noteEntries` were dropped on the floor with it, leaving an open row
                   waiting on a repaint that will not come until they blur and the 2-minute poll
                   fires. Merging the history and swapping ONLY the entries subtree gives them the
                   feed without touching the composer they are typing into. */
                try {
                  var _gainedRefs = _mergeHistoryFrom(fresh);
                  for (var _gi = 0; _gi < _gainedRefs.length; _gi++) _repaintEntriesFor(_gainedRefs[_gi]);
                } catch (_e) { /* the next full repaint is the backstop */ }
                _bgDone();
              }
            }).catch(function() {
              /* Background refresh failure — the stale view stands until the next action, and
                 deliberately WITHOUT setting _loadFailed: the board on screen is real data that
                 loaded fine, and painting the pill red over a failed background check would
                 accuse the visible board of something that is not true of it. The pill simply
                 goes back to reporting its honest age. */
              _bgDone();
            });
          }
        }
        if (!data) {
          // Bypass the server cache (serve fresh) on quiet loads AND for ~30s after
          // ANY mutation — including a quote saved in the Workstation before returning
          // to the DD — so the change is reflected instead of a stale cached assembly.
          var _recentMut = false;
          try { var _mAt = parseInt(localStorage.getItem('rqd_mutated_at') || '0', 10); _recentMut = !!_mAt && (Date.now() - _mAt < 30000); } catch (_e) {}
          /* ⛔ force MUST send __nc. Without it a Refresh is served straight from the 180s server
             cache and returns the very bytes the rep is trying to get past — the button would look
             like it worked and change nothing. This is also the ONLY way a human can force fresh
             data: a browser reload sends a plain request and hits that cache. It matters more now
             that AI agents write to deals, because an agent's write cannot mark THIS browser dirty
             (`rqd_mutated_at` is localStorage, set by our own posts), so the 2-minute poll is
             otherwise the only thing that would ever correct the view. */
          data = await API.get('/rep-quotes' + params + (((_quiet && !_searchBg) || _recentMut || opts.force) ? '&__nc=1' : ''));
          /* CUSTOM_DDSEARCH_BY_CLAUDE — a search answer that a newer keystroke has overtaken is not
             painted, but its rows still join the instant pool, so the next keystroke can find them. */
          if (_searchBg && data && Array.isArray(data.quotes) && _ddViewKeyOf(params) === _ddSearchViewKey) {
            data.quotes.forEach(function (q) { if (q && q.reference && !isRecentlyDeleted(q.reference)) _ddSearchExtras[q.reference] = q; });
          }
          _dataAsOf = Date.now();
          // A newer tab/rep/filter/page fetch started while this was in flight —
          // discard this response so it can't repaint over the newer view.
          if (_gen !== _fetchGen) return;
          _memQuotesSet(_swrKey, data);
          /* ⛔ was a bare setItem in a silent catch: sessionStorage is ONE ~5 MB origin budget
             shared by every cached view and this layer evicted nothing, so the first view loaded
             kept the space and the offline board was never cached at all. cacheDealList evicts
             the oldest rqd-swr view and retries. RAM cache still covers a genuine failure. */
          API.cacheDealList(_swrKey, JSON.stringify({ at: Date.now(), data: _slimForCache(data) }));
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        // Walk the raw response once: filter out tombstoned refs from the
        // displayed list AND count how many we removed per status bucket so
        // we can patch the server-computed stats. Without the stats patch,
        // the pill counts (NEW LEADS, QUOTED, etc.) still reflect deleted
        // refs during the 2-min propagation window — the row disappears
        // but the badge is wrong.
        var rawQuotes = data.quotes || [];
        var tombstoneAdjust = { awaiting: 0, quoted: 0, sold: 0, lost: 0, pending: 0, total: 0 };
        allQuotes = rawQuotes.filter(function(q) {
          if (!q || !isRecentlyDeleted(q.reference)) return true;
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — when the admin explicitly toggles
             "Show cancelled orders" on, a freshly-cancelled order's tombstone
             must NOT hide it. Tombstone is meant for "this row is gone";
             cancelled rows the admin chose to see are a different state, not
             a deletion. Other tombstoned refs (deleted quotes/leads) still
             get filtered. */
          if (currentIncludeCancelled && q.cancelled) return true;
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          tombstoneAdjust.total++;
          if (q.isPending || q.status === 'pending') { tombstoneAdjust.pending++; return false; }
          if (q.lifecycleStatus === 'sold') { tombstoneAdjust.sold++; return false; }
          if (q.lifecycleStatus === 'lost') { tombstoneAdjust.lost++; return false; }
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Match the
             server's awaiting filter (now gates on !chainLastSavedAt
             instead of !chainHasItems) so the tombstone count matches
             what the dashboard actually shows as NEW LEAD. */
          var isAwaiting = !q.lifecycleStatus && !q.chainQuoted && !q.chainLastSavedAt && (q.chainFromCustomerRfq || q.fromCustomerRfq || q.status === 'submitted' || q.status === 'under_review' || q.isLead || q.status === 'new_lead');
          if (isAwaiting) { tombstoneAdjust.awaiting++; return false; }
          tombstoneAdjust.quoted++; // catch-all
          return false;
        });
        /* CUSTOM_OPTIMISTIC_BY_CLAUDE (Ryan 2026-08-27) — re-apply anything saved in the last two
           minutes that this response does not yet reflect. Must run HERE: `allQuotes` has just been
           replaced with server objects, and every renderer below reads from it. */
        applyPendingPatches(allQuotes);
        // Patch data.stats so the pill counts match the visible rows.
        var patchedStats = Object.assign({}, data.stats || {});
        patchedStats.total           = Math.max(0, (patchedStats.total           || 0) - tombstoneAdjust.total);
        patchedStats.rawAwaitingCount= Math.max(0, (patchedStats.rawAwaitingCount|| 0) - tombstoneAdjust.awaiting);
        patchedStats.rawQuotedCount  = Math.max(0, (patchedStats.rawQuotedCount  || patchedStats.quotedCount || 0) - tombstoneAdjust.quoted);
        patchedStats.quotedCount     = Math.max(0, (patchedStats.quotedCount     || 0) - tombstoneAdjust.quoted);
        patchedStats.rawSoldCount    = Math.max(0, (patchedStats.rawSoldCount    || patchedStats.soldCount   || 0) - tombstoneAdjust.sold);
        patchedStats.soldCount       = Math.max(0, (patchedStats.soldCount       || 0) - tombstoneAdjust.sold);
        patchedStats.rawLostCount    = Math.max(0, (patchedStats.rawLostCount    || patchedStats.lostCount   || 0) - tombstoneAdjust.lost);
        patchedStats.lostCount       = Math.max(0, (patchedStats.lostCount       || 0) - tombstoneAdjust.lost);
        patchedStats.pendingCount    = Math.max(0, (patchedStats.pendingCount    || 0) - tombstoneAdjust.pending);
        renderStats(patchedStats);
        renderAlerts(data.alerts || []);
        if (data.reporting) renderReports(data.reporting, patchedStats);
        // CUSTOM_RFQPORTAL_BY_CLAUDE — Apply the freight-pending sub-filter
        // when the "⚠ Freight Pending" stat card was clicked. Keeps the
        // existing status-filter pipeline intact; this is a client-side
        // overlay that narrows the rendered set further. Resets on every
        // fresh fetch unless explicitly persisted (toggle is session-only).
        var _toRender = freightPendingOnly
          ? allQuotes.filter(function (q) {
              var bks = (q && Array.isArray(q.shippingBuckets)) ? q.shippingBuckets : [];
              return bks.some(function (b) {
                var set = !!b.freightCostSet || parseFloat(b.freightCost) > 0;
                return !set && b.parcelRatePending && b.parcelRatePending.since;
              });
            })
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — the open-deal cut. Skipped entirely
             under freightPendingOnly: that filter is an explicit narrowing the rep asked for,
             and quietly trimming it further would hide rows they went looking for. */
          : applyOpenDealCut(allQuotes);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-20) — LAST-MOMENT gate on the
           quiet render. Two checks that must happen HERE, immediately before the
           DOM write, not when this render was queued:

           1. Superseded? A newer quiet render is already in flight; rendering
              stale data now would fight it (and its restore would fight ours).

           2. Typing? hasUnsavedTyping() was consulted back at :5517, at the
              moment the revalidate RESOLVED — but the write lands later. Measured
              live 2026-07-20: FETCH-DONE t=38895 → TBODY-REBUILD t=44016, a
              5-SECOND window. A rep who started typing anywhere in that window had
              already been cleared by the guard, and their note was destroyed by
              this line. Re-checking here closes it: the check and the act are now
              the same instant.

           Skipping loses nothing — the fresh payload is already in the SWR cache,
           so the rep's next action repaints with it. Only the quiet path is gated;
           a loud fetch is an explicit user request and must always render. */
        if (_quiet && (_qSuperseded() || hasUnsavedTyping())) {
          _qStopTracking();
          return;
        }
        /* CUSTOM_DDKEEPPLACE_BY_CLAUDE (Ryan 2026-10-22: "if I'm on the DD and it's doing a refresh silently, once the
           refresh is done, I don't want it to disrupt whatever I'm doing at that moment"). ⛔ A QUIET REPAINT WAITS FOR A
           PAUSE. Mid-click, mid-scroll, with text selected or a menu open, the rebuild is held and re-checked every
           second. After DD_QUIET_HOLD_MAX_MS it paints anyway (still keeping the rep's row, below), so a menu whose
           `aria-expanded` was left stuck can never freeze the board. The typing gate above is unchanged and still skips
           outright. */
        if (_quiet && !_searchBg) {
          var _heldSince = Date.now();
          while (_ddRepIsBusy()) {
            if (Date.now() - _heldSince > DD_QUIET_HOLD_MAX_MS) break;
            await new Promise(function (r) { setTimeout(r, 1000); });
            if (_qSuperseded() || hasUnsavedTyping()) { _qStopTracking(); return; }
          }
        }
        /* ⛔ AND KEEP THE SAME ROW IN FRONT OF THEM, NOT THE SAME PIXEL. Restoring scrollY alone points at different
           deals as soon as a new row lands above the rep. The anchor is the first row (or open detail panel) on screen
           and its distance from the top, captured right before the rebuild. */
        var _qAnchor = _quiet ? _ddCaptureAnchor() : null;
        /* CUSTOM_DDSEARCH_BY_CLAUDE — the instant filter's pool. A plain load of a view is the
           pool; a search answer adds its rows (page 2+, other pills) so the next keystroke finds
           them at once. Recorded only for a response about to be painted. */
        if (!String(_reqSearch || '').trim()) {
          _ddSearchPool = { key: _ddSearchViewKey, rows: allQuotes.slice() };
        } else {
          allQuotes.forEach(function (q) { if (q && q.reference) _ddSearchExtras[q.reference] = q; });
        }
        if (_searchBg && searchInput && String(searchInput.value || '').trim() !== String(_reqSearch || '').trim()) {
          _qStopTracking();
          return;
        }
        emptyEl.textContent = _ddSearchEmptyText;
        _qStopTracking();  // from here on, any scroll change is OURS, not the rep's
        _qDidRender = true;
        /* Stamp what is about to be PAINTED, not when the fetch started — a served-from-cache
           paint is as old as the cache entry, and the whole point of the label is to say so. */
        _lastDataAt = _dataAsOf || Date.now();
        /* Bytes reached the screen, so whatever went wrong last time is over. The only writer of
           this flag other than the catch below and the give-up timer. */
        _loadFailed = false;
        _renderFreshness();
        renderTable(_toRender, { stream: !_quiet });
        // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — the trim's count is only known after
        // the cut has run, so refresh the toggle here rather than at bind time.
        syncOlderCompletedToggle();
        renderPagination(data.pagination);
        // When the freight-pending filter has narrowed to a single order,
        // auto-expand it + jump to the Freight Balance card so admin lands
        // directly on the parcel-rate-pending banner + cost input. Saves
        // the second click on the order row.
        if (freightPendingOnly && _toRender.length === 1) {
          var _autoRef = _toRender[0] && _toRender[0].reference;
          if (_autoRef) {
            setTimeout(function () { jumpToFreightBalance(_autoRef); }, 50);
          }
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        updateSortArrows();
        updatePillCounts(patchedStats);
        // Toggle-reveal hint on the show-cancelled checkbox — "(+N)"
        // shows how many cancelled rows would be revealed by toggling on.
        // (+0) means nothing matches; toggle is a no-op.
        var hints = data.toggleHints || {};
        var cancelledCountEl = document.getElementById('rqd-include-cancelled-count');
        if (cancelledCountEl) {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Count suffix only renders when the
             checkbox is checked (showing what's currently included). When
             unchecked the label reads cleanly as "Cancelled orders" with
             no trailing "(+N)" / "(0)" noise. */
          var cn = parseInt(hints.cancelledCount, 10) || 0;
          var cancelledCb = document.getElementById('rqd-include-cancelled');
          var showSuffix = cancelledCb && cancelledCb.checked;
          if (showSuffix) {
            cancelledCountEl.textContent = ' (' + cn + ')';
            cancelledCountEl.style.color = 'var(--rq-blue)';
          } else {
            cancelledCountEl.textContent = '';
          }
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        }
        // Restore the previously-expanded row's detail panel after the
        // table re-renders. Closing a modal triggers fetchQuotes, which
        // collapses the row otherwise — annoying when admins want to
        // keep working in the same order's detail panel after dismissing
        // a modal.
        restoreExpandedRow();
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — after a user-initiated load,
           warm the sibling tab in the background (debounced) so the next Offline<->Online
           switch is instant. Quiet refreshes + revalidate repaints don't trigger it. */
        if (!_quiet && !opts._inject) {
          try { clearTimeout(_prefetchTimer); } catch (_) {}
          _prefetchTimer = setTimeout(_prefetchSibling, 1500);
        }
      } catch (err) {
        console.error('Dashboard fetch error:', err);
        /* CUSTOM_DDSEARCH_BY_CLAUDE — the instant rows stay; say they are all there is. */
        if (_searchBg) {
          try { pageInfo.textContent = 'Showing matches on screen only. The full search failed; press Refresh to retry.'; } catch (_e) {}
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-11) — ⛔ A FAILED LOAD MUST NOT LOOK LIKE AN
           EMPTY ONE, AND IT MUST NOT LOOK LIKE NOTHING AT ALL. The loud path hides the table and
           the empty-state at the top of this function and only restores them inside the `try`, so
           a throw left the rep with a blank board, no message, and the error in devtools — which
           is exactly the "is it working or not" complaint. The Deal Prospecting branch forty lines
           up has surfaced its own failures since it was written; the main branch never did.
           ⚠️ Quiet refreshes stay silent: they run behind a note save and the rep is looking at
           something else. A background failure that hijacks the screen would be worse. */
        if (!_quiet) {
          try {
            emptyEl.style.display = 'block';
            emptyEl.textContent = 'Could not load the board: '
              + ((err && err.message) ? err.message : 'the request failed')
              + ' - press Refresh to try again.';
          } catch (_e) {}
          /* CUSTOM_DDREFRESH_BY_CLAUDE (Ryan 2026-09-15, suggestion c045754566fe) — and it has to
             be visible from wherever the rep is looking. The empty state above is inside the
             table area, which is scrolled off screen on a long board; the pill is in the header
             the rep just clicked, and the toast is in front of everything. ⛔ The age must stop
             claiming freshness it does not have: a board that failed to load still reads "· now"
             without this, which is worse than no stamp at all. */
          _loadFailed = true;
          _renderFreshness();
          _refreshToast('Could not refresh the board: '
            + ((err && err.message) ? err.message : 'the request failed'));
        }
      } finally {
        if (!_quiet) loader.style.display = 'none';
        if (_sbBusy) { _bgBusy = Math.max(0, _bgBusy - 1); _renderFreshness(); }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Quiet mode preserves
           scroll position across the re-render so a background refresh
           (note save → auto-hold → fetchQuotes({quiet:true})) doesn't fling
           the rep to the top of the page. */
        _qStopTracking();
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-20) — only the NEWEST quiet
           render may move the rep. Previously every superseded in-flight
           invocation ran this block with its own stale snapshot, which is what
           produced the observed bursts (three restores 100ms apart walking the
           rep 2316 → 1569 → 1358 → 1126). _qSavedScrollY now also tracks the rep
           right up to the DOM write above, so this restores where they ACTUALLY
           are — correcting only the displacement our own rebuild caused. */
        if (_quiet && _qDidRender && !_qSuperseded()) {
          var _restoreTo = _qSavedScrollY;
          var _restoreQuietScroll = function () {
            if (_qSuperseded()) return;   // a newer render started mid-restore
            /* CUSTOM_DDKEEPPLACE_BY_CLAUDE - by row when the anchor row is still on the board, by pixel otherwise. */
            if (_ddRestoreAnchor(_qAnchor)) return;
            try { window.scrollTo(0, _restoreTo); } catch (e) {}
          };
          _restoreQuietScroll();
          // One more on the next frame in case a late layout settle nudged it.
          requestAnimationFrame(_restoreQuietScroll);
        }
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Background auto-
       refresh. Polls fetchQuotes({quiet:true}) on a 2-minute cadence so
       new Outlook emails (cron syncs every 5 min) + lifecycle changes
       made by admin / other reps surface without the rep having to F5.

       Visibility-aware: pauses entirely when the tab is hidden (no
       wasted requests when the rep's in Outlook / another tab), and
       fires an immediate fetch when the tab becomes visible again.
       Quiet mode preserves scroll + expanded-row state, so the refresh
       is invisible unless a row actually changed. */
    (function setupAutoRefresh() {
      var POLL_MS = 2 * 60 * 1000;
      var pollTimer = null;
      /* hasUnsavedTyping() is now defined once in the outer scope (shared by the
         SWR revalidate repaint + this 2-min poll + the tab-return fetch), so the
         guard can't drift between those paths. */
      function start() {
        if (pollTimer) return;
        pollTimer = setInterval(function () {
          if (document.hidden) return;
          if (hasUnsavedTyping()) return; // skip; try again on next tick
          fetchQuotes({ quiet: true });
        }, POLL_MS);
      }
      function stop() {
        if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          // Tab came back — refresh immediately UNLESS the rep is mid-edit
          // (focused in an input/select, or a textarea with content). Without
          // this guard the immediate fetch raced with focused tracking-card
          // edits and wiped the row's typed values on re-render (Ryan
          // 2026-05-27). Defer one frame so focus restoration lands before
          // we check; the interval poll inside start() runs the same guard
          // each tick so it catches up once the rep blurs.
          requestAnimationFrame(function () {
            if (!hasUnsavedTyping()) fetchQuotes({ quiet: true });
          });
          start();
        }
      });
      // Kick off on init
      if (!document.hidden) start();
    })();

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — Typing-latency ROOT KILL. While the rep is
       focused in ANY text field / editor in the portal, pause the DD row background-color pulses
       (they repaint on the main thread ~60fps continuously and steal cycles from input). Toggles
       body.rqd-typing; the CSS pauses .rqd-table tr animations while it's set. Pulses resume
       in-phase on blur. Covers every typing surface — the email composer, the note/call composer,
       the QW, the search box — without touching the intricate pulse/hover visuals. */
    (function _pausePulsesWhileTyping() {
      function _isTextEntry(el) {
        if (!el) return false;
        if (el.isContentEditable) return true;            // Quill .ql-editor + any contenteditable
        var tag = el.tagName;
        if (tag === 'TEXTAREA') return true;
        if (tag === 'INPUT') {
          var t = (el.type || 'text').toLowerCase();
          return t === '' || ['text', 'email', 'tel', 'search', 'url', 'number', 'password'].indexOf(t) !== -1;
        }
        return false;
      }
      document.addEventListener('focusin', function (e) {
        if (_isTextEntry(e.target)) document.body.classList.add('rqd-typing');
      });
      document.addEventListener('focusout', function () {
        // Defer so document.activeElement reflects the new focus target — keep paused if focus
        // just moved between text fields (no flicker of the pulse resuming for one frame).
        setTimeout(function () {
          if (!_isTextEntry(document.activeElement)) document.body.classList.remove('rqd-typing');
        }, 0);
      });
    })();

    // ── Render Stats ──

    function renderStats(s) {
      var html = '';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Online tab gets a
         tailored stat strip: Quoted / Lost / Win Rate make no sense on
         Shopify orders (everything's paid at checkout, no losses). Show
         Sold + AOV + Profit + Margin% + Fulfilled instead, mirroring
         what a sales-ops dashboard top row should answer: how much
         came in, average deal size, how much we made, performance ratio,
         and how many orders are still in flight. */
      if (currentSource === 'online' && isAdmin) {
        var _revenue = parseFloat(s.soldValue || 0);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Use GP of Order
           (worker's s.totalProfitFull) instead of GP of Goods so the
           Profit stat card matches the per-row Financials card's "GP of
           Order" total. Fall back to s.totalProfit if the worker hasn't
           been updated yet. */
        var _profit = parseFloat(s.totalProfitFull != null ? s.totalProfitFull : s.totalProfit) || 0;
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        var _soldCt = parseInt(s.soldCount, 10) || 0;
        var _aov = _soldCt > 0 ? (_revenue / _soldCt) : 0;
        var _marginPct = _revenue > 0 ? ((_profit / _revenue) * 100).toFixed(1) : '0.0';
        // Fulfilled count: walk allQuotes for online orders flagged as
        // fully-fulfilled by the same predicate the row pills use.
        var _fulfilledCt = 0;
        var _onlineTotal = 0;
        if (Array.isArray(allQuotes)) {
          for (var _fi = 0; _fi < allQuotes.length; _fi++) {
            var _aq = allQuotes[_fi];
            if (!_aq || _aq.source !== 'online') continue;
            _onlineTotal++;
            try { if (isOrderFullyFulfilled(_aq)) _fulfilledCt++; } catch (_) {}
          }
        }
        var _fulPct = _onlineTotal > 0 ? Math.round((_fulfilledCt / _onlineTotal) * 100) : 0;
        html += '<div class="rqd-stat rqd-stat--sold"><div class="rqd-stat__value">' + _soldCt + '</div><div class="rqd-stat__sub">' + moneyRound(_revenue) + '</div><div class="rqd-stat__label">Sold</div></div>';
        html += '<div class="rqd-stat rqd-stat--aov"><div class="rqd-stat__value">' + moneyRound(_aov) + '</div><div class="rqd-stat__sub">' + (_soldCt > 0 ? 'over ' + _soldCt + ' orders' : 'no orders') + '</div><div class="rqd-stat__label">Avg Order Value</div></div>';
        html += '<div class="rqd-stat rqd-stat--profit"><div class="rqd-stat__value">' + moneyRound(_profit) + '</div><div class="rqd-stat__sub">' + moneyRound(_revenue) + ' sold</div><div class="rqd-stat__label">Profit</div></div>';
        html += '<div class="rqd-stat rqd-stat--margin"><div class="rqd-stat__value">' + _marginPct + '%</div><div class="rqd-stat__sub">' + moneyRound(_profit) + ' of ' + moneyRound(_revenue) + '</div><div class="rqd-stat__label">Margin</div></div>';
        html += '<div class="rqd-stat rqd-stat--fulfilled"><div class="rqd-stat__value">' + _fulfilledCt + '</div><div class="rqd-stat__sub">' + (_onlineTotal > 0 ? _fulPct + '% of ' + _onlineTotal : 'no orders') + '</div><div class="rqd-stat__label">Fulfilled</div></div>';
        statsEl.innerHTML = html;
      } else {
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE — falls through to existing offline/all stats below */
      var totalQuoted = s.quotedCount + s.soldCount + s.lostCount;
      var totalQuotedValue = parseFloat(s.quotedValue || 0) + parseFloat(s.soldValue || 0) + parseFloat(s.lostValue || 0);
      html += '<div class="rqd-stat rqd-stat--quoted"><div class="rqd-stat__value">' + totalQuoted + '</div><div class="rqd-stat__sub">' + moneyRound(totalQuotedValue) + '</div><div class="rqd-stat__label">Quoted</div></div>';
      html += '<div class="rqd-stat rqd-stat--sold"><div class="rqd-stat__value">' + s.soldCount + '</div><div class="rqd-stat__sub">' + moneyRound(s.soldValue) + '</div><div class="rqd-stat__label">Sold</div></div>';
      html += '<div class="rqd-stat rqd-stat--lost"><div class="rqd-stat__value">' + s.lostCount + '</div><div class="rqd-stat__sub">' + moneyRound(s.lostValue) + '</div><div class="rqd-stat__label">Lost</div></div>';
      var winPct = totalQuotedValue > 0 ? ((parseFloat(s.soldValue || 0) / totalQuotedValue) * 100).toFixed(0) : '0';
      html += '<div class="rqd-stat rqd-stat--conv"><div class="rqd-stat__value">' + winPct + '%</div><div class="rqd-stat__sub">' + moneyRound(s.soldValue) + ' of ' + moneyRound(totalQuotedValue) + '</div><div class="rqd-stat__label">Win Rate</div></div>';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — reps now see the same Profit card as admins
         (commission detail lives in the Commissions hub, so the rep-only
         "Commission YTD" card is retired here). Ryan 2026-06-02. */
      html += '<div class="rqd-stat rqd-stat--profit"><div class="rqd-stat__value">' + moneyRound(s.totalProfit) + '</div><div class="rqd-stat__sub">' + moneyRound(s.soldValue) + ' sold</div><div class="rqd-stat__label">Profit</div></div>';
      statsEl.innerHTML = html;
      } // close online-tab branch
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Freight Pending pill (moved out of
         the stats strip and into the source toggle row per Ryan). Counts
         orders with any shippingBucket where parcelRatePending.since is
         set AND freightCostSet/freightCost > 0 is not. Show/hide the pill
         based on count + update the count badge. Click handler lives in
         the source-toggle delegation (see #rqd-source-toggle listener). */
      var freightPill = document.getElementById('rqd-freight-pending-pill');
      var freightPillCount = document.getElementById('rqd-freight-pending-pill-count');
      if (freightPill && isAdmin && Array.isArray(allQuotes)) {
        var pendingFreightCount = 0;
        for (var i = 0; i < allQuotes.length; i++) {
          var _q = allQuotes[i];
          var _bks = (_q && Array.isArray(_q.shippingBuckets)) ? _q.shippingBuckets : [];
          for (var j = 0; j < _bks.length; j++) {
            var _b = _bks[j];
            var _set = !!_b.freightCostSet || parseFloat(_b.freightCost) > 0;
            if (!_set && _b.parcelRatePending && _b.parcelRatePending.since) { pendingFreightCount++; break; }
          }
        }
        if (pendingFreightCount > 0) {
          freightPill.style.display = '';
          if (freightPillCount) freightPillCount.textContent = pendingFreightCount;
          // Keep active state visually consistent across re-renders.
          freightPill.classList.toggle('rqd-source-btn--active', !!freightPendingOnly);
        } else {
          freightPill.style.display = 'none';
          if (freightPendingOnly) {
            // Count dropped to zero — auto-clear the filter to avoid an
            // invisible-but-active state.
            freightPendingOnly = false;
            freightPill.classList.remove('rqd-source-btn--active');
          }
        }
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }

    function updatePillCounts(s) {
      var pills = document.querySelectorAll('.rqd-pill[data-status]');
      pills.forEach(function(p) {
        var st = p.dataset.status;
        var count = st === 'all' ? s.total : st === 'pending' ? (s.pendingCount || 0) : st === 'awaiting' ? (s.rawAwaitingCount || 0) : st === 'quoted' ? (s.rawQuotedCount || s.quotedCount) : st === 'sold' ? (s.rawSoldCount || s.soldCount) : st === 'lost' ? (s.rawLostCount || s.lostCount) : st === 'expired' ? (s.expiredCount || 0) : st === 'closed' ? s.closedCount : st === 'dead' ? (s.deadLeadCount || 0) : st === 'sample' ? (s.sampleCount || 0) : st === 'hold' ? (s.onHoldCount || 0) : st === 'linked' ? (s.linkedCount || 0) : st === 'replacement' ? (s.replacementCount || 0) : st === 'cold' ? (s.coldCount || 0) : 0;
        var existing = p.querySelector('.rqd-pill__count');
        var badge = existing;
        if (existing) existing.textContent = count;
        else {
          var span = document.createElement('span');
          span.className = 'rqd-pill__count';
          span.textContent = count;
          p.appendChild(span);
          badge = span;
        }
        // Highlight the "New Leads" count yellow when anything is waiting.
        badge.classList.toggle('rqd-pill__count--awaiting', st === 'awaiting' && count > 0);
        // Same pattern for Hold — violet when anything is on hold.
        badge.classList.toggle('rqd-pill__count--hold', st === 'hold' && count > 0);
        // Same pattern for Sample — green to match the SAMPLE status pill.
        badge.classList.toggle('rqd-pill__count--sample', st === 'sample' && count > 0);
        /* CUSTOM_COLDOWNER_BY_CLAUDE (Ryan 2026-09-11) — and for Cold, matching the row chip's
           slate so the pill and the thing it filters to read as one idea. */
        badge.classList.toggle('rqd-pill__count--cold', st === 'cold' && count > 0);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Hide-when-zero
           pattern generalized to every pill except 'all'. Cleans up the
           filter row so only relevant categories surface — a rep with
           no Dead leads, no Samples, no On-Hold, etc. sees a much
           shorter row. The 'all' pill is the catch-all default and
           always stays visible. If the currently-active filter has
           zero matches (e.g. all NEW LEADs just got promoted to QUOTED
           and the row count flips 1→0 while the user has 'New' selected),
           auto-revert to 'all' and strip the URL param so a refresh
           doesn't reload into an invisible-but-active filter. Mirrors
           the linked-pill-specific logic that's been in production. */
        if (st === 'all') {
          p.style.display = '';
        } else if (count > 0) {
          p.style.display = '';
        } else {
          p.style.display = 'none';
          if (currentStatus === st) {
            currentStatus = 'all';
            document.querySelectorAll('.rqd-pill[data-status]').forEach(function (b) {
              b.classList.toggle('rqd-pill--active', b.dataset.status === 'all');
            });
            try {
              var _u = new URL(window.location.href);
              if (_u.searchParams.get('status') === st) {
                _u.searchParams.delete('status');
                window.history.replaceState(null, '', _u.pathname + (_u.search || '') + _u.hash);
              }
            } catch (_) { /* URL parsing fallback — non-fatal */ }
          }
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      });
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-29) — MONEY MOVES badge (no
         data-status, so the pill loop above skips it) + keep the dropdown
         trigger label/count in sync after every stats refresh. */
      var _mmCount = document.getElementById('rqd-moneymoves-count');
      if (_mmCount) _mmCount.textContent = (s.moneyMovesCount || 0);
      if (typeof _syncStatusTrigger === 'function') _syncStatusTrigger();
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }

    // ── Render Alerts ──

    var alertsEl = document.getElementById('rqd-alerts');
    var alertsCollapsed = true;

    function renderAlerts(alerts) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Aging Quotes
         banner retired per Ryan. The rest of this function is kept
         intact (formatter + toggle wiring) as harvestable code in case
         the alerts surface comes back in a different shape later. */
      if (alertsEl) alertsEl.innerHTML = '';
      return;
      /* Legacy aging-quotes banner below — unreachable. */
      // eslint-disable-next-line no-unreachable
      if (currentSource === 'prospecting') { alertsEl.innerHTML = ''; return; }
      if (!alerts || !alerts.length) { alertsEl.innerHTML = ''; return; }

      var visible = alerts;

      // Show max 5 by default, expandable
      var maxShow = alertsCollapsed ? 0 : 5;
      var showing = visible.slice(0, maxShow);
      var remaining = visible.length - showing.length;

      var html = '<div class="rqd-alerts__header">' +
        '<div class="rqd-alerts__title">' +
          '<span>Aging Quotes</span>' +
          '<span class="rqd-alerts__count">' + visible.length + '</span>' +
        '</div>' +
        '<button class="rqd-alerts__toggle" type="button">' + (alertsCollapsed ? 'Show' : (remaining > 0 ? 'Show all (' + visible.length + ')' : 'Hide')) + '</button>' +
      '</div>';

      var icons = {
        aging_quote: 'ðŸ“‹',
      };

      showing.forEach(function(a) {
        html += '<div class="rqd-alert rqd-alert--' + a.severity + '">' +
          '<span class="rqd-alert__icon">' + (icons[a.type] || '⚠️') + '</span>' +
          '<span class="rqd-alert__text">' + esc(a.message) + '</span>' +
          (a.actionUrl ? '<a class="rqd-alert__action" href="' + a.actionUrl + '" target="_blank">' + esc(a.actionLabel) + '</a>' : '') +
        '</div>';
      });

      alertsEl.innerHTML = html;

      // Toggle handler
      alertsEl.querySelector('.rqd-alerts__header').addEventListener('click', function() {
        if (alertsCollapsed) {
          alertsCollapsed = false;
          renderAlerts(alerts);
        } else if (remaining > 0) {
          // Show all
          maxShow = visible.length;
          var allHtml = '<div class="rqd-alerts__header">' +
            '<div class="rqd-alerts__title"><span>Aging Quotes</span><span class="rqd-alerts__count">' + visible.length + '</span></div>' +
            '<button class="rqd-alerts__toggle" type="button">Collapse</button></div>';
          visible.forEach(function(a) {
            allHtml += '<div class="rqd-alert rqd-alert--' + a.severity + '">' +
              '<span class="rqd-alert__icon">' + (icons[a.type] || '⚠️') + '</span>' +
              '<span class="rqd-alert__text">' + esc(a.message) + '</span>' +
              (a.actionUrl ? '<a class="rqd-alert__action" href="' + a.actionUrl + '" target="_blank">' + esc(a.actionLabel) + '</a>' : '') +
            '</div>';
          });
          alertsEl.innerHTML = allHtml;
          alertsEl.querySelector('.rqd-alerts__header').addEventListener('click', function() {
            alertsCollapsed = true;
            renderAlerts(alerts);
          });
        } else {
          alertsCollapsed = true;
          renderAlerts(alerts);
        }
      });

    }

    // ── Render Table ──

    // Parse a quote reference into base ref and suffix: "RW-1024-B" → { base: "RW-1024", suffix: "B" }
    function parseBaseRef(ref) {
      var m = ref.match(/^(.+)-([A-Z])$/);
      return m ? { base: m[1], suffix: m[2] } : null;
    }

    // ── Progress helpers (shared by table column + detail panel) ──
    function getProgressSteps(q) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — ⛔ A REPLACEMENT GETS THE GOODS HALF ONLY.
         The normal bar is Ordered → Shipped → Paid → Invoiced. Nobody pays for a replacement and
         nothing is invoiced, so those two steps could never complete: a permanently-unchecked
         "Paid" on a free order is a false to-do sitting on the rep's screen forever.

         ⛔ RETURNED EARLY, ON PURPOSE. Everything below computes per-vendor counts across a dozen
         branches (buckets, freight handshake, Flow A, terms-up-front). A replacement needs none of
         it, and threading a fourth condition through all of it is how that function grows another
         drift hazard. The stage is already derived server-side — one answer, shared with the pill
         and the parent's strip.

         ⛔ AND THIS IS THE HOLE RYAN ALREADY FELL INTO ONCE. Every step below is "done" when EVERY
         vendor satisfies it, which is vacuously TRUE with no vendors — that is the RW-1290-A bug
         recorded a few dozen lines down in his own words. A replacement with no damaged items
         picked has no vendors, and would have rendered Ordered ✓ Shipped ✓ on an order nobody had
         started, telling a rep the customer's goods were on the way. `awaiting-items` is a real
         stage precisely so that cannot happen here. */
      if (q && q.isReplacement) {
        var _rs = q.replacementStage || 'awaiting-items';
        return [
          { label: 'Ordered', done: _rs === 'ordered' || _rs === 'shipped' },
          { label: 'Shipped', done: _rs === 'shipped' }
        ];
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var steps = [];
      var vendors = (q.financials || {}).vendors || [];
      var ordering = q.ordering || {};
      var vendorCount = vendors.length;

      // Per-vendor PO state for the new "Ordered" step (Purchasing-driven).
      // A vendor is "ordered" when at least one non-voided PO for them has
      // been sent OR downloaded — same conditions that flip the Purchasing
      // card row checkbox. Bucketed via vendorNamesMatch so canonical names
      // ("ECORE Athletic") still pair with row short forms ("ECORE").
      var posByVendor = {};
      vendors.forEach(function(v){ posByVendor[v] = []; });
      (q.pos || []).forEach(function(p){
        if (!p || p.status === 'voided') return;
        var bucket = vendors.find(function(v){ return vendorNamesMatch(v, p.vendor); });
        if (bucket) posByVendor[bucket].push(p);
      });

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — All per-vendor step
         state computed via shared predicates defined near isVendorAllBuckets
         Purchased (~L5097-area). Inline checks here were the previous
         drift hazard — workflow changes had to be fixed in 3 places.
         Predicates are now THE source of truth; the To Do emoji strip
         (buildOnlineFlowVendorState) + Tracking card use the same ones.
         freightApplicableCount = vendors that NEED the freight handshake
         (excludes web-order). When 0, the Freight Requested / Dims
         Requested step is hidden entirely from the bar. */
      var isOnlineProgress = q.source === 'online';
      var purchasedCount = 0, shippedCount = 0;
      var freightApplicableCount = 0, freightRequestedCount = 0, freightAddedCount = 0;
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — the vendorNeedsFreightCost set,
         mirroring buildOnlineFlowVendorState. isOnlineRowResolved reads the emoji strip while
         the rep-side fill reads THIS, so a step present on one surface and absent on the other
         is a row that claims to be finished in one place and open in the other. */
      var costApplicableCount = 0, costAddedCount = 0;
      /* CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE (Ryan 2026-09-13) — the supplier-payment set. */
      var payApplicableCount = 0, payPaidCount = 0;
      for (var vi = 0; vi < vendorCount; vi++) {
        var v = vendors[vi];
        var _vps = vendorPayState(q, v, vendorNamesMatch);
        if (_vps.applicable) { payApplicableCount++; if (_vps.paid) payPaidCount++; }
        if (isVendorAllBucketsPurchased(q, v)) purchasedCount++;
        if (vendorIsShipped(q, v)) shippedCount++;
        if (vendorNeedsFreightHandshake(q, v)) freightApplicableCount++;
        if (vendorHasFreightRequested(q, v)) freightRequestedCount++;
        if (vendorHasFreightAdded(q, v)) freightAddedCount++;
        if (vendorNeedsFreightCost(q, v)) {
          costApplicableCount++;
          if (vendorHasFreightAdded(q, v)) costAddedCount++;
        }
      }
      var allPurchased = vendorCount === 0 || purchasedCount === vendorCount;
      var allShipped = vendorCount === 0
        ? (isOnlineProgress ? !!q.onlineHasTracking : true)
        : shippedCount === vendorCount;
      var allFreightRequested = freightApplicableCount === 0 || freightRequestedCount === freightApplicableCount;
      var allFreightAdded = costApplicableCount === 0 || costAddedCount === costApplicableCount;
      var allVendorsPaid = payApplicableCount === 0 || payPaidCount === payApplicableCount;
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Optional `total`
         arg so steps with a different applicable-vendor set (e.g. Freight
         Requested with freightApplicableCount as the denominator) can
         render the right "X/Y" partial. Defaults to vendorCount for back-
         compat with all existing callers. */
      function vendorStep(label, done, count, total) {
        var denom = (typeof total === 'number' && total > 0) ? total : vendorCount;
        if (denom > 1) {
          var partial = count > 0 && count < denom ? count / denom : 0;
          return { label: label, done: done, partial: partial, partialText: count + '/' + denom };
        }
        return { label: label, done: done };
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      if (isAdmin) {
        // Step order depends on payment terms. For up-front terms (Pay in
        // Full / 50/50 — money-up-front) Paid lands first because it's the
        // gating event. For deferred terms (Net 30 / 50/50 Net 30) Ordered
        // and Shipped happen first; Paid lands later when the invoice clears.
        var _payments = q.payments || [];
        var _totalAmt = parseFloat(q.total || q.quoteAmount || q.amount || 0);
        var _paidAmt = _payments.length > 0 ? _payments.reduce(function(s, p) { return s + (parseFloat(p.amount) || 0); }, 0) : parseFloat(q.paymentAmount || 0);
        /* CUSTOM_PAYTERMSGATE_BY_CLAUDE (Ryan 2026-09-19, SHOP-2073) — ⛔ "ONLINE" IS NOT
           "PAID IN FULL", AND THIS STEP USED TO SAY IT WAS.
           This block forced `_paidAmt = _totalAmt` and then `_paidFull = true` for every online
           order, unconditionally. It was the fourth workaround for one root cause: a native
           online order has no `lifecycle.payments[]`, so `q.payments` is empty and the honest
           arithmetic above reads $0 collected. Forcing it was right for the common case and
           wrong for the one that matters — a PARTIALLY_PAID order carrying an unpaid `collect`
           adjustment showed Customer Paid ✓ while genuinely owing the freight balance.
           ✅ `q.paymentGate` now answers this properly for online rows (it resolves receipts from
           Shopify: `onlinePaid`, else `totalReceivedSet`), so take its numbers rather than
           inventing a second set here. `balanceDue` of 0 is the settled test — it covers a paid
           order, a fully refunded one (current total 0) and an unpriced one alike, which is the
           same set this used to wave through.
           ⚠️ THE OLD BEHAVIOUR IS THE FALLBACK, deliberately. A row cached before the gate
           existed, or one built without it, has no `paymentGate`, and reading $0 collected off an
           empty payments array would light every online order as UNPAID — a far louder wrong
           answer than the one being fixed. */
        if (q.source === 'online' && q.paymentGate) {
          _paidAmt = Number(q.paymentGate.totalPaid) || 0;
          if (Number(q.paymentGate.total) > 0) _totalAmt = Number(q.paymentGate.total);
        } else if (q.source === 'online' && _totalAmt > 0 && _paidAmt < _totalAmt) {
          _paidAmt = _totalAmt;
        }
        var _paidFull = _totalAmt > 0 ? _paidAmt >= _totalAmt : !!q.paid;
        if (q.source === 'online') {
          _paidFull = q.paymentGate ? !(Number(q.paymentGate.balanceDue) > 0) : true;
        }
        var _paidFrac = (_totalAmt > 0 && _paidAmt > 0 && !_paidFull) ? Math.min(_paidAmt / _totalAmt, 1) : 0;
        /* CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE (Ryan 2026-09-13) — "Customer Paid", because
           "Vendor Paid" now sits on the same bar and one bare "Paid" between them is a guess.
           ⚠️ The rename EARNS ITSELF only because of that step; on its own it would be churn. */
        var _paidStep = { label: 'Customer Paid', done: _paidFull, partial: _paidFrac, partialText: _paidFrac > 0 ? money(_paidAmt) + ' / ' + money(_totalAmt) : '' };
        // Online Shopify orders are pre-paid in full at checkout, so Paid
        // lands first regardless of payment terms — same up-front treatment
        // as Pay in Full / 50/50.
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — PO received defers
           payment regardless of nominal terms. When admin marks SOLD with
           "PO received" checked but leaves terms at the default "Pay in Full",
           the customer's PO acknowledges intent to pay later — payment
           lands after fulfillment, not up-front. Treat sb.poReceived as
           overriding the terms-based up-front detection so the Paid step
           sequences correctly (after Shipped, not first). Mirrors the rep
           view's existing "PO ✓" handling at L4353. */
        var _sbAdmin = q.soldBasis || {};
        var _termsUpFront = (q.terms === 'Pay in Full' || q.terms === '50/50' || q.source === 'online') && !_sbAdmin.poReceived;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — "PO Received" step
           anchors the progress bar's leading position on PO purchases so
           admin sees the trigger event for the rest of the sequence. By
           definition the step is done the moment sb.poReceived was flipped
           in the SOLD modal — no further action needed; serves as a visual
           anchor + audit signal. Mirrors the rep view (~L4353). */
        if (_sbAdmin.poReceived) {
          steps.push({ label: 'PO Received', done: true });
        }

        // Online orders use a tailored sequence per flow:
        //   Flow A (freight-quoted at checkout) → Paid → Dims Requested
        //     → Freight Added → Balance Paid → PO Sent → Shipped
        //   Flow B (parcel — supplier still owes a quote) → Paid → Freight
        //     Requested → Freight Added → PO Sent → Shipped
        //   Flow C (flat-rate)                  → Paid → PO Sent → Shipped
        // Each step uses vendorStep so multi-vendor orders show "1/N", "2/N"
        // progress as each vendor's checkbox flips.
        if (q.source === 'online') {
          steps.push(_paidStep);
          if (q.onlineFlow === 'B') {
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Bucket-aware partial on the panel
               bar for Freight Requested / Freight Added. Mirrors emoji-strip
               logic via the shared bucketAwareStepEmoji helper (function
               declarations are hoisted; helper lives further down). The
               returned object's `emoji` field is ignored by the panel bar
               render.
               2026-05-22: hide Freight Requested when 0 vendors need the
               handshake (e.g. all web-order). Denominator becomes the
               applicable count when shown. Freight Added stays (web-order
               vendors can have retroactive cost via Mark Web Purchased). */
            var _sB = { vendorCount: vendorCount, freightReqCount: freightRequestedCount, freightAddCount: freightAddedCount };
            if (freightApplicableCount > 0) {
              steps.push(bucketAwareStepEmoji(q, _sB, 'freight-requested') || vendorStep('Freight Requested', allFreightRequested, freightRequestedCount, freightApplicableCount));
            }
            /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — hidden when nothing on the
               order carries a freight bill. See vendorNeedsFreightCost. */
            if (costApplicableCount > 0) {
              steps.push(bucketAwareStepEmoji(q, _sB, 'freight-added') || vendorStep('Freight Cost', allFreightAdded, costAddedCount, costApplicableCount));
            }
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          } else if (q.onlineFlow === 'A') {
            // Flow A's six-step sequence — granular, matches the
            // Freight Balance card workflow:
            //   📧 Dims Requested  — supplier emailed for w/dims
            //   🚚 Freight Added   — broker cost + customerCharge entered,
            //                        FREIGHT-{ref} draft minted
            //   💵 Balance Paid    — customer paid the freight invoice
            // Strip stays compact at 5 (no Freight Added) since space is
            // tight in the To Do column; progress bar gets the full 6.
            var _fb = q.freightBalance || {};
            var _bc = q.balanceCollected || {};
            // Same three-path auto-detect as buildOnlineFlowASteps + the FB
            // card. When the balance was settled outside the in-app invoice
            // flow (linked child order or explicit override), Freight Added
            // and Balance Paid both auto-flip — the invoice step is moot.
            var _hasLinkedChild = Array.isArray(q.balanceChildren) && q.balanceChildren.length > 0;
            var _handledExt = !!_fb.handledExternally;
            var _bypassedAll = _hasLinkedChild || _handledExt;
            var _invoiceGenerated = !!_fb.draftOrderId || _bypassedAll;
            var _balancePaid = !!_bc.paid || _bypassedAll;
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Bucket-aware Dims Requested on
               Flow A. Freight Added on Flow A still tracks the invoice
               draft (not bucket cost), so it stays binary.
               2026-05-22: hide Dims Requested when 0 vendors need the
               handshake. Use freightApplicableCount as denominator. */
            var _sA = { vendorCount: vendorCount, freightReqCount: freightRequestedCount };
            if (freightApplicableCount > 0) {
              steps.push(bucketAwareStepEmoji(q, _sA, 'dims-requested') || vendorStep('Dims Requested', allFreightRequested, freightRequestedCount, freightApplicableCount));
            }
            steps.push({ label: 'Freight Added', done: _invoiceGenerated });
            steps.push({ label: 'Balance Paid', done: _balancePaid });
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          } else if (q.onlineFlow === 'C') {
            /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-17) — Flow C gains a Freight Added
               step. "Freight was collected at checkout" answers the CUSTOMER-side question
               only; it says nothing about what the pallet costs US. On the ECORE pavers —
               the products this flow now covers (see the `flat-rate-shipping` tag note in
               quote-dashboard.js ~L612) — Blue Sky brokers the pickup itself, so there is a
               real carrier bill and it is large relative to the goods: SHOP-1931 collected
               $354.38 of shipping against $219.00 of product. Without this step nothing ever
               asks for that number and the DD books the whole $354.38 as margin.

               No Freight REQUESTED step — that is the supplier ask, and Flow C's whole
               premise is that there isn't one. Ryan chose to keep the cost step (2026-08-17)
               precisely so the tag change couldn't quietly overstate paver GP.

               Auto-satisfies for a genuine flat-rate vendor: deriveShippingBucketsForQuote
               pre-fills the bucket cost from the Vendor Guide's shippingFlatRate, which
               vendorHasFreightAdded now reads.

               ⚠ AMENDED 2026-08-21 on both counts. The auto-satisfy above did NOT work — the
               prefill leaves freightCostSet false, so the predicate discarded it (fixed in
               vendorHasFreightAdded). And the step is now hidden for parcel-only /
               freight-in-product vendors, which reach Flow C by shippingModel demotion rather
               than by the paver tag and have no freight bill to record. See
               vendorNeedsFreightCost — sixteen fulfilled orders retracted without it. */
            if (costApplicableCount > 0) {
              steps.push(vendorStep('Freight Cost', allFreightAdded, costAddedCount, costApplicableCount));
            }
            /* END CUSTOM_DEALDASHBOARD_BY_CLAUDE */
          }
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Bucket-aware PO Sent partial state.
             Single-vendor / multi-bucket orders (mixed-cart Flow A — SHOP-1681
             class) need a half-filled bar with "PO Sent 1/2" while one of N
             POs is out, instead of waiting for ALL buckets to flip ✓ before
             showing any progress. Falls back to vendor-level fraction for
             multi-vendor / single-bucket orders. */
          var _poBucketsAware = vendorCount === 1
            && Array.isArray(q.shippingBuckets)
            && q.shippingBuckets.length > 1;
          if (_poBucketsAware) {
            var _bks = q.shippingBuckets;
            var _bksSent = 0;
            for (var _bbi = 0; _bbi < _bks.length; _bbi++) {
              var _bkPos = (q.pos || []).filter(function (p) {
                return p && p.status !== 'voided' && p.bucket === _bks[_bbi].id;
              });
              if (_bkPos.some(function (p) { return p.status === 'sent' || !!p.downloadedAt; })) _bksSent++;
            }
            var _allBksSent = _bksSent === _bks.length;
            var _bkPartial = (_bksSent > 0 && !_allBksSent) ? _bksSent / _bks.length : 0;
            steps.push({
              label: 'PO Sent',
              done: _allBksSent,
              partial: _bkPartial,
              partialText: _bkPartial ? (_bksSent + '/' + _bks.length) : '',
            });
          } else {
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-28) — Swap to
               "Purchased" when every vendor on the order was Marked
               Purchased directly (no PO sent). Mixed orders keep "PO
               Sent" since the label is still accurate for the PO ones. */
            var _poLabel = allVendorsPurchasedDirectly(q) ? 'Purchased' : 'PO Sent';
            steps.push(vendorStep(_poLabel, allPurchased, purchasedCount));
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          }
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Progress bar step
             order matches the new card render order: Fulfillment before
             Tracking. For bucket-mode orders the Fulfillment-card steps
             (Dims Requested → Freight Added → Balance Paid → PO Sent →
             Freight Balanced) cluster together, then the Tracking-card
             step (Shipped) lands last. Real-world sequence: get quotes /
             enter dims / send POs / reconcile freight, THEN supplier
             ships. Previously Shipped was pushed before Freight Balanced,
             leaving the bar's penultimate step on a post-ship Fulfillment-
             card field — visually inconsistent with the card order. */
          var _useBucketPanelsPB = Array.isArray(q.shippingBuckets) && q.shippingBuckets.length > 0;
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19, v2) — Align the
             Freight Balanced step's appearance with the Freight Balance
             card's render gate (renderFreightBalanceCard, ~line 9407).
             Step appears only when the card actually renders:
               • Flow C orders never have the card → skip the step
                 (covers SHOP-1691: flat-rate / freight-in-product).
               • Flow B non-post-ship orders (e.g. SHOP-1686) — Purchasing
                 card owns the workflow and the FB card is hidden, so
                 the step is moot. Skip too.
               • Flow A with buckets OR post-ship-invoice vendor
                 (Hyperice etc.) — card renders, step pushes. */
          var _firstVendorPB = (q.financials && q.financials.vendors && q.financials.vendors[0]) || '';
          var _isPostShipPB = typeof isPostShipInvoiceVendor === 'function' && isPostShipInvoiceVendor(_firstVendorPB);
          var _bucketPanelsActivePB = q.onlineFlow === 'A' && q.lifecycleStatus === 'sold' && _useBucketPanelsPB;
          var _skipFreightBalancedStep = q.onlineFlow === 'C' || !(_isPostShipPB || _bucketPanelsActivePB);
          if (_useBucketPanelsPB && !_skipFreightBalancedStep) {
            // ⚖ Freight Balanced — Fulfillment-card summary. Pushed
            // BEFORE Shipped so the Fulfillment cluster reads top-to-
            // bottom contiguous in the progress bar.
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Partial state
               based on per-bucket Fulfillment-phase completeness — bucket
               needs BOTH its freight cost finalized AND its PO sent for
               it to count. Matches the broader isFreightBalanced gates
               so ⚖ stays partial when broker has freight cost in but PO
               not sent yet (the case Ryan flagged). `done` requires the
               order-level gates (dims received, recon balanced) on top. */
            var _bksBalancedCount = 0;
            for (var _bbpi = 0; _bbpi < q.shippingBuckets.length; _bbpi++) {
              if (isBucketFullyDone(q.shippingBuckets[_bbpi], q)) _bksBalancedCount++;
            }
            var _bksBalTotal = q.shippingBuckets.length;
            var _allBalanced = isFreightBalanced(q);
            var _balPartial = (!_allBalanced && _bksBalancedCount > 0 && _bksBalTotal > 1)
              ? _bksBalancedCount / _bksBalTotal
              : 0;
            steps.push({
              label: 'Freight Balanced',
              done: _allBalanced,
              partial: _balPartial,
              partialText: _balPartial ? (_bksBalancedCount + '/' + _bksBalTotal) : '',
            });
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          }
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE — _skipFreightBalancedStep gate */
          // Bucket-aware Shipped — Tracking-card step, last in the bar.
          var _sShip = { vendorCount: vendorCount, shippedCount: shippedCount };
          steps.push(bucketAwareStepEmoji(q, _sShip, 'shipped') || vendorStep('Shipped', allShipped, shippedCount));
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Phase 3.5 Phase 1.5:
             Online orders skip Invoiced / Taxes / Installer (Shopify
             handles those). Commission though is OURS — for code-attributed
             rows admin sets leadSource and a real commissionAmount lands.
             Push the same Commission step the offline path uses so the
             progress tracker reflects the unpaid-commission gap until admin
             marks it Paid. Same gate as below: rep earns + amount > 0. */
          if (q.repEarnsCommission !== false && parseFloat(q.commissionAmount || 0) > 0) {
            steps.push({ label: 'Commission', done: !!q.commissionPaid });
          }
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          return steps;
        }
        if (_termsUpFront) steps.push(_paidStep);
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — Freight Requested on OFFLINE deals,
           for vendors set to Freight → PO. Ahead of Ordered because that is the real sequence: ask
           the supplier what freight costs, then place the order.

           Hidden entirely when no vendor on the deal owes the ask (freightApplicableCount === 0),
           which is every deal whose vendors are PO Only — exactly how the Flow B branch above
           hides it for all-web-order orders. Counted by the same predicate the Purchasing card
           now renders from, so a step showing here and a row missing there is not possible. */
        if (freightApplicableCount > 0) {
          steps.push(vendorStep('Freight Requested', allFreightRequested, freightRequestedCount, freightApplicableCount));
        }
        /* END CUSTOM_DEALDASHBOARD_BY_CLAUDE */
        steps.push(vendorStep('Ordered', allPurchased, purchasedCount));
        /* CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE (Ryan 2026-09-13) — ⛔ ITS OWN STEP, NOT A SECOND
           MEANING FOR "Ordered". Ryan asked whether Ordered could fill half on the order and half
           on the payment: every step on this bar answers ONE question and its fraction always
           means "N of M vendors have done THIS", so a half-full Ordered would be ambiguous between
           one of two vendors ordered and one vendor ordered-but-unpaid. Two steps say strictly
           more for the cost of one segment.
           ⚠️ Hidden when no vendor carries a pay row - see vendorPayState for why the denominator
           is "vendors we owe or owed" rather than every vendor. */
        if (payApplicableCount > 0) {
          steps.push(vendorStep('Vendor Paid', allVendorsPaid, payPaidCount, payApplicableCount));
        }
        steps.push(vendorStep('Shipped', allShipped, shippedCount));
        // Invoiced step is optional for: online-paid offline orders, externally
        // linked Shopify orders, residential buyers (Org = Residence / n/a /
        // etc.), and pure online orders (q.source==='online' — those have
        // their own Shopify receipt, no need to track invoice status here).
        // Still shown for history if one was actually generated.
        var _sb = q.soldBasis || {};
        var _invoiceOptional = _sb.paidOnline === true || _sb.source === 'external' || isResidentialOrg(q.customerCompany);
        if (!_invoiceOptional || q.invoiced) {
          steps.push({ label: 'Invoiced', done: !!q.invoiced });
        }
        if (!_termsUpFront) steps.push(_paidStep);
        var _taxes = parseFloat((q.financials || {}).taxes || q.taxes || 0);
        if (_taxes > 0) steps.push({ label: 'Taxes', done: !!q.taxesRemitted });
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-02) — INSTALLED. A CLOSED gate the admin
           bar never drew.

           ⛔ `installScheduleOk` in the worker (lib/closed-gate.js) requires
           `install.status === 'complete'` on any deal with `install.required`, and this ladder
           had no step for it — so an admin looked at a bar reading ✓ all the way across while the
           deal stayed open on a condition nothing on screen mentioned. RW-1068-B: installer
           scheduled 2026-06-12, never marked complete, deal open into September. Six deals are in
           that state (RW-1037-A, RW-1034-A, RW-1116-B, RW-1068-B, JW-1211-A, JW-1235-A).

           📌 The REP view has had this step since it was written (~L8720 below) — this is the
           admin branch catching up, same label and same predicate, not a new idea.

           Sequenced before Installer Paid because that is the real order: the crew finishes, then
           we pay them. */
        if (q.install && q.install.required) {
          steps.push({ label: 'Installed', done: q.install.status === 'complete' });
        }
        /* END CUSTOM_DEALDASHBOARD_BY_CLAUDE */
        var _installCost = parseFloat((q.financials || {}).installCost || 0);
        if (_installCost > 0) steps.push({ label: 'Installer Paid', done: !!q.installerPaid });
        // Commission gate matches the worker's closedStatus check: only when
        // a real commission was computed (commissionAmount > 0) AND the rep
        // is flagged as earning commission. ADMIN-only quotes (no rep) and
        // non-earning reps (e.g. RW) skip this step entirely — the dashboard
        // shows an "n/a" row in the Commission card instead, and closedStatus
        // doesn't gate on commissionPaid for these.
        if (q.repEarnsCommission !== false && parseFloat(q.commissionAmount || 0) > 0) {
          steps.push({ label: 'Commission', done: !!q.commissionPaid });
        }
        // Referral step — Shared/Referral lead source with a named recipient
        // and a non-zero GP%. Independent of rep/admin commission.
        if (parseFloat(q.referralAmount || 0) > 0) {
          steps.push({ label: 'Referral', done: !!q.referralPaid });
        }
        // CFA commission step — only when the customer was attributed to a
        // CFA inside the 18-month window AND a commission was computed.
        if (q.cfaCode && parseFloat(q.cfaCommissionAmount || 0) > 0) {
          steps.push({ label: 'CFA', done: !!q.cfaCommissionPaid });
        }
      } else {
        var sb = q.soldBasis || {};
        var offlineMethods = ['ACH', 'Wire', 'Check', 'Zelle', 'Cash'];
        var needsSignedOrder = sb.paymentReceived && offlineMethods.indexOf(sb.paymentMethod) !== -1;
        var hasWaiver = q.tncWaiver && q.tncWaiver.active;
        if ((needsSignedOrder && !hasWaiver) || sb.signedOrder) {
          steps.push({ label: 'Signed', done: !!sb.signedOrder });
        }
        if (sb.poReceived) {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Renamed 'PO' to
             'PO Received' for clarity; matches the admin-view step label
             added above. */
          steps.push({ label: 'PO Received', done: true });
        }
        // Same up-front-vs-deferred ordering as the admin view: pay-in-full
        // and 50/50 mean money lands before fulfilment, so Paid leads. Net 30
        // and 50/50 Net 30 mean fulfilment first, payment after.
        var _payments = q.payments || [];
        var _totalAmt = parseFloat(q.total || q.quoteAmount || q.amount || 0);
        var _paidAmt = _payments.length > 0 ? _payments.reduce(function(s, p) { return s + (parseFloat(p.amount) || 0); }, 0) : parseFloat(q.paymentAmount || 0);
        /* CUSTOM_PAYTERMSGATE_BY_CLAUDE (Ryan 2026-09-19, SHOP-2073) — ⛔ "ONLINE" IS NOT
           "PAID IN FULL", AND THIS STEP USED TO SAY IT WAS.
           This block forced `_paidAmt = _totalAmt` and then `_paidFull = true` for every online
           order, unconditionally. It was the fourth workaround for one root cause: a native
           online order has no `lifecycle.payments[]`, so `q.payments` is empty and the honest
           arithmetic above reads $0 collected. Forcing it was right for the common case and
           wrong for the one that matters — a PARTIALLY_PAID order carrying an unpaid `collect`
           adjustment showed Customer Paid ✓ while genuinely owing the freight balance.
           ✅ `q.paymentGate` now answers this properly for online rows (it resolves receipts from
           Shopify: `onlinePaid`, else `totalReceivedSet`), so take its numbers rather than
           inventing a second set here. `balanceDue` of 0 is the settled test — it covers a paid
           order, a fully refunded one (current total 0) and an unpriced one alike, which is the
           same set this used to wave through.
           ⚠️ THE OLD BEHAVIOUR IS THE FALLBACK, deliberately. A row cached before the gate
           existed, or one built without it, has no `paymentGate`, and reading $0 collected off an
           empty payments array would light every online order as UNPAID — a far louder wrong
           answer than the one being fixed. */
        if (q.source === 'online' && q.paymentGate) {
          _paidAmt = Number(q.paymentGate.totalPaid) || 0;
          if (Number(q.paymentGate.total) > 0) _totalAmt = Number(q.paymentGate.total);
        } else if (q.source === 'online' && _totalAmt > 0 && _paidAmt < _totalAmt) {
          _paidAmt = _totalAmt;
        }
        var _paidFull = _totalAmt > 0 ? _paidAmt >= _totalAmt : !!q.paid;
        if (q.source === 'online') {
          _paidFull = q.paymentGate ? !(Number(q.paymentGate.balanceDue) > 0) : true;
        }
        var _paidFrac = (_totalAmt > 0 && _paidAmt > 0 && !_paidFull) ? Math.min(_paidAmt / _totalAmt, 1) : 0;
        var _paidStep = { label: 'Customer Paid', done: _paidFull, partial: _paidFrac, partialText: _paidFrac > 0 ? money(_paidAmt) + ' / ' + money(_totalAmt) : '' };
        // Online Shopify orders are pre-paid in full at checkout (rep view).
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Mirror the admin
           view's PO-defers-payment rule. sb.poReceived overrides terms-based
           up-front detection so Paid sequences late on PO purchases. */
        var _termsUpFront = (q.terms === 'Pay in Full' || q.terms === '50/50' || q.source === 'online') && !sb.poReceived;

        if (_termsUpFront) steps.push(_paidStep);
        steps.push(vendorStep('Ordered', allPurchased, purchasedCount));
        steps.push(vendorStep('Shipped', allShipped, shippedCount));
        if (!_termsUpFront) steps.push(_paidStep);
        if (q.install && q.install.required) {
          steps.push({ label: 'Installed', done: q.install.status === 'complete' });
        }
        // Commission step — same gate as admin view. The rep sees their own
        // commission progress here so they know when payout has cleared. Only
        // shows when a real commission was computed AND the rep is flagged
        // as earning commission on the quote.
        if (q.repEarnsCommission !== false && parseFloat(q.commissionAmount || 0) > 0) {
          steps.push({ label: 'Commission', done: !!q.commissionPaid });
        }
      }
      return steps;
    }

    /* CUSTOM_FREIGHTPROMISE_BY_CLAUDE (Ryan 2026-10-23) - the To Do truck for a freight price past its 30-day promise.
       `q.freightHold` = {sentAt, proposals[{vendor, from, to}]} reaches the row only while the Freight Hub's "30-day
       quote hold" switch is on (rfq-worker strips it otherwise). The age is worked out HERE, at paint time: the board
       paints from a cache, so a baked "34 days" would be wrong by tomorrow. */
    var FREIGHT_HOLD_DAYS = 30;
    var FREIGHT_HOLD_SVG = {
      up: '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1.5v9M1.8 5.4 6 1.5 10.2 5.4" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      down: '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M6 10.5v-9M1.8 6.6 6 10.5 10.2 6.6" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      refresh: '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M9.8 6.6A3.9 3.9 0 1 1 8.6 3.2" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/><path d="M9.6 1.2v2.9H6.7" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };
    function freightHoldState(q) {
      var h = q && q.freightHold;
      if (!h || q.lifecycleStatus === 'sold' || q.lifecycleStatus === 'lost' || q.closedStatus === 'closed') return null;
      var t = Date.parse(h.sentAt || '');
      var days = isFinite(t) ? Math.floor((Date.now() - t) / 86400000) : null;
      var props = Array.isArray(h.proposals) ? h.proposals : [];
      var money = function (n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
      var age = days != null ? 'Freight quote is ' + days + ' days old. ' : 'Freight quote is over ' + FREIGHT_HOLD_DAYS + ' days old. ';
      var tail = ' Our ' + FREIGHT_HOLD_DAYS + '-day price promise has passed.';
      if (props.length) {
        var from = 0, to = 0;
        props.forEach(function (p) { from += Number(p.from) || 0; to += Number(p.to) || 0; });
        from = Math.round(from * 100) / 100; to = Math.round(to * 100) / 100;
        var up = to > from;
        return { dir: up ? 'up' : 'down', variant: up ? 'lost' : 'sold', from: from, to: to, days: days, action: 'apply',
          label: 'New freight price waiting: ' + money(to),
          tip: age + 'Current rate is ' + money(to) + ', ' + (up ? 'up' : 'down') + ' from the ' + money(from) + ' on the quote. Click to apply it when you are next talking with the customer.' + tail };
      }
      if (days == null || days < FREIGHT_HOLD_DAYS) return null;
      return { dir: 'refresh', variant: 'awaiting', days: days, action: 'rerequest',
        label: 'Freight quote expired: request a fresh one',
        tip: age + 'We do not have a current rate yet. Click to request a fresh freight quote.' + tail };
    }

    /* CUSTOM_FREIGHTPROMISE_BY_CLAUDE - the card the truck opens: one button, Apply (POST /freight-reprice-apply) or
       Re-request (POST /request-logistics, the same door as the row's Request Freight). Cloned from the freight-override
       popover so it positions, closes and themes the same way.
       Ryan 2026-10-23: "why require a click to see another pop-up? Make it all a part of the first pop-up on mouseover" and
       "the 'Not now' button seems pointless" - so the card IS the hover: it opens when the pointer reaches the truck, stays
       while the pointer is on the truck or the card (a short grace to cross the gap), closes when it leaves both. A click
       still opens it (touch screens have no hover). Never closes under a request in flight. */
    var _freightHoldCloseTimer = null;
    function openFreightHoldPopover(btn, ref) {
      var prior = document.getElementById('rqd-freight-hold-popover');
      if (prior && prior.getAttribute('data-ref') === ref) { clearTimeout(_freightHoldCloseTimer); return; }
      if (prior) prior.remove();
      clearTimeout(_freightHoldCloseTimer);
      var q = allQuotes.find(function (x) { return x && x.reference === ref; });
      var st = q && freightHoldState(q);
      if (!st) return;
      var money = function (n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
      var zip = (q.shipTo && q.shipTo.zip) || q.zip || '';
      var noZip = st.action === 'rerequest' && !String(zip).trim();
      var qwUrl = '/pages/rep-quote-workstation?ref=' + encodeURIComponent(ref);
      var title = st.days != null ? 'Freight quote is ' + st.days + ' days old' : 'Freight quote is over ' + FREIGHT_HOLD_DAYS + ' days old';
      var body = st.action === 'apply'
        ? 'Current rate is <b>' + money(st.to) + '</b>, ' + (st.dir === 'up' ? 'up' : 'down') + ' from the ' + money(st.from) + ' on the quote. Apply it when the timing with the customer is right; the quote and pay link update.'
        : (noZip
          ? 'We need a ship-to zip code before a fresh freight quote can be requested. <a href="' + qwUrl + '" style="color:var(--rq-blue, #2563eb);">Open the quote</a> and add it.'
          : 'We do not have a current rate yet. Request a fresh freight quote; the price on the quote stays until you apply the new one.');
      var label = st.action === 'apply' ? 'Apply ' + money(st.to) : 'Re-request freight';
      var pop = document.createElement('div');
      pop.id = 'rqd-freight-hold-popover';
      pop.setAttribute('data-ref', ref);
      pop.setAttribute('role', 'dialog');
      /* Ryan 2026-10-23: the same colours as the 📦 sample tracking card (.rqd-sample-tip--dark). */
      pop.style.cssText = 'position:fixed;z-index:9999;background:#1a2332;color:#e2e8f0;border:1px solid #334155;border-radius:8px;padding:12px 14px;box-shadow:0 6px 18px rgba(0,0,0,0.4);font-family:Montserrat,sans-serif;font-size:12px;display:flex;flex-direction:column;gap:10px;min-width:260px;max-width:320px;';
      /* Ryan 2026-10-23: the re-request card reads exactly "🚚 FREIGHT QUOTE IS X DAYS OLD / The current freight rate has
         expired, time to request an updated one." then the button - no ref, no promise line. */
      /* Ryan 2026-10-23: the Apply card in the same short style - the title, one sentence, the button. */
      var _short = !noZip;
      if (st.action === 'rerequest' && !noZip) body = 'The current freight rate has expired, time to request an updated one.';
      if (st.action === 'apply') body = 'The freight rate has changed: <b>' + money(st.to) + '</b>, ' + (st.dir === 'up' ? 'up' : 'down') + ' from ' + money(st.from) + '.';
      pop.innerHTML =
        '<div style="font-weight:700;font-size:11px;letter-spacing:0.04em;text-transform:uppercase;color:var(--rq-text-secondary, #6b7280);">&#x1F69A; ' + esc(title) + (_short ? '' : ' &middot; ' + esc(ref)) + '</div>' +
        '<div style="font-size:12px;line-height:1.45;">' + body + '</div>' +
        (_short ? '' : '<div style="font-size:11px;color:var(--rq-text-secondary, #6b7280);">Our ' + FREIGHT_HOLD_DAYS + '-day price promise has passed.</div>') +
        (noZip ? '' : '<div style="display:flex;justify-content:flex-end;align-items:center;">' +
          '<button type="button" id="rqd-fhold-go" style="background:#2563eb;border:1px solid #2563eb;color:#fff;border-radius:999px;padding:4px 12px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:600;">' + esc(label) + '</button>' +
        '</div>');
      var _mountWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
      _mountWrap.appendChild(pop);
      function repositionPop() {
        var r = btn.getBoundingClientRect();
        var popH = pop.offsetHeight || 160, popW = pop.offsetWidth || 300;
        var top = r.bottom + 6;
        if (top + popH > window.innerHeight - 8) { var above = r.top - popH - 6; top = above >= 8 ? above : Math.max(8, window.innerHeight - popH - 8); }
        if (top < 8) top = 8;
        var left = r.left - 12;
        if (left + popW > window.innerWidth - 8) left = window.innerWidth - popW - 8;
        if (left < 8) left = 8;
        pop.style.top = Math.round(top) + 'px'; pop.style.left = Math.round(left) + 'px';
      }
      repositionPop();
      var _raf = false;
      function onScroll() { if (_raf) return; _raf = true; requestAnimationFrame(function () { _raf = false; repositionPop(); }); }
      var busy = false;
      /* Ryan 2026-10-23: the badge fades while its card is open, like the 📦's tracking pop-up, so you can see which
         small truck the card belongs to. A class, not :hover - the card stays open while the pointer is on the card. */
      btn.classList.add('rqd-logistics-icon--hold-open');
      function close() { clearTimeout(_freightHoldCloseTimer); btn.classList.remove('rqd-logistics-icon--hold-open'); if (pop && pop.parentNode) pop.parentNode.removeChild(pop); document.removeEventListener('mousedown', outside, true); document.removeEventListener('keydown', onKey); window.removeEventListener('scroll', onScroll, true); window.removeEventListener('resize', onScroll); btn.removeEventListener('mouseleave', laterClose); }
      function laterClose() { clearTimeout(_freightHoldCloseTimer); _freightHoldCloseTimer = setTimeout(function () { if (!busy) close(); }, 300); }
      function stayOpen() { clearTimeout(_freightHoldCloseTimer); }
      pop.addEventListener('mouseenter', stayOpen);
      pop.addEventListener('mouseleave', laterClose);
      btn.addEventListener('mouseleave', laterClose);
      function outside(ev) { if (!pop.contains(ev.target) && !btn.contains(ev.target) && !busy) close(); }
      function onKey(ev) { if (ev.key === 'Escape' && !busy) close(); }
      async function go() {
        var b = pop.querySelector('#rqd-fhold-go');
        busy = true;
        b.disabled = true; b.textContent = st.action === 'apply' ? 'Applying...' : 'Requesting...';
        try {
          var res = st.action === 'apply'
            ? await API.post('/freight-reprice-apply', { ref: ref })
            : await API.post('/request-logistics', { ref: ref, type: 'freight' });
          if (!res || res.success === false) throw new Error((res && res.error) || 'Unknown error');
          busy = false;
          close();
          /* Paint the result now, then reconcile: the truck goes (applied) or turns into the blue "R" (requested). */
          if (st.action === 'apply') { delete q.freightHold; q.freightSynced = false; }
          else { q.freightStatus = 'requested'; q.freightRequestedBy = (window.RepPortal && window.RepPortal.Auth.getSession() || {}).repCode || q.freightRequestedBy; }
          refreshProgressBar(ref);
          fetchQuotes({ quiet: true });
        } catch (err) {
          busy = false;
          b.disabled = false; b.textContent = label;
          rqdAlert((st.action === 'apply' ? 'Could not apply the new freight price: ' : 'Could not request freight: ') + ((err && err.message) || err));
        }
      }
      var goBtn = pop.querySelector('#rqd-fhold-go');
      if (goBtn) goBtn.addEventListener('click', go);
      setTimeout(function () { document.addEventListener('mousedown', outside, true); document.addEventListener('keydown', onKey); window.addEventListener('scroll', onScroll, true); window.addEventListener('resize', onScroll); }, 0);
    }

    function buildLogisticsIcons(q) {
      var html = '';
      if (q.lifecycleStatus === 'lost' || q.closedStatus === 'closed') return html;
      // Sold orders normally hide the truck (the freight workflow ended at
      // sold-time). EXCEPTION: when the rep / admin requests freight again
      // post-sale (e.g. estimate-→-real-quote conversion), we want the
      // requesting user to keep seeing the truck so they can track it.
      // Visibility:
      //   - Admin: always sees post-sale freight requests.
      //   - Rep: sees ONLY requests they themselves initiated. Admin-initiated
      //     post-sale freight is hidden from reps so they don't get confused
      //     by what was an internal admin re-quote.
      if (q.lifecycleStatus === 'sold') {
        if (q.freightStatus !== 'requested' && !q.freightReRequested && !q.freightRequestPending) return html;
        if (!isAdmin) {
          var _sess = window.RepPortal && window.RepPortal.Auth.getSession();
          var _myCode = _sess && _sess.repCode;
          if (!_myCode || (q.freightRequestedBy !== _myCode && q.freightReRequestedBy !== _myCode)) return html;
        }
      }
      // Status-tint variables removed (2026-05-07) — the truck/hammer no
      // longer mirror the row's status pill colour. The new three-state
      // sync indicator (orange-pending → orange+blue✓-ready → B&W-synced)
      // is more useful and unambiguous, and the status pill itself already
      // carries the row-status colour next to the icons.

      /* Freight icon — Ryan 2026-05-16 new badge progression:
           requested + N vendors still need a request → count badge (N)
           requested + all vendors requested, awaiting replies        → "R"
           quoted + !synced → orange truck + blue "✓" ready badge
           quoted + synced  → B&W truck, no badge
         Both admins and non-admins see the badge state. Replaces the
         prior "Nx request" admin-only text in the TO DO column —
         info now lives on the badge attached to the truck emoji. */
      /* CUSTOM_FREIGHTSAVEMERGE_BY_CLAUDE (ONYX 44a20f69e2a7, Ryan 2026-10-16, RW-1517-A) - the truck only means freight
         that is IN the total. Freight applied but missing from the total shows this red warning instead of any truck
         (the worker sets q.freightNotInTotal; the Order Desk gets a row to fix it). */
      if (q.freightNotInTotal) {
        var _fnt = q.freightNotInTotal;
        var _fntTitle = 'Freight not in the total: $' + (Number(_fnt.quoted) || 0).toFixed(2) + ' of freight was applied, but the quote total carries $'
          + (Number(_fnt.charged) || 0).toFixed(2) + '. Click Apply on the Freight Quote card to put it back in the total.';
        /* Ryan 2026-10-17: a red truck (the blue-check truck's shape), not text, so the column keeps its width. */
        html += '<span class="rqd-logistics-icon rqd-logistics-icon--freight-missing" title="' + esc(_fntTitle) + '">'
          + '<span class="rqd-logistics-icon__truck-red" aria-hidden="true">&#x1F69A;</span><span class="rqd-logistics-icon__alert" aria-hidden="true">!</span></span>';
      } else if (q.freightStatus === 'requested' || q.freightRequestPending) {
        var _frUnreq = q.freightUnrequestedCount || 0;
        var _frVc = q.freightVendorCount || 0;
        var _frBadge, _frBadgeTitle;
        /* CUSTOM_BOLGATEPANEL_BY_CLAUDE (ONYX 9baa31abcad4, Ryan 2026-10-26) - the worker says whether anybody was told to go ask
           (q.freightRequestTracked, false = no Order Desk row behind the press). Untracked: the same orange truck, the number red. */
        var _frUntracked = _frUnreq > 0 && q.freightRequestTracked === false;
        /* CUSTOM_TRUCKREDRACE_BY_CLAUDE (Ryan 2026-10-30, RW-1556-A: "if I see a red circle, there's legitimately something
           wrong") - the agent's row opens a few seconds after the press, so red waits 30 minutes from the request. Counted here,
           at every draw, never in the baked row: a baked "not yet" would stay blue on a request that really was lost. */
        var _frAskedMs = Date.parse(q.freightRequestedAt || '');
        if (_frUntracked && isFinite(_frAskedMs) && Date.now() - _frAskedMs < 30 * 60000) _frUntracked = false;
        if (_frUnreq > 0) {
          _frBadge = _frUnreq;
          _frBadgeTitle = _frUnreq + ' of ' + _frVc + ' vendor' + (_frVc > 1 ? 's' : '') + ' still need a freight quote request'
            + (_frUntracked ? ', and nobody was told to ask. Run the freight request catch-up in Settings, or ask the supplier yourself.' : '');
        } else {
          _frBadge = 'R';
          _frBadgeTitle = 'All ' + _frVc + ' vendor' + (_frVc > 1 ? 's' : '') + ' requested — awaiting supplier replies';
        }
        if (_frUntracked) {
          html += '<span class="rqd-logistics-icon rqd-logistics-icon--freight-untracked" title="' + esc(_frBadgeTitle) + '"><span class="rqd-logistics-icon__truck-orange" aria-hidden="true">&#x1F69A;</span><span class="rqd-logistics-icon__alert">' + _frBadge + '</span></span>';
        } else {
          html += '<span class="rqd-logistics-icon rqd-logistics-icon--freight" title="' + esc(_frBadgeTitle) + '">&#x1F69A;<span class="rqd-logistics-icon__count">' + _frBadge + '</span></span>';
        }
      } else if (q.freightReRequested) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-08) — Weight/dims re-requested on a deal
           whose freight is already quoted. The applied quote is untouched (freight.status
           stays 'quoted'); this truck just signals a fresh supplier reply is pending — a new
           weight/dims request went out to re-quote. Same orange freight truck + "R" as the
           awaiting-reply state. Clears when the deal is re-quoted or the reply lands. */
        html += '<span class="rqd-logistics-icon rqd-logistics-icon--freight" title="Weight/dims re-requested — awaiting supplier reply (applied quote unchanged)">&#x1F69A;<span class="rqd-logistics-icon__count">R</span></span>';
      } else if (freightHoldState(q)) {
        /* CUSTOM_FREIGHTPROMISE_BY_CLAUDE (Ryan 2026-10-23) - the 30-day freight promise has run out on a quote the
           customer holds: red up / green down = a new price is waiting (click to apply it), amber refresh = no current
           rate yet (click to re-request). Hover explains it in prices only, never our cost. */
        var _fhs = freightHoldState(q);
        /* Ryan 2026-10-23: the hover IS the card (openFreightHoldPopover), so no separate tooltip. */
        html += '<span class="rqd-logistics-icon rqd-logistics-icon--hold" data-ref="' + esc(q.reference) + '" role="button" tabindex="0" aria-haspopup="dialog" aria-label="' + esc(_fhs.label) + '">&#x1F69A;'
          + '<span class="rqd-logistics-icon__hold rqd-logistics-icon__hold--' + _fhs.dir + '" aria-hidden="true">' + FREIGHT_HOLD_SVG[_fhs.dir] + '</span></span>';
      } else if (q.freightStatus === 'quoted' && q.freightSynced === false) {
        /* Ryan 2026-05-21: dropped the synced/B&W informational truck.
           Once freight is quoted AND the customer has the updated
           quote, there's no action needed in the To Do column —
           clutter without signal. Rep / admin can see "deal has
           freight" by expanding the row (Financials card). The
           orange-with-✓ "ready to send" state stays because it
           signals an unfulfilled action.
           CUSTOM_TRUCKONQUOTE_BY_CLAUDE (Ryan 2026-09-29): freightSynced is false ONLY when freight
           is ON the quote (applied) and no PDF download / quote email has gone out since. A saved
           supplier cost nobody applied no longer lights it (RW-1466-A). */
        html += '<span class="rqd-logistics-icon rqd-logistics-icon--ready" title="Freight is on the quote and the customer has not seen it yet: download or email the quote">&#x1F69A;<span class="rqd-logistics-icon__check-ready" aria-hidden="true">✓</span></span>';
      }
      /* Install icon — typically single-vendor, so the count phase
         doesn't really apply. The moment admin clicks "Request Install
         Quote", installationStatus flips to 'requested' which means
         the request is OUT. Badge goes straight to "R" → ✓. */
      if (q.installationStatus === 'requested') {
        html += '<span class="rqd-logistics-icon rqd-logistics-icon--install" title="Installation requested — awaiting installer reply"><span aria-hidden="true">&#x1F528;</span><span class="rqd-logistics-icon__count">R</span></span>';
      } else if (q.installationStatus === 'quoted' && q.installSynced === false) {
        /* Ryan 2026-05-21: dropped the synced/B&W informational hammer
           (same rule as freight above). Action-signal hammer with ✓
           stays for the "send updated quote" case. */
        html += '<span class="rqd-logistics-icon rqd-logistics-icon--ready" title="Installation added — send updated quote to customer">&#x1F528;<span class="rqd-logistics-icon__check-ready" aria-hidden="true">✓</span></span>';
      }
      // Quote-level sample tracking — admin-only. When set, render a 📦 pill
      // with hover popover for the carrier + number. Variant picked from row
      // state so the pill matches the row's surrounding theme:
      //   - NEW LEAD row → --lead (orange/yellow, matches awaiting timer)
      //   - QUOTED / in-progress / SOLD → --quote (blue, matches QUOTED pill)
      // The variant flips automatically on the next dashboard refresh once
      // the lead progresses (items added or PDF downloaded), so admins don't
      // have to do anything to migrate the colour.
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Skip the
         sample-shipped pill in the generic logistics-icons builder
         when the row is ON HOLD. The on-hold render path injects its
         OWN purple-themed (.rqd-sample-shipped--on-hold) variant
         alongside the countdown pill — rendering both stacks a blue
         and a purple 📦 next to each other. ON HOLD owns the icon. */
      if (q.quoteSampleTracking && q.quoteSampleTracking.number && !q.isOnHold) {
        var _qst = q.quoteSampleTracking;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Use bestSampleTrackingUrl to heal
           legacy saved URLs that point to a generic carrier landing page
           instead of the deep link for this tracking number. */
        var _qstUrl = bestSampleTrackingUrl(_qst.url, _qst.carrier, _qst.number);
        var _qstLabel = (_qst.carrier ? esc(_qst.carrier) + ' ' : '') + esc(_qst.number);
        var _qstTitle = 'Sample shipped' + (_qst.savedAt ? ' · saved ' + (formatDate(_qst.savedAt) || _qst.savedAt) : '');
        var _qstSaved = _qst.savedAt ? (formatDate(_qst.savedAt) || _qst.savedAt) : '';
        // Fresh-NEW-LEAD detection mirrors _isFreshLeadDH in buildDetailHtml.
        // Once items land OR the PDF is downloaded, the row no longer reads
        // as NEW LEAD on the dashboard, so the pill flips back to --quote.
        var _qstIsLeadRow = (q.isLead || q.status === 'new_lead') && !q.isSample && !q.isDeadLead && !q.isOnHold;
        var _qstHasItems = (parseFloat(q.total) || 0) > 0;
        var _qstPdfDone = !!(q.pdfDownloaded || q.chainPdfDownloaded);
        var _qstIsFreshLead = _qstIsLeadRow && !_qstHasItems && !_qstPdfDone;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-25) — pending rows get the gray
           --pending pill variant (matches the PENDING theme) instead of blue --quote. */
        var _qstIsPendingRow = q.isPending || q.status === 'pending';
        var _qstVariant = _qstIsPendingRow ? 'pending' : (_qstIsFreshLead ? 'lead' : 'quote');
        var _qstDel = sampleDeliveryState(_qst);
        /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient on a quoted deal: the same
           second bubble + who-went-where popover the sample row wears. */
        var _qsec = (q.sampleSecondary && typeof q.sampleSecondary === 'object' && !q.sampleSecondary.removedAt
          && (q.sampleSecondary.requested || (q.sampleSecondary.sampleRequest && q.sampleSecondary.sampleRequest.sentAt))) ? q.sampleSecondary : null;
        var _qsecList = '';
        if (_qsec) {
          try {
            var _w2 = String((_qsec.shipTo && _qsec.shipTo.name) || 'Second recipient') + ((_qsec.shipTo && _qsec.shipTo.company) ? ' (' + _qsec.shipTo.company + ')' : '');
            var _qt2 = (_qsec.sampleTracking && _qsec.sampleTracking.number) ? _qsec.sampleTracking : null;
            var _qd2 = _qt2 ? sampleDeliveryState(_qt2) : null;
            _qsecList = JSON.stringify([
              { seq: 1, who: 'Buyer', url: _qstUrl || '', label: (_qst.carrier ? _qst.carrier + ' ' : '') + (_qst.number || ''), saved: _qstSaved, state: _qstDel.title, tone: _qstDel.tone || '' },
              _qt2 ? { seq: 2, who: _w2, url: bestSampleTrackingUrl(_qt2.url, _qt2.carrier, _qt2.number) || '', label: (_qt2.carrier ? _qt2.carrier + ' ' : '') + (_qt2.number || ''),
                        saved: _qt2.savedAt ? (formatDate(_qt2.savedAt) || _qt2.savedAt) : '', state: _qd2.title, tone: _qd2.tone || '' }
                   : { seq: 2, who: _w2, url: '', label: 'No tracking number yet', saved: '', state: 'Requested from ECORE · awaiting box', tone: '' },
            ]);
          } catch (_) { _qsecList = ''; }
        }
        html += '<span class="rqd-sample-shipped rqd-sample-shipped--' + _qstVariant + _qstDel.cls + (_qsec ? ' rqd-sample-shipped--two-recipients' : '') + '" tabindex="0"' +
          ' data-track-url="' + esc(_qstUrl || '') + '"' +
          ' data-track-label="' + esc(_qstLabel) + '"' +
          ' data-track-saved="' + esc(_qstSaved) + '"' +
          ' data-track-state="' + esc(_qstDel.title) + '"' +
          ' data-track-tone="' + esc(_qstDel.tone || '') + '"' +
          (_qsecList ? ' data-track-list="' + esc(_qsecList) + '"' : '') +
          ' data-variant="' + _qstVariant + '"' +
          /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — PHASE 2. The delivery state was
             ALREADY machine-readable here: `sampleDeliveryState` returns one canonical `tone`
             ('delivered' | 'trouble' | 'transit') and it rides out as `data-track-tone`. What was
             missing is an accessible NAME — the whole pill is a 📦 with `aria-hidden` on the only
             text node, so a screen reader and anything reading rendered text got an empty
             clickable element, and the ✓/✕ that distinguish delivered from trouble are drawn by
             CSS ::after and exist in no text node at all.

             `role="button"` because it is one: clicking opens the tracking popover (the delegated
             handler on .rqd-sample-shipped). The label restates what the tooltip says, so touch
             users and non-hover readers get the state without a hover they cannot perform. */
          ' role="button" aria-label="' + esc((_qsec ? 'Two recipients · ' : '') + _qstTitle + ' · ' + _qstDel.title + ' · ' + _qstLabel) + '"' +
          ' title="' + esc((_qsec ? 'Two recipients · ' : '') + _qstTitle) + ' · ' + esc(_qstDel.title) + ' — hover for tracking">' +
          '<span class="rqd-sample-shipped__icon" aria-hidden="true">📦</span>' +
          (_qsec ? '<span class="rqd-sample-shipped__count rqd-sample-shipped__count--recipients" aria-hidden="true">2</span>' : '') + // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24)
        '</span>';
      }
      return html;
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — the purple 📦 for an ON HOLD row, extracted
       so it has ONE definition and more than one caller.
       ─────────────────────────────────────────────────────────────────────────────────────────
       ⛔ THE BUG THIS FIXES. `buildLogisticsIcons` deliberately skips the shipped pill when
       `q.isOnHold` — the on-hold render path owns it, and drawing both stacked a blue and a
       purple box side by side. That was safe while the on-hold branch was guaranteed to run.
       It stopped being guaranteed on 2026-08-20, when the ⚡ sequence countdown was added ABOVE
       it and returns early: on a held deal with a live automation, `buildLogisticsIcons` declined
       to draw the box and the branch that would have drawn it was never reached, so the shipment
       vanished from the To Do column entirely. Ryan caught it on RW-1327-A, the only deal on the
       board in exactly that state.
       ⚠️ `q.isSample` is NOT part of the gate — it reflects the CURRENT lead status, which flips
       off 'sample' the moment the lead goes on hold. The presence of a tracking number is the
       real signal (Ryan 2026-05-20). */
    function buildHeldSampleIcon(q) {
      var st = (q.sampleTracking && q.sampleTracking.number)
        ? q.sampleTracking
        : (q.quoteSampleTracking && q.quoteSampleTracking.number ? q.quoteSampleTracking : null);
      if (!st) return '';
      var url = bestSampleTrackingUrl(st.url, st.carrier, st.number);
      var label = (st.carrier ? esc(st.carrier) + ' ' : '') + esc(st.number);
      var saved = st.savedAt ? (formatDate(st.savedAt) || st.savedAt) : '';
      var del = sampleDeliveryState(st);
      return '<span class="rqd-sample-shipped rqd-sample-shipped--on-hold' + del.cls + '" tabindex="0"' +
        ' data-track-url="' + esc(url || '') + '"' +
        ' data-track-label="' + esc(label) + '"' +
        ' data-track-saved="' + esc(saved) + '"' +
        ' data-track-state="' + esc(del.title) + '"' +
        ' data-track-tone="' + esc(del.tone || '') + '"' +
        ' data-variant="on-hold"' +
        ' title="Sample shipped · ' + esc(del.title) + ' — hover for tracking">' +
        '<span class="rqd-sample-shipped__icon" aria-hidden="true">📦</span>' +
      '</span>';
    }

    function buildRequestLogisticsButtons(q) {
      var isPend = q.isPending || q.status === 'pending';
      if (isPend) return '';
      var html = '';
      /* CUSTOM_OFFLINEDIMSONFILE_BY_CLAUDE (Ryan 2026-10-01, RW-1469-A) — ADMINS GET REQUEST FREIGHT TOO.
         It hands the job to the AI agents (they quote from packaged dims on file, else ask the supplier),
         which is as useful to an admin as to a rep. Freight only and offline deals only for an admin:
         Request Installation just emails the admins, and an online order has its own freight lane. */
      if (isAdmin) {
        if (q.freightStatus === 'pending' && q.source !== 'online') {
          html += '<button type="button" class="rqd-request-logistics-btn" data-ref="' + esc(q.reference) + '" data-logistics-type="freight">Request Freight</button>';
        }
        return html;
      }
      if (q.freightStatus === 'pending') {
        html += '<button type="button" class="rqd-request-logistics-btn" data-ref="' + esc(q.reference) + '" data-logistics-type="freight">Request Freight</button>';
      }
      if (q.installationStatus === 'pending') {
        html += '<button type="button" class="rqd-request-logistics-btn" data-ref="' + esc(q.reference) + '" data-logistics-type="installation">Request Installation</button>';
      }
      return html;
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM²) — ONE predicate for "this row is tied
       to a Shopify order by an external link", so the row pill (dashboard-quote-row.js) and the
       detail-panel tint (detailLinkedClass below) can never drift apart. They did on the first
       pass: the row said LINKED while expanding it showed the green SOLD panel, because the tint
       is a separate chain gated only on linkedParentRef.

       Covers both directions — the offline deal (soldBasis.source === 'external') and the online
       order carrying the back-pointer tag (externalLinkedToRef).

       ⚠️ Deliberately NOT extended to the two other linkedParentRef gates nearby:
         • `_noCommissionCard` (~L8195) hides the commission card, right for a balance child whose
           commission lives on the parent, WRONG here — RW-1290-A earns its own;
         • the "See PARENT for full deal financials" stub (~L8418) — this deal's financials are
           its own.
       Only the visual theme is shared, never the "your money lives elsewhere" behaviour. */
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM⁷) — OFFLINE ROWS ONLY.

       Ryan, opening SHOP-1922: "I wasn't aware that ANY of this would be changing to the
       purple/pink theme... on the ONLINE deals page, it's all green all the time." Correct, and
       this predicate was the over-reach — it answered "is there an external link?" when every
       caller actually means "is this the OFFLINE DEAL side of one?". The statuses and colour
       themes are an offline-pipeline language; an online order is always green.

       All four consumers want the narrower question, and each would be actively wrong without it:
         • the LINKED pill would replace the online row's own Shopify status pill;
         • the detail panel would go navy/pink instead of the sold green every other order wears;
         • the fulfillment tracker would be SUPPRESSED on the order — the one row where ordering
           and shipping genuinely happen, which is the opposite of the intent;
         • Order Contents would try to borrow items from itself.

       What the order KEEPS is the informational half: the 🔗 on its ref and the detail banner
       naming the deal. Those say "this belongs to RW-1290-A" without repainting anything. */
    function hasExternalOrderLink(q) {
      if (!q || q.source === 'online') return false;
      return !!((q.soldBasis && q.soldBasis.source === 'external') || q.externalLinkedToRef);
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08) — "Link to External Order", one builder
       for every cog branch.

       It used to be inlined in exactly ONE branch of the four-way cog ternary: the QUOTED /
       in-progress one. Every other state hid it — including the two states a deal is normally IN
       at the moment the customer goes and buys online themselves:
         • ON HOLD with no items/PDF → the LEAD/HOLD branch (RW-1290-A / SHOP-1922, 2026-08-08)
         • already flipped SOLD      → the SOLD branch
       In both, the only link action left standing was the appended "Link as Same Deal", which is
       the WRONG tool: it groups two rep quote CHAINS and moves no money, and the worker rejects
       it outright for an order (resolveDealOwnerRep reads SHOP-1922's owner from the ref prefix
       as "SHOP", which never equals the deal's rep → 409).

       Self-gating so every branch can call it unconditionally. Admin-only mirrors the server
       gate (this only hides noise); online rows are excluded because the direction of travel is
       offline-deal → order, never the reverse; an already-linked deal offers Unlink instead. */
    function buildLinkExternalButton(q) {
      if (!isAdmin) return '';
      if (!q || q.source === 'online' || q.cancelled) return '';
      if (q.soldBasis && q.soldBasis.source === 'external') return '';
      return '<button type="button" class="rqd-link-external-btn" data-ref="' + esc(q.reference) + '">Link to External Order</button>';
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08) — the same link, offered from the ORDER
       side. The worker stamps q.openDealMatchRef on an online order whose customer matches a
       still-open offline deal (quote-dashboard.js stampOnlineOrderDealMatches). This turns that
       match into one click, so catching "they bought it themselves" stops depending on someone
       recognising the name on the Online tab. Passes the order GID rather than its name — the
       worker's findOrderByInput takes a strict gid:// path, which sidesteps every #/SHOP- name
       formatting question. */
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM⁵) — the linked Shopify order's line
       items, for a deal that owns the sale but holds none of the goods. Resolves the order row out
       of allQuotes by the name recorded at link time (soldBasis.externalOrderName, e.g.
       "SHOP-1922"), which is exactly how online rows are keyed — buildBaseQuote sets an online
       row's `reference` to order.name. Returns null when the order isn't in the current pool (a
       rep view, or a source filter that excluded it) so callers fall through to their existing
       path rather than rendering an empty card. */
    function _linkedOrderItems(q) {
      if (!q || typeof allQuotes === 'undefined' || !allQuotes) return null;
      var orderName = (q.soldBasis && q.soldBasis.externalOrderName) || q.externalLinkedToRef || '';
      if (!orderName) return null;
      var orderRow = allQuotes.find(function(x) { return x && x.reference === orderName; });
      if (!orderRow || !Array.isArray(orderRow.onlineLineItems) || !orderRow.onlineLineItems.length) return null;
      return orderRow.onlineLineItems;
    }

    function buildLinkOpenDealButton(q) {
      if (!isAdmin) return '';
      if (!q || q.source !== 'online' || q.cancelled) return '';
      if (!q.openDealMatchRef || q.externalLinkedToRef) return '';
      return '<button type="button" class="rqd-link-open-deal-btn"' +
        ' data-ref="' + esc(q.openDealMatchRef) + '"' +
        ' data-order-gid="' + esc(q.id || '') + '"' +
        ' data-order-name="' + esc(q.orderName || q.reference) + '"' +
        ' data-matched-on="' + esc(q.openDealMatchOn || '') + '"' +
        '>&#128279; Link to open deal ' + esc(q.openDealMatchRef) + '</button>';
    }

    /* CUSTOM_REVIEWS_BY_CLAUDE (Ryan 2026-09-09) — THE REVIEW ASK LIVES IN THE ROW'S COG MENU.
       The centered ⭐ in the To Do cell hid under the green "Closed ✓" pill on a sold +
       all-shipped row (JW-1151-A), which is exactly the row the decision is for. So: one entry
       per sold row, for the deal OWNER or an admin, reading the durable `reviewAsk` stamp
       (rfq-worker lib/review-eligibility.js; `reviewStatus` is the fallback for rows stamped
       before it existed): what the state is, when Abby asks (`askDueAt`), and whether there is
       anything left to decide. A live entry carries .rqd-review-star-decide so the SAME delegated
       handler opens the SAME send/skip popover and the same POST /review-decision calls run;
       an informational one is inert. The star cell in buildProgressBar is retired. */
    function reviewAskSummary(q) {
      var ra = q.reviewAsk || {};
      var st = q.reviewStatus || null;
      var when = function (iso) { try { return iso ? formatDate(iso) : ''; } catch (_) { return ''; } };
      if (st === 'received') return { text: 'Review received', sub: '', sendOpen: false, skipOpen: false };
      if (st === 'external' || ra.state === 'external') return null;
      /* CUSTOM_REVIEWDELIVERY_BY_CLAUDE (ONYX ceac255ae3f1, Ryan 2026-10-09) - the ask is planned from a
         recorded delivery: no delivery yet reads "waiting for delivery", a recorded delivery problem reads
         "on hold" with the reason. Both stay live (Send / Skip), the same popover as before. */
      if (ra.state === 'awaiting-delivery') {
        return { text: 'Review ask: waiting for delivery', sub: ra.held && ra.held.reason ? 'On hold: ' + ra.held.reason : 'Abby asks the owner to confirm it arrived', sendOpen: true, skipOpen: true };
      }
      if (ra.state === 'pending' && ra.held && ra.held.reason) {
        return { text: 'Review ask: on hold', sub: ra.held.reason, sendOpen: true, skipOpen: true };
      }
      if (ra.state === 'pending' || st === 'decision-pending') {
        /* CUSTOM_REVIEWASKREPLY_BY_CLAUDE (AIOPS 8b9bc468e661, 2026-09-10) — the owner already said
           yes (a reply on Abby's check-in, or the agent recorded it): the ask still goes on its date,
           no nudge; nothing is waiting on anybody. Both buttons stay live (a yes is not a close). */
        if (ra.ownerConfirmedAt) {
          return { text: 'Review ask: owner said yes', sub: (ra.askDueAt ? 'Abby asks ' + when(ra.askDueAt) : 'Abby asks on schedule') + (ra.ownerConfirmedBy ? ' · ' + ra.ownerConfirmedBy + ' ' + when(ra.ownerConfirmedAt) : ''), sendOpen: true, skipOpen: true };
        }
        return { text: 'Review ask: waiting on you', sub: ra.askDueAt ? 'Abby asks ' + when(ra.askDueAt) + ' unless you skip' : 'Send it, or skip this deal', sendOpen: true, skipOpen: true };
      }
      if (ra.state === 'skipped' || st === 'skipped') {
        var _by = ra.by || (q.reviewDecision && q.reviewDecision.by) || '';
        var _sub = (_by ? 'by ' + _by : '') + (ra.reason ? (_by ? ' · ' : '') + ra.reason : '');
        return { text: 'Review ask: skipped', sub: _sub || 'Send re-opens the ask', sendOpen: true, skipOpen: false };
      }
      if (ra.state === 'suppressed' || st === 'suppressed') return { text: 'Review ask: not sent', sub: ra.reason || 'recently asked or already reviewed', sendOpen: false, skipOpen: false };
      if (st === 'requested') return { text: 'Review ask: queued', sub: 'Abby emails at the next 10am window', sendOpen: false, skipOpen: true };
      if (ra.state === 'sent-by-owner' || ra.state === 'sent-by-default' || st === 'email_sent') {
        var _who = ra.state === 'sent-by-default' ? 'by default' : (ra.by ? 'by ' + ra.by : '');
        return { text: 'Review ask: sent', sub: (_who + (ra.at ? (_who ? ' ' : '') + when(ra.at) : '')).trim(), sendOpen: false, skipOpen: false };
      }
      if (st) return { text: 'Review ask: ' + st, sub: '', sendOpen: false, skipOpen: false };
      return null;
    }
    function buildReviewAskMenuItem(q) {
      if (!q || q.cancelled || q.isReplacement) return '';
      var s = reviewAskSummary(q);
      if (!s) return '';
      var _sess = (window.RepPortal && window.RepPortal.Auth && window.RepPortal.Auth.getSession()) || {};
      var myCode = String(_sess.repCode || _sess.code || '').toUpperCase();
      var ownerCode = String(q.reference || '').split('-')[0].toUpperCase();
      if (!isAdmin && (!myCode || myCode !== ownerCode)) return '';
      var live = s.sendOpen || s.skipOpen;
      return '<button type="button" class="rqd-review-ask-btn' + (live ? ' rqd-review-star-decide' : ' rqd-review-ask-btn--info') + '" data-ref="' + esc(q.reference) + '"' + (live ? '' : ' disabled') + '>' +
        '&#11088; ' + esc(s.text) +
        (s.sub ? '<span class="rqd-review-ask-btn__sub">' + esc(s.sub) + '</span>' : '') +
        '</button>';
    }
    function refreshReviewAskMenuItems(q) {
      var html = buildReviewAskMenuItem(q);
      document.querySelectorAll('.rqd-review-ask-btn[data-ref="' + q.reference + '"]').forEach(function (el) {
        if (html) el.outerHTML = html; else el.remove();
      });
    }
    /* END CUSTOM_REVIEWS_BY_CLAUDE */

    function buildReviewIcon(q) {
      if (!q.reviewStatus) return '';
      if (q.reviewStatus === 'received') {
        var href = q.reviewProductHandle ? 'https://www.blueskyfitsupply.com/products/' + esc(q.reviewProductHandle) + '#reviews' : '';
        return href
          ? '<a href="' + href + '" target="_blank" class="rqd-review-icon rqd-review-icon--received" title="Review received &#8212; click to view">&#11088;</a>'
          : '<span class="rqd-review-icon rqd-review-icon--received" title="Review received">&#11088;</span>';
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-11) — ⭐ decision states.
         skipped → muted star in the icons slot, clickable to re-open the
         send/skip menu (reversible). suppressed → the rep chose send but
         review-worker's dedupe guards declined it (recent ask / already
         reviewed); resolved, informational only. decision-pending renders
         the big centered star in buildProgressBar, not here. */
      if (q.reviewStatus === 'skipped') {
        var _skTip = 'Review ask skipped' + (q.reviewDecision && q.reviewDecision.by ? ' by ' + esc(q.reviewDecision.by) : '') + ' — click to change';
        return '<span class="rqd-review-icon rqd-review-icon--skipped rqd-review-star-decide" data-ref="' + esc(q.reference) + '" title="' + _skTip + '" role="button" tabindex="0">&#11088;</span>';
      }
      if (q.reviewStatus === 'suppressed') {
        return '<span class="rqd-review-icon rqd-review-icon--suppressed" title="Review ask not sent &#8212; customer was recently asked or already reviewed">&#9993;</span>';
      }
      if (q.reviewStatus === 'decision-pending') return '';
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      return '<span class="rqd-review-icon rqd-review-icon--pending" title="Review request sent">&#9993;</span>';
    }

// CUSTOM_RFQPORTAL_BY_CLAUDE — Shared progress-state predicates used
    // by BOTH the To Do column emoji strip (buildOnlineFlow*Steps) and
    // the detail panel checkmark bar (getProgressSteps). Single source of
    // truth so the two surfaces can never disagree on whether a step is
    // done.
    //
    // isVendorAllBucketsPurchased — a vendor counts as "purchased" only
    // when EVERY bucket for that vendor has a sent/downloaded non-voided
    // PO. For bucket-mode orders this guarantees the step doesn't flip
    // done after just one of N POs (e.g., SHOP-1681's broker + parcel
    // pair would have wrongly flipped on the first PO sent under the
    // legacy "any PO sent" check). Non-bucket-mode orders fall back to
    // the legacy any-PO behaviour.
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Per-vendor step
       predicates. Single source of truth used by every UI surface that
       shows per-vendor progress:
         1. getProgressSteps (status bar under Sold To/Ship To/Bill To/Financials)
         2. buildOnlineFlowVendorState (To Do column emoji strip)
         3. Tracking card per-vendor row (shipped checkbox)
       The previous pattern of inlining these checks at every call site is
       what kept biting us — workflow changes required fixing 3 surfaces
       independently. Going forward: any new per-vendor step semantic
       (e.g. new shipping model, new workflow) edits the predicate here
       only; every consumer surface inherits the change.

       Pattern mirrors the long-standing isVendorAllBucketsPurchased
       predicate immediately below. */

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-17) — case-tolerant lookup into a
       vendor-keyed lifecycle map (freightOverrides today). Mirrors _lookupByVendor in
       dashboard-po-lens.js: those maps are written with whatever casing the writer had
       ("ECORE Athletic"), while the predicates below are handed the canonical name
       ("ECORE"), so a straight key lookup silently misses. */
    /* ONLINE-TODO-TWIN:BEGIN
       CUSTOM_ONLINETODO_BY_CLAUDE (AIOPS suggestion 8c3657329fc1, Ryan 2026-09-04) — THE ONLINE
       TO DO STRIP EXISTS TWICE. Everything between these markers — the per-vendor predicates,
       the bucket-aware step builders, the three flow builders, buildOnlineFlowSteps and
       isOnlineRowResolved — is evaluated by rfq-worker's tests/online-todo-parity.test.mjs
       against src/lib/online-todo.js over the same fixtures, and the two must agree step for
       step. That is what lets /rep-quotes carry `todo` for an agent and honestly call it "what
       Ryan sees in the TO DO column". Edit the rule here and the worker's test goes red until
       the copy there is edited too; that is the feature.
       ⚠️ The span reads three helpers from outside itself — getVendorWorkflow, resolvedVendorFor,
       vendorNamesMatch — which the test injects. Add a fourth and the test will say so. */
    function vendorMapEntry(map, vendor) {
      if (!map || !vendor) return null;
      if (map[vendor] != null) return map[vendor];
      var vl = String(vendor).trim().toLowerCase();
      var k = Object.keys(map).find(function (kk) { return String(kk).trim().toLowerCase() === vl; });
      return k ? map[k] : null;
    }
    function vendorIsOurCarrier(q, vendor) {
      var ov = vendorMapEntry(q && q.freightOverrides, vendor);
      return !!(ov && ov.mode === 'our-carrier');
    }

    // Does this vendor need a freight handshake at all? Web-order vendors
    // (admin buys direct on vendor's website) skip it — shipping calculated
    // at the vendor's checkout.
    function vendorNeedsFreightHandshake(q, vendor) {
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — resolved, not the row's name. Both
         questions below are about the SUPPLIER: whether they are bought from a website, and
         whether they owe us a freight quote. A white-label row is named for us, not for them. */
      var wf = getVendorWorkflow(resolvedVendorFor(q, vendor));
      if (wf === 'web-order') return false;
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-17) — an our-carrier order owes no
         handshake either. Flipping the shipment to Blue Sky's own carrier IS the statement
         that the supplier will never quote us freight, which is exactly why the Purchasing
         card's Generate PO gate already honours it (dashboard-po-lens.js ~L220, commit
         1a03755a). The two PROGRESS surfaces were left behind by that fix, so SHOP-1931
         (60 ECORE pavers, switched to our carrier 2026-08-13) kept showing a "Freight
         Requested" step for a quote nobody was ever going to send. Fixed at the predicate
         so the bar, the To Do strip and the PO gate can't drift apart again.

         ⚠ NOT on Flow A. There the outstanding ask is weight/DIMS, and our-carrier is Flow
         A's normal state (we always broker those) — so "we ship it ourselves" is not an
         answer to it: we still need the supplier's dims before a broker will quote. The
         switch renders on Flow A rows too (dashboard-po-lens.js gates only on web-order),
         so without this clause one click would hide a step that is genuinely owed. */
      if (q && q.onlineFlow !== 'A' && vendorIsOurCarrier(q, vendor)) return false;
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — OFFLINE deals: the vendor's own
         workflow decides. Until now this predicate answered `true` for every offline vendor,
         which was harmless only because nothing offline rendered a freight step — so switching
         the Purchasing card on without this clause would have put a Request Freight row on every
         offline deal in the system, including the PO-only vendors that have never needed one.

         `freight-then-po` is what Ryan already sets in the Vendor Guide to mean "ask them for
         freight, then send the PO". Before today the dashboard read that field for exactly
         nothing — the only value it acted on was `web-order` — so a vendor set to Freight → PO
         behaved identically to PO Only. This is the line that makes the setting mean something.

         Online is untouched on purpose: there the flow classification already answers it, and
         this clause cannot fire. */
      if (q && q.source !== 'online' && wf !== 'freight-then-po') return false;
      return true;
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — does this vendor owe us a freight
       COST at all? Sibling of vendorNeedsFreightHandshake above, and the same shape: the
       caller counts the APPLICABLE set, and the step hides entirely when that set is empty.

       ⛔ THIS IS NOT THE SAME QUESTION AS "did anyone type a number". Two shipping models
       have no separate carrier bill in existence:
         • parcel-only        — the supplier ships UPS/FedEx and bills it on the invoice
         • freight-in-product — freight is baked into what we pay for the goods
       For those, an unfilled Freight Cost step is a demand for a number that will never
       exist, and the deal can never read finished. That is exactly what happened on
       2026-08-17: adding the cost step to Flow C (9a96800d, correct for the ECORE pavers,
       whose model is `standard` and whose pallet Blue Sky really does broker) retracted
       sixteen already-fulfilled parcel orders — ANCORE, Hyperice, Airex, Golden Designs,
       Dynamic Cold Therapy — back to an open row with the truck circled.

       ⚠ FAIL-SAFE DIRECTION: an unknown / missing model means TRUE (a cost is owed). The map
       is empty whenever the vendor-worker cross-fetch didn't run (cron bakes carry no auth),
       and "we couldn't look it up" must never silently hide work. Same reasoning as the
       Freight Requested step's applicable-count. */
    function vendorNeedsFreightCost(q, vendor) {
      var sm = String(vendorMapEntry(q && q.vendorShippingModels, vendor) || '');
      if (sm === 'parcel-only' || sm === 'freight-in-product') return false;
      return true;
    }

    // Has freight been requested for this vendor? Literal check — does NOT
    // auto-complete for web-order vendors. Callers that need to display
    // step progress should first filter by vendorNeedsFreightHandshake to
    // get the applicable set, then count via this predicate. The step is
    // hidden entirely from the UI when 0 vendors are applicable.
    function vendorHasFreightRequested(q, vendor) {
      var fqv = (q.freightQuotes || {})[vendor] || {};
      if (fqv.requestedAt) return true;
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — a SKIPPED ask counts as answered here,
         for the same reason the our-carrier clause exists in vendorNeedsFreightHandshake: the
         Purchasing card has already stopped waiting (freightSettled) and Generate PO is live, so a
         progress bar still showing "Freight Requested 0/1" would be describing a step nothing is
         going to take. Deliberately NOT in vendorHasFreightAdded — a skip is the absence of a
         cost, and claiming otherwise would mark the money step done with no money recorded. */
      if (fqv.skippedAt) return true;
      /* CUSTOM_WSFREIGHT_BY_CLAUDE (Ryan 2026-09-02) — and a cost already recorded in the Quote
         Workstation answers the ask too.

         ⛔ THIS IS THE OFFLINE HALF OF THE 2026-08-27 JW-1230-G FIX. That day taught
         `vendorHasFreightAdded` (just below) that `wsFreightVendors` is a real source of a freight
         cost, and settled the PO gate with it. This predicate was left on `lifecycle.freightQuotes`
         alone — so on 44 of the 59 offline sold deals carrying a freight-then-po vendor, the bar
         read "Freight Requested 0/1" permanently, 40 of them with the supplier's number already on
         the deal and folded into GP. RW-1068-B is the case Ryan raised: ECORE $995.08, carrier
         "Go Rocket Shipping" — we brokered it ourselves, ECORE was never going to quote us, and
         the row asked for that quote from May to September.

         📌 Same reasoning the `skippedAt` clause above already uses: a step nothing is going to
         take should not sit there unticked. A recorded cost is strictly stronger evidence than a
         skip — the skip says we stopped waiting, the cost says we got the answer.

         ⚠️ ANY cost counts here, `official` or `estimate` — deliberately looser than
         dashboard-po-lens.js `freightSettled`, which requires `official` before it will release
         Generate PO. Those two gates are asking different questions: the PO gate decides whether
         it is safe to commit money on this number, and an estimate is not good enough for that;
         this bar only reports whether the ask still needs making, and an estimate means somebody
         already made it. RW-1068-B's $995.08 is an estimate, and it is exactly the row that must
         stop asking. */
      var _wsf = vendorMapEntry(q && q.wsFreightVendors, vendor);
      if (_wsf && parseFloat(_wsf.cost) > 0) return true;
      /* END CUSTOM_WSFREIGHT_BY_CLAUDE */
      // CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — also honor a request recorded on a
      // shipping bucket. Bucket mode stores the dims/freight request on the
      // bucket (q.shippingBuckets[*].requestedAt), not freightQuotes[vendor], so
      // a single-bucket broker order showed "Dims Requested" / the To Do 📧 as
      // not-done even though the bucket panel shows it requested. Single-vendor
      // is the supported Flow A shape, so any non-'none' bucket with a
      // requestedAt counts for the order's one vendor.
      var bks = Array.isArray(q.shippingBuckets) ? q.shippingBuckets : [];
      if (bks.some(function (b) { return b && b.requestKind !== 'none' && b.requestedAt; })) return true;
      /* CUSTOM_ORDERDESK_BY_CLAUDE (suggestion fffce82aa9fd, Ryan 2026-09-20) — PACKAGED DIMS WE
         ALREADY HOLD ANSWER THE DIMS ASK, so the step stops describing an email nobody should send.

         📌 The fourth clause on this predicate, and it earns its place the same way the three above
         it did: "a step nothing is going to take should not sit there unticked." `skippedAt` says we
         stopped waiting, a workstation cost says somebody already got the answer — and a stored
         freight profile says we never needed to ask, because the number is in KV.

         ⛔ THIS IS THE HALF THAT WAS MISSING ON SHOP-2037. lib/packaged-dims.js has stamped
         `q.packagedDims` since 2026-09-07 and lib/order-desk-next.js reads it, so the AGENT was
         already told "do not email Legend for dims we hold" — while this strip, the one Ryan
         actually looks at, kept showing Dims Requested. One fact, two readers, and only one of them
         knew. `complete` is true only when EVERY freight-quoted line has a profile carrying L/W/H
         and a weight, so a partly-covered order still owes the vendor an ask and still shows it.

         ⚠️ ROW-LEVEL FACT ON A PER-VENDOR PREDICATE, AND THAT IS SOUND: `complete` requires every
         freight-quoted line on the order to be covered, so it cannot be true for one vendor's lines
         and false for another's. It is deliberately NOT mirrored onto vendorHasFreightAdded — dims
         are not a freight cost, and claiming otherwise would tick the money step with no money. */
      return !!(q && q.packagedDims && q.packagedDims.complete === true);
      /* END CUSTOM_ORDERDESK_BY_CLAUDE */
    }

    // Has the freight cost been entered for this vendor? Same literal
    // semantic as vendorHasFreightRequested.
    function vendorHasFreightAdded(q, vendor) {
      var fqv = (q.freightQuotes || {})[vendor] || {};
      if (fqv.cost != null && !!fqv.receivedAt) return true;
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-17) — freightQuotes is only ONE of the
         three places a real freight cost lands, and it is the one an our-carrier order never
         writes. "Edit cost" on the Purchasing card stores freightOverrides[vendor].cost, and
         the worker folds that straight into financials.freightCost (reassertOurCarrierFreight,
         quote-dashboard.js ~L2984) — so a cost ALREADY counted in GP still read as "Freight
         Added — not done" on both progress surfaces. Bucket-mode saves are the third place. */
      var ov = vendorMapEntry(q && q.freightOverrides, vendor);
      if (ov && ov.cost != null && parseFloat(ov.cost) > 0) return true;
      /* CUSTOM_WSFREIGHT_BY_CLAUDE (Ryan 2026-08-27) - and the FOURTH place: the Quote Workstation's
         own freight section, where a number lands when a rep phones the supplier directly and admin
         types it into the quote rather than running the card's request-and-save handshake.

         ⛔ JW-1230-G IS THE CASE. ECORE quoted $840 and CPTurf $230.12, both already on the deal
         and both already in GP - and the Purchasing card still blocked Generate PO behind "request
         freight first", because it only ever looked at `lifecycle.freightQuotes`. Ryan: *"why is it
         forcing me to request freight before I can send the PO?"* The gate exists to stop a PO
         going out before we know what freight costs. We knew. Twice.

         📌 A cost, not a carrier, is what settles this: whoever ends up moving the goods, the
         number is recorded and the PO is safe to send. `wsFreightVendors` only carries entries with
         a cost > 0 (quote-summary-builder), so presence IS the answer. */
      var wsf = vendorMapEntry(q && q.wsFreightVendors, vendor);
      if (wsf && parseFloat(wsf.cost) > 0) return true;
      /* END CUSTOM_WSFREIGHT_BY_CLAUDE */
      /* Bucket costs are keyed by shipping lane ('broker' / 'parcel'), NOT by vendor, so on a
         multi-vendor order one vendor's cost would satisfy all of them — a false ✓ that could
         let a deal close with an unrecorded cost. Guarded to the single-vendor shape, which is
         the only one bucket mode actually supports. (vendorHasFreightRequested above runs the
         same order-wide .some() unguarded; not copied here because a missed REQUEST is visible
         the moment someone opens the card, while a missed COST is silent and lands in GP.) */
      var _vAll = (q.financials || {}).vendors || [];
      if (_vAll.length > 1) return false;
      var bks = Array.isArray(q.shippingBuckets) ? q.shippingBuckets : [];
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — freightCostAutoFromFlatRate counts
         too. 9a96800d claimed this step "auto-satisfies for a genuine flat-rate vendor"
         because deriveShippingBucketsForQuote pre-fills the bucket from the Vendor Guide's
         shippingFlatRate — but that prefill deliberately leaves `freightCostSet` FALSE
         (quote-dashboard.js ~L467: the flag means "admin confirmed", not "a number is
         present"), so the `freightCostSet &&` above threw the prefilled value away. Airex
         orders carried $9.95 in financials.freightCost and still read Freight Cost — not
         done (SHOP-1702, SHOP-1906). The rate IS the known cost; nothing is owed. */
      return bks.some(function (b) {
        return b && (b.freightCostSet || b.freightCostAutoFromFlatRate) && parseFloat(b.freightCost) > 0;
      });
    }

    // Has this vendor shipped? Different signal source per row type:
    //   Online → vo.shopifyFulfillmentId (set when Mark Fulfilled fires the
    //   fulfillmentCreate mutation against Shopify; updates immediately on
    //   click vs onlineHasTracking which only refreshes on next /rep-quotes).
    //   Offline → carrier + trackingType + tracking all present (matches
    //   the Tracking card's checkbox gate at ~L9723).
    // Self-healing data gate per Ryan 2026-05-20: switched from vo.ordered
    // (which carried both "tracking entered" AND legacy "PO sent" semantics)
    // to a pure data check.
    function vendorIsShipped(q, vendor) {
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-06) — ⛔ RESOLVE THE NAME, NOT THE KEY. The
         Tracking card stores a shipment under whatever name it was keyed by; JW-1227-C carries its
         ABF tracking under "ECORE" while the quote names "ECORE Athletic", so an exact lookup read
         it as unshipped forever. Same class of bug the Ordered step fixed on 2026-09-02, and the
         worker's new shipped gate (lib/closed-gate.js `isVendorShippedForClose`) matches names —
         so this must too, or the ✓ Closed pill and this step disagree on the same row. Exact key
         first, then the same vendorNamesMatch the Ordered step uses. */
      var _ord = q.ordering || {};
      var vo = _ord[vendor];
      if (!vo) {
        for (var _ok in _ord) {
          if (Object.prototype.hasOwnProperty.call(_ord, _ok) && vendorNamesMatch(vendor, _ok)) { vo = _ord[_ok]; break; }
        }
      }
      vo = vo || {};
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-11) — Shopify's own
         fulfillment state is AUTHORITATIVE for online orders. The portal-side
         shopifyFulfillmentId flag only exists when the fulfillment was created
         THROUGH the portal — an order fulfilled directly in Shopify admin (or
         by a vendor app) showed un-shipped here forever (SHOP-1689: closed in
         Shopify, "tracking missing" in the DD). FULFILLED = every line
         fulfilled, so all vendors count as shipped; partial fulfillments
         still rely on the per-vendor portal flag. q.onlineFulfillmentStatus
         is stamped by the worker from displayFulfillmentStatus on every load. */
      if (q && q.source === 'online') {
        return !!vo.shopifyFulfillmentId || q.onlineFulfillmentStatus === 'FULFILLED';
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_DDCARDCOUNT_BY_CLAUDE (AIOPS be87acc13b79, Ryan 2026-09-26 - RW-1317-C) — ⛔ EVERY ROW
         THAT NAMES THIS SUPPLIER, NOT THE FIRST ONE. RW-1317-C carries `ordering["ECORE"]` (dims only)
         beside `ordering["ECORE Athletic"]` (the XPO PRO); exact-key-first stopped at the empty row and
         called ECORE unshipped. The worker's twin (lib/closed-gate.js `isVendorShippedForClose`) has
         always walked every matching row and answered yes if ANY is shipped — this now does the same,
         exact key first, so the two cannot disagree on one row. */
      var _keys = Object.prototype.hasOwnProperty.call(_ord, vendor) ? [vendor] : [];
      for (var _ok2 in _ord) {
        if (_ok2 !== vendor && Object.prototype.hasOwnProperty.call(_ord, _ok2) && vendorNamesMatch(vendor, _ok2)) _keys.push(_ok2);
      }
      for (var _ki = 0; _ki < _keys.length; _ki++) {
        if (vendorRowIsShipped(q, _ord[_keys[_ki]] || {}, _keys[_ki])) return true;
      }
      return false;
    }

    /* One stored ordering row, offline: is its shipment out? `voKey` is the key it is stored under,
       which is what its customer marker is keyed by. */
    function vendorRowIsShipped(q, vo, voKey) {
      /* END CUSTOM_DDCARDCOUNT_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — shippedNoTracking marks a
         shipment fulfilled with no tracking (pickup / tracking unavailable), so
         it counts as shipped without carrier+type+number. */
      if (vo.shippedNoTracking) return true;
      if (!(vo.carrier && vo.trackingType && vo.tracking)) return false;
      /* CUSTOM_EARLYSTAMP_BY_CLAUDE (AIOPS fb2ebf0cafb8, Ryan 2026-09-21) — ⛔ A PRO STAMPED ON
         BOOK DAY IS NOT "SHIPPED" WHILE THE PICKUP FLOOR STILL HOLDS THE CUSTOMER'S NOTICE.
         RW-1297-E: the agent stamped the PRO the morning the pickup was booked (the house rule
         allows that) and this predicate ticked the card header ✓, the Shipped step, the To-Do 📦
         and collapsed the card - a "done" the customer had not been told about. TWIN of the
         worker's `isVendorShippedForClose` veto (lib/closed-gate.js, `earlyStampVeto`); they
         MUST stay in step or the ✓ Closed pill and this step disagree on one row. */
      return !vendorEarlyStampVeto(q, vo, voKey);
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_EARLYSTAMP_BY_CLAUDE (AIOPS fb2ebf0cafb8, Ryan 2026-09-21) — the veto, client side.
       True while the row carries a booked pickup nobody has confirmed, no customer marker on the
       row or on q.customerShippingEmails, and the pickup floor (lib/pickup-notice-hold.js: the
       customer is not told on the day the truck is only due; the notice opens at 6 AM Mountain
       on the day AFTER the booked pickup) is still in force. The date walk is UTC-midnight
       arithmetic and the wall clock is read in America/Denver, so DST cannot skip a day.
       `nowMs` is a test seam. A row with no pickup date is never vetoed - the hold is not
       fail-closed, on purpose (see that lib's header). */
    function vendorEarlyStampVeto(q, vo, vendorKey, nowMs) {
      vo = vo || {};
      if (!vo.pickupScheduledFor || vo.pickupConfirmedAt || vo.customerNotifiedAt) return false;
      var _cse = ((q && q.customerShippingEmails) || {})[vendorKey] || {};
      if (_cse.at) return false;
      var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(vo.pickupScheduledFor || '').trim());
      if (!m) return false;
      var releaseOn = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]) + 86400000).toISOString().slice(0, 10);
      var now = new Date(nowMs == null ? Date.now() : nowMs);
      var parts = {};
      try {
        new Intl.DateTimeFormat('en-US', { timeZone: 'America/Denver', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
          .formatToParts(now).forEach(function (p) { parts[p.type] = p.value; });
      } catch (_) { return false; }
      var todayMt = parts.year + '-' + parts.month + '-' + parts.day;
      var hourMt = parseInt(parts.hour, 10) % 24;
      if (todayMt < releaseOn) return true;
      return todayMt === releaseOn && hourMt < 6;
    }
    /* END CUSTOM_EARLYSTAMP_BY_CLAUDE */

    function isVendorAllBucketsPurchased(q, vendor) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Direct-purchased
         vendors (bought online via portal/discount code, no formal PO)
         carry no q.pos record. Check ordering[vendor].purchasedDirectly
         first so the Ordered progress step counts them. The Tracking
         card row keeps using ord.ordered as its "shipped" signal — that
         flag stays false until tracking is actually entered. */
      var vo = (q.ordering || {})[vendor] || {};
      if (vo.purchasedDirectly === true) return true;
      var allPos = (q.pos || []).filter(function (p) {
        return p && p.status !== 'voided' && vendorNamesMatch(vendor, p.vendor);
      });
      if (allPos.length === 0) return false;
      var hasBuckets = Array.isArray(q.shippingBuckets) && q.shippingBuckets.length > 0;
      // Only enforce the per-bucket check when at least one PO is
      // bucket-tagged (i.e., admin actually used the bucket workflow on
      // this order). Legacy POs generated before the bucket feature
      // shipped — or via the legacy single-PO Purchasing card path —
      // carry no `bucket` field. Without this fallback, those orders'
      // PO Sent step would never flip ✓ even after admin clearly sent
      // the PO (SHOP-1663 class of regression).
      var anyBucketTagged = allPos.some(function (p) { return !!p.bucket; });
      if (hasBuckets && anyBucketTagged) {
        /* CUSTOM_ALTSHIP_BY_CLAUDE (Ryan 2026-10-09) - on an order where a bucket is shared with an alternate
           source, a supplier owes a PO only in the buckets it ships in (a shared bucket lists its suppliers; one
           without the list is the brand's alone). With no shared bucket every bucket counts, as before. */
        var _anyShared = q.shippingBuckets.some(function (b) { return b && Array.isArray(b.suppliers); });
        var _isAltV = !!(q.altSourceSummary && q.altSourceSummary.rows && Object.keys(q.altSourceSummary.rows).some(function (k) { return vendorNamesMatch(k, vendor); }));
        var _myBuckets = _anyShared ? q.shippingBuckets.filter(function (b) {
          return Array.isArray(b.suppliers)
            ? b.suppliers.some(function (e) { return e && vendorNamesMatch(e.vendor || '', vendor); })
            : !_isAltV;
        }) : q.shippingBuckets;
        // Each derived bucket needs its own sent/downloaded PO.
        return _myBuckets.every(function (b) {
          var bucketPos = allPos.filter(function (p) { return p.bucket === b.id; });
          return bucketPos.some(function (p) { return p.status === 'sent' || !!p.downloadedAt; });
        });
      }
      // Legacy / non-bucket order: any sent/downloaded PO satisfies.
      return allPos.some(function (p) { return p.status === 'sent' || !!p.downloadedAt; });
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-28) — Relabel the progress-
       tracker "PO Sent" step → "Purchased" when no PO was actually sent
       on any vendor (i.e., every vendor was Marked Purchased directly).
       Mixed orders (some PO, some direct) keep "PO Sent" since the label
       is still accurate for the PO ones. */
    function allVendorsPurchasedDirectly(q) {
      var vendors = (q.financials || {}).vendors || [];
      if (vendors.length === 0) return false;
      var ord = q.ordering || {};
      return vendors.every(function (v) { return (ord[v] || {}).purchasedDirectly === true; });
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // isFreightBalanced — Fulfillment-phase rollup for bucket-mode orders.
    // Captures whether the WHOLE pre-ship workflow is wrapped up — drives
    // the Fulfillment card header checkmark, the ⚖ emoji's done state in
    // the To-Do strip, the panel-bar Freight Balanced step, and the
    // auto-collapse rule for the card. Per Ryan 2026-05-15: must reflect
    // everything in the Fulfillment card being done, not just the
    // accounting subset — otherwise ⚖ would flip full-circle while the
    // broker bucket still has an unsent PO inside the card.
    //
    // Gates (every one must pass for true):
    //   1. Every bucket has an explicit freight cost (positive or
    //      explicitly-set zero — admin closed out as "vendor didn't bill")
    //   2. Dims recorded (if any dims-kind bucket exists)
    //   3. Every bucket has at least one non-voided PO that's sent or
    //      downloaded (added 2026-05-15)
    //   4. Linked balance reconciliation balanced (if balanceChildren)
    //
    // For non-bucket orders this returns true (no balance concept applies)
    // so existing flows aren't gated.
    /* CUSTOM_WILLCALL_BY_CLAUDE (Ryan 2026-09-17) — the customer is collecting this bucket, so it
       has no freight to quote, no dims to ask for and no carrier to chase. ⛔ Its PO still goes
       out: what changes is the shipping, not the buying.
       ⚠️ MIRRORED, deliberately — lib/online-todo.js carries the identical predicate server-side
       and the two must not drift, or the To Do strip and the progress bar disagree about the same
       order. Change one, change the other. */
    function bucketIsWillCall(b) { return !!b && String(b.requestKind || '') === 'will-call'; }
    function isBucketFullyDone(b, q) {
      /* ⛔ A WILL-CALL BUCKET CAN NEVER SATISFY A FREIGHT-COST GATE, because no freight cost is
         ever coming — and a gate nothing can satisfy is an order that never closes. Same carve-out
         `dimsNa` already makes one branch down, for the same reason. */
      if (!bucketIsWillCall(b) && !(!!b.freightCostSet || parseFloat(b.freightCost) > 0)) return false;
      var bPosSent = (q.pos || []).some(function (p) {
        return p && p.status !== 'voided' && p.bucket === b.id && (p.status === 'sent' || !!p.downloadedAt);
      });
      if (!bPosSent) return false;
      /* CUSTOM_ALTSHIP_BY_CLAUDE (Ryan 2026-10-09, SHOP-2128) - a bucket shared by a brand and its alternate
         source is done only when EACH supplier's shipment is: its own freight cost and a sent PO of its own.
         One supplier's sent PO used to mark the whole bucket done. No `suppliers` = the rule above, unchanged. */
      if (Array.isArray(b.suppliers) && b.suppliers.length) {
        var allSup = b.suppliers.every(function (e) {
          if (!e) return true;
          if (!bucketIsWillCall(e) && !(!!e.freightCostSet || parseFloat(e.freightCost) > 0)) return false;
          return (q.pos || []).some(function (p) {
            return p && p.status !== 'voided' && p.bucket === b.id && (p.status === 'sent' || !!p.downloadedAt)
              && (vendorNamesMatch(e.vendor, p.vendor || '') || vendorNamesMatch(e.vendor, p.poVendor || ''));
          });
        });
        if (!allSup) return false;
      }
      return true;
    }
    function isFreightBalanced(q) {
      var hasBuckets = Array.isArray(q.shippingBuckets) && q.shippingBuckets.length > 0;
      if (!hasBuckets) return true;
      // 1. Every bucket has freight cost + 3. PO sent — combined per-bucket gate.
      var allBucketsDone = q.shippingBuckets.every(function (b) { return isBucketFullyDone(b, q); });
      if (!allBucketsDone) return false;
      // 2. Any dims-kind bucket needs dims recorded.
      var anyDimsKindBucket = q.shippingBuckets.some(function (b) {
        return b.requestKind === 'dims' || (!b.requestKind && b.type === 'broker');
      });
      if (anyDimsKindBucket) {
        var fb = q.freightBalance || {};
        var dimsObj = (fb.dims && typeof fb.dims === 'object') ? fb.dims : null;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-16) — dims marked N/A (supplier
           shipped on their own carrier, no dims forthcoming) satisfies the gate
           the same as real dims, so the order can close out. */
        var dimsNa = !!(dimsObj && dimsObj.na);
        var dimsRaw = dimsObj ? (dimsObj.raw || '') : (fb.dims || '');
        /* CUSTOM_ORDERDESK_BY_CLAUDE (suggestion fffce82aa9fd, Ryan 2026-09-20) — a stored freight
           profile covering every freight-quoted line satisfies this gate too. Same carve-out shape
           as `dimsNa` right above, and the same reason: a gate nothing can satisfy is an order that
           never closes. Without this the strip's 📧 would tick (the predicate above) while ⚖ stayed
           stuck waiting for a human to retype dims we already hold. */
        var dimsHeld = !!(q && q.packagedDims && q.packagedDims.complete === true);
        if (!dimsNa && !dimsHeld && (!dimsRaw || !String(dimsRaw).trim().length)) return false;
      }
      /* CUSTOM_ALTSHIP_BY_CLAUDE - an alternate source's weight/dims shipment needs ITS dims (or N/A); the
         brand's are the order-level ones checked above. */
      var altDimsMissing = q.shippingBuckets.some(function (b) {
        return Array.isArray(b.suppliers) && b.suppliers.some(function (e) {
          if (!e || e.isBrand || e.requestKind !== 'dims') return false;
          var d = e.dims;
          var dOk = d && (typeof d === 'object' ? !!(d.na || (d.raw && String(d.raw).trim())) : !!String(d).trim());
          return !dOk && !(q && q.packagedDims && q.packagedDims.complete === true);
        });
      });
      if (altDimsMissing) return false;
      // 4. Linked balance child requires the reconciliation to be balanced.
      if (Array.isArray(q.balanceChildren) && q.balanceChildren.length > 0) {
        if (!q.balanceReconciliation || q.balanceReconciliation.balanced !== true) return false;
      }
      return true;
    }

    // Compute the 5-step status strip for online orders. Per-vendor state is
    // aggregated: every vendor must hit a step before the strip flips it to
    // done. The strip shape is identical across flows (5 slots, same width)
    // so the To Do column visually scans consistently — only the middle slot
    // changes per flow:
    //   Flow B  💳 → 📧 → 🚚 → 📋 → 📦         (charged in full at checkout incl. freight estimate)
    //   Flow A  💳 → 📧 → 💵 → 📋 → 📦 → ⚖    (paid for goods + small flat freight; balance owed
    //                                              once we quote with our broker — 💵 = balance paid;
    //                                              ⚖ = freight balanced — final costs + dims captured)
    //   Flow C  💳 → 📋 → 📦                    (flat-rate freight at checkout, no handshake — 3 slots)
    //
    // Helpers shared by all flows.
    function buildOnlineFlowVendorState(q) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — All per-vendor counts
         use shared predicates so this surface (To Do column emoji strip)
         can never disagree with getProgressSteps (status tracker bar) or
         the Tracking card. Predicates defined near isVendorAllBuckets
         Purchased.
         freightApplicableCount = vendors that NEED the freight handshake
         (excludes web-order). Used as denominator for "Freight Requested"
         partial fraction so the step shows real progress against the set
         of vendors that actually need it. Step is hidden entirely when 0.
         Freight Added uses vendorCount as denominator since freight cost
         can be entered retroactively for any vendor including web-order. */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — ...except when the vendor has no
         freight bill to begin with. costApplicableCount is the vendorNeedsFreightCost set,
         and it is BOTH the denominator and the filter on the numerator — counting a
         non-applicable vendor as "added" would let one parcel-only vendor satisfy the step
         for a standard-shipping sibling on the same order. Step hides when the set is 0,
         mirroring Freight Requested one line up. */
      var vendors = (q.financials || {}).vendors || [];
      var freightApplicableCount = 0, freightReqCount = 0, freightAddCount = 0, poSentCount = 0, shippedCount = 0;
      var costApplicableCount = 0, costAddedCount = 0;
      vendors.forEach(function (v) {
        if (vendorNeedsFreightHandshake(q, v)) freightApplicableCount++;
        if (vendorHasFreightRequested(q, v))   freightReqCount++;
        if (vendorHasFreightAdded(q, v))       freightAddCount++;
        if (isVendorAllBucketsPurchased(q, v)) poSentCount++;
        if (vendorIsShipped(q, v))             shippedCount++;
        if (vendorNeedsFreightCost(q, v)) {
          costApplicableCount++;
          if (vendorHasFreightAdded(q, v)) costAddedCount++;
        }
      });
      return {
        vendorCount: vendors.length || 1,
        freightApplicableCount: freightApplicableCount,
        freightReqCount: freightReqCount,
        freightAddCount: freightAddCount,
        costApplicableCount: costApplicableCount,
        costAddedCount: costAddedCount,
        poSentCount: poSentCount,
        shippedCount: shippedCount,
      };
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }

    /* CUSTOM_ORDERDESK_BY_CLAUDE (suggestion fffce82aa9fd, Ryan 2026-09-20) — SAY WHY THE STEP IS
       TICKED, AND HOW GOOD THE NUMBER IS.

       Ryan: "we need to know when one is vendor confirmed vs estimated … but estimated ones can't
       stop us from working." So the dims step never blocks on provenance — it relabels:

         Dims Requested            we emailed the supplier (unchanged, and it still wins)
         📦 Dims On File           a vendor sheet / measured profile covers every line
         📦 Dims On File ±10%      a Blue Sky estimate covers them; the band is the profile's own

       ⛔ AN ACTUAL ASK OUTRANKS A HELD PROFILE. If somebody already emailed the supplier, the step
       must keep saying so — relabelling it "On File" would erase the fact that a reply is owed and
       is on the SLA clock. This only renames the case where the step is ticked BECAUSE we hold the
       numbers and nobody asked anyone anything.

       ⚠️ THE ± IS A WEIGHT BAND, NEVER A DIMENSION ONE (lib/freight-profile.js: a buffer on dims
       moves the density class invisibly and cannot be explained on a BOL). Do not let this string
       grow into "±10% dims" — it would read as box tolerance and it is not. */
    function labelHeldDims(q, step) {
      var pd = q && q.packagedDims;
      if (!step || !pd || pd.complete !== true) return step;
      var askedAnyway = (Array.isArray(q.shippingBuckets) ? q.shippingBuckets : []).some(function (b) {
        return b && b.requestKind !== 'none' && b.requestedAt;
      }) || Object.keys(q.freightQuotes || {}).some(function (k) {
        var f = (q.freightQuotes || {})[k] || {}; return !!(f.requestedAt || f.dimsRequestedAt);
      });
      if (askedAnyway) return step;
      var band = pd.estimated && pd.bufferPct ? ' ±' + pd.bufferPct + '%' : '';
      return Object.assign({}, step, {
        emoji: '📦',
        label: 'Dims On File' + band,
        done: true,
        partial: 0,
        partialText: '',
        heldDims: true,
        dimsEstimated: !!pd.estimated,
      });
    }
    /* END CUSTOM_ORDERDESK_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Generic per-vendor emoji step builder.
       Returns done + partial fraction so multi-vendor orders render a
       proportional ring (e.g., 1 of 3 vendors freight-quoted → 33% ring).
       Mirrors vendorStep() used on the panel bar, but emits `emoji` for the
       To Do strip render. */
    function vendorStepEmoji(emoji, label, count, total) {
      var done = total > 0 && count === total;
      var partial = (!done && total > 1 && count > 0) ? (count / total) : 0;
      return {
        emoji: emoji,
        label: label,
        done: done,
        partial: partial,
        partialText: partial ? (count + '/' + total) : '',
      };
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Bucket-aware step builder for SHOP-1681
       class orders (single-vendor / multi-bucket). For PO Sent uses sent
       PO matching bucket id; for Freight Requested / Freight Added counts
       bucket.requestedAt or bucket.freightCost > 0 among buckets where the
       request kind isn't 'none'. Returns null when bucket-aware mode
       doesn't apply (caller falls back to vendorStepEmoji). */
    function bucketAwareStepEmoji(q, s, kind) {
      var bks = Array.isArray(q.shippingBuckets) ? q.shippingBuckets : [];
      if (!(s.vendorCount === 1 && bks.length > 1)) return null;
      var emoji = '', label = '';
      var sent = 0, total = bks.length;
      if (kind === 'po') {
        emoji = '📋'; label = 'PO Sent';
        for (var bi = 0; bi < bks.length; bi++) {
          var bp = (q.pos || []).filter(function (p) {
            return p && p.status !== 'voided' && p.bucket === bks[bi].id;
          });
          if (bp.some(function (p) { return p.status === 'sent' || !!p.downloadedAt; })) sent++;
        }
      } else if (kind === 'freight-requested' || kind === 'dims-requested') {
        emoji = kind === 'dims-requested' ? '📧' : '📧';
        label = kind === 'dims-requested' ? 'Dims Requested' : 'Freight Requested';
        /* Only count buckets that actually need a request. `none` never did; `will-call` joins it
           (CUSTOM_WILLCALL_BY_CLAUDE, Ryan 2026-09-17) — counting a bucket nobody will ever email
           leaves this step reading 1/2 for the life of the order. Mirrored in lib/online-todo.js. */
        var applicable = bks.filter(function (b) {
          var _k = (b.requestKind || (b.type === 'broker' ? 'dims' : 'freight'));
          return _k !== 'none' && _k !== 'will-call';
        });
        total = applicable.length || 1;
        for (var bj = 0; bj < applicable.length; bj++) {
          if (applicable[bj].requestedAt) sent++;
        }
      } else if (kind === 'freight-added') {
        emoji = '🚚'; label = 'Freight Cost';
        for (var bk = 0; bk < bks.length; bk++) {
          if (parseFloat(bks[bk].freightCost) > 0) sent++;
        }
      } else if (kind === 'shipped') {
        emoji = '📦'; label = 'Shipped';
        for (var bs = 0; bs < bks.length; bs++) {
          if (bks[bs] && bks[bs].shipping && bks[bs].shipping.fulfillmentId) sent++;
        }
      } else {
        return null;
      }
      var done = sent === total && total > 0;
      var partial = (!done && total > 1 && sent > 0) ? (sent / total) : 0;
      return {
        emoji: emoji,
        label: label,
        done: done,
        partial: partial,
        partialText: partial ? (sent + '/' + total) : '',
      };
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    function vendorPayState(q, vendor, match) {
        var owed = (q.supplierPay || []).some(function (r) { return r && match(vendor, r.vendor); });
        var settled = (q.supplierPaid || []).some(function (r) { return r && match(vendor, r.vendor); });
        return { applicable: owed || settled, paid: settled && !owed };
      }

      /* CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE (Ryan 2026-09-13) — 💵 VENDOR PAID, its own step rather
         than a second meaning for 🛒. Ryan asked whether the purchase step could fill half on the
         order and half on the payment; every step on this strip answers ONE question and its fraction
         always means "N of M vendors have done THIS", so a half-full 🛒 would be ambiguous between one
         of two vendors ordered and one vendor ordered-but-unpaid.
         ⛔ THE DENOMINATOR IS VENDORS WE OWE OR OWED, never every vendor - a vendor with no pay row
         has no OPEN row either, so counting all of them would tick this for a deal that never sent a
         purchase order and, worse, for one whose pay ledger failed to load. Returns null when the set
         is empty, so the step is HIDDEN rather than finished - the `freightApplicableCount` rule.
         ⚠️ `vendorNamesMatch` is already one of the three helpers injected into this span; passing it
         down keeps the outer-reference count where the parity test expects it. */
      function buildVendorPaidStepEmoji(q, s) {
        var vendors = (q.financials || {}).vendors || [];
        var applicable = 0, paid = 0;
        vendors.forEach(function (v) {
          var st = vendorPayState(q, v, vendorNamesMatch);
          if (st.applicable) { applicable++; if (st.paid) paid++; }
        });
        if (applicable === 0) return null;
        return vendorStepEmoji('💵', 'Vendor Paid', paid, applicable);
      }

      function buildPoSentStepEmoji(q, s) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-28) — To-do strip mirrors
         the panel bar's label swap: when every vendor was Marked Purchased
         directly, emoji becomes 🛒 + label "Purchased" (matches the deal-
         feed direct-purchase chip). Mixed/all-PO keeps 📋 + "PO Sent". */
      return bucketAwareStepEmoji(q, s, 'po')
        || (allVendorsPurchasedDirectly(q)
            ? vendorStepEmoji('🛒', 'Purchased', s.poSentCount, s.vendorCount)
            : vendorStepEmoji('📋', 'PO Sent', s.poSentCount, s.vendorCount));
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }

    function buildOnlineFlowBSteps(q) {
      var s = buildOnlineFlowVendorState(q);
      var steps = [{ emoji: '💳', label: 'Customer Paid', done: true }];
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Hide Freight Requested
         entirely when 0 vendors need the handshake (e.g. SHOP-1716 where the
         only vendor is web-order). Use freightApplicableCount as denominator
         so multi-vendor deals show meaningful progress against just the
         vendors that need it. Freight Added stays — web-order vendors can
         have retroactive freight cost entered via the Mark Web Purchased
         popover. */
      if (s.freightApplicableCount > 0) {
        steps.push(bucketAwareStepEmoji(q, s, 'freight-requested') || vendorStepEmoji('📧', 'Freight Requested', s.freightReqCount, s.freightApplicableCount));
      }
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — hide Freight Cost when no vendor
         on the order has a freight bill (parcel-only / freight-in-product). See
         vendorNeedsFreightCost. Same shape as the Freight Requested hide above. */
      if (s.costApplicableCount > 0) {
        steps.push(bucketAwareStepEmoji(q, s, 'freight-added') || vendorStepEmoji('🚚', 'Freight Cost', s.costAddedCount, s.costApplicableCount));
      }
      steps.push(buildPoSentStepEmoji(q, s));
          var _vpStep = buildVendorPaidStepEmoji(q, s);
          if (_vpStep) steps.push(_vpStep);
      steps.push(bucketAwareStepEmoji(q, s, 'shipped') || vendorStepEmoji('📦', 'Shipped', s.shippedCount, s.vendorCount));
      return steps;
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }

    // Flow A: customer paid for the goods + a small flat-rate shipping bucket
    // at checkout (only on non-freight-quoted items). For the freight-quoted
    // items (large rolls etc.) the rep emails the supplier for weight/dims,
    // gets a broker quote, generates a separate FREIGHT-{ref} draft order,
    // and emails the customer the payment link. Once paid, the rest mirrors
    // Flow B (PO → ship).
    //   📧 Freight Requested — first dims-request email fired (lifecycle.freightQuotes[v].requestedAt)
    //   💵 Balance Paid     — lifecycle.balanceCollected.paid (set by webhook OR manual mark)
    function buildOnlineFlowASteps(q) {
      var s = buildOnlineFlowVendorState(q);
      // Balance "paid" auto-detects three paths (matches the Freight
      // Balance card + the Flow A PO gate):
      //   1. lifecycle.balanceCollected.paid — normal Flow A invoice flow
      //   2. q.balanceChildren — admin linked a separate Shopify order
      //      (Link Balance Order) that IS the freight payment
      //   3. lifecycle.freightBalance.handledExternally — explicit admin override
      var hasLinkedChild = Array.isArray(q.balanceChildren) && q.balanceChildren.length > 0;
      var handledExt = !!(q.freightBalance && q.freightBalance.handledExternally);
      var balancePaid = !!(q.balanceCollected && q.balanceCollected.paid) || hasLinkedChild || handledExt;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Step order matches
         the new card render order (Fulfillment before Tracking). Freight
         Balanced is Fulfillment-card content and is pushed BEFORE Shipped
         (Tracking-card content) when bucket panels are active, so the
         strip reads contiguous: Paid / Dims / Balance / PO / Freight
         Balanced / Shipped. Legacy invoiced Flow A orders (no buckets)
         skip the Freight Balanced step entirely and keep Shipped last. */
      var _useBucketPanels = Array.isArray(q.shippingBuckets) && q.shippingBuckets.length > 0;
      var steps = [{ emoji: '💳', label: 'Customer Paid', done: true }];
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Hide Dims/Freight
         Requested step when 0 vendors need handshake (e.g. all web-order).
         Denominator uses freightApplicableCount when shown. */
      if (s.freightApplicableCount > 0) {
        steps.push(labelHeldDims(q, bucketAwareStepEmoji(q, s, 'dims-requested') || vendorStepEmoji('📧', 'Freight Requested', s.freightReqCount, s.freightApplicableCount)));
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      steps.push({ emoji: '💵', label: 'Balance Paid', done: balancePaid });
      steps.push(buildPoSentStepEmoji(q, s));
          var _vpStep = buildVendorPaidStepEmoji(q, s);
          if (_vpStep) steps.push(_vpStep);
      if (_useBucketPanels) {
        // ⚖ Freight Balanced — Fulfillment-card summary. Pushed BEFORE
        // Shipped on bucket-mode orders so the Fulfillment cluster is
        // contiguous, with the Tracking-card Shipped step landing last.
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Partial state
           based on per-bucket Fulfillment-phase completeness (cost
           finalized + PO sent). Matches the panel-bar partial above
           and the tightened isFreightBalanced gates so ⚖ stays partial
           when a bucket still has work pending inside the Fulfillment
           card. `done` requires the order-level gates on top. */
        var _bksBalEmoji = 0;
        for (var _bbei = 0; _bbei < q.shippingBuckets.length; _bbei++) {
          if (isBucketFullyDone(q.shippingBuckets[_bbei], q)) _bksBalEmoji++;
        }
        var _bksBalEmojiTotal = q.shippingBuckets.length;
        var _allBalancedEmoji = isFreightBalanced(q);
        var _balPartialEmoji = (!_allBalancedEmoji && _bksBalEmoji > 0 && _bksBalEmojiTotal > 1)
          ? _bksBalEmoji / _bksBalEmojiTotal
          : 0;
        steps.push({
          emoji: '⚖️',
          label: 'Freight Balanced',
          done: _allBalancedEmoji,
          partial: _balPartialEmoji,
          partialText: _balPartialEmoji ? (_bksBalEmoji + '/' + _bksBalEmojiTotal) : '',
        });
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      }
      steps.push(bucketAwareStepEmoji(q, s, 'shipped') || vendorStepEmoji('📦', 'Shipped', s.shippedCount, s.vendorCount));
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      return steps;
    }

    // Flow C: freight already collected at checkout, no supplier handshake.
    // Tightest path — four steps. Renders as a 4-emoji strip (NOT padded to
    // 5 slots) so it visually reads as "less to do" — which is correct for
    // Flow C.
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-17) — 🚚 Freight Added joins the strip,
       mirroring the panel bar's new Flow C branch (getProgressSteps ~L6491). The two
       surfaces are read back by isOnlineRowResolved to decide "✓ Fulfilled", so they have
       to carry the same steps or a Flow C row would claim to be finished on one surface
       while the other still shows work. Rationale for the step itself is on that branch. */
    function buildOnlineFlowCSteps(q) {
      var s = buildOnlineFlowVendorState(q);
      var steps = [{ emoji: '💳', label: 'Customer Paid', done: true }];
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — and it drops back off for the
         vendors that never had a freight bill. Flow C is reached two ways: the
         `flat-rate-shipping` product tag (the ECORE pavers, where the cost step is the whole
         point) and a shippingModel demotion in normalizeOnlineOrders (parcel-only /
         freight-in-product / flat-rate — where it is not). Undifferentiated, the step
         un-fulfilled every parcel order on the board. See vendorNeedsFreightCost. */
      if (s.costApplicableCount > 0) {
        steps.push(bucketAwareStepEmoji(q, s, 'freight-added') || vendorStepEmoji('🚚', 'Freight Cost', s.costAddedCount, s.costApplicableCount));
      }
      steps.push(buildPoSentStepEmoji(q, s));
          var _vpStep = buildVendorPaidStepEmoji(q, s);
          if (_vpStep) steps.push(_vpStep);
      steps.push(bucketAwareStepEmoji(q, s, 'shipped') || vendorStepEmoji('📦', 'Shipped', s.shippedCount, s.vendorCount));
      return steps;
    }

    // Dispatcher: pick the right step builder by flow.
    function buildOnlineFlowSteps(q) {
      var flow = q.onlineFlow || '';
      var steps = (flow === 'A') ? buildOnlineFlowASteps(q)
                : (flow === 'C') ? buildOnlineFlowCSteps(q)
                : buildOnlineFlowBSteps(q);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Phase 3.5 Phase 1.5:
         Append $ Commission step to the TO DO emoji strip when commission
         is owed (rep earns + amount > 0). Done when paid, pending when
         outstanding. Hidden entirely when no commission applies — keeps
         the strip compact for orders without rep attribution. */
      if (q.repEarnsCommission !== false && parseFloat(q.commissionAmount || 0) > 0) {
        steps.push({ emoji: '💵', label: 'Commission', done: !!q.commissionPaid });
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      return steps;
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — "is this online row finished?", answered
       with the SAME logic the To Do column renders. That column shows either a ✗ Cancelled pill
       (q.cancelled, which a full refund now also sets) or a ✓ Fulfilled pill when every flow
       step is done — so reading it back through buildOnlineFlowSteps is what guarantees the cut
       below can never disagree with what the rep is looking at.

       ⚠ THIS IS DELIBERATELY *NOT* SHOPIFY'S displayFulfillmentStatus, which disagrees in both
       directions: SHOP-1743 was FULFILLED in Shopify while the DD correctly showed it open (its
       PO was never recorded as sent), and sample orders sit UNFULFILLED in Shopify forever
       (the worker excludes them via -tag:sample-request, so they are not even rows here).
       Ryan, 2026-08-12: the DD's own last open deal was SHOP-1866 (7-20), months later than
       Shopify's oldest unfulfilled order suggested. */
    function isOnlineRowResolved(q) {
      if (!q) return false;
      if (q.cancelled) return true;
      var steps = buildOnlineFlowSteps(q);
      return steps.length > 0 && steps.every(function (s) { return s.done; });
    }
    /* ONLINE-TODO-TWIN:END */

    /* The row's own date, matching what the worker derives for online rows (onlineProcessedAt →
       createdAt, see mergeLiveOntoSummary). 0 when unparseable, which the cut treats as "keep". */
    function onlineRowTimeMs(q) {
      var raw = (q && (q.onlineProcessedAt || q.dateSold || q.createdAt)) || '';
      var t = Date.parse(raw);
      return isNaN(t) ? 0 : t;
    }

    /**
     * Trim the Online Deals list to everything from the EARLIEST still-open deal forward.
     *
     * Cuts by DATE, not by position, so it survives re-sorting — a positional "drop everything
     * after index N" would mean something completely different the moment the rep sorts by
     * total or customer.
     *
     * ⚠ TWO FAIL-SAFES, both of the same kind: never hide open work.
     *   1. Nothing open in the loaded set → return everything untouched. Cutting at "the oldest
     *      open deal" when there ISN'T one would blank the table, and on a page where every row
     *      happens to be finished the honest answer is to show them.
     *   2. Rows with an unparseable date are always kept, rather than assumed old.
     *
     * @param {Array} rows
     * @returns {Array} rows from the oldest open deal forward
     */
    function applyOpenDealCut(rows) {
      _olderCompletedHidden = 0;
      if (!currentHideOlderCompleted) return rows;
      if (currentSource !== 'online') return rows;
      if (!Array.isArray(rows) || rows.length === 0) return rows;

      var oldestOpen = null;
      for (var i = 0; i < rows.length; i++) {
        if (isOnlineRowResolved(rows[i])) continue;
        var t = onlineRowTimeMs(rows[i]);
        if (t && (oldestOpen === null || t < oldestOpen)) oldestOpen = t;
      }
      if (oldestOpen === null) return rows;   // fail-safe 1

      var kept = rows.filter(function (q) {
        var t = onlineRowTimeMs(q);
        return !t || t >= oldestOpen;         // fail-safe 2
      });
      _olderCompletedHidden = rows.length - kept.length;
      return kept;
    }

    /* Reflect the trim in the toggle's label so hidden rows are never a silent omission — the
       count IS the affordance that tells you there is more behind the checkbox. */
    function syncOlderCompletedToggle() {
      var wrap = document.getElementById('rqd-source-older-completed');
      if (wrap) {
        wrap.style.display = (currentSource === 'online') ? '' : 'none';
      }
      var countEl = document.getElementById('rqd-older-completed-count');
      if (countEl) {
        countEl.textContent = (currentHideOlderCompleted && _olderCompletedHidden > 0)
          ? '(' + _olderCompletedHidden + ' hidden)'
          : '';
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-17) — the To Do cell's fill percentage for one
       deal, factored out of buildProgressBar so a LINKED CHILD can render its PARENT's number
       without a second copy of the maths. Partial steps count their own fraction (a 50/50 deal
       with the deposit paid is genuinely part-done), which is why this is not simply
       done/total. */
    function progressFillPct(q) {
      if (!q) return 0;
      var _st = getProgressSteps(q);
      if (!_st.length) return 0;
      var _u = 0;
      for (var _i = 0; _i < _st.length; _i++) {
        if (_st[_i].done) _u += 1;
        else if (_st[_i].partial > 0) _u += _st[_i].partial;
      }
      return Math.round((_u / _st.length) * 100);
    }

    function buildProgressBar(q) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Build the follow-up
         element HTML for SOLD/CLOSED rows. Mirrors the QUOTED-row
         follow-up countdown/bell shape at L4702-4727 but with the `sold`
         tooltip variant. Colour comes from the CSS rule
         `.rqd-row--sold .rqd-remaining--followup` (green) — every
         SOLD/CLOSED tr carries the rqd-row--sold class.
         Returns { html, expired } so callers can decide layout (CLOSED
         pill uses `expired` to switch between space-between and
         centered with-bell layouts). */
      function _buildSoldFollowUpHtml(q) {
        if (!q.followUp || !q.followUp.dueAt) return { html: '', expired: false };
        var dateLabel = formatFollowUpDate(q.followUp.dueAt);
        var expired = isFollowUpExpired(q.followUp.dueAt);
        var title = (expired
          ? 'Follow-up due: ' + esc(dateLabel) + ' (' + esc(q.followUp.dueAt) + ')'
          : 'Follow up: ' + esc(dateLabel) + ' (' + esc(q.followUp.dueAt) + ')')
          + (q.followUp.setBy ? ' · set by ' + esc(q.followUp.setBy) : '')
          + (q.followUp.reason ? ' — ' + esc(q.followUp.reason) : '');
        var cls = 'rqd-remaining rqd-remaining--followup rqd-followup-countdown rqd-tip-trigger'
          + (expired ? ' rqd-followup-countdown--expired' : '');
        var inner = expired
          ? '<span class="rqd-followup-bell" aria-label="Follow-up due">🔔</span>'
          : '<span class="rqd-followup-countdown__text">' + esc(formatHoldCountdown(q.followUp.dueAt)) + '</span>';
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — Clicking a SOLD deal's reminder
           (countdown or bell) opens a confirm popup to clear it (deal stays sold, no new
           countdown). data-sold-fu-clear routes the click to the confirm modal instead
           of the Activity card; tooltip hints the action. No bare check button — a
           mis-click needs a confirm, not an instant clear. */
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (AIOPS d6c1b2c5907a, Ryan 2026-09-16) — the ✕ he asked
           for. ⛔ IT IS A SIGN, NOT A NEW POWER: the badge has opened a clear-confirm since
           2026-07-03 and the card was filed believing the only way to silence a sold deal's bell
           was to log a call that never happened. Nothing announced the click but a tooltip.
           ⛔ `stopPropagation` LIVES IN THE HANDLER, not here — a nested <button> inside a span
           that is itself `role="button"` needs the outer path skipped deliberately, and the
           handler is where both paths are visible at once. */
        var dismiss = '<button type="button" class="rqd-fu-dismiss" data-sold-fu-dismiss="1"'
          + ' data-ref="' + esc(q.reference) + '"'
          + ' title="Clear this reminder. The deal stays sold and nothing is logged."'
          + ' aria-label="Clear the follow-up reminder on ' + esc(q.reference) + '">&times;</button>';
        return {
          html: '<span class="' + cls + '" data-sold-fu-clear="1" data-followup-until="' + esc(q.followUp.dueAt)
            + '" data-ref="' + esc(q.reference) + '" data-tip="' + title + ' &mdash; click to clear'
            + '" data-tip-variant="sold" role="button" tabindex="0">' + inner + dismiss + '</span>',
          expired: expired,
        };
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Linked-child early-out. The actual
         fulfillment progress (ordered → shipped → paid → invoiced) lives
         on the PARENT order. The child quote is an accounting entry for
         the credit + balance payment, so rendering a Paid/Ordered/Shipped
         tracker on it would (a) duplicate the parent's progress and (b)
         show stuck/incomplete steps that admin can't actually advance
         (no PO is generated against the child, no fulfillment happens
         here).
         Ryan 2026-05-16: Return an EMPTY cell. The 🔗 + ref column in
         the row already signals "this is linked to X", and expanding
         the row shows the full Sold To / Balance card / linked-banner
         layout — the To-Do text was just clutter. */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM²) — let the ✓ Closed chip through.
         Ryan: "the ordering and all for both RW-1126-A and RW-1290-A take place from the ONLINE
         deals page ... I think both can say closed in the TO DO column." He's right, and KV
         agrees: both are sold + paid with zero POs, so both compute closed. RW-1126-A was blank
         only because this early-out fired first and swallowed the chip.

         The early-out's original point stands — don't render an ordered/shipped/paid tracker on a
         row whose steps admin can't advance. But ✓ Closed is not a task, it's the CONCLUSION that
         every task is settled, so it's the one thing worth showing. Everything else still blanks.
         Hoisted into one variable used by both sites so the two conditions can't drift. */
      /* CUSTOM_REVIEWS_BY_CLAUDE (Ryan 2026-09-09) — the `reviewStatus !== 'decision-pending'`
         exception is gone with the star cell: the review ask is a cog-menu entry now, so a
         settled row shows ✓ Closed regardless. */
      var _isClosedRow = q.closedStatus === 'closed' && !q.cancelled;
      if (q.linkedParentRef && !_isClosedRow) {
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-17) — mirror the PARENT's progress instead
           of leaving the cell blank.

           ⚠️ THIS IS NOT A REVERSAL OF THE BLANKING, IT IS THE FIX THAT MAKES IT UNNECESSARY. The
           cell was blanked because computing the CHILD's own steps produced green ticks
           vacuously: RW-1290-A had no line items, therefore no vendors, therefore every
           ordered/shipped step passed trivially and the bar asserted work that had not happened.
           Reading the PARENT's percentage sidesteps that entirely — it is a measured number, taken
           from the row where the work actually occurs. A child still gets NO step icons and no
           text; only the fill, because the individual steps belong to the parent and naming them
           here is what misled before.

           Falls back to a blank cell when the parent is not in the current view (filtered out, or
           a different rep's row) — an unresolvable parent must not render 0% and imply "nothing
           has happened", which is the same class of lie in the other direction. */
        var _lpRef = String(q.linkedParentRef || '').replace(/^#/, '').trim().toUpperCase();
        var _lpQ = null;
        for (var _lpi = 0; _lpi < allQuotes.length; _lpi++) {
          var _cand = allQuotes[_lpi];
          if (_cand && String(_cand.reference || '').replace(/^#/, '').trim().toUpperCase() === _lpRef) { _lpQ = _cand; break; }
        }
        /* ⛔ The parent is usually NOT in allQuotes. The dashboard fetches one source at a time
           (`&source=offline` / `&source=online`), and the canonical case here is an OFFLINE child of
           an ONLINE parent — so on the offline table the parent was never fetched and the lookup
           above finds nothing. `q._parentQuote` is the server-attached snapshot for exactly that
           (quote-dashboard.js, the balance-child rollup). The allQuotes hit is kept and tried FIRST
           because when both rows are in view it is the live object, already carrying any optimistic
           patches a mutation applied this session. */
        if (!_lpQ) _lpQ = q._parentQuote || null;
        if (!_lpQ) return wrap('', '');
        return wrap('', '', progressFillPct(_lpQ));
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — CLOSED orders render the same green
         "✓ FULFILLED"-style pill that online fulfilled orders already get,
         but reading "✓ Closed". CLOSED is a strictly stronger state than
         SOLD (every post-sale gate settled: commission paid, taxes
         remitted, vendors ordered, installer paid), so it dominates both
         the online emoji-strip and the offline N-admin-tasks renderings.
         Cancelled wins over closed (cancelled and closed are mutually
         exclusive in practice, but defensive gate keeps the red "Cancelled"
         pill on the rare row that's flagged both). Status pill stays SOLD
         — see line 4187, where the closedStatus → 'Closed' override was
         removed so the pill reflects lifecycle outcome and the TO DO
         column carries the closedness signal. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-11) — a pending ⭐ review
         decision outranks the ✓ Closed pill: the cell shows the star until
         the rep picks send/skip, THEN flips to ✓ Closed once all post-sale
         steps are also done. The star itself renders further down (after
         the envelope chip is computed — it must ride along). */
      if (_isClosedRow) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Reps can set a
           follow-up on a CLOSED deal (e.g. "check warranty in 1y", "ask
           for referral in 90d"). When present, render the countdown /
           bell next to the ✓ Closed pill. Active countdown → push
           "✓ Closed" left + countdown right (space-between). Expired
           bell → keep "✓ Closed" centered, bell sits flush right of
           the text. Colour is green via .rqd-row--sold .rqd-remaining
           --followup CSS rule (CLOSED rows carry .rqd-row--sold class). */
        var _closedFuHtml = '';
        var _closedExtraCls = '';
        if (q.followUp && q.followUp.dueAt) {
          var _cfu = _buildSoldFollowUpHtml(q);
          _closedFuHtml = _cfu.html;
          if (!_cfu.expired) _closedExtraCls = ' rqd-flow-cell--with-followup';
        }
        return '<span class="rqd-flow-cell rqd-flow-cell--done' + _closedExtraCls + '">' +
          '<span class="rqd-flow-done" title="Order closed — all post-sale obligations settled">&#10003; Closed</span>' +
          _closedFuHtml +
          '</span>';
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      // Two-column layout inside the To Do cell:
      //   left  → all emoji indicators (truck/wrench, $ commission, ⭐/envelope review)
      //   right → text (countdown for awaiting, "N task(s) remain(s)" / ✓ for sold)
      // CSS uses justify-content: space-between to push them apart.

      // Online orders render an emoji-strip status indicator across the To Do
      // cell — done emojis full color, current step amber-ringed, pending
      // steps faded. Collapses to a single green ✓ Done pill when complete.
      // Flow B + A use 5 slots (different middle emoji); Flow C uses 3 slots
      // (no supplier handshake — flat rate at checkout). The 💵 in Flow A's
      // middle slot vs 🚚 in Flow B's is the visual signature distinguishing
      // the two five-step flows at a glance.
      if (q.source === 'online') {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Admin-created draft orders that haven't
           been linked yet to a parent get a single "🔗 Link to Parent" pill
           instead of a misleading Flow A/B/C strip. They're not real
           fulfillment rows — they're payment records waiting to be rolled up.
           Once linked the row hides via the rollup pass, so the pill self-
           clears. Detection: Shopify's sourceName is 'shopify_draft_order'
           when the order originated as an admin-created draft (not a
           customer checkout). */
        var _isDraftSourced = (q.onlineSourceName === 'shopify_draft_order');
        var _alreadyChild = !!(q.tags || []).find(function (t) { return /^(?:balance-for|freight-balance-for):/i.test(String(t)); });
        if (isAdmin && _isDraftSourced && !_alreadyChild) {
          return '<span class="rqd-flow-cell rqd-flow-cell--draft-prompt">' +
            '<button type="button" class="rqd-flow-link-prompt rqd-link-balance-btn" data-ref="' + esc(q.reference) + '" data-order-gid="' + esc(q.id || '') + '" title="This is an admin-created draft order. Link it to its parent customer order.">🔗 Link to Parent</button>' +
            '</span>';
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Cancelled online orders show a red
           "✗ Cancelled" pill in the To Do column, mirroring the green
           "✓ Fulfilled" pill's anatomy. Surfaces only when "Cancelled
           orders" filter is checked (cancelled rows are hidden by
           default). Tooltip explains the order is closed-out. */
        if (q.cancelled) {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — a FULLY refunded order also arrives
             here with q.cancelled set (quote-base-builder.js), because from the dashboard's
             point of view "refunding 100% of an order means there's nothing to do with it at
             all". It shows the same ✗ Cancelled pill as the genuinely cancelled rows and files
             under the same checkbox, deliberately.

             Only the TOOLTIP distinguishes them, and it has to: SHOP-1924 has cancelledAt null
             in Shopify, so a rep told flatly that it was "cancelled" would go looking for a
             cancellation that does not exist. Naming the refund (and its amount) is what stops
             that walk. */
          var _refAmt = Number(q.refundedAmount) || 0;
          var _cancelTitle = q.refunded
            ? (_refAmt > 0
                ? 'Refunded in full (' + money(_refAmt) + ') — closed out, no further action'
                : 'Refunded in full — closed out, no further action')
            : 'Order was cancelled — no further action';
          return '<span class="rqd-flow-cell rqd-flow-cell--done">' +
            '<span class="rqd-flow-done rqd-flow-done--cancelled" title="' + esc(_cancelTitle) + '">&#10005; Cancelled</span>' +
            '</span>';
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        var steps = buildOnlineFlowSteps(q);
        var allDone = steps.every(function (s) { return s.done; });
        if (allDone) {
          return '<span class="rqd-flow-cell rqd-flow-cell--done">' +
            '<span class="rqd-flow-done" title="All steps complete">&#10003; Fulfilled</span>' +
            '</span>';
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Phase 3.5 Phase 1.5:
           Rep view of attributed online row reuses the EXACT same L→R
           green progress underlay that offline SOLD rows use — same
           wrap() helper, same .rqd-progress-cell__fill mechanism, same
           getProgressSteps() rep-side step set (Paid / Ordered / Shipped
           / Commission) so the math is identical to offline SOLD rows
           like JW-1126-D. No % verbiage; offline rows don't have it
           either. At 100% the offline allDone branch elsewhere renders
           "✓ Fulfilled" — same chrome.
           Admin viewing this row from the Offline tab gets the same
           rep-style fill (since admin manages it from Online tab and
           the Offline mirror is read-only). On Online/All tabs admin
           still gets the emoji-strip Flow A/B/C admin view. */
        if (!isAdmin || currentSource === 'offline') {
          var _repSteps = getProgressSteps(q);
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-10) — partial-aware fill
             (mirrors the offline-SOLD path at ~L7462): a not-done step still
             contributes its `partial` fraction so a half-paid 50/50 deal reads
             real progress instead of an empty bar. */
          var _repUnits = 0;
          for (var _ri = 0; _ri < _repSteps.length; _ri++) {
            if (_repSteps[_ri].done) _repUnits += 1;
            else if (_repSteps[_ri].partial > 0) _repUnits += _repSteps[_ri].partial;
          }
          var _repPct = _repSteps.length > 0
            ? Math.round((_repUnits / _repSteps.length) * 100)
            : 0;
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          return wrap('', '', _repPct);
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        var currentIdx = -1;
        for (var si = 0; si < steps.length; si++) {
          if (!steps[si].done) { currentIdx = si; break; }
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Tag the strip with its step count so
           CSS can right-align short (3-emoji Flow C) strips while keeping
           5-emoji strips edge-to-edge via space-evenly. */
        var strip = '<span class="rqd-flow-cell rqd-flow-cell--' + steps.length + '">';
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        for (var sj = 0; sj < steps.length; sj++) {
          var ss = steps[sj];
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Partial-progress ring. Any step
             with a non-zero `partial` fraction (multi-vendor or single-
             vendor multi-bucket) renders the conic-gradient ring instead
             of the full amber "current" ring or faded "pending" treatment.
             A partial step at the current position keeps the amber tint
             via .rqd-flow-step--current; partials in earlier positions
             (rare — happens when a later step already done) drop the
             tint. */
          var isPartial = !ss.done && ss.partial > 0;
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Partial steps
             NEVER get --pending. Pending applies opacity 0.25 + grayscale
             which faded out partial-but-not-current emojis (e.g., when
             ⚖ and 📦 are both 1/2 done, currentIdx lands on ⚖ → the 📦
             emoji ended up --pending --partial and rendered grayed
             despite its ring). A step with active progress should
             always read at full color; the partial ring already signals
             the in-progress state. */
          var stateCls;
          if (ss.done) {
            stateCls = 'rqd-flow-step--done';
          } else if (isPartial) {
            stateCls = sj === currentIdx
              ? 'rqd-flow-step--current rqd-flow-step--partial'
              : 'rqd-flow-step--partial';
          } else if (sj === currentIdx) {
            stateCls = 'rqd-flow-step--current';
          } else {
            stateCls = 'rqd-flow-step--pending';
          }
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          var stateLbl = ss.done
            ? ' — done'
            : (isPartial
                ? ' — ' + (ss.partialText || (Math.round(ss.partial * 100) + '%'))
                : (sj === currentIdx ? ' — up next' : ' — pending'));
          var styleAttr = isPartial ? ' style="--partial-frac:' + ss.partial.toFixed(3) + ';"' : '';
          strip += '<span class="rqd-flow-step ' + stateCls + '"' + styleAttr + ' title="' + esc(ss.label + stateLbl) + '">' + ss.emoji + '</span>';
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        }
        strip += '</span>';
        return strip;
      }

      var icons = buildLogisticsIcons(q);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — deal-group: a member's 📦
         sample-tracking pill, hoisted by the server onto the group's primary
         row (_groupSampleTracking) when the primary has none of its own. Rides
         in the left icons slot so it shows on the collapsed parent in every
         render path, same popover behavior as a native sample pill. */
      if (q._groupSampleTracking && q._groupSampleTracking.number) {
        var _gst = q._groupSampleTracking;
        var _gstUrl = bestSampleTrackingUrl(_gst.url, _gst.carrier, _gst.number);
        var _gstLabel = (_gst.carrier ? esc(_gst.carrier) + ' ' : '') + esc(_gst.number);
        var _gstSaved = _gst.savedAt ? (formatDate(_gst.savedAt) || _gst.savedAt) : '';
        /* Colour the hoisted 📦 to match the PRIMARY row's status (the deal it
           lands on), mirroring the native variant logic (~line 6233): on-hold →
           purple, fresh new lead → orange, sample → green (base), else
           quoted/sold/in-progress → blue. */
        var _gstVariant;
        if (q.isOnHold) _gstVariant = 'on-hold';
        else if ((q.isLead || q.status === 'new_lead') && !q.isSample && !q.isDeadLead && !((parseFloat(q.total) || 0) > 0) && !(q.pdfDownloaded || q.chainPdfDownloaded)) _gstVariant = 'lead';
        else if (q.isSample) _gstVariant = '';
        else _gstVariant = 'quote';
        var _gstDel = sampleDeliveryState(_gst);
        icons += '<span class="rqd-sample-shipped' + (_gstVariant ? ' rqd-sample-shipped--' + _gstVariant : '') + _gstDel.cls + '" tabindex="0"' +
          ' data-track-url="' + esc(_gstUrl || '') + '"' +
          ' data-track-label="' + esc(_gstLabel) + '"' +
          ' data-track-saved="' + esc(_gstSaved) + '"' +
          ' data-track-state="' + esc(_gstDel.title) + '"' +
          ' data-track-tone="' + esc(_gstDel.tone || '') + '"' +
          ' title="Sample shipped on a linked deal · ' + esc(_gstDel.title) + ' — hover for tracking">' +
          '<span class="rqd-sample-shipped__icon" aria-hidden="true">&#128230;</span>' +
        '</span>';
      }
      var isPending = q.isPending || q.status === 'pending';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Dead leads need
         nothing in this cell. No count-up timer, no icons. Return an
         empty cell early so the row reads as "archived, ignore". */
      if (q.isDeadLead) return wrap('', '');
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      // Awaiting timer fires while the row is still in NEW LEAD state —
      // customer-RFQ origin AND no rep has saved content edits yet. Once
      // the rep saves real edits (chainLastSavedAt stamped) the row
      // transitions to in-progress and this To Do cell drops the timer.
      var _amt = parseFloat(q.total) || 0;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Rep-engagement
         signal is chainLastSavedAt, not chainHasItems. Mirrors the
         buildQuoteRow gate. Customer-supplied items don't count; the
         rep actually saving real content edits does. */
      var isAwaiting = !isPending && !q.isOnHold && !q.isDeadLead && !q.lifecycleStatus && !q.chainQuoted && !(q.chainPdfDownloaded || q.pdfDownloaded) && !q.chainLastSavedAt && ((q.chainFromCustomerRfq || q.fromCustomerRfq) || q.status === 'submitted' || q.status === 'under_review');
      var isSoldOrClosed = q.lifecycleStatus === 'sold' || q.closedStatus === 'closed';

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Unread-email
         indicator on the To Do column. When the deal has an inbound
         Outlook email with isRead=false, drop a 📧 chip into the
         right-side text slot (where the bell + countdown live). Bell
         stays visible side-by-side; the countdown text is CSS-hidden
         (still live-ticking in the DOM) until the email is read so the
         cell decluters. Read state is sourced from emailMeta.isRead
         which the cron syncs every 5 min from Outlook + flips
         immediately in-place when the rep opens the email modal. */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-03) — ⛔ THE ARRAY WHEN THERE IS ONE, THE
         CACHED COUNT WHEN THERE IS NOT. A row painted from sessionStorage carries no
         `noteEntries` (see `_slimForCache`) but does carry `_unreadCached`, so the envelope
         survives a cold reload instead of blinking off until the refresh lands.
         ⚠️ THE ORDER MATTERS: a live array is the truth and must never be overridden by a stale
         number — the count is only consulted when the array is genuinely absent. Opening the
         email modal flips `isRead` in place on the live array, and that must win immediately. */
      var _liveEntries = Array.isArray(q.noteEntries) ? q.noteEntries : null;
      var _unreadCount = _liveEntries
        ? _liveEntries.filter(function(e) {
            return e && e.type === 'email' && e.emailMeta
              && e.emailMeta.direction === 'inbound'
              && e.emailMeta.isRead === false;
          }).length
        : (Number(q._unreadCached) || 0);
      var _hasUnreadInbound = _unreadCount > 0;
      /* Ryan 2026-05-21: variant class picks the badge color so the
         envelope's count circle matches the 📦 sample-shipped badge's
         color for the same row status — blue on QUOTED, yellow on
         NEW LEAD, purple on ON HOLD, dark green on SOLD/CLOSED, red
         on LOST, near-black on DEAD. Envelope glyph itself stays
         white-ish (default emoji rendering); only the badge changes. */
      var _envVariant = 'quote'; // default — most rows are QUOTED-class
      if (q.isOnHold) {
        _envVariant = 'on-hold';
      } else if (q.isDeadLead) {
        _envVariant = 'dead';
      } else if (q.lifecycleStatus === 'lost') {
        _envVariant = 'lost';
      } else if (q.lifecycleStatus === 'sold' || q.closedStatus === 'closed') {
        _envVariant = 'sold';
      } else if (q.isSample) {
        _envVariant = 'sample';
      } else if (q.isLead || q.status === 'new_lead') {
        var _envHasItems = (parseFloat(q.total) || 0) > 0;
        var _envPdfDone = !!(q.pdfDownloaded || q.chainPdfDownloaded);
        if (!_envHasItems && !_envPdfDone) _envVariant = 'lead';
      }
      /* Ryan 2026-05-21: use the dashboard's custom tooltip system
         (rqd-tip-trigger + data-tip + data-tip-variant) so the
         envelope hover-tip matches the bell's styled tooltip —
         left-bordered, per-status color, fade-in. Maps the envelope's
         variant to the matching tooltip variant (quote→quoted,
         lead→awaiting, on-hold→hold; sample/sold/lost/dead pass through). */
      var _envTipVariant = {
        'quote': 'quoted', 'lead': 'awaiting', 'on-hold': 'hold',
        'sample': 'sample', 'sold': 'sold', 'lost': 'lost', 'dead': 'dead',
      }[_envVariant] || 'quoted';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-08) — On an ON HOLD lead, a customer
         reply that hasn't been acted on shows the ✉️ even if the email was already read
         in Outlook (q.holdReplyPending, stamped by the worker). It's a lifecycle nudge —
         "reply, or adjust the hold" — distinct from the generic unread-email envelope,
         and it coexists with the running countdown exactly like the unread one does.
         Clears the moment the rep acts (worker recomputes holdReplyPending via actedSince). */
      var _holdReplyNudge = !!(q.isOnHold && q.holdReplyPending);
      var _showEnvelope = _hasUnreadInbound || _holdReplyNudge;
      var _envTipText = (_holdReplyNudge && !_hasUnreadInbound)
        ? 'Customer replied while on hold — click the row to reply or adjust the hold'
        : (_unreadCount + ' unread email' + (_unreadCount === 1 ? '' : 's') + ' — click the row to read');
      var _envAriaLabel = (_holdReplyNudge && !_hasUnreadInbound) ? 'Customer replied while on hold' : 'Unread email';
      var _envelopeHtml = _showEnvelope
        ? '<span class="rqd-todo-envelope rqd-todo-envelope--' + _envVariant + ' rqd-tip-trigger" data-ref="' + esc(q.reference) + '" data-tip="' + esc(_envTipText) + '" data-tip-variant="' + _envTipVariant + '" aria-label="' + _envAriaLabel + '" role="button" tabindex="0">✉️' + (_unreadCount > 1 ? '<span class="rqd-todo-envelope__count">' + _unreadCount + '</span>' : '') + '</span>'
        : '';

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Optional fillPct
         (0–100). Renders a green progress underlay behind the icons +
         text that visualizes admin closeout completion on SOLD rows.
         Caller passes the percentage; CSS positions the fill absolutely
         inside the .rqd-progress-cell container with width = pct. At
         100% the cell falls through to the ✓ Closed pill (handled by
         the SOLD-or-closed branch's remaining === 0 path) so the fill
         is only visible during the "in progress toward closed" window. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — ARMED, BUT WITH NO DATE YET.
         The post-delivery ladder gets its job when the carrier reports delivery, so between
         "shipped" and "delivered" there is no `sendAfter` and the cell said nothing at all about
         an automation that was live and guaranteed to fire.

         ⛔ IT RIDES WITH THE COUNTDOWN, NOT IN THE ICONS SLOT. The first version put it on the
         left with the 📦, which gave three different-looking ⚡ across three deals depending on
         which branch drew the cell. Ryan: *"I want it positioned to the left of the 'xd' text on
         the right side of the column... with no big gap between the two."* Injecting it inside
         wrap()'s TEXT span puts it immediately left of whatever that row counts down to — a hold,
         an awaiting timer, anything — so every state reads the same without touching one branch.
         ⚠️ Computed here, ABOVE wrap, rather than relying on var-hoisting to reach it.
         ⚠️ Empty when a real job exists: that branch draws its own bolt inside the amber pill,
         and two would stack. */
      /* CUSTOM_BOLTNOBELL_BY_CLAUDE (Ryan 2026-09-28, RW-1459-A) — ⛔ THE TWIN of the worker's
         `awaitingDeliveryArmed` (quote-dashboard.js): armed, no date yet, not held, and shipped less
         than 14 days ago. Past 14 days the bolt goes (a box FedEx never reports delivered must not
         hold the bell off for ever), so the row gets its bell back and never shows both. */
      function rqdAwaitingDeliveryArmed(pa, nowMs) {
        if (!pa || pa.holdKind || pa.sendAfter || pa.awaiting !== 'delivery') return false;
        var t = Date.parse(pa.shippedAt || '') || 0;
        return !!t && (nowMs || Date.now()) - t < 14 * 86400000;
      }
      var _seqArmedIcon = (function () {
        var pa = q.pendingAutomation;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-01) — ⛔ `holdKind` SILENCES THIS BOLT TOO.
           The countdown branch below has refused a held automation since it shipped; this one
           did not, so a guard everyone believed was on the ladder was only ever on one rung.
           A held sequence is one nothing is going to send — that is precisely when the row's
           bell comes back (isAutomationPending in the worker) — and a ⚡ beside a live bell
           says two opposite things about the same deal.
           ⚠️ The audience gate is settled SERVER-side (dropGatedAutomations): a deal the
           `sequence` switch will not send for carries no `pendingAutomation` at all, so it
           never reaches here. This is the belt to that braces. */
        if (!rqdAwaitingDeliveryArmed(pa)) return '';
        var tip = (pa.label || 'Post-delivery follow-ups')
          + ' are armed. The first one sends automatically the morning after '
          + (pa.carrier ? pa.carrier + ' ' : '') + 'reports the samples delivered'
          + (pa.number ? ' (' + pa.number + ')' : '') + '.';
        return '<span class="rqd-seq-armed rqd-tip-trigger" role="button" tabindex="0"'
          + ' data-ref="' + esc(q.reference) + '" data-tip="' + esc(tip) + '"'
          + ' data-tip-variant="quoted" aria-label="Automation armed, waiting on delivery">⚡</span>';
      })();

      function wrap(iconsHtml, textHtml, fillPct) {
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-17) — `<= 100`, was `< 100`. The exclusion
           was defensive: a normal row at 100% returns the ✓ from the remaining===0 path long
           before reaching wrap(), so nothing ever passed 100. A LINKED CHILD mirroring a
           fully-progressed parent does, and would have gone blank at the exact moment the parent
           finished — the reading most likely to be mistaken for "nothing happened". It also fixes
           a rounding edge on ordinary rows: partials summing to 99.6% round to 100 while work
           genuinely remains, which used to erase the bar instead of filling it. */
        var fillHtml = (typeof fillPct === 'number' && fillPct > 0 && fillPct <= 100)
          ? '<span class="rqd-progress-cell__fill" style="width:' + Math.min(fillPct, 100) + '%"></span>'
          : '';
        /* Guard against `_envelopeHtml` being undefined — wrap() is
           called from early-return paths (q.linkedParentRef, q.isDeadLead)
           that happen BEFORE the `var _envelopeHtml = ...` line further
           down in this function. Without `|| ''`, var-hoisting leaves
           it as undefined and string-concat emits literal "undefined"
           in the To Do cell (RW-1126-A class bug, 2026-05-21).

           ⛔ AND THE SAME GUARD ON `_seqArmedIcon`, WHICH IT DID NOT HAVE (Ryan 2026-09-03,
           RW-1325-A). That variable was added to this very line later, one identifier along from
           the one this comment is about, and did not inherit the rule the comment states. It is
           declared at the `var _seqArmedIcon = (function () {` line BELOW — later than
           `_envelopeHtml` even — so every early return above it printed a literal "undefined" in
           the To Do cell. Three shapes reach it: a LINKED CHILD (`q.linkedParentRef`, which is
           RW-1325-A — it hangs off SHOP-1933), a rep-view row, and a DEAD LEAD.

           ⚠️ THE FIRST FIX ONLY MOVED THE HOLE. Guarding one of two hoisted reads on one line
           leaves the line just as broken for the next variable somebody appends, which is exactly
           what happened here — four months apart, same line, same cause. Both reads are guarded
           now, and the invariant is the line's, not either variable's: NOTHING declared below the
           early returns may be concatenated here unguarded. */
        var envHtml = _envelopeHtml || '';
        var textCls = 'rqd-progress-cell__text' + (envHtml ? ' rqd-progress-cell__text--has-envelope' : '');
        /* CUSTOM_BOLTNOBELL_BY_CLAUDE (Ryan 2026-09-28, RW-1459-A) — ⛔ THE ARMED BOLT AND A BELL NEVER
           SHARE THE CELL. Ryan: *"while there's a lightning bolt ... there should never be a bell."*
           The dated bolt has always returned before every bell; this one (armed, waiting on delivery)
           had no branch, so it was drawn beside whatever bell came next - RW-1459-A read ⚡ 🔔.
           ⚠️ HERE, IN THE ONE PLACE EVERY BRANCH PASSES, and keyed on the class every bell in this cell
           wears, so the next bell branch somebody adds is covered without knowing about this. Only a
           BELL is dropped: a hold countdown ("7d") is not a nag and keeps its place beside the bolt,
           which is where Ryan asked for it. The server agrees (isAutomationPending), so the row also
           leaves Money Moves. The bolt expires 14 days after shipping (rqdAwaitingDeliveryArmed) and
           the bell comes back with it. */
        var txtHtml = textHtml || '';
        if (_seqArmedIcon && /rqd-followup-bell/.test(txtHtml)) txtHtml = '';
        return fillHtml +
          '<span class="rqd-progress-cell__icons">' + (iconsHtml || '') + '</span>' +
          '<span class="' + textCls + '">' + envHtml + (_seqArmedIcon || '') + txtHtml + '</span>';
      }

      /* ============================================
         CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — ⛔ NO BELL WHILE A SEQUENCE IS ARMED
         ============================================
         Ryan: *"the countdowns to bells when there's a sequence on needs to just countdown to an
         automated email, then the email goes out and you never see the bell and the countdown
         resets."*

         A rep being nagged to do the thing the automation just did is how people stop trusting
         both. So while an automated email is coming, this cell counts down to THAT — and it
         NEVER flips to a bell, because there is no action for the rep to take.

         ⛔ CHECKED BEFORE EVERY OTHER BELL IN THIS FUNCTION, including the sample-awaiting and
         off-hold ones. Suppressing only the follow-up countdown would leave a sample deal with a
         live confirm sequence ringing its "awaiting a response" bell — which is the same nag
         wearing a different emoji. The one exception is the deal-group pair below: a linked
         group's bell belongs to whichever member the SERVER nominated, and that decision is
         already automation-aware (isMoneyMove reads the same field).

         ⚠️ A HELD SEQUENCE IS NOT SUPPRESSED. `holdKind` means it has stalled on something a
         human must fix, so the deal is the rep's again and its bell should ring. Same rule the
         worker's isAutomationPending applies to Money Moves — one definition, two surfaces. */
      var _seqPending = (function () {
        var pa = q.pendingAutomation;
        if (!pa || !pa.sendAfter || pa.holdKind) return null;
        return pa;
      })();

      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-17, RW-1375-A) — ⛔ THE GROUP'S BELL AND
         THIS DEAL'S BOLT ARE ABOUT DIFFERENT DEALS, SO BOTH DRAW.
         ─────────────────────────────────────────────────────────────────────────────────────
         The group hoist borrows a SIBLING's bell onto the collapsed primary. That is working as
         designed — something in the group genuinely needs a person. What was not designed is that
         it then swallowed the row's own ⚡ and countdown: the branch below returned on
         `_groupBellShow` before the sequence branch could draw, so RW-1375-A rang a bell for
         RW-1380-A while saying nothing about the four-email sequence armed on itself. Ryan, on
         the pair: *"it should go away and be replaced with the lightning bolt"* — and it should,
         but only for the half of the cell that is this deal's.

         ⛔ BOTH BRANCHES, NOT JUST THE ONE THAT BIT. `_groupBellHide` swallowed the bolt exactly
         the same way on every non-primary member of a ringing group; fixing only the branch in
         the bug report leaves the identical fault one rung along.
         ⚠️ The chip goes in the TEXT slot ahead of the countdown, the same place the ✉️ sits, so
         the cell reads 📦 · ✉️ · 🔔 · ⚡ 7d left to right whichever branch built it. */
      var _groupChipHtml = (function () {
        if (q._groupBellShow) {
          var _gbFor = q._groupBellFor ? String(q._groupBellFor) : '';
          var _gbMore = (Number(q._groupBellForCount) || 0) - 1;
          var _gbTip = _gbFor
            ? 'Linked deal ' + _gbFor + (_gbMore > 0 ? ' and ' + _gbMore + ' other' + (_gbMore === 1 ? '' : 's') : '')
              + ' — follow-up due'
            : 'Linked deal — follow-up due';
          return '<span class="rqd-remaining rqd-remaining--followup rqd-followup-countdown rqd-followup-countdown--expired rqd-tip-trigger"'
            + ' data-tip="' + esc(_gbTip) + '" data-ref="' + esc(q.reference) + '" role="button" tabindex="0">'
            + '<span class="rqd-followup-bell" aria-label="' + esc(_gbTip) + '">🔔</span></span>';
        }
        if (q._groupBellHide) {
          var _gbOn = q._groupBellOn ? String(q._groupBellOn) : '';
          var _ghTip = _gbOn
            ? 'Part of a linked deal — the follow-up bell is on ' + _gbOn
            : 'Part of a linked deal — the follow-up bell is on the primary deal';
          return '<span class="rqd-remaining rqd-remaining--grouped rqd-tip-trigger"'
            + ' data-tip="' + esc(_ghTip) + '" data-ref="' + esc(q.reference) + '" role="button" tabindex="0">🔗</span>';
        }
        return '';
      })();

      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-17, RW-1375-A) — ⛔ A SIBLING OF AN AUTOMATED
         GROUP IS SILENT, AND IT HAS TO BE SILENCED HERE.
         ─────────────────────────────────────────────────────────────────────────────────────
         The server stamps `_linkGroupAutomated` on every member of a linked group that has an
         email coming, and drops the whole group from Money Moves. That is the COUNT. This cell
         does not read `isMoneyMove` — it re-derives its bells from `followUp`, `wokeAt`,
         `isSample` and the rest — so a server-side suppression on its own would clear the badge
         and leave the sibling's 🔔 sitting on screen. Exactly the badge-vs-bell desync the
         2026-06-30 hoist and the 2026-07-03 `_linkGroupSold` stamp were both written to repair;
         this is the third time, and the lesson is the same one: silence the predicate AND the
         render, in the same pass.

         Ryan: *"the bell should be 100% cleared.. from the parent and the sibling and the money
         moves count."* The member holding the sequence falls through to the branch below and
         draws its ⚡ + countdown; every other member draws nothing at all until the sequence is
         spent, at which point `pendingAutomation` disappears and their bells come back by
         themselves on the next board build.
         ⚠️ `icons` is kept — a 📦 in flight is a fact about the shipment, not a nag. */
      if (q._linkGroupAutomated && !_seqPending) {
        return wrap(icons + (q.isOnHold ? buildHeldSampleIcon(q) : ''), '');
      }
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-28, RW-1428-A) — same silence, third cause:
         the server stamps `_linkGroupCounting` on a sibling whose group PRIMARY is resting on its
         own follow-up countdown (the quote just went out; the customer is not owed a chase from
         the sibling). Server drops it from Money Moves; this drops the sibling's own 🔔. Comes
         back by itself when the primary's countdown runs out. */
      if (q._linkGroupCounting && !_seqPending) {
        return wrap(icons + (q.isOnHold ? buildHeldSampleIcon(q) : ''), '');
      }

      if (_seqPending) {
        var _seqDue = Date.parse(_seqPending.sendAfter) || 0;
        var _seqOverdue = _seqDue <= Date.now();
        var _seqTip = (_seqPending.label || 'Automated email')
          + (_seqPending.rung && _seqPending.of ? ' — email ' + _seqPending.rung + ' of ' + _seqPending.of : '')
          + ' sends automatically'
          + (_seqPending.repCode ? ' from ' + _seqPending.repCode + "'s mailbox" : '')
          + '. No follow-up needed from you.';
        /* ⛔ PAST DUE READS "sending", NOT A BELL AND NOT A NEGATIVE COUNTDOWN. The drain runs
           every fifteen minutes, so a few minutes past the hour is the normal case; showing a
           bell there would ring for exactly the deal that needs nothing. */
        var _seqInner = _seqOverdue
          ? '<span class="rqd-seq-countdown__text">sending</span>'
          : '<span class="rqd-seq-countdown__text">' + esc(formatHoldCountdown(_seqPending.sendAfter)) + '</span>';
        /* ⛔ CARRY THE SHIPMENT THROUGH THIS EARLY RETURN. On a HELD row `icons` has no 📦 —
           buildLogisticsIcons leaves it to the on-hold branch below, which this return skips. So
           the one deal shape that has both a shipment and an automation was the one that showed
           neither. Non-held rows already have it in `icons`; adding it again here would stack two. */
        var _seqIcons = icons + (q.isOnHold ? buildHeldSampleIcon(q) : '');
        /* ⛔ THE BOLT STANDS ALONE (Ryan 2026-09-17, second pass). The first build drew the
           hoisted group bell beside it; Ryan, seeing it: *"shouldn't that go away when there's a
           lightning bolt? As in, it's one or the other, never both."* The To Do column's whole
           grammar is one state per row, and two chips describing two deals is not a state.
           ⚠️ Belt to the server's braces: `_linkGroupAutomated` now silences every member of an
           automated group, so `_groupChipHtml` is empty here by construction. Not prefixing it is
           what makes that a guarantee rather than a coincidence — if the server ever did set
           both, the bolt still wins, which is the direction Ryan chose. */
        return wrap(_seqIcons,
          '<span class="rqd-remaining rqd-remaining--sequence rqd-seq-countdown rqd-tip-trigger"'
          + ' data-seq-until="' + esc(_seqPending.sendAfter) + '"'
          + ' data-ref="' + esc(q.reference) + '" data-tip="' + esc(_seqTip) + '"'
          + ' data-tip-variant="quoted" role="button" tabindex="0">'
          + '<span class="rqd-seq-bolt" aria-label="Automated email scheduled">⚡</span>'
          + _seqInner
          + '</span>');
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — ONE bell per deal group.
         The server marks exactly one row per linked group to carry the bell
         (_groupBellShow on the primary) and the other ringing members to hide
         it (_groupBellHide → a muted 🔗 chip). Checked FIRST so a grouped deal
         shows a single bell on its parent, matching the deduped Money Moves pill.
         Both flags are only set on active (non-sold/closed/held) rows server-side. */
      /* ⚠️ ONE BUILDER, TWO CALLERS. These render the same two chips the sequence branch above
         prefixes, so the tooltip that names the sibling cannot drift between a grouped row that
         happens to have an automation armed and one that does not. */
      if (q._groupBellHide || q._groupBellShow) {
        return wrap(icons, _groupChipHtml);
      }

      /* CUSTOM_REVIEWS_BY_CLAUDE (Ryan 2026-09-09) — the centered ⭐ that used to render here on
         reviewStatus='decision-pending' is RETIRED: it lost to the green "Closed ✓" pill on the
         very rows it was for. The decision is the row's cog-menu entry now (buildReviewAskMenuItem);
         this cell falls through to the ordinary progress / closed rendering. */

      // ON HOLD — countdown text in the To Do column. The ⏳ emoji
      // lives on the status pill ("⏳ ON HOLD") to match how SAMPLE
      // carries 🧪 in its pill, so the cell stays clean: just the
      // remaining-time text in the row's violet color. Live-ticked via
      // the same setInterval that drives the awaiting timers.
      if (q.isOnHold) {
        var holdRemaining = formatHoldCountdown(q.holdUntil);
        var holdTitle = q.holdUntil ? 'Wakes on ' + esc(q.holdUntil) : 'No wake date set';
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — When samples shipped, preserve the
           📦 box icon to the LEFT of the countdown so admin doesn't lose
           the shipment context when the lead is parked. Tinted purple via
           .rqd-sample-shipped--on-hold so the icon visually pairs with the
           ON HOLD pill. Both surfaces covered: sample-row (q.sampleTracking)
           and regular-row quote-level sample tracking (q.quoteSampleTracking).
           Tracking popover (hover) still works since the pill keeps its
           data-track-* attrs. */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — q.isSample reflects
           the CURRENT lead.status, which flips off 'sample' the moment the
           lead is put on hold (status='on_hold'). But lead.sampleTracking
           persists across state changes, so a previously-sample-shipped row
           held on hold was losing its purple 📦 because the first branch's
           q.isSample gate failed. Drop the isSample requirement — presence
           of sampleTracking.number is the real signal. quoteSampleTracking
           still wins via fallback for non-sample-source orders. */
        var _holdSampleIcon = buildHeldSampleIcon(q);
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Countdown pill
           moved to the RIGHT side with a ⏰ prefix for uniformity with
           the other timers (awaiting, sample, follow-up). The 📦
           sample-shipped icon (if applicable) stays in the LEFT icons
           slot so the row still surfaces shipment context at a glance. */
        /* Ryan 2026-05-16: ⏰ dropped from count-down renders. The alarm-
           clock icon connotes "act now" which is misleading on a future-
           scheduled countdown — rep shouldn't engage until the bell fires.
           Plain text reads as "scheduled wake date, ignore for now". */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — Hold countdown + unread-
           email envelope now COEXIST (envelope left, countdown right). The prior
           "envelope owns the right slot" hide was removed (here + in CSS). */
        var holdPill = '<span class="rqd-hold-countdown" title="' + holdTitle + '" data-hold-until="' + esc(q.holdUntil || '') + '"><span class="rqd-hold-countdown__text">' + esc(holdRemaining) + '</span></span>';
        return wrap(icons + _holdSampleIcon, holdPill);
      }

      // Sample rows: show shipped indicator (✓ + tracking pill) once admin
      // saves a tracking number; otherwise an "awaiting shipment" hint.
      // Tracking lives on lead.sampleTracking — admin records it via the
      // sample detail panel input.
      if (q.isSample) {
        var st = q.sampleTracking;
        if (st && st.number) {
          // Once admin records tracking, show 📦 + tracking number
          // LEFT-aligned in the To Do cell. Emoji rendered at the same
          // 16px the truck/logistics icons use; label stays at the
          // standard 12px so the emoji visually matches sibling rows
          // without dragging the number text up to that size.
          // Pill goes in the iconsHtml slot of wrap() (left side, not
          // the right-aligned text slot).
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Use bestSampleTrackingUrl to heal
             legacy saved URLs that point to a generic carrier landing page
             instead of the deep link for this tracking number. */
          var trackUrl = bestSampleTrackingUrl(st.url, st.carrier, st.number);
          var labelText = (st.carrier ? esc(st.carrier) + ' ' : '') + esc(st.number);
          var titleText = 'Shipped' + (st.savedAt ? ' · saved ' + (formatDate(st.savedAt) || st.savedAt) : '');
          // 📦 emoji shows by default — clean and compact. Carrier + tracking
          // number lives in a CSS-driven hover popover so it doesn't clutter
          // the To Do cell at rest. Text in the popover stays selectable
          // (user-select:text) for Ctrl+C, and the link inside is clickable
          // to open the tracking page in a new tab.
          var iconHtml = '<span class="rqd-sample-shipped__icon" aria-hidden="true">📦</span>';
          // Tracking data lives on the wrapper as data-attributes. A
          // single body-level popover (like the brand tooltip) reads
          // them on hover and renders the link + saved date. The
          // popover lives on <body> so the table-scroll wrapper's
          // overflow-x:auto doesn't clip it, doesn't contribute to a
          // phantom horizontal scrollbar, and the z-index can stack
          // above any table chrome.
          var trackSaved = st.savedAt ? (formatDate(st.savedAt) || st.savedAt) : '';
          var _stDel = sampleDeliveryState(st);
          /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-20) — a deal with more than one box wears a count
             beside the disc and the popover lists every box with its own tracking. One box: the pill
             is byte-for-byte what it was. */
          var _boxes = Array.isArray(q.sampleShipments) ? q.sampleShipments : [];
          var _multi = _boxes.length > 1;
          var _boxList = '';
          /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: TWO PEOPLE is not two boxes to
             one person. A requested second set adds a second bubble in the row's own status colour (the
             multi-box one stays black) and the popover names who each box went to. */
          var _sec = (q.sampleSecondary && typeof q.sampleSecondary === 'object' && !q.sampleSecondary.removedAt
            && (q.sampleSecondary.requested || (q.sampleSecondary.sampleRequest && q.sampleSecondary.sampleRequest.sentAt))) ? q.sampleSecondary : null;
          var _boxRow = function (b, who) {
            var bs = sampleDeliveryState({ number: b.number, delivery: b.delivery || null, trouble: b.trouble || null, savedAt: b.savedAt });
            return { seq: b.seq, who: who || '', url: bestSampleTrackingUrl(b.url, b.carrier, b.number) || '', label: (b.carrier ? b.carrier + ' ' : '') + (b.number || ''),
              saved: b.savedAt ? (formatDate(b.savedAt) || b.savedAt) : '', state: bs.title, tone: bs.tone || '' };
          };
          if (_multi || _sec) {
            try {
              var _rows = (_boxes.length ? _boxes : [st]).map(function (b, i) {
                return _boxRow(Object.assign({}, b, { seq: b.seq || (i + 1) }), _sec ? 'Buyer' + (_boxes.length > 1 ? ' · shipment ' + (b.seq || (i + 1)) : '') : '');
              });
              if (_sec) {
                var _who2 = String((_sec.shipTo && _sec.shipTo.name) || 'Second recipient') + ((_sec.shipTo && _sec.shipTo.company) ? ' (' + _sec.shipTo.company + ')' : '');
                var _t2 = (_sec.sampleTracking && _sec.sampleTracking.number) ? _sec.sampleTracking : null;
                _rows.push(_t2 ? _boxRow(Object.assign({}, _t2, { seq: _rows.length + 1 }), _who2)
                  : { seq: _rows.length + 1, who: _who2, url: '', label: 'No tracking number yet', saved: '', state: 'Requested from ECORE · awaiting box', tone: '' });
              }
              _boxList = JSON.stringify(_rows);
            } catch (_) { _boxList = ''; }
          }
          if (_multi) {
            iconHtml += '<span class="rqd-sample-shipped__count" aria-hidden="true">' + _boxes.length + '</span>';
            titleText = _boxes.length + ' shipments · latest ' + titleText.charAt(0).toLowerCase() + titleText.slice(1);
          }
          if (_sec) {
            iconHtml += '<span class="rqd-sample-shipped__count rqd-sample-shipped__count--recipients" aria-hidden="true">2</span>';
            titleText = 'Two recipients · ' + titleText.charAt(0).toLowerCase() + titleText.slice(1);
          }
          var pillHtml = '<span class="rqd-sample-shipped' + _stDel.cls + (_multi ? ' rqd-sample-shipped--multi' : '') + (_sec ? ' rqd-sample-shipped--two-recipients' : '') + '" tabindex="0"' +
            ' data-track-url="' + esc(trackUrl || '') + '"' +
            ' data-track-label="' + esc(labelText) + '"' +
            ' data-track-saved="' + esc(trackSaved) + '"' +
            ' data-track-state="' + esc(_stDel.title) + '"' +
            ' data-track-tone="' + esc(_stDel.tone || '') + '"' +
            (_boxList ? ' data-track-list="' + esc(_boxList) + '"' : '') +
            ' title="' + esc(titleText) + ' · ' + esc(_stDel.title) + ' — hover for tracking">' +
            iconHtml +
          '</span>';
          return wrap(pillHtml, '');
        }
        // No tracking yet — show a green count-up timer ticking from when
        // the sample request landed, mirroring the NEW LEAD awaiting
        // timer's pattern. Green text matches the sample aesthetic.
        // Left-aligned in the icon-slot for vertical alignment with the
        // NEW LEAD + ON HOLD timers across rows.
        var sampleSince = q.chainCreatedAt || q.createdAt;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Timer to RIGHT
           side with ⏰ prefix for uniformity across row types. */
        /* Ryan 2026-05-16: count-up timer text DROPPED — only the 🔔 is
           visible. Time-since-landed surfaces in the body-level tooltip
           on hover ("38m since sample request landed"). Live-tick keeps
           the tooltip text fresh. Reps prioritize within the "act now"
           bucket via hover-inspection; aggregate metrics will live on
           the stats page later. */
        var sampleAwaitingText = '<span class="rqd-remaining rqd-remaining--sample rqd-tip-trigger rqd-followup-countdown rqd-followup-countdown--expired" data-tip="' + esc(formatAwaitingElapsed(sampleSince)) + ' since sample request landed" data-tip-variant="sample" data-awaiting-since="' + esc(sampleSince || '') + '" data-ref="' + esc(q.reference) + '" role="button" tabindex="0"><span class="rqd-followup-bell" aria-label="Sample awaiting response">🔔</span></span>';
        return wrap(icons, sampleAwaitingText);
      }

      if (!isSoldOrClosed) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-16) — An explicitly-armed,
           not-yet-due follow-up wins over the count-up awaiting / resumed-from-hold
           bell. A rep who sent an email and scheduled a reminder has already acted, so
           the row should read "scheduled, waiting" (the follow-up countdown below) —
           not "respond now" (bell). Previously a woken-from-hold / new-lead row with
           wm.followUp set rendered its awaiting bell here and returned BEFORE the
           follow-up countdown branch ran, so the armed countdown was silently invisible
           (RW-1181-A). Scoped to non-expired follow-ups; an overdue one still flows to
           the bell. Freight/install "added but unsent" keeps priority via its own
           branch below (it gates on !_fuOverdue and is unaffected by this). */
        var _fuActive = q.followUp && q.followUp.dueAt && !isFollowUpExpired(q.followUp.dueAt);
        if (isAwaiting && !_fuActive) {
          // Use the chain's earliest createdAt — Save-As (-A → -B → -C) shouldn't
          // restart the response-time clock; the customer's wait started when
          // the original lead landed and applies uniformly across all revisions.
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Uniformity:
             timers all live on the RIGHT side of the To-Do column with
             a ⏰ prefix, matching the follow-up countdown. Status icons
             (📦, truck) stay in the LEFT icons slot. */
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — RESUMED leads
             restart the To-Do timer from wokeAt. The original lead-landed
             clock is the right baseline for a fresh NEW LEAD ("how long
             has the customer been waiting?"), but once the rep put it on
             hold and pulled it back out, the relevant metric is "how long
             since I picked it back up". Backend stamps wokeAt on every
             wake (manual /lead-wake + autoWakeIfDue), so hold → resume →
             hold → resume always counts from the latest resume. */
          var _isResumed = !!(q.wokenFromHold && q.wokeAt);
          var awaitingSince = _isResumed ? q.wokeAt : (q.chainCreatedAt || q.createdAt);
          var awaitingText;
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — RESUMED rows
             render a 🔔 bell instead of a count-up timer. Semantic split:
             ⏰ count-up = customer-driven urgency (NEW LEAD, SAMPLE —
             customer reached out, rep needs to respond NOW). 🔔 bell =
             rep-scheduled timer expired (RESUMED, expired QUOTED
             follow-up — rep needs to act on their own commitment). The
             staleness ("how long since auto-wake") lives in the hover
             title only — invisible at rest, available on inspection.
             bellWaitMs gets stamped server-side on next note save for
             reporting. Click handler: data-ref + role=button routes
             through the existing follow-up-bell handler to open the
             Activity card. */
          if (_isResumed) {
            var _resumedAgo = formatAwaitingElapsed(awaitingSince);
            /* Ryan 2026-05-16: native title= replaced with the body-level
               .rqd-tip-trigger pattern. Same content, styled on-brand
               to match the sample-tip aesthetic. variant=awaiting maps
               to the amber/yellow RESUMED palette. */
            awaitingText = '<span class="rqd-remaining rqd-remaining--awaiting rqd-remaining--resumed-bell rqd-followup-countdown rqd-followup-countdown--expired rqd-tip-trigger" data-tip="Off hold ' + esc(_resumedAgo) + ' ago" data-tip-variant="awaiting" data-awaiting-since="' + esc(awaitingSince || '') + '" data-ref="' + esc(q.reference) + '" role="button" tabindex="0"><span class="rqd-followup-bell" aria-label="Off hold — follow-up due">🔔</span></span>';
          } else {
            /* Ryan 2026-05-16: count-up text DROPPED — only 🔔 is
               visible. Time-since-landed in the body-level tooltip on
               hover. Live-tick updates data-tip every second so the
               number stays fresh. Click → open Activity card (same
               handler that fires for expired-followup bells, since
               this span carries rqd-followup-countdown--expired). */
            awaitingText = '<span class="rqd-remaining rqd-remaining--awaiting rqd-tip-trigger rqd-followup-countdown rqd-followup-countdown--expired" data-tip="' + esc(formatAwaitingElapsed(awaitingSince)) + ' since lead landed" data-tip-variant="awaiting" data-awaiting-since="' + esc(awaitingSince || '') + '" data-ref="' + esc(q.reference) + '" role="button" tabindex="0"><span class="rqd-followup-bell" aria-label="New lead awaiting response">🔔</span></span>';
          }
          return wrap(icons, awaitingText);
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-08) — Freight/install added but
           NOT yet sent → action-required 🔔 (rep must re-send the quote so the
           customer gets the new total). Shows in place of a pending follow-up
           countdown (customer is owed the updated quote first); an already-OVERDUE
           follow-up bell still wins (older obligation). Reuses the expired-bell
           classes — same styling + click→open-row behavior as the RESUMED bell
           above. Mirrors the server isMoneyMove predicate, so the row also lands
           in the MONEY MOVES filter. */
        var _fUnsent = (Number(q.freightTotal) > 0 && q.freightSynced === false);
        var _iUnsent = (Number(q.installTotal) > 0 && q.installSynced === false);
        var _fuOverdue = q.followUp && q.followUp.dueAt && isFollowUpExpired(q.followUp.dueAt);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-08) — An explicitly-set follow-up
           (active OR overdue) now wins over this re-send bell: the rep deliberately
           scheduled a reminder, so the countdown/bell for THAT shows here. The unsent
           freight/install is NOT lost — it stays flagged by the left-slot truck/wrench
           icon and still lands in the MONEY MOVES filter. Mirrors how an active
           follow-up already outranks the "awaiting response" bell above (!_fuActive). */
        if ((_fUnsent || _iUnsent) && !_fuOverdue && !_fuActive) {
          var _addOnLabel = (_fUnsent && _iUnsent) ? 'Freight + installation' : (_fUnsent ? 'Freight' : 'Installation');
          var _addOnTip = _addOnLabel + ' added — re-send the quote so the customer gets the new total';
          return wrap(icons, '<span class="rqd-remaining rqd-remaining--followup rqd-followup-countdown rqd-followup-countdown--expired rqd-tip-trigger" data-tip="' + esc(_addOnTip) + '" data-tip-variant="quoted" data-ref="' + esc(q.reference) + '" role="button" tabindex="0"><span class="rqd-followup-bell" aria-label="' + esc(_addOnLabel) + ' added — send to customer">🔔</span></span>');
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — "Nx request"
           To-Do column text dropped entirely. The truck/install emoji
           badge now carries the same signal (count → "R" → ✓) and
           shows to both admins AND non-admins. Falls through to the
           follow-up countdown branch below. */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Follow-up reminder
           on a QUOTED / PENDING row. q.followUp surfaced from the
           dashboard handler. Live-ticked countdown badge.
           Ryan 2026-05-16: Once dueAt is in the past, the badge swaps
           to a 🔔 bell (the eye-grabber state — "action due now"). Click
           on EITHER the bell or the countdown opens the row + scrolls to
           the Activity card to log a follow-through (advances the cadence).
           No manual clear — a follow-up only clears on SOLD/LOST. Count-up
           timers (NEW LEAD / RESUMED / SAMPLE awaiting) do NOT get the
           bell — those flow to the future Tasks dashboard instead. */
        if (q.followUp && q.followUp.dueAt) {
          var fuDateLabel = formatFollowUpDate(q.followUp.dueAt);
          var fuExpired = isFollowUpExpired(q.followUp.dueAt);
          /* Ryan 2026-05-16: "click to ..." trailing hints dropped from
             both variants — reps figure out the click affordance
             naturally; the parenthetical noise just clutters the tooltip. */
          var fuTitle = fuExpired
            ? 'Follow-up due: ' + esc(fuDateLabel) + ' (' + esc(q.followUp.dueAt) + ')'
              + (q.followUp.setBy ? ' · set by ' + esc(q.followUp.setBy) : '')
              + (q.followUp.reason ? ' — ' + esc(q.followUp.reason) : '')
            : 'Follow up: ' + esc(fuDateLabel) + ' (' + esc(q.followUp.dueAt) + ')'
              + (q.followUp.setBy ? ' · set by ' + esc(q.followUp.setBy) : '')
              + (q.followUp.reason ? ' — ' + esc(q.followUp.reason) : '');
          var fuCls = 'rqd-remaining rqd-remaining--followup rqd-followup-countdown rqd-tip-trigger'
            + (fuExpired ? ' rqd-followup-countdown--expired' : '');
          /* Ryan 2026-05-16: ⏰ dropped from the non-expired (count-down)
             variant — same reasoning as the hold countdown above. Bell
             stays on the expired variant. Tooltip variant follows the
             row's status: pending rows get the slate-themed tip; all
             other QUOTED-class rows (including in-progress '...') get
             the blue-themed quoted variant. */
          var fuInner = fuExpired
            ? '<span class="rqd-followup-bell" aria-label="Follow-up due">🔔</span>'
            : '<span class="rqd-followup-countdown__text">' + esc(formatHoldCountdown(q.followUp.dueAt)) + '</span>';
          var _fuTipVariant = (q.isPending || q.status === 'pending') ? 'pending' : 'quoted';
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — Follow-up countdown +
             unread-email envelope now COEXIST (envelope left, countdown right).
             The prior envelope-hides-countdown rule (this inline hide + the CSS
             `display:none`) was removed. */
          return wrap(icons, '<span class="' + fuCls + '" data-followup-until="' + esc(q.followUp.dueAt) + '" data-ref="' + esc(q.reference) + '" data-tip="' + fuTitle + '" data-tip-variant="' + _fuTipVariant + '" role="button" tabindex="0">' + fuInner + '</span>');
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_ANALYTICS_BY_CLAUDE (Ryan 2026-06-10) — woken-deal gap: a
           QUOTED/saved deal whose lead came OFF HOLD (auto-wake or customer
           reply) with no rep action since had NO bell anywhere — wake-on-reply
           clears the chase timer, and the OFF-HOLD bell above only renders on
           lead-state rows. q.wokenAwaiting is server-computed (untouched since
           wokeAt) and mirrors isMoneyMove, so this row also lands in MONEY
           MOVES. Bell clears the moment the rep saves / re-arms / sends. */
        if (q.wokenAwaiting) {
          var _wokenAgo2 = formatAwaitingElapsed(q.wokeAt);
          return wrap(icons, '<span class="rqd-remaining rqd-remaining--awaiting rqd-remaining--resumed-bell rqd-followup-countdown rqd-followup-countdown--expired rqd-tip-trigger" data-tip="Off hold ' + esc(_wokenAgo2) + ' ago — customer waiting, respond now" data-tip-variant="awaiting" data-awaiting-since="' + esc(q.wokeAt || '') + '" data-ref="' + esc(q.reference) + '" role="button" tabindex="0"><span class="rqd-followup-bell" aria-label="Off hold — respond">🔔</span></span>');
        }
        /* END CUSTOM_ANALYTICS_BY_CLAUDE */
        return wrap(icons, '');
      }

      var steps = getProgressSteps(q);
      var remaining = 0;
      for (var si = 0; si < steps.length; si++) { if (!steps[si].done) remaining++; }

      var reviewIcon = buildReviewIcon(q);
      // When everything is done, the ✓ moves to the LEFT side (ahead of any
      // review envelope) so the row reads "done first" rather than ending
      // with the checkmark floating off to the right. Right side stays
      // empty for closed rows. While work is still pending, the icons sit
      // on the left and the "N task(s) remain(s)" text on the right.
      if (remaining === 0) {
        var done = '<span class="rqd-remaining rqd-remaining--done">&#10003;</span>';
        return wrap(done + reviewIcon, '');
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Green progress
         fill replaces the "Nx admin" text counter for SOLD rows with
         remaining closeout work. Same data (done / total admin steps)
         but rendered as a left-to-right green fill that underlaps the
         icons + text in the cell. At 100% complete, the SOLD-or-closed
         branch's `remaining === 0` path above fires and renders the
         ✓ Closed pill instead. Both admin AND non-admin reps see the
         fill — gives non-admins a glanceable "how close to closed?"
         indicator they didn't have before. Replaces the prior split
         where admins saw "3x admin" text and non-admins saw nothing. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-10) — Count partial-step
         fractions toward the fill, not just fully-done steps. A 50/50 deal
         with only the deposit paid leaves the Paid step done:false but
         partial:~0.5 — the old (steps-remaining)/steps math scored it as 0
         green (empty bar) even though the order is genuinely ~1/(2·N) of the
         way done. Now each not-done step contributes its own `partial`
         fraction (0..1) and done steps contribute a full 1, so the bar reads
         the true completion (e.g. Paid-half of 4 steps → ~13%). (RW-1242-B) */
      var _fillPct = progressFillPct(q);
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Reps can set a
         follow-up on a SOLD-not-yet-closed deal (e.g. "ping installer
         next week", "confirm payment Friday"). Render the countdown /
         bell in the right text slot of wrap() — same green colour as
         the CLOSED row's follow-up via .rqd-row--sold .rqd-remaining
         --followup. Sits to the right of the partial green fill. */
      var _soldFu = _buildSoldFollowUpHtml(q);
      return wrap(icons + reviewIcon, _soldFu.html, _fillPct);
    }

    function buildDetailProgressBar(q) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — a REPLACEMENT reaches this surface too.
         Goods-committed, not sold: see RQD.dealGoodsAreCommitted in dashboard-claim-card.js for
         why the money surfaces (AR/AP, invoicing, commission) still ask the old question. */
      var isSoldOrClosed = q.lifecycleStatus === 'sold' || q.closedStatus === 'closed';
      if (!isSoldOrClosed && !window.RQD.dealGoodsAreCommitted(q)) return '';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Linked children skip the detail-panel
         progress tracker. Same reasoning as buildProgressBar above: the
         actual fulfillment progress (ordered → shipped → paid → invoiced)
         lives on the parent. Rendering a half-checked Paid/Ordered/Shipped
         tracker on the child is misleading. */
      if (q.linkedParentRef) return '';
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM⁴) — an externally linked deal skips
         it for the same reason, and Ryan caught it as a correctness bug before a colour one:
         "the order hasn't been ordered or shipped yet so not sure why those 2 are checked."

         They were checked VACUOUSLY. RW-1290-A was a held lead with no line items, so it has no
         vendors — and every ordered/shipped step passes trivially when there is nothing to
         order. Meanwhile the goods the customer actually bought are on SHOP-1922, where the real
         ordering and shipping happen. So the tracker was asserting, in green, that work was done
         that nobody has started.

         Ryan, twice now: fulfillment for these deals runs from the Online deals page. Same
         conclusion as the linked-child guard directly above, so it gets the same treatment
         rather than a second, subtly different rule. */
      if (hasExternalOrderLink(q)) return '';

      var steps = getProgressSteps(q);
      var done = 0;
      for (var si = 0; si < steps.length; si++) { if (steps[si].done) done++; }
      var isComplete = done === steps.length;

      var html = '<div class="rqd-progress-panel' + (isComplete ? ' rqd-progress-panel--complete' : '') + '" data-progress-ref="' + esc(q.reference) + '">';
      html += '<div class="rqd-progress-panel__bar">';
      for (var si = 0; si < steps.length; si++) {
        var s = steps[si];
        var stepClass = s.done ? ' rqd-progress-panel__step--done' : (s.partial ? ' rqd-progress-panel__step--partial' : '');
        html += '<div class="rqd-progress-panel__step' + stepClass + '">';
        if (s.partial && !s.done) {
          html += '<div class="rqd-progress-panel__seg rqd-progress-panel__seg--partial">';
          html += '<div class="rqd-progress-panel__seg-fill" style="width:' + Math.round(s.partial * 100) + '%"></div>';
          html += '</div>';
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Prefix partial steps with their label
             (e.g., "PO Sent 1/2" instead of bare "1/2") so the bar reads
             without needing context. Applies to bucket-progress + paid-amount
             fractions equally. */
          var _partialName = s.partialText ? (s.label + ' ' + s.partialText) : s.label;
          html += '<span class="rqd-progress-panel__name">' + _partialName + '</span>';
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        } else {
          html += '<div class="rqd-progress-panel__seg"></div>';
          html += '<span class="rqd-progress-panel__name">' + s.label + (s.done ? ' ✓' : '') + '</span>';
        }
        html += '</div>';
      }
      html += '</div>';
      html += '</div>';
      return html;
    }

    /** Phase 1.25 — Rebuild a PROSPECT row's To-Do cell (BANT chips on
        the left + follow-up countdown on the right). Mirrors the markup
        produced by _buildProspectRowPair so the cell stays consistent
        with the initial render. Used after a follow-up is added/edited
        on a prospect — refreshProgressBar (which is offline-quote-
        flavored) would otherwise insert quote-style markup that pushes
        the BANT chips to the wrong side. */
    function _refreshProspectTodoCell(p) {
      if (!p || !p.ref || !tbody) return;
      var row = tbody.querySelector('tr[data-ref="' + p.ref.replace(/"/g, '\\"') + '"]:not(.rqd-detail-row)');
      if (!row) return;
      var cell = row.querySelector('.rqd-col-progress .rqd-progress-cell');
      if (!cell) return;
      var d = p.discovery || {};
      cell.innerHTML = _buildBantSpan(d, p.prospectStage)
        + '<span class="rqd-progress-cell__text">' + _prospectFollowupBadge(p) + '</span>';
    }

    function refreshProgressBar(ref) {
      var q = allQuotes.find(function(x) { return x.reference === ref; });
      if (!q) return;
      // Phase 1.25 — Route prospect rows to the prospect-shaped cell
      // builder instead of the quote-shaped buildProgressBar (which
      // would prepend offline-flavor markup and break the BANT ↔
      // countdown layout). Detected via cfaCode (set on every prospect
      // by the worker; never set on rep-side leads/quotes).
      if (q.cfaCode && !q.handoffAt) {
        _refreshProspectTodoCell(q);
        return;
      }
      var row = tbody.querySelector('tr[data-ref="' + ref + '"]:not(.rqd-detail-row)');
      if (row) {
        // Swap the progress bar markup, leaving the cog button + actions menu
        // alone. Need to clean up every flavor of progress-cell content:
        //   - offline-flavor spans (.rqd-remaining, .rqd-review-icon)
        //   - online A/C-flavor wrappers (.rqd-progress-cell__icons /
        //     __text)
        //   - online B-flavor strip (.rqd-flow-cell)
        // Otherwise the new HTML gets prepended on top of the old → strips
        // duplicate every time a Shipping field is touched.
        var progressCell = row.querySelector('.rqd-progress-cell');
        if (progressCell) {
          progressCell.querySelectorAll(
            '.rqd-remaining, .rqd-review-icon, .rqd-progress-cell__icons, .rqd-progress-cell__text, .rqd-flow-cell'
          ).forEach(function(el) { el.remove(); });
          var newBarHtml = buildProgressBar(q);
          if (newBarHtml) progressCell.insertAdjacentHTML('afterbegin', newBarHtml);
        }
      }
      var panelBar = document.querySelector('[data-progress-ref="' + ref + '"]');
      if (panelBar) panelBar.outerHTML = buildDetailProgressBar(q);
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-23) — targeted status-pill flip for
       an optimistic close-out. Mirrors refreshProgressBar: rewrites ONLY the
       one row's status pill (text + colour class) and swaps the row's state class,
       so marking a deal Lost/Dead updates the pill the instant the save returns
       instead of waiting on the full-board fetchQuotes rebuild.
       Pill text/class come from dashboard-quote-row.js (statusClass/statusText for
       lsLabel==='lost' / isDeadLead). Skips the read-only Shopify/online pill — an
       online order's status is driven by Shopify, not /quote-lifecycle. The background
       fetch remains the source of truth and reconciles the detail panel + counts.
       (Ryan 2026-08-11) kind added so the composer's "Save & Mark Dead" gets the same
       instant flip the LOST modal has had — was lost-only. */
    function markStatusPillClosed(ref, kind) {
      var _isDead = kind === 'dead';
      var row = tbody.querySelector('tr[data-ref="' + ref + '"]:not(.rqd-detail-row)');
      if (!row) return;
      var pill = row.querySelector('.rqd-status');
      if (pill && !pill.classList.contains('rqd-status--readonly')) {
        pill.className = 'rqd-status rqd-status--' + (_isDead ? 'dead' : 'lost');
        pill.textContent = _isDead ? '💀 LEAD' : 'Lost';
      }
      ['rqd-row--quoted', 'rqd-row--awaiting', 'rqd-row--sold', 'rqd-row--hold',
       'rqd-row--sample', 'rqd-row--dead', 'rqd-row--lost', 'rqd-row--pending'].forEach(function(c) {
        row.classList.remove(c);
      });
      row.classList.add(_isDead ? 'rqd-row--dead' : 'rqd-row--lost');
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — render perf. Detail panels are
       built LAZILY (ensureDetailBuilt, on first expand) instead of eagerly for all
       ~200 rows, and rows are STREAMED in rAF batches on user-initiated loads so the
       top is clickable almost immediately. _renderedQById maps ref→q for the lazy
       build; _renderToken aborts a stale stream when a newer render starts. */
    var _renderedQById = {};
    var _renderToken = 0;
    function renderTable(quotes, opts) {
      // Hide the brand-list tooltip if it was visible before re-render —
      // the cell it was anchored to is about to be replaced, and without
      // this the tooltip would orphan with no mouseout to dismiss it.
      if (typeof hideBrandsTip === 'function') hideBrandsTip();
      // Bump the render token up front so this render aborts any in-flight stream
      // from a previous one — including the empty-results path below.
      var _myRenderToken = ++_renderToken;
      if (quotes.length === 0) {
        tbody.innerHTML = '';
        emptyEl.style.display = 'block';
        return;
      }

      tableWrap.style.display = '';
      /* CUSTOM_DDSEARCH_BY_CLAUDE (Ryan 2026-10-07) — rows on screen means the empty message goes.
         Only the loud fetch used to hide it, so after an instant search drew nothing, the quiet
         answer that found the deal painted it ABOVE "No deals found matching your filters." */
      emptyEl.style.display = 'none';
      tbody.innerHTML = '';

      // ── Group quotes by base ref (revision chains) ──
      // Collect all revisions per base ref, then split into parent groups.
      // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Standalones (online
      // orders like SHOP-1705, plus any non-suffixed ref) used to be pushed
      // into `groups` as a separate first pass, ahead of every chain entry.
      // Server sends rows date-sorted (desc by default), but that two-bucket
      // emit destroyed the order — online orders always pinned to the top of
      // the table regardless of date. Track a unified `slotOrder` so the
      // server's sort survives the chain dedup: each slot's position = the
      // position of its FIRST quote in the server-sorted stream.
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — REPLACEMENT ORDERS NEST, THEY DO
         NOT STAND ALONE. An RPL-* ref has its own base, so the chain grouping below would
         render it as a top-level deal line — inflating the board and inviting a rep to
         work it like live business. It is neither: it is a $0 re-ship hanging off a deal
         the customer already paid for.

         Pulled out here and re-attached inside _renderGroup as a child row, exactly the
         way revision children render. Keyed by the parent's BASE, not its full ref: the
         replacement is bound to JW-1129-F, but the row the board actually draws as the
         chain parent may be JW-1129-G. Keying on the full ref would make the replacement
         vanish the moment anyone added a revision. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — ⛔ EXCEPT ON THE REPLACEMENTS TAB,
         WHERE NESTING IS THE WHOLE PROBLEM. Nesting is right on a normal board: a $0
         re-ship is not live business and must not inflate the deal list. But it is also
         why an admin could not see their reps' replacements at all — every one of them
         was tucked inside a collapsed parent group. On the Replacements filter the rows
         ARE the subject, so they stay top-level.

         In practice the orphan-promotion below already achieves this (no parents are in a
         replacement-filtered list, so every child gets pushed back as standalone) — but
         only by accident of what the filter happens to return, and NOT while an admin is
         searching, because search bypasses the status filter server-side and drags the
         parents back in. Saying it outright is what makes it true in both cases. */
      var _replacementTabActive = (currentStatus === 'replacement');
      var _replacementsByParentBase = {};
      quotes = quotes.filter(function(q) {
        if (_replacementTabActive) return true;
        if (!q || !q.isReplacement || !q.replacementParentRef) return true;
        var pp = parseBaseRef(q.replacementParentRef);
        var pk = pp ? pp.base : q.replacementParentRef;
        (_replacementsByParentBase[pk] = _replacementsByParentBase[pk] || []).push(q);
        return false;
      });
      /* An orphan (parent outside the current filter/date window) must not disappear —
         it still represents goods we owe someone. Put it back as a standalone row. */
      var _replacementParentBasesPresent = {};
      quotes.forEach(function(q) {
        var pr = parseBaseRef(q.reference);
        var bk = pr ? pr.base : q.reference;
        _replacementParentBasesPresent[bk] = true;
        /* Stamp the children onto the deal's rows so buildDetailHtml can render the
           rep-facing "a replacement is in progress" strip without reaching back into
           renderTable's scope. Every revision of the deal carries it, which is correct:
           the replacement belongs to the DEAL, not to one revision of the paperwork. */
        if (_replacementsByParentBase[bk]) q._replacementChildren = _replacementsByParentBase[bk];
      });
      Object.keys(_replacementsByParentBase).forEach(function(pk) {
        if (_replacementParentBasesPresent[pk]) return;
        _replacementsByParentBase[pk].forEach(function(q) { quotes.push(q); });
        delete _replacementsByParentBase[pk];
      });

      var chains = {}; // baseRef → quote[]
      var slotOrder = []; // [{ kind: 'standalone', q } | { kind: 'chain', key }]
      quotes.forEach(function(q) {
        var parsed = parseBaseRef(q.reference);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — Deal grouping ("Same
           Deal" link): linked chains (different ref bases) collect under one
           key (the server-sent linkGroupId) so they render as ONE cascade. */
        var key = q.linkGroupId || (parsed ? parsed.base : null);
        if (!key) {
          slotOrder.push({ kind: 'standalone', q: q });
          return;
        }
        if (!chains[key]) {
          chains[key] = [];
          slotOrder.push({ kind: 'chain', key: key });
        }
        chains[key].push(q);
      });
      // Sort each chain by suffix A < B < C. For a deal group, order by the
      // server's base order index FIRST (primary base sorts last → becomes the
      // cascade parent), then revision suffix.
      Object.keys(chains).forEach(function(key) {
        chains[key].sort(function(a, b) {
          var ao = (typeof a.linkGroupOrderIndex === 'number') ? a.linkGroupOrderIndex : 0;
          var bo = (typeof b.linkGroupOrderIndex === 'number') ? b.linkGroupOrderIndex : 0;
          if (ao !== bo) return ao - bo;
          var pa = parseBaseRef(a.reference), pb = parseBaseRef(b.reference);
          var as = pa ? pa.suffix : '', bs = pb ? pb.suffix : '';
          return as < bs ? -1 : as > bs ? 1 : 0;
        });
      });

      // Build display groups: { parent: quote, children: quote[] }
      // Rules:
      //   - If any revisions are sold, each sold revision becomes a parent
      //     Unsold revisions become children of the nearest sold revision after them
      //     Unsold revisions after the last sold revision become children of that last sold one
      //   - If no revisions are sold, latest letter is the parent (original behavior)
      var groups = [];
      function isSold(q) { return q.lifecycleStatus === 'sold'; }

      slotOrder.forEach(function(slot) {
        if (slot.kind === 'standalone') {
          groups.push({ parent: slot.q, children: [] });
          return;
        }
        var revs = chains[slot.key];
        var soldIdxs = [];
        revs.forEach(function(q, i) { if (isSold(q)) soldIdxs.push(i); });

        if (soldIdxs.length === 0) {
          // No sold: latest letter is parent, rest are children (newest first)
          var parent = revs[revs.length - 1];
          var children = revs.slice(0, -1).reverse();
          groups.push({ parent: parent, children: children });
        } else {
          // Sold revisions become parents. Each unsold revision becomes a child of the
          // next sold revision after it. Unsold revisions after the last sold one attach
          // to that last sold revision.
          // Step 1: Create a parent entry for each sold revision
          var parentEntries = []; // { idx, parent, children[] }
          soldIdxs.forEach(function(si) { parentEntries.push({ idx: si, parent: revs[si], children: [] }); });
          // Step 2: Assign each unsold revision to the nearest sold revision after it
          for (var i = 0; i < revs.length; i++) {
            if (isSold(revs[i])) continue;
            // Find the first sold revision with idx > i
            var assigned = false;
            for (var p = 0; p < parentEntries.length; p++) {
              if (parentEntries[p].idx > i) { parentEntries[p].children.push(revs[i]); assigned = true; break; }
            }
            // No sold revision after this one — attach to the last sold revision
            if (!assigned) parentEntries[parentEntries.length - 1].children.push(revs[i]);
          }
          var merged = parentEntries;
          // Sort children within each bucket: newest suffix first
          merged.forEach(function(b) {
            b.children.sort(function(a, bb) {
              var sa = parseBaseRef(a.reference).suffix;
              var sb = parseBaseRef(bb.reference).suffix;
              return sb < sa ? -1 : sb > sa ? 1 : 0;
            });
            groups.push(b);
          });
        }
      });

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-30) — Surface a buried Money
         Moves bell onto its cascade's VISIBLE parent. When a ringing row
         collapses under a parent that doesn't itself ring — e.g. a linked
         "Same Deal" group whose primary chain has a SOLD revision that becomes
         the cascade parent (sold JW-1129-F burying the active, linked RW-1117-A)
         — the server's deal-group hoist can't place the bell there (it only
         hoists to an ACTIVE primary, else leaves it on the ringing member, which
         the client then buries). Result: the 🔔 vanished from the table while the
         Money Moves pill still counted the group (badge 26 vs 25 visible). Reusing
         the SAME _groupBellShow/_groupBellHide render paths the deal-group hoist
         uses, move a ringing child's bell onto the parent the client actually
         renders. Operates on the real parent/children, so it also covers the
         multi-sold variants the server can't replicate. */
      groups.forEach(function(g) {
        var p = g.parent;
        var parentRings = (p.isMoneyMove || p._groupBellShow) && !p._groupBellHide;
        if (parentRings || p._groupBellHide) return;
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-18) — never hoist onto a parent that is
           RESTING ON ITS OWN TIMER. An ON HOLD row is not a silent row with a free To Do cell:
           it is showing a countdown the rep deliberately set, and the _groupBellShow branch is
           checked BEFORE the isOnHold branch, so a hoisted bell REPLACES that countdown. On
           RW-1320-A that made the 🔔 unclearable — Ryan pushed the follow-up to 8/20, the cell
           kept ringing, and no edit to the parent could help because the bell belonged to the
           linked RW-1295-A underneath it.

           ⚠️ NOT the same as the SOLD parent this hoist was written for (sold JW-1129-F burying
           the active RW-1117-A): a sold row has no timer of its own and the linked deal really
           does need attention, so that case still hoists. The server now also rests a group whose
           primary is held, so this is the second line of defence rather than the only one — it
           still matters for a child ringing on the freight/install-unsent override, which
           deliberately outranks a hold. The child keeps its own bell when the cascade is
           expanded, and the parent's left-slot truck/wrench icon still flags the add-on. */
        if (p.isOnHold) return;
        var hoisted = false;
        g.children.forEach(function(c) {
          if ((c.isMoneyMove || c._groupBellShow) && !c._groupBellHide) {
            c._groupBellHide = true; // collapse the buried child to a muted 🔗 chip
            hoisted = true;
          }
        });
        if (hoisted) p._groupBellShow = true; // exactly one bell, on the visible parent
      });

      // ── Build rows ──
      var colspan = 11;

      // buildQuoteRow + DIT moved to assets/dashboard-quote-row.js (Phase B.3.b SURGICAL, 2026-05-23).
      // Renders a single quote <tr> via window.RQD.buildQuoteRow(q, extraRefHtml, extraClass, parentQ).

      function buildDetailRow(q) {
        var isPending = q.isPending || q.status === 'pending';
        var isDeadLead = !!q.isDeadLead;
        var isSample = !!q.isSample;
        var isOnHold = !!q.isOnHold;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Mirror the main-row
           gate at buildQuoteRow (~L5466). isAwaiting keys off chainLastSavedAt
           (rep-engagement marker), not chainHasItems. Customer-RFQ rows arrive
           with customer-added items but no rep save; expand panel must theme
           orange/yellow (NEW LEAD) until rep saves content edits. */
        var _baseClear = !isPending && !isDeadLead && !isSample && !isOnHold && !q.lifecycleStatus && !q.chainQuoted && !(q.chainPdfDownloaded || q.pdfDownloaded);
        var _hasQuoteItems = (parseFloat(q.total) || 0) > 0;
        var _chainHasItemsDR = !!q.chainHasItems || _hasQuoteItems;
        var _isFreshCustomerRfqDR = (q.chainFromCustomerRfq || q.fromCustomerRfq) || q.status === 'submitted' || q.status === 'under_review';
        var isAwaiting = _baseClear && _isFreshCustomerRfqDR && !q.chainLastSavedAt;
        var isInProgress = _baseClear && !isAwaiting && (_chainHasItemsDR || q.chainLastSavedAt);
        var lsLabel = isPending ? 'pending' : isDeadLead ? 'dead' : isSample ? 'sample' : isOnHold ? 'hold' : isAwaiting ? 'awaiting' : isInProgress ? 'in-progress' : (q.lifecycleStatus || 'quoted');
        var statusClass = isPending ? 'pending' : isDeadLead ? 'dead' : isSample ? 'sample' : isOnHold ? 'hold' : isAwaiting ? 'awaiting' : isInProgress ? 'quoted' : (lsLabel === 'expired' ? 'expired' : lsLabel === 'sold' ? 'sold' : lsLabel === 'lost' ? 'lost' : (q.closedStatus === 'closed' ? 'closed' : 'quoted'));
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — Pending now uses the
           STANDARD detail layout (3-col grid: Sold To / Financials / Commission,
           Activity full-width below), not the old `rqd-detail--pending` 2-col
           [Sold To | Activity] grid that stacked the placeholder cards vertically
           under Sold To. */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-08) — A cancelled deal
           themes its detail panel like LOST (red cards), regardless of its
           prior sold/quoted lifecycle. Checked first so it overrides the
           status-derived class (which otherwise fell through to blue quoted). */
        var detailStatusClass = q.cancelled ? 'rqd-detail--lost' : (isPending ? 'rqd-detail--quoted rqd-detail--pending-tint' : statusClass === 'dead' ? 'rqd-detail--dead' : statusClass === 'sample' ? 'rqd-detail--sample' : statusClass === 'hold' ? 'rqd-detail--hold' : statusClass === 'awaiting' ? 'rqd-detail--awaiting' : statusClass === 'sold' ? 'rqd-detail--sold' : statusClass === 'lost' ? 'rqd-detail--lost' : 'rqd-detail--quoted');
        var detailTr = document.createElement('tr');
        detailTr.className = 'rqd-detail-row';
        detailTr.dataset.detailRef = q.reference;
        var detailSourceClass = q.source === 'online' ? ' rqd-detail--online' : '';
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Add rqd-detail--no-commission when the
           Commission card won't render, so the top grid drops from 3-col
           to 2-col and the remaining Sold To + Financials cards take the
           freed space (no awkward gap on the right). Three triggers:
             1. q.source === 'online' (already handled via the --online class,
                but kept here for the unified gate)
             2. q.linkedParentRef set (linked-child rows)
             3. Rep doesn't earn commission AND no referral attached (commission
                card was just rendering "n/a" rows, now hidden entirely) */
        var _noCommRepEarns = q.repEarnsCommission !== false;
        var _noCommHasReferral = !!q.referralName && parseFloat(q.referralAmount || 0) > 0;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Phase 3.5 Phase 1.5:
           Online code-attributed rows now DO get a commission card (the
           "Rep Commission (Code Attribution)" card). Admin gets the
           editable leadSource dropdown; reps see the same card read-only
           (per locked decision "Rep edit power: Read-only"). Either way,
           exclude from the no-commission shrink so the grid stays 3-col
           and the card occupies the third slot beside Sold To +
           Financials. Class `rqd-detail--has-attr-commission` (added
           below) also overrides the `--online` 2-col rule. */
        var _hasAttrCommCard = q.source === 'online'
          && q.attribution && q.attribution.method === 'discount-code';
        var _noCommissionCard = (q.source === 'online' && !_hasAttrCommCard)
          || !!q.linkedParentRef
          || (!_noCommRepEarns && !_noCommHasReferral);
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Lead rows (NEW
           LEAD / SAMPLE / ON HOLD / DEAD) don't render a Commission card —
           the Form Submission card replaces the Financials + Commission
           cards and is rendered with grid-column: span 2 in the qIsLead
           branch. Forcing the 2-col --no-commission grid here breaks that
           layout: Sold To shrinks to 50%, Form Submission's span 2 wraps
           to its own row at 100%. Skip the shrink for lead-shaped rows so
           the default 3-col grid stays put (Sold To 1/3 + Form Submission
           2/3, same row, matched heights). */
        var _qIsLeadShape = q.isLead || q.status === 'new_lead'
          || q.isDeadLead || q.status === 'dead_lead'
          || q.isSample || q.status === 'sample'
          || q.isOnHold || q.status === 'on_hold';
        var detailNoCommissionClass = (_noCommissionCard && !_qIsLeadShape) ? ' rqd-detail--no-commission' : '';
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Phase 3.5 Phase 1.5:
           Has-attribution-commission class. Overrides .rqd-detail--online's
           default 2-col grid so the third card (Rep Commission for code-
           attributed online sales) sits beside Sold To + Financials. CSS
           rule lives in dashboard.css alongside the other grid overrides. */
        var detailAttrCommClass = _hasAttrCommCard ? ' rqd-detail--has-attr-commission' : '';
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Add rqd-detail--linked class on linked
           children so the panel chrome (cards, inputs, buttons, dividers,
           section titles) gets a distinct pink-on-navy theme instead of
           inheriting the SOLD green palette. Linked rows are technically
           sold but they're conceptually pieces of a parent's deal — the
           visual signal helps admin keep them mentally separate. */
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM²) — an externally linked deal gets
           the purple linked theme too. Ryan: expanding RW-1290-A "everything is green as opposed
           to going with the purple linked colour theme that we used on RW-1126-A". The row pill
           already read LINKED; this is the panel catching up. Same shared predicate, so the two
           can't diverge again. */
        var detailLinkedClass = (q.linkedParentRef || hasExternalOrderLink(q)) ? ' rqd-detail--linked' : '';
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — LAZY detail. Leave the
           panel EMPTY; the heavy buildDetailHtml (Sold To / Financials / Commission /
           Order Contents / Purchasing / AR-AP / Activity / Shipping) is built only on
           first expand via ensureDetailBuilt. Container keeps its id + state classes
           so toggleDetail / restoreExpandedRow find it; q is stashed for the build;
           applyCollapseState runs in ensureDetailBuilt once content exists. */
        detailTr.innerHTML = '<td colspan="' + colspan + '"><div class="rqd-detail ' + detailStatusClass + detailSourceClass + detailNoCommissionClass + detailAttrCommClass + detailLinkedClass + '" id="rqd-detail-' + esc(q.reference) + '" data-detail-built="0"></div></td>';
        _renderedQById[q.reference] = q;
        return detailTr;
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — which group draws each deal's
         replacement rows. A multi-sold chain yields several groups sharing one base; only
         the LAST of them (the most recent sale) carries the replacements, or the row is
         drawn once per sold revision with duplicate DOM ids. Keyed by base → the group
         OBJECT so the check is identity, not position. */
      var _replCarrierGroup = {};
      groups.forEach(function(g) {
        var p = parseBaseRef(g.parent.reference);
        var b = p ? p.base : g.parent.reference;
        if (_replacementsByParentBase[b]) _replCarrierGroup[b] = g;
      });

      _renderedQById = {};
      function _renderGroup(g) {
        var totalVersions = g.children.length + 1;
        var parsedParent = parseBaseRef(g.parent.reference);
        var groupKey = parsedParent ? parsedParent.base + ':' + parsedParent.suffix : g.parent.reference;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — replacement children for this deal
           (see the split above). They share the revision-child chrome and the same expand
           toggle, so one badge opens everything hanging off the deal.

           ⛔ ONE CARRIER GROUP, NOT EVERY GROUP THAT SHARES THE BASE (fixed 2026-08-22).
           A chain with TWO SOLD revisions produces one group PER sold revision (see the
           group builder above), and every one of them parses to the SAME base — so reading
           the map directly handed the same replacement to each, and the row rendered twice
           with two elements sharing id="rqd-detail-RPL-1001-A". getElementById returns the
           first, so expanding the second row toggled the first row's panel; three sold
           revisions gave three copies. `_replCarrierGroup` (built once, below the group
           builder) names the LAST group for each base — the most recent sale, which is
           where a replacement reads right — and only that group draws it. Identity
           comparison, not an index, so it does not depend on the streaming batch order. */
        var _repl = (parsedParent && _replCarrierGroup[parsedParent.base] === g
          && _replacementsByParentBase[parsedParent.base]) || [];
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-11) — auto-cascade-open RETIRED.
           It existed (2026-06-08) so bells hidden under a collapsed parent stayed
           visible; the one-bell-per-chain rule (worker: follow-up timers migrate to
           the top revision, woken + re-send bells hoist/suppress to top-only) means
           a child revision can never carry a bell anymore, so there's nothing to
           reveal. Chains render collapsed; the version badge toggles them manually. */
        var _autoOpen = false;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — ⛔ THE REPLACEMENT IS NOT HIDDEN
           BEHIND THE BADGE. It used to be counted here and rendered with the collapsed
           revisions, so seeing RPL-1003-A meant clicking "+7" and scrolling past JW-1129-E,
           -D, -C… — every superseded draft — to reach the one row that represents goods we
           still owe a customer. Ryan: "both should be visible on the DD without having to
           expand the main parent order".
           It now renders directly under the parent, always open, and the badge counts only
           what it actually hides: the revisions. +7 becomes +6. */
        var _hiddenCount = g.children.length;
        var badgeHtml = _hiddenCount > 0
          ? ' <span class="rqd-version-badge' + (_autoOpen ? ' rqd-version-badge--open' : '') + '" data-revision-group="' + esc(groupKey) + '">+' + _hiddenCount + '</span>'
          : '';

        // Parent row, then its detail row immediately after
        // buildQuoteRow lives in dashboard-quote-row.js (Phase B.3.b SURGICAL).
        var tr = window.RQD.buildQuoteRow(g.parent, badgeHtml, '');
        if (_autoOpen) tr.classList.add('rqd-group-open', 'rqd-group-top');
        tbody.appendChild(tr);
        tbody.appendChild(buildDetailRow(g.parent));

        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — ⛔ REPLACEMENTS RIDE DIRECTLY UNDER
           THE PARENT, ALWAYS VISIBLE. Rendered here — before the revisions, not after them —
           so the row sits immediately beneath the deal it belongs to.

           ⛔ NO `data-revision-group` and NO `--hidden`. That dataset is what the +N badge
           toggles; carrying it would let a collapse hide the row again, which is the whole
           thing being fixed. Without it the badge cannot touch this row, so it stays put
           whether the chain is open or shut.

           ⛔ AND IT MOVES WITH THE DEAL FOR FREE. Ryan: "if JW-1129-F were to hypothetically
           become JW-1129-G and move higher up on the DD, then RPL-1003-A would move with it,
           staying just under it in lock step." That falls out of rendering inside the group
           rather than as a sibling row — the group is placed by its parent's position, and
           this appends into it. It is also why the map is keyed on the parent's BASE and not
           its full ref (see the split above): a new revision changes the ref, never the base.

           Keeps `rqd-revision-row` for the 24px indent, so it still reads as belonging to
           the deal above it rather than as a second top-level order. */
        _repl.forEach(function(rq) {
          var rTr = window.RQD.buildQuoteRow(rq, '', 'rqd-revision-row rqd-replacement-row', g.parent);
          tbody.appendChild(rTr);
          tbody.appendChild(buildDetailRow(rq));
        });
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

        // Children sub-rows (newest-first), below parent's detail. Hidden by default;
        // shown immediately when _autoOpen so the bell-bearing rows are visible.
        var _lastChildIdx = g.children.length - 1;
        g.children.forEach(function(childQ, _ci) {
          var subTr = window.RQD.buildQuoteRow(childQ, '', 'rqd-revision-row' + (_autoOpen ? '' : ' rqd-revision-row--hidden'), g.parent);
          subTr.dataset.revisionGroup = groupKey;
          if (_autoOpen) {
            subTr.classList.add('rqd-group-open');
            if (_ci === _lastChildIdx) subTr.classList.add('rqd-group-bottom');
          }
          tbody.appendChild(subTr);
          tbody.appendChild(buildDetailRow(childQ));
        });

        /* ⛔ The replacement rows used to render HERE, last and hidden, sharing the revisions'
           expand toggle. Moved above the children 2026-08-22 — see the block after the parent
           row. Nothing renders after the revisions any more. */
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — stream rows in rAF batches on
         user-initiated loads (opts.stream) so the top of the list is visible +
         clickable almost immediately instead of after the whole table builds. Quiet
         background refreshes render synchronously (so scroll + re-expand are exact).
         A newer render (token bump) aborts an in-flight stream. */
      var _stream = !!(opts && opts.stream) && groups.length > 30;
      var _gi = 0;
      function _renderRange(n) {
        var end = Math.min(_gi + n, groups.length);
        for (; _gi < end; _gi++) _renderGroup(groups[_gi]);
      }
      if (!_stream) {
        _renderRange(groups.length);
        return;
      }
      _renderRange(24); // first batch fills the viewport + is clickable immediately
      (function _step() {
        if (_myRenderToken !== _renderToken) return; // a newer render took over
        if (_gi >= groups.length) return;
        _renderRange(24);
        requestAnimationFrame(_step);
      })();
    }

    // ── Purchase Orders (helper renderers) ──
    // PO vendor-row HTML builder lives in assets/dashboard-po-lens.js (extracted
    // to keep this section under Shopify's 256 KB limit).
    function renderPoVendorRow(q, vendor, pos) {
      return window.dashboardPoLens
        ? window.dashboardPoLens.renderVendorRow(q, vendor, pos, { esc: esc, money: money, formatDate: formatDate })
        : '';
    }
    /* CUSTOM_PAYTERMSGATE_BY_CLAUDE (AIOPS `87238b70d3ee`, 2026-09-18) — the terms + balance row,
       published on RQD as well so the Fulfillment / Tracking card draws the SAME row from the same
       verdict rather than restating the rule beside its own pickup controls. */
    function renderPaymentGateRow(q) {
      return (window.dashboardPoLens && window.dashboardPoLens.paymentGateRow)
        ? window.dashboardPoLens.paymentGateRow(q, { esc: esc })
        : '';
    }
    window.RQD = window.RQD || {};
    window.RQD.renderPaymentGateRow = renderPaymentGateRow;

    // === Phase B.1.a (2026-05-22) — pallet form helpers extracted to dashboard-shipping-cards.js ===
    function renderFreightBalancePalletRow(p, isFirst) { return window.RQD.renderFreightBalancePalletRow(p, isFirst); }
    function renderFreightBalancePalletForm(ref, existing, vendor) { return window.RQD.renderFreightBalancePalletForm(ref, existing, vendor); }

    // === Phase B.1.a (2026-05-22) — renderShippingBucketPanel + renderFreightBalanceCard
    //     extracted to dashboard-shipping-cards.js. Bucket panel has no external
    //     call sites in main.js (only called by renderFreightBalanceCard, now in module)
    //     so it's gone entirely. Balance card keeps a one-line stub below for its
    //     two call sites inside buildDetailHtml. ===
    function renderFreightBalanceCard(q) { return window.RQD.renderFreightBalanceCard(q); }

    // ── Detail Panel ──

    // Slugify a section title to a stable identifier used for collapse-state
    // bookkeeping. "AR / AP" → "ar-ap", "Order Contents" → "order-contents".
    // === Phase B.1.b (2026-05-22) — order/balance cards + collapse helpers extracted to dashboard-order-cards.js ===
    //     sectionSlug + shouldAutoCollapse are internal to that module (no external callers) so deleted entirely.
    //     Five stubs below preserve the external call sites.
    function isOrderFullyFulfilled(q) { return window.RQD.isOrderFullyFulfilled(q); }
    function applyCollapseState(detailEl, q) { return window.RQD.applyCollapseState(detailEl, q); }
    function renderOrderContentsCard(items, fees, opts) { return window.RQD.renderOrderContentsCard(items, fees, opts); }
    function renderBalanceReconciliationCard(q, isAdmin) { return window.RQD.renderBalanceReconciliationCard(q, isAdmin); }
    function sectionTitleHtml(label, done) { return window.RQD.sectionTitleHtml(label, done); }

    function buildDetailHtml(q) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Deal Prospecting
         records (CFA-owned leads) get a purpose-built detail panel:
         Discovery (BANT) card, Activity log, Follow-up, Handoff button.
         Detected by cfaCode + prospectStage presence. The rep-side
         buildDetailHtml below renders everything else (quotes + leads). */
      if (q && q.cfaCode && q.prospectStage) {
        return buildProspectDetailHtml(q);
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var fin = q.financials || {};
      var isPend = q.isPending || q.status === 'pending';
      var isLead = q.isLead || q.status === 'new_lead';
      var isDeadLead = !!q.isDeadLead;
      var isSample = !!q.isSample;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Admin viewing a
         code-attributed online row from the Offline tab should see the
         rep's read-only mirror, not the admin power-user view (admin
         manages these from the Online Deals tab). _treatAsRepView ==
         true here flips Summary card on / hides AR-AP + Purchasing +
         Installation admin cards / etc. _effectiveAdmin stays true for
         OFFLINE quotes admin is viewing (full admin view), and for
         admin on Online/All tabs. */
      var _treatAsRepView = isAdmin && q.source === 'online' && currentSource === 'offline';
      var _effectiveAdmin = isAdmin && !_treatAsRepView;
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var isOnHold = !!q.isOnHold;
      // === Phase B.3.a (2026-05-23) — Mobile actions row (cog menu) extracted to dashboard-detail-shell.js ===
      // The mobile-actions block was the only consumer of the prior
      // _hasQuoteItemsDH / _pdfDoneDH / _isFreshLeadDH locals (progressed-
      // lead detection); the module recomputes them internally from q.
      var html = window.RQD.buildMobileActions(q);

      // === Phase B.3.a (2026-05-23) — Linked-child banner extracted to dashboard-detail-shell.js ===
      html += window.RQD.buildLinkedChildBanner(q);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — on the PARENT deal, a one-line
         "a replacement is in progress" strip. This is the rep's answer to "when does my
         customer get their stuff" and carries NO claim data: the claim is our money and
         runs on a different clock (see dashboard-claim-card.js). */
      if (window.RQD && window.RQD.renderReplacementStrip) html += window.RQD.renderReplacementStrip(q);

      // === Phase B.3.a (2026-05-23) — Balance chain banner extracted to dashboard-detail-shell.js ===
      html += window.RQD.buildBalanceChainBanner(q);

      html += '<div class="rqd-detail__grid">';
      /* CUSTOM_PAYMENTCHECK_BY_CLAUDE (ONYX e27ee0c84a87) - the payment check, first: while it is held
         nothing else on the order can move. Admin only; '' when there is no check or it is clear. */
      if (window.RQD && window.RQD.renderPaymentCheckCard) html += window.RQD.renderPaymentCheckCard(q);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — the recovery-claim panel, first card
         on a replacement order's panel. Admin-only; self-gates to '' otherwise. */
      if (window.RQD && window.RQD.renderClaimCard) html += window.RQD.renderClaimCard(q);
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — the claim paperwork launcher,
         directly under the claim it belongs to. Self-gates to '' for non-admins, for
         anything that isn't a replacement, and for a replacement not chasing a carrier. */
      if (window.RQD && window.RQD.renderClaimDocsCard) html += window.RQD.renderClaimDocsCard(q);

      // === Phase B.2.a (2026-05-22) — Sold To / Ship To / Bill To column extracted to dashboard-customer-columns.js ===
      //     qIsPending passed verbatim — preserves the pre-existing hoisting bug at this call site
      //     (qIsPending is read here BEFORE its var declaration ~120 lines below, so it is undefined
      //     and PENDING rows do not actually get the comment-promised span-3 treatment). Flagged in
      //     the module header for a follow-up ship to fix.
      html += window.RQD.buildCustomerColumn(q, { qIsPending: qIsPending });

      // Column 2+3: Pending = Notes card, Lead = form-submission detail, otherwise Financials + Commission
      var qIsPending = q.isPending || q.status === 'pending';
      // Dead, Sample, and On-Hold leads still surface the form-submission
      // detail card — rep needs to read the customer's selections (samples),
      // message (dead), or schedule notes (on hold) before deciding to engage.
      var qIsLead = q.isLead || q.status === 'new_lead' || q.isDeadLead || q.status === 'dead_lead' || q.isSample || q.status === 'sample' || q.isOnHold || q.status === 'on_hold';
      if (qIsLead) {
        // === Phase B.2.b (2026-05-23) — Lead detail card extracted to dashboard-lead-detail.js ===
        //     Renders the full Form Submission / CFA Handoff card (NEW LEAD / SAMPLE /
        //     DEAD / ON HOLD rows). 370 LOC moved out of buildDetailHtml.
        html += window.RQD.buildLeadDetail(q);
        // Notes card now renders universally for every non-Pending detail
        // panel — see the buildDetailProgressBar(q) call further down.
      } else if (qIsPending) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — Pending deals now use the
           STANDARD detail layout (Sold To / Financials / Commission on top,
           Activity below) instead of their old one-off arrangement. There's no
           quote yet, so Financials + Commission render a short placeholder. */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — pencil to edit deal
           terms on a PENDING deal (it can't reach the QW until a quote is
           built). Mirrors the Sold To pencil; opens __openEditTerms. */
        var _pendTermsPencil = '<button type="button" class="rqd-edit-terms-pencil" data-edit-terms-ref="' + esc(q.reference) + '" title="Edit deal terms" aria-label="Edit deal terms" style="background:none;border:none;cursor:pointer;padding:2px 6px;margin-left:6px;color:var(--rq-text-secondary);font-size:13px;vertical-align:middle;line-height:1;">&#9998;</button>';
        html += '<div class="rqd-detail__card">';
        html += '<div class="rqd-detail__section-title">Financials' + _pendTermsPencil + '</div>';
        html += '<div class="rqd-detail__linked-stub">Quote required for financials. Use the &#9998; to set Deal Type, referral, CFA, payment terms, lead time &amp; expiration before building the quote.</div>';
        html += '</div>';
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-23) — ⛔ NO COMMISSION CARD ON A PENDING. The placeholder
           that stood here ("Quote required for commission.") was the card Ryan saw, not buildCommissionCard,
           which this branch never calls. Ryan: *"we don't need it to exist on PENDING deals."* */
      } else if (q.linkedParentRef) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Linked children skip the full
           Financials card. Revenue/COGS/freight/install/profit math for
           this deal live on the PARENT (substituted, if admin toggled
           Use Child's Items). Showing the child's per-quote P&L here
           would either duplicate or contradict the parent's view. */
        html += '<div class="rqd-detail__card">';
        html += '<div class="rqd-detail__section-title">Financials</div>';
        html += '<div class="rqd-detail__linked-stub">See <a class="rqd-detail__linked-stub-link" href="#" data-jump-to-parent="' + esc(q.linkedParentRef) + '"><strong>' + esc(q.linkedParentRef) + '</strong></a> for full deal financials.</div>';
        html += '</div>';
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      } else {
        // === Phase B.3.a (2026-05-23) — Financials default-branch card extracted to dashboard-detail-shell.js ===
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — show the Edit Deal Terms
           pencil on quoted + in-progress ('...') pre-sale deals only. Computed
           from q here (NOT renderTable's statusClass, which is out of scope in
           buildDetailHtml): exclude sold/lost/expired/closed/online, and require
           a real quote/draft signal so AWAITING (bare RFQ, no wm/pending) is
           excluded too. */
        var _canEditTerms = q.source !== 'online'
          && q.lifecycleStatus !== 'sold' && q.lifecycleStatus !== 'lost' && q.lifecycleStatus !== 'expired'
          && q.closedStatus !== 'closed'
          && (q.lifecycleStatus === 'quoted' || !!q.chainQuoted || !!q.pdfDownloaded || !!q.chainPdfDownloaded || !!q.chainLastSavedAt);
        html += window.RQD.buildFinancialsCard(q, { canEditTerms: _canEditTerms });

        // === Phase B.2.d (2026-05-23) — Offline Commission card extracted to dashboard-sample-commission.js ===
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — ⛔ NO COMMISSION CARD ON A REPLACEMENT.
           Nobody is paid for a $0 re-ship: `commissions.js` returns [] on an RPL- ref, and the
           whole feature exists so a rep's payout is untouched by goods we replace. A card
           computing $0 against a $0 order is not information, it is an invitation to wonder
           whether something is broken. Ryan: "drop the COMMISSION card from replacement
           orders — n/a". */
        /* ⛔ REVISED (Ryan 2026-08-22, same afternoon): dropped for the ADMIN only, because
           that is where the Recovery Claim card takes the slot. A REP never sees the claim
           card — it is admin-only by design, and has been since the feature shipped — so
           removing Commission there just left their panel a card short. Ryan: "from the reps
           POV — you can keep the commission card as the 3rd, and just have it say $0."
           Keyed on `isAdmin`, the same flag the claim card's own gate reads (via getIsAdmin),
           so the two decisions cannot disagree about who is looking. */
        if (!(q.isReplacement && isAdmin)) html += window.RQD.buildCommissionCard(q);
      }

      // === Phase B.2.d (2026-05-23) — Commission Code Attribution card extracted to dashboard-sample-commission.js ===
      html += window.RQD.buildCommissionCodeAttribution(q);

      html += '</div>'; // close grid

      // ── Progress bar (full-width, below cards, sold/closed only) ──
      html += buildDetailProgressBar(q);

      // === Phase B.2.e (2026-05-23) — Activity card extracted to dashboard-activity-card.js ===
      //     ~775 LOC moved out. Universal Activity log card — composer (chips
      //     + textarea + follow-up cluster), DEAL FEED entries loop (notes /
      //     system transitions / Outlook emails / sample shipments / workflow
      //     events), and LINKED FILES sidecar. Largest of all the Phase B
      //     extractions.
      html += window.RQD.buildActivityCard(q, { isPend: isPend });

      // ORDER CONTENTS — admin-only. Sits below the progress tracker so
      // the customer/financial/progress reading flow stays at the top, then
      // the line-item breakdown shows what was actually purchased / quoted /
      // requested before the AR/AP / Purchasing / Shipping cards.
      //   Online orders: items already present in q.onlineLineItems (eager).
      //   Offline orders (any lifecycle state — quoted, sold, lost, new lead,
      //     pending): lazy-load via /quote-details on first expand. Placeholder
      //     renders now, gets replaced when the fetch resolves and
      //     q.offlineLineItems is populated. The render also collapses
      //     itself if the fetch returns no items, so pending leads without
      //     items don't show an empty card.
      // Show Order Contents when the quote has actual dollars on it. Status
      // (NEW LEAD vs QUOTED vs SOLD) doesn't matter — what matters is whether
      // there's anything to render. A NEW LEAD that the rep started building
      // (added items, total > 0) gets the card; an empty NEW LEAD or PENDING
      // doesn't. This is dynamic — re-collapsing and re-expanding the row
      // after the rep adds items will surface the card.
      var _ocPending = q.isPending || q.status === 'pending';
      var _ocAmount = parseFloat(q.total) || 0;
      if (!_ocPending && _ocAmount > 0) {
        var _ocItems = null;
        var _ocLoading = false;
        if (q.source === 'online' && Array.isArray(q.onlineLineItems) && q.onlineLineItems.length > 0) {
          _ocItems = q.onlineLineItems;
        } else if (hasExternalOrderLink(q) && _linkedOrderItems(q)) {
          /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM⁵) — Ryan: "it just says
             'Loading order contents...' forever, and never loads. Shouldn't it pull in from the
             ONLINE deal?" Yes. An externally linked deal has no line items of its own — the goods
             the customer bought are on the Shopify order — so /quote-details had nothing to
             return. Borrow the linked order's items instead.

             No extra request: admins always fetch BOTH source pools (quote-dashboard.js ~L967, so
             the balance rollup can pair cross-source rows), which means the order row is already
             sitting in allQuotes. */
          _ocItems = _linkedOrderItems(q);
        } else if (q.source !== 'online') {
          if (Array.isArray(q.offlineLineItems) && q.offlineLineItems.length > 0) {
            _ocItems = q.offlineLineItems;
          } else if (window.__orderContentsCache && Array.isArray(window.__orderContentsCache[q.reference]) && window.__orderContentsCache[q.reference].length > 0) {
            /* Ryan 2026-05-21: cache fallback. fetchQuotes() wipes
               q.offlineLineItems when it rebuilds allQuotes from the
               server response, so the 2-min auto-refresh resets every
               expanded LINKED order to the "Loading…" placeholder.
               The module-level cache (populated by the lazy-load
               success handler) survives across re-renders. */
            _ocItems = window.__orderContentsCache[q.reference];
            // Hydrate qq for future renders in this session
            q.offlineLineItems = _ocItems;
          } else {
            _ocLoading = true;
          }
        }
        if (_ocItems) {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Surface
             lifecycle.freightBalance.dims to the Order Contents card so
             the offline "Log dims" affordance can flip its label between
             "Log dims" and "Edit dims" based on whether retroactive
             dims have already been captured for this ref. Prefer groups
             over the expanded pallets[] array (matches Edit Dims flow). */
          var _ocFbDims = (q.freightBalance && q.freightBalance.dims) || null;
          var _ocExistingDims = null;
          if (_ocFbDims && typeof _ocFbDims === 'object') {
            _ocExistingDims = (Array.isArray(_ocFbDims.groups) && _ocFbDims.groups.length > 0)
              ? _ocFbDims.groups
              : (Array.isArray(_ocFbDims.pallets) ? _ocFbDims.pallets : null);
          }
          html += renderOrderContentsCard(_ocItems, q.financials || {}, {
            isOnline: q.source === 'online',
            isAdmin: isAdmin,
            ref: q.reference,
            lineVendorOverrides: q.lineVendorOverrides || {}, // CUSTOM_ALTSOURCE_BY_CLAUDE
            /* CUSTOM_AUTOFREIGHT_BY_CLAUDE (Ryan 2026-08-28) — per-vendor shipment weight verdicts
               from the worker, so the card can attribute an auto freight-quoted line and flag a
               vendor whose weight could not be evaluated. ⚠️ Passed on BOTH render paths: the
               lazy Order Contents re-render builds its own opts, and a field missed there
               disappears the moment the card refreshes (the same trap the credit row hit). */
            autoFreightByVendor: q._autoFreightByVendor || {},
            /* CUSTOM_AUTOFREIGHT_BY_CLAUDE (Ryan 2026-08-29) — is the pallet decision ALREADY made
               for this order? Ryan: *"I can't think of any helpful/beneficial reason for the NO
               WEIGHT IN SHOPIFY pill existing on the order contents card?"* On SHOP-1997 he was
               right — the roll is freight-quoted by TAG, the broker bucket exists, and whether the
               weight rule could ALSO have reached that verdict is of no use to anybody. The chip
               only means something where the weight rule is the ONLY thing that could have caught
               a heavy shipment, and it could not. ⚠️ Passed on BOTH paths, per the note above. */
            orderIsFreightQuoted: !!q._isFreightQuoted,
            lifecycleStatus: q.lifecycleStatus,
            /* CUSTOM_ROLLMATH_BY_CLAUDE (ONYX c5ef9e57c97f, Ryan 2026-09-30) — the roll totals the worker
               computed (saved rolls vs paid), for the roll sub-row's readout + "Adjust to N". ⚠️ Passed on
               BOTH render paths (the lazy re-render below builds its own opts). */
            rollLengths: q.rollLengths || null,
            rollAdjustable: !!(isAdmin && q.source === 'online' && q.lifecycleStatus === 'sold'),
            customCosts: q.customCosts,
            existingDims: _ocExistingDims,
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Pass through the Existing Credit
               info so the card can render the negative-amount row that
               reconciles items + fees − credit = Order Total. */
            linkedCreditAmount: q.linkedCreditAmount,
            linkedCreditSourceRef: q.linkedCreditSourceRef,
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Parent-side credit + card-fee
               rows. Only populated when substitution is active — on a
               non-substitution parent the card shows the parent's OWN items
               so subtracting a linked child's totals would break the
               reconciliation. On a substituting parent the card has
               adopted the child's items + freight + install + tax, so:
                 items + freight + install + tax
                   + Σ(child cardFee)   ← parent cardfee row (+)
                   − Σ(child total)     ← parent credit row (−)
                   = parent's own f.grandTotal
               Mirror image of the child-side rows. */
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Option B
               combined view: worker's substitution synth now sets
               q.financials.directTotal + grandTotal to the COMBINED
               transaction value (parent + linked children), so Order
               Contents naturally renders the substituted item at full
               price with Order Total = combined goods + fees. No
               credit-line reconciliation needed. Per-order payment
               breakdown lives in the Linked Balance Reconciliation
               card below. */
            parentCardFeeLines: [],
            parentCreditLines: [],
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-02) — Roll the collected
               freight balance into the displayed Order Total. freightCharged
               already includes the balance (worker), but Shopify's grandTotal
               is parent-only, so without this the card showed e.g. freight
               $370.77 against a $367.47 total. Scoped to paid freight-balance
               orders so substitution parents (whose grandTotal the worker
               already sets to the combined value) are untouched. */
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — also roll up the Order Total for an
               auto-reconciled parent: its Order Contents now lists the child's added
               goods + freight, so the total must recompute from subtotal+freight rather
               than Shopify's parent-only grandTotal. Scoped to auto-reconcile so
               substitution parents (worker already sets combined grandTotal) are untouched. */
            rollUpBalanceTotal: !!(q.balanceCollected && q.balanceCollected.paid) || !!(q.autoReconciledChildRefs && q.autoReconciledChildRefs.length),
          });
          // Linked Balance Reconciliation card sits directly BELOW Order
          // Contents — the reconciliation is the bookkeeping that backs
          // the lines + totals above it, so the natural reading order
          // is "see the order, then see how the linked child's $ maps
          // back to it". Admin only.
          if (q.source === 'online') {
            html += renderBalanceReconciliationCard(q, isAdmin);
          }
          /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-07-22) — Adjust Order card
             sits directly BELOW Order Contents: the tool acts ON these line items,
             so it reads naturally right under them. Self-gates (admin/sold/online)
             in the module. See dashboard-adjust-order.js. */
          /* CUSTOM_NOCHARGEADD_BY_CLAUDE (Ryan 2026-09-12) — AND an OFFLINE deal that was paid
             through Shopify. Those carry a real order the tool can edit (q.paidOrderGid), and the
             panel has handled them since 2026-08-05 — but the only way IN was the cog's "Cancel
             and/or Refund" chooser, so the whole tool was filed under a heading that describes
             cancelling. Ryan looked for the button on RW-1380-B, correctly concluded it wasn't
             there, and the reason was this gate, not the deal being closed.
             ⚠️ Duplicated on purpose, and the module self-gates on the SAME condition — see the
             note in dashboard-adjust-order.js about these two drifting apart. Change both. */
          if (_effectiveAdmin && q.lifecycleStatus === 'sold'
              && (q.source === 'online' || (q.hasPaidOrder && q.paidOrderGid && !q.cancelled))
              && window.RQD && typeof window.RQD.renderAdjustOrderCard === 'function') {
            html += window.RQD.renderAdjustOrderCard(q);
          }
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Custom Costs card moved INTO the
             Financials card as inline rows (admin-only, online orders).
             See the Financials section below. The standalone card here
             is intentionally suppressed. */
        } else if (_ocLoading) {
          html += '<div class="rqd-detail__arap" data-order-contents-loading="1" data-ref="' + esc(q.reference) + '">' +
            '<div class="rqd-detail__section-title">Order Contents</div>' +
            '<div class="rqd-online-items-loading">Loading order contents…</div>' +
            '</div>';
        }
      }

      /* CUSTOM_DDFREIGHTCARD_BY_CLAUDE (Ryan 2026-08-29) — FREIGHT QUOTE + INSTALLATION QUOTE, under
         Order Contents. Admin-only, OFFLINE deals; both self-gate in dashboard-freight-cards.js.

         ⚠️ AND NO LONGER "ONLY BEFORE THE DEAL IS SOLD" (Ryan 2026-08-30). That exclusion is gone:
         the carrier's corrected rate arrives WEEKS AFTER the sale, and this was the only surface
         with the cost/markup/charged trio needed to record it without re-pricing the customer. The
         "never show the same freight step twice" rule is kept on the other side now — the
         Purchasing card stands its freight-cost input down while these are on screen. See the note
         on `cardsApply`.

         ⛔ EMITTED OUTSIDE THE `_ocAmount > 0` BLOCK ABOVE, and that placement is load-bearing. On a
         cold OFFLINE expand `_ocItems` is null — the line items arrive later from /quote-details —
         so the eager branch does not run and only the loading placeholder is written. Anything put
         inside it would be correct on an online deal and invisible on precisely the offline ones
         these cards exist for. Out here they need no mirroring in the lazy re-render either.

         ⚠️ These cards do not read line items, so they do not have to wait for that fetch: the
         vendor spine is q.financials.vendors, which the summary already carries. */
      if (window.RQD && window.RQD.renderDealFreightCard) {
        html += window.RQD.renderDealFreightCard(q);
        html += window.RQD.renderDealInstallCard(q);
      }

      // === Phase B.2.d (2026-05-23) — Quote-level Sample Tracking card extracted to dashboard-sample-commission.js ===
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) - `isLeadRow` rides along so the samples
         block on that card can defer to the lead card's when BOTH would otherwise draw it.
         ⚠️ Passed rather than re-derived: `qIsLead` is the exact expression that decides whether
         buildLeadDetail runs at all (line ~9877), and a second copy of it in the card would
         silently stop agreeing the first time this one changed. */
      html += window.RQD.buildSampleTrackingCard(q, { isSample: isSample, isPend: isPend, isDeadLead: isDeadLead, isLeadRow: qIsLead });
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-13) — Delay/Backorder Notice
         card (online orders only; the card self-gates on q.source==='online'). */
      if (window.RQD.buildDelayNoticeCard) html += window.RQD.buildDelayNoticeCard(q, { isPend: isPend });

      // ── Order of operations for sold quotes:
      //   1. AR / AP    — invoice + collect customer payments
      //   2. Purchasing — generate vendor POs
      //   3. Shipping   — track vendor ordering + shipment status
      //   4. Installation — schedule onsite install (only when quoted)

      // 1. AR/AP — full width below the grid (admin only, sold quotes only).
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Linked children skip the AR/AP card.
      // Invoicing, payment tracking, taxes-remitted, installer-paid all live
      // on the PARENT order. The child's "Paid" status is auto-tracked
      // (customer paid the balance link), so there's nothing to toggle here
      // — showing the card would invite admin to tick toggles on the wrong
      // row.
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — PO orders defer
         the AR/AP card to AFTER the Tracking card. Logic: customer sent
         us a PO, we generate POs to vendors, vendors ship, THEN we invoice
         the customer to collect payment. AR/AP belongs in the post-
         fulfillment phase for these orders.
         Implementation: mark html length BEFORE the AR/AP block runs.
         AR/AP appends to html normally (avoids rewriting ~200 lines of
         internal html += statements). After the block, if deferred,
         extract the AR/AP slice into _arApCardHtml + chop it from html.
         A later emission point right before Installation re-appends. */
      /* CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE (Ryan 2026-09-13) — WHICH CARD DRAWS EACH PAYABLE,
         decided ONCE, here, because AR / AP renders before Purchasing and cannot otherwise know
         what Purchasing is about to take.
         ⛔ NOTHING IS LOST. Every payable lands in exactly one bucket: under its vendor on the
         Purchasing card, or on AR / AP. A payable whose vendor has no block on Purchasing (which
         should not happen - a pay row exists because a PO was SENT) falls back rather than being
         silently dropped, because money going missing is the one failure this whole ledger exists
         to prevent.
         ⚠️ `_showsPurchasing` mirrors the Purchasing card's own gate below, which is why that gate
         now READS this variable instead of restating the condition. */
      var _payAll = (_effectiveAdmin && Array.isArray(q.supplierPay)) ? q.supplierPay.slice() : [];
      var _poVendorsEarly = (q.financials || {}).vendors || [];
      var _bucketPanelsEarly = q.source === 'online' && q.onlineFlow === 'A'
        && q.lifecycleStatus === 'sold'
        && Array.isArray(q.shippingBuckets) && q.shippingBuckets.length > 0;
      var _showsPurchasing = _effectiveAdmin && window.RQD.dealGoodsAreCommitted(q)
        && !_bucketPanelsEarly && !q.linkedParentRef && _poVendorsEarly.length > 0;
      var _paidAll = (_effectiveAdmin && Array.isArray(q.supplierPaid)) ? q.supplierPaid.slice() : [];
      var _payByVendor = {};
      var _paidByVendor = {};
      var _payTaken = {};
      if (_showsPurchasing) {
        _poVendorsEarly.forEach(function (v) {
          var mine = _payAll.filter(function (r) { return r && vendorNamesMatch(v, r.vendor); });
          var done = _paidAll.filter(function (r) { return r && vendorNamesMatch(v, r.vendor); });
          if (mine.length) { _payByVendor[v] = mine; mine.forEach(function (r) { _payTaken[r.poNumber] = true; }); }
          if (done.length) { _paidByVendor[v] = done; done.forEach(function (r) { _payTaken[r.poNumber] = true; }); }
        });
      }
      q._payablesForArAp = _payAll.filter(function (r) { return r && !_payTaken[r.poNumber]; });
      q._paidForArAp = _paidAll.filter(function (r) { return r && !_payTaken[r.poNumber]; });
      /* END CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE */
      var _arApMark = html.length;
      var _arApCardHtml = '';
      var _arApSb = q.soldBasis || {};
      var _arApDeferred = !!_arApSb.poReceived;
      if (_effectiveAdmin && q.lifecycleStatus === 'sold' && !q.linkedParentRef) {
        // AR/AP done = invoice (or n/a) + payments fully paid + taxes
        // remitted (or no taxes) + installer paid (or no install cost).
        // Each sub-step is rendered as a toggle inside the card; this is
        // just the aggregate signal for the section title's green ✓.
        var _arInvDone = !!q.invoiced || isResidentialOrg(q.customerCompany) || q.source === 'online';
        var _arPayments = q.payments || [];
        var _arQTotal = parseFloat(q.total || q.quoteAmount || q.amount || 0);
        var _arPaidAmt = _arPayments.length > 0 ? _arPayments.reduce(function(s, p) { return s + (parseFloat(p.amount) || 0); }, 0) : parseFloat(q.paymentAmount || 0);
        var _arPaidFull = q.source === 'online' || (_arQTotal > 0 ? _arPaidAmt >= _arQTotal : !!q.paid);
        var _arTaxAmt = parseFloat((q.financials || {}).taxes || q.taxes || 0);
        var _arTaxesOk = _arTaxAmt <= 0 || !!q.taxesRemitted;
        var _arInstAmt = parseFloat((q.financials || {}).installCost || 0);
        var _arInstOk = _arInstAmt <= 0 || !!q.installerPaid;
        /* CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE (Ryan 2026-09-13) — ⛔ AND THE SUPPLIER HAS TO HAVE
           BEEN PAID. RW-1359-A wore the header tick with $1,531.84 owed to ECORE sitting on the
           card underneath it, because this line was written before the payables row existed.
           ⚠️ ADMIN ONLY, and that is not symmetry for its own sake: `q.supplierPay` rides on the
           row for everyone, but the payables ROW is admin-gated (a payable is cost). Counting it
           for a rep would mark their card incomplete over something they cannot see, which is the
           blocker-with-no-visible-cause failure. */
        var _arPayablesOk = !(q._payablesForArAp && q._payablesForArAp.length);
        var _arDone = _arInvDone && _arPaidFull && _arTaxesOk && _arInstOk && _arPayablesOk;
        html += '<div class="rqd-detail__arap"' + ((q._payablesForArAp || []).length ? ' data-has-payables="1"' : '') + '>';
        html += sectionTitleHtml('AR / AP', _arDone);
        html += '<div class="rqd-detail__arap-row">';
        // === Phase B.2.c (2026-05-23) — AR/AP card halves extracted to dashboard-ar-ap-card.js ===
        //     Top half (B.2.c.i): Invoice row + Payments parent + Payment child rows (216 LOC).
        //     Closeout half (B.2.c.ii): Taxes Remitted + Installer Paid toggles (12 LOC).
        //     The .rqd-detail__arap wrapper + section title + defer slice/stash logic stay in main.
        html += window.RQD.buildArApTopHalf(q);
        html += window.RQD.buildArApCloseout(q);
        html += '</div>';
        html += '</div>';
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — If AR/AP is deferred
         (PO order), extract the AR/AP slice from html and stash it for
         re-emission below (after Tracking, before Installation). */
      if (_arApDeferred) {
        _arApCardHtml = html.substring(_arApMark);
        html = html.substring(0, _arApMark);
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      // 2. Purchasing — admin only, sold quotes only.
      // Mirrors the Shipping / AR-AP card chrome (.rqd-detail__arap wrapper +
      // .rqd-toggle rows) so all post-sale ops cards read as one consistent set.
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Hidden when bucket panels are
      // rendering this order's POs. The bucket panel's PO row carries
      // the same Email/View/Re-send/Re-gen/Void actions inline, so a
      // separate Purchasing card would just duplicate the management
      // surface. Bucket panels render under the same conditions as the
      // Freight Balance card. The legacy-invoice gate is intentionally
      // omitted: once buckets exist on an order, the bucket flow takes
      // precedence even if a stale FREIGHT-{ref} draft invoice lingers
      // in lifecycle.freightBalance.draftOrderId from earlier testing.
      // Without this, SHOP-1681 was showing the Purchasing card whose
      // Generate PO button carries no data-bucket, so PO requests went
      // out without the bucket key — producing un-suffixed PO numbers
      // and unfiltered line item sets.
      var _bucketPanelsActive = q.source === 'online'
        && q.onlineFlow === 'A'
        && q.lifecycleStatus === 'sold'
        && Array.isArray(q.shippingBuckets) && q.shippingBuckets.length > 0;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Linked children skip the Purchasing
         card. All POs go out from the parent order (where fulfillment
         actually happens); the child has no items to procure on its own. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — a REPLACEMENT reaches this surface too.
         Goods-committed, not sold: see RQD.dealGoodsAreCommitted in dashboard-claim-card.js for
         why the money surfaces (AR/AP, invoicing, commission) still ask the old question. */
      /* ⚠️ ONE DEFINITION: `_showsPurchasing` was computed above the AR / AP card so the two could
         agree about which of them draws a payable. Restating the condition here is how they would
         start disagreeing, and the symptom would be a payable drawn twice or not at all. */
      if (_showsPurchasing) {
        var poVendors = _poVendorsEarly;
        if (poVendors.length > 0) {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — Use the shared
             isVendorAllBucketsPurchased predicate so the heading checkmark
             agrees with the per-vendor row + the progress bar. The old inline
             check counted ONLY sent/downloaded POs and ignored
             ordering[vendor].purchasedDirectly ("Mark Purchased — no PO"), so a
             directly-purchased vendor showed a row ✓ but no heading ✓
             (JW-1152-A: RubberLogix purchasedDirectly:true, 0 POs). */
          /* CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE (Ryan 2026-09-13) — ⛔ AND PAID, NOT JUST ORDERED.
             The payment control lives on this card now, so a ✓ here has to mean both; a tick over
             an unpaid row inside the same card is exactly the bug Ryan reported on AR / AP. */
          var _purchPayOpen = Object.keys(_payByVendor).length > 0;
          var _purchAllDone = poVendors.every(function (v) {
            return isVendorAllBucketsPurchased(q, v);
          }) && !_purchPayOpen;
          /* CUSTOM_DDCARDCOUNT_BY_CLAUDE (AIOPS 9ab5bd14ca5f, Ryan 2026-09-26 - RW-1317-C) — "PURCHASING
             (3/3) ✓". Counts the SAME predicate the tick uses, so the bracket and the tick cannot
             disagree about which suppliers are ordered. The tick still also waits on payables (above):
             "(3/3)" with no tick means all ordered, somebody still to pay.
             data-section-id pins the collapse identity the count would otherwise change. */
          var _purchDoneCount = poVendors.filter(function (v) { return isVendorAllBucketsPurchased(q, v); }).length;
          html += '<div class="rqd-detail__arap" data-section-id="purchasing"' + (_purchPayOpen ? ' data-has-payables="1"' : '') + '>';
          html += window.RQD.sectionTitleWithCount('Purchasing', _purchAllDone, _purchDoneCount, poVendors.length);
          html += '<div class="rqd-detail__arap-row">';
          /* CUSTOM_PAYTERMSGATE_BY_CLAUDE (AIOPS `87238b70d3ee`, Ryan 2026-09-18) — FIRST ROW ON
             THE CARD, above every vendor group, because it is a fact about the DEAL and because
             the thing it warns about (booking a pickup on an unpaid 50/50) happens after somebody
             has read down this card. Renders nothing when the money is settled. */
          html += renderPaymentGateRow(q);
          // Bucket POs by row vendor via vendorNamesMatch so canonical Vendor
          // Guide names ("ECORE Athletic") still pair with the Shopify short
          // form on q.financials.vendors ("ECORE").
          var posByVendor = {};
          poVendors.forEach(function(v){ posByVendor[v] = []; });
          (q.pos || []).forEach(function(p){
            if (!p) return;
            var bucket = poVendors.find(function(v){ return vendorNamesMatch(v, p.vendor); });
            if (bucket) posByVendor[bucket].push(p);
          });
          /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) - one thin rule BETWEEN vendor
             groups. Multi-vendor purchases are new on this card, and every vendor emits three or
             more .rqd-toggle rows into ONE flat flex column, so two suppliers' freight and
             purchase rows read as a single six-row list with no seam (RW-1339-A: Blue Sky
             Fitness Supply -> Ferus Prime, then TKO).

             JOINED rather than appended per iteration, deliberately. Join gives exactly N-1
             separators, which means a single-vendor card is untouched, there is never a trailing
             rule floating above the card's bottom edge, and a vendor whose block comes back
             empty cannot leave a doubled or orphaned line behind. Separating the groups is a
             property of the LIST, not of a row - which is why it lives here and not in
             renderVendorRow, a function that has no idea what position it is rendering at. */
          var _vendorBlocks = [];
          poVendors.forEach(function(v){
            var _blockHtml = renderPoVendorRow(q, v, posByVendor[v] || []);
            /* The payable sits at the BOTTOM of its vendor's block: the order on the card is
               ask, order, pay, which is the order it happens in. `showVendor:false` because the
               block already carries that supplier's sub-header. */
            if (_blockHtml && (_payByVendor[v] || _paidByVendor[v])) {
              _blockHtml += window.RQD.buildPayableRows(q, {
                rows: _payByVendor[v] || [], paid: _paidByVendor[v] || [], showVendor: false,
              });
            }
            if (_blockHtml) _vendorBlocks.push(_blockHtml);
          });
          html += _vendorBlocks.join('<div class="rqd-po-vendor-sep" role="presentation"></div>');
          /* END CUSTOM_DEALDASHBOARD_BY_CLAUDE */
          html += '</div>';
          html += '</div>';
        }
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Card render order for
         bucket-mode workflows. The real-world sequence on these orders is:
           1. get freight quotes / dims / pallet sizes (Fulfillment card)
           2. generate + send POs (Fulfillment card — bucket panels)
           3. supplier ships (Tracking card — Mark Fulfilled)
         So Fulfillment should render BEFORE Tracking. Post-ship-vendor
         orders (Hyperice family) keep the legacy order (Tracking BEFORE
         Freight Balance) because freight invoicing literally is post-ship
         for them. Flag is reused by the existing Freight Balance render
         block below to avoid double-rendering. */
      var _fbHasBucketsEarly = Array.isArray(q.shippingBuckets) && q.shippingBuckets.length > 0;
      var _fbFirstVendorEarly = (q.financials && q.financials.vendors && q.financials.vendors[0]) || '';
      var _fbIsPostShipVendorEarly = isPostShipInvoiceVendor(_fbFirstVendorEarly);
      var _fbBucketPanelsActiveEarly = q.source === 'online'
        && q.onlineFlow === 'A'
        && q.lifecycleStatus === 'sold'
        && _fbHasBucketsEarly;
      var _fbShowEarly = isAdmin
        && q.lifecycleStatus === 'sold'
        && q.source === 'online'
        && (q.onlineFlow === 'A' || _fbHasBucketsEarly)
        && (_fbIsPostShipVendorEarly || _fbBucketPanelsActiveEarly);
      var _renderedFulfillmentEarly = false;
      if (_fbShowEarly && _fbBucketPanelsActiveEarly) {
        html += renderFreightBalanceCard(q);
        _renderedFulfillmentEarly = true;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      // 3a. Shipping/Tracking detail card — extracted to assets/dashboard-shipping-tracking-card.js (Phase C.1, 2026-05-23).
      // Renders per-vendor / per-bucket tracking + Mark Fulfilled / dims via window.RQD.buildShippingTrackingCard(q, opts).
      // Self-gates on effectiveAdmin + sold + not-linked-child + vendors.length > 0; returns '' otherwise.
      html += window.RQD.buildShippingTrackingCard(q, { effectiveAdmin: _effectiveAdmin, renderedFulfillmentEarly: _renderedFulfillmentEarly });

      // 3b. Summary — rep view (non-admin, sold quotes only). Single card
      // covering every meaningful stage of the order: Signed, Paid (with
      // partial-fill for half-paid 50/50 etc.), Ordered, Shipped (with
      // tracking #/type), Installed, Commission. Read-only; the admin view
      // splits these into separate cards for editing.
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — a REPLACEMENT reaches this surface too.
         Goods-committed, not sold: see RQD.dealGoodsAreCommitted in dashboard-claim-card.js for
         why the money surfaces (AR/AP, invoicing, commission) still ask the old question. */
      if (!_effectiveAdmin && window.RQD.dealGoodsAreCommitted(q)) {
        var sumSb = q.soldBasis || {};
        var sumOrdering = q.ordering || {};
        var sumVendors = (q.financials || {}).vendors || [];

        // Helper to render one summary row in the same .rqd-toggle vocabulary
        // the admin view uses, but always non-interactive (no data-field).
        function summaryRow(done, label, meta, dateStr) {
          return '<div class="rqd-toggle' + (done ? ' rqd-toggle--done' : '') + '" style="cursor:default;">' +
            '<div class="rqd-toggle__check">' + (done ? '&#10003;' : '') + '</div>' +
            '<span>' + label + (meta ? ' <span class="rqd-toggle__partial-badge">' + meta + '</span>' : '') + '</span>' +
            (dateStr ? '<span class="rqd-toggle__date">' + dateStr + '</span>' : '') +
            '</div>';
        }

        html += '<div class="rqd-detail__arap">';
        html += '<div class="rqd-detail__section-title">Summary</div>';
        html += '<div class="rqd-detail__arap-row">';

        // Signed — only when soldBasis confirms the customer signed (offline
        // payment paths require a signed order; the basis stamp is what we
        // show here as the "signed" event).
        if (sumSb.signedOrder) {
          var signedDate = sumSb.signedAt || q.dateSold;
          html += summaryRow(true, 'Signed', '', signedDate ? formatDate(signedDate) : '');
        }
        // PO Received (when applicable to this customer — e.g., commercial
        // buyers paying via PO).
        if (sumSb.poReceived) {
          html += summaryRow(true, 'PO Received', '', q.dateSold ? formatDate(q.dateSold) : '');
        }

        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — ⛔ NO 'PAID' STEP ON A REPLACEMENT.
           Ryan: "it includes the PAID step but that's n/a on these -- right?" Right. A
           replacement is $0 to the customer, so `sumQTotal` is 0, `sumPaidFull` falls back to
           `!!q.paid` — which is false — and the rep's summary showed a permanently unticked
           Paid box on an order nobody will ever pay for. That is a to-do that can never be
           done, sitting on the surface a rep reads to answer "where is my customer's stuff".
           Same reasoning that trimmed the admin fulfilment bar to Ordered → Shipped. */
        if (!q.isReplacement) {
        // Paid — full / partial / unpaid.
        var sumPayments = q.payments || [];
        var sumPaidAmt = sumPayments.reduce(function(s, p) { return s + (parseFloat(p.amount) || 0); }, 0);
        var sumQTotal = parseFloat(q.total || q.quoteAmount || q.amount || 0);
        var sumPaidFull = sumQTotal > 0 ? sumPaidAmt >= sumQTotal : !!q.paid;
        var sumPaidFrac = (sumQTotal > 0 && sumPaidAmt > 0 && !sumPaidFull) ? Math.min(sumPaidAmt / sumQTotal, 1) : 0;
        var sumLastPmt = sumPayments.length > 0 ? sumPayments[sumPayments.length - 1] : null;
        var sumPmtDate = sumPaidFull && sumLastPmt && sumLastPmt.date
          ? formatDate(sumLastPmt.date)
          : (sumPaidFull && q.paymentDate ? formatDate(q.paymentDate) : '');
        var sumPmtMethod = sumPaidFull
          ? (sumLastPmt && sumLastPmt.method ? sumLastPmt.method : (q.paymentMethod || ''))
          : '';
        if (sumPaidFull) {
          html += summaryRow(true, 'Paid' + (sumPmtMethod ? ' (' + esc(sumPmtMethod) + ')' : ''), '', sumPmtDate);
        } else if (sumPaidFrac > 0) {
          // Partial: green fill inside the checkbox + amount badge inline.
          var sumFillPct = Math.round(sumPaidFrac * 100);
          html += '<div class="rqd-toggle" style="cursor:default;">' +
            '<div class="rqd-payment-check"><div class="rqd-payment-check__fill" style="height:' + sumFillPct + '%"></div></div>' +
            '<span>Paid <span class="rqd-toggle__partial-badge">' + money(sumPaidAmt) + ' of ' + money(sumQTotal) + '</span></span>' +
            (sumLastPmt && sumLastPmt.date ? '<span class="rqd-toggle__date">' + formatDate(sumLastPmt.date) + '</span>' : '') +
            '</div>';
        } else {
          html += summaryRow(false, 'Paid', '', '');
        }
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

        // Ordered + Shipped use the same gates as the progress tracker:
        //   Ordered = Purchasing-driven  → at least one non-voided PO per
        //             vendor has status='sent' OR downloadedAt is set
        //   Shipped = Shipping-driven    → ordering[v].ordered is true
        //             (auto-set by the Shipping card when carrier+type+
        //             tracking number are all filled)
        // Bucketed via vendorNamesMatch so canonical Vendor Guide names
        // ("ECORE Athletic") still pair with the row's short form ("ECORE").
        var sumPosByVendor = {};
        sumVendors.forEach(function(v) { sumPosByVendor[v] = []; });
        (q.pos || []).forEach(function(p) {
          if (!p || p.status === 'voided') return;
          var bucket = sumVendors.find(function(v) { return vendorNamesMatch(v, p.vendor); });
          if (bucket) sumPosByVendor[bucket].push(p);
        });
        function sumIsOrdered(v) {
          return (sumPosByVendor[v] || []).some(function(p) { return p.status === 'sent' || !!p.downloadedAt; });
        }
        function sumOrderDate(v) {
          var pos = sumPosByVendor[v] || [];
          var dates = pos.map(function(p) { return p.sentAt || p.lastSentAt || p.downloadedAt || p.createdAt || p.generatedAt; }).filter(Boolean);
          return dates.sort().pop();
        }
        var sumOrderedAll = sumVendors.length > 0 && sumVendors.every(sumIsOrdered);
        var sumOrderCount = sumVendors.filter(sumIsOrdered).length;
        var sumShippedAll = sumVendors.length > 0 && sumVendors.every(function(v) { return sumOrdering[v] && sumOrdering[v].ordered; });
        var sumShipCount = sumVendors.filter(function(v) { return sumOrdering[v] && sumOrdering[v].ordered; }).length;

        if (sumVendors.length > 0) {
          var orderedLatest = sumVendors.map(sumOrderDate).filter(Boolean).sort().pop();
          var orderedMeta = sumVendors.length > 1 && !sumOrderedAll && sumOrderCount > 0
            ? sumOrderCount + '/' + sumVendors.length
            : '';
          html += summaryRow(sumOrderedAll, 'Ordered', orderedMeta, sumOrderedAll && orderedLatest ? formatDate(orderedLatest) : '');

          /* CUSTOM_REPREADYDATE_BY_CLAUDE (Ryan 2026-10-22) - SUPPLIER READY, ON THE REP'S SUMMARY. The ready date used to ride
             under the status pill in the To Do column; Ryan moved it here for reps (admins read it on the Tracking card) and
             dropped it from the column. ⛔ THE SUPPLIER'S ACTUAL WORD ONLY: a built-to-order default (`vendorEtaDefault`, or an
             entry marked isDefault) is never shown - "the only one that matters is the actual date". Same .rqd-toggle rows as
             Ordered / Shipped: one supplier = one row; several = the latest date on the row (the order ships complete no
             sooner), a n/total badge while some have not answered, and a sub-line per supplier that has. The wording is the
             board's own formatter (RQD.readyByShort: "Nov 18", "early Nov", "Nov 18–25"). */
          var sumEtaMap = (q.vendorEta && typeof q.vendorEta === 'object') ? q.vendorEta : {};
          var sumEtaFor = function(v) {
            var e = sumEtaMap[v];
            if (!e) {
              for (var ek in sumEtaMap) {
                if (Object.prototype.hasOwnProperty.call(sumEtaMap, ek) && vendorNamesMatch(v, ek)) { e = sumEtaMap[ek]; break; }
              }
            }
            if (!e || typeof e !== 'object' || e.isDefault) return null;
            if (!e.date && !(e.kind === 'unparsed' && e.label)) return null;
            return e;
          };
          var sumEtaShort = (window.RQD && window.RQD.readyByShort) || function(e) { return e.date || e.label || ''; };
          var sumEtaRows = sumVendors.map(function(v) { return { v: v, e: sumEtaFor(v) }; }).filter(function(r) { return !!r.e; });
          if (sumEtaRows.length) {
            var sumEtaDated = sumEtaRows.filter(function(r) { return !!r.e.date; })
              .sort(function(a, b) { return a.e.date < b.e.date ? -1 : a.e.date > b.e.date ? 1 : 0; });
            var sumEtaLatest = sumEtaDated.length ? sumEtaDated[sumEtaDated.length - 1] : sumEtaRows[0];
            var sumEtaAll = sumEtaDated.length === sumVendors.length;
            var sumEtaMeta = sumVendors.length > 1 && !sumEtaAll ? sumEtaDated.length + '/' + sumVendors.length : '';
            html += summaryRow(sumEtaAll, 'Supplier ready', sumEtaMeta, esc(sumEtaShort(sumEtaLatest.e)));
            if (sumVendors.length > 1) {
              sumEtaRows.forEach(function(r) {
                var dated = !!r.e.date;
                html += '<div class="rqd-toggle' + (dated ? ' rqd-toggle--done' : '') + '" style="cursor:default;padding-left:28px;font-size:12px;">' +
                  '<div class="rqd-toggle__check" style="width:14px;height:14px;font-size:9px;">' + (dated ? '&#10003;' : '') + '</div>' +
                  '<span>' + esc(r.v) + '</span>' +
                  '<span class="rqd-toggle__date">' + esc(sumEtaShort(r.e)) + '</span>' +
                  '</div>';
              });
            }
          }
          /* END CUSTOM_REPREADYDATE_BY_CLAUDE */

          /* CUSTOM_QUOTEDWINDOW_BY_CLAUDE (ONYX 50c30528851f, Ryan 2026-10-21/27) - THE CUSTOMER WINDOW, EDITABLE, ON THE REP'S SUMMARY.
             The same row the admin Tracking card draws (RQD.renderCustomerWindowRow) and the same save (saveCustomerWindow, the
             delegated change handler), so a rep's edit is exactly an admin's: one Deal Feed line with their initials, nothing
             else triggered (Ryan: "ok"). The worker's own ownership check is the gate, as for every rep write on /quote-lifecycle. */
          if (window.RQD && typeof window.RQD.renderCustomerWindowRow === 'function') {
            html += window.RQD.renderCustomerWindowRow(q, sumShippedAll);
          }
          /* END CUSTOM_QUOTEDWINDOW_BY_CLAUDE */

          var shippedLatest = sumVendors.map(function(v) { return (sumOrdering[v] || {}).date; }).filter(Boolean).sort().pop();
          var shippedMeta = sumVendors.length > 1 && !sumShippedAll && sumShipCount > 0
            ? sumShipCount + '/' + sumVendors.length
            : '';
          var shippedSingleTracking = sumVendors.length === 1 && sumShippedAll
            ? (function() {
                var only = sumOrdering[sumVendors[0]] || {};
                return only.tracking ? esc(only.trackingType || 'Tracking #') + ' ' + esc(only.tracking) : '';
              })()
            : '';
          if (shippedSingleTracking && sumShippedAll) {
            // One vendor + shipped: inline the tracking on the same row.
            html += '<div class="rqd-toggle rqd-toggle--done" style="cursor:default;">' +
              '<div class="rqd-toggle__check">&#10003;</div>' +
              '<span>Shipped <span class="rqd-toggle__partial-badge">' + shippedSingleTracking + '</span></span>' +
              (shippedLatest ? '<span class="rqd-toggle__date">' + formatDate(shippedLatest) + '</span>' : '') +
              '</div>';
          } else {
            html += summaryRow(sumShippedAll, 'Shipped', shippedMeta, sumShippedAll && shippedLatest ? formatDate(shippedLatest) : '');
            // Per-vendor sub-rows for multi-vendor orders so each tracking#
            // gets its own line (only when there are multiple vendors).
            if (sumVendors.length > 1) {
              sumVendors.forEach(function(v) {
                var ord = sumOrdering[v] || {};
                /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Last
                   legacy ord.ordered read. Converged to vendorIsShipped
                   predicate so this Shipping-summary sub-row agrees with
                   the status tracker bar + To Do strip + Tracking card
                   on the "is this vendor shipped" answer. Note: the q
                   object isn't in this closure's scope — synth one with
                   the bits the predicate needs. */
                if (!vendorIsShipped({ source: q.source, ordering: sumOrdering }, v)) return;
                /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
                var trackBits = ord.tracking
                  ? esc(ord.trackingType || 'Tracking #') + ' ' + esc(ord.tracking)
                  : (ord.carrier ? esc(ord.carrier) : '');
                html += '<div class="rqd-toggle rqd-toggle--done" style="cursor:default;padding-left:28px;font-size:12px;">' +
                  '<div class="rqd-toggle__check" style="width:14px;height:14px;font-size:9px;">&#10003;</div>' +
                  '<span>' + esc(v) + (trackBits ? ' <span class="rqd-toggle__partial-badge">' + trackBits + '</span>' : '') + '</span>' +
                  (ord.date ? '<span class="rqd-toggle__date">' + formatDate(ord.date) + '</span>' : '') +
                  '</div>';
              });
            }
          }
        }

        // Installation — only when install was quoted on the order.
        if (q.install && q.install.required) {
          var instDone = q.install.status === 'complete';
          var instDate = q.install.completedDate || q.install.scheduledDate;
          html += summaryRow(instDone, 'Installed', '', instDate ? formatDate(instDate) : '');
        }

        // Commission — only when this rep actually accrues commission on
        // this order (matches the progress tracker step's gate).
        if (q.repEarnsCommission !== false && parseFloat(q.commissionAmount || 0) > 0) {
          html += summaryRow(!!q.commissionPaid, 'Commission', '', q.commissionPaidDate ? formatDate(q.commissionPaidDate) : '');
        }

        html += '</div>';
        html += '</div>';
      }

      // 3b. Freight Balance — post-shipping reconciliation card. Hosts the
      // bucket panels (freight cost input, dims, balance reconciliation).
      // Order rationale: vendor invoices freight AFTER shipment, so this
      // is the final post-shipping loose end. Was previously rendered
      // before the Purchasing card (Flow A's broker-quote workflow
      // historically preceded PO gen) — moved here per Ryan so the
      // bucket-mode workflow (PO → ship → vendor freight invoice) reads
      // top-to-bottom in the order it actually happens.
      //
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Gate: any sold online order with
      // shipping buckets (auto-derived parcel/broker/combined) or Flow A.
      // Bucket panels handle Flow B / C parcel-rate workflows (Hyperice
      // etc.) so the card needs to render for those even though they're
      // not Flow A.
      var _fbHasBuckets = Array.isArray(q.shippingBuckets) && q.shippingBuckets.length > 0;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Freight Balance card visibility rule:
         show when EITHER
           (a) the vendor bills freight post-ship (Hyperice family) — so
               admin has a surface to enter the post-ship freight invoice
               whenever it arrives, OR
           (b) the bucket panels need a host because the Purchasing card
               is itself hidden — same `_bucketPanelsActive` condition the
               Purchasing card uses to suppress itself (Flow A sold online
               order with shipping buckets). In that case Freight Balance
               acts as the canonical PO management surface, hosting each
               bucket panel's Generate PO / Email PO / freight cost row.
         Hide otherwise. Earlier gate only hid on FULFILLED non-Hyperice;
         per Ryan the card can hide from onset for non-Hyperice orders
         that also have a visible Purchasing card — the active fulfillment
         window doesn't need the Freight Balance surface unless one of the
         two conditions above applies. */
      var _fbFirstVendor = (q.financials && q.financials.vendors && q.financials.vendors[0]) || '';
      var _fbIsPostShipVendor = isPostShipInvoiceVendor(_fbFirstVendor);
      var _fbBucketPanelsActive = q.source === 'online'
        && q.onlineFlow === 'A'
        && q.lifecycleStatus === 'sold'
        && _fbHasBuckets;
      var _fbShouldShow = _fbIsPostShipVendor || _fbBucketPanelsActive;
      if (_effectiveAdmin && q.lifecycleStatus === 'sold' && q.source === 'online' && (q.onlineFlow === 'A' || _fbHasBuckets) && _fbShouldShow && !_renderedFulfillmentEarly) {
        html += renderFreightBalanceCard(q);
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Emit the deferred
         AR/AP card here (between Tracking/Freight Balance and Installation)
         for PO orders. _arApCardHtml is empty for non-PO orders so this is
         a no-op there. */
      if (_arApDeferred && _arApCardHtml) {
        html += _arApCardHtml;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      /* CUSTOM_DDINSTALL_BY_CLAUDE (Ryan 2026-09-02) — THE SECOND INSTALLATION CARD IS GONE.

         It rendered here: a card also titled "Installation", holding nothing but the scheduled-date
         picker, directly below the INSTALLATION (n/n) card that holds the installer and the cost.
         Ryan, on RW-1068-B: *"we now have 2x installation cards... we need to combine the 2nd one
         where you select the date onto the first one."* Both rows — Scheduled and the new Install
         completed — now render from `renderInstallFulfilmentRows` in dashboard-freight-cards.js,
         with Installer paid beneath them.

         ⚠️ The markup moved VERBATIM, classes included (`rqd-install-form`, `rqd-install-form__date`,
         `rqd-vendor-tracking__status`), because `handleInstallSave` and the two delegated change
         listeners key off those class names. Renaming anything here would have been a second change
         wearing the same commit.

         ⛔ EXCEPT FOR THE REP, WHO CANNOT SEE THAT CARD AT ALL. `cardsApply` in
         dashboard-freight-cards.js opens with `if (!getIsAdmin()) return false` — so moving the
         block wholesale would have silently deleted the install schedule from every rep's panel,
         where it has always rendered read-only ("Admin will schedule"). A merge that removes
         information from one audience is not a merge. Reps keep a read-only card here; admins get
         the merged one and never see this branch, so there is still exactly ONE Installation card
         on any given screen. */
      if (!_effectiveAdmin && q.lifecycleStatus === 'sold' && q.financials && parseFloat(q.financials.installCost) > 0) {
        var _repInst = q.install || {};
        var _repSched = !!(_repInst.scheduledDate && String(_repInst.scheduledDate).trim());
        var _repDone = _repInst.status === 'complete';
        html += '<div class="rqd-detail__arap">';
        html += sectionTitleHtml('Installation', _repSched || _repDone);
        html += '<div class="rqd-vendor-item">';
        html += '<div class="rqd-vendors__check' + (_repSched ? ' rqd-vendors__check--done' : '') + '" style="pointer-events:none;"><span style="font-size:12px;">' + (_repSched ? '&#10003;' : '') + '</span></div>';
        html += '<span class="rqd-vendor-item__name">Scheduled</span>';
        html += '<div class="rqd-vendor-tracking">';
        html += '<span class="rqd-vendor-tracking__input rqd-install-form__date rqd-install-form__date--readonly" aria-readonly="true">' + (_repSched ? esc(_repInst.scheduledDate) : 'Admin will schedule') + '</span>';
        html += '</div></div>';
        /* The rep sees WHETHER the job is done, and cannot set it — same split as the date. */
        html += '<div class="rqd-vendor-item">';
        html += '<div class="rqd-vendors__check' + (_repDone ? ' rqd-vendors__check--done' : '') + '" style="pointer-events:none;"><span style="font-size:12px;">' + (_repDone ? '&#10003;' : '') + '</span></div>';
        html += '<span class="rqd-vendor-item__name">Install completed</span>';
        html += '<div class="rqd-vendor-tracking">';
        html += '<span class="rqd-vendor-tracking__input rqd-install-form__date rqd-install-form__date--readonly" aria-readonly="true">' + (_repDone ? 'Completed' : 'Not yet') + '</span>';
        html += '</div></div>';
        html += '</div>';
      }
      /* END CUSTOM_DDINSTALL_BY_CLAUDE */

      // 5. Commission — bottom of the detail panel (admin only, sold quotes).
      // Renders only when the quote actually accrues commission to someone:
      //   - rep (commissionAmount > 0; zero for reps with earnsCommission=false)
      //   - CFA attribution inside the 18-month window
      //   - Shared/Referral recipient (named on the Workstation when
      //     leadSource='shared')
      // ADMIN-only sold orders with no referral skip the card entirely.
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Also skip the bottom commission
      // (lifecycle toggles) card on:
      //   1. Linked children — commission lives on the parent
      //   2. Rep doesn't earn + no CFA + no referral — the card would
      //      just render a single "Rep Commission n/a" row with no
      //      action affordance, which is noise.
      if (_effectiveAdmin && q.lifecycleStatus === 'sold' && !q.linkedParentRef) {
        // A rep "row" in the Commission card is shown either:
        //   - as a regular togglable "Rep Commission Paid (RW — $X.XX)" row when
        //     repEarnsCommission is true AND commissionAmount > 0, or
        //   - as a non-interactive "n/a" row when repEarnsCommission is false
        //     (so it's clear this rep doesn't take a cut, even on old sold
        //     orders whose stored commissionAmount hasn't been zeroed yet).
        var _repFlagOff = !!(q.rep && q.rep !== 'ADMIN' && q.repEarnsCommission === false);
        var _commHasRep = !!(q.rep && q.rep !== 'ADMIN' && (
          (parseFloat(q.commissionAmount || 0) > 0 && !_repFlagOff) || _repFlagOff
        ));
        var _commHasCfa = !!q.cfaCode && (parseFloat(q.cfaCommissionAmount || 0) > 0);
        var _commHasReferral = !!q.referralName && (parseFloat(q.referralAmount || 0) > 0);
        // Block commission toggles until the order is paid in full. Same math
        // the AR/AP card uses for the Payments parent row's fully-paid state.
        var _commPayments = q.payments || [];
        var _commPaidAmt = _commPayments.reduce(function(s, p) { return s + (parseFloat(p.amount) || 0); }, 0);
        var _commQTotal = parseFloat(q.total || q.quoteAmount || q.amount || 0);
        var _commPaidInFull = _commQTotal > 0 ? _commPaidAmt >= _commQTotal : !!q.paid;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Always carry editableDate so the
           date picker renders on EVERY commission row, even when the row
           is locked (order not yet paid in full). buildToggle disables
           the input via the `disabled` HTML attr when `disabled` is also
           set; styling grays it out so the rep can see the field is
           there + know what they'll fill in once the order pays. */
        var _commLockOpts = !_commPaidInFull
          ? { disabled: true, disabledReason: 'Order must be paid in full before commission can be marked paid', datePopover: true }
          : { datePopover: true };
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Suppress the bottom commission card
           when the ONLY commission "row" would be a non-actionable rep
           n/a (rep flag-off, no CFA, no referral). That's pure noise —
           the top Commission card already hides for the same reason via
           the n/a gate above; mirror it here. */
        var _commOnlyRepNa = _commHasRep && _repFlagOff && !_commHasCfa && !_commHasReferral;
        if ((_commHasRep || _commHasCfa || _commHasReferral) && !_commOnlyRepNa) {
          // Commission done = each applicable recipient is paid (or n/a for
          // a flag-off rep). repFlagOff treats the rep slot as already done
          // since they don't earn commission on this order.
          var _commRepOk = !_commHasRep || _repFlagOff || !!q.commissionPaid;
          var _commCfaOk = !_commHasCfa || !!q.cfaCommissionPaid;
          var _commRefOk = !_commHasReferral || !!q.referralPaid;
          var _commAllDone = _commRepOk && _commCfaOk && _commRefOk;
          html += '<div class="rqd-detail__arap">';
          html += sectionTitleHtml('Commission', _commAllDone);
          html += '<div class="rqd-detail__arap-row">';
          // Bottom card labels are intentionally bare — the top-grid
          // Commission card shows recipient initials/name + amount, so
          // duplicating them here is redundant.
          /* CUSTOM_COMMISSIONS_BY_CLAUDE (Ryan 2026-11-02) - a commission partly paid early from the
             Commissions page says so on its row until the rest is paid. */
          var _earlyLbl = function(base, soFar, done){
            return (!done && parseFloat(soFar) > 0) ? base + ' ($' + parseFloat(soFar).toFixed(2) + ' paid early)' : base;
          };
          if (_commHasRep) {
            if (_repFlagOff) {
              html += '<div class="rqd-toggle rqd-toggle--done" title="This rep does not earn commission on their own quotes">' +
                '<div class="rqd-toggle__check rqd-toggle__check--na" style="cursor:default;">n/a</div>' +
                '<span>Rep Commission</span>' +
                '</div>';
            } else {
              html += buildToggle(q.reference, 'commissionPaid', _earlyLbl('Rep Commission Paid', q.commissionPaidSoFar, q.commissionPaid), q.commissionPaid, q.commissionPaidDate, _commLockOpts);
            }
          }
          if (_commHasReferral) {
            html += buildToggle(q.reference, 'referralPaid', _earlyLbl('Referral Commission Paid', q.referralPaidSoFar, q.referralPaid), q.referralPaid, q.referralPaidDate, _commLockOpts);
          }
          if (_commHasCfa) {
            html += buildToggle(q.reference, 'cfaCommissionPaid', _earlyLbl('CFA Commission Paid', q.cfaCommissionPaidSoFar, q.cfaCommissionPaid), q.cfaCommissionPaid, q.cfaCommissionPaidDate, _commLockOpts);
          }
          html += '</div>';
          html += '</div>';
        }
      }

      html += '</div>';
      return html;
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-27) — optional `title`, and the helper escapes it
       itself because the helper is what owns the attribute.

       ⛔ IT EXISTS SO CALLERS DO NOT NEST A SPAN. `.rqd-detail__row span:first-child` is written
       WITHOUT a child combinator, so it matches any span that happens to be its parent's first
       child — including one wrapped around a value — and hands it the LABEL's styling, including
       `margin-right: 12px`. That is what pushed "Residence" 12px off the right edge and made it
       read as `Residence   `. Passing the tooltip here keeps the value a bare text node. */
    function detailRow(label, value, title) {
      var t = title
        /* `>` too: legal raw inside an attribute, but escaping it means the attribute contains no
           character that can terminate a tag, so nothing downstream has to parse carefully. */
        ? ' title="' + String(title).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') + '"'
        : '';
      return '<div class="rqd-detail__row"><span>' + label + '</span><span' + t + '>' + (value || '—') + '</span></div>';
    }
    // Cost-styled row — red text + leading minus sign so the eye instantly
    // reads it as a deduction. `value` should be the positive number (e.g.
    // costRow('COGS', 167.84) renders "−$167.84" in red).
    function costRow(label, value) {
      var n = parseFloat(value) || 0;
      return '<div class="rqd-detail__row rqd-detail__row--cost"><span>' + label + '</span><span>−' + money(n) + '</span></div>';
    }
    function editableFinRow(ref, field, label, value, isCost) {
      var numVal = parseFloat(value) || 0;
      var rowClass = isCost ? ' rqd-detail__row--cost' : '';
      var prefix = isCost ? '−' : '';
      return '<div class="rqd-detail__row rqd-fin-editable' + rowClass + '" data-ref="' + esc(ref) + '" data-field="' + field + '">' +
        '<span>' + label + ' <span class="rqd-fin-edit-icon">&#9998;</span></span>' +
        '<span class="rqd-fin-value">' + prefix + money(numVal) + '</span>' +
      '</div>';
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Freight Cost row variant that "deep-links"
       to the Freight Balance card. The actual value lives on one or more
       wm.shippingBuckets[bucketId].freightCost entries; editing the
       Financials rollup directly would be ambiguous when multiple buckets
       exist. Click → scrolls to the bucket panel + focuses the freight
       cost input (prefers a parcel-rate-pending bucket if present). */
    function freightCostScrollRow(ref, value) {
      var n = parseFloat(value) || 0;
      return '<div class="rqd-detail__row rqd-detail__row--cost rqd-fin-freight-scroll" data-ref="' + esc(ref) + '" style="cursor:pointer;" title="Jump to the Freight Balance card to enter the supplier freight cost">' +
        '<span>Freight Cost <span class="rqd-fin-edit-icon">&#9998;</span></span>' +
        '<span>−' + money(n) + '</span>' +
      '</div>';
    }
    // Shared "open this order + scroll to Freight Balance + focus input"
    // action. Used by (a) the ⚠ Freight Pending stat card auto-expand path
    // when a single order remains after filtering, and (b) the Financials
    // card's Freight Cost ✎ wayfinding click. If the detail isn't already
    // open, toggleDetail expands it first; we then poll briefly for the
    // .rqd-fb section to render (Freight Balance can lazy-render on expand
    // for some flows) before scrolling + focusing.
    function jumpToFreightBalance(ref) {
      if (!ref) return;
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (!detailEl) return;
      if (!detailEl.classList.contains('rqd-detail--open')) {
        try { toggleDetail(ref); } catch (_) {}
      }
      var attempts = 0;
      function tryScroll() {
        var fb = document.querySelector('.rqd-fb[data-ref="' + ref + '"]');
        if (fb) {
          fb.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Prefer a parcel-rate-pending input if present so admin lands
          // exactly on the bucket that needs the supplier's invoice value.
          setTimeout(function () {
            var pendingInp = fb.querySelector('.rqd-fb__bucket-cost-input[data-parcel-pending="1"]');
            var inp = pendingInp || fb.querySelector('.rqd-fb__bucket-cost-input');
            if (inp) { inp.focus(); inp.select && inp.select(); }
          }, 380);
          return;
        }
        if (++attempts < 10) setTimeout(tryScroll, 60);
      }
      tryScroll();
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Map toggle field names to their date field names in the lifecycle API
    var toggleDateFields = {
      invoiced: 'invoicedDate',
      paid: 'paymentDate',
      taxesRemitted: 'taxesRemittedDate',
      installerPaid: 'installerPaidDate',
      commissionPaid: 'commissionPaidDate',
      cfaCommissionPaid: 'cfaCommissionPaidDate',
      referralPaid: 'referralPaidDate'
    };

    function buildToggle(ref, field, label, isDone, dateVal, opts) {
      var done = !!isDone;
      var dateStr = dateVal ? formatDate(dateVal) : '';
      // opts.disabled — when true, the row renders grayed out and click is
      // suppressed (data-field is omitted so handleToggleClick short-circuits
      // on its !field gate). opts.disabledReason becomes the title tooltip.
      // opts.editableDate — render the date as an <input type="date"> ALWAYS
      // (regardless of done state) so the rep can pick the date directly.
      // Picking a date on an undone toggle also flips done (and the green
      // class so it visually reads as "set"); changing on a done toggle just
      // updates the date.
      var disabled = !!(opts && opts.disabled);
      var editableDate = !!(opts && opts.editableDate);
      /* CUSTOM_DDINSTALL_BY_CLAUDE (Ryan 2026-09-02) — opts.optionalDate: ticking this row records
         the flag and NO date.

         ⛔ EVERY CLOSEOUT TOGGLE HAS ALWAYS FABRICATED ONE. `handleToggleClick` writes
         `todayStr()` into the date field the moment you tick the box, so a payment recorded a week
         after the fact has been filed under the wrong day since these rows were written — silently,
         because a date that looks plausible reads as a date somebody chose. Ryan, 2026-09-02:
         *"it's easy to forget to mark these things on the exact day, so sometimes it's best to not
         make something up and just say 'yes we paid them but I don't remember the exact date'."*

         📌 Pairs with `editableDate`: tick the row for "yes, date unknown", or pick a date in the
         inline picker for both at once (that path already flips the toggle done, unchanged). The
         attribute is read by handleToggleClick — the renderer states the intent, one handler acts
         on it. Applied ONLY to Installer paid for now; the other rows keep today's behaviour until
         Ryan says otherwise. */
      var optionalDate = !!(opts && opts.optionalDate);
      var disabledReason = opts && opts.disabledReason ? esc(opts.disabledReason) : '';
      var dateField = toggleDateFields[field] || (field + 'Date');
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — datePopover mode (used by
         the Commission card): instead of an inline native date input, an unpaid
         row shows a "-- Select --" pill that opens a date popover; Save logs the
         payment with the chosen date — mirroring the Purchasing card's Mark
         Purchased flow. A paid row shows the check + date + an "Edit" link that
         re-opens the popover to change the date or undo. */
      var datePopover = !!(opts && opts.datePopover);
      if (datePopover) {
        if (done) {
          // Done: matches the Purchasing card's purchased state — "<label> -
          // M/D/YYYY" on the left, ghosted Edit button (rqd-invoice__generate)
          // right-aligned in the .rqd-invoice slot. rqd-commission-edit is just
          // the JS hook (styling comes from rqd-invoice__link/__generate).
          return '<div class="rqd-toggle rqd-toggle--done" data-ref="' + esc(ref) + '" data-step="' + esc(field) + '" data-state="done">' +
            '<div class="rqd-toggle__check">&#10003;</div>' +
            '<span>' + label + (dateStr ? ' - ' + dateStr : '') + '</span>' +
            '<div class="rqd-invoice">' +
              '<button type="button" class="rqd-invoice__link rqd-invoice__generate rqd-commission-edit" data-action="commission-paid-edit" data-ref="' + esc(ref) + '" data-field="' + esc(field) + '" data-date-field="' + esc(dateField) + '" data-label="' + esc(label) + '" title="Change the date or undo">Edit</button>' +
            '</div>' +
            '</div>';
        }
        // Unpaid: "-- Select --" uses the standard .rqd-invoice__link button in a
        // .rqd-invoice slot, so it matches the other cards' buttons + right-column
        // alignment. rqd-commission-select is just the JS hook (no own styling).
        var _cpDisAttr = disabled ? ' disabled aria-disabled="true"' : '';
        var _cpDisCls = disabled ? ' rqd-invoice__link--disabled' : '';
        return '<div class="rqd-toggle' + (disabled ? ' rqd-toggle--disabled' : '') + '" data-ref="' + esc(ref) + '"' + ' data-step="' + esc(field) + '" data-state="' + (disabled ? 'blocked' : 'pending') + '"' + (disabled && disabledReason ? ' data-blocked-reason="' + disabledReason + '"' : '') +
          (disabled && disabledReason ? ' title="' + disabledReason + '"' : '') + '>' +
          '<div class="rqd-toggle__check"></div>' +
          '<span>' + label + '</span>' +
          '<div class="rqd-invoice">' +
            '<button type="button" class="rqd-invoice__link rqd-commission-select' + _cpDisCls + '" data-action="commission-paid-open" data-ref="' + esc(ref) + '" data-field="' + esc(field) + '" data-date-field="' + esc(dateField) + '" data-label="' + esc(label) + '"' + _cpDisAttr + '>-- Select --</button>' +
          '</div>' +
          '</div>';
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var dateNode = '';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Render the date input whenever
         editableDate is set, even if the row is `disabled`. Locked rows
         get the `disabled` HTML attr on the input so the picker is
         visible-but-grayed; user sees the date slot ahead of time and
         knows what they'll fill in. */
      if (editableDate) {
        var isoVal = dateVal ? new Date(dateVal).toISOString().slice(0, 10) : '';
        var filledClass = isoVal ? ' rqd-toggle__date-input--filled' : '';
        var disabledAttr = disabled ? ' disabled aria-disabled="true"' : '';
        dateNode = '<span class="rqd-toggle__date-wrap">' +
          '<input type="date" class="rqd-toggle__inline-date rqd-toggle__date-input' + filledClass + '" data-ref="' + esc(ref) + '" data-field="' + esc(dateField) + '" data-toggle-field="' + esc(field) + '" value="' + esc(isoVal) + '"' + disabledAttr + '>' +
          '<span class="rqd-toggle__date-placeholder">Select date</span>' +
          '</span>';
      } else if (dateStr) {
        dateNode = '<span class="rqd-toggle__date">' + dateStr + '</span>';
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) - PHASE 2: one place tags every
         closeout toggle. buildToggle renders Taxes Remitted, Installer Paid, Commission Paid,
         CFA Commission, Referral and the invoice/payment rows, and each one's state existed
         only as `rqd-toggle--done`. `data-step` is the FIELD, so a reader asks about the
         thing it cares about rather than counting rows; `data-blocked-reason` surfaces the
         disabled explanation that was hover-only (e.g. commission is locked until the order
         is paid in full - the reason somebody would otherwise file a bug about). */
      var _tgState = disabled ? 'blocked' : (done ? 'done' : 'pending');
      return '<div class="rqd-toggle' + (done ? ' rqd-toggle--done' : '') + (disabled ? ' rqd-toggle--disabled' : '') + '" data-ref="' + esc(ref) + '"' + ' data-step="' + esc(field) + '" data-state="' + _tgState + '"' + (optionalDate ? ' data-optional-date="1"' : '') + (disabled && disabledReason ? ' data-blocked-reason="' + disabledReason + '"' : '') +
        (disabled ? '' : ' data-field="' + field + '"') +
        (disabled && disabledReason ? ' title="' + disabledReason + '"' : '') + '>' +
        '<div class="rqd-toggle__check">' + (done ? '&#10003;' : '') + '</div>' +
        '<span>' + label + '</span>' +
        dateNode +
        '</div>';
    }

    // Re-apply the expanded-row state after a fetchQuotes re-render so
    // closing a modal doesn't visually collapse the order the admin was
    // working in. Honours both expandedRef (single-row open) and
    // expandedGroup (revision-chain group open). Silent no-op if the
    // previously-expanded row is no longer in the rendered set
    // (e.g. filter changed and the row got paginated out).
    function restoreExpandedRow() {
      if (expandedRef) {
        // Lazy detail: build the panel content before snapping it open so the
        // forced-reflow height below is accurate.
        ensureDetailBuilt(expandedRef);
        var detailEl = document.getElementById('rqd-detail-' + expandedRef);
        var dataRow = tbody.querySelector('tr[data-ref="' + expandedRef + '"]');
        if (detailEl && dataRow) {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-29) — Snap the restored row
             open WITHOUT the max-height transition. On a quiet re-render (e.g.
             after an email send) the panel was animating open AFTER fetchQuotes'
             scrollTo, growing the page post-scroll and flinging the rep elsewhere.
             transition:none + forced reflow makes the height final synchronously
             so the scroll restore lands accurately; transition re-enabled next
             frame for normal expand/collapse. */
          detailEl.style.transition = 'none';
          detailEl.classList.add('rqd-detail--open');
          dataRow.classList.add('rqd-row--expanded');
          void detailEl.offsetHeight;
          requestAnimationFrame(function () { detailEl.style.transition = ''; });
          var icon = dataRow.querySelector('.rqd-expand-icon');
          if (icon) {
            icon.textContent = '−';
            icon.classList.add('rqd-expand-icon--open');
          }
        } else {
          // Row no longer in view — clear the stale ref so future renders
          // don't keep trying to restore something that's gone.
          expandedRef = null;
        }
      }
      if (expandedGroup) {
        var children = tbody.querySelectorAll('tr[data-revision-group="' + expandedGroup + '"]');
        if (children.length === 0) {
          expandedGroup = null;
        } else {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-17) — actually RE-OPEN the
             revision chain after a quiet re-render. Previously this only checked
             the children still existed; the rebuilt table renders the group
             COLLAPSED (children carry rqd-revision-row--hidden by default), so an
             expanded chain silently snapped shut on the 2-min background poll /
             tab-return refresh ("expand a parent into its chain, then it
             auto-closes after a few seconds"). Mirror the open branch of the
             version-badge click handler: open the badge, unhide the child rows,
             and re-apply the group-border classes. */
          var vBadgeR = tbody.querySelector('.rqd-version-badge[data-revision-group="' + expandedGroup + '"]');
          if (vBadgeR) {
            vBadgeR.classList.add('rqd-version-badge--open');
            var parentRowR = vBadgeR.closest('tr');
            if (parentRowR) parentRowR.classList.add('rqd-group-open', 'rqd-group-top');
          }
          children.forEach(function (r) {
            r.classList.remove('rqd-revision-row--hidden');
            r.classList.add('rqd-group-open');
          });
          children[children.length - 1].classList.add('rqd-group-bottom');
        }
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — build a row's detail panel on
       demand (lazy render). Idempotent; safe to call before any open/restore. Returns
       the .rqd-detail element (or null). */
    function ensureDetailBuilt(ref) {
      var el = document.getElementById('rqd-detail-' + ref);
      if (!el || el.dataset.detailBuilt === '1') return el;
      var q = _renderedQById[ref] || (allQuotes && allQuotes.find(function (x) { return x && x.reference === ref; }));
      if (!q) return el;
      el.innerHTML = buildDetailHtml(q);
      el.dataset.detailBuilt = '1';
      try { applyCollapseState(el, q); } catch (_) {}
      return el;
    }

    function toggleDetail(ref) {
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (!detailEl) return;
      // Lazy build the panel content the first time the row is opened.
      ensureDetailBuilt(ref);

      // Close any other open detail
      if (expandedRef && expandedRef !== ref) {
        var prevDetail = document.getElementById('rqd-detail-' + expandedRef);
        if (prevDetail) prevDetail.classList.remove('rqd-detail--open');
        var prevRow = tbody.querySelector('tr[data-ref="' + expandedRef + '"]');
        var prevIcon = prevRow && prevRow.querySelector('.rqd-expand-icon');
        if (prevIcon) { prevIcon.textContent = '+'; prevIcon.classList.remove('rqd-expand-icon--open'); }
        if (prevRow) prevRow.classList.remove('rqd-row--expanded');
      }

      var isOpen = detailEl.classList.contains('rqd-detail--open');
      detailEl.classList.toggle('rqd-detail--open');
      expandedRef = isOpen ? null : ref;

      var dataRow = tbody.querySelector('tr[data-ref="' + ref + '"]');
      if (dataRow) dataRow.classList.toggle('rqd-row--expanded', !isOpen);
      // Phase 1.28 — Toggle a table-level "has-expanded" flag so CSS can
      // gently dim the other rows. Subtle focus assist for long lists;
      // 55% opacity, no desaturation — neighbors stay scannable.
      var tableEl = tbody && tbody.closest('table.rqd-table');
      if (tableEl) tableEl.classList.toggle('rqd-table--has-expanded', !!expandedRef);
      var icon = dataRow && dataRow.querySelector('.rqd-expand-icon');
      if (icon) {
        icon.textContent = isOpen ? '+' : '−';
        icon.classList.toggle('rqd-expand-icon--open', !isOpen);
      }

      // Lazy-load Order Contents for offline SOLD orders on first expand.
      // The placeholder div was rendered in buildDetailHtml; we fetch
      // /quote-details once, cache items on the q object, then replace the
      // placeholder with the rendered card. Re-expansion uses cached items.
      if (!isOpen) {
        var loadingEl = detailEl.querySelector('[data-order-contents-loading="1"]');
        if (loadingEl) {
          (function fetchOrderContents() {
            API.get('/quote-details?ref=' + encodeURIComponent(ref)).then(function(res) {
              /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM⁵) — this early return used to
                 just `return`, leaving "Loading order contents…" on screen forever. Ryan hit it
                 on RW-1290-A, but it was never linked-specific: ANY deal whose /quote-details
                 comes back without a lineItems array (no draft order — a lead-state deal, a
                 wm stub created on link) hangs the placeholder. The empty-items path a few lines
                 down already removes it; this path forgot to. */
              if (!res || !res.success || !res.quote || !Array.isArray(res.quote.lineItems)) {
                loadingEl.remove();
                return;
              }
              var items = res.quote.lineItems
                .filter(function(li) { return !li.isSpacer; })
                .map(function(li) {
                  // Prefer the rep-set directPrice over Shopify's MAP-stamped
                  // originalUnitPrice — the Order Contents card should reflect
                  // the actual customer-facing quote price.
                  var unit = parseFloat(li.directPrice) || parseFloat(li.price) || 0;
                  var qty = parseInt(li.quantity, 10) || 0;
                  return {
                    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Carry through lineItemId
                       + isNew from the worker so the Order Contents card's
                       NEW toggle works on offline orders (same per-line
                       flag system as online). */
                    lineItemId: li.lineItemId || '',
                    isNew: !!li.isNew,
                    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
                    title: li.title || '',
                    variantTitle: '',
                    sku: li.sku || '',
                    quantity: qty,
                    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-14) — carry the qty override
                       through so the offline card renders the ✎ pencil in its overridden state.
                       Without these the override would drive the vendor PO invisibly: the cell
                       falls back to `quantity`, which is still the draft's original number. */
                    effectiveQuantity: (li.effectiveQuantity != null) ? (parseInt(li.effectiveQuantity, 10) || 0) : null,
                    quantityOverridden: !!li.quantityOverridden,
                    unitPrice: unit,
                    lineTotal: unit * qty,
                    vendor: li.vendor || '',
                    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21 PM²) — carried through for the
                       pallet-fee estimate on the Financials card: a weight-stack upgrade rides its
                       machine's pallet and must not be counted as one. The worker answers this with
                       the same predicate the PO uses; dropping it here would leave the theme to
                       guess from a title. */
                    isStackUpgrade: !!li.isStackUpgrade,
                    productTags: [],
                    /* CUSTOM_ASKUNITS_BY_CLAUDE (ONYX 8737a938898f) - the unit the PO prints for this line; the
                       freight / dims ask reads it so the supplier sees "464 sq ft", not "(464x)". */
                    poUnit: li.poUnit || '',
                    /* CUSTOM_RFQPORTAL_BY_CLAUDE — roll layout (flooring rolls) */
                    isRoll: !!li.isRoll,
                    rollLayout: li.rollLayout || '',
                    /* Cuts as an array (offline only) so the card can chip each group —
                       see dashboard-order-cards.js. Falls back to rollLayout when absent. */
                    rollLabel: li.rollLabel || '',
                    rollCuts: Array.isArray(li.rollCuts) ? li.rollCuts : [],
                    /* CUSTOM_LINESWAP_BY_CLAUDE (Ryan 2026-09-16) — the flooring colour, which the
                       worker has shipped on every offline line since 2026-08-26 and this map never
                       named — so it arrived undefined and the card could not draw it. The same
                       explicit-whitelist trap the Legend spec note above records, one field over. */
                    color: li.color || '',
                    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
                    /* CUSTOM_LEGENDSPEC_BY_CLAUDE (Ryan 2026-08-21) — the Legend build spec on
                       offline deals. This map is an explicit whitelist, so a field the worker now
                       ships still arrives as undefined unless it is named here — which is why the
                       spec stayed invisible on every rep-built Legend order even after the worker
                       could compute it. Same four keys as the online shape (quote-summary-builder),
                       so the card reads one vocabulary. */
                    legendSpecRows: Array.isArray(li.legendSpecRows) ? li.legendSpecRows : [],
                    legendSpecDerived: Array.isArray(li.legendSpecDerived) ? li.legendSpecDerived : [],
                    legendSpecOverridden: !!li.legendSpecOverridden,
                    legendSpecNote: li.legendSpecNote || '',
                    /* CUSTOM_SPECMISMATCH_BY_CLAUDE — rows where the rep's quote text contradicts
                       the variant the vendor PO reads. Offline-only by nature. */
                    specMismatches: Array.isArray(li.specMismatches) ? li.specMismatches : [],
                  };
                });
              /* CUSTOM_NOCHARGEADD_BY_CLAUDE (Ryan 2026-09-12) — items Adjust Order put on this
                 deal's PAID order after Shopify froze the draft behind the quote. Order Contents is
                 built from the draft, so without this it shows the quote's items while the
                 customer's own order and the vendor PO both carry one more — which is exactly the
                 discrepancy somebody would open a ticket about.

                 ⛔ THEY ARRIVE IN THEIR OWN FIELD AND ARE APPENDED HERE, NEVER MERGED SERVER-SIDE
                 INTO `quote.lineItems`. The WORKSTATION loads through the same /quote-details, and
                 a line folded into that array would ride out in the rep's next save payload and
                 trip the paid-draft goods lock — 409 on every later save of a deal whose notes and
                 costs are still meant to be editable. Appending in the DASHBOARD's own handler is
                 what keeps the two apart.

                 Marked rather than blended: `_addedAfterPayment` is what the card's badge reads. A
                 free line at $0 sitting silently among priced ones reads as a pricing bug. */
              (Array.isArray(res.orderAdditions) ? res.orderAdditions : []).forEach(function (a) {
                if (!a) return;
                var q2 = parseInt(a.quantity, 10) || 1;
                var unit2 = parseFloat(a.unitPrice) || 0;
                items.push({
                  /* CUSTOM_NOCHARGEADD_BY_CLAUDE (Ryan 2026-09-12) — the worker's own id for this
                     line, which is what earns the row its `+` menu: that button gates on
                     `lineItemId`, and the NEW / Freight-Quoted flags it writes are stored keyed by
                     it. The vendor PO mints the SAME id for its copy of the line, so a box ticked
                     here reaches the document it is meant to change. */
                  lineItemId: a.lineItemId || '',
                  isNew: !!a.isNew,
                  isFreightQuotedFlag: !!a.isFreightQuotedFlag,
                  title: a.title || a.sku || 'item',
                  /* CUSTOM_LINESWAP_BY_CLAUDE (Ryan 2026-09-16) — the option and the colour, so a
                     swapped-in line reads like the line it replaced instead of carrying the colour
                     inside its name. The worker strips the option out of `title` for the same
                     reason. */
                  variantTitle: a.variantTitle || '',
                  color: a.color || '',
                  sku: a.sku || '',
                  quantity: q2, effectiveQuantity: null, quantityOverridden: false,
                  unitPrice: unit2, lineTotal: unit2 * q2,
                  vendor: a.vendor || '', isStackUpgrade: false, productTags: [],
                  /* CUSTOM_LINESWAP_BY_CLAUDE (Ryan 2026-09-16) — THE CUT LIST THIS LINE
                     INHERITED. An added line has no Workstation entry and can never have one, so
                     its lengths are the ones off the line it replaced — resolved by the worker
                     with the SAME function the PO builder uses, never re-derived here.
                     ⚠ `isRoll` stays false: it means "carries the roll metafield", which this
                     record cannot answer, and the only thing reading it is the online
                     missing-layout nag. */
                  isRoll: false,
                  rollLayout: a.rollLayout || '',
                  rollLabel: a.rollLabel || '',
                  rollCuts: Array.isArray(a.rollCuts) ? a.rollCuts : [],
                  rollCutsInherited: !!a.rollCutsInherited,
                  legendSpecRows: [], legendSpecDerived: [], legendSpecOverridden: false,
                  legendSpecNote: '', specMismatches: [],
                  _addedAfterPayment: true,
                  _noCharge: !!a.noCharge,
                  _addedBy: a.addedBy || '',
                  _addedAt: a.addedAt || '',
                });
              });
              var qq = allQuotes.find(function(x) { return x.reference === ref; });
              if (qq) qq.offlineLineItems = items;
              /* Ryan 2026-05-21: also persist to a module-level cache
                 keyed by ref so the lazy-loaded items survive the 2-min
                 auto-refresh re-renders (fetchQuotes rebuilds allQuotes
                 from the server response, wiping qq.offlineLineItems).
                 The buildDetailHtml render path checks this cache and
                 reuses items instead of re-injecting the "Loading…"
                 placeholder. */
              if (typeof window.__orderContentsCache !== 'object' || window.__orderContentsCache === null) {
                window.__orderContentsCache = {};
              }
              window.__orderContentsCache[ref] = items;
              if (items.length > 0) {
                // outerHTML replaces the loading element; we need a reference
                // to the new card to apply collapsible chrome to it. Capture
                // the parent + a unique marker, swap, then re-query.
                var parentEl = loadingEl.parentElement;
                /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Mirror the
                   Log Pallet Dims pass-through from the initial-render caller
                   (~L8155). Without these, offline SOLD deals' Order Contents
                   card never showed the 📦 Log dims button — the lazy-load
                   re-render here was silently overwriting the initial render
                   with opts missing lifecycleStatus + existingDims, failing
                   the button-render gate. Same fix shape as the linkedCredit
                   pass-through that landed here earlier. */
                var _lazyFbDims = (qq && qq.freightBalance && qq.freightBalance.dims) || null;
                var _lazyExistingDims = null;
                if (_lazyFbDims && typeof _lazyFbDims === 'object') {
                  _lazyExistingDims = (Array.isArray(_lazyFbDims.groups) && _lazyFbDims.groups.length > 0)
                    ? _lazyFbDims.groups
                    : (Array.isArray(_lazyFbDims.pallets) ? _lazyFbDims.pallets : null);
                }
                loadingEl.outerHTML = renderOrderContentsCard(items, (qq && qq.financials) || {}, {
                  isOnline: qq && qq.source === 'online',
                  isAdmin: isAdmin,
                  ref: ref,
                  lineVendorOverrides: (qq && qq.lineVendorOverrides) || {}, // CUSTOM_ALTSOURCE_BY_CLAUDE
                  // CUSTOM_AUTOFREIGHT_BY_CLAUDE (Ryan 2026-08-28) — see the note on the initial render.
                  autoFreightByVendor: (qq && qq._autoFreightByVendor) || {},
                  // CUSTOM_AUTOFREIGHT_BY_CLAUDE (Ryan 2026-08-29) — the lazy re-render's own opts.
                  // Missing it here is the exact trap the note on the other path describes: the chip
                  // would be right on first paint and wrong the moment Order Contents refreshed.
                  orderIsFreightQuoted: !!(qq && qq._isFreightQuoted),
                  lifecycleStatus: qq && qq.lifecycleStatus,
                  rollLengths: (qq && qq.rollLengths) || null, // CUSTOM_ROLLMATH_BY_CLAUDE — see the initial render
                  rollAdjustable: !!(isAdmin && qq && qq.source === 'online' && qq.lifecycleStatus === 'sold'),
                  customCosts: qq && qq.customCosts,
                  rollUpBalanceTotal: !!(qq && ((qq.balanceCollected && qq.balanceCollected.paid) || (qq.autoReconciledChildRefs && qq.autoReconciledChildRefs.length))),
                  existingDims: _lazyExistingDims,
                  /* CUSTOM_RFQPORTAL_BY_CLAUDE — Pass through the Existing
                     Credit info on the lazy-load re-render too. The initial
                     render at buildDetailHtml passes these in opts, but the
                     lazy-load path here was building opts inline and missed
                     them — causing the credit row to disappear after the
                     offline-quote items lazy-loaded. */
                  linkedCreditAmount: qq && qq.linkedCreditAmount,
                  linkedCreditSourceRef: qq && qq.linkedCreditSourceRef,
                  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) —
                     Option B combined view mirrors the initial-render
                     caller above; always-empty arrays. */
                  parentCardFeeLines: [],
                  parentCreditLines: [],
                });
                var detailEl = parentEl && parentEl.closest('[id^="rqd-detail-"]');
                if (detailEl && qq) applyCollapseState(detailEl, qq);
                /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21 PM²) — the Financials card can only
                   estimate the pallet fee once it has real line items, and on an offline deal those
                   arrive HERE, after the card has already been drawn from the summary. Re-render
                   the panel so the estimate appears instead of waiting for the next refresh.

                   Gated to deals that can actually carry one (a vendor with a rate, and no PO-stamped
                   fee — the stored value outranks any estimate), so the ordinary deal keeps the
                   surgical swap above and never pays for a re-render. Safe to redo the whole panel:
                   buildDetailHtml reads __orderContentsCache, which was populated two lines up, so
                   the card it just built is rebuilt from the same items rather than reverting to the
                   loading placeholder. */
                if (detailEl && qq && qq.vendorPalletFees
                    && !(parseFloat(qq.financials && qq.financials.palletFee) > 0)) {
                  detailEl.innerHTML = buildDetailHtml(qq);
                  applyCollapseState(detailEl, qq);
                }
              } else {
                loadingEl.remove();
              }
            }).catch(function(err) {
              console.error('Failed to load order contents for ' + ref + ':', err);
              var inner = loadingEl.querySelector('.rqd-online-items-loading');
              if (inner) inner.textContent = 'Couldn’t load order contents.';
            });
          })();
        }
      }
    }

    // ── Status Change Modal ──

    var pendingStatusChange = null;
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — set to a ref while the "Clear
       reminder?" confirm (which reuses this same modal shell) is open. */
    var pendingReminderClear = null;

    function openStatusModal(q) {
      var currentLS = q.lifecycleStatus || 'quoted';
      modalTitle.textContent = 'Update Status: ' + q.reference;
      modalSub.textContent = 'Currently: ' + capitalize(currentLS);

      // Pre-fill sold basis from existing data if re-opening a sold quote
      var existingBasis = q.soldBasis || {};
      var existingWaiver = q.tncWaiver || {};

      var html = '<label class="rqd-modal__label">New Status</label>';
      html += '<select class="rqd-modal__input" id="rqd-modal-status">';
      html += '<option value="quoted"' + (currentLS === 'quoted' ? ' selected' : '') + '>Quoted</option>';
      html += '<option value="sold"' + (currentLS === 'sold' ? ' selected' : '') + '>Sold</option>';
      html += '<option value="lost"' + (currentLS === 'lost' ? ' selected' : '') + '>Lost</option>';
      html += '</select>';

      // ── SOLD fields: date + gating checkboxes ──
      html += '<div id="rqd-modal-sold-fields" style="display:none;">';
      html += '<label class="rqd-modal__label">Date Sold</label>';
      html += '<input type="date" class="rqd-modal__input" id="rqd-modal-sold-date" value="' + (q.dateSold || todayStr()) + '">';

      html += '<p class="rqd-modal__section-label">What do you have? (at least one required)</p>';
      html += '<div class="rqd-modal__checkbox-group">';

      /* CUSTOM_SIGNEDORDERPENDING_BY_CLAUDE (ONYX 51b7fca781f6, Ryan 2026-10-16) - the signed order is Received or Not
         required, never both. Neither ticked on a paid deal (no PO) saves the deal as SOLD and PENDING: the signed order
         is still owed and Abby asks for it. */
      var _soChoice = existingBasis.signedOrderChoice || (existingBasis.signedOrder ? 'received' : '');
      var _soReceived = _soChoice === 'received';
      var _soNotReq = _soChoice === 'not-required';
      html += '<label class="rqd-modal__checkbox-row' + (_soReceived ? ' rqd-modal__checkbox-row--checked' : '') + '" id="rqd-sold-row-signed">';
      html += '<input type="checkbox" id="rqd-sold-signed"' + (_soReceived ? ' checked' : '') + '> Signed order form: Received';
      html += '</label>';
      html += '<label class="rqd-modal__checkbox-row' + (_soNotReq ? ' rqd-modal__checkbox-row--checked' : '') + '" id="rqd-sold-row-signed-nr">';
      html += '<input type="checkbox" id="rqd-sold-signed-nr"' + (_soNotReq ? ' checked' : '') + '> Signed order form: Not required';
      html += '</label>';
      html += '<div class="rqd-modal__checkbox-sub" id="rqd-sold-pending-note" style="display:none;font-size:12px;opacity:0.8;">Payment with no signed order: the deal saves as SOLD (PENDING) and Abby asks the customer to sign the proposal.</div>';

      // PO received
      html += '<label class="rqd-modal__checkbox-row' + (existingBasis.poReceived ? ' rqd-modal__checkbox-row--checked' : '') + '" id="rqd-sold-row-po">';
      html += '<input type="checkbox" id="rqd-sold-po"' + (existingBasis.poReceived ? ' checked' : '') + '> PO received';
      html += '</label>';
      html += '<div class="rqd-modal__checkbox-sub" id="rqd-sold-po-fields" style="display:' + (existingBasis.poReceived ? 'block' : 'none') + ';">';
      html += '<input type="text" class="rqd-modal__input" id="rqd-sold-po-number" placeholder="PO #" value="' + esc(existingBasis.poNumber || '') + '">';
      html += '</div>';

      // Payment received — one or more payments (each: amount + method + date).
      // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-18) — multi-payment recording.
      html += '<label class="rqd-modal__checkbox-row' + (existingBasis.paymentReceived ? ' rqd-modal__checkbox-row--checked' : '') + '" id="rqd-sold-row-payment">';
      html += '<input type="checkbox" id="rqd-sold-payment"' + (existingBasis.paymentReceived ? ' checked' : '') + '> Payment received';
      html += '</label>';
      html += '<div class="rqd-modal__checkbox-sub" id="rqd-sold-payment-fields" style="display:' + (existingBasis.paymentReceived ? 'block' : 'none') + ';">';
      html += '<div id="rqd-sold-payments-list"></div>';
      // CUSTOM_PAIDCOMPOSE_BY_CLAUDE — a rep reports ONE incoming payment by method; there is
      // nothing to add a second row of when no amounts are being entered.
      if (isAdmin) html += '<button type="button" class="rqd-pill" id="rqd-sold-add-payment" style="font-size:11px;margin-top:2px;">+ Add another payment</button>';
      html += '</div>';

      html += '</div>'; // end checkbox-group

      html += '</div>'; // end sold-fields

      // ── LOST fields ──
      html += '<div id="rqd-modal-lost-fields" style="display:none;">';
      html += '<label class="rqd-modal__label">Date Lost</label>';
      html += '<input type="date" class="rqd-modal__input" id="rqd-modal-lost-date" value="' + todayStr() + '">';
      html += '<label class="rqd-modal__label">Reason (required)</label>';
      html += '<textarea class="rqd-modal__input" id="rqd-modal-lost-reason" rows="3" placeholder="Why was this quote lost?" style="resize:vertical;">' + esc(q.lostReason || '') + '</textarea>';
      html += '</div>';

      modalBody.innerHTML = html;
      pendingStatusChange = q;
      pendingReminderClear = null; // mutually exclusive with the clear-reminder mode

      // Show/hide fields based on status selection
      var statusSel = document.getElementById('rqd-modal-status');

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-18) — multi-payment rows. Each
         payment = amount + method + date; 100%/50% quick-fill off the order total;
         Date Sold derives from the latest payment date. */
      var PMT_METHODS = ['Card', 'ACH', 'Wire', 'Check', 'Zelle', 'Cash'];
      var orderTotal = parseFloat(q.total || q.quoteAmount || q.amount || 0) || 0;
      var paymentsList = document.getElementById('rqd-sold-payments-list');
      function pmtMethodOpts(sel) {
        var o = '';
        for (var i = 0; i < PMT_METHODS.length; i++) {
          o += '<option value="' + PMT_METHODS[i] + '"' + (sel === PMT_METHODS[i] ? ' selected' : '') + '>' + PMT_METHODS[i] + '</option>';
        }
        return o;
      }
      // Live "$1,000.00" formatting for the amount field (text input, not number,
      // so it can show the $ + thousands separators). Read back via parseFloat
      // after stripping non-numeric chars.
      function formatAmountInput(el) {
        if (!el) return;
        var raw = String(el.value || '').replace(/[^0-9.]/g, '');
        if (raw === '') { el.value = ''; return; }
        var firstDot = raw.indexOf('.');
        var intPart, decPart;
        if (firstDot === -1) { intPart = raw; decPart = null; }
        else { intPart = raw.slice(0, firstDot); decPart = raw.slice(firstDot + 1).replace(/\./g, '').slice(0, 2); }
        intPart = intPart.replace(/^0+(?=\d)/, '');
        var intFmt = intPart ? Number(intPart).toLocaleString('en-US') : '';
        var out = '$' + (intFmt || '0');
        if (decPart !== null) out += '.' + decPart;
        el.value = out;
      }
      function pmtRowHtml(p) {
        p = p || {};
        var amt = (p.amount != null && p.amount !== '' && !isNaN(parseFloat(p.amount))) ? parseFloat(p.amount) : '';
        var amtStr = (amt !== '') ? ('$' + Number(amt).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) : '';
        var dt = p.date || todayStr();
        /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE (Ryan 2026-08-31) — REPS REPORT, ADMINS RECORD.
           Ryan: *"admins are the ones that control bank accounts and cash checks... reps, not so
           much. But reps receive verbal confirmation from customers that 'we're buying' or 'we're
           sending the money' — so reps can mark it as sold, and the admins can mark it as paid."*

           A rep gets the METHOD and nothing else: enough to say what is coming, no amount and no
           date, so nothing they submit can reach lifecycle.payments or move the paid-in-full math
           that fires the customer's invoice. The worker enforces the same split (quote-routes.js
           MONEY_FIELDS + the rep.admin gate on the W2 block) — this is the honest UI for it, not
           the guard itself. ⛔ Fields are REMOVED rather than disabled: a greyed-out amount box
           still reads as "someone will fill this in", and the whole point is that the rep is
           reporting a promise, not entering money. */
        if (!isAdmin) {
          return '<div class="rqd-sold-pmt-row" style="display:flex;flex-wrap:wrap;align-items:center;gap:8px;margin-bottom:8px;">'
            + '<select class="rqd-modal__input rqd-sold-pmt-method" style="flex:0 0 110px;">' + pmtMethodOpts(p.method) + '</select>'
            + '<span style="font-size:11px;color:var(--rq-text-secondary,#5a6b7d);flex:1 1 180px;">Amount is recorded by an admin once it clears.</span>'
            + '</div>';
        }
        return '<div class="rqd-sold-pmt-row" style="display:flex;flex-wrap:wrap;align-items:center;gap:6px;margin-bottom:8px;">'
          + '<input type="text" inputmode="decimal" class="rqd-modal__input rqd-sold-pmt-amount" placeholder="$ Amount" value="' + esc(amtStr) + '" style="flex:0 0 96px;width:96px;">'
          + '<button type="button" class="rqd-pill rqd-sold-pmt-quick" data-pct="100" style="align-self:stretch;font-size:11px;padding:0 8px;">100%</button>'
          + '<button type="button" class="rqd-pill rqd-sold-pmt-quick" data-pct="50" style="align-self:stretch;font-size:11px;padding:0 8px;">50%</button>'
          + '<select class="rqd-modal__input rqd-sold-pmt-method" style="flex:0 0 86px;">' + pmtMethodOpts(p.method) + '</select>'
          + '<input type="date" class="rqd-modal__input rqd-sold-pmt-date" value="' + dt + '" style="flex:1 1 120px;min-width:120px;">'
          + '<button type="button" class="rqd-sold-pmt-remove" title="Remove payment" style="background:transparent;border:0;color:#dc2626;font-size:22px;font-weight:700;line-height:1;cursor:pointer;padding:0 6px;">&times;</button>'
          + '</div>';
      }
      function addPmtRow(p) { if (paymentsList) paymentsList.insertAdjacentHTML('beforeend', pmtRowHtml(p)); }
      function seedPmtRows() {
        if (!paymentsList) return;
        paymentsList.innerHTML = '';
        var seed = (existingBasis.paymentReceived && Array.isArray(q.payments) && q.payments.length)
          ? q.payments
          : [{ method: (existingBasis.paymentMethod || 'Card'), date: todayStr() }];
        seed.forEach(function (p) { addPmtRow(p); });
      }
      function latestPmtDate() {
        if (!paymentsList) return '';
        var dates = [];
        paymentsList.querySelectorAll('.rqd-sold-pmt-date').forEach(function (el) { if (el.value) dates.push(el.value); });
        dates.sort();
        return dates.length ? dates[dates.length - 1] : '';
      }
      function syncDateSold() {
        var dateEl = document.getElementById('rqd-modal-sold-date');
        var payCb = document.getElementById('rqd-sold-payment');
        if (!dateEl) return;
        if (payCb && payCb.checked) {
          var latest = latestPmtDate();
          if (latest) { dateEl.value = latest; dateEl.readOnly = true; dateEl.style.opacity = '0.6'; dateEl.title = 'Set automatically from the latest payment date'; return; }
        }
        dateEl.readOnly = false; dateEl.style.opacity = ''; dateEl.title = '';
      }

      function bindCheckboxRow(checkboxId, rowId, subFieldsId, onChange) {
        var cb = document.getElementById(checkboxId);
        var row = document.getElementById(rowId);
        var sub = subFieldsId ? document.getElementById(subFieldsId) : null;
        if (!cb || !row) return;
        cb.addEventListener('change', function() {
          row.classList.toggle('rqd-modal__checkbox-row--checked', cb.checked);
          if (sub) sub.style.display = cb.checked ? 'block' : 'none';
          if (typeof onChange === 'function') onChange();
        });
      }

      function updateFields() {
        var isSold = statusSel.value === 'sold';
        var isLost = statusSel.value === 'lost';
        document.getElementById('rqd-modal-sold-fields').style.display = isSold ? '' : 'none';
        document.getElementById('rqd-modal-lost-fields').style.display = isLost ? '' : 'none';
        // Update confirm button text
        modalConfirm.textContent = isSold ? 'Mark as Sold' : isLost ? 'Mark as Lost' : 'Confirm';
      }
      statusSel.addEventListener('change', updateFields);
      updateFields();

      // Seed payment rows + bind checkbox rows
      seedPmtRows();
      bindCheckboxRow('rqd-sold-signed', 'rqd-sold-row-signed', null, function () { _soExclusive('rqd-sold-signed', 'rqd-sold-signed-nr', 'rqd-sold-row-signed-nr'); _soPendingNote(); });
      bindCheckboxRow('rqd-sold-signed-nr', 'rqd-sold-row-signed-nr', null, function () { _soExclusive('rqd-sold-signed-nr', 'rqd-sold-signed', 'rqd-sold-row-signed'); _soPendingNote(); });
      function _soExclusive(onId, offId, offRowId) {
        var on = document.getElementById(onId), off = document.getElementById(offId), offRow = document.getElementById(offRowId);
        if (on && on.checked && off && off.checked) { off.checked = false; if (offRow) offRow.classList.remove('rqd-modal__checkbox-row--checked'); }
      }
      function _soPendingNote() {
        var note = document.getElementById('rqd-sold-pending-note');
        if (!note) return;
        var sg = document.getElementById('rqd-sold-signed'), nr = document.getElementById('rqd-sold-signed-nr');
        var po = document.getElementById('rqd-sold-po'), pay = document.getElementById('rqd-sold-payment');
        var pending = !!(pay && pay.checked) && !(sg && sg.checked) && !(nr && nr.checked) && !(po && po.checked);
        note.style.display = pending ? 'block' : 'none';
      }
      bindCheckboxRow('rqd-sold-po', 'rqd-sold-row-po', 'rqd-sold-po-fields', _soPendingNote);
      bindCheckboxRow('rqd-sold-payment', 'rqd-sold-row-payment', 'rqd-sold-payment-fields', function () { syncDateSold(); _soPendingNote(); });
      _soPendingNote();

      // Add / remove payment rows + quick-fill + date sync
      var addPmtBtn = document.getElementById('rqd-sold-add-payment');
      if (addPmtBtn) addPmtBtn.addEventListener('click', function() { addPmtRow({ date: todayStr() }); syncDateSold(); });
      if (paymentsList) {
        paymentsList.addEventListener('click', function(e) {
          var rm = e.target.closest && e.target.closest('.rqd-sold-pmt-remove');
          if (rm) {
            var row = rm.closest('.rqd-sold-pmt-row');
            if (row) row.remove();
            if (paymentsList.querySelectorAll('.rqd-sold-pmt-row').length === 0) addPmtRow({ date: todayStr() });
            syncDateSold();
            return;
          }
          var quick = e.target.closest && e.target.closest('.rqd-sold-pmt-quick');
          if (quick) {
            e.preventDefault();
            var pct = parseFloat(quick.getAttribute('data-pct')) || 0;
            var amtEl = quick.closest('.rqd-sold-pmt-row').querySelector('.rqd-sold-pmt-amount');
            if (amtEl) { amtEl.value = orderTotal > 0 ? (Math.round(orderTotal * pct) / 100).toFixed(2) : ''; formatAmountInput(amtEl); }
          }
        });
        paymentsList.addEventListener('change', function(e) {
          if (e.target.classList && e.target.classList.contains('rqd-sold-pmt-date')) syncDateSold();
        });
        paymentsList.addEventListener('input', function(e) {
          if (e.target.classList && e.target.classList.contains('rqd-sold-pmt-amount')) formatAmountInput(e.target);
        });
      }

      syncDateSold();

      modalBackdrop.classList.add('rqd-modal-backdrop--open');
    }

    function closeModal() {
      modalBackdrop.classList.remove('rqd-modal-backdrop--open');
      // Reset wide-modal modifier so the next PENDING modal isn't oversized
      if (modalEl) modalEl.classList.remove('rqd-modal--wide');
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — restore the Confirm button; the
         "Link…" chooser hides it (it's a chooser, not a confirm form). */
      if (modalConfirm) modalConfirm.style.display = '';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-19) — drop the modal's markup on the way out.
         Hiding it left every injected field (and the rep's typed text) in the DOM until some
         later modal happened to overwrite this node. hasUnsavedTyping() now ignores invisible
         textareas, so this is belt-and-braces rather than the fix — but it keeps a stale
         #rqd-lead-message from being found by getElementById, and stops the next predicate
         that forgets to check visibility from inheriting the same trap. Safe because every
         confirm handler reads its fields BEFORE calling closeModal() (verified across all 13
         call sites); if you ever add one that reads after, read them into locals first. */
      if (modalBody) modalBody.innerHTML = '';
      pendingStatusChange = null;
      pendingReminderClear = null;
    }

    modalConfirm.addEventListener('click', async function() {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — Clear-reminder confirm. Reuses
         this modal's Confirm button; clears wm.followUp on a sold deal (no new
         countdown) and re-renders the row. Checked before the status-change path. */
      if (pendingReminderClear) {
        var _crRef = pendingReminderClear;
        modalConfirm.disabled = true;
        modalConfirm.textContent = 'Clearing…';
        try {
          await API.post('/follow-up-clear', { ref: _crRef });
          var _crQ = allQuotes.find(function(x) { return x.reference === _crRef; });
          if (_crQ) { _crQ.followUp = null; refreshProgressBar(_crRef); }
        } catch (err) { /* leave the reminder; user can retry */ }
        modalConfirm.disabled = false;
        modalConfirm.textContent = 'Confirm';
        closeModal();
        return;
      }
      if (!pendingStatusChange) return;
      var q = pendingStatusChange;

      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Edit Sold To save handler.
         Reads the modal inputs, builds a PATCH-shaped payload (only fields
         the user actually filled — empty strings still send to clear,
         omitted via "undefined" never reach the JSON), POSTs to
         /lead-customer-update, then re-fetches the dashboard so the row
         shows the new info immediately. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — Edit Deal Terms save.
         Collects the Terms & Options fields and PATCHes pending/wm via
         /deal-terms-update, then re-fetches so derived cards refresh. */
      if (q._isTermsEdit) {
        function tval(id) { var el = document.getElementById(id); return el ? (el.value || '').trim() : ''; }
        var _dt = tval('rqd-terms-dealtype');
        var _sharedName = tval('rqd-terms-shared-name');
        var _sharedPct = parseFloat(tval('rqd-terms-shared-pct')) || 0;
        // Guard: a Shared Deal with a Shared With name needs a % of GP (mirrors the QW).
        if (_dt === 'shared' && _sharedName && !(_sharedPct > 0)) {
          rqdAlert('% of GP is required when a Shared With name is set on a Shared Deal.');
          return;
        }
        var termsPayload = {
          ref: q.ref,
          leadSource: _dt,
          cfaAttribution: tval('rqd-terms-cfa'),
          terms: tval('rqd-terms-terms'),
          leadTime: tval('rqd-terms-leadtime'),
          expiration: tval('rqd-terms-expiration'),
          referral: (_dt === 'shared' && _sharedName) ? { name: _sharedName, gpPercent: _sharedPct } : null,
        };
        modalConfirm.disabled = true;
        modalConfirm.textContent = 'Saving…';
        try {
          await window.RepPortal.API.post('/deal-terms-update', termsPayload);
          closeModal();
          if (typeof fetchQuotes === 'function') fetchQuotes();
        } catch (err) {
          modalConfirm.disabled = false;
          modalConfirm.textContent = 'Save';
          rqdAlert('Failed to save deal terms: ' + ((err && err.message) || 'error'));
        }
        return;
      }
      /* CUSTOM_SHIPTOPENCIL_BY_CLAUDE (Ryan 2026-10-02, RW-1339-A) — Edit Ship To save. */
      if (q._isShipToEdit) {
        function sval(id) { var el = document.getElementById(id); return el ? (el.value || '').trim() : ''; }
        var shipPayload = {
          ref: q.ref, pane: 'ship',
          shipName: sval('rqd-edit-ship-name'),
          shipCompany: sval('rqd-edit-ship-company'),
          shipStreet: sval('rqd-edit-ship-street1'),
          shipStreet2: sval('rqd-edit-ship-street2'),
          shipCity: sval('rqd-edit-ship-city'),
          shipState: sval('rqd-edit-ship-state').toUpperCase(),
          shipZip: sval('rqd-edit-ship-zip'),
          shipPhone: sval('rqd-edit-ship-phone'),
          shipEmail: sval('rqd-edit-ship-email'),
        };
        if (!shipPayload.shipStreet && !shipPayload.shipCity && !shipPayload.shipZip) {
          rqdAlert('A Ship To needs at least a street, city or ZIP.');
          return;
        }
        modalConfirm.disabled = true;
        modalConfirm.textContent = 'Saving…';
        try {
          var sres = await window.RepPortal.API.post('/lead-customer-update', shipPayload);
          if (!sres || sres.error) throw new Error((sres && sres.error) || 'Save failed');
          modalConfirm.disabled = false;
          modalConfirm.textContent = 'Save';
          var _sq = Array.isArray(allQuotes) ? allQuotes.find(function(x){ return x.reference === q.ref; }) : null;
          if (_sq) {
            _sq.shipTo = {
              name: shipPayload.shipName, company: shipPayload.shipCompany,
              street: shipPayload.shipStreet, street2: shipPayload.shipStreet2,
              city: shipPayload.shipCity, state: shipPayload.shipState, zip: shipPayload.shipZip,
              phone: shipPayload.shipPhone, email: shipPayload.shipEmail,
            };
            if (window.RQD && RQD.rememberInfoTab) RQD.rememberInfoTab(q.ref, 'ship');
            var _sd = document.getElementById('rqd-detail-' + q.ref);
            if (_sd && typeof buildDetailHtml === 'function') _sd.innerHTML = buildDetailHtml(_sq);
          }
          closeModal();
        } catch (err) {
          modalConfirm.disabled = false;
          modalConfirm.textContent = 'Save';
          rqdAlert('Save failed: ' + (err.message || err));
        }
        return;
      }
      if (q._isLeadCustomerEdit) {
        function val(id) {
          var el = document.getElementById(id);
          return el ? (el.value || '').trim() : '';
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — "+ Person". The email field holds
           the PRIMARY only; everyone else comes off the People rows. Read straight out of the
           DOM, the same way every other field in this payload is read.

           ⛔ An EMPTY array is sent deliberately when the rep has removed the last person. The
           worker treats an absent `contacts` as "not mentioned" and an explicit [] as "clear
           them" -- send nothing here and a contact could be added but never taken off. */
        function collectPeople() {
          var rows = document.querySelectorAll('#rqd-edit-cust-people [data-person-row]');
          var out = [];
          Array.prototype.forEach.call(rows, function(row) {
            function f(n) { var el = row.querySelector('[data-f="' + n + '"]'); return el ? (el.value || '').trim() : ''; }
            var c = { name: f('name'), email: f('email'), phone: f('phone') };
            if (c.name || c.email || c.phone) out.push(c); // a blank row the rep never filled in
          });
          return out;
        }
        /* CUSTOM_DEALPEOPLE_BY_CLAUDE (Ryan 2026-10-27) — the To / CC pill boxes. The first To pill is the main contact
           (email); every other pill is a contact with its role, keeping the phone / title saved on it, and the people with
           no address ride along untouched. An empty list is still sent when the rep removed everyone else. */
        var _pp = window.__rqdEditPeople;
        var _ppTo = _pp && _pp.to ? _pp.to.getPeople() : null;
        var _ppCc = _pp && _pp.cc ? _pp.cc.getPeople() : null;
        function collectRolePeople() {
          var ex = (_pp && _pp.extras) || {};
          var withInfo = function(p, role) { var x = ex[String(p.email).toLowerCase()] || {}; return { name: p.name || '', email: p.email, phone: x.phone || '', title: x.title || '', role: role }; };
          return _ppTo.slice(1).map(function(p) { return withInfo(p, 'to'); })
            .concat(_ppCc.map(function(p) { return withInfo(p, 'cc'); }))
            .concat(((_pp && _pp.noEmail) || []).map(function(c) { return { name: c.name || '', title: c.title || '', phone: c.phone || '', email: '', role: c.role === 'to' ? 'to' : 'cc' }; }));
        }
        var residentialCheckbox = document.getElementById('rqd-edit-cust-residential');
        var payload = {
          ref: q.ref,
          name: val('rqd-edit-cust-name') || (_ppTo && _ppTo[0] ? _ppTo[0].name : ''),
          email: _ppTo ? (_ppTo[0] ? _ppTo[0].email : '') : val('rqd-edit-cust-email'),
          contacts: _ppTo ? collectRolePeople() : collectPeople(),
          phone: val('rqd-edit-cust-phone'),
          organization: val('rqd-edit-cust-org'),
          residentialOrCommercial: residentialCheckbox && residentialCheckbox.checked ? 'residential' : '',
          soldStreet: val('rqd-edit-cust-street1'),
          soldStreet2: val('rqd-edit-cust-street2'),
          city: val('rqd-edit-cust-city'),
          state: val('rqd-edit-cust-state').toUpperCase(),
          zip: val('rqd-edit-cust-zip'),
        };
        modalConfirm.disabled = true;
        modalConfirm.textContent = 'Saving…';
        try {
          var data = await window.RepPortal.API.post('/lead-customer-update', payload);
          if (!data || data.error) throw new Error((data && data.error) || 'Save failed');
          modalConfirm.disabled = false;
          modalConfirm.textContent = 'Save';
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-08) — In-place update instead
             of a full fetchQuotes(): patch the local quote object + re-render ONLY
             this ref's expanded detail panel. Avoids the whole-table reload that
             jumped to the top of the page and collapsed the open row. Mirrors the
             in-place pattern the vendor/notify handlers use (buildDetailHtml on
             rqd-detail-{ref}). The worker already persisted the change (incl. the
             wm.customer mirror), so the next natural fetch reconciles the row cell. */
          var _rq = Array.isArray(allQuotes) ? allQuotes.find(function(x){ return x.reference === q.ref; }) : null;
          if (_rq) {
            _rq.customer = payload.name || _rq.customer;
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — "+ Person": RECONCILE against the
               server's copy, don't echo the payload. `payload.email` is now the PRIMARY only,
               while customerEmail is the joined mirror of every contact -- the worker rebuilds
               it, so echoing the payload would repaint the card with the secondaries stripped
               and they would silently reappear on the next natural fetch. The response already
               carries the merged customer block; the payload is only the fallback. */
            var _sc = (data && data.customer) || null;
            _rq.customerEmail = (_sc && typeof _sc.email === 'string') ? _sc.email : payload.email;
            _rq.customerContacts = (_sc && Array.isArray(_sc.contacts)) ? _sc.contacts : [];
            _rq.customerPhone = payload.phone;
            _rq.customerCompany = payload.organization;
            _rq.residentialOrCommercial = payload.residentialOrCommercial;
            _rq.customerStreet = payload.soldStreet;
            _rq.customerStreet2 = payload.soldStreet2;
            _rq.city = payload.city;
            _rq.state = payload.state;
            _rq.zip = payload.zip;
            var _detailEl = document.getElementById('rqd-detail-' + q.ref);
            if (_detailEl && typeof buildDetailHtml === 'function') _detailEl.innerHTML = buildDetailHtml(_rq);
            /* Keep the collapsed-row name cell (td.rqd-col-cust, dashboard-quote-row.js)
               in sync so the row header right above the panel doesn't show a stale
               first-name-only while the Sold To card shows the full name. */
            var _custCell = document.querySelector('tr[data-ref="' + q.ref + '"] td.rqd-col-cust');
            if (_custCell) {
              _custCell.innerHTML = esc(_rq.customer) + (_rq.location ? '<span class="rqd-col-cust__loc">' + esc(_rq.location) + '</span>' : '');
            }
          }
          closeModal();
        } catch (err) {
          modalConfirm.disabled = false;
          modalConfirm.textContent = 'Save';
          rqdAlert('Save failed: ' + (err.message || err));
        }
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Email Lead step 1: Process with AI.
         The footer Confirm button is repurposed to fire the extraction
         instead of saving a lead. On success the modal hands off to
         __openNewLead with prefill data — that resets pendingStatusChange
         to _isLeadCreate=true and the footer button reverts to Confirm. */
      if (q._isEmailLeadStep1) {
        var rawEl = document.getElementById('rqd-email-lead-raw');
        var statusEl = document.getElementById('rqd-email-lead-status');
        var raw = rawEl ? (rawEl.value || '').trim() : '';
        if (!raw) { if (statusEl) { statusEl.textContent = 'Paste the email first.'; statusEl.style.color = '#dc2626'; } return; }
        if (raw.length < 20) { if (statusEl) { statusEl.textContent = 'Need a bit more text — paste the whole email.'; statusEl.style.color = '#dc2626'; } return; }
        modalConfirm.disabled = true;
        modalConfirm.textContent = 'Processing…';
        if (statusEl) { statusEl.textContent = 'AI is extracting fields…'; statusEl.style.color = 'var(--rq-text-secondary)'; }
        try {
          var data = await window.RepPortal.API.post('/admin/email-lead-extract', { raw: raw });
          if (!data || data.error) throw new Error((data && data.error) || 'Extraction failed');
          // Hand off to the standard New Lead modal pre-filled with the
          // AI-extracted fields. That resets pendingStatusChange so the
          // footer Confirm reverts to its normal "save lead" behavior.
          modalConfirm.disabled = false;
          modalConfirm.textContent = 'Confirm';
          window.__openNewLead(null, { prefill: data.fields || {}, originalEmail: raw });
        } catch (err) {
          modalConfirm.disabled = false;
          modalConfirm.textContent = 'Process with AI';
          if (statusEl) { statusEl.textContent = 'Failed: ' + (err.message || err); statusEl.style.color = '#dc2626'; }
        }
        return;
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Phase 3 lead create save handler
         (Ryan polish: now reads sold-to address, optional ship-to block, and
         rich-text message via the contenteditable's .innerHTML) */
      if (q._isLeadCreate) {
        function val(id) {
          var el = document.getElementById(id);
          return el ? (el.value || '').trim() : '';
        }
        var lName = val('rqd-lead-name');
        var lEmail = val('rqd-lead-email');
        var lPhone = val('rqd-lead-phone');
        var lZip = val('rqd-lead-zip');
        var lState = val('rqd-lead-state').toUpperCase();
        var lOrg = val('rqd-lead-org');
        var lSoldStreet = val('rqd-lead-sold-street1');
        var lSoldStreet2 = val('rqd-lead-sold-street2');
        var lSoldCity = val('rqd-lead-sold-city');
        var lRes = !!(document.getElementById('rqd-lead-residential') && document.getElementById('rqd-lead-residential').checked);
        // Plain textarea now — read .value, no HTML/contenteditable parsing.
        // Worker still sanitizes any HTML the rep might paste from another app.
        var msgEditor = document.getElementById('rqd-lead-message');
        var lMsg = msgEditor ? (msgEditor.value || '').trim() : '';
        var lAssigneeEl = document.getElementById('rqd-lead-assignee');
        var lAssignee = lAssigneeEl ? lAssigneeEl.value.trim() : '';

        // Ship-to (only included if the toggle was opened AND any field has a value)
        var shipBlock = document.getElementById('rqd-lead-ship-block');
        var shipFields = (shipBlock && shipBlock.style.display !== 'none') ? {
          shipName: val('rqd-lead-ship-name'),
          shipPhone: val('rqd-lead-ship-phone'),
          shipEmail: val('rqd-lead-ship-email'),
          shipCompany: val('rqd-lead-ship-company'),
          shipStreet: val('rqd-lead-ship-street1'),
          shipStreet2: val('rqd-lead-ship-street2'),
          shipCity: val('rqd-lead-ship-city'),
          shipState: val('rqd-lead-ship-state').toUpperCase(),
          shipZip: val('rqd-lead-ship-zip'),
        } : null;

        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Manual phone leads often arrive with
           partial info (voicemail with name + number, no zip/email). Drop
           strict per-field requirements. Require AT LEAST one identifier
           (name / email / phone) so we know who to call back, and validate
           format only when the field IS provided. */
        if (!lName && !lEmail && !lPhone) {
          rqdAlert('At least one of Customer Name, Email, or Phone is required.');
          return;
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — The Email field is a CHIP
           field, and its hidden mirror holds every chip comma-joined
           ("a@x.com, b@y.com"). This guard used to test that whole joined string
           against an anchored regex whose [^\s@] rejects the space, so adding a
           SECOND contact to a phone lead failed the save with "Email is not a valid
           format." and deleting it appeared to fix the deal. Nothing was wrong with
           the address. Validate each one on its own, splitting on the same
           delimiters installChipField commits on, and name the one that is actually
           bad — the old message pointed at a field holding several values. */
        var lBadEmail = lEmail.split(/[,;\s]+/).filter(Boolean).find(function (a) {
          return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(a);
        });
        if (lBadEmail) {
          rqdAlert('Email is not a valid format: ' + lBadEmail);
          return;
        }
        if (lPhone && lPhone.replace(/\D/g, '').length < 10) {
          rqdAlert('Phone must be at least 10 digits (or leave it blank).');
          return;
        }
        /* CUSTOM_CANADA_BY_CLAUDE (Ryan 2026-09-23) — a Canadian postal code is a valid ZIP field. */
        if (lZip && !/^\d{5}(-\d{4})?$/.test(lZip) && !/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/i.test(lZip)) {
          rqdAlert('Zip must be 5 digits or a Canadian postal code like A1A 1A1 (or leave it blank).');
          return;
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

        // Source taxonomy:
        //   sample-request → SAMPLE cold pool (no slot taken)
        //   email-lead     → manual entry pre-extracted from a customer
        //                     email; same routing as 'manual' but distinct
        //                     source for marketing reporting + so we can
        //                     stash the original email body
        //   manual         → phone-call entry (default)
        var _src = q._asSample ? 'sample-request'
          : (q._fromEmailLead ? 'email-lead' : 'manual');
        var _formId = q._asSample ? 'manual-sample-modal'
          : (q._fromEmailLead ? 'email-lead-modal' : 'manual-modal');
        var _formName = q._asSample ? 'Sample Request (manual entry)'
          : (q._fromEmailLead ? 'Email Inquiry (AI-extracted)' : 'Phone Inquiry (manual entry)');
        // Sample inquiry channel — mandatory pick for + New Sample.
        var sampleChannel = '';
        if (q._asSample) {
          var chWrap = modalBody.querySelector('[data-sample-channel-toggle]');
          var activeBtn = chWrap ? chWrap.querySelector('[data-sample-channel].rqd-sample-channel-toggle__btn--active') : null;
          sampleChannel = activeBtn ? activeBtn.getAttribute('data-sample-channel') : '';
          if (!sampleChannel) {
            if (chWrap) chWrap.setAttribute('data-sample-channel-error', '1');
            rqdAlert('Pick Phone, Email, or Referral to record how this sample inquiry came in.');
            return;
          }
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Referral channel requires name + %.
             Phone/email keep the channel as a marketing attribution signal;
             referral additionally needs the referral object populated so
             commission flows correctly when the lead becomes a quote. */
          if (sampleChannel === 'referral') {
            var _refNameVal = (document.getElementById('rqd-lead-referral-name') || {}).value || '';
            var _refPctVal = parseFloat((document.getElementById('rqd-lead-referral-pct') || {}).value || '0') || 0;
            if (!_refNameVal.trim()) {
              rqdAlert('Enter the Referred By name (required when Inquiry Channel = Referral).');
              return;
            }
            if (_refPctVal <= 0) {
              rqdAlert('Enter the % of GP for the referral (required when Inquiry Channel = Referral).');
              return;
            }
          }
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — Project Type + Square Feet, required on
             a Sample Lead. They post under the SAME `responses` keys the website picker writes
             through the order webhook ("Project Type" / "Square Feet"), so ECORE's work order, the
             Form Responses table, the rep email and the reply scorer all read a phone-in lead
             exactly as they read a website one. "Other" stores as "Other — <text>", the storefront's
             own shape. */
          var _spTypeEl = document.getElementById('rqd-lead-project-type');
          var _spOtherEl = document.getElementById('rqd-lead-project-type-other');
          var _spSqftEl = document.getElementById('rqd-lead-square-feet');
          var _spType = _spTypeEl ? String(_spTypeEl.value || '').trim() : '';
          if (_spType === 'Other') {
            var _spOther = _spOtherEl ? String(_spOtherEl.value || '').trim() : '';
            if (!_spOther) { rqdAlert('Describe the project (Project Type is "Other").'); if (_spOtherEl) _spOtherEl.focus(); return; }
            _spType = 'Other — ' + _spOther;
          }
          var _spSqft = _spSqftEl ? String(_spSqftEl.value || '').trim() : '';
          if (!_spType) { rqdAlert('Pick a Project Type — ECORE asks for it on every sample request.'); if (_spTypeEl) _spTypeEl.focus(); return; }
          if (!/^\d+$/.test(_spSqft.replace(/,/g, '')) || Number(_spSqft.replace(/,/g, '')) <= 0) {
            rqdAlert('Enter the Square Feet of the area as a whole number.'); if (_spSqftEl) _spSqftEl.focus(); return;
          }
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        }

        /* CUSTOM_RFQPORTAL_BY_CLAUDE — residentialOrCommercial is enum-
           validated to {'residential','commercial'} on the worker side.
           Don't send it when neither signal is present (no Residential
           tick AND no Organization typed) — the empty string would fail
           validation and reject the whole submission. */
        var _resOrCom = lRes ? 'residential' : (lOrg ? 'commercial' : '');
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        var leadPayload = {
          source: _src,
          sourceUrl: window.location.href,
          formId: _formId,
          formName: _formName,
          name: lName,
          email: lEmail,
          phone: lPhone,
          zip: lZip,
          state: lState,
          organization: lRes ? 'n/a - residence' : lOrg,
          soldStreet: lSoldStreet,
          soldStreet2: lSoldStreet2,
          message: lMsg,
          inquiryType: 'new_order',
          responses: lSoldCity ? { City: lSoldCity } : {},
        };
        if (_resOrCom) leadPayload.residentialOrCommercial = _resOrCom;
        if (sampleChannel) leadPayload.sampleInquiryChannel = sampleChannel;
        if (q._asSample) {
          leadPayload.responses['Project Type'] = _spType;
          leadPayload.responses['Square Feet'] = _spSqft.replace(/,/g, '');
        }
        // Stash the original email body so we have an audit trail of
        // what the AI was given to extract from. Truncate defensively
        // — the worker's schema caps message at 50KB anyway.
        if (q._fromEmailLead && q._originalEmail) {
          leadPayload.originalEmail = String(q._originalEmail).slice(0, 30000);
        }
        if (shipFields) Object.assign(leadPayload, shipFields);
        if (lAssignee) leadPayload.forceAssignee = lAssignee;

        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Referral capture. When a name is
           set, attach `referral: { name, gpPercent }` to the lead so the
           Workstation can auto-populate Lead Source (channel) = Referral +
           Referred By name (+ % of GP if set → Deal Type = Shared Deal, else
           Inbound tracking) when admin builds a quote from this lead.
           Also push the name to the shared localStorage memory so it
           autocompletes next time across both this form and the Workstation
           Referral picker. % of GP is captured here when known but isn't
           required at lead stage — the Workstation save-validation enforces
           it before the quote can be saved. */
        var _refName = (document.getElementById('rqd-lead-referral-name')||{}).value || '';
        _refName = _refName.trim();
        if (_refName) {
          var _refPct = parseFloat((document.getElementById('rqd-lead-referral-pct')||{}).value || '0') || 0;
          leadPayload.referral = { name: _refName, gpPercent: _refPct };
          try {
            var _mem = (function(){ try { return JSON.parse(localStorage.getItem('bsfs_referral_memory') || '[]') || []; } catch(e){ return []; } })();
            if (!Array.isArray(_mem)) _mem = [];
            // Upsert on case-insensitive name match. Keep most recent first, cap 50.
            var _key = _refName.toLowerCase();
            _mem = _mem.filter(function(m){ return m && m.name && String(m.name).toLowerCase() !== _key; });
            _mem.unshift({ name: _refName, gpPercent: _refPct, lastUsedAt: new Date().toISOString() });
            if (_mem.length > 50) _mem = _mem.slice(0, 50);
            localStorage.setItem('bsfs_referral_memory', JSON.stringify(_mem));
          } catch (_) { /* localStorage disabled — memory just doesn't persist */ }
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

        modalConfirm.textContent = 'Creating...';
        modalConfirm.disabled = true;
        try {
          var leadRes = await API.post('/lead-intake', leadPayload);
          closeModal();
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-19) — a new lead is a new ROW, and the cached
             list was assembled before it existed. Without this the fetchQuotes() below repaints
             from that cache and the rep's own lead is missing until they force a refresh. This is
             the same fix _isPendingCreate got on 2026-08-26 (see the note over
             _swrInvalidateQuotes); this branch — Phone / Email / Sample Lead — never got it. */
          _swrInvalidateQuotes();
          fetchQuotes();
          if (leadRes && leadRes.assigneeName) {
            console.log('[lead] created ' + leadRes.ref + ' → ' + leadRes.assigneeName + ' (' + leadRes.trail + ')');
          }
        } catch (err) {
          rqdAlert('Failed: ' + (err.message || 'Unknown error'));
        } finally {
          modalConfirm.textContent = 'Confirm';
          modalConfirm.disabled = false;
        }
        return;
      }

      // Handle new pending creation
      if (q._isPendingCreate) {
        var pName = (document.getElementById('rqd-pending-name').value || '').trim();
        if (!pName) { rqdAlert('Customer name is required.'); return; }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Note + Follow-Up
           are now mandatory on new pending creation. Every pending must
           carry a note (context for the rep when they come back to it)
           and a wake date (so it can't get forgotten). Validated client-
           side; the existing /create-pending worker accepts both as
           optional so backend gracefully handles older clients. */
        var pNoteRaw = (document.getElementById('rqd-pending-note').value || '').trim();
        if (!pNoteRaw) { rqdAlert('Note is required.'); document.getElementById('rqd-pending-note').focus(); return; }
        var pFollowUpEl = document.getElementById('rqd-pending-followup');
        var pFollowUpAt = pFollowUpEl ? (pFollowUpEl.value || '').trim() : '';
        if (!pFollowUpAt) { rqdAlert('Follow-Up date is required.'); pFollowUpEl && pFollowUpEl.focus(); return; }
        modalConfirm.textContent = 'Creating...';
        modalConfirm.disabled = true;
        try {
          var pAssigneeEl = document.getElementById('rqd-pending-assignee');
          var pAssigneeCode = pAssigneeEl ? (pAssigneeEl.value || '').trim() : '';
          var pendingPayload = {
            name: pName,
            organization: (document.getElementById('rqd-pending-org').value || '').trim(),
            email: (document.getElementById('rqd-pending-email').value || '').trim(),
            phone: (document.getElementById('rqd-pending-phone').value || '').trim(),
            street: ((document.getElementById('rqd-pending-street1') || {}).value || '').trim(),
            street2: ((document.getElementById('rqd-pending-street2') || {}).value || '').trim(),
            city: ((document.getElementById('rqd-pending-city') || {}).value || '').trim(),
            state: ((document.getElementById('rqd-pending-state') || {}).value || '').trim().toUpperCase(),
            zip: (document.getElementById('rqd-pending-zip').value || '').trim(),
            note: pNoteRaw,
          };
          if (pAssigneeCode) pendingPayload.assigneeCode = pAssigneeCode;
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-12) — referral partner from the referral
             block rides on the pending record and prefills the Workstation's Shared Deal recipient
             at quote time. Name pushes to the shared bsfs_referral_memory (same shape the
             Workstation writes: {name, gpPercent, lastUsedAt}).
             CUSTOM_MARKETINGOPS_BY_CLAUDE (2026-07-24, DNI decoupling piece 3) — no longer gated on
             the retired "How did they reach us?" pick; a typed name is the only condition. */
          {
            var pRefNameEl = document.getElementById('rqd-pending-referral-name');
            var pRefPctEl = document.getElementById('rqd-pending-referral-pct');
            var pRefName = pRefNameEl ? pRefNameEl.value.trim() : '';
            if (pRefName) {
              pendingPayload.referralName = pRefName;
              var pRefPct = parseFloat(pRefPctEl && pRefPctEl.value);
              if (isFinite(pRefPct) && pRefPct > 0) pendingPayload.referralGpPercent = pRefPct;
              try {
                var _mem2 = JSON.parse(localStorage.getItem('bsfs_referral_memory') || '[]') || [];
                if (!Array.isArray(_mem2)) _mem2 = [];
                var _key2 = pRefName.toLowerCase();
                _mem2 = _mem2.filter(function(m) { return m && m.name && String(m.name).toLowerCase() !== _key2; });
                _mem2.unshift({ name: pRefName, gpPercent: (isFinite(pRefPct) && pRefPct > 0) ? pRefPct : 0, lastUsedAt: new Date().toISOString() });
                if (_mem2.length > 50) _mem2 = _mem2.slice(0, 50);
                localStorage.setItem('bsfs_referral_memory', JSON.stringify(_mem2));
              } catch (e) { /* non-fatal */ }
            }
          }
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Optional
             follow-up timer attached at pending creation. Worker writes
             pending.followUp{dueAt, setAt, setBy} which surfaces as the
             To-Do column ⏰ countdown the moment the row hits the
             dashboard. */
          if (pFollowUpAt) pendingPayload.followUpAt = pFollowUpAt;
          await API.post('/create-pending', pendingPayload);
          closeModal();
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — a new deal is a new ROW, and the
             cached list was assembled before it existed. Without this the fetchQuotes() below
             repaints from that cache and the rep's own deal is missing until they reload the
             page. See the note over _swrInvalidateQuotes. */
          _swrInvalidateQuotes();
          fetchQuotes();
        } catch (err) {
          rqdAlert('Failed: ' + (err.message || 'Unknown error'));
        } finally {
          modalConfirm.textContent = 'Confirm';
          modalConfirm.disabled = false;
        }
        return;
      }

      var newStatus = document.getElementById('rqd-modal-status').value;

      var payload = { ref: q.reference, status: newStatus };

      if (newStatus === 'sold') {
        // SOLD gating validation
        var signedChecked = document.getElementById('rqd-sold-signed') && document.getElementById('rqd-sold-signed').checked;
        var signedNotRequired = document.getElementById('rqd-sold-signed-nr') && document.getElementById('rqd-sold-signed-nr').checked;
        var poChecked = document.getElementById('rqd-sold-po') && document.getElementById('rqd-sold-po').checked;
        var paymentChecked = document.getElementById('rqd-sold-payment') && document.getElementById('rqd-sold-payment').checked;

        // Collect payment rows (amount > 0 only). Multiple payments supported.
        var soldPayments = [];
        if (paymentChecked) {
          document.querySelectorAll('#rqd-sold-payments-list .rqd-sold-pmt-row').forEach(function(row) {
            var a = parseFloat(String((row.querySelector('.rqd-sold-pmt-amount') || {}).value || '').replace(/[^0-9.]/g, ''));
            var m = (row.querySelector('.rqd-sold-pmt-method') || {}).value || '';
            var d = (row.querySelector('.rqd-sold-pmt-date') || {}).value || todayStr();
            if (!isNaN(a) && a > 0) soldPayments.push({ method: m, amount: Math.round(a * 100) / 100, date: d });
          });
        }
        /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE (Ryan 2026-08-31) — a rep's row has no amount field, so
           soldPayments is always empty for them. "Payment received" still counts as a sold basis:
           the rep has the customer's word, which is the whole reason they are allowed to close the
           deal. What they do NOT get is a number. */
        var _repReportedMethod = '';
        if (!isAdmin && paymentChecked) {
          var _mEl = document.querySelector('#rqd-sold-payments-list .rqd-sold-pmt-method');
          _repReportedMethod = (_mEl && _mEl.value) || '';
        }
        var hasPayment = isAdmin ? (paymentChecked && soldPayments.length > 0) : paymentChecked;

        if (!signedChecked && !signedNotRequired && !poChecked && !hasPayment) {
          rqdAlert('At least one is required: signed order, PO, or a payment.');
          return;
        }
        /* CUSTOM_SIGNEDORDERPENDING_BY_CLAUDE - paid, no PO, signed order neither received nor waived = PENDING. */
        var _soPending = hasPayment && !signedChecked && !signedNotRequired && !poChecked;
        // Admin-only: an admin who ticked the box but typed nothing has left the amount out by
        // mistake. A rep has no box to type in, so the same prompt would be a dead end.
        if (isAdmin && paymentChecked && soldPayments.length === 0) {
          rqdAlert('Enter a payment amount (or uncheck Payment received).');
          return;
        }

        /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE — does THIS save settle the order outright? Marking a deal
           sold with payment in full is the other way across the same line the AR/AP card crosses,
           and it has to raise the same composer (email/lifecycle.js §2c is its worker twin).
           `var` here is function-scoped on purpose: it is read after closeModal(), outside this
           branch. Admin-only because a rep submits no amounts at all. */
        var _soldQTotal = parseFloat(q.total || q.quoteAmount || q.amount || 0);
        var _soldNowPaid = 0;
        soldPayments.forEach(function (p) { _soldNowPaid += parseFloat(p.amount) || 0; });
        var _soldPriorPaid = (q.payments || []).reduce(function (s, p) { return s + (parseFloat(p.amount) || 0); }, 0);
        var _soldPaidInFull = isAdmin && _soldQTotal > 0
          && _soldNowPaid >= _soldQTotal && !(_soldPriorPaid >= _soldQTotal);

        // Date Sold = latest payment date when payments exist; else the field value.
        var latestSoldDate = '';
        soldPayments.forEach(function(p) { if (p.date && p.date > latestSoldDate) latestSoldDate = p.date; });
        payload.dateSold = latestSoldDate || (document.getElementById('rqd-modal-sold-date') || {}).value || todayStr();

        // Sold basis (flat paymentMethod = latest payment's method, for back-compat displays)
        payload.soldBasis = {
          signedOrder: !!signedChecked,
          signedOrderChoice: signedChecked ? 'received' : (signedNotRequired ? 'not-required' : (_soPending ? 'pending' : null)),
          poReceived: !!poChecked,
          poNumber: poChecked ? (document.getElementById('rqd-sold-po-number') || {}).value || null : null,
          paymentReceived: hasPayment,
          paymentMethod: hasPayment
            ? (soldPayments.length ? soldPayments[soldPayments.length - 1].method : (_repReportedMethod || null))
            : null
        };
        /* ⛔ ONLY AN ADMIN SENDS `payments`. A rep's save carries the basis flag and the method and
           stops there — the worker refuses the money fields from a non-admin anyway
           (quote-routes.js MONEY_FIELDS), and posting an array it will reject would turn a normal
           rep close into a 403. */
        if (hasPayment && isAdmin && soldPayments.length) payload.payments = soldPayments;
        /* THE DASHBOARD OWNS THE PAID-INVOICE EMAIL — same flag as the AR/AP payment rows. A deal
           marked sold and paid in full in one go crosses the line here instead of on the card, and
           without this the worker mails the customer before anyone has seen it. */
        payload.suppressInvoiceEmail = true;

        // Lead source comes from workstation (set at quote creation)
        if (q.leadSource) payload.leadSource = q.leadSource;
        // Carry financial data for commission calc
        var fin = q.financials || {};
        payload.grossProfit = fin.gpOfGoods || fin.grossProfit || 0;
        payload.terms = q.terms || 'Net 30';
      }

      if (newStatus === 'lost') {
        var reason = document.getElementById('rqd-modal-lost-reason').value.trim();
        if (!reason) {
          rqdAlert('A reason is required for lost quotes.');
          return;
        }
        payload.dateLost = document.getElementById('rqd-modal-lost-date').value || todayStr();
        payload.lostReason = reason;
      }

      modalConfirm.textContent = 'Saving...';
      modalConfirm.disabled = true;

      try {
        var _lcRes = await API.post('/quote-lifecycle', payload);
        /* CUSTOM_SIGNEDORDERPENDING_BY_CLAUDE - Abby's sign-the-proposal email carries the payment thank-you, so the
           paid-invoice composer stays shut when that switch is on. */
        var _soReplacesCompose = !!(_lcRes && _lcRes.signedOrder && _lcRes.signedOrder.pending && _lcRes.signedOrder.signRequestOn);
        // D1: Sync payment data to local state for immediate UI consistency
        if (newStatus === 'sold' && payload.soldBasis && payload.soldBasis.paymentReceived) {
          var qLocal = allQuotes.find(function(x) { return x.reference === q.reference; });
          if (qLocal) {
            /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE — a REP only reported that money is coming; the worker
               recorded none of it, so painting the row paid here would be a local lie that stands
               until the next fetch quietly contradicts it. Only an admin's save moved money. */
            if (isAdmin) {
              qLocal.paid = true;
              qLocal.paymentMethod = payload.soldBasis.paymentMethod || null;
              qLocal.paymentDate = payload.dateSold || todayStr();
            }
            qLocal.dateSold = payload.dateSold || qLocal.dateSold;
            if (Array.isArray(payload.payments)) qLocal.payments = payload.payments.map(function(p, i) { return { id: i + 1, method: p.method, amount: p.amount, date: p.date }; });
          }
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-23) — instant LOST feedback.
           The quiet fetchQuotes below is authoritative but re-pulls + re-renders
           the whole board (several seconds), so the row's status pill + To-Do
           bell used to sit stale that entire time after marking a deal Lost.
           Patch local state and flip just this row's pill + progress cell now;
           the background fetch still reconciles the detail panel, filters, and
           counts. Runs only after the await above succeeded, so a failed save
           never reaches here (no optimistic state to revert). */
        if (newStatus === 'lost') {
          var qLost = allQuotes.find(function(x) { return x.reference === q.reference; });
          if (qLost) {
            qLost.lifecycleStatus = 'lost';
            qLost.followUp = null;   // a follow-up clears on LOST → drop the bell
            qLost.holdUntil = null;
            qLost.isOnHold = false;
            if (payload.dateLost) qLost.dateLost = payload.dateLost;
            if (payload.lostReason) qLost.lostReason = payload.lostReason;
          }
          markStatusPillClosed(q.reference, 'lost');
          if (typeof refreshProgressBar === 'function') refreshProgressBar(q.reference);
        }
        closeModal();
        if (newStatus === 'sold') celebrateSold();
        /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE — sold and settled in one action: the worker has prepared
           the paid invoice and sent nothing, so put it in front of a human. After closeModal() so
           the composer is the only thing on screen, and before the quiet refetch below, which is
           slow and does not affect what the composer reads. */
        if (_soldPaidInFull && !_soReplacesCompose) openPaidInvoiceCompose(q.reference);
        // Quiet refresh: keep the rep's scroll position + re-expand the open
        // row instead of collapsing everything and flinging back to the top.
        fetchQuotes({ quiet: true });
      } catch (err) {
        rqdAlert('Failed to update status: ' + (err.message || 'Unknown error'));
      } finally {
        modalConfirm.textContent = 'Confirm';
        modalConfirm.disabled = false;
      }
    });

    // ── AR/AP Toggle Handler ──

    function handleFinancialEdit(el) {
      // Already editing? skip
      if (el.querySelector('.rqd-fin-input')) return;
      var ref = el.dataset.ref;
      var field = el.dataset.field;
      var valueSpan = el.querySelector('.rqd-fin-value');
      if (!valueSpan) return;

      // For COGS edits on multi-line online orders, the order-level number
      // doesn't propagate into PO line item costs (the PO reads per-line
      // cost). Warn the admin and abort — they should use the Cost column
      // on the Order Contents card. Single-line online orders are handled
      // below in the save callback by piggy-backing a /line-cost-override
      // call so the single line item picks up the same number.
      var qForRef = allQuotes && allQuotes.find && allQuotes.find(function(x) { return x.reference === ref; });
      var isOnlineSingleLine = false;
      var soleLineItemId = null;
      if (field === 'costTotal' && qForRef && qForRef.source === 'online' && Array.isArray(qForRef.onlineLineItems)) {
        if (qForRef.onlineLineItems.length > 1) {
          rqdAlert('This order has ' + qForRef.onlineLineItems.length + ' line items. Editing the order-level COGS here won\'t update the per-line costs on the PO.\n\nUse the Cost column on the Order Contents card to edit each line item\'s cost — those values flow into the PO and the COGS sum.');
          return;
        }
        if (qForRef.onlineLineItems.length === 1) {
          isOnlineSingleLine = true;
          soleLineItemId = (qForRef.onlineLineItems[0] || {}).lineItemId || null;
        }
      }

      var currentVal = valueSpan.textContent.replace(/[$,]/g, '');
      var input = document.createElement('input');
      input.type = 'text';
      input.inputMode = 'decimal';
      input.className = 'rqd-fin-input';
      input.value = parseFloat(currentVal) || 0;
      valueSpan.textContent = '';
      valueSpan.appendChild(input);
      input.focus();
      input.select();
      input.addEventListener('click', function(ev) { ev.stopPropagation(); });

      var saved = false;
      function save() {
        if (saved) return;
        saved = true;
        var rawVal = input.value.replace(/[$,]/g, '');
        var newVal = parseFloat(rawVal) || 0;
        valueSpan.textContent = money(newVal);
        var primary = API.post('/quote-financials', { ref: ref, field: field, value: newVal }).then(function(data) {
          if (data.financials) {
            // Update the detail panel derived fields
            var detailEl = document.getElementById('rqd-detail-' + ref.replace(/[^A-Za-z0-9\-]/g, ''));
            if (detailEl) {
              var rows = detailEl.querySelectorAll('.rqd-detail__row');
              rows.forEach(function(row) {
                var label = row.querySelector('span:first-child');
                var val = row.querySelector('span:last-child');
                if (!label || !val) return;
                var lt = label.textContent.trim();
                if (lt === 'Gross Profit') {
                  val.textContent = money(data.financials.grossProfit);
                  val.style.color = data.financials.grossProfit >= 0 ? '#16a34a' : '#dc2626';
                }
                if (lt === 'Gross Margin') val.textContent = (data.financials.grossMargin || 0).toFixed(1) + '%';
              });
            }
          }
        });
        // Single-line online order COGS edit → also write a per-line cost
        // override so the PO + COGS sum stay aligned. fetchQuotes() at the
        // end pulls the recomputed financials.
        if (isOnlineSingleLine && soleLineItemId) {
          primary.then(function() {
            return API.post('/line-cost-override', { ref: ref, lineItemId: soleLineItemId, cost: newVal });
          }).then(function() {
            /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM¹¹) — same fix as the per-line
               editor: paint locally, reconcile quietly. This is the single-line online path,
               where editing order-level COGS also writes the per-line override. */
            applyLineCostLocally(ref, soleLineItemId, newVal);
            fetchQuotes({ quiet: true });
          }).catch(function() {
            valueSpan.textContent = money(parseFloat(currentVal) || 0); // revert on error
          });
        } else {
          primary.catch(function() {
            valueSpan.textContent = money(parseFloat(currentVal) || 0); // revert on error
          });
        }
      }

      input.addEventListener('blur', save);
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
        if (e.key === 'Escape') { valueSpan.textContent = money(parseFloat(currentVal) || 0); }
      });
    }

    // Per-line cost override editor — admin only, online orders. Saves to
    // /line-cost-override (keyed by Shopify lineItem GID) and refreshes the
    // dashboard so the Financials card's COGS sum + the PO generator pick
    // up the new number. Mirrors handleFinancialEdit's inline-edit pattern.
    function handleLineCostEdit(el) {
      if (el.querySelector('.rqd-fin-input')) return; // already editing
      var ref = el.dataset.ref;
      var lineItemId = el.dataset.lineItemId;
      var valueSpan = el.querySelector('.rqd-line-cost-value');
      if (!valueSpan || !ref || !lineItemId) return;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Bundle component
         cells route to a different endpoint (per-component override
         keyed by lineItemId + componentSku) and revert payload includes
         the component SKU. */
      var isBundleComponent = el.classList.contains('rqd-line-cost-edit--bundle-component');
      var componentSku = isBundleComponent ? el.dataset.componentSku : '';
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      var currentVal = valueSpan.textContent.replace(/[$,]/g, '');
      var input = document.createElement('input');
      input.type = 'text';
      input.inputMode = 'decimal';
      input.className = 'rqd-fin-input';
      input.value = parseFloat(currentVal) || 0;
      valueSpan.textContent = '';
      valueSpan.appendChild(input);
      input.focus();
      input.select();
      input.addEventListener('click', function(ev) { ev.stopPropagation(); });

      var saved = false;
      function save() {
        if (saved) return;
        saved = true;
        var rawVal = input.value.replace(/[$,]/g, '');
        var newVal = parseFloat(rawVal);
        if (isNaN(newVal) || newVal < 0) {
          valueSpan.textContent = money(parseFloat(currentVal) || 0); // revert
          return;
        }
        valueSpan.textContent = money(newVal);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-19) — Endpoint + payload
           branch: bundle component override vs line cost override. */
        var endpoint = isBundleComponent ? '/line-bundle-component-cost-override' : '/line-cost-override';
        var payload = isBundleComponent
          ? { ref: ref, lineItemId: lineItemId, componentSku: componentSku, cost: newVal }
          : { ref: ref, lineItemId: lineItemId, cost: newVal };
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        API.post(endpoint, payload)
          .then(function() {
            /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM¹¹) — was a bare fetchQuotes(),
               which collapses the card and throws the rep back to the top of the page (see the
               fetchQuotes header). Paint the new cost locally, then reconcile QUIETLY so the
               Financials COGS sum and the PO's cost source still catch up without stealing the
               scroll position or the open card.
               Bundle-component overrides (componentSku payloads) fall through to the quiet
               refresh for their recompute — they still stop collapsing and jumping, they just
               aren't repainted from memory first. */
            if (!isBundleComponent) applyLineCostLocally(ref, lineItemId, newVal);
            fetchQuotes({ quiet: true });
          })
          .catch(function(err) {
            valueSpan.textContent = money(parseFloat(currentVal) || 0); // revert
            rqdAlert('Failed to save line cost override: ' + (err && err.message ? err.message : 'unknown error'));
          });
      }
      input.addEventListener('blur', save);
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
        if (e.key === 'Escape') { saved = true; valueSpan.textContent = money(parseFloat(currentVal) || 0); }
      });
    }

    // Per-line quantity override editor — admin only; online orders, plus SOLD offline deals
    // (Ryan 2026-08-14: a completed draft locks the Workstation out, and the PO reads that
    // draft, so this became the only way to tell a vendor to ship a corrected qty). Saves
    // to /line-qty-override (keyed by Shopify lineItem GID) and refreshes
    // the dashboard so the PO generator + recomputed COGS pick up the new
    // qty. Customer-facing lineTotal stays from Shopify — the financial
    // diff for over/under-purchases is reconciled via a linked balance
    // order (Link Balance Order modal), not by mutating the parent.
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Per-line flags popover. `+` button on
       each Order Contents row opens a small popover with two toggles:
       NEW (vendor PO highlight, /line-new-flag) and Freight Quoted (broker
       bucket, /line-freight-quoted-flag). Each checkbox change fires
       immediately, persists, and re-renders the detail panel. Outside-
       click closes the popover (delegated below in the dashboard's body
       click listener via .rqd-online-items__flags-popover guard). */
    function handleLineFlagsToggle(btn) {
      var ref = btn.dataset.ref;
      var lineItemId = btn.dataset.lineItemId;
      if (!ref || !lineItemId) return;
      // Close any other open popover first
      document.querySelectorAll('.rqd-online-items__flags-popover').forEach(function (p) { p.remove(); });
      var isNewNow = btn.dataset.isNew === '1';
      var isFqNow = btn.dataset.isFq === '1';
      /* CUSTOM_ALTSOURCE_BY_CLAUDE (Ryan 2026-10-07) - one "Send to <alternate>" row per supplier
         whose Vendor Guide "Buys for" names this line's vendor. Ticking it moves the line's PO to
         that supplier; unticking puts it back. Nothing shows for a vendor with no alternate. */
      var lineVendorNow = btn.dataset.vendor || '';
      var altNow = btn.dataset.altVendor || '';
      var _altFold = function (s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); };
      var _altOpts = (vendorAlternates || []).filter(function (a) {
        return a && a.name && lineVendorNow && (vendorNamesMatch(a.alternateFor, lineVendorNow) || _altFold(a.name) === _altFold(altNow));
      });
      var altRowsHtml = _altOpts.map(function (a) {
        var on = _altFold(a.name) === _altFold(altNow);
        return '<label class="rqd-online-items__flags-popover-row">'
          + '<input type="checkbox" data-line-flag-input="1" data-flag="alt"'
          + ' data-alt-name="' + esc(a.name) + '"'
          + ' data-ref="' + ref + '" data-line-item-id="' + lineItemId + '"'
          + (on ? ' checked' : '') + '> '
          + '<span><strong>Send to ' + esc(a.name) + '</strong> <span class="rqd-online-items__flags-popover-hint">&mdash; PO goes to them, not ' + esc(lineVendorNow) + '</span></span>'
          + '</label>';
      }).join('');
      var pop = document.createElement('div');
      pop.className = 'rqd-online-items__flags-popover';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Popover now lives
         on document.body (outside .rep-quote-portal-wrap.rep-quote-dark),
         so the descendant `.rep-quote-dark` selector no longer reaches
         it. Add a `--dark` modifier class at creation when dark mode is
         active so CSS can style it via its own class. */
      if (document.querySelector('.rep-quote-portal-wrap.rep-quote-dark')) {
        pop.classList.add('rqd-online-items__flags-popover--dark');
      }
      pop.setAttribute('data-line-flags-popover', '1');
      pop.innerHTML = ''
        + '<label class="rqd-online-items__flags-popover-row">'
        +   '<input type="checkbox" data-line-flag-input="1" data-flag="new"'
        +     ' data-ref="' + ref + '" data-line-item-id="' + lineItemId + '"'
        +     (isNewNow ? ' checked' : '') + '> '
        +   '<span><strong>NEW</strong> <span class="rqd-online-items__flags-popover-hint">— highlight on vendor PO</span></span>'
        + '</label>'
        + '<label class="rqd-online-items__flags-popover-row">'
        +   '<input type="checkbox" data-line-flag-input="1" data-flag="fq"'
        +     ' data-ref="' + ref + '" data-line-item-id="' + lineItemId + '"'
        +     (isFqNow ? ' checked' : '') + '> '
        +   '<span><strong>Freight Quoted</strong> <span class="rqd-online-items__flags-popover-hint">— route to broker bucket</span></span>'
        + '</label>'
        + altRowsHtml; // CUSTOM_ALTSOURCE_BY_CLAUDE
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Position the
         popover via position:fixed + JS-computed coords + attach to
         document.body so it escapes .rqd-online-items__scroll, which
         computes to overflow:hidden on both axes and was clipping the
         popover bottom edge. Coordinates target just-below the button;
         flip above if there isn't room below the viewport. */
      document.body.appendChild(pop);
      var rect = btn.getBoundingClientRect();
      var popH = pop.offsetHeight;
      var popW = pop.offsetWidth;
      var top = rect.bottom + 4;
      var left = rect.left;
      // Flip above if there's not enough room below
      if (top + popH > window.innerHeight - 8) {
        top = rect.top - popH - 4;
      }
      // Keep within viewport horizontally
      if (left + popW > window.innerWidth - 8) {
        left = window.innerWidth - popW - 8;
      }
      if (left < 8) left = 8;
      pop.style.top = Math.round(top) + 'px';
      pop.style.left = Math.round(left) + 'px';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Bind the checkbox handler directly on
         the popover. The popover lives on document.body (see 2026-05-18
         note above), which is OUTSIDE the `tbody` that carries the detail-
         panel click delegation, so the old delegated path never received
         these change events — checks appeared to do nothing and reverted
         on reopen. Mirror the pattern the other body-level popovers in
         this file use (commission-paid, mark-purchased, date-override):
         own listener on the popover element. */
      pop.addEventListener('change', function (ev) {
        var input = ev.target.closest('[data-line-flag-input]');
        if (input && isAdmin) handleLineFlagsCheckbox(input);
      });
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }

    /* CUSTOM_ALTSOURCE_BY_CLAUDE (Ryan 2026-10-07) - tick = this line's PO goes to the alternate
       source; untick = back to the brand. The worker refuses once a PO for either row has gone out
       (void or revise it first) and names any draft PO that now needs regenerating. */
    function handleLineAltSource(input) {
      var ref = input.dataset.ref;
      var lineItemId = input.dataset.lineItemId;
      var altName = input.dataset.altName || '';
      var turnOn = !!input.checked;
      input.disabled = true;
      API.post('/line-vendor-override', { ref: ref, lineItemId: lineItemId, vendor: turnOn ? altName : '' })
        .then(function (res) {
          var q = (allQuotes || []).find(function (x) { return x.reference === ref; });
          if (q) {
            q.lineVendorOverrides = q.lineVendorOverrides || {};
            if (turnOn) q.lineVendorOverrides[lineItemId] = { vendor: altName, brand: res && res.brand };
            else delete q.lineVendorOverrides[lineItemId];
          }
          if (res && Array.isArray(res.regenerate) && res.regenerate.length) {
            rqdAlert('Moved. Draft PO ' + res.regenerate.join(', ') + ' was built before this change: regenerate it before sending.');
          }
          document.querySelectorAll('.rqd-online-items__flags-popover').forEach(function (p) { p.remove(); });
          // The vendor rows (Purchasing, freight, tracking) are rebuilt by the worker.
          fetchQuotes({ quiet: true });
        })
        .catch(function (err) {
          input.checked = !turnOn;
          input.disabled = false;
          rqdAlert('Could not move this line: ' + (err && err.message ? err.message : 'unknown error'));
        });
    }
    /* END CUSTOM_ALTSOURCE_BY_CLAUDE */

    function handleLineFlagsCheckbox(input) {
      var ref = input.dataset.ref;
      var lineItemId = input.dataset.lineItemId;
      var flag = input.dataset.flag; // 'new' | 'fq' | 'alt'
      if (!ref || !lineItemId || !flag) return;
      if (flag === 'alt') { handleLineAltSource(input); return; } // CUSTOM_ALTSOURCE_BY_CLAUDE
      var nextVal = !!input.checked;
      input.disabled = true;
      var endpoint = flag === 'fq' ? '/line-freight-quoted-flag' : '/line-new-flag';
      var bodyKey = flag === 'fq' ? 'isFreightQuoted' : 'isNew';
      var body = { ref: ref, lineItemId: lineItemId };
      body[bodyKey] = nextVal;
      API.post(endpoint, body)
        .then(function () {
          var q = (allQuotes || []).find(function (x) { return x.reference === ref; });
          // Patch BOTH item arrays (online + offline) so re-render reads
          // the updated state regardless of which one this quote uses.
          var _patchList = function (arr) {
            if (!Array.isArray(arr)) return;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i] && arr[i].lineItemId === lineItemId) {
                if (flag === 'new') {
                  arr[i].isNew = nextVal;
                  arr[i].newFlaggedAt = nextVal ? new Date().toISOString() : null;
                } else {
                  arr[i].isFreightQuotedFlag = nextVal;
                  arr[i].freightQuotedFlaggedAt = new Date().toISOString();
                  /* CUSTOM_AUTOFREIGHT_BY_CLAUDE (Ryan 2026-08-28) — mirror the worker's off-marker
                     optimistically. Clearing the toggle no longer deletes the flag, it records an
                     explicit OFF that beats the weight rule; without setting it here the pill would
                     stay lit (the rule still says yes) until the next fetch, and the click would
                     read as having done nothing. */
                  arr[i].freightQuotedFlagOff = !nextVal;
                }
                break;
              }
            }
          };
          if (q) {
            _patchList(q.onlineLineItems);
            _patchList(q.offlineLineItems);
          }
          var detailEl = document.getElementById('rqd-detail-' + ref);
          if (detailEl) {
            detailEl.innerHTML = buildDetailHtml(q);
            if (q) applyCollapseState(detailEl, q);
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Reopen the popover on the same
               line so admin can toggle the OTHER flag without re-clicking
               the `+`. The re-render wipes the popover; we read the now-
               updated data-is-* attrs on the freshly-rendered button. */
            var newBtn = detailEl.querySelector('[data-line-flags-toggle="1"][data-line-item-id="' + lineItemId + '"]');
            if (newBtn) handleLineFlagsToggle(newBtn);
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          }
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Reconcile the server-derived view.
             The local patch above flips isFreightQuotedFlag on the line item
             so the pill updates instantly, but the Fulfillment card's
             Supplier-parcel / broker-freight split is computed server-side
             (quote-dashboard.js `_parcelLines = filter(!_isFreightQuoted)`),
             NOT from the patched line array — so the parcel section wouldn't
             appear/disappear until a manual refresh. Quiet refetch re-runs
             the worker split and re-renders the open panel while preserving
             scroll + expanded-row state (Ryan 2026-05-21 quiet mode). */
          fetchQuotes({ quiet: true });
        })
        .catch(function (err) {
          input.checked = !nextVal;
          input.disabled = false;
          rqdAlert('Failed to update flag: ' + (err && err.message ? err.message : 'unknown error'));
        });
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    function handleLineQtyEdit(el) {
      if (el.querySelector('.rqd-fin-input')) return; // already editing
      var ref = el.dataset.ref;
      var lineItemId = el.dataset.lineItemId;
      var valueSpan = el.querySelector('.rqd-line-qty-value');
      if (!valueSpan || !ref || !lineItemId) return;

      var currentVal = (valueSpan.textContent || '').trim();
      var input = document.createElement('input');
      input.type = 'text';
      input.inputMode = 'numeric';
      input.className = 'rqd-fin-input';
      input.value = parseInt(currentVal, 10) || 0;
      valueSpan.textContent = '';
      valueSpan.appendChild(input);
      input.focus();
      input.select();
      input.addEventListener('click', function(ev) { ev.stopPropagation(); });

      var saved = false;
      function save() {
        if (saved) return;
        saved = true;
        var rawVal = input.value.replace(/[^\d]/g, '');
        var newVal = parseInt(rawVal, 10);
        if (isNaN(newVal) || newVal < 1) {
          valueSpan.textContent = String(parseInt(currentVal, 10) || 0); // revert
          return;
        }
        valueSpan.textContent = String(newVal);
        API.post('/line-qty-override', { ref: ref, lineItemId: lineItemId, quantity: newVal })
          .then(function() {
            // Quiet refresh — recompute the ledger/COGS/PO gate + re-render the
            // open panel WITHOUT a full reload (no jump-to-top, order stays open).
            // (Ryan 2026-06-02 — reconciling shouldn't collapse the open order.)
            fetchQuotes({ quiet: true });
          })
          .catch(function(err) {
            valueSpan.textContent = String(parseInt(currentVal, 10) || 0); // revert
            rqdAlert('Failed to save line qty override: ' + (err && err.message ? err.message : 'unknown error'));
          });
      }
      input.addEventListener('blur', save);
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
        if (e.key === 'Escape') { saved = true; valueSpan.textContent = String(parseInt(currentVal, 10) || 0); }
      });
    }

    // Inline SKU edit — mirrors handleLineQtyEdit but free-text. Empty value
    // clears the override (reverts to the Shopify SKU). The corrected SKU is
    // authoritative for the vendor PO (worker /line-sku-override).
    function handleLineSkuEdit(el) {
      if (el.querySelector('.rqd-fin-input')) return; // already editing
      var ref = el.dataset.ref;
      var lineItemId = el.dataset.lineItemId;
      var valueSpan = el.querySelector('.rqd-line-sku-value');
      if (!valueSpan || !ref || !lineItemId) return;

      var currentVal = (valueSpan.textContent || '').trim();
      if (currentVal === '—') currentVal = ''; // em-dash placeholder = no SKU
      function restore(v) { valueSpan.textContent = v ? v : '—'; }

      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'rqd-fin-input';
      input.value = currentVal;
      valueSpan.textContent = '';
      valueSpan.appendChild(input);
      input.focus();
      input.select();
      input.addEventListener('click', function(ev) { ev.stopPropagation(); });

      var saved = false;
      function save() {
        if (saved) return;
        saved = true;
        var newVal = (input.value || '').trim();
        if (newVal === currentVal) { restore(currentVal); return; } // no change
        restore(newVal);
        API.post('/line-sku-override', { ref: ref, lineItemId: lineItemId, sku: newVal })
          .then(function() {
            fetchQuotes({ quiet: true });
          })
          .catch(function(err) {
            restore(currentVal); // revert
            rqdAlert('Failed to save line SKU override: ' + (err && err.message ? err.message : 'unknown error'));
          });
      }
      input.addEventListener('blur', save);
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
        if (e.key === 'Escape') { saved = true; restore(currentVal); }
      });
    }

    /* CUSTOM_LINETITLE_BY_CLAUDE (Ryan 2026-10-09) — inline item-name edit, the twin of
       handleLineSkuEdit. Empty clears the override (back to Shopify's title, which the cell carries
       as data-original-title so the revert shows at once). Saved through /line-title-override. */
    function handleLineTitleEdit(el) {
      if (el.querySelector('.rqd-fin-input')) return; // already editing
      var ref = el.dataset.ref;
      var lineItemId = el.dataset.lineItemId;
      var original = (el.dataset.originalTitle || '').trim(); // "Name - Variant" as Shopify has it
      var valueSpan = el.querySelector('.rqd-line-title-value');
      if (!valueSpan || !ref || !lineItemId) return;

      // The cell may show a styled "— Variant" suffix, so the editable text comes from the data
      // attribute, never from the cell's textContent; Escape puts the cell's own HTML back.
      var currentVal = (el.dataset.editValue != null ? el.dataset.editValue : valueSpan.textContent || '').trim();
      var shownHtml = valueSpan.innerHTML;
      function restoreShown() { valueSpan.innerHTML = shownHtml; }

      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'rqd-fin-input rqd-line-title-input';
      input.value = currentVal;
      input.maxLength = 255;
      valueSpan.textContent = '';
      valueSpan.appendChild(input);
      input.focus();
      input.select();
      input.addEventListener('click', function(ev) { ev.stopPropagation(); });

      var saved = false;
      function save() {
        if (saved) return;
        saved = true;
        var newVal = (input.value || '').replace(/\s+/g, ' ').trim();
        if (newVal === currentVal) { restoreShown(); return; } // no change
        // Blank, or Shopify's own "Name - Variant" typed back, is a revert, not an override.
        var payload = (newVal === original) ? '' : newVal;
        valueSpan.textContent = payload ? payload : original;
        // includesVariant: the box carried "Name - Variant", so the saved text stands for both and the
        // variant is hidden beside it (a line with no inline variant saves a name only).
        API.post('/line-title-override', { ref: ref, lineItemId: lineItemId, title: payload, includesVariant: el.dataset.hasVariant === '1' })
          .then(function() {
            fetchQuotes({ quiet: true });
          })
          .catch(function(err) {
            restoreShown(); // revert
            rqdAlert('Failed to save the item name: ' + (err && err.message ? err.message : 'unknown error'));
          });
      }
      input.addEventListener('blur', save);
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
        if (e.key === 'Escape') { saved = true; restoreShown(); }
      });
    }

    /* CUSTOM_LEGENDSPEC_BY_CLAUDE (Ryan 2026-08-13) — ONE inline multi-line editor, used by both
       the Legend build spec and the weight-stack list.

       Ryan: *"the UI for clicking on the stacks to edit those is very different. it should use
       the same UI for that too."* They were two hand-rolled editors — a single-line
       .rqd-fin-input for stacks, a textarea for the spec — which is how two controls that do the
       same job end up looking like different features. One function now renders both.

       A textarea for both, deliberately: each is a LIST, so Enter has to add a row. That means
       Enter cannot also mean save, so both commit on blur or Ctrl+Enter and cancel on Escape,
       and the hint says so — every other pencil on this card saves on Enter and a silent
       difference is a trap.

       @param {Element} el   the clickable wrapper (carries data-ref / data-line-item-id)
       @param {Object}  cfg  { valueSel, noteAttr, derivedAttr, endpoint, field, placeholder } */
    function openInlineListEditor(el, cfg) {
      if (el.querySelector('.rqd-legend-spec-input')) return; // already editing
      var ref = el.dataset.ref;
      var lineItemId = el.dataset.lineItemId;
      var valueSpan = el.querySelector(cfg.valueSel);
      if (!valueSpan || !ref || !lineItemId) return;

      var currentHtml = valueSpan.innerHTML;
      // The override actually STORED right now ('' = none). Not the rendered text: that may be a
      // placeholder, or the derived rows, neither of which is the field's value.
      var stored = (el.dataset[cfg.noteAttr] || '').trim();
      // What the row shows when nothing is stored. Seeding with it means the rep edits the real
      // content instead of retyping it from the line above.
      var derived = cfg.derivedAttr ? (el.dataset[cfg.derivedAttr] || '').trim() : '';
      var seed = stored || derived;

      var box = document.createElement('textarea');
      /* Deliberately NOT .rqd-fin-input: that class is styled for the 90px, right-aligned,
         tabular-numeric money fields and is defined ~7000 lines further down this stylesheet, so
         at equal specificity it would win and render this as a narrow right-aligned strip. */
      box.className = 'rqd-legend-spec-input';
      box.rows = Math.max(3, seed.split('\n').length + 1);
      box.value = seed;
      box.placeholder = cfg.placeholder || '';
      valueSpan.innerHTML = '';
      valueSpan.appendChild(box);

      var hint = document.createElement('span');
      hint.className = 'rqd-legend-spec__hint';
      hint.textContent = 'One per line. Ctrl+Enter or click away to save, Esc to cancel, empty to reset.';
      valueSpan.appendChild(hint);

      box.focus();
      box.select();
      box.addEventListener('click', function (ev) { ev.stopPropagation(); });

      var saved = false;
      function save() {
        if (saved) return;
        saved = true;
        var typed = (box.value || '').trim();

        /* ⛔ THE NO-OP CASES, both of which used to write an override and stamp the row "edited".
           Ryan: *"I clicked to edit but didn't actually edit, then the 'edited' pill showed up and
           all the text turned bold."* Cause: the box is SEEDED with the derived rows, so opening
           and closing it produced typed === derived while stored was '' — a difference against
           the stored value, and therefore a save. The comparison has to be against what would
           actually change, not against the empty string. */
        if (typed === stored) { valueSpan.innerHTML = currentHtml; return; }   // nothing moved
        if (derived && typed === derived) {
          // Typed back to exactly the derived content. If nothing was stored this is the
          // open-and-close case — do nothing at all. If something WAS stored, the rep has
          // reverted it, which means clear the override rather than store a copy of the default.
          if (!stored) { valueSpan.innerHTML = currentHtml; return; }
          typed = '';
        }

        /* ⛔ Tear the textarea down BEFORE the refetch. hasUnsavedTyping() returns true while ANY
           portal textarea holds text, and the quiet-render path skips the whole render when it
           does — so leaving this box in the DOM makes the rep's own edit veto the render meant to
           show it. That is what stranded "Save & Mark Lost" on *Saving…* (2026-08-11). */
        valueSpan.textContent = typed;

        var payload = { ref: ref, lineItemId: lineItemId };
        payload[cfg.field] = typed;
        API.post(cfg.endpoint, payload)
          .then(function () {
            // Full quiet refresh rather than patching here: the worker decides what the value
            // resolves to (typed rows, or the derived ones when cleared) and, for stacks, what
            // pound quantity it implies. A second copy of that logic in the browser is how the
            // card and the PO start disagreeing.
            fetchQuotes({ quiet: true });
          })
          .catch(function (err) {
            valueSpan.innerHTML = currentHtml; // revert
            rqdAlert('Failed to save: ' + (err && err.message ? err.message : 'unknown error'));
          });
      }
      box.addEventListener('blur', save);
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); box.blur(); }
        if (e.key === 'Escape') { saved = true; valueSpan.innerHTML = currentHtml; }
      });
    }

    /* Which stacks a Legend weight-stack upgrade applies to. NOT cosmetic — the label count sets
       the PO's pound quantity (four stacks at +50 lb prints 200). No derived fallback: nothing in
       Shopify enumerates a machine's stacks, which is the whole reason this is free text. */
    function handleLineStackEdit(el) {
      openInlineListEditor(el, {
        valueSel: '.rqd-line-stack-value',
        noteAttr: 'stackNote',
        derivedAttr: null,
        endpoint: '/line-stack-upgrade',
        field: 'stacks',
        placeholder: 'Crossover 1\nCrossover 2\nLat Pulldown 1',
      });
    }

    /* The Legend build spec the PO prints. Seeded with the derived rows so the rep can rename one
       ("Pad Color:" -> "Pad Top Color:") and add another, which is the two-tone upholstery case
       Ryan keeps off the storefront because it would confuse more people than it helps. */
    function handleLineLegendSpecEdit(el) {
      openInlineListEditor(el, {
        valueSel: '.rqd-legend-spec-value',
        noteAttr: 'specNote',
        derivedAttr: 'specDerived',
        endpoint: '/line-legend-spec',
        field: 'spec',
        placeholder: 'Frame Color: Storm Gray Powder Coat\nPad Top Color: Nasturtium Upholstery',
      });
    }
    /* END CUSTOM_LEGENDSPEC_BY_CLAUDE */

    // Linked Balance Reconciliation — freight bucket inline editor. Admin
    // allocates $$ from the linked balance child to the parent's freight
    // bucket. On save, /balance-freight-allocation persists the value and
    // fetchQuotes() refreshes so the running ledger + Generate PO gate
    // pick up the new "remaining" amount.
    function handleBalanceFreightEdit(el) {
      if (el.querySelector('.rqd-fin-input')) return; // already editing
      var ref = el.dataset.ref;
      var valueSpan = el.querySelector('.rqd-balance-rec__freight-value');
      if (!valueSpan || !ref) return;

      var currentVal = (valueSpan.textContent || '').replace(/[$,]/g, '').trim();
      var input = document.createElement('input');
      input.type = 'text';
      input.inputMode = 'decimal';
      input.className = 'rqd-fin-input';
      input.value = (parseFloat(currentVal) || 0).toFixed(2);
      valueSpan.textContent = '';
      valueSpan.appendChild(input);
      input.focus();
      input.select();
      input.addEventListener('click', function(ev) { ev.stopPropagation(); });

      var saved = false;
      function save() {
        if (saved) return;
        saved = true;
        var rawVal = input.value.replace(/[$,]/g, '');
        var newVal = parseFloat(rawVal);
        if (isNaN(newVal) || newVal < 0) {
          valueSpan.textContent = money(parseFloat(currentVal) || 0); // revert
          return;
        }
        valueSpan.textContent = money(newVal);
        API.post('/balance-freight-allocation', { ref: ref, amount: newVal })
          .then(function() {
            // Quiet refresh — running ledger + Generate PO gate update in place,
            // no full reload (scroll position + open order preserved).
            // (Ryan 2026-06-02 — reconciling shouldn't collapse the open order.)
            fetchQuotes({ quiet: true });
          })
          .catch(function(err) {
            valueSpan.textContent = money(parseFloat(currentVal) || 0); // revert
            rqdAlert('Failed to save balance freight allocation: ' + (err && err.message ? err.message : 'unknown error'));
          });
      }
      input.addEventListener('blur', save);
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
        if (e.key === 'Escape') { saved = true; valueSpan.textContent = money(parseFloat(currentVal) || 0); }
      });
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — One-click auto-reconcile of an itemized balance child.
       Reads the child's spelled-out line items server-side and drops freight, each good,
       the card fee, and freight cost into the parent's reconciliation buckets (freight
       allocation + vendor-tagged customCosts that hit the PO + COGS). Does NOT touch the
       deal's own financials; revenue rides the existing freight-split rollup. */
    async function handleBalanceAutoReconcile(btn) {
      var ref = btn.dataset.ref;
      var childRef = btn.dataset.childRef;
      if (!ref || !childRef) return;
      if (!(await rqdConfirm(
        'If ' + childRef + ' has itemized lines, reads them and fills the buckets:\n' +
        '  • Freight → freight allocation\n' +
        '  • Each good → a cost line on this order + the vendor PO\n' +
        '  • Card fee + freight cost → cost lines\n\n' +
        'If it’s a pure freight-balance order (no line items), its full amount goes to the freight bucket.\n\n' +
        'Reversible with Undo.',
        { title: 'Auto-reconcile ' + childRef + ' into ' + ref + '?', confirmLabel: 'Auto-reconcile' }
      ))) return;
      try {
        var res = await API.post('/balance-auto-reconcile', { ref: ref, childRef: childRef });
        var lines = (res.addedCosts || []).map(function(c){ return '  • ' + c.label + ' — $' + (parseFloat(c.amount)||0).toFixed(2) + (c.addToPo ? ' (→PO)' : ''); }).join('\n');
        rqdAlert('Auto-reconciled ' + childRef + '.\n\nFreight allocation: $' + (parseFloat(res.freightAllocation)||0).toFixed(2) +
          (lines ? '\n\nCost lines added:\n' + lines : ''));
        fetchQuotes({ quiet: true });
      } catch (err) {
        rqdAlert('Auto-reconcile failed: ' + (err && err.message ? err.message : 'unknown error'));
      }
    }

    async function handleBalanceAutoReconcileUndo(btn) {
      var ref = btn.dataset.ref;
      var childRef = btn.dataset.childRef;
      if (!ref || !childRef) return;
      if (!(await rqdConfirm('Removes the cost lines it added and restores the prior freight allocation.', { title: 'Undo the auto-reconcile of ' + childRef + '?', confirmLabel: 'Undo', danger: true }))) return;
      try {
        await API.post('/balance-auto-reconcile-undo', { ref: ref, childRef: childRef });
        fetchQuotes({ quiet: true });
      } catch (err) {
        rqdAlert('Undo failed: ' + (err && err.message ? err.message : 'unknown error'));
      }
    }

    // Toggle the bucket settings popover visibility. Closes other open
    // popovers first so only one is visible at a time. Document-click
    // listener (set up once in init) closes on outside-click.
    function handleBucketSettingsToggle(btn, ref, bucketId) {
      if (!ref || !bucketId) return;
      var bucketEl = btn.closest('.rqd-fb__bucket');
      if (!bucketEl) return;
      var popover = bucketEl.querySelector('[data-bucket-popover="' + bucketId + '"]');
      if (!popover) return;
      var alreadyOpen = !popover.hasAttribute('hidden');
      // Close all other popovers first.
      document.querySelectorAll('.rqd-fb__bucket-popover').forEach(function (p) {
        if (p !== popover) p.setAttribute('hidden', '');
      });
      if (alreadyOpen) popover.setAttribute('hidden', '');
      else popover.removeAttribute('hidden');
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-23) — one implementation behind both
       request-kind surfaces: the ⚙ popover's <select> and the on-row pill switch.
       Same endpoint, same state (wm.shippingBuckets[id].requestKind), so the two
       always agree after the re-fetch. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-23) — optimistic local flip so the row
       switches INSTANTLY. Waiting on the POST + quiet re-fetch meant the request row
       kept the old kind's button (data-fb-action="request-dims" vs
       data-freight-action="request-quote") for as long as the round-trip took — and
       that re-fetch deliberately bypasses the server cache, so it's the slow path
       (Ryan measured 15-30s). Clicking Email {vendor} in that window opened the OLD
       template, which reads as the picker having silently not worked.
       Mirrors deriveShippingBucketsForQuote's own derivation so the optimistic state
       matches what the server will send back a moment later. */
    function applyRequestKindLocally(ref, bucketId, kind, supplier) {
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q || !Array.isArray(q.shippingBuckets)) return;
      var b = q.shippingBuckets.find(function (x) { return x && x.id === bucketId; });
      // CUSTOM_ALTSHIP_BY_CLAUDE - an alternate's block flips its own shipment entry (same field names).
      if (b && supplier) b = bucketSupplierEntry(q, bucketId, supplier);
      if (!b || b.requestKind === kind) return;
      // A request already sent under the kind we're switching TO becomes current
      // again; the one we're leaving becomes the "already requested" note.
      var incoming = (b.priorRequest && b.priorRequest.kind === kind) ? b.priorRequest : null;
      var outgoing = b.requestedAt ? { kind: b.requestKind, requestedAt: b.requestedAt } : null;
      b.requestKind = kind;
      b.requestKindOverridden = true;
      b.requiresCostBeforePo = (kind === 'freight');
      b.requestedAt = incoming ? incoming.requestedAt : null;
      b.requestedBy = incoming ? (incoming.requestedBy || null) : null;
      b.priorRequest = outgoing
        || ((b.priorRequest && b.priorRequest.kind !== kind) ? b.priorRequest : null);
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (detailEl) {
        detailEl.innerHTML = buildDetailHtml(q);
        applyCollapseState(detailEl, q);
      }
    }

    function saveBucketRequestKind(ref, bucketId, kind, supplier) {
      if (!ref || !bucketId || !kind) return;
      applyRequestKindLocally(ref, bucketId, kind, supplier);
      var _kindBody = { ref: ref, bucketId: bucketId, requestKind: kind };
      if (supplier) _kindBody.vendor = supplier; // CUSTOM_ALTSHIP_BY_CLAUDE
      API.post('/shipping-bucket-set', _kindBody)
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-23) — quiet re-fetch, same as the
           freight-cost save on this very endpoint above. A bare fetchQuotes() snaps
           the detail panel shut and jumps the page to the top, which is brutal when
           the control you just used lives halfway down an expanded card. */
        .then(function () { fetchQuotes({ quiet: true }); })
        .catch(function (err) {
          rqdAlert('Failed to save bucket request kind: ' + (err && err.message ? err.message : 'unknown error'));
          // Re-fetch so the optimistic flip above doesn't leave the row showing a
          // kind the server never accepted.
          fetchQuotes({ quiet: true });
        });
    }

    /* Save the buckets-mode toggle (auto-split vs combined) and refresh.
       ⚠️ async as of the Phase 2 dialog conversion. Both callers fire-and-forget it from the
       bucket-action dispatcher and discard the return, so the Promise is harmless; the POST
       below keeps its own .catch, so nothing here can reject unhandled. */
    /* CUSTOM_RELEASENOW_BY_CLAUDE (Ryan 2026-08-29) — send a business-hours-held vendor email now.

       ⛔ CONFIRMED, NOT ONE-CLICK. Everything else this pill could do is reversible; this puts mail
       in a supplier's inbox and there is no undo. The prompt names WHAT and WHEN so the admin is
       agreeing to a specific email rather than to a button.

       ⚠️ `released: false` COMES BACK AS A SUCCESS, and is reported as information rather than as a
       failure — it means the cron drained the job between the render and the click, which is the
       system working. Telling somebody their send failed when it has just succeeded is the one
       wrong answer here. A genuine refusal (the PO was voided or re-generated while it waited)
       arrives as a 409 and carries its own sentence, which says what to do instead. */
    async function handleReleaseScheduledEmail(btn) {
      var kind = btn.dataset.releaseEmail;
      var ref = btn.dataset.ref || '';
      var when = btn.dataset.when || 'its scheduled time';
      if (!ref || !kind) return;
      var what = kind === 'po'
        ? ('PO ' + (btn.dataset.po || ''))
        : ((btn.dataset.type === 'dims' ? 'weight & dims' : 'freight quote') + ' request to ' + (btn.dataset.vendor || 'the supplier'));
      /* ⛔ THE DIALOG IS THE AFFORDANCE, NOT THE TOOLTIP. Ryan: *"I was half expecting something
         to appear saying 'Send freight request email now instead?' with a yes or no"* — and, the
         standing constraint, *"we need this tool to be usable by AI agents that can't read
         tooltips."* So the question is asked in the DOM, in full words, naming the email and the
         time it would otherwise go. */
      if (!(await rqdConfirm(
        'It is queued to send at ' + when + ' MT. Send it to the supplier right now instead, '
          + 'overriding the business-hours hold?',
        { title: 'Send the ' + what + ' email now?', confirmLabel: 'Send now' }
      ))) return;
      var payload = { quoteRef: ref, kind: kind };
      if (kind === 'po') {
        payload.poNumber = btn.dataset.po || '';
      } else {
        payload.vendor = btn.dataset.vendor || '';
        payload.type = btn.dataset.type || 'freight';
        if (btn.dataset.bucket) payload.bucket = btn.dataset.bucket;
      }
      btn.classList.add('rqd-invoice__link--loading');
      API.post('/release-scheduled-email', payload)
        /* CUSTOM_RELEASENOW_BY_CLAUDE (Ryan 2026-08-29) — ⛔ QUIET, NOT A BARE fetchQuotes().
           Ryan: *"it collapses the deal when I click ok on the pop-up."* A default re-fetch wipes
           `expandedRef`, hides the table and jumps to the top — brutal when the control you just
           used lives halfway down an expanded card, which is the note `saveBucketRequestKind`
           already carries about this exact mistake on this exact card. `quiet` keeps the card
           open and the scroll position, and still re-renders off fresh server data so the pill
           becomes a plain sent row rather than lying about a hold that is gone. */
        .then(function (r) {
          if (r && r.released === false) rqdAlert((r && r.message) || 'That email has already gone out.');
          fetchQuotes({ quiet: true });
        })
        .catch(function (err) {
          btn.classList.remove('rqd-invoice__link--loading');
          rqdAlert('Could not release it: ' + (err && err.message ? err.message : 'unknown error'));
        });
    }

    /* CUSTOM_FREIGHTABORT_BY_CLAUDE (AIOPS e653a9fd28de, Ryan 2026-09-04) — the un-send twin of
       handleReleaseScheduledEmail. Asks in full words, posts to /freight-email/abort, and re-renders
       quietly so the card stays open. A hold that already went out is reported as such, not as an
       error — the honest answer to "stop it" can be "too late". */
    async function handleCancelScheduledEmail(btn) {
      var ref = btn.dataset.ref || '';
      var when = btn.dataset.when || 'its scheduled time';
      if (!ref) return;
      var what = (btn.dataset.type === 'dims' ? 'weight & dims' : 'freight quote') + ' request to ' + (btn.dataset.vendor || 'the supplier');
      if (!(await rqdConfirm(
        'It is queued to send at ' + when + ' MT. Cancel it so it never goes to the supplier? '
          + 'The request stamp goes back to what it was before; you can ask again any time.',
        { title: 'Cancel the held ' + what + ' email?', confirmLabel: 'Cancel the email' }
      ))) return;
      var payload = { quoteRef: ref, vendorName: btn.dataset.vendor || '', type: btn.dataset.type || 'freight' };
      if (btn.dataset.bucket) payload.bucket = btn.dataset.bucket;
      btn.classList.add('rqd-invoice__link--loading');
      return API.post('/freight-email/abort', payload)
        .then(function (r) {
          if (r && r.aborted === false) rqdAlert(r.reason === 'already-sent' ? 'Too late — that email has already gone out.' : 'Nothing was queued for it any more.');
          fetchQuotes({ quiet: true });
        })
        .catch(function (err) {
          btn.classList.remove('rqd-invoice__link--loading');
          rqdAlert('Could not cancel it: ' + (err && err.message ? err.message : 'unknown error'));
        });
    }

    async function handleBucketMode(ref, mode) {
      if (!ref || !mode) return;
      var confirmMsg = mode === 'combined'
        ? 'You can split back later.'
        : 'Broker and parcel go back to separate buckets.';
      if (!(await rqdConfirm(confirmMsg, { title: mode === 'combined' ? 'Combine broker + parcel into one bucket?' : 'Split back into broker + parcel buckets?', confirmLabel: mode === 'combined' ? 'Combine' : 'Split' }))) return;
      API.post('/shipping-bucket-mode', { ref: ref, mode: mode })
        .then(function () { fetchQuotes(); })
        .catch(function (err) { rqdAlert('Failed to change bucket mode: ' + (err && err.message ? err.message : 'unknown error')); });
    }

    // CUSTOM_RFQPORTAL_BY_CLAUDE — handleShippingBucketCostEdit removed.
    // The bucket freight cost is an always-visible input (see render in
    // renderShippingBucketPanel). Committed by its own floppy Save button
    // via saveBucketCost(btn) above — NOT by blur (Ryan 2026-08-13).

    async function handleToggleClick(toggleEl) {
      var ref = toggleEl.dataset.ref;
      var field = toggleEl.dataset.field;

      // Invoiced is fully controlled by the invoice system — not manually toggleable
      if (!field || field === 'invoiced') return;

      var isDone = toggleEl.classList.contains('rqd-toggle--done');
      var newVal = !isDone;

      var payload = { ref: ref };
      payload[field] = newVal;
      var dateField = toggleDateFields[field] || (field + 'Date');
      /* CUSTOM_DDINSTALL_BY_CLAUDE (Ryan 2026-09-02) — a row the renderer marked `optionalDate`
         records the flag WITHOUT inventing a date. See the note in buildToggle: stamping
         `todayStr()` on tick has been quietly filing late-recorded payments under the wrong day.
         The inline picker is still how a known date gets set, and that path is untouched. */
      var _optionalDate = toggleEl.dataset.optionalDate === '1';
      var _stampDate = newVal && !_optionalDate;
      if (_stampDate) payload[dateField] = todayStr();
      else payload[dateField] = null;
      try {
        await API.post('/quote-lifecycle', payload);
        // Update local state
        var q = allQuotes.find(function(x) { return x.reference === ref; });
        if (q) {
          q[field] = newVal;
          if (_stampDate) q[dateField] = todayStr();
          else q[dateField] = null;
          // D4: Clear payment data on uncheck
        }
        // Update UI immediately
        toggleEl.classList.toggle('rqd-toggle--done');
        var check = toggleEl.querySelector('.rqd-toggle__check');
        check.innerHTML = newVal ? '&#10003;' : '';
        var dateSpan = toggleEl.querySelector('.rqd-toggle__date');
        if (_stampDate && !dateSpan) {
          var span = document.createElement('span');
          span.className = 'rqd-toggle__date';
          span.textContent = formatDate(todayStr());
          toggleEl.appendChild(span);
        } else if (!newVal && dateSpan) {
          dateSpan.remove();
        }
        refreshProgressBar(ref);
      } catch (err) {
        console.error('Toggle update failed:', err);
      }
    }

    // ── Purchase Order Handlers ──

    var poModalEl = document.getElementById('rqd-po-modal');
    var poModalTitle = document.getElementById('rqd-po-modal-title');
    var poModalPdfWrap = document.getElementById('rqd-po-modal-pdf-wrap');
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — recipients/subject/body/high-
       importance were removed from Modal 1; they now live on the shared compose modal
       (step 2). Modal 1 is instructions + PDF + Continue only. */
    var poModalDownload = document.getElementById('rqd-po-modal-download');
    var poModalMarkSent = document.getElementById('rqd-po-modal-mark-sent');
    var poModalSend = document.getElementById('rqd-po-modal-send');
    var poModalPreviewBtn = document.getElementById('rqd-po-modal-preview');
    var poModalClose = document.getElementById('rqd-po-modal-close');
    var poModalMsg = document.getElementById('rqd-po-modal-msg');
    var poModalInstructionsList = document.getElementById('rqd-po-modal-instructions-list');
    var poModalInstructionInput = document.getElementById('rqd-po-modal-instruction-input');
    var poModalInstructionAddBtn = document.getElementById('rqd-po-modal-instruction-add-btn');
    var poModalInstructionsPane = document.getElementById('rqd-po-modal-instructions-pane');
    var poModalPaneTabs = document.getElementById('rqd-po-modal-pane-tabs');
    // CUSTOM_BALLAST_BY_CLAUDE (Ryan 2026-09-01) — the missing Vendor Design Sheet bar.
    var poModalSheetGap = document.getElementById('rqd-po-modal-sheet-gap');
    var poModalSheetGapText = document.getElementById('rqd-po-modal-sheet-gap-text');
    var poModalSheetGapBtn = document.getElementById('rqd-po-modal-sheet-gap-btn');
    var poSheetWin = null; // the designer popup, while one is open
    var currentPoModalState = null; // { poNumber, ref, vendor, pdfUrl, instructions[] }
    var poModalPdfBlobUrl = null; // CUSTOM_RFQPORTAL_BY_CLAUDE — same-origin blob: URL for the preview iframe
    var poModalInstructions = []; // mutable per-modal-session list

    function poModalSetMsg(text, isErr) {
      if (!poModalMsg) return;
      poModalMsg.textContent = text || '';
      poModalMsg.className = 'rqd-po-modal__msg' + (isErr ? ' rqd-po-modal__msg--err' : '');
    }

    // PDF magnifier lens — implementation in assets/dashboard-po-lens.js (extracted
    // to keep this section under Shopify's 256 KB template limit).
    function attachPdfLensHandlers() {
      if (window.dashboardPoLens) window.dashboardPoLens.attach(poModalPdfWrap);
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — the PO body is now composed in
       the shared Quill compose modal (step 2), not a contenteditable in Modal 1. The
       only thing Modal 1 does with the body is seed it: convert the plain-text PO body
       template (escaped, `**bold**`, blank-line-separated paragraphs) into Quill-shaped
       HTML. The key fix for the old "squished lines" bug: a blank line between two
       paragraphs must become an empty `<p><br></p>` paragraph — that's exactly what
       Quill emits when a user presses Enter twice, and what normalizeQuillHtml (worker
       src/email/signature.js) preserves while flattening every <p> to margin:0. Joining
       on plain `</p><p>` (no empty paragraph) is what collapsed the gap. */
    function poBodyToQuillHtml(text) {
      function _esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
      var paras = String(text || '')
        .replace(/\r\n/g, '\n')
        .split(/\n{2,}/)                                   // blank line(s) => paragraph break
        .map(function (p) {
          var inner = _esc(p)
            .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')   // **bold** => <strong>
            .replace(/\n/g, '<br>');                              // single newline => soft break
          return '<p>' + (inner || '<br>') + '</p>';
        });
      // Empty paragraph between blocks => one real blank line after margin:0 flatten.
      return paras.join('<p><br></p>');
    }
    // ── Instructions editor ──
    // Escape first, then promote **bold** markers to <strong> — same rendering
    // rule as the PDF (drawInstructionLine in po-pdf.js) and the email body
    // (renderBody in po-routes.js), so what reps see in the modal previews
    // exactly how it'll print/send.
    function renderInstructionMarkup(line) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — {SENDER_EMAIL} renders as a chip rather than
         raw text. This list is the one place the token is visible during a real send, and left
         plain it reads like a broken merge field somebody forgot to fill in. It is deliberately
         NOT resolved here: this list is echoed straight back as customInstructions on every regen,
         so substituting it would freeze one mailbox into the PO the first time it was previewed. */
      // CUSTOM_VGUX_BY_CLAUDE (Ryan 2026-10-11): *italic* and ***bold italic*** as well, the marks the Vendor Guide's
      // instruction boxes write and the PO PDF now prints (rfq po-pdf.js instructionSegments).
      return esc(line)
        .replace(/\*\*\*([^*]+)\*\*\*|\*\*([^*]+)\*\*|\*([^*\s][^*]*?)\*/g, function (all, bi, b, i) {
          return bi != null ? '<strong><em>' + bi + '</em></strong>' : (b != null ? '<strong>' + b + '</strong>' : '<em>' + i + '</em>');
        })
        .replace(/\{SENDER_EMAIL\}/g,
          '<span class="rqd-po-token" title="Resolves on the PDF to the mailbox this PO is sent from — ryan@blueskyfitsupply.com or orders@blueskyfitsupply.com.">{SENDER_EMAIL}</span>');
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }
    function renderPoInstructions() {
      if (!poModalInstructionsList) return;
      poModalInstructionsList.innerHTML = poModalInstructions.map(function (line, idx) {
        return '<li class="rqd-po-modal__instruction-item">'
          + '<span class="rqd-po-modal__instruction-text">' + renderInstructionMarkup(line) + '</span>'
          + '<button type="button" class="rqd-po-modal__instruction-x" data-idx="' + idx + '" aria-label="Remove">&times;</button>'
          + '</li>';
      }).join('');
      if (poModalInstructions.length === 0) {
        poModalInstructionsList.innerHTML = '<li class="rqd-po-modal__instruction-empty">No instructions yet — add one below to print on the PO.</li>';
      }
      renderPoPalletNote();
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — say what pallet fee is on this PO, before it
       goes to the supplier. The count is derived and can be wrong (an exempt bar counts as a
       pallet), and the moment to catch that is here, looking at the document — not later, on the
       invoice.

       Deliberately a NOTICE, not a second editor: the pencil opens the SAME popover the Financials
       card uses, so one number has one write path. Rendered as its own banner rather than a row in
       the instructions list, because everything in that list PRINTS on the PO and this does not —
       the fee prints as a line item, from the worker. */
    function renderPoPalletNote() {
      if (!poModalInstructionsList || !poModalInstructionsList.parentNode) return;
      var host = poModalInstructionsList.parentNode;
      var note = host.querySelector('#rqd-po-pallet-note');
      var fee = currentPoModalState && currentPoModalState.palletFee;
      if (!fee || !(parseFloat(fee.amount) > 0)) { if (note) note.remove(); return; }
      if (!note) {
        note = document.createElement('div');
        note.id = 'rqd-po-pallet-note';
        note.style.cssText = 'margin:0 0 10px;padding:8px 10px;border:1px dashed var(--rq-border, #d1d5db);border-radius:6px;font-size:12px;color:var(--rq-text-secondary, #6b7280);line-height:1.45;';
        host.insertBefore(note, poModalInstructionsList);
      }
      var _cnt = parseInt(fee.count, 10) || 1;
      var _rate = parseFloat(fee.rate) || (parseFloat(fee.amount) / _cnt);
      note.innerHTML =
        '<strong style="color:var(--rq-text, #000);">' + esc(fee.label || 'Pallet / Packaging Fee') + '</strong> — '
        + _cnt + ' &times; $' + _rate.toFixed(2) + ' = <strong style="color:var(--rq-text, #000);">$' + parseFloat(fee.amount).toFixed(2) + '</strong>'
        + ' <button type="button" data-pallet-fee-action="edit"'
        + ' data-ref="' + esc((currentPoModalState && currentPoModalState.ref) || '') + '"'
        + ' data-vendor="' + esc((currentPoModalState && currentPoModalState.vendor) || '') + '"'
        + ' data-bucket="' + esc((currentPoModalState && currentPoModalState.bucket) || '') + '"'
        + ' data-count="' + esc(String(_cnt)) + '"'
        + ' title="Change how many pieces are palletized" aria-label="Edit the pallet fee"'
        + ' style="background:none;border:none;cursor:pointer;padding:0 4px;color:var(--rq-text-secondary, #6b7280);font-size:12px;line-height:1;vertical-align:middle;">&#9998;</button>'
        + '<div style="margin-top:3px;">Prints as a line on this PO because we are moving the freight. Change the count if a bar, attachment or anything else here doesn&rsquo;t take its own pallet &mdash; the PO is re-minted on save.</div>';
      /* Bound directly rather than through the table's click delegation: that listener is on
         `tbody` and this banner lives in the modal, outside it. */
      var _pfBtn = note.querySelector('[data-pallet-fee-action]');
      if (_pfBtn) _pfBtn.addEventListener('click', function () {
        var s = currentPoModalState || {};
        openPalletFeePopover(_pfBtn, s.ref || '', s.vendor || '', {
          bucket: s.bucket || '',
          currentCount: _cnt,
          rate: _rate,
          onSaved: function () {
            // Re-mint the PDF with the corrected count, and refresh the banner from the response.
            poModalSetMsg('Updating the PO…');
            regeneratePoFromModal()
              .then(function (d) { if (d && d.pdfUrl && !poModalPdfWrap.hidden) fillPoPdf(d.pdfUrl); poModalSetMsg(''); })
              .catch(function (err) { poModalSetMsg('Re-generate failed: ' + (err.message || err), true); });
          },
        });
      });
    }
    function poAddInstruction() {
      var v = poModalInstructionInput.value.trim();
      if (!v) return;
      poModalInstructions.push(v);
      poModalInstructionInput.value = '';
      renderPoInstructions();
    }
    if (poModalInstructionAddBtn) poModalInstructionAddBtn.addEventListener('click', poAddInstruction);
    if (poModalInstructionInput) poModalInstructionInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); poAddInstruction(); }
    });
    if (poModalInstructionsList) poModalInstructionsList.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-idx]');
      if (!btn) return;
      var idx = parseInt(btn.getAttribute('data-idx'), 10);
      if (!isNaN(idx)) {
        poModalInstructions.splice(idx, 1);
        renderPoInstructions();
      }
    });

    // ── Pane tabs (Instructions ↔ PDF Preview) ──
    function setPoPane(name) {
      if (!poModalPaneTabs) return;
      poModalPaneTabs.querySelectorAll('[data-pane]').forEach(function (b) {
        b.classList.toggle('rqd-po-modal__pane-tab--active', b.getAttribute('data-pane') === name);
      });
      if (poModalInstructionsPane) poModalInstructionsPane.hidden = name !== 'instructions';
      if (poModalPdfWrap) poModalPdfWrap.hidden = name !== 'pdf';
    }
    if (poModalPaneTabs) poModalPaneTabs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pane]');
      if (!btn) return;
      setPoPane(btn.getAttribute('data-pane'));
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — The signed PO PDF lives on the worker's cross-origin
       domain; framing it directly is blocked by the storefront CSP (Chrome: "<worker>
       refused to connect"). /files sends CORS headers, so fetch the bytes and frame a
       same-origin blob: URL instead — that loads cleanly. Download / Fullscreen still use
       the direct worker URL (new tab / navigation, which CSP frame-src doesn't gate). */
    var _poFsBtnHtml =
        '<button type="button" class="rqd-po-modal__pdf-fullscreen-btn" id="rqd-po-modal-pdf-capture" title="Open full screen" aria-label="Open full screen">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8V3h5"/><path d="M21 8V3h-5"/><path d="M3 16v5h5"/><path d="M21 16v5h-5"/></svg>' +
          '<span>Fullscreen</span>' +
        '</button>';
    function fillPoPdf(pdfUrl) {
      if (poModalPdfBlobUrl) { try { URL.revokeObjectURL(poModalPdfBlobUrl); } catch (e) {} poModalPdfBlobUrl = null; }
      poModalPdfWrap.innerHTML = '<div class="rqd-po-modal__pdf-empty">Loading preview…</div>';
      fetch(pdfUrl, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); })
        .then(function (blob) {
          poModalPdfBlobUrl = URL.createObjectURL(blob);
          poModalPdfWrap.innerHTML =
            '<iframe class="rqd-po-modal__pdf-iframe" src="' + poModalPdfBlobUrl + '#toolbar=0&navpanes=0" title="PO PDF"></iframe>' +
            _poFsBtnHtml;
          attachPdfLensHandlers();
        })
        .catch(function (err) {
          poModalPdfWrap.innerHTML = '<div class="rqd-po-modal__pdf-empty">Couldn’t load the inline preview (' + (err && err.message ? err.message : 'error') + '). Use <strong>Download</strong> or <strong>Fullscreen</strong> instead.</div>';
        });
    }

    /* CUSTOM_BALLAST_BY_CLAUDE (Ryan 2026-09-01) — THE VENDOR DESIGN SHEET, GENERATED FROM HERE.
       ───────────────────────────────────────────────────────────────────────────────────────────
       A deal can carry a weight design whose Vendor Design Sheet was never made, and the PO then
       goes to the factory without the artwork it is being asked to print. Nothing said so: the
       worker logged a line and sent the PO anyway.

       ⛔ THE DASHBOARD CANNOT BUILD THIS PDF, and neither can the worker. The sheet is a contact
       sheet of every picked product, each one a WebGL render of a plate; a Cloudflare isolate has
       no GPU and this page has no plate renderer. The Weight Designer has both. So this sends the
       rep's browser there — `?autosheet=vendor` runs the ordinary sheet path unattended and posts
       the outcome back — rather than growing a second renderer here that would drift from the one
       reps actually use.

       ⚠️ A POPUP, NOT AN IFRAME. The storefront's bare-domain → www canonical redirect returns
       X-Frame-Options that block framing a portal page in a portal page (see the LeadFinder import
       at the bottom of this file, which learned the same thing). `window.open` in the click
       handler keeps the user gesture, so a blocker does not swallow it silently.

       ⚠️ THE SUPPLIER COMES FROM THE WORKER, NOT FROM `state.vendor`. On a white-label order the
       modal's vendor is OUR name and the PO goes to somebody else entirely; the sheet must be
       stamped with whoever receives it. `designSheetGap.vendor` is the resolved name the worker
       already used to decide there was a gap, passed straight through. */
    function renderPoSheetGap() {
      if (!poModalSheetGap) return;
      var st = currentPoModalState;
      var gap = st && st.designSheetGap;
      var have = st && st.designSheet;

      /* ⛔ A SHEET THAT EXISTS STILL NEEDS A WAY TO BE REPLACED. The bar used to render only on a
         GAP, so the moment one sheet existed the button vanished and there was no route back to a
         fresh one — a design edited after its sheet was made would have shipped the old artwork
         with nothing on screen saying so, and a sheet named under an older rule could never be
         brought into line. Two moods, one bar: fill the gap, or confirm and offer to replace. */
      if (!gap && !have) { poModalSheetGap.hidden = true; return; }
      poModalSheetGap.hidden = false;
      poModalSheetGap.classList.toggle('rqd-po-modal__sheet-gap--ok', !gap && !!have);

      if (poModalSheetGapText) {
        poModalSheetGapText.textContent = gap
          ? ('This order has a weight design (' + (gap.designRef || gap.designId)
            + ') but no design sheet for ' + (gap.vendor || 'this supplier')
            + '. Without one the PO goes out with no artwork.')
          : ('Design sheet attached: ' + (have.filename || 'Vendor Design Sheet.pdf')
            + '. Regenerate it if the design has changed since.');
      }
      /* ⚠️ THE WARNING IS FOR EVERYONE, THE BUTTON IS NOT. `/wd-pdf` refuses the vendor variant to
         a non-admin and the designer's portal page is admin-gated too, so the button would open a
         window that greys itself out. A rep still needs to know the PO has no artwork on it —
         hiding the whole bar would put them back where they started. `isAdmin` is read HERE rather
         than captured, because it is a var that is assigned after boot. */
      if (poModalSheetGapBtn) {
        poModalSheetGapBtn.hidden = !isAdmin;
        poModalSheetGapBtn.disabled = false;
        poModalSheetGapBtn.textContent = gap ? 'Generate design sheet' : 'Regenerate';
      }
      if (!isAdmin && gap && poModalSheetGapText) {
        poModalSheetGapText.textContent += ' An admin has to generate it from the Weight Designer.';
      }
    }

    if (poModalSheetGapBtn) poModalSheetGapBtn.addEventListener('click', function() {
      var st = currentPoModalState;
      /* Either mood drives the same popup: the GAP names the design that needs a sheet, and an
         existing POINTER names the design its sheet was made from. Same three fields either way. */
      var gap = st && (st.designSheetGap || st.designSheet);
      if (!gap || !gap.designId) return;
      var qs = new URLSearchParams({
        designId: gap.designId,
        autosheet: 'vendor',
        ref: st.ref || '',
        poVendor: gap.vendor || '',
        // Names the sheet "Design Details - PO {n} - {date}" (Ryan 2026-09-01) — a factory filing
        // an attachment beside a purchase order needs to know WHICH order, and the customer's
        // school name tells them nothing they can search for.
        poNumber: st.poNumber || '',
      });
      /* The customer's name is what the sheet files itself under. Best-effort: the vendor variant
         has no cover to print it on, so a blank one costs a filename, not a document. */
      var _co = (gap.customer || '').trim();
      if (_co) qs.set('customer', _co);
      /* CUSTOM_BALLAST_BY_CLAUDE (Ryan 2026-09-02) — the CONTACT, which the sheet prints as an
         initial and a surname so the factory can file a repeat order. A separate field from
         `customer`: that one prefers the company, and "Arcadia High School" initialises to
         "A. School". The designer abbreviates it; the full name is never printed.
         ⚠️ Without this the PO-generated sheet silently differed from the one a rep builds by hand
         in the designer, which is the whole complaint this fixes. */
      var _ct = (gap.contact || '').trim();
      if (_ct) qs.set('contact', _ct);
      /* ⚠️ SYNCHRONOUS, inside the gesture. Every await between the click and the open is a chance
         for the blocker to treat this as unsolicited. */
      try { poSheetWin = window.open('/pages/rep-weight-designer?' + qs.toString(), 'rqd-wd-sheet', 'width=1280,height=900'); }
      catch (e) { poSheetWin = null; }
      if (!poSheetWin) {
        poModalSetMsg('Your browser blocked the designer window — allow popups for this site, then try again.', true);
        return;
      }
      poModalSheetGapBtn.disabled = true;
      poModalSheetGapBtn.textContent = 'Building…';
      poModalSetMsg('Building the design sheet — the designer window will close when it is done.');
      poSheetWatch(poSheetWin);
    });

    /* ⛔ "BUILDING…" MUST BE ABLE TO END WITHOUT A MESSAGE. The reply is the happy path and it is
       not the only path: the rep can close the window, the designer can stall behind a screen that
       wants a tap, the bundle can fail to load, a render can hang on a lost WebGL context. Every
       one of those leaves a disabled button and a sentence that will never come true, which is the
       exact shape of a UI a rep has to reload the page to escape.
         Two exits, both unconditional: the window going away, and a wall-clock deadline. Three
       minutes is generous — the oven renders every picked product through its own WebGL context
       and the bundle pulls ~4 MB before it starts — and generous is right for a bound whose only
       job is to guarantee the state ends. */
    var poSheetTimer = null;
    var poSheetPoll = null;
    function poSheetDone() {
      if (poSheetTimer) { clearTimeout(poSheetTimer); poSheetTimer = null; }
      if (poSheetPoll) { clearInterval(poSheetPoll); poSheetPoll = null; }
      poSheetWin = null;
      if (poModalSheetGapBtn) { poModalSheetGapBtn.disabled = false; poModalSheetGapBtn.textContent = 'Generate design sheet'; }
    }
    function poSheetWatch(win) {
      if (poSheetTimer) clearTimeout(poSheetTimer);
      if (poSheetPoll) clearInterval(poSheetPoll);
      poSheetTimer = setTimeout(function() {
        poSheetDone();
        poModalSetMsg('The designer did not finish in time. Generate the sheet from the Weight Designer, then re-open this PO.', true);
      }, 180000);
      /* A closed window reports nothing, so it has to be noticed rather than waited for. Same
         close-poll shape as the LeadFinder import handshake further down this file. */
      poSheetPoll = setInterval(function() {
        if (!win || win.closed) {
          var wasOpen = !!poSheetWin;
          poSheetDone();
          if (wasOpen) poModalSetMsg('The designer window was closed before the sheet was finished.', true);
        }
      }, 1000);
    }

    /* The other half of the contract. Origin-checked, unlike the two older popup handshakes in this
       file which post to '*' and read whatever arrives. */
    window.addEventListener('message', function(ev) {
      if (ev.origin !== window.location.origin) return;
      var d = ev.data;
      if (!d || d.source !== 'weight-designer') return;
      if (d.type !== 'wd-sheet:done' && d.type !== 'wd-sheet:failed') return;
      try { if (poSheetWin && !poSheetWin.closed) poSheetWin.close(); } catch (e) { /* already gone */ }
      /* Clears the deadline and the close-poll in the SAME tick as the close, so the poll cannot
         then report the window we just closed ourselves as an abandonment. */
      poSheetDone();
      if (d.type === 'wd-sheet:failed') {
        poModalSetMsg('The design sheet could not be built' + (d.error ? ' — ' + d.error : '') + '.', true);
        return;
      }
      /* ⛔ `recorded` IS THE PART THAT MATTERS. The sheet always downloads; what makes a PO carry it
         is the worker writing its key back against the design. A sheet that built but did not
         register would otherwise read here as a success and then not appear on the email. */
      if (!d.recorded) {
        poModalSetMsg('The sheet was built but could not be attached to this deal — send it by hand from the designer.', true);
        return;
      }
      if (currentPoModalState) {
        currentPoModalState.designSheetGap = null;
        /* What the composer's pill will name. Held here rather than re-fetched: /generate-po
           answers `designSheet` too, but the rep's next click is usually Continue and a round trip
           to learn a filename we were just handed is a round trip for nothing. */
        currentPoModalState.designSheet = {
          filename: d.filename || 'Vendor Design Sheet.pdf',
          // Absolute already — the designer reports the worker's own URL for the stored sheet.
          url: d.url || '',
          designId: (currentPoModalState.designSheetGap && currentPoModalState.designSheetGap.designId)
            || (currentPoModalState.designSheet && currentPoModalState.designSheet.designId) || '',
          vendor: (currentPoModalState.designSheetGap && currentPoModalState.designSheetGap.vendor)
            || (currentPoModalState.designSheet && currentPoModalState.designSheet.vendor) || '',
        };
      }
      renderPoSheetGap();
      poModalSetMsg('Design sheet ready — it will be attached when this PO is sent.');
    });

    function openPoModal(state) {
      currentPoModalState = state;
      poModalTitle.textContent = 'PO ' + state.poNumber + ' — ' + state.vendor;
      renderPoSheetGap();
      poModalInstructions = (state.instructions || []).slice();
      renderPoInstructions();
      if (state.pdfUrl) {
        fillPoPdf(state.pdfUrl);
      } else {
        poModalPdfWrap.innerHTML = '<div class="rqd-po-modal__pdf-empty">Click <strong>Preview PDF</strong> below to render the PO.</div>';
      }
      // Default to Instructions pane on open — admin sees + edits before any PDF render
      setPoPane('instructions');
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — recipients/subject/body live on
         the compose modal now; they ride in currentPoModalState and are read at hand-off.
         "Continue to email →" is enabled unless the PO is voided (an empty recipient list
         is fine — the rep enters/edits To in step 2, which has its own "To required"
         guard). */
      poModalSend.disabled = (state.allowSend === false);
      // Download button is meaningful only when a PDF has been rendered
      if (poModalDownload) poModalDownload.disabled = !state.pdfUrl;
      poModalSetMsg('');
      poModalEl.classList.remove('rqd-po-modal--hidden');
    }
    function closePoModal() {
      poModalEl.classList.add('rqd-po-modal--hidden');
      currentPoModalState = null;
    }
    if (poModalClose) poModalClose.addEventListener('click', closePoModal);
    if (poModalEl) poModalEl.addEventListener('click', function(e){ if (e.target === poModalEl) closePoModal(); });
    if (poModalDownload) poModalDownload.addEventListener('click', async function(){
      if (!currentPoModalState || !currentPoModalState.pdfUrl) return;
      // Open the PDF in a new tab synchronously (popup blockers won't fire on
      // direct user-gesture window.open calls — the awaits below are fine after).
      window.open(currentPoModalState.pdfUrl, '_blank');

      var ref = currentPoModalState.ref;
      var poNumber = currentPoModalState.poNumber;

      // Optimistic local update — flip downloadedAt on the in-memory PO
      // summary and re-render so the Purchasing card checkbox shows ✓ before
      // the worker round-trip resolves. Avoids the appearance of nothing
      // happening if the user is on a slow connection.
      var q = allQuotes.find(function(x){ return x.reference === ref; });
      if (q) {
        if (!Array.isArray(q.pos)) q.pos = [];
        var match = q.pos.find(function(p){ return p.poNumber === poNumber; });
        if (match) {
          match.downloadedAt = new Date().toISOString();
        } else {
          // Newly-generated PO that hasn't been folded into q.pos yet.
          q.pos.push({
            poNumber: poNumber,
            vendor: currentPoModalState.vendor,
            status: 'draft',
            downloadedAt: new Date().toISOString(),
          });
        }
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl) { detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q); }
        refreshProgressBar(ref);
      }

      // Persist server-side and refetch authoritative state. Surface failures
      // so a 401 / 403 / 5xx doesn't silently desync the optimistic flip.
      try {
        await API.post('/po-mark-downloaded', { poNumber: poNumber });
        await refreshQuotePos(ref);
      } catch (e) {
        poModalSetMsg('Download saved locally — server sync failed: ' + (e && e.message ? e.message : e), true);
      }
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — "Mark as Sent" from the PO modal. The
       primary home for this is the Fulfillment card's PO row (data-po-action="mark-sent"),
       which is where you already are when you notice a PO never got recorded; this second
       entry point covers deciding NOT to email once the modal is open. Both call the same
       handler so they cannot drift. */
    if (poModalMarkSent) poModalMarkSent.addEventListener('click', function () {
      if (!currentPoModalState || !currentPoModalState.poNumber) return;
      handlePoMarkSent(currentPoModalState.poNumber, currentPoModalState.ref,
        currentPoModalState.vendor, poModalMarkSent, poModalSetMsg);
    });
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Re-renders the PDF using the modal's current instructions list. Stores the
    // freshly-built pdfUrl on currentPoModalState so Send/Download use the latest.
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — takes an explicit state now. The compose
       modal opens AFTER closePoModal() has nulled the live reference, and switching the From
       dropdown there has to re-render the PDF so a {SENDER_EMAIL} instruction resolves to the
       mailbox actually sending. `opts.state` is the surviving object the composer closed over. */
    async function regeneratePoFromModal(opts) {
      var s = (opts && opts.state) || currentPoModalState;
      if (!s) return null;
      var payload = {
        quoteRef: s.ref,
        vendor: s.vendor,
        customInstructions: poModalInstructions.join('\n'),
      };
      // Which mailbox this PO is going out from — decides what {SENDER_EMAIL} prints.
      if (opts && opts.fromMailbox) payload.fromMailbox = opts.fromMailbox;
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      // CUSTOM_RFQPORTAL_BY_CLAUDE — Carry the bucket key from the modal
      // state into every regen so the filtered line items + bucket PO
      // suffix stay correct on Preview re-renders + Send. Without this
      // the modal's Preview button was minting a no-bucket PO carrying
      // ALL line items, overwriting the originally-bucket-filtered PDF
      // with one that violated the bucket boundary.
      if (s.bucket) payload.bucket = s.bucket;
      // Past the initial roll-layout gate (the modal only opens after the first
      // generate succeeded) — don't re-warn on Preview/Send regens.
      payload.confirmedNoRollLayout = true;
      // CUSTOM_SPECMISMATCH_BY_CLAUDE — same reason: the modal only opens after the first generate
      // cleared both gates, so a Preview/Send regen must not re-ask.
      payload.confirmedSpecMismatch = true;
      var data = await API.post('/generate-po', payload);
      s.pdfUrl = data.pdfUrl;
      s.poNumber = data.poNumber;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — the regen re-resolves the pallet fee (a
         corrected count only reaches the PDF through this call), so the notice has to be re-read
         from the response. Assigned unconditionally: `null` is a real answer — it is what a
         supplier-ships PO returns — and keeping a stale object would leave the banner claiming a
         fee that is no longer on the document. */
      s.palletFee = data.palletFee || null;
      /* CUSTOM_BALLAST_BY_CLAUDE (Ryan 2026-09-01) — and the design-sheet gap, re-read for the same
         reason and assigned the same way: `null` is a real answer. A rep who generated the sheet in
         the designer directly, or on another PO for this supplier, has closed the gap without this
         modal hearing about it, and a bar still demanding a sheet that now exists is worse than no
         bar at all. Note the regen also re-resolves the SUPPLIER, so a gap answered here is the
         gap for the vendor this PO currently goes to. */
      s.designSheetGap = data.designSheetGap || null;
      s.designSheet = data.designSheet || null;
      /* Only repaint when this IS the open modal — a From-switch regen happens with the PO
         modal closed behind the composer, and painting a hidden pane is wasted work. */
      if (s === currentPoModalState) {
        renderPoPalletNote();
        renderPoSheetGap();
        if (poModalDownload) poModalDownload.disabled = false;
      }
      return data;
    }

    if (poModalPreviewBtn) poModalPreviewBtn.addEventListener('click', async function () {
      poModalPreviewBtn.disabled = true;
      poModalSetMsg('Rendering PDF…');
      try {
        var data = await regeneratePoFromModal();
        fillPoPdf(data.pdfUrl);
        setPoPane('pdf');
        poModalSetMsg('');
      } catch (err) {
        poModalSetMsg('Preview failed: ' + (err.message || err), true);
      } finally {
        poModalPreviewBtn.disabled = false;
      }
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-09) — PO email now sends through the
       SHARED compose modal (Quill: blank-line preservation, plain-paste, Send Test).
       Instructions → PDF-regenerate stay here in the PO flow; on Send we regenerate
       with the latest instructions, then hand off to openComposeModal seeded from
       these fields. The adapter posts to /email-po (quillBody:true) which attaches the
       PO PDF server-side by poNumber + stamps the post-send state. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — fetch the rendered PO PDF as a
       base64 blob so it can ride into the compose modal as a (locked, non-removable)
       attachment chip — the rep sees + can preview the exact PDF that /email-po attaches
       server-side. Best-effort: a fetch failure just omits the chip (PDF still attaches
       server-side by poNumber). */
    function _fetchPoPdfAttachment(pdfUrl, poNum) {
      return fetch(pdfUrl)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); })
        .then(function (blob) {
          return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
              var s = String(reader.result || '');
              var i = s.indexOf(',');
              resolve({
                name: 'PO ' + poNum + '.pdf',
                contentType: 'application/pdf',
                base64: i >= 0 ? s.slice(i + 1) : s,
                sizeBytes: blob.size,
                locked: true,
              });
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        });
    }

    if (poModalSend) poModalSend.addEventListener('click', async function () {
      if (!currentPoModalState) return;
      poModalSend.disabled = true;
      poModalSetMsg('Generating PDF…');
      try {
        // Always re-generate with the latest instructions before handing off — admin
        // may have tweaked them since the last preview (or never previewed at all).
        await regeneratePoFromModal();
        if (!(window.RQD && window.RQD.openComposeModal)) { throw new Error('Composer unavailable — reload the page.'); }
        // Recipients / subject / body now live on the compose modal — they ride in
        // currentPoModalState (seeded from /generate-po), edited by the rep in step 2.
        var s = currentPoModalState;
        var to = (s.to || []).slice();
        var cc = (s.cc || []).slice();
        var poNum = s.poNumber;
        var poRef = s.ref;
        var subject = s.subject || '';
        // PO body template → Quill-shaped HTML (blank lines preserved as empty
        // paragraphs — see poBodyToQuillHtml + normalizeQuillHtml).
        var _bodyHtml = poBodyToQuillHtml(s.body || '');
        function _repSessionEmail() {
          try { var raw = sessionStorage.getItem('rep_portal_session'); return raw ? ((JSON.parse(raw) || {}).email || '').trim() : ''; } catch (_) { return ''; }
        }
        // Fetch the PO PDF for the attachment chip (best-effort).
        var preAttachments = [];
        try {
          if (s.pdfUrl) preAttachments = [await _fetchPoPdfAttachment(s.pdfUrl, poNum)];
        } catch (_) { preAttachments = []; }
        /* CUSTOM_BALLAST_BY_CLAUDE (Ryan 2026-09-01) — THE DESIGN SHEET, SHOWN BEFORE IT IS SENT.
           Ryan: *"prior to clicking send, shouldn't I be able to see the attachment listed in the
           footer of the composer alongside the PO attachment pill? That would help me be reassured
           it's actually going to send."* It is attached SERVER-SIDE by /email-po (the worker reads
           the pointer and appends the bytes), so unlike the PO PDF it never passes through this
           composer and had no pill — the one attachment the rep had just gone and made was the
           only one they could not see.

           ⛔ `displayOnly`, NOT `locked`. Both render the padlock and neither can be removed, but
           only `displayOnly` is filtered out of the wire (`a.base64 && !a.displayOnly`), and it
           carries no base64 at all. A `locked` chip here would either send the sheet TWICE or
           demand we fetch a megabyte of PDF to render a filename. The composer already words its
           tooltip for exactly this case: "Attached automatically when you send". */
        if (s.designSheet && s.designSheet.filename) {
          preAttachments = preAttachments.concat([{
            name: s.designSheet.filename,
            contentType: 'application/pdf',
            displayOnly: true,
            /* Ryan 2026-09-01: *"make the pill clickable so you can open the attachment in browser
               like you can for the actual PO PDF."* The PO PDF previews from its own base64; this
               one has none by design, so it opens by URL instead — `/wd-pdf-file/` is public (an
               unguessable key) and serves `inline`, so the browser renders it. */
            previewUrl: s.designSheet.url || '',
          }]);
        }

        // Preserve the modal state so the compose modal's Back button can re-open
        // Modal 1 (closePoModal nulls the live reference, but the object survives).
        var savedState = s;
        /* CUSTOM_POTHREAD_BY_CLAUDE (AIOPS 4da52e6a59c6, Ryan 2026-09-04) — ask the worker which
           supplier message this PO would reply on. When threading is live and a rate reply is on
           file, the subject the composer shows is the thread's own "RE: …" (Graph owns a reply's
           subject; showing anything else would be a lie about what leaves). A test send threads
           whether or not the switch is on, so the tester sees the real thing. Best-effort: a
           failed lookup opens the composer exactly as before. */
        var _poThread = null;
        try { _poThread = await API.get('/email-po/thread?poNumber=' + encodeURIComponent(poNum)); } catch (_) { _poThread = null; }
        if (_poThread && _poThread.wouldThread && _poThread.thread && _poThread.thread.subject) {
          subject = _poThread.thread.subject;
          /* CUSTOM_POGREET_BY_CLAUDE (AIOPS d0cf7d74e32c, Ryan 2026-09-04) — and the greeting the
             worker will open the body with when it replies to a named person ("Thank you Mandy,"
             rather than the Guide's "Hi West Team," — Ryan 2026-09-05: this email is a reply to
             the one they sent us, so it thanks them). The worker decides and applies it at send on
             every path; this only shows the rep the line that will actually leave. Live-threading
             only: when only a test would thread, the composer keeps the composed greeting and the
             test email itself carries the personal one. Swaps the first paragraph when it is a
             greeting line (Hi / Hello / Dear / Thank you…, the worker's own GREETING_LINE);
             otherwise leaves the body alone. */
          if (_poThread.greeting) {
            _bodyHtml = String(_bodyHtml).replace(/^(\s*<p[^>]*>)([\s\S]*?)(<\/p>)/i, function (m, open, inner, close) {
              var text = inner.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
              return /^(hi|hello|hey|dear|thank you|thanks|good\s+(morning|afternoon|evening))\b/i.test(text) ? open + esc(_poThread.greeting) + close : m;
            });
          }
        }
        function _openPoComposer() {
          window.RQD.openComposeModal({
            ref: poRef,
            prefillTo: to.join(', '),
            prefillCc: cc,
            prefillSubject: subject,
            prefillBody: _bodyHtml,
            preAttachments: preAttachments,
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-15) — From: selector. 'po' remembers
               (per rep) whether POs send from Ryan Walker <ryan@> or Abby <orders@>. The
               PO PDF is attached server-side either way; the dropdown owns the signature preview. */
            emailType: 'po',
            // CUSTOM_VENDORFROM_BY_CLAUDE — Legend POs default to Abby; still switchable.
            forceFrom: defaultFromMailboxFor(poRef, s.vendor),
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — re-render the PDF when the composer's
               From settles or is switched, so a {SENDER_EMAIL} instruction names the mailbox that
               actually sends. It has to be a callback rather than a value read up front: the
               composer loads the rep's saved per-type default asynchronously and moves the
               dropdown a moment AFTER it opens, so anything decided here would already be stale.

               Three gates, and each one is load-bearing:
                 • token absent  → every ordinary PO skips the round trip entirely
                 • already sent  → a sent PO is the audit record; regenerating one mints a revision
                 • same mailbox  → the settle fires with the value we already baked, most of the time
               Failure is silent on purpose: the PDF the composer attaches is still a valid PO, and
               an alert over a background re-render would interrupt a send for nothing. */
            onFromChange: function (mailbox) {
              try {
                if (savedState.isSent) return;
                if (poModalInstructions.join('\n').indexOf('{SENDER_EMAIL}') === -1) return;
                if (savedState.fromMailbox === mailbox) return;
                savedState.fromMailbox = mailbox;
                regeneratePoFromModal({ state: savedState, fromMailbox: mailbox })
                  .catch(function () { /* non-fatal — the previously rendered PO still attaches */ });
              } catch (_) { /* non-fatal */ }
            },
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
            fromRepLabel: 'Ryan Walker <ryan@blueskyfitsupply.com>',
            // Resend-sent (not in Outlook Sent) → pre-fill ryan@ into the visible Bcc when
            // sending as Ryan, so he keeps a copy. Removable via the chip; removed = no copy.
            /* CUSTOM_VENDORFROM_BY_CLAUDE (Ryan 2026-08-27) - ⛔ THE HARDCODED SELF-BCC IS GONE.
               It pre-filled ryan@ into the visible Bcc whenever the email sent AS Ryan, because these go
               out through Resend and never land in his Outlook Sent folder. Ryan: *"I just realized we
               can set this on all vendors in the vendor guide as we need to, so we don't need that hard
               coded rule anymore."*

               The Guide's PO Profile -> Bcc is now the single source of who gets a copy, and it already
               prefills this composer, so one field decides instead of a field plus a rule that silently
               appended to it.

               ⚠️ MEASURED BEFORE REMOVING: 13 of 41 vendor profiles carry a Bcc today (all ryan@); the
               other 28 carry none, and nothing else adds one - `/freight-email` sends exactly the list it
               is given and `handleEmailPo` falls back only to the vendor's own configured Bcc. So on
               those 28, a vendor email now goes out with NO copy to anybody until the profile is filled
               in. That is the intended trade, recorded here because the failure is silent. */
            suppressAttachmentGuard: true, // the PO PDF is attached server-side by /email-po
            showHighImportance: true,
            /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-08-13) — vendor POs get the same
               "send within business hours" hold the customer shipping email has.
               ⛔ BUT UNTICKED BY DEFAULT (Ryan 2026-08-29). The hold stays available — a PO
               composed at 11pm can still be parked for 6am — it just is not the assumption.
               A supplier works their orders@ inbox in the morning whenever it arrived, so the
               overnight hold bought nothing and cost a night of manufacturing lead time on
               every PO cut after 6pm MT. The ⏱ is one click away when it is wanted. */
            showBusinessHours: true,
            businessHoursDefault: false,
            enterFrom: 'right',
            fetchQuotes: fetchQuotes,
            onBack: function () { openPoModal(savedState); },
            sendOverride: function (args) {
              /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — forward the composer's
                 manually-uploaded files (e.g. a BOL) to /email-po so they ride ALONGSIDE
                 the server-attached PO PDF. Skip locked chips (the PO PDF preview, which
                 the worker attaches itself). Applies to Send Test too. */
              var _extraAtt = (args.attachments || [])
                .filter(function (a) { return a && a.base64 && !a.locked; })
                .map(function (a) { return { name: a.name, contentType: a.contentType, base64: a.base64 }; });
              var payload = {
                poNumber: poNum,
                to: args.to, cc: args.cc, bcc: args.bcc,
                subject: args.subject,
                body: args.bodyHtml,
                quillBody: true,
                highImportance: !!args.highImportance,
                fromMailbox: args.fromMailbox || 'REP',
                // CUSTOM_SENDWINDOW_BY_CLAUDE — worker queues the send when outside the window.
                businessHoursOnly: args.businessHoursOnly === true,
                attachments: _extraAtt,
              };
              if (args.isTest) {
                payload.test = true;
                payload.testRecipient = _repSessionEmail() || (args.to || [])[0] || '';
                if (!payload.testRecipient) { return Promise.reject(new Error('No address for the test — re-login so your session email is set.')); }
              }
              /* CUSTOM_LINESWAP_BY_CLAUDE (Ryan 2026-09-15) ⛔ "RE-SEND PO" HAS NEVER WORKED.
                 The worker has refused a second send of an already-sent PO since 2026-08-27
                 unless the caller acknowledges it with `confirmResend: true` — and this
                 payload has never carried that field (nor has any other caller in the theme).
                 The button relabels itself to "Re-send PO" and then fails with *"This PO was
                 already emailed to the vendor on {date}. Use Re-send if you mean to send it
                 again"* — naming the control the operator just pressed.

                 ⛔ FIXED BY ASKING, NOT BY SETTING THE FLAG. The guard exists because a
                 stuck spinner used to mail a supplier twice; sending `confirmResend` up front
                 would delete the protection rather than complete it. The acknowledgement it
                 wants is a human's, so the human is the one who gives it — once, on the
                 refusal, with the date of the first send in front of them.

                 ⚠ ONLY on `confirmResendRequired`, which the worker sets on both doors it
                 guards: an already-sent PO and an INDETERMINATE one (a send Graph never
                 confirmed, where the vendor may or may not already have it). The second is
                 the more dangerous and its message says so; the retry is the same. */
              /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-15) — ⛔ THE ASYNC IS THE POINT HERE,
                 not a tidy-up. This is the guard that stops a supplier receiving the same PO
                 twice, and it was a native confirm(): invisible to anything driving the board, and
                 unanswerable by it. The callback stays a `.catch` handler and still hands the same
                 things back — an async function that throws rejects, and one that returns
                 API.post's promise resolves to it, so the chain below sees exactly what it did
                 before. Only the dialog changed. */
              var _post = function (p) {
                return API.post('/email-po', p).catch(async function (err) {
                  var d = (err && err.data) || {};
                  if (!d.confirmResendRequired || p.confirmResend || p.test) throw err;
                  var when = d.sentAt ? (' on ' + d.sentAt) : '';
                  var who = (d.sentTo && d.sentTo.length) ? (' to ' + d.sentTo.join(', ')) : '';
                  var msg = d.indeterminate
                    ? 'A previous send of this PO never confirmed, so the supplier may already have it.'
                      + ' Send it again anyway?'
                    : 'This PO was already emailed' + who + when + '. Send it again?';
                  /* ⚠️ `danger` so nothing is focused: Enter must not mail a vendor a second
                     copy of a purchase order by reflex. The label says which way is which, because
                     "OK" on a message ending in "Send it again?" is a coin toss. */
                  if (!(await rqdConfirm(msg, {
                        title: d.indeterminate ? 'Send this PO again?' : 'This PO was already sent',
                        confirmLabel: 'Send it again', cancelLabel: 'Do not send', danger: true,
                      }))) throw new Error('Not re-sent.');
                  var again = {}; for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) again[k] = p[k];
                  again.confirmResend = true;
                  return API.post('/email-po', again);
                });
              };
              return _post(payload).then(function (res) {
                if (res && res.success === false) throw new Error((res && res.error) || 'Send failed');
                if (!args.isTest) { try { refreshQuotePos(poRef); } catch (_) {} }
                /* CUSTOM_SENTITEMS_BY_CLAUDE (Ryan 2026-08-28) — say so when the PO went out on
                   Resend instead of through the sending mailbox, i.e. when it will not be in
                   Sent Items. Empty note on the Graph path leaves the plain "✓ Sent." */
                var _note = (window.RQD && window.RQD.transportNote) ? window.RQD.transportNote(res) : '';
                /* CUSTOM_POTHREAD_BY_CLAUDE — say whether it threaded, in words, after the send. */
                var _th = res && res.threaded;
                if (_th) {
                  var _thNote = _th.mode === 'reply'
                    ? (args.isTest ? 'Test copy replied on the supplier\'s rate thread ("' + (_th.subject || '') + '") — to you only.' : 'Replied on the supplier\'s rate thread ("' + (_th.subject || '') + '").')
                    : (_th.mode === 'reply-when-released' ? 'Held; will reply on the supplier\'s rate thread when it releases.'
                      : (_th.requested ? 'Threading was requested but the reply could not be built — sent as a new email.' : (_th.note || 'Sent as a new email.')));
                  _note = _note ? (_note + ' ' + _thNote) : _thNote;
                }
                return _note ? { composerNote: _note } : res;
              });
            },
          });
        }

        // Slide Modal 1 left-out, then open the composer sliding in from the right.
        poModalEl.classList.add('rqd-po-modal--slide-out');
        setTimeout(function () {
          closePoModal();
          poModalEl.classList.remove('rqd-po-modal--slide-out');
          _openPoComposer();
        }, 190);
      } catch (err) {
        poModalSetMsg('Could not prepare PO: ' + (err.message || err), true);
        poModalSend.disabled = false;
      }
    });

    async function refreshQuotePos(ref) {
      try {
        var data = await API.get('/pos?quoteRef=' + encodeURIComponent(ref));
        var pos = (data && data.pos) || [];
        var q = allQuotes.find(function(x){ return x.reference === ref; });
        // CUSTOM_RFQPORTAL_BY_CLAUDE — Build a local bucket-lookup from the
        // current q.pos so legacy / orphan POs that were attributed via the
        // worker's read-time heal (lc.pos heal in quote-dashboard.js — not
        // reflected on the po:{poNumber} record itself) don't lose their
        // bucket tag when /pos returns null for that field. The /pos endpoint
        // reads po:{poNumber} records directly without running the heal.
        var _localBucketByPo = {};
        if (q && Array.isArray(q.pos)) {
          q.pos.forEach(function (p) { if (p && p.bucket) _localBucketByPo[p.poNumber] = p.bucket; });
        }
        // Map to summary shape (same as lifecycle.pos so the renderer doesn't
        // care which source). downloadedAt is included so the progress tracker
        // can count a vendor as "Ordered" off a PDF download alone.
        var summaries = pos.map(function(p){
          return {
            poNumber: p.poNumber, vendor: p.vendor, status: p.status,
            total: p.total, createdAt: p.createdAt, sentAt: p.sentAt,
            downloadedAt: p.downloadedAt,
            voidedAt: p.voidedAt,
            // Bucket attribution: prefer the PO record's own bucket field,
            // fall back to the locally-healed value for legacy/orphan POs.
            bucket: p.bucket || _localBucketByPo[p.poNumber] || null,
          };
        });
        if (q) q.pos = summaries;
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl && q) { detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q); }
        // Detail-panel HTML rebuild already includes the panel progress bar,
        // but the table-row progress cell isn't part of that HTML — refresh
        // it explicitly so the new "Ordered" step reflects PO state.
        refreshProgressBar(ref);
      } catch (e) { /* non-fatal */ }
    }

    /* ── Freight quote handshake (online Flow B orders) ──
       Three-state row on the Purchasing card per vendor:
         1. No requestedAt → "Request Freight Quote" button
         2. requestedAt set, no cost → cost input + Save
         3. cost saved → display "$X — saved {date}" + Edit
       Generate PO is gated to state 3 so we can't accidentally PO a vendor
       before they've quoted parcel freight. */

    // Freight handshake handlers + ECORE freight quirks live in
    // assets/dashboard-handshake.js (extracted to keep this section file
    // under Shopify's 256 KB limit). window.DashboardHandshake is the API.
    // Wrappers below preserve the original function names so existing
    // click delegations call into the extracted module.
    function handleFreightRequestStub(ref, vendor, bucket) {
      if (window.DashboardHandshake) window.DashboardHandshake.request(ref, vendor, bucket || null);
    }
    function handleFreightCostSave(ref, vendor, btn) {
      if (window.DashboardHandshake) window.DashboardHandshake.saveCost(ref, vendor, btn);
    }
    function handleFreightCostEdit(ref, vendor) {
      if (window.DashboardHandshake) window.DashboardHandshake.editCost(ref, vendor);
    }
    function handleFreightReset(ref, vendor, mode) {
      if (window.DashboardHandshake) window.DashboardHandshake.reset(ref, vendor, mode);
    }
    // CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — send the PO without the supplier's quote.
    function handleFreightSkip(ref, vendor, clear) {
      if (window.DashboardHandshake) window.DashboardHandshake.skip(ref, vendor, !!clear);
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — per-order freight "our own
       carrier" override controls. Switch (freight-in-product → our broker), edit
       our cost, and revert. The cost popover is shared by the Purchasing-card
       switch and the Financials-card ✎ (handleFinancialsFreightEdit). Writes via
       /freight-override-set; on success a full refresh re-reads the override +
       recomputed GP, and the next Generate PO picks up the BSFS-carrier rendering. */
    function openFreightOverridePopover(btn, ref, vendor, opts) {
      opts = opts || {};
      var prior = document.getElementById('rqd-freight-override-popover');
      if (prior) prior.remove();
      var existingCost = (opts.currentCost != null && opts.currentCost !== '') ? String(opts.currentCost) : '';
      var isSwitch = !!opts.isSwitch;
      var pop = document.createElement('div');
      pop.id = 'rqd-freight-override-popover';
      pop.style.cssText = 'position:fixed;z-index:9999;background:var(--rq-bg, #fff);color:var(--rq-text, #000);border:1px solid var(--rq-border, #d1d5db);border-radius:8px;padding:12px 14px;box-shadow:0 6px 20px rgba(0,0,0,0.20);font-family:Montserrat,sans-serif;font-size:12px;display:flex;flex-direction:column;gap:10px;min-width:260px;max-width:330px;';
      var _title = isSwitch ? 'Use our own carrier' : 'Edit our freight cost';
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-12) — the cost is OPTIONAL on the switch.
         Ryan on SHOP-1931 (60 ECORE rubber pavers, shipping collected in full at checkout): he
         needs to tell the supplier "we're carrying this" and get the PO out NOW, and only learns
         what we actually pay when the order is ready and he schedules the pickup with the broker.
         Forcing a number here meant either inventing one or not sending the PO. The worker has
         always accepted a cost-less our-carrier override (po-routes.js handleFreightOverrideSet:
         `hasCost` is optional) and the Purchasing row already renders "our cost not set" — this
         input was the only thing demanding it. Editing an EXISTING cost still requires a number:
         there, a blank box means "clear it", which is what Revert is for. */
      var _hint = isSwitch
        ? 'The PO will read "Blue Sky Fitness Supply using own carrier" and carry no supplier freight line. Leave the cost blank if the pickup isn\'t scheduled yet — add it later with Edit cost. Our cost is tracked in this order\'s financials, never on the supplier PO.'
        : 'What we pay our carrier for this order. Tracked in financials; not on the supplier PO.';
      pop.innerHTML =
        '<div style="font-weight:700;font-size:11px;letter-spacing:0.04em;text-transform:uppercase;color:var(--rq-text-secondary, #6b7280);">' + esc(_title) + ' — ' + esc(vendor) + '</div>' +
        '<div style="font-size:11px;color:var(--rq-text-secondary, #6b7280);line-height:1.4;">' + esc(_hint) + '</div>' +
        '<label style="display:flex;flex-direction:column;gap:4px;">' +
          '<span style="font-size:11px;color:var(--rq-text-secondary, #6b7280);">Our freight cost' + (isSwitch ? ' <span style="text-transform:none;font-style:italic;">(optional — can be added later)</span>' : '') + '</span>' +
          '<div style="display:flex;align-items:center;gap:4px;">' +
            '<span style="font-size:13px;color:var(--rq-text-secondary, #6b7280);">$</span>' +
            '<input type="text" inputmode="decimal" id="rqd-fov-cost" value="' + esc(existingCost) + '" placeholder="0.00" style="flex:1;padding:6px 8px;border:1px solid var(--rq-border, #d1d5db);border-radius:4px;font-family:inherit;font-size:13px;background:var(--rq-bg, #fff);color:var(--rq-text, #000);">' +
          '</div>' +
        '</label>' +
        '<div style="display:flex;gap:6px;justify-content:flex-end;align-items:center;">' +
          '<button type="button" id="rqd-fov-cancel" style="background:transparent;border:1px solid var(--rq-border, #d1d5db);color:var(--rq-text-secondary, #6b7280);border-radius:999px;padding:4px 10px;cursor:pointer;font-family:inherit;font-size:11px;">Cancel</button>' +
          '<button type="button" id="rqd-fov-save" style="background:#2563eb;border:1px solid #2563eb;color:#fff;border-radius:999px;padding:4px 12px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:600;">' + (isSwitch ? 'Switch' : 'Save') + '</button>' +
        '</div>';
      var _mountWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
      _mountWrap.appendChild(pop);
      function repositionPop() {
        var r = btn.getBoundingClientRect();
        var popH = pop.offsetHeight || 200, popW = pop.offsetWidth || 300;
        var top = r.bottom + 6;
        if (top + popH > window.innerHeight - 8) { var above = r.top - popH - 6; top = above >= 8 ? above : Math.max(8, window.innerHeight - popH - 8); }
        if (top < 8) top = 8;
        var left = r.right - popW;
        if (left + popW > window.innerWidth - 8) left = window.innerWidth - popW - 8;
        if (left < 8) left = 8;
        pop.style.top = Math.round(top) + 'px'; pop.style.left = Math.round(left) + 'px';
      }
      repositionPop();
      var costInput = pop.querySelector('#rqd-fov-cost');
      if (costInput) setTimeout(function () { costInput.focus(); costInput.select(); }, 30);
      var _raf = false;
      function onScroll() { if (_raf) return; _raf = true; requestAnimationFrame(function () { _raf = false; repositionPop(); }); }
      function close() { if (pop && pop.parentNode) pop.parentNode.removeChild(pop); document.removeEventListener('mousedown', outside, true); document.removeEventListener('keydown', onKey); window.removeEventListener('scroll', onScroll, true); window.removeEventListener('resize', onScroll); }
      function outside(ev) { if (!pop.contains(ev.target)) close(); }
      function onKey(ev) { if (ev.key === 'Escape') close(); else if (ev.key === 'Enter') { ev.preventDefault(); doSave(); } }
      async function doSave() {
        var raw = (costInput.value || '').trim().replace(/[$,]/g, '');
        var cost = parseFloat(raw);
        /* Blank is allowed ONLY on the switch — it means "we're carrying it, price TBD". Anything
           typed is still validated, so a typo can't sail through as a deferred cost. */
        var deferCost = isSwitch && raw === '';
        if (!deferCost && (raw === '' || isNaN(cost) || cost < 0)) { costInput.focus(); costInput.style.borderColor = '#dc2626'; return; }
        var saveBtn = pop.querySelector('#rqd-fov-save');
        saveBtn.disabled = true; saveBtn.textContent = 'Saving...';
        var payload = { ref: ref, vendor: vendor };
        if (!deferCost) payload.cost = Math.round(cost * 100) / 100;
        if (isSwitch) payload.mode = 'our-carrier';
        try {
          var res = await API.post('/freight-override-set', payload);
          if (res && res.success !== false) {
            close();
            /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM¹⁰) — paint the result NOW.
               Ryan: "then nothing happened for 30 seconds." The popover closed instantly but the
               freight row kept showing the old value, because the only thing driving the re-render
               was a full fetchQuotes() — the heavy /rep-quotes round trip (both source pools +
               Shopify + KV). The write itself had already succeeded in well under a second.

               /freight-override-set returns the authoritative `freightOverrides` map, so there is
               nothing to wait for: apply it locally, mirror the worker's own precedence rule for
               freightCost (Σ our-carrier costs wins — see reassertOurCarrierFreight in
               quote-dashboard.js) so the Financials card agrees with the Purchasing row, and
               re-render just this detail panel. The background refresh still runs to reconcile
               everything derived (GP-of-Order, PO gating); it just stops being the thing standing
               between the click and the feedback. Same optimistic shape the ordering/shipped
               toggles already use (~L3466). */
            applyFreightOverrideLocally(ref, res.freightOverrides);
            fetchQuotes({ quiet: true });
          }
          else { saveBtn.disabled = false; saveBtn.textContent = isSwitch ? 'Switch' : 'Save'; rqdAlert('Failed to save: ' + ((res && res.error) || 'Unknown error')); }
        } catch (err) {
          saveBtn.disabled = false; saveBtn.textContent = isSwitch ? 'Switch' : 'Save'; rqdAlert('Failed to save: ' + (err.message || err));
        }
      }
      pop.querySelector('#rqd-fov-save').addEventListener('click', doSave);
      pop.querySelector('#rqd-fov-cancel').addEventListener('click', close);
      setTimeout(function () { document.addEventListener('mousedown', outside, true); document.addEventListener('keydown', onKey); window.addEventListener('scroll', onScroll, true); window.addEventListener('resize', onScroll); }, 0);
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — correct the supplier's pallet / packaging fee
       on one order.

       What gets edited here is the COUNT, not the rate: the rate is the vendor's and lives in the
       Vendor Guide, where changing it changes every future PO instead of this one order. The count
       is what the automatic derivation gets wrong — it counts every non-upgrade line as a pallet,
       and bars, attachments and anything riding in another crate look identical to equipment from
       here. Ryan's case: a machine plus an Olympic bar auto-counts 2; the truth is 1.

       Saving stamps `auto: false` server-side, which is what makes the correction survive a
       regenerate. "Use automatic count" hands the slot back.

       Built on openFreightOverridePopover's shape on purpose — same mount target (inside
       .rep-quote-portal-wrap, so dark-mode vars resolve), same reposition-on-scroll, same
       optimistic local apply before the background reconcile. */
    function openPalletFeePopover(btn, ref, vendor, opts) {
      opts = opts || {};
      var prior = document.getElementById('rqd-pallet-fee-popover');
      if (prior) prior.remove();
      var existingCount = (opts.currentCount != null && opts.currentCount !== '') ? String(opts.currentCount) : '';
      var pop = document.createElement('div');
      pop.id = 'rqd-pallet-fee-popover';
      pop.style.cssText = 'position:fixed;z-index:9999;background:var(--rq-bg, #fff);color:var(--rq-text, #000);border:1px solid var(--rq-border, #d1d5db);border-radius:8px;padding:12px 14px;box-shadow:0 6px 20px rgba(0,0,0,0.20);font-family:Montserrat,sans-serif;font-size:12px;display:flex;flex-direction:column;gap:10px;min-width:280px;max-width:340px;';
      var _rate = parseFloat(opts.rate) || 0;
      var _rateStr = _rate > 0 ? ('$' + _rate.toFixed(2)) : 'the vendor rate';
      pop.innerHTML =
        '<div style="font-weight:700;font-size:11px;letter-spacing:0.04em;text-transform:uppercase;color:var(--rq-text-secondary, #6b7280);">Pallet / packaging &mdash; ' + esc(vendor) + '</div>' +
        '<div style="font-size:11px;color:var(--rq-text-secondary, #6b7280);line-height:1.4;">How many pieces this supplier is palletizing, at ' + esc(_rateStr) + ' each. Weight-stack upgrades already ride their machine; drop the count for bars, attachments or anything else that doesn&rsquo;t get its own pallet. Re-generate the PO after saving so the supplier sees the corrected line.</div>' +
        '<label style="display:flex;flex-direction:column;gap:4px;">' +
          '<span style="font-size:11px;color:var(--rq-text-secondary, #6b7280);">Pieces on a pallet</span>' +
          '<input type="text" inputmode="numeric" id="rqd-pf-count" value="' + esc(existingCount) + '" placeholder="1" style="padding:6px 8px;border:1px solid var(--rq-border, #d1d5db);border-radius:4px;font-family:inherit;font-size:13px;background:var(--rq-bg, #fff);color:var(--rq-text, #000);">' +
          '<span id="rqd-pf-preview" style="font-size:11px;color:var(--rq-text-secondary, #6b7280);"></span>' +
        '</label>' +
        '<div style="display:flex;gap:6px;justify-content:space-between;align-items:center;">' +
          '<button type="button" id="rqd-pf-auto" style="background:transparent;border:none;color:var(--rq-text-secondary, #6b7280);cursor:pointer;font-family:inherit;font-size:11px;font-style:italic;text-decoration:underline dotted;padding:0;">Use automatic count</button>' +
          '<span style="display:flex;gap:6px;">' +
            '<button type="button" id="rqd-pf-cancel" style="background:transparent;border:1px solid var(--rq-border, #d1d5db);color:var(--rq-text-secondary, #6b7280);border-radius:999px;padding:4px 10px;cursor:pointer;font-family:inherit;font-size:11px;">Cancel</button>' +
            '<button type="button" id="rqd-pf-save" style="background:#2563eb;border:1px solid #2563eb;color:#fff;border-radius:999px;padding:4px 12px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:600;">Save</button>' +
          '</span>' +
        '</div>';
      var _mountWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
      _mountWrap.appendChild(pop);
      function repositionPop() {
        var r = btn.getBoundingClientRect();
        var popH = pop.offsetHeight || 200, popW = pop.offsetWidth || 300;
        var top = r.bottom + 6;
        if (top + popH > window.innerHeight - 8) { var above = r.top - popH - 6; top = above >= 8 ? above : Math.max(8, window.innerHeight - popH - 8); }
        if (top < 8) top = 8;
        var left = r.right - popW;
        if (left + popW > window.innerWidth - 8) left = window.innerWidth - popW - 8;
        if (left < 8) left = 8;
        pop.style.top = Math.round(top) + 'px'; pop.style.left = Math.round(left) + 'px';
      }
      repositionPop();
      var countInput = pop.querySelector('#rqd-pf-count');
      var previewEl = pop.querySelector('#rqd-pf-preview');
      function paintPreview() {
        var n = parseInt((countInput.value || '').trim(), 10);
        if (isNaN(n) || n < 0 || _rate <= 0) { previewEl.textContent = ''; return; }
        previewEl.textContent = n === 0
          ? 'No pallet fee on this order.'
          : (n + ' x $' + _rate.toFixed(2) + ' = $' + (n * _rate).toFixed(2));
      }
      paintPreview();
      countInput.addEventListener('input', paintPreview);
      if (countInput) setTimeout(function () { countInput.focus(); countInput.select(); }, 30);
      var _raf = false;
      function onScroll() { if (_raf) return; _raf = true; requestAnimationFrame(function () { _raf = false; repositionPop(); }); }
      function close() { if (pop && pop.parentNode) pop.parentNode.removeChild(pop); document.removeEventListener('mousedown', outside, true); document.removeEventListener('keydown', onKey); window.removeEventListener('scroll', onScroll, true); window.removeEventListener('resize', onScroll); }
      function outside(ev) { if (!pop.contains(ev.target)) close(); }
      function onKey(ev) { if (ev.key === 'Escape') close(); else if (ev.key === 'Enter') { ev.preventDefault(); doSave(false); } }
      async function doSave(useAuto) {
        var payload = { ref: ref, vendor: vendor };
        if (opts.bucket) payload.bucket = opts.bucket;
        if (useAuto) {
          payload.clear = true;
        } else {
          var raw = (countInput.value || '').trim();
          var n = parseInt(raw, 10);
          /* 0 is a legitimate answer — "everything on this order is exempt" — so it must be
             accepted, not treated as an empty box. */
          if (raw === '' || isNaN(n) || n < 0) { countInput.focus(); countInput.style.borderColor = '#dc2626'; return; }
          payload.count = n;
        }
        var saveBtn = pop.querySelector('#rqd-pf-save');
        var autoBtn = pop.querySelector('#rqd-pf-auto');
        saveBtn.disabled = true; autoBtn.disabled = true;
        saveBtn.textContent = 'Saving...';
        try {
          var res = await API.post('/pallet-fee-set', payload);
          if (res && res.success !== false) {
            close();
            // Paint the new number now; the background refresh reconciles everything derived
            // from it (GP of Order, the Marketing Ops rollup). Same shape as the freight override.
            applyPalletFeeLocally(ref, res.palletFees || {});
            /* When the edit came from inside the PO modal, the PDF in front of the admin still
               carries the OLD count — a corrected number that isn't on the document is worse than
               no correction, because it looks handled. Re-mint it. */
            if (typeof opts.onSaved === 'function') { try { opts.onSaved(); } catch (_) {} }
            fetchQuotes({ quiet: true });
          } else {
            saveBtn.disabled = false; autoBtn.disabled = false; saveBtn.textContent = 'Save';
            rqdAlert('Failed to save: ' + ((res && res.error) || 'Unknown error'));
          }
        } catch (err) {
          saveBtn.disabled = false; autoBtn.disabled = false; saveBtn.textContent = 'Save';
          rqdAlert('Failed to save: ' + (err.message || err));
        }
      }
      pop.querySelector('#rqd-pf-save').addEventListener('click', function () { doSave(false); });
      pop.querySelector('#rqd-pf-auto').addEventListener('click', function () { doSave(true); });
      pop.querySelector('#rqd-pf-cancel').addEventListener('click', close);
      setTimeout(function () { document.addEventListener('mousedown', outside, true); document.addEventListener('keydown', onKey); window.addEventListener('scroll', onScroll, true); window.addEventListener('resize', onScroll); }, 0);
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — apply a pallet-fee result in memory and
       repaint the panel, so the Financials card moves on the click instead of on the round trip.
       financials.palletFee is re-summed from the authoritative map the worker returned rather than
       patched by delta — a cleared slot has to remove its money, and a delta can't express that. */
    function applyPalletFeeLocally(ref, palletFees) {
      var q = (typeof allQuotes !== 'undefined' && allQuotes)
        ? allQuotes.find(function (x) { return x && x.reference === ref; })
        : null;
      if (!q) return;
      q.palletFees = palletFees || {};
      var sum = 0;
      Object.keys(q.palletFees).forEach(function (k) {
        var a = parseFloat(q.palletFees[k] && q.palletFees[k].amount);
        if (!isNaN(a) && a > 0) sum += a;
      });
      q.financials = q.financials || {};
      q.financials.palletFee = Math.round(sum * 100) / 100;
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (detailEl) {
        detailEl.innerHTML = buildDetailHtml(q);
        if (typeof applyCollapseState === 'function') applyCollapseState(detailEl, q);
      }
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM¹⁰) — apply a freight-override result to
       the in-memory quote and repaint its panel, without a server round trip.

       freightCost mirrors the worker's rule deliberately rather than trusting whatever value the
       row happens to hold: an our-carrier override REPLACES the derived freight cost (it is what
       we actually pay), and when the last override is reverted we must NOT keep a stale figure —
       so the field is deleted and the next refresh re-derives it from the real source. */
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08 PM¹¹) — apply a line-cost override in
       memory so the Order Contents card shows the new number immediately.

       Ryan: "I edit the cost of something... it collapses the card and scrolls me to the top, but
       then when I refresh and reopen it, it often is stuck on the old number. takes a good 30+
       seconds and a few refreshes." Three symptoms, one root: the save called a bare
       fetchQuotes(), whose own header (~L5486) spells out what non-quiet mode does — "loader
       flash + table-hide + expandedRef wipe + scroll jump". That IS the collapse and the jump to
       the top. And because the cell was only repainted from the server response, the old value
       stared back until that heavy round trip finished.

       Updates every place a line's cost is read from — the online items, the offline items, and
       __orderContentsCache (the module-level cache that deliberately survives re-renders, and
       which is exactly why a reopen could keep serving the pre-edit number). */
    function applyLineCostLocally(ref, lineItemId, newCost) {
      var q = (typeof allQuotes !== 'undefined' && allQuotes)
        ? allQuotes.find(function (x) { return x && x.reference === ref; })
        : null;
      if (!q || !lineItemId) return;
      var cost = parseFloat(newCost);
      if (isNaN(cost)) return;
      function patch(list) {
        if (!Array.isArray(list)) return;
        list.forEach(function (it) {
          if (it && String(it.lineItemId) === String(lineItemId)) it.effectiveUnitCost = cost;
        });
      }
      patch(q.onlineLineItems);
      patch(q.offlineLineItems);
      if (window.__orderContentsCache) patch(window.__orderContentsCache[ref]);
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (detailEl) {
        detailEl.innerHTML = buildDetailHtml(q);
        if (typeof applyCollapseState === 'function') applyCollapseState(detailEl, q);
      }
    }

    function applyFreightOverrideLocally(ref, freightOverrides) {
      var q = (typeof allQuotes !== 'undefined' && allQuotes)
        ? allQuotes.find(function (x) { return x && x.reference === ref; })
        : null;
      if (!q) return;
      if (freightOverrides && typeof freightOverrides === 'object') q.freightOverrides = freightOverrides;
      /* CUSTOM_FREIGHTOVR_BY_CLAUDE (Ryan 2026-09-01) — ⛔ THE LOCAL FREIGHT-COST MATH IS GONE, NOT
         CORRECTED, AND THAT IS DELIBERATE.

         It was the FOURTH copy of "what does this deal pay for freight" (`Σ our-carrier costs
         wins`), kept here to mirror the worker. All four were wrong the same way — the override is
         per VENDOR, not per deal — and the fix needs the per-vendor RAW supplier costs plus the raw
         base, neither of which this function has: `q.financials.freightCost` arrives already
         resolved, so re-deriving from it would subtract a second time.

         ✅ The worker owns the number. `fetchQuotes({ quiet: true })` fires on the next line and
         lands the authoritative figure within a second, the same way GP-of-Order and the PO gating
         have always reconciled — see the 2026-08-08 note on the caller.

         📌 THE REASON THAT NOTE EXISTS IS UNTOUCHED. Ryan's *"then nothing happened for 30
         seconds"* was about the Purchasing ROW, which repaints instantly below off the
         `freightOverrides` map applied above. Only the derived money figure now waits for the
         refresh, which is where every other derived money figure already waited. A wrong number
         flashing on the Financials card is worse than a right one arriving a beat later. */
      q.financials = q.financials || {};
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (detailEl) {
        detailEl.innerHTML = buildDetailHtml(q);
        if (typeof applyCollapseState === 'function') applyCollapseState(detailEl, q);
      }
    }

    /* CUSTOM_FOVCOSTROW_BY_CLAUDE (Ryan 2026-09-01) — save our-carrier freight cost straight off
       the Purchasing row, no popover. Ryan switches to our carrier long before the rate exists
       (production → weights/dims → broker → rate), so the row sits at "our cost not set" for days
       and the number lands in one keystroke-and-click when it finally arrives.

       ⛔ IT DOES NOT REUSE DashboardHandshake.saveCost. That posts /freight-cost-save, which is the
       SUPPLIER's freight quote (freightQuotes[vendor]); this is what WE pay our broker, and it
       belongs in lifecycle.freightOverrides[vendor].cost — a different number in a different place
       that lands in GP by a different rule. Two rows on one card, two endpoints, deliberately.

       ⚠️ THE INPUT IS FOUND THROUGH THE BUTTON'S OWN WRAPPER, not by a document-wide
       [data-ref][data-vendor] query. The freight-handshake row can be on screen for the same
       vendor, wearing the same `.rqd-freight-cost-input` class — see the note in
       dashboard-po-lens.js on why that row's input keeps `data-vendor` and this one does not.

       Mirrors the popover's own save path exactly on success: /freight-override-set returns the
       authoritative map, so paint it locally and let the background refresh reconcile the derived
       figures, rather than making the click wait on a full /rep-quotes round trip. */
    async function handleFreightOverrideCostSave(btn, ref, vendor) {
      if (!ref || !vendor || !btn) return;
      var wrap = btn.closest('.rqd-freight-cost-wrap');
      var input = wrap && wrap.querySelector('.rqd-freight-override-cost-input');
      if (!input) return;
      var raw = (input.value || '').trim().replace(/[$,]/g, '');
      var cost = parseFloat(raw);
      /* Unlike the SWITCH, a blank here is not "price TBD" — that is already what the row says.
         Clicking save with nothing typed is a mis-click, so it focuses the box rather than writing. */
      if (raw === '' || isNaN(cost) || cost < 0) { input.focus(); return; }
      /* Icon-sized button: disable + pulse rather than a text swap, same as the handshake floppy. */
      btn.disabled = true;
      btn.classList.add('rqd-invoice__link--loading');
      function _unbusy() { btn.disabled = false; btn.classList.remove('rqd-invoice__link--loading'); }
      try {
        var res = await API.post('/freight-override-set', {
          ref: ref, vendor: vendor, mode: 'our-carrier', cost: Math.round(cost * 100) / 100,
        });
        if (res && res.success !== false) {
          applyFreightOverrideLocally(ref, res.freightOverrides);
          fetchQuotes({ quiet: true });
        } else {
          _unbusy();
          rqdAlert('Failed to save: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        _unbusy();
        rqdAlert('Failed to save: ' + (err.message || err));
      }
    }

    /* CUSTOM_THEIRCARRIER_BY_CLAUDE (Ryan 2026-09-06) — "Their carrier" on a brokered row. Records
       mode 'vendor-carrier' on lifecycle.freightOverrides[vendor]: the supplier carries this order
       after all, whatever carrier the Workstation named. Same write path and the same instant
       repaint as the our-carrier switch; the card and the PO generator both honour the record.
       A confirm rather than a popover, because the only input is the decision itself. */
    async function handleFreightOverrideSwitchVendor(ref, vendor) {
      if (!ref || !vendor) return;
      if (!(await rqdConfirm(vendor + ' will carry this order on their own freight instead of our broker. Generate PO will wait for their freight quote, and the PO will carry the supplier\'s freight line rather than the Blue Sky-carrier instructions.', { title: 'Switch ' + vendor + ' freight to their carrier?', confirmLabel: 'Their carrier' }))) return;
      try {
        var res = await API.post('/freight-override-set', { ref: ref, vendor: vendor, mode: 'vendor-carrier' });
        if (res && res.success !== false) {
          applyFreightOverrideLocally(ref, res.freightOverrides);
          fetchQuotes({ quiet: true });
        }
        else rqdAlert('Failed to switch: ' + ((res && res.error) || 'Unknown error'));
      } catch (err) { rqdAlert('Failed to switch: ' + (err.message || err)); }
    }

    async function handleFreightOverrideRevert(ref, vendor, fromMode) {
      /* CUSTOM_THEIRCARRIER_BY_CLAUDE (Ryan 2026-09-06) — the confirm says what the revert RESTORES.
         Off a vendor-carrier record it is the quote's own carrier, and there is no cost of ours
         to remove; the old wording would have promised the wrong thing. */
      var _msg = fromMode === 'vendor-carrier'
        ? 'Freight goes back to what the quote says for ' + vendor + '. This removes the "their carrier" record from this order.'
        : 'Freight goes back to being included in the product cost. This removes our-carrier freight cost from this order.';
      if (!(await rqdConfirm(_msg, { title: 'Revert ' + vendor + ' freight to the vendor default?', confirmLabel: 'Revert to default', danger: true }))) return;
      try {
        var res = await API.post('/freight-override-set', { ref: ref, vendor: vendor, mode: 'default' });
        if (res && res.success !== false) {
          /* Same instant repaint as the switch — a revert that appears to do nothing for half a
             minute reads as a failed click, and invites a second one. */
          applyFreightOverrideLocally(ref, res.freightOverrides);
          fetchQuotes({ quiet: true });
        }
        else rqdAlert('Failed to revert: ' + ((res && res.error) || 'Unknown error'));
      } catch (err) { rqdAlert('Failed to revert: ' + (err.message || err)); }
    }

    // Look up the stored our-carrier override cost for a vendor on a quote
    // (tolerant of vendor-name casing/spacing drift). '' when none.
    function _freightOverrideCostFor(ref, vendor) {
      var _q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!_q || !_q.freightOverrides) return '';
      var ov = _q.freightOverrides[vendor];
      if (ov == null) {
        var vl = String(vendor || '').trim().toLowerCase();
        var k = Object.keys(_q.freightOverrides).find(function (kk) { return String(kk).trim().toLowerCase() === vl; });
        ov = k ? _q.freightOverrides[k] : null;
      }
      return (ov && ov.cost != null) ? ov.cost : '';
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    // ── Freight Balance handlers (Flow A) ──
    // Each handler refreshes only the affected row + strip when the worker
    // confirms; full table re-render is overkill for a single state change
    // and it'd reset any other in-flight rep edits in the detail panel.

    function handleFreightBalanceRequestDims(btn, ref, vendor, bucket) {
      if (!ref || !vendor) return;
      // Open the existing freight email modal in 'dims' mode — same
      // preview/edit/recipients UX as Flow B's freight quote request, just
      // with a "Weight & Dimensions Request" subject + body intro. The
      // worker stamps requestedAt + kind='dims' on send so the strip's 📧
      // step flips and the card row marks done.
      if (window.DashboardHandshake) {
        window.DashboardHandshake.requestDims(ref, vendor, bucket || null);
      } else {
        rqdAlert('Handshake module not loaded yet — refresh the page.');
      }
    }

    function handleFreightBalanceAddPalletRow(btn) {
      var form = btn.closest('.rqd-fb-pallet-form');
      var rowsContainer = form && form.querySelector('.rqd-fb-pallet-rows');
      if (!rowsContainer) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = renderFreightBalancePalletRow({}, false);
      var newRow = tmp.firstElementChild;
      rowsContainer.appendChild(newRow);
      var firstInput = newRow.querySelector('.rqd-fb-pallet-qty');
      if (firstInput) firstInput.focus();
    }

    function handleFreightBalanceRemovePalletRow(btn) {
      var row = btn.closest('.rqd-fb-pallet-row');
      if (row) row.remove();
    }

    function readPalletForm(form) {
      var rowEls = form.querySelectorAll('.rqd-fb-pallet-row');
      var pallets = [];
      var hadValidation = true;
      rowEls.forEach(function (row) {
        var qty = parseInt((row.querySelector('.rqd-fb-pallet-qty') || {}).value, 10);
        var l = parseFloat((row.querySelector('.rqd-fb-pallet-l') || {}).value);
        var w = parseFloat((row.querySelector('.rqd-fb-pallet-w') || {}).value);
        var h = parseFloat((row.querySelector('.rqd-fb-pallet-h') || {}).value);
        var wt = parseFloat((row.querySelector('.rqd-fb-pallet-weight') || {}).value);
        if (!qty || qty < 1) { hadValidation = false; row.classList.add('rqd-fb-pallet-row--invalid'); return; }
        if (isNaN(l) || isNaN(w) || isNaN(h) || isNaN(wt) || l <= 0 || w <= 0 || h <= 0 || wt <= 0) {
          hadValidation = false;
          row.classList.add('rqd-fb-pallet-row--invalid');
          return;
        }
        row.classList.remove('rqd-fb-pallet-row--invalid');
        pallets.push({ qty: qty, length: l, width: w, height: h, weight: wt });
      });
      return { pallets: pallets, valid: hadValidation && pallets.length > 0 };
    }

    async function handleFreightBalanceSavePallets(btn, ref) {
      var form = btn.closest('.rqd-fb-pallet-form');
      if (!form) return;
      var parsed = readPalletForm(form);
      if (!parsed.valid) {
        var firstBad = form.querySelector('.rqd-fb-pallet-row--invalid input');
        if (firstBad) firstBad.focus();
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Per-vendor save.
         Form wrapper carries data-vendor when admin opened the form from a
         vendor row. Send to the worker so dims save to
         lifecycle.ordering[vendor].freightDims. For per-vendor saves use
         in-place re-render so the row + scroll don't reset between vendor
         entries on multi-vendor orders. Legacy global-dims save (no vendor
         attr) keeps the existing fetchQuotes() refresh — preserves the
         online Flow A behavior. */
      var vendor = form.dataset.vendor || '';
      var payload = { quoteRef: ref, pallets: parsed.pallets };
      if (vendor) payload.vendor = vendor;
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Saving...'; markPending(btn);
      try {
        var res = await API.post('/freight-balance/save-dims', payload);
        if (res && res.success !== false) {
          btn.textContent = 'Saved ✓'; markResult(btn, true, 'Saved');
          if (vendor) {
            // In-place patch — splice the freightDims onto local
            // q.ordering[vendor] from the worker's response, then
            // re-render just this row's detail panel.
            setTimeout(function () { applyVendorDimsPatch(ref, vendor, res); }, 400);
          } else {
            /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-25) — the order-level
               (no-vendor) save used to call a bare fetchQuotes(). Ryan: *"it then
               loads me back at the top of the page... it appears as though nothing
               was saved... I then have to do a hard refresh to see any of it."*
               Both symptoms, one root — the same one already fixed for line-cost
               edits (applyLineCostLocally):
                 • non-quiet fetchQuotes wipes expandedRef, hides the table and
                   jumps to the top (see its own header at ~L6332);
                 • it then repaints from the SWR cache, whose entry for this view
                   was written BEFORE the save — so the re-opened card shows the
                   pre-save state until the background revalidate lands.
               The worker already returns the authoritative lc.freightBalance, so
               there is nothing to go back for: splice it in and repaint the panel. */
            applyFreightBalanceDimsLocally(ref, res.freightBalance, parsed.pallets);
          }
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed to save dims: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed to save dims: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed to save dims: ' + (err.message || err));
        rqdAlert('Failed to save dims: ' + (err.message || err));
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — In-place per-vendor
       dims re-render. The worker returns lc.ordering[vendor] (or no field
       if cleared); splice it onto local allQuotes + re-render the detail
       panel only, keeping the row expanded + scroll preserved. Mirrors
       applyOrderingPatch in the Mark Purchased flow. */
    function applyVendorDimsPatch(ref, vendor, res) {
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) { fetchQuotes(); return; }
      q.ordering = q.ordering || {};
      // The worker writes to lc.ordering[vendor].freightDims; res doesn't
      // surface the full lc.ordering[vendor] back, only res.freightBalance
      // (legacy). Easiest: refetch the single quote's lifecycle state.
      // Approximation: stamp the local q.ordering[vendor].freightDims from
      // the form's parsed data (matches what the worker just stored).
      q.ordering[vendor] = q.ordering[vendor] || {};
      var prevForm = document.querySelector('.rqd-fb-pallet-form[data-ref="' + ref + '"][data-vendor="' + vendor + '"]');
      if (prevForm) {
        var parsed = readPalletForm(prevForm);
        if (parsed && parsed.valid) {
          q.ordering[vendor].freightDims = {
            groups: parsed.pallets,
            pallets: parsed.pallets,
            summary: parsed.pallets.map(function (p) {
              return (p.qty || 1) + '× ' + p.length + 'x' + p.width + 'x' + p.height + ' ' + p.weight + 'lbs';
            }).join(', '),
          };
          q.ordering[vendor].freightDimsSavedAt = new Date().toISOString();
          /* CUSTOM_ALTSHIP_BY_CLAUDE - an alternate source's shipment in a shared bucket shows these dims too,
             on every cached copy, held until the server's row carries them. */
          var _newDims = q.ordering[vendor].freightDims;
          var _hasSharedEntry = Array.isArray(q.shippingBuckets) && q.shippingBuckets.some(function (b) {
            return b && Array.isArray(b.suppliers) && b.suppliers.some(function (e) { return e && e.vendor === vendor; });
          });
          if (_hasSharedEntry) {
            stickCardWrite('supplier-dims:' + ref + ':' + vendor, ref, function (x) {
              (x.shippingBuckets || []).forEach(function (b) {
                (b && Array.isArray(b.suppliers) ? b.suppliers : []).forEach(function (e) { if (e && e.vendor === vendor) e.dims = _newDims; });
              });
            }, function (x) {
              return (x.shippingBuckets || []).some(function (b) {
                return b && Array.isArray(b.suppliers) && b.suppliers.some(function (e) {
                  return e && e.vendor === vendor && e.dims && (e.dims.raw || e.dims.summary || (e.dims.pallets && e.dims.pallets.length));
                });
              });
            });
          }
        }
      }
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (detailEl) {
        detailEl.innerHTML = buildDetailHtml(q);
        applyCollapseState(detailEl, q);
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-25) — apply an order-level
       dims save in memory and repaint the panel, no server round trip.

       freightBalance comes straight from the worker's response (it returns the
       whole lc.freightBalance it just wrote), so the summary string, confidence
       and savedAt shown afterwards are the SERVER's — not a client re-derivation
       that could drift from what the parser actually stored. The pallets array is
       only a fallback for an older worker build that answers without the field.

       Repainting the whole detail panel (rather than just this row) is deliberate:
       saving dims also unlocks the Broker-quote row and can flip the card's
       section-title check, and those live in the same panel. */
    function applyFreightBalanceDimsLocally(ref, freightBalance, fallbackPallets) {
      var q = (typeof allQuotes !== 'undefined' && allQuotes)
        ? allQuotes.find(function (x) { return x && x.reference === ref; })
        : null;
      if (!q) { fetchQuotes({ quiet: true }); return; }
      if (freightBalance && typeof freightBalance === 'object') {
        q.freightBalance = freightBalance;
      } else if (Array.isArray(fallbackPallets) && fallbackPallets.length > 0) {
        q.freightBalance = q.freightBalance || {};
        q.freightBalance.dims = {
          groups: fallbackPallets,
          pallets: fallbackPallets,
          confidence: 'high',
          raw: fallbackPallets.map(function (p) {
            return (p.qty || 1) + '× ' + p.length + 'x' + p.width + 'x' + p.height + ' ' + p.weight + 'lbs';
          }).join(', '),
          summary: fallbackPallets.map(function (p) {
            return (p.qty || 1) + '× ' + p.length + 'x' + p.width + 'x' + p.height + ' ' + p.weight + 'lbs';
          }).join(', '),
        };
        q.freightBalance.dimsSavedAt = new Date().toISOString();
      }
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (detailEl) {
        detailEl.innerHTML = buildDetailHtml(q);
        if (typeof applyCollapseState === 'function') applyCollapseState(detailEl, q);
      }
    }
    /* END CUSTOM_DEALDASHBOARD_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Fulfillment-card
       Edit Dims. Replaces the saved-display toggle inside the
       offline-sold Fulfillment card's standalone .rqd-fulfillment-dims-block
       with the pallet entry form, pre-populated. Parallel to
       handleFreightBalanceEditDims but scoped to a single-row block. */
    function handleFulfillmentEditDims(btn, ref) {
      var block = btn.closest('.rqd-fulfillment-dims-block');
      if (!block) return;
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) return;
      var fbDims = (q.freightBalance && q.freightBalance.dims) || null;
      var existing = [];
      if (fbDims && typeof fbDims === 'object') {
        var src = (Array.isArray(fbDims.groups) && fbDims.groups.length > 0)
          ? fbDims.groups
          : (Array.isArray(fbDims.pallets) ? fbDims.pallets : []);
        existing = src.map(function (p) {
          return { qty: p.qty || 1, length: p.length, width: p.width, height: p.height, weight: p.weight };
        });
      }
      block.innerHTML = renderFreightBalancePalletForm(ref, existing);
      var firstInput = block.querySelector('.rqd-fb-pallet-l');
      if (firstInput) firstInput.focus();
    }

    /* CUSTOM_DIMSDISCLOSURE_BY_CLAUDE (Ryan 2026-08-28) — the online bucket row's "Log dims".
       Fills the empty .rqd-bucket-dims-block that renderShippingBucketPanel left beside the row.

       ⛔ NO VENDOR ARGUMENT. renderFreightBalancePalletForm routes its save by whether a vendor was
       passed: with one it writes lifecycle.ordering[vendor].freightDims, without it the order-level
       freightBalance.dims. This surface is order-level — the Fulfillment card reads the dims back
       from freightBalance.dims — so passing a vendor here would save the numbers somewhere this
       card never looks, and the row would sit unchecked after a successful save.

       Pre-populates from any existing order-level dims for the same reason handleFulfillmentEditDims
       does: reopening the form on a deal that already has dims must show them, not a blank grid. */
    function handleBucketDimsOpen(btn, ref) {
      /* CUSTOM_ALTSHIP_BY_CLAUDE - an alternate source's block carries data-supplier: its dims are its own
         (the form takes the vendor, so the save lands on lifecycle.ordering[name], never the brand's). */
      var supplier = (btn && btn.dataset && btn.dataset.supplier) || '';
      var block = btn.closest('.rqd-toggle');
      block = block && block.nextElementSibling;
      if (!block || !block.classList.contains('rqd-bucket-dims-block')) {
        block = document.querySelector('.rqd-bucket-dims-block[data-ref="' + ref + '"]'
          + (supplier ? '[data-supplier="' + supplier.replace(/"/g, '\\"') + '"]' : ':not([data-supplier])'));
      }
      if (!block) return;
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      var _spEntry = supplier ? bucketSupplierEntry(q, btn.dataset.bucket || '', supplier) : null;
      var fbDims = supplier ? ((_spEntry && _spEntry.dims) || null) : ((q && q.freightBalance && q.freightBalance.dims) || null);
      var existing = [];
      if (fbDims && typeof fbDims === 'object') {
        var src = (Array.isArray(fbDims.groups) && fbDims.groups.length > 0)
          ? fbDims.groups
          : (Array.isArray(fbDims.pallets) ? fbDims.pallets : []);
        existing = src.map(function (p) {
          return { qty: p.qty || 1, length: p.length, width: p.width, height: p.height, weight: p.weight };
        });
      }
      block.innerHTML = supplier ? renderFreightBalancePalletForm(ref, existing, supplier) : renderFreightBalancePalletForm(ref, existing);
      var firstInput = block.querySelector('.rqd-fb-pallet-l');
      if (firstInput) firstInput.focus();
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Per-vendor dims open
       handler. Swaps the .rqd-vendor-dims-block contents inline for the
       pallet entry form (with vendor context). Re-uses
       renderFreightBalancePalletForm with the third `vendor` param so the
       form wrapper carries data-vendor and the save handler routes
       per-vendor. existing=null → empty form for first capture; non-null
       → pre-populated for Edit. */
    function handleVendorDimsOpen(btn, ref, vendor, existing) {
      /* Trigger link lives in the vendor row; the expansion target is
         the sibling .rqd-vendor-dims-block container appended at the end
         of the same .rqd-vendor-item. Lookup by ref+vendor in case the
         click came from anywhere within the row. */
      var block = document.querySelector('.rqd-vendor-dims-block[data-ref="' + ref + '"][data-vendor="' + vendor.replace(/"/g, '\\"') + '"]');
      if (!block) return;
      var existingArr = [];
      if (existing && typeof existing === 'object') {
        var src = (Array.isArray(existing.groups) && existing.groups.length > 0)
          ? existing.groups
          : (Array.isArray(existing.pallets) ? existing.pallets : []);
        existingArr = src.map(function (p) {
          return { qty: p.qty || 1, length: p.length, width: p.width, height: p.height, weight: p.weight };
        });
      }
      block.innerHTML = renderFreightBalancePalletForm(ref, existingArr, vendor);
      var firstInput = block.querySelector('.rqd-fb-pallet-l');
      if (firstInput) firstInput.focus();
    }

    /* Per-vendor dims remove handler. Posts clear:true → worker strips
       lifecycle.ordering[vendor].freightDims, then in-place re-renders
       the detail panel so the row goes back to "+ Log dims" disclosure. */
    async function handleVendorDimsRemove(btn, ref, vendor) {
      if (!(await rqdConfirm('The row goes back to "+ Log dims" and the saved weight and dimensions are cleared.', { title: 'Remove the freight dims record for ' + vendor + '?', confirmLabel: 'Remove', danger: true }))) return;
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Removing…'; markPending(btn);
      try {
        await API.post('/freight-balance/save-dims', { quoteRef: ref, vendor: vendor, clear: true });
        // Patch local state + re-render in place.
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        if (q) {
          q.ordering = q.ordering || {};
          if (q.ordering[vendor]) {
            delete q.ordering[vendor].freightDims;
            delete q.ordering[vendor].freightDimsSavedAt;
            delete q.ordering[vendor].freightDimsSavedBy;
          }
          var detailEl = document.getElementById('rqd-detail-' + ref);
          if (detailEl) {
            detailEl.innerHTML = buildDetailHtml(q);
            applyCollapseState(detailEl, q);
          }
        } else {
          fetchQuotes();
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Could not remove dims: ' + (err && err.message ? err.message : 'Unknown error'));
        rqdAlert('Could not remove dims: ' + (err && err.message ? err.message : 'Unknown error'));
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    function handleFreightBalanceEditDims(btn, ref) {
      // Swap the saved-dims display row inline for the multi-row pallet
      // entry form, pre-populated with the existing pallet data.
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) return;
      var fbDims = (q.freightBalance && q.freightBalance.dims) || null;
      var existing = [];
      if (fbDims && typeof fbDims === 'object') {
        // Prefer groups (one form row per spec'd pallet group) over the
        // expanded pallets[] array (one entry per individual pallet) so
        // the form re-opens in the same row layout the admin entered.
        var src = (Array.isArray(fbDims.groups) && fbDims.groups.length > 0)
          ? fbDims.groups
          : (Array.isArray(fbDims.pallets) ? fbDims.pallets : []);
        existing = src.map(function (p) {
          return {
            qty: p.qty || 1,
            length: p.length,
            width: p.width,
            height: p.height,
            weight: p.weight,
          };
        });
      }
      var card = btn.closest('.rqd-fb');
      if (!card) return;
      // The form now wraps its own toggle row inline. Replace the saved-
      // dims toggle (row 2) with the form so the editing state sits in
      // exactly the same spot — no hide-and-stack-below dance needed.
      var dimsToggle = card.querySelectorAll('.rqd-toggle')[1]; // row 2
      var oldForm = card.querySelector('.rqd-fb-pallet-form');
      if (oldForm) oldForm.remove();
      var formHtml = renderFreightBalancePalletForm(ref, existing);
      var tmp = document.createElement('div');
      tmp.innerHTML = formHtml;
      var formEl = tmp.firstElementChild;
      if (dimsToggle && dimsToggle.parentNode) {
        dimsToggle.parentNode.replaceChild(formEl, dimsToggle);
      }
      var firstInput = formEl.querySelector('.rqd-fb-pallet-l');
      if (firstInput) firstInput.focus();
    }

    async function handleFreightBalanceGenerate(btn, ref) {
      var card = btn.closest('.rqd-fb');
      var costInput = card && card.querySelector('.rqd-fb-cost-input[data-ref="' + ref + '"]');
      // CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — Pass-through pricing (charge == cost,
      // markup baked in by the rep). Bucket mode has NO dedicated charge input —
      // pull the freight cost already entered on the broker bucket above. Legacy
      // Flow A + the edit-cost flow still carry a .rqd-fb-cost-input.
      var freightCharge;
      if (costInput) {
        freightCharge = parseFloat(costInput.value);
        if (isNaN(freightCharge) || freightCharge <= 0) { costInput.focus(); return; }
      } else {
        var _fbQ = (typeof allQuotes !== 'undefined') ? allQuotes.find(function (x) { return x.reference === ref; }) : null;
        var _fbBucket = _fbQ && (_fbQ.shippingBuckets || []).find(function (b) { return b && b.type === 'broker'; });
        freightCharge = _fbBucket ? parseFloat(_fbBucket.freightCost) : NaN;
        /* CUSTOM_ALTSHIP_BY_CLAUDE (Ryan 2026-10-09) - a broker bucket shared with an alternate source charges the
           customer ONCE for both shipments: the brand's cost plus every alternate's. */
        if (_fbBucket && Array.isArray(_fbBucket.suppliers)) {
          freightCharge = Math.round(((parseFloat(_fbBucket.freightCost) || 0) + _fbBucket.suppliers.reduce(function (t, e) {
            return t + (e && !e.isBrand ? (parseFloat(e.freightCost) || 0) : 0);
          }, 0)) * 100) / 100;
        }
        if ((isNaN(freightCharge) || freightCharge <= 0) && card) {
          var _fbBucketInp = card.querySelector('.rqd-fb__bucket-cost-input');
          if (_fbBucketInp) freightCharge = parseFloat((_fbBucketInp.value || '').replace(/[$,\s]/g, ''));
        }
        if (isNaN(freightCharge) || freightCharge <= 0) { rqdAlert('Enter the freight cost above first, then click Invoice + Email.'); return; }
      }
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Generating...'; markPending(btn);
      try {
        var res = await API.post('/freight-balance/generate', {
          quoteRef: ref,
          brokerCost: freightCharge,
          markupPercent: 0,
          customerCharge: freightCharge,
        });
        if (res && res.success !== false) {
          btn.textContent = orig; btn.disabled = false;
          // Open the email preview/edit/send modal
          openFreightBalanceEmailModal({
            quoteRef: ref,
            customerEmail: res.customerEmail,
            subject: res.emailSubject,
            html: res.emailHtml,
            bodyProse: res.emailBodyProse,
            draftOrderName: res.draftOrderName,
            invoiceUrl: res.invoiceUrl,
            brokerCost: res.brokerCost,
            claudeUsed: res.claudeUsed,
          });
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed to generate freight invoice: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed to generate freight invoice: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed to generate freight invoice: ' + (err.message || err));
        rqdAlert('Failed to generate freight invoice: ' + (err.message || err));
      }
    }

    function handleFreightBalanceEditCost(btn, ref) {
      // Swap the saved-row content back to the cost/markup/charge input
      // cluster, pre-populated with current values. Save calls
      // /update-cost (not /generate) so we don't mint a duplicate
      // FREIGHT draft.
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) return;
      var fb = (q.freightBalance || {});
      var card = btn.closest('.rqd-fb');
      if (!card) return;
      // Find the toggle row containing this button (row 3 — Broker quote)
      var row = btn.closest('.rqd-toggle');
      if (!row) return;
      // CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — Pass-through pricing: single
      // freight-charge field, prefilled with the current charge.
      var charge = (fb.customerCharge != null ? fb.customerCharge : fb.brokerCost) || '';
      // Replace the right-side .rqd-invoice cluster in this row with the
      // editable input. Keep the row's check + label intact.
      var existingActions = row.querySelector('.rqd-invoice');
      var existingDate = row.querySelector('.rqd-toggle__date');
      if (existingDate) existingDate.remove();
      if (!existingActions) return;
      existingActions.outerHTML =
        '<div class="rqd-invoice">' +
          '<div class="rqd-fb-cost-input-inner" title="Freight charge — the amount the customer pays (markup already included)">' +
            '<span class="rqd-fb-cost-prefix">$</span>' +
            '<input type="number" step="0.01" min="0" class="rqd-fb-cost-input" data-ref="' + esc(ref) + '" value="' + esc(charge) + '">' +
          '</div>' +
          '<button class="rqd-invoice__link rqd-fb-btn--primary" data-fb-action="save-edited-cost" data-ref="' + esc(ref) + '">Save</button>' +
        '</div>';
      var firstInput = row.querySelector('.rqd-fb-cost-input');
      if (firstInput) { firstInput.focus(); firstInput.select(); }
    }

    async function handleFreightBalanceSaveEditedCost(btn, ref) {
      var card = btn.closest('.rqd-fb');
      var costInput = card && card.querySelector('.rqd-fb-cost-input[data-ref="' + ref + '"]');
      if (!costInput) return;
      // CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — Pass-through pricing: the single
      // field is the amount charged; no markup math.
      var freightCharge = parseFloat(costInput.value);
      if (isNaN(freightCharge) || freightCharge <= 0) { costInput.focus(); return; }
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Saving...'; markPending(btn);
      try {
        var res = await API.post('/freight-balance/update-cost', {
          quoteRef: ref,
          brokerCost: freightCharge,
          markupPercent: 0,
          customerCharge: freightCharge,
        });
        if (res && res.success !== false) {
          btn.textContent = 'Saved ✓'; markResult(btn, true, 'Saved');
          setTimeout(function () { fetchQuotes(); }, 600);
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed to update cost: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed to update cost: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed to update cost: ' + (err.message || err));
        rqdAlert('Failed to update cost: ' + (err.message || err));
      }
    }

    async function handleFreightBalanceSendEmailRecovery(btn, ref) {
      // Re-open the preview modal using the EXISTING FREIGHT-{ref} draft
      // order. Calls /freight-balance/draft-email which re-generates the
      // email body via Claude (or templated fallback) without minting a
      // new draft order. Used when admin cancelled the original modal.
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Loading...'; markPending(btn);
      try {
        var res = await API.post('/freight-balance/draft-email', { quoteRef: ref });
        if (res && res.success !== false) {
          btn.textContent = orig; btn.disabled = false;
          openFreightBalanceEmailModal({
            quoteRef: ref,
            customerEmail: res.customerEmail,
            subject: res.emailSubject,
            html: res.emailHtml,
            bodyProse: res.emailBodyProse,
            draftOrderName: res.draftOrderName,
            invoiceUrl: res.invoiceUrl,
            brokerCost: res.brokerCost,
            claudeUsed: res.claudeUsed,
          });
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed to re-open email preview: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed to re-open email preview: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed to re-open email preview: ' + (err.message || err));
        rqdAlert('Failed to re-open email preview: ' + (err.message || err));
      }
    }

    async function handleFreightBalanceMarkPaid(btn, ref) {
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — in-DOM confirm; see the note on the
         invoice-void conversion for why the await was verified rather than assumed. */
      if (!(await rqdConfirm(
        'Use this only if the orders/paid webhook has not auto-flipped it. The action is logged.',
        { title: 'Mark the freight balance as paid?', confirmLabel: 'Mark paid', danger: true }
      ))) return;
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Marking...'; markPending(btn);
      try {
        var res = await API.post('/freight-balance/mark-paid', { quoteRef: ref });
        if (res && res.success !== false) {
          btn.textContent = 'Marked ✓'; markResult(btn, true, 'Freight balance marked paid');
          setTimeout(function() { fetchQuotes(); }, 600);
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed to mark paid: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed to mark paid: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed to mark paid: ' + (err.message || err));
        rqdAlert('Failed to mark paid: ' + (err.message || err));
      }
    }

    // Mark the Flow A freight balance as handled outside the in-app
    // invoice flow (e.g. customer paid via a manually-linked balance
    // child order). Unlocks the Generate PO gate without requiring the
    // Invoice + Email step + a balanceCollected.paid flip.
    /* CUSTOM_BALANCEBTN_BY_CLAUDE (Ryan 2026-08-28) — one place that flips the local bypass state
       and repaints the open panel, shared by set and clear so the two can never disagree about what
       the card should look like afterwards. `ext` null = cleared. */
    function _patchBypassLocal(ref, ext) {
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) { fetchQuotes(); return; }
      /* CUSTOM_CARDWRITESTICK_BY_CLAUDE - every cached copy, and held over a stale refetch until the server agrees. */
      stickCardWrite('fb-bypass:' + ref, ref, function (x) {
        if (!x.freightBalance) x.freightBalance = {};
        if (ext) x.freightBalance.handledExternally = ext;
        else delete x.freightBalance.handledExternally;
      }, function (x) {
        var has = !!(x && x.freightBalance && x.freightBalance.handledExternally);
        return ext ? has : !has;
      });
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (detailEl && window.DashboardHandshake && window.DashboardHandshake.rerenderDetail) {
        window.DashboardHandshake.rerenderDetail(detailEl, q);
      } else if (detailEl) {
        detailEl.innerHTML = buildDetailHtml(q);
        applyCollapseState(detailEl, q);
      }
      try { refreshProgressBar(ref); } catch (_) {}
    }

    /* CUSTOM_ONLINEWILLCALL_BY_CLAUDE (ONYX 39db36f688e9 + 96dc64a31604, Ryan 2026-10-26, SHOP-1923) - the customer
       collects the whole online order. POST /deal-will-call is the same route the Order Desk agent uses; the board
       re-reads quietly so the card stays open. A booked truck comes back as a warning: nothing is cancelled. */
    async function handleWillCallSet(btn, ref) {
      var note = await rqdPrompt(
        'Where does the customer pick up, who collects it, and when (if known)? This stops freight and dims asks, the tracking and shipped emails and the pickup-PRO chase for this order, and the customer\'s updates say "ready for pickup". A truck already booked is NOT cancelled.',
        '',
        { title: 'Will-call: the customer picks up ' + ref, placeholder: 'e.g. Kyle collects at Legend, Knoxville; disassembled; ready 11/13', confirmLabel: 'Next',
          validate: function (v) { return String(v || '').trim().length < 8 ? 'Say where and who picks it up (a few words).' : ''; } }
      );
      if (note === null) return;
      var date = await rqdPrompt('Pickup date, if you know it. Leave it blank if not.', '',
        { title: 'Pickup date', placeholder: 'YYYY-MM-DD', confirmLabel: 'Set will-call',
          validate: function (v) { v = String(v || '').trim(); return (v && !/^\d{4}-\d{2}-\d{2}$/.test(v)) ? 'Use YYYY-MM-DD, or leave it blank.' : ''; } });
      if (date === null) return;
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Saving...'; markPending(btn);
      try {
        var body = { ref: ref, note: String(note).trim() };
        if (String(date || '').trim()) body.pickupAt = String(date).trim();
        var res = await API.post('/deal-will-call', body);
        if (res && res.success) {
          markResult(btn, true, 'Will-call set');
          if (res.warnings && res.warnings.length) await rqdAlert(res.warnings.join('\n'), { title: 'Will-call is set, but a truck is booked' });
          fetchQuotes({ quiet: true });
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed: ' + (err.message || err));
        rqdAlert('Failed: ' + (err.message || err));
      }
    }
    async function handleWillCallUndo(btn, ref) {
      var go = await rqdConfirm('Take will-call off ' + ref + '? The order ships again: freight and dims asks, the tracking and shipped emails come back on, and each shipping group goes back to the request it had before.',
        { title: 'Undo will-call', confirmLabel: 'Undo will-call' });
      if (!go) return;
      btn.disabled = true; markPending(btn);
      try {
        var res = await API.post('/deal-will-call', { ref: ref, undo: true });
        if (res && res.success) { markResult(btn, true, 'Will-call taken off'); fetchQuotes({ quiet: true }); }
        else { btn.disabled = false; markResult(btn, false, 'Failed: ' + ((res && res.error) || 'Unknown error')); rqdAlert('Failed: ' + ((res && res.error) || 'Unknown error')); }
      } catch (err) {
        btn.disabled = false; markResult(btn, false, 'Failed: ' + (err.message || err)); rqdAlert('Failed: ' + (err.message || err));
      }
    }
    /* Ryan's pick (2026-10-26): Refund freight OPENS the Adjust Order card filled in (freight cost $0, markup 0), so the
       refund, its release and the customer email are the card's own, exactly as any other Adjust refund. */
    function handleWillCallRefund(btn, ref) {
      var _q = allQuotes.find(function (x) { return x && x.reference === ref; });
      if (window.RQD && window.RQD.adjustOrder && window.RQD.adjustOrder.open) {
        window.RQD.adjustOrder.open(ref, _q, null, { prefill: { freightCost: 0, orderName: ref } });
      } else {
        rqdAlert('The Adjust Order card did not load. Reload the page and try again.');
      }
    }

    async function handleFreightBalanceBypassSet(btn, ref) {
      var note = await rqdPrompt(
        'Optional note for the audit log (e.g. "Customer paid freight at checkout — we ship own carrier, covering the cost" or "Balance paid via SHOP-1683").',
        '',
        { title: 'Mark the freight balance handled outside the invoice flow', placeholder: 'Note (optional)', confirmLabel: 'Record the bypass' }
      );
      if (note === null) return; // cancelled
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Saving...'; markPending(btn);
      try {
        var res = await API.post('/admin/freight-balance-bypass', { ref: ref, note: note || '' });
        if (res && res.success) {
          btn.textContent = 'Saved ✓'; markResult(btn, true, 'Freight balance bypass recorded');
          /* CUSTOM_BALANCEBTN_BY_CLAUDE (Ryan 2026-08-28) — patch local state and re-render THIS
             panel rather than reloading the board. fetchQuotes() collapsed the deal and dropped the
             admin at the top of the page, which Ryan flagged on this button and on the dims Cancel
             in the same breath. rerenderDetail restores scroll + collapse state. */
          _patchBypassLocal(ref, { at: new Date().toISOString(), by: (res && res.by) || 'you' });
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed: ' + (err.message || err));
        rqdAlert('Failed: ' + (err.message || err));
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-16) — Mark Weight/dims received as
       N/A. For outlier shipments the supplier sent on their own carrier, so no
       weight/dims will ever come back. Satisfies the dims gate so the order can
       close out (Freight Balanced step completes, order leaves To Do). Stored on
       freightBalance.dims = { na:true, ... } and fully reversible via Undo. */
    async function handleFreightBalanceDimsNa(btn, ref) {
      var reason = await rqdPrompt(
        'Use this when the supplier shipped on their own carrier and no dims will be received. The order will be able to close out.\n\nOptional note (why):',
        '',
        { title: 'Mark weight/dims as N/A for this order?', placeholder: 'Reason (optional)', confirmLabel: 'Mark N/A' }
      );
      if (reason === null) return; // cancelled
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Saving...'; markPending(btn);
      try {
        var res = await API.post('/freight-balance/save-dims', { quoteRef: ref, na: true, reason: reason || '' });
        if (res && res.success) {
          btn.textContent = 'Saved ✓'; markResult(btn, true, 'Saved');
          // Quiet re-render: preserve scroll + keep the deal expanded so saving
          // N/A (which can complete the order) doesn't collapse it + fling the
          // rep to the bottom of the page.
          setTimeout(function () { fetchQuotes({ quiet: true }); }, 400);
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed: ' + (err.message || err));
        rqdAlert('Failed: ' + (err.message || err));
      }
    }

    async function handleFreightBalanceDimsNaClear(btn, ref) {
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Reopening...'; markPending(btn);
      try {
        var res = await API.post('/freight-balance/save-dims', { quoteRef: ref, clear: true });
        if (res && res.success) {
          setTimeout(function () { fetchQuotes({ quiet: true }); }, 300);
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed: ' + (err.message || err));
        rqdAlert('Failed: ' + (err.message || err));
      }
    }

    async function handleFreightBalanceBypassClear(btn, ref) {
      if (!(await rqdConfirm(
        'The Flow A Generate PO gate will re-engage until the invoice flow completes '
          + '(Invoice + Email + customer pays).',
        { title: 'Clear the external-balance override?', confirmLabel: 'Clear override' }
      ))) return;
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Clearing...'; markPending(btn);
      try {
        var res = await API.post('/admin/freight-balance-bypass', { ref: ref, clear: true });
        if (res && res.success) {
          btn.textContent = 'Cleared ✓'; markResult(btn, true, 'Cleared');
          // CUSTOM_BALANCEBTN_BY_CLAUDE (Ryan 2026-08-28) — in place, same reasoning as the set path.
          _patchBypassLocal(ref, null);
        } else {
          btn.disabled = false; btn.textContent = orig;
          markResult(btn, false, 'Failed: ' + ((res && res.error) || 'Unknown error'));
          rqdAlert('Failed: ' + ((res && res.error) || 'Unknown error'));
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = orig;
        markResult(btn, false, 'Failed: ' + (err.message || err));
        rqdAlert('Failed: ' + (err.message || err));
      }
    }

    // Freight Balance email preview/edit/send modal — opened after
    // /freight-balance/generate or /freight-balance/draft-email returns.
    // Mirrors the supplier freight-modal UX: TO/CC/BCC inputs, subject,
    // contenteditable body, plus a "Send to me (test)" button so admins
    // can verify the payment-link button works before firing the real
    // customer email. Append-target is .rep-quote-portal-wrap so the
    // dashboard's scoped CSS vars resolve correctly.
    // CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — autocomplete source for every Abby
    // send-modal email field: standing inboxes + every portal user's email
    // (collected on boot from /rep-list). Shared with the handshake modals via
    // window.RQD.abbyEmailDatalist().
    var abbyEmailList = ['ryan@blueskyfitsupply.com', 'orders@blueskyfitsupply.com', 'info@blueskyfitsupply.com'];
    function abbyEmailDatalistHtml() {
      var seen = {};
      var opts = abbyEmailList.filter(function (e) {
        var k = String(e || '').trim().toLowerCase();
        if (!k || k.indexOf('@') === -1 || seen[k]) return false;
        seen[k] = 1; return true;
      }).map(function (e) { return '<option value="' + esc(String(e).trim()) + '"></option>'; }).join('');
      return '<datalist id="rqd-abby-emails">' + opts + '</datalist>';
    }
    window.RQD = window.RQD || {};
    window.RQD.abbyEmailDatalist = abbyEmailDatalistHtml;
    /* CUSTOM_LINESWAP_BY_CLAUDE (Ryan 2026-09-15) — REPAINT THIS DEAL FROM THE SERVER, NOW.

       An Adjust Order commit changed the order and then refreshed only the on-card
       adjustment log, so ORDER CONTENTS kept showing the pre-commit lines. Ryan: *"it did
       take FOREVER for the ORDER CONTENTS to update (like 2 mins and a hard refresh)."*
       Two things stacked to make it exactly that long:
         — nothing re-fetched, so the view waited for the 2-minute poll; and
         — by the time that poll ran, the 30-second `rqd_mutated_at` window had expired, so
           it was served from the 180s server cache — the stale bytes again, hence the reload.

       ⛔ QUIET + FORCE, and both halves matter. `force` is what sends `__nc=1` and gets past
       the server cache; `quiet` is what preserves `expandedRef` so `restoreExpandedRow`
       re-opens the deal the person is standing in. A plain refresh would collapse the detail
       out from under them, which is a worse bug than the one being fixed.

       ⚠ It refetches the BOARD, not one row. That is deliberate: the row is assembled
       server-side from several records and a per-row patch here would be a second, partial
       copy of that assembly — the drift `quoteByRef` above exists to avoid. */
    window.RQD.refreshDealNow = function () {
      try { return Promise.resolve(fetchQuotes({ quiet: true, force: true })); }
      catch (e) { return Promise.resolve(); }
    };
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — the row in memory, by ref, for a sibling
       module that just changed it on the server (the sample picker after Adjust, the Project row
       after a save). Without this every out-of-file save was DOM-only, and the next detail
       re-render quietly rebuilt the card from a row that had not been told. Returns the live
       object, so a caller's assignment is what the next render sees. */
    window.RQD.quoteByRef = function (ref) {
      var r = String(ref || '');
      for (var i = 0; i < allQuotes.length; i++) if (allQuotes[i] && allQuotes[i].reference === r) return allQuotes[i];
      return null;
    };
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-06) — THE SAMPLES CASCADE, IN MEMORY. The worker
       paints an origin revision's sample fields onto every sibling that has none of its own
       (`samplesOriginRef`) at READ time. Between a save and the next refetch that copy is stale,
       and since today an inheriting card's controls write to the ORIGIN — so the row on screen
       (-B) would keep showing the pre-save state while -A's row held the truth. This is the same
       cascade, applied to `allQuotes` after a save. ⚠️ Only ever writes the six cascaded fields,
       and only onto rows that name this origin; a revision with samples of its own is never one
       of those, because the worker never sets `samplesOriginRef` on it. */
    window.RQD.mirrorSampleFields = function (originRef) {
      var o = window.RQD.quoteByRef(originRef);
      if (!o) return;
      var list = (window.RQD && typeof RQD.samplesListFor === 'function') ? RQD.samplesListFor(o)
        : (Array.isArray(o.leadSamples) && o.leadSamples.length ? o.leadSamples : (o.quoteSamples || []));
      var req = o.quoteSampleRequest || o.sampleRequest || null;
      var trk = (o.quoteSampleTracking && o.quoteSampleTracking.number) ? o.quoteSampleTracking
        : ((o.sampleTracking && o.sampleTracking.number) ? o.sampleTracking : null);
      allQuotes.forEach(function (x) {
        if (!x || x.samplesOriginRef !== originRef) return;
        x.quoteSamples = (list || []).slice();
        x.quoteSampleItems = (o.quoteSampleItems || o.leadSampleItems || []).slice();
        x.quoteSampleRequest = req;
        if (trk) x.quoteSampleTracking = trk;
        if (o.sampleNotifiedAt) x.sampleNotifiedAt = o.sampleNotifiedAt;
        if (Object.prototype.hasOwnProperty.call(o, 'sampleProject')) x.sampleProject = o.sampleProject;
        if (Object.prototype.hasOwnProperty.call(o, 'sampleShipTo')) x.sampleShipTo = o.sampleShipTo;
        if (Object.prototype.hasOwnProperty.call(o, 'sampleSecondary')) x.sampleSecondary = o.sampleSecondary; // CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient rides the cascade
        if (Object.prototype.hasOwnProperty.call(o, 'samplePriorityOvernight')) x.samplePriorityOvernight = o.samplePriorityOvernight; // CUSTOM_SAMPLEOVERNIGHT_BY_CLAUDE (Ryan 2026-10-03)
        /* CUSTOM_SAMPLES2ND_BY_CLAUDE — a FOLDED lead row renders the lead-side card, so the lead-side
           names travel too, with the second-box view (tags, boxes, counts) under both name sets. */
        if (x.samplesFoldedTo === originRef) {
          x.leadSamples = (list || []).slice();
          x.sampleRequest = req;
          if (trk) x.sampleTracking = trk;
        }
        ['ItemTags', 'Shipments', 'RequestCount', 'NewCount'].forEach(function (k) {
          var lk = 'sample' + k; var qk = 'quoteSample' + k;
          var v = Object.prototype.hasOwnProperty.call(o, qk) ? o[qk] : (Object.prototype.hasOwnProperty.call(o, lk) ? o[lk] : undefined);
          if (v === undefined) return;
          var copy = Array.isArray(v) ? v.slice() : v;
          if (Object.prototype.hasOwnProperty.call(x, qk) || !x.isLead) x[qk] = copy;
          if (x.samplesFoldedTo === originRef || Object.prototype.hasOwnProperty.call(x, lk)) x[lk] = copy;
        });
      });
    };

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-09, Phase 3) — the freight-balance
       email now uses the SHARED compose modal (Quill: blank-line preservation,
       plain-paste, Send Test) via a send adapter that posts to
       /freight-balance/send-email (quillBody:true) instead of /outlook-send. Abby's
       signature is appended server-side, so we load the PROSE only + show a note.
       Replaces the old bespoke contentEditable composer. */
    function openFreightBalanceEmailModal(opts) {
      opts = opts || {};
      if (!(window.RQD && window.RQD.openComposeModal)) {
        rqdAlert('Email composer unavailable — reload the page and try again.');
        return;
      }
      function getRepSessionEmail() {
        try {
          var raw = sessionStorage.getItem('rep_portal_session');
          return raw ? ((JSON.parse(raw) || {}).email || '').trim() : '';
        } catch (_) { return ''; }
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-17) — render Abby's ACTUAL signature in the
         preview (parity with the vendor-PO pop-up), not just an "added on send" note. Pull it
         from /rep-settings (the same source the From-identity selector uses), then open; fall
         back to the note if it can't load. The signature is still appended server-side on send. */
      function _open(abbySig) {
      window.RQD.openComposeModal({
        ref: opts.quoteRef,
        prefillTo: opts.customerEmail || '',
        prefillSubject: opts.subject || '',
        prefillBody: opts.bodyProse || opts.html || '',
        signatureHtml: abbySig || undefined,
        signatureNote: abbySig ? undefined : "Sends as Abby (orders@blueskyfitsupply.com) — her signature is added automatically on send.",
        fromOptions: ['ABBY'],   // Abby-only email → locked From box (same pop-up, single sender)
        fetchQuotes: fetchQuotes,
        sendOverride: function (args) {
          // args: { to[], cc[], bcc[], subject, bodyHtml, attachments, isTest }
          var payload = {
            quoteRef: opts.quoteRef,
            subject: args.subject,
            html: args.bodyHtml,
            quillBody: true,
            cc: (args.cc || []).join(','),
            bcc: (args.bcc || []).join(','),
          };
          if (args.isTest) {
            payload.testRecipient = getRepSessionEmail() || (args.to || [])[0] || '';
            if (!payload.testRecipient) { return Promise.reject(new Error('No address for the test — re-login so your session email is set, or type a To.')); }
          } else {
            payload.customerEmail = (args.to || [])[0] || '';
          }
          return API.post('/freight-balance/send-email', payload).then(function (res) {
            if (res && res.success === false) throw new Error((res && res.error) || 'Send failed');
            return res;
          });
        },
      });
      } // _open
      if (window.RepPortal && window.RepPortal.API) {
        window.RepPortal.API.get('/rep-settings')
          .then(function (d) { _open(d && d.abbySignatureHtml); })
          .catch(function () { _open(''); });
      } else { _open(''); }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-13) — delay/backorder notice
       composer (online orders). Builds the prose from the selected items + ETA,
       then hands off to the shared compose modal; Send routes to
       /notify-customer-delay (Abby/orders@ via Outlook, quillBody:true). */
    function openDelayNoticeModal(opts) {
      opts = opts || {};
      if (!(window.RQD && window.RQD.openComposeModal)) {
        rqdAlert('Email composer unavailable — reload the page and try again.');
        return;
      }
      function getRepSessionEmail() {
        try { var raw = sessionStorage.getItem('rep_portal_session'); return raw ? ((JSON.parse(raw) || {}).email || '').trim() : ''; } catch (_) { return ''; }
      }
      function getRepSessionCode() {
        try { var raw = sessionStorage.getItem('rep_portal_session'); return raw ? ((JSON.parse(raw) || {}).code || '') : ''; } catch (_) { return ''; }
      }
      /* The email body is built SERVER-SIDE (preview mode) so the copy can vary
         on whether Abby has emailed this customer before (needs her ledger).
         Fetch it, then open the editable compose modal seeded with the result. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-31) — the discontinued fields ride the
         SAME route. noticeType picks the body; absent, the worker builds the delay
         notice exactly as it always has. */
      var _isDisc = opts.noticeType === 'discontinued';
      API.post('/notify-customer-delay', {
        preview: true,
        ref: opts.ref,
        customerEmail: opts.customerEmail || '',
        customerName: opts.customerName || '',
        items: opts.items || [],
        brands: opts.brands || [],
        eta: opts.eta || '',
        orderItemCount: opts.orderItemCount || (opts.items || []).length,
        noticeType: _isDisc ? 'discontinued' : 'delay',
        urls: opts.urls || [],
        subs: opts.subs || [],
        keepItems: opts.keepItems || [],
        variantTitles: opts.variantTitles || [],
      }).then(function (pv) {
        if (!pv || pv.success === false) throw new Error((pv && pv.error) || 'Could not build the email');
        window.RQD.openComposeModal({
          ref: opts.ref,
          prefillTo: opts.customerEmail || '',
          /* CUSTOM_DISCDRIP_BY_CLAUDE (Ryan 2026-09-06) — cc only a rep with a REGISTERED call on the
             feed (voicemail left / connected): "the ONLINE customer has no idea who I am." The worker's
             preview decides (`pv.cc`); an older worker that sends none falls back to nobody. */
          prefillCc: Array.isArray(pv.cc) ? pv.cc.slice() : [],
          prefillSubject: pv.subject || ('Update on your Blue Sky Fitness Supply order - ' + (opts.ref || '')),
          prefillBody: pv.html || '',
          signatureNote: "Sends as Abby (orders@blueskyfitsupply.com) — her signature is added automatically on send.",
        fromOptions: ['ABBY'],   // Abby-only email → locked From box (same pop-up, single sender)
          /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-08-31) — the ⏱ box, ticked by default. This is
             customer mail about their order, and none of it needs to arrive at 2am. The worker
             holds it in `pending-delay-email:` and the 5-minute drain sends it when the 6am-6pm MT
             window opens; untick to send now, whatever the hour. */
          showBusinessHours: true,
          suppressFollowUp: true,
          /* CUSTOM_DISCDRIP_BY_CLAUDE (Ryan 2026-09-06) — THE DISCONTINUED NOTICE GETS ABBY'S FOLLOW-UP DRIP,
             ticked by default. Ryan: *"the box is checked by default"*; SHOP-2000's customer never
             answered and nothing was watching. ⛔ Discontinued only — a delay/backorder notice that goes
             unanswered means "ship it when it lands", so that mode offers no box at all. The worker reads
             `drip` on the send and arms lib/discontinued-drip.js; every outcome lands on the Deal Feed. */
          extraToggle: _isDisc ? {
            label: '⚡ Abby follows up automatically if they don\u2019t reply',
            why: 'Three more emails in this thread, 7 days apart, from Abby. After the third she asks Ryan to call; 3 business days after the last she tells Ryan it is time to cancel and refund. It stops on its own when the customer replies, a call is logged, or the order is adjusted or cancelled. Untick to send this one on its own.',
            title: 'On by default. Untick to send this notice without the automatic follow-ups.',
            checked: true,
          } : null,
          fetchQuotes: fetchQuotes,
          sendOverride: function (args) {
            var payload = {
              ref: opts.ref,
              subject: args.subject,
              html: args.bodyHtml,
              quillBody: true,
              cc: (args.cc || []).join(','),
              // CUSTOM_DISCDRIP_BY_CLAUDE — the box (absent = on, so the worker's default is Ryan's), and
              // what Abby's "please call them" note needs. Both are ignored on a delay notice.
              drip: _isDisc ? args.extraToggle !== false : false,
              customerName: opts.customerName || '',
              customerPhone: opts.customerPhone || '',
              items: opts.items || [],
              qtys: opts.qtys || [],
              eta: opts.eta || '',
              /* Re-sent on SEND, not carried over from the preview: the worker rebuilds
                 the item table server-side here (a real <table> cannot survive Quill), and
                 that table needs the same names, quantities and URLs the prose was built
                 from. orderItemCount rides along because the Deal Feed entry's outcome is
                 derived from it at send time. */
              noticeType: _isDisc ? 'discontinued' : 'delay',
              urls: opts.urls || [],
              subs: opts.subs || [],
              variantTitles: opts.variantTitles || [],
              orderItemCount: opts.orderItemCount || (opts.items || []).length,
              // CUSTOM_SENDWINDOW_BY_CLAUDE — the ⏱ box. Queued by the worker when it is ticked
              // outside 6am-6pm MT; a test send is never held.
              businessHoursOnly: args.businessHoursOnly === true,
            };
            if (args.isTest) {
              payload.isTest = true;
              payload.testRecipient = getRepSessionEmail() || (args.to || [])[0] || '';
              if (!payload.testRecipient) { return Promise.reject(new Error('No address for the test — re-login so your session email is set, or type a To.')); }
            } else {
              payload.customerEmail = (args.to || [])[0] || '';
            }
            return API.post('/notify-customer-delay', payload).then(function (res) {
              if (res && res.success === false) throw new Error((res && res.error) || 'Send failed');
              if (!args.isTest) {
                var qq = allQuotes.find(function (x) { return x.reference === opts.ref; });
                if (qq) {
                  /* Mirror what the worker actually recorded. ⛔ A held email has NO `at` — the
                     card reads `at` for its green tick, and painting one over an email still
                     sitting in the 6am queue would say "sent" about something that has not been. */
                  qq.delayNoticeSent = (res && res.deferred)
                    ? { scheduledFor: res.sendAfter || '', by: getRepSessionCode(), items: opts.items || [], eta: opts.eta || '', type: _isDisc ? 'discontinued' : 'delay' }
                    : { at: new Date().toISOString(), by: getRepSessionCode(), items: opts.items || [], eta: opts.eta || '', type: _isDisc ? 'discontinued' : 'delay' };
                  var detailEl = document.getElementById('rqd-detail-' + opts.ref);
                  if (detailEl) { detailEl.innerHTML = buildDetailHtml(qq); applyCollapseState(detailEl, qq); }
                }
              }
              return res;
            });
          },
        });
      }).catch(function (err) {
        rqdAlert('Could not build the ' + (_isDisc ? 'discontinued' : 'delay') + ' email: ' + (err && err.message ? err.message : 'unknown error'));
      });
    }

    function _retiredFreightBalanceEmailModal(opts) {
      var existing = document.getElementById('rqd-fb-modal');
      if (existing) existing.remove();
      var modal = document.createElement('div');
      modal.id = 'rqd-fb-modal';
      modal.className = 'rqd-modal-backdrop rqd-modal-backdrop--open';
      modal.style.cssText = 'position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,15,28,0.7);z-index:9999;';
      var rowLabel = 'display:inline-block;width:48px;font-size:12px;font-weight:600;color:var(--rq-text-secondary,#6b7280);';
      var rowInput = 'flex:1;height:30px;padding:0 10px;font-family:Montserrat,sans-serif;font-size:13px;border:1px solid var(--rq-border,#EAEAEA);border-radius:6px;background:var(--rq-card-bg,#fff);color:var(--rq-text,#000F1C);box-sizing:border-box;';
      var rowWrap = 'display:flex;align-items:center;gap:8px;';
      modal.innerHTML =
        '<div class="rqd-modal" style="max-width:760px;width:92vw;max-height:90vh;display:flex;flex-direction:column;background:var(--rq-bg-surface,#fff);color:var(--rq-text,#000F1C);border-radius:16px;padding:20px 24px;box-shadow:0 20px 60px rgba(0,0,0,0.3);">' +
          '<p class="rqd-modal__title" style="font-size:18px;font-weight:700;margin:0 0 4px;">Freight Balance Email — ' + esc(opts.draftOrderName || '') + '</p>' +
          '<p class="rqd-modal__sub" style="font-size:12px;color:var(--rq-text-secondary,#6b7280);margin:0 0 14px;">' +
            (opts.claudeUsed ? '<span title="Drafted by Claude">🤖 AI-drafted</span>' : '<span title="Drafted via static template (Claude unavailable)">📝 Templated</span>') +
            ' &middot; sends from <strong>orders@blueskyfitsupply.com</strong> (Abby Rivers)' +
            ' &middot; <a href="' + esc(opts.invoiceUrl) + '" target="_blank">preview invoice</a>' +
          '</p>' +
          '<div style="display:flex;flex-direction:column;gap:8px;margin-bottom:10px;">' +
            // CUSTOM_ABBY_BY_CLAUDE (2026-06-02) — common-address autocomplete on
            // every Abby email field (type "r" → ryan@blueskyfitsupply.com).
            abbyEmailDatalistHtml() +
            '<div style="' + rowWrap + '"><label style="' + rowLabel + '">TO</label><input type="text" list="rqd-abby-emails" class="rqd-fb-modal__to" value="' + esc(opts.customerEmail || '') + '" style="' + rowInput + '"></div>' +
            '<div style="' + rowWrap + '"><label style="' + rowLabel + '">CC</label><input type="text" list="rqd-abby-emails" class="rqd-fb-modal__cc" placeholder="(optional)" style="' + rowInput + '"></div>' +
            '<div style="' + rowWrap + '"><label style="' + rowLabel + '">BCC</label><input type="text" list="rqd-abby-emails" class="rqd-fb-modal__bcc" placeholder="(optional)" style="' + rowInput + '"></div>' +
            '<div style="' + rowWrap + '"><label style="' + rowLabel + '">SUBJECT</label><input type="text" class="rqd-fb-modal__subject" value="' + esc(opts.subject || '') + '" style="' + rowInput + '"></div>' +
          '</div>' +
          '<div style="display:flex;flex-direction:column;flex:1;min-height:240px;">' +
            '<label style="display:block;font-size:12px;font-weight:600;margin-bottom:4px;">BODY <span style="font-weight:400;color:var(--rq-text-secondary,#6b7280);">— edit prose only; the signature is fixed</span></label>' +
            '<div class="rqd-fb-modal__body" contenteditable="true" style="flex:1;min-height:240px;max-height:520px;overflow:auto;padding:14px 18px;font-family:Helvetica,Arial,sans-serif;font-size:14px;line-height:1.5;border:1px solid var(--rq-border,#EAEAEA);border-radius:6px;background:var(--rq-card-bg,#fff);color:var(--rq-text,#000F1C);">' + (opts.html || '') + '</div>' +
          '</div>' +
          // Buttons reuse the portal-wide .rep-quote-btn styles (same as
          // the freight request modal) so hover, active, and dark-mode
          // states are consistent across email modals.
          '<div class="rqd-modal__btns" style="margin-top:14px;display:flex;gap:8px;align-items:center;">' +
            '<button class="rep-quote-btn rep-quote-btn--secondary rqd-fb-modal__cancel" type="button">Cancel</button>' +
            '<button class="rep-quote-btn rep-quote-btn--secondary rqd-fb-modal__test" type="button" style="margin-left:auto;" title="Send a copy of this email to your session email address — does not stamp the freight balance state">Send to me (test)</button>' +
            '<button class="rep-quote-btn rep-quote-btn--primary rqd-fb-modal__send" type="button">Send Email</button>' +
          '</div>' +
        '</div>';
      var portal = document.querySelector('.rep-quote-portal-wrap') || document.body;
      portal.appendChild(modal);
      var toInput = modal.querySelector('.rqd-fb-modal__to');
      var ccInput = modal.querySelector('.rqd-fb-modal__cc');
      var bccInput = modal.querySelector('.rqd-fb-modal__bcc');
      var subjectInput = modal.querySelector('.rqd-fb-modal__subject');
      var bodyEl = modal.querySelector('.rqd-fb-modal__body');
      var sendBtn = modal.querySelector('.rqd-fb-modal__send');
      var testBtn = modal.querySelector('.rqd-fb-modal__test');
      var cancelBtn = modal.querySelector('.rqd-fb-modal__cancel');

      function getRepSessionEmail() {
        try {
          var raw = sessionStorage.getItem('rep_portal_session');
          return raw ? ((JSON.parse(raw) || {}).email || '').trim() : '';
        } catch (_) { return ''; }
      }

      cancelBtn.onclick = function () {
        modal.remove();
        fetchQuotes();
      };

      // Send to me (test) — fires the same /send-email endpoint with a
      // testRecipient override (defaults to admin's session email; falls
      // back to whatever they typed in TO if session email isn't set).
      // Worker prefixes subject with [TEST] and skips lifecycle stamping.
      // Modal stays open so the admin can iterate / re-send.
      testBtn.onclick = async function () {
        var testEmail = getRepSessionEmail() || toInput.value.trim();
        if (!testEmail) { toInput.focus(); rqdAlert('Type an email in TO or re-login so your session email is set.'); return; }
        var origText = testBtn.textContent;
        testBtn.disabled = true; testBtn.textContent = 'Sending…';
        try {
          var res = await API.post('/freight-balance/send-email', {
            quoteRef: opts.quoteRef,
            testRecipient: testEmail,
            subject: subjectInput.value.trim(),
            html: bodyEl.innerHTML.trim(),
          });
          if (res && res.success !== false) {
            // Inline confirmation on the button — no pop-up (Ryan 2026-06-02).
            testBtn.textContent = '✓ Sent';
            setTimeout(function () { testBtn.disabled = false; testBtn.textContent = origText; }, 3000);
          } else {
            testBtn.disabled = false; testBtn.textContent = origText;
            rqdAlert('Test send failed: ' + ((res && res.error) || 'Unknown error'));
          }
        } catch (err) {
          testBtn.disabled = false; testBtn.textContent = origText;
          rqdAlert('Test send failed: ' + (err.message || err));
        }
      };

      sendBtn.onclick = async function () {
        var to = toInput.value.trim();
        var cc = ccInput.value.trim();
        var bcc = bccInput.value.trim();
        var subject = subjectInput.value.trim();
        var html = bodyEl.innerHTML.trim();
        if (!to) { toInput.focus(); return; }
        if (!subject || !html) return;
        sendBtn.disabled = true; sendBtn.textContent = 'Sending…';
        try {
          var res = await API.post('/freight-balance/send-email', {
            quoteRef: opts.quoteRef,
            customerEmail: to,
            cc: cc || undefined,
            bcc: bcc || undefined,
            subject: subject,
            html: html,
          });
          if (res && res.success !== false) {
            modal.remove();
            fetchQuotes();
          } else {
            sendBtn.disabled = false; sendBtn.textContent = 'Send Email';
            rqdAlert('Send failed: ' + ((res && res.error) || 'Unknown error'));
          }
        } catch (err) {
          sendBtn.disabled = false; sendBtn.textContent = 'Send Email';
          rqdAlert('Send failed: ' + (err.message || err));
        }
      };
    }

    async function handlePoGenerate(ref, vendor, isReissue, bucket, btn) {
      if (!ref || !vendor) return;
      // Confirm reissue when prior PO exists. Worker auto-mints -B if prior was sent.
      if (isReissue && !(await rqdConfirm('Re-generate PO for "' + vendor + '"? If a sent PO exists, a new revision (-B/-C/...) will be minted.', { title: 'Re-generate PO', confirmLabel: 'Re-generate' }))) return;
      // Loading state on the clicked button — PO generation can take a
      // few seconds (Shopify fetch + PDF render + R2 upload), and admin
      // has no feedback during that window. Disable the button + swap
      // its text so a second click can't fire a duplicate request and
      // the user knows the click registered. Finally{} restores on
      // success OR failure so admin can retry without a stuck button.
      var origBtnText = null;
      if (btn) {
        origBtnText = btn.textContent;
        btn.disabled = true;
        btn.textContent = isReissue ? 'Re-generating…' : 'Generating…';
        btn.classList.add('rqd-invoice__link--loading');
      }
      try {
        // Initial /generate-po: builds a baseline PDF + returns suggested fields
        // (instructions, subject, body, recipients). Modal opens on Instructions
        // pane — admin edits before clicking Preview or Send. Modal does NOT show
        // the baseline PDF until admin clicks Preview (per UX request).
        var poPayload = { quoteRef: ref, vendor: vendor };
        if (bucket) poPayload.bucket = bucket;
        var data = await API.post('/generate-po', poPayload);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — Missing roll layout.
           The worker held the PO because a roll product has no roll layout on
           file. Warn the rep to call the customer for roll lengths; if they
           proceed anyway, re-POST with confirmedNoRollLayout to override. */
        if (data && data.needsRollLayoutConfirm) {
          var _missRoll = (data.missingProducts || []).join(', ');
          if (!(await rqdConfirm('No roll layout on file for: ' + (_missRoll || 'a roll product') +
            '.\n\nThese rolls need cut lengths before the supplier can fulfill — call the customer to get their roll lengths first.\n\nSend the PO anyway, without roll layout?',
            { title: 'No roll layout on file', confirmLabel: 'Send without roll layout', cancelLabel: 'Stop — call the customer', danger: true }))) {
            return; // aborted — finally{} restores the button
          }
          poPayload.confirmedNoRollLayout = true;
          data = await API.post('/generate-po', poPayload);
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_SPECMISMATCH_BY_CLAUDE (Ryan 2026-08-21) — the worker held the PO because a line's
           quoted colours contradict the variant the PO prints from. RW-1284-A went to Legend in
           Textured Black against a quote that said Silver Vein, and nothing asked. Warn-and-proceed
           like the roll-layout gate above: the sub-description is sometimes the stale one, and the
           rep is who knows. Both documents are shown so the choice is an informed one, not a
           click-through. */
        if (data && data.needsSpecMismatchConfirm) {
          var _mmLines = (data.specMismatches || []).map(function (it) {
            var _head = '• ' + (it.name || 'Item') + (it.model ? ' (' + it.model + ')' : '') + ':';
            var _rows = (it.rows || []).map(function (r) {
              return '    ' + r.label + ' — quote says "' + r.quoted + '", the order is built as "' + r.variant + '"';
            }).join('\n');
            return _head + '\n' + _rows;
          }).join('\n');
          if (!(await rqdConfirm('⚠ This PO does not match the quote.\n\n' + _mmLines +
            '\n\nThe supplier builds from the PO, so it will ship what the ORDER says. Fix the line in the Workstation, or rewrite the build spec from the Order Contents pencil, before sending.\n\nSend the PO anyway?',
            { title: 'PO does not match the quote', confirmLabel: 'Send anyway', cancelLabel: 'Stop — fix the line', danger: true }))) {
            return; // aborted — finally{} restores the button
          }
          poPayload.confirmedSpecMismatch = true;
          data = await API.post('/generate-po', poPayload);
        }
        /* END CUSTOM_SPECMISMATCH_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — roll under-order heads-up.
           Advisory (not a server hold): the customer bought less than their own roll
           layout calls for (e.g. overrode the calculator down to the bare room area),
           so they may come up short once cut waste is accounted for. Warn the rep so
           they can call the customer to confirm coverage BEFORE committing the vendor
           PO; OK proceeds, Cancel aborts. */
        if (data && Array.isArray(data.rollUnderOrders) && data.rollUnderOrders.length) {
          var _uoLines = data.rollUnderOrders.map(function (u) {
            var _room = u.netSqft ? (' for a ' + u.netSqft + ' sq ft room') : '';
            return '• ' + (u.name || 'Roll') + ': bought ' + u.ordered + ' sq ft, but the layout (' + (u.layoutText || '') + ') needs ~' + u.layoutSqft + ' sq ft' + _room + '.';
          }).join('\n');
          if (!(await rqdConfirm('⚠ Possible roll under-order — the customer bought less than their own roll layout calls for:\n\n' + _uoLines + '\n\nThey may be short once cut waste is accounted for. Call the customer to confirm coverage before sending this PO.\n\nSend the PO anyway?',
            { title: 'Possible roll under-order', confirmLabel: 'Send anyway', cancelLabel: 'Stop — call the customer', danger: true }))) {
            return; // aborted — finally{} restores the button
          }
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_POCOSTSANITY_BY_CLAUDE (ONYX 181ae7eadafe, Ryan 2026-09-30) — a line whose cost is under 25% or
           over 100% of its own sell price is a unit mix-up, not a margin (SHOP-2081: a per-sq-ft cost on a
           per-tile line). Advisory, same shape as the roll heads-up above: OK proceeds, Cancel stops. */
        if (data && Array.isArray(data.costWarnings) && data.costWarnings.length) {
          var _cwLines = data.costWarnings.map(function (w) { return '• ' + (w.message || w.name); }).join('\n');
          if (!(await rqdConfirm('⚠ A line cost on this PO looks wrong:\n\n' + _cwLines + '\n\nFix the cost on the line (Order Contents, cost pencil) before this goes to the supplier, or send it if you know it is right.\n\nSend the PO anyway?',
            { title: 'PO cost looks wrong', confirmLabel: 'Send anyway', cancelLabel: 'Stop — fix the cost', danger: true }))) {
            return; // aborted — finally{} restores the button
          }
        }
        /* END CUSTOM_POCOSTSANITY_BY_CLAUDE */
        // vendorEmails is the multi-recipient array; vendorEmail kept around as a
        // comma-joined fallback for older worker versions.
        var to = Array.isArray(data.vendorEmails) && data.vendorEmails.length
          ? data.vendorEmails
          : (data.vendorEmail ? String(data.vendorEmail).split(',').map(function (s) { return s.trim(); }).filter(Boolean) : []);
        var cc = data.vendorCc || [];
        var bcc = data.vendorBcc || [];
        await refreshQuotePos(ref);
        openPoModal({
          poNumber: data.poNumber,
          ref: ref,
          vendor: vendor,
          // Bucket key threaded into modal state so regeneratePoFromModal
          // (called on Preview + Send) re-fires /generate-po WITH the
          // bucket so the filtered line item set persists. Without this
          // the Preview-time regen produces a no-bucket PO carrying all
          // line items.
          bucket: bucket || null,
          // Don't pass pdfUrl initially — Instructions pane is the default; admin
          // clicks Preview to render with their edits.
          pdfUrl: null,
          to: to, cc: cc, bcc: bcc,
          subject: data.suggestedSubject || '',
          body: data.suggestedBody || '',
          instructions: Array.isArray(data.suggestedInstructions) ? data.suggestedInstructions : [],
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — what pallet fee the worker put on this
             PO (null when the supplier is shipping, or the vendor has no rule). Surfaced in the
             Instructions pane so a wrong count is caught while looking at the document. */
          palletFee: data.palletFee || null,
          /* CUSTOM_BALLAST_BY_CLAUDE (Ryan 2026-09-01) — `{designId, designRef, vendor, customer}`
             when this supplier's PO has a weight design with no Vendor Design Sheet, null
             otherwise (which is nearly every PO). Drives the amber bar on the modal. */
          designSheetGap: data.designSheetGap || null,
          /* The sheet that WILL ride, when one already exists for this supplier. Mutually
             exclusive with the gap above — one or the other, never both. */
          designSheet: data.designSheet || null,
          // Freshly generated PO is never voided; recipients are edited in step 2.
          allowSend: true,
        });
      } catch (err) {
        if (err && err.message && /vendor profile not found/i.test(err.message)) {
          if (await rqdConfirm('Vendor "' + vendor + '" needs PO data filled in. Open the Vendor Guide → PO Profiles tab to set it up?', { title: 'Vendor PO profile missing', confirmLabel: 'Open the Vendor Guide' })) {
            /* ⚠️ The popup opens outside the click gesture (this branch is already several awaits
               past it), so a blocker can swallow it silently. Say so on the button rather than
               leaving the operator looking at a tab that never arrived. */
            var _vgWin = window.open('/pages/rep-vendor-guide', '_blank');
            if (!_vgWin && btn) markResult(btn, false, 'Popup blocked — open /pages/rep-vendor-guide manually to set up ' + vendor + '.');
          }
        } else {
          rqdAlert('PO generation failed: ' + (err && err.message ? err.message : 'unknown error'));
        }
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.textContent = origBtnText;
          btn.classList.remove('rqd-invoice__link--loading');
        }
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Open sent PO PDF in a new tab. Pops the
       window synchronously from the click handler so popup blockers don't
       fire, then sets the URL once the GET /po fetch resolves. */
    async function handlePoViewPdf(poNumber) {
      if (!poNumber) return;
      var newWindow = window.open('about:blank', '_blank');
      try {
        var data = await API.get('/po?number=' + encodeURIComponent(poNumber));
        var url = data && data.pdfUrl;
        if (!url) throw new Error('PDF URL missing on PO record');
        if (newWindow) newWindow.location = url;
        else window.location = url;
      } catch (err) {
        if (newWindow) newWindow.close();
        rqdAlert('Failed to open PO PDF: ' + (err && err.message ? err.message : 'unknown'));
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    async function handlePoView(poNumber) {
      if (!poNumber) return;
      try {
        var data = await API.get('/po?number=' + encodeURIComponent(poNumber));
        var p = data.po;
        openPoModal({
          poNumber: poNumber,
          ref: p.quoteRef,
          vendor: p.vendor,
          pdfUrl: data.pdfUrl,
          to: p.sentTo || [],
          cc: p.sentCc || [],
          subject: '',
          body: '',
          allowSend: p.status !== 'voided',
        });
      } catch (err) {
        rqdAlert('Failed to load PO: ' + (err && err.message ? err.message : 'unknown'));
      }
    }

    async function handlePoEmail(poNumber, btn) {
      if (!poNumber) return;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Loading state on the clicked button
         while we fetch the PO record + (for drafts) regenerate the PDF.
         Mirrors the Generate PO button's "Generating…" treatment so the
         rep gets feedback during the few-second round-trip. Restored in
         the finally block on success OR failure. */
      var _origText = null;
      if (btn) {
        _origText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Loading…';
        btn.classList.add('rqd-invoice__link--loading');
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      try {
        var data = await API.get('/po?number=' + encodeURIComponent(poNumber));
        var p = data.po;
        // For draft (un-sent) POs, auto-regenerate the PDF before opening
        // so the modal reflects the latest line item costs, freight, etc.
        // (admin may have edited the per-line cost since the last generate).
        // Sent POs are immutable — never regen those; the as-sent PDF is
        // the audit record.
        if (p && p.status === 'draft' && p.quoteRef && p.vendor) {
          try {
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Carry the bucket key through the
               auto-regen. Without this the regen takes the legacy single-PO
               path on the worker side: returns the no-sub `{ref}-{vendor}`
               name, runs no bucket filter (all line items on the PDF), and
               overwrites the bucket PO's R2 blob with the wrong content.
               When admin then clicks Send, the modal state's bucket is also
               null → Send-time regen + /email-po also operates on the
               no-sub legacy PO → bucket-aware `.N-` PO stays in draft
               forever (panel check never lights up). */
            var _regenPayload = { quoteRef: p.quoteRef, vendor: p.vendor };
            if (p.bucket) _regenPayload.bucket = p.bucket;
            // Regen of an existing draft PO — the roll-layout gate was already
            // cleared when this PO was first generated, so don't re-warn here.
            _regenPayload.confirmedNoRollLayout = true;
            // CUSTOM_SPECMISMATCH_BY_CLAUDE — likewise: this is a regen of an already-generated
            // draft PO, so both gates were cleared when it was first minted.
            _regenPayload.confirmedSpecMismatch = true;
            var regenData = await API.post('/generate-po', _regenPayload);
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
            if (regenData && regenData.pdfUrl) data.pdfUrl = regenData.pdfUrl;
            // Re-fetch the PO record so suggestedSubject/Body + items reflect the regen.
            var refreshed = await API.get('/po?number=' + encodeURIComponent(poNumber));
            if (refreshed && refreshed.po) p = refreshed.po;
          } catch (_) {
            // Non-fatal — fall through to the previously stored PDF / record.
          }
        }
        // Use the persisted suggestedSubject + suggestedBody from the PO
        // record (saved at generation time). Falls back to a generic
        // template only for legacy POs minted before the persistence
        // landed — those will still show the old hardcoded message but
        // won't drift further.
        var subject = p.suggestedSubject || ('Blue Sky Order — ' + poNumber);
        var body = p.suggestedBody || ('Hi Team,\n\nPlease see the attached PO ' + poNumber + '. Kindly confirm receipt and provide an estimated ship date.\n\nThank you!');
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Pre-fill TO / CC / BCC / Instructions
           from the persisted vendor snapshot when the PO has never been sent
           (sentTo empty). Worker now stamps vendorEmails/Cc/Bcc + suggested
           Instructions onto the PO record at generation time. */
        var _to = (p.sentTo && p.sentTo.length) ? p.sentTo
          : ((p.vendorEmails && p.vendorEmails.length) ? p.vendorEmails : []);
        var _cc = (p.sentCc && p.sentCc.length) ? p.sentCc
          : ((p.vendorCc && p.vendorCc.length) ? p.vendorCc : []);
        var _bcc = (p.vendorBcc && p.vendorBcc.length) ? p.vendorBcc : [];
        var _instr = Array.isArray(p.suggestedInstructions) ? p.suggestedInstructions : [];
        openPoModal({
          poNumber: poNumber,
          ref: p.quoteRef,
          vendor: p.vendor,
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Bucket key threaded through so
             regeneratePoFromModal on Preview + Send keeps the filtered
             item set + bucket-aware PO numbering. Pulls from the PO
             record (p.bucket) — set at generation time on bucket-aware
             POs, null for legacy non-bucket POs. */
          bucket: p.bucket || null,
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          pdfUrl: data.pdfUrl,
          to: _to,
          cc: _cc,
          bcc: _bcc,
          subject: subject,
          body: body,
          instructions: _instr,
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — a sent PO is the audit record of what
             the supplier received. The composer's From-switch regen reads this to leave it alone;
             regenerating one would mint a revision behind a re-send. */
          isSent: p.status === 'sent',
          // Recipients are edited in step 2 (compose modal); only voided blocks send.
          allowSend: p.status !== 'voided',
        });
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      } catch (err) {
        rqdAlert('Failed to load PO: ' + (err && err.message ? err.message : 'unknown'));
      } finally {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Restore the Email PO button's
           label + remove the loading state. Runs on both success (modal
           open) and failure (alert shown) so admin can retry without a
           stuck button. */
        if (btn) {
          btn.disabled = false;
          if (_origText != null) btn.textContent = _origText;
          btn.classList.remove('rqd-invoice__link--loading');
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-12) — record a PO that reached the vendor
       through another channel (a plain email, a phone call, a portal upload) so the deal can
       close instead of showing open forever. Driving case SHOP-1743: paid, fulfilled and
       tracked back in June, with its only PO stuck at status 'draft' and no way to say so.

       Sends NOTHING. The confirm names the two things that are easy to get wrong about this
       button: no email goes out, and it records something that already happened rather than
       performing an action.

       @param {string} poNumber
       @param {string} ref        - deal reference, for the optimistic re-render
       @param {string} vendorName - display only
       @param {Element} btn       - the clicked button, disabled during the round-trip
       @param {Function} [setMsg] - modal message sink; absent when fired from a card row
    */
    async function handlePoMarkSent(poNumber, ref, vendorName, btn, setMsg) {
      if (!poNumber) return;
      var _vendorLabel = vendorName || 'the vendor';
      if (!(await rqdConfirm(
        'No email is sent. Use this only when the PO genuinely reached the vendor another way '
          + '(plain email, phone, portal upload) and the dashboard never saw it.',
        { title: 'Mark ' + poNumber + ' as already sent to ' + _vendorLabel + '?', confirmLabel: 'Mark as sent' }
      ))) return;

      var _origText = null;
      if (btn) { _origText = btn.textContent; btn.disabled = true; btn.textContent = 'Saving…'; markPending(btn); }

      /* Optimistic flip so the card + progress bar update before the round-trip, matching the
         Download button's behaviour. refreshQuotePos then replaces this with authoritative
         server state, so a rejected write cannot leave a false ✓ standing. */
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (q) {
        if (!Array.isArray(q.pos)) q.pos = [];
        var match = q.pos.find(function (p) { return p.poNumber === poNumber; });
        var nowIso = new Date().toISOString();
        if (match) {
          match.status = 'sent';
          match.sentAt = match.sentAt || nowIso;
        } else {
          q.pos.push({ poNumber: poNumber, vendor: vendorName || '', status: 'sent', sentAt: nowIso });
        }
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl) { detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q); }
        refreshProgressBar(ref);
      }

      try {
        var resp = await API.post('/po-mark-sent', { poNumber: poNumber });
        await refreshQuotePos(ref);
        if (setMsg) setMsg(resp && resp.alreadySent ? 'Already marked sent.' : 'Marked as sent — no email was sent.');
      } catch (e) {
        var _err = 'Could not mark as sent: ' + ((e && e.message) ? e.message : e);
        // Never leave the optimistic flip looking authoritative on a failure.
        if (setMsg) setMsg(_err, true); else rqdAlert(_err);
        try { await refreshQuotePos(ref); } catch (_) { /* the alert already told them */ }
      } finally {
        if (btn) { btn.disabled = false; if (_origText != null) btn.textContent = _origText; }
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    async function handlePoVoid(poNumber) {
      if (!poNumber) return;
      var reason = await rqdPrompt(
        'Optional reason (will be stored on the audit trail):',
        '',
        { title: 'Void PO ' + poNumber + '?', placeholder: 'Reason (optional)', confirmLabel: 'Void PO' }
      );
      if (reason === null) return;
      try {
        var resp = await API.post('/void-po', { poNumber: poNumber, reason: reason || '' });
        if (resp && resp.success) {
          // Find the quote ref by looking up the PO record (the API doesn't return it on void)
          var data = await API.get('/po?number=' + encodeURIComponent(poNumber));
          if (data && data.po && data.po.quoteRef) await refreshQuotePos(data.po.quoteRef);
        }
      } catch (err) {
        rqdAlert('Void failed: ' + (err && err.message ? err.message : 'unknown'));
      }
    }

    // ── Vendor Order Handler ──

    async function handleVendorOrderClick(checkEl) {
      var ref = checkEl.dataset.ref;
      var vendor = checkEl.dataset.vendor;
      var isDone = checkEl.classList.contains('rqd-vendors__check--done');
      var newVal = !isDone;

      // Read current ordering state for this quote — preserve tracking fields
      var q = allQuotes.find(function(x) { return x.reference === ref; });
      var ordering = Object.assign({}, (q && q.ordering) || {});
      var existing = ordering[vendor] || {};
      ordering[vendor] = {
        ordered: newVal,
        date: newVal ? (existing.date || todayStr()) : null,
        tracking: newVal ? (existing.tracking || null) : null,
        carrier: newVal ? (existing.carrier || null) : null,
        shipped: newVal ? (existing.shipped || false) : false,
        shipDate: newVal ? (existing.shipDate || null) : null
      };

      try {
        await API.post('/quote-lifecycle', { ref: ref, ordering: ordering });
        checkEl.classList.toggle('rqd-vendors__check--done');
        // Update checkmark
        checkEl.innerHTML = newVal ? '<span style="font-size:12px;">✓</span>' : '';
        // Update date display
        var vendorItem = checkEl.closest('.rqd-vendor-item');
        var dateSpan = vendorItem.querySelector('.rqd-toggle__date');
        if (newVal) {
          if (!dateSpan) {
            dateSpan = document.createElement('span');
            dateSpan.className = 'rqd-toggle__date';
            // Insert into the name+date group (falls back to old behavior).
            var _ng = vendorItem.querySelector('.rqd-vendor-item__namegroup');
            var nameEl = vendorItem.querySelector('.rqd-vendor-item__name');
            if (_ng) {
              _ng.appendChild(dateSpan);
            } else if (nameEl && nameEl.nextSibling) {
              vendorItem.insertBefore(dateSpan, nameEl.nextSibling);
            } else {
              vendorItem.appendChild(dateSpan);
            }
          }
          dateSpan.textContent = formatDate(todayStr());
        } else if (dateSpan) {
          dateSpan.remove();
        }
        // Update local state
        if (q) q.ordering = ordering;
        refreshProgressBar(ref);

        // Tracking row is now always rendered in buildDetailHtml; manually
        // toggling the box only flips ordered + date here. The fields stay
        // visible with whatever values the rep typed.
      } catch (err) {
        console.error('Vendor order update failed:', err);
      }
    }

    // ── Payment Log Auto-Save ──

    function maybeAutoSavePaymentRow(row) {
      if (!row) return;
      var methodSel = row.querySelector('.rqd-payment-method');
      var amountInput = row.querySelector('.rqd-payment-amount');
      var dateInput = row.querySelector('.rqd-payment-date');
      var method = methodSel ? methodSel.value : '';
      var amount = parseMoneyInput(amountInput ? amountInput.value : '');
      var date = dateInput ? dateInput.value : '';
      // Only save when all 3 fields are filled
      if (method && amount > 0 && date) {
        schedulePaymentRowSave(row);
      }
    }

    var _paymentSaveTimers = {};
    function schedulePaymentRowSave(row) {
      if (!row) return;
      var ref = row.dataset.ref;
      var idx = row.dataset.paymentIdx;
      var key = ref + ':' + idx;
      if (_paymentSaveTimers[key]) clearTimeout(_paymentSaveTimers[key]);
      _paymentSaveTimers[key] = setTimeout(function() { doPaymentRowSave(row); }, 400);
    }

    function parseMoneyInput(val) {
      if (!val) return 0;
      return parseFloat(String(val).replace(/[$,\s]/g, '')) || 0;
    }

    async function doPaymentRowSave(row) {
      if (!row) return;
      var ref = row.dataset.ref;
      var idx = parseInt(row.dataset.paymentIdx, 10);
      var methodSel = row.querySelector('.rqd-payment-method');
      var amountInput = row.querySelector('.rqd-payment-amount');
      var dateInput = row.querySelector('.rqd-payment-date');
      var indicator = row.querySelector('.rqd-payment-saved');

      var method = methodSel ? methodSel.value : '';
      var amount = parseMoneyInput(amountInput ? amountInput.value : '');
      var date = dateInput ? dateInput.value : '';

      // Format amount display
      if (amountInput && amount > 0) amountInput.value = money(amount);

      if (indicator) indicator.textContent = 'Saving...';

      try {
        var q = allQuotes.find(function(x) { return x.reference === ref; });
        if (!q) return;
        /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE (Ryan 2026-08-31) — capture the PRIOR total before anything
           mutates, so "did this save cross the line?" is answerable afterwards. `payments` below is
           a copy, but q.payments is reassigned a few lines down and reading it after that would
           compare the new total against itself and never detect a crossing. */
        var _qTotalAmt = parseFloat(q.total || q.quoteAmount || q.amount || 0);
        var _priorPaid = (q.payments || []).reduce(function (s, p) { return s + (parseFloat(p.amount) || 0); }, 0);
        var _wasFullyPaid = _qTotalAmt > 0 && _priorPaid >= _qTotalAmt;
        var payments = (q.payments || []).slice();
        if (idx < payments.length) {
          payments[idx] = { id: payments[idx].id || idx + 1, method: method, amount: amount, date: date };
        }
        /* ⛔ suppressInvoiceEmail — THE DASHBOARD OWNS THIS EMAIL NOW. Without it the worker mails
           the customer their paid invoice from inside this request the moment the total is reached
           (email/lifecycle.js §2d): no prompt, nothing to read, nothing to decline. With it the
           invoice is still prepared — PAID PDF, deal marked paid — and openPaidInvoiceCompose below
           puts it in front of a human. */
        await API.post('/quote-lifecycle', { ref: ref, payments: payments, suppressInvoiceEmail: true });
        q.payments = payments;

        // Update paid status based on total
        var totalPaid = payments.reduce(function(s, p) { return s + (parseFloat(p.amount) || 0); }, 0);
        q.paymentAmount = totalPaid;
        var qTotalAmt = parseFloat(q.total || q.quoteAmount || q.amount || 0);
        q.paid = qTotalAmt > 0 ? totalPaid >= qTotalAmt : !!q.paid;

        refreshProgressBar(ref);

        // Re-render detail panel to update header checkmark/badge
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl) {
          detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q);
          detailEl.classList.add('rqd-detail--open');
        }

        /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE — THIS save is what paid the order off. Opened after the
           re-render so the card behind the modal already reads paid.
           ⚠️ Gated on the CROSSING, not on "is fully paid": editing a typo on an already-settled
           deal would otherwise re-open the composer every time the field blurred. */
        if (!_wasFullyPaid && _qTotalAmt > 0 && totalPaid >= _qTotalAmt) {
          openPaidInvoiceCompose(ref);
        }
      } catch (err) {
        console.error('Payment save failed:', err);
        if (indicator) {
          indicator.textContent = 'Error';
          setTimeout(function() { if (indicator) indicator.textContent = ''; }, 3000);
        }
      }
    }

    function handlePaymentAdd(btn) {
      var ref = btn.dataset.ref;
      var q = allQuotes.find(function(x) { return x.reference === ref; });
      if (!q) return;
      var payments = (q.payments || []).slice();
      var newId = payments.length > 0 ? Math.max.apply(null, payments.map(function(p) { return p.id || 0; })) + 1 : 1;
      // Add empty payment — don't save yet (save only when all 3 fields filled)
      payments.push({ id: newId, method: '', amount: 0, date: '' });
      q.payments = payments;
      // Re-render detail panel (new row shows method dropdown only)
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (detailEl) {
        detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q);
        detailEl.classList.add('rqd-detail--open');
      }
    }

    async function handlePaymentRemove(btn) {
      var row = btn.closest('.rqd-payment-row');
      if (!row) return;
      var ref = row.dataset.ref;
      var idx = parseInt(row.dataset.paymentIdx, 10);
      var q = allQuotes.find(function(x) { return x.reference === ref; });
      if (!q) return;
      var payments = (q.payments || []).slice();
      payments.splice(idx, 1);
      q.payments = payments;
      var totalPaid = payments.reduce(function(s, p) { return s + (parseFloat(p.amount) || 0); }, 0);
      q.paymentAmount = totalPaid;
      try {
        /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE — removing a payment cannot raise the total, but a remove
           on an already-settled deal still posts an array that reaches the total, and §2d only
           tests the sum. The flag makes "the DD never auto-mails a customer" true of every payment
           write rather than only the ones we predicted. */
        await API.post('/quote-lifecycle', { ref: ref, payments: payments, suppressInvoiceEmail: true });
      } catch (err) {
        console.error('Remove payment failed:', err);
      }
      // Re-render detail panel
      var detailEl = document.getElementById('rqd-detail-' + ref);
      if (detailEl) {
        detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q);
        detailEl.classList.add('rqd-detail--open');
      }
      refreshProgressBar(ref);
    }

    // ── Vendor Tracking Auto-Save ──

    var _trackingSaveTimers = {};
    // Toggles the red × button on a Shipping tracking row based on whether
    // any of carrier/type/number have content. Called from change/input
    // listeners and at the end of doTrackingSave.
    function updateTrackingRemoveVisibility(row) {
      if (!row) return;
      var btn = row.querySelector('.rqd-vendor-tracking__remove');
      if (!btn) return;
      var carrierSel = row.querySelector('.rqd-vendor-tracking__carrier');
      var carrierOther = row.querySelector('.rqd-vendor-tracking__carrier-other');
      var typeSel = row.querySelector('.rqd-vendor-tracking__type');
      var typeOther = row.querySelector('.rqd-vendor-tracking__type-other');
      var numInput = row.querySelector('.rqd-vendor-tracking__input');
      var hasAny =
        (carrierSel && !!carrierSel.value) ||
        (carrierOther && !!carrierOther.value && carrierOther.style.display !== 'none') ||
        (typeSel && !!typeSel.value) ||
        (typeOther && !!typeOther.value && typeOther.style.display !== 'none') ||
        (numInput && !!numInput.value);
      btn.classList.toggle('rqd-vendor-tracking__remove--visible', !!hasAny);
    }

    // Red × click — clears every field on the tracking row, hides the ×, and
    // unchecks the vendor's "ordered" checkbox. Persists via /quote-lifecycle.
    function handleShopifyFulfillmentSync(btn) {
      if (window.DashboardHandshake) window.DashboardHandshake.shopifySync(btn);
    }

    /* CUSTOM_MULTISHIP_BY_CLAUDE (AIOPS `17a342129a10`, Ryan 2026-09-26) — the "+ Add shipment" form on the
       Tracking card (dashboard-shipping-tracking-card.js laterShipmentsLineHtml). Posts the same route an agent
       uses, POST /deal-tracking-stamp {additional:true}: the first number stays, the new one is a Second
       Shipment, the open Shopify lines are fulfilled silently, nobody is emailed. The customer's notice for it
       goes through the tracking notify route (Abby / the Order Desk), which lists every shipment. */
    async function handleLaterShipmentAction(btn) {
      var line = btn.closest('.rqd-vendor-ships');
      if (!line) return;
      var form = line.querySelector('.rqd-vendor-ships__form');
      var addBtn = line.querySelector('[data-ship-action="add-shipment"]');
      var action = btn.dataset.shipAction;
      if (action === 'add-shipment') {
        if (form) form.style.display = 'inline-flex';
        if (addBtn) addBtn.style.display = 'none';
        var n = line.querySelector('.rqd-vendor-ships__number');
        if (n) n.focus();
        return;
      }
      if (action === 'cancel-shipment') {
        if (form) form.style.display = 'none';
        if (addBtn) addBtn.style.display = '';
        return;
      }
      if (action !== 'save-shipment') return;
      var ref = btn.dataset.ref, vendor = btn.dataset.vendor;
      var numEl = line.querySelector('.rqd-vendor-ships__number');
      var carEl = line.querySelector('.rqd-vendor-ships__carrier');
      var number = String((numEl && numEl.value) || '').replace(/\s+/g, '').toUpperCase();
      var carrier = String((carEl && carEl.value) || '').trim();
      if (!number) { rqdAlert('Enter the tracking number of the later shipment.'); return; }
      btn.disabled = true;
      try {
        var r = await API.post('/deal-tracking-stamp', { ref: ref, vendor: vendor, carrier: carrier || undefined, tracking: [number], additional: true, source: 'deal-dashboard' });
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        if (q && q.ordering && q.ordering[vendor] && r) {
          if (r.additionalShipments) q.ordering[vendor].additionalShipments = r.additionalShipments;
          if (r.trackingNumbers) q.ordering[vendor].trackingNumbers = r.trackingNumbers;
          if (r.firstDeliveredOn) q.ordering[vendor].firstDeliveredOn = r.firstDeliveredOn;
        }
        var d = document.getElementById('rqd-detail-' + ref);
        if (d && q) d.innerHTML = buildDetailHtml(q);
        if (r && r.changed === false) rqdAlert('That number is already on the deal.');
        else if (r && r.warnings && r.warnings.length) rqdAlert(r.detail || 'Added, with a warning.');
      } catch (err) {
        btn.disabled = false;
        rqdAlert('Could not add the shipment: ' + (err && err.message ? err.message : 'unknown error'));
      }
    }
    /* END CUSTOM_MULTISHIP_BY_CLAUDE */

    async function handleVendorShipmentClear(btn) {
      var ref = btn.dataset.ref;
      var vendor = btn.dataset.vendor;
      var row = btn.closest('.rqd-vendor-tracking');
      var vendorItem = btn.closest('.rqd-vendor-item');
      if (!row || !vendorItem) return;
      var isOnlineRow = row.dataset.online === '1';

      // Clear every input in the row.
      var carrierSel = row.querySelector('.rqd-vendor-tracking__carrier');
      var carrierOther = row.querySelector('.rqd-vendor-tracking__carrier-other');
      var typeSel = row.querySelector('.rqd-vendor-tracking__type');
      var typeOther = row.querySelector('.rqd-vendor-tracking__type-other');
      var numInput = row.querySelector('.rqd-vendor-tracking__input');
      var urlInput = row.querySelector('.rqd-vendor-tracking__url');
      if (carrierSel) carrierSel.value = '';
      if (carrierOther) { carrierOther.value = ''; carrierOther.style.display = 'none'; }
      if (typeSel) typeSel.value = '';
      if (typeOther) { typeOther.value = ''; typeOther.style.display = 'none'; }
      if (numInput) numInput.value = '';
      // Online rows: blank + hide the Tracking URL too. URL was only visible
      // because the carrier was a custom name; clearing the carrier means
      // the URL is no longer relevant — keeping it visible would leave an
      // empty input dangling next to the other cleared fields.
      if (urlInput) { urlInput.value = ''; }

      // Hide the × itself.
      btn.classList.remove('rqd-vendor-tracking__remove--visible');
      /* CUSTOM_DDCARDCOUNT_BY_CLAUDE (Ryan 2026-09-26) — a cleared row is "fill me in" again. */
      var _clearedRow = btn.closest('.rqd-vendor-tracking');
      if (_clearedRow) _clearedRow.classList.remove('rqd-vendor-tracking--filled');

      // Online rows: typed values live in the DOM until Mark Fulfilled fires, so with nothing
      // on the record there is nothing to write. No /quote-lifecycle write needed; vendor
      // checkbox is already unchecked because we never auto-checked it.
      /* CUSTOM_TRACKINGCLEAR_BY_CLAUDE (AIOPS `5982e62242c1`, Ryan 2026-09-22 - SHOP-2026) — ⛔ BUT A
         STAMPED NUMBER IS ON THE RECORD. An agent's POST /deal-tracking-stamp (or the ship-notice
         sweep) writes `ordering[vendor].tracking` on an online deal, and this early return left
         SHOP-2026 carrying SHOP-2006's FedEx number for eight days while the × looked like it had
         worked. When the card marked the button `data-persisted`, the record is cleared through
         POST /deal-tracking-clear: the row's number, its silent Shopify fulfillment, any queued
         customer notice, and a note on the feed saying whether the customer had been told it. */
      /* CUSTOM_OFFLINECLEAR_BY_CLAUDE (AIOPS `2e3e604e835c` + `6351c8516cbf`, Ryan 2026-09-24 - RW-1285-C) — AN
         OFFLINE ROW WHOSE NUMBER IS ON THE RECORD GOES THROUGH THE SAME ROUTE. The legacy path below wrote a
         blanked `ordering[vendor]` straight to /quote-lifecycle, which on RW-1285-C created an empty "ECORE"
         row beside the real "ECORE Athletic" one and cleared nothing. The route clears the stored row, cancels
         the linked order's silent fulfillment, keeps the customer-told marker and notes the feed. A row with
         nothing on the record (typed and not yet saved) still takes the legacy path. */
      var _offlineRow = !isOnlineRow;
      if (isOnlineRow || btn.dataset.persisted === '1') {
        if (btn.dataset.persisted !== '1') return;
        var _was = (btn.dataset.carrier ? btn.dataset.carrier + ' ' : '') + (btn.dataset.tracking || '');
        if (!(await rqdConfirm(_offlineRow
            ? 'This removes ' + _was + ' from the deal so the right number can be entered. If a linked paid Shopify order was fulfilled with it, that fulfillment is cancelled silently. Nobody is emailed. If the customer was already sent this number, correct it with a reply on that email.'
            : 'This removes ' + _was + ' from the deal, cancels the Shopify fulfillment it created (the customer is not notified), and lets a different number be recorded. If the customer was already emailed this number, the next notice must go as a correction.', { title: 'Clear the tracking on ' + vendor + '?', confirmLabel: 'Clear tracking', cancelLabel: 'Keep it', danger: true }))) {
          btn.classList.add('rqd-vendor-tracking__remove--visible');
          /* the inputs were emptied above; put the stored values back rather than leave blank boxes over a number that is still recorded */
          var _qk = allQuotes.find(function (x) { return x.reference === ref; });
          var _dk = document.getElementById('rqd-detail-' + ref);
          if (_dk && _qk) _dk.innerHTML = buildDetailHtml(_qk);
          return;
        }
        var _qo = allQuotes.find(function (x) { return x.reference === ref; });
        try {
          var _r = await API.post('/deal-tracking-clear', { ref: ref, vendor: vendor, reason: 'cleared on the Deal Dashboard' });
          if (_qo && _qo.ordering && _qo.ordering[vendor]) {
            var _row = _qo.ordering[vendor];
            ['carrier', 'tracking', 'trackingNumbers', 'trackingType', 'trackingUrl', 'shopifyFulfillmentId', 'shipDate', 'shippedNoTracking'].forEach(function (k) { delete _row[k]; });
            _row.shipped = false;
          }
          if (_qo) _qo.onlineHasTracking = false;
          var _detailEl = document.getElementById('rqd-detail-' + ref);
          if (_detailEl && _qo) _detailEl.innerHTML = buildDetailHtml(_qo);
          refreshProgressBar(ref);
          if (_r && _r.customerWasTold) {
            rqdAlert(_offlineRow
              ? 'Tracking cleared. The customer was emailed that number' + (_r.toldAt ? ' on ' + formatDate(_r.toldAt) : '') + '. Enter the right number here; nothing is sent to the customer automatically, so send the correction as a reply on that email.'
              : 'Tracking cleared. The customer was emailed that number' + (_r.toldAt ? ' on ' + formatDate(_r.toldAt) : '') + ', so once the right number is recorded send the notice again as a correction.');
          }
        } catch (err) {
          btn.classList.add('rqd-vendor-tracking__remove--visible');
          rqdAlert('Could not clear the tracking: ' + (err && err.message ? err.message : 'unknown error'));
        }
        return;
      }

      // Offline rows: legacy auto-save behavior — uncheck the box, drop the
      // date span, and persist the cleared state to /quote-lifecycle.
      var checkEl = vendorItem.querySelector('.rqd-vendors__check');
      if (checkEl) {
        checkEl.classList.remove('rqd-vendors__check--done');
        var checkSpan = checkEl.querySelector('span');
        if (checkSpan) checkSpan.textContent = '';
      }
      var dateSpan = vendorItem.querySelector('.rqd-toggle__date');
      if (dateSpan) dateSpan.remove();

      var q = allQuotes.find(function(x){ return x.reference === ref; });
      var ordering = Object.assign({}, (q && q.ordering) || {});
      ordering[vendor] = {
        ordered: false, date: null,
        tracking: null, carrier: null, trackingType: null,
        shipped: false, shipDate: null,
      };
      try {
        await API.post('/quote-lifecycle', { ref: ref, ordering: ordering });
        if (q) q.ordering = ordering;
        refreshProgressBar(ref);
      } catch (err) {
        console.error('Clear shipment failed:', err);
      }
    }

    function scheduleTrackingSave(row) {
      var key = row.dataset.ref + ':' + row.dataset.vendor;
      if (_trackingSaveTimers[key]) clearTimeout(_trackingSaveTimers[key]);
      _trackingSaveTimers[key] = setTimeout(function() { doTrackingSave(row); }, 400);
    }

    async function doTrackingSave(row) {
      if (!row) return;
      var ref = row.dataset.ref;
      var vendor = row.dataset.vendor;
      var trackingInput = row.querySelector('.rqd-vendor-tracking__input');
      var carrierInput = row.querySelector('.rqd-vendor-tracking__carrier');
      var typeSelect = row.querySelector('.rqd-vendor-tracking__type');
      var typeOtherInput = row.querySelector('.rqd-vendor-tracking__type-other');
      var indicator = row.querySelector('.rqd-vendor-tracking__status');

      var tracking = trackingInput ? trackingInput.value.trim() : '';
      // Both online and offline rows now use the same free-typed
      // autocomplete <input>. carrier value reads directly from the
      // input — no more <select>+Other-input split for offline.
      var isOnlineRow = row.dataset.online === '1';
      // Online rows: shipping card values are NOT persisted on type/blur.
      // Save happens exclusively when the rep clicks Mark as Fulfilled and
      // confirms the modal — that's when the inputs commit to /quote-lifecycle
      // alongside the Shopify fulfillmentCreate response. Until then the
      // typed values live in the DOM only; the vendor's "ordered" check
      // also stays unchecked. Mirrors Shopify's fulfillment-form behavior
      // where typed values aren't persisted until you submit. Offline rows
      // keep the legacy auto-save + auto-check behavior since they have no
      // Mark Fulfilled step.
      if (isOnlineRow) return;
      var carrier = carrierInput ? carrierInput.value.trim() : '';
      // Online rows hide the tracking-type dropdown and force "Tracking #"
      // (Shopify only cares about the number; PRO/BOL/etc. are LTL freight
      // concepts that don't apply to online parcel orders).
      var typeRaw, trackingType;
      if (isOnlineRow) {
        trackingType = 'Tracking #';
      } else {
        typeRaw = typeSelect ? typeSelect.value : '';
        trackingType = typeRaw === 'Other' && typeOtherInput ? (typeOtherInput.value.trim() || 'Other') : typeRaw;
      }
      var urlInput = row.querySelector('.rqd-vendor-tracking__url');
      var trackingUrl = urlInput ? urlInput.value.trim() : '';
      // The vendor "ordered" checkbox in the Shipping card is read-only. Its
      // state is fully derived from the tracking fields:
      //   - all three filled (carrier + type + number) → auto-check
      //   - any of the three goes empty → auto-uncheck
      //   - red × button → clear all + uncheck (handleVendorShipmentClear)
      var allFilled = !!(carrier && trackingType && tracking);

      var q = allQuotes.find(function(x) { return x.reference === ref; });
      var ordering = Object.assign({}, (q && q.ordering) || {});
      var existing = ordering[vendor] || {};
      // Online rows: ord.shipped is the source-of-truth for the Flow strip's
      // 📦 step. Setting it true just from tracking entry was the cause of
      // rows showing "Done" in the To Do column before Mark Fulfilled was
      // ever clicked. Online shipped state is now driven exclusively by
      // shopifyFulfillmentId (set when the rep actually fulfills in Shopify
      // via /shopify-fulfillment-create). Offline rows still infer shipped
      // from tracking presence — there's no Shopify step on those.
      var shipped = isOnlineRow ? !!existing.shipped : !!tracking;
      // Skip the save (and the "Saving..." → "Saved ✓" indicator flash) when
      // nothing actually changed. Without this, just clicking into and out
      // of the carrier autocomplete fires focusout → scheduleTrackingSave
      // and the rep sees a save indicator for a no-op.
      var nothingChanged =
        (existing.tracking || '') === (tracking || '') &&
        (existing.carrier || '') === (carrier || '') &&
        (existing.trackingType || '') === (trackingType || '') &&
        (existing.trackingUrl || '') === (trackingUrl || '');
      if (nothingChanged) return;
      var shouldAutoOrder = allFilled && !existing.ordered;
      var shouldAutoUnorder = !allFilled && !!existing.ordered;
      var newOrdered = shouldAutoOrder ? true : (shouldAutoUnorder ? false : !!existing.ordered);
      ordering[vendor] = Object.assign({}, existing, {
        tracking: tracking || null,
        carrier: carrier || null,
        trackingType: trackingType || null,
        trackingUrl: trackingUrl || null,
        shipped: shipped,
        shipDate: shipped ? (existing.shipDate || todayStr()) : null,
        ordered: newOrdered,
        date: newOrdered ? (shouldAutoOrder ? todayStr() : (existing.date || todayStr())) : null,
      });

      if (indicator) indicator.textContent = 'Saving...';

      try {
        await API.post('/quote-lifecycle', { ref: ref, ordering: ordering });
        if (q) q.ordering = ordering;
        // Stash the URL template under the carrier name so next time the rep
        // picks this same carrier (on any order), the tracking-URL field
        // auto-fills. This save path is offline-only (online returns early
        // above + remembers via the Mark-as-Fulfilled handler), so the prior
        // `isOnlineRow &&` guard made this dead — drop it so offline freight
        // carriers (e.g. "FedEx Freight Priority") get remembered. Ryan 2026-05-27.
        if (carrier && trackingUrl) {
          rememberCarrierUrl(carrier, trackingUrl, tracking);
        }
        refreshProgressBar(ref);
        if (indicator) {
          indicator.textContent = 'Saved ✓';
          setTimeout(function() { if (indicator) indicator.textContent = ''; }, 2000);
        }

        // Reflect the new ordered state in the DOM without a full re-render.
        // Three transitions to handle: false→true (auto-check + add date),
        // true→false (auto-uncheck + remove date), and no-change (skip).
        var vendorItem = row.closest('.rqd-vendor-item');
        if (vendorItem) {
          var checkEl = vendorItem.querySelector('.rqd-vendors__check');
          var dateSpan = vendorItem.querySelector('.rqd-toggle__date');
          if (shouldAutoOrder && checkEl) {
            checkEl.classList.add('rqd-vendors__check--done');
            var checkSpan = checkEl.querySelector('span');
            if (checkSpan) checkSpan.textContent = '✓';
            if (!dateSpan) {
              dateSpan = document.createElement('span');
              dateSpan.className = 'rqd-toggle__date';
              var _ng = vendorItem.querySelector('.rqd-vendor-item__namegroup');
              var nameEl = vendorItem.querySelector('.rqd-vendor-item__name');
              if (_ng) {
                _ng.appendChild(dateSpan);
              } else if (nameEl && nameEl.nextSibling) {
                vendorItem.insertBefore(dateSpan, nameEl.nextSibling);
              } else {
                vendorItem.appendChild(dateSpan);
              }
            }
            dateSpan.textContent = formatDate(todayStr());
          } else if (shouldAutoUnorder && checkEl) {
            checkEl.classList.remove('rqd-vendors__check--done');
            var checkSpan2 = checkEl.querySelector('span');
            if (checkSpan2) checkSpan2.textContent = '';
            if (dateSpan) dateSpan.remove();
          }
        }
        // Toggle the red × visibility based on whether any field still has data.
        updateTrackingRemoveVisibility(row);
        /* CUSTOM_DDCARDCOUNT_BY_CLAUDE (Ryan 2026-09-26) — the row ghosts once a number is SAVED, not
           while it is being typed (the × above tracks keystrokes; this is the save's own answer). */
        row.classList.toggle('rqd-vendor-tracking--filled', !!tracking);

        // Auto-check Invoiced toggle when all vendors are now shipped — but
        // skip residential buyers and online orders (the row is already shown
        // as "n/a"; flipping it to a real ✓ would imply an invoice was
        // generated, which it wasn't).
        if (q && !q.invoiced && !isResidentialOrg(q.customerCompany) && q.source !== 'online') {
          var vendors = (q.financials || {}).vendors || [];
          var ord = q.ordering || {};
          var allShipped = vendors.length > 0 && vendors.every(function(v) { return ord[v] && ord[v].shipped; });
          if (allShipped) {
            // Visually check the Invoiced toggle
            var invoicedToggle = document.querySelector('.rqd-toggle[data-ref="' + ref + '"][data-field="invoiced"]');
            if (invoicedToggle && !invoicedToggle.classList.contains('rqd-toggle--done')) {
              invoicedToggle.classList.add('rqd-toggle--done');
              var check = invoicedToggle.querySelector('.rqd-toggle__check');
              if (check) check.innerHTML = '&#10003;';
              var dateSpan = document.createElement('span');
              dateSpan.className = 'rqd-toggle__date';
              dateSpan.textContent = formatDate(todayStr());
              invoicedToggle.appendChild(dateSpan);
            }
            q.invoiced = true;
            q.invoicedDate = todayStr();
            refreshProgressBar(ref);
          }
        }
      } catch (err) {
        console.error('Tracking save failed:', err);
        if (indicator) {
          indicator.textContent = 'Error';
          setTimeout(function() { if (indicator) indicator.textContent = ''; }, 3000);
        }
      }
    }

    // ── Install Scheduling Handler ──

    async function handleInstallSave(triggerEl) {
      var form = triggerEl.closest('.rqd-install-form');
      if (!form) return;
      var ref = form.dataset.ref;
      /* CUSTOM_DDINSTALL_BY_CLAUDE (Ryan 2026-09-02) — look the two controls up across the CARD,
         not inside the one row that fired.

         Scheduled and Install completed are now separate rows on the merged Installation card, and
         each has to carry its own `.rqd-vendor-tracking.rqd-install-form` — the delegated change
         listener finds the row with `closest('.rqd-vendor-tracking')` and then asks whether that
         element is an install form, so a shared wrapper would route the save to the tracking
         handler instead. Scoping the lookup to the card is what lets the two rows stay separate
         while one save still writes one `install` object. Falls back to the row when no card
         wrapper is present, so any other caller keeps working. */
      var scope = triggerEl.closest('[data-section-id="installation-quote"]') || form;
      var statusSelect = scope.querySelector('.rqd-install-form__status');
      var dateInput = scope.querySelector('.rqd-install-form__date');
      var indicator = form.querySelector('.rqd-vendor-tracking__status');
      /* ⛔ AN EMPTY SELECT IS "NOT YET", NOT AN EMPTY STATUS. The dropdown's unselected option
         carries value '' by design (Ryan: *"select yes or leave it unselected which means no"*),
         and writing that straight through would put `status: ''` on the lifecycle — a value the
         CLOSED gate reads as not-complete but nothing else recognises. */
      var newStatus = (statusSelect && statusSelect.value) ? statusSelect.value : 'pending';
      var scheduledDate = dateInput ? dateInput.value : null;

      var q = allQuotes.find(function(x) { return x.reference === ref; });
      var existing = (q && q.install) || {};
      var install = {
        required: true,
        status: newStatus,
        scheduledDate: scheduledDate || existing.scheduledDate || null,
        completedDate: newStatus === 'complete' ? (existing.completedDate || todayStr()) : null
      };

      if (indicator) indicator.textContent = 'Saving...';

      try {
        await API.post('/quote-lifecycle', { ref: ref, install: install });
        if (q) q.install = install;
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Re-render the detail panel from the
           canonical builder so the Installation card reflects the saved state
           exactly: the "Scheduled" checkbox checks + the date input ghosts
           (--filled) the moment a date is set. The previous in-place update
           keyed the checkbox off status==='complete' — but this card has no
           status <select>, so newStatus was always 'pending' and the box never
           checked — and it never added the --filled ghost class to the input,
           so picking a date left the step looking incomplete. Mirrors
           handleInstallAdd, single source of truth = buildDetailHtml. */
        var _detailEl = document.getElementById('rqd-detail-' + ref);
        if (_detailEl && q) { _detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(_detailEl, q); }
        refreshProgressBar(ref);
      } catch (err) {
        console.error('Install save failed:', err);
        if (indicator) {
          indicator.textContent = 'Error';
          setTimeout(function() { if (indicator) indicator.textContent = ''; }, 3000);
        }
      }
    }

    async function handleInstallAdd(btn) {
      var ref = btn.dataset.ref;
      var q = allQuotes.find(function(x) { return x.reference === ref; });
      var install = { required: true, status: 'pending', scheduledDate: null, completedDate: null };

      try {
        await API.post('/quote-lifecycle', { ref: ref, install: install });
        if (q) q.install = install;
        // Re-render the detail panel to show the form
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl && q) {
          detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q);
        }
      } catch (err) {
        console.error('Install add failed:', err);
        rqdAlert('Failed: ' + (err.message || 'Unknown error'));
      }
    }

    // ── Invoice Generate/Send ──

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — "Send Invoice" flow for sold-but-unpaid deals.
       Opens the shared Abby composer (orders@) addressed to the bill-to contact. When the invoice
       isn't generated yet, a preStep collects the due date (no browser prompt) and generates it on
       "Continue to email →" — same UX as the shipment-notification pop-up. The invoice is attached
       server-side from R2 on send (/send-invoice composer mode), which also stamps Invoiced. */
    /* ============================================
       CUSTOM_PAIDCOMPOSE_BY_CLAUDE (Ryan 2026-08-31) — THE LAST PAYMENT OPENS AN EMAIL
       ============================================
       Recording a payment that reaches the quote total used to mail the customer their paid
       invoice from inside the request — no prompt, nothing to read, nothing to decline. It now
       lands here instead: the worker PREPARES the invoice (suppressInvoiceEmail on
       /quote-lifecycle → PAID PDF, deal marked paid, nothing sent) and this opens the shared Abby
       composer over the top so the email can be read, edited, held, or not sent at all.

       Two callers, one flow: the AR/AP payment rows and the mark-sold modal. Both cross the same
       line and both must behave identically, so neither owns the copy.

       ⛔ THE PREPARE HAS ALREADY HAPPENED BY THE TIME WE GET HERE. So every exit from this
       function is safe: closing the composer, a failed preview, a dead modal, or the browser being
       shut — the money is recorded and the document exists either way. The only thing that varies
       is whether an email goes out. That ordering is deliberate; the reverse (compose first,
       record on send) would lose a recorded payment to a closed tab.

       ⚠️ EVERY FAILURE PATH STILL HAS TO SAY SO OUT LOUD. A composer that silently fails to open
       looks exactly like "no email was needed", and the deal reads fully paid either way. Each
       bail below names what happened AND how to send it later — which is why the AR/AP card
       grew a "Send Paid Invoice" button for a prepared-but-unsent paid invoice
       (dashboard-ar-ap-card.js). Without that button this would be a one-way door.
       ============================================ */
    function openPaidInvoiceCompose(ref) {
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) return;

      var _recovery = ' The payment is recorded and the paid invoice is generated —'
        + ' nothing was sent to the customer. Use "Send Paid Invoice" on the AR/AP card when ready.';

      if (!(window.RQD && typeof window.RQD.openComposeModal === 'function')) {
        rqdAlert('The email composer could not load.' + _recovery);
        return;
      }

      /* ⛔ WRITE THE EMAIL FOR WHEN IT ARRIVES. The paid body says "The final payment came in
         earlier today". The ⏱ box defaults to TICKED, so composing at 9pm means the customer
         reads that sentence at 6am tomorrow, about yesterday. Ask the worker for the copy with
         the clock the send will actually use. Inside the window the two are the same instant and
         this is a no-op, which is the common case — payments get recorded during the day. */
      var _held = 0;
      try {
        if (typeof window.RQD.nextSendWindowMs === 'function') {
          var _w = window.RQD.nextSendWindowMs();
          if (_w > Date.now() + 60000) _held = _w;
        }
      } catch (_) { /* fall back to now */ }

      /* CUSTOM_PAIDCOMPOSE_BY_CLAUDE (Ryan 2026-09-06, RW-1367-B) — ⛔ THE PREPARE IS NOT ALWAYS
         DONE WHEN WE GET HERE. The header above says it is; on the mark-sold path the worker
         generates the PAID PDF inside ctx.waitUntil, i.e. AFTER it has answered the browser, and
         this preview call landed ~3s before `invoice.generated` was stamped. The worker answered
         "Invoice must be generated before sending", the notice fired, and the composer never
         opened — for a deal that was, three seconds later, fully prepared. So: when the ONLY
         thing wrong is that the invoice is not there yet, wait and ask again (1.5s apart, up to
         ~12s). Any other error still fails loudly on the first answer; the bail text is unchanged. */
      var _attempt = 0;
      function _preview() {
        return API.post('/send-invoice', { ref: ref, preview: true, nowMs: _held || Date.now() })
          .then(function (pr) {
            if (pr && pr.ok) return pr;
            var m = (pr && pr.error) || 'preview unavailable';
            if (/must be generated/i.test(m) && _attempt < 8) {
              _attempt++;
              return new Promise(function (res) { setTimeout(res, 1500); }).then(_preview);
            }
            throw new Error(m);
          });
      }
      _preview()
        .then(function (pr) { _openPaidComposer(ref, q, pr, _held); })
        .catch(function (err) {
          rqdAlert('The email preview failed (' + ((err && err.message) || 'unknown') + ').' + _recovery);
        });
    }

    function _openPaidComposer(ref, q, pr, heldMs) {
      var payments = q.payments || [];
      var totalPaid = 0;
      for (var i = 0; i < payments.length; i++) totalPaid += parseFloat(payments[i].amount) || 0;
      var qTotal = parseFloat(q.total || q.quoteAmount || q.amount || 0);
      var last = payments[payments.length - 1] || {};
      var balance = Math.round((qTotal - totalPaid) * 100) / 100;

      var _row = function (label, value) {
        return '<div style="color:var(--rq-text-secondary);font-weight:600;">' + esc(label) + '</div>'
          + '<div>' + value + '</div>';
      };
      var _preHtml = [
        '<div style="display:grid;grid-template-columns:auto 1fr;column-gap:12px;row-gap:6px;font-size:13px;">',
          _row('Payment', money(parseFloat(last.amount) || 0) + (last.method ? ' &middot; ' + esc(last.method) : '')
            + (last.date ? ' &middot; ' + esc(last.date) : '')),
          _row('Paid to date', money(totalPaid) + ' of ' + money(qTotal)),
          _row('Balance', balance <= 0
            ? '<strong>Paid in full</strong>'
            : money(balance)),
        '</div>',
        /* Same shape as Mark-as-Fulfilled's notify control: ticked by default, and unticking it
           turns the Continue button into a plain Done. Nothing here re-records the payment. */
        '<label style="display:flex;align-items:center;gap:8px;margin-top:18px;font-size:13px;font-weight:600;cursor:pointer;">',
          '<input type="checkbox" id="rqd-paid-notify" checked style="width:auto;margin:0;cursor:inherit;">',
          '<span>Email the customer their paid invoice</span>',
        '</label>',
        '<div style="margin-top:6px;color:var(--rq-text-secondary,#5a6b7d);font-size:11px;">',
          'Leave this off to record the payment quietly. The invoice is generated either way, and',
          ' you can send it later from the AR/AP card.',
        '</div>',
      ].join('');

      window.RQD.openComposeModal({
        ref: ref,
        emailType: 'invoice-paid',
        enterFrom: 'right',
        fromOptions: ['ABBY'],          // paid invoice is Abby's, same as every other invoice mail
        showBusinessHours: true,        // the ⏱ box — /send-invoice already holds + drains these
        suppressFollowUp: true,
        followUpDefaultNa: true,
        suppressAttachmentGuard: true,
        /* A receipt is not a negotiation — no cadence, and no sequence arming (openComposeModal
           refuses that behind a sendOverride anyway; this is belt and braces). */
        noticeHtml: heldMs
          ? 'Held for business hours, so this is written for when it arrives (' + esc(_paidHeldLabel(heldMs)) + '). Untick the ⏱ to send it now — check the wording if you do.'
          : undefined,
        prefillTo: pr.to || '',
        prefillCc: pr.cc || [],
        prefillSubject: pr.subject || '',
        prefillBody: pr.bodyHtml || '',
        // The worker attaches the real PDF from R2 on send; this is the visible locked pill.
        preAttachments: [{ name: 'PAID-INVOICE-' + ref + '.pdf', locked: true, displayOnly: true }],
        preStep: {
          title: 'Payment recorded',
          continueLabel: 'Continue to email →',
          html: _preHtml,
          onMount: function (panel) {
            var notify = panel.querySelector('#rqd-paid-notify');
            var contBtn = panel.querySelector('#rqd-prestep-continue');
            if (!notify || !contBtn) return;
            var _sync = function (checked) { contBtn.textContent = checked ? 'Continue to email →' : 'Done'; };
            _sync(notify.checked);
            notify.addEventListener('change', function () { _sync(this.checked); });
          },
          onContinue: function (panel) {
            var notify = panel.querySelector('#rqd-paid-notify');
            if (!notify || notify.checked) return true;   // → the universal compose step
            // Not notifying. The payment and the PDF are already done, so there is no work to
            // run here — just close, the way Mark-as-Fulfilled does on notify-off.
            var cancelBtn = panel.querySelector('#rqd-prestep-cancel');
            if (cancelBtn) cancelBtn.click();
            return false;
          },
        },
        sendOverride: function (args) {
          if (args.isTest) {
            var sess = {};
            try { sess = JSON.parse(sessionStorage.getItem('rep_portal_session') || '{}'); } catch (_) {}
            return API.post('/send-invoice', { ref: ref, composer: true, test: true, testTo: sess.email || '', subject: args.subject, html: args.bodyHtml })
              .then(function (r) { if (!(r && r.success)) throw new Error((r && r.error) || 'Test send failed'); });
          }
          /* ⛔ Bcc SEPARATE FROM Cc. Folding them is what put a Bcc'd address in the customer's
             visible header on the due-invoice composer (fixed 2026-08-29); the worker unions
             body.bcc into the invoice Bcc. */
          return API.post('/send-invoice', {
            ref: ref, composer: true,
            to: args.to, cc: (args.cc || []), bcc: (args.bcc || []),
            subject: args.subject, html: args.bodyHtml,
            businessHoursOnly: args.businessHoursOnly === true,
          }).then(function (r) {
            if (!(r && r.success)) throw new Error((r && r.error) || 'Send failed');
            if (q.invoice) {
              if (r.scheduled) { q.invoice.scheduledFor = r.sendAfter || null; }
              else { q.invoice.sentDate = new Date().toISOString(); q.invoice.sentKind = 'paid'; q.invoice.scheduledFor = null; }
            }
            var _el = document.getElementById('rqd-detail-' + ref);
            if (_el) { _el.innerHTML = buildDetailHtml(q); applyCollapseState(_el, q); _el.classList.add('rqd-detail--open'); }
            refreshProgressBar(ref);
          });
        },
      });
    }

    /* "tomorrow morning" / "this morning" — deliberately not a minute. The worker jitters the
       exact time off a queue key that does not exist yet, so naming one here would be a promise
       made by the half of the system that is not keeping it. Mirrors _heldWhenLabel in
       dashboard-email-modal.js. */
    function _paidHeldLabel(ms) {
      try {
        var f = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Denver', day: '2-digit' });
        return f.format(new Date(ms)) === f.format(new Date()) ? 'this morning' : 'tomorrow morning';
      } catch (_) { return 'the next business-hours window'; }
    }

    function handleInvoiceSendCompose(btn) {
      var ref = btn.dataset.ref;
      if (!ref) return;
      var q = allQuotes.find(function (x) { return x.reference === ref; });
      if (!q) return;
      if (!(window.RQD && typeof window.RQD.openComposeModal === 'function')) {
        rqdAlert('Email composer unavailable — reload the page and try again.');
        return;
      }

      // Recipients: bill-to (fallback sold-to); CC sold-to when different.
      var billTo = (q.billTo && q.billTo.email) ? q.billTo.email : (q.customerEmail || '');
      var soldTo = q.customerEmail || '';
      var ccList = (soldTo && billTo && soldTo.toLowerCase() !== billTo.toLowerCase()) ? [soldTo] : [];
      var billName = (q.billTo && q.billTo.name) || q.customer || '';
      var billFirst = String(billName).trim().split(/\s+/)[0] || 'there';
      var _escFirst = billFirst.replace(/[<>&"]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]; });

      // Soft Abby template (Abby's signature is appended server-side on send).
      var _escRef = String(ref).replace(/[<>&"]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]; });
      var bodyHtml = '<p>Hi ' + _escFirst + ',</p><p><br></p>'
        + '<p>Please find your invoice attached for order number ' + _escRef + '.</p><p><br></p>'
        + '<p>The payment options are listed on the last page. Please reach out if you have any questions.</p>';

      // Skip the due-date step only once the invoice has actually been SENT (Resend). A merely
      // generated-but-unsent draft still re-runs the step so the rep can set/adjust the due date.
      var alreadySent = !!(q.invoice && q.invoice.sentDate);
      var _preHtml = ''
        + '<div style="font-size:13px;color:var(--rq-text);">'
        +   '<label style="display:block;font-weight:600;margin-bottom:6px;">Due in how many days?</label>'
        +   '<input type="text" id="rqd-inv-due-input" value="30" autocomplete="off" style="width:170px;padding:6px 8px;border-radius:6px;border:1px solid var(--rq-border,#2a3a4d);background:var(--rq-input-bg,#ffffff);color:var(--rq-text,#000F1C);font-size:13px;">'
        +   '<div style="margin-top:8px;color:var(--rq-text-secondary,#5a6b7d);font-size:11px;">A number of days (e.g. 5, 15, 30), or an absolute date (e.g. 5/20/2026). Blank uses the order terms.</div>'
        +   '<div id="rqd-inv-due-err" style="margin-top:6px;color:#dc2626;font-size:12px;"></div>'
        + '</div>';

      window.RQD.openComposeModal({
        ref: ref,
        emailType: 'invoice-send',
        fromOptions: ['ABBY'],
        /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-08-28) — the ⏱ box. /send-invoice holds a ticked
           send in `pending-invoice-email:{ref}` and the five-minute drain mails it when the window
           opens; see the hold in invoicing-routes.js. An invoice landing in a customer's inbox at
           2am is the exact thing this checkbox exists to stop. */
        showBusinessHours: true,
        prefillTo: billTo,
        prefillCc: ccList,
        prefillSubject: 'Invoice from Blue Sky Fitness Supply - ' + ref,
        prefillBody: bodyHtml,
        // Server attaches the real PDF from R2 on send; this is the visible (locked) pill.
        preAttachments: [{ name: 'Invoice ' + ref + '.pdf', locked: true, displayOnly: true }],
        preStep: alreadySent ? undefined : {
          title: 'Send Invoice',
          continueLabel: 'Continue to email →',
          html: _preHtml,
          onContinue: function (panel) {
            if (panel.dataset.generated === '1') return true;   // 2nd pass (post-generate) → advance
            var input = panel.querySelector('#rqd-inv-due-input');
            var errEl = panel.querySelector('#rqd-inv-due-err');
            var contBtn = panel.querySelector('#rqd-prestep-continue');
            var val = (input && input.value || '').trim();
            var genPayload = { ref: ref, draft: true };   // draft → builds the PDF without marking Invoiced
            if (val) {
              if (/^\d+$/.test(val)) { genPayload.dueInDays = parseInt(val, 10); }
              else {
                var _d = new Date(val);
                if (isNaN(_d.getTime())) { if (errEl) errEl.textContent = 'Enter a number of days or a date like 5/20/2026.'; return false; }
                genPayload.dueDate = _d.getFullYear() + '-' + String(_d.getMonth() + 1).padStart(2, '0') + '-' + String(_d.getDate()).padStart(2, '0');
              }
            }
            if (errEl) errEl.textContent = '';
            if (contBtn) { contBtn.disabled = true; contBtn.textContent = 'Generating…'; }
            API.post('/generate-invoice', genPayload).then(function (genResult) {
              q.invoice = genResult.invoice; q.invoiced = false; q.invoicedDate = null;   // draft → not invoiced until sent
              var _dEl = document.getElementById('rqd-detail-' + ref);   // reflect the unchecked box underneath the modal
              if (_dEl) { _dEl.innerHTML = buildDetailHtml(q); applyCollapseState(_dEl, q); }
              panel.dataset.generated = '1';
              if (contBtn) { contBtn.disabled = false; contBtn.textContent = 'Continue to email →'; contBtn.click(); }
            }).catch(function (err) {
              if (contBtn) { contBtn.disabled = false; contBtn.textContent = 'Continue to email →'; }
              if (errEl) errEl.textContent = 'Could not generate the invoice: ' + (err && err.message ? err.message : 'unknown error');
            });
            return false;   // stay during the async generate; the re-click above advances
          },
        },
        sendOverride: function (args) {
          if (args.isTest) {
            var sess = {}; try { sess = JSON.parse(sessionStorage.getItem('rep_portal_session') || '{}'); } catch (_) {}
            return API.post('/send-invoice', { ref: ref, composer: true, test: true, testTo: sess.email || '', subject: args.subject, html: args.bodyHtml })
              .then(function (r) { if (!(r && r.success)) throw new Error((r && r.error) || 'Test send failed'); });
          }
          /* ⛔ Bcc IS NOT Cc. This folded the two together, so anything the admin typed into Bcc
             on a CUSTOMER invoice went out in the visible Cc header — the customer could read it.
             It was the last survivor of that class: the same fold was removed from the
             fulfillment notice, the shipping notice and the samples notice on 2026-08-27
             (dashboard-handshake.js:1076 / :1697 / :2278 are the reference implementations).
             It also poisoned the server's own dedupe — resolveInvoiceBcc skips Ryan when he is
             already a visible recipient, so a Bcc'd Ryan arriving as a Cc suppressed his Bcc and
             put him on the customer's header instead. Found 2026-08-29 while tracing an unrelated
             vendor-email Bcc; sent separately now, and the worker unions it into the invoice Bcc. */
          return API.post('/send-invoice', { ref: ref, composer: true, to: args.to, cc: (args.cc || []), bcc: (args.bcc || []), subject: args.subject, html: args.bodyHtml, businessHoursOnly: args.businessHoursOnly === true }).then(function (r) {
            if (!(r && r.success)) throw new Error((r && r.error) || 'Send failed');
            /* CUSTOM_SENDWINDOW_BY_CLAUDE (Ryan 2026-08-28) — ⛔ A HELD INVOICE IS NOT AN INVOICED DEAL.
               Unlike a held freight request (which stamps `requested` immediately so nobody asks the
               supplier twice), "Invoiced" is a FINANCIAL state: the customer has not been billed until
               the mail actually leaves. Flipping it here would put the deal in the invoiced column, out
               of the follow-up queue, and into the paid-on-terms clock hours before anybody was asked
               for money. So a scheduled send records only when it goes out — the same reason a
               scheduled PO reads SCHEDULED rather than Sent. */
            if (r && r.scheduled) {
              if (q.invoice) { q.invoice.scheduledFor = r.sendAfter || null; }
              var _sEl = document.getElementById('rqd-detail-' + ref);
              if (_sEl) { _sEl.innerHTML = buildDetailHtml(q); applyCollapseState(_sEl, q); _sEl.classList.add('rqd-detail--open'); }
              refreshProgressBar(ref);
              return;
            }
            if (q.invoice) { q.invoice.sentTo = (r && r.sentTo) || billTo; q.invoice.sentDate = new Date().toISOString(); q.invoice.scheduledFor = null; }
            q.invoiced = true;
            // CUSTOM_SENTITEMS_BY_CLAUDE (Ryan 2026-08-28) — resolved below with the transport note.
            var _invNote = (window.RQD && window.RQD.transportNote) ? window.RQD.transportNote(r) : '';
            var detailEl = document.getElementById('rqd-detail-' + ref);
            if (detailEl) { detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q); detailEl.classList.add('rqd-detail--open'); }
            refreshProgressBar(ref);
            if (_invNote) return { composerNote: _invNote };
          });
        },
      });
    }

    async function handleInvoiceGenerate(btn) {
      var ref = btn.dataset.ref;
      var isManual = btn.dataset.manual === '1';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Per-invoice due-date picker. Single
         prompt accepts either a day count (e.g. "30" / "5") or an
         absolute date (e.g. "5/20/2026"). Cancel aborts the whole generate
         so accidental clicks don't fire the PDF + lifecycle write.
         (Ryan 2026-08-14) — extracted into promptInvoiceDueDate, now shared
         with the cog's Generate Invoice. Blank no longer re-derives from
         terms on a deal that already has a due date; it KEEPS that date, so
         regenerating to pick up new freight can't silently move it. */
      var _qGen = allQuotes.find(function(x) { return x.reference === ref; });
      var _dueFields = await promptInvoiceDueDate(ref, { currentDueDate: currentDueDateLabel(_qGen) });
      if (_dueFields === null) return; // Cancel / unparseable → abort
      var payload = Object.assign({ ref: ref, manuallyRequested: isManual }, _dueFields);
      btn.disabled = true;
      btn.textContent = 'Generating...';
      try {
        var result = await API.post('/generate-invoice', payload);
        var q = allQuotes.find(function(x) { return x.reference === ref; });
        if (q) {
          q.invoice = result.invoice;
          q.invoiced = true;
          q.invoicedDate = result.invoice.generatedDate;
        }
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl && q) {
          detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q);
          detailEl.classList.add('rqd-detail--open');
        }
        refreshProgressBar(ref);
      } catch (err) {
        rqdAlert('Failed to generate invoice: ' + (err.message || 'Unknown error'));
        btn.textContent = 'Generate Invoice';
        btn.disabled = false;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Void invoice. Admin clears the
       lifecycle.invoice record so the AR/AP row reverts to its
       pre-generate state. Worker blocks if the invoice has been sent
       (sentDate present). */
    async function handleInvoiceVoid(btn) {
      var ref = btn.dataset.ref;
      if (!ref) return;
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — in-DOM confirm. Verified async before
         adding the await: a missing one yields a Promise, which is truthy, and this guard would
         silently stop guarding a destructive action. */
      if (!(await rqdConfirm(
        'Clears the invoice record so the AR/AP row goes back to "Generate Invoice". The PDF in R2 '
          + 'is preserved for audit. If the invoice was already emailed to the customer this will '
          + 'be rejected - generate a corrected invoice and send a manual cancellation note instead.',
        { title: 'Void invoice for ' + ref + '?', confirmLabel: 'Void invoice', danger: true }
      ))) return;
      btn.disabled = true;
      var origText = btn.textContent;
      btn.textContent = 'Voiding…';
      try {
        await API.post('/void-invoice', { ref: ref });
        var q = allQuotes.find(function(x) { return x.reference === ref; });
        if (q) {
          q.invoice = null;
          q.invoiced = false;
          q.invoicedDate = null;
        }
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl && q) {
          detailEl.innerHTML = buildDetailHtml(q);
          applyCollapseState(detailEl, q);
        }
        refreshProgressBar(ref);
      } catch (err) {
        rqdAlert('Void failed: ' + (err && err.message ? err.message : 'unknown error'));
        btn.disabled = false;
        btn.textContent = origText;
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    async function handleInvoiceSend(btn) {
      var ref = btn.dataset.ref;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Sending...';
      try {
        var result = await API.post('/send-invoice', { ref: ref });
        var q = allQuotes.find(function(x) { return x.reference === ref; });
        if (q && q.invoice) {
          q.invoice.sentTo = result.sentTo;
          q.invoice.sentDate = new Date().toISOString();
        }
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl && q) {
          detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q);
          detailEl.classList.add('rqd-detail--open');
        }
      } catch (err) {
        rqdAlert('Failed to send invoice: ' + (err.message || 'Unknown error'));
        btn.textContent = originalText;
        btn.disabled = false;
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Phase 3: + New dropdown chooser + Lead modal */

    // ── + New dropdown menu toggle ──
    window.__toggleNewMenu = function(e) {
      if (e) e.stopPropagation();
      var menu = document.getElementById('rqd-new-menu');
      if (!menu) return;
      if (menu.style.display === 'block') {
        menu.style.display = 'none';
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Swap the menu options
         based on which dashboard source is active. Prospecting mode hides
         the rep-side Phone/Email/Sample/Pending Lead options and shows the
         CFA-side Manual / Import options. */
      var inProspecting = currentSource === 'prospecting';
      menu.querySelectorAll('.rqd-new-menu__opt').forEach(function(opt) {
        var isProspectOpt = opt.classList.contains('rqd-new-menu__opt--prospect');
        opt.style.display = (inProspecting === isProspectOpt) ? '' : 'none';
      });
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — On mobile the
         menu lives inside `.rqd-filters` which has `overflow-x: auto`
         for horizontal scroll. Per spec, any non-visible overflow on
         one axis forces the other axis to also clip — so the menu
         (position: absolute below the trigger) was rendering but
         invisible (clipped by the scroll container).
         Fix: on mobile, swap to `position: fixed` and compute coords
         from the toggle button's bounding rect. The menu reads from
         the same DOM node but escapes the scroll container. On
         desktop the original absolute positioning still applies. */
      var toggleBtn = document.getElementById('rqd-new-toggle');
      var isMobile = toggleBtn && window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — On the Deal
         Prospecting tab the .rqd-new-wrap lives inside the prospect
         filter bar which has overflow-x: auto for horizontal scroll.
         That clips the absolutely-positioned dropdown the same way the
         filter row's overflow does on mobile. Force the fixed-position
         escape hatch on prospecting too. */
      var inProspecting = (typeof currentSource !== 'undefined') && currentSource === 'prospecting';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — On mobile the menu is
         no longer a dropdown anchored under the trigger: it's a bottom-sheet
         popup, to match how the deal-type / Name / Date selects surface their
         native OS picker. Anchoring under a full-width + New button left a
         cramped 220px card floating against the right edge.
         The dimmer is a giant spread box-shadow rather than a backdrop
         element. That matters: the menu is closed from six places (this
         toggle, the outside-click listener, and four openers across
         dashboard-lead-create.js + this file), so a real backdrop div would
         need teardown in all six — miss one and a dead overlay eats every
         tap on the page. The shadow is painted by the menu itself, so it
         cannot outlive it. Taps still fall through the dim to the
         outside-click listener, which closes the menu — same as today's
         no-backdrop behaviour, so nothing regresses.
         NOTE: the branches below are `isMobile` FIRST, then `inProspecting`.
         They used to share one branch, but inProspecting forces fixed
         positioning on DESKTOP too (the prospect filter bar's overflow-x
         clips an absolute menu), so folding the sheet in with it would turn
         the desktop prospecting menu into a bottom sheet. */
      if (isMobile) {
        menu.style.position = 'fixed';
        menu.style.top = 'auto';
        menu.style.bottom = '12px';
        menu.style.left = '12px';
        menu.style.right = '12px';
        menu.style.maxHeight = '70vh';
        menu.style.overflowY = 'auto';
        menu.style.zIndex = '10000';
        menu.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15), 0 0 0 100vmax rgba(0,0,0,0.45)';
      } else if (inProspecting && toggleBtn) {
        var rect = toggleBtn.getBoundingClientRect();
        menu.style.position = 'fixed';
        menu.style.top = (rect.bottom + 6) + 'px';
        // Right-align with the button; clamp to viewport so it doesn't
        // overflow off-screen at the right edge.
        var rightPx = Math.max(8, window.innerWidth - rect.right);
        menu.style.right = rightPx + 'px';
        menu.style.left = 'auto';
        menu.style.bottom = 'auto';
        menu.style.maxHeight = '';
        menu.style.overflowY = '';
        menu.style.zIndex = '10000';
        menu.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15)';
      } else {
        // Reset to inline-style defaults in case we'd switched to fixed
        // earlier in the same session (rotate / resize edge case).
        menu.style.position = 'absolute';
        menu.style.top = '100%';
        menu.style.right = '0';
        menu.style.left = 'auto';
        menu.style.bottom = 'auto';
        menu.style.maxHeight = '';
        menu.style.overflowY = '';
        menu.style.zIndex = '100';
        menu.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15)';
      }
      menu.style.display = 'block';
    };

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Edit Sold To modal for pre-quote leads.
       Opened from the pencil button on the Sold To card. Same shape as
       __openNewLead but pre-filled with q.customer* values and posts to
       /lead-customer-update on save (PATCH semantics — empty string clears
       a field, omitting it leaves it alone). Once a lead has become a
       quote (lifecycleStatus set), the workstation owns the customer block
       and this modal is hidden — see the qIsEditableLead gate in
       buildDetailHtml. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — Edit Deal Terms popup.
       Opens from the Financials-card pencil on PENDING + QUOTED deals. Reads the
       QW "Terms & Options" via GET /deal-terms, lets the rep adjust Deal Type,
       Shared With + %, CFA, Lead Source + Referred By, Payment Terms, Lead Time,
       Expiration, and saves via POST /deal-terms-update (patches pending or wm).
       Built so a rep can set terms on a pending deal BEFORE building a quote. */
    window.__openEditTerms = function(q) {
      if (!q || !q.reference) return;
      var sess = window.RepPortal && window.RepPortal.Auth.getSession();
      if (sess && sess.role === 'cfa') return;
      var refStr = q.reference;
      modalTitle.textContent = 'Edit Deal Terms — ' + refStr;
      modalSub.textContent = 'Adjust Terms & Options without opening the Quote Workstation.';
      modalEl.classList.add('rqd-modal--wide');
      modalConfirm.textContent = 'Save';
      modalConfirm.disabled = true;
      modalBody.innerHTML = '<div style="padding:24px;text-align:center;color:var(--rq-text-secondary);">Loading…</div>';
      modalBackdrop.classList.add('rqd-modal-backdrop--open');
      pendingStatusChange = { _isTermsEdit: true, ref: refStr };

      var LEADTIME_PRESETS = ['Approx. 2 Weeks','Approx. 2-4 Weeks','Approx. 3-5 Weeks','Approx. 4-6 Weeks','Approx. 6-8 Weeks','Approx. 8-10 Weeks','Approx. 10-12 Weeks','Approx. 12-14 Weeks','Approx. 15+ Weeks'];

      function buildSelect(id, current, opts) {
        var h = '<select class="rqd-modal__input" id="' + id + '">';
        opts.forEach(function(o) {
          h += '<option value="' + esc(o.v) + '"' + (String(o.v) === String(current == null ? '' : current) ? ' selected' : '') + '>' + esc(o.l) + '</option>';
        });
        return h + '</select>';
      }

      Promise.all([
        window.RepPortal.API.get('/deal-terms?ref=' + encodeURIComponent(refStr)),
        window.RepPortal.API.get('/cfa-list').catch(function() { return { cfas: [] }; })
      ]).then(function(res) {
        var t = res[0] || {};
        var cfas = (res[1] && res[1].cfas) || [];
        var ref0 = (t.referral && t.referral.name) ? t.referral : { name: '', gpPercent: '' };

        var ltOpts = [{ v: '', l: '-- Select --' }];
        if (t.leadTime && LEADTIME_PRESETS.indexOf(t.leadTime) === -1) ltOpts.push({ v: t.leadTime, l: t.leadTime + ' (custom)' });
        LEADTIME_PRESETS.forEach(function(p) { ltOpts.push({ v: p, l: p }); });

        var cfaOpts = [{ v: '', l: '-- Select --' }, { v: 'none', l: 'None' }];
        cfas.forEach(function(c) { cfaOpts.push({ v: c.code, l: c.fullName || c.name || c.code }); });

        var isShared = t.leadSource === 'shared';
        var html = '';
        html += '<label class="rqd-modal__label" style="margin-top:0;">Deal Type</label>';
        html += buildSelect('rqd-terms-dealtype', t.leadSource, [
          { v: '', l: '-- Select --' }, { v: 'inbound', l: 'Inbound Deal (Company Sourced)' },
          { v: 'outbound', l: 'Outbound Deal (Rep Sourced)' }, { v: 'shared', l: 'Shared Deal' }
        ]);
        // Block A — Shared With + % of GP (Shared Deal only)
        html += '<div id="rqd-terms-shared-block" style="display:' + (isShared ? '' : 'none') + ';margin-top:10px;padding:10px;border:1px solid var(--rq-border);border-radius:6px;background:var(--rq-bg-section);">';
        html += '<div style="display:grid;grid-template-columns:2fr 1fr;gap:10px;">';
        html += '<div><label class="rqd-modal__label" style="margin-top:0;">Shared With</label><input type="text" class="rqd-modal__input" id="rqd-terms-shared-name" maxlength="80" placeholder="e.g. John Smith" value="' + esc(ref0.name) + '"></div>';
        html += '<div><label class="rqd-modal__label" style="margin-top:0;">% of GP</label><input type="number" class="rqd-modal__input" id="rqd-terms-shared-pct" min="0" max="100" step="0.5" placeholder="10" value="' + esc(ref0.gpPercent ? ref0.gpPercent : '') + '"></div>';
        html += '</div><p style="margin:8px 0 0;font-size:11px;color:var(--rq-text-secondary);">This partner is paid the entered % of GP-of-Goods as a commission share.</p></div>';
        html += '<label class="rqd-modal__label">CFA Attribution</label>';
        html += buildSelect('rqd-terms-cfa', t.cfaAttribution, cfaOpts);
        /* CUSTOM_MARKETINGOPS_BY_CLAUDE (2026-07-24, DNI decoupling piece 3) — the Lead Source
           select + its Referred By block were REMOVED here. This modal was the SECOND door onto
           wm.leadContext.source (the Quote Workstation dropdown was the first, the +New Pending
           form the third): as long as any of them survived, a rep pick could still decide a deal's
           marketing source. Origin is now derived server-side from hard signals. Who referred us
           on a non-shared deal goes in the deal's Notes. Deal Type + the PAID Shared Deal recipient
           stay — they are commission fields and no longer touch attribution. */
        html += '<label class="rqd-modal__label">Payment Terms</label>';
        html += buildSelect('rqd-terms-terms', t.terms, [
          { v: '', l: '-- Select --' }, { v: 'Pay in Full', l: 'Pay in Full' }, { v: '50/50', l: '50/50' },
          { v: '50/50 Net 30', l: '50/50 Net 30' }, { v: 'Net 30', l: 'Net 30' }
        ]);
        html += '<label class="rqd-modal__label">Estimated Lead Time</label>';
        html += buildSelect('rqd-terms-leadtime', t.leadTime, ltOpts);
        html += '<label class="rqd-modal__label">Quote Expiration</label>';
        html += '<input type="date" class="rqd-modal__input" id="rqd-terms-expiration" value="' + esc(t.expiration || '') + '">';
        modalBody.innerHTML = html;
        modalConfirm.disabled = false;

        // Show/hide the Shared Deal recipient block as Deal Type changes.
        var dtSel = document.getElementById('rqd-terms-dealtype');
        var sharedBlk = document.getElementById('rqd-terms-shared-block');
        if (dtSel) dtSel.addEventListener('change', function() { sharedBlk.style.display = (this.value === 'shared') ? '' : 'none'; });
      }).catch(function(err) {
        modalBody.innerHTML = '<div style="padding:20px;color:#dc2626;">Failed to load deal terms: ' + esc((err && err.message) || 'error') + '</div>';
      });
    };
    /* CUSTOM_SHIPTOPENCIL_BY_CLAUDE (Ryan 2026-10-02, RW-1339-A) — Edit Ship To. Opened by the card
       pencil while the Ship To tab is active. Posts /lead-customer-update with pane:'ship', which
       patches only wm.customer.ship* and moves the draft's shipping address; Sold To is untouched. */
    window.__openEditShipTo = function(q) {
      if (!q || !q.reference) return;
      var sess = window.RepPortal && window.RepPortal.Auth.getSession();
      if (sess && sess.role === 'cfa') return;
      var st = q.shipTo || {};
      function v(x) { return x == null ? '' : String(x); }
      function field(label, id, val, attrs) {
        return '<label class="rqd-modal__label">' + label + '</label>' +
          '<input type="text" class="rqd-modal__input" id="' + id + '" value="' + esc(v(val)) + '"' + (attrs || '') + '>';
      }
      modalTitle.textContent = 'Edit Ship To — ' + q.reference;
      modalSub.textContent = 'Where the goods go. The Sold To is not changed.';
      modalEl.classList.add('rqd-modal--wide');
      modalConfirm.textContent = 'Save';
      modalConfirm.disabled = false;
      var html = '';
      if (q.lifecycleStatus === 'sold') {
        html += '<div style="background:#fef3c7;border:1px solid #f59e0b;color:#92400e;padding:10px 12px;border-radius:6px;font-size:12px;margin-bottom:14px;line-height:1.45;">';
        html += '⚠ This deal is sold. Anything already shipped is not redirected. Purchase orders sent before this change still show the old address, so tell the supplier if a shipment has not left yet.';
        html += '</div>';
      }
      html += field('Contact Name', 'rqd-edit-ship-name', st.name).replace('<label class="rqd-modal__label">', '<label class="rqd-modal__label" style="margin-top:0;">');
      html += field('Organization', 'rqd-edit-ship-company', st.company);
      html += field('Street 1', 'rqd-edit-ship-street1', st.street, ' placeholder="123 Main St"');
      html += field('Street 2', 'rqd-edit-ship-street2', st.street2, ' placeholder="Suite 200"');
      html += field('Zip Code', 'rqd-edit-ship-zip', st.zip, ' maxlength="10" inputmode="numeric"');
      html += field('City', 'rqd-edit-ship-city', st.city);
      html += field('State', 'rqd-edit-ship-state', st.state, ' maxlength="2" style="text-transform:uppercase;"');
      html += field('Phone', 'rqd-edit-ship-phone', st.phone);
      html += field('Email', 'rqd-edit-ship-email', st.email);
      modalBody.innerHTML = html;
      (function() {
        var zipEl = document.getElementById('rqd-edit-ship-zip');
        if (!zipEl) return;
        zipEl.addEventListener('blur', function() {
          var zip = this.value.trim();
          if (!/^\d{5}$/.test(zip)) return;
          fetch('https://api.zippopotam.us/us/' + zip)
            .then(function(r) { return r.ok ? r.json() : null; })
            .then(function(data) {
              if (!data || !data.places || !data.places[0]) return;
              var p = data.places[0];
              var c = document.getElementById('rqd-edit-ship-city');
              var s = document.getElementById('rqd-edit-ship-state');
              if (c && !c.value) c.value = p['place name'] || '';
              if (s && !s.value) s.value = p['state abbreviation'] || '';
            })
            .catch(function() {});
        });
      })();
      modalBackdrop.classList.add('rqd-modal-backdrop--open');
      pendingStatusChange = { _isShipToEdit: true, ref: q.reference };
    };

    window.__openEditCustomer = function(q) {
      if (!q || !q.reference) return;
      window.__rqdEditPeople = null; // CUSTOM_DEALPEOPLE_BY_CLAUDE - never save the last deal's pills onto this one
      var sess = window.RepPortal && window.RepPortal.Auth.getSession();
      if (sess && sess.role === 'cfa') return;
      var refStr = q.reference;

      modalTitle.textContent = 'Edit Sold To — ' + refStr;
      modalSub.textContent = 'Patch the customer info on this deal.';
      modalEl.classList.add('rqd-modal--wide');
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — the confirm button is
         shared; set it to "Save" (it would otherwise inherit a stale "Create"/
         "Confirm" from whatever modal ran last — misleading on an existing deal). */
      modalConfirm.textContent = 'Save';
      modalConfirm.disabled = false;

      var html = '';

      // SAMPLE-specific warning: address already on shipping label
      var isSampleLead = q.status === 'sample' || q.isSample;
      var hasSampleTracking = q.sampleTracking && q.sampleTracking.number;
      if (isSampleLead && hasSampleTracking) {
        html += '<div style="background:#fef3c7;border:1px solid #f59e0b;color:#92400e;padding:10px 12px;border-radius:6px;font-size:12px;margin-bottom:14px;line-height:1.45;">';
        html += '⚠ The sample for this lead has already shipped. Editing the address here updates the lead record only — it does not redirect or recall the shipment.';
        html += '</div>';
      }

      function inputVal(v) { return (v == null) ? '' : String(v); }

      html += '<label class="rqd-modal__label" style="margin-top:0;">Customer Name</label>';
      html += '<input type="text" class="rqd-modal__input" id="rqd-edit-cust-name" value="' + esc(inputVal(q.customer)) + '" placeholder="John Smith">';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — "+ Person" Phase 2. This field used to
         be a chip box holding every address comma-joined, labelled "Email (comma separated)".
         It now holds the PRIMARY only -- the person we To -- and everyone else lives in the
         People list below as a real contact with a name and a phone, which a joined string
         could never carry. A deal whose email is still a legacy joined string splits here on
         open: first token to this field, the rest into the list. */
      var _CTm = window.RepPortal && window.RepPortal.Contacts;
      var _editPeopleSeed = _CTm ? _CTm.readContacts({
        name: q.customer, email: q.customerEmail, phone: q.customerPhone, contacts: q.customerContacts
      }) : [];
      var _primarySeed = _editPeopleSeed[0] || { email: inputVal(q.customerEmail) };
      /* CUSTOM_DEALPEOPLE_BY_CLAUDE (Ryan 2026-10-27) — TO AND CC PILLS. Ryan: a customer writes months after the sale "can
         you also include me and so-and-so going forward", and that needs a quick, simple way in. The Email field and the
         "+ Person" rows became two pill boxes: To (the first pill is the main contact, the name above) and CC. Every
         person in either box gets every email Abby sends on this deal (the worker reads the role); type or paste an
         address and press Enter, paste a whole Outlook line ("Jill Smith <jill@...>; ...") and the names come with it,
         click a pill to add or fix a name, x to remove. Phones saved on an extra person are kept, just not shown. */
      html += '<label class="rqd-modal__label">To<span class="rqd-info-i" tabindex="0" title="The first person in To is the main contact (the name above). Everyone in To and CC gets every email on this deal. Paste an Outlook line to keep names, or click a pill to add or fix a name." aria-label="The first person in To is the main contact (the name above). Everyone in To and CC gets every email on this deal. Paste an Outlook line to keep names, or click a pill to add or fix a name.">i</span></label>';
      html += '<input type="email" class="rqd-modal__input" id="rqd-edit-cust-email" value="" placeholder="Main contact first, then anyone else to email">';
      html += '<label class="rqd-modal__label">CC</label>';
      html += '<input type="text" class="rqd-modal__input" id="rqd-edit-cust-cc" value="" placeholder="Anyone to copy">';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — optional backfill: pull
         historical Outlook threads for the email(s) on this existing deal. */
      html += '<div id="rqd-edit-cust-email-backfill" style="margin:8px 0 12px;display:none;"></div>';
      html += '<label class="rqd-modal__label">Phone</label>';
      html += '<input type="tel" class="rqd-modal__input" id="rqd-edit-cust-phone" value="' + esc(inputVal(q.customerPhone)) + '" placeholder="(555) 123-4567">';

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — "+ Person": everyone on the deal after
         the primary. Ryan's rule is that the first contact is who we To and the 2nd+ get a Cc,
         so this list IS the Cc list -- which is also the only place a standing Cc can be
         revoked, hence a remove button on every row and no confirm step.
         Rows are plain inputs read back on save rather than a nested modal: modal-in-modal has
         its own bug history here, and three short fields do not earn a second dialog. */

      html += '<label class="rqd-modal__label">Organization</label>';
      html += '<input type="text" class="rqd-modal__input" id="rqd-edit-cust-org" value="' + esc(inputVal(q.customerCompany)) + '" placeholder="Acme Fitness Center">';
      var resVal = q.residentialOrCommercial || (q.customer && q.customer.residentialOrCommercial) || '';
      var isResChecked = String(resVal).toLowerCase() === 'residential';
      html += '<label style="display:flex;align-items:center;gap:8px;font-weight:600;font-size:12px;cursor:pointer;color:var(--rq-text);margin:6px 0 10px;"><input type="checkbox" id="rqd-edit-cust-residential"' + (isResChecked ? ' checked' : '') + ' style="width:auto;margin:0;cursor:pointer;"> Residential</label>';

      html += '<label class="rqd-modal__label">Street 1</label>';
      html += '<input type="text" class="rqd-modal__input" id="rqd-edit-cust-street1" value="' + esc(inputVal(q.customerStreet)) + '" placeholder="123 Main St">';
      html += '<label class="rqd-modal__label">Street 2</label>';
      html += '<input type="text" class="rqd-modal__input" id="rqd-edit-cust-street2" value="' + esc(inputVal(q.customerStreet2)) + '" placeholder="Suite 200">';
      html += '<label class="rqd-modal__label">Zip Code</label>';
      html += '<input type="text" class="rqd-modal__input" id="rqd-edit-cust-zip" value="' + esc(inputVal(q.zip)) + '" maxlength="10" inputmode="numeric">';
      html += '<label class="rqd-modal__label">City</label>';
      html += '<input type="text" class="rqd-modal__input" id="rqd-edit-cust-city" value="' + esc(inputVal(q.city)) + '" placeholder="Broomfield">';
      html += '<label class="rqd-modal__label">State</label>';
      html += '<input type="text" class="rqd-modal__input" id="rqd-edit-cust-state" value="' + esc(inputVal(q.state)) + '" maxlength="2" style="text-transform:uppercase;" placeholder="CO">';

      modalBody.innerHTML = html;

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-08) — Zip → city/state autofill,
         mirroring the Quote Workstation customer card (workstation-customer.js
         bindZipLookup). On blur of a valid 5-digit zip, look up city + state via
         zippopotam.us and fill them ONLY when still empty — a manually-entered
         city/state is never clobbered. Soft-fails silently on any network error.
         Re-binds each open (fresh inputs from innerHTML), so no listener buildup. */
      (function() {
        var zipEl = document.getElementById('rqd-edit-cust-zip');
        if (!zipEl) return;
        zipEl.addEventListener('blur', function() {
          var zip = this.value.trim();
          if (zip.length === 5 && /^\d{5}$/.test(zip)) {
            fetch('https://api.zippopotam.us/us/' + zip)
              .then(function(r) { return r.ok ? r.json() : null; })
              .then(function(data) {
                if (data && data.places && data.places[0]) {
                  var p = data.places[0];
                  var cityInput = document.getElementById('rqd-edit-cust-city');
                  var stateInput = document.getElementById('rqd-edit-cust-state');
                  if (cityInput && !cityInput.value) cityInput.value = p['place name'] || '';
                  if (stateInput && !stateInput.value) stateInput.value = p['state abbreviation'] || '';
                }
              })
              .catch(function() {});
          }
        });
      })();

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — the People list, plus the Outlook
         backfill that used to hang off the chip field.

         Replaces the 2026-06-19 chip box. Addresses on a deal are now named contacts, so the
         backfill reads its address list from the People rows plus the primary field instead of
         from chips -- same request, same endpoint, same behaviour; only the source moved.

         Rows are appended and removed as DOM nodes and never re-rendered wholesale: a re-render
         on every keystroke would take focus out of the field being typed in. Save reads them
         back out of the DOM. */
      (function() {
        /* CUSTOM_DEALPEOPLE_BY_CLAUDE (Ryan 2026-10-27) — the To and CC pill boxes, seeded from the people the model read
           on open (a legacy joined address list splits itself: the rest of its addresses arrive as CC, as they were). The
           save reads them back through window.__rqdEditPeople. `extras` keeps each extra person's saved phone / title, and
           `noEmail` the people recorded with a name or phone but no address, so a save never drops what it does not show. */
        var RP = window.RepPortal;
        if (!(RP && RP.installChipField)) return;
        var _seedTo = [{ name: _primarySeed.name || inputVal(q.customer), email: _primarySeed.email || '' }].filter(function(p) { return p.email; });
        var _seedCc = [];
        var _extras = {};
        var _noEmail = [];
        (_editPeopleSeed.slice(1) || []).forEach(function(c) {
          if (!c.email) { _noEmail.push({ name: c.name, title: c.title, phone: c.phone, role: c.role }); return; }
          _extras[c.email.toLowerCase()] = { phone: c.phone || '', title: c.title || '' };
          (c.role === 'to' ? _seedTo : _seedCc).push({ name: c.name || '', email: c.email });
        });
        var _toApi = RP.installChipField({ replace: document.getElementById('rqd-edit-cust-email'), named: true, initial: _seedTo,
          placeholder: 'Main contact first, then anyone else to email', ariaLabel: 'To', onChange: function() { renderBackfillBtn(); } });
        var _ccApi = RP.installChipField({ replace: document.getElementById('rqd-edit-cust-cc'), named: true, noPrimary: true, initial: _seedCc,
          placeholder: 'Anyone to copy', ariaLabel: 'CC', onChange: function() { renderBackfillBtn(); } });
        window.__rqdEditPeople = { to: _toApi, cc: _ccApi, extras: _extras, noEmail: _noEmail };
        /* The first To pill wears the Customer Name above; typing a new name renames it. */
        var _nameEl = document.getElementById('rqd-edit-cust-name');
        if (_nameEl && _toApi) _nameEl.addEventListener('change', function() {
          var ps = _toApi.getPeople();
          if (ps[0]) { ps[0].name = _nameEl.value.trim(); _toApi.setPeople(ps); }
        });

        /* Every address on the deal, To then CC: what the Outlook backfill asks about. */
        function allEmails() {
          var out = [];
          [_toApi, _ccApi].forEach(function(api) { if (api) api.getPeople().forEach(function(p) { out.push(p.email); }); });
          return out;
        }

        var backfillWrap = document.getElementById('rqd-edit-cust-email-backfill');
        function renderBackfillBtn() {
          if (!backfillWrap) return;
          if (allEmails().length === 0) { backfillWrap.style.display = 'none'; backfillWrap.innerHTML = ''; return; }
          backfillWrap.style.display = '';
          backfillWrap.innerHTML = '<button type="button" class="rqd-backfill-btn" id="rqd-edit-cust-backfill-btn">&#128231; Pull emails from Outlook</button>'
            + '<span id="rqd-edit-cust-backfill-status" style="margin-left:8px;font-size:11px;color:var(--rq-text-secondary);"></span>';
        }
        renderBackfillBtn();

        if (backfillWrap) backfillWrap.addEventListener('click', function(ev) {
          var btn = ev.target.closest('#rqd-edit-cust-backfill-btn');
          if (!btn) return;
          var emails = allEmails();
          if (emails.length === 0) return;
          var statusEl = document.getElementById('rqd-edit-cust-backfill-status');
          btn.disabled = true; if (statusEl) statusEl.textContent = 'Searching Outlook…';
          window.RepPortal.API.post('/admin/deal-email-backfill', { ref: q.reference, emails: emails.join(', '), dryRun: false })
            .then(function(d) {
              /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-09-19) — ⛔ REPORT WHAT IT ACTUALLY DID.
                 This printed "No new emails found." on any run that linked nothing, which is a
                 different claim from what the route measured and reads as a flat failure. On
                 RW-1317-C it fired with EIGHTEEN of the customer's emails already on the deal:
                 the route had scanned them, recognised every one as already linked and added
                 none — correct behaviour, reported as though Outlook were empty. Ryan: "it
                 returns 'No new emails found.' which is a load of crap."
                 The route has returned `counts {scanned, linked, skipped}` plus `ownerMailbox`
                 and `emails` since it was written; this read one field of the three.
                 ⚠️ THE THREE OUTCOMES ARE GENUINELY DIFFERENT and only one of them is a problem:
                 linked something / found them and they were already here / found nothing at all.
                 The last one is the only case worth acting on, and it is the one that now names
                 the mailbox and the addresses searched, because "which mailbox did it even look
                 in" is the first question anybody asks. */
              var _c = (d && d.counts) || {};
              var _linked = _c.linked || 0, _scanned = _c.scanned || 0;
              var _plural = function (n) { return n === 1 ? '' : 's'; };
              var _msg;
              if (_linked > 0) {
                _msg = 'Linked ' + _linked + ' email' + _plural(_linked) + ' — refresh to see them.';
              } else if (_scanned > 0) {
                _msg = 'Found ' + _scanned + ' email' + _plural(_scanned) + ' in '
                  + ((d && d.ownerMailbox) || 'Outlook') + ' — all already on this deal. Nothing new to add.';
              } else {
                _msg = 'Nothing in ' + ((d && d.ownerMailbox) || 'Outlook') + ' matched '
                  + (((d && d.emails) || []).join(', ') || 'this deal’s email addresses') + '.';
              }
              if (statusEl) statusEl.textContent = _msg;
              btn.disabled = false;
              if (n > 0 && typeof fetchQuotes === 'function') fetchQuotes({ quiet: true });
            })
            .catch(function(err) {
              if (statusEl) statusEl.textContent = 'Failed: ' + (err && err.message ? err.message : 'unknown');
              btn.disabled = false;
            });
        });
      })();

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-29) — Customer-history typeahead
         on Org + Name fields, mirrors the Pending modal. Wires _bindCustomerLookup
         (exposed on window.RQD by dashboard-lead-create.js). On pick, all contact
         fields overwrite so the rep gets a clean swap to the chosen customer. */
      (function() {
        if (!(window.RQD && window.RQD.bindCustomerLookup)) return;
        function fmtPhone(p) { return (p && window.RepPortal && window.RepPortal.formatPhone) ? window.RepPortal.formatPhone(p) : (p || ''); }
        function fillFromCustomer(m) {
          if (!m) return;
          var set = function(id, v) { var el = document.getElementById(id); if (el) el.value = (v == null ? '' : v); };
          var addr = m;
          if (!m.street) {
            var cache = (window.RQD.getCustLookupCache && window.RQD.getCustLookupCache()) || [];
            var alt = (m.email && cache.find(function(c) { return c && c.email === m.email && c.street; }))
                   || (m.company && cache.find(function(c) { return c && c.company && c.company.toLowerCase() === m.company.toLowerCase() && c.street; }));
            if (alt) addr = alt;
          }
          if (m.name)    set('rqd-edit-cust-name',   m.name);
          if (m.company) set('rqd-edit-cust-org',    m.company);
          if (m.phone)   set('rqd-edit-cust-phone',  fmtPhone(m.phone));
          set('rqd-edit-cust-street1', addr.street  || '');
          set('rqd-edit-cust-street2', addr.street2 || '');
          set('rqd-edit-cust-zip',     addr.zip     || m.zip   || '');
          set('rqd-edit-cust-city',    addr.city    || m.city  || '');
          set('rqd-edit-cust-state',   addr.state   || m.state || '');
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — the chip API is gone; fill the
             primary email field, and only when it is EMPTY. Picking a customer from history
             must never silently overwrite an address the rep already typed. */
          var _pp = window.__rqdEditPeople; // CUSTOM_DEALPEOPLE_BY_CLAUDE - the To pill box
          if (_pp && _pp.to && m.email && !_pp.to.getPeople().length) _pp.to.add(m.email, m.name || '');
        }
        window.RQD.bindCustomerLookup(document.getElementById('rqd-edit-cust-org'),  'company', fillFromCustomer);
        window.RQD.bindCustomerLookup(document.getElementById('rqd-edit-cust-name'), 'name',    fillFromCustomer);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — live phone formatting
           (10 digits + ext.) on the Edit Sold To phone, matching the New-deal
           modals so an edited customer phone keeps its extension through the deal. */
        if (window.RepPortal && window.RepPortal.bindPhoneInput) window.RepPortal.bindPhoneInput(document.getElementById('rqd-edit-cust-phone'));
      })();

      pendingStatusChange = { _isLeadCustomerEdit: true, ref: refStr };
      modalBackdrop.classList.add('rqd-modal-backdrop--open');
    };
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // Close the dropdown on outside click
    document.addEventListener('click', function(e) {
      var menu = document.getElementById('rqd-new-menu');
      if (!menu || menu.style.display !== 'block') return;
      if (e.target.closest('#rqd-new-wrap')) return;
      menu.style.display = 'none';
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21, Phase A.3 refactor) —
       The + New modal openers (__openNewLead / __openNewSample /
       __openNewEmailLead / __openNewPending — ~506 LOC) moved to
       assets/dashboard-lead-create.js. They were already window globals
       before the refactor, so no delegation stubs needed here — call
       sites continue to reach them via window.__open* unchanged. */
    // ── Save Pending Note ──

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21, Phase A.4 refactor) —
       Deal Feed note-entry CRUD handlers (handlePendingNoteSave,
       handleLeadNoteSave, handleNoteEntryAdd, showEntryMutatePopover,
       enterNoteEditMode, exitNoteEditMode, handleNoteEntryEdit,
       handleNoteEntryDelete + internal helper formatLeadNoteStamp —
       ~588 LOC) moved to assets/dashboard-deal-feed.js. These thin
       delegations preserve the call-site contract used by the event
       delegation handler in main.js (~line 2266+). */
    function handlePendingNoteSave(btn) { return window.RQD.handlePendingNoteSave(btn); }
    function handleLeadNoteSave(btn) { return window.RQD.handleLeadNoteSave(btn); }
    function handleNoteEntryAdd(btn) { return window.RQD.handleNoteEntryAdd(btn); }
    function showEntryMutatePopover(anchorEl, editBtn, delBtn) { return window.RQD.showEntryMutatePopover(anchorEl, editBtn, delBtn); }
    function enterNoteEditMode(btn) { return window.RQD.enterNoteEditMode(btn); }
    function exitNoteEditMode(entryEl) { return window.RQD.exitNoteEditMode(entryEl); }
    function handleNoteEntryEdit(btn) { return window.RQD.handleNoteEntryEdit(btn); }
    function handleNoteEntryDelete(btn) { return window.RQD.handleNoteEntryDelete(btn); }
    async function handleRequestLogistics(btn) {
      var ref = btn.dataset.ref;
      var type = btn.dataset.logisticsType;
      var label = type === 'freight' ? 'freight quote' : 'installation quote';
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var confirmText = type === 'freight'
        ? 'The AI agents take it from here: they quote from the packaged dims on file when every product has them, and otherwise ask the supplier.'
        : 'A request goes out to the vendors on this deal.';
      if (!(await rqdConfirm(confirmText, { title: 'Request ' + label + ' for ' + ref + '?', confirmLabel: 'Send the request' }))) return;
      try {
        btn.disabled = true;
        btn.textContent = 'Requesting...';
        var res = await API.post('/request-logistics', { ref: ref, type: type });
        var q = allQuotes.find(function(x) { return x.reference === ref; });
        if (q) {
          if (type === 'freight') q.freightStatus = 'requested';
          else q.installationStatus = 'requested';
        }
        fetchQuotes();
        /* CUSTOM_OFFLINEDIMSONFILE_BY_CLAUDE — say which way the agents were sent (the worker's sentence). */
        if (type === 'freight' && res && res.dimsOnFile && res.dimsOnFile.sentence) {
          rqdAlert(res.dimsOnFile.sentence, { title: 'Freight requested for ' + ref });
        }
      } catch (err) {
        rqdAlert('Failed: ' + (err.message || 'Unknown error'));
        btn.disabled = false;
        btn.textContent = type === 'freight' ? 'Request Freight' : 'Request Installation';
      }
    }

    async function handleFreightCancel(btn) {
      var ref = btn.dataset.ref;
      if (!ref) return;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      if (!(await rqdConfirm('Abby (orders@) is emailed that it is no longer needed and the AI agent stops. A supplier who was already asked is not contacted. Freight costs already saved are kept.', { title: 'Cancel the pending freight request for ' + ref + '?', confirmLabel: 'Cancel the request', cancelLabel: 'Leave it pending', danger: true }))) return;
      try {
        btn.disabled = true;
        var res = await API.post('/freight-cancel-request', { quoteRef: ref });
        if (res && res.success) {
          var q = allQuotes.find(function (x) { return x.reference === ref; });
          if (q) {
            q.freightQuotes = res.freightQuotes || {};
            if (res.freightStatus) q.freightStatus = res.freightStatus;
          }
        }
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed to cancel: ' + (err.message || 'Unknown error'));
        btn.disabled = false;
      }
    }

    /* CUSTOM_REQUESTCANCEL_BY_CLAUDE (Ryan 2026-10-13) - the cog's Cancel Installation Request: the deal owner or an admin;
       POST /installation-cancel-request puts the request back to pending and emails Ryan (the request emailed him). */
    async function handleInstallCancel(btn) {
      var ref = btn.dataset.ref;
      if (!ref) return;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      if (!(await rqdConfirm('Ryan is emailed that it is no longer needed.', { title: 'Cancel the installation request for ' + ref + '?', confirmLabel: 'Cancel the request', cancelLabel: 'Leave it requested', danger: true }))) return;
      try {
        btn.disabled = true;
        var res = await API.post('/installation-cancel-request', { ref: ref });
        if (res && res.success) {
          var q = allQuotes.find(function (x) { return x.reference === ref; });
          if (q) q.installationStatus = res.installationStatus || 'pending';
        }
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed to cancel: ' + (err.message || 'Unknown error'));
        btn.disabled = false;
      }
    }

    async function handleDeletePending(btn) {
      var ref = btn.dataset.ref;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      if (!(await rqdConfirm('This cannot be undone.', { title: 'Delete pending quote ' + ref + '?', confirmLabel: 'Delete', cancelLabel: 'Keep it', danger: true }))) return;
      try {
        await API.post('/delete-pending', { ref: ref });
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — same reason as the create: the cached
           list still holds this row. ⚠️ Unlike handleDeleteQuote below, this path writes NO
           tombstone (`markRefDeleted`) — the tombstone is what lets that one look instant over a
           stale cache, and its absence here is exactly why this delete needed the refetch to be
           real. Invalidating is the smaller fix; a tombstone would also be defensible. */
        _swrInvalidateQuotes();
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed: ' + (err.message || 'Unknown error'));
      }
    }

    // ── Build Quote from Lead (Phase 2.5) ──
    // POST /create-quote-from-lead → mints new ref + workstation_meta with
    // customer pre-filled, transitions lead OUT of NEW LEAD (counter
    // decrements). Then redirects rep to /pages/rep-quote-workstation?ref=...
    // where the customer fields are already populated and the rep just adds
    // line items + pricing.
    /* CUSTOM_DRAFTPOINTER_BY_CLAUDE (Ryan 2026-10-08, JW-1310-A) — ONE CLICK, ONE REQUEST. The tbody
       carries two click listeners (the actions-menu one and the detail-panel one) and BOTH match
       .rqd-build-quote-from-lead-btn, so Create Quote from the cog menu fired this twice in the same
       instant: two /create-quote-from-lead calls, two Shopify drafts (58 empty twins since August).
       The worker now dedupes too; this stops the second call leaving the browser at all. */
    var _buildQuoteInFlight = {};
    async function handleBuildQuoteFromLead(btn) {
      var ref = btn.dataset.ref;
      if (!ref || _buildQuoteInFlight[ref]) return;
      _buildQuoteInFlight[ref] = true;
      setTimeout(function() { delete _buildQuoteInFlight[ref]; }, 15000);
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var origText = btn.textContent;
      btn.textContent = 'Building...';
      btn.disabled = true;
      try {
        var res = await API.post('/create-quote-from-lead', { ref: ref });
        if (res && res.redirectUrl) {
          // Stash the just-created customer + leadContext so the workstation
          // can populate Sold To and the Lead Submission button instantly on
          // first load — KV writes may not propagate to the POP serving the
          // workstation's /quote-details call before the user lands there.
          if (res.quoteRef && (res.customer || res.leadContext)) {
            try {
              sessionStorage.setItem('bsfs_lead_handoff:' + res.quoteRef, JSON.stringify({
                customer: res.customer || null,
                leadContext: res.leadContext || null,
                draftOrderId: res.draftOrderId || null,
                draftOrderName: res.draftOrderName || null,
                stashedAt: Date.now(),
              }));
            } catch (e) { /* storage quota / disabled — workstation falls back to /quote-details retry */ }
          }
          /* CUSTOM_WEIGHTDESIGNER_BY_CLAUDE (Ryan 2026-09-01) — ⛔ THE WEIGHT DESIGN'S ORDER, HANDED
             TO THE WORKSTATION. Until now this endpoint ignored the design entirely and the rep
             landed on an empty quote and typed twenty dumbbell rows by hand.

             ⚠️ WRITTEN EVEN WHEN THE IMPORT FAILED (`weights: []`), because the diagnosis has to
             reach the screen the rep is actually looking at. An expired share, a KV error and a
             rep-saved design with no recorded quantities each produce a different sentence there;
             saying nothing is what made the original bug invisible.

             ⚠️ `mode: 'existing'` and NOT 'append'. Append re-POSTs this endpoint, which would mint
             a SECOND Shopify draft inside the tag-search index lag, and it calls loadQuote a second
             time — and loadQuote clears `state.items`, so whichever load lands second wipes the
             rows. 'existing' means "the quote is already loading; wait for it, then add".

             ⚠️ NO `designRef`/`designId` AT THE TOP LEVEL, deliberately. Those arm the Workstation's
             own one-shot /quote-link-design listener, and the WORKER now owns that link. Two
             writers of one link is how it starts disagreeing with itself.

             ⚠️ Only ever set on a lead the worker says is a weight-designer lead. `status === 'none'`
             is every other lead, and this block does not run for them. */
          if (res.wdImport && res.wdImport.status && res.wdImport.status !== 'none') {
            try {
              localStorage.setItem('rep_workstation_import', JSON.stringify({
                mode: 'existing',
                targetRef: res.quoteRef,
                items: [],
                weights: Array.isArray(res.wdImport.groups) ? res.wdImport.groups : [],
                wdImport: {
                  status: res.wdImport.status,
                  designId: res.wdImport.designId || '',
                  reason: res.wdImport.reason || '',
                  linked: !!(res.designLink && res.designLink.linked),
                },
                stashedAt: Date.now(),
              }));
            } catch (e) {
              /* Private mode or quota. Say what was lost and NAVIGATE ANYWAY — the quote exists
                 server-side, and stranding the rep on the dashboard is the worse failure. */
              rqdAlert('Quote ' + res.quoteRef + ' was created, but this browser would not hold the '
                + 'design’s line items for the handoff. Open the deal and click Create Quote again, '
                + 'or add the rows by hand.');
            }
          }
          window.location.href = res.redirectUrl;
        } else {
          btn.textContent = origText;
          btn.disabled = false;
          rqdAlert('Build succeeded but no redirect URL — check console.');
          console.log('create-quote-from-lead response:', res);
        }
      } catch (err) {
        btn.textContent = origText;
        btn.disabled = false;
        delete _buildQuoteInFlight[ref];
        rqdAlert('Failed: ' + (err.message || 'Unknown error'));
      }
    }

    // ── Mark Lead Dead / Resurrect ──
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21, refactored) — Mark Dead
       reason form is now hosted INSIDE the lead-actions modal as a swap
       view, not a separate body-mounted popover. Eliminates fragile-anchor
       positioning (the prior popover slid into the top-left when the
       anchor element was inside a modal that closed before positioning).
       Both entry points route through openLeadActionsModal:
         - Cog menu Mark Dead → handleMarkLeadDead → opens modal pre-
           focused on the reason view (initialView: 'mark-dead').
         - Status-pill → lead-actions modal → Mark Dead button → swaps the
           modal body to reason view in place. */
    /* Delegated to assets/dashboard-lead-actions.js (Phase A.2 refactor). */
    function handleMarkLeadDead(btn) { return window.RQD.handleMarkLeadDead(btn); }

    /* Delegated to assets/dashboard-lead-actions.js (Phase A.2 refactor). */
    function handleResurrectLead(btn) { return window.RQD.handleResurrectLead(btn); }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Outlook email
       expand modal. Click an email entry on the Deal Feed → full body
       in a centered modal. If the conversation has multiple emails on
       this deal, a "Show rest of thread (N more)" button expands the
       modal to render every email in the chain (oldest → newest) with
       the originally-clicked email highlighted + auto-scrolled into
       view. Phase 2 will add a Reply button here. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21, Phase A.1 refactor) —
       openEmailModal body extracted to assets/dashboard-email-modal.js.
       This thin delegation preserves the call-site contract used
       throughout main.js (renderTable, buildDetailHtml, etc.). */
    function openEmailModal(entry, q) {
      return window.RQD.openEmailModal(entry, q, {
        esc: esc,
        formatNoteDate: formatNoteDate,
        fetchQuotes: fetchQuotes,
      });
    }

/* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Manual link picker
       for grandfathered deals. Fetches /design-list (rep's saved
       designs), lets the rep pick one, POSTs /quote-link-design to
       associate it with the deal, then quiet-refreshes so the new
       LINKED FILES card appears.

       Mounted inside .rep-quote-portal-wrap so the dark-mode cascade
       works. Click-outside / Esc / Cancel dismiss. Search box filters
       the list as you type. Designs already linked to this deal are
       grayed out and labeled "(already linked)". */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Unlink Asset picker.
       Lists currently-linked assets for the given quote with a per-row
       Unlink button. Click → POST /quote-unlink-design + quiet-refresh.
       Reuses the same modal chrome as openLinkFloorPlanPicker so the
       two flows look like siblings. */
    function openUnlinkAssetPicker(quoteRef, linkedFiles) {
      var existing = document.getElementById('rqd-unlink-asset-modal');
      if (existing) existing.remove();
      if (!quoteRef || !Array.isArray(linkedFiles) || linkedFiles.length === 0) return;

      var overlay = document.createElement('div');
      overlay.id = 'rqd-unlink-asset-modal';
      overlay.className = 'rqd-daterange-backdrop';
      var html = '<div class="rqd-daterange-modal" role="dialog" aria-label="Unlink asset" style="max-width:520px">';
      html += '<h3 style="margin:0 0 6px;font-size:16px;font-weight:700">Unlink asset from ' + esc(quoteRef) + '</h3>';
      html += '<p style="margin:0 0 12px;font-size:13px;color:var(--rq-text-secondary)">Pick the asset to remove from this deal.</p>';
      html += '<div style="display:flex;flex-direction:column;gap:6px;max-height:300px;overflow-y:auto">';
      linkedFiles.forEach(function(f) {
        if (!f) return;
        var nm = f.name || f.designRef || 'Asset';
        var sub = (f.designRef ? f.designRef : '') + (f.spaceSummary ? ' · ' + f.spaceSummary : '');
        var id = f.designId || f.designRef;
        html += '<div class="rqd-unlink-asset-row" style="display:flex;align-items:center;gap:10px;padding:8px 10px;border:1px solid var(--rq-border);border-radius:6px">';
        html +=   '<div style="flex:1;min-width:0">';
        html +=     '<div style="font-size:13px;font-weight:600;color:var(--rq-text)">' + esc(nm) + '</div>';
        html +=     (sub ? '<div style="font-size:11px;color:var(--rq-text-secondary);margin-top:2px">' + esc(sub) + '</div>' : '');
        html +=   '</div>';
        html +=   '<button type="button" class="rqd-pill rqd-unlink-asset-pick" data-design-id="' + esc(id) + '" data-asset-name="' + esc(nm) + '" style="font-size:12px">Unlink</button>';
        html += '</div>';
      });
      html += '</div>';
      html += '<div class="rqd-daterange-modal__footer" style="margin-top:14px"><button type="button" class="rqd-pill" id="rqd-unlink-asset-close">Cancel</button></div>';
      html += '</div>';
      overlay.innerHTML = html;
      var portalWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
      portalWrap.appendChild(overlay);

      function close() {
        overlay.remove();
        document.removeEventListener('keydown', onEsc);
      }
      function onEsc(ev) { if (ev.key === 'Escape') close(); }
      document.addEventListener('keydown', onEsc);
      /* ⚠️ async (Phase 2): the per-asset confirm below is a Promise now. The backdrop test and
         the close() branch both run before the first await. */
      overlay.addEventListener('click', async function(ev) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
        if (window.RepPortal.dismissedOnBackdrop(ev, overlay) || ev.target.id === 'rqd-unlink-asset-close') {
          close();
          return;
        }
        var pickBtn = ev.target.closest('.rqd-unlink-asset-pick');
        if (pickBtn) {
          var designId = pickBtn.dataset.designId;
          var assetName = pickBtn.dataset.assetName;
          if (!(await rqdConfirm('Unlink "' + assetName + '" from ' + quoteRef + '?', { title: 'Unlink asset', confirmLabel: 'Unlink', danger: true }))) return;
          pickBtn.disabled = true;
          pickBtn.textContent = 'Unlinking...';
          window.RepPortal.API.post('/quote-unlink-design', { ref: quoteRef, designId: designId })
            .then(function() {
              /* Drop it from every cached copy, not just the DOM. This is the half that was
                 missing: an unlink that only repainted came back on the next paint from
                 sessionStorage, and the second unlink then failed with "Asset not linked to this
                 deal" — because the record was right and the cache was not. */
              rqdPatchLinkedFiles(quoteRef, function(q) {
                if (!Array.isArray(q.linkedFiles)) return;
                q.linkedFiles = q.linkedFiles.filter(function(f) { return !(f && f.designId === designId); });
              });
              close();
              fetchQuotes({ quiet: true });
            })
            .catch(function(err) {
              pickBtn.disabled = false;
              pickBtn.textContent = 'Unlink';
              rqdAlert('Unlink failed: ' + (err && err.message ? err.message : 'unknown error'));
            });
        }
      });
    }

    /* CUSTOM_WEIGHTDESIGNER_BY_CLAUDE (Ryan 2026-08-31) — PAINT THE LINK/UNLINK IMMEDIATELY.
     *
     * *"After linking/unlinking a file it still takes 10-15 seconds to appear."* The write is
     * instant and the server summary is now current (the handler awaits its re-bake) — the wait is
     * the BOARD: `fetchQuotes` paints the 6h SWR copy first and revalidates behind it with a full
     * `/rep-quotes` assembly, which this file's own note measures at 25+ seconds.
     *
     * ⛔ AND THE STALE COPY DOES NOT JUST DELAY THE CARD, IT RESURRECTS IT. Ryan unlinked a floor
     * plan, watched it go, and *"a few minutes later it reappeared"* — then unlinking it again
     * answered "Asset not linked to this deal", because the RECORD was right and the CACHE was not.
     * So patching the DOM alone would be undone by the next paint: every cached copy of this deal
     * has to move too.
     *
     * ⚠ PATCHED, NOT INVALIDATED, and that is deliberate. `_swrInvalidateQuotes`'s own rule
     * (2026-08-26) is to clear only when the SET OF ROWS changes; a linked asset is a row's
     * CONTENTS. Blanket-clearing here would trade a warm cache for a cold 25s assembly on every
     * link, which is the trade that note explicitly rejected.
     *
     * ⚠ THE PAINTED ENTRY IS PROVISIONAL. Its display fields are built from the picker row rather
     * than from the server's enrichment, so `designUrl` duplicates a rule the worker also owns.
     * That drift is bounded and self-healing: the next real fetch overwrites it with the
     * authoritative entry. It is only ever applied AFTER a 200 — painting before would hide a
     * failed write, which is exactly how the missing re-bake stayed invisible for months.
     */
    /* CUSTOM_SUPPLIERPAYDIGEST_BY_CLAUDE (AIOPS `5a3c91c495dd`, Ryan 2026-09-14) — ⛔ THE CACHE
     * PATCH, LIFTED OUT SO IT IS NOT THE LINKED-FILES FEATURE'S PRIVATE TRICK. Three layers hold a
     * copy of every board row: `allQuotes`, the RAM SWR entries, and `sessionStorage` — and the
     * LAST of those is the one that survives a reload. Any action that changes a row's CONTENTS
     * and then re-renders locally has to reach all three or the change un-happens on the next F5,
     * which is exactly what the Supplier Pay card reported ("hard refresh shows it unpaid again").
     * Exposed on `window.RQD` so a card module in its own file can use it.
     *
     * ⚠ PATCHED, NOT INVALIDATED, and that is deliberate. `_swrInvalidateQuotes`'s own rule
     * (2026-08-26) is to clear only when the SET OF ROWS changes; this is a row's contents.
     * Blanket-clearing would trade a warm cache for a cold 25s assembly on every click.
     * ⚠ APPLY IT ONLY AFTER A 200. Painting before would hide a failed write — the rule the
     * linked-files patch below was written under, and it applies to every caller.
     */
    function rqdPatchQuoteRow(quoteRef, mutate) {
      var patched = false;
      function apply(list) {
        (list || []).forEach(function(x) {
          if (x && x.reference === quoteRef) { mutate(x); patched = true; }
        });
      }
      apply(allQuotes);
      // The RAM SWR layer, every cached view of it — the rep may switch filters before a refetch.
      try {
        Object.keys(_memQuotes).forEach(function(k) {
          var d = _memQuotes[k] && _memQuotes[k].data;
          if (d) apply(d.quotes);
        });
      } catch (_) { /* RAM patch is best-effort */ }
      /* The sessionStorage layer, which is what SURVIVES A RELOAD and is therefore the half that
         resurrected the card. Rewritten in place rather than dropped, so the view stays warm. */
      try {
        for (var i = 0; i < sessionStorage.length; i++) {
          var key = sessionStorage.key(i);
          if (!key || key.indexOf('rqd-swr:') !== 0) continue;
          var raw = sessionStorage.getItem(key);
          if (!raw) continue;
          var entry = JSON.parse(raw);
          if (!entry || !entry.data) continue;
          apply(entry.data.quotes);
          sessionStorage.setItem(key, JSON.stringify(entry));
        }
      } catch (_) { /* quota or a corrupt entry — the RAM copy above still carries this session */ }
      /* CUSTOM_DDKEEPPLACE_BY_CLAUDE - and the IndexedDB copies, which are what survive a reload now. */
      try { if (API.dealListPatchAll) API.dealListPatchAll(apply); } catch (_) {}
      return patched;
    }
    window.RQD = window.RQD || {};
    window.RQD.patchCachedQuoteRow = rqdPatchQuoteRow;

    function rqdPatchLinkedFiles(quoteRef, mutate) {
      var patched = rqdPatchQuoteRow(quoteRef, mutate);
      // Swap ONLY the linked-files sidecar, built offscreen. Re-rendering the whole activity card
      // would wipe an open note composer's unsaved text and reset scroll (the same reason the
      // quiet repaint is gated on `hasUnsavedTyping`).
      try {
        var q = allQuotes.filter(function(x) { return x && x.reference === quoteRef; })[0];
        var live = document.querySelector('.rqd-notes-log__linked-files .rqd-linked-file__add[data-ref="' + quoteRef + '"]');
        var host = live && live.closest('.rqd-notes-log__linked-files');
        if (q && host && window.RQD && window.RQD.buildActivityCard) {
          var tmp = document.createElement('div');
          tmp.innerHTML = window.RQD.buildActivityCard(q, {});
          var fresh = tmp.querySelector('.rqd-notes-log__linked-files');
          if (fresh) host.parentNode.replaceChild(fresh, host);
        }
      } catch (_) { /* the background refetch is the backstop */ }
      return patched;
    }

    function openLinkFloorPlanPicker(quoteRef) {
      var existing = document.getElementById('rqd-link-floorplan-modal');
      if (existing) existing.remove();
      if (!quoteRef) return;

      // Find current linkedFiles to flag already-linked designs.
      var q = (typeof allQuotes !== 'undefined') ? allQuotes.find(function(x) { return x.reference === quoteRef; }) : null;
      var alreadyLinkedIds = {};
      if (q && Array.isArray(q.linkedFiles)) {
        q.linkedFiles.forEach(function(f) { if (f && f.designId) alreadyLinkedIds[f.designId] = true; });
      }

      var overlay = document.createElement('div');
      overlay.id = 'rqd-link-floorplan-modal';
      overlay.className = 'rqd-daterange-backdrop';
      overlay.innerHTML = ''
        + '<div class="rqd-daterange-modal" role="dialog" aria-label="Link asset" style="max-width:520px;">'
        +   '<div class="rqd-daterange-modal__header">'
        +     '<div class="rqd-daterange-modal__title">Link an asset to ' + esc(quoteRef) + '</div>'
        +     '<div class="rqd-daterange-modal__summary">Pick a saved design to attach to this deal’s LINKED FILES.</div>'
        +   '</div>'
        +   '<div class="rqd-link-floorplan-body">'
        /* CUSTOM_WEIGHTDESIGNER_BY_CLAUDE (Ryan 2026-08-30) — THREE VIEWS OF ONE SHELF, not three
           shelves. "All" leads and is the default because the question a rep is answering is
           "what's attached to this deal", not "which tool made it"; the other two exist for the
           case where they know which they want and the list is long. The button was renamed from
           "Link Floor Plan" to "Link Asset" back in May precisely so this day would not need a
           second button. */
        +     '<div class="rqd-link-asset__tabs" role="tablist">'
        +       '<button type="button" class="rqd-link-asset__tab is-on" data-kind="all" role="tab" aria-selected="true">All</button>'
        +       '<button type="button" class="rqd-link-asset__tab" data-kind="floor-plan" role="tab" aria-selected="false">Gym Designs</button>'
        +       '<button type="button" class="rqd-link-asset__tab" data-kind="weights" role="tab" aria-selected="false">Weights</button>'
        +     '</div>'
        +     '<input type="text" class="rqd-link-floorplan__search" placeholder="Search designs by name or ref…" autocomplete="off">'
        +     '<div class="rqd-link-floorplan__list" id="rqd-link-floorplan-list">'
        +       '<div class="rqd-link-floorplan__loading">Loading your designs…</div>'
        +     '</div>'
        +     '<div class="rqd-link-floorplan__error" id="rqd-link-floorplan-error" style="display:none;"></div>'
        +   '</div>'
        +   '<div class="rqd-daterange-modal__footer">'
        +     '<button type="button" class="rqd-pill" id="rqd-link-floorplan-cancel">Close</button>'
        +   '</div>'
        + '</div>';
      var portalWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
      portalWrap.appendChild(overlay);

      var listEl = overlay.querySelector('#rqd-link-floorplan-list');
      var errorEl = overlay.querySelector('#rqd-link-floorplan-error');
      var searchEl = overlay.querySelector('.rqd-link-floorplan__search');
      var cancelEl = overlay.querySelector('#rqd-link-floorplan-cancel');

      function close() {
        overlay.remove();
        document.removeEventListener('keydown', onEsc);
      }
      function onEsc(ev) { if (ev.key === 'Escape') close(); }
      document.addEventListener('keydown', onEsc);
      overlay.addEventListener('click', function(e) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
        if (window.RepPortal.dismissedOnBackdrop(e, overlay) || e.target === cancelEl) close();
      });

      var _allDesigns = [];
      var _kind = 'all';

      function renderList(filter) {
        var f = (filter || '').toLowerCase().trim();
        var matches = _allDesigns.filter(function(d) {
          if (_kind !== 'all' && d.assetKind !== _kind) return false;
          if (!f) return true;
          return (d.name || '').toLowerCase().indexOf(f) !== -1
            || (d.ref || '').toLowerCase().indexOf(f) !== -1;
        });
        if (matches.length === 0) {
          /* The empty state has to tell "nothing matched your filter" apart from "you have none of
             these yet" — a rep who has floor plans but no weight designs must not read the Weights
             tab as a broken list. Same rule the DD's own empty states follow. */
          var emptyMsg;
          if (f) emptyMsg = 'No designs match “' + esc(filter) + '”.';
          else if (_kind === 'weights') emptyMsg = 'No saved weight designs yet. Create one in the Weight Designer first.';
          else if (_kind === 'floor-plan') emptyMsg = 'No saved floor plans yet. Create one in the Gym Layout Designer first.';
          else emptyMsg = 'You don’t have any saved designs yet.';
          listEl.innerHTML = '<div class="rqd-link-floorplan__empty">' + emptyMsg + '</div>';
          return;
        }
        var rows = '';
        matches.forEach(function(d) {
          var isLinked = !!alreadyLinkedIds[d.id];
          var disabledAttr = isLinked ? ' disabled' : '';
          var linkedBadge = isLinked ? '<span class="rqd-link-floorplan__row-badge">already linked</span>' : '';
          var ref = d.ref || '';
          var name = d.name || ref || 'Untitled design';
          var summary = d.spaceSummary || '';
          var updated = d.updatedAt ? formatDate(d.updatedAt) : '';
          // 📐 a floor plan, 🏋 a weight design — on the "All" tab the icon is the only thing
          // telling two otherwise identical rows apart, so it carries real information here.
          var icon = d.assetKind === 'weights' ? '&#127947;' : '&#128208;';
          rows += '<button type="button" class="rqd-link-floorplan__row' + (isLinked ? ' rqd-link-floorplan__row--linked' : '') + '" data-id="' + esc(d.id) + '" data-ref="' + esc(ref) + '" data-kind="' + esc(d.assetKind || 'floor-plan') + '" data-store="' + esc(d.assetStore || '') + '"' + disabledAttr + '>'
            + '<span class="rqd-link-floorplan__row-icon" aria-hidden="true">' + icon + '</span>'
            + '<span class="rqd-link-floorplan__row-body">'
            +   '<span class="rqd-link-floorplan__row-name">' + esc(name) + linkedBadge + '</span>'
            +   (summary ? '<span class="rqd-link-floorplan__row-sub">' + esc(summary) + '</span>' : '')
            +   '<span class="rqd-link-floorplan__row-meta">' + esc(ref) + (updated ? ' · updated ' + esc(updated) : '') + '</span>'
            + '</span>'
            + '</button>';
        });
        listEl.innerHTML = rows;
      }

      searchEl.addEventListener('input', function() { renderList(searchEl.value); });

      /* The tab strip. Filtering only — the fetch happens once for both sources, so switching tabs
         is instant and cannot fail. A tab that re-fetched would give the rep three ways to hit a
         network error while answering one question. */
      overlay.querySelectorAll('.rqd-link-asset__tab').forEach(function(t) {
        t.addEventListener('click', function() {
          _kind = t.dataset.kind || 'all';
          overlay.querySelectorAll('.rqd-link-asset__tab').forEach(function(o) {
            var on = o === t;
            o.classList.toggle('is-on', on);
            o.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          renderList(searchEl.value);
        });
      });

      listEl.addEventListener('click', async function(e) {
        var row = e.target.closest('.rqd-link-floorplan__row');
        if (!row || row.disabled) return;
        var designId = row.dataset.id;
        var designRef = row.dataset.ref;
        if (!designId) return;
        // Disable the whole list during the POST so the rep can't double-click.
        listEl.querySelectorAll('.rqd-link-floorplan__row').forEach(function(b) { b.disabled = true; });
        row.classList.add('rqd-link-floorplan__row--saving');
        errorEl.style.display = 'none';
        try {
          /* `type` + `store` (2026-08-30). Omitted for a floor plan so the request is byte-identical
             to the one this picker has always sent; the endpoint defaults to floor-plan behaviour.
             `store` is what tells the worker WHICH keyspace holds this id — the picker only ever
             lists rep-saved designs, so it is always 'wd-design' here, but the field has to travel
             because a customer submission's share id is drawn from the same alphabet. */
          var _rowKind = row.dataset.kind === 'weights' ? 'weights' : 'floor-plan';
          await API.post('/quote-link-design', Object.assign({
            ref: quoteRef,
            designRef: designRef || designId,
            designId: designId,
          }, _rowKind === 'weights' ? { type: 'weights', store: row.dataset.store || 'wd-design' } : {}));
          /* Paint it now, from the row the rep just clicked — see `rqdPatchLinkedFiles`. Strictly
             after the await, so a failed link paints nothing. */
          var _d = _allDesigns.filter(function(x) { return x && x.id === designId; })[0] || {};
          rqdPatchLinkedFiles(quoteRef, function(q) {
            if (!Array.isArray(q.linkedFiles)) q.linkedFiles = [];
            if (q.linkedFiles.some(function(f) { return f && f.designId === designId; })) return;
            q.linkedFiles.push({
              type: _rowKind,
              designId: designId,
              designRef: designRef || _d.ref || null,
              name: _d.name || _d.ref || 'Untitled design',
              spaceSummary: _d.spaceSummary || '',
              updatedAt: _d.updatedAt || null,
              hasThumbnail: !!_d.hasThumbnail,
              designUrl: _rowKind === 'weights'
                ? '/pages/rep-weight-designer?designId=' + encodeURIComponent(designId)
                : '/pages/rep-gym-designer?designId=' + encodeURIComponent(designId),
              missing: false,
              linkedAt: new Date().toISOString(),
              linkedBy: ''
            });
          });
          close();
          /* Quiet refresh — repaints the row's detail panel with the new
             LINKED FILES card without collapsing the row or jumping to
             the top of the page. */
          if (typeof fetchQuotes === 'function') fetchQuotes({ quiet: true });
        } catch (err) {
          listEl.querySelectorAll('.rqd-link-floorplan__row').forEach(function(b) { b.disabled = !!alreadyLinkedIds[b.dataset.id]; });
          row.classList.remove('rqd-link-floorplan__row--saving');
          errorEl.textContent = 'Link failed: ' + (err && err.message ? err.message : 'unknown error');
          errorEl.style.display = 'block';
        }
      });

      /* Fetch BOTH shelves at once and tag each row with which it came from.
         ⚠ ONE FAILING SOURCE MUST NOT EMPTY THE PICKER. `allSettled`, not `all`: if the weight-
         design list errors, the rep still gets their floor plans and a note about the half that is
         missing. `all` would reject the pair and show "could not load your designs" over a list
         that is perfectly available — the failure mode this endpoint pair makes twice as likely as
         it used to be. */
      Promise.allSettled([API.get('/design-list'), API.get('/wd-design-list')]).then(function(res) {
        var plans = (res[0].status === 'fulfilled' && res[0].value && Array.isArray(res[0].value.designs)) ? res[0].value.designs : [];
        var weights = (res[1].status === 'fulfilled' && res[1].value && Array.isArray(res[1].value.designs)) ? res[1].value.designs : [];
        _allDesigns = plans.map(function(d) { return Object.assign({}, d, { assetKind: 'floor-plan' }); })
          .concat(weights.map(function(d) { return Object.assign({}, d, { assetKind: 'weights', assetStore: 'wd-design' }); }));
        // Newest first across both sources, so "All" reads as one shelf rather than two lists
        // stapled together in fetch order.
        _allDesigns.sort(function(a, b) { return String(b.updatedAt || '').localeCompare(String(a.updatedAt || '')); });
        renderList('');
        try { searchEl.focus(); } catch (e) {}
        var failed = [];
        if (res[0].status === 'rejected') failed.push('floor plans');
        if (res[1].status === 'rejected') failed.push('weight designs');
        if (failed.length) {
          errorEl.textContent = 'Could not load your ' + failed.join(' or ') + '. The rest are listed above.';
          errorEl.style.display = 'block';
        }
      });
    }

    // ── Lead actions chooser modal ──
    // Status-pill click on any lead-state row (NEW LEAD / SAMPLE / DEAD /
    // ON HOLD) opens this. Lists the relevant transitions for the row's
    // state. Replaces the previous direct-route behavior (which auto-fired
    // mark-dead and could only show a "<72h" alert with no Hold option).
    //
    // Mark Dead button always appears for NEW/SAMPLE rows (never gated
    // out of the menu) — the 72h check fires when the rep clicks it, with
    // a friendly "Xh remaining" message. Mirrors Ryan's spec: "click brings
    // up pop-up, warning only happens when you then try to mark dead."
    /* Delegated to assets/dashboard-lead-actions.js (Phase A.2 refactor). */
    function openLeadActionsModal(q, opts) { return window.RQD.openLeadActionsModal(q, opts); }
    /* Delegated to assets/dashboard-lead-actions.js (Phase A.2 refactor). */
    function handleHoldLead(btn) { return window.RQD.handleHoldLead(btn); }

    /* Delegated to assets/dashboard-lead-actions.js (Phase A.2 refactor). */
    function handleWakeLead(btn) { return window.RQD.handleWakeLead(btn); }
    async function handleQuoteSampleTrackingSave(btn) {
      var wrap = btn.closest('.rqd-quote-sample-tracking');
      if (!wrap) return;
      var ref = wrap.dataset.ref;
      var carrierInput = wrap.querySelector('.rqd-sample-tracking__carrier');
      var numberInput = wrap.querySelector('.rqd-sample-tracking__number');
      var urlInput = wrap.querySelector('.rqd-sample-tracking__url');
      var carrier = carrierInput ? carrierInput.value.trim() : '';
      var number = numberInput ? numberInput.value.trim() : '';
      var trackingUrl = urlInput ? urlInput.value.trim() : '';
      if (!number && !(await rqdConfirm('The tracking number, carrier and link come off this deal.', { title: 'Clear the sample tracking record for ' + ref + '?', confirmLabel: 'Clear it', danger: true }))) return;
      var _isWm = true;   // this card only ever edits workstation_meta
      var origText = btn.textContent;
      btn.textContent = number ? 'Saving…' : 'Clearing…';
      btn.disabled = true;
      try {
        await API.post('/quote-sample-tracking-save', {
          ref: ref,
          trackingNumber: number,
          carrier: carrier,
          trackingUrl: trackingUrl,
        });
        if (number && carrier && trackingUrl) {
          rememberSampleCarrierUrl(carrier, trackingUrl, number);
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — ⛔ NO fetchQuotes() HERE. Ryan: *"when
           save is clicked, I don't want it to collapse the deal and scroll me back up to the
           top of the DD."* A refetch rebuilds every row, which closes the open detail panel and
           throws the page back to the top — for a three-field save whose values are already on
           screen. Patch the row in memory so the next real render agrees with the server, and
           leave the DOM alone. */
        var _q = allQuotes.find(function (x) { return x.reference === ref; });
        if (_q) {
          var _rec = number ? { carrier: carrier, number: number, url: trackingUrl } : null;
          if (_isWm) _q.quoteSampleTracking = _rec; else _q.sampleTracking = _rec;
          if (window.RQD && typeof RQD.mirrorSampleFields === 'function') RQD.mirrorSampleFields(ref);
        }
        btn.textContent = number ? 'Saved ✓' : 'Cleared ✓';
        if (!number) {
          [carrierInput, numberInput, urlInput].forEach(function (el) { if (el) el.value = ''; });
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — repaint the summary and leave edit mode,
           mirroring the lead-side handler. Required for the same reason: this path deliberately does
           not refetch the board, so nothing else would ever redraw these three cells and the card
           would save correctly while still showing the old values.
           ⚠️ Guarded on the class — the summary only exists when RQD.buildSampleTrackingView was
           available at render time, and this card falls back to a plain input row when it was not. */
        if (wrap.classList.contains('rqd-sample-tracking--summary')) {
          if (window.RQD && typeof RQD.paintSampleTrackingView === 'function') {
            RQD.paintSampleTrackingView(wrap, number ? { carrier: carrier, number: number, url: trackingUrl } : null);
          }
          _stExitEdit(wrap);
        }
        setTimeout(function () { if (btn.isConnected) { btn.textContent = origText; btn.disabled = false; } }, 1600);
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      } catch (err) {
        btn.textContent = origText;
        btn.disabled = false;
        rqdAlert('Could not save tracking: ' + (err && err.message ? err.message : 'Unknown error'));
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Admin-only date
       override popover. Anchored to the ✎ button in the date column on
       offline non-pending rows. Save posts to /admin/quote-date-override
       which writes wm.createdAtOverride; both read paths
       (quote-dashboard.js:1402 + quote-status.js:567) already honor it.
       Clear button (visible only when override likely exists — admin
       chose a date) wipes back to the draft.createdAt fallback. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Purchase-action
       dropdown menu. Replaces the earlier split-button (Generate PO + chevron)
       per Ryan — the chevron-on-half-a-button looked dumb. Now a single
       "-- Select -- ▾" button opens this menu with both options equal:
       Generate PO + Mark Purchased (no PO). Clicking Generate PO routes
       to the existing handlePoGenerate flow; clicking Mark Purchased opens
       the popover (date + note + Save). */
    function openPurchaseActionMenu(btn, ref, vendor, bucket) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Web-order vendors
         (flagged in Vendor Guide as workflow='web-order') skip the menu:
         there's no PO to generate, so the only valid choice is Mark
         Purchased (no PO). Route straight to the popover. Pre-existing menu
         (if any) is closed first so the popover doesn't render behind it. */
      // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — ask about the resolved supplier: a
      // white-label row's own name never carries a workflow when two suppliers share it.
      if (getRowVendorWorkflow(ref, vendor) === 'web-order') {
        var existingMenu = document.getElementById('rqd-purchase-action-menu');
        if (existingMenu) existingMenu.remove();
        openMarkPurchasedPopover(btn, ref, vendor, null);
        return;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var existing = document.getElementById('rqd-purchase-action-menu');
      if (existing) { existing.remove(); return; }
      var rect = btn.getBoundingClientRect();
      var menu = document.createElement('div');
      menu.id = 'rqd-purchase-action-menu';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Sizing + behavior:
         - width: max-content so the menu hugs the longest item ("Mark
           Purchased (no PO)") instead of a fixed 220px container.
         - Close on scroll matches native dropdown UX — keeps the menu
           visually tied to the button without the cost of re-positioning
           on every scroll tick. User re-clicks to reopen. */
      menu.style.cssText = 'position:fixed;z-index:9999;background:var(--rq-bg, #fff);color:var(--rq-text, #000);border:1px solid var(--rq-border, #d1d5db);border-radius:6px;padding:4px;box-shadow:0 4px 12px rgba(0,0,0,0.16);font-family:Montserrat,sans-serif;font-size:12px;width:max-content;';
      var top = rect.bottom + 4;
      var left = rect.left;
      menu.style.top = top + 'px';
      menu.style.left = left + 'px';
      var itemStyle = 'display:block;width:100%;text-align:left;background:transparent;border:0;padding:6px 14px;font-family:inherit;font-size:12px;color:inherit;cursor:pointer;border-radius:4px;white-space:nowrap;';
      menu.innerHTML =
        '<button type="button" class="rqd-purchase-action-menu__item" data-purchase-choice="generate" style="' + itemStyle + '">Generate PO</button>' +
        '<button type="button" class="rqd-purchase-action-menu__item" data-purchase-choice="mark-purchased" style="' + itemStyle + '">Mark Purchased (no PO)</button>';
      /* Mount inside the portal wrap so the --rq-bg / --rq-text / --rq-border
         CSS variables resolve to the active light/dark palette. document.body
         sits OUTSIDE the portal wrap (where the .rep-quote-dark class lives),
         so menus appended there fall back to placeholder defaults (#fff) and
         look stark white on dark mode. */
      var _mountWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
      _mountWrap.appendChild(menu);
      // Nudge left if the menu would overflow the right edge of the viewport.
      var menuRect = menu.getBoundingClientRect();
      if (menuRect.right > window.innerWidth - 8) {
        menu.style.left = (Math.max(8, window.innerWidth - menuRect.width - 8)) + 'px';
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      function close() { if (menu && menu.parentNode) menu.parentNode.removeChild(menu); document.removeEventListener('mousedown', outside, true); document.removeEventListener('keydown', onKey); window.removeEventListener('scroll', onScroll, true); }
      function outside(ev) { if (!menu.contains(ev.target) && ev.target !== btn) close(); }
      function onKey(ev) { if (ev.key === 'Escape') close(); }
      function onScroll() { close(); }
      menu.addEventListener('click', function(ev) {
        var it = ev.target.closest('[data-purchase-choice]');
        if (!it) return;
        ev.stopPropagation();
        var choice = it.dataset.purchaseChoice;
        close();
        // Defer one tick so the click event finishes before the next surface opens
        setTimeout(function() {
          if (choice === 'generate') {
            handlePoGenerate(ref, vendor, false, bucket, btn);
          } else if (choice === 'mark-purchased') {
            openMarkPurchasedPopover(btn, ref, vendor, null);
          }
        }, 0);
      });
      Array.prototype.forEach.call(menu.querySelectorAll('.rqd-purchase-action-menu__item'), function (el) {
        el.addEventListener('mouseenter', function() { this.style.background = 'var(--rq-bg-hover, #f3f4f6)'; });
        el.addEventListener('mouseleave', function() { this.style.background = 'transparent'; });
      });
      setTimeout(function() {
        document.addEventListener('mousedown', outside, true);
        document.addEventListener('keydown', onKey);
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Close on scroll
           so the menu stays visually tied to its button. Capture phase
           catches scrolls in any ancestor (page or nested scroll containers). */
        window.addEventListener('scroll', onScroll, true);
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      }, 50);
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-27) — Commission "mark paid"
       date popover, mirroring the Purchasing Mark Purchased popover. Pick the
       date the commission was paid → Save posts { [field]:true, [dateField]:
       date } in ONE call, so the paid flag + date land together (the old inline
       date input could set the date without flipping the flag, leaving the
       order un-closeable). When already paid, Remove clears it (undo). `field`
       is commissionPaid / cfaCommissionPaid / referralPaid. */
    function openCommissionPaidPopover(btn, ref, field, dateField, label, isPaid, existingIso) {
      var prior = document.getElementById('rqd-commission-paid-popover');
      if (prior) prior.remove();
      function _localTodayYmd() {
        var d = new Date();
        var m = String(d.getMonth() + 1).padStart(2, '0');
        var day = String(d.getDate()).padStart(2, '0');
        return d.getFullYear() + '-' + m + '-' + day;
      }
      var dateVal = existingIso || _localTodayYmd();
      var rect = btn.getBoundingClientRect();
      var pop = document.createElement('div');
      pop.id = 'rqd-commission-paid-popover';
      pop.style.cssText = 'position:fixed;z-index:9999;background:var(--rq-bg, #fff);color:var(--rq-text, #000);border:1px solid var(--rq-border, #d1d5db);border-radius:8px;padding:12px 14px;box-shadow:0 6px 20px rgba(0,0,0,0.20);font-family:Montserrat,sans-serif;font-size:12px;display:flex;flex-direction:column;gap:10px;min-width:240px;max-width:300px;';
      var top = rect.bottom + 6;
      var left = rect.right - 240;
      if (left < 8) left = 8;
      if (top + 180 > window.innerHeight) top = Math.max(8, window.innerHeight - 180);
      pop.style.top = top + 'px';
      pop.style.left = left + 'px';
      pop.innerHTML =
        '<div style="font-weight:700;font-size:11px;letter-spacing:0.04em;text-transform:uppercase;color:var(--rq-text-secondary, #6b7280);">' + esc(label) + '</div>' +
        '<label style="display:flex;flex-direction:column;gap:4px;">' +
          '<span style="font-size:11px;color:var(--rq-text-secondary, #6b7280);">Paid on</span>' +
          '<input type="date" id="rqd-commission-paid-date" value="' + esc(dateVal) + '" style="padding:6px 8px;border:1px solid var(--rq-border, #d1d5db);border-radius:4px;font-family:inherit;font-size:13px;background:var(--rq-bg, #fff);color:var(--rq-text, #000);">' +
        '</label>' +
        '<div style="display:flex;gap:6px;justify-content:flex-end;align-items:center;">' +
          (isPaid ? '<button type="button" id="rqd-commission-paid-remove" style="background:transparent;border:1px solid var(--rq-border, #d1d5db);color:#b91c1c;border-radius:999px;padding:4px 10px;cursor:pointer;font-family:inherit;font-size:11px;margin-right:auto;">Remove</button>' : '') +
          '<button type="button" id="rqd-commission-paid-cancel" style="background:transparent;border:1px solid var(--rq-border, #d1d5db);color:var(--rq-text-secondary, #6b7280);border-radius:999px;padding:4px 10px;cursor:pointer;font-family:inherit;font-size:11px;">Cancel</button>' +
          '<button type="button" id="rqd-commission-paid-save" style="background:#2563eb;border:1px solid #2563eb;color:#fff;border-radius:999px;padding:4px 12px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:600;">Save</button>' +
        '</div>';
      var _mountWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
      _mountWrap.appendChild(pop);
      var dateInput = pop.querySelector('#rqd-commission-paid-date');
      if (dateInput) setTimeout(function () { dateInput.focus(); }, 30);
      function close() { if (pop && pop.parentNode) pop.parentNode.removeChild(pop); document.removeEventListener('mousedown', outside, true); document.removeEventListener('keydown', onKey); window.removeEventListener('scroll', onScroll, true); }
      function outside(ev) { if (!pop.contains(ev.target)) close(); }
      function onKey(ev) { if (ev.key === 'Escape') close(); }
      function onScroll() { close(); }
      function rerender() {
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        if (!q) return;
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl) { detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q); }
        if (typeof refreshProgressBar === 'function') refreshProgressBar(ref);
      }
      async function save() {
        var dv = dateInput ? dateInput.value.trim() : '';
        if (!dv) { rqdAlert('Pick the date the commission was paid.'); return; }
        var payload = { ref: ref };
        payload[field] = true;
        payload[dateField] = dv;
        var saveBtn = pop.querySelector('#rqd-commission-paid-save');
        if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Saving…'; }
        try {
          await API.post('/quote-lifecycle', payload);
          var q = allQuotes.find(function (x) { return x.reference === ref; });
          if (q) { q[field] = true; q[dateField] = dv; }
          close();
          rerender();
        } catch (err) {
          if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save'; }
          rqdAlert('Could not save: ' + (err && err.message ? err.message : 'unknown error'));
        }
      }
      async function remove() {
        var payload = { ref: ref };
        payload[field] = false;
        payload[dateField] = null;
        try {
          await API.post('/quote-lifecycle', payload);
          var q = allQuotes.find(function (x) { return x.reference === ref; });
          if (q) { q[field] = false; q[dateField] = null; }
          close();
          rerender();
        } catch (err) {
          rqdAlert('Could not undo: ' + (err && err.message ? err.message : 'unknown error'));
        }
      }
      pop.querySelector('#rqd-commission-paid-save').addEventListener('click', save);
      pop.querySelector('#rqd-commission-paid-cancel').addEventListener('click', close);
      var rmBtn = pop.querySelector('#rqd-commission-paid-remove');
      if (rmBtn) rmBtn.addEventListener('click', remove);
      setTimeout(function () {
        document.addEventListener('mousedown', outside, true);
        document.addEventListener('keydown', onKey);
        window.addEventListener('scroll', onScroll, true);
      }, 0);
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    function openMarkPurchasedPopover(btn, ref, vendor, existing) {
      var prior = document.getElementById('rqd-mark-purchased-popover');
      if (prior) prior.remove();
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Default to LOCAL
         today, not UTC. `new Date().toISOString().slice(0,10)` returns the
         UTC date which lands a day ahead for any user west of UTC after
         their local noon. For MTN (UTC-6/-7), a click at 7pm local on 5/20
         was defaulting to 2026-05-21. Build YYYY-MM-DD from local Date
         components instead so the picker matches the user's calendar. */
      function _localTodayYmd() {
        var d = new Date();
        var m = String(d.getMonth() + 1).padStart(2, '0');
        var day = String(d.getDate()).padStart(2, '0');
        return d.getFullYear() + '-' + m + '-' + day;
      }
      var existingDate = (existing && existing.purchasedAt) || _localTodayYmd();
      var existingNote = (existing && existing.purchasedNote) || '';
      /* CUSTOM_AGENTACCESS_BY_CLAUDE (AIOPS 959e860c4e03, 2026-09-04) — the supplier's own
         order / confirmation number. The agent route (`purchasing.mark`) writes it as
         purchasedOrderNumber; this field is the human's copy of the same stamp, so a
         site-buy recorded by either reads the same on the record and in the feed. */
      var existingOrderNo = (existing && existing.purchasedOrderNumber) || '';
      var isEdit = !!existing;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22 / extended 2026-05-28) —
         Optional freight cost on every Mark Purchased save (web-order AND
         standard direct-purchase). Web-order vendors get freight revealed
         only after the web purchase; non-bucket parcel direct-purchases
         (e.g. Lock-Jaw on SHOP-1725, supplier "buy 2 get freight free")
         have no other place to record freight — Freight Balance card is
         hidden for non-bucket, non-post-ship online orders, so without
         this field the Freight Added status step is unreachable. On Save
         the cost flows through the worker to freightQuotes[vendor] so it
         lands in financials + flips the step done. Pre-fill from any
         existing freightQuotes[vendor].cost when editing. */
      // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — resolved supplier, same reason as above.
      var _wfForPop = getRowVendorWorkflow(ref, vendor);
      var _isWebOrderPop = _wfForPop === 'web-order';
      var _existingFreightCost = '';
      var _q = allQuotes.find(function (x) { return x.reference === ref; });
      if (_q && _q.freightQuotes && _q.freightQuotes[vendor] && _q.freightQuotes[vendor].cost != null) {
        _existingFreightCost = String(_q.freightQuotes[vendor].cost);
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var pop = document.createElement('div');
      pop.id = 'rqd-mark-purchased-popover';
      pop.style.cssText = 'position:fixed;z-index:9999;background:var(--rq-bg, #fff);color:var(--rq-text, #000);border:1px solid var(--rq-border, #d1d5db);border-radius:8px;padding:12px 14px;box-shadow:0 6px 20px rgba(0,0,0,0.20);font-family:Montserrat,sans-serif;font-size:12px;display:flex;flex-direction:column;gap:10px;min-width:280px;max-width:320px;';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-01) — Position is computed in
         repositionPop() AFTER append (so it reads the popover's real measured
         height instead of a 240px guess that let a tall popover hang off the
         bottom) and re-run on scroll so the popover stays glued to the button
         rather than closing. */
      var _popTitle = _isWebOrderPop ? 'Log web purchase' : 'Log direct purchase';
      var _freightCostFieldHtml =
        '<label style="display:flex;flex-direction:column;gap:4px;">' +
          '<span style="font-size:11px;color:var(--rq-text-secondary, #6b7280);">Freight charged by vendor <span style="color:var(--rq-text-secondary, #9ca3af);font-weight:400;">(enter 0 if none)</span></span>' +
          '<div style="display:flex;align-items:center;gap:4px;">' +
            '<span style="font-size:13px;color:var(--rq-text-secondary, #6b7280);">$</span>' +
            '<input type="text" inputmode="decimal" id="rqd-mark-purchased-freight" value="' + esc(_existingFreightCost) + '" placeholder="0.00" style="flex:1;padding:6px 8px;border:1px solid var(--rq-border, #d1d5db);border-radius:4px;font-family:inherit;font-size:13px;background:var(--rq-bg, #fff);color:var(--rq-text, #000);">' +
          '</div>' +
        '</label>';
      pop.innerHTML =
        '<div style="font-weight:700;font-size:11px;letter-spacing:0.04em;text-transform:uppercase;color:var(--rq-text-secondary, #6b7280);">' + esc(_popTitle) + '</div>' +
        '<label style="display:flex;flex-direction:column;gap:4px;">' +
          '<span style="font-size:11px;color:var(--rq-text-secondary, #6b7280);">Purchased on</span>' +
          '<input type="date" id="rqd-mark-purchased-date" value="' + esc(existingDate) + '" style="padding:6px 8px;border:1px solid var(--rq-border, #d1d5db);border-radius:4px;font-family:inherit;font-size:13px;background:var(--rq-bg, #fff);color:var(--rq-text, #000);">' +
        '</label>' +
        '<label style="display:flex;flex-direction:column;gap:4px;">' +
          '<span style="font-size:11px;color:var(--rq-text-secondary, #6b7280);">Supplier order # <span style="color:var(--rq-text-secondary, #9ca3af);font-weight:400;">(optional)</span></span>' +
          '<input type="text" id="rqd-mark-purchased-orderno" maxlength="60" value="' + esc(existingOrderNo) + '" placeholder="e.g. 5V0NGPZQ8" style="padding:6px 8px;border:1px solid var(--rq-border, #d1d5db);border-radius:4px;font-family:inherit;font-size:13px;background:var(--rq-bg, #fff);color:var(--rq-text, #000);">' +
        '</label>' +
        '<label style="display:flex;flex-direction:column;gap:4px;">' +
          '<span style="font-size:11px;color:var(--rq-text-secondary, #6b7280);">Note</span>' +
          '<textarea id="rqd-mark-purchased-note" rows="2" maxlength="400" placeholder="" style="padding:6px 8px;border:1px solid var(--rq-border, #d1d5db);border-radius:4px;font-family:inherit;font-size:12px;background:var(--rq-bg, #fff);color:var(--rq-text, #000);resize:vertical;">' + esc(existingNote) + '</textarea>' +
        '</label>' +
        _freightCostFieldHtml +
        '<div style="display:flex;gap:6px;justify-content:flex-end;align-items:center;">' +
          (isEdit ? '<button type="button" id="rqd-mark-purchased-remove" class="rqd-mark-purchased-remove-btn" style="background:transparent;border:1px solid var(--rq-border, #d1d5db);color:#b91c1c;border-radius:999px;padding:4px 10px;cursor:pointer;font-family:inherit;font-size:11px;margin-right:auto;transition:background 0.15s, border-color 0.15s, color 0.15s;">Remove</button>' : '') +
          '<button type="button" id="rqd-mark-purchased-cancel" class="rqd-mark-purchased-cancel-btn" style="background:transparent;border:1px solid var(--rq-border, #d1d5db);color:var(--rq-text-secondary, #6b7280);border-radius:999px;padding:4px 10px;cursor:pointer;font-family:inherit;font-size:11px;transition:background 0.15s, border-color 0.15s, color 0.15s;">Cancel</button>' +
          '<button type="button" id="rqd-mark-purchased-save" class="rqd-mark-purchased-save-btn" style="background:#2563eb;border:1px solid #2563eb;color:#fff;border-radius:999px;padding:4px 12px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:600;transition:background 0.15s, border-color 0.15s, color 0.15s;">Save</button>' +
        '</div>';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Mount inside portal
         wrap so CSS variables resolve to the active light/dark palette
         (same fix as openPurchaseActionMenu above). */
      var _mountWrapMp = document.querySelector('.rep-quote-portal-wrap') || document.body;
      _mountWrapMp.appendChild(pop);
      repositionPop(); // place now that offsetHeight is measurable
      var dateInput = pop.querySelector('#rqd-mark-purchased-date');
      var noteInput = pop.querySelector('#rqd-mark-purchased-note');
      if (dateInput) setTimeout(function() { dateInput.focus(); }, 30);

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-01) — On scroll, REPOSITION
         the popover to stay glued to the trigger button instead of closing it.
         It used to close on every scroll (it's position:fixed, so it would
         otherwise detach from the button) — but that made it vanish the moment
         the rep nudged the page. Now it tracks the button as the page scrolls,
         so the rep can scroll a near-bottom popover up into the center of the
         display. repositionPop also flips the popover ABOVE the button when
         there isn't room below + clamps inside the viewport, so it never opens
         half-off the bottom edge. */
      var _mpRaf = false;
      function repositionPop() {
        var r = btn.getBoundingClientRect();
        var popH = pop.offsetHeight || 240;
        var popW = pop.offsetWidth || 300;
        var top = r.bottom + 6;
        if (top + popH > window.innerHeight - 8) {
          var above = r.top - popH - 6;
          top = above >= 8 ? above : Math.max(8, window.innerHeight - popH - 8);
        }
        if (top < 8) top = 8;
        var left = r.right - popW; // right-align to the trigger button
        if (left + popW > window.innerWidth - 8) left = window.innerWidth - popW - 8;
        if (left < 8) left = 8;
        pop.style.top = Math.round(top) + 'px';
        pop.style.left = Math.round(left) + 'px';
      }
      function close() { if (pop && pop.parentNode) pop.parentNode.removeChild(pop); document.removeEventListener('mousedown', outside, true); document.removeEventListener('keydown', onKey); window.removeEventListener('scroll', onScroll, true); window.removeEventListener('resize', onScroll); }
      function outside(ev) { if (!pop.contains(ev.target)) close(); }
      function onKey(ev) { if (ev.key === 'Escape') close(); }
      function onScroll() { if (_mpRaf) return; _mpRaf = true; requestAnimationFrame(function () { _mpRaf = false; repositionPop(); }); }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — In-place re-render
         on save so the row stays expanded and scroll position holds. The
         worker response carries the updated ordering[vendor] payload; we
         splice it into the local q + re-render just that row's detail
         panel (pattern borrowed from the Financials full-margin toggle
         re-render at L2850). Avoids fetchQuotes() which collapses the
         row + scrolls to top of table. */
      function applyOrderingPatch(orderingPatch) {
        var q = allQuotes.find(function (x) { return x.reference === ref; });
        if (!q) return;
        q.ordering = q.ordering || {};
        if (orderingPatch && typeof orderingPatch === 'object') {
          q.ordering[vendor] = orderingPatch;
        } else {
          // Clear path: server returned an empty object (purchasedDirectly
          // fields stripped + ordered: false). Mirror locally so the
          // re-render shows the "-- Select --" dropdown back in place.
          q.ordering[vendor] = orderingPatch || {};
        }
        var detailEl = document.getElementById('rqd-detail-' + ref);
        if (detailEl) {
          detailEl.innerHTML = buildDetailHtml(q);
          applyCollapseState(detailEl, q);
        }
      }
      async function save() {
        var dateVal = dateInput ? dateInput.value.trim() : '';
        var noteVal = noteInput ? noteInput.value.trim() : '';
        if (!dateVal) { rqdAlert('Pick a purchase date.'); return; }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Optional freight
           cost (web-order vendors only). Empty string = "don't touch the
           cost field on the lifecycle record". A literal "0" or any
           non-negative number writes to freightQuotes[vendor].cost + sets
           receivedAt so the Freight Added status step flips done. Negative
           or non-numeric input is rejected with an alert (worker also
           validates as defense-in-depth). */
        var freightInput = pop.querySelector('#rqd-mark-purchased-freight');
        var freightVal = freightInput ? freightInput.value.trim() : '';
        var freightNum = null;
        if (freightVal !== '') {
          freightNum = parseFloat(freightVal.replace(/[$,]/g, ''));
          if (!isFinite(freightNum) || freightNum < 0) {
            rqdAlert('Freight cost must be a non-negative number (use 0 if no freight was charged).');
            return;
          }
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        var saveBtn = pop.querySelector('#rqd-mark-purchased-save');
        if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Saving…'; }
        try {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Pass the vendor's
             Vendor-Guide workflow so the worker can pick the right deal-feed
             event type ('vendor-web-purchased' for web-order vendors, falls
             back to 'vendor-purchased' otherwise). Also pass freightCost when
             the rep entered one (web-order only — worker writes it to
             freightQuotes[vendor] so it lands in financials). */
          var _payload = {
            ref: ref, vendor: vendor, purchasedAt: dateVal, note: noteVal,
            workflow: getVendorWorkflow(vendor)
          };
          if (freightNum != null) _payload.freightCost = freightNum;
          /* CUSTOM_AGENTACCESS_BY_CLAUDE (AIOPS 959e860c4e03, 2026-09-04) — same field the
             agent sends; the worker keeps the existing number when this is left blank. */
          var _orderNoInput = pop.querySelector('#rqd-mark-purchased-orderno');
          var _orderNoVal = _orderNoInput ? _orderNoInput.value.trim() : '';
          if (_orderNoVal) _payload.supplierOrderNumber = _orderNoVal;
          var resp = await API.post('/vendor-mark-purchased', _payload);
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          close();
          applyOrderingPatch(resp && resp.ordering);
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-22) — Patch local
             freightQuotes too so the status bar's Freight Added step flips
             done immediately without waiting for the next fetchQuotes. */
          if (freightNum != null && resp && resp.freightQuotes && resp.freightQuotes[vendor]) {
            var _qLocal = allQuotes.find(function (x) { return x.reference === ref; });
            if (_qLocal) {
              _qLocal.freightQuotes = _qLocal.freightQuotes || {};
              _qLocal.freightQuotes[vendor] = resp.freightQuotes[vendor];
              var _detailEl = document.getElementById('rqd-detail-' + ref);
              if (_detailEl) { _detailEl.innerHTML = buildDetailHtml(_qLocal); applyCollapseState(_detailEl, _qLocal); }
            }
          }
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-28) — Refresh the row's
             progress cell so the TO DO column emoji strip (PO Sent → 🛒
             Purchased, Freight Added flip) updates in sync with the detail
             panel. Without this, the panel bar showed ✓ on all four steps
             but the row's emoji strip stayed stale until next fetchQuotes. */
          refreshProgressBar(ref);
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        } catch (err) {
          rqdAlert('Could not save: ' + (err && err.message ? err.message : 'Unknown error'));
          if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save'; }
        }
      }
      async function remove() {
        if (!(await rqdConfirm('This will let you Generate a PO for them instead.', { title: 'Remove the direct-purchase record for ' + vendor + '?', confirmLabel: 'Remove', danger: true }))) return;
        var removeBtn = pop.querySelector('#rqd-mark-purchased-remove');
        if (removeBtn) { removeBtn.disabled = true; removeBtn.textContent = 'Removing…'; }
        try {
          var resp = await API.post('/vendor-mark-purchased', { ref: ref, vendor: vendor, clear: true });
          close();
          applyOrderingPatch(resp && resp.ordering);
          refreshProgressBar(ref);
        } catch (err) {
          rqdAlert('Could not remove: ' + (err && err.message ? err.message : 'Unknown error'));
          if (removeBtn) { removeBtn.disabled = false; removeBtn.textContent = 'Remove'; }
        }
      }
      pop.querySelector('#rqd-mark-purchased-save').addEventListener('click', save);
      pop.querySelector('#rqd-mark-purchased-cancel').addEventListener('click', close);
      var rmBtn = pop.querySelector('#rqd-mark-purchased-remove');
      if (rmBtn) rmBtn.addEventListener('click', remove);
      setTimeout(function() {
        document.addEventListener('mousedown', outside, true);
        document.addEventListener('keydown', onKey);
        window.addEventListener('scroll', onScroll, true);
        window.addEventListener('resize', onScroll);
      }, 50);
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    function openDateOverridePopover(btn) {
      var existing = document.getElementById('rqd-date-override-popover');
      if (existing) existing.remove();
      var ref = btn.dataset.ref;
      var current = btn.dataset.current || '';
      var rect = btn.getBoundingClientRect();
      var pop = document.createElement('div');
      pop.id = 'rqd-date-override-popover';
      pop.style.cssText = 'position:fixed;z-index:9999;background:var(--rq-bg, #fff);color:var(--rq-text, #000);border:1px solid var(--rq-border, #d1d5db);border-radius:8px;padding:10px 12px;box-shadow:0 4px 16px rgba(0,0,0,0.18);font-family:Montserrat,sans-serif;font-size:12px;display:flex;flex-direction:column;gap:8px;min-width:220px;';
      var top = rect.bottom + 6;
      var left = rect.left;
      // Clamp right edge so popover stays on-screen
      if (left + 240 > window.innerWidth) left = window.innerWidth - 248;
      pop.style.top = top + 'px';
      pop.style.left = left + 'px';
      pop.innerHTML =
        '<div style="font-weight:700;font-size:11px;letter-spacing:0.04em;text-transform:uppercase;color:var(--rq-text-secondary, #6b7280);">Edit date · ' + esc(ref) + '</div>' +
        '<input type="date" id="rqd-date-override-input" value="' + esc(current) + '" style="padding:6px 8px;border:1px solid var(--rq-border, #d1d5db);border-radius:4px;font-family:inherit;font-size:13px;background:var(--rq-bg, #fff);color:var(--rq-text, #000);">' +
        '<div style="display:flex;gap:6px;justify-content:flex-end;">' +
          '<button type="button" id="rqd-date-override-clear" style="background:transparent;border:1px solid var(--rq-border, #d1d5db);color:var(--rq-text-secondary, #6b7280);border-radius:999px;padding:4px 10px;cursor:pointer;font-family:inherit;font-size:11px;">Clear</button>' +
          '<button type="button" id="rqd-date-override-cancel" style="background:transparent;border:1px solid var(--rq-border, #d1d5db);color:var(--rq-text-secondary, #6b7280);border-radius:999px;padding:4px 10px;cursor:pointer;font-family:inherit;font-size:11px;">Cancel</button>' +
          '<button type="button" id="rqd-date-override-save" style="background:#2563eb;border:1px solid #2563eb;color:#fff;border-radius:999px;padding:4px 12px;cursor:pointer;font-family:inherit;font-size:11px;font-weight:600;">Save</button>' +
        '</div>';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-20) — Mount inside portal
         wrap so CSS variables resolve to the active light/dark palette. */
      var _mountWrapDo = document.querySelector('.rep-quote-portal-wrap') || document.body;
      _mountWrapDo.appendChild(pop);
      var input = pop.querySelector('#rqd-date-override-input');
      if (input) setTimeout(function() { input.focus(); }, 30);

      function close() { if (pop && pop.parentNode) pop.parentNode.removeChild(pop); document.removeEventListener('mousedown', outside, true); document.removeEventListener('keydown', onKey); }
      function outside(ev) { if (!pop.contains(ev.target)) close(); }
      function onKey(ev) { if (ev.key === 'Escape') close(); if (ev.key === 'Enter' && pop.contains(document.activeElement)) save(); }
      async function save() {
        var newDate = input ? input.value.trim() : '';
        await submit(newDate);
      }
      async function submit(value) {
        var saveBtn = pop.querySelector('#rqd-date-override-save');
        if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Saving…'; }
        try {
          await API.post('/admin/quote-date-override', { ref: ref, createdAt: value });
          close();
          fetchQuotes();
        } catch (err) {
          rqdAlert('Could not save date: ' + (err && err.message ? err.message : 'Unknown error'));
          if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save'; }
        }
      }
      pop.querySelector('#rqd-date-override-save').addEventListener('click', save);
      pop.querySelector('#rqd-date-override-cancel').addEventListener('click', close);
      pop.querySelector('#rqd-date-override-clear').addEventListener('click', async function() {
        if (await rqdConfirm('The deal goes back to its real created date.', { title: 'Clear the date override for ' + ref + '?', confirmLabel: 'Clear the override', danger: true })) submit('');
      });
      setTimeout(function() {
        document.addEventListener('mousedown', outside, true);
        document.addEventListener('keydown', onKey);
      }, 50);
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    async function handleSampleTrackingSave(btn) {
      var wrap = btn.closest('.rqd-sample-tracking');
      if (!wrap) return;
      var ref = wrap.dataset.ref;
      /* CUSTOM_SAMPLES2ND_BY_CLAUDE (Ryan 2026-09-24) — second recipient: the block's widget wears
         `data-lane="2"`; the same door takes `recipient: 2` and writes THEIR box, never the buyer's. */
      var _lane2 = wrap.dataset.lane === '2';
      var carrierInput = wrap.querySelector('.rqd-sample-tracking__carrier');
      var numberInput = wrap.querySelector('.rqd-sample-tracking__number');
      var urlInput = wrap.querySelector('.rqd-sample-tracking__url');
      var carrier = carrierInput ? carrierInput.value.trim() : '';
      var number = numberInput ? numberInput.value.trim() : '';
      var trackingUrl = urlInput ? urlInput.value.trim() : '';

      // Empty save = clear the tracking record. Confirm first to avoid
      // accidental wipes (no separate Clear button — admin deletes the
      // fields and saves over them).
      if (!number && !(await rqdConfirm(_lane2 ? 'The second recipient\'s tracking number, carrier and link come off this deal.' : 'The tracking number, carrier and link come off this deal.', { title: 'Clear the ' + (_lane2 ? 'second recipient\'s ' : '') + 'tracking record for ' + ref + '?', confirmLabel: 'Clear it', danger: true }))) return;

      /* ⚠️ WHICH RECORD OWNS THE TRACKING, not which card drew. This card also renders for a
         deal whose sample lives on the QUOTE (an `rfq` lead with a wm shipment), and posting
         that to the lead endpoint used to be refused outright. The worker forwards it now, but
         addressing it correctly is better than relying on the catch. */
      var _isWm = (wrap.dataset.owner || '') === 'wm';

      var origText = btn.textContent;
      btn.textContent = number ? 'Saving…' : 'Clearing…';
      btn.disabled = true;
      try {
        var _saveRes = await API.post(_isWm ? '/quote-sample-tracking-save' : '/sample-tracking-save', Object.assign({
          ref: ref,
          trackingNumber: number,
          carrier: carrier,
          trackingUrl: trackingUrl,
        }, _lane2 ? { recipient: 2 } : {}));
        if (number && carrier && trackingUrl) {
          rememberSampleCarrierUrl(carrier, trackingUrl, number);
        }
        if (_lane2) {
          /* CUSTOM_SAMPLES2ND_BY_CLAUDE — the block in memory learns the box and re-renders whole (chip,
             Status row, the "Awaiting Box 2" label on the buyer's Notify). No refetch, same as below. */
          var _q2 = allQuotes.find(function (x) { return x.reference === ref; });
          if (_q2 && _q2.sampleSecondary && typeof _q2.sampleSecondary === 'object') {
            var _rec2 = (_saveRes && _saveRes.sampleTracking) || (number ? { carrier: carrier, number: number, url: trackingUrl, savedAt: new Date().toISOString() } : null);
            _q2.sampleSecondary = Object.assign({}, _q2.sampleSecondary, { sampleTracking: _rec2, status: _rec2 ? 'shipped' : (_q2.sampleSecondary.requested ? 'requested' : 'draft') });
            if (window.RQD && typeof RQD.mirrorSampleFields === 'function') RQD.mirrorSampleFields(ref);
          }
          btn.textContent = number ? 'Saved ✓' : 'Cleared ✓';
          setTimeout(function () {
            if (window.RQD && typeof RQD.rerenderSampleSecondary === 'function') RQD.rerenderSampleSecondary(ref);
            var _detail = document.getElementById('rqd-detail-' + ref);
            if (_detail && _q2) {
              var _nb = _detail.querySelector('.rqd-sample-notify:not([data-lane="2"])');
              var _waiting = !!(window.RQD && typeof RQD.samplePairWaiting === 'function' && RQD.samplePairWaiting(_q2));
              if (_nb && !_q2.sampleNotifiedAt) { _nb.textContent = _waiting ? 'Awaiting Box 2' : 'Notify Customer'; _nb.classList.toggle('rqd-sample-notify--waiting', _waiting); }
            }
          }, 900);
          return;
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — ⛔ NO fetchQuotes() HERE. Ryan: *"when
           save is clicked, I don't want it to collapse the deal and scroll me back up to the
           top of the DD."* A refetch rebuilds every row, which closes the open detail panel and
           throws the page back to the top — for a three-field save whose values are already on
           screen. Patch the row in memory so the next real render agrees with the server, and
           leave the DOM alone. */
        var _q = allQuotes.find(function (x) { return x.reference === ref; });
        if (_q) {
          var _rec = number ? { carrier: carrier, number: number, url: trackingUrl } : null;
          if (_isWm) _q.quoteSampleTracking = _rec; else _q.sampleTracking = _rec;
          if (window.RQD && typeof RQD.mirrorSampleFields === 'function') RQD.mirrorSampleFields(ref);
        }
        btn.textContent = number ? 'Saved ✓' : 'Cleared ✓';
        if (!number) {
          [carrierInput, numberInput, urlInput].forEach(function (el) { if (el) el.value = ''; });
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — repaint the summary, then step back out
           of edit mode. ⛔ THE DROPPED REFETCH ABOVE MAKES THIS MANDATORY, NOT COSMETIC: with no
           re-render there is nothing else in the app that would ever redraw these three cells, so
           without it the card would save correctly and keep showing the OLD values — the same
           "the write landed, the read didn't" shape that cost an afternoon on RW-1241-A.
           ⚠️ Placed AFTER the clear-inputs branch above so a cleared record repaints to its three
           "Add …" prompts rather than to the values it just dropped.
           ⚠️ Guarded on the class — the quote-side card renders no summary to paint. */
        if (wrap.classList.contains('rqd-sample-tracking--summary')) {
          if (window.RQD && typeof RQD.paintSampleTrackingView === 'function') {
            RQD.paintSampleTrackingView(wrap, number ? { carrier: carrier, number: number, url: trackingUrl } : null);
          }
          _stExitEdit(wrap);
        }
        setTimeout(function () { if (btn.isConnected) { btn.textContent = origText; btn.disabled = false; } }, 1600);
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      } catch (err) {
        btn.textContent = origText;
        btn.disabled = false;
        rqdAlert('Could not save tracking: ' + (err && err.message ? err.message : 'Unknown error'));
      }
    }

    // Hold-until date picker modal — preset buttons (+3/+7/+14/+30/+90 days)
    // plus optional reason. Default pre-selected preset is +3 days (the most
    // common "short follow-up" case — most holds resolve within the week).
    // Self-contained overlay appended into .rep-quote-portal-wrap so the
    // --rq-* CSS vars resolve (same trick the date range modal uses).
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Hold modal mirrors
       the inline Notes composer. Same 4 type chips, lifecycle-aware
       preset shelf, lifecycle-aware default arm — but in a popup
       triggered from the status-pill / cog-menu "Put on Hold" flow.
       Submits via /note-entry-add (the worker auto-holds the lead when
       followUpAt is set on a lead ref AND writes the structured note
       entry in one round-trip — so both the inline Notes composer and
       this modal land on the same data path).

       Preset shelf:
       - RESUMED (wokenFromHold flag set): +7/+14/+30/+60/+90/+180,
         default +7d. The lead has been through one hold cycle, so it
         gets the longer-cadence shelf.
       - Fresh NEW LEAD / SAMPLE / DEAD: +1/+2/+3/+4/+5, default +2d
         (chase cadence — leads go cold fast).
       Calendar (date picker) is rendered in BOTH cases — short shelf
       is a nudge, not a hard cap, so the rep can override for outlier
       customers who say "I'm 8 months out".

       Differences from the inline composer (intentional, this is a
       "put on hold" flow specifically):
       - The follow-up is ALWAYS armed (you can't clear it — that would
         defeat the purpose of this modal).
       - The Save button always reads "Put on Hold" (or "Edit Hold Date"
         when editing an existing hold). */
    /* Delegated to assets/dashboard-lead-actions.js (Phase A.2 refactor). */
    function openHoldDateModal(ref, existingHoldUntil, existingReason, isResumed, isPending) {
      return window.RQD.openHoldDateModal(ref, existingHoldUntil, existingReason, isResumed, isPending);
    }
    function handleDownloadPdf(btn) {
      var ref = btn.dataset.ref;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var session = Auth.getSession();
      // JWT in the URL (the worker validates it) — replaces the old &repCode= flow,
      // which was an auth bypass. JWT is short-lived; URL-leak surface acceptable
      // for the new-tab download flow.
      var token = session ? (session.accessToken || '') : '';
      var pdfUrl = 'https://rfq-worker.ryan-29b.workers.dev/pdf?ref=' + encodeURIComponent(ref) + '&token=' + encodeURIComponent(token);
      window.open(pdfUrl, '_blank');
      // Worker stamps pdfDownloaded:true on the workstation_meta KV during PDF
      // generation, which flips NEW LEAD → QUOTED. Refresh after a short delay
      // (PDF gen is a few seconds) so the row reflects the new state without
      // requiring a manual reload.
      setTimeout(function() { fetchQuotes(); }, 3000);
    }

    /* CUSTOM_ONLINESIGN_BY_CLAUDE (Ryan 2026-10-26) — the cog's "Copy payment link". The worker (GET /deal-pay-link) picks the
       link: an offline deal's sign page (sign, then the card button; a signed deal goes straight to the button), any other
       deal's Shopify checkout (the deposit on 50/50). ⛔ The clipboard write is started INSIDE the click, with the link as a
       promise (ClipboardItem): Safari refuses a write that begins after an await, which a fetch-then-copy would be. */
    function handleCopyPayLink(btn) {
      var ref = btn.dataset.ref;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var linkP = window.RepPortal.API.get('/deal-pay-link?ref=' + encodeURIComponent(ref)).then(function (d) {
        if (!d || !d.link) throw new Error((d && (d.detail || d.error)) || 'No payment link');
        return d;
      });
      var said = function (d) {
        _dupToast(d.kind === 'sign'
          ? 'Payment link for ' + ref + ' copied. It opens the sign page: they sign, then pay by card.'
          : 'Payment link for ' + ref + ' copied.');
      };
      var failed = function (e) { _dupToast('No payment link copied: ' + ((e && e.message) || 'unknown error')); };
      try {
        if (window.ClipboardItem && navigator.clipboard && navigator.clipboard.write) {
          var blobP = linkP.then(function (d) { return new Blob([d.link], { type: 'text/plain' }); });
          navigator.clipboard.write([new ClipboardItem({ 'text/plain': blobP })])
            .then(function () { return linkP.then(said); }, function () { return linkP.then(copyAfter); })
            .catch(failed);
          return;
        }
      } catch (_) { /* the plain path below */ }
      linkP.then(copyAfter).catch(failed);
      function copyAfter(d) {
        var ok = function () { said(d); };
        if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(d.link).then(ok, function () { window.prompt('Copy the payment link:', d.link); });
        window.prompt('Copy the payment link:', d.link);
      }
    }

    /* CUSTOM_SIGNEDUNPAID_BY_CLAUDE (card 0a13de9f8439, Ryan 2026-10-26) — Reverse signature, on a signed-but-unpaid deal (🫰 PAYMENT).
       The rep picks why (the customer cancelled / wants changes) and may add a line; POST /deal-signed-order-void moves the signed
       copy to the deal history marked replaced and the deal is a quote again. "Cancelled" does NOT mark it Lost (Ryan: the rep
       does that the usual way). A self-contained modal, like the Cancel / Refund ones below. */
    function handleReverseSignature(btn) {
      var ref = btn.dataset.ref;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var back = document.createElement('div');
      back.setAttribute('style', 'position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;padding:16px;');
      back.innerHTML = '<div role="dialog" aria-modal="true" style="background:#0f1a2b;color:#e5ecf5;border:1px solid #1e2a42;border-radius:12px;max-width:440px;width:100%;padding:20px;font-size:14px;line-height:1.5;">'
        + '<h3 style="margin:0 0 8px;font-size:17px;">Reverse the signature on ' + esc(ref) + '?</h3>'
        + '<p style="margin:0 0 12px;color:#a9b6c8;">The deal goes back to a quote and the payment reminders stop. The signed copy stays in the deal history, marked replaced.</p>'
        + '<label style="display:block;margin:6px 0;"><input type="radio" name="rqd-rev-why" value="cancelled" checked> The customer cancelled</label>'
        + '<label style="display:block;margin:6px 0 10px;"><input type="radio" name="rqd-rev-why" value="changes"> The customer wants changes (they will sign the revised quote)</label>'
        + '<textarea id="rqd-rev-note" rows="2" maxlength="300" placeholder="Optional: what the customer said" style="width:100%;box-sizing:border-box;background:#0b1422;color:#e5ecf5;border:1px solid #1e2a42;border-radius:8px;padding:8px;"></textarea>'
        + '<p id="rqd-rev-err" style="color:#f87171;margin:8px 0 0;display:none;"></p>'
        + '<div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;"><button type="button" id="rqd-rev-cancel" style="padding:8px 14px;border-radius:8px;background:transparent;color:#e5ecf5;border:1px solid #334155;cursor:pointer;">Keep the signature</button>'
        + '<button type="button" id="rqd-rev-go" style="padding:8px 14px;border-radius:8px;background:#b91c1c;color:#fff;border:0;cursor:pointer;font-weight:600;">Reverse signature</button></div></div>';
      document.body.appendChild(back);
      var close = function () { if (back.parentNode) back.parentNode.removeChild(back); };
      back.addEventListener('click', function (ev) { if (ev.target === back) close(); });
      back.querySelector('#rqd-rev-cancel').addEventListener('click', close);
      back.querySelector('#rqd-rev-go').addEventListener('click', function () {
        var go = back.querySelector('#rqd-rev-go');
        var why = (back.querySelector('input[name="rqd-rev-why"]:checked') || {}).value || 'cancelled';
        var note = String(back.querySelector('#rqd-rev-note').value || '').trim();
        go.disabled = true; go.textContent = 'Reversing...';
        window.RepPortal.API.post('/deal-signed-order-void', note ? { ref: ref, reason: why, note: note } : { ref: ref, reason: why }).then(function () {
          close();
          _dupToast('Signature on ' + ref + ' reversed. It is a quote again.');
          setTimeout(function () { fetchQuotes(); }, 600);
        }).catch(function (err) {
          go.disabled = false; go.textContent = 'Reverse signature';
          var p = back.querySelector('#rqd-rev-err'); p.style.display = 'block'; p.textContent = 'Could not reverse it: ' + ((err && err.message) || 'unknown error');
        });
      });
    }

    // ── Generate Invoice (admin + rep for own quotes) ──

    /* CUSTOM_ABBY_BY_CLAUDE (Ryan 2026-08-14) — mirrors isSplitPaymentTerms in the
       worker (shopify/helpers.js). Kept character-identical: if the two ever
       disagree, a deal prompts for a date the worker won't treat as split, or
       vice versa. q.terms is already on the dashboard row (the progress bar
       reads it for the up-front-payment rule), so nothing new crosses the wire. */
    function isSplitPaymentTerms(terms) {
      if (!terms) return false;
      var t = String(terms).toLowerCase().replace(/\s/g, '');
      return t === '50/50' || t === '50/50net30';
    }

    /* CUSTOM_ABBY_BY_CLAUDE (Ryan 2026-08-14) — ONE due-date picker, two callers:
       the cog's Generate Invoice (50/50 deals only) and the AR/AP card's Generate
       button (every deal). Both send the same dueInDays / dueDate payload the
       worker validates, so the parse can't drift between the two surfaces.

       Returns null when the rep cancelled or typed something unparseable (caller
       aborts without generating), otherwise the payload fields to merge in.
       Blank now means KEEP the date already on the invoice — the worker only
       falls back to the terms-derived default on a deal that's never been dated. */
    /* ⚠️ ASYNC as of the Phase 2 dialog conversion (Ryan 2026-08-27). Both callers
       (handleInvoiceGenerate, handleGenerateInvoice) were verified async and now await it — an
       un-awaited call returns a Promise, which is neither `null` nor a payload, so the abort check
       would pass and Object.assign would merge nothing: an invoice generated on the wrong date. */
    async function promptInvoiceDueDate(ref, opts) {
      var o = opts || {};
      var current = o.currentDueDate || '';
      /* The unparseable case used to be an alert() that threw away what was typed and aborted the
         whole generate. It is a validator now: the error appears inside the dialog and the rep
         corrects the value in place. */
      var _readable = function (t) {
        return !t || /^\d+$/.test(t) || !isNaN(new Date(t).getTime());
      };
      var ans = await rqdPrompt([
        'Due in how many days? (e.g. 5, 7, 15, 30)',
        'Or type an absolute date (e.g. 5/20/2026).',
        current
          ? 'Leave blank to keep the current due date (' + current + ').'
          : 'Leave blank for the default based on terms.',
        '',
        'Cancel skips generation entirely.'
      ].join('\n'), current ? '' : '30', {
        title: o.title || ('Generate invoice for ' + ref),
        placeholder: current ? 'blank keeps ' + current : 'e.g. 30, or 5/20/2026',
        confirmLabel: 'Generate invoice',
        validate: function (v) {
          var t = String(v == null ? '' : v).trim();
          return _readable(t) ? '' : 'Could not read "' + t + '" as a number of days or a date. Try "5" or "5/20/2026".';
        },
      });
      if (ans === null) return null; // Cancel → abort
      var trimmed = (ans || '').trim();
      if (!trimmed) return {};
      if (/^\d+$/.test(trimmed)) return { dueInDays: parseInt(trimmed, 10) };
      var _d = new Date(trimmed);
      /* Unreachable through the validator above; kept so the parse can never fall through to
         building a date out of NaN if the validator is ever loosened. */
      if (isNaN(_d.getTime())) return null;
      // ISO yyyy-mm-dd (local TZ-safe — pad month/day)
      return {
        dueDate: _d.getFullYear()
          + '-' + String(_d.getMonth() + 1).padStart(2, '0')
          + '-' + String(_d.getDate()).padStart(2, '0')
      };
    }

    /* Current due date as the rep would read it, for the prompt's "keep it" line. */
    function currentDueDateLabel(q) {
      var raw = q && q.invoice && q.invoice.dueDate;
      if (!raw) return '';
      return formatDate(raw) || String(raw).slice(0, 10);
    }

    async function handleGenerateInvoice(btn) {
      var ref = btn.dataset.ref;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Dropped the
      // pre-generation confirm. The button text ("Generate Invoice" vs
      // "Regenerate Invoice") already signals intent; the extra click
      // just slowed every flow. Post-generation "Email it to the
      // customer now?" prompt below stays — that one's an actionable
      // affordance, not a confirmation.
      /* CUSTOM_ABBY_BY_CLAUDE (Ryan 2026-08-14) — ...with ONE exception: a 50/50
         deal. The balance on a split-payment deal is the money Abby actually
         chases, and its due date is a commercial decision the rep makes with the
         customer ("balance before we ship"), not something Net-30 arithmetic can
         guess. So split-payment deals get the picker here; every other deal keeps
         the zero-click path. Whatever the rep sets is frozen — Abby reprints that
         exact date on every follow-up invoice instead of re-deriving it. */
      var _q = allQuotes.find(function(x) { return x.reference === ref; });
      var _duePayload = {};
      if (_q && isSplitPaymentTerms(_q.terms)) {
        _duePayload = await promptInvoiceDueDate(ref, {
          title: 'Generate BALANCE invoice for ' + ref + ' (50/50 deal)',
          currentDueDate: currentDueDateLabel(_q)
        });
        if (_duePayload === null) return; // Cancel / unparseable → abort
      }
      var origText = btn.textContent;
      btn.textContent = 'Generating...';
      btn.disabled = true;
      try {
        var res = await API.post('/generate-invoice', Object.assign({ ref: ref }, _duePayload));
        btn.textContent = origText;
        btn.disabled = false;
        if (res && res.pdfUrl) {
          window.open(res.pdfUrl, '_blank');
        }
        if (await rqdConfirm('The PDF is ready. Email it to the customer now?', { title: 'Invoice generated for ' + ref, confirmLabel: 'Email the customer', cancelLabel: 'Not now' })) {
          try {
            var sendRes = await API.post('/send-invoice', { ref: ref });
            rqdAlert('Invoice sent to ' + (sendRes && sendRes.sentTo ? sendRes.sentTo : 'customer') + '.');
          } catch (sendErr) {
            rqdAlert('Invoice generated, but email failed: ' + (sendErr.message || 'Unknown error'));
          }
        }
        fetchQuotes();
      } catch (err) {
        btn.textContent = origText;
        btn.disabled = false;
        rqdAlert('Failed to generate invoice: ' + (err.message || 'Unknown error'));
      }
    }

    // ── Delete Quote (admin only) ──

    // Refs deleted recently — filtered out of /rep-quotes responses until
    // Shopify's tag-search index + KV propagation catch up (can take up to a
    // minute or two in worst cases). Stored in sessionStorage so the
    // tombstone survives page navigation (Edit Quote → workstation → back to
    // dashboard); without that, the rep can navigate away and back and see
    // the just-deleted row reappear before indexes settle.
    var TOMBSTONE_KEY = 'rqd_deleted_refs';
    var TOMBSTONE_TTL_MS = 120000; // 2 minutes
    function readTombstone() {
      try {
        var raw = sessionStorage.getItem(TOMBSTONE_KEY);
        if (!raw) return {};
        var parsed = JSON.parse(raw);
        return (parsed && typeof parsed === 'object') ? parsed : {};
      } catch (e) { return {}; }
    }
    function writeTombstone(map) {
      try { sessionStorage.setItem(TOMBSTONE_KEY, JSON.stringify(map)); } catch (e) {}
    }
    function pruneTombstone(map) {
      var now = Date.now();
      var changed = false;
      Object.keys(map).forEach(function(k) {
        if (now - map[k] > TOMBSTONE_TTL_MS) { delete map[k]; changed = true; }
      });
      if (changed) writeTombstone(map);
      return map;
    }
    function markRefDeleted(ref) {
      var map = pruneTombstone(readTombstone());
      map[ref] = Date.now();
      writeTombstone(map);
    }
    function isRecentlyDeleted(ref) {
      var map = pruneTombstone(readTombstone());
      return Object.prototype.hasOwnProperty.call(map, ref);
    }

    async function handleDeleteQuote(btn) {
      var ref = btn.dataset.ref;
      var draftId = btn.dataset.draftId || '';
      // CUSTOM_RFQPORTAL_BY_CLAUDE — three cases:
      //  1. Pure NEW LEAD (no draft order): just /delete-lead
      //  2. Lead-derived quote (lead and draft order share ref): both endpoints
      //  3. Plain quote (no lead): just /delete-quote
      // The lead-derived case happens after Edit Quote has been clicked on a
      // NEW LEAD — /create-quote-from-lead reuses the lead ref so a draft
      // order now exists at the same ref. Cleaning up only one would leave
      // an orphaned record that would re-appear on the dashboard.
      var isLead = btn.dataset.isLead === '1';
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var confirmMsg = isLead
        ? 'Permanently delete lead ' + ref + '?\n\nThis removes the lead record' + (draftId ? ', the draft order from Shopify, and any in-progress quote data' : '') + '. This cannot be undone.'
        : 'Permanently delete quote ' + ref + '?\n\nThis removes the draft order from Shopify and all associated data. This cannot be undone.';
      if (!(await rqdConfirm(confirmMsg, { title: isLead ? 'Delete lead ' + ref : 'Delete quote ' + ref, confirmLabel: isLead ? 'Delete the lead' : 'Delete the quote', cancelLabel: 'Keep it', danger: true }))) return;
      try {
        if (isLead && draftId) {
          // Lead-derived row: nuke draft order + workstation_meta AND the
          // lead record + counter slot. Run BOTH regardless of either failing
          // — if /delete-quote rejects (Shopify 5xx, draft already gone),
          // /delete-lead would otherwise never run, leaving the lead in
          // lead-index forever and the assignee's capacity slot inflated.
          var deleteErrors = [];
          try { await API.post('/delete-quote', { ref: ref, draftOrderId: draftId }); }
          catch (e1) { deleteErrors.push('quote: ' + (e1.message || e1)); }
          try { await API.post('/delete-lead', { ref: ref }); }
          catch (e2) { deleteErrors.push('lead: ' + (e2.message || e2)); }
          if (deleteErrors.length === 2) throw new Error(deleteErrors.join('; '));
          // Partial success → optimistic UI still removes the row; the rep
          // can retry if the row reappears later.
        } else if (isLead) {
          await API.post('/delete-lead', { ref: ref });
        } else {
          await API.post('/delete-quote', { ref: ref, draftOrderId: draftId });
        }
        // Optimistic UI + sessionStorage-backed tombstone: Shopify's tag
        // -search index and KV propagation can lag the delete by tens of
        // seconds (sometimes longer). The tombstone persists across page
        // navigation so the row stays gone even if the rep opens another
        // quote in the workstation and comes back.
        markRefDeleted(ref);
        if (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes)) {
          allQuotes = allQuotes.filter(function(q) { return q && q.reference !== ref; });
        }
        var deletedRow = document.querySelector('.rqd-table tbody tr[data-ref="' + ref.replace(/"/g, '\\"') + '"]');
        if (deletedRow) deletedRow.remove();
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed to delete: ' + (err.message || 'Unknown error'));
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-10) — Duplicate to New Deal.
       Forks the quote into a brand-new independent deal server-side, then repopulates
       the DD (no navigation) so the rep watches the new line appear and clicks Edit as
       usual. The original is untouched. */
    async function handleDuplicateQuote(btn) {
      var ref = btn.dataset.ref;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      if (!(await rqdConfirm('A full copy — items, pricing, shipping address, customer — is created as its own separate deal (new reference). Edit the ship-to and send it as usual. The original quote is left untouched.', { title: 'Duplicate ' + ref + ' into a brand-new deal?', confirmLabel: 'Duplicate' }))) return;
      if (btn.disabled) return;
      btn.disabled = true;
      try {
        var res = await API.post('/duplicate-quote', { ref: ref });
        var newRef = (res && res.ref) || '';
        _dupToast('✓ Duplicated as ' + (newRef || 'a new deal') + ' — appearing in the list…');
        // Repopulate the DD so the new independent line shows up. Keep the rep here.
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed to duplicate: ' + (err.message || 'Unknown error'));
      } finally {
        btn.disabled = false;
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — CREATE REPLACEMENT ORDER.
     *
     * Part of a delivery arrived damaged (or defective, or wrong). We owe the customer a
     * re-ship NOW, and we chase the carrier for a claim separately and invisibly. This
     * spawns a $0-to-customer RPL-* order that generates the supplier PO and carries the
     * claim. Admin-only, gated again on the worker.
     *
     * The reason is asked up front rather than edited later because it decides WHO we
     * chase for recovery — a carrier broke it, a vendor shipped it broken, or nobody owes
     * us anything.
     */
    var REPLACEMENT_REASON_OPTIONS = [
      { key: 'carrier-damage', label: 'Damaged in transit', desc: 'The carrier broke it. We re-ship now and file a freight claim against them in the background.' },
      { key: 'vendor-defect',  label: 'Vendor defect / DOA', desc: 'Arrived faulty from the supplier. We re-ship and chase the vendor for credit.' },
      { key: 'wrong-item',     label: 'Wrong item shipped',  desc: 'The supplier sent the wrong goods. We re-ship the right ones and chase the vendor.' },
      { key: 'warranty',       label: 'Warranty replacement', desc: 'In-warranty failure after delivery. We re-ship and claim against the vendor warranty.' },
      { key: 'goodwill',       label: 'Goodwill / our error', desc: 'Our mistake, or a gesture. We eat the cost — no claim is tracked.' }
    ];

    /* ⛔ In-flight state lives HERE, not on the button. The cog menu is re-rendered by
       fetchQuotes(), which resurrects an enabled button while the POST is still running —
       a second press would mint a second replacement order. Keyed by ref so two different
       deals can be worked at once. */
    var _replacementInFlight = {};

    function handleCreateReplacement(btn) {
      var ref = btn.dataset.ref;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      if (_replacementInFlight[ref]) return;

      /* Same shared modal shell the link chooser uses, so this matches the rest of the
         board exactly. Confirm stays hidden — picking a reason IS the confirmation. */
      modalTitle.textContent = 'Create replacement order';
      modalSub.textContent = 'What went wrong with ' + ref + '? This decides who we chase for the money.';
      var html = '<p style="font-size:12px;line-height:1.5;color:var(--rq-text-secondary);margin:0 0 4px;">'
        + 'A replacement is <strong>$0 to the customer</strong>. You pick the damaged items next, then generate the supplier PO. '
        + 'It never counts as a sale and never affects anyone’s commission.</p>';
      REPLACEMENT_REASON_OPTIONS.forEach(function(o, i) {
        html += '<button type="button" class="rqd-replacement-reason-opt" data-idx="' + i + '" ' +
          'style="display:block;width:100%;text-align:left;font-family:inherit;border:1px solid var(--rq-border-input);background:var(--rq-bg-section);border-radius:10px;padding:12px 14px;margin-top:10px;cursor:pointer;transition:background .12s,border-color .12s;">' +
          '<span style="display:block;font-size:14px;font-weight:600;color:var(--rq-text);">' + esc(o.label) + '</span>' +
          '<span style="display:block;font-size:12px;color:var(--rq-text-secondary);margin-top:4px;line-height:1.45;">' + esc(o.desc) + '</span>' +
          '</button>';
      });
      modalBody.innerHTML = html;
      pendingStatusChange = null;
      if (modalConfirm) modalConfirm.style.display = 'none';
      if (modalEl) modalEl.classList.remove('rqd-modal--wide');
      modalBackdrop.classList.add('rqd-modal-backdrop--open');
      modalBody.querySelectorAll('.rqd-replacement-reason-opt').forEach(function(opt) {
        opt.addEventListener('mouseenter', function() { opt.style.background = 'var(--rq-input-bg)'; opt.style.borderColor = 'var(--rq-blue)'; });
        opt.addEventListener('mouseleave', function() { opt.style.background = 'var(--rq-bg-section)'; opt.style.borderColor = 'var(--rq-border-input)'; });
        opt.addEventListener('click', function() {
          var o = REPLACEMENT_REASON_OPTIONS[parseInt(opt.dataset.idx, 10)];
          closeModal();
          if (o) _submitReplacement(ref, o.key, o.label);
        });
      });
    }

    async function _submitReplacement(ref, reason, reasonLabel) {
      if (_replacementInFlight[ref]) return;
      _replacementInFlight[ref] = true;
      _dupToast('Creating replacement for ' + ref + '…');
      try {
        var res = await API.post('/create-replacement-order', { ref: ref, reason: reason });
        var newRef = (res && res.ref) || '';
        /* Straight into the workstation: the admin's very next job is choosing which
           items were damaged, and the replacement is useless until they do. */
        if (res && res.redirectUrl) { window.location.href = res.redirectUrl; return; }
        _dupToast('✓ Replacement ' + newRef + ' created (' + reasonLabel + ')');
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed to create the replacement order: ' + (err.message || 'Unknown error'));
      } finally {
        _replacementInFlight[ref] = false;
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — persist the recovery claim.
       Sends the whole claim block; the worker MERGES it over what is already stored, so
       a field this card doesn't render can never be blanked by a save from here. */
    var _claimSaveInFlight = {};
    /* CUSTOM_PAYMENTCHECK_BY_CLAUDE (ONYX e27ee0c84a87, Ryan 2026-10-11) - the payment check card's buttons.
       Release / re-hold post /payment-hold (human admin only on the worker); Refund opens the existing
       Cancel & Refund dialog, whose cancel the orders/cancelled webhook stamps on the hold. */
    async function handlePaymentHoldClick(btn) {
      var action = btn.dataset.payholdAction;
      var ref = btn.dataset.ref;
      if (action === 'refund') { _openCancelOnlineOrderModal(btn); return; }
      /* CUSTOM_PAYMENTVERIFY_BY_CLAUDE (ONYX e27ee0c84a87 phase 2) - Ryan marks one check (card + ID photo, his call) pass / fail / not done.
         No confirm: a mark releases nothing, and the Release button reads the rule the marks feed. */
      if (action === 'check') {
        btn.disabled = true;
        try {
          await API.post('/payment-hold', { ref: ref, action: 'check', check: btn.dataset.check, result: btn.dataset.result });
          fetchQuotes({ quiet: true });
        } catch (err) {
          rqdAlert('Could not mark the check: ' + (err.message || 'Unknown error'));
        } finally { btn.disabled = false; }
        return;
      }
      var release = action === 'release';
      var ok = await rqdConfirm(release
          ? 'POs, PO emails and web-order purchases on ' + ref + ' can go out once it is released.'
          : 'No PO, PO email or web-order purchase on ' + ref + ' can go out until it is released again.',
        { title: release ? 'Release the payment hold?' : 'Put the payment hold back on?', confirmLabel: release ? 'Release' : 'Hold', danger: !release });
      if (!ok) return;
      btn.disabled = true;
      try {
        await API.post('/payment-hold', { ref: ref, action: action });
        fetchQuotes({ quiet: true });
      } catch (err) {
        rqdAlert('Could not ' + (release ? 'release' : 'hold') + ' the payment check: ' + (err.message || 'Unknown error'));
      } finally {
        btn.disabled = false;
      }
    }
    /* END CUSTOM_PAYMENTCHECK_BY_CLAUDE */

    async function handleClaimSave(btn) {
      var ref = btn.dataset.ref;
      if (_claimSaveInFlight[ref]) return;
      var card = btn.closest('.rqd-claim-card');
      if (!card) return;
      var claim = {};
      card.querySelectorAll('.rqd-claim-input[data-claim-field]').forEach(function(el) {
        var f = el.dataset.claimField;
        var v = el.value;
        claim[f] = (f === 'amountClaimed' || f === 'amountRecovered') ? (parseFloat(v) || 0) : v;
      });
      var flag = card.querySelector('.rqd-claim-saved');
      _claimSaveInFlight[ref] = true;
      btn.disabled = true;
      if (flag) flag.textContent = 'Saving…';
      try {
        await API.post('/quote-lifecycle', { ref: ref, claim: claim });
        if (flag) flag.textContent = '✓ Saved';
        /* Quiet refresh so the Outstanding row and the parent's strip re-derive.
           No full navigation — the admin is mid-thought on this claim. */
        fetchQuotes({ quiet: true });
      } catch (err) {
        if (flag) flag.textContent = '';
        rqdAlert('Could not save the claim: ' + (err.message || 'Unknown error'));
      } finally {
        _claimSaveInFlight[ref] = false;
        btn.disabled = false;
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* Lightweight, self-contained success toast (no CSS dependency) — the DD has no
       shared toast helper, and duplicate needs positive "it worked, here's the new ref"
       feedback without a blocking alert. */
    function _dupToast(msg) {
      try {
        var t = document.createElement('div');
        t.className = 'rqd-dup-toast';
        t.textContent = msg;
        t.setAttribute('style', 'position:fixed;left:50%;bottom:32px;transform:translateX(-50%);z-index:100000;background:#0b3a5b;color:#fff;padding:12px 18px;border-radius:10px;box-shadow:0 8px 30px rgba(0,0,0,.35);font-size:14px;font-weight:600;max-width:90vw;text-align:center;');
        document.body.appendChild(t);
        setTimeout(function () { t.style.transition = 'opacity .4s'; t.style.opacity = '0'; }, 3200);
        setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 3700);
      } catch (_) { /* toast is cosmetic */ }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Online order Cancel + Refund modals
       ──────────────────────────────────────────────────────────────────
       Self-contained modals (their own backdrop) so they don't collide
       with the dashboard's global pendingStatusChange modal flow.
       Confirm-name guard mirrors the worker's check — admin must type
       the order name (e.g. "#SHOP-1667") to proceed. */

    function _formatMoneyShort(v) {
      var n = parseFloat(v); if (!isFinite(n)) n = 0;
      return '$' + n.toFixed(2);
    }

    function _openOnlineActionModal(opts) {
      // opts: { title, subtitle, bodyHtml, confirmText, confirmClass, onConfirm, requireName }
      var backdrop = document.createElement('div');
      backdrop.className = 'rqd-online-modal-backdrop';
      // Dark-mode propagation: the modal is appended to <body>, outside the
      // .rep-quote-portal-wrap that carries the .rep-quote-dark class. Detect
      // and self-tag so the CSS overrides actually match.
      var _portalWrap = document.querySelector('.rep-quote-portal-wrap');
      if (_portalWrap && _portalWrap.classList.contains('rep-quote-dark')) {
        backdrop.classList.add('rqd-online-modal-backdrop--dark');
      }
      var modal = document.createElement('div');
      modal.className = 'rqd-online-modal';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — type-to-confirm gate is
         OPTIONAL. Destructive actions pass requireName (type the ref to arm the
         button); plain data-entry modals (e.g. Link as Same Deal) omit it, so
         the confirm button is enabled immediately and onConfirm does the
         validation. Without this the gate rendered "Type undefined to confirm"
         and the button could never enable. */
      var _needName = !!opts.requireName;
      modal.innerHTML =
        '<button type="button" class="rqd-online-modal__x" aria-label="Close">&times;</button>' +
        '<h3 class="rqd-online-modal__title">' + opts.title + '</h3>' +
        '<p class="rqd-online-modal__sub">' + opts.subtitle + '</p>' +
        '<div class="rqd-online-modal__body">' + opts.bodyHtml + '</div>' +
        (_needName
          ? '<label class="rqd-online-modal__confirm-name">' +
              '<span>Type <strong>' + opts.requireName + '</strong> to confirm:</span>' +
              '<input type="text" class="rqd-online-modal__name-input" autocomplete="off" spellcheck="false">' +
            '</label>'
          : '') +
        '<p class="rqd-online-modal__error" style="display:none;"></p>' +
        '<div class="rqd-online-modal__actions">' +
          '<button type="button" class="rqd-online-modal__cancel">Cancel</button>' +
          '<button type="button" class="rqd-online-modal__confirm ' + (opts.confirmClass || '') + '"' + (_needName ? ' disabled' : '') + '>' + opts.confirmText + '</button>' +
        '</div>';
      backdrop.appendChild(modal);
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      var nameInput = modal.querySelector('.rqd-online-modal__name-input');
      var confirmBtn = modal.querySelector('.rqd-online-modal__confirm');
      var errEl = modal.querySelector('.rqd-online-modal__error');

      function close() { backdrop.remove(); }
      modal.querySelector('.rqd-online-modal__x').addEventListener('click', close);
      modal.querySelector('.rqd-online-modal__cancel').addEventListener('click', close);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
      backdrop.addEventListener('click', function(e) { if (window.RepPortal.dismissedOnBackdrop(e, backdrop)) close(); });

      if (nameInput) {
        nameInput.addEventListener('input', function() {
          confirmBtn.disabled = nameInput.value.trim() !== opts.requireName;
          errEl.style.display = 'none';
        });
      }

      confirmBtn.addEventListener('click', async function() {
        if (_needName && nameInput.value.trim() !== opts.requireName) return;
        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Working...';
        try {
          await opts.onConfirm(modal);
          close();
        } catch (err) {
          confirmBtn.disabled = false;
          confirmBtn.textContent = opts.confirmText;
          errEl.textContent = err.message || String(err);
          errEl.style.display = 'block';
        }
      });

      setTimeout(function() {
        if (nameInput) { nameInput.focus(); return; }
        var firstField = modal.querySelector('.rqd-online-modal__body input, .rqd-online-modal__body textarea, .rqd-online-modal__body select');
        if (firstField) firstField.focus();
      }, 0);
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — handed back so a caller can fill in a
         figure that has to be READ before it can be shown. The refund dialogs need the order's real
         refundable amount from Shopify, and the modal must open immediately rather than block on it. */
      return modal;
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — what a refund on this order can actually
       pay out, straight from Shopify.

       ⛔ NEVER LABEL A REFUND FROM THE ORDER TOTAL. Ryan, on SHOP-1952: the dialog offered to refund
       $1,065.83 on an order the customer had paid $672.01 for -- the rest being an outstanding
       freight adjustment they had never paid. Shopify was never going to pay out the difference
       (orderCancel takes a flag, not an amount), but a number that large on an irreversible button
       is its own hazard, and the same price-not-receipts confusion had already cost the Adjust Order
       refund cap.

       Returns null on any failure, and every caller shows NO figure rather than a guessed one. */
    async function _fetchRefundable(orderGid) {
      if (!orderGid) return null;
      try {
        var res = await API.get('/order-refundable?orderGid=' + encodeURIComponent(orderGid));
        if (!res || res.success === false || typeof res.refundable !== 'number') return null;
        return res;
      } catch (e) { return null; }
    }

    /* Fill a refund figure into an already-open modal. `slot` is a [data-refund-slot] span the
       body rendered as a placeholder. When the amount is 0 the checkbox (if there is one) is
       unchecked and disabled -- there is nothing to hand back, and offering it invites a support
       call about a refund that never arrives. */
    function _paintRefundable(modal, info, opts) {
      if (!modal) return;
      var slot = modal.querySelector('[data-refund-slot]');
      var box = modal.querySelector('[data-field="refund"]');
      if (!info) {
        if (slot) slot.textContent = '';
        return;
      }
      var amt = info.refundable;
      if (slot) {
        slot.innerHTML = amt > 0
          ? ' (' + _formatMoneyShort(amt) + ')'
          : ' <em>(nothing to refund — no payment received)</em>';
      }
      if (box && amt <= 0) { box.checked = false; box.disabled = true; }
      /* An order priced above what it took in is carrying an unpaid balance. Say so: it is the
         difference between "we are refunding everything" and "we are refunding what they paid",
         and on a cancel that distinction is the customer's whole experience of it. */
      /* The confirm button on the standalone Refund dialog names the amount. Restate it from the
         real figure once we have it, so the button and the body can never disagree. */
      if (opts && opts.confirmPrefix) {
        var cbtn = modal.querySelector('.rqd-online-modal__confirm');
        if (cbtn) cbtn.textContent = amt > 0 ? (opts.confirmPrefix + _formatMoneyShort(amt)) : 'Nothing to refund';
        if (cbtn && amt <= 0) cbtn.disabled = true;
      }
      var note = modal.querySelector('[data-refund-note]');
      if (note && info.currentTotal > amt + 0.005 && amt > 0) {
        note.innerHTML = 'Order is priced ' + _formatMoneyShort(info.currentTotal)
          + ', but only ' + _formatMoneyShort(amt) + ' was ever received'
          + (info.outstanding > 0 ? ' (' + _formatMoneyShort(info.outstanding) + ' still outstanding)' : '')
          + '. Only what they paid can be refunded.';
        note.style.display = '';
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Roll-lengths CALCULATOR (Fulfillment "Roll lengths" step).
       Replaces the old free-text box. Per roll product it surfaces the roll spec (width + the
       min/max purchasable length pulled from the product's custom.* metafields via the worker)
       plus the ordered sq-ft, then takes multiple {qty, length} rows — orders are mixed
       ("1x 43', 7x 41', 5x 27'…"). A live entered-sq-ft + delta-vs-ordered readout tells the
       admin whether the cut layout covers the order. On save the rows serialize to the vendor
       string "(5x) 35' x 4' + (7x) 41' x 4'" and POST to /line-roll-layout-override per line —
       the SAME storage the PO builder / quote-status / quote-summary already read (kept
       parseable by the PO under-order flag). Data entry, so no type-to-confirm. */
    // Width label: feet when the inches divide evenly (4'), else inches (70").
    function rlFmtWidth(inches) {
      var n = parseFloat(inches) || 48;
      return (n % 12 === 0) ? ((n / 12) + "'") : (n + '"');
    }
    // Serialize rows -> "(5x) 35' x 4' + (7x) 41' x 4'". Empty when no valid row.
    function rlSerialize(rows, widthInches) {
      var w = rlFmtWidth(widthInches);
      var parts = rows
        .filter(function (r) { return (parseInt(r.qty, 10) > 0) && (parseFloat(r.length) > 0); })
        .map(function (r) { return '(' + parseInt(r.qty, 10) + 'x) ' + parseFloat(r.length) + "' x " + w; });
      return parts.join(' + ');
    }
    // Parse a stored/calculator string back into rows. Handles the new per-part format first,
    // then the legacy PDP-calculator format ("N rolls (4' wide): 2 x 50' + 43'") and loose
    // free-text ("2 @ 45ft + 1 @ 30ft") as a best-effort fallback.
    function rlParse(str) {
      var rows = [];
      if (!str) return rows;
      var s = String(str);
      var m;
      var reNew = /\(?\s*(\d+)\s*x\s*\)?\s*(\d+(?:\.\d+)?)\s*['′]\s*x\s*\d+(?:\.\d+)?\s*['′"]/gi;
      while ((m = reNew.exec(s))) rows.push({ qty: parseInt(m[1], 10), length: parseFloat(m[2]) });
      if (rows.length) return rows;
      var colon = s.indexOf('):');
      var body = colon !== -1 ? s.slice(colon + 2) : s;
      var reQ = /(\d+)\s*[x×@]\s*\)?\s*(\d+(?:\.\d+)?)\s*(?:['′]|ft|feet)?/gi;
      var consumed = [];
      while ((m = reQ.exec(body))) { rows.push({ qty: parseInt(m[1], 10), length: parseFloat(m[2]) }); consumed.push([m.index, reQ.lastIndex]); }
      var reL = /(\d+(?:\.\d+)?)\s*(?:['′]|(?:ft|feet)\b)/gi;
      while ((m = reL.exec(body))) {
        var i = m.index;
        var inside = consumed.some(function (c) { return i >= c[0] && i < c[1]; });
        if (!inside) rows.push({ qty: 1, length: parseFloat(m[1]) });
      }
      return rows;
    }

    async function handleLogRollLengths(btn) {
      var ref = (btn && btn.dataset) ? btn.dataset.ref : '';
      var q = allQuotes.find(function (x) { return x && x.reference === ref; });
      if (!q) { rqdAlert('Order not found.'); return; }
      var rolls = (Array.isArray(q.onlineLineItems) ? q.onlineLineItems : []).filter(function (it) { return it && it.isRoll; });
      if (!rolls.length) { rqdAlert('No roll items on this order.'); return; }

      var backdrop = document.createElement('div');
      backdrop.className = 'rqd-online-modal-backdrop';
      var _pw = document.querySelector('.rep-quote-portal-wrap');
      if (_pw && _pw.classList.contains('rep-quote-dark')) backdrop.classList.add('rqd-online-modal-backdrop--dark');
      var modal = document.createElement('div');
      modal.className = 'rqd-online-modal';
      modal.style.maxWidth = '580px';

      function rowHtml(r) {
        var q0 = r ? r.qty : '';
        var l0 = r ? r.length : '';
        return '<div class="rqd-rl-row" style="display:grid;grid-template-columns:1fr 1fr auto auto;gap:8px;align-items:center;margin-bottom:6px;">' +
          '<input type="number" class="rqd-online-modal__select rqd-rl-qty" min="1" step="1" placeholder="qty" value="' + esc(String(q0)) + '" autocomplete="off">' +
          '<input type="number" class="rqd-online-modal__select rqd-rl-len" min="0" step="0.5" placeholder="length (ft)" value="' + esc(String(l0)) + '" autocomplete="off">' +
          '<span class="rqd-rl-w" style="opacity:0.7;white-space:nowrap;">&times; <span class="rqd-rl-wval"></span></span>' +
          '<button type="button" class="rqd-rl-del" title="Remove line" style="border:none;background:none;cursor:pointer;font-size:18px;line-height:1;opacity:0.55;padding:0 4px;">&times;</button>' +
        '</div>';
      }

      var prodBlocks = rolls.map(function (it) {
        var widthIn = parseFloat(it.rollWidth) || 48;
        var minL = parseFloat(it.minRollLength) || 25;
        var maxL = parseFloat(it.maxRollLength) || 60;
        var ordered = parseInt(it.quantity, 10) || 0;
        var existing = rlParse((it.rollLayout && String(it.rollLayout).trim()) || '');
        var rowsInit = existing.length ? existing : [null];
        return '<div class="rqd-rl-prod" data-line-item-id="' + esc(it.lineItemId || '') + '" data-width="' + widthIn + '" data-min="' + minL + '" data-max="' + maxL + '" data-ordered="' + ordered + '" style="border:1px solid rgba(128,128,128,0.22);border-radius:10px;padding:12px;margin-bottom:12px;">' +
          '<div style="display:flex;justify-content:space-between;align-items:baseline;gap:10px;margin-bottom:4px;">' +
            '<strong style="font-size:14px;">' + esc(it.title || 'Roll') + '</strong>' +
            (it.sku ? '<span style="opacity:0.55;font-size:12px;">' + esc(it.sku) + '</span>' : '') +
          '</div>' +
          '<div style="font-size:12px;opacity:0.72;margin-bottom:10px;">' +
            rlFmtWidth(widthIn) + ' wide roll &middot; lengths ' + minL + "'&ndash;" + maxL + "' &middot; ordered <strong>" + ordered.toLocaleString('en-US') + '</strong> sq ft' +
          '</div>' +
          '<div class="rqd-rl-colhead" style="display:grid;grid-template-columns:1fr 1fr auto auto;gap:8px;font-size:11px;text-transform:uppercase;letter-spacing:0.04em;opacity:0.55;margin-bottom:4px;">' +
            '<span>Qty</span><span>Length (ft)</span><span>Width</span><span></span>' +
          '</div>' +
          '<div class="rqd-rl-rows">' + rowsInit.map(rowHtml).join('') + '</div>' +
          '<button type="button" class="rqd-rl-addline" style="border:1px dashed rgba(128,128,128,0.4);background:none;border-radius:8px;padding:5px 10px;font-size:12px;cursor:pointer;margin-top:2px;">+ Add line</button>' +
          '<div class="rqd-rl-readout" style="margin-top:10px;font-size:12.5px;display:flex;justify-content:space-between;gap:10px;">' +
            '<span>Entered: <strong class="rqd-rl-entered">0</strong> sq ft</span>' +
            '<span class="rqd-rl-delta"></span>' +
          '</div>' +
          '<div class="rqd-rl-warn" style="display:none;margin-top:6px;font-size:12px;color:#c0392b;"></div>' +
        '</div>';
      }).join('');

      modal.innerHTML =
        '<button type="button" class="rqd-online-modal__x" aria-label="Close">&times;</button>' +
        '<h3 class="rqd-online-modal__title">Roll lengths — ' + esc(ref) + '</h3>' +
        '<p class="rqd-online-modal__sub">Enter the cut roll(s) for each product — qty &times; length. Width is fixed per product. This prints on the vendor PO and clears the missing-roll-layout warning. Press Enter on a length to add another line.</p>' +
        '<div class="rqd-online-modal__body">' + prodBlocks + '</div>' +
        '<p class="rqd-online-modal__error" style="display:none;"></p>' +
        '<div class="rqd-online-modal__actions">' +
          '<button type="button" class="rqd-online-modal__cancel rqd-rl-clear" title="Empty all rows — then Save to clear the logged roll lengths.">Clear all</button>' +
          '<button type="button" class="rqd-online-modal__confirm rqd-rl-save">Save roll lengths</button>' +
        '</div>';
      backdrop.appendChild(modal);
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      function close() { backdrop.remove(); }
      modal.querySelector('.rqd-online-modal__x').addEventListener('click', close);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
      backdrop.addEventListener('click', function (e) { if (window.RepPortal.dismissedOnBackdrop(e, backdrop)) close(); });

      // Per-product recompute: entered sq ft = ceil(Σ(qty × length) × widthFt); delta vs ordered.
      function recalc(prodEl) {
        var widthIn = parseFloat(prodEl.dataset.width) || 48;
        var widthFt = widthIn / 12;
        var minL = parseFloat(prodEl.dataset.min) || 0;
        var maxL = parseFloat(prodEl.dataset.max) || 0;
        var ordered = parseInt(prodEl.dataset.ordered, 10) || 0;
        var linear = 0;
        var outOfRange = [];
        Array.prototype.slice.call(prodEl.querySelectorAll('.rqd-rl-row')).forEach(function (row) {
          var qv = parseInt(row.querySelector('.rqd-rl-qty').value, 10) || 0;
          var lenInput = row.querySelector('.rqd-rl-len');
          var lv = parseFloat(lenInput.value) || 0;
          row.querySelector('.rqd-rl-wval').textContent = rlFmtWidth(widthIn);
          if (qv > 0 && lv > 0) {
            linear += qv * lv;
            var bad = (minL && lv < minL) || (maxL && lv > maxL);
            lenInput.style.borderColor = bad ? '#e0a800' : '';
            if (bad) outOfRange.push(lv);
          } else {
            lenInput.style.borderColor = '';
          }
        });
        var entered = Math.ceil(linear * widthFt);
        prodEl.querySelector('.rqd-rl-entered').textContent = entered.toLocaleString('en-US');
        var deltaEl = prodEl.querySelector('.rqd-rl-delta');
        if (!linear) {
          deltaEl.textContent = '';
        } else if (entered >= ordered) {
          var over = entered - ordered;
          deltaEl.innerHTML = '<span style="color:#1e8e4e;">&#10003; covers order' + (over > 0 ? ' (+' + over.toLocaleString('en-US') + ' sq ft waste)' : '') + '</span>';
        } else {
          deltaEl.innerHTML = '<span style="color:#c0392b;">short ' + (ordered - entered).toLocaleString('en-US') + ' sq ft</span>';
        }
        var warnEl = prodEl.querySelector('.rqd-rl-warn');
        if (outOfRange.length) {
          warnEl.textContent = 'Heads up: ' + outOfRange.join("', ") + "' is outside the " + minL + "'–" + maxL + "' purchasable range for this roll.";
          warnEl.style.display = 'block';
        } else {
          warnEl.style.display = 'none';
        }
      }

      function addRow(prodEl, focus) {
        var rowsWrap = prodEl.querySelector('.rqd-rl-rows');
        var tmp = document.createElement('div');
        tmp.innerHTML = rowHtml(null);
        var row = tmp.firstChild;
        rowsWrap.appendChild(row);
        recalc(prodEl);
        if (focus) { var qf = row.querySelector('.rqd-rl-qty'); if (qf) qf.focus(); }
      }

      // Delegated events per product block.
      Array.prototype.slice.call(modal.querySelectorAll('.rqd-rl-prod')).forEach(function (prodEl) {
        prodEl.addEventListener('input', function (e) {
          if (e.target.classList.contains('rqd-rl-qty') || e.target.classList.contains('rqd-rl-len')) recalc(prodEl);
        });
        prodEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && e.target.classList.contains('rqd-rl-len')) { e.preventDefault(); addRow(prodEl, true); }
        });
        prodEl.addEventListener('click', function (e) {
          if (e.target.classList.contains('rqd-rl-addline')) { e.preventDefault(); addRow(prodEl, true); return; }
          if (e.target.classList.contains('rqd-rl-del')) {
            e.preventDefault();
            var rowsWrap = prodEl.querySelector('.rqd-rl-rows');
            var row = e.target.closest('.rqd-rl-row');
            if (rowsWrap.querySelectorAll('.rqd-rl-row').length > 1) { row.remove(); }
            else { row.querySelector('.rqd-rl-qty').value = ''; row.querySelector('.rqd-rl-len').value = ''; }
            recalc(prodEl);
          }
        });
        recalc(prodEl);
      });

      // Clear all — empty every row (one blank row per product) so Save wipes the logged lengths.
      modal.querySelector('.rqd-rl-clear').addEventListener('click', function () {
        Array.prototype.slice.call(modal.querySelectorAll('.rqd-rl-prod')).forEach(function (prodEl) {
          prodEl.querySelector('.rqd-rl-rows').innerHTML = rowHtml(null);
          recalc(prodEl);
        });
        var f0 = modal.querySelector('.rqd-rl-qty'); if (f0) f0.focus();
      });

      var saveBtn = modal.querySelector('.rqd-rl-save');
      var errEl = modal.querySelector('.rqd-online-modal__error');
      saveBtn.addEventListener('click', async function () {
        saveBtn.disabled = true;
        saveBtn.textContent = 'Saving...';
        try {
          var edits = Array.prototype.slice.call(modal.querySelectorAll('.rqd-rl-prod'))
            .filter(function (prodEl) { return prodEl.dataset.lineItemId; })
            .map(function (prodEl) {
              var widthIn = parseFloat(prodEl.dataset.width) || 48;
              var rows = Array.prototype.slice.call(prodEl.querySelectorAll('.rqd-rl-row')).map(function (row) {
                return { qty: row.querySelector('.rqd-rl-qty').value, length: row.querySelector('.rqd-rl-len').value };
              });
              return { lineItemId: prodEl.dataset.lineItemId, rollLayout: rlSerialize(rows, widthIn) };
            });
          // Save all rolls in PARALLEL, then optimistic local update + targeted detail re-render.
          await Promise.all(edits.map(function (e) {
            return API.post('/line-roll-layout-override', { ref: ref, lineItemId: e.lineItemId, rollLayout: e.rollLayout });
          }));
          var anySet = false;
          if (Array.isArray(q.onlineLineItems)) {
            edits.forEach(function (e) {
              var li = q.onlineLineItems.find(function (it) { return it && it.lineItemId === e.lineItemId; });
              if (li) li.rollLayout = e.rollLayout;
              if (e.rollLayout) anySet = true;
            });
          }
          q.rollLengthsLoggedAt = anySet ? new Date().toISOString() : null;
          close();
          var detailEl = document.getElementById('rqd-detail-' + ref);
          if (detailEl) { detailEl.innerHTML = buildDetailHtml(q); applyCollapseState(detailEl, q); }
          fetchQuotes({ quiet: true });
        } catch (err) {
          saveBtn.disabled = false;
          saveBtn.textContent = 'Save roll lengths';
          errEl.textContent = (err && err.message) ? err.message : 'Save failed';
          errEl.style.display = 'block';
        }
      });
      setTimeout(function () { var f = modal.querySelector('.rqd-rl-qty'); if (f) f.focus(); }, 0);
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-07-29) — "Cancel and/or Refund" chooser.
       The old button said "Cancel & Refund" but only ever ran the CANCEL cascade (cancel the
       Shopify order + full refund + mark the deal CANCELLED, which reverses the rep's
       commission). Handing back PART of a deal that stays sold is a different job, so the
       button now asks which one. The refund arm deliberately routes into the Adjust Order
       panel instead of growing a second money path here — that panel owns the refund ledger,
       the release step, Abby's email, and the revenue/GP/commission basis. Two doors, one
       engine. Chooser shell mirrors openLinkChooser (shared #rqd-modal). */
    async function handleCancelOnlineOrder(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var chooserRef = btn.dataset.ref;
      var chooserQ = (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes))
        ? allQuotes.find(function(q) { return q && q.reference === chooserRef; })
        : null;
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-05) — offline deals can refund too. An
         offline deal paid by Shopify invoice has a real order + SALE transaction, so Adjust
         Order's refund rail works on it identically; the only difference is which order it
         acts on (q.paidOrderGid, carried on the button as data-order-gid) and which cancel
         cascade the OTHER arm belongs to. Refund arm needs the module + a SOLD deal + a
         resolvable paid order. */
      var isOfflineDeal = btn.dataset.offline === '1';
      var canRefund = !!(window.RQD && window.RQD.adjustOrder && window.RQD.adjustOrder.open)
        && !!chooserQ && chooserQ.lifecycleStatus === 'sold'
        && (chooserQ.source === 'online' || (isOfflineDeal && !!btn.dataset.orderGid));
      if (!canRefund) {
        if (isOfflineDeal) { handleCancelOrder(btn); return; }   // offline cascade, not the online one
        _openCancelOnlineOrderModal(btn); return;
      }

      var OPTS = [
        { key: 'cancel', icon: '🚫', label: 'Cancel the whole order',
          desc: isOfflineDeal
            ? 'Cancels the Shopify order with a full refund, cancels the vendor PO(s), and marks the deal CANCELLED — which also reverses commission. Blocked once a vendor has shipped.'
            : 'Cancels it in Shopify with a full refund, and marks the deal CANCELLED — which also reverses the rep\'s commission. Use when the order should not have happened.' },
        { key: 'refund', icon: '💸', label: 'Refund part of it (deal stays sold)',
          desc: 'Opens the refund panel. Hand back a flat amount, a whole line, or a % — works even after delivery. The deal stays SOLD; revenue, GP and commission drop by the refund. Anyone already PAID on the old GP gets a deduction on their next statement.' },
      ];
      /* CUSTOM_REFUNDALLCLEAR_BY_CLAUDE (ONYX 716e52ec512e, Ryan 2026-10-08) — Ryan's OK for an AGENT refund.
         Only his login sees it (the worker refuses anyone else). His own refunds above never need it. */
      var _rkSess = (window.RepPortal && window.RepPortal.Auth && window.RepPortal.Auth.getSession()) || {};
      if (isAdmin && String(_rkSess.repCode || _rkSess.code || '').toUpperCase() === 'RW') {
        OPTS.push({ key: 'refund-ok', icon: '✅', label: 'OK an agent refund',
          desc: 'Lets the AI agents refund this customer, up to the amount you type. Until you do, they cannot refund. Your own refunds here never need it.' });
      }
      modalTitle.textContent = 'Cancel and/or Refund';
      modalSub.textContent = 'What do you want to do with ' + (btn.dataset.orderName || chooserRef) + '?';
      modalBody.innerHTML = OPTS.map(function(o, i) {
        return '<button type="button" class="rqd-link-chooser-opt" data-idx="' + i + '" ' +
          'style="display:block;width:100%;text-align:left;font-family:inherit;border:1px solid var(--rq-border-input);background:var(--rq-bg-section);border-radius:10px;padding:12px 14px;margin-top:10px;cursor:pointer;transition:background .12s,border-color .12s;">' +
          '<span style="display:block;font-size:14px;font-weight:600;color:var(--rq-text);">' + o.icon + ' ' + esc(o.label) + '</span>' +
          '<span style="display:block;font-size:12px;color:var(--rq-text-secondary);margin-top:4px;line-height:1.45;">' + esc(o.desc) + '</span>' +
          '</button>';
      }).join('');
      pendingStatusChange = null;                             // keep the shared Confirm inert
      if (modalConfirm) modalConfirm.style.display = 'none';
      if (modalEl) modalEl.classList.remove('rqd-modal--wide');
      modalBackdrop.classList.add('rqd-modal-backdrop--open');
      modalBody.querySelectorAll('.rqd-link-chooser-opt').forEach(function(opt) {
        opt.addEventListener('mouseenter', function() { opt.style.background = 'var(--rq-input-bg)'; opt.style.borderColor = 'var(--rq-blue)'; });
        opt.addEventListener('mouseleave', function() { opt.style.background = 'var(--rq-bg-section)'; opt.style.borderColor = 'var(--rq-border-input)'; });
        opt.addEventListener('click', function() {
          var chosen = OPTS[parseInt(opt.dataset.idx, 10)];
          closeModal();                                       // closes + restores Confirm
          if (!chosen) return;
          if (chosen.key === 'refund-ok') { _openRefundOkModal(chooserRef, btn.dataset.orderName || chooserRef); return; } // CUSTOM_REFUNDALLCLEAR_BY_CLAUDE
          if (chosen.key === 'cancel') {
            // Offline deals have their own cascade (/cancel-order: Shopify cancel + PO cancel +
            // lifecycle CANCELLED); the online modal hits /online-cancel-order and would 404.
            if (isOfflineDeal) handleCancelOrder(btn); else _openCancelOnlineOrderModal(btn);
          } else {
            /* CUSTOM_REFUNDDOOR_BY_CLAUDE (AIOPS `281f35395eda`, Ryan 2026-09-14) — ⛔ NAME THE DOOR.
               Clicking "Refund part of it" used to open a modal headed "Adjust Order", scrolled to
               the top, with the refund controls somewhere below the add-items search — which reads
               as the wrong modal, and is what Ryan filed. The ROUTE is deliberate and stays (see the
               2026-07-29 note above: two doors, one engine); what changes is that the panel now
               opens titled Refund and lands on the refund block.
               ⚠️ The title carries the ORDER name when the cog has it, matching the chooser's own
               subtitle — on a family deal "Refund — RW-1234" would name the deal while the panel is
               about one order. */
            var _refundDoor = {
              title: 'Refund — ' + (btn.dataset.orderName || chooserRef),
              focus: 'refund',
            };
            // Offline: hand the panel the PAID order (q.id is the draft order on those rows).
            window.RQD.adjustOrder.open(chooserRef, chooserQ, isOfflineDeal ? {
              orderGid: btn.dataset.orderGid,
              orderName: btn.dataset.orderName,
              dealRef: chooserRef,
            } : null, _refundDoor);
          }
        });
      });
    }

    /* CUSTOM_REFUNDALLCLEAR_BY_CLAUDE (ONYX 716e52ec512e, Ryan 2026-10-08) — the OK itself. Shows the OK on file
       (amount, what agents already refunded under it, how it was given), takes a new amount, or withdraws it.
       ⛔ Moves no money: it only lets an agent's refund through, up to the amount. */
    function _openRefundOkModal(ref, orderLabel) {
      var bodyHtml =
        '<p data-rk-status style="margin:0 0 10px;font-size:13px;line-height:1.45;color:var(--rq-text-secondary);">Checking for an OK on this deal…</p>' +
        '<label class="rqd-online-modal__field">' +
          '<span>Agents may refund the customer up to ($)</span>' +
          '<input type="number" min="0.01" step="0.01" class="rqd-online-modal__select" data-field="amount" placeholder="e.g. 826.00">' +
        '</label>' +
        '<label class="rqd-online-modal__check" data-rk-withdraw-row style="display:none;">' +
          '<input type="checkbox" data-field="withdraw"> Withdraw my OK instead' +
        '</label>' +
        '<p style="margin:8px 0 0;font-size:12px;line-height:1.45;color:var(--rq-text-secondary);">This refunds nothing by itself. It lets an agent refund, and the agent still uses the normal refund steps.</p>';
      var modal = _openOnlineActionModal({
        title: 'OK an agent refund — ' + orderLabel,
        subtitle: 'Only do this once the money is back in our account.',
        bodyHtml: bodyHtml,
        confirmText: 'Save OK',
        onConfirm: async function (m) {
          var withdraw = !!(m.querySelector('[data-field="withdraw"]') || {}).checked;
          var amount = parseFloat((m.querySelector('[data-field="amount"]') || {}).value || '');
          if (!withdraw && !(amount > 0)) throw new Error('Type the dollar amount you OK.');
          var res = await API.post('/refund-allclear', withdraw ? { ref: ref, withdraw: true } : { ref: ref, amount: Math.round(amount * 100) / 100 });
          if (!res || res.success === false) throw new Error((res && res.error) || 'The OK was not saved.');
          if (typeof showToast === 'function') showToast(withdraw ? 'OK withdrawn for ' + ref : 'Agents may refund up to $' + amount.toFixed(2) + ' on ' + ref);
        },
      });
      API.get('/refund-allclear?ref=' + encodeURIComponent(ref)).then(function (res) {
        var st = modal && modal.querySelector('[data-rk-status]');
        if (!st) return;
        var ok = res && res.ok;
        if (!ok || ok.withdrawnAt || !(ok.amount > 0)) { st.textContent = 'No OK on file. Agents cannot refund this customer.'; return; }
        st.textContent = 'On file: up to $' + Number(ok.amount).toFixed(2) + ' (' + (ok.via === 'email' ? 'from your email' : 'from this button') + '). Agents have refunded $' + Number(ok.used || 0).toFixed(2) + ' under it; $' + Number(ok.remaining || 0).toFixed(2) + ' left.';
        var row = modal.querySelector('[data-rk-withdraw-row]'); if (row) row.style.display = '';
      }).catch(function () {
        var st = modal && modal.querySelector('[data-rk-status]');
        if (st) st.textContent = 'Could not read the OK on file.';
      });
    }

    async function _openCancelOnlineOrderModal(btn) {
      var ref = btn.dataset.ref;
      var orderGid = btn.dataset.orderGid;
      var orderName = btn.dataset.orderName;
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — the refund figure is READ from Shopify
         (see _fetchRefundable), never taken from btn.dataset.amount. That attribute carries
         `q.total`, the order's PRICE, which on an order with an unpaid balance is not what the
         customer paid: SHOP-1952 is priced $1,065.83 against $672.01 received, and this dialog
         offered to refund the larger number. The modal opens straight away and the amount lands a
         moment later; until it does, and if the read fails, NO figure is shown at all. */

      var bodyHtml =
        '<label class="rqd-online-modal__field">' +
          '<span>Reason</span>' +
          '<select class="rqd-online-modal__select" data-field="reason">' +
            '<option value="OTHER" selected>Other</option>' +
            '<option value="CUSTOMER">Customer changed mind</option>' +
            '<option value="DECLINED">Payment declined</option>' +
            '<option value="FRAUD">Fraudulent</option>' +
            '<option value="INVENTORY">Out of stock</option>' +
            '<option value="STAFF">Staff error</option>' +
          '</select>' +
        '</label>' +
        '<label class="rqd-online-modal__field">' +
          '<span>Internal note (optional)</span>' +
          '<textarea class="rqd-online-modal__textarea" data-field="note" rows="2" maxlength="2000" placeholder="e.g. Test order cleanup"></textarea>' +
        '</label>' +
        '<label class="rqd-online-modal__check">' +
          '<input type="checkbox" data-field="restock"> Restock items <em>(no-op for drop-ship)</em>' +
        '</label>' +
        '<label class="rqd-online-modal__check">' +
          '<input type="checkbox" data-field="refund" checked>' +
          ' Refund payment<span data-refund-slot> <em>(checking…)</em></span>' +
        '</label>' +
        '<p data-refund-note style="display:none;margin:6px 0 0;font-size:12px;line-height:1.45;color:var(--rq-text-secondary);"></p>' +
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — the family block. Empty and hidden
           on a lone order, so a normal cancel looks exactly as it did. */
        '<div data-family-slot style="display:none;"></div>' +
        '<label class="rqd-online-modal__check">' +
          '<input type="checkbox" data-field="notifyCustomer"> Send cancellation email to customer' +
        '</label>';

      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — filled by the family preview below.
         Until it lands the dialog behaves exactly as the single-order one always has; if the
         preview never arrives, `_family` stays null and the single-order route is used. A
         family that cannot be READ must never silently become a family cancel. */
      var _family = null;

      var _cancelModal = _openOnlineActionModal({
        title: 'Cancel & Refund ' + orderName,
        subtitle: 'This cancels the order in Shopify. The refund covers what the customer actually paid.',
        bodyHtml: bodyHtml,
        confirmText: 'Cancel & Refund',
        confirmClass: 'rqd-online-modal__confirm--danger',
        requireName: orderName,
        onConfirm: async function(modal) {
          var payload = {
            orderGid: orderGid,
            confirmName: orderName,
            reason: modal.querySelector('[data-field="reason"]').value,
            note: modal.querySelector('[data-field="note"]').value || '',
            restock: !!modal.querySelector('[data-field="restock"]').checked,
            refund: !modal.querySelector('[data-field="refund"]').disabled && !!modal.querySelector('[data-field="refund"]').checked,
            notifyCustomer: !!modal.querySelector('[data-field="notifyCustomer"]').checked,
          };
          if (_family && _family.length > 1) {
            payload.childRefs = _family.filter(function(o) { return !o.isParent; })
              .map(function(o) { return o.dealRef || o.orderName; }).filter(Boolean);
            var fres = await API.post('/online-cancel-order/family-commit', payload);
            /* ⛔ The family commit answers 200 even on a PARTIAL failure, because a
               half-cancelled family is the one case the admin most needs itemised rather than
               reduced to one red line. Surface it and STOP — no tombstone, the row has to stay
               reachable so the rest can be finished. */
            if (fres && fres.ok === false) {
              var done = (fres.results || []).filter(function(r) { return r.ok; })
                .map(function(r) { return r.orderName; });
              throw new Error('Stopped at ' + (fres.failedAt || '?') + '. '
                + (done.length ? 'Already cancelled: ' + done.join(', ') + '. ' : 'Nothing was cancelled. ')
                + 'Re-open this dialog to finish the rest.');
            }
          } else {
            await API.post('/online-cancel-order', payload);
          }
          // Optimistic UI: tombstone + drop the row. Worker filter +
          // next /rep-quotes poll cover the propagation gap.
          markRefDeleted(ref);
          if (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes)) {
            allQuotes = allQuotes.filter(function(q) { return q && q.reference !== ref; });
          }
          var row = document.querySelector('.rqd-table tbody tr[data-ref="' + ref.replace(/"/g, '\\"') + '"]');
          if (row) row.remove();
          setTimeout(function() { fetchQuotes(); }, 800);
        },
      });

      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — one read, not two. The family preview
         returns each member's refundable figure from the SAME live Shopify read /order-refundable
         performs, so a lone order takes the identical path it always did and a family gets the
         whole picture — rather than the dialog confidently naming 46% of what the customer paid.
         Falls back to the single-order read if the family route is unavailable. */
      var _famQ = (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes))
        ? allQuotes.find(function(q) { return q && q.reference === ref; }) : null;
      var _hintRefs = (_famQ && Array.isArray(_famQ.balanceChildren) ? _famQ.balanceChildren : [])
        .map(function(c) { return c && (c.orderName || c.ref); }).filter(Boolean);

      API.post('/online-cancel-order/family-preview', { orderGid: orderGid, childRefs: _hintRefs })
        .then(function(fam) {
          if (!fam || !Array.isArray(fam.orders) || !fam.orders.length) throw new Error('no family');
          var live = fam.orders.filter(function(o) { return !o.cancelled; });
          if (fam.orders.length <= 1) {
            var one = fam.orders[0] || {};
            _paintRefundable(_cancelModal, (typeof one.refundable === 'number') ? {
              refundable: one.refundable, currentTotal: one.currentTotal,
              received: one.received, outstanding: (one.currentTotal || 0) - (one.received || 0),
            } : null);
            _paintCancelPos(_cancelModal, fam.pos);
            return;
          }
          _family = fam.orders;
          _paintCancelFamily(_cancelModal, fam, live, orderName);
          _paintCancelPos(_cancelModal, fam.pos);
        })
        .catch(function() {
          _fetchRefundable(orderGid).then(function(info) { _paintRefundable(_cancelModal, info); });
        });
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — the family breakdown.
       ⛔ It lists every order SEPARATELY rather than printing one total, because that is what
       actually happens: Shopify refunds against each order's own transactions, so the customer
       sees one refund PER ORDER on their statement. A single blended figure would read as one
       payment landing back and generate the support call it was meant to prevent. */
    function _paintCancelFamily(modal, fam, live, parentName) {
      if (!modal) return;
      var slot = modal.querySelector('[data-family-slot]');
      if (!slot) return;
      var total = live.reduce(function(s, o) { return s + (Number(o.refundable) || 0); }, 0);
      var rows = fam.orders.map(function(o) {
        var amt = o.cancelled
          ? '<em>already cancelled</em>'
          : (typeof o.refundable === 'number' ? _formatMoneyShort(o.refundable) : '<em>unreadable</em>');
        return '<div style="display:flex;justify-content:space-between;gap:10px;padding:3px 0;">'
          + '<span>' + esc(o.orderName) + (o.isParent ? '' : ' <span style="opacity:.6">· ' + esc(o.dealRef || 'linked') + '</span>') + '</span>'
          + '<span>' + amt + '</span></div>';
      }).join('');
      slot.innerHTML =
        '<div style="margin:10px 0 0;padding:10px 12px;border:1px solid var(--rq-border-input);border-radius:8px;background:var(--rq-bg-section);">'
        + '<div style="font-size:13px;font-weight:600;margin-bottom:6px;">This deal is ' + fam.orders.length + ' Shopify orders</div>'
        + '<div style="font-size:13px;">' + rows + '</div>'
        + '<div style="display:flex;justify-content:space-between;gap:10px;margin-top:6px;padding-top:6px;border-top:1px solid var(--rq-border-input);font-weight:600;font-size:13px;">'
          + '<span>Total refund</span><span>' + _formatMoneyShort(total) + '</span></div>'
        + '<p style="margin:8px 0 0;font-size:12px;line-height:1.45;color:var(--rq-text-secondary);">'
        + 'All ' + live.length + ' are cancelled and refunded, ' + esc(parentName) + ' last. '
        + 'Shopify refunds each order against its own payment, so the customer will see '
        + live.length + ' separate refunds. One cancellation email is sent, on ' + esc(parentName) + '.'
        + '</p></div>';
      slot.style.display = '';
      var box = modal.querySelector('[data-field="refund"]');
      var rslot = modal.querySelector('[data-refund-slot]');
      if (rslot) rslot.innerHTML = total > 0 ? ' (' + _formatMoneyShort(total) + ' across ' + live.length + ' orders)' : '';
      if (box && total <= 0) { box.checked = false; box.disabled = true; }
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-26) — the vendor POs this will mark cancelled.
       ⚠️ Only the SENT ones are named. Marking is mark-only by Ryan's ruling ("I can phone the
       vendor"), so the list is a call list — and a never-sent draft on it would send him to a
       supplier about paperwork they have never seen. SHOP-1933 alone carries two such drafts. */
    function _paintCancelPos(modal, pos) {
      if (!modal || !pos) return;
      var sent = Array.isArray(pos.sent) ? pos.sent : [];
      var unsent = Array.isArray(pos.unsent) ? pos.unsent : [];
      if (!sent.length && !unsent.length) return;
      var slot = modal.querySelector('[data-family-slot]');
      if (!slot) return;
      var html = '<div style="margin:10px 0 0;font-size:12px;line-height:1.5;color:var(--rq-text-secondary);">';
      if (sent.length) {
        html += '<strong style="color:#b91c1c;">Call the vendor.</strong> '
          + (sent.length === 1 ? 'This PO has been sent' : 'These POs have been sent')
          + ' and will be marked cancelled here only: <strong>' + sent.map(esc).join(', ') + '</strong>.';
      }
      if (unsent.length) {
        html += (sent.length ? ' ' : '') + unsent.length + ' unsent draft PO'
          + (unsent.length === 1 ? '' : 's') + ' will be marked cancelled too (nothing to tell the vendor).';
      }
      slot.insertAdjacentHTML('beforeend', html + '</div>');
      slot.style.display = '';
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-08) — Cancel Order for a rep-created sold
       deal. One click: cancel Shopify order + full refund, cancel the PO(s), reverse the
       rep's commission, and mark the deal CANCELLED. Type-to-confirm on the order name.
       The row stays (re-renders as CANCELLED) rather than being tombstoned. */
    async function handleCancelOrder(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var ref = btn.dataset.ref;
      var orderName = btn.dataset.orderName || '';
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — read the refundable amount rather than
         printing q.total. Same defect as the online dialog: this said "refund $X in full" using the
         order's PRICE, which overstates it on any deal carrying an unpaid balance. The GID is only
         present when this dialog was reached through the Cancel-and/or-Refund chooser; from the
         plain Cancel Order button there is none, and then no figure is shown at all. */
      var _refundGid = btn.dataset.orderGid || '';
      var bodyHtml =
        '<label class="rqd-online-modal__field">' +
          '<span>Reason</span>' +
          '<select class="rqd-online-modal__select" data-field="reason">' +
            '<option value="CUSTOMER" selected>Customer changed mind</option>' +
            '<option value="STAFF">Staff error</option>' +
            '<option value="INVENTORY">Out of stock</option>' +
            '<option value="OTHER">Other</option>' +
          '</select>' +
        '</label>' +
        '<div class="rqd-online-modal__field" style="font-size:13px;line-height:1.5;">' +
          'In one step this will:' +
          '<ul style="margin:6px 0 0;padding-left:18px;">' +
            '<li>Cancel Shopify order <strong>' + orderName + '</strong> and <strong>refund what the customer paid</strong><span data-refund-slot></span></li>' +
            '<li>Cancel the vendor PO(s) on this deal <em>(you still contact the supplier)</em></li>' +
            '<li>Reverse the rep&#39;s commission and mark the deal <strong>CANCELLED</strong></li>' +
          '</ul>' +
          '<p data-refund-note style="display:none;margin:8px 0 0;font-size:12px;line-height:1.45;color:var(--rq-text-secondary);"></p>' +
          '<div style="margin-top:8px;color:#b91c1c;font-weight:600;">This can&#39;t be undone. Blocked if a vendor has already shipped.</div>' +
        '</div>';
      var _offCancelModal = _openOnlineActionModal({
        title: 'Cancel Order ' + orderName,
        subtitle: 'Cancels the Shopify order + full refund, cancels the PO, and marks the deal CANCELLED.',
        bodyHtml: bodyHtml,
        confirmText: 'Cancel Order + Refund',
        confirmClass: 'rqd-online-modal__confirm--danger',
        requireName: orderName,
        onConfirm: async function(modal) {
          await API.post('/cancel-order', {
            ref: ref,
            confirmName: orderName,
            reason: modal.querySelector('[data-field="reason"]').value,
          });
          // Keep the row — it re-renders as CANCELLED on the next poll.
          setTimeout(function() { fetchQuotes(); }, 900);
        },
      });
      _fetchRefundable(_refundGid).then(function(info) { _paintRefundable(_offCancelModal, info); });
    }

    async function handleRefundOnlineOrder(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var ref = btn.dataset.ref;
      var orderGid = btn.dataset.orderGid;
      var orderName = btn.dataset.orderName;
      var amount = parseFloat(btn.dataset.amount || '0');

      if (amount === 0) {
        rqdAlert('This is a $0 order — there is nothing to refund. Use Cancel Order to remove it.');
        return;
      }

      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-21) — fourth door with the same defect. This
         one printed the order's PRICE as "Refund amount", which on a partially-paid order promises
         more than the customer can get back. The worker was always safe -- it refunds per
         TRANSACTION against each original capture, so Shopify caps the payout at what was taken --
         but the figure a human reads before pressing an irreversible button should be the figure
         that actually leaves the account. Read, then shown; never shown if the read fails. */
      var bodyHtml =
        '<p class="rqd-online-modal__amount-line">Refund amount:<span data-refund-slot> <em>(checking…)</em></span> <span class="rqd-online-modal__muted">(full order — partial refunds in Shopify Admin)</span></p>' +
        '<p data-refund-note style="display:none;margin:0 0 8px;font-size:12px;line-height:1.45;color:var(--rq-text-secondary);"></p>' +
        '<label class="rqd-online-modal__field">' +
          '<span>Internal note (optional)</span>' +
          '<textarea class="rqd-online-modal__textarea" data-field="note" rows="2" maxlength="2000"></textarea>' +
        '</label>' +
        '<label class="rqd-online-modal__check">' +
          '<input type="checkbox" data-field="restock"> Restock items <em>(no-op for drop-ship)</em>' +
        '</label>' +
        '<label class="rqd-online-modal__check">' +
          '<input type="checkbox" data-field="notifyCustomer"> Send refund email to customer' +
        '</label>';

      var _refundModal = _openOnlineActionModal({
        title: 'Refund Order ' + orderName,
        subtitle: 'Refunds what the customer actually paid, to the original payment method. The order stays open and is not cancelled.',
        bodyHtml: bodyHtml,
        confirmText: 'Refund',
        confirmClass: 'rqd-online-modal__confirm--warn',
        requireName: orderName,
        onConfirm: async function(modal) {
          var payload = {
            orderGid: orderGid,
            confirmName: orderName,
            note: modal.querySelector('[data-field="note"]').value || '',
            restock: !!modal.querySelector('[data-field="restock"]').checked,
            notifyCustomer: !!modal.querySelector('[data-field="notifyCustomer"]').checked,
          };
          var res = await API.post('/online-refund-order', payload);
          // Refund leaves the row visible; financial-status will flip to
          // REFUNDED on the next refresh.
          setTimeout(function() { fetchQuotes(); }, 800);
          rqdAlert('Refunded ' + _formatMoneyShort(res.amount || amount) + ' to original payment method.');
        },
      });
      _fetchRefundable(orderGid).then(function(info) {
        _paintRefundable(_refundModal, info, { confirmPrefix: 'Refund ' });
      });
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-23) — Ship-To pencil router for
       online orders. The pencil sits in the Sold/Ship/Bill tab row and edits the
       OPEN tab. Only Ship To is editable on a placed Shopify order, so Sold To /
       Bill To get a short explanation instead of an editor. */
    function handleOnlineShipPencil(btn) {
      var card = btn.closest('.rqd-detail__card');
      var activeTab = card ? card.querySelector('.rqd-info-tab--active') : null;
      var tabName = activeTab ? (activeTab.getAttribute('data-tab') || '') : '';
      var m = /-(sold|ship|bill)$/.exec(tabName);
      var pane = m ? m[1] : 'ship';   // no-tabs fallback (shouldn't happen for online)
      if (pane === 'ship') {
        handleEditOnlineShippingAddress(btn);
      } else if (pane === 'bill') {
        rqdAlert('Billing address can\'t be edited on a Shopify order — the Admin API locks it after checkout.');
      } else {
        handleEditOnlineCustomerEmail(btn); // CUSTOM_ONLINEEMAIL_BY_CLAUDE - the email is the one Sold To field that can change
      }
    }

    /* CUSTOM_ONLINEEMAIL_BY_CLAUDE (ONYX c2f54737b332, Ryan 2026-10-12, SHOP-2156) — the customer EMAIL on a
       placed online order, and nothing else. The Sold To pencil used to say "comes from Shopify"; the email is
       the one Sold To field that can change after checkout. Save -> POST /deal-customer-email/online: the
       Shopify order's email AND its customer account change, then every portal copy (the row, an un-emailed
       pay-link, any email still waiting to send). "Pull from Shopify" -> /deal-customer-email/refresh, for an
       email somebody already fixed in Shopify. Name, address and billing are untouched. */
    function handleEditOnlineCustomerEmail(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var ref = btn.dataset.ref;
      var orderName = btn.dataset.orderName || ref;
      function _liveQ() {
        return (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes)) ? allQuotes.find(function (x) { return x && x.reference === ref; }) : null;
      }
      var q = _liveQ();
      var current = (q && q.customerEmail) || '';

      var backdrop = document.createElement('div');
      backdrop.className = 'rqd-online-modal-backdrop';
      var _pw = document.querySelector('.rep-quote-portal-wrap');
      if (_pw && _pw.classList.contains('rep-quote-dark')) backdrop.classList.add('rqd-online-modal-backdrop--dark');
      var modal = document.createElement('div');
      modal.className = 'rqd-online-modal';
      modal.innerHTML =
        '<button type="button" class="rqd-online-modal__x" aria-label="Close">&times;</button>' +
        '<h3 class="rqd-online-modal__title">Customer Email &mdash; ' + esc(orderName) + '</h3>' +
        '<p class="rqd-online-modal__sub">Changes the email on the Shopify order and the customer&rsquo;s Shopify account, and points every email still waiting to send at the new address. Name and addresses are not changed.</p>' +
        '<div class="rqd-online-modal__body"><div class="rqd-ship-grid">' +
          '<label class="rqd-online-modal__field rqd-online-modal__field--full"><span>Email on the portal now</span>' +
            '<input type="text" class="rqd-online-modal__select rqd-ship-input" value="' + esc(current || '(none)') + '" disabled></label>' +
          '<label class="rqd-online-modal__field rqd-online-modal__field--full"><span>Correct email</span>' +
            '<input type="email" class="rqd-online-modal__select rqd-ship-input" data-field="email" value="' + esc(current) + '" autocomplete="off" spellcheck="false"></label>' +
          '<label class="rqd-online-modal__field rqd-online-modal__field--full"><span>Why (kept on the deal)</span>' +
            '<input type="text" class="rqd-online-modal__select rqd-ship-input" data-field="reason" placeholder="e.g. typo in the domain, customer writes from outlook.com" autocomplete="off"></label>' +
        '</div></div>' +
        '<p class="rqd-online-modal__error" style="display:none;"></p>' +
        '<div class="rqd-online-modal__actions">' +
          '<button type="button" class="rqd-online-modal__cancel rqd-email-refresh" title="Use when the email was already fixed in Shopify">Pull from Shopify</button>' +
          '<button type="button" class="rqd-online-modal__cancel rqd-email-cancel">Cancel</button>' +
          '<button type="button" class="rqd-online-modal__confirm rqd-email-save">Save Email</button>' +
        '</div>';
      backdrop.appendChild(modal);
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      function close() { backdrop.remove(); }
      modal.querySelector('.rqd-online-modal__x').addEventListener('click', close);
      modal.querySelector('.rqd-email-cancel').addEventListener('click', close);
      backdrop.addEventListener('click', function (e) { if (window.RepPortal.dismissedOnBackdrop(e, backdrop)) close(); });
      var errEl = modal.querySelector('.rqd-online-modal__error');
      function showErr(msg) { errEl.textContent = msg; errEl.style.display = 'block'; }
      function errText(err, dflt) { var d = err && err.data; return (d && (d.detail || d.error)) || (err && err.message) || dflt; }
      function busy(on, label) {
        modal.querySelectorAll('button').forEach(function (b) { b.disabled = !!on; });
        if (label) modal.querySelector(on === 'save' ? '.rqd-email-save' : '.rqd-email-refresh').textContent = label;
      }
      function applyEmail(email) {
        var _q = _liveQ();
        if (_q && email) {
          var old = _q.customerEmail;
          _q.customerEmail = email;
          if (_q.billTo && _q.billTo.email === old) _q.billTo.email = email;
          if (_q.shipTo && _q.shipTo.email === old) _q.shipTo.email = email;
          var _detailEl = document.getElementById('rqd-detail-' + ref);
          if (_detailEl && typeof buildDetailHtml === 'function') _detailEl.innerHTML = buildDetailHtml(_q);
        }
      }
      function done(res, fallbackEmail) {
        if (res && res.error && !res.ok) throw new Error(res.detail || res.error);
        applyEmail((res && (res.to || res.email)) || fallbackEmail);
        close();
        rqdAlert((res && res.detail) || 'Saved.');
      }
      modal.querySelector('.rqd-email-save').addEventListener('click', function () {
        var email = modal.querySelector('[data-field="email"]').value.trim().toLowerCase();
        var reason = modal.querySelector('[data-field="reason"]').value.trim();
        errEl.style.display = 'none';
        if (!/^[^\s@,;<>]+@[^\s@,;<>]+\.[a-z]{2,}$/i.test(email)) { showErr('Enter one email address.'); return; }
        if (email === String(current).toLowerCase()) { showErr('That is already the email on the portal. If Shopify already has it, use Pull from Shopify.'); return; }
        if (!reason) { showErr('Say why, in a few words (kept on the deal).'); return; }
        busy('save', 'Saving...');
        API.post('/deal-customer-email/online', { ref: ref, email: email, reason: reason })
          .then(function (res) { done(res, email); })
          .catch(function (err) { busy(false); modal.querySelector('.rqd-email-save').textContent = 'Save Email'; showErr(errText(err, 'The save failed.')); });
      });
      modal.querySelector('.rqd-email-refresh').addEventListener('click', function () {
        errEl.style.display = 'none';
        busy('refresh', 'Pulling...');
        API.post('/deal-customer-email/refresh', { ref: ref })
          .then(function (res) { done(res, null); })
          .catch(function (err) { busy(false); modal.querySelector('.rqd-email-refresh').textContent = 'Pull from Shopify'; showErr(errText(err, 'The pull failed.')); });
      });
      setTimeout(function () { var f = modal.querySelector('[data-field="email"]'); if (f) f.focus(); }, 0);
    }
    /* END CUSTOM_ONLINEEMAIL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-23) — Edit Shipping Address on a
       placed online order. Customer emails right after checkout with the wrong
       ship-to; admin corrects it here and it syncs to Shopify via orderUpdate.
       Lightweight data-entry modal (no type-to-confirm) mirroring handleLogRollLengths;
       pre-filled from the row's q.shippingAddress. Destination only — no totals/tax/
       freight recalc. (Billing address can't be edited via the Shopify API.) */
    async function handleEditOnlineShippingAddress(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var ref = btn.dataset.ref;
      var orderGid = btn.dataset.orderGid;
      var orderName = btn.dataset.orderName;
      var q = allQuotes.find(function (x) { return x && x.reference === ref; });
      // Pre-fill from q.shipTo — the normalized ship-to the card's Ship To tab
      // renders (online rows carry q.shipTo, not q.shippingAddress). shipTo holds
      // a single combined `name`; split it into first/last for the Shopify fields.
      var st = (q && q.shipTo) ? q.shipTo : {};
      var _nm = String(st.name || '').trim();
      var _sp = _nm.indexOf(' ');
      var a = {
        firstName: _sp === -1 ? _nm : _nm.slice(0, _sp),
        lastName: _sp === -1 ? '' : _nm.slice(_sp + 1),
        company: st.company || '',
        address1: st.street || '',
        address2: st.street2 || '',
        city: st.city || '',
        provinceCode: st.state || '',
        zip: st.zip || '',
        phone: st.phone || '',
      };

      function field(label, key, val, ph, full, attrs) {
        return '<label class="rqd-online-modal__field' + (full ? ' rqd-online-modal__field--full' : '') + '">' +
          '<span>' + label + '</span>' +
          '<input type="text" class="rqd-online-modal__select rqd-ship-input" data-field="' + key + '" value="' + esc(val || '') + '"' +
          (ph ? ' placeholder="' + esc(ph) + '"' : '') + (attrs || '') + ' autocomplete="off" spellcheck="false"></label>';
      }

      var backdrop = document.createElement('div');
      backdrop.className = 'rqd-online-modal-backdrop';
      var _pw = document.querySelector('.rep-quote-portal-wrap');
      if (_pw && _pw.classList.contains('rep-quote-dark')) backdrop.classList.add('rqd-online-modal-backdrop--dark');
      var modal = document.createElement('div');
      modal.className = 'rqd-online-modal';
      modal.innerHTML =
        '<button type="button" class="rqd-online-modal__x" aria-label="Close">&times;</button>' +
        '<h3 class="rqd-online-modal__title">Edit Shipping Address &mdash; ' + esc(orderName) + '</h3>' +
        '<p class="rqd-online-modal__sub">Updates the ship-to on the Shopify order. Destination only &mdash; this does not change totals, tax, or freight. (Billing address can\'t be edited via the API.)</p>' +
        '<div class="rqd-online-modal__body"><div class="rqd-ship-grid">' +
          field('First name', 'firstName', a.firstName, '', false) +
          field('Last name', 'lastName', a.lastName, '', false) +
          field('Company', 'company', a.company, '', true) +
          field('Address 1', 'address1', a.address1, '123 Main St', true) +
          field('Address 2', 'address2', a.address2, 'Suite / Unit (optional)', true) +
          field('City', 'city', a.city, '', false) +
          field('State', 'provinceCode', a.provinceCode, 'CO', false, ' maxlength="2" style="text-transform:uppercase;"') +
          field('ZIP', 'zip', a.zip, '80202', false) +
          field('Phone', 'phone', a.phone, '', false) +
        '</div></div>' +
        '<p class="rqd-online-modal__error" style="display:none;"></p>' +
        '<div class="rqd-online-modal__actions">' +
          '<button type="button" class="rqd-online-modal__cancel">Cancel</button>' +
          '<button type="button" class="rqd-online-modal__confirm rqd-ship-save">Save Address</button>' +
        '</div>';
      backdrop.appendChild(modal);
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      function close() { backdrop.remove(); }
      modal.querySelector('.rqd-online-modal__x').addEventListener('click', close);
      modal.querySelector('.rqd-online-modal__cancel').addEventListener('click', close);
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
      backdrop.addEventListener('click', function (e) { if (window.RepPortal.dismissedOnBackdrop(e, backdrop)) close(); });

      var saveBtn = modal.querySelector('.rqd-ship-save');
      var errEl = modal.querySelector('.rqd-online-modal__error');
      function getF(key) {
        var el = modal.querySelector('.rqd-ship-input[data-field="' + key + '"]');
        return el ? el.value.trim() : '';
      }
      /* CUSTOM_ZIPFILL_BY_CLAUDE (AIOPS 3abdd8c2ff7b, SHOP-2030 37064 → 37046) — a NEW ZIP refreshes
         city and state the way the offline Sold To modal does (zippopotam.us on blur), with one
         difference: this form opens PRE-FILLED, so "fill only when empty" would never fire. City
         and state are replaced when they still read what the order had (or are blank); a value the
         admin typed by hand is kept and the lookup's answer is shown beside it instead. A ZIP the
         service cannot resolve leaves both fields alone and says so. Never blocks the save. */
      (function () {
        var zipEl = modal.querySelector('.rqd-ship-input[data-field="zip"]');
        var cityEl = modal.querySelector('.rqd-ship-input[data-field="city"]');
        var stateEl = modal.querySelector('.rqd-ship-input[data-field="provinceCode"]');
        if (!zipEl || !cityEl || !stateEl) return;
        var note = document.createElement('p');
        note.className = 'rqd-online-modal__sub';
        note.style.cssText = 'display:none;margin:-4px 0 8px;font-size:12px;';
        modal.querySelector('.rqd-online-modal__body').appendChild(note);
        var origCity = String(a.city || '').trim().toLowerCase();
        var origState = String(a.provinceCode || '').trim().toUpperCase();
        zipEl.addEventListener('blur', function () {
          var zip = this.value.trim();
          note.style.display = 'none';
          if (!/^\d{5}(-\d{4})?$/.test(zip) || zip.slice(0, 5) === String(a.zip || '').trim().slice(0, 5)) return;
          fetch('https://api.zippopotam.us/us/' + zip.slice(0, 5))
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              var p = data && data.places && data.places[0];
              if (!p) { note.textContent = 'ZIP ' + zip + ' did not resolve to a city and state. Check them before saving.'; note.style.display = 'block'; return; }
              var city = p['place name'] || '', state = (p['state abbreviation'] || '').toUpperCase();
              var cityNow = cityEl.value.trim(), stateNow = stateEl.value.trim().toUpperCase();
              var cityKept = cityNow && cityNow.toLowerCase() !== origCity && cityNow.toLowerCase() !== city.toLowerCase();
              var stateKept = stateNow && stateNow !== origState && stateNow !== state;
              if (!cityKept) cityEl.value = city;
              if (!stateKept) stateEl.value = state;
              if (cityKept || stateKept) { note.textContent = 'ZIP ' + zip + ' is ' + city + ', ' + state + ' — kept what you typed.'; note.style.display = 'block'; }
            })
            .catch(function () { note.textContent = 'Could not look up ZIP ' + zip + ' right now. Check city and state before saving.'; note.style.display = 'block'; });
        });
      })();
      saveBtn.addEventListener('click', async function () {
        var payload = {
          orderGid: orderGid,
          confirmName: orderName,
          firstName: getF('firstName'), lastName: getF('lastName'), company: getF('company'),
          address1: getF('address1'), address2: getF('address2'), city: getF('city'),
          provinceCode: getF('provinceCode').toUpperCase(), zip: getF('zip'), phone: getF('phone'),
        };
        if (!payload.address1 || !payload.city || !payload.zip) {
          errEl.textContent = 'Address 1, City, and ZIP are required.';
          errEl.style.display = 'block';
          return;
        }
        errEl.style.display = 'none';

        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-25) — PAINT FIRST, WRITE IN THE
           BACKGROUND. Ryan, on SHOP-1984: *"upon saving the new address it took 20 seconds for it
           to appear in the DD.. can this be sped up? Shouldn't it be instant even if it takes 20+
           seconds to write it back on the Shopify end?"*

           ⛔ THE PATCH WAS ALREADY "OPTIMISTIC" AND STILL BLOCKED FOR 20 SECONDS, because it ran
           AFTER the await. Optimistic RENDERING is not an optimistic INTERACTION: the modal sat on
           "Saving..." for the whole round trip, and the row only moved once Shopify answered. The
           worker is not the problem — it is auth, one order read for the name guard, one mutation,
           audit deferred to waitUntil. Those two sequential Shopify calls ARE the 20 seconds, and
           there is nothing there to trim without dropping the guard that stops us editing the
           wrong order.

           So: validate locally, patch, repaint, close. The write goes out unawaited.

           ⛔ AN OPTIMISTIC WRITE MUST BE REVERTIBLE, and this one changes where a paid order
           physically ships. The pre-patch address is snapshotted and restored on failure, so the
           DD shows the TRUTH rather than a change that never landed — and the rep is told loudly,
           naming the order, because they will have moved on by then. */
        /* ⚠️ Re-resolve the row instead of trusting the captured `q`. This callback can land 20
           seconds later, and a background SWR revalidate in that window REPLACES allQuotes — so
           the captured object can be orphaned, and patching it would paint nothing while the
           real row keeps the old address. */
        function _liveQ() {
          var found = (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes))
            ? allQuotes.find(function (x) { return x && x.reference === ref; })
            : null;
          return found || q;
        }
        function _repaintRow() {
          var _detailEl = document.getElementById('rqd-detail-' + ref);
          if (_detailEl && typeof buildDetailHtml === 'function') _detailEl.innerHTML = buildDetailHtml(_liveQ());
        }

        /* Snapshot the SAME object the patch lands on, or a revert could write the captured
           row's address onto a different one. */
        var _tq = _liveQ();
        var _prevShippingAddress = _tq ? _tq.shippingAddress : null;
        var _prevShipTo = _tq ? _tq.shipTo : null;
        if (_tq) {
          _tq.shippingAddress = Object.assign({}, _tq.shippingAddress, payload);
          _tq.shipTo = Object.assign({}, _tq.shipTo, {
            name: (payload.firstName + ' ' + payload.lastName).trim(),
            company: payload.company,
            street: payload.address1,
            street2: payload.address2,
            city: payload.city,
            state: payload.provinceCode,
            zip: payload.zip,
            phone: payload.phone,
          });
        }
        close();
        _repaintRow();

        API.post('/online-update-shipping-address', payload)
          .then(function (res) {
            if (res && res.error) throw new Error(res.error);
            /* Reconcile with what Shopify actually stored — it normalises addresses (casing,
               province, formatting), so the server's copy outranks the one typed here. Repaint
               only if it differs, to avoid a pointless second rebuild of the panel. */
            var _rq = _liveQ();
            if (_rq && res && res.shippingAddress) {
              var merged = Object.assign({}, _rq.shippingAddress, res.shippingAddress);
              if (JSON.stringify(merged) !== JSON.stringify(_rq.shippingAddress)) {
                _rq.shippingAddress = merged;
                _repaintRow();
              }
            }
          })
          .catch(function (err) {
            /* Put the row back to the truth before saying anything, so the address on screen
               matches Shopify by the time the rep reads the alert. */
            var _fq = _liveQ();
            if (_fq) { _fq.shippingAddress = _prevShippingAddress; _fq.shipTo = _prevShipTo; }
            _repaintRow();
            rqdAlert('The ship-to address on ' + orderName + ' was NOT changed.\n\n'
              + ((err && err.message) ? err.message : 'The save failed.')
              + '\n\nThe dashboard has been put back to the previous address. Try again.');
          });
      });
      setTimeout(function () { var f = modal.querySelector('.rqd-ship-input'); if (f) f.focus(); }, 0);
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Balance Order Link / Unlink
       ─────────────────────────────────────────────────────────────
       Admin opens this modal from the cog menu of an Online Order
       row to tie a secondary Shopify order (upsell, substitution,
       freight balance, customization fee, etc.) to that parent.
       Both orders get tagged in Shopify (linked-to: + balance-for:)
       and the parent's lifecycle.balances[] gets a new entry. The
       dashboard rolls up the child amount into the parent's total
       and the PO generator uses the fulfilled SKU when the swap is
       set. See src/lib/balance-orders.js for the full data model. */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-24) — Deal grouping ("Same Deal"
       link). Group a duplicate inquiry / separate quote chain under one deal so
       the dashboard shows one cascade, one Money Moves bell, and every count
       treats them as a single deal. POST /deal-group-link, then refresh. The
       worker enforces the same-owner rule and returns a clear error if violated
       (surfaced by the modal via the thrown _request error message). */
    async function handleLinkDeal(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var sourceRef = btn.dataset.ref;
      var srcQ = (typeof allQuotes !== 'undefined' && allQuotes) ? allQuotes.find(function(x) { return x && x.reference === sourceRef; }) : null;
      /* "Link Another Deal" off a deal that's ALREADY grouped vs the first link
         of two loose deals. When adding to an existing group, don't auto-pick a
         new top (the group already has one) — leave the primary field blank so
         the current top is preserved unless the rep explicitly sets one. */
      var _addingToGroup = !!(srcQ && srcQ.isDealGroup);
      var bodyHtml =
        '<label class="rqd-online-modal__field">' +
          '<span>' + (_addingToGroup ? 'Deal to add to this group' : 'Other deal reference (the duplicate to merge in)') + '</span>' +
          '<input type="text" class="rqd-online-modal__select" data-field="targetRef" autocomplete="off" spellcheck="false" placeholder="e.g. JW-1182-A or QUOTE-1077-B">' +
        '</label>' +
        '<label class="rqd-online-modal__field">' +
          '<span>' + (_addingToGroup ? 'Pin a different deal on top? (optional)' : 'Which deal shows on top? (defaults to the most recent)') + '</span>' +
          '<input type="text" class="rqd-online-modal__select" data-field="primaryRef" autocomplete="off" spellcheck="false" placeholder="' + (_addingToGroup ? 'leave blank to keep the current top' : 'auto-fills once you enter the other ref') + '">' +
        '</label>' +
        '<p style="margin:8px 0 0;font-size:11px;opacity:0.7;">' + (_addingToGroup
          ? 'The deal you name will join this group (same rep required). The current top deal stays on top unless you pin a different ref above.'
          : 'Both deals must belong to the same rep. They\'ll cascade as one deal with a single Money Moves bell. The top defaults to the most recent by date — change it above, or later from the cog menu.') + '</p>';
      _openOnlineActionModal({
        title: (_addingToGroup ? 'Link Another Deal to ' : 'Link as Same Deal: ') + sourceRef,
        subtitle: _addingToGroup ? 'Add another deal to this existing group.' : 'Group a duplicate inquiry or separate quote chain under one deal.',
        bodyHtml: bodyHtml,
        confirmText: _addingToGroup ? 'Add to Group' : 'Link Deals',
        onConfirm: async function(modal) {
          var targetRef = modal.querySelector('[data-field="targetRef"]').value.trim();
          if (!targetRef) throw new Error((_addingToGroup ? 'Deal to add' : 'Other deal reference') + ' required');
          var primary = modal.querySelector('[data-field="primaryRef"]').value.trim() || null;
          await API.post('/deal-group-link', { ref: sourceRef, targetRef: targetRef, primary: primary });
          setTimeout(function() { fetchQuotes(); }, 1500); // deal-groups KV is eventually consistent — give the write time to propagate before refetch
        },
      });
      /* Live "which on top" default: once a valid other ref is entered, pre-fill
         the primary field with the MOST RECENT of the two by date (q.createdAt,
         the date shown in the DD) — unless the rep typed their own choice, or
         we're adding to a group (then the existing top is preserved). */
      var modalEl = document.querySelector('.rqd-online-modal');
      if (modalEl && !_addingToGroup) {
        var tIn = modalEl.querySelector('[data-field="targetRef"]');
        var pIn = modalEl.querySelector('[data-field="primaryRef"]');
        var pEdited = false;
        if (pIn) pIn.addEventListener('input', function() { pEdited = true; });
        if (tIn && pIn) {
          tIn.addEventListener('input', function() {
            if (pEdited) return;
            var tRef = tIn.value.trim();
            var tQ = (typeof allQuotes !== 'undefined' && allQuotes) ? allQuotes.find(function(x) { return x && x.reference === tRef; }) : null;
            var sd = srcQ ? Date.parse(srcQ.createdAt || '') : NaN;
            var td = tQ ? Date.parse(tQ.createdAt || '') : NaN;
            if (tRef && isFinite(sd) && isFinite(td)) pIn.value = (td > sd ? tRef : sourceRef);
            else if (tRef && isFinite(sd)) pIn.value = sourceRef; // other deal not loaded → default to the one we can see
            else pIn.value = '';
          });
        }
      }
    }

    async function handleUngroupDeal(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var ref = btn.dataset.ref;
      if (!(await rqdConfirm('The other deals stay grouped.', { title: 'Remove ' + ref + ' from its deal group?', confirmLabel: 'Ungroup it', danger: true }))) return;
      try {
        await API.post('/deal-group-unlink', { ref: ref });
        setTimeout(function() { fetchQuotes(); }, 1500);
      } catch (e) { rqdAlert('Could not ungroup: ' + (e && e.message || e)); }
    }

    async function handleSetPrimaryDeal(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var ref = btn.dataset.ref;
      try {
        await API.post('/deal-group-primary', { ref: ref });
        setTimeout(function() { fetchQuotes(); }, 1500);
      } catch (e) { rqdAlert('Could not set primary: ' + (e && e.message || e)); }
    }

    async function handleLinkBalanceOrder(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var parentRef = btn.dataset.ref;
      var bodyHtml =
        '<label class="rqd-online-modal__field">' +
          '<span>Child Order Ref (Ex. SHOP-1000)</span>' +
          '<input type="text" class="rqd-online-modal__select" data-field="childRef" autocomplete="off" spellcheck="false">' +
        '</label>' +
        '<div data-swap-section style="border-top:1px solid rgba(0,0,0,0.1);margin-top:8px;padding-top:8px;">' +
          '<p style="margin:0 0 8px;font-size:11px;opacity:0.7;">Optional swap (upsell / substitution): tells the PO generator to send the supplier the new SKU instead of the original.</p>' +
          '<label class="rqd-online-modal__field">' +
            '<span>Search Shopify Catalog (or Type Manually Below)</span>' +
            '<div class="rqd-online-modal__search-wrap">' +
              '<input type="search" class="rqd-online-modal__select" data-field="productSearch" autocomplete="off" spellcheck="false" placeholder="🔍 Type a product name, SKU, or vendor...">' +
              '<div data-product-results class="rqd-online-modal__search-results"></div>' +
            '</div>' +
          '</label>' +
          '<div class="rqd-online-modal__grid-2">' +
            '<label class="rqd-online-modal__field">' +
              '<span>Original SKU on Parent (Optional)</span>' +
              '<input type="text" class="rqd-online-modal__select" data-field="originalSku" autocomplete="off">' +
            '</label>' +
            '<label class="rqd-online-modal__field">' +
              '<span>Fulfilled SKU (What Supplier Will Ship)</span>' +
              '<input type="text" class="rqd-online-modal__select" data-field="fulfilledSku" autocomplete="off">' +
            '</label>' +
          '</div>' +
          '<label class="rqd-online-modal__field">' +
            '<span>Fulfilled Product Title (for PO Display)</span>' +
            '<input type="text" class="rqd-online-modal__select" data-field="fulfilledTitle" autocomplete="off">' +
          '</label>' +
          '<label class="rqd-online-modal__field">' +
            '<span>Fulfilled Vendor (Vendor Guide)</span>' +
            '<div class="rqd-online-modal__search-wrap">' +
              '<input type="search" class="rqd-online-modal__select" data-field="fulfilledVendor" autocomplete="off" spellcheck="false" placeholder="🔍 Type to search Vendor Guide...">' +
              '<div data-vendor-results class="rqd-online-modal__search-results"></div>' +
            '</div>' +
          '</label>' +
        '</div>' +
        '<label class="rqd-online-modal__field">' +
          '<span>Internal Note (Optional)</span>' +
          '<textarea class="rqd-online-modal__textarea" data-field="swapNote" rows="2" maxlength="500"></textarea>' +
        '</label>';

      _openOnlineActionModal({
        title: 'Link Balance Order to ' + parentRef,
        subtitle: 'Roll up a secondary Shopify order under this parent. Both orders stay in Shopify; this is metadata only.',
        bodyHtml: bodyHtml,
        confirmText: 'Link Order',
        confirmClass: 'rqd-online-modal__confirm--warn',
        requireName: parentRef,
        onConfirm: async function(modal) {
          var childRefRaw = modal.querySelector('[data-field="childRef"]').value.trim();
          if (!childRefRaw) throw new Error('Child order ref required');
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — fulfilledCost captured from the
             product search click (stamped on modal.dataset.fulfilledCost).
             If admin didn't use the search picker, it's empty and the
             worker will resolve cost via Shopify SKU lookup at PO time. */
          var fulfilledCost = (modal.dataset.fulfilledCost && parseFloat(modal.dataset.fulfilledCost) > 0)
            ? parseFloat(modal.dataset.fulfilledCost)
            : null;
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          var payload = {
            parentRef: parentRef,
            childRef: childRefRaw,
            originalSku: modal.querySelector('[data-field="originalSku"]').value.trim() || null,
            fulfilledSku: modal.querySelector('[data-field="fulfilledSku"]').value.trim() || null,
            fulfilledTitle: modal.querySelector('[data-field="fulfilledTitle"]').value.trim() || null,
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Variant
               title captured separately via modal.dataset.fulfilledVariantTitle
               (see picker click handler). Persists on the balance entry
               so dashboard rendering can show "Product — Variant" while
               PO PDFs continue using product-only title. */
            fulfilledVariantTitle: (modal.dataset.fulfilledVariantTitle || '').trim() || null,
            fulfilledVendor: modal.querySelector('[data-field="fulfilledVendor"]').value.trim() || null,
            fulfilledCost: fulfilledCost,
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Online
               list price for the substituted variant, captured at modal
               save time. Persists on the balance entry so Order Contents
               renders the right unit price (was hardcoded to $0). */
            fulfilledPrice: (modal.dataset.fulfilledPrice && parseFloat(modal.dataset.fulfilledPrice) > 0)
              ? parseFloat(modal.dataset.fulfilledPrice)
              : null,
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Variant
               GID. Persists on the balance entry so the PO generator
               can read the substituted variant's bundle metafields and
               split bundles into 2 PO lines (Phase 2). */
            fulfilledVariantId: (modal.dataset.fulfilledVariantId || '').trim() || null,
            swapNote: modal.querySelector('[data-field="swapNote"]').value.trim() || null,
          };
          var res = await API.post('/balance-link', payload);
          setTimeout(function() { fetchQuotes(); }, 600);
          var msg = 'Linked ' + childRefRaw + ' to ' + parentRef + '.';
          if (res && res.tagErrors && res.tagErrors.length) {
            msg += ' (Shopify tag warnings: ' + res.tagErrors.join('; ') + ')';
          }
          rqdAlert(msg);
        },
      });
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Modal post-render setup:
         1. Auto-fill / dropdown for Original SKU based on the parent's
            line items (zero typing for single-line orders, dropdown when
            there are multiple).
         2. Wire the Shopify product search → autofill fulfilled fields.
         Manual entry remains valid for off-catalog substitutes. */
      setTimeout(function () {
        var modal = document.querySelector('.rqd-online-modal');
        if (!modal) return;
        var searchInput = modal.querySelector('[data-field="productSearch"]');
        var resultsBox = modal.querySelector('[data-product-results]');
        var skuInput = modal.querySelector('[data-field="fulfilledSku"]');
        var titleInput = modal.querySelector('[data-field="fulfilledTitle"]');
        var vendorInput = modal.querySelector('[data-field="fulfilledVendor"]');
        var originalSkuInput = modal.querySelector('[data-field="originalSku"]');
        var childRefInput = modal.querySelector('[data-field="childRef"]');

        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Child Order Ref auto-suggest. Calls
           /balance-link-suggest to find candidate child orders matching the
           parent's customer within ±4 weeks. If exactly one candidate, auto-
           fill the Child Order Ref input. If multiple, render a small chip
           list under the input so admin can click to populate. */
        if (childRefInput) {
          API.get('/balance-link-suggest?parentRef=' + encodeURIComponent(parentRef))
            .then(function (data) {
              var suggestions = (data && data.suggestions) || [];
              if (!suggestions.length) return;
              if (suggestions.length === 1) {
                var s = suggestions[0];
                childRefInput.value = s.ref;
                var hint = document.createElement('div');
                hint.className = 'rqd-online-modal__hint--info';
                var dayWord = s.daysFromParent === 1 || s.daysFromParent === -1 ? 'day' : 'days';
                var when = s.daysFromParent === 0 ? 'same day' :
                  (s.daysFromParent > 0 ? s.daysFromParent + ' ' + dayWord + ' after' : Math.abs(s.daysFromParent) + ' ' + dayWord + ' before') + ' parent';
                hint.textContent = 'Auto-suggested: matches ' + (data.parentCustomer || 'parent customer') + ' (' + when + ', ' + _formatMoneyShort(s.total) + ')';
                childRefInput.parentNode.appendChild(hint);
              } else {
                // Multiple candidates → chip list under the input.
                var picker = document.createElement('div');
                picker.style.cssText = 'margin-top:4px;display:flex;flex-wrap:wrap;gap:4px;';
                picker.innerHTML = '<span style="font-size:11px;opacity:0.7;width:100%;margin-bottom:2px;">' + suggestions.length + ' candidates from this customer in ±4 weeks — click to fill:</span>' +
                  suggestions.map(function (s) {
                    return '<button type="button" data-suggestion-ref="' + s.ref + '" style="font-size:11px;padding:3px 8px;border:1px solid rgba(0,107,204,0.35);background:rgba(0,107,204,0.06);color:inherit;border-radius:999px;cursor:pointer;">' +
                      s.ref + ' · ' + _formatMoneyShort(s.total) +
                      '</button>';
                  }).join('');
                childRefInput.parentNode.appendChild(picker);
                picker.addEventListener('click', function (e) {
                  var btn = e.target.closest('[data-suggestion-ref]');
                  if (!btn) return;
                  childRefInput.value = btn.dataset.suggestionRef;
                });
              }
            })
            .catch(function () { /* silent — admin can still type manually */ });
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

        // ── Original SKU auto-fill / dropdown ──
        // Look up parent quote's line items. Skip non-product lines (fees,
        // tax, shipping placeholders) using the same heuristics as the PO
        // builder.
        var parentQuote = (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes))
          ? allQuotes.find(function (q) { return q && q.reference === parentRef; })
          : null;
        var rawItems = (parentQuote && Array.isArray(parentQuote.onlineLineItems)) ? parentQuote.onlineLineItems : [];
        var skipPatterns = [/^card processing fee/i, /^tax\b/i, /^shipping & freight/i, /^installation\b/i, /^discount/i, /^by completing/i];
        var productItems = rawItems.filter(function (it) {
          return it && it.title && !skipPatterns.some(function (re) { return re.test(it.title); });
        });

        if (originalSkuInput && productItems.length === 1) {
          // Single product line — auto-fill SKU. Read-only feel via subtle
          // hint text, but admin can still edit if they want.
          originalSkuInput.value = productItems[0].sku || '';
          var hint = document.createElement('div');
          hint.style.cssText = 'font-size:11px;opacity:0.6;margin-top:3px;font-style:italic;';
          hint.textContent = 'Auto-filled from the parent order\'s line item: ' + productItems[0].title;
          originalSkuInput.parentNode.appendChild(hint);
        } else if (originalSkuInput && productItems.length > 1) {
          // Multiple product lines — replace the text input with a dropdown.
          var select = document.createElement('select');
          select.className = 'rqd-online-modal__select';
          select.setAttribute('data-field', 'originalSku');
          select.innerHTML = '<option value="">— Select line item —</option>' +
            productItems.map(function (it) {
              var label = it.title + (it.variantTitle ? ' — ' + it.variantTitle : '') + ' (SKU: ' + (it.sku || '—') + ')';
              return '<option value="' + (it.sku || '').replace(/"/g, '&quot;') + '">' + label.replace(/</g, '&lt;') + '</option>';
            }).join('');
          originalSkuInput.parentNode.replaceChild(select, originalSkuInput);
          var hintMulti = document.createElement('div');
          hintMulti.style.cssText = 'font-size:11px;opacity:0.6;margin-top:3px;font-style:italic;';
          hintMulti.textContent = 'Pick which line on the parent order is being replaced.';
          select.parentNode.appendChild(hintMulti);
        }

        if (!searchInput || !resultsBox) return;
        var searchTimer = null;
        function renderResults(products) {
          if (!products || !products.length) {
            resultsBox.innerHTML = '<div class="rqd-online-modal__search-empty">No matches. Type manually below.</div>';
            resultsBox.style.display = 'block';
            return;
          }
          // Flatten to variants with title + sku + price + vendor.
          var rows = [];
          products.slice(0, 12).forEach(function (p) {
            var variants = (p.variants && p.variants.edges) || p.variants || [];
            /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Dropped the
               .slice(0, 3) per-product variant cap. It was silently
               hiding variants past the third — surfaced on Dynamic Cold
               Plunge Cedar Barrel Oval (4 variants: 0.8 HP Residential,
               1.0 HP Residential, 0.8 HP Commercial, 1.0 HP Premier
               Light Commercial Chiller) where only the first 2 were
               showing in the substitute-product search. */
            variants.forEach(function (vEdge) {
              var v = vEdge.node || vEdge;
              if (!v) return;
              /* CUSTOM_RFQPORTAL_BY_CLAUDE — Capture variant unit cost.
                 Worker /product-search returns cost flat as `v.cost`
                 (worker line 119: `cost: v.inventoryItem?.unitCost?.amount`),
                 NOT under v.inventoryItem.unitCost.amount as this code
                 was previously assuming. That mismatch was silently
                 dropping cost capture — fulfilledCost reached the
                 balance entry as null even when the variant had a cost
                 in Shopify. Fall back to the GraphQL shape so a future
                 caller that hits this code with raw GQL nodes still
                 works. (Ryan 2026-05-18) */
              var variantCost = '';
              if (v.cost) {
                variantCost = String(v.cost);
              } else if (v.inventoryItem && v.inventoryItem.unitCost && v.inventoryItem.unitCost.amount) {
                variantCost = String(v.inventoryItem.unitCost.amount);
              }
              /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
              rows.push({
                productTitle: p.title || '',
                variantTitle: (v.title && v.title !== 'Default Title') ? v.title : '',
                sku: v.sku || '',
                vendor: p.vendor || '',
                unitCost: variantCost,
                /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Capture
                   variant's online list price so it surfaces in Order
                   Contents as the substituted line's unit price. */
                unitPrice: (v.price && parseFloat(v.price) > 0) ? String(v.price) : '',
                /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Variant
                   GID for Phase 2 bundle expansion on substituted
                   parents. The worker reads bundle_plunge_sku +
                   bundle_chiller_sku metafields on this exact variant
                   to split substituted bundles into 2 PO lines. */
                variantId: v.id || '',
              });
            });
          });
          resultsBox.innerHTML = rows.map(function (r, i) {
            var label = r.productTitle + (r.variantTitle ? ' — ' + r.variantTitle : '');
            return '<div data-product-row="' + i + '" class="rqd-online-modal__search-row">' +
              '<div class="rqd-online-modal__search-row-title">' + esc(label) + '</div>' +
              '<div class="rqd-online-modal__search-row-meta">SKU: ' + esc(r.sku || '—') + ' · Vendor: ' + esc(r.vendor || '—') + '</div>' +
              '</div>';
          }).join('');
          resultsBox.style.display = 'block';
          rows.forEach(function (r, i) {
            var rowEl = resultsBox.querySelector('[data-product-row="' + i + '"]');
            if (!rowEl) return;
            rowEl.addEventListener('click', function () {
              /* CUSTOM_RFQPORTAL_BY_CLAUDE — Use product title only (no
                 variant title suffix). The SKU already encodes the
                 variant, so duplicating it in the display title just
                 makes the PO line wider than the PDF column and
                 triggers ugly truncation like "Model Und...". */
              var labelText = r.productTitle;
              /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
              if (skuInput) skuInput.value = r.sku || '';
              if (titleInput) titleInput.value = labelText;
              if (vendorInput) vendorInput.value = r.vendor || '';
              /* CUSTOM_RFQPORTAL_BY_CLAUDE — Capture unit cost from the
                 search response so the PO generator can use the correct
                 cost for the fulfilled variant (not the original line's
                 cost). Stored on the modal via dataset for the onConfirm
                 handler to read. */
              modal.dataset.fulfilledCost = r.unitCost || '';
              /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Capture
                 the variant title separately so dashboard Order Contents
                 can render "Product — Variant" while the PO line keeps
                 the product-only title (avoids PDF column truncation
                 per the original rationale a few lines above). */
              modal.dataset.fulfilledVariantTitle = r.variantTitle || '';
              /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Capture
                 the variant's list price so substituted Order Contents
                 lines show the right unit price (was $0). */
              modal.dataset.fulfilledPrice = r.unitPrice || '';
              /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-18) — Capture
                 the variant's GID so the worker can later read this
                 variant's bundle metafields (custom.bundle_plunge_sku +
                 custom.bundle_chiller_sku) and split bundle products
                 into 2 PO lines (plunge + chiller). */
              modal.dataset.fulfilledVariantId = r.variantId || '';
              /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
              resultsBox.style.display = 'none';
              /* CUSTOM_RFQPORTAL_BY_CLAUDE — Keep the picked product's
                 label in the search input as visual confirmation of what
                 was selected. Admin can re-type to change. */
              searchInput.value = '✓ ' + labelText;
              searchInput.blur();
              /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
            });
          });
        }
        searchInput.addEventListener('input', function () {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE — Strip the "✓ " confirmation prefix
             when admin starts typing again to re-search. */
          if (this.value.indexOf('✓ ') === 0) this.value = '';
          /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          var q = this.value.trim();
          clearTimeout(searchTimer);
          if (q.length < 2) { resultsBox.style.display = 'none'; resultsBox.innerHTML = ''; return; }
          searchTimer = setTimeout(function () {
            API.get('/product-search?q=' + encodeURIComponent(q))
              .then(function (data) {
                var products = (data && data.products && data.products.edges)
                  ? data.products.edges.map(function (e) { return e.node; })
                  : (data && data.products) ? data.products
                  : [];
                renderResults(products);
              })
              .catch(function () {
                resultsBox.innerHTML = '<div class="rqd-online-modal__search-empty rqd-online-modal__search-empty--err">Search failed — type manually below.</div>';
                resultsBox.style.display = 'block';
              });
          }, 250);
        });

        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Vendor Guide picker. Fetch the full
           vendor list once, filter client-side as admin types. Picking a
           vendor exact-fills the field — eliminates name-mismatch issues
           with PO generation's vendor lookup (no fuzzy matching needed). */
        var vendorResultsBox = modal.querySelector('[data-vendor-results]');
        if (vendorInput && vendorResultsBox) {
          var vendorList = null;
          var vendorListLoading = false;
          function ensureVendorList() {
            if (vendorList || vendorListLoading) return Promise.resolve(vendorList);
            vendorListLoading = true;
            return API.get('/vendor-profiles').then(function (data) {
              var arr = (data && data.profiles) || (data && data.vendors) || [];
              vendorList = arr.map(function (v) { return { name: v.name || '', shortCode: v.shortCode || '' }; })
                .filter(function (v) { return v.name; })
                .sort(function (a, b) { return a.name.localeCompare(b.name); });
              vendorListLoading = false;
              return vendorList;
            }).catch(function () { vendorListLoading = false; return []; });
          }
          function renderVendorResults(matches) {
            if (!matches || !matches.length) {
              vendorResultsBox.innerHTML = '<div class="rqd-online-modal__search-empty">No matching vendors. Type the exact name (must match Vendor Guide).</div>';
              vendorResultsBox.style.display = 'block';
              return;
            }
            vendorResultsBox.innerHTML = matches.slice(0, 12).map(function (v, i) {
              return '<div data-vendor-row="' + i + '" class="rqd-online-modal__search-row">' +
                '<div class="rqd-online-modal__search-row-title">' + esc(v.name) + '</div>' +
                (v.shortCode ? '<div class="rqd-online-modal__search-row-meta">Code: ' + esc(v.shortCode) + '</div>' : '') +
                '</div>';
            }).join('');
            vendorResultsBox.style.display = 'block';
            matches.slice(0, 12).forEach(function (v, i) {
              var rowEl = vendorResultsBox.querySelector('[data-vendor-row="' + i + '"]');
              if (!rowEl) return;
              rowEl.addEventListener('click', function () {
                vendorInput.value = v.name;
                vendorResultsBox.style.display = 'none';
              });
            });
          }
          var vendorTimer = null;
          vendorInput.addEventListener('input', function () {
            var q = this.value.trim().toLowerCase();
            clearTimeout(vendorTimer);
            if (q.length < 1) { vendorResultsBox.style.display = 'none'; return; }
            vendorTimer = setTimeout(function () {
              ensureVendorList().then(function (list) {
                if (!list || !list.length) {
                  vendorResultsBox.innerHTML = '<div class="rqd-online-modal__search-empty">Vendor list unavailable.</div>';
                  vendorResultsBox.style.display = 'block';
                  return;
                }
                var matches = list.filter(function (v) {
                  return v.name.toLowerCase().includes(q) || (v.shortCode && v.shortCode.toLowerCase().includes(q));
                });
                renderVendorResults(matches);
              });
            }, 100);
          });
          // Pre-warm the vendor list so the first keystroke is instant.
          ensureVendorList();
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      }, 50);
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Pill click on a draft-sourced order
       (the CHILD waiting to be linked). Resolves the most likely parent
       locally from allQuotes (same customer + within ±4 weeks + not draft-
       sourced + has products), then opens the modal with parent pre-set
       and child-ref pre-filled. Falls back to the regular modal on the
       child if no parent can be auto-resolved. */
    async function handleLinkBalanceFromDraft(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var draftRef = btn.dataset.ref;
      var draftQuote = (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes))
        ? allQuotes.find(function (q) { return q && q.reference === draftRef; })
        : null;
      if (!draftQuote) {
        rqdAlert('Could not find this order in the dashboard data — refresh and try again.');
        return;
      }
      // Find candidate parents: same customer email, within ±4 weeks, NOT
      // a draft-source itself, and has at least one product line item.
      var draftEmail = (draftQuote.customerEmail || '').toLowerCase();
      var draftDate = new Date(draftQuote.createdAt || draftQuote.onlineProcessedAt || Date.now());
      var FOUR_WEEKS_MS = 28 * 24 * 60 * 60 * 1000;
      var candidates = [];
      if (draftEmail && !isNaN(draftDate.getTime()) && Array.isArray(allQuotes)) {
        candidates = allQuotes.filter(function (q) {
          if (!q || q.reference === draftRef) return false;
          if (q.source !== 'online') return false;
          if (q.onlineSourceName === 'shopify_draft_order') return false;
          if ((q.customerEmail || '').toLowerCase() !== draftEmail) return false;
          var qDate = new Date(q.createdAt || q.onlineProcessedAt || 0);
          if (isNaN(qDate.getTime())) return false;
          return Math.abs(qDate.getTime() - draftDate.getTime()) <= FOUR_WEEKS_MS;
        });
      }

      if (candidates.length === 0) {
        rqdAlert('No parent order found for this draft (need same customer email within ±4 weeks of the draft, customer-initiated, with products). You can still link manually — open the parent order\'s cog menu and click Link Balance Order.');
        return;
      }

      /* Pick the parent. If multiple, ask.
         CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — PHASE 2: this was "pick by number"
         typed into a prompt(), where an off-by-one attaches a balance to the wrong customer's
         order. It is a menu, so it renders as one — each candidate is its own button carrying
         its real reference, and the answer is matched by reference rather than by position. */
      var parent = candidates[0];
      if (candidates.length > 1) {
        var pickRef = await rqdChoice(
          'Several orders could be the parent of this draft. Pick the one this balance belongs to.',
          candidates.map(function (q) {
            return { label: q.reference + ' — ' + (q.customer || '') + ' — ' + money(q.total || 0), value: q.reference };
          }),
          { title: 'Pick the parent order', cancelLabel: 'Cancel' }
        );
        if (!pickRef) return;
        parent = candidates.find(function (q) { return q.reference === pickRef; });
        if (!parent) return;
      }

      // Open the regular link modal targeting the resolved parent. Pre-fill
      // the child ref input with this draft order's ref via setTimeout (the
      // modal builds its DOM async).
      handleLinkBalanceOrder({ dataset: { ref: parent.reference, orderGid: parent.id || '' } });
      setTimeout(function () {
        var modal = document.querySelector('.rqd-online-modal');
        var childInput = modal && modal.querySelector('[data-field="childRef"]');
        if (childInput) {
          childInput.value = draftRef;
          childInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }, 100);
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Edit balance entry. Opens the same Link
       modal pre-filled with the existing balance data so admin can tweak
       any field (typically the title or SKU) without going through unlink
       + relink ceremony. The /balance-link endpoint is upsert by childRef
       so re-submitting overwrites the entry cleanly. */
    async function handleEditBalanceOrder(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var parentRef = btn.dataset.ref;
      var childRef = btn.dataset.childRef;
      if (!parentRef || !childRef) return;
      var parentQuote = (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes))
        ? allQuotes.find(function (q) { return q && q.reference === parentRef; })
        : null;
      var existing = (parentQuote && Array.isArray(parentQuote.balances))
        ? parentQuote.balances.find(function (b) { return b && b.ref === childRef; })
        : null;
      if (!existing) {
        rqdAlert('Could not find this balance entry — refresh and try again.');
        return;
      }
      // Open the regular link modal targeting the parent.
      handleLinkBalanceOrder({ dataset: { ref: parentRef, orderGid: parentQuote ? (parentQuote.id || '') : '' } });
      // Wait for modal to render, then prefill all fields from the existing
      // balance. Run after the auto-suggest call so we overwrite its result.
      setTimeout(function () {
        var modal = document.querySelector('.rqd-online-modal');
        if (!modal) return;
        function set(field, value) {
          var el = modal.querySelector('[data-field="' + field + '"]');
          if (el && value != null) el.value = value;
        }
        set('childRef', existing.ref || childRef);
        set('originalSku', existing.originalSku || '');
        set('fulfilledSku', existing.fulfilledSku || '');
        set('fulfilledTitle', existing.fulfilledTitle || '');
        set('fulfilledVendor', existing.fulfilledVendor || '');
        set('swapNote', existing.swapNote || '');
        // Stamp fulfilledCost on the modal dataset so the onConfirm
        // handler picks it up (preserves the cost from the original link
        // unless admin re-uses the search picker to grab a new one).
        if (existing.fulfilledCost) modal.dataset.fulfilledCost = String(existing.fulfilledCost);
        // Update the modal title + confirm button to signal Edit mode.
        var titleEl = modal.querySelector('.rqd-online-modal__title');
        if (titleEl) titleEl.textContent = 'Edit Balance: ' + (existing.ref || childRef) + ' → ' + parentRef;
        var subEl = modal.querySelector('.rqd-online-modal__sub');
        if (subEl) subEl.textContent = 'Update the linked balance entry. Re-saving overwrites the existing data on the parent\'s lifecycle.';
        var confirmBtn = modal.querySelector('.rqd-online-modal__confirm');
        if (confirmBtn) confirmBtn.textContent = 'Save Changes';
      }, 250);
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    async function handleUnlinkBalanceOrder(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var parentRef = btn.dataset.ref;
      var childRef = btn.dataset.childRef;
      if (!parentRef || !childRef) return;
      if (!(await rqdConfirm('Unlink ' + childRef + ' from ' + parentRef + '?\n\nThe two Shopify orders stay as-is — only the dashboard rollup + Shopify tags + SKU swap will be removed.', { title: 'Unlink balance order', confirmLabel: 'Unlink', danger: true }))) return;
      try {
        await API.post('/balance-unlink', { parentRef: parentRef, childRef: childRef });
        setTimeout(function() { fetchQuotes(); }, 600);
      } catch (err) {
        rqdAlert('Unlink failed: ' + (err.message || 'Unknown error'));
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Substitution toggle handler. Click flips
       whether the child's line items + financials replace the parent's for
       Order Contents card, Financials card, and PO generation. Single-child
       enforcement on the parent: when ON for one child, worker auto-clears
       it for any siblings. */
    async function handleBalanceSubstitute(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var parentRef = btn.dataset.ref;
      var childRef = btn.dataset.childRef;
      var currentlyOn = btn.dataset.substitutes === '1';
      if (!parentRef || !childRef) return;
      // Lock the button BEFORE any await (including confirm). Without this,
      // a fast double-click could fire two POSTs before the first returns,
      // and the second would see the same data-substitutes value and race.
      if (btn.disabled) return;
      var origText = btn.textContent;
      btn.disabled = true;
      var targetState = !currentlyOn;
      // Confirm when turning ON — admin should know the parent's items
      // disappear from Order Contents + the PO. No confirm on toggle OFF
      // (reverting to default is low-risk).
      if (targetState) {
        if (!(await rqdConfirm(
          'Substitute ' + childRef + '\'s items for ' + parentRef + '\'s?\n\n' +
          'Order Contents, Financials, and PO generation on ' + parentRef + ' will pull from ' + childRef + ' instead. ' +
          'Parent\'s original line items won\'t be shipped.\n\n' +
          'You can toggle this off later if needed.',
          { title: 'Substitute items', confirmLabel: 'Substitute' }
        ))) {
          btn.disabled = false;
          return;
        }
      }
      btn.textContent = targetState ? 'Applying...' : 'Reverting...';
      try {
        await API.post('/balance-set-substitution', { parentRef: parentRef, childRef: childRef, substitutes: targetState });
        setTimeout(function() { fetchQuotes(); }, 600);
      } catch (err) {
        rqdAlert('Substitution toggle failed: ' + (err.message || 'Unknown error'));
        btn.textContent = origText;
        btn.disabled = false;
      }
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    // ── Rep Reassignment ──

    async function handleReassign(btn) {
      var ref = btn.dataset.ref;
      // Close the menu
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });

      // Fetch rep list
      var reps;
      try {
        var data = await API.get('/rep-list');
        reps = (data.reps || data || []).filter(function(r) { return (r.role || 'rep') !== 'cfa'; });
      } catch (e) { reps = []; }

      if (reps.length === 0) { rqdAlert('No reps found.'); return; }

      // Self-contained reassign modal — replaces the legacy prompt() numbered
      // text-list. Appended into .rep-quote-portal-wrap so the --rq-* CSS
      // vars resolve (same scope trick as the other custom overlays).
      var existing = document.getElementById('rqd-reassign-modal');
      if (existing) existing.remove();

      var q = allQuotes.find(function (x) { return x.reference === ref; });
      var currentOwner = '';
      if (q) {
        var repTag = (q.tags || []).find(function (t) { return typeof t === 'string' && t.toLowerCase().indexOf('rep:') === 0; });
        currentOwner = repTag ? repTag.split(':')[1] : '';
      }

      var optionsHtml = reps.map(function (r) {
        var label = (r.fullName || r.name) + ' (' + r.code + ')';
        var sel = r.code === currentOwner ? ' selected' : '';
        return '<option value="' + esc(r.code) + '"' + sel + '>' + esc(label) + '</option>';
      }).join('');

      var overlay = document.createElement('div');
      overlay.id = 'rqd-reassign-modal';
      overlay.className = 'rqd-daterange-backdrop';
      overlay.innerHTML = ''
        + '<div class="rqd-daterange-modal" role="dialog" aria-label="Reassign rep" style="max-width:440px;">'
        +   '<div class="rqd-daterange-modal__header">'
        +     '<div class="rqd-daterange-modal__title">Reassign ' + esc(ref) + '</div>'
        +     '<div class="rqd-daterange-modal__summary">Pick the rep this quote should be moved to.</div>'
        +   '</div>'
        +   '<div style="padding:18px 22px;">'
        +     '<label style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;color:var(--rq-text-secondary);margin-bottom:8px;display:block;">New owner</label>'
        +     '<select id="rqd-reassign-select" class="rqd-modal__input" style="width:100%;">' + optionsHtml + '</select>'
        +   '</div>'
        +   '<div class="rqd-daterange-modal__footer">'
        +     '<button type="button" class="rqd-pill" id="rqd-reassign-cancel">Cancel</button>'
        +     '<button type="button" class="rqd-pill rqd-pill--active" id="rqd-reassign-apply">Reassign</button>'
        +   '</div>'
        + '</div>';
      var portalWrap = document.querySelector('.rep-quote-portal-wrap') || document.body;
      portalWrap.appendChild(overlay);

      overlay.addEventListener('click', async function (e) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
        if (e.target.id === 'rqd-reassign-cancel' || window.RepPortal.dismissedOnBackdrop(e, overlay)) {
          overlay.remove();
          return;
        }
        if (e.target.id === 'rqd-reassign-apply') {
          var sel = overlay.querySelector('#rqd-reassign-select');
          var newRepCode = sel ? sel.value : '';
          if (!newRepCode) return;
          if (newRepCode === currentOwner) {
            overlay.remove();
            return;
          }
          var newRep = reps.find(function (r) { return r.code === newRepCode; });
          var applyBtn = e.target;
          applyBtn.textContent = 'Reassigning…';
          applyBtn.disabled = true;
          try {
            var resp = await API.post('/quote-reassign', { ref: ref, newRepCode: newRepCode });
            // Surface duplicate-draft warning if the worker hit the multi-draft path.
            var msg = ref + ' reassigned to ' + (newRep ? (newRep.fullName || newRep.name) : newRepCode);
            if (resp && resp.draftsFound > 1 && resp.warning) msg += '\n\n' + resp.warning;
            overlay.remove();
            /* Awaited: msg can carry the multi-draft warning, and fetchQuotes() rebuilds the
               list under it. */
            await rqdAlert(msg);
            fetchQuotes();
          } catch (err) {
            applyBtn.textContent = 'Reassign';
            applyBtn.disabled = false;
            var emsg = err && err.message ? err.message : 'Unknown error';
            rqdAlert('Failed: ' + emsg);
          }
        }
      });
      function onEsc(ev) {
        if (ev.key === 'Escape') {
          overlay.remove();
          document.removeEventListener('keydown', onEsc);
        }
      }
      document.addEventListener('keydown', onEsc);
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — "Link" hub. A deal's cog can carry up
       to FOUR different link actions (external order, balance order, same-deal grouping,
       original inquiry) — cluttered and easy to confuse. Rather than restructure the fragile
       row-builder markup, we collapse whatever link-* buttons a given deal actually rendered
       into ONE "🔗 Link…" entry on cog-open; clicking it opens a chooser with a one-line
       description per option, and picking one fires the ORIGINAL button's existing handler
       (via a real .click(), so no handler/route changes). Dynamic — shows exactly the 2–4
       that apply; a lone link stays a direct button (no hub). Group-management actions
       (Ungroup / Make Primary) are intentionally NOT link-* classes, so they stay separate. */
    var LINK_HUB_CLASSES = ['rqd-link-external-btn', 'rqd-link-open-deal-btn', 'rqd-link-balance-btn', 'rqd-link-deal-btn', 'rqd-link-inquiry-btn'];
    var LINK_HUB_DESCRIPTIONS = {
      'rqd-link-external-btn': 'Tie this quote to a separate Shopify order (e.g. an offline-negotiated discount) so the dashboard shows the real sale amount.',
      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08) */
      'rqd-link-open-deal-btn': 'This order matches a deal you still have open — link it so the sale lands on the deal you worked, with its notes, lead source and commission.',
      'rqd-link-balance-btn': 'Roll a secondary order — an upsell, substitution, or add-on — into this one so they count as a single sale.',
      'rqd-link-deal-btn': 'Group this with another quote chain for the SAME customer, so they cascade as one deal (one row, one bell, one count).',
      'rqd-link-inquiry-btn': 'Reattach the original inquiry — its web-form submission and ad/marketing attribution — to this quote.'
    };
    function _linkHubClassOf(btn) {
      for (var i = 0; i < LINK_HUB_CLASSES.length; i++) { if (btn.classList.contains(LINK_HUB_CLASSES[i])) return LINK_HUB_CLASSES[i]; }
      return null;
    }
    function collapseLinkButtons(menu) {
      if (!menu || menu.dataset.linkHub === '1') return;
      menu.dataset.linkHub = '1'; // run once per rendered menu
      var links = [];
      LINK_HUB_CLASSES.forEach(function(cls) {
        menu.querySelectorAll('.' + cls).forEach(function(b) { if (links.indexOf(b) === -1) links.push(b); });
      });
      if (links.length < 2) return; // 0 or 1 → leave the direct button as-is (auto-invoke)
      var hub = document.createElement('button');
      hub.type = 'button';
      hub.className = 'rqd-link-hub-btn';
      hub.textContent = '🔗 Link…';
      links[0].parentNode.insertBefore(hub, links[0]);
      links.forEach(function(b) { b.style.display = 'none'; }); // keep in DOM so their handlers/data survive
      hub.addEventListener('click', function(e) {
        e.stopPropagation();
        document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
        openLinkChooser(links);
      });
    }
    function openLinkChooser(linkBtns) {
      /* Reuse the shared status/pending modal shell (#rqd-modal) so the chooser matches
         the "status pill" popup EXACTLY — same dark backdrop, card, title, and theme
         tokens. Confirm is hidden (a chooser acts on click, not on confirm); closeModal
         restores it. Options are styled with the same --rq-* vars as the modal. */
      var refAttr = (linkBtns[0] && linkBtns[0].dataset && linkBtns[0].dataset.ref) || '';
      modalTitle.textContent = 'Link this deal';
      modalSub.textContent = refAttr ? ('Choose what to link ' + refAttr + ' to') : 'Choose what to link this deal to';
      var html = '';
      linkBtns.forEach(function(b, i) {
        var cls = _linkHubClassOf(b);
        var label = (b.textContent || 'Link').replace(/^\s*🔗\s*/, '').trim();
        var desc = LINK_HUB_DESCRIPTIONS[cls] || '';
        html += '<button type="button" class="rqd-link-chooser-opt" data-idx="' + i + '" ' +
          'style="display:block;width:100%;text-align:left;font-family:inherit;border:1px solid var(--rq-border-input);background:var(--rq-bg-section);border-radius:10px;padding:12px 14px;margin-top:10px;cursor:pointer;transition:background .12s,border-color .12s;">' +
          '<span style="display:block;font-size:14px;font-weight:600;color:var(--rq-text);">🔗 ' + esc(label) + '</span>' +
          '<span style="display:block;font-size:12px;color:var(--rq-text-secondary);margin-top:4px;line-height:1.45;">' + esc(desc) + '</span>' +
          '</button>';
      });
      modalBody.innerHTML = html;
      pendingStatusChange = null;                             // keep the shared Confirm inert
      if (modalConfirm) modalConfirm.style.display = 'none';  // chooser: no Confirm (Cancel closes)
      if (modalEl) modalEl.classList.remove('rqd-modal--wide');
      modalBackdrop.classList.add('rqd-modal-backdrop--open');
      modalBody.querySelectorAll('.rqd-link-chooser-opt').forEach(function(opt) {
        opt.addEventListener('mouseenter', function() { opt.style.background = 'var(--rq-input-bg)'; opt.style.borderColor = 'var(--rq-blue)'; });
        opt.addEventListener('mouseleave', function() { opt.style.background = 'var(--rq-bg-section)'; opt.style.borderColor = 'var(--rq-border-input)'; });
        opt.addEventListener('click', function() {
          var idx = parseInt(opt.dataset.idx, 10);
          var target = linkBtns[idx];
          closeModal();                                       // closes + restores Confirm
          if (target) target.click();                         // fire the original button's existing handler + route
        });
      });
    }

    // ── Link to External Order (admin only) ──
    // Customer negotiated offline → rep drafted a separate discounted order → we link that order
    // back to the original quote so the dashboard reflects the actual sale amount.

    async function handleLinkExternal(btn) {
      var ref = btn.dataset.ref;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var orderInput = await rqdPrompt(
        'Link ' + ref + ' to a Shopify order\n\n' +
        /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08) — the hint said "#1234", but this
           store's order names carry the SHOP- prefix the DD itself displays. Reps typed what
           they saw and got "Order not found". findOrderByInput now tries the #-prefixed AND
           bare forms, so say what actually works. */
        'Enter the Shopify order number (e.g. SHOP-1922 or #1922) or the order GID.\n\n' +
        'This will:\n' +
        '  • Mark ' + ref + ' as SOLD\n' +
        '  • Override financials to match the actual order totals\n' +
        '  • Pull COGS from each line item\'s variant cost\n' +
        '  • Preserve workstation COGS if no variant costs found',
        '',
        {
          title: 'Link ' + ref + ' to a Shopify order',
          placeholder: 'SHOP-1922, #1922, or an order GID',
          confirmLabel: 'Link order',
          /* The error belongs INSIDE the dialog: an alert() here would discard what was typed. */
          validate: function (v) { return String(v || '').trim() ? '' : 'Enter an order number or GID.'; },
        }
      );
      if (!orderInput) return;
      orderInput = orderInput.trim();
      if (!orderInput) return;
      try {
        var res = await API.post('/link-external-order', { ref: ref, orderInput: orderInput });
        var msg = ref + ' linked to ' + (res.externalOrder ? res.externalOrder.orderName : orderInput) +
          (res.externalOrder && res.externalOrder.orderTotal ? ' — total $' + res.externalOrder.orderTotal.toFixed(2) : '');
        var c = res.cogs || {};
        if (c.computed > 0) {
          msg += '\n\nCOGS pulled: $' + c.computed.toFixed(2) + ' across ' + c.itemsWithCost + ' line item(s).';
        }
        if (c.itemsMissingCost && c.itemsMissingCost.length > 0) {
          msg += '\n\nHeads up — the following line item(s) have no variant cost set in Shopify, so they were excluded from COGS:\n  • ' + c.itemsMissingCost.join('\n  • ');
          if (!(c.computed > 0)) msg += '\n\nNo COGS could be computed — previous value preserved.';
        }
        /* ⚠️ AWAITED, unlike most notices. This summary is the ONLY place the COGS result and
           the missing-variant-cost list are ever shown, and a bare fetchQuotes() snaps the panel
           shut and jumps to the top. alert() used to block that until the operator had read it;
           the await keeps that ordering. */
        await rqdAlert(msg);
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed to link: ' + (err.message || 'Unknown error'));
      }
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-08) — link from the ORDER side.
       Same endpoint as handleLinkExternal, opposite starting point: the rep is looking at the
       online order and the worker has already told us which open offline deal it matches
       (q.openDealMatchRef). No order number to type — the order GID goes straight through, so
       there's no way to link the wrong order. Confirms first because this flips a real deal to
       SOLD and pays commission on it; the match is a heuristic (email, or company name), not
       proof, so a human says yes. Unlink External Order reverses it if the guess was wrong. */
    async function handleLinkOpenDeal(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var dealRef = btn.dataset.ref;
      var orderGid = btn.dataset.orderGid || '';
      var orderName = btn.dataset.orderName || '';
      if (!dealRef || !orderGid) { rqdAlert('Missing the deal ref or order id — reload and try again.'); return; }
      var q = (typeof allQuotes !== 'undefined' && allQuotes) ? allQuotes.find(function(x) { return x && x.reference === dealRef; }) : null;
      var matchedOn = btn.dataset.matchedOn === 'company' ? 'company name' : 'email address';
      if (!(await rqdConfirm(
        'Link order ' + orderName + ' to open deal ' + dealRef + '?\n\n' +
        'They were matched on ' + matchedOn + (q && q.customer ? ' (' + q.customer + ')' : '') + '.\n\n' +
        'This will:\n' +
        '  • Mark ' + dealRef + ' as SOLD, dated from the order\n' +
        '  • Set its financials from this order\'s actual totals\n' +
        '  • Pull COGS from each line item\'s variant cost\n' +
        '  • Recompute the rep\'s commission\n\n' +
        'The order keeps its own row on the Online tab, flagged as linked. ' +
        'Use "Unlink External Order" on ' + dealRef + ' to reverse it.',
        { title: 'Link order to open deal', confirmLabel: 'Link and mark SOLD' }
      ))) return;
      try {
        var res = await API.post('/link-external-order', { ref: dealRef, orderInput: orderGid });
        var msg = dealRef + ' linked to ' + (res.externalOrder ? res.externalOrder.orderName : orderName) +
          (res.externalOrder && res.externalOrder.orderTotal ? ' — total $' + res.externalOrder.orderTotal.toFixed(2) : '');
        var c = res.cogs || {};
        if (c.computed > 0) {
          msg += '\n\nCOGS pulled: $' + c.computed.toFixed(2) + ' across ' + c.itemsWithCost + ' line item(s).';
        }
        if (c.itemsMissingCost && c.itemsMissingCost.length > 0) {
          msg += '\n\nHeads up — the following line item(s) have no variant cost set in Shopify, so they were excluded from COGS:\n  • ' + c.itemsMissingCost.join('\n  • ');
          if (!(c.computed > 0)) msg += '\n\nNo COGS could be computed — previous value preserved.';
        }
        await rqdAlert(msg);   /* awaited for the same reason as handleLinkExternal above */
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed to link: ' + (err.message || 'Unknown error'));
      }
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-03) — "Link to inquiry" (admin, standalone
       quotes). Reattach an original lead's form submission + marketing (ad) attribution to a
       quote that was built fresh instead of via "Build Quote from Lead". Auto-suggests the
       customer's OPEN leads via /lead-lookup, plus a manual ref fallback, then POSTs
       /link-quote-to-lead (which clones the lead onto this quote's ref + retires the
       original). The quote's items, Shopify drafts, and linked emails are untouched. */
    async function handleLinkInquiry(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var ref = btn.dataset.ref;
      var preRef = (btn.dataset.leadRef || '').trim(); // worker-stamped openInquiryRef → pre-select it
      var q = (typeof allQuotes !== 'undefined' && allQuotes) ? allQuotes.find(function(x) { return x && x.reference === ref; }) : null;
      var email = q ? (q.customerEmail || '') : '';
      var company = q ? (q.customerCompany || '') : '';

      var suggestions = [];
      try {
        var qs = [];
        if (email) qs.push('email=' + encodeURIComponent(email));
        if (company) qs.push('company=' + encodeURIComponent(company));
        if (qs.length) {
          var res = await API.get('/lead-lookup?' + qs.join('&'));
          suggestions = (res && Array.isArray(res.leads)) ? res.leads.filter(function(l) { return l && l.ref !== ref; }) : [];
        }
      } catch (e) { /* non-fatal — fall back to manual entry */ }

      var sugHtml;
      if (suggestions.length) {
        sugHtml = '<div class="rqd-online-modal__field"><span>Matching open leads for this customer</span>' +
          suggestions.map(function(l, i) {
            var bits = [l.ref, (l.company || l.customerName || '')];
            if (l.formName) bits.push(l.formName);
            bits.push(l.status);
            if (l.createdAt) bits.push(String(l.createdAt).slice(0, 10));
            var checked = (preRef && l.ref === preRef) || (!preRef && i === 0) ? ' checked' : '';
            return '<label style="display:flex;align-items:flex-start;gap:8px;margin:6px 0;cursor:pointer;font-size:13px;">' +
              '<input type="radio" name="rqd-link-inq-pick" value="' + esc(l.ref) + '"' + checked + ' style="margin-top:3px;">' +
              '<span>' + esc(bits.filter(Boolean).join(' · ')) + '</span></label>';
          }).join('') + '</div>';
      } else {
        sugHtml = '<p style="margin:0 0 8px;font-size:12px;opacity:0.75;">No open leads matched this customer automatically — enter the lead reference manually below.</p>';
      }

      var bodyHtml = sugHtml +
        '<label class="rqd-online-modal__field"><span>' + (suggestions.length ? 'Or enter a lead reference' : 'Lead reference') + '</span>' +
          '<input type="text" class="rqd-online-modal__select" data-field="manualRef" autocomplete="off" spellcheck="false" placeholder="e.g. RW-1216-A"></label>' +
        '<p style="margin:8px 0 0;font-size:11px;opacity:0.7;">Reattaches the inquiry\'s form submission + ad/marketing attribution to this quote and retires the original lead. The quote, its emails, and drafts are untouched.</p>';

      _openOnlineActionModal({
        title: 'Link to inquiry: ' + ref,
        subtitle: 'Reattach an existing lead (form + ad attribution) to this standalone quote.',
        bodyHtml: bodyHtml,
        confirmText: 'Link inquiry',
        onConfirm: async function(modal) {
          var picked = '';
          var radio = modal.querySelector('input[name="rqd-link-inq-pick"]:checked');
          if (radio) picked = (radio.value || '').trim();
          if (!picked) { var manual = modal.querySelector('[data-field="manualRef"]'); if (manual) picked = (manual.value || '').trim(); }
          if (!picked) throw new Error('Pick a lead or enter a lead reference');
          if (picked === ref) throw new Error('That is this quote\'s own reference — pick the original lead');
          await API.post('/link-quote-to-lead', { quoteRef: ref, leadRef: picked });
          fetchQuotes();
        },
      });
    }

    async function handleUnlinkExternal(btn) {
      var ref = btn.dataset.ref;
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      if (!(await rqdConfirm('Unlink external order from ' + ref + '?\n\nThis reverts the quote to QUOTED status and restores original financials.', { title: 'Unlink external order', confirmLabel: 'Unlink', danger: true }))) return;
      try {
        await API.post('/unlink-external-order', { ref: ref });
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed to unlink: ' + (err.message || 'Unknown error'));
      }
    }

    async function handleCancelLinkedOrder(btn) {
      document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
      var ref = btn.dataset.ref;
      var orderName = btn.dataset.orderName || ref;
      var amount = parseFloat(btn.dataset.amount || '0');
      var amountStr = amount > 0 ? ' ($' + amount.toFixed(2) + ' full refund)' : '';

      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — PHASE 2: the reason was a free-text
         prompt() that accepted anything and silently coerced the unrecognised to OTHER, so the
         audit trail could not distinguish "the rep meant OTHER" from "the rep typed CUSTOMR".
         It only ever had six answers, so it is a choice — and a choice renders as six real
         buttons a person or a bot can read. The six values are unchanged. */
      var reason = await rqdChoice(
        'Cancel order ' + orderName + amountStr + '?\n\nPick the cancellation reason. Cancelling this dialog aborts — nothing is refunded.',
        [
          { label: 'Customer', value: 'CUSTOMER', primary: true },
          { label: 'Declined', value: 'DECLINED' },
          { label: 'Fraud', value: 'FRAUD' },
          { label: 'Inventory', value: 'INVENTORY' },
          { label: 'Staff', value: 'STAFF' },
          { label: 'Other', value: 'OTHER' },
        ],
        { title: 'Cancel ' + orderName, cancelLabel: 'Do not cancel' }
      );
      if (!reason) return;
      reason = String(reason).trim().toUpperCase();
      var validReasons = ['CUSTOMER', 'DECLINED', 'FRAUD', 'INVENTORY', 'STAFF', 'OTHER'];
      if (!validReasons.includes(reason)) reason = 'OTHER';

      if (!(await rqdConfirm('Confirm: cancel ' + orderName + ' and issue a full refund to the customer?\n\nThis cannot be undone.', { title: 'Cancel order and refund', confirmLabel: 'Cancel order + refund', cancelLabel: 'Keep the order', danger: true }))) return;

      try {
        await API.post('/cancel-online-order', { ref: ref, reason: reason });
        fetchQuotes();
      } catch (err) {
        rqdAlert('Failed to cancel order: ' + (err.message || 'Unknown error'));
      }
    }

    // ── Pagination ──

    function renderPagination(p) {
      if (!p) return;
      // Sync local currentPage to whatever the server clamped to. Without this, switching
      // filters from page=5 of "all" to "lost" (3 items) leaves currentPage=5 locally
      // while the server returns page 1 — next click would re-send page=5.
      if (p.page && p.page !== currentPage) currentPage = p.page;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Keep this in sync with the worker's
         default pageSize in src/handlers/quote-dashboard.js (currently 200).
         Drives the "showing X-Y of N" math in the pagination footer; the
         actual page-size enforcement lives server-side. p.totalCount is
         the revision-chain (visible row) count, not the raw quote count
         — server groups by base ref before paginating (Ryan 2026-05-15).
         Defensive math: if a stale page lookup ever produces startItem
         past totalCount (shouldn't happen post-clamp, but guards against
         races where local currentPage drifts ahead of server), collapse
         to "0-0 of N" instead of "201-52 of 52" gibberish. */
      var pageSize = 200;
      var totalCount = p.totalCount || 0;
      var startItem = (p.page - 1) * pageSize + 1;
      var endItem = Math.min(p.page * pageSize, totalCount);
      if (totalCount === 0) { startItem = 0; endItem = 0; }
      else if (startItem > totalCount) { startItem = 0; endItem = 0; }
      pageInfo.textContent = 'Page ' + p.page + ' of ' + p.totalPages + ' (' + startItem + '-' + endItem + ' of ' + totalCount + ')';
      prevBtn.disabled = p.page <= 1;
      nextBtn.disabled = p.page >= p.totalPages;
      document.getElementById('rqd-pagination').style.display = '';
    }

    // ── Helpers ──

    function money(amt) {
      var n = parseFloat(amt) || 0;
      return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function moneyRound(amt) {
      var n = Math.round(parseFloat(amt) || 0);
      return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — ⛔ esc() DID NOT ESCAPE QUOTES, AND IT IS
       USED INSIDE ATTRIBUTES 704 TIMES.

       textContent -> innerHTML escapes &, < and > and nothing else. Every `attr="' + esc(x) + '"'
       in the DD was therefore breakable by a double quote in the data: 92 `value=`, 52 `title=`,
       29 `href=` (some carrying CUSTOMER-SUBMITTED urls) and 21 `data-vendor=`. A vendor called
       `48" Turf Co`, or a product title with an inch mark, truncates the attribute — the input
       renders blank, the link dies, or the tooltip silently empties. That last one matters most:
       `title` is where this card keeps its load-bearing text, including the reason a Generate PO
       button is disabled. The 2026-08-27 alias work hit exactly this and patched THREE sites in
       one file with a local `escAttr`; the other ~190 were still open.

       ⛔ FIXED IN esc() ITSELF RATHER THAN AT THE CALL SITES. Hand-converting 194 interpolations
       is a mechanical change with 194 chances to miss one, and the next new attribute would start
       the count again. Escaping quotes here is safe in BOTH positions, which is what makes the
       one-line fix legitimate rather than lazy: in an attribute `&quot;` closes the hole, and in
       text content it renders as an ordinary `"`. Verified before changing: no caller assigns
       esc() output to textContent/value, compares it, or uses it as an object key — it is only
       ever interpolated into HTML.

       po-lens's `escAttr` still works and is now a no-op second pass (there is no bare `"` left
       for it to find), so it needs no coordinated edit.

       ⚠️ LEFT ALONE: the `if (!str)` guard means esc(0) returns '' rather than '0'. That is a real
       quirk, it predates this change, and callers may lean on the falsy-to-empty behaviour — not
       worth folding into an escaping fix. */
    function esc(str) {
      if (!str) return '';
      var d = document.createElement('div');
      d.textContent = str;
      return d.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — PHASE 2: A DURABLE ANSWER TO
       "DID MY CLICK WORK?"

       ⛔ EVERY OUTCOME ON THIS BOARD WAS TRANSIENT. Success was a button relabelling itself
       'Saved ✓' for 400-1800ms and then being destroyed by the re-render that followed; failure
       was a window.alert(), which leaves no DOM at all and blocks the page until dismissed. So a
       second after acting there was nothing to read — and an operator who cannot tell a completed
       click from an ignored one clicks again. On this board the thing they click again might be a
       refund.

       Two surfaces, because they answer different questions:
         - `data-last-result` on the ACTING ELEMENT — persists until that element next acts, so a
           reader can ask "what happened to THIS control?" whenever it gets round to it.
         - one shared live region — `role="status"`, so assistive tech and anything watching the
           page get the message announced once, in a fixed place, rather than hunting for it.

       Follows the shape already used by the prospect cards (`data-state` + `aria-live`), rather
       than inventing a second vocabulary for the same idea.

       ⛔ DELIBERATELY NOT AUTO-CLEARED. A timeout is what made the existing signals useless. The
       stamp is replaced when the same control acts again, and `data-last-result-at` carries the
       time so a stale one is recognisable as stale rather than mistaken for fresh. */
    function _liveRegion() {
      var el = document.getElementById('rqd-live');
      if (!el) {
        el = document.createElement('div');
        el.id = 'rqd-live';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.setAttribute('aria-atomic', 'true');
        /* Visually hidden, NOT display:none — a display:none region is not announced, and this
           has to reach a screen reader. clip-path keeps it out of the layout. */
        el.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;'
          + 'overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;';
        (document.querySelector('.rep-quote-portal-content') || document.body).appendChild(el);
      }
      return el;
    }

    function markResult(el, ok, detail) {
      var when = new Date().toISOString();
      var msg = String(detail == null ? '' : detail);
      try {
        if (el && el.setAttribute) {
          el.setAttribute('data-last-result', ok ? 'ok' : 'error');
          el.setAttribute('data-last-result-at', when);
          if (msg) el.setAttribute('data-last-result-detail', msg.slice(0, 300));
          else el.removeAttribute('data-last-result-detail');
        }
      } catch (_) { /* never let a status stamp break the action it is reporting on */ }
      try {
        if (msg) _liveRegion().textContent = (ok ? '' : 'Failed: ') + msg;
      } catch (_) {}
      return ok;
    }
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — PHASE 2: IN-DOM DIALOGS.

       ⛔ NATIVE confirm()/prompt()/alert() ARE INVISIBLE TO ANYTHING DRIVING THIS PAGE. They live
       in browser chrome, not the DOM, and they BLOCK the page while open. So an agent that clicks
       "Delete Quote" sees no DOM change at all, concludes the click failed, and clicks again — and
       on this board the thing it clicks again might be a refund. A harness that auto-dismisses
       dialogs is worse still: it silently answers questions nobody read.

       These render real elements with stable hooks, so the same dialog can be read, answered and
       verified by a person, a screen reader or a bot:

         [data-dialog]           the overlay, with kind = confirm | prompt | choice
         [data-dialog-message]   the question, as text
         [data-dialog-input]     the prompt's field
         [data-action="confirm"] / [data-action="cancel"] / [data-choice="<value>"]

       Modelled on the mark-dead view in dashboard-lead-actions.js, which already does this
       properly — real elements, a real error node, a real disabled state.

       ⚠️ ASYNC, where the natives were synchronous. Every converted call site must `await`, and
       an un-awaited one reads as truthy — which is why the conversion is done deliberately rather
       than by blanket find-and-replace. */
    function rqdDialog(opts) {
      var kind = opts.kind || 'confirm';
      var overlay = document.createElement('div');
      overlay.className = 'rqd-modal-backdrop rqd-dialog-backdrop';
      overlay.setAttribute('data-dialog', kind);
      overlay.setAttribute('role', kind === 'alert' ? 'alertdialog' : 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', opts.title || 'Confirm');
      overlay.style.cssText = 'display:flex;align-items:center;justify-content:center;position:fixed;'
        + 'inset:0;background:rgba(0,0,0,0.55);z-index:100001;padding:16px;';

      var panel = document.createElement('div');
      panel.className = 'rqd-modal rqd-dialog';
      panel.style.cssText = 'max-width:520px;width:100%;background:var(--rq-bg-surface,#0a1e30);'
        + 'color:var(--rq-text,#e0e0e0);border:1px solid var(--rq-border,#1e2a42);border-radius:12px;'
        + 'padding:20px;box-shadow:0 20px 60px rgba(0,0,0,0.5);';

      var h = document.createElement('p');
      h.className = 'rqd-modal__title';
      h.textContent = opts.title || (kind === 'prompt' ? 'Enter a value' : kind === 'alert' ? 'Notice' : 'Please confirm');
      h.style.cssText = 'margin:0 0 8px;font-weight:700;font-size:15px;';
      panel.appendChild(h);

      var msg = document.createElement('p');
      msg.setAttribute('data-dialog-message', '');
      msg.className = 'rqd-modal__sub';
      /* textContent, not innerHTML: these messages interpolate customer, vendor and deal values. */
      msg.textContent = String(opts.message || '');
      msg.style.cssText = 'margin:0 0 14px;font-size:13px;line-height:1.5;white-space:pre-wrap;'
        + 'color:var(--rq-text-secondary,#b0b8c4);';
      panel.appendChild(msg);

      var input = null;
      if (kind === 'prompt') {
        input = document.createElement('input');
        input.type = 'text';
        input.setAttribute('data-dialog-input', '');
        input.value = opts.defaultValue || '';
        if (opts.placeholder) input.placeholder = opts.placeholder;
        input.style.cssText = 'width:100%;padding:8px 10px;margin-bottom:14px;border-radius:8px;'
          + 'border:1px solid var(--rq-border,#1e2a42);background:var(--rq-bg-section,#0a1e30);'
          + 'color:var(--rq-text,#e0e0e0);font-size:13px;';
        panel.appendChild(input);
      }

      var err = document.createElement('p');
      err.setAttribute('data-dialog-error', '');
      err.style.cssText = 'display:none;margin:0 0 12px;font-size:12px;color:var(--rq-error,#f87171);';
      panel.appendChild(err);

      var btns = document.createElement('div');
      btns.className = 'rqd-modal__btns';
      btns.style.cssText = 'display:flex;gap:8px;justify-content:flex-end;flex-wrap:wrap;';
      panel.appendChild(btns);
      overlay.appendChild(panel);

      var settled = false;
      var resolveFn = null;
      function done(value) {
        if (settled) return;
        settled = true;
        document.removeEventListener('keydown', onKey, true);
        try { overlay.remove(); } catch (_) {}
        resolveFn(value);
      }
      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); done(kind === 'prompt' ? null : false); }
      }

      function mkBtn(label, value, primary, danger) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rqd-modal__btn ' + (primary ? 'rqd-modal__btn--primary' : 'rqd-modal__btn--cancel');
        b.textContent = label;
        /* ⛔ The destructive option is styled as destructive and is NEVER the default focus — a
           confirm whose dangerous answer is one Enter away is not a confirmation. */
        if (danger) b.style.cssText = 'background:var(--rq-error,#f87171);color:#1a0000;border:none;';
        if (value === false || value === null) b.setAttribute('data-action', 'cancel');
        else if (kind === 'choice') b.setAttribute('data-choice', String(value));
        else b.setAttribute('data-action', 'confirm');
        b.addEventListener('click', function () {
          if (kind === 'prompt' && value !== null) {
            var v = input ? input.value : '';
            if (opts.validate) {
              var problem = opts.validate(v);
              if (problem) { err.textContent = problem; err.style.display = 'block'; input.focus(); return; }
            }
            done(v);
            return;
          }
          done(value);
        });
        btns.appendChild(b);
        return b;
      }

      var focusTarget = null;
      if (kind === 'choice') {
        (opts.choices || []).forEach(function (c) {
          var b = mkBtn(c.label, c.value, !!c.primary, !!c.danger);
          if (c.primary) focusTarget = b;
        });
        mkBtn(opts.cancelLabel || 'Cancel', false, false, false);
      } else if (kind === 'alert') {
        /* One button. An alert asks nothing, so a Cancel would be a second way to say the only
           thing there is to say, and a bot would have to guess which one dismisses it. */
        focusTarget = mkBtn(opts.confirmLabel || 'OK', true, true, false);
      } else {
        mkBtn(opts.cancelLabel || 'Cancel', kind === 'prompt' ? null : false, false, false);
        var ok = mkBtn(opts.confirmLabel || 'Confirm', true, true, !!opts.danger);
        if (!opts.danger) focusTarget = ok;
      }

      /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-29) — ⛔ MOUNTED IN THE WRAP, NOT THE CONTENT,
         AND THIS IS A STACKING-CONTEXT FIX RATHER THAN A z-index ONE.
         `.rep-quote-portal-content` is `position: relative; z-index: 1`, which makes it a stacking
         context — so a dialog appended inside it is CAPPED at that 1 no matter what its own
         z-index says. Every full-screen modal (the composer, the email modal, the date range) is
         appended to `.rep-quote-portal-wrap` at z-index 9999, a SIBLING of content, so a confirm
         raised over one could never win from in there: bumping 9998 to 10050 would have changed
         nothing and looked like the fix. Ryan asked for exactly this: *"make sure the confirmation
         pop-up appears on top of the pop-up(s) below it."*
         ⚠️ The wrap is also what carries the theme's custom properties, so this keeps the dialog's
         colours — moving it to <body> instead would have fixed the stacking and greyed the dialog,
         which is the trade the held-email modal already got wrong once today.
         ⚠️ Verified before moving: no CSS anywhere scopes the dialog under `.portal-content`. */
      (document.querySelector('.rep-quote-portal-wrap')
        || document.querySelector('.rep-quote-portal-content')
        || document.body).appendChild(overlay);
      document.addEventListener('keydown', onKey, true);
      /* Focus the input on a prompt; otherwise the safe button. On a destructive confirm nothing
         is focused, so Enter cannot carry it out by reflex. */
      try { (input || focusTarget) && (input || focusTarget).focus(); } catch (_) {}

      return new Promise(function (res) { resolveFn = res; });
    }

    function rqdConfirm(message, opts) {
      var o = opts || {};
      return rqdDialog({
        kind: 'confirm', message: message,
        title: o.title, confirmLabel: o.confirmLabel, cancelLabel: o.cancelLabel, danger: o.danger,
      });
    }
    function rqdPrompt(message, defaultValue, opts) {
      var o = opts || {};
      return rqdDialog({
        kind: 'prompt', message: message, defaultValue: defaultValue || '',
        title: o.title, confirmLabel: o.confirmLabel || 'OK', placeholder: o.placeholder, validate: o.validate,
      });
    }
    function rqdChoice(message, choices, opts) {
      var o = opts || {};
      return rqdDialog({ kind: 'choice', message: message, choices: choices, title: o.title, cancelLabel: o.cancelLabel });
    }
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) — PHASE 2: the alert() replacement.

       ⛔ NOT a markResult() stamp, and that was measured rather than assumed. The stamp writes
       data-last-result on the acting element and mirrors the text into the shared live region —
       but that region is VISUALLY HIDDEN by design (it has to reach a screen reader without
       taking layout). Replacing an alert() with a stamp alone would therefore make every failure
       invisible to a sighted operator, which is a worse bug than the one being fixed. Nineteen
       sites already stamp AND alert; both stay — the stamp is what a bot reads back, the notice
       is what a person sees.

       ⚠️ THE MIRROR OF THE CONFIRM TRAP: alert() BLOCKS and this does not. Where the old code
       ran a re-render or a refetch on the line after the alert, that work used to happen only
       after the operator dismissed it; here it would happen underneath the notice. Those sites
       await this — see the await audit in tests/dashboard-dialog-contract-tests.mjs. Everywhere
       else nothing follows the call in its block, so fire-and-forget is exactly equivalent. */
    function rqdAlert(message, opts) {
      var o = opts || {};
      /* Mirror into the live region as well, so the message is readable without finding the
         modal — the same channel markResult() uses. */
      try { if (message) _liveRegion().textContent = String(message); } catch (_) {}
      return rqdDialog({ kind: 'alert', message: message, title: o.title, confirmLabel: o.confirmLabel });
    }
    window.RQD = window.RQD || {};
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) - PHASE 2: ONE HOOK FOR "THIS CONTROL ACTS".

       Sixteen attribute names mean that on this board - data-fb-action, data-po-action, data-cmd,
       data-adj, data-oc-go, data-f, data-act and nine more - because each card grew its own
       delegated handler and named its own attribute. 126 controls, no shared selector. A bot has
       to know all sixteen, and the seventeenth card will invent the seventeenth name.

       This adds ONE: `data-dd-action`, as `family:value`.

       It does NOT rename anything. Every delegated handler matches on the EXISTING attribute, so
       renaming means rewriting ~40 handlers and 126 render sites simultaneously, on controls that
       send POs and release refunds, to fix what is a discoverability problem. Additive is the
       right trade.

       It does NOT reuse `data-action` either - that is already in service with its own vocabulary
       (cancel / confirm / contact-add / prospect-edit / open-row-actions), and overloading it
       would make an existing selector ambiguous.

       Stamped from a debounced MutationObserver rather than at each render site: renders happen
       from ~40 places across 20 modules, and a normaliser you have to remember at each one is one
       you will forget at the next one. */
    var DD_ACTION_ATTRS = {
      'data-fb-action': 'fb',
      'data-po-action': 'po',
      'data-freight-action': 'freight',
      'data-freight-override-action': 'freight-override',
      'data-bucket-action': 'bucket',
      'data-adjust-action': 'adjust',
      'data-claimdoc-action': 'claimdoc',
      'data-pallet-fee-action': 'pallet-fee',
      'data-invoice-action': 'invoice',
      'data-cc-action': 'cc',
      'data-action': 'action',
      'data-cmd': 'cmd',
      'data-act': 'act',
      'data-adj': 'adj',
      'data-oc-go': 'oc',
      'data-f': 'f',
    };
    var DD_ACTION_SELECTOR = Object.keys(DD_ACTION_ATTRS).map(function (a) { return '[' + a + ']'; }).join(',');

    function stampDdAction(root) {
      if (!root || !root.querySelectorAll) return 0;
      var n = 0;
      var els = root.querySelectorAll(DD_ACTION_SELECTOR);
      var list = [];
      for (var i = 0; i < els.length; i++) list.push(els[i]);
      /* the root itself may be the control, not just a container */
      if (root.matches && root.matches(DD_ACTION_SELECTOR)) list.push(root);
      list.forEach(function (el) {
        if (el.hasAttribute('data-dd-action')) return;   // first one wins; never overwrite
        for (var attr in DD_ACTION_ATTRS) {
          if (!el.hasAttribute(attr)) continue;
          var v = el.getAttribute(attr);
          if (!v) continue;
          el.setAttribute('data-dd-action', DD_ACTION_ATTRS[attr] + ':' + v);
          n++;
          return;
        }
      });
      return n;
    }

    function initDdActionNormalizer() {
      var host = document.querySelector('.rep-quote-portal-content') || document.body;
      if (!host) return;
      stampDdAction(host);
      var queued = false;
      var obs = new MutationObserver(function (records) {
        if (queued) return;
        queued = true;
        /* Coalesce a whole render into one sweep. renderTable can emit hundreds of nodes in a
           burst; stamping per-record would run the selector hundreds of times for one repaint. */
        requestAnimationFrame(function () {
          queued = false;
          for (var i = 0; i < records.length; i++) {
            var added = records[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              if (added[j].nodeType === 1) stampDdAction(added[j]);
            }
          }
        });
      });
      try { obs.observe(host, { childList: true, subtree: true }); } catch (_) {}
    }
    window.RQD.stampDdAction = stampDdAction;
    /* CUSTOM_DEALDASHBOARD_BY_CLAUDE (Ryan 2026-08-27) - called HERE, not up with the other init.
       ⛔ DD_ACTION_ATTRS and DD_ACTION_SELECTOR are `var`s declared just above. A call from the
       boot block ~20k lines earlier hoists the FUNCTION fine but reads those as undefined, so
       Object.keys(undefined) throws - and because the attribute this adds is purely additive,
       nothing visibly breaks: the hook simply never appears. A normaliser that is silently dead
       is worse than none, because the DOM contract would look complete and not be. */
    try { initDdActionNormalizer(); } catch (e) { console.error('dd-action normalizer failed:', e); }

    window.RQD.confirm = rqdConfirm;
    window.RQD.prompt = rqdPrompt;
    window.RQD.choice = rqdChoice;
    window.RQD.alert = rqdAlert;

    /* Clear the previous verdict the moment a control acts again, so a stale 'ok' can never be
       read as the result of the click currently in flight. */
    function markPending(el) {
      try {
        if (el && el.setAttribute) {
          el.setAttribute('data-last-result', 'pending');
          el.setAttribute('data-last-result-at', new Date().toISOString());
          el.removeAttribute('data-last-result-detail');
        }
      } catch (_) {}
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-21) — Mark Dead activity gate.
       Replaces the 72h age check: a NEW LEAD can only be marked dead once the
       rep has logged at least one Note / Phone Call / Email (or any chip type
       — Meeting / Drop-In also count, since they're also explicit customer
       engagement). System-generated entries (_AUTO / _SYSTEM transitions,
       sample-shipped stamps, etc.) don't count — only entries the rep wrote.
       Mirrors the server-side check in lead-routes.js handleLeadMarkDead. */
    function _qstHasContactActivity(q) {
      if (!q || !Array.isArray(q.noteEntries)) return false;
      for (var i = 0; i < q.noteEntries.length; i++) {
        var e = q.noteEntries[i];
        if (!e || !e.by) continue;
        if (e.by === '_AUTO' || e.by === '_SYSTEM') continue;
        return true;
      }
      return false;
    }
    // Derive a tracking URL from a carrier + number when admin didn't paste
    // an explicit URL AND nothing's been remembered yet for this carrier.
    // Falls back to '' so the pill renders as plain text rather than a
    // broken link. FedEx uses the static landing page per Ryan — admin
    // pastes the number on FedEx's site (their tracking-by-querystring
    // form changes regularly so a deep link breaks more than it helps).
    function sampleTrackingUrl(carrier, number) {
      if (!number) return '';
      var c = String(carrier || '').toLowerCase().replace(/[^a-z]/g, '');
      var num = encodeURIComponent(String(number).trim());
      if (!c) return '';
      if (c.indexOf('ups') !== -1) return 'https://www.ups.com/track?tracknum=' + num;
      if (c.indexOf('fedex') !== -1) return 'https://www.fedex.com/fedextrack/?trknbr=' + num;
      if (c.indexOf('usps') !== -1) return 'https://tools.usps.com/go/TrackConfirmAction?tLabels=' + num;
      if (c.indexOf('dhl') !== -1) return 'https://www.dhl.com/en/express/tracking.html?AWB=' + num;
      return '';
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Pick the best tracking URL for a sample
       shipment row. Heals saved URLs that don't actually point to the
       tracking number (e.g. a generic carrier landing page got stored when
       buildUrlTemplate couldn't find the number inside the URL, so memory
       was templated without a {TRACKING} token — then every subsequent
       pre-fill / save propagated the generic URL).

       Precedence:
         1. savedUrl that contains the tracking number → trust it (admin's
            deep link is intentional, including non-standard carrier
            domains like internal portals).
         2. Static deep link for known carriers (FedEx/UPS/USPS/DHL) →
            canonical tracking page with the number embedded.
         3. Remembered template that yields a URL containing the number →
            useful for niche carriers that admin set up by hand.
         4. Fall back to whatever savedUrl / memory we have, even if it
            doesn't point to the specific number (last-resort, preserves
            existing behavior for edge cases).

       Heals at render time → no migration needed; old `sampleTracking.url`
       values in workstation_meta stay as-is. */
    function bestSampleTrackingUrl(savedUrl, carrier, number) {
      var num = number ? String(number).trim() : '';
      if (savedUrl && num && String(savedUrl).indexOf(num) !== -1) {
        return savedUrl;
      }
      var deepLink = sampleTrackingUrl(carrier, num);
      if (deepLink) return deepLink;
      var remembered = recallSampleCarrierUrl(carrier, num);
      if (remembered && num && String(remembered).indexOf(num) !== -1) return remembered;
      return savedUrl || remembered || '';
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

    /* ============================================
       THE 📦 BADGE HAS THREE STATES, NOT TWO
       CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-19)
       ============================================
       Ryan: "when they ship out, the circle shows up with a truck emoji in the top
       right corner of it ... then once delivered it changes to a checkmark."

       So the corner badge means IN TRANSIT (truck) until FedEx says the box landed, and
       only then a ✓. Before this, the ✓ appeared the moment a tracking number was typed —
       which claimed a delivery on the strength of a shipping label.

       ⛔ THE GLYPH AND THE COLOUR ARE ORTHOGONAL, AND THAT IS DELIBERATE. Five colour
       variants already exist on this badge (green sample, blue --quote, gray --pending,
       yellow --lead, violet --on-hold), each with a dark-mode pair, and every one of them
       needed a truck too. Folding delivery into the variant would have made ten classes.
       Instead the variant keeps owning the colour and `--delivered` owns the glyph, so the
       truck inherits whatever `color` its variant already resolved to — which is also how
       Ryan's "black truck or white truck depending on whether the corresponding checkmark
       is black or white" gets satisfied without naming a single colour here.

       ⚠️ `deliveredAtRaw` LEADS. FedEx's ACTUAL_DELIVERY usually carries a UTC offset, but
       when it does not the time is local to the delivery address, and re-parsing it can
       move the calendar date by a day. For a DATE we show a human, the string FedEx sent is
       the more truthful source; the parsed instant is for measuring intervals. */
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-19) — THREE OUTCOMES, NOT TWO. Ryan: "if
       something DOES go wrong with the package, the circle on the package emoji can turn red
       with a white X on it or something, so at a glance the rep is made aware of the issue."

       ⛔ TROUBLE IS TESTED BEFORE DELIVERY, and it has to be: the worker only writes
       `trouble` on a box that has NOT landed (10+ days in transit, a carrier exception, or a
       tracking number FedEx cannot find), so the two are mutually exclusive today — but
       ordering it this way means a late-arriving delivery scan clears the alarm on its own
       rather than leaving a red X on a box sitting in someone's lobby. */
    function sampleDeliveryState(trk) {
      var d = trk && trk.delivery;
      var at = d ? (d.deliveredAtRaw || d.deliveredAt || '') : '';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — `tone` rides along with `title`.
         The tracking popover needs to colour this sentence, and deriving "is this the bad
         one" a second time at the render site would be a second opinion about the same
         record — exactly the two-writers-of-one-meaning problem the worker side already had
         with `trouble.reason`. One function decides; everyone downstream reads. */
      if (at) {
        var shown = formatDate(at) || String(at).slice(0, 10);
        return { delivered: true, cls: ' rqd-sample-shipped--delivered', tone: 'delivered',
                 title: 'Delivered · ' + shown };
      }
      var tr = trk && trk.trouble;
      if (tr && tr.reason) {
        var why = tr.reason === 'overdue' ? 'No delivery scan after 10 days'
          : (tr.reason === 'tracking-not-found' ? 'FedEx cannot find this tracking number'
            : 'Carrier reported a problem');
        return { delivered: false, trouble: true, cls: ' rqd-sample-shipped--trouble', tone: 'trouble',
                 title: why + (tr.statusText ? ' · ' + tr.statusText : '') + ' — worth a look' };
      }
      return { delivered: false, cls: '', tone: 'transit', title: 'In transit' };
    }

    // Sample-tracking carrier URL memory. Separate from rememberCarrierUrl
    // (the online-shipping one) because that one explicitly skips known
    // carriers (FedEx/UPS/etc.) — the sample flow needs to remember EVERY
    // carrier's last-used URL so admin's preference (e.g., a FedEx waybill
    // URL with the tracking number embedded) sticks for next time.
    var SAMPLE_CARRIER_URL_LS_KEY = 'rqd-sample-carrier-urls';
    function loadSampleCarrierUrls() {
      try {
        var raw = localStorage.getItem(SAMPLE_CARRIER_URL_LS_KEY);
        return raw ? (JSON.parse(raw) || {}) : {};
      } catch (_) { return {}; }
    }
    function saveSampleCarrierUrls(dict) {
      try { localStorage.setItem(SAMPLE_CARRIER_URL_LS_KEY, JSON.stringify(dict || {})); } catch (_) {}
    }
    function rememberSampleCarrierUrl(carrier, url, tracking) {
      if (!carrier || !url) return;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-01) — a URL that does not contain the
         tracking number is a landing page, not a template. buildUrlTemplate returns it
         VERBATIM when it cannot find the number to swap for {TRACKING}, so remembering one
         pins a numberless link against the carrier and every later pre-fill hands it back —
         which is how RW-1336-A came to store ".../fedextrack/?trknbr=" and would have mailed
         Matt Lightner a link to an empty search box. Same rule, same reason, as
         rememberCarrierUrl on the vendor side. */
      if (!tracking || String(url).indexOf(String(tracking).trim()) === -1) return;
      var dict = loadSampleCarrierUrls();
      dict[String(carrier).trim().toLowerCase()] = buildUrlTemplate(url, tracking);
      saveSampleCarrierUrls(dict);
    }
    function recallSampleCarrierUrl(carrier, tracking) {
      if (!carrier) return '';
      var dict = loadSampleCarrierUrls();
      var key = String(carrier).trim().toLowerCase();
      var template = dict[key];
      if (!template) return '';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-09-01) — self-heal entries stored before the
         guard above existed. A template carrying no {TRACKING} token can only ever expand to
         the same numberless URL, so it is the poison rather than a memory. localStorage
         outlives every deploy, so the heal has to happen on READ. */
      if (String(template).indexOf('{TRACKING}') === -1) {
        delete dict[key];
        saveSampleCarrierUrls(dict);
        return '';
      }
      return expandUrlTemplate(template, tracking);
    }

    function formatDate(dateStr) {
      if (!dateStr) return '—';
      // Date-only strings (YYYY-MM-DD) get parsed as UTC midnight by the Date constructor,
      // which then renders in local time as the previous day for users west of UTC. Parse
      // those as local dates instead to preserve the calendar date.
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        var parts = dateStr.split('-');
        return parseInt(parts[1], 10) + '/' + parseInt(parts[2], 10) + '/' + parts[0];
      }
      var d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Compact, friendly
       timestamp for the Notes activity log. Never shows year; collapses
       "today" / "yesterday" to relative; recent (≤ 7 days) gets the
       weekday prefix; older drops weekday. Time always trails as
       "h:mm am/pm". Examples:
         Today, 10:33 am
         Yesterday, 4:15 pm
         Fri May 9, 2:30 pm
         May 3, 9:14 am
    */
    function formatNoteDate(ts) {
      if (!ts) return '';
      var d = new Date(ts);
      if (isNaN(d.getTime())) return '';
      var now = new Date();
      function ymd(x) { return x.getFullYear() + '-' + (x.getMonth()+1) + '-' + x.getDate(); }
      var sameDay = ymd(d) === ymd(now);
      var yest = new Date(now); yest.setDate(now.getDate() - 1);
      var sameYest = ymd(d) === ymd(yest);
      var sevenAgo = new Date(now); sevenAgo.setDate(now.getDate() - 7); sevenAgo.setHours(0,0,0,0);
      // Time piece: lowercase am/pm with no leading zero on hours.
      var h = d.getHours();
      var ampm = h < 12 ? 'am' : 'pm';
      var h12 = h % 12; if (h12 === 0) h12 = 12;
      var mm = String(d.getMinutes()).padStart(2, '0');
      var timeStr = h12 + ':' + mm + ' ' + ampm;
      if (sameDay) return 'Today, ' + timeStr;
      if (sameYest) return 'Yesterday, ' + timeStr;
      var monShort = d.toLocaleDateString('en-US', { month: 'short' });
      var datePart = monShort + ' ' + d.getDate();
      if (d >= sevenAgo) {
        var weekday = d.toLocaleDateString('en-US', { weekday: 'short' });
        return weekday + ' ' + datePart + ', ' + timeStr;
      }
      return datePart + ', ' + timeStr;
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    function formatAwaitingElapsed(createdAt) {
      if (!createdAt) return '0m';
      var t = new Date(createdAt).getTime();
      if (!isFinite(t)) return '0m';
      var totalMin = Math.floor((Date.now() - t) / 60000);
      if (totalMin < 0) totalMin = 0;
      var m = totalMin % 60;
      var h = Math.floor(totalMin / 60) % 24;
      var d = Math.floor(totalMin / 1440);
      // Past 24h the minutes lose signal — drop them so the badge stays
      // visually quiet ("3d 14h" rather than "3d 14h 27m"). Hours + minutes
      // still both show inside the first day so newly-landed leads tick
      // up at minute resolution and feel responsive.
      if (d > 0) return d + 'd ' + h + 'h';
      if (h > 0) return h + 'h ' + m + 'm';
      return m + 'm';
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Unified expiration
       anchor for all follow-up / hold / wake timing. YYYY-MM-DD dates
       "tip over" at 4am EDT (most of the year) / 3am EST (winter),
       both safely in the dead zone before reps start work. T08:00:00Z
       = 4am EDT = 3am EST. Worker side (autoWakeIfDue) uses the same
       anchor so frontend bell state + backend auto-resurrect happen
       at the same instant. Effect: rep starting their day at 7-8am
       sees a complete, stable task list — no "trickling in" through
       the morning. */
    var FU_DAY_ANCHOR = 'T08:00:00Z';
    // Countdown from now → holdUntil for the ON HOLD pill in the To Do
    // column.
    function formatHoldCountdown(holdUntil) {
      if (!holdUntil) return '—';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) — ⛔ TWO SHAPES REACH THIS, AND ONLY ONE
         WANTS THE ANCHOR. `holdUntil` is a DATE ("2026-09-01"): a hold has no time of day, so
         FU_DAY_ANCHOR pins it to 08:00Z. `sendAfter` on an automation is a full INSTANT
         ("2026-08-26T21:37:00.000Z") and already carries one — suffixing it produced
         "...000ZT08:00:00Z", an unparseable string, NaN, and the — Ryan saw beside the ⚡ on
         RW-1327-A. The overdue test one line up parses `sendAfter` correctly with Date.parse,
         so the pill knew the email was still pending and then could not say when. */
      var _raw = String(holdUntil);
      var t = /^\d{4}-\d{2}-\d{2}$/.test(_raw)
        ? new Date(_raw + FU_DAY_ANCHOR).getTime()
        : new Date(_raw).getTime();
      if (!isFinite(t)) return '—';
      var totalMin = Math.floor((t - Date.now()) / 60000);
      if (totalMin <= 0) return 'wakes today';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — Single-unit countdown:
         whole DAYS down to the 1-day mark, then flip to HOURS for the final day.
         24h shows "1d", 23h shows "23h", counting down to "1h" → bell. No mixed
         "Xd Yh". floor(min/1440) keeps "1d" through the entire last day;
         floor(min/60) (min 1) gives the clean hour countdown so it never reads
         "0h" before expiry. */
      /* CUSTOM_COUNTDOWNROUND_BY_CLAUDE (Ryan 2026-09-30) — DAYS ROUND THE WAY A PERSON COUNTS.
         floor() read "1d" for an email going out in 46 hours (RW-1447-A, scheduled Wednesday
         morning for Friday morning), which reads as "tomorrow". Inside the last 24 hours it is
         still hours; past that, nearest whole day — 46h → 2d, 30h → 1d, 36h → 2d. Applies to
         every countdown pill that comes through here, holds included; that was the ask. */
      if (totalMin < 1440) {
        var h = Math.floor(totalMin / 60);
        return (h > 0 ? h : 1) + 'h';
      }
      return Math.round(totalMin / 1440) + 'd';
    }
    /* Follow-up expired gate. Returns true once the day's 4am-ET
       tipping point has passed; the To-Do column's follow-up badge
       flips from ⏰ + countdown text to a 🔔 bell when this is true. */
    function isFollowUpExpired(dueAt) {
      if (!dueAt) return false;
      var t = new Date(String(dueAt) + FU_DAY_ANCHOR).getTime();
      if (!isFinite(t)) return false;
      return t <= Date.now();
    }
    /* Format duration between an entry's ts and a follow-up YYYY-MM-DD
       date as "Xd Yh" / "Xd" / "Yh" / "0h". Used by the activity-log
       follow-up indicator's delta-aware variant ("Was at 3d 4h, set
       for 7d") when an entry has previousFollowUpAt stamped on it. */
    function formatFollowUpRemaining(fromIso, toYmd) {
      if (!toYmd) return '0h';
      var fromMs = fromIso ? Date.parse(fromIso) : Date.now();
      var toMs = Date.parse(String(toYmd) + FU_DAY_ANCHOR);
      if (!isFinite(fromMs) || !isFinite(toMs)) return '0h';
      var totalMin = Math.max(0, Math.floor((toMs - fromMs) / 60000));
      var d = Math.floor(totalMin / 1440);
      var h = Math.floor((totalMin % 1440) / 60);
      if (d > 0 && h > 0) return d + 'd ' + h + 'h';
      if (d > 0) return d + 'd';
      if (h > 0) return h + 'h';
      return '0h';
    }
    /* Phase 1.19 — Shared follow-up day count used by activity log entry
       render. Uses Math.ceil (not Math.round) so +1d at 11pm still reads
       as "1d" instead of "0d". Hoisted to prevent the same bug from
       creeping back via duplicated copies in 3 render paths. */
    function _followUpDayCount(entryTsIso, followUpAtYmd) {
      if (!followUpAtYmd) return 0;
      var fromMs = entryTsIso ? Date.parse(entryTsIso) : Date.now();
      var toMs = Date.parse(String(followUpAtYmd) + 'T08:00:00Z');
      if (!isFinite(fromMs) || !isFinite(toMs)) return 0;
      return Math.max(0, Math.ceil((toMs - fromMs) / 86400000));
    }
    // Live-tick the "New Lead" timers + SAMPLE timers + ON HOLD countdowns
    // without re-rendering the whole row. Single selector covers both lead
    // and sample variants since they share the same .rqd-remaining base
    // class + data-awaiting-since hook.
    setInterval(function() {
      document.querySelectorAll('.rqd-remaining--awaiting[data-awaiting-since], .rqd-remaining--sample[data-awaiting-since]').forEach(function(el) {
        /* Ryan 2026-05-16: all "act now" awaiting bells are now bell-
           only (no visible count-up text). Time-since-landed lives in
           the body-level tooltip via data-tip. Live-tick refreshes
           that attribute so the number stays fresh second-by-second.
           Three variants based on row state — sample, NEW LEAD, and
           RESUMED — each phrased slightly differently for context. */
        var elapsed = formatAwaitingElapsed(el.dataset.awaitingSince);
        if (el.classList.contains('rqd-remaining--resumed-bell')) {
          el.setAttribute('data-tip', 'Off hold ' + elapsed + ' ago');
        } else if (el.classList.contains('rqd-remaining--sample')) {
          el.setAttribute('data-tip', elapsed + ' since sample request landed');
        } else if (el.classList.contains('rqd-remaining--awaiting')) {
          el.setAttribute('data-tip', elapsed + ' since lead landed');
        }
      });
      document.querySelectorAll('.rqd-hold-countdown[data-hold-until]').forEach(function(el) {
        var textEl = el.querySelector('.rqd-hold-countdown__text');
        if (textEl) textEl.textContent = formatHoldCountdown(el.dataset.holdUntil);
      });
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-15) — Follow-up countdown
         live-tick. Mirrors the on-hold tick — same formatHoldCountdown
         output (single-unit: "3d" / "23h") so the two countdowns read with
         the same visual language. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-20) — the automated-email countdown ticks like
         the others and ⛔ NEVER BECOMES A BELL. Ryan: *"the email goes out and you never see the
         bell."* The bell branch below is a TIMER, so without its own loop here a suppressed row
         would grow one the moment its countdown crossed zero — the exact nag, arriving by the
         back door, on the one deal that needs nothing.
         ⚠️ It reads "sending" past due rather than counting negative: the drain runs every
         fifteen minutes, and the row corrects itself on the next quiet refetch. */
      document.querySelectorAll('.rqd-seq-countdown[data-seq-until]').forEach(function(el) {
        var until = el.dataset.seqUntil;
        var t = el.querySelector('.rqd-seq-countdown__text');
        if (!t) return;
        t.textContent = (Date.parse(until) || 0) <= Date.now() ? 'sending' : formatHoldCountdown(until);
      });
      document.querySelectorAll('.rqd-followup-countdown[data-followup-until]').forEach(function(el) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-16) — Two-phase tick.
           While the countdown hasn't expired, just update the text.
           Once it crosses zero, swap the inner HTML to the bell variant
           in place + flip the modifier class so the CSS pulse + hover
           shake kick in without a full row re-render. */
        var dueAt = el.dataset.followupUntil;
        var expired = isFollowUpExpired(dueAt);
        var alreadyExpired = el.classList.contains('rqd-followup-countdown--expired');
        if (expired && !alreadyExpired) {
          el.classList.add('rqd-followup-countdown--expired');
          el.innerHTML = '<span class="rqd-followup-bell" aria-label="Follow-up due">🔔</span>';
          /* Ryan 2026-05-21: countdown was hidden via inline style
             (envelope present); the transition to bell means the
             element should be visible again per spec (envelope + bell
             allowed side-by-side). Clear any leftover inline display
             so the bell renders. */
          if (el.style.display === 'none') el.style.display = '';
          /* Ryan 2026-05-16: tooltip text doesn't carry "click to..."
             hints anymore — reps figure out the click affordance from
             cursor: pointer + role=button. Tooltip text stays as-is
             when transitioning to bell state. */
        } else if (!expired) {
          var textEl = el.querySelector('.rqd-followup-countdown__text');
          if (textEl) textEl.textContent = formatHoldCountdown(dueAt);
        }
      });
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    }, 1000);
    function capitalize(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }
    // PO records store the canonical Vendor Guide name (e.g. "ECORE Athletic"),
    // but q.financials.vendors holds the Shopify product.vendor short form
    // ("ECORE"). Strict equality misses that pairing, so the Purchasing card
    // ends up showing "Generate PO" forever even after a PO has been minted /
    // sent / downloaded. Mirrors the worker-side vendorMatches helper.
    /* FREIGHT-VENDORMATCH-TWIN:BEGIN
       CUSTOM_FREIGHTTWIN_BY_CLAUDE (Ryan 2026-09-03) — this is the rule that decides which line
       items a supplier's freight request covers, so `src/lib/freight-request-inputs.js` in the
       rfq-worker carries a copy and tests/freight-compose-parity.test.mjs asserts they agree.

       ⛔ IT IS NOT THE WORKER'S `vendorMatches` (lib/vendor-canonical.js), which additionally
       resolves brand rollups — Normatec, Hypervolt and Venom all match Hyperice there and none of
       them match here. That one is right for "has a PO been raised for this vendor"; using it to
       pick freight-email line items would put items in an agent's email that this button leaves
       out. The button is the reference, so the narrower rule is the one that travels. */
    function vendorNamesMatch(a, b) {
      if (!a || !b) return false;
      /* CUSTOM_ORDERSTHROUGH_BY_CLAUDE (Ryan 2026-11-02) - the Vendor Guide's "Order through" fold on both
         names first (Maxxus Saunas -> Golden Designs), same as the worker twin. Absent map = unchanged. */
      var _fold = (typeof window !== 'undefined' && window.RPDash && typeof window.RPDash.foldVendor === 'function') ? window.RPDash.foldVendor : null;
      if (_fold) { a = _fold(a); b = _fold(b); }
      var na = String(a).toLowerCase().trim();
      var nb = String(b).toLowerCase().trim();
      if (na === nb) return true;
      if (na.startsWith(nb + ' ') || nb.startsWith(na + ' ')) return true;
      var sfx = /\s+(inc|llc|corp|corporation|company|co|ltd|limited|athletic|training systems|training|fitness|equipment|industries|enterprises)\.?$/i;
      var ka = na, kb = nb;
      while (sfx.test(ka)) ka = ka.replace(sfx, '').trim();
      while (sfx.test(kb)) kb = kb.replace(sfx, '').trim();
      return !!ka && ka === kb;
    }
    /* FREIGHT-VENDORMATCH-TWIN:END */

    function isResidentialOrg(val) {
      if (!val) return true;
      var v = val.trim().toLowerCase().replace(/[\s\-\/\\,]+/g, ' ').trim();
      if (!v) return true;
      var words = ['n', 'a', 'n a', 'na', 'none', 'residential', 'residence', 'home', 'home gym', 'personal'];
      for (var i = 0; i < words.length; i++) { if (v === words[i]) return true; }
      var parts = v.split(' ');
      return parts.length > 0 && parts.every(function(p) { return !p || p === '-' || words.indexOf(p) !== -1; });
    }
    function fmtPhone(p) {
      if (!p) return '';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — use the shared formatter so
         a stored extension renders on the deal's detail panel too (10 digits + ext.). */
      if (window.RepPortal && window.RepPortal.formatPhone) return window.RepPortal.formatPhone(p);
      var digits = p.replace(/\D/g, '');
      var prefix = '';
      if (digits.length === 11 && digits[0] === '1') { prefix = '+1 '; digits = digits.substring(1); }
      if (digits.length === 10) return prefix + '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
      return p; // return as-is if not standard US
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — phone COLUMN cell (the narrow
       Prospecting-tab Phone column). When a number carries an extension, don't render
       the full "…ext. 890" inline — it overflows into the next column. Show just the
       number + "…" and move "ext. 890" into a hover tooltip. Numbers without an
       extension render normally. */
    function _phoneColHtml(rawPhone) {
      var raw = (rawPhone || '').trim();
      if (!raw) return '<span class="rqd-col-phone__empty">—</span>';
      var full = fmtPhone(raw);
      var parts = full.split(/\s+ext\.\s+/i);
      if (parts.length > 1 && parts[1]) {
        return '<span class="rqd-col-phone__num" title="ext. ' + esc(parts[1]) + '">' + esc(parts[0]) + ' …</span>';
      }
      return '<span class="rqd-col-phone__num">' + esc(full) + '</span>';
    }
    // CSV Export
    document.getElementById('rqd-export').addEventListener('click', function() {
      var btn = this;
      btn.textContent = 'Exporting...';
      btn.disabled = true;

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17 — Phase 1.10) — Deal
         Prospecting export branch. Uses the in-memory allQuotes (already
         CFA-filtered server-side + stage-filtered client-side via
         _filterProspectsByStage) so the CSV reflects exactly what the
         CFA sees on screen. Columns mirror the visible table + Discovery
         fields so a CSV-to-spreadsheet path is useful for offline review. */
      if (currentSource === 'prospecting') {
        try {
          var visibleP = (currentProspectView === 'playbook') ? _dueFollowUpProspects(allQuotes) : _filterProspectsByStage(allQuotes);
          var pCols = ['Ref', 'Stage', 'CFA', 'Organization', 'Name', 'Title', 'Email', 'Phone', 'City', 'State', 'Created',
                       'Budget', 'Need', 'Timeline', 'Source', 'Source URL', 'Handoff At', 'Handoff To', 'Last Touch'];
          var pRows = [pCols.map(csvSafe).join(',')];
          visibleP.forEach(function(p) {
            var c = p.customer || {};
            var d = p.discovery || {};
            var lastTouch = _prospectLastTouch ? _prospectLastTouch(p) : '';
            var row = [
              p.ref || '',
              (p.prospectStage || 'cold').toUpperCase(),
              p.cfaName || p.cfaCode || '',
              c.organization || '',
              d.authorityName || c.name || '',
              d.authorityTitle || '',
              d.authorityEmail || c.email || '',
              d.authorityPhone || c.phone || '',
              c.city || '',
              c.state || '',
              p.createdAt ? formatDate(p.createdAt) : '',
              d.budget || '',
              d.need || '',
              d.timeline || '',
              p.prospectSource || '',
              (p.prospectSourceRef && p.prospectSourceRef.url) || '',
              p.handoffAt ? formatDate(p.handoffAt) : '',
              p.handoffTo || '',
              lastTouch ? formatDate(lastTouch) : '',
            ].map(csvSafe);
            pRows.push(row.join(','));
          });
          var pCsv = pRows.join('\n');
          var pBlob = new Blob([pCsv], { type: 'text/csv' });
          var pUrl = URL.createObjectURL(pBlob);
          var pA = document.createElement('a');
          pA.href = pUrl;
          pA.download = 'prospects-' + todayStr() + '.csv';
          pA.click();
          URL.revokeObjectURL(pUrl);
        } catch (err) {
          console.error('Prospect export error:', err);
          rqdAlert('Export failed: ' + (err && err.message ? err.message : 'unknown'));
        } finally {
          btn.textContent = 'Export CSV';
          btn.disabled = false;
        }
        return;
      }
      /* END Phase 1.10 export branch */

      // Fetch all quotes (page 1, limit 9999) with current filters
      var params = '?status=' + encodeURIComponent(currentStatus) +
        '&page=1&limit=9999' +
        '&sort=' + encodeURIComponent(currentSort) +
        '&search=' + encodeURIComponent(currentSearch);
      var repVal = repFilter.value;
      if (repVal) params += '&rep=' + encodeURIComponent(repVal);
      if (currentDateFrom) params += '&dateFrom=' + encodeURIComponent(currentDateFrom);
      if (currentDateTo) params += '&dateTo=' + encodeURIComponent(currentDateTo);

      API.get('/rep-quotes' + params).then(function(data) {
        var quotes = data.quotes || [];
        var cols = ['Reference', 'Customer', 'Organization', 'Location', 'Date Quoted', 'Status', 'Deal Type', 'Amount'];
        if (isAdmin) cols = cols.concat(['COGS', 'Profit', 'Margin %', 'Comm %', 'Comm $', 'Invoiced', 'Paid', 'Closed']);

        var rows = [cols.join(',')];
        quotes.forEach(function(q) {
          var fin = q.financials || {};
          var row = [
            q.reference,
            csvSafe(q.customer),
            csvSafe(q.customerCompany || ''),
            csvSafe(q.location || ''),
            formatDate(q.createdAt),
            q.lifecycleStatus || 'quoted',
            q.leadSource || '',
            parseFloat(q.total || 0).toFixed(2)
          ];
          if (isAdmin) {
            row = row.concat([
              (fin.costTotal || 0).toFixed(2),
              (fin.gpOfGoods || 0).toFixed(2),
              (fin.gpOfGoodsMargin || 0).toFixed(1) + '%',
              q.commissionRate ? ((q.commissionRate * 100).toFixed(0) + '%') : '',
              q.commissionAmount ? q.commissionAmount.toFixed(2) : '',
              q.invoicedDate || '',
              q.paid ? 'Yes' : 'No',
              q.closedStatus === 'closed' ? 'Yes' : 'No'
            ]);
          }
          rows.push(row.join(','));
        });

        var csv = rows.join('\n');
        var blob = new Blob([csv], { type: 'text/csv' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'quotes-' + todayStr() + '.csv';
        a.click();
        URL.revokeObjectURL(url);
      }).catch(function(err) {
        console.error('Export error:', err);
      }).finally(function() {
        btn.textContent = 'Export CSV';
        btn.disabled = false;
      });
    });

    function csvSafe(str) {
      if (!str) return '';
      if (str.indexOf(',') >= 0 || str.indexOf('"') >= 0 || str.indexOf('\n') >= 0) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    }

    /* CUSTOM_MARKETINGOPS_BY_CLAUDE — account-local (Denver) "today", NOT UTC.
       UTC rolled to tomorrow after ~6pm Denver, so the mark-sold modal defaulted
       dateSold to tomorrow → the order fell outside the dashboard's (Denver) range
       and could land in the wrong month. Matches the worker's accountLocalYmd. */
    function todayStr() {
      try {
        return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Denver', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      } catch (_e) { return new Date().toISOString().split('T')[0]; }
    }
    function toDateStr(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }
    function pad2(n) { return n < 10 ? '0' + n : '' + n; }

    // ── Reports Section ──

    var reportsSection = document.getElementById('rqd-reports');
    var reportsToggle = document.getElementById('rqd-reports-toggle');
    var reportsBody = document.getElementById('rqd-reports-body');
    var reportsOpen = false;
    var cachedReporting = null;

    function initReportsToggle() {
      if (!reportsToggle || !reportsSection) return;
      reportsSection.style.display = 'block';
      reportsToggle.addEventListener('click', function() {
        reportsOpen = !reportsOpen;
        reportsBody.style.display = reportsOpen ? 'block' : 'none';
        reportsToggle.classList.toggle('rqd-reports__toggle--active', reportsOpen);
        reportsToggle.querySelector('span').innerHTML = reportsOpen ? '&#9650;' : '&#9660;';
        if (reportsOpen && cachedReporting) renderReports(cachedReporting, cachedStats);
      });
    }

    var cachedStats = null;
    function renderReports(r, stats) {
      if (!r || !r.monthly) return;
      cachedReporting = r;
      if (stats) cachedStats = stats;
      if (!reportsOpen) return;

      var html = '<div class="rqd-reports__grid">';

      // Pipeline funnel
      var st = cachedStats || {};
      var funnelData = [
        { label: 'Quoted', count: st.quotedCount || 0, value: parseFloat(st.quotedValue || 0), color: 'blue' },
        { label: 'Sold', count: st.soldCount || 0, value: parseFloat(st.soldValue || 0), color: 'green' },
        { label: 'Lost', count: st.lostCount || 0, value: parseFloat(st.lostValue || 0), color: 'red' },
        { label: 'Expired', count: st.expiredCount || 0, value: parseFloat(st.expiredValue || 0), color: 'purple' },
      ];
      var maxFunnelVal = Math.max.apply(null, funnelData.map(function(f) { return f.value; })) || 1;
      html += '<div class="rqd-reports__card">' +
        '<div class="rqd-reports__card-title">Pipeline Funnel</div>' +
        '<div class="rqd-bar-chart">';
      funnelData.forEach(function(f) {
        if (f.count === 0) return;
        var pct = Math.max((f.value / maxFunnelVal) * 100, 5);
        html += '<div class="rqd-bar">' +
          '<div class="rqd-bar__label">' + f.label + ' (' + f.count + ')</div>' +
          '<div class="rqd-bar__track"><div class="rqd-bar__fill rqd-bar__fill--' + f.color + '" style="width:' + pct + '%;">' + money(f.value) + '</div></div>' +
        '</div>';
      });
      html += '</div></div>';

      // Summary metrics
      var s = r.summary || {};
      html += '<div class="rqd-reports__card rqd-reports__card--full">' +
        '<div class="rqd-reports__card-title">Key Metrics</div>' +
        '<div class="rqd-metrics">' +
          '<div class="rqd-metric"><div class="rqd-metric__value">' + money(s.avgDealSize) + '</div><div class="rqd-metric__label">Avg Deal Size</div></div>' +
          '<div class="rqd-metric"><div class="rqd-metric__value">' + (s.avgMargin || '0') + '%</div><div class="rqd-metric__label">Avg Margin</div></div>' +
          '<div class="rqd-metric"><div class="rqd-metric__value">' + (s.avgTimeToClose || 0) + 'd</div><div class="rqd-metric__label">Avg Time to Close</div></div>' +
          '<div class="rqd-metric"><div class="rqd-metric__value">' + money(s.commissionEarned) + '</div><div class="rqd-metric__label">Commission Earned</div></div>' +
          '<div class="rqd-metric"><div class="rqd-metric__value">' + money(s.commissionPaid) + '</div><div class="rqd-metric__label">Commission Paid</div></div>' +
          '<div class="rqd-metric"><div class="rqd-metric__value">' + money(s.commissionUnpaid) + '</div><div class="rqd-metric__label">Commission Unpaid</div></div>' +
        '</div></div>';

      // Monthly revenue chart
      var months = r.monthly || [];
      var maxVal = Math.max.apply(null, months.map(function(m) { return Math.max(m.quoted, m.sold); })) || 1;
      html += '<div class="rqd-reports__card rqd-reports__card--full">' +
        '<div class="rqd-reports__card-title">Monthly Revenue (12 Months)</div>' +
        '<div class="rqd-vchart">';
      months.forEach(function(m) {
        var qPct = Math.max((m.quoted / maxVal) * 100, 2);
        var sPct = Math.max((m.sold / maxVal) * 100, m.sold > 0 ? 2 : 0);
        var label = m.month.split('-')[1] + '/' + m.month.split('-')[0].slice(2);
        html += '<div class="rqd-vchart__col">' +
          '<div class="rqd-vchart__val">' + (m.sold > 0 ? '$' + Math.round(m.sold / 1000) + 'k' : '') + '</div>' +
          '<div class="rqd-vchart__bar-group">' +
            '<div class="rqd-vchart__bar rqd-vchart__bar--quoted" style="height:' + qPct + '%;width:45%;"></div>' +
            '<div class="rqd-vchart__bar rqd-vchart__bar--sold" style="height:' + sPct + '%;width:45%;"></div>' +
          '</div>' +
          '<div class="rqd-vchart__label">' + label + '</div>' +
        '</div>';
      });
      html += '</div>' +
        '<div style="display:flex;gap:16px;margin-top:10px;font-size:11px;color:var(--rq-text-muted);">' +
          '<span><span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:var(--rq-blue);opacity:0.4;margin-right:4px;vertical-align:middle;"></span>Quoted</span>' +
          '<span><span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:#16a34a;margin-right:4px;vertical-align:middle;"></span>Sold</span>' +
        '</div></div>';

      // Deal Type breakdown (grouped by the commission axis: inbound/outbound/shared)
      var sources = r.leadSources || [];
      var maxSrcVal = Math.max.apply(null, sources.map(function(s) { return s.value; })) || 1;
      html += '<div class="rqd-reports__card">' +
        '<div class="rqd-reports__card-title">Deal Type Breakdown</div>' +
        '<div class="rqd-bar-chart">';
      var srcColors = { outbound: '--blue', inbound: '--green', shared: '--purple', unset: '--amber' };
      sources.forEach(function(src) {
        var pct = Math.max((src.value / maxSrcVal) * 100, 3);
        var colorClass = 'rqd-bar__fill' + (srcColors[src.source] || '--blue');
        html += '<div class="rqd-bar">' +
          '<div class="rqd-bar__label">' + capitalize(src.source) + '</div>' +
          '<div class="rqd-bar__track"><div class="' + colorClass + '" style="width:' + pct + '%;">' + src.count + '</div></div>' +
          '<div class="rqd-bar__value">' + money(src.soldValue) + '</div>' +
        '</div>';
      });
      html += '</div></div>';

      // Rep leaderboard
      var reps = r.repLeaderboard || [];
      html += '<div class="rqd-reports__card">' +
        '<div class="rqd-reports__card-title">Rep Leaderboard</div>' +
        '<table class="rqd-leaderboard">' +
        '<thead><tr><th>Rep</th><th>Quoted</th><th>Sold</th><th>Win %</th><th>Profit</th></tr></thead>' +
        '<tbody>';
      reps.forEach(function(rep) {
        var winRate = rep.quotedCount > 0 ? ((rep.soldCount / rep.quotedCount) * 100).toFixed(0) : '0';
        html += '<tr>' +
          '<td>' + esc(rep.rep) + '</td>' +
          '<td>' + money(rep.quoted) + ' <span style="opacity:0.5;font-size:11px;">(' + rep.quotedCount + ')</span></td>' +
          '<td>' + money(rep.sold) + ' <span style="opacity:0.5;font-size:11px;">(' + rep.soldCount + ')</span></td>' +
          '<td>' + winRate + '%</td>' +
          '<td>' + money(rep.profit) + '</td>' +
        '</tr>';
      });
      html += '</tbody></table></div>';

      html += '</div>'; // close grid
      reportsBody.innerHTML = html;
    }

    function celebrateSold() {
      var container = document.createElement('div');
      container.className = 'rqd-confetti-container';
      document.body.appendChild(container);
      var colors = ['#006BCC', '#16a34a', '#f59e0b', '#dc2626', '#8b5cf6', '#06b6d4', '#ec4899'];
      for (var i = 0; i < 60; i++) {
        var piece = document.createElement('div');
        piece.className = 'rqd-confetti';
        piece.style.left = (Math.random() * 100) + '%';
        piece.style.background = colors[Math.floor(Math.random() * colors.length)];
        piece.style.animationDelay = (Math.random() * 0.8) + 's';
        piece.style.animationDuration = (1.5 + Math.random() * 1.5) + 's';
        piece.style.width = (6 + Math.random() * 8) + 'px';
        piece.style.height = (6 + Math.random() * 8) + 'px';
        if (Math.random() > 0.5) piece.style.borderRadius = '50%';
        container.appendChild(piece);
      }
      setTimeout(function() { container.remove(); }, 3500);
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Deal Prospecting render
       functions. Live inside the same closure as the rep-side renderTable +
       renderStats + buildDetailHtml so they share esc(), tbody, statsEl,
       formatNoteDate, formatFollowUpDate, isFollowUpExpired, formatHoldCountdown,
       Auth, and friends. */

    var _prospectStageLabels = {
      cold: '🥶 COLD',
      engaged: '🤝 ENGAGED',
      qualified: '✅ QUALIFIED',
      handoff: '🎯 HANDOFF',
      won: '🏆 WON',
      lost: '💀 LOST',
    };

    // Active prospect filter — 'all' or one of the stage keys above.
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — the prospect stage filter is
       MULTI-SELECT. currentProspectStages holds the checked stages. The main toggle
       has three presets: 🔔 Follow Up (due list), 📊 All Active (the 3 active stages),
       🗂 All (every stage). The checkbox-pills toggle individual stages in/out; a
       preset button highlights only when the checked set exactly matches its set.
       Won is intentionally NOT a filter option (terminal/converted). */
    var PROSPECT_ACTIVE_STAGES = ['cold', 'engaged', 'qualified'];
    var PROSPECT_ALL_STAGES = ['cold', 'engaged', 'qualified', 'handoff', 'lost'];
    var currentProspectStages = PROSPECT_ACTIVE_STAGES.slice();
    function _prospectStagesEq(a, b) {
      if (!a || !b || a.length !== b.length) return false;
      for (var _si = 0; _si < b.length; _si++) { if (a.indexOf(b[_si]) === -1) return false; }
      return true;
    }

    // Active prospect view — 'all' = All Active (flat, stage-filterable),
    // 'playbook' = 🔔 Follow Up (due-follow-ups only). Default to All Active on
    // every load and don't persist the Follow Up view across reloads (mirrors how
    // MONEY MOVES resets each load) — the localStorage flush below enforces this.
    var currentProspectView = 'all';
    /* Phase 1.19 — Clear any stale 'playbook' localStorage value from
       pre-1.11 sessions. The toggle has only one valid value ('all')
       now, but leaving 'playbook' in storage means it'd come back if
       the playbook view is ever re-enabled. Sanity flush. */
    try { localStorage.removeItem('rqd-prospect-view'); } catch (_) {}

    function _syncProspectFilters() {
      var filtersEl = document.getElementById('rqd-filters');
      if (!filtersEl) return;
      var existingProspectBar = document.getElementById('rqd-prospect-filters');
      var newWrap = document.getElementById('rqd-new-wrap');
      // Helper: toggle visibility of the rep-side status pills + the
      // separator WITHOUT touching the .rqd-new-wrap (+ New button).
      function _setRepPillsHidden(hidden) {
        filtersEl.querySelectorAll('.rqd-pill[data-status]').forEach(function(p) {
          p.style.display = hidden ? 'none' : '';
        });
        filtersEl.querySelectorAll('.rqd-filter-sep').forEach(function(s) {
          s.style.display = hidden ? 'none' : '';
        });
      }
      if (currentSource !== 'prospecting') {
        // Restore rep pills + move + New wrap back if it was relocated.
        _setRepPillsHidden(false);
        filtersEl.style.display = '';
        if (newWrap && newWrap.parentNode !== filtersEl) {
          filtersEl.appendChild(newWrap);
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-29) — Refresh travels with "+ New".
           ⛔ IT HAS TO, OR IT VANISHES ON THE PROSPECTING TAB. When Refresh lived in the
           .rqd-controls row this function could not reach it; now that it is a pill in
           .rqd-filters, the `filtersEl.style.display = 'none'` below would take it with the
           rest of the row and leave a CFA with no way to force fresh data at all. Appended
           after newWrap in both directions so the New | Refresh order survives the trip. */
        var _refWrapBack = document.getElementById('rqd-refresh-wrap');
        if (_refWrapBack && _refWrapBack.parentNode !== filtersEl) {
          filtersEl.appendChild(_refWrapBack);
        }
        if (existingProspectBar) existingProspectBar.remove();
        return;
      }
      // On prospecting: hide the rep row entirely + relocate the + New
      // wrap into the prospect-filter bar so it sits inline with the
      // view toggle and stage pills.
      filtersEl.style.display = 'none';
      _setRepPillsHidden(true);
      // Always (re-)render the bar so the view-toggle button state is
      // current — view changes don't trigger fetchQuotes(), so bypassing
      // re-render here would leave the button stuck in its old visual state.
      if (existingProspectBar) existingProspectBar.remove();
      var bar = document.createElement('div');
      bar.id = 'rqd-prospect-filters';
      bar.className = 'rqd-filters rqd-filters--prospect';

      // View toggle. Playbook is parked for now — rendered visible but
      // disabled (Ryan 2026-05-17). Click handler short-circuits on the
      // disabled flag below so it can't activate.
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — toggle is now shown to
         CFAs as well as admins (was admin-only under Phase 1.20). The Playbook
         half is still the parked/disabled "Coming soon" button for everyone;
         All Prospects is the live view. Un-park Playbook separately when ready. */
      var _sessAdmin = window.RepPortal && window.RepPortal.Auth && window.RepPortal.Auth.getSession && window.RepPortal.Auth.getSession();
      if (_sessAdmin && (_sessAdmin.admin || _sessAdmin.role === 'cfa')) {
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — the former parked
           "Today's Playbook" button is now the live "🔔 Follow Up" filter: the
           Prospecting twin of the Offline tab's MONEY MOVES. It shows only
           prospects with a follow-up due now (flat list) and carries a live
           due-count badge; amber/bell styling mirrors MONEY MOVES. */
        var _dueCt = _dueFollowUpProspects(allQuotes).length;
        var _isFollowUpView = (currentProspectView === 'playbook');
        var _isActivePreset = (currentProspectView === 'all') && _prospectStagesEq(currentProspectStages, PROSPECT_ACTIVE_STAGES);
        var _isAllPreset = (currentProspectView === 'all') && _prospectStagesEq(currentProspectStages, PROSPECT_ALL_STAGES);
        var viewToggleHtml = '<div class="rqd-prospect-view-toggle" role="group" aria-label="Prospect view">' +
          '<button type="button" class="rqd-prospect-view-toggle__btn rqd-prospect-view-toggle__btn--followup' + (_isFollowUpView ? ' rqd-prospect-view-toggle__btn--active' : '') + '" data-prospect-view="playbook" title="Prospects with a follow-up due now">' +
            '<span class="rqd-followup-toggle__bell">🔔</span> Follow Up <span class="rqd-followup-toggle__count">' + _dueCt + '</span>' +
          '</button>' +
          '<button type="button" class="rqd-prospect-view-toggle__btn' + (_isActivePreset ? ' rqd-prospect-view-toggle__btn--active' : '') + '" data-prospect-preset="active" title="Cold, Engaged & Qualified — your active pipeline">📊 All Active</button>' +
          '<button type="button" class="rqd-prospect-view-toggle__btn' + (_isAllPreset ? ' rqd-prospect-view-toggle__btn--active' : '') + '" data-prospect-preset="all" title="Every stage — Cold, Engaged, Qualified, Handoff & Lost">🗂️ All</button>' +
        '</div>';
        bar.innerHTML += viewToggleHtml;
      }

      // Stage checkbox-pills — multi-select, ALWAYS shown (Ryan 2026-07-11: in the
      // Follow Up view they render but stay UN-lit, so the filter bar doesn't reflow).
      // Each pill toggles its stage in/out of currentProspectStages. No 'all' pill
      // (that's the 🗂 All toggle now) and no 'won' pill (terminal).
      {
        var stages = ['cold', 'engaged', 'qualified', 'handoff', 'lost'];
        var stageCounts = {};
        (allQuotes || []).forEach(function(p) {
          var s = p.prospectStage || 'cold';
          stageCounts[s] = (stageCounts[s] || 0) + 1;
        });
        // In the Follow Up view the stage set doesn't apply, so pills show un-lit.
        var _pillsLit = (currentProspectView === 'all');
        stages.forEach(function(s) {
          // Filter pills use the bare stage label (no emoji) — emojis stay
          // on the Status COLUMN pills (Ryan 2026-05-17). _prospectStageLabels
          // carries "🥶 COLD" etc.; strip the leading emoji + space for the
          // filter bar so the row reads cleanly without symbol clutter.
          var fullLabel = (_prospectStageLabels[s] || s);
          var label = fullLabel.replace(/^\S+\s+/, '');
          var count = stageCounts[s] || 0;
          var isChecked = _pillsLit && currentProspectStages.indexOf(s) !== -1;
          // Hide zero-count stages unless checked (keeps the row compact);
          // 'handoff' is always visible so a CFA can pull up already-handed-off
          // prospects (which otherwise disappear into the rep's Offline Deals).
          if (s !== 'handoff' && !isChecked && count === 0) return;
          var activeCls = isChecked ? ' rqd-pill--active' : '';
          bar.innerHTML += '<button type="button" class="rqd-pill rqd-pill--prospect-' + s + activeCls + '" data-prospect-stage="' + s + '" role="checkbox" aria-checked="' + (isChecked ? 'true' : 'false') + '">' + label + ' <span class="rqd-pill__count">' + count + '</span></button>';
        });
      }

      // Move the + New wrap into the prospect bar (pushed to the right
      // via CSS margin-left: auto) so the toggle, stage pills, and + New
      // sit on a single row.
      if (newWrap) bar.appendChild(newWrap);
      /* Refresh follows "+ New" into the prospect bar — see the restore branch above. */
      var _refWrap = document.getElementById('rqd-refresh-wrap');
      if (_refWrap) bar.appendChild(_refWrap);
      // Insert ahead of #rqd-filters in the DOM (the rep row is now
      // display:none, but kept in the DOM so toggling back to a deal
      // source can restore everything in place).
      filtersEl.parentNode.insertBefore(bar, filtersEl);

      // Stage-filter pill click: client-side filter, re-render the flat table.
      bar.addEventListener('click', function(ev) {
        // Checkbox-pill: toggle this stage in/out of the multi-select set, then
        // re-render the whole bar so the preset buttons' highlight reflects the set.
        var pill = ev.target.closest('.rqd-pill[data-prospect-stage]');
        if (pill) {
          var _st = pill.dataset.prospectStage;
          if (currentProspectView !== 'all') {
            // Clicking a dimmed stage pill from the Follow Up view switches to the
            // stage view and SELECTS that stage (never un-toggles what you can't see).
            currentProspectView = 'all';
            try { localStorage.setItem('rqd-prospect-view', 'all'); } catch (e) {}
            if (currentProspectStages.indexOf(_st) === -1) currentProspectStages.push(_st);
          } else {
            var _si2 = currentProspectStages.indexOf(_st);
            if (_si2 === -1) currentProspectStages.push(_st); else currentProspectStages.splice(_si2, 1);
          }
          _syncProspectFilters();
          _renderProspectView();
          return;
        }
        // Preset button (📊 All Active / 🗂 All): set the checked set + 'all' view.
        var presetBtn = ev.target.closest('[data-prospect-preset]');
        if (presetBtn) {
          currentProspectStages = (presetBtn.dataset.prospectPreset === 'all' ? PROSPECT_ALL_STAGES : PROSPECT_ACTIVE_STAGES).slice();
          currentProspectView = 'all';
          try { localStorage.setItem('rqd-prospect-view', 'all'); } catch (e) {}
          _syncProspectFilters();
          _renderProspectView();
          return;
        }
        // View toggle click (🔔 Follow Up): persist + swap renderer.
        var viewBtn = ev.target.closest('[data-prospect-view]');
        if (viewBtn) {
          // Playbook is parked — disabled button must not activate.
          if (viewBtn.disabled || viewBtn.classList.contains('rqd-prospect-view-toggle__btn--disabled')) return;
          var view = viewBtn.dataset.prospectView;
          if (view !== currentProspectView) {
            currentProspectView = view;
            try { localStorage.setItem('rqd-prospect-view', view); } catch (e) {}
            // Re-render the bar so the stage pills show/hide + button
            // states refresh, then render the appropriate table view.
            _syncProspectFilters();
            _renderProspectView();
          }
          return;
        }
      });
    }

    function _filterProspectsByStage(prospects) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — multi-select: show prospects
         whose stage is in the checked set (currentProspectStages). Empty set → none
         (uncheck everything = show nothing; re-check a pill or a preset to restore). */
      var set = currentProspectStages || [];
      return prospects.filter(function(p) { return set.indexOf(p.prospectStage || 'cold') !== -1; });
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — prospects with a follow-up
       due now (today or overdue), excluding won/lost. Same rule the old Playbook
       "Due Today" bucket used; now drives the 🔔 Follow Up view + its count badge.
       The 08:00Z day-anchor matches the 4am-ET universal day boundary used across
       the dashboard. */
    function _dueFollowUpProspects(prospects) {
      var now = Date.now();
      var dayAnchor = 'T08:00:00Z';
      return (prospects || []).filter(function(p) {
        if (!p || !p.followUp || !p.followUp.dueAt) return false;
        // Exclude terminal/handed-off — a handed-off prospect is the rep's deal now, so its
        // follow-up shouldn't surface in the CFA's 🔔 Follow Up view (Ryan 2026-07-11).
        if (p.prospectStage === 'won' || p.prospectStage === 'lost' || p.prospectStage === 'handoff') return false;
        var ms = Date.parse((p.followUp.dueAt || '') + dayAnchor);
        return Number.isFinite(ms) && ms <= now + 86400000; // due today or earlier
      }).sort(function(a, b) {
        return Date.parse((a.followUp.dueAt || '') + dayAnchor) - Date.parse((b.followUp.dueAt || '') + dayAnchor);
      });
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — /cfa-prospects returns the whole list
       with no server-side search or sort, so both are applied client-side here. */
    function _searchFilterProspects(list) {
      var q = (currentSearch || '').trim().toLowerCase();
      if (!q) return list;
      return list.filter(function(p) {
        var c = p.customer || {}, d = p.discovery || {};
        var hay = [p.ref, p.reference, c.organization, c.name, c.email, c.phone,
                   d.authorityName, d.authorityEmail, d.authorityPhone, c.city, c.state, c.zip]
          .filter(Boolean).join(' ').toLowerCase();
        return hay.indexOf(q) !== -1;
      });
    }
    var _PROSPECT_STAGE_RANK = { cold: 0, engaged: 1, qualified: 2, handoff: 3, won: 4, lost: 5 };
    function _sortProspects(list) {
      var parts = String(currentSort || 'date_desc').split('_');
      var key = parts[0], dir = parts[1] === 'asc' ? 1 : -1;
      function keyVal(p) {
        var c = p.customer || {}, d = p.discovery || {};
        switch (key) {
          case 'ref':      return String(p.ref || p.reference || '').toLowerCase();
          case 'org':      return String(c.organization || '').toLowerCase();
          case 'customer': return String(d.authorityName || c.name || '').toLowerCase();
          case 'location': return (String(c.city || '') + ' ' + String(c.state || '')).toLowerCase();
          case 'status':   { var r = _PROSPECT_STAGE_RANK[p.prospectStage || 'cold']; return (r == null ? 9 : r); }
          case 'todo':     return Date.parse(((p.followUp && p.followUp.dueAt) || '') + 'T08:00:00Z') || Infinity;
          case 'amount':   return 0;
          default:         return Date.parse(p.createdAt || '') || 0; // 'date'
        }
      }
      // Decorate-sort-undecorate for a stable sort (equal keys keep fetch order).
      return list.map(function(p, i) { return { p: p, i: i, v: keyVal(p) }; })
        .sort(function(a, b) { return (a.v < b.v ? -1 : a.v > b.v ? 1 : 0) * dir || (a.i - b.i); })
        .map(function(x) { return x.p; });
    }
    function _prospectEmptyMessage(isFollowUp) {
      if ((currentSearch || '').trim()) return 'No prospects match “' + currentSearch.trim() + '”.';
      if (isFollowUp) return '🎉 No follow-ups due right now.';
      if (!(allQuotes || []).length) return 'No prospects yet — use + New to add a cold lead.';
      if (!(currentProspectStages || []).length) return 'No stages selected — pick a stage pill or a preset (All Active / All).';
      return 'No prospects in the selected stage' + (currentProspectStages.length > 1 ? 's' : '') + '.';
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — single render path for the prospect
       table, shared by the initial load, the view toggle, stage-pill/preset clicks, SEARCH,
       and SORT. All Active = stage-filtered active list; Follow Up = due follow-ups only;
       then client-side search + sort. Owns table/empty-state visibility AND the pagination
       footer so every client-side re-render keeps the count current. Returns the visible set. */
    function _renderProspectView() {
      var isFollowUp = (currentProspectView === 'playbook');
      var visible = isFollowUp ? _dueFollowUpProspects(allQuotes) : _filterProspectsByStage(allQuotes);
      visible = _sortProspects(_searchFilterProspects(visible));
      renderProspectTable(visible);
      // Empty state now keys off the VISIBLE count (search / an empty stage-set can zero it
      // even when prospects exist), with a context-aware message.
      var empty = visible.length === 0;
      if (tableWrap) tableWrap.style.display = empty ? 'none' : '';
      if (emptyEl) {
        emptyEl.style.display = empty ? 'block' : 'none';
        if (empty) emptyEl.textContent = _prospectEmptyMessage(isFollowUp);
      }
      // Footer count — driven here (was fetch-only, so it went stale on pill/preset/Follow-Up
      // toggles + search/sort).
      if (typeof pageInfo !== 'undefined' && pageInfo) {
        pageInfo.textContent = empty ? _prospectEmptyMessage(isFollowUp) : ('Showing 1-' + visible.length + ' of ' + visible.length);
      }
      return visible;
    }
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — expose the filter-bar refresh so
       dashboard-deal-feed.js can update the 🔔 Follow Up count badge after a prospect
       follow-up is armed via the composer (bug 6). */
    window.RQD = window.RQD || {};
    window.RQD.syncProspectFilters = _syncProspectFilters;

    /* Phase 1.12 — Prospect stats now dynamic to the date-range pill
       selection. Worker still computes activeWindows server-side (rolling
       18-mo attribution count — doesn't follow the dashboard's date
       filter per Ryan's explicit exception); everything else is computed
       client-side from allQuotes so changing the date pill (which triggers
       fetchQuotes → this render) updates labels + values immediately. */

    // Stash the most-recent worker payload so activeWindows survives
    // recomputes that ignore the worker numbers.
    var _lastWorkerProspectStats = null;

    function _parseYmdToMs(ymd, endOfDay) {
      if (!ymd) return null;
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(ymd).trim());
      if (!m) return null;
      var d = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
      if (endOfDay) d.setHours(23, 59, 59, 999);
      else d.setHours(0, 0, 0, 0);
      return d.getTime();
    }

    /** Human label for the active date-range preset (or "Custom" for
        bespoke date pickers). Used as both the headline label under each
        stat AND the lowercase sub-text on rate/handoffs/closed stats. */
    function _prospectStatsRangeLabel() {
      switch (currentPreset) {
        case 'today': return 'Today';
        case 'week': return 'This Week';
        case 'month': return 'This Month';
        case 'quarter': return 'This Quarter';
        case 'year': return 'This Year';
        case 'lastweek': return 'Last Week';
        case 'lastmonth': return 'Last Month';
        case 'lastquarter': return 'Last Quarter';
        case 'lastyear': return 'Last Year';
        case 'last30': return 'Last 30 days';
        case 'last90': return 'Last 90 days';
        case 'last180': return 'Last 180 days';
        case 'custom': return 'Custom Range';
        default: return 'This Year';
      }
    }

    /** Client-side per-range stats computation. Mirrors the worker's
        computeProspectStats (`src/handlers/cfa-prospect-routes.js`) but
        evaluates against an arbitrary [fromMs, toMs] window instead of
        the hardcoded week/month/year boundaries. */
    function _computeProspectStatsClient(prospects, fromMs, toMs) {
      var callsCount = 0;
      var pipelineCount = 0;
      var qNum = 0, qDen = 0;
      var handoffsCount = 0;
      var wonCount = 0;
      function inRange(ms) {
        if (!Number.isFinite(ms)) return false;
        if (fromMs != null && ms < fromMs) return false;
        if (toMs   != null && ms > toMs)   return false;
        return true;
      }
      for (var i = 0; i < (prospects || []).length; i++) {
        var p = prospects[i];
        if (!p) continue;
        var created = Date.parse(p.createdAt || '');
        /* Touches within range — calls AND emails.
           CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15): this counted only
           'call'-tagged entries. For an email-first CFA that reported ~0 all
           year while they worked the list hard, so the KPI measured the wrong
           half of the job. Meetings and drop-ins stay out — the stat is about
           outreach volume, not every interaction.

           Email entries come from the Outlook sync (type 'email'), so they land
           here automatically; a call is only ever a hand-logged note. That
           asymmetry is fine — both are a touch — but it does mean the number
           jumped the moment this shipped, without anyone doing more work. */
        var entries = p.noteEntries || [];
        for (var j = 0; j < entries.length; j++) {
          var e = entries[j];
          if (!e) continue;
          var ets = Date.parse(e.ts || '');
          if (!inRange(ets)) continue;
          var _tags = Array.isArray(e.types) ? e.types : [];
          var isCall  = e.type === 'call'  || _tags.indexOf('call') !== -1;
          var isEmail = e.type === 'email' || _tags.indexOf('email') !== -1;
          // A combined entry tagged both is one touch, not two.
          if (isCall || isEmail) callsCount++;
        }
        // Pipeline = QUALIFIED right now (no date filter — point-in-time).
        if (p.prospectStage === 'qualified') pipelineCount++;
        // Qualified rate: of prospects CREATED in range, what fraction
        // reached qualified/handoff/won.
        if (inRange(created)) {
          qDen++;
          if (['qualified', 'handoff', 'won'].indexOf(p.prospectStage) !== -1) qNum++;
        }
        // Handoffs counted by handoffAt within range.
        if (p.prospectStage === 'handoff') {
          var hts = Date.parse(p.handoffAt || '');
          if (inRange(hts)) handoffsCount++;
        }
        // Won counted by created within range (matches worker — most recent
        // close timestamp isn't currently persisted on the lead record).
        if (p.prospectStage === 'won' && inRange(created)) wonCount++;
      }
      return {
        calls: callsCount,
        pipelineCount: pipelineCount,
        qualifiedRate: qDen > 0 ? Math.round((qNum / qDen) * 100) / 100 : 0,
        handoffs: handoffsCount,
        won: wonCount,
      };
    }

    function renderProspectStats(stats) {
      if (!statsEl) return;
      if (stats) _lastWorkerProspectStats = stats;
      var fromMs = _parseYmdToMs(currentDateFrom, false);
      var toMs   = _parseYmdToMs(currentDateTo, true);
      var s = _computeProspectStatsClient(allQuotes || [], fromMs, toMs);
      var label = _prospectStatsRangeLabel();
      var labelSub = label.toLowerCase();
      var pct = Math.round((s.qualifiedRate || 0) * 100);
      // 18-mo Windows — rolling, never follows the date pill (Ryan's
      // explicit exception). Use the worker's computed value (or 0 until
      // Phase 2 wires the cfa-attribution:{email} walk).
      var activeWindows = (_lastWorkerProspectStats && _lastWorkerProspectStats.activeWindows) || 0;
      statsEl.innerHTML =
        '<div class="rqd-stat rqd-stat--prospect-activity" title="Calls logged + emails sent and received"><p class="rqd-stat__value">' + s.calls + '</p><p class="rqd-stat__sub">calls + emails</p><p class="rqd-stat__label">' + esc(label) + '</p></div>' +
        '<div class="rqd-stat rqd-stat--prospect-pipeline rqd-stat--clickable" data-prospect-stat-filter="qualified" role="button" tabindex="0" title="Filter to Qualified prospects"><p class="rqd-stat__value">' + s.pipelineCount + '</p><p class="rqd-stat__sub">qualified</p><p class="rqd-stat__label">Pipeline</p></div>' +
        '<div class="rqd-stat rqd-stat--prospect-rate"><p class="rqd-stat__value">' + pct + '%</p><p class="rqd-stat__sub">' + esc(labelSub) + '</p><p class="rqd-stat__label">Qualified Rate</p></div>' +
        '<div class="rqd-stat rqd-stat--prospect-handoff rqd-stat--clickable" data-prospect-stat-filter="handoff" role="button" tabindex="0" title="Filter to Handed-off prospects"><p class="rqd-stat__value">' + s.handoffs + '</p><p class="rqd-stat__sub">' + esc(labelSub) + '</p><p class="rqd-stat__label">Handoffs</p></div>' +
        '<div class="rqd-stat rqd-stat--prospect-won rqd-stat--clickable" data-prospect-stat-filter="won" role="button" tabindex="0" title="Filter to Closed (won) prospects — the only place they show"><p class="rqd-stat__value">' + s.won + '</p><p class="rqd-stat__sub">' + esc(labelSub) + '</p><p class="rqd-stat__label">Closed</p></div>' +
        '<div class="rqd-stat rqd-stat--prospect-windows"><p class="rqd-stat__value">' + activeWindows + '</p><p class="rqd-stat__sub">accounts active</p><p class="rqd-stat__label">18-mo Windows</p></div>';
    }

    function _prospectLastTouch(p) {
      var entries = Array.isArray(p.noteEntries) ? p.noteEntries : [];
      if (entries.length === 0) return p.createdAt || '';
      var newest = entries[0].ts || '';
      for (var i = 1; i < entries.length; i++) {
        if ((entries[i].ts || '') > newest) newest = entries[i].ts;
      }
      return newest;
    }

    function _prospectFollowupBadge(p) {
      // Phase 1.27 — Closed prospects (lost / won) never show a
      // follow-up countdown, even if the persisted lead.followUp
      // still has a stale dueAt from before the deal was closed.
      // Belt-and-braces with the worker's null-on-archive: covers
      // records archived before the worker fix shipped + any future
      // path that flips to a closed stage without clearing followUp.
      if (p && (p.prospectStage === 'lost' || p.prospectStage === 'won')) return '';
      if (!p.followUp || !p.followUp.dueAt) return '';
      var due = p.followUp.dueAt;
      var expired = isFollowUpExpired(due);
      var dateLabel = formatFollowUpDate(due);
      var title = (expired ? 'Follow-up due: ' : 'Follow up: ') + esc(dateLabel) + ' (' + esc(due) + ')'
        + (p.followUp.setBy ? ' · set by ' + esc(p.followUp.setBy) : '')
        + (p.followUp.reason ? ' — ' + esc(p.followUp.reason) : '');
      var cls = 'rqd-remaining rqd-remaining--followup rqd-followup-countdown rqd-tip-trigger'
        + (expired ? ' rqd-followup-countdown--expired' : '');
      var inner = expired
        ? '<span class="rqd-followup-bell" aria-label="Follow-up due">🔔</span>'
        : '<span class="rqd-followup-countdown__text">' + esc(formatHoldCountdown(due)) + '</span>';
      return '<span class="' + cls + '" data-followup-until="' + esc(due) + '" data-ref="' + esc(p.ref) + '" data-tip="' + title + '" data-tip-variant="sold" role="button" tabindex="0">' + inner + '</span>';
    }

    /** Build the data-row + detail-row pair for one prospect. Returns a
        DocumentFragment that callers can append. Shared between
        renderProspectTable (flat list) and renderProspectPlaybook
        (sectioned daily-flow view). */
    /** Count how many of the 4 Authority sub-fields (name, title, email,
        phone) have content. Drives the To-Do A chip's 4-step partial fill
        (0/1/2/3/4) and the qualified gate via `_isProspectQualified`. */
    function _authorityFilledCount(d) {
      d = d || {};
      var n = 0;
      if ((d.authorityName  || '').trim()) n++;
      if ((d.authorityTitle || '').trim()) n++;
      if ((d.authorityEmail || '').trim()) n++;
      if ((d.authorityPhone || '').trim()) n++;
      return n;
    }

    /** Phase 1.23 — Does THIS enrichment contact still match the
        currently-saved Authority on Discovery? Used to decide whether the
        row shows the ★ Authority badge or the Make Authority button.
        Stricter than just an email match: ALL four sub-fields
        (name/title/email/phone) must equal the contact's data — the
        moment the CFA clears or edits any one of them, the contact is
        no longer the pristine Authority and the badge drops. */
    function _enrichmentMatchesAuthority(ct, d) {
      if (!ct || !d) return false;
      var norm = function(s) { return (s || '').toString().trim().toLowerCase(); };
      var normPhone = function(s) { return (s || '').toString().replace(/\D/g, ''); };
      // No Authority captured at all → nothing matches.
      if (_authorityFilledCount(d) === 0) return false;
      return norm(ct.name)  === norm(d.authorityName)
          && norm(ct.title) === norm(d.authorityTitle)
          && norm(ct.email) === norm(d.authorityEmail)
          && normPhone(ct.phone) === normPhone(d.authorityPhone);
    }

    /** Canonical qualified-gate calc (Phase 1.8). Requires all 7 BANT
        fields independently — Budget + Need + Timeline + all 4 Authority
        sub-fields. Mirrors the worker's deriveProspectStage gate. */
    function _isProspectQualified(d) {
      d = d || {};
      return _authorityFilledCount(d) === 4
        && (d.need     || '').trim().length > 0
        && (d.budget   || '').trim().length > 0
        && (d.timeline || '').trim().length > 0;
    }

    /** Build the BANT chip strip for the To-Do column. Extracted so the
        Save Discovery handler can refresh just this fragment on the
        parent row without re-rendering the whole tr. B/N/T are binary;
        A uses 5-step fill (--a-0 through --a-4) based on how many of the
        4 Authority sub-fields are populated. */
    function _buildBantSpan(d, stage) {
      d = d || {};
      var aCount = _authorityFilledCount(d);
      // Phase 1.27 — When the prospect is LOST, any chip that wasn't
      // fully filled at archive time paints red (a visual record of
      // what was missed). Fully-filled chips stay green. Partial A
      // (1-3/4) also paints red since it wasn't a complete capture.
      var isLost = stage === 'lost';
      var bFilled = !!(d.budget   || '').trim();
      var nFilled = !!(d.need     || '').trim();
      var tFilled = !!(d.timeline || '').trim();
      var aFilled = aCount === 4;
      var missedCls = ' rqd-bant__c--missed';
      var bCls = bFilled ? 'rqd-bant__c--on' : (isLost ? missedCls.trim() : '');
      var nCls = nFilled ? 'rqd-bant__c--on' : (isLost ? missedCls.trim() : '');
      var tCls = tFilled ? 'rqd-bant__c--on' : (isLost ? missedCls.trim() : '');
      var aCls = aFilled
        ? 'rqd-bant__c--a-' + aCount
        : (isLost ? 'rqd-bant__c--missed' : 'rqd-bant__c--a-' + aCount);
      return '<span class="rqd-bant" title="Budget · Authority · Need · Timeline">'
        + '<span class="rqd-bant__c ' + bCls + '" title="Budget">B</span>'
        + '<span class="rqd-bant__c ' + aCls + '" title="Authority (' + aCount + '/4)">A</span>'
        + '<span class="rqd-bant__c ' + nCls + '" title="Need">N</span>'
        + '<span class="rqd-bant__c ' + tCls + '" title="Timeline">T</span>'
        + '</span>';
    }


    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — Emails (Sent / Received)
       column + the ✉️ envelope on the Prospecting tab.

       Both read the same data the rep-side tabs already use: noteEntries of
       type 'email', with emailMeta.direction set 'outbound'/'inbound' by the
       Outlook sync cron. /cfa-prospects already ships noteEntries and
       prospectRepliedAt, so this is presentation only — no worker change. */


    /** Sent / Received cell for the PRIMARY contact. Three states:
        - nothing sent yet → "- / -" muted (every freshly imported prospect)
        - sent, no reply   → "3 / 0" normal
        - they replied     → bold green; the counter has done its job */
    function _prospectEmailsCell(p) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — scoped to the PRIMARY
         contact. It used to count every email on the prospect, so traffic with a
         strength coach inflated the AD's column and "1 / 1" could mean two
         different people. _emailCountsFor falls back to counting everything when
         no primary email is recorded, so a prospect with only a phone number
         still shows its traffic instead of a misleading "- / -". */
      var c = _emailCountsFor(p, _prospectPrimaryEmail(p));
      // prospectRepliedAt is the worker's authoritative reply stamp (Outlook
      // sync sets it alongside the inbound note). Belt-and-braces: if the two
      // ever disagree, a reply we know about still shows as a reply.
      var replied = c.recv > 0 || !!(p && p.prospectRepliedAt);
      var cls, txt, tip;
      if (!c.sent && !c.recv) {
        cls = 'none'; txt = '- / -';
        tip = 'No emails yet';
      } else if (replied) {
        cls = 'replied';
        /* When the reply stamp exists but no inbound note does, print a ✓ rather
           than a 0 — "3 / 0" in reply-green reads as a bug. Rare (the Outlook
           sync writes the note and the stamp together) but not impossible. */
        txt = c.sent + ' / ' + (c.recv || '✓');
        tip = c.recv
          ? ('Replied — ' + c.sent + ' sent, ' + c.recv + ' received')
          : ('Replied — recorded on the prospect, but the reply is not in the activity log');
      } else {
        cls = 'sent';
        txt = c.sent + ' / 0';
        tip = c.sent + ' sent, no reply yet';
      }
      return '<span class="rqd-emails-count rqd-emails-count--' + cls + '" title="' + esc(tip) + '">' + esc(txt) + '</span>';
    }

    /** ✉️ for the Prospecting To Do cell. Mirrors the rep-side envelope in
        buildProgressCell: shows on UNREAD inbound mail, carries a count circle
        past 1, uses the shared tooltip system, and sits beside the countdown /
        bell exactly as it does on Offline Deals.

        Variant maps prospect stage onto the existing badge colours rather than
        inventing new ones — active prospects read as 'lead' (yellow, same as a
        rep-side NEW LEAD), won as 'sold', lost as 'lost'. */
    function _prospectEnvelopeHtml(p) {
      var nes = (p && Array.isArray(p.noteEntries)) ? p.noteEntries : [];
      var unread = 0;
      for (var i = 0; i < nes.length; i++) {
        var ne = nes[i];
        if (ne && ne.type === 'email' && ne.emailMeta
            && ne.emailMeta.direction === 'inbound'
            && ne.emailMeta.isRead === false) unread++;
      }
      if (!unread) return '';
      var stage = (p && p.prospectStage) || 'cold';
      var variant = stage === 'won' ? 'sold' : (stage === 'lost' ? 'lost' : 'lead');
      var tipVariant = stage === 'won' ? 'sold' : (stage === 'lost' ? 'lost' : 'awaiting');
      var tip = unread + ' unread email' + (unread === 1 ? '' : 's') + ' — click the row to read';
      return '<span class="rqd-todo-envelope rqd-todo-envelope--' + variant + ' rqd-tip-trigger" data-ref="' + esc(p.ref) + '" data-tip="' + esc(tip) + '" data-tip-variant="' + tipVariant + '" aria-label="Unread email" role="button" tabindex="0">✉️'
        + (unread > 1 ? '<span class="rqd-todo-envelope__count">' + unread + '</span>' : '')
        + '</span>';
    }


    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — Contacts on a prospect.
       Was the "🔍 Enrichment" card: import-only, collapsed by default, and
       invisible unless a Lead Generator / AD-database import had populated it.
       A manually-created prospect had no way to record a second person at all.

       Storage is unchanged — still enrichment.contacts[] on the lead, still
       {name,title,email,phone,type}. Only the label, the entry points, and
       add/edit/remove are new, so imported prospects keep their contacts and no
       migration is needed.

       PRIMARY == the Authority contact. There is deliberately no separate
       "primary" flag: a second source of truth is how customer.* and
       discovery.authority* drifted apart in the first place. The primary is
       whichever contact matches Authority, and promoting writes both layers. */

    function _prospectContacts(p) {
      return (p && p.enrichment && Array.isArray(p.enrichment.contacts)) ? p.enrichment.contacts : [];
    }

    /** The primary's email — what the Prospecting row's Emails column counts.
        Authority first, same precedence the card and pencil use. */
    function _prospectPrimaryEmail(p) {
      var d = (p && p.discovery) || {};
      var c = (p && p.customer) || {};
      return ((d.authorityEmail || '').trim() || (c.email || '').trim()).toLowerCase();
    }

    /** Count emails involving ONE address. Outbound = we sent it to them (their
        address in to[] or cc[]); inbound = it came from them.

        Falls back to counting everything when no address is supplied — a
        prospect with no primary email recorded should still show its traffic
        rather than a misleading "- / -". */
    function _emailCountsFor(p, addr) {
      var nes = (p && Array.isArray(p.noteEntries)) ? p.noteEntries : [];
      var want = String(addr || '').trim().toLowerCase();
      var sent = 0, recv = 0;
      for (var i = 0; i < nes.length; i++) {
        var ne = nes[i];
        if (!ne || ne.type !== 'email' || !ne.emailMeta) continue;
        var m = ne.emailMeta;
        if (!want) {
          if (m.direction === 'outbound') sent++;
          else if (m.direction === 'inbound') recv++;
          continue;
        }
        var lc = function(x) { return String(x || '').trim().toLowerCase(); };
        if (m.direction === 'outbound') {
          var to = (Array.isArray(m.to) ? m.to : []).map(lc);
          var cc = (Array.isArray(m.cc) ? m.cc : []).map(lc);
          if (to.indexOf(want) !== -1 || cc.indexOf(want) !== -1) sent++;
        } else if (m.direction === 'inbound') {
          if (lc(m.from) === want) recv++;
        }
      }
      return { sent: sent, recv: recv };
    }

    /** Compact "3 / 1" chip for a single contact row on the Contacts card. */
    function _contactEmailChip(p, ct) {
      var addr = ((ct && ct.email) || '').trim();
      if (!addr) return '';
      var c = _emailCountsFor(p, addr);
      if (!c.sent && !c.recv) return '<span class="rqd-contact-chip rqd-contact-chip--none" title="No emails with this contact">– / –</span>';
      var cls = c.recv ? 'replied' : 'sent';
      return '<span class="rqd-contact-chip rqd-contact-chip--' + cls + '" title="' + esc(c.sent + ' sent, ' + c.recv + ' received with ' + addr) + '">' + c.sent + ' / ' + c.recv + '</span>';
    }

    /** The Contacts card. Renders even with zero contacts so there is always a
        way in — the old card vanished entirely when empty, which is exactly
        when you most need the Add button. */
    function _prospectContactsCardHtml(p, d, isClosed) {
      var list = _prospectContacts(p);
      var primaryEmail = _prospectPrimaryEmail(p);
      var showChips = list.length > 1; // per-contact counts only earn their space with >1
      var html = '';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — A Contacts card with no
         contacts opens collapsed: it's a header and an empty-state sentence, so
         expanded it just pushes the Discovery/Activity cards down the page for
         nothing. Mirrors the Deal Feed's _notesCollapsed (empty-OR-remembered)
         exactly — same --collapsed class, same collapsedSections store, same
         data-section key, so the existing click router toggles and remembers it
         with no new wiring. Once a contact exists the card opens as before.
         The chevron glyph is rendered from the same flag: the router only swaps
         it on click, so a card that STARTS collapsed would otherwise show "−"
         (the expanded affordance) while sitting collapsed. */
      var _contactsCollapsed = !list.length
        || !!(collapsedSections[p.ref] && collapsedSections[p.ref].contacts);
      html += '<div class="rqd-detail__card rqd-prospect-enrichment rqd-detail__arap--collapsible' + (_contactsCollapsed ? ' rqd-detail__arap--collapsed' : '') + '" data-section="contacts" data-ref="' + esc(p.ref) + '" style="margin-top:14px;">';
      html += '<div class="rqd-detail__section-title">👥 Contacts <span class="rqd-notes-log__count">(' + list.length + ')</span> <span class="rqd-arap__chevron">' + (_contactsCollapsed ? '+' : '−') + '</span></div>';
      html += '<div class="rqd-prospect-enrichment__list">';
      if (!list.length) {
        html += '<div class="rqd-prospect-contacts__empty">No contacts yet. The primary contact also fills the Authority fields on the Discovery card.</div>';
      }
      list.forEach(function(ct, idx) {
        var nm = (ct && ct.name) || '—';
        var ti = (ct && ct.title) || '';
        var em = (ct && ct.email) || '';
        var ph = (ct && ct.phone) || '';
        var ty = (ct && ct.type) || '';
        // Primary == matches Authority. Email is the reliable key; fall back to
        // name when a contact has no address recorded.
        var isPrimary = em
          ? (em.trim().toLowerCase() === primaryEmail && !!primaryEmail)
          : (!!nm && nm.trim().toLowerCase() === ((d.authorityName || '').trim().toLowerCase()) && !!(d.authorityName || '').trim());
        html += '<div class="rqd-prospect-enrichment__row' + (isPrimary ? ' rqd-prospect-enrichment__row--primary' : '') + '" data-idx="' + idx + '">';
        html +=   '<div class="rqd-prospect-enrichment__col-main">';
        html +=     '<div class="rqd-prospect-enrichment__name">' + esc(nm)
                    + (ti ? ' <span class="rqd-prospect-enrichment__title">· ' + esc(ti) + '</span>' : '')
                    + (ty ? ' <span class="rqd-prospect-enrichment__type">' + esc(ty.replace(/_/g, ' ')) + '</span>' : '') + '</div>';
        html +=     '<div class="rqd-prospect-enrichment__sub">';
        if (em) html += '<a href="mailto:' + esc(em) + '">' + esc(em) + '</a>';
        if (ph) html += (em ? ' <span class="rqd-prospect-enrichment__sep">·</span> ' : '') + '<a href="tel:' + esc(ph) + '">' + esc(typeof fmtPhone === 'function' ? fmtPhone(ph) : ph) + '</a>';
        if (showChips) html += ' ' + _contactEmailChip(p, ct);
        html +=     '</div>';
        html +=   '</div>';
        html +=   '<div class="rqd-prospect-enrichment__actions">';
        if (isPrimary) {
          html += '<span class="rqd-prospect-enrichment__current" title="Primary — mirrored into the Prospect card and the Discovery card&#39;s Authority fields">★ Primary</span>';
        } else if (!isClosed) {
          html += '<button type="button" class="rqd-prospect-enrichment__make-auth" data-ref="' + esc(p.ref) + '" data-idx="' + idx + '" title="Make this the primary contact — updates the Prospect card and the Authority fields">Make Primary</button>';
        }
        if (!isClosed) {
          html += '<button type="button" class="rqd-contact-btn rqd-contact-btn--edit" data-action="contact-edit" data-ref="' + esc(p.ref) + '" data-idx="' + idx + '" title="Edit contact" aria-label="Edit contact">&#9998;</button>';
          html += '<button type="button" class="rqd-contact-btn rqd-contact-btn--del" data-action="contact-remove" data-ref="' + esc(p.ref) + '" data-idx="' + idx + '" title="Remove contact" aria-label="Remove contact">&#10005;</button>';
        }
        html +=   '</div>';
        html += '</div>';
      });
      html += '</div>';
      if (!isClosed) {
        html += '<div class="rqd-prospect-contacts__foot">' +
                  '<button type="button" class="rqd-prospect-contacts__add" data-action="contact-add" data-ref="' + esc(p.ref) + '">+ Add contact</button>' +
                '</div>';
      }
      html += '</div>';
      return html;
    }

    /** Add / edit one contact. idx === null adds. Saving replaces the whole
        contacts array via /cfa-prospect-update (the endpoint already accepts a
        whole-object enrichment patch), and re-promotes if this row is the
        primary, so an edit to the primary's email doesn't silently orphan
        Authority. */
    window.__openEditContact = function(p, idx) {
      if (!p || !p.ref) return;
      var list = _prospectContacts(p).slice();
      var isNew = (idx === null || idx === undefined);
      var ct = isNew ? { name: '', title: '', email: '', phone: '', type: '' } : (list[idx] || null);
      if (!ct) return;

      var existing = document.getElementById('rqd-contact-modal');
      if (existing) existing.remove();
      var backdrop = document.createElement('div');
      backdrop.id = 'rqd-contact-modal';
      backdrop.className = 'rqd-modal-backdrop rqd-modal-backdrop--open';
      backdrop.innerHTML =
        '<div class="rqd-modal">' +
          '<h2 class="rqd-modal__title">' + (isNew ? 'Add Contact' : 'Edit Contact') + '</h2>' +
          '<p class="rqd-modal__sub">Another person at this organization. Use ★ Make Primary on the card to promote one — the primary drives the Prospect card and the Authority fields.</p>' +
          '<div class="rqd-modal__body">' +
            '<label class="rqd-modal__label" style="margin-top:0;">Name</label><input type="text" id="rqd-ct-name" class="rqd-modal__input" maxlength="200" value="' + esc(ct.name || '') + '">' +
            '<label class="rqd-modal__label">Title</label><input type="text" id="rqd-ct-title" class="rqd-modal__input" maxlength="200" value="' + esc(ct.title || '') + '" placeholder="Athletic Director">' +
            '<label class="rqd-modal__label">Email</label><input type="email" id="rqd-ct-email" class="rqd-modal__input" maxlength="200" value="' + esc(ct.email || '') + '">' +
            '<label class="rqd-modal__label">Phone</label><input type="tel" id="rqd-ct-phone" class="rqd-modal__input" maxlength="30" value="' + esc(ct.phone || '') + '">' +
            '<div id="rqd-ct-err" style="display:none;color:#dc2626;font-size:12px;margin-top:8px;"></div>' +
          '</div>' +
          '<div class="rqd-modal__actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:14px;">' +
            '<button type="button" id="rqd-ct-cancel" class="rqd-modal__btn">Cancel</button>' +
            '<button type="button" id="rqd-ct-save" class="rqd-modal__btn rqd-modal__btn--primary">' + (isNew ? 'Add' : 'Save') + '</button>' +
          '</div>' +
        '</div>';
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);
      var q = function(id) { return backdrop.querySelector('#' + id); };
      q('rqd-ct-cancel').addEventListener('click', function() { backdrop.remove(); });
      q('rqd-ct-name').focus();

      q('rqd-ct-save').addEventListener('click', async function() {
        var err = q('rqd-ct-err');
        err.style.display = 'none';
        var next = {
          name:  (q('rqd-ct-name').value  || '').trim(),
          title: (q('rqd-ct-title').value || '').trim(),
          email: (q('rqd-ct-email').value || '').trim(),
          phone: (q('rqd-ct-phone').value || '').trim(),
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — no Role picker; the
             hand-typed Title says it better than a fixed enum. `type` is still
             carried through untouched so an imported contact keeps the
             machine-set tag ('athletic_director' / 'strength_coach') the
             importer wrote — editing an AD's phone shouldn't strip it. Hand-added
             contacts simply have none. */
          type:  (ct && ct.type) || ''
        };
        if (!next.name && !next.email && !next.phone) {
          err.style.display = ''; err.textContent = 'Give the contact at least a name, an email, or a phone number.';
          return;
        }
        var wasPrimary = !isNew && ct.email && _prospectPrimaryEmail(p) === String(ct.email).trim().toLowerCase();
        if (isNew) list.push(next); else list[idx] = next;

        var btn = q('rqd-ct-save');
        var prev = btn.textContent;
        btn.disabled = true; btn.textContent = 'Saving…'; markPending(btn);
        try {
          var payload = {
            ref: p.ref,
            enrichment: {
              contacts: list,
              totalContactsFound: list.length,
              enrichAttempted: !!(p.enrichment && p.enrichment.enrichAttempted)
            }
          };
          /* Editing the primary must move Authority + customer with it, or the
             card keeps showing the old address and handoff reads a contact that
             no longer exists. */
          if (wasPrimary) {
            payload.discovery = { authorityName: next.name, authorityTitle: next.title, authorityEmail: next.email, authorityPhone: next.phone };
            payload.customer  = { name: next.name, email: next.email, phone: next.phone };
          }
          await API.post('/cfa-prospect-update', payload);
          backdrop.remove();
          try { await fetchQuotes(); } catch (_) {}
        } catch (e2) {
          btn.disabled = false; btn.textContent = prev;
          err.style.display = ''; err.textContent = 'Save failed: ' + (e2 && e2.message ? e2.message : 'unknown');
        }
      });
    };

    function _buildProspectRowPair(p) {
      var c = p.customer || {};
      var stage = p.prospectStage || 'cold';
      var stageLabel = _prospectStageLabels[stage] || stage.toUpperCase();
      var d = p.discovery || {};
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11, Feature B) — row quick-actions cog. */
      var _rowIsClosed = (stage === 'won' || stage === 'lost' || stage === 'handoff');
      var _rowCanHandoff = _isProspectQualified(d);
      // Column order matches the global thead so prospect cells line up
      // with the rest of the dashboard. REF + Amount cols are hidden via
      // CSS on the prospecting tab (REF only meaningful at handoff;
      // Budget rides in the To-Do BANT grid until handoff promotes it to
      // lead.amount on Offline Deals). Org and Name are two separate
      // columns now (matches the rep-side layout exactly).
      var locText = [c.city, c.state].filter(Boolean).join(', ');
      var createdDisplay = p.createdAt ? formatDate(p.createdAt) : '—';
      // Source marker emoji — Lead Finder 💰, Lead Generator 🔍, manual ✏️.
      // Always present so the Org column carries an at-a-glance origin tag.
      var srcMark = p.prospectSource === 'lead-finder' ? '💰'
        : p.prospectSource === 'lead-generator' ? '🔍'
        : '✏️';
      var srcEmoji = '<span class="rqd-prospect-source" title="Source: ' + esc(p.prospectSource || 'manual') + '">' + srcMark + '</span> ';
      // De-facto contact override — when the CFA has captured an Authority
      // contact via Discovery, that person becomes the primary name on the
      // row + detail panel (overrides the customer.name imported with the
      // record). Falls back to customer.name otherwise.
      var contactName = (d.authorityName || '').trim() || (c.name || '').trim();
      // Residential prospects (home-gym / individual buyers, no org) render
      // as "🏠 Residence" in the Org column. isResidentialOrg() matches
      // "n/a - residence" + variants — same convention as rep-side rows.
      var _isResi = (typeof isResidentialOrg === 'function' && isResidentialOrg(c.organization));
      var orgInner = _isResi
        ? '🏠 Residence'
        : esc(c.organization || '—');
      // Phase 1.30 — hanging-indent wrapper. When the org name wraps to
       // a second line, the wrapped text lines up under the first character
       // of the org name (not under the emoji), reading much cleaner.
       // padding-left + text-indent: negative is the classic CSS hang.
      var orgHtml = '<span class="rqd-prospect-org-hang">' + srcEmoji + orgInner + '</span>';
      /* Feature E — repeat-buyer 🔁 pill (prior SOLD deal, auto-detected server-side by
         email/phone against the same index the Offline DD + QW pills use). Same markup +
         .rqd-repeat-pill class as the rep-side row (dashboard-quote-row.js). */
      var _rbCount = p.repeatBuyerCount || 1;
      var repeatPill = p.isRepeatBuyer
        ? ' <span class="rqd-repeat-pill" title="Repeat buyer — ' + _rbCount + ' prior closed deal' + (_rbCount === 1 ? '' : 's') + '">🔁</span>'
        : '';
      var nameHtml = esc(contactName || '—') + repeatPill;
      // Phone column — Authority phone wins when the CFA has filled it,
      // otherwise fall back to the org-level contact phone (lead.phone /
      // customer.phone, which is what the importers now populate by
      // default — see Phase 1.21). Plain text; CFA dials via her usual
      // workflow (Ryan flagged a hyperlink as noise on the table view).
      var dispPhoneRaw = ((d.authorityPhone || '').trim()) || ((c.phone || '').trim());
      var phoneCell = _phoneColHtml(dispPhoneRaw);

      var frag = document.createDocumentFragment();
      var tr = document.createElement('tr');
      tr.dataset.ref = p.ref;
      tr.style.cursor = 'pointer';
      tr.className = 'rqd-row--prospect rqd-row--prospect-' + stage;
      tr.innerHTML =
        '<td class="rqd-expand-cell"><span class="rqd-expand-icon">+</span></td>' +
        '<td class="rqd-col-ref"></td>' +
        '<td class="rqd-col-org">' + orgHtml + '</td>' +
        '<td class="rqd-col-cust" title="' + esc(c.email || '') + '">' + nameHtml + '</td>' +
        '<td class="rqd-col-loc">' + esc(locText || '—') + '</td>' +
        '<td class="rqd-col-phone">' + phoneCell + '</td>' +
        '<td class="rqd-col-amount"></td>' +
        '<td class="rqd-col-date">' + esc(createdDisplay) + '</td>' +
        '<td class="rqd-col-status"><span class="rqd-status rqd-status--prospect-' + stage + '" data-ref="' + esc(p.ref) + '">' + stageLabel + '</span></td>' +
        '<td class="rqd-col-emails">' + _prospectEmailsCell(p) + '</td>' +
        '<td class="rqd-col-progress"><div class="rqd-progress-cell">' +
          _buildBantSpan(d, stage) +
          /* Envelope rides in the same span as the countdown / bell, exactly as
             wrap() does on the rep-side tabs — the --has-envelope class is what
             gives it spacing against the badge. */
          (function() {
            var _env = _prospectEnvelopeHtml(p);
            return '<span class="rqd-progress-cell__text' + (_env ? ' rqd-progress-cell__text--has-envelope' : '') + '">' + _env + _prospectFollowupBadge(p) + '</span>';
          })() +
          /* Feature B — quick-actions cog (Hand off / Mark Lost) without expanding the row. Reuses
             the shared .rqd-actions-trigger open handler + the existing delegated handoff/archive
             handlers. Hidden on closed prospects. */
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — Delete Prospect, mirroring
             the admin Delete Quote on Offline Deals. The cog was hidden outright on
             closed prospects; now an admin still gets one there, carrying Delete
             alone. Otherwise a bad import that's since been marked Lost is
             undeletable — which is exactly the row you most want to remove. */
          ((_rowIsClosed && !isAdmin) ? '' :
            '<button class="rqd-actions-trigger" type="button" data-menu-ref="' + esc(p.ref) + '" aria-label="Quick actions">&#9881;</button>' +
            '<div class="rqd-actions-menu" data-menu-for="' + esc(p.ref) + '">' +
              (_rowIsClosed ? '' :
                '<button type="button" class="rqd-prospect-handoff-btn" data-ref="' + esc(p.ref) + '"' + (_rowCanHandoff ? '' : ' disabled title="Fill Budget, Need, Timeline + all 4 Authority fields to enable handoff"') + '>🎯 Hand off to Rep</button>' +
                /* Feature C — reassign this prospect to another CFA (stage unchanged). */
                '<button type="button" class="rqd-prospect-transfer-btn" data-ref="' + esc(p.ref) + '">🔄 Transfer to CFA</button>' +
                '<button type="button" class="rqd-prospect-archive-btn" data-ref="' + esc(p.ref) + '">💀 Mark Lost</button>') +
              (isAdmin ? '<button type="button" class="rqd-prospect-delete-btn" data-ref="' + esc(p.ref) + '" data-org="' + esc((c && c.organization) || '') + '">🗑️ Delete Prospect</button>' : '') +
            '</div>') +
        '</div></td>' +
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — Mobile "⚙ Options ›"
           cell, matching the rep-side tabs (see buildQuoteRow in
           dashboard-quote-row.js). Prospects already render the cog + its
           .rqd-actions-menu inside the progress cell, but the mobile card hides
           that cog (td.rqd-col-progress .rqd-actions-trigger is display:none on
           mobile) and expects this separate cell instead — which prospect rows
           never emitted, so the tab had no Options button on a phone.
           This button only TRIGGERS: the shared handler resolves data-menu-ref
           to the existing [data-menu-for] menu above, so no second menu and no
           new handlers. Hence the guard is the same one that decides whether
           that menu is rendered at all — without it a closed prospect would show
           an Options button wired to a menu that doesn't exist. Emitting no cell
           (rather than an empty one) also keeps the card's row 5 from reserving
           blank space.
           No colspan change: the cell is display:none on desktop, so it adds no
           column — the rep-side rows have carried it under colspan 11 all along. */
        ((_rowIsClosed && !isAdmin) ? '' :
          '<td class="rqd-col-mobile-actions"><button class="rqd-actions-trigger rqd-actions-trigger--mobile" type="button" data-menu-ref="' + esc(p.ref) + '">&#9881; Options &#8250;</button></td>');
      frag.appendChild(tr);

      var detailTr = document.createElement('tr');
      detailTr.className = 'rqd-detail-row';
      detailTr.dataset.detailRef = p.ref;
      detailTr.dataset.source = 'prospecting';
      detailTr.innerHTML = '<td colspan="11"><div class="rqd-detail rqd-detail--prospect rqd-detail--prospect-' + stage + '" id="rqd-detail-' + esc(p.ref) + '">' + buildProspectDetailHtml(p) + '</div></td>';
      frag.appendChild(detailTr);
      return frag;
    }

    function renderProspectTable(prospects) {
      if (!tbody) return;
      // Phase 1.36 — Re-rendering the tbody throws away the previously
      // expanded row (it doesn't survive innerHTML wipe), so the
      // "has-expanded" dim class needs to drop too — otherwise every
      // freshly-rendered row sits at 55% opacity until the user clicks
      // one to expand it. Happens after handoff / archive / stage
      // filter changes.
      expandedRef = null;
      var _tableForReset = tbody && tbody.closest('table.rqd-table');
      if (_tableForReset) _tableForReset.classList.remove('rqd-table--has-expanded');
      tbody.innerHTML = '';
      if (!prospects || prospects.length === 0) return;
      tableWrap.style.display = '';

      var df = document.createDocumentFragment();
      for (var i = 0; i < prospects.length; i++) {
        df.appendChild(_buildProspectRowPair(prospects[i]));
      }
      tbody.appendChild(df);
    }

    /** Daily-flow sectioned view. Buckets prospects into 4 categories
        based on what action they need next, then renders each non-empty
        bucket as a section header row + its prospect rows. Reuses
        _buildProspectRowPair so click→expand behavior is identical
        between Playbook and All views. */
    function renderProspectPlaybook(prospects) {
      if (!tbody) return;
      tbody.innerHTML = '';
      tableWrap.style.display = '';

      var now = Date.now();
      var sevenDayMs = 7 * 86400000;
      var fourAmEt = 'T08:00:00Z'; // matches the universal day anchor used elsewhere
      function dueAtMs(due) { return Date.parse((due || '') + fourAmEt); }

      // Section 1: 🔔 Due Today — followUp.dueAt today/past.
      var dueToday = (prospects || []).filter(function(p) {
        if (!p.followUp || !p.followUp.dueAt) return false;
        if (p.prospectStage === 'won' || p.prospectStage === 'lost') return false;
        var ms = dueAtMs(p.followUp.dueAt);
        return Number.isFinite(ms) && ms <= now + 86400000; // includes today
      }).sort(function(a, b) {
        return dueAtMs(a.followUp.dueAt) - dueAtMs(b.followUp.dueAt);
      });

      // Section 2: 🥶 Stale Cold — cold-stage with no activity in 7+ days.
      var staleCold = (prospects || []).filter(function(p) {
        if ((p.prospectStage || 'cold') !== 'cold') return false;
        var lt = _prospectLastTouch(p) || p.createdAt;
        var ltMs = Date.parse(lt || '');
        if (!Number.isFinite(ltMs)) return true; // never touched, definitely stale
        return now - ltMs >= sevenDayMs;
      }).sort(function(a, b) {
        // Oldest first (most overdue for outreach).
        var aMs = Date.parse(_prospectLastTouch(a) || a.createdAt || '') || 0;
        var bMs = Date.parse(_prospectLastTouch(b) || b.createdAt || '') || 0;
        return aMs - bMs;
      });

      // Section 3: 🤝 Push to Qualified — engaged-stage waiting on BANT.
      var pushToQualified = (prospects || []).filter(function(p) {
        return (p.prospectStage || 'cold') === 'engaged';
      }).sort(function(a, b) {
        // Most recently touched first (warm leads to follow up on).
        var aMs = Date.parse(_prospectLastTouch(a) || a.createdAt || '') || 0;
        var bMs = Date.parse(_prospectLastTouch(b) || b.createdAt || '') || 0;
        return bMs - aMs;
      });

      // Section 4: ✅ Ready to Handoff — qualified-stage, not yet handed off.
      var readyHandoff = (prospects || []).filter(function(p) {
        return (p.prospectStage || 'cold') === 'qualified';
      }).sort(function(a, b) {
        var aMs = Date.parse(_prospectLastTouch(a) || a.createdAt || '') || 0;
        var bMs = Date.parse(_prospectLastTouch(b) || b.createdAt || '') || 0;
        return bMs - aMs;
      });

      var sections = [
        { id: 'due', emoji: '🔔', title: 'Due Today', subtitle: 'Follow-ups + bells that need an action right now', rows: dueToday, accent: 'amber' },
        { id: 'cold', emoji: '🥶', title: 'Stale Cold', subtitle: '7+ days since last touch — fresh outreach next', rows: staleCold, accent: 'cyan' },
        { id: 'engaged', emoji: '🤝', title: 'Push to Qualified', subtitle: 'Fill all four of BANT (B · A · N · T) to enable handoff', rows: pushToQualified, accent: 'amber' },
        { id: 'qualified', emoji: '✅', title: 'Ready to Handoff', subtitle: 'BANT complete — hand to a rep when you can', rows: readyHandoff, accent: 'green' },
      ];

      var df = document.createDocumentFragment();
      var anyRendered = false;
      sections.forEach(function(sec) {
        if (sec.rows.length === 0) return; // hide empty sections
        anyRendered = true;
        var headerTr = document.createElement('tr');
        headerTr.className = 'rqd-playbook-section-header rqd-playbook-section-header--' + sec.accent;
        headerTr.innerHTML = '<td colspan="11">' +
          '<div class="rqd-playbook-section-header__inner">' +
            '<span class="rqd-playbook-section-header__emoji">' + sec.emoji + '</span>' +
            '<span class="rqd-playbook-section-header__title">' + esc(sec.title) + '</span>' +
            '<span class="rqd-playbook-section-header__count">' + sec.rows.length + '</span>' +
            '<span class="rqd-playbook-section-header__subtitle">' + esc(sec.subtitle) + '</span>' +
          '</div></td>';
        df.appendChild(headerTr);
        sec.rows.forEach(function(p) { df.appendChild(_buildProspectRowPair(p)); });
      });

      if (!anyRendered) {
        // Empty-state row inside the tbody so the table chrome stays visible.
        var emptyTr = document.createElement('tr');
        emptyTr.className = 'rqd-playbook-empty';
        emptyTr.innerHTML = '<td colspan="11" class="rqd-playbook-empty__cell">' +
          '<div class="rqd-playbook-empty__emoji">🎉</div>' +
          '<div class="rqd-playbook-empty__title">All caught up — nothing needs attention right now.</div>' +
          '<div class="rqd-playbook-empty__sub">Switch to <strong>All Active</strong> to see the full pipeline, or use <strong>+ New</strong> to add a fresh cold lead.</div>' +
        '</td>';
        df.appendChild(emptyTr);
      }
      tbody.appendChild(df);
    }

    function buildProspectDetailHtml(p) {
      var c = p.customer || {};
      var d = p.discovery || {};
      var stage = p.prospectStage || 'cold';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17 — Phase 1.8) — Qualified
         gate now requires all SEVEN BANT inputs independently: all four
         Authority sub-fields (Name/Title/Email/Phone) + Need + Budget +
         Timeline. The To-Do A chip's 4-step partial fill is the natural
         progress indicator. */
      var qualified = _isProspectQualified(d);
      var canHandoff = qualified && stage !== 'handoff' && stage !== 'won' && stage !== 'lost';
      var isClosed = stage === 'won' || stage === 'lost' || stage === 'handoff';
      var _disAttr = isClosed ? ' disabled' : '';

      // De-facto contact override — when Authority sub-fields are filled,
      // that person becomes the primary contact displayed on this card
      // (overrides the customer.name/email/phone imported with the record).
      var authName  = (d.authorityName  || '').trim();
      var authTitle = (d.authorityTitle || '').trim();
      var dispName  = authName  || (c.name  || '').trim();
      var dispEmail = (d.authorityEmail || '').trim() || (c.email || '').trim();
      var dispPhone = (d.authorityPhone || '').trim() || (c.phone || '').trim();
      // Inline Title next to Name when both Authority Name + Title are set
      // (Ryan 2026-05-17). One-line "Sarah Chen · CFO" reads fast on scan;
      // empty Title or missing Authority Name leaves the row as just the name.
      var _nameInline = esc(dispName || '—');
      if (authName && authTitle) {
        _nameInline += ' <span class="rqd-prospect-name__title">· ' + esc(authTitle) + '</span>';
      }
      // Per-letter state classes for the Discovery card's section-letter
      // chips — they mirror the To-Do BANT chips (gray default, green when
      // filled; A uses 4-step partial fill). _updateDiscoveryDerivedUI
      // refreshes these in place on auto-save without re-rendering.
      var _bCls = (d.budget   || '').trim() ? ' rqd-bant-section__letter--on' : '';
      var _nCls = (d.need     || '').trim() ? ' rqd-bant-section__letter--on' : '';
      var _tCls = (d.timeline || '').trim() ? ' rqd-bant-section__letter--on' : '';
      var _aCount = _authorityFilledCount(d);
      var _aCls = ' rqd-bant-section__letter--a-' + _aCount;

      var streetText = [c.street, c.street2].filter(Boolean).join(', ');
      var locText = [c.city, c.state, c.zip].filter(Boolean).join(', ');
      var html = '';

      // Top grid: Prospect card (1fr) + Discovery card (2fr). Activity card
      // lives below as a full-width row inside .rqd-detail--prospect.
      html += '<div class="rqd-detail__grid">';

      // ── Prospect card ──────────────────────────────────────────────
      // Phase 1.30 — Address fields render as plain rows by default;
      // a pencil icon next to Street toggles an inline edit form for
      // Street + City + State + Zip together (one address = one edit).
      // Save POSTs to /cfa-prospect-update; Cancel discards. Worker
      // already accepts customer.{street,city,state,zip}.
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — One master pencil on the
         card title, replacing the two per-line address pencils. Mirrors the
         SOLD TO / BILL TO / SHIP TO pencil on Offline Deals: one popup that
         governs every field on the card. The old inline form only ever covered
         the address — Organization / Name / Email / Phone were not editable at
         all, which is the gap this closes. */
      var _editBtnHtml = isClosed ? '' : '<button type="button" class="rqd-prospect-card__edit-btn" data-action="prospect-edit" data-ref="' + esc(p.ref) + '" title="Edit prospect details" aria-label="Edit prospect details">&#9998;</button>';
      html += '<div class="rqd-detail__card rqd-prospect-card" data-ref="' + esc(p.ref) + '">';
      html +=   '<div class="rqd-detail__section-title">Prospect ' + _editBtnHtml + ' <span class="rqd-prospect-card__status" data-state="idle" aria-live="polite"></span></div>';
      html +=   '<div class="rqd-detail__row"><span class="rqd-detail__label">Organization</span><span class="rqd-detail__value">' + esc(c.organization || '—') + '</span></div>';
      html +=   '<div class="rqd-detail__row"><span class="rqd-detail__label">Name</span><span class="rqd-detail__value">' + _nameInline + '</span></div>';
      html +=   '<div class="rqd-detail__row"><span class="rqd-detail__label">Email</span><span class="rqd-detail__value">' + (dispEmail ? '<a href="mailto:' + esc(dispEmail) + '">' + esc(dispEmail) + '</a>' : '—') + '</span></div>';
      html +=   '<div class="rqd-detail__row"><span class="rqd-detail__label">Phone</span><span class="rqd-detail__value">' + (dispPhone ? '<a href="tel:' + esc(dispPhone) + '">' + esc(typeof fmtPhone === 'function' ? fmtPhone(dispPhone) : dispPhone) + '</a>' : '—') + '</span></div>';
      // Read-only Street + City/State/Zip rows. Pencil sits on BOTH
      // labels — either click opens the same edit form covering all
      // five address fields (Street, Street 2, City, State, Zip).
      // Street display still joins street + street2 with a comma when
      // both are present so a "Suite 200" line shows inline.
      html +=   '<div class="rqd-detail__row"><span class="rqd-detail__label">Street</span><span class="rqd-detail__value">' + esc(streetText || '—') + '</span></div>';
      html +=   '<div class="rqd-detail__row"><span class="rqd-detail__label">City/State/Zip</span><span class="rqd-detail__value">' + esc(locText || '—') + '</span></div>';
      // Phase 1.30's inline address form removed 2026-07-15 — superseded by the
      // master pencil popup, which covers every field rather than just the address.

      // SOURCE row (was its own card before Phase 1.7) — only when imported.
      if (p.prospectSource && p.prospectSource !== 'manual') {
        var srcLabel = p.prospectSource === 'lead-finder' ? 'Deal Finder' : 'Lead Generator';
        var srcUrl = (p.prospectSourceRef && p.prospectSourceRef.url) || '';
        var srcValue = srcUrl
          ? '<a href="' + esc(srcUrl) + '" target="_blank" rel="noopener" class="rqd-prospect-source-link">' + esc(srcLabel) + ' ↗</a>'
          : esc(srcLabel) + ' <span class="rqd-prospect-source-link__nourl">(no URL)</span>';
        html += '<div class="rqd-detail__row"><span class="rqd-detail__label">Source</span><span class="rqd-detail__value">' + srcValue + '</span></div>';
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — entry point to Contacts,
         below Source. The card itself lives further down the panel; this is the
         affordance where you're already looking when you realise there's a
         second person to record. */
      if (!isClosed) {
        var _ctCount = _prospectContacts(p).length;
        html += '<div class="rqd-prospect-card__addcontact">' +
                  '<button type="button" class="rqd-prospect-contacts__add" data-action="contact-add" data-ref="' + esc(p.ref) + '">+ Add contact</button>' +
                  (_ctCount > 1 ? '<span class="rqd-prospect-card__addcontact-note">' + _ctCount + ' on file</span>' : '') +
                '</div>';
      }
      html += '</div>';

      // ── Discovery (BANT) card ─────────────────────────────────────
      // Clean B-A-N-T layout — single text input per section, Authority
      // expands into Name / Title / Email / Phone since that contact
      // becomes the de-facto person on this prospect (see override above).
      // Phase 1.9 — Save button retired in favor of debounced auto-save
      // (750ms after the last keystroke). The status indicator next to
      // the Discovery title surfaces saving / saved state.
      html += '<div class="rqd-detail__card rqd-prospect-discovery" data-ref="' + esc(p.ref) + '">';
      html +=   '<div class="rqd-detail__section-title">Discovery ' + (qualified ? '<span class="rqd-prospect-discovery__qualified">✓ Qualified</span>' : '') + ' <span class="rqd-prospect-discovery__status" data-state="idle" aria-live="polite"></span></div>';

      // B — Budget
      html += '<div class="rqd-bant-section">';
      html +=   '<div class="rqd-bant-section__label"><span class="rqd-bant-section__letter' + _bCls + '" data-bant-letter="B">B</span> Budget <span class="rqd-bant-section__hint" title="What is their (or their client\'s) budget?" aria-hidden="true">i</span></div>';
      html +=   '<input type="text" class="rqd-bant-section__input" data-field="budget" value="' + esc(d.budget || '') + '"' + _disAttr + '>';
      html += '</div>';

      // A — Authority (4 sub-fields)
      html += '<div class="rqd-bant-section">';
      html +=   '<div class="rqd-bant-section__label"><span class="rqd-bant-section__letter' + _aCls + '" data-bant-letter="A">A</span> Authority <span class="rqd-bant-section__hint" title="Who is the decision maker?" aria-hidden="true">i</span></div>';
      html +=   '<div class="rqd-bant-authority-grid">';
      html +=     '<input type="text" class="rqd-bant-section__input" data-field="authorityName" placeholder="Name" value="' + esc(d.authorityName || '') + '"' + _disAttr + '>';
      html +=     '<input type="text" class="rqd-bant-section__input" data-field="authorityTitle" placeholder="Title / role" value="' + esc(d.authorityTitle || '') + '"' + _disAttr + '>';
      html +=     '<input type="email" class="rqd-bant-section__input" data-field="authorityEmail" placeholder="Email" value="' + esc(d.authorityEmail || '') + '"' + _disAttr + '>';
      html +=     '<input type="tel" class="rqd-bant-section__input" data-field="authorityPhone" placeholder="Phone" value="' + esc(_formatAsUsPhone(d.authorityPhone || '') || (d.authorityPhone || '')) + '"' + _disAttr + '>';
      html +=   '</div>';
      html += '</div>';

      // N — Need
      html += '<div class="rqd-bant-section">';
      html +=   '<div class="rqd-bant-section__label"><span class="rqd-bant-section__letter' + _nCls + '" data-bant-letter="N">N</span> Need <span class="rqd-bant-section__hint" title="What problem are they trying to solve?" aria-hidden="true">i</span></div>';
      html +=   '<input type="text" class="rqd-bant-section__input" data-field="need" value="' + esc(d.need || '') + '"' + _disAttr + '>';
      html += '</div>';

      // T — Timeline
      html += '<div class="rqd-bant-section">';
      html +=   '<div class="rqd-bant-section__label"><span class="rqd-bant-section__letter' + _tCls + '" data-bant-letter="T">T</span> Timeline <span class="rqd-bant-section__hint" title="When are they trying to solve it?" aria-hidden="true">i</span></div>';
      html +=   '<input type="text" class="rqd-bant-section__input" data-field="timeline" value="' + esc(d.timeline || '') + '"' + _disAttr + '>';
      html += '</div>';

      if (!isClosed) {
        html += '<div class="rqd-prospect-discovery__actions">';
        html +=   '<button type="button" class="rqd-prospect-handoff-btn" data-ref="' + esc(p.ref) + '"' + (canHandoff ? '' : ' disabled') + ' title="' + (canHandoff ? 'Hand off to a Territory Sales Manager for quoting' : 'Fill Budget, Need, Timeline, AND all four Authority sub-fields (Name · Title · Email · Phone) to enable handoff') + '">🎯 Handoff to Rep</button>';
        /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — the "💀 Archive (Lost)" button
           moved into the Activity composer as "Save & Mark Lost" (note + LOST in one
           go, routes to /cfa-prospect-archive). Removed from here to avoid two ways. */
        html += '</div>';
      } else if (stage === 'handoff') {
        html += '<div class="rqd-prospect-handed-off">Handed off to <strong>' + esc(p.handoffTo || '?') + '</strong>' + (p.handoffAt ? ' on ' + esc(formatNoteDate(p.handoffAt)) : '') + (p.handoffNotes ? '<div class="rqd-prospect-handoff-notes">' + esc(p.handoffNotes) + '</div>' : '') + '</div>';
      } else if (stage === 'won') {
        html += '<div class="rqd-prospect-won-banner">🏆 Closed — commission earned' + (p.resultingDealRef ? ' on ' + esc(p.resultingDealRef) : '') + '</div>';
      } else if (stage === 'lost') {
        html += '<div class="rqd-prospect-lost-banner">💀 Archived' + (p.archiveReason ? ' — ' + esc(p.archiveReason) : '') + '</div>';
      }
      html += '</div>'; // close discovery card

      html += '</div>'; // close grid

      // ── Enrichment card (Phase 1.15) ──────────────────────────────
      // Contacts card — see _prospectContactsCardHtml. Renders even when
      // empty, unlike the Enrichment card it replaces.
      html += _prospectContactsCardHtml(p, d, isClosed);

      // ── Activity card — reuse the shared rich composer ────────────────
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — was a trimmed hand-rolled
         composer; now feeds the prospect into the SAME buildActivityCard the Offline
         tab uses, so prospects get the Call-outcome decision tree, Text chip,
         email-from-the-DD (Outlook compose), "Save & Mark Lost" in one action, richer
         follow-up presets, and entry edit/delete. ctx.isProspect gates the offline-only
         bits (linked-files sidecar, lifecycle presets) and ctx.isClosed hides the
         close-out on won/lost/handoff prospects; handleNoteCloseOut routes the LOST
         action to /cfa-prospect-archive. The card renders even when closed (matching
         prior behavior) so the activity history stays visible. `p` already carries
         reference (aliased to p.ref), noteEntries, customer, discovery. */
      html += window.RQD.buildActivityCard(p, {
        isProspect: true,
        isClosed: isClosed,
        custEmail: (d.authorityEmail || (p.customer && p.customer.email) || '')
      });
      return html;
    }

    /** Phase 1.33 — Extracted so _runDiscoverySave can refresh the
        Activity log in place after a stage change (auto-transition
        entry stamped server-side). Returns the inner HTML for
        .rqd-notes-log__entries — either the empty-state div or the
        forEach'd entries. */
    function _buildProspectEntriesHtml(entries) {
      entries = Array.isArray(entries) ? entries : [];
      if (entries.length === 0) {
        return '<div class="rqd-notes-log__empty">No activity yet — log your first touch above.</div>';
      }
      var html = '';
      entries.forEach(function(e) {
          var meta = formatNoteDate(e.ts) + (e.by ? ' — ' + esc(e.by) : '');
          var labelStr = (e.types && e.types.length) ? e.types.map(function(t) { return t.charAt(0).toUpperCase() + t.slice(1); }).join(' · ') : (e.type || 'Note');
          var emoji = (e.type === 'call') ? '📞' : (e.type === 'text') ? '📱' : (e.type === 'email') ? '📧' : (e.type === 'meeting') ? '🤝' : (e.type === 'dropin' || e.type === 'drop-in') ? '🚪' : (e.type === 'transition') ? '🎯' : '💬';
          html += '<div class="rqd-notes-log__entry" data-entry-id="' + esc(e.id || '') + '">';
          if (e.transition) {
            // Phase 1.28 — Color the from/to transition pills per stage,
            // matching the on-row status pill colors. Was missing on the
            // prospect tab even though offline already does it.
            var _fromStage = String(e.transition.from || '').toLowerCase();
            var _toStage = String(e.transition.to || '').toLowerCase();
            var _fromCls = _fromStage ? ' rqd-notes-log__transition-pill--prospect-' + _fromStage : '';
            var _toCls = _toStage ? ' rqd-notes-log__transition-pill--prospect-' + _toStage : '';
            html += '<div class="rqd-notes-log__entry-meta">';
            html +=   '<span class="rqd-notes-log__entry-transition">';
            html +=     '<span class="rqd-notes-log__transition-pill' + _fromCls + '">' + esc(e.transition.fromLabel || e.transition.from) + '</span>';
            html +=     '<span class="rqd-notes-log__transition-arrow">→</span>';
            html +=     '<span class="rqd-notes-log__transition-pill' + _toCls + '">' + esc(e.transition.toLabel || e.transition.to) + '</span>';
            html +=   '</span>';
            // Empty mutate-btns span absorbs the margin-left:auto rule so the
            // when timestamp pins right on desktop (matches offline pattern).
            html +=   '<span class="rqd-notes-log__entry-mutate-btns"></span>';
            html +=   '<span class="rqd-notes-log__entry-when">' + meta + '</span>';
            html += '</div>';
            if (e.text) html += '<div class="rqd-notes-log__entry-meta"><span class="rqd-notes-log__entry-text">' + esc(e.text).replace(/\n/g, '<br>') + '</span></div>';
          } else {
            html += '<div class="rqd-notes-log__entry-meta">';
            html +=   '<span class="rqd-notes-log__entry-type">' + emoji + ' ' + esc(labelStr) + '</span>';
            html +=   '<span class="rqd-notes-log__entry-meta-sep"> — </span>';
            html +=   '<span class="rqd-notes-log__entry-text">' + esc(e.text || '').replace(/\n/g, '<br>') + '</span>';
            html +=   '<span class="rqd-notes-log__entry-mutate-btns"></span>';
            html +=   '<span class="rqd-notes-log__entry-when">' + meta + '</span>';
            html += '</div>';
          }
          /* Phase 1.13 — follow-up info on a separate bottom line per entry
             (matches offline pattern). Worker stamps entry.followUpAt when
             the rep arms a follow-up date with the note. Renders as
             "Follow-up set for Nd — Mon, May 20" (or delta-aware variant
             when the rep edited an existing follow-up). */
          if (e.followUpAt) {
            var _fuLabel;
            if (e.previousFollowUpAt && typeof formatFollowUpRemaining === 'function') {
              var _oldMs = Date.parse(e.previousFollowUpAt + 'T08:00:00Z');
              var _newMs = Date.parse(e.followUpAt + 'T08:00:00Z');
              var _direction = _newMs > _oldMs ? 'increased' : (_newMs < _oldMs ? 'decreased' : '');
              if (_direction) {
                var _oldStr = formatFollowUpRemaining(e.ts, e.previousFollowUpAt);
                var _newStr = formatFollowUpRemaining(e.ts, e.followUpAt);
                _fuLabel = 'Follow-up ' + _direction + '. Was at ' + _oldStr + ', set for ' + _newStr + ' — ' + (typeof formatFollowUpDate === 'function' ? esc(formatFollowUpDate(e.followUpAt)) : esc(e.followUpAt));
              }
            }
            if (!_fuLabel) {
              var _fuDays = _followUpDayCount(e.ts, e.followUpAt);
              _fuLabel = 'Follow-up set for ' + _fuDays + 'd';
              if (_fuDays > 0 && typeof formatFollowUpDate === 'function') _fuLabel += ' — ' + esc(formatFollowUpDate(e.followUpAt));
            }
            html += '<div class="rqd-notes-log__entry-followup" title="Wake date ' + esc(e.followUpAt) + '">' + _fuLabel + '</div>';
          }
          html += '</div>';
      });
      return html;
    }

    /* END CUSTOM_RFQPORTAL_BY_CLAUDE (Deal Prospecting render) */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17 — Phase 1.8) — Live phone
       formatting on the Authority Phone field. As the CFA types digits the
       value reflows to (XXX) XXX-XXXX. Strips non-digits, caps at 10, and
       preserves cursor placement after each keystroke. Wired via document
       delegation so it works regardless of which prospect row's Discovery
       card is open. */
    function _formatAsUsPhone(digits) {
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — delegate to the shared
         formatter so the BANT / New-Prospect phone matches every other field:
         first 10 digits format normally, any extra digits become an extension. */
      if (window.RepPortal && window.RepPortal.formatPhone) return window.RepPortal.formatPhone(digits);
      // Fallback (shared portal JS not yet loaded): 10-digit main + extension.
      var d = (digits || '').replace(/\D/g, '');
      var main = d.slice(0, 10), ext = d.slice(10), out;
      if (main.length === 0) out = '';
      else if (main.length <= 3) out = '(' + main;
      else if (main.length <= 6) out = '(' + main.slice(0, 3) + ') ' + main.slice(3);
      else out = '(' + main.slice(0, 3) + ') ' + main.slice(3, 6) + '-' + main.slice(6);
      if (ext) out += ' ext. ' + ext;
      return out;
    }
    document.addEventListener('input', function(e) {
      var input = e.target;
      if (!input || input.dataset.field !== 'authorityPhone') return;
      // Cursor strategy: count the digits before the current cursor in the
      // raw value, format the value, then re-place the cursor after the
      // Nth digit in the formatted string. Keeps backspace + middle-of-
      // string edits feeling natural.
      var raw = input.value || '';
      var caret = input.selectionStart || raw.length;
      var digitsBeforeCaret = (raw.slice(0, caret).match(/\d/g) || []).length;
      var formatted = _formatAsUsPhone(raw);
      if (formatted === raw) return; // no-op (e.g. arrow key fires input on some browsers)
      input.value = formatted;
      // Re-place caret: walk forward through formatted, count digits.
      var seen = 0, newCaret = formatted.length;
      for (var i = 0; i < formatted.length; i++) {
        if (/\d/.test(formatted[i])) {
          seen++;
          if (seen === digitsBeforeCaret) { newCaret = i + 1; break; }
        }
      }
      if (digitsBeforeCaret === 0) newCaret = formatted.length;
      try { input.setSelectionRange(newCaret, newCaret); } catch (_) {}
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17 — Phase 1.9) — Discovery
       auto-save. Replaces the explicit Save Discovery button: 750ms after
       the last keystroke in any Discovery field, POST /cfa-prospect-update
       and refresh derived UI in place (BANT chips on parent row + letter
       chips inside the card + qualified badge + Handoff button state).
       Flush on Handoff / Archive click so a pending save can't be skipped. */
    var _discoverySaveTimer = null;
    var _discoveryPendingRef = null;

    /** Refresh derived Discovery UI in place after a successful save —
        keeps the user's input focus + cursor (no full re-render).
        Phase 1.11 extends this to also refresh the sibling Prospect card's
        Name / Email / Phone rows (de-facto contact override) AND the parent
        row's Status pill class+text + the row-level stage class that
        drives the hover tint. */
    function _updateDiscoveryDerivedUI(card, p) {
      if (!card || !p) return;
      var d = p.discovery || {};
      var aCount = _authorityFilledCount(d);
      /* Phase 1.19 — Preserve input focus + caret across the surgical
         re-render. The card itself doesn't get re-rendered (only the
         letter chips + qualified badge + handoff button), but stage
         downgrades can re-render the detail panel via buildProspectDetailHtml.
         Capture focused field + caret so we can restore after if the
         element survives. */
      var _focusFieldName = null;
      var _focusCaretStart = null;
      var _focusCaretEnd = null;
      try {
        var _activeEl = document.activeElement;
        if (_activeEl && card.contains(_activeEl) && _activeEl.dataset && _activeEl.dataset.field) {
          _focusFieldName = _activeEl.dataset.field;
          _focusCaretStart = _activeEl.selectionStart;
          _focusCaretEnd = _activeEl.selectionEnd;
        }
      } catch (_) {}
      // Section letter chips inside the Discovery card.
      card.querySelectorAll('.rqd-bant-section__letter').forEach(function(chip) {
        var letter = chip.dataset.bantLetter || chip.textContent.trim();
        var classes = ['rqd-bant-section__letter'];
        if (letter === 'A') {
          classes.push('rqd-bant-section__letter--a-' + aCount);
        } else {
          var key = letter === 'B' ? 'budget' : letter === 'N' ? 'need' : letter === 'T' ? 'timeline' : '';
          if (key && (d[key] || '').trim()) classes.push('rqd-bant-section__letter--on');
        }
        chip.className = classes.join(' ');
      });
      // Qualified badge in title.
      var qualified = _isProspectQualified(d);
      var title = card.querySelector('.rqd-detail__section-title');
      var qBadge = title && title.querySelector('.rqd-prospect-discovery__qualified');
      if (title) {
        if (qualified && !qBadge) {
          var statusEl = title.querySelector('.rqd-prospect-discovery__status');
          var badgeHtml = '<span class="rqd-prospect-discovery__qualified">✓ Qualified</span>';
          if (statusEl) statusEl.insertAdjacentHTML('beforebegin', badgeHtml + ' ');
          else title.insertAdjacentHTML('beforeend', ' ' + badgeHtml);
        } else if (!qualified && qBadge) {
          qBadge.remove();
        }
      }
      // Handoff button enable/disable + tooltip.
      var canHandoff = qualified && p.prospectStage !== 'handoff' && p.prospectStage !== 'won' && p.prospectStage !== 'lost';
      var handoffBtn = card.querySelector('.rqd-prospect-handoff-btn');
      if (handoffBtn) {
        handoffBtn.disabled = !canHandoff;
        handoffBtn.title = canHandoff
          ? 'Hand off to a Territory Sales Manager for quoting'
          : 'Fill Budget, Need, Timeline, AND all four Authority sub-fields (Name · Title · Email · Phone) to enable handoff';
      }
      // Refresh the sibling Prospect card's Name / Email / Phone rows so
      // the de-facto contact override reflects the latest Authority fields
      // without a full panel re-render (preserves Discovery input focus).
      var detailEl = card.closest('.rqd-detail');
      if (detailEl) {
        var prospectCard = detailEl.querySelector('.rqd-detail__grid > .rqd-detail__card:first-child');
        if (prospectCard) {
          var c = p.customer || {};
          var authName  = (d.authorityName  || '').trim();
          var authTitle = (d.authorityTitle || '').trim();
          var dispName  = authName  || (c.name  || '').trim();
          var dispEmail = (d.authorityEmail || '').trim() || (c.email || '').trim();
          var dispPhone = (d.authorityPhone || '').trim() || (c.phone || '').trim();
          var nameInline = esc(dispName || '—');
          if (authName && authTitle) {
            nameInline += ' <span class="rqd-prospect-name__title">· ' + esc(authTitle) + '</span>';
          }
          // Each detail row's label drives which value to update.
          prospectCard.querySelectorAll('.rqd-detail__row').forEach(function(row) {
            var labelEl = row.querySelector('.rqd-detail__label');
            var valueEl = row.querySelector('.rqd-detail__value');
            if (!labelEl || !valueEl) return;
            var label = (labelEl.textContent || '').trim();
            if (label === 'Name') {
              valueEl.innerHTML = nameInline;
            } else if (label === 'Email') {
              valueEl.innerHTML = dispEmail
                ? '<a href="mailto:' + esc(dispEmail) + '">' + esc(dispEmail) + '</a>'
                : '—';
            } else if (label === 'Phone') {
              valueEl.innerHTML = dispPhone
                ? '<a href="tel:' + esc(dispPhone) + '">' + esc(typeof fmtPhone === 'function' ? fmtPhone(dispPhone) : dispPhone) + '</a>'
                : '—';
            }
          });
        }
      }
      // Refresh the parent row's Status pill (class + text) + the row-level
      // stage class that drives the hover tint. Phase 1.11 — clearing a
      // BANT field on QUALIFIED now drops the worker's persisted stage
      // back to engaged, so the row's pill needs to follow suit.
      var stage = p.prospectStage || 'cold';
      var stageLabel = _prospectStageLabels[stage] || stage.toUpperCase();
      var ref = p.ref || (card && card.dataset && card.dataset.ref);
      if (ref && tbody) {
        var rowEl = tbody.querySelector('tr[data-ref="' + ref + '"]');
        if (rowEl) {
          rowEl.className = 'rqd-row--prospect rqd-row--prospect-' + stage;
          var statusPill = rowEl.querySelector('.rqd-col-status .rqd-status');
          if (statusPill) {
            // Strip any prior `rqd-status--prospect-X` modifier; keep the
            // base classes (.rqd-status + any non-stage extras) intact.
            statusPill.className = statusPill.className.replace(/\s*rqd-status--prospect-\S+/g, '').trim();
            statusPill.classList.add('rqd-status--prospect-' + stage);
            statusPill.textContent = stageLabel;
          }
        }
      }
      // Detail panel container also carries a `.rqd-detail--prospect-X`
      // class — used by per-stage card-background rules. Keep it in sync.
      if (detailEl && ref) {
        detailEl.className = detailEl.className.replace(/\s*rqd-detail--prospect-\S+/g, '').trim();
        detailEl.classList.add('rqd-detail--prospect-' + stage);
      }
      // Phase 1.23 — Refresh each Enrichment row's ★ Authority badge vs
      // Make Authority button. A contact stays "the Authority" only as
      // long as ALL four Discovery sub-fields still equal the contact's
      // pristine data — the moment the CFA edits or clears one, the
      // badge drops and the button reappears.
      if (detailEl) {
        var enrichList = detailEl.querySelector('.rqd-prospect-enrichment__list');
        var enrichContacts = (p.enrichment && Array.isArray(p.enrichment.contacts)) ? p.enrichment.contacts : null;
        if (enrichList && enrichContacts) {
          var isClosed = (p.prospectStage === 'won' || p.prospectStage === 'lost' || p.prospectStage === 'handoff');
          enrichList.querySelectorAll('.rqd-prospect-enrichment__row').forEach(function(rowEl) {
            var idx = parseInt(rowEl.dataset.idx, 10);
            var ct = (!isNaN(idx) && enrichContacts[idx]) ? enrichContacts[idx] : null;
            if (!ct) return;
            var actionsEl = rowEl.querySelector('.rqd-prospect-enrichment__actions');
            if (!actionsEl) return;
            var isCurrent = _enrichmentMatchesAuthority(ct, d);
            if (isCurrent) {
              actionsEl.innerHTML = '<span class="rqd-prospect-enrichment__current" title="Currently the Authority contact">★ Authority</span>';
            } else if (!isClosed) {
              actionsEl.innerHTML = '<button type="button" class="rqd-prospect-enrichment__make-auth" data-ref="' + esc(p.ref) + '" data-idx="' + idx + '" title="Set this contact as the Authority person">Make Authority</button>';
            } else {
              actionsEl.innerHTML = '';
            }
          });
        }
      }
      // Phase 1.19 — Restore focus + caret if the field still exists in
      // the (re-rendered) card. Best-effort; silent if the field was
      // removed (e.g., closed prospect now disables all inputs).
      if (_focusFieldName) {
        try {
          var _restoreEl = card.querySelector('[data-field="' + _focusFieldName + '"]');
          if (_restoreEl && document.activeElement !== _restoreEl) {
            _restoreEl.focus();
            if (_focusCaretStart != null) {
              _restoreEl.setSelectionRange(_focusCaretStart, _focusCaretEnd != null ? _focusCaretEnd : _focusCaretStart);
            }
          }
        } catch (_) {}
      }
    }

    /** Run the save POST + refresh derived UI. Returns a promise so
        callers (Handoff / Archive flush) can await it. */
    async function _runDiscoverySave(ref) {
      if (!ref) return;
      var card = document.querySelector('.rqd-prospect-discovery[data-ref="' + ref + '"]');
      if (!card) return;
      var indicator = card.querySelector('.rqd-prospect-discovery__status');
      function _fv(name) { var el = card.querySelector('[data-field="' + name + '"]'); return el ? (el.value || '') : ''; }
      var payload = {
        ref: ref,
        discovery: {
          authorityName:  _fv('authorityName'),
          authorityTitle: _fv('authorityTitle'),
          authorityEmail: _fv('authorityEmail'),
          authorityPhone: _fv('authorityPhone'),
          need:           _fv('need'),
          budget:         _fv('budget'),
          timeline:       _fv('timeline'),
        },
      };
      // Phase 1.30 — Customer field saves moved to an explicit pencil-edit
      // flow; 2026-07-15 that became the master pencil popup
      // (__openEditProspect). Auto-save here stays Discovery-only.
      if (indicator) { indicator.textContent = 'Saving…'; indicator.dataset.state = 'saving'; }
      try {
        var resp = await API.post('/cfa-prospect-update', payload);
        if (resp && resp.success) {
          var idx = allQuotes.findIndex(function(x) { return x.ref === ref; });
          if (idx >= 0) {
            allQuotes[idx].discovery = (resp.prospect && resp.prospect.discovery) || allQuotes[idx].discovery;
            allQuotes[idx].prospectStage = (resp.prospect && resp.prospect.prospectStage) || allQuotes[idx].prospectStage;
            // Phase 1.33 — Worker may have auto-stamped a transition
            // entry in noteEntries when this save shifted the stage
            // (e.g. COLD → QUALIFIED after BANT completes). Pick up
            // the echoed list so the Activity log reflects it without
            // a page refresh.
            if (resp.prospect && Array.isArray(resp.prospect.noteEntries)) {
              allQuotes[idx].noteEntries = resp.prospect.noteEntries;
            }
            // Refresh parent row's To-Do BANT chips in place.
            var _rowEl = tbody && tbody.querySelector('tr[data-ref="' + ref + '"]');
            if (_rowEl) {
              var _bantSpan = _rowEl.querySelector('.rqd-bant');
              if (_bantSpan) {
                var _temp = document.createElement('div');
                _temp.innerHTML = _buildBantSpan(allQuotes[idx].discovery, allQuotes[idx].prospectStage);
                var _newSpan = _temp.firstElementChild;
                if (_newSpan) _bantSpan.replaceWith(_newSpan);
              }
            }
            // Refresh derived UI inside the card (letter chips, qualified
            // badge, Handoff button). Inputs untouched so focus persists.
            _updateDiscoveryDerivedUI(card, allQuotes[idx]);
            // Phase 1.33 — Refresh the Activity entries list + count
            // badge so any new system transition entry shows up in
            // real time (Discovery inputs keep focus since we only
            // touch the entries list + the title's count badge, not
            // the composer).
            var _detailElForLog = document.getElementById('rqd-detail-' + ref);
            if (_detailElForLog) {
              /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — the prospect Activity card
                 now IS the shared buildActivityCard. Re-render just the entries subtree
                 via buildActivityCard (built offscreen) so the feed keeps its rich
                 styling (call outcomes, emails, edit/delete) after a Discovery save,
                 without disturbing the live composer above — only .rqd-notes-log__entries
                 is swapped, so the rep's in-progress note is preserved. */
              var _entriesEl = _detailElForLog.querySelector('.rqd-notes-log__entries');
              /* Ryan 2026-07-11: skip the swap if the rep is mid-interaction inside the feed
                 (an inline ✎ edit form focused, etc.) — the offscreen rebuild would wipe their
                 unsaved edit. The transition entry shows on the next natural re-render. */
              var _busyInFeed = _entriesEl && document.activeElement && _entriesEl.contains(document.activeElement);
              if (_entriesEl && !_busyInFeed && window.RQD && window.RQD.buildActivityCard) {
                var _pForLog = allQuotes[idx];
                var _tmpCard = document.createElement('div');
                _tmpCard.innerHTML = window.RQD.buildActivityCard(_pForLog, {
                  isProspect: true,
                  isClosed: (_pForLog.prospectStage === 'won' || _pForLog.prospectStage === 'lost' || _pForLog.prospectStage === 'handoff'),
                  custEmail: (_pForLog.discovery && _pForLog.discovery.authorityEmail) || (_pForLog.customer && _pForLog.customer.email) || ''
                });
                var _freshEntries = _tmpCard.querySelector('.rqd-notes-log__entries');
                if (_freshEntries) _entriesEl.replaceWith(_freshEntries);
              }
              // Count badge — the card no longer carries .rqd-prospect-activity-wrap;
              // target the Activity card's own title inside this detail panel.
              var _activityCardEl = _detailElForLog.querySelector('.rqd-notes-log');
              var _activityTitle = _activityCardEl && _activityCardEl.querySelector('.rqd-detail__section-title');
              if (_activityTitle) {
                var _countEl = _activityTitle.querySelector('.rqd-notes-log__count');
                var _newCount = (allQuotes[idx].noteEntries || []).length;
                if (_countEl) {
                  _countEl.textContent = '(' + _newCount + ')';
                } else if (_newCount > 0) {
                  var _bumpBadge = document.createElement('span');
                  _bumpBadge.className = 'rqd-notes-log__count';
                  _bumpBadge.textContent = ' (' + _newCount + ')';
                  var _chev = _activityTitle.querySelector('.rqd-arap__chevron');
                  if (_chev) _activityTitle.insertBefore(_bumpBadge, _chev);
                  else _activityTitle.appendChild(_bumpBadge);
                }
              }
            }
          }
          if (indicator) {
            indicator.textContent = 'Saved ✓';
            indicator.dataset.state = 'saved';
            setTimeout(function() {
              if (indicator.dataset.state === 'saved') {
                indicator.textContent = '';
                indicator.dataset.state = 'idle';
              }
            }, 1500);
          }
        } else {
          /* Phase 1.19 — Surface the worker's error message so the CFA
             knows WHY the save failed (validation, ownership, etc.).
             Previously the indicator just said "Save failed" with no
             detail — invisible to anyone not in DevTools. */
          var _errMsg = (resp && resp.error) ? String(resp.error) : 'Unknown error';
          if (indicator) {
            indicator.textContent = 'Save failed';
            indicator.dataset.state = 'error';
            indicator.title = _errMsg;
          }
          if (window.console && console.warn) console.warn('[Discovery save] worker error:', _errMsg);
        }
      } catch (err) {
        var _excMsg = (err && err.message) ? String(err.message) : 'Network error';
        if (indicator) {
          indicator.textContent = 'Save failed';
          indicator.dataset.state = 'error';
          indicator.title = _excMsg;
        }
        if (window.console && console.warn) console.warn('[Discovery save] exception:', err);
      }
    }

    /** Flush any pending debounced save — called before Handoff or Archive
        fires so unsaved field edits don't get dropped. */
    async function _flushDiscoverySave() {
      if (_discoverySaveTimer) {
        clearTimeout(_discoverySaveTimer);
        _discoverySaveTimer = null;
        var ref = _discoveryPendingRef;
        _discoveryPendingRef = null;
        if (ref) await _runDiscoverySave(ref);
      }
    }

    // Input event delegate — schedule auto-save 750ms after the last
    // keystroke in any Discovery field. Indicator shows "Editing…" until
    // the timer fires.
    document.addEventListener('input', function(e) {
      var input = e.target;
      if (!input) return;
      var card = input.closest && input.closest('.rqd-prospect-discovery');
      if (!card || !input.classList || !input.classList.contains('rqd-bant-section__input')) return;
      var ref = card.dataset.ref;
      if (!ref) return;
      _discoveryPendingRef = ref;
      if (_discoverySaveTimer) clearTimeout(_discoverySaveTimer);
      var indicator = card.querySelector('.rqd-prospect-discovery__status');
      if (indicator && indicator.dataset.state !== 'saving') {
        indicator.textContent = 'Editing…';
        indicator.dataset.state = 'pending';
      }
      _discoverySaveTimer = setTimeout(function() {
        _discoverySaveTimer = null;
        _discoveryPendingRef = null;
        _runDiscoverySave(ref);
      }, 750);
    });

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Deal Prospecting
       action handlers: Archive, Handoff. Document-level delegation so
       they fire regardless of which row/detail panel was rendered.
       Each handler awaits _flushDiscoverySave first so any pending
       auto-save commits before the state transition. */
    document.addEventListener('click', async function(e) {
      /* Phase 1.15 — Make Authority button on an Enrichment card row.
         Picks that contact, copies name/title/email/phone into Discovery's
         authority sub-fields, saves, and the surgical UI updater refreshes
         the Discovery card + Prospect card + To-Do BANT chips in place. */
      var mkAuthBtn = e.target.closest('.rqd-prospect-enrichment__make-auth');
      if (mkAuthBtn) {
        e.preventDefault();
        var enrichRef = mkAuthBtn.dataset.ref;
        var enrichIdx = parseInt(mkAuthBtn.dataset.idx, 10);
        if (!enrichRef || isNaN(enrichIdx)) return;
        var enrichProspect = allQuotes.find(function(x) { return x.ref === enrichRef; });
        if (!enrichProspect || !enrichProspect.enrichment) return;
        var pickedContact = (enrichProspect.enrichment.contacts || [])[enrichIdx];
        if (!pickedContact) return;
        /* Phase 1.19 — Confirm before overwriting an existing Authority.
           Prevents accidental mis-click loss when the CFA has already
           picked + saved an Authority person. */
        var _curD = enrichProspect.discovery || {};
        var _curAuthName = (_curD.authorityName || '').trim();
        var _newAuthName = (pickedContact.name || '').trim();
        if (_curAuthName && _curAuthName.toLowerCase() !== _newAuthName.toLowerCase()) {
          var _ok = await rqdConfirm('The Discovery card, the Prospect card and the BANT chips all follow the Authority.', { title: 'Replace Authority "' + _curAuthName + '" with "' + (_newAuthName || '?') + '"?', confirmLabel: 'Replace' });
          if (!_ok) return;
        }
        // Flush any pending Discovery save so we don't race against an
        // in-flight debounce that could clobber the authority promotion.
        await _flushDiscoverySave();
        var prev = mkAuthBtn.textContent;
        mkAuthBtn.textContent = 'Setting…';
        mkAuthBtn.disabled = true;
        try {
          /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — promote writes BOTH
             layers. This used to set discovery.authority* only, leaving
             customer.* frozen at whatever the import wrote — the exact split
             that made the pencil show a blank name and the school switchboard
             while the card showed the real AD. Promoting a contact now moves
             the whole identity, so the card, the pencil, the Prospecting row and
             handoff eligibility all agree. Address fields are untouched — a
             contact is a person, not a location. */
          var resp = await API.post('/cfa-prospect-update', {
            ref: enrichRef,
            discovery: {
              authorityName:  pickedContact.name  || '',
              authorityTitle: pickedContact.title || '',
              authorityEmail: pickedContact.email || '',
              authorityPhone: pickedContact.phone || '',
            },
            customer: {
              name:  pickedContact.name  || '',
              email: pickedContact.email || '',
              phone: pickedContact.phone || '',
            },
          });
          if (resp && resp.success) {
            var enrichIdxQ = allQuotes.findIndex(function(x) { return x.ref === enrichRef; });
            if (enrichIdxQ >= 0) {
              allQuotes[enrichIdxQ].discovery = (resp.prospect && resp.prospect.discovery) || allQuotes[enrichIdxQ].discovery;
              allQuotes[enrichIdxQ].prospectStage = (resp.prospect && resp.prospect.prospectStage) || allQuotes[enrichIdxQ].prospectStage;
            }
            // Re-render the detail panel so the Enrichment row's badge
            // flips to "★ Authority" + Discovery card sub-fields update.
            var detailEnrichEl = document.getElementById('rqd-detail-' + enrichRef);
            if (detailEnrichEl) detailEnrichEl.innerHTML = buildProspectDetailHtml(allQuotes[enrichIdxQ]);
            // Also refresh parent row BANT chips.
            var _rowEnrichEl = tbody && tbody.querySelector('tr[data-ref="' + enrichRef + '"]');
            if (_rowEnrichEl) {
              var _bantSpanEnrich = _rowEnrichEl.querySelector('.rqd-bant');
              if (_bantSpanEnrich) {
                var _tmpEnrich = document.createElement('div');
                _tmpEnrich.innerHTML = _buildBantSpan(allQuotes[enrichIdxQ].discovery, allQuotes[enrichIdxQ].prospectStage);
                var _newSpanEnrich = _tmpEnrich.firstElementChild;
                if (_newSpanEnrich) _bantSpanEnrich.replaceWith(_newSpanEnrich);
              }
            }
          } else {
            mkAuthBtn.textContent = prev;
            mkAuthBtn.disabled = false;
            rqdAlert('Save failed: ' + ((resp && resp.error) || 'unknown'));
          }
        } catch (err) {
          mkAuthBtn.textContent = prev;
          mkAuthBtn.disabled = false;
          rqdAlert('Save failed: ' + (err && err.message ? err.message : 'unknown'));
        }
        return;
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — Delete Prospect (admin).
         Mirrors the Offline Deals cog's Delete Quote. A prospect IS a lead record
         with no draft order, so /delete-lead is the right endpoint — the same one
         handleDeleteQuote already calls for a pure NEW LEAD. It soft-deletes to
         trash (90-day restore), drops the ref from lead-index, releases the dupe
         index, and audits. Deliberately NOT /cfa-prospect-archive: Mark Lost keeps
         the record for reporting, this removes it — different intents, both wanted. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — master pencil on the
         Prospect card. Looks the row's record up from allQuotes the same way the
         offline pencil does, then hands off to the popup. */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — Contacts add / edit / remove.
         All three resolve the prospect from allQuotes the same way the pencil does. */
      var ctBtn = e.target.closest('[data-action="contact-add"], [data-action="contact-edit"], [data-action="contact-remove"]');
      if (ctBtn) {
        e.preventDefault();
        e.stopPropagation();
        var ctAct = ctBtn.dataset.action;
        var ctRef = ctBtn.dataset.ref;
        if (!ctRef) return;
        var ctRec = (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes))
          ? allQuotes.filter(function(x) { return x.ref === ctRef || x.reference === ctRef; })[0] : null;
        if (!ctRec) { rqdAlert('Could not find prospect ' + ctRef + ' — refresh and try again.'); return; }
        if (ctAct === 'contact-add') {
          if (typeof window.__openEditContact === 'function') window.__openEditContact(ctRec, null);
          return;
        }
        var ctIdx = parseInt(ctBtn.dataset.idx, 10);
        if (isNaN(ctIdx)) return;
        if (ctAct === 'contact-edit') {
          if (typeof window.__openEditContact === 'function') window.__openEditContact(ctRec, ctIdx);
          return;
        }
        // contact-remove
        var _list = _prospectContacts(ctRec).slice();
        var _gone = _list[ctIdx];
        if (!_gone) return;
        var _wasPrimary = _gone.email && _prospectPrimaryEmail(ctRec) === String(_gone.email).trim().toLowerCase();
        var _nl = String.fromCharCode(10);
        var _primaryWarn = _nl + _nl + 'This is the PRIMARY contact. Removing it here does NOT clear the Prospect card or the Authority fields — promote another contact, or edit them with the pencil.';
        if (!(await rqdConfirm((_wasPrimary ? _primaryWarn.replace(/^\n\n/, '') : 'The contact comes off this prospect.'),
            { title: 'Remove ' + (_gone.name || _gone.email || 'this contact') + ' from this prospect?', confirmLabel: 'Remove', danger: true }))) return;
        _list.splice(ctIdx, 1);
        (async function() {
          ctBtn.disabled = true;
          try {
            await API.post('/cfa-prospect-update', {
              ref: ctRef,
              enrichment: { contacts: _list, totalContactsFound: _list.length, enrichAttempted: !!(ctRec.enrichment && ctRec.enrichment.enrichAttempted) }
            });
            try { await fetchQuotes(); } catch (_) {}
          } catch (err) {
            ctBtn.disabled = false;
            rqdAlert('Remove failed: ' + (err && err.message ? err.message : 'unknown'));
          }
        })();
        return;
      }
      var epBtn = e.target.closest('[data-action="prospect-edit"]');
      if (epBtn) {
        e.preventDefault();
        e.stopPropagation();
        var epRef = epBtn.dataset.ref;
        if (!epRef) return;
        var epRec = (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes))
          ? allQuotes.filter(function(x) { return x.ref === epRef || x.reference === epRef; })[0]
          : null;
        if (!epRec) { rqdAlert('Could not find prospect ' + epRef + ' — refresh and try again.'); return; }
        if (typeof window.__openEditProspect === 'function') window.__openEditProspect(epRec);
        return;
      }
      var delProspectBtn = e.target.closest('.rqd-prospect-delete-btn');
      if (delProspectBtn) {
        e.preventDefault();
        var delRef = delProspectBtn.dataset.ref;
        if (!delRef) return;
        var delOrg = delProspectBtn.dataset.org || '';
        document.querySelectorAll('.rqd-actions-menu--open').forEach(function(m) { m.classList.remove('rqd-actions-menu--open'); });
        if (!(await rqdConfirm('This removes the prospect record and all its discovery, notes, and activity.\n\n' +
                     'To close it out but keep it for reporting, use Mark Lost instead.',
            { title: 'Permanently delete prospect ' + delRef + (delOrg ? ' (' + delOrg + ')' : '') + '?', confirmLabel: 'Delete permanently', cancelLabel: 'Keep it', danger: true }))) return;
        (async function() {
          var prevTxt = delProspectBtn.textContent;
          delProspectBtn.disabled = true;
          delProspectBtn.textContent = 'Deleting…';
          try {
            await API.post('/delete-lead', { ref: delRef });
            // Same optimistic-removal + tombstone path the quote delete uses —
            // KV propagation can lag the delete by tens of seconds, and without
            // the tombstone the row reappears on the next refresh.
            markRefDeleted(delRef);
            if (typeof allQuotes !== 'undefined' && Array.isArray(allQuotes)) {
              allQuotes = allQuotes.filter(function(x) { return x.reference !== delRef && x.ref !== delRef; });
            }
            try { await fetchQuotes(); } catch (_) {}
          } catch (err) {
            delProspectBtn.disabled = false;
            delProspectBtn.textContent = prevTxt;
            rqdAlert('Delete failed: ' + (err && err.message ? err.message : 'unknown'));
          }
        })();
        return;
      }
      var archBtn = e.target.closest('.rqd-prospect-archive-btn');
      if (archBtn) {
        e.preventDefault();
        var ref2 = archBtn.dataset.ref;
        if (!ref2) return;
        // Phase 1.27 — Replaced the browser prompt() with a centered
        // in-app modal that requires a reason before formalizing the
        // archive. Browser prompts feel out-of-style with the rest of
        // the portal and an optional reason left half the lost-stage
        // records with no context for later review.
        openProspectArchiveModal(ref2);
        return;
      }
      var hoBtn = e.target.closest('.rqd-prospect-handoff-btn');
      if (hoBtn) {
        e.preventDefault();
        if (hoBtn.disabled) return;
        // Flush any pending auto-save before opening the handoff modal so
        // the qualified gate evaluates against the latest field values.
        await _flushDiscoverySave();
        openProspectHandoffModal(hoBtn.dataset.ref);
        return;
      }
      /* Feature C — reassign a prospect to another CFA (stage unchanged). */
      var xferBtn = e.target.closest('.rqd-prospect-transfer-btn');
      if (xferBtn) {
        e.preventDefault();
        if (xferBtn.disabled) return;
        openProspectTransferModal(xferBtn.dataset.ref);
        return;
      }
      // Phase 1.30 — Address pencil / Save / Cancel on the Prospect card.
    });

    /* Phase 1.27 — Archive (Lost) modal — centered in-app dialog that
       requires a reason before POST /cfa-prospect-archive. Mirrors the
       handoff modal chrome (rqd-modal-backdrop + rqd-modal-* classes,
       Cancel + primary action buttons) so it feels like part of the
       portal instead of the OS-flavored prompt(). */
    async function openProspectArchiveModal(ref) {
      var p = allQuotes.find(function(x) { return x.ref === ref; });
      if (!p) return;
      var existing = document.getElementById('rqd-prospect-archive-modal');
      if (existing) existing.remove();

      var orgLabel = (p.customer && p.customer.organization) || p.ref;

      var backdrop = document.createElement('div');
      backdrop.id = 'rqd-prospect-archive-modal';
      backdrop.className = 'rqd-modal-backdrop rqd-modal-backdrop--open';
      backdrop.innerHTML =
        '<div class="rqd-modal">' +
          '<h2 class="rqd-modal__title">💀 Archive as Lost</h2>' +
          '<p class="rqd-modal__sub">' + esc(orgLabel) + ' — flips this prospect to LOST. Reason is required so the record carries context for later review.</p>' +
          '<div class="rqd-modal__body">' +
            '<label class="rqd-modal__label" style="margin-bottom:6px;">Reason <span style="color:#dc2626;">*</span></label>' +
            '<textarea id="rqd-prospect-archive-reason" rows="4" class="rqd-modal__input" placeholder="No budget · ghosting · went with competitor · bad fit · etc." style="resize:vertical;"></textarea>' +
          '</div>' +
          '<div class="rqd-modal__actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:14px;">' +
            '<button type="button" id="rqd-prospect-archive-cancel" class="rqd-modal__btn">Cancel</button>' +
            '<button type="button" id="rqd-prospect-archive-confirm" class="rqd-modal__btn rqd-modal__btn--primary" disabled>Archive (Lost)</button>' +
          '</div>' +
        '</div>';
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      var reasonEl = backdrop.querySelector('#rqd-prospect-archive-reason');
      var confirmBtn = backdrop.querySelector('#rqd-prospect-archive-confirm');
      var cancelBtn = backdrop.querySelector('#rqd-prospect-archive-cancel');

      reasonEl.focus();
      reasonEl.addEventListener('input', function() {
        confirmBtn.disabled = !(reasonEl.value && reasonEl.value.trim());
      });

      cancelBtn.addEventListener('click', function() { backdrop.remove(); });
      // Backdrop click closes; click on the modal panel itself does not.
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
      backdrop.addEventListener('click', function(ev) { if (window.RepPortal.dismissedOnBackdrop(ev, backdrop)) backdrop.remove(); });

      confirmBtn.addEventListener('click', async function() {
        var reason = (reasonEl.value || '').trim();
        if (!reason) {
          reasonEl.focus();
          return;
        }
        var prev = confirmBtn.textContent;
        confirmBtn.textContent = 'Archiving…';
        confirmBtn.disabled = true;
        cancelBtn.disabled = true;
        // Flush any pending Discovery auto-save so the archived record
        // reflects the latest field edits.
        try { await _flushDiscoverySave(); } catch (_) {}
        try {
          var resp2 = await API.post('/cfa-prospect-archive', { ref: ref, reason: reason });
          if (resp2 && resp2.success) {
            var idx2 = allQuotes.findIndex(function(x) { return x.ref === ref; });
            if (idx2 >= 0) {
              allQuotes[idx2].prospectStage = 'lost';
              allQuotes[idx2].archivedAt = (resp2.prospect && resp2.prospect.archivedAt) || new Date().toISOString();
              allQuotes[idx2].archiveReason = reason;
              // Phase 1.27 — Clear the active follow-up locally so the
              // To-Do countdown drops immediately (worker also nulls
              // lead.followUp on archive). Use the worker's echoed
              // record when present in case server-side fields shift.
              allQuotes[idx2].followUp = (resp2.prospect && 'followUp' in resp2.prospect)
                ? resp2.prospect.followUp
                : null;
              if (resp2.prospect && Array.isArray(resp2.prospect.noteEntries)) {
                allQuotes[idx2].noteEntries = resp2.prospect.noteEntries;
              }
            }
            // Phase 1.38 — Apply the active stage filter so an "All"
            // view still excludes LOST records after an archive.
            _syncProspectFilters(); _renderProspectView(); /* refresh toggle/pills/footer + respect the current view (was: bare renderProspectTable → view/content divergence from Follow Up) */
            backdrop.remove();
          } else {
            confirmBtn.textContent = prev;
            confirmBtn.disabled = false;
            cancelBtn.disabled = false;
            rqdAlert('Archive failed: ' + ((resp2 && resp2.error) || 'unknown'));
          }
        } catch (err) {
          confirmBtn.textContent = prev;
          confirmBtn.disabled = false;
          cancelBtn.disabled = false;
          rqdAlert('Archive failed: ' + (err && err.message ? err.message : 'unknown'));
        }
      });
    }

    /* Handoff modal — pick rep + add notes → POST /cfa-prospect-handoff. */
    async function openProspectHandoffModal(ref) {
      var p = allQuotes.find(function(x) { return x.ref === ref; });
      if (!p) return;
      // Remove any prior modal instance.
      var existing = document.getElementById('rqd-prospect-handoff-modal');
      if (existing) existing.remove();

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-11) — the picker now reflects this
         CFA's admin-set offload targets: only reps they're allowed to hand off to, and
         the Auto option only if Auto is enabled for them. /cfa-offload-options works for
         CFAs (unlike admin-only /rep-list) and resolves the allow-list + names server-
         side; /cfa-prospect-handoff enforces the same rule regardless. */
      var offloadOpts = { auto: true, reps: [] };
      try {
        offloadOpts = await API.get('/cfa-offload-options') || offloadOpts;
      } catch (_) { /* fallback: auto-only (server still routes via assignLead) */ offloadOpts = { auto: true, reps: [] }; }
      var reps = offloadOpts.reps || [];
      var offloadAuto = offloadOpts.auto !== false;

      var backdrop = document.createElement('div');
      backdrop.id = 'rqd-prospect-handoff-modal';
      backdrop.className = 'rqd-modal-backdrop rqd-modal-backdrop--open';
      backdrop.innerHTML =
        '<div class="rqd-modal rqd-modal--wide">' +
          '<h2 class="rqd-modal__title">Hand off to Rep</h2>' +
          '<p class="rqd-modal__sub">' + esc(p.customer && p.customer.organization || p.ref) + ' — flips prospect to HANDOFF and lights up as NEW LEAD on the rep\'s dashboard.</p>' +
          '<div class="rqd-modal__body">' +
            '<label style="display:block;margin-bottom:6px;font-weight:700;">Rep <span style="font-weight:400;font-style:italic;color:var(--rq-text-secondary);">— ' + (offloadAuto ? 'leave on auto to let the territory cascade pick' : 'choose one of your assigned reps') + '</span></label>' +
            '<select id="rqd-prospect-handoff-rep" style="width:100%;padding:8px;border-radius:6px;border:1px solid var(--rq-border);background:var(--rq-bg-surface);color:var(--rq-text);margin-bottom:12px;">' +
              (offloadAuto ? '<option value="">— Auto (territory cascade) —</option>' : '') +
              reps.map(function(r) {
                var code = r.code || r.initials;
                return '<option value="' + esc(code) + '">' + esc((r.name || r.fullName || code) + ' (' + code + ')') + '</option>';
              }).join('') +
            '</select>' +
            '<label style="display:block;margin-bottom:6px;font-weight:700;">Handoff notes <span style="font-weight:400;font-style:italic;color:var(--rq-text-secondary);">— context for the rep, included in the NEW LEAD email</span></label>' +
            '<textarea id="rqd-prospect-handoff-notes" rows="4" style="width:100%;padding:9px;border-radius:6px;border:1px solid var(--rq-border);background:var(--rq-bg-surface);color:var(--rq-text);box-sizing:border-box;" placeholder="What did you learn? Decision maker, timing, quirks, what they want quoted."></textarea>' +
          '</div>' +
          '<div class="rqd-modal__actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:14px;">' +
            '<button type="button" id="rqd-prospect-handoff-cancel" class="rqd-modal__btn">Cancel</button>' +
            '<button type="button" id="rqd-prospect-handoff-confirm" class="rqd-modal__btn rqd-modal__btn--primary">🎯 Hand off</button>' +
          '</div>' +
        '</div>';
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      backdrop.querySelector('#rqd-prospect-handoff-cancel').addEventListener('click', function() { backdrop.remove(); });
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
      backdrop.addEventListener('click', function(ev) { if (window.RepPortal.dismissedOnBackdrop(ev, backdrop)) backdrop.remove(); });
      backdrop.querySelector('#rqd-prospect-handoff-confirm').addEventListener('click', async function() {
        var btn = this;
        var repCode = backdrop.querySelector('#rqd-prospect-handoff-rep').value || '';
        var notes = backdrop.querySelector('#rqd-prospect-handoff-notes').value || '';
        var prev = btn.textContent; btn.textContent = 'Handing off…'; btn.disabled = true;
        try {
          var resp = await API.post('/cfa-prospect-handoff', { ref: ref, repCode: repCode, notes: notes });
          if (resp && resp.success) {
            var idx = allQuotes.findIndex(function(x) { return x.ref === ref; });
            if (idx >= 0) {
              allQuotes[idx] = Object.assign({}, allQuotes[idx], resp.prospect || {});
              allQuotes[idx].prospectStage = 'handoff';
              allQuotes[idx].handoffTo = resp.assignee;
            }
            // Phase 1.38 — Apply the active stage filter so an "All"
            // view still excludes LOST records after a handoff (and
            // the freshly handed-off record stays visible only if the
            // current filter shows handoff stage — which 'All' does).
            _syncProspectFilters(); _renderProspectView(); /* refresh toggle/pills/footer + respect the current view (was: bare renderProspectTable → view/content divergence from Follow Up) */
            backdrop.remove();
            // Phase 1.39 — Confirmation alert removed; the row's
            // stage pill flipping to HANDOFF + the modal closing is
            // already enough visual feedback. The blocking OK click
            // was friction.
          } else {
            btn.textContent = prev; btn.disabled = false;
            rqdAlert('Handoff failed: ' + ((resp && resp.error) || 'unknown'));
          }
        } catch (err) {
          btn.textContent = prev; btn.disabled = false;
          rqdAlert('Handoff failed: ' + (err && err.message ? err.message : 'unknown'));
        }
      });
    }

    /* Feature C (Ryan 2026-07-11) — Transfer-to-CFA modal. Reassigns a prospect's
       ownership from one CFA to another WITHOUT touching its stage (unlike Handoff,
       which promotes a Qualified prospect to a rep's NEW LEAD). Admin sees every CFA;
       an owning CFA can move it to a peer. Picker is fed by /cfa-list (available to any
       authenticated rep); the current owner is excluded. Server enforces ownership +
       terminal-stage guard on POST /cfa-prospect-transfer. */
    async function openProspectTransferModal(ref) {
      var p = allQuotes.find(function(x) { return x.ref === ref; });
      if (!p) return;
      var existing = document.getElementById('rqd-prospect-transfer-modal');
      if (existing) existing.remove();

      var curOwner = (p.cfaCode || '').toUpperCase();
      var cfaList = [];
      try {
        var _resp = await API.get('/cfa-list?all=1');
        cfaList = (_resp && (_resp.cfas || _resp.reps || _resp.list)) || [];
      } catch (_) { cfaList = []; }
      // Exclude the current owner — you can't transfer to yourself.
      var options = cfaList.filter(function(r) {
        var code = (r.code || r.initials || '').toUpperCase();
        return code && code !== curOwner;
      });

      var backdrop = document.createElement('div');
      backdrop.id = 'rqd-prospect-transfer-modal';
      backdrop.className = 'rqd-modal-backdrop rqd-modal-backdrop--open';
      var orgLabel = (p.customer && p.customer.organization) || p.ref;
      var body;
      if (!options.length) {
        body = '<p class="rqd-modal__sub">No other CFA is available to receive this prospect. Add a second CFA in Settings first.</p>';
      } else {
        body =
          '<p class="rqd-modal__sub">' + esc(orgLabel) + ' — moves ownership from <strong>' + esc(curOwner || '(unassigned)') + '</strong> to another CFA. Stage stays <strong>' + esc((_prospectStageLabels[p.prospectStage] || (p.prospectStage || 'cold').toUpperCase())) + '</strong>; this is NOT a handoff to a rep.</p>' +
          '<div class="rqd-modal__body">' +
            '<label style="display:block;margin-bottom:6px;font-weight:700;">Transfer to CFA</label>' +
            '<select id="rqd-prospect-transfer-cfa" style="width:100%;padding:8px;border-radius:6px;border:1px solid var(--rq-border);background:var(--rq-bg-surface);color:var(--rq-text);margin-bottom:12px;">' +
              options.map(function(r) {
                var code = (r.code || r.initials || '').toUpperCase();
                return '<option value="' + esc(code) + '">' + esc((r.name || r.fullName || code) + ' (' + code + ')') + '</option>';
              }).join('') +
            '</select>' +
            '<label style="display:block;margin-bottom:6px;font-weight:700;">Note <span style="font-weight:400;font-style:italic;color:var(--rq-text-secondary);">— optional, logged on the activity trail</span></label>' +
            '<textarea id="rqd-prospect-transfer-notes" rows="3" style="width:100%;padding:9px;border-radius:6px;border:1px solid var(--rq-border);background:var(--rq-bg-surface);color:var(--rq-text);box-sizing:border-box;" placeholder="Why is this moving? (going on leave, logged by the wrong CFA, territory swap, etc.)"></textarea>' +
          '</div>';
      }
      backdrop.innerHTML =
        '<div class="rqd-modal">' +
          '<h2 class="rqd-modal__title">🔄 Transfer to CFA</h2>' +
          body +
          '<div class="rqd-modal__actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:14px;">' +
            '<button type="button" id="rqd-prospect-transfer-cancel" class="rqd-modal__btn">' + (options.length ? 'Cancel' : 'Close') + '</button>' +
            (options.length ? '<button type="button" id="rqd-prospect-transfer-confirm" class="rqd-modal__btn rqd-modal__btn--primary">🔄 Transfer</button>' : '') +
          '</div>' +
        '</div>';
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      backdrop.querySelector('#rqd-prospect-transfer-cancel').addEventListener('click', function() { backdrop.remove(); });
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
      backdrop.addEventListener('click', function(ev) { if (window.RepPortal.dismissedOnBackdrop(ev, backdrop)) backdrop.remove(); });
      var confirmBtn = backdrop.querySelector('#rqd-prospect-transfer-confirm');
      if (confirmBtn) confirmBtn.addEventListener('click', async function() {
        var btn = this;
        var toCfaCode = backdrop.querySelector('#rqd-prospect-transfer-cfa').value || '';
        var notes = backdrop.querySelector('#rqd-prospect-transfer-notes').value || '';
        if (!toCfaCode) return;
        var prev = btn.textContent; btn.textContent = 'Transferring…'; btn.disabled = true;
        try {
          var resp = await API.post('/cfa-prospect-transfer', { ref: ref, toCfaCode: toCfaCode, notes: notes });
          if (resp && resp.success) {
            var idx = allQuotes.findIndex(function(x) { return x.ref === ref; });
            if (idx >= 0) {
              allQuotes[idx].cfaCode = resp.toCfaCode || toCfaCode;
              allQuotes[idx].cfaName = resp.toName || allQuotes[idx].cfaName;
              if (resp.prospect && Array.isArray(resp.prospect.noteEntries)) {
                allQuotes[idx].noteEntries = resp.prospect.noteEntries;
              }
              // If the viewer is a CFA (not admin), the transferred-away
              // prospect no longer belongs to them — drop it from the list.
              if (!isAdmin) allQuotes.splice(idx, 1);
            }
            _syncProspectFilters(); _renderProspectView();
            backdrop.remove();
          } else {
            btn.textContent = prev; btn.disabled = false;
            rqdAlert('Transfer failed: ' + ((resp && resp.error) || 'unknown'));
          }
        } catch (err) {
          btn.textContent = prev; btn.disabled = false;
          rqdAlert('Transfer failed: ' + (err && err.message ? err.message : 'unknown'));
        }
      });
    }
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE (Deal Prospecting handlers) */

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — + New Prospect modal
       (manual entry from a cold call, walk-up, networking event, etc.).
       Same anatomy as the other "+ New" modals but POSTs /cfa-prospect-create
       and refreshes the prospect table on success. */
    window.__openNewProspect = function(e) {
      if (e) e.stopPropagation();
      // Close the + New menu.
      var menu = document.getElementById('rqd-new-menu');
      if (menu) menu.style.display = 'none';

      // Strip any prior instance.
      var existing = document.getElementById('rqd-new-prospect-modal');
      if (existing) existing.remove();

      var backdrop = document.createElement('div');
      backdrop.id = 'rqd-new-prospect-modal';
      backdrop.className = 'rqd-modal-backdrop rqd-modal-backdrop--open';
      backdrop.innerHTML =
        '<div class="rqd-modal rqd-modal--wide">' +
          '<h2 class="rqd-modal__title">New Prospect</h2>' +
          '<p class="rqd-modal__sub">Log a fresh cold contact. Lands at COLD; advance with discovery + activity, then hand off to a rep when qualified.</p>' +
          '<div class="rqd-modal__body" style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">' +
            '<div style="grid-column:1/-1;"><label class="rqd-modal__label">Organization</label><input type="text" id="rqd-np-org" class="rqd-modal__input" placeholder="School / Org name (leave blank for residential)" maxlength="300"></div>' +
            '<div style="grid-column:1/-1;"><label style="display:flex;align-items:center;gap:8px;font-weight:600;font-size:12px;cursor:pointer;color:var(--rq-text);"><input type="checkbox" id="rqd-np-residential" style="width:auto;margin:0;cursor:pointer;"> Residential <span style="font-weight:400;color:var(--rq-text-secondary);font-style:italic;">— home gym / individual buyer (no org)</span></label></div>' +
            '<div><label class="rqd-modal__label">Contact Name</label><input type="text" id="rqd-np-name" class="rqd-modal__input" maxlength="200"></div>' +
            '<div><label class="rqd-modal__label">Title</label><input type="text" id="rqd-np-title" class="rqd-modal__input" placeholder="Decision maker role" maxlength="200"></div>' +
            '<div><label class="rqd-modal__label">Email (comma separated)</label><input type="email" id="rqd-np-email" class="rqd-modal__input" maxlength="200"></div>' +
            '<div><label class="rqd-modal__label">Phone</label><input type="tel" id="rqd-np-phone" class="rqd-modal__input" placeholder="(555) 123-4567" maxlength="30"></div>' +
            '<div style="grid-column:1/-1;display:grid;grid-template-columns:1fr 2fr 1fr;gap:10px;">' +
              '<div><label class="rqd-modal__label">Zip Code <span style="font-weight:400;text-transform:none;letter-spacing:0;color:var(--rq-text-secondary);">(autofills)</span></label><input type="text" id="rqd-np-zip" class="rqd-modal__input" placeholder="80021" maxlength="5" inputmode="numeric" pattern="[0-9]{5}"></div>' +
              '<div><label class="rqd-modal__label">City <span style="font-weight:400;text-transform:none;letter-spacing:0;color:var(--rq-text-secondary);">(auto)</span></label><input type="text" id="rqd-np-city" class="rqd-modal__input" maxlength="120"></div>' +
              '<div><label class="rqd-modal__label">State <span style="color:#dc2626;">*</span></label><input type="text" id="rqd-np-state" class="rqd-modal__input" placeholder="CO" maxlength="4" style="text-transform:uppercase;"></div>' +
            '</div>' +
            '<div style="grid-column:1/-1;"><label class="rqd-modal__label">Initial note (optional)</label><textarea id="rqd-np-note" class="rqd-modal__input" rows="2" placeholder="What you learned on first touch — e.g. \'cold call, AD said reach out in spring\'."></textarea></div>' +
          '</div>' +
          '<div class="rqd-modal__actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:14px;">' +
            '<button type="button" id="rqd-np-cancel" class="rqd-modal__btn">Cancel</button>' +
            '<button type="button" id="rqd-np-confirm" class="rqd-modal__btn rqd-modal__btn--primary">Create Prospect</button>' +
          '</div>' +
        '</div>';
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      backdrop.querySelector('#rqd-np-cancel').addEventListener('click', function() { backdrop.remove(); });
      // Ryan 2026-05-17 — backdrop-click-to-close removed. CFAs only dismiss
      // via the Cancel button; prevents accidental field-data loss when
      // they mis-click outside the modal mid-typing.
      backdrop.querySelector('#rqd-np-org').focus();

      // Live phone formatting on the Phone input — matches the Authority
      // Phone behavior in the Discovery card (Ryan 2026-05-17).
      var _npPhoneIn = backdrop.querySelector('#rqd-np-phone');
      if (_npPhoneIn) {
        _npPhoneIn.addEventListener('input', function() {
          var raw = this.value || '';
          var caret = this.selectionStart || raw.length;
          var dbc = (raw.slice(0, caret).match(/\d/g) || []).length;
          var f = _formatAsUsPhone(raw);
          if (f === raw) return;
          this.value = f;
          var seen = 0, nc = f.length;
          for (var i = 0; i < f.length; i++) {
            if (/\d/.test(f[i])) { seen++; if (seen === dbc) { nc = i + 1; break; } }
          }
          if (dbc === 0) nc = f.length;
          try { this.setSelectionRange(nc, nc); } catch (_) {}
        });
      }

      // Residential checkbox — when ticked, auto-fills Organization with
      // "n/a - residence" so the field always carries a value (matches the
      // rep-side __openNewLead pattern + isResidentialOrg() detector).
      // Unchecking clears only when the input still holds the auto-fill
      // value, so a CFA's manual edit isn't wiped.
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — chip-style multi-email on
         the +New Pending email field (comma-separated, first = primary). */
      var _npEmailChips = null;
      (function() {
        var npEmailEl = backdrop.querySelector('#rqd-np-email');
        if (npEmailEl && window.RepPortal && window.RepPortal.installChipField) {
          _npEmailChips = window.RepPortal.installChipField({ replace: npEmailEl, placeholder: 'john@example.com', ariaLabel: 'Customer email addresses' });
        }
      })();

      var _npResCb = backdrop.querySelector('#rqd-np-residential');
      var _npOrgIn = backdrop.querySelector('#rqd-np-org');
      if (_npResCb && _npOrgIn) {
        _npResCb.addEventListener('change', function() {
          if (this.checked) {
            if (!_npOrgIn.value || _npOrgIn.value.trim() === '') _npOrgIn.value = 'n/a - residence';
          } else if (_npOrgIn.value === 'n/a - residence') {
            _npOrgIn.value = '';
          }
        });
      }

      // Zip → City + State auto-lookup. Mirrors the __openNewLead pattern
      // (zippopotam.us, 350ms debounce). Empty city/state inputs get
      // autofilled; non-empty values left alone so the CFA's manual entry
      // wins over the lookup.
      var _npZipIn   = backdrop.querySelector('#rqd-np-zip');
      var _npCityIn  = backdrop.querySelector('#rqd-np-city');
      var _npStateIn = backdrop.querySelector('#rqd-np-state');
      var _npZipDebounce;
      if (_npZipIn) {
        _npZipIn.addEventListener('input', function() {
          var z = this.value.replace(/\D/g, '').substring(0, 5);
          this.value = z;
          clearTimeout(_npZipDebounce);
          if (z.length < 5) return;
          _npZipDebounce = setTimeout(function() {
            fetch('https://api.zippopotam.us/us/' + z)
              .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
              .then(function(data) {
                var p = data.places && data.places[0] || {};
                if (_npStateIn && p['state abbreviation'] && !_npStateIn.value) _npStateIn.value = p['state abbreviation'];
                if (_npCityIn  && p['place name']        && !_npCityIn.value)  _npCityIn.value  = p['place name'];
              })
              .catch(function() {});
          }, 350);
        });
      }

      backdrop.querySelector('#rqd-np-confirm').addEventListener('click', async function() {
        var btn = this;
        var org = backdrop.querySelector('#rqd-np-org').value.trim();
        var state = backdrop.querySelector('#rqd-np-state').value.trim().toUpperCase();
        var isResidential = !!backdrop.querySelector('#rqd-np-residential').checked;
        // Ryan 2026-05-17 — Org no longer mandatory when Residential is
        // checked (the checkbox auto-fills "n/a - residence" anyway, but
        // we also accept a blank org + residential as valid). For B2B
        // entries, Org is still required.
        if (!org && !isResidential) {
          rqdAlert('Organization is required — or tick Residential for an individual / home gym buyer.');
          backdrop.querySelector('#rqd-np-org').focus();
          return;
        }
        if (!org && isResidential) org = 'n/a - residence';
        if (!state) { rqdAlert('State is required for territory routing later.'); backdrop.querySelector('#rqd-np-state').focus(); return; }

        var prev = btn.textContent; btn.textContent = 'Creating…'; btn.disabled = true;
        var payload = {
          organization: org,
          state: state,
          name: backdrop.querySelector('#rqd-np-name').value.trim(),
          email: _npEmailChips ? _npEmailChips.getValue() : backdrop.querySelector('#rqd-np-email').value.trim(),
          phone: backdrop.querySelector('#rqd-np-phone').value.trim(),
          city: backdrop.querySelector('#rqd-np-city').value.trim(),
          zip: (backdrop.querySelector('#rqd-np-zip').value || '').trim(),
          message: backdrop.querySelector('#rqd-np-note').value.trim(),
          prospectSource: 'manual',
          residentialOrCommercial: isResidential ? 'residential' : 'commercial',
          discovery: {
            authorityName:  backdrop.querySelector('#rqd-np-name').value.trim(),
            authorityTitle: backdrop.querySelector('#rqd-np-title').value.trim(),
            authorityEmail: _npEmailChips ? _npEmailChips.primary() : backdrop.querySelector('#rqd-np-email').value.trim(),
            authorityPhone: backdrop.querySelector('#rqd-np-phone').value.trim(),
          },
        };
        try {
          var resp = await API.post('/cfa-prospect-create', payload);
          if (resp && resp.success) {
            if (resp.alreadyExists) {
              rqdAlert('Prospect already in your CRM — opening existing record ' + resp.ref);
            }
            // Refresh the table so the new prospect shows up.
            backdrop.remove();
            await fetchQuotes();
          } else {
            btn.textContent = prev; btn.disabled = false;
            rqdAlert('Create failed: ' + ((resp && resp.error) || 'unknown'));
          }
        } catch (err) {
          btn.textContent = prev; btn.disabled = false;
          // 409 conflict — different CFA already owns this prospect. Surface
          // the worker's error message verbatim so the rep sees who owns it.
          var msg = (err && err.message) || 'unknown';
          rqdAlert(msg);
        }
      });
    };

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17) — Phase 1.5 import pickers.
       Both modals call directly into the leadfinder / leadgen workers using
       the same JWT the dashboard already uses. Multi-select → loop
       /cfa-prospect-create. Worker dedupes same-CFA via first-logged-wins
       (alreadyExists:true) so re-imports are safe. */

    /** Shared bulk-import loop. Calls /cfa-prospect-create per pick,
        accumulates {ok, skipped, failed} counts, returns a summary. */
    async function _bulkImportProspects(picks, importLabel) {
      var ok = 0, skipped = 0, failed = 0;
      var failures = [];
      for (var i = 0; i < picks.length; i++) {
        try {
          var resp = await API.post('/cfa-prospect-create', picks[i]);
          if (resp && resp.alreadyExists) skipped++;
          else if (resp && resp.success) ok++;
          else { failed++; failures.push((picks[i].organization || '?') + ': ' + ((resp && resp.error) || 'unknown')); }
        } catch (err) {
          failed++;
          failures.push((picks[i].organization || '?') + ': ' + (err && err.message ? err.message : 'unknown'));
        }
      }
      var msg = importLabel + ' done.\n\n' + ok + ' imported · ' + skipped + ' already in your CRM (skipped) · ' + failed + ' failed';
      if (failures.length > 0) msg += '\n\nFailures:\n' + failures.slice(0, 6).join('\n');
      if (failures.length > 6) msg += '\n... and ' + (failures.length - 6) + ' more';
      return msg;
    }

    /** Pull the JWT off the auth session so we can hit the leadfinder /
        leadgen workers directly (they're not behind rfq-worker — separate
        Cloudflare workers). Returns null if no session. */
    function _getJwtForImport() {
      var sess = Auth.getSession();
      return sess && (sess.accessToken || sess.jwt) || null;
    }

    /** Map a Lead Finder record → /cfa-prospect-create payload.
        Phase 1.21 — don't auto-promote any enriched contact to "Authority".
        The CFA picks Authority manually via the Enrichment card's
        Make Authority button (or types in their own findings as they
        research). Prospect card top-level name/email stay blank;
        org-level phone stamps if present (the main switchboard number,
        not an individual's). All enriched contacts ride through as
        `enrichment` so the CFA has the picker. */
    function _mapLeadFinderRecord(lead) {
      var summary = (lead.summary || '').trim();
      var msg = summary;
      if (lead.urgencyNote) msg = (msg ? msg + '\n\n' : '') + 'Urgency: ' + lead.urgencyNote;
      if (lead.priorityReason) msg = (msg ? msg + '\n\n' : '') + 'Why this lead: ' + lead.priorityReason;
      return {
        organization: lead.schoolName || '',
        name: '',
        email: '',
        phone: lead.phone || '',
        city: lead.city || '',
        state: (lead.state || '').toUpperCase(),
        zip: lead.zip || '',
        street: lead.street || '',
        message: msg.slice(0, 5000),
        prospectSource: 'lead-finder',
        prospectSourceRef: {
          tool: 'lead-finder',
          recordId: String(lead.id || ''),
          url: lead.sourceUrl || lead.schoolWebsite || '',
        },
      };
    }

    /** Map a Lead Generator record → /cfa-prospect-create payload.
        leadgen records carry phone/email/website at the top level; if the
        record was enriched, contacts[] may exist with named people.
        Phase 1.21 — don't auto-promote any enriched contact to Authority.
        The CFA picks Authority manually via Make Authority OR types in
        their own findings. Prospect card name/email blank; phone uses
        the organization-level number only (Google Maps switchboard, not
        an individual's). Enrichment array still rides through so the
        CFA has the picker. */
    function _mapLeadGenRecord(lead) {
      var contacts = Array.isArray(lead.contacts) ? lead.contacts : [];
      var payload = {
        organization: lead.name || '',
        name: '',
        email: '',
        phone: lead.phone || '',
        city: lead.city || '',
        state: (lead.state || '').toUpperCase(),
        zip: lead.zip || '',
        street: lead.address || '',
        message: lead.website ? ('Website: ' + lead.website + (lead.category ? ' · ' + lead.category : '')) : (lead.category || ''),
        prospectSource: 'lead-generator',
        prospectSourceRef: {
          tool: 'lead-generator',
          recordId: String(lead.placeId || ''),
          url: lead.website || '',
        },
      };
      if (contacts.length > 0 || lead.enrichAttempted) {
        payload.enrichment = {
          contacts: contacts.map(function(c) {
            return {
              name:  c && c.name  || '',
              title: c && c.title || '',
              email: c && c.email || '',
              phone: c && c.phone || '',
              type:  c && c.type  || '',
            };
          }),
          totalContactsFound: lead.totalContactsFound || contacts.length,
          enrichAttempted: !!lead.enrichAttempted,
        };
      }
      return payload;
    }

    /** Build the modal chrome + checkbox list rows for either picker. */
    function _renderImportPickerModal(opts) {
      var existing = document.getElementById('rqd-prospect-import-modal');
      if (existing) existing.remove();

      var backdrop = document.createElement('div');
      backdrop.id = 'rqd-prospect-import-modal';
      backdrop.className = 'rqd-modal-backdrop rqd-modal-backdrop--open';
      backdrop.innerHTML =
        '<div class="rqd-modal rqd-modal--wide" style="max-width:760px;">' +
          '<h2 class="rqd-modal__title">' + opts.title + '</h2>' +
          '<p class="rqd-modal__sub">' + opts.subtitle + '</p>' +
          '<div class="rqd-prospect-import__header" style="display:flex;gap:8px;align-items:center;padding:8px 0;border-bottom:1px solid var(--rq-border);">' +
            '<label style="display:inline-flex;align-items:center;gap:6px;font-weight:700;font-size:12px;cursor:pointer;"><input type="checkbox" id="rqd-import-toggle-all"> Select all</label>' +
            '<span class="rqd-prospect-import__count" id="rqd-import-count" style="margin-left:auto;font-size:12px;color:var(--rq-text-secondary);">0 selected</span>' +
          '</div>' +
          '<div id="rqd-import-body" class="rqd-prospect-import__body" style="max-height:50vh;overflow-y:auto;padding:6px 0;">' +
            '<div style="padding:20px;text-align:center;color:var(--rq-text-secondary);">Loading…</div>' +
          '</div>' +
          '<div class="rqd-modal__actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:14px;">' +
            '<button type="button" id="rqd-import-cancel" class="rqd-modal__btn">Cancel</button>' +
            '<button type="button" id="rqd-import-confirm" class="rqd-modal__btn rqd-modal__btn--primary" disabled>Import 0</button>' +
          '</div>' +
        '</div>';
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);
      backdrop.querySelector('#rqd-import-cancel').addEventListener('click', function() { backdrop.remove(); });
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-25) — both ends of the gesture must be on the backdrop; a drag out of the dialog (selecting a quantity) must not close it. See custom-rep-portal.js. */
      backdrop.addEventListener('click', function(ev) { if (window.RepPortal.dismissedOnBackdrop(ev, backdrop)) backdrop.remove(); });
      return backdrop;
    }

    /** Wire common select-all + count + confirm-button behavior on a
        rendered picker. `getPayloads()` returns the array of prospect-
        create payloads for the currently-checked rows. */
    function _wireImportPicker(backdrop, getPayloads, importLabel) {
      var bodyEl = backdrop.querySelector('#rqd-import-body');
      var countEl = backdrop.querySelector('#rqd-import-count');
      var confirmBtn = backdrop.querySelector('#rqd-import-confirm');
      var allCb = backdrop.querySelector('#rqd-import-toggle-all');
      function refresh() {
        var picks = getPayloads();
        countEl.textContent = picks.length + ' selected';
        confirmBtn.textContent = 'Import ' + picks.length;
        confirmBtn.disabled = picks.length === 0;
      }
      bodyEl.addEventListener('change', function(ev) {
        if (ev.target && ev.target.matches('.rqd-import-row__cb')) refresh();
      });
      allCb.addEventListener('change', function() {
        var checked = allCb.checked;
        bodyEl.querySelectorAll('.rqd-import-row__cb').forEach(function(cb) { cb.checked = checked; });
        refresh();
      });
      confirmBtn.addEventListener('click', async function() {
        var picks = getPayloads();
        if (picks.length === 0) return;
        var prev = confirmBtn.textContent;
        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Importing ' + picks.length + '…';
        var summary = await _bulkImportProspects(picks, importLabel);
        backdrop.remove();
        await rqdAlert(summary);   /* the import counts are only shown here */
        await fetchQuotes();
      });
      return refresh;
    }

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17 — Phase 1.16) — Deal
       Finder import opens the actual /pages/lead-finder page in a popup
       window with `?embed=cfa-import`. The page detects embed mode, swaps
       each lead's "Send to HubSpot" button to "Add to Deal Prospecting"
       (single-lead per click — Deal Finder's native UX is per-lead detail,
       no batch select-all like LeadGen). On click, the page posts the
       lead back via window.opener.postMessage. We listen for the message,
       map via _mapLeadFinderRecord, run /cfa-prospect-create. Popup stays
       open so the CFA can add more leads in succession; a running summary
       toast appears after each import. */
    window.__openImportLeadFinder = function(e) {
      if (e) e.stopPropagation();
      var menu = document.getElementById('rqd-new-menu');
      if (menu) menu.style.display = 'none';

      var w = 1400, h = 900;
      var left = Math.max(0, ((screen.availWidth || window.innerWidth) - w) / 2);
      var top = Math.max(0, ((screen.availHeight || window.innerHeight) - h) / 2);
      var features = 'width=' + w + ',height=' + h + ',left=' + Math.round(left) + ',top=' + Math.round(top) + ',resizable=yes,scrollbars=yes';
      var popup = window.open('/pages/lead-finder?embed=cfa-import', 'cfa-leadfinder-import', features);
      if (!popup) {
        rqdAlert('Popup blocked. Allow popups for this site and try again.');
        return;
      }
      try { popup.focus(); } catch (_) {}

      var importedCount = 0;
      var skippedCount = 0;
      var failedCount = 0;
      async function onMessage(ev) {
        var msg = ev && ev.data;
        if (!msg || typeof msg !== 'object') return;
        if (msg.type !== 'cfa-import:pick') return;
        if (msg.source !== 'lead-finder') return;
        var leads = Array.isArray(msg.leads) ? msg.leads : [];
        if (leads.length === 0) return;
        var picks = leads.map(_mapLeadFinderRecord);
        // Per-pick import (Deal Finder sends one lead at a time). Refresh
        // the prospect list at the end so the new row shows up.
        var _retire = [];
        for (var i = 0; i < picks.length; i++) {
          try {
            var resp = await API.post('/cfa-prospect-create', picks[i]);
            if (resp && resp.alreadyExists) { skippedCount++; _retire.push({ id: leads[i] && leads[i].id, ref: (resp && resp.ref) || '' }); }
            else if (resp && resp.success) { importedCount++; _retire.push({ id: leads[i] && leads[i].id, ref: (resp && resp.ref) || '' }); }
            else failedCount++;
          } catch (err) { failedCount++; }
        }
        /* CUSTOM_LEADFINDER_BY_CLAUDE (D-3, 2026-07-15) — tell the Deal Finder
           popup which leads are now in the CRM so it can retire them. Sending
           the outcome BACK rather than letting the popup retire optimistically
           on send: only this side knows whether /cfa-prospect-create actually
           succeeded, and a lead retired against a failed import is a lead
           nobody ever works again. Failures are deliberately not included —
           they stay live in the Deal Finder for a retry.
           alreadyExists counts as retire: "already in your CRM" is the
           strongest signal that it should stop being offered.
           The popup owns the actual leadfinder-worker call (it has that API's
           session); this is just the signal. If the CFA closed the popup first,
           the message is dropped and we're back to the old behaviour — the lead
           reappears. Not ideal, not harmful. */
        try {
          var _rt = _retire.filter(function(r) { return r && r.id; });
          if (_rt.length && popup && !popup.closed) {
            popup.postMessage({ type: 'cfa-import:retire', source: 'deal-dashboard', leads: _rt }, '*');
          }
        } catch (_) {}
        try { await fetchQuotes(); } catch (_) {}
      }
      window.addEventListener('message', onMessage);

      // Detect popup close (CFA done importing) — show running tally + cleanup.
      var pollClose = setInterval(function() {
        if (popup.closed) {
          clearInterval(pollClose);
          window.removeEventListener('message', onMessage);
          if (importedCount + skippedCount + failedCount > 0) {
            rqdAlert('Deal Finder import done.\n\n' + importedCount + ' imported · ' + skippedCount + ' already in your CRM (skipped) · ' + failedCount + ' failed');
          }
        }
      }, 1000);
    };



    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — Master edit popup for the
       Prospect card. Mirrors the SOLD TO / BILL TO / SHIP TO pencil on Offline
       Deals: one pencil on the card title governs every field, instead of
       per-line pencils that only reached the address.

       Why not reuse __openEditCustomer (the offline one): it hard-returns for
       CFAs (`sess.role === 'cfa'`) and posts to /lead-customer-update, whose
       worker rejects CFAs outright ("CFAs cannot edit leads"). CFAs OWN
       prospects, so that path is unusable here. /cfa-prospect-update already
       accepts a customer:{} patch over exactly these nine fields and is
       CFA-callable, so no new endpoint is needed.

       Standalone backdrop rather than the shared modalBody/pendingStatusChange
       machinery — that confirm handler is a long if/else chain shared by every
       modal in the dashboard, and this needs none of it. Same rqd-modal classes,
       so it looks identical. */
    window.__openEditProspect = function(p) {
      if (!p || !p.ref) return;
      var c = p.customer || {};
      var d = p.discovery || {};

      var existing = document.getElementById('rqd-edit-prospect-modal');
      if (existing) existing.remove();

      function v(x) { return (x == null) ? '' : String(x); }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — prefill from the SAME
         Authority-first merge the card renders (see buildProspectDetailHtml:
         dispName/dispEmail/dispPhone), not the raw customer.* layer.

         Why they diverge: until the master pencil shipped, customer.* was not
         editable from the UI at all — the only way to record a contact was the
         Discovery card's Authority fields. So customer.* stays frozen at
         whatever the import wrote (typically the school's generic switchboard
         number, no name, no email) while Authority carries the real decision
         maker the CFA found. The card shows Authority; this popup was showing
         the fossil underneath, so it looked like the pencil "lost" the contact.

         Saving writes BOTH layers, which permanently converges them. */
      var _epName  = (d.authorityName  || '').trim() || v(c.name).trim();
      var _epTitle = (d.authorityTitle || '').trim();
      var _epEmail = (d.authorityEmail || '').trim() || v(c.email).trim();
      var _epPhone = (d.authorityPhone || '').trim() || v(c.phone).trim();

      var backdrop = document.createElement('div');
      backdrop.id = 'rqd-edit-prospect-modal';
      backdrop.className = 'rqd-modal-backdrop rqd-modal-backdrop--open';
      backdrop.innerHTML =
        '<div class="rqd-modal rqd-modal--wide">' +
          '<h2 class="rqd-modal__title">Edit Prospect — ' + esc(p.ref) + '</h2>' +
          '<p class="rqd-modal__sub">Everything on the Prospect card. Name, Title, Email and Phone are the decision maker — saving keeps the Authority fields on the Discovery card in step, so handoff eligibility stays correct. Blank a field to clear it.</p>' +
          '<div class="rqd-modal__body" style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">' +
            '<div style="grid-column:1/-1;"><label class="rqd-modal__label">Organization</label><input type="text" id="rqd-ep-org" class="rqd-modal__input" maxlength="300" value="' + esc(v(c.organization)) + '" placeholder="School / Org name"></div>' +
            '<div><label class="rqd-modal__label">Contact Name</label><input type="text" id="rqd-ep-name" class="rqd-modal__input" maxlength="200" value="' + esc(_epName) + '"></div>' +
            '<div><label class="rqd-modal__label">Title</label><input type="text" id="rqd-ep-title" class="rqd-modal__input" maxlength="200" value="' + esc(_epTitle) + '" placeholder="Athletic Director"></div>' +
            '<div><label class="rqd-modal__label">Phone</label><input type="tel" id="rqd-ep-phone" class="rqd-modal__input" maxlength="30" value="' + esc(_epPhone) + '" placeholder="(555) 123-4567"></div>' +
            '<div><label class="rqd-modal__label">Email</label><input type="email" id="rqd-ep-email" class="rqd-modal__input" maxlength="200" value="' + esc(_epEmail) + '"></div>' +
            '<div style="grid-column:1/-1;"><label class="rqd-modal__label">Street</label><input type="text" id="rqd-ep-street" class="rqd-modal__input" maxlength="200" value="' + esc(v(c.street)) + '" placeholder="123 Main St"></div>' +
            '<div style="grid-column:1/-1;"><label class="rqd-modal__label">Street 2 <span style="font-weight:400;text-transform:none;letter-spacing:0;color:var(--rq-text-secondary);">(suite, apt, floor — optional)</span></label><input type="text" id="rqd-ep-street2" class="rqd-modal__input" maxlength="200" value="' + esc(v(c.street2)) + '"></div>' +
            '<div style="grid-column:1/-1;display:grid;grid-template-columns:1fr 2fr 1fr;gap:10px;">' +
              '<div><label class="rqd-modal__label">Zip</label><input type="text" id="rqd-ep-zip" class="rqd-modal__input" maxlength="10" inputmode="numeric" value="' + esc(v(c.zip)) + '"></div>' +
              '<div><label class="rqd-modal__label">City</label><input type="text" id="rqd-ep-city" class="rqd-modal__input" maxlength="120" value="' + esc(v(c.city)) + '"></div>' +
              '<div><label class="rqd-modal__label">State</label><input type="text" id="rqd-ep-state" class="rqd-modal__input" maxlength="4" style="text-transform:uppercase;" value="' + esc(v(c.state)) + '"></div>' +
            '</div>' +
            '<div id="rqd-ep-err" style="grid-column:1/-1;display:none;color:#dc2626;font-size:12px;"></div>' +
          '</div>' +
          '<div class="rqd-modal__actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:14px;">' +
            '<button type="button" id="rqd-ep-addcontact" class="rqd-modal__btn" style="margin-right:auto;">+ Add contact</button>' +
            '<button type="button" id="rqd-ep-cancel" class="rqd-modal__btn">Cancel</button>' +
            '<button type="button" id="rqd-ep-save" class="rqd-modal__btn rqd-modal__btn--primary">Save</button>' +
          '</div>' +
        '</div>';
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      var $ = function(id) { return backdrop.querySelector('#' + id); };

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — the card and this popup
         now show the SAME person. See the prefill above for why they used to
         disagree. Nothing to warn about; a save re-converges both layers. */

      $('rqd-ep-cancel').addEventListener('click', function() { backdrop.remove(); });
      /* This popup edits the PRIMARY. Adding another person is a different job,
         so hand off to the contact modal rather than growing this form. Closes
         first — stacked modals are a trap, and any edit here is unsaved anyway. */
      $('rqd-ep-addcontact').addEventListener('click', function() {
        backdrop.remove();
        if (typeof window.__openEditContact === 'function') window.__openEditContact(p, null);
      });
      $('rqd-ep-org').focus();

      $('rqd-ep-save').addEventListener('click', async function() {
        var btn = $('rqd-ep-save');
        var err = $('rqd-ep-err');
        err.style.display = 'none';
        var st = ($('rqd-ep-state').value || '').trim().toUpperCase();
        // The worker's dupe check matches on organization+state, and its state
        // field caps at 4 chars — a full state name breaks both.
        if (st && st.length !== 2) {
          err.style.display = '';
          err.textContent = 'State must be a 2-letter code (e.g. CO), not "' + st + '".';
          return;
        }
        var prev = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Saving…';
        try {
          var _nm = ($('rqd-ep-name').value || '').trim();
          var _ti = ($('rqd-ep-title').value || '').trim();
          var _em = ($('rqd-ep-email').value || '').trim();
          var _ph = ($('rqd-ep-phone').value || '').trim();
          /* Write BOTH layers from one set of inputs. The card already presents
             them as a single Name / Email / Phone, so keeping them apart is what
             produced the drift. The worker patches discovery field-by-field, so
             need / budget / timeline are untouched — only the authority
             sub-fields move, which is what handoff eligibility reads. */
          await API.post('/cfa-prospect-update', {
            ref: p.ref,
            customer: {
              organization: ($('rqd-ep-org').value || '').trim(),
              name:         _nm,
              email:        _em,
              phone:        _ph,
              street:       ($('rqd-ep-street').value || '').trim(),
              street2:      ($('rqd-ep-street2').value || '').trim(),
              city:         ($('rqd-ep-city').value || '').trim(),
              state:        st,
              zip:          ($('rqd-ep-zip').value || '').trim()
            },
            discovery: {
              authorityName:  _nm,
              authorityTitle: _ti,
              authorityEmail: _em,
              authorityPhone: _ph
            }
          });
          backdrop.remove();
          // Re-fetch rather than patch the DOM: organization/state feed the row's
          // Org + Location cells and the dupe index, and the worker may normalize
          // what it stored (trim, cap). Showing the server's truth beats guessing.
          try { await fetchQuotes(); } catch (_) {}
        } catch (e2) {
          btn.disabled = false;
          btn.textContent = prev;
          err.style.display = '';
          err.textContent = 'Save failed: ' + (e2 && e2.message ? e2.message : 'unknown');
        }
      });
    };

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-15) — Import from CSV / Excel.
       Bulk-loads contract-shaped rows (see the AD database's README.md) into
       Deal Prospecting via POST /admin/import-prospects.

       Design notes:
       - No SheetJS. The theme has no build system, so real .xlsx parsing would
         mean vendoring ~800KB for one button. Instead: CSV upload, plus paste
         straight out of Excel (which yields TSV — same parser, different
         delimiter). "Save As CSV" or Ctrl+C covers the actual use case.
       - Headers are matched BY NAME, not position, so columns can be reordered
         in the spreadsheet without breaking the import.
       - Always dry-runs before committing. The dry run is what produces the
         real counts and the measured time estimate for each option. */

    // Minimal RFC4180-ish parser. Handles quoted fields containing the
    // delimiter, escaped "" quotes, and CRLF. Deliberately not a regex —
    // a school name like "Roosevelt High, Annex" would break a naive split.
    function _csvParse(text, delim) {
      var rows = [], row = [], field = '', inQ = false, i = 0;
      // Excel writes a UTF-8 BOM; left in place it corrupts the first header.
      if (text.charCodeAt(0) === 0xFEFF) text = text.slice(1);
      while (i < text.length) {
        var c = text[i];
        if (inQ) {
          if (c === '"') {
            if (text[i + 1] === '"') { field += '"'; i += 2; continue; }
            inQ = false; i++; continue;
          }
          field += c; i++; continue;
        }
        if (c === '"') { inQ = true; i++; continue; }
        if (c === delim) { row.push(field); field = ''; i++; continue; }
        if (c === '\r') { i++; continue; }
        if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; i++; continue; }
        field += c; i++;
      }
      if (field.length || row.length) { row.push(field); rows.push(row); }
      return rows.filter(function(r) { return r.some(function(v) { return String(v).trim() !== ''; }); });
    }

    function _csvToObjects(text) {
      if (!text || !text.trim()) return { rows: [], headers: [], error: 'Nothing pasted or uploaded.' };
      // Excel copy/paste is tab-delimited; a saved file is comma-delimited.
      // Sniff on the header line rather than asking the user which they have.
      var firstLine = text.split(/\r?\n/)[0] || '';
      var delim = (firstLine.split('\t').length > firstLine.split(',').length) ? '\t' : ',';
      var grid = _csvParse(text, delim);
      if (grid.length < 2) return { rows: [], headers: [], error: 'Need a header row plus at least one data row.' };
      var headers = grid[0].map(function(h) { return String(h || '').trim().toLowerCase().replace(/\s+/g, '_'); });
      var rows = grid.slice(1).map(function(r) {
        var o = {};
        headers.forEach(function(h, idx) { if (h) o[h] = String(r[idx] == null ? '' : r[idx]).trim(); });
        return o;
      });
      return { rows: rows, headers: headers, delim: delim, error: null };
    }

    var CSV_REQUIRED = ['school_name', 'state'];

    function _csvValidateHeaders(headers) {
      var missing = CSV_REQUIRED.filter(function(h) { return headers.indexOf(h) === -1; });
      if (missing.length) {
        return 'Missing required column' + (missing.length > 1 ? 's' : '') + ': ' + missing.join(', ') +
               '. Run scripts/normalize_ad_csv.py on the build first — the raw AD-database CSVs have no state column.';
      }
      if (headers.indexOf('ad_email') === -1 && headers.indexOf('ad_phone') === -1) {
        return 'Need an ad_email or ad_phone column — otherwise there is no way to contact anyone.';
      }
      return null;
    }

    function _csvRowHasEmail(r) { return !!String(r.ad_email || '').trim(); }

    window.__openImportCsv = function(e) {
      if (e) e.stopPropagation();
      var menu = document.getElementById('rqd-new-menu');
      if (menu) menu.style.display = 'none';

      var existing = document.getElementById('rqd-import-csv-modal');
      if (existing) existing.remove();

      var backdrop = document.createElement('div');
      backdrop.id = 'rqd-import-csv-modal';
      backdrop.className = 'rqd-modal-backdrop rqd-modal-backdrop--open';
      backdrop.innerHTML =
        '<div class="rqd-modal rqd-modal--wide">' +
          '<h2 class="rqd-modal__title">Import from CSV / Excel</h2>' +
          '<p class="rqd-modal__sub">Upload a contract-shaped file, or copy the cells straight out of Excel and paste below. Nothing is written until you pick an option and confirm.</p>' +
          '<div class="rqd-modal__body">' +
            '<div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap;">' +
              '<div><label class="rqd-modal__label">CSV file</label><input type="file" id="rqd-csv-file" accept=".csv,text/csv,text/plain" class="rqd-modal__input" style="padding:6px;"></div>' +
              '<div id="rqd-csv-cfa-wrap" style="display:none;"><label class="rqd-modal__label">Assign to CFA</label><select id="rqd-csv-cfa" class="rqd-modal__input"></select></div>' +
            '</div>' +
            '<div style="margin-top:10px;"><label class="rqd-modal__label">…or paste from Excel</label>' +
              '<textarea id="rqd-csv-paste" class="rqd-modal__input" rows="4" placeholder="Select your cells in Excel including the header row, Ctrl+C, then paste here."></textarea></div>' +
            '<div id="rqd-csv-parse-msg" style="margin-top:8px;font-size:12px;"></div>' +
            '<div id="rqd-csv-options" style="display:none;margin-top:12px;">' +
              '<p class="rqd-modal__section-label">What do you want to bring in?</p>' +
              '<div id="rqd-csv-radios" style="display:grid;gap:6px;"></div>' +
              '<div id="rqd-csv-preview" style="margin-top:10px;font-size:11px;color:var(--rq-text-secondary);"></div>' +
            '</div>' +
            '<div id="rqd-csv-progress" style="display:none;margin-top:12px;">' +
              '<div style="height:6px;background:var(--rq-border,#e5e7eb);border-radius:3px;overflow:hidden;">' +
                '<div id="rqd-csv-bar" style="height:100%;width:0;background:var(--rq-accent,#2563eb);transition:width .2s;"></div></div>' +
              '<p id="rqd-csv-progress-txt" style="margin:6px 0 0;font-size:12px;color:var(--rq-text-secondary);"></p>' +
            '</div>' +
            '<div id="rqd-csv-result" style="display:none;margin-top:12px;font-size:12px;"></div>' +
          '</div>' +
          '<div class="rqd-modal__actions" style="display:flex;gap:8px;justify-content:flex-end;margin-top:14px;">' +
            '<button type="button" id="rqd-csv-cancel" class="rqd-modal__btn">Close</button>' +
            '<button type="button" id="rqd-csv-import" class="rqd-modal__btn rqd-modal__btn--primary" disabled>Import</button>' +
          '</div>' +
        '</div>';
      (document.querySelector('.rep-quote-portal-wrap') || document.body).appendChild(backdrop);

      var elFile = backdrop.querySelector('#rqd-csv-file');
      var elPaste = backdrop.querySelector('#rqd-csv-paste');
      var elMsg = backdrop.querySelector('#rqd-csv-parse-msg');
      var elOpts = backdrop.querySelector('#rqd-csv-options');
      var elRadios = backdrop.querySelector('#rqd-csv-radios');
      var elPreview = backdrop.querySelector('#rqd-csv-preview');
      var elProg = backdrop.querySelector('#rqd-csv-progress');
      var elBar = backdrop.querySelector('#rqd-csv-bar');
      var elProgTxt = backdrop.querySelector('#rqd-csv-progress-txt');
      var elResult = backdrop.querySelector('#rqd-csv-result');
      var elImport = backdrop.querySelector('#rqd-csv-import');
      var elCfaWrap = backdrop.querySelector('#rqd-csv-cfa-wrap');
      var elCfa = backdrop.querySelector('#rqd-csv-cfa');

      var parsed = [];
      var perRowMs = 0;

      backdrop.querySelector('#rqd-csv-cancel').addEventListener('click', function() { backdrop.remove(); });

      // Admins pick whose pipeline this lands in; a CFA can only import for
      // themselves (the worker ignores cfaCode for CFA callers regardless).
      var sess = (window.RepAuth && RepAuth.getSession && RepAuth.getSession()) || {};
      if (sess.admin) {
        elCfaWrap.style.display = '';
        API.get('/cfa-list').then(function(d) {
          var list = (d && (d.cfas || d.reps)) || [];
          elCfa.innerHTML = list.map(function(c) {
            return '<option value="' + c.code + '">' + c.code + ' — ' + (c.fullName || c.name || c.code) + '</option>';
          }).join('');
        }).catch(function() {
          elCfa.innerHTML = '<option value="">(could not load CFA list — type a code)</option>';
        });
      }

      function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
      function est(count) {
        if (!perRowMs || !count) return '';
        var secs = Math.ceil((count * perRowMs) / 1000);
        return secs < 90 ? ('~' + secs + 's') : ('~' + Math.ceil(secs / 60) + ' min');
      }

      function renderOptions() {
        var withEmail = parsed.filter(_csvRowHasEmail);
        var without = parsed.filter(function(r) { return !_csvRowHasEmail(r); });
        var opts = [
          { v: 'with-email', n: withEmail.length, label: 'Contacts with emails', sub: 'Ready to email. This is what an email-only CFA wants.' },
          { v: 'without-email', n: without.length, label: 'Call list (no email, phone only)', sub: 'Nothing to email — these get worked by phone.' },
          { v: 'all', n: parsed.length, label: 'Everything', sub: 'Both of the above.' }
        ];
        elRadios.innerHTML = opts.map(function(o, i) {
          var disabled = o.n === 0 ? ' disabled' : '';
          return '<label style="display:flex;gap:8px;align-items:flex-start;padding:8px 10px;border:1px solid var(--rq-border,#e5e7eb);border-radius:6px;cursor:' + (o.n ? 'pointer' : 'not-allowed') + ';opacity:' + (o.n ? '1' : '.5') + ';">' +
            '<input type="radio" name="rqd-csv-filter" value="' + o.v + '"' + (i === 0 && o.n ? ' checked' : '') + disabled + ' style="width:auto;margin:3px 0 0;">' +
            '<span><strong>' + o.label + '</strong> — ' + fmt(o.n) + ' row' + (o.n === 1 ? '' : 's') +
            '<span id="rqd-csv-est-' + o.v + '" style="color:var(--rq-text-secondary);"></span>' +
            '<br><span style="font-weight:400;color:var(--rq-text-secondary);">' + o.sub + '</span></span></label>';
        }).join('');
        opts.forEach(function(o) {
          var s = backdrop.querySelector('#rqd-csv-est-' + o.v);
          if (s && perRowMs) s.textContent = '  ·  ' + est(o.n);
        });
        elOpts.style.display = '';
        elImport.disabled = !parsed.length;
      }

      async function ingest(text) {
        elResult.style.display = 'none';
        var out = _csvToObjects(text);
        if (out.error) { elMsg.innerHTML = '<span style="color:#dc2626;">' + out.error + '</span>'; elOpts.style.display = 'none'; elImport.disabled = true; return; }
        var hErr = _csvValidateHeaders(out.headers);
        if (hErr) { elMsg.innerHTML = '<span style="color:#dc2626;">' + hErr + '</span>'; elOpts.style.display = 'none'; elImport.disabled = true; return; }
        parsed = out.rows;
        elMsg.innerHTML = '<span style="color:var(--rq-text-secondary);">Read <strong>' + fmt(parsed.length) + '</strong> rows · ' +
          out.headers.length + ' columns · ' + (out.delim === '\t' ? 'tab-separated (Excel paste)' : 'comma-separated') + '</span>';
        renderOptions();

        // Dry-run a sample to measure the real per-row cost and surface any
        // conflicts before the user commits. The estimate is measured, not
        // guessed, so it stays honest as the pipeline grows.
        try {
          var sample = parsed.slice(0, 25);
          var body = { rows: sample, filter: 'all', mode: 'dry' };
          if (sess.admin && elCfa.value) body.cfaCode = elCfa.value;
          var dry = await API.post('/admin/import-prospects', body);
          if (dry && dry.perRowMs) { perRowMs = dry.perRowMs; renderOptions(); }
          if (dry && dry.counts) {
            var c = dry.counts;
            var notes = [];
            if (c.exists) notes.push(c.exists + ' already in the CRM (in the first ' + sample.length + ')');
            if (c.conflict) notes.push('<span style="color:#b45309;">' + c.conflict + ' logged by another CFA — will be skipped</span>');
            if (c.invalid) notes.push('<span style="color:#b45309;">' + c.invalid + ' unusable (no email and no phone)</span>');
            elPreview.innerHTML = 'Sampled the first ' + sample.length + ' rows. ' + (notes.length ? notes.join(' · ') : 'No conflicts found.');
          }
        } catch (err) {
          elPreview.innerHTML = '<span style="color:#dc2626;">Could not dry-run: ' + (err && err.message ? err.message : err) + '</span>';
        }
      }

      elFile.addEventListener('change', function() {
        var f = elFile.files && elFile.files[0];
        if (!f) return;
        var reader = new FileReader();
        reader.onload = function() { elPaste.value = ''; ingest(String(reader.result || '')); };
        reader.readAsText(f);
      });
      var pasteTimer;
      elPaste.addEventListener('input', function() {
        clearTimeout(pasteTimer);
        pasteTimer = setTimeout(function() { if (elPaste.value.trim()) ingest(elPaste.value); }, 400);
      });

      elImport.addEventListener('click', async function() {
        var picked = backdrop.querySelector('input[name="rqd-csv-filter"]:checked');
        if (!picked || !parsed.length) return;
        var filter = picked.value;
        var subset = filter === 'with-email' ? parsed.filter(_csvRowHasEmail)
                   : filter === 'without-email' ? parsed.filter(function(r) { return !_csvRowHasEmail(r); })
                   : parsed.slice();
        if (!subset.length) return;
        if (!(await rqdConfirm('This writes to the CRM. Rows already logged by another CFA are skipped, not overwritten.', { title: 'Import ' + fmt(subset.length) + ' prospect' + (subset.length === 1 ? '' : 's') + '?', confirmLabel: 'Import' }))) return;

        elImport.disabled = true;
        elFile.disabled = true;
        elPaste.disabled = true;
        elProg.style.display = '';
        elResult.style.display = 'none';

        // 50 per request: the worker caps at 60, and each row costs several KV
        // ops against the Workers subrequest ceiling. Each batch is also ONE
        // lead-index write instead of one per row — the whole reason this
        // doesn't take half an hour.
        var BATCH = 50;
        var tot = { created: 0, exists: 0, conflict: 0, invalid: 0, failed: 0 };
        var started = Date.now();
        for (var i = 0; i < subset.length; i += BATCH) {
          var chunk = subset.slice(i, i + BATCH);
          var body = { rows: chunk, filter: 'all', mode: 'commit' };
          if (sess.admin && elCfa.value) body.cfaCode = elCfa.value;
          try {
            var r = await API.post('/admin/import-prospects', body);
            if (r && r.counts) Object.keys(tot).forEach(function(k) { tot[k] += (r.counts[k] || 0); });
          } catch (err) {
            tot.failed += chunk.length;
          }
          var done = Math.min(i + BATCH, subset.length);
          elBar.style.width = Math.round((done / subset.length) * 100) + '%';
          elProgTxt.textContent = fmt(done) + ' of ' + fmt(subset.length) + ' · ' + tot.created + ' created, ' + tot.exists + ' already there, ' + tot.conflict + ' conflicts, ' + tot.invalid + ' unusable';
        }
        var secs = Math.round((Date.now() - started) / 1000);
        elResult.style.display = '';
        elResult.innerHTML =
          '<strong>Import finished in ' + secs + 's.</strong><br>' +
          '<span style="color:#059669;">' + fmt(tot.created) + ' created</span> · ' +
          fmt(tot.exists) + ' already in your CRM · ' +
          (tot.conflict ? '<span style="color:#b45309;">' + fmt(tot.conflict) + ' logged first by another CFA (skipped)</span> · ' : '') +
          (tot.invalid ? '<span style="color:#b45309;">' + fmt(tot.invalid) + ' unusable (no email, no phone)</span> · ' : '') +
          (tot.failed ? '<span style="color:#dc2626;">' + fmt(tot.failed) + ' failed</span>' : '0 failed');
        elImport.textContent = 'Done';
        try { await fetchQuotes(); } catch (_) {}
      });
    };

    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-05-17 — Phase 1.14) — Lead
       Generator import opens the actual /pages/rep-leadgen page in a
       popup window with `?embed=cfa-import`. The Lead Generator page
       detects embed mode, swaps its "Send to HubSpot" button to "Add to
       Deal Prospecting", and on click it posts selected lead records
       back via window.opener.postMessage. We listen for that message and
       run /cfa-prospect-create per pick (via _bulkImportProspects).
       Popup window — not iframe — because the storefront returns
       X-Frame-Options that block same-origin framing across the bare-
       domain → www. canonical redirect ("refused to connect" error). */
    window.__openImportLeadGen = function(e) {
      if (e) e.stopPropagation();
      var menu = document.getElementById('rqd-new-menu');
      if (menu) menu.style.display = 'none';

      // Reasonable size + centered on the current screen.
      var w = 1400, h = 900;
      var left = Math.max(0, ((screen.availWidth || window.innerWidth) - w) / 2);
      var top = Math.max(0, ((screen.availHeight || window.innerHeight) - h) / 2);
      var features = 'width=' + w + ',height=' + h + ',left=' + Math.round(left) + ',top=' + Math.round(top) + ',resizable=yes,scrollbars=yes';
      var popup = window.open('/pages/rep-leadgen?embed=cfa-import', 'cfa-leadgen-import', features);
      if (!popup) {
        rqdAlert('Popup blocked. Allow popups for this site and try again.');
        return;
      }
      try { popup.focus(); } catch (_) {}

      /* Phase 1.20 — popup stays open after Send so the CFA can keep
         importing more leads from the same session. Was: one-shot
         listener that closed the popup + alerted summary. Now: tally
         each batch, refresh dashboard prospect list after each import,
         and only show the summary when the CFA closes the popup
         (matches the Deal Finder pattern). */
      var lgImportedCount = 0;
      var lgSkippedCount = 0;
      var lgFailedCount = 0;
      async function onMessage(ev) {
        var msg = ev && ev.data;
        if (!msg || typeof msg !== 'object') return;
        if (msg.type !== 'cfa-import:pick') return;
        if (msg.source !== 'lead-generator') return;
        var leads = Array.isArray(msg.leads) ? msg.leads : [];
        if (leads.length === 0) return;
        var picks = leads.map(_mapLeadGenRecord);
        // Inline per-pick loop (mirrors _bulkImportProspects but tallies
        // into the popup-scoped counters so the close-poll can show a
        // running summary).
        for (var i = 0; i < picks.length; i++) {
          try {
            var resp = await API.post('/cfa-prospect-create', picks[i]);
            if (resp && resp.alreadyExists) lgSkippedCount++;
            else if (resp && resp.success) lgImportedCount++;
            else lgFailedCount++;
          } catch (err) { lgFailedCount++; }
        }
        try { await fetchQuotes(); } catch (_) {}
      }
      window.addEventListener('message', onMessage);

      // Show summary when the CFA closes the popup.
      var lgPollClose = setInterval(function() {
        if (popup.closed) {
          clearInterval(lgPollClose);
          window.removeEventListener('message', onMessage);
          if (lgImportedCount + lgSkippedCount + lgFailedCount > 0) {
            rqdAlert('Lead Generator import done.\n\n' + lgImportedCount + ' imported · ' + lgSkippedCount + ' already in your CRM (skipped) · ' + lgFailedCount + ' failed');
          }
        }
      }, 1000);
    };
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE (Phase 1.5 import pickers) */
  });
})();
